
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree71e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree71e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("82Ay3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5daadc5dcdcf4dfc$export$2e2bcd8739ae039);
var $5daadc5dcdcf4dfc$var$cusId = "";
var $5daadc5dcdcf4dfc$var$data = "";
var $5daadc5dcdcf4dfc$var$overlay = "";
var $5daadc5dcdcf4dfc$var$DigilockerData = "";
const $5daadc5dcdcf4dfc$var$KYC_DIGILOCKER = "DIGILOCKER";
const $5daadc5dcdcf4dfc$var$KYC_SMS = "SMS_LINK";
var $5daadc5dcdcf4dfc$var$select = "";
var $5daadc5dcdcf4dfc$var$option = "";
var $5daadc5dcdcf4dfc$var$parentalFlow = false;
var $5daadc5dcdcf4dfc$var$langRecieved = "ENGLISH";
var $5daadc5dcdcf4dfc$var$langFlag = 0;
var $5daadc5dcdcf4dfc$var$cburl = "";
const $5daadc5dcdcf4dfc$var$keyTranslations = {
    Purpose: "Purpose",
    "Data type": "Data type",
    Duration: "Duration",
    "Processing activity": "Processing activity",
    "Used by": "Used by",
    "Data item": "Data item",
    Id: "Id"
};
var $5daadc5dcdcf4dfc$var$digilockerClientId = "";
var $5daadc5dcdcf4dfc$var$digilockerSecret = "";
var $5daadc5dcdcf4dfc$var$digilockercodeVerifier = "";
var $5daadc5dcdcf4dfc$var$digilockerredirectUri = "";
var $5daadc5dcdcf4dfc$var$finalSelectedLanguage = "ENGLISH";
var $5daadc5dcdcf4dfc$var$backBtn = "";
var $5daadc5dcdcf4dfc$var$checkbox = "";
var $5daadc5dcdcf4dfc$var$btn1BackgroundColor = ""; //Save My choicves , Cancel
var $5daadc5dcdcf4dfc$var$btn1FontColor = "";
var $5daadc5dcdcf4dfc$var$btn2BackgroundColor = ""; //AllowAll,Verify,next
var $5daadc5dcdcf4dfc$var$btn2FontColor = "";
var $5daadc5dcdcf4dfc$var$cancelBtn = "";
var $5daadc5dcdcf4dfc$var$nextBtn = "";
var $5daadc5dcdcf4dfc$var$verifyBtn = "";
var $5daadc5dcdcf4dfc$var$selectedKYCMethod = "";
var $5daadc5dcdcf4dfc$var$doc_name = "";
var $5daadc5dcdcf4dfc$var$doc_id = "";
var $5daadc5dcdcf4dfc$var$TopDesc = "";
var $5daadc5dcdcf4dfc$var$translatedLabel = "Customer ID";
var $5daadc5dcdcf4dfc$var$labelSpan = "";
var $5daadc5dcdcf4dfc$var$ConsentAllow = "";
var $5daadc5dcdcf4dfc$var$withdrawLine = "";
var $5daadc5dcdcf4dfc$var$clickHere = "";
var $5daadc5dcdcf4dfc$var$requiredLabel = "";
var $5daadc5dcdcf4dfc$var$documentLink = "";
var $5daadc5dcdcf4dfc$var$label = "";
var $5daadc5dcdcf4dfc$var$label2 = "";
var $5daadc5dcdcf4dfc$var$title = "";
var $5daadc5dcdcf4dfc$var$content = "";
var $5daadc5dcdcf4dfc$var$content2 = "";
var $5daadc5dcdcf4dfc$var$checkbox2 = "";
var $5daadc5dcdcf4dfc$var$checkboxLabel = "";
var $5daadc5dcdcf4dfc$var$badge = "";
var $5daadc5dcdcf4dfc$var$pdfUrl = "";
var $5daadc5dcdcf4dfc$var$topDesc = "";
var $5daadc5dcdcf4dfc$var$rightsDesc = "";
var $5daadc5dcdcf4dfc$var$permissionText = "";
var $5daadc5dcdcf4dfc$var$parentalControl = "";
var $5daadc5dcdcf4dfc$var$dataItemToBeShown = "";
var $5daadc5dcdcf4dfc$var$processActivityNameToBeShown = "";
var $5daadc5dcdcf4dfc$var$idshown = false;
var $5daadc5dcdcf4dfc$var$processorNameToBeShown = "";
var $5daadc5dcdcf4dfc$var$validitytoBeShown = "";
var $5daadc5dcdcf4dfc$var$logoUrl = "";
var $5daadc5dcdcf4dfc$var$saveBtn = "";
var $5daadc5dcdcf4dfc$var$allowBtn = "";
var $5daadc5dcdcf4dfc$var$isParental = false;
var $5daadc5dcdcf4dfc$var$parentIdentity = "";
var $5daadc5dcdcf4dfc$var$parentIdentityType = "";
var $5daadc5dcdcf4dfc$var$parentName = "";
var $5daadc5dcdcf4dfc$var$theme = "";
var $5daadc5dcdcf4dfc$var$cardBackgroundColor = "";
var $5daadc5dcdcf4dfc$var$buttonBackgroundColor = "";
var $5daadc5dcdcf4dfc$var$cardFontColor = "";
var $5daadc5dcdcf4dfc$var$buttonFontColor = "";
var $5daadc5dcdcf4dfc$var$linkFontColor = "";
var $5daadc5dcdcf4dfc$var$fontFamily = "system-ui"; // replaced by the tenant font once it loads
var $5daadc5dcdcf4dfc$var$fontStyle = "normal";
var $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor = "";
var $5daadc5dcdcf4dfc$var$mainAccordionFontColor = "";
var $5daadc5dcdcf4dfc$var$subAccordionBackgroundColor = "";
var $5daadc5dcdcf4dfc$var$subAccordionFontColor = "";
var $5daadc5dcdcf4dfc$var$activeBadgeFontColor = "";
var $5daadc5dcdcf4dfc$var$activeBadgeBackgroundColor = "#FFFFFF"; // badge background stays white in both themes
var $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor = "";
var $5daadc5dcdcf4dfc$var$languageDropdownFontColor = "";
var $5daadc5dcdcf4dfc$var$darkModeVisibility = "";
var $5daadc5dcdcf4dfc$var$darkTheme = "";
var $5daadc5dcdcf4dfc$var$lightTheme = "";
var $5daadc5dcdcf4dfc$var$templateList1 = []; // has required accordion contents
var $5daadc5dcdcf4dfc$var$templateList2 = []; // has others accordion contents
var $5daadc5dcdcf4dfc$var$consentArray = {};
var $5daadc5dcdcf4dfc$var$consentArray2 = {};
var $5daadc5dcdcf4dfc$var$consentHandleId = "";
var $5daadc5dcdcf4dfc$var$tenantId = "";
var $5daadc5dcdcf4dfc$var$businessId = "";
var $5daadc5dcdcf4dfc$var$secureId = "";
let $5daadc5dcdcf4dfc$var$dotLoaderInterval; //loader constant
let $5daadc5dcdcf4dfc$var$initDotLoaderInterval;
var $5daadc5dcdcf4dfc$var$rowCheckboxes = [];
let $5daadc5dcdcf4dfc$var$currentSourceLang = "en";
function $5daadc5dcdcf4dfc$var$createToastContainer() {
    if (!document.getElementById("toast-container")) {
        const container = document.createElement("div");
        Object.assign(container.style, {
            position: "fixed",
            bottom: "1rem",
            left: "1rem",
            zIndex: "9999",
            display: "flex",
            flexDirection: "column-reverse",
            gap: "10px",
            alignItems: "flex-start"
        });
        container.id = "toast-container";
        document.body.appendChild(container);
    }
}
function $5daadc5dcdcf4dfc$var$showToast(message, type = "success", duration = 3000) {
    $5daadc5dcdcf4dfc$var$createToastContainer();
    const toast = document.createElement("div");
    Object.assign(toast.style, {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        minWidth: "260px",
        maxWidth: "350px",
        padding: "12px 16px",
        borderRadius: "24px",
        backgroundColor: "rgba(0,0,0,0.65)",
        color: "#fff",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        fontSize: "14px",
        fontWeight: "500",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        opacity: "0",
        transform: "translateY(20px)",
        transition: "all 0.3s ease"
    });
    // Left icon
    const icon1 = document.createElement("span");
    icon1.innerHTML = `<svg width="25" height="25" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    ${type === "success" ? `<path d="M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z" fill="#25AB21"></path>` : `<path d="M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z" fill="#F50031"></path>`}
  </svg>`;
    Object.assign(icon1.style, {
        display: "flex",
        alignItems: "center",
        flexShrink: 0
    });
    // Message
    const msg = document.createElement("span");
    msg.innerText = message;
    Object.assign(msg.style, {
        flex: "1",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        wordBreak: "break-word"
    });
    // Close icon
    const closeBtn = document.createElement("span");
    closeBtn.innerHTML = `<svg width="25" height="25" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z" fill="currentColor"></path>
  </svg>`;
    Object.assign(closeBtn.style, {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        flexShrink: 0,
        color: "#fff"
    });
    closeBtn.onclick = ()=>toast.remove();
    // Append
    toast.appendChild(icon1);
    toast.appendChild(msg);
    toast.appendChild(closeBtn);
    document.getElementById("toast-container").appendChild(toast);
    // Animate in
    setTimeout(()=>{
        toast.style.opacity = "1";
        toast.style.transform = "translateY(0)";
    }, 50);
    // Auto dismiss
    setTimeout(()=>{
        toast.style.opacity = "0";
        toast.style.transform = "translateY(20px)";
        setTimeout(()=>toast.remove(), 300);
    }, duration);
}
async function $5daadc5dcdcf4dfc$var$generateCodeChallenge(codeVerifier) {
    if (window.crypto && window.crypto.subtle) {
        // Use native secure API if available (HTTPS / localhost)
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
        const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        return base64Hash;
    } else {
        // 🔒 Fallback for HTTP: pure JS SHA-256 + Base64URL
        console.warn("crypto.subtle not available. Using fallback SHA-256.");
        function sha256(ascii) {
            const rightRotate = (value, amount)=>value >>> amount | value << 32 - amount;
            let mathPow = Math.pow;
            let maxWord = mathPow(2, 32);
            let lengthProperty = "length";
            let i, j; // Used as a counter across the whole file
            let result = "";
            let words = [];
            let asciiBitLength = ascii[lengthProperty] * 8;
            let hash = sha256.h = sha256.h || [];
            let k = sha256.k = sha256.k || [];
            let primeCounter = k[lengthProperty];
            let isComposite = {};
            const fractionalPart = (n)=>n - Math.floor(n);
            // Compute primes and hash constants
            function getPrime(n) {
                let num = 2;
                while(n > 0){
                    if (!isComposite[num]) {
                        for(let i = num * num; i < 312; i += num)isComposite[i] = true;
                        if (--n === 0) return num;
                    }
                    num++;
                }
            }
            if (!primeCounter) {
                let n = 0;
                let prime = 2;
                while(n < 64){
                    while(isComposite[prime])prime++;
                    hash[n] = fractionalPart(Math.pow(prime, 0.5)) * maxWord | 0;
                    k[n++] = fractionalPart(Math.pow(prime, 1 / 3)) * maxWord | 0;
                    for(i = prime * prime; i < 312; i += prime)isComposite[i] = true;
                    prime++;
                }
            }
            ascii += "\x80"; // append '1' bit (plus zero padding)
            while(ascii[lengthProperty] % 64 - 56)ascii += "\x00"; // pad until length ≡ 56 mod 64
            for(i = 0; i < ascii[lengthProperty]; i++){
                j = ascii.charCodeAt(i);
                if (j >> 8) return; // ASCII check
                words[i >> 2] |= j << (3 - i) % 4 * 8;
            }
            words[words[lengthProperty]] = asciiBitLength / maxWord | 0;
            words[words[lengthProperty]] = asciiBitLength;
            for(j = 0; j < words[lengthProperty];){
                const w = words.slice(j, j += 16);
                const oldHash = hash.slice(0);
                for(i = 16; i < 64; i++){
                    const s0 = rightRotate(w[i - 15], 7) ^ rightRotate(w[i - 15], 18) ^ w[i - 15] >>> 3;
                    const s1 = rightRotate(w[i - 2], 17) ^ rightRotate(w[i - 2], 19) ^ w[i - 2] >>> 10;
                    w[i] = w[i - 16] + s0 + w[i - 7] + s1 | 0;
                }
                let a = hash[0], b = hash[1], c = hash[2], d = hash[3], e = hash[4], f = hash[5], g = hash[6], h = hash[7];
                for(i = 0; i < 64; i++){
                    const S1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
                    const ch = e & f ^ ~e & g;
                    const temp1 = h + S1 + ch + k[i] + w[i] | 0;
                    const S0 = rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
                    const maj = a & b ^ a & c ^ b & c;
                    const temp2 = S0 + maj | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + temp1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = temp1 + temp2 | 0;
                }
                for(i = 0; i < 8; i++)hash[i] = hash[i] + [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h
                ][i] | 0;
            }
            for(i = 0; i < 8; i++)for(j = 3; j + 1; j--){
                const b = hash[i] >> j * 8 & 255;
                result += (b < 16 ? "0" : "") + b.toString(16);
            }
            return result;
        }
        function hexToBase64Url(hex) {
            let bytes = [];
            for(let c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            let base64 = btoa(String.fromCharCode(...bytes));
            return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }
        const hashHex = sha256(codeVerifier);
        return hexToBase64Url(hashHex);
    }
}
function $5daadc5dcdcf4dfc$var$startDigilockerFlow(consentArray) {
    $5daadc5dcdcf4dfc$var$showLoader();
    const responseType = "code";
    const codeChallengeMethod = "S256";
    $5daadc5dcdcf4dfc$var$generateDigilockerTransactionId(consentArray).then(async (consentMetaId)=>{
        if (!consentMetaId) {
            $5daadc5dcdcf4dfc$var$hideLoader();
            return;
        }
        const state = consentMetaId;
        const state2 = `${state}:${$5daadc5dcdcf4dfc$var$secureId}`;
        const codeChallenge = await $5daadc5dcdcf4dfc$var$generateCodeChallenge($5daadc5dcdcf4dfc$var$digilockercodeVerifier);
        const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=${responseType}&client_id=${$5daadc5dcdcf4dfc$var$digilockerClientId}&redirect_uri=${$5daadc5dcdcf4dfc$var$digilockerredirectUri}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state2}`;
        const newTab = window.open(digilockerAuthUrl, "_blank");
        const checkInterval = setInterval(()=>{
            if (newTab.closed) {
                clearInterval(checkInterval);
                $5daadc5dcdcf4dfc$var$hideLoader();
                window.location.href = $5daadc5dcdcf4dfc$var$cburl;
            }
        }, 1000);
    });
}
function $5daadc5dcdcf4dfc$var$openUnder18Modal(consentArray) {
    let currentStep = 0;
    let selectedKYCMethod = null;
    let savedName = "";
    let savedIdentity = "";
    let savedDropdown = ""; // to preserve dropdown selection
    // Create overlay & box
    const modalOverlay = document.createElement("div");
    Object.assign(modalOverlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "9999"
    });
    const modalBox = document.createElement("div");
    Object.assign(modalBox.style, {
        borderRadius: "32px",
        width: "400px",
        padding: "20px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        position: "relative",
        background: $5daadc5dcdcf4dfc$var$cardBackgroundColor,
        color: $5daadc5dcdcf4dfc$var$cardFontColor
    });
    // Header: back button + step text
    const headerRow = document.createElement("div");
    Object.assign(headerRow.style, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px"
    });
    const backBtn = document.createElement("button");
    backBtn.innerHTML = "";
    Object.assign(backBtn.style, {
        background: "none",
        border: "none",
        fontSize: "20px",
        cursor: "pointer",
        display: "none"
    });
    const stepText = document.createElement("span");
    stepText.style.fontWeight = "600";
    stepText.style.fontFamily = $5daadc5dcdcf4dfc$var$fontFamily;
    stepText.style.fontSize = "16px";
    stepText.style.display = "none"; // hidden until Declaration is selected
    headerRow.appendChild(backBtn);
    headerRow.appendChild(stepText);
    // Title & content
    const title = document.createElement("div");
    Object.assign(title.style, {
        fontWeight: "500",
        fontSize: "14px",
        marginBottom: "5px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
    });
    const stepContent = document.createElement("div");
    // Footer (buttons)
    const footer = document.createElement("div");
    Object.assign(footer.style, {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "20px"
    });
    const cancelBtn = document.createElement("button");
    cancelBtn.innerText = window.modalTranslations?.cancel || "Cancel";
    Object.assign(cancelBtn.style, {
        background: $5daadc5dcdcf4dfc$var$btn1BackgroundColor,
        color: $5daadc5dcdcf4dfc$var$btn1FontColor,
        border: "1px solid rgba(181, 181, 181, 1)",
        padding: "8px 16px",
        borderRadius: "250px",
        fontWeight: "700",
        fontSize: "18px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        cursor: "pointer"
    });
    const nextBtn = document.createElement("button");
    nextBtn.innerText = window.modalTranslations?.next || "Next";
    Object.assign(nextBtn.style, {
        background: $5daadc5dcdcf4dfc$var$btn2BackgroundColor,
        color: $5daadc5dcdcf4dfc$var$btn2FontColor,
        border: "1px solid rgba(181, 181, 181, 1)",
        padding: "8px 16px",
        borderRadius: "250px",
        fontWeight: "700",
        fontSize: "18px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        cursor: "pointer"
    });
    footer.appendChild(cancelBtn);
    footer.appendChild(nextBtn);
    // Compose modal
    modalBox.appendChild(headerRow);
    modalBox.appendChild(title);
    modalBox.appendChild(stepContent);
    modalBox.appendChild(footer);
    modalOverlay.appendChild(modalBox);
    document.body.appendChild(modalOverlay);
    // Styled dropdown helper
    function createStyledDropdown(defaultOption = {
        label: "Select verification method",
        value: ""
    }) {
        const container = document.createElement("div");
        Object.assign(container.style, {
            position: "relative",
            display: "flex",
            borderRadius: "20px",
            cursor: "pointer",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
        });
        const dropdown = document.createElement("select");
        Object.assign(dropdown.style, {
            padding: "9px 30px 9px 9px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            cursor: "pointer",
            appearance: "none",
            width: "100%",
            color: "rgba(0,0,0,0.65)"
        });
        // Check if Digilocker data exists and is valid
        const hasDigilockerData = $5daadc5dcdcf4dfc$var$DigilockerData && $5daadc5dcdcf4dfc$var$DigilockerData.searchList && Array.isArray($5daadc5dcdcf4dfc$var$DigilockerData.searchList) && $5daadc5dcdcf4dfc$var$DigilockerData.searchList.length > 0;
        // Build options dynamically
        const options = [
            defaultOption
        ];
        if (hasDigilockerData) options.push({
            label: "Proceed with KYC of the parent/legal guardian using DigiLocker",
            value: $5daadc5dcdcf4dfc$var$KYC_DIGILOCKER
        });
        options.push({
            label: "Send the consent link to the parent/legal guardian over SMS/email and obtain approval",
            value: $5daadc5dcdcf4dfc$var$KYC_SMS
        });
        // Add options to dropdown
        options.forEach((opt)=>{
            const optionEl = document.createElement("option");
            optionEl.value = opt.value;
            optionEl.innerText = opt.label;
            dropdown.appendChild(optionEl);
        });
        if (savedDropdown) dropdown.value = savedDropdown;
        // Add SVG icon
        const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        icon.setAttribute("width", "20");
        icon.setAttribute("height", "20");
        icon.setAttribute("viewBox", "0 0 25 25");
        Object.assign(icon.style, {
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            pointerEvents: "none"
        });
        icon.innerHTML = `<path d="M12 15a1 1 0 01-.71-.29l-4-4a1 1 0 111.42-1.42l3.29 3.3 3.29-3.3a1 1 0 111.42 1.42l-4 4A1 1 0 0112 15z" fill="currentColor"></path>`;
        dropdown.addEventListener("change", ()=>{
            selectedKYCMethod = dropdown.value;
            savedDropdown = dropdown.value;
        });
        container.appendChild(dropdown);
        container.appendChild(icon);
        return {
            container: container,
            select: dropdown
        };
    }
    // Validation helpers
    function isValidName(name) {
        return /^[a-zA-Z\s]+$/.test(name.trim());
    }
    function isValidIdentity(identity) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileRegex = /^[0-9]{10}$/;
        return emailRegex.test(identity) || mobileRegex.test(identity);
    }
    // ----------- renderInitial (single screen that toggles inputs based on dropdown) -----------
    function renderInitial() {
        currentStep = 0;
        // Hide back button; stepText hidden until Declaration selected
        backBtn.style.display = "none";
        stepText.style.display = "none";
        headerRow.style.display = "flex"; // keep header area but stepText/back control visibility
        title.innerText = window.modalTranslations?.verificationMethod || "Select verification method (Required)";
        stepContent.innerHTML = "";
        const { container: container, select: select } = createStyledDropdown();
        // restore saved selection
        if (savedDropdown) select.value = savedDropdown;
        // Parent name & identity (created once per initial render)
        const nameLabel = document.createElement("label");
        nameLabel.innerText = window.modalTranslations?.name || "Parent Name (Required)";
        Object.assign(nameLabel.style, {
            display: "none",
            marginBottom: "5px",
            fontWeight: "500",
            fontSize: "14px",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
        });
        const nameInput = document.createElement("input");
        Object.assign(nameInput.style, {
            width: "100%",
            padding: "8px",
            marginBottom: "20px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            display: "none"
        });
        nameInput.value = savedName || "";
        const identityLabel = document.createElement("label");
        identityLabel.innerText = window.modalTranslations?.identity || "Identity (Email or Mobile)";
        Object.assign(identityLabel.style, {
            display: "none",
            marginBottom: "5px",
            fontWeight: "500",
            fontSize: "14px",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
        });
        const identityInput = document.createElement("input");
        Object.assign(identityInput.style, {
            width: "100%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            display: "none"
        });
        identityInput.value = savedIdentity || "";
        // append elements
        stepContent.appendChild(container);
        stepContent.appendChild(nameLabel);
        stepContent.appendChild(nameInput);
        stepContent.appendChild(identityLabel);
        stepContent.appendChild(identityInput);
        // Footer
        footer.innerHTML = "";
        footer.appendChild(cancelBtn);
        footer.appendChild(nextBtn);
        // helper to set visuals depending on selection
        function updateForSelection(val) {
            if (val === $5daadc5dcdcf4dfc$var$KYC_SMS) {
                // stepText.innerText = window.modalTranslations?.step1 || "Step 1/2";
                // stepText.style.display = "block";
                // show inputs
                nameLabel.style.display = "block";
                nameInput.style.display = "block";
                identityLabel.style.display = "block";
                identityInput.style.display = "block";
                backBtn.style.display = "none"; // NO back on initial screen
            } else {
                // blank or DIGILOCKER
                stepText.style.display = "none";
                nameLabel.style.display = "none";
                nameInput.style.display = "none";
                identityLabel.style.display = "none";
                identityInput.style.display = "none";
                backBtn.style.display = "none";
            }
        }
        // reflect saved selection
        updateForSelection(select.value);
        // change handler toggles inputs but does not show back button on initial
        select.addEventListener("change", ()=>{
            selectedKYCMethod = select.value;
            savedDropdown = select.value;
            updateForSelection(select.value);
        });
        // Next behaviour on this initial screen
        nextBtn.onclick = async ()=>{
            const sel = select.value;
            if (!sel) {
                $5daadc5dcdcf4dfc$var$showToast("Please select a verification method", "error");
                return;
            }
            if (sel === $5daadc5dcdcf4dfc$var$KYC_DIGILOCKER) {
                $5daadc5dcdcf4dfc$var$showLoader();
                modalOverlay.remove();
                $5daadc5dcdcf4dfc$var$overlay.remove();
                const responseType = "code";
                const codeChallengeMethod = "S256";
                // prepare redirect data
                const redirectData = {
                    consentHandleId: $5daadc5dcdcf4dfc$var$consentHandleId,
                    preferencesStatus: consentArray,
                    languagePreference: $5daadc5dcdcf4dfc$var$finalSelectedLanguage
                };
                const base64EncodedData = btoa(JSON.stringify(redirectData));
                // Step 1: Generate Transaction ID
                $5daadc5dcdcf4dfc$var$generateDigilockerTransactionId(consentArray).then(async (consentMetaId)=>{
                    if (!consentMetaId) {
                        console.log("Transaction ID not received");
                        return;
                    }
                    // Use consentMetaId as the `state`
                    const state = consentMetaId;
                    const state2 = `${state}:${$5daadc5dcdcf4dfc$var$secureId}`;
                    const codeChallenge = await $5daadc5dcdcf4dfc$var$generateCodeChallenge($5daadc5dcdcf4dfc$var$digilockercodeVerifier);
                    const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=${responseType}&client_id=${$5daadc5dcdcf4dfc$var$digilockerClientId}&redirect_uri=${$5daadc5dcdcf4dfc$var$digilockerredirectUri}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state2}`;
                    setTimeout(()=>{
                        const newTab = window.open(digilockerAuthUrl, "_blank");
                        const checkInterval = setInterval(()=>{
                            if (newTab.closed) {
                                clearInterval(checkInterval);
                                $5daadc5dcdcf4dfc$var$hideLoader();
                                window.location.href = $5daadc5dcdcf4dfc$var$cburl;
                            }
                        }, 1000);
                        window.addEventListener("message", (event)=>{
                            if (event.data === "DIGILOCKER_DONE") {
                                $5daadc5dcdcf4dfc$var$hideLoader();
                                clearInterval(checkInterval);
                                window.location.href = $5daadc5dcdcf4dfc$var$cburl;
                            }
                        });
                    }, 300);
                });
                return;
            }
            window.addEventListener("load", async ()=>{
                try {
                    const urlParams = new URLSearchParams(window.location.search);
                    const encryptedData = urlParams.get("encryptedData");
                    if (!encryptedData) throw new Error("Missing encrypted data");
                    const decodedData = JSON.parse(atob(encryptedData));
                    // Perform your backend or API actions
                    await fetchDetails(decodedData);
                    await callYourMethods(decodedData);
                    //  Notify main tab and close
                    if (window.opener) {
                        s;
                        window.opener.postMessage("DIGILOCKER_DONE", "*");
                    }
                    window.close();
                } catch (err) {
                    console.log("Error in loader page:", err);
                    window.close();
                }
            });
            if (sel === $5daadc5dcdcf4dfc$var$KYC_SMS) {
                const nameVal = nameInput.value.trim();
                const identityVal = identityInput.value.trim();
                if (!isValidName(nameVal)) {
                    $5daadc5dcdcf4dfc$var$showToast("Name should contain letters only", "error");
                    return;
                }
                if (!isValidIdentity(identityVal)) {
                    $5daadc5dcdcf4dfc$var$showToast("Enter a valid email or 10-digit mobile", "error");
                    return;
                }
                savedName = nameVal;
                savedIdentity = identityVal;
                // Call parental consent API
                const response = await $5daadc5dcdcf4dfc$var$sendParentalConsentRequest(nameVal, identityVal);
                if (response) {
                    // Close the modal on success
                    window.location.href = $5daadc5dcdcf4dfc$var$cburl;
                    modalOverlay.remove();
                    $5daadc5dcdcf4dfc$var$overlay.remove();
                }
            }
        };
    }
    // ----------- renderOTPStep (OTP screen with back button) -----------
    function renderOTPStep() {
        currentStep = 2;
        // show header, step 2/2 and back button
        headerRow.style.display = "flex";
        backBtn.style.display = "inline-flex";
        stepText.style.display = "block";
        stepText.innerText = window.modalTranslations?.step2 || "Step 2/2";
        title.innerText = "";
        stepContent.innerHTML = "";
        // build back arrow icon
        backBtn.innerHTML = "";
        const backIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        backIcon.setAttribute("width", "24");
        backIcon.setAttribute("height", "24");
        backIcon.setAttribute("viewBox", "0 0 24 24");
        backIcon.innerHTML = `<path d="M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z" fill="currentColor"></path>`;
        Object.assign(backIcon.style, {
            cursor: "pointer",
            fill: "rgba(0,0,0,0.75)"
        });
        backBtn.appendChild(backIcon);
        // OTP content
        const headerParentOTP = document.createElement("div");
        Object.assign(headerParentOTP.style, {
            fontWeight: "900",
            fontSize: "24px",
            marginBottom: "10px",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
        });
        headerParentOTP.innerText = window.modalTranslations?.otpHeading || "OTP Verification";
        stepContent.appendChild(headerParentOTP);
        const instruction = document.createElement("div");
        instruction.innerText = window.modalTranslations?.otpInstruction || "Enter the 6-digit OTP sent to 9800125683.";
        Object.assign(instruction.style, {
            fontSize: "14px",
            marginBottom: "20px",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
            fontWeight: "500"
        });
        stepContent.appendChild(instruction);
        const otpInput = document.createElement("input");
        otpInput.type = "text";
        otpInput.maxLength = 6;
        otpInput.placeholder = "000000";
        Object.assign(otpInput.style, {
            width: "100%",
            height: "40px",
            textAlign: "center",
            fontSize: "18px",
            letterSpacing: "10px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            outline: "none",
            color: "#000",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
            fontWeight: "500"
        });
        otpInput.addEventListener("input", (e)=>{
            e.target.value = e.target.value.replace(/\D/g, "");
        });
        stepContent.appendChild(otpInput);
        // Footer: Verify only
        footer.innerHTML = "";
        const verifyBtn = document.createElement("button");
        verifyBtn.innerText = window.modalTranslations?.verify || "Verify";
        Object.assign(verifyBtn.style, {
            background: $5daadc5dcdcf4dfc$var$btn2BackgroundColor,
            color: $5daadc5dcdcf4dfc$var$btn2FontColor,
            border: "1px solid rgba(181, 181, 181, 1)",
            padding: "8px 16px",
            borderRadius: "250px",
            fontWeight: "700",
            fontSize: "18px",
            fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
            cursor: "pointer"
        });
        footer.appendChild(verifyBtn);
        // Back: return to initial state (restore saved values, no back button)
        backBtn.onclick = ()=>{
            // ensure saved values are preserved, then renderInitial which will restore visuals
            renderInitial();
        // after renderInitial executes, savedDropdown/name/identity are already used
        };
        verifyBtn.onclick = ()=>{
            const otp = otpInput.value.trim();
            if (otp.length !== 6) {
                $5daadc5dcdcf4dfc$var$showToast("Please enter a valid 6-digit OTP", "error");
                return;
            }
            $5daadc5dcdcf4dfc$var$showToast("OTP verified successfully!", "success");
            setTimeout(()=>modalOverlay.remove(), 800);
        };
    }
    // cancel closes modal
    // cancelBtn.addEventListener("click", () => modalOverlay.remove());
    cancelBtn.addEventListener("click", ()=>{
        // Uncheck the checkbox
        if ($5daadc5dcdcf4dfc$var$checkbox) $5daadc5dcdcf4dfc$var$checkbox.checked = false;
        modalOverlay.remove();
        $5daadc5dcdcf4dfc$var$parentalFlow = false;
        $5daadc5dcdcf4dfc$var$checkbox2.checked = false;
        // Check all row checkboxes and update consentArray
        $5daadc5dcdcf4dfc$var$rowCheckboxes.forEach(({ checkbox: checkbox, prefId: prefId })=>{
            checkbox.checked = false;
        // consentArray2[prefId] = "ACCEPTED";
        });
    });
    // start modal
    renderInitial();
}
function $5daadc5dcdcf4dfc$var$openParentalRelationModal(consentArray) {
    // Overlay
    const modalOverlay = document.createElement("div");
    Object.assign(modalOverlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "9999"
    });
    // Modal Box
    const modalBox = document.createElement("div");
    Object.assign(modalBox.style, {
        borderRadius: "24px",
        width: "420px",
        padding: "20px",
        background: $5daadc5dcdcf4dfc$var$cardBackgroundColor || "#fff",
        color: $5daadc5dcdcf4dfc$var$cardFontColor || "#000",
        position: "relative",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
    });
    /* ---------------- Close Button ---------------- */ const closeBtn = document.createElement("span");
    closeBtn.innerHTML = "&times;";
    Object.assign(closeBtn.style, {
        position: "absolute",
        top: "12px",
        right: "16px",
        fontSize: "22px",
        cursor: "pointer",
        fontWeight: "600"
    });
    function closeParentalModal() {
        $5daadc5dcdcf4dfc$var$hideLoader();
        modalOverlay.remove();
    }
    closeBtn.onclick = closeParentalModal;
    /* ---------------- Header Title ---------------- */ const headerTitle = document.createElement("div");
    headerTitle.innerText = window.relationModalTranslation?.relation || "Select your relationship with the child";
    Object.assign(headerTitle.style, {
        fontSize: "18px",
        fontWeight: "700",
        marginTop: "12px",
        marginBottom: "20px"
    });
    /* ---------------- Radio Options ---------------- */ const optionsContainer = document.createElement("div");
    const createRadio = (translationKey, fallbackText, value)=>{
        const wrapper = document.createElement("div");
        wrapper.style.marginBottom = "12px";
        const radio = document.createElement("input");
        radio.type = "radio";
        radio.name = "guardianType";
        radio.value = value;
        radio.style.marginRight = "8px";
        const label = document.createElement("label");
        label.innerText = window.relationModalTranslation?.[translationKey] || fallbackText;
        if (!window.relationModalElements) window.relationModalElements = {};
        window.relationModalElements[translationKey] = label;
        wrapper.appendChild(radio);
        wrapper.appendChild(label);
        return {
            wrapper: wrapper,
            radio: radio
        };
    };
    const parentOpt = createRadio("parent", "Parent", "PARENT");
    const guardianOpt = createRadio("legalGuardian", "Legal Guardian", "LEGAL_GUARDIAN");
    const otherOpt = createRadio("other", "Other", "OTHER");
    /* ---------------- Other Textbox ---------------- */ const otherInputWrapper = document.createElement("div");
    Object.assign(otherInputWrapper.style, {
        marginLeft: "24px",
        marginTop: "8px",
        display: "none"
    });
    const otherInput = document.createElement("input");
    otherInput.type = "text";
    otherInput.placeholder = "Please specify relationship";
    Object.assign(otherInput.style, {
        width: "90%",
        padding: "6px 10px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        fontSize: "14px"
    });
    otherInputWrapper.appendChild(otherInput);
    /* ---------------- Radio Behaviour ---------------- */ otherOpt.radio.addEventListener("change", ()=>{
        otherInputWrapper.style.display = "block";
    });
    parentOpt.radio.addEventListener("change", ()=>{
        otherInputWrapper.style.display = "none";
        otherInput.value = "";
    });
    guardianOpt.radio.addEventListener("change", ()=>{
        otherInputWrapper.style.display = "none";
        otherInput.value = "";
    });
    optionsContainer.appendChild(parentOpt.wrapper);
    optionsContainer.appendChild(guardianOpt.wrapper);
    optionsContainer.appendChild(otherOpt.wrapper);
    optionsContainer.appendChild(otherInputWrapper);
    /* ---------------- Footer ---------------- */ const footer = document.createElement("div");
    Object.assign(footer.style, {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "24px"
    });
    /* -------- Clear Button -------- */ const clearBtn = document.createElement("button");
    clearBtn.innerText = window.relationModalTranslation?.clear || "Clear";
    Object.assign(clearBtn.style, {
        padding: "8px 18px",
        borderRadius: "24px",
        background: "#f0f0f0",
        color: "#333",
        fontSize: "14px",
        fontWeight: "600",
        border: "1px solid #ccc",
        cursor: "pointer"
    });
    clearBtn.onclick = ()=>{
        parentOpt.radio.checked = true;
        guardianOpt.radio.checked = false;
        otherOpt.radio.checked = false;
        otherInputWrapper.style.display = "none";
        otherInput.value = "";
    };
    /* -------- Save Button -------- */ const relSaveBtn = document.createElement("button");
    relSaveBtn.innerText = window.relationModalTranslation?.save || "Save";
    Object.assign(relSaveBtn.style, {
        padding: "8px 20px",
        borderRadius: "24px",
        background: $5daadc5dcdcf4dfc$var$btn2BackgroundColor || "#007bff",
        color: $5daadc5dcdcf4dfc$var$btn2FontColor || "#fff",
        fontSize: "14px",
        fontWeight: "600",
        border: "none",
        cursor: "pointer"
    });
    relSaveBtn.onclick = ()=>{
        const selected = document.querySelector('input[name="guardianType"]:checked');
        if (!selected) {
            $5daadc5dcdcf4dfc$var$showToast("Please select a relationship", "error", 3000);
            return;
        }
        if (selected.value === "OTHER" && !otherInput.value.trim()) {
            $5daadc5dcdcf4dfc$var$showToast("Please specify the relationship", "error", 3000);
            return;
        }
        window.selectedGuardianType = selected.value;
        window.otherGuardianText = otherInput.value || "";
        modalOverlay.remove();
        $5daadc5dcdcf4dfc$var$startDigilockerFlow(consentArray);
    };
    footer.appendChild(clearBtn);
    footer.appendChild(relSaveBtn);
    /* ---------------- Default Selection ---------------- */ parentOpt.radio.checked = true;
    /* ---------------- Compose ---------------- */ modalBox.appendChild(closeBtn);
    modalBox.appendChild(headerTitle);
    modalBox.appendChild(optionsContainer);
    modalBox.appendChild(footer);
    modalOverlay.appendChild(modalBox);
    document.body.appendChild(modalOverlay);
}
async function $5daadc5dcdcf4dfc$var$sendParentalConsentRequest(parentName, parentIdentity) {
    try {
        // Determine if identity is EMAIL or MOBILE
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isEmail = emailRegex.test(parentIdentity);
        const parentIdentityType = isEmail ? "EMAIL" : "MOBILE";
        $5daadc5dcdcf4dfc$var$showDotLoader("Sending consent request to parent");
        const url = "https://lua.consent.jiolabs.com/user/consent/v1.0/consent-handle/parental-consent";
        const response = await fetch(url, {
            method: "POST",
            headers: {
                accept: "*/*",
                txn: $5daadc5dcdcf4dfc$var$generateUUID(),
                "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                "Content-Type": "application/json",
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            },
            body: JSON.stringify({
                consentHandleId: $5daadc5dcdcf4dfc$var$consentHandleId,
                parentIdentity: parentIdentity.toUpperCase(),
                parentIdentityType: parentIdentityType,
                isParental: true,
                parentName: parentName,
                redirectUri: $5daadc5dcdcf4dfc$var$cburl
            })
        });
        const responseData = await response.json();
        if (!response.ok) {
            let message = "Failed to send parental consent request";
            if (responseData?.[0]?.errorMessage) message = responseData[0].errorMessage;
            else if (responseData?.message) message = responseData.message;
            $5daadc5dcdcf4dfc$var$showToast(message, "error", 3000);
            $5daadc5dcdcf4dfc$var$hideDotLoader();
            return null;
        }
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        // Show appropriate message based on email or mobile
        const successMessage = isEmail ? "A consent request has been sent to your parent's email. Please ask them to approve it." : "A consent request has been sent to your parent's mobile. Please ask them to approve it.";
        $5daadc5dcdcf4dfc$var$showToast(successMessage, "success", 5000);
        return responseData;
    } catch (error) {
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        console.log("Error in sendParentalConsentRequest:", error);
        $5daadc5dcdcf4dfc$var$showToast("Something went wrong. Please try again.", "error", 3000);
        return null;
    }
}
async function $5daadc5dcdcf4dfc$var$fetchDocument(doc_id) {
    try {
        const url = `https://lua.consent.jiolabs.com/user/consent/v1.0/documents/view-document/${doc_id}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
                "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                Accept: "*/*",
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            }
        });
        if (!response.ok) throw new Error("API call failed: " + response.status);
        const blob = await response.blob();
        const pdfUrl = URL.createObjectURL(blob);
        return pdfUrl;
    } catch (error) {
        console.log("Error fetching:", error);
        return null;
    }
}
const $5daadc5dcdcf4dfc$var$showDotLoader = (text)=>{
    const overlay = document.createElement("div");
    overlay.id = "dot-loader-overlay";
    Object.assign(overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
        color: "rgb(15, 60, 201)",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        fontSize: "20px",
        fontWeight: "600",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)"
    });
    // text element
    const loaderText = document.createElement("div");
    loaderText.id = "dot-loader-text";
    loaderText.innerText = text;
    overlay.appendChild(loaderText);
    document.body.appendChild(overlay);
    // animate dots
    let dotCount = 0;
    $5daadc5dcdcf4dfc$var$dotLoaderInterval = setInterval(()=>{
        dotCount = (dotCount + 1) % 5; // cycles 0..4
        loaderText.innerText = text + ".".repeat(dotCount);
    }, 500);
};
const $5daadc5dcdcf4dfc$var$showDotInitLoader = (text)=>{
    const overlay = document.createElement("div");
    overlay.id = "init-dot-loader-overlay";
    Object.assign(overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.05)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
        color: "rgb(15, 60, 201)",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        fontSize: "20px",
        fontWeight: "600",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)"
    });
    // text element
    const loaderText = document.createElement("div");
    loaderText.id = "dot-loader-text";
    loaderText.innerText = text;
    overlay.appendChild(loaderText);
    document.body.appendChild(overlay);
    // animate dots
    let dotCount = 0;
    $5daadc5dcdcf4dfc$var$initDotLoaderInterval = setInterval(()=>{
        dotCount = (dotCount + 1) % 5; // cycles 0..4
        loaderText.innerText = text + ".".repeat(dotCount);
    }, 500);
};
const $5daadc5dcdcf4dfc$var$hideDotLoader = ()=>{
    clearInterval($5daadc5dcdcf4dfc$var$dotLoaderInterval);
    document.getElementById("dot-loader-overlay")?.remove();
};
const $5daadc5dcdcf4dfc$var$hideInitDotLoader = ()=>{
    clearInterval($5daadc5dcdcf4dfc$var$initDotLoaderInterval);
    document.getElementById("init-dot-loader-overlay")?.remove();
};
async function $5daadc5dcdcf4dfc$var$callBhashini(selectedLangKey) {
    try {
        if ($5daadc5dcdcf4dfc$var$langFlag == 1) {
            $5daadc5dcdcf4dfc$var$showDotInitLoader("Loading");
            $5daadc5dcdcf4dfc$var$langFlag = 0;
        } else $5daadc5dcdcf4dfc$var$showDotLoader("Translating");
        const url = "https://lua.consent.jiolabs.com/user/translator/translate";
        const options = [
            {
                value: "ENGLISH",
                label: "English",
                apiValue: "en"
            },
            {
                value: "HINDI",
                label: "Hindi",
                apiValue: "hi"
            },
            {
                value: "BENGALI",
                label: "Bengali",
                apiValue: "bn"
            },
            {
                value: "TAMIL",
                label: "Tamil",
                apiValue: "ta"
            },
            {
                value: "TELUGU",
                label: "Telugu",
                apiValue: "te"
            },
            {
                value: "KANNADA",
                label: "Kannada",
                apiValue: "kn"
            },
            {
                value: "MALAYALAM",
                label: "Malayalam",
                apiValue: "ml"
            },
            {
                value: "GUJARATI",
                label: "Gujarati",
                apiValue: "gu"
            },
            {
                value: "MARATHI",
                label: "Marathi",
                apiValue: "mr"
            },
            {
                value: "ODIA",
                label: "Odia",
                apiValue: "or"
            },
            {
                value: "PUNJABI",
                label: "Punjabi",
                apiValue: "pa"
            },
            {
                value: "ASSAMESE",
                label: "Assamese",
                apiValue: "as"
            },
            {
                value: "NEPALI",
                label: "Nepali",
                apiValue: "ne"
            },
            {
                value: "SINDHI",
                label: "Sindhi",
                apiValue: "sd"
            },
            {
                value: "KASHMIRI",
                label: "Kashmiri",
                apiValue: "ks"
            },
            {
                value: "DOGRI",
                label: "Dogri",
                apiValue: "doi"
            },
            {
                value: "KONKANI",
                label: "Konkani",
                apiValue: "gom"
            },
            {
                value: "MAITHILI",
                label: "Maithili",
                apiValue: "mai"
            },
            {
                value: "SANSKRIT",
                label: "Sanskrit",
                apiValue: "sa"
            },
            {
                value: "SANTALI",
                label: "Santali",
                apiValue: "sat"
            },
            {
                value: "BODO",
                label: "Bodo",
                apiValue: "brx"
            },
            {
                value: "MANIPURI",
                label: "Manipuri",
                apiValue: "mni"
            }
        ];
        const selectedOption = options.find((opt)=>opt.value === selectedLangKey);
        const targetLang = selectedOption ? selectedOption.apiValue : "";
        const targetLang2 = selectedOption ? selectedOption.value : "";
        $5daadc5dcdcf4dfc$var$finalSelectedLanguage = targetLang2;
        function toText(value) {
            return Array.isArray(value) ? value.join(", ") : value;
        }
        const dynamicInputs = $5daadc5dcdcf4dfc$var$templateList1.flatMap((item, index)=>{
            const reqNo = index + 1;
            const inputs = [];
            // Translate Purpose, Duration, Id
            inputs.push({
                id: `purpose_req_${reqNo}`,
                source: toText(item.Purpose)
            });
            inputs.push({
                id: `duration_req_${reqNo}`,
                source: toText(item.Duration)
            });
            inputs.push({
                id: `id_req_${reqNo}`,
                source: item.Id
            });
            // Translate each Processing activity
            (item["Processing activity"] || []).forEach((activityObj, actIndex)=>{
                inputs.push({
                    id: `processingName_req_${reqNo}_${actIndex}`,
                    source: activityObj.activityName
                });
                inputs.push({
                    id: `usedBy_req_${reqNo}_${actIndex}`,
                    source: activityObj.processorName
                });
                inputs.push({
                    id: `dataType_req_${reqNo}_${actIndex}`,
                    source: toText(activityObj.dataTypes)
                });
                inputs.push({
                    id: `dataItem_req_${reqNo}_${actIndex}`,
                    source: toText(activityObj.dataItems)
                });
            });
            return inputs;
        });
        const dynamicInputs2 = $5daadc5dcdcf4dfc$var$templateList2.flatMap((item, index)=>{
            const reqNo = index + 1;
            const inputs = [];
            // Purpose, Duration, Id
            inputs.push({
                id: `purpose_otr_${reqNo}`,
                source: toText(item.Purpose)
            });
            inputs.push({
                id: `duration_otr_${reqNo}`,
                source: toText(item.Duration)
            });
            inputs.push({
                id: `id_otr_${reqNo}`,
                source: item.Id
            });
            // Each Processing activity
            (item["Processing activity"] || []).forEach((activityObj, actIndex)=>{
                inputs.push({
                    id: `processingName_otr_${reqNo}_${actIndex}`,
                    source: activityObj.activityName
                });
                inputs.push({
                    id: `usedBy_otr_${reqNo}_${actIndex}`,
                    source: activityObj.processorName
                });
                inputs.push({
                    id: `dataType_otr_${reqNo}_${actIndex}`,
                    source: toText(activityObj.dataTypes)
                });
                inputs.push({
                    id: `dataItem_otr_${reqNo}_${actIndex}`,
                    source: toText(activityObj.dataItems)
                });
            });
            return inputs;
        });
        const staticInputs = [
            {
                id: "topDescription",
                source: $5daadc5dcdcf4dfc$var$topDesc
            },
            {
                id: "permissionDescription",
                source: $5daadc5dcdcf4dfc$var$permissionText
            },
            {
                id: "rightsDescription",
                source: $5daadc5dcdcf4dfc$var$rightsDesc
            },
            {
                id: "parentCheck",
                source: "I am below 18 years of age."
            },
            {
                id: "saveChoice",
                source: "Save My Choices"
            },
            {
                id: "allowAll",
                source: "Allow All"
            },
            {
                id: "badge",
                source: "Always Active"
            },
            {
                id: "requiredHeader",
                source: $5daadc5dcdcf4dfc$var$requiredLabel
            },
            {
                id: "othersHeader",
                source: "Others"
            },
            {
                id: "customerId",
                source: $5daadc5dcdcf4dfc$var$translatedLabel
            },
            {
                id: "header",
                source: "Manage Consent"
            },
            {
                id: "documentTitle",
                source: $5daadc5dcdcf4dfc$var$doc_name
            },
            {
                id: "click",
                source: "click here"
            },
            {
                id: "parentVerificationMethod",
                source: "Select verification method (Required)"
            },
            {
                id: "parentCancel",
                source: "Cancel"
            },
            {
                id: "parentNext",
                source: "Next"
            },
            {
                id: "parentName",
                source: "Parent Name (Required)"
            },
            {
                id: "parentIdentity",
                source: "Identity (Email or Mobile)"
            },
            {
                id: "parentStep1",
                source: "Step1/2"
            },
            {
                id: "parentStep2",
                source: "Step2/2"
            },
            {
                id: "parentOTPHeading",
                source: "OTP Verification"
            },
            {
                id: "parentOTPInstruction",
                source: "Enter the 6-digit OTP sent to 9800125683."
            },
            {
                id: "parentVerify",
                source: "Verify"
            },
            {
                id: "relation",
                source: "Select your relationship with the child"
            },
            {
                id: "parent",
                source: "Parent"
            },
            {
                id: "legalGuardian",
                source: "Legal Guardian"
            },
            {
                id: "other",
                source: "Other"
            },
            {
                id: "pleaseSpecify",
                source: "Please specify relationship"
            },
            {
                id: "clear",
                source: "Clear"
            },
            {
                id: "save",
                source: "Save"
            },
            // add label translations
            {
                id: "Purpose",
                source: "Purpose"
            },
            {
                id: "Data type",
                source: "Data type"
            },
            {
                id: "Data item",
                source: "Data item"
            },
            {
                id: "Processing activity",
                source: "Processing activity"
            },
            {
                id: "Used by",
                source: "Used by"
            },
            {
                id: "Duration",
                source: "Duration"
            },
            {
                id: "Id",
                source: "Id"
            }
        ];
        const finalInputs = [
            ...staticInputs,
            ...dynamicInputs,
            ...dynamicInputs2
        ];
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                tenantid: $5daadc5dcdcf4dfc$var$tenantId,
                businessid: $5daadc5dcdcf4dfc$var$businessId,
                txn: $5daadc5dcdcf4dfc$var$generateUUID(),
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            },
            body: JSON.stringify({
                configId: "e66b0624-61fb-44e9-b087-8bb312b5387b",
                provider: "BHASHINI",
                source: "CONSENTPOPUP",
                language: {
                    sourceLanguage: $5daadc5dcdcf4dfc$var$currentSourceLang,
                    targetLanguage: targetLang
                },
                input: finalInputs
            })
        });
        const data2 = await response.json();
        // Build a map for translated labels
        const getTranslated = (id)=>data2.output.find((o)=>o.id === id)?.target || "";
        // Build translatedTemplateList
        const translatedTemplateList = $5daadc5dcdcf4dfc$var$templateList1.map((item, index)=>{
            const reqNo = index + 1;
            return {
                Purpose: [
                    getTranslated(`purpose_req_${reqNo}`)
                ],
                Duration: getTranslated(`duration_req_${reqNo}`),
                Id: item.Id,
                "Processing activity": (item["Processing activity"] || []).map((act, actIndex)=>({
                        activityName: getTranslated(`processingName_req_${reqNo}_${actIndex}`),
                        processorName: getTranslated(`usedBy_req_${reqNo}_${actIndex}`),
                        dataTypes: (getTranslated(`dataType_req_${reqNo}_${actIndex}`) || "").split(",").map((s1)=>s1.trim()).filter(Boolean),
                        dataItems: (getTranslated(`dataItem_req_${reqNo}_${actIndex}`) || "").split(",").map((s1)=>s1.trim())
                    }))
            };
        });
        // Build translatedTemplateList2
        const translatedTemplateList2 = $5daadc5dcdcf4dfc$var$templateList2.map((item, index)=>{
            const reqNo = index + 1;
            const processingActivities = (item["Processing activity"] || []).map((act, actIndex)=>({
                    activityName: getTranslated(`processingName_otr_${reqNo}_${actIndex}`),
                    processorName: getTranslated(`usedBy_otr_${reqNo}_${actIndex}`),
                    dataTypes: (getTranslated(`dataType_otr_${reqNo}_${actIndex}`) || "").split(",").map((s1)=>s1.trim()).filter(Boolean),
                    dataItems: (getTranslated(`dataItem_otr_${reqNo}_${actIndex}`) || "").split(",").map((s1)=>s1.trim()).filter(Boolean)
                }));
            return {
                Purpose: [
                    getTranslated(`purpose_otr_${reqNo}`)
                ],
                Duration: getTranslated(`duration_otr_${reqNo}`),
                Id: item.Id,
                "Processing activity": processingActivities
            };
        });
        [
            "Purpose",
            "Data type",
            "Data item",
            "Processing activity",
            "Used by",
            "Duration",
            "Id"
        ].forEach((key)=>{
            const obj = data2.output.find((o)=>o.id === key);
            $5daadc5dcdcf4dfc$var$keyTranslations[key] = obj ? obj.target : key;
        });
        function renderTranslatedList(list, container, keyTranslations) {
            if (!container) return;
            container.innerHTML = "";
            list.forEach((template)=>{
                container.appendChild($5daadc5dcdcf4dfc$var$buildPurposeAccordionItem(template, {
                    keyTranslations: keyTranslations,
                    arrowColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
                    cardColor: $5daadc5dcdcf4dfc$var$cardFontColor
                }));
            });
        }
        // Same change for renderTranslatedList2:
        function renderTranslatedList2(list, container, keyTranslations) {
            if (!container) return;
            container.innerHTML = "";
            $5daadc5dcdcf4dfc$var$rowCheckboxes = [];
            list.forEach((template)=>{
                container.appendChild($5daadc5dcdcf4dfc$var$buildPurposeAccordionItem(template, {
                    keyTranslations: keyTranslations,
                    showCheckbox: true,
                    preferenceId: template.Id,
                    arrowColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
                    cardColor: $5daadc5dcdcf4dfc$var$cardFontColor
                }));
            });
        }
        // Finally call with keyTranslations
        renderTranslatedList(translatedTemplateList, $5daadc5dcdcf4dfc$var$content, $5daadc5dcdcf4dfc$var$keyTranslations);
        renderTranslatedList2(translatedTemplateList2, $5daadc5dcdcf4dfc$var$content2, $5daadc5dcdcf4dfc$var$keyTranslations);
        const getTarget = (id)=>data2.output.find((o)=>o.id === id)?.target || null;
        $5daadc5dcdcf4dfc$var$ConsentAllow.innerHTML = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]?.permissionText || getTarget("permissionDescription");
        $5daadc5dcdcf4dfc$var$TopDesc.innerHTML = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]?.description || getTarget("topDescription");
        $5daadc5dcdcf4dfc$var$withdrawLine.innerHTML = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]?.rightsText || getTarget("rightsDescription");
        $5daadc5dcdcf4dfc$var$checkboxLabel.innerHTML = getTarget("parentCheck");
        $5daadc5dcdcf4dfc$var$title.innerText = getTarget("header");
        $5daadc5dcdcf4dfc$var$labelSpan.innerHTML = getTarget("customerId");
        $5daadc5dcdcf4dfc$var$badge.innerText = getTarget("badge");
        $5daadc5dcdcf4dfc$var$label.innerText = getTarget("requiredHeader");
        $5daadc5dcdcf4dfc$var$label2.innerText = getTarget("othersHeader");
        $5daadc5dcdcf4dfc$var$saveBtn.innerText = getTarget("saveChoice");
        $5daadc5dcdcf4dfc$var$allowBtn.innerText = getTarget("allowAll");
        $5daadc5dcdcf4dfc$var$documentLink.innerText = getTarget("documentTitle");
        $5daadc5dcdcf4dfc$var$clickHere.innerHTML = getTarget("click");
        $5daadc5dcdcf4dfc$var$currentSourceLang = targetLang;
        window.relationModalTranslation = {
            relation: getTarget("relation"),
            parent: getTarget("parent"),
            legalGuardian: getTarget("legalGuardian"),
            other: getTarget("other"),
            pleaseSpecify: getTarget("pleaseSpecify"),
            clear: getTarget("clear"),
            save: getTarget("save")
        };
        window.modalTranslations = {
            verificationMethod: getTarget("parentVerificationMethod"),
            cancel: getTarget("parentCancel"),
            next: getTarget("parentNext"),
            name: getTarget("parentName"),
            identity: getTarget("parentIdentity"),
            step1: getTarget("parentStep1"),
            step2: getTarget("parentStep2"),
            otpHeading: getTarget("parentOTPHeading"),
            otpInstruction: getTarget("parentOTPInstruction"),
            verify: getTarget("parentVerify")
        };
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        $5daadc5dcdcf4dfc$var$hideInitDotLoader();
    } catch (error) {
        console.log("Translation error:", error);
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        $5daadc5dcdcf4dfc$var$hideInitDotLoader();
    }
}
function $5daadc5dcdcf4dfc$var$applyRelationModalTranslations() {
    if (!window.relationModalElements) return;
    Object.keys(window.relationModalElements).forEach((key)=>{
        const el = window.relationModalElements[key];
        const translatedText = window.relationModalTranslation?.[key];
        if (el && translatedText) el.innerText = translatedText;
    });
}
async function $5daadc5dcdcf4dfc$var$generateDigilockerTransactionId(consentArray) {
    if (consentArray == null || typeof consentArray === "object" && Object.keys(consentArray).length === 0) $5daadc5dcdcf4dfc$var$rowCheckboxes.forEach(({ checkbox: checkbox, prefId: prefId })=>{
        consentArray[prefId] = "NOTACCEPTED";
    });
    try {
        $5daadc5dcdcf4dfc$var$showDotLoader("Capturing Your Consent");
        let relationshipValue = "parent";
        if (window.selectedGuardianType === "PARENT") relationshipValue = "Parent";
        else if (window.selectedGuardianType === "LEGAL_GUARDIAN") relationshipValue = "Legal Guardian";
        else if (window.selectedGuardianType === "OTHER") relationshipValue = window.otherGuardianText || "";
        const url = "https://lua.consent.jiolabs.com/user/consent/v1.0/consent-meta/create";
        console.log("RElationship Value:", relationshipValue);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                txn: $5daadc5dcdcf4dfc$var$generateUUID(),
                "Content-Type": "application/json",
                "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            },
            body: JSON.stringify({
                consentHandleId: $5daadc5dcdcf4dfc$var$consentHandleId,
                preferencesStatus: consentArray,
                languagePreference: $5daadc5dcdcf4dfc$var$finalSelectedLanguage,
                isParentalConsent: true,
                secId: $5daadc5dcdcf4dfc$var$secureId,
                relation: relationshipValue
            })
        });
        const responseData = await response.json();
        if (!response.ok) {
            let message = "API call failed";
            if (responseData?.[0]?.errorCode === "JCMP3004") message = "Consent Handle already exists";
            else if (responseData?.[0]?.errorMessage) message = responseData[0].errorMessage;
            $5daadc5dcdcf4dfc$var$showToast(message, "error", 3000);
            throw new Error("API call failed: " + response.status);
        }
        //  Extract consentMetaId from response
        const consentMetaId = responseData?.consentMetaId;
        // if (consentMetaId) {
        //   showToast("Consent Successfully captured.", "success", 6000);
        // }
        $5daadc5dcdcf4dfc$var$overlay.remove();
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        return consentMetaId;
    } catch (error) {
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        console.log("Error in generateDigilockerTransactionId:", error);
        return null;
    }
}
async function $5daadc5dcdcf4dfc$var$captureConsent(consentArray) {
    if (consentArray == null || // covers null & undefined
    typeof consentArray === "object" && Object.keys(consentArray).length === 0) $5daadc5dcdcf4dfc$var$rowCheckboxes.forEach(({ checkbox: checkbox, prefId: prefId })=>{
        consentArray[prefId] = "NOTACCEPTED";
    });
    try {
        if ($5daadc5dcdcf4dfc$var$parentalFlow == true) {
            // If isParental is true, auto-trigger Digilocker flow directly
            if ($5daadc5dcdcf4dfc$var$isParental) {
                // showLoader();
                //overlay.remove();
                $5daadc5dcdcf4dfc$var$openParentalRelationModal(consentArray);
                return;
            }
            // Otherwise show the under 18 modal for manual selection
            $5daadc5dcdcf4dfc$var$openUnder18Modal(consentArray);
        } else {
            $5daadc5dcdcf4dfc$var$showDotLoader("Capturing Your Consent");
            const url = "https://lua.consent.jiolabs.com/user/consent/v1.0/consent/create";
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
                    "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                    Accept: "*/*",
                    "Content-Type": "application/json",
                    "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
                },
                body: JSON.stringify({
                    consentHandleId: $5daadc5dcdcf4dfc$var$consentHandleId,
                    preferencesStatus: consentArray,
                    languagePreference: $5daadc5dcdcf4dfc$var$finalSelectedLanguage
                })
            });
            if (!response.ok) {
                const responseData = await response.json();
                let message = "API call failed";
                if (responseData?.[0]?.errorCode === "JCMP3004") message = "Consent Handle already exists";
                else if (responseData?.[0]?.errorMessage) message = responseData[0].errorMessage;
                $5daadc5dcdcf4dfc$var$showToast(message, "error", 3000);
                throw new Error("API call failed: " + response.status);
            } else {
                $5daadc5dcdcf4dfc$var$showToast("Consent Successfully captured.", "success", 6000);
                $5daadc5dcdcf4dfc$var$parentalFlow = false;
                $5daadc5dcdcf4dfc$var$overlay.remove();
                $5daadc5dcdcf4dfc$var$hideDotLoader();
                window.location.href = $5daadc5dcdcf4dfc$var$cburl;
            }
        }
    } catch (error) {
        return null;
    }
}
async function $5daadc5dcdcf4dfc$var$captureAllConsent(consentArray) {
    try {
        if ($5daadc5dcdcf4dfc$var$parentalFlow == true) {
            // If isParental is true, auto-trigger Digilocker flow directly
            if ($5daadc5dcdcf4dfc$var$isParental) {
                // showLoader();
                //overlay.remove();
                $5daadc5dcdcf4dfc$var$openParentalRelationModal(consentArray);
                return;
            }
            // Otherwise show the under 18 modal for manual selection
            $5daadc5dcdcf4dfc$var$openUnder18Modal(consentArray);
        } else {
            $5daadc5dcdcf4dfc$var$showDotLoader("Capturing Your Consent");
            const url = "https://lua.consent.jiolabs.com/user/consent/v1.0/consent/create";
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
                    "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                    Accept: "*/*",
                    "Content-Type": "application/json",
                    "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
                },
                body: JSON.stringify({
                    consentHandleId: $5daadc5dcdcf4dfc$var$consentHandleId,
                    preferencesStatus: consentArray,
                    languagePreference: $5daadc5dcdcf4dfc$var$finalSelectedLanguage
                })
            });
            if (!response.ok) {
                const responseData = await response.json();
                let message = "API call failed";
                if (responseData?.[0]?.errorCode === "JCMP3004") message = "Consent Handle already exists";
                else if (responseData?.[0]?.errorMessage) message = responseData[0].errorMessage;
                $5daadc5dcdcf4dfc$var$showToast(message, "error", 3000);
                throw new Error("API call failed: " + response.status);
            } else {
                $5daadc5dcdcf4dfc$var$showToast("Consent Successfully captured.", "success", 3000);
                // window.location.href = "/loggedIn";
                $5daadc5dcdcf4dfc$var$parentalFlow = false;
                window.location.href = $5daadc5dcdcf4dfc$var$cburl;
                $5daadc5dcdcf4dfc$var$overlay.remove();
                $5daadc5dcdcf4dfc$var$hideDotLoader();
            }
        }
    } catch (error) {
        $5daadc5dcdcf4dfc$var$hideDotLoader();
        return null;
    }
}
async function $5daadc5dcdcf4dfc$var$fetchConsentData() {
    try {
        const url = `https://lua.consent.jiolabs.com/user/consent/v1.0/consent-handle/get/${$5daadc5dcdcf4dfc$var$consentHandleId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
                "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                Accept: "*/*",
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            }
        });
        if (!response.ok) throw new Error("API call failed: " + response.status);
        $5daadc5dcdcf4dfc$var$data = await response.json();
        // Extract parental consent fields
        $5daadc5dcdcf4dfc$var$isParental = $5daadc5dcdcf4dfc$var$data?.isParental || false;
        $5daadc5dcdcf4dfc$var$parentIdentity = $5daadc5dcdcf4dfc$var$data?.parentIdentity || "";
        $5daadc5dcdcf4dfc$var$parentIdentityType = $5daadc5dcdcf4dfc$var$data?.parentIdentityType || "";
        $5daadc5dcdcf4dfc$var$parentName = $5daadc5dcdcf4dfc$var$data?.parentName || "";
        // Use parentIdentity as customer ID if isParental is true
        $5daadc5dcdcf4dfc$var$cusId = $5daadc5dcdcf4dfc$var$isParental ? $5daadc5dcdcf4dfc$var$parentIdentity : $5daadc5dcdcf4dfc$var$data?.customerIdentifiers?.value;
        if ($5daadc5dcdcf4dfc$var$data?.multilingual?.supportedLanguages.length == 1) {
            $5daadc5dcdcf4dfc$var$langRecieved = $5daadc5dcdcf4dfc$var$data?.multilingual?.supportedLanguages[0];
            $5daadc5dcdcf4dfc$var$langFlag = 1;
        }
        $5daadc5dcdcf4dfc$var$doc_name = $5daadc5dcdcf4dfc$var$data?.documentMeta?.name;
        $5daadc5dcdcf4dfc$var$doc_id = $5daadc5dcdcf4dfc$var$data?.documentMeta?.documentId;
        $5daadc5dcdcf4dfc$var$topDesc = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.ENGLISH?.description;
        $5daadc5dcdcf4dfc$var$rightsDesc = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText;
        $5daadc5dcdcf4dfc$var$permissionText = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText;
        $5daadc5dcdcf4dfc$var$requiredLabel = $5daadc5dcdcf4dfc$var$data?.multilingual?.languageSpecificContentMap?.ENGLISH?.label;
        $5daadc5dcdcf4dfc$var$parentalControl = $5daadc5dcdcf4dfc$var$data?.uiConfig?.parentalControl;
        $5daadc5dcdcf4dfc$var$dataItemToBeShown = $5daadc5dcdcf4dfc$var$data?.uiConfig?.dataItemToBeShown;
        $5daadc5dcdcf4dfc$var$processActivityNameToBeShown = $5daadc5dcdcf4dfc$var$data?.uiConfig?.processActivityNameToBeShown;
        $5daadc5dcdcf4dfc$var$processorNameToBeShown = $5daadc5dcdcf4dfc$var$data?.uiConfig?.processorNameToBeShown;
        $5daadc5dcdcf4dfc$var$validitytoBeShown = $5daadc5dcdcf4dfc$var$data?.uiConfig?.validitytoBeShown;
        $5daadc5dcdcf4dfc$var$darkModeVisibility = $5daadc5dcdcf4dfc$var$data?.uiConfig?.darkMode;
        // darkModeVisibility = false;
        // parentalControl = true;
        $5daadc5dcdcf4dfc$var$logoUrl = $5daadc5dcdcf4dfc$var$data?.uiConfig?.logo;
        // Typography configured for the tenant. The base64 font file is registered
        // as "DynamicFont"; system-ui stays as the fallback while it loads or when
        // no font file is configured.
        const typography = $5daadc5dcdcf4dfc$var$data?.uiConfig?.typographySettings?.ENGLISH;
        if (typography) {
            $5daadc5dcdcf4dfc$var$fontStyle = typography?.fontStyle || $5daadc5dcdcf4dfc$var$fontStyle;
            if (typography?.fontFile) {
                const font = new FontFace("DynamicFont", `url(data:application/octet-stream;base64,${typography.fontFile})`);
                font.load().then(function(loadedFont) {
                    document.fonts.add(loadedFont);
                });
                $5daadc5dcdcf4dfc$var$fontFamily = "DynamicFont, system-ui";
            }
        }
        var theme = $5daadc5dcdcf4dfc$var$data?.uiConfig?.theme;
        if (theme) {
            var decodedThemeStr = atob(theme);
            var decodedTheme = JSON.parse(decodedThemeStr);
            $5daadc5dcdcf4dfc$var$lightTheme = JSON.parse(decodedTheme.light);
            $5daadc5dcdcf4dfc$var$darkTheme = JSON.parse(decodedTheme.dark);
            $5daadc5dcdcf4dfc$var$cardBackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.cardBackground;
            $5daadc5dcdcf4dfc$var$cardFontColor = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            $5daadc5dcdcf4dfc$var$buttonBackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$buttonFontColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$linkFontColor = $5daadc5dcdcf4dfc$var$lightTheme.linkFont;
            $5daadc5dcdcf4dfc$var$btn1BackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$btn1FontColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2BackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2FontColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$applyThemeTokens($5daadc5dcdcf4dfc$var$lightTheme);
        }
        $5daadc5dcdcf4dfc$var$data?.preferences?.forEach((pref)=>{
            const puporse = (pref.purposeList || []).map((pa)=>pa.purposeInfo?.purposeName).filter(Boolean);
            const usedBy = pref.processorActivityList.map((pa)=>pa.processActivityInfo.processorName);
            const processingActivities = pref.processorActivityList.map((p)=>({
                    activityName: p.processActivityInfo.activityName,
                    processorName: p.processActivityInfo.processorName,
                    // Every data type of the activity clubbed into one row, same for items
                    dataTypes: [
                        ...new Set(p.processActivityInfo.dataTypesList.map((d)=>d.dataTypeName).filter(Boolean))
                    ],
                    dataItems: p.processActivityInfo.dataTypesList.flatMap((d)=>d.dataItems)
                }));
            const dataItems = pref.processorActivityList.flatMap((pa)=>pa.processActivityInfo.dataTypesList.flatMap((dt)=>dt.dataItems));
            const id = pref.preferenceId;
            const obj = {
                Purpose: puporse,
                "Used by": [
                    ...new Set(usedBy)
                ],
                Duration: `${pref.preferenceValidity.value} ${pref.preferenceValidity.value === 1 ? pref.preferenceValidity.unit.replace(/s$/i, "") // remove trailing s
                 : pref.preferenceValidity.unit}`,
                "Processing activity": processingActivities,
                "Data item": dataItems,
                Id: id
            };
            $5daadc5dcdcf4dfc$var$consentArray2[pref.preferenceId] = "ACCEPTED";
            if (pref.mandatory) {
                $5daadc5dcdcf4dfc$var$templateList1.push(obj); // Required
                $5daadc5dcdcf4dfc$var$consentArray[pref.preferenceId] = "ACCEPTED";
            } else $5daadc5dcdcf4dfc$var$templateList2.push(obj); // Other
        });
        return $5daadc5dcdcf4dfc$var$data;
    } catch (error) {
        console.log("Error fetching:", error);
        return null;
    }
}
async function $5daadc5dcdcf4dfc$var$fetchDigilockerData() {
    try {
        const url = `https://lua.consent.jiolabs.com/user/partnerportal/v1.0/digilocker/credential/search`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                txn: $5daadc5dcdcf4dfc$var$generateUUID(),
                "tenant-id": $5daadc5dcdcf4dfc$var$tenantId,
                "x-session-token": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJwYXJ0bmVyLXBvcnRhbCIsInRlbmFudElkIjoiNTg5Yzk1YzYtNGJiOC00Njc4LThjMGItYzE1YzczNmNiNDZkIiwic3ViIjoiMzA1NWEwNDItOTFkZi00MWI2LWIxZDMtNDc2YWM5M2ZiNGM2IiwiZXhwIjoxNzYxODg4ODc4LCJpYXQiOjE3NjE4ODUyNzh9.bLREZVmrQrIwxxvIj0BjFmfa9wUiwtbu9GqXmQcmfaznl8UMAuhFq3OEVEKC4wXTh6Ahk_2uwUs0_EmN_wtBc2gVmrZ7tESijFTUPlelzm3NExFXfMR6HcfQxyyvkcZh9Ih_JqEgpJG0akQDdjK0tUd--usZMhFz069T-h5PavvCl6hODDxCwNEtJCWWo0RJ3YEkj6JTjvSRkbIvFULjrA8Qd0uj_31UswcKWheInajoNG-rhEwYO62hpbxFw7svJFDd4whY5JtfXWSV5jC1l1-zy5HaFYn8_q9Euf-S7FP6zCICqGQ7cIK5bgstJhV2QsvdZE6SpRnuabRznzkucg",
                Accept: "application/json",
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            }
        });
        if (!response.ok) throw new Error("API call failed: " + response.status);
        const data2 = await response.json();
        return data2;
    } catch (error) {
        console.log("Error fetching:", error);
        return null;
    }
}
function $5daadc5dcdcf4dfc$var$changeDesc(selectedLangKey) {
    $5daadc5dcdcf4dfc$var$callBhashini(selectedLangKey).then(()=>{
        $5daadc5dcdcf4dfc$var$applyRelationModalTranslations();
    });
}
function $5daadc5dcdcf4dfc$var$selectKYCMethod(method) {
    console.log("Yesssssss", method);
}
const $5daadc5dcdcf4dfc$var$showLoader = ()=>{
    const overlay = document.createElement("div");
    overlay.id = "loader-overlay";
    Object.assign(overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000"
    });
    // spinner container
    const spinner = document.createElement("div");
    Object.assign(spinner.style, {
        border: "8px solid #f3f3f3",
        borderTop: "8px solid #3498db",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        animation: "spin 1s linear infinite"
    });
    // inject keyframes if not already added
    if (!document.getElementById("loader-style")) {
        const style = document.createElement("style");
        style.id = "loader-style";
        style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
        document.head.appendChild(style);
    }
    overlay.appendChild(spinner);
    document.body.appendChild(overlay);
};
const $5daadc5dcdcf4dfc$var$hideLoader = ()=>{
    console.log("Callleddd..");
    document.getElementById("loader-overlay")?.remove();
};
function $5daadc5dcdcf4dfc$var$generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
async function $5daadc5dcdcf4dfc$var$callBhashiniConfig(tenant, business) {
    try {
        const url = "https://lua.consent.jiolabs.com/user/translator/translateConfig";
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                tenantid: tenant,
                businessid: tenant,
                txn: $5daadc5dcdcf4dfc$var$generateUUID(),
                "X-Secure-Code": $5daadc5dcdcf4dfc$var$secureId
            },
            body: JSON.stringify({
                scopeLevel: "BUSINESS",
                config: {
                    provider: "BHASHINI",
                    apiBaseUrl: "https://meity-auth.ulcacontrib.org",
                    modelPipelineEndpoint: "/ulca/apis/v0/model/getModelsPipeline",
                    callbackUrl: "https://dhruva-api.bhashini.gov.in/services/inference/pipeline",
                    userId: "02c3fec39bbf46cda8ece45ba52e78cb",
                    apiKey: "058a0399da-ea84-4077-9e3e-984ff46f8b77",
                    pipelineId: "64392f96daac500b55c543cd"
                }
            })
        });
        if (!response.ok) {
            console.log("Bhashini config API call failed:", response.status);
            return null;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("Error calling Bhashini config API:", error);
        return null;
    }
}
const $5daadc5dcdcf4dfc$var$loadPreferenceCenter = async (handleId, tenant, business, cbackUrl, secCode)=>{
    $5daadc5dcdcf4dfc$var$consentHandleId = handleId;
    $5daadc5dcdcf4dfc$var$tenantId = tenant;
    $5daadc5dcdcf4dfc$var$businessId = business;
    $5daadc5dcdcf4dfc$var$secureId = secCode;
    $5daadc5dcdcf4dfc$var$cburl = cbackUrl;
    $5daadc5dcdcf4dfc$var$showLoader();
    // Call Bhashini configuration API first
    await $5daadc5dcdcf4dfc$var$callBhashiniConfig(tenant, business);
    const consentData = await $5daadc5dcdcf4dfc$var$fetchConsentData();
    console.log("Consent Data recieved:", consentData);
    if (consentData == null || consentData == undefined) {
        $5daadc5dcdcf4dfc$var$showToast("Something went wrong. Please try again later.", "error", 5000);
        setTimeout(()=>{
            window.location.replace($5daadc5dcdcf4dfc$var$cburl);
        }, 3000);
    } else {
        $5daadc5dcdcf4dfc$var$DigilockerData = await $5daadc5dcdcf4dfc$var$fetchDigilockerData();
        if (consentData?.documentMeta?.documentId) await $5daadc5dcdcf4dfc$var$fetchDocument(consentData.documentMeta.documentId);
        // callBhashiniConfig(tenant, business);
        if ($5daadc5dcdcf4dfc$var$DigilockerData) {
            $5daadc5dcdcf4dfc$var$digilockerClientId = $5daadc5dcdcf4dfc$var$DigilockerData?.searchList[0]?.clientId;
            $5daadc5dcdcf4dfc$var$digilockerSecret = $5daadc5dcdcf4dfc$var$DigilockerData?.searchList[0]?.clientSecret;
            $5daadc5dcdcf4dfc$var$digilockercodeVerifier = $5daadc5dcdcf4dfc$var$DigilockerData?.searchList[0]?.codeVerifier;
            $5daadc5dcdcf4dfc$var$digilockerredirectUri = $5daadc5dcdcf4dfc$var$DigilockerData?.searchList[0]?.redirectUri;
        }
        //hideLoader();
        $5daadc5dcdcf4dfc$var$createIntegrationPopup();
        $5daadc5dcdcf4dfc$var$callBhashini($5daadc5dcdcf4dfc$var$langRecieved);
    }
};
// Pulls the accordion / badge / language-dropdown colours out of a decoded
// theme block (light or dark). Falls back to the card colours so tenants whose
// theme does not carry the newer keys keep rendering as before.
function $5daadc5dcdcf4dfc$var$applyThemeTokens(themeObj) {
    if (!themeObj) return;
    $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor = themeObj.mainAccordionBackground || themeObj.cardBackground;
    $5daadc5dcdcf4dfc$var$mainAccordionFontColor = themeObj.mainAccordionFont || themeObj.cardFont;
    $5daadc5dcdcf4dfc$var$subAccordionBackgroundColor = themeObj.subAccordionBackground || themeObj.cardBackground;
    $5daadc5dcdcf4dfc$var$subAccordionFontColor = themeObj.subAccordionFont || themeObj.cardFont;
    $5daadc5dcdcf4dfc$var$activeBadgeFontColor = themeObj.activeBadgeFont || themeObj.cardFont;
    $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor = themeObj.languageDropdownBackground || themeObj.cardBackground;
    $5daadc5dcdcf4dfc$var$languageDropdownFontColor = themeObj.languageDropdownFont || themeObj.cardFont;
}
// Repaints the purpose (sub) accordion headings that are already on screen.
// They are rebuilt on every language change, so new ones pick the colours up
// at creation time and this only has to cover the existing ones.
function $5daadc5dcdcf4dfc$var$applySubAccordionTheme() {
    document.querySelectorAll(".purpose-nested-accordion__summary").forEach((el)=>{
        el.style.background = $5daadc5dcdcf4dfc$var$subAccordionBackgroundColor;
        el.style.color = $5daadc5dcdcf4dfc$var$subAccordionFontColor;
    });
}
// The purpose detail rows carry an inline colour set when they were built, so
// inheriting from the container is not enough - repaint them with the card
// font of whichever theme is now active.
function $5daadc5dcdcf4dfc$var$applySubAccordionBodyTheme() {
    document.querySelectorAll(".purpose-nested-accordion__body").forEach((el)=>{
        el.style.color = $5daadc5dcdcf4dfc$var$cardFontColor;
    });
}
function $5daadc5dcdcf4dfc$var$buildPurposeAccordionItem(template, options = {}) {
    const { keyTranslations: keyTranslations, showCheckbox: showCheckbox = false, preferenceId: preferenceId = null, arrowColor: arrowColor = "", cardColor: cardColor = "", syncMasterCheckbox: syncMasterCheckbox = false } = options;
    const details = document.createElement("details");
    details.className = "purpose-nested-accordion";
    const summary = document.createElement("summary");
    summary.className = "purpose-nested-accordion__summary";
    // Purpose heading colours come from the theme's subAccordion tokens
    summary.style.background = $5daadc5dcdcf4dfc$var$subAccordionBackgroundColor;
    summary.style.color = $5daadc5dcdcf4dfc$var$subAccordionFontColor;
    const arrowEl = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrowEl.setAttribute("width", "30");
    arrowEl.setAttribute("height", "30");
    arrowEl.setAttribute("viewBox", "5 0 12 23");
    arrowEl.classList.add("purpose-nested-accordion__arrow");
    arrowEl.style.color = arrowColor;
    arrowEl.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;
    const titleSpan = document.createElement("span");
    titleSpan.className = "purpose-nested-accordion__title";
    const purposes = Array.isArray(template.Purpose) ? template.Purpose.join(", ") : template.Purpose || "";
    const labelSpan = document.createElement("span");
    labelSpan.className = "purpose-label";
    labelSpan.textContent = "";
    const valueSpan = document.createElement("span");
    valueSpan.className = "purpose-value";
    valueSpan.textContent = purposes;
    titleSpan.appendChild(labelSpan);
    titleSpan.appendChild(valueSpan);
    summary.appendChild(arrowEl);
    summary.appendChild(titleSpan);
    if (showCheckbox && preferenceId) {
        const checkboxDiv = document.createElement("div");
        checkboxDiv.className = "purpose-nested-accordion__checkbox";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "purpose-nested-accordion__input";
        checkbox.style.accentColor = $5daadc5dcdcf4dfc$var$buttonBackgroundColor;
        if ($5daadc5dcdcf4dfc$var$consentArray[preferenceId]) checkbox.checked = true;
        checkbox.addEventListener("click", (e)=>e.stopPropagation());
        checkbox.addEventListener("change", ()=>{
            if (checkbox.checked) $5daadc5dcdcf4dfc$var$consentArray[preferenceId] = "ACCEPTED";
            else delete $5daadc5dcdcf4dfc$var$consentArray[preferenceId];
            if (syncMasterCheckbox && typeof $5daadc5dcdcf4dfc$var$checkbox2 !== "undefined") $5daadc5dcdcf4dfc$var$checkbox2.checked = $5daadc5dcdcf4dfc$var$rowCheckboxes.every(({ checkbox: rowCheckbox })=>rowCheckbox.checked);
        });
        checkboxDiv.appendChild(checkbox);
        summary.appendChild(checkboxDiv);
        $5daadc5dcdcf4dfc$var$rowCheckboxes.push({
            checkbox: checkbox,
            prefId: preferenceId
        });
    } else {
        const checkboxDiv = document.createElement("div");
        checkboxDiv.className = "purpose-nested-accordion__checkbox";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "purpose-nested-accordion__input";
        checkbox.checked = true;
        checkbox.disabled = true;
        checkbox.style.accentColor = $5daadc5dcdcf4dfc$var$buttonBackgroundColor;
        checkbox.style.cursor = "not-allowed";
        checkbox.addEventListener("click", (e)=>e.stopPropagation());
        checkboxDiv.appendChild(checkbox);
        summary.appendChild(checkboxDiv);
    }
    const body = document.createElement("div");
    body.className = "purpose-nested-accordion__body";
    if (cardColor) body.style.color = cardColor;
    function addBodyRow(label, value) {
        const rowDiv = document.createElement("div");
        rowDiv.className = "consent-detail-row";
        const rowLabel = document.createElement("span");
        rowLabel.className = "consent-label";
        rowLabel.textContent = `${label} `;
        const rowValue = document.createElement("span");
        rowValue.className = "consent-value";
        rowValue.textContent = value;
        rowDiv.appendChild(rowLabel);
        rowDiv.appendChild(rowValue);
        body.appendChild(rowDiv);
    }
    if ($5daadc5dcdcf4dfc$var$validitytoBeShown) addBodyRow(`${keyTranslations["Duration"]}:`, template.Duration);
    const processingActivities = template["Processing activity"] || [];
    const hasProcessingRows = processingActivities.length > 0 && ($5daadc5dcdcf4dfc$var$processActivityNameToBeShown || $5daadc5dcdcf4dfc$var$processorNameToBeShown || $5daadc5dcdcf4dfc$var$dataItemToBeShown);
    if (hasProcessingRows) {
        const hrMain = document.createElement("hr");
        body.appendChild(hrMain);
    }
    processingActivities.forEach((activityObj, aIndex)=>{
        if ($5daadc5dcdcf4dfc$var$processActivityNameToBeShown) addBodyRow(`${keyTranslations["Processing activity"]}:`, activityObj.activityName);
        if ($5daadc5dcdcf4dfc$var$processorNameToBeShown) addBodyRow(`${keyTranslations["Used by"]}:`, activityObj.processorName);
        if ($5daadc5dcdcf4dfc$var$dataItemToBeShown) {
            const dataTypes = Array.isArray(activityObj.dataTypes) ? activityObj.dataTypes.filter(Boolean) : activityObj.dataTypes;
            if (Array.isArray(dataTypes) ? dataTypes.length : dataTypes) addBodyRow(`${keyTranslations["Data type"]}:`, Array.isArray(dataTypes) ? dataTypes.join(", ") : dataTypes);
            addBodyRow(`${keyTranslations["Data item"]}:`, Array.isArray(activityObj.dataItems) ? activityObj.dataItems.join(", ") : activityObj.dataItems);
        }
        if (!($5daadc5dcdcf4dfc$var$dataItemToBeShown === false && $5daadc5dcdcf4dfc$var$processActivityNameToBeShown === false && $5daadc5dcdcf4dfc$var$processorNameToBeShown === false) && aIndex < processingActivities.length - 1) {
            const hrActivity = document.createElement("hr");
            body.appendChild(hrActivity);
        }
    });
    details.appendChild(summary);
    details.appendChild(body);
    return details;
}
const $5daadc5dcdcf4dfc$var$createIntegrationPopup = ()=>{
    $5daadc5dcdcf4dfc$var$overlay = document.createElement("div");
    Object.assign($5daadc5dcdcf4dfc$var$overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000"
    });
    const modal = document.createElement("div");
    Object.assign(modal.style, {
        background: $5daadc5dcdcf4dfc$var$cardBackgroundColor,
        padding: "20px",
        borderRadius: "32px",
        width: "584px",
        textAlign: "left",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        fontStyle: $5daadc5dcdcf4dfc$var$fontStyle,
        //maxHeight: "90vh",
        // overflowY: "auto",
        boxSizing: "border-box",
        // ScrollBarWidth: "none",
        color: $5daadc5dcdcf4dfc$var$cardFontColor
    });
    modal.classList.add("custom-modal");
    const toggleWrapper = document.createElement("label");
    Object.assign(toggleWrapper.style, {
        position: "fixed",
        top: "0.5rem",
        right: "0.5rem",
        display: "inline-block",
        width: "50px",
        height: "28px",
        zIndex: "1100",
        cursor: "pointer"
    });
    // Create hidden checkbox
    const toggleCheckbox = document.createElement("input");
    toggleCheckbox.type = "checkbox";
    Object.assign(toggleCheckbox.style, {
        opacity: "0",
        width: "0",
        height: "0"
    });
    // Create slider span
    const slider = document.createElement("span");
    Object.assign(slider.style, {
        position: "absolute",
        cursor: "pointer",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundColor: "#ccc",
        transition: "0.3s",
        borderRadius: "34px"
    });
    // Add circle inside slider
    const circle = document.createElement("span");
    Object.assign(circle.style, {
        position: "absolute",
        content: '""',
        height: "22px",
        width: "22px",
        left: "3px",
        bottom: "3px",
        backgroundColor: "white",
        transition: "0.3s",
        borderRadius: "50%"
    });
    slider.appendChild(circle);
    toggleWrapper.appendChild(toggleCheckbox);
    toggleWrapper.appendChild(slider);
    toggleCheckbox.addEventListener("change", ()=>{
        if (toggleCheckbox.checked) {
            // Dark mode
            slider.style.backgroundColor = "#0F3CC9";
            circle.style.transform = "translateX(22px)";
            modal.style.background = $5daadc5dcdcf4dfc$var$darkTheme.cardBackground;
            modal.style.color = $5daadc5dcdcf4dfc$var$darkTheme.cardFont;
            $5daadc5dcdcf4dfc$var$applyThemeTokens($5daadc5dcdcf4dfc$var$darkTheme);
            applyPopupThemeColors();
            $5daadc5dcdcf4dfc$var$cardFontColor = $5daadc5dcdcf4dfc$var$darkTheme.cardFont;
            $5daadc5dcdcf4dfc$var$cardBackgroundColor = $5daadc5dcdcf4dfc$var$darkTheme.cardBackground;
            $5daadc5dcdcf4dfc$var$cardFontColor = $5daadc5dcdcf4dfc$var$darkTheme.cardFont, // saveBtn.style.background = darkTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$allowBtn.style.background = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$allowBtn.style.color = $5daadc5dcdcf4dfc$var$darkTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$btn1BackgroundColor = $5daadc5dcdcf4dfc$var$darkTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$btn1FontColor = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2BackgroundColor = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2FontColor = $5daadc5dcdcf4dfc$var$darkTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$saveBtn.style.background = $5daadc5dcdcf4dfc$var$darkTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$saveBtn.style.color = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            // path.setAttribute("stroke", darkTheme.buttonBackground);
            // path2.setAttribute("stroke", darkTheme.buttonBackground);
            $5daadc5dcdcf4dfc$var$checkboxLabel.style.color = $5daadc5dcdcf4dfc$var$darkTheme.cardFont;
            $5daadc5dcdcf4dfc$var$documentLink.style.color = $5daadc5dcdcf4dfc$var$darkTheme.linkFont;
            $5daadc5dcdcf4dfc$var$linkFontColor = $5daadc5dcdcf4dfc$var$darkTheme.linkFont;
            closeBtn.style.color = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            arrow2.style.color = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            arrow.style.color = $5daadc5dcdcf4dfc$var$darkTheme.buttonBackground;
            container.style.color = $5daadc5dcdcf4dfc$var$darkTheme.cardFont;
            container2.style.color = $5daadc5dcdcf4dfc$var$darkTheme.cardFont;
            $5daadc5dcdcf4dfc$var$applySubAccordionBodyTheme();
        // buttonBackgroundColor = darkTheme.buttonBackground;
        // buttonFontColor = darkTheme.buttonFont;
        } else {
            // Light mode
            slider.style.backgroundColor = "#ccc";
            circle.style.transform = "translateX(0)";
            modal.style.background = $5daadc5dcdcf4dfc$var$lightTheme.cardBackground;
            modal.style.color = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            // saveBtn.style.background = lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$allowBtn.style.background = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$allowBtn.style.color = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$applyThemeTokens($5daadc5dcdcf4dfc$var$lightTheme);
            applyPopupThemeColors();
            $5daadc5dcdcf4dfc$var$saveBtn.style.background = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$saveBtn.style.color = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn1BackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            $5daadc5dcdcf4dfc$var$btn1FontColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2BackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            $5daadc5dcdcf4dfc$var$btn2FontColor = $5daadc5dcdcf4dfc$var$lightTheme.buttonFont;
            // path.setAttribute("stroke", lightTheme.buttonBackground);
            // path2.setAttribute("stroke", lightTheme.buttonBackground);
            $5daadc5dcdcf4dfc$var$cardBackgroundColor = $5daadc5dcdcf4dfc$var$lightTheme.cardBackground;
            $5daadc5dcdcf4dfc$var$cardFontColor = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            $5daadc5dcdcf4dfc$var$checkboxLabel.style.color = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            $5daadc5dcdcf4dfc$var$documentLink.style.color = $5daadc5dcdcf4dfc$var$lightTheme.linkFont;
            $5daadc5dcdcf4dfc$var$linkFontColor = $5daadc5dcdcf4dfc$var$lightTheme.linkFont;
            closeBtn.style.color = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            arrow2.style.color = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            arrow.style.color = $5daadc5dcdcf4dfc$var$lightTheme.buttonBackground;
            container.style.color = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            container2.style.color = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            $5daadc5dcdcf4dfc$var$cardFontColor = $5daadc5dcdcf4dfc$var$lightTheme.cardFont;
            $5daadc5dcdcf4dfc$var$applySubAccordionBodyTheme();
        // buttonBackgroundColor = lightTheme.buttonBackground;
        // buttonFontColor = lightTheme.buttonFont;
        }
    });
    // Repaints everything driven by the accordion / badge / dropdown theme
    // tokens. Called whenever the dark-light toggle flips, after the tokens
    // themselves have been re-read from the active theme.
    function applyPopupThemeColors() {
        header.style.background = $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor;
        header.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
        $5daadc5dcdcf4dfc$var$label.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
        header2.style.background = $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor;
        header2.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
        $5daadc5dcdcf4dfc$var$label2.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
        // Badge background stays white in both themes
        $5daadc5dcdcf4dfc$var$badge.style.background = $5daadc5dcdcf4dfc$var$activeBadgeBackgroundColor;
        $5daadc5dcdcf4dfc$var$badge.style.color = $5daadc5dcdcf4dfc$var$activeBadgeFontColor;
        dropdown.style.color = $5daadc5dcdcf4dfc$var$languageDropdownFontColor;
        $5daadc5dcdcf4dfc$var$select.style.color = $5daadc5dcdcf4dfc$var$languageDropdownFontColor;
        $5daadc5dcdcf4dfc$var$select.style.background = $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor;
        Array.from($5daadc5dcdcf4dfc$var$select.options).forEach((opt)=>{
            opt.style.color = $5daadc5dcdcf4dfc$var$languageDropdownFontColor;
            opt.style.background = $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor;
        });
        $5daadc5dcdcf4dfc$var$applySubAccordionTheme();
    }
    const style = document.createElement("style");
    style.textContent = `
  .custom-modal {
    scrollbar-width: none; /* Firefox */
  }
  .custom-modal::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  .consent-purpose-container .purpose-nested-accordion {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    width: 100%;
  }

  .consent-purpose-container .purpose-nested-accordion:last-child {
    border-bottom: none;
  }

  .consent-purpose-container .purpose-nested-accordion__summary {
    display: flex;
    flex-direction: row;
    /* centred so the chevron and checkbox line up with multi-line purpose text,
       matching the Required / Others headers */
    align-items: center;
    gap: 0;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    list-style: none;
    font-family: ${$5daadc5dcdcf4dfc$var$fontFamily}, Inter, Arial, sans-serif;
    font-size: 14px;
    color: inherit;
  }

  .consent-purpose-container .purpose-nested-accordion__summary::-webkit-details-marker,
  .consent-purpose-container .purpose-nested-accordion__summary::marker {
    display: none;
    content: "";
  }

  .consent-purpose-container .purpose-nested-accordion__arrow {
    display: block;
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    transition: transform 0.3s ease;
  }

  .consent-purpose-container .purpose-nested-accordion[open] > .purpose-nested-accordion__summary .purpose-nested-accordion__arrow {
    transform: rotate(180deg);
  }

  .consent-purpose-container .purpose-nested-accordion__title {
    flex: 1;
    line-height: 1.4;
    padding-right: 8px;
    min-width: 0;
    font-size: 16px;
  }

  .consent-purpose-container .purpose-label,
  .consent-purpose-container .consent-label {
    font-weight: 500;
  }

  .consent-purpose-container .purpose-value,
  .consent-purpose-container .consent-value {
    font-weight: 500;
  }

  .consent-purpose-container .purpose-nested-accordion__checkbox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 0 0 auto;
  }

  .consent-purpose-container .purpose-nested-accordion__input {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.65);
    cursor: pointer;
  }

  .consent-purpose-container .purpose-nested-accordion__body {
    display: grid;
    grid-template-columns: 1fr;
    gap: 5px;
    /* rows start at the card's left padding, level with the chevron */
    padding: 12px 16px 12px 16px;
    font-family: ${$5daadc5dcdcf4dfc$var$fontFamily}, Inter, Arial, sans-serif;
    font-size: 14px;
  }

  .consent-purpose-container .purpose-nested-accordion__body hr {
    border: 0;
    border-top: 1px solid #ddd;
    margin: 10px 0;
    width: 100%;
  }

  @media (max-width: 768px) {
    .consent-button-container {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }

    .consent-action-btn {
      width: 100% !important;
      max-width: none !important;
    }
  }

  @media (max-width: 329px) {
    .consent-title-container {
      flex-wrap: wrap !important;
      row-gap: 8px !important;
    }

    .consent-title-left {
      display: contents !important;
    }

    .consent-title-heading {
      order: 1;
      flex: 1 1 auto;
      min-width: 0;
      margin: 0;
    }

    .consent-header-logo {
      order: 2;
      flex: 0 0 auto;
    }

    .consent-lang-dropdown {
      order: 3;
      width: 100%;
      display: flex !important;
      justify-content: flex-end !important;
    }
  }

  .others-master-cb:not(:checked) {
    -webkit-appearance: none;
    appearance: none;
    background-color: rgba(0, 0, 0, 0.30);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M18 12a1 1 0 01-1 1H7a1 1 0 010-2h10a1 1 0 011 1z' fill='white'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    border: none !important;
  }
`;
    const firstContainer = document.createElement("div");
    Object.assign(firstContainer.style, {
        display: "flex",
        justifyContent: "flex-end",
        margin: 0,
        padding: "10px 0px",
        position: "sticky"
    });
    const closeBtn = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    closeBtn.setAttribute("width", "30");
    closeBtn.setAttribute("height", "30");
    closeBtn.setAttribute("viewBox", "0 0 25 25");
    const line1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    line1.setAttribute("x1", "6");
    line1.setAttribute("y1", "6");
    line1.setAttribute("x2", "18");
    line1.setAttribute("y2", "18");
    line1.setAttribute("stroke", "rgba(10, 40, 133, 1)");
    line1.setAttribute("stroke-width", "2.5");
    line1.setAttribute("stroke-linecap", "round");
    const line2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    line2.setAttribute("x1", "18");
    line2.setAttribute("y1", "6");
    line2.setAttribute("x2", "6");
    line2.setAttribute("y2", "18");
    line2.setAttribute("stroke", "rgba(10, 40, 133, 1)");
    line2.setAttribute("stroke-width", "2.5");
    line2.setAttribute("stroke-linecap", "round");
    // closeBtn.appendChild(line1);
    // closeBtn.appendChild(line2);
    closeBtn.innerHTML = `<path d="M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z" fill="currentColor"></path>`;
    closeBtn.style.cursor = "pointer";
    closeBtn.style.color = $5daadc5dcdcf4dfc$var$buttonBackgroundColor;
    closeBtn.addEventListener("click", ()=>{
        // window.location.href = "/loggedIn";
        $5daadc5dcdcf4dfc$var$overlay.remove();
        toggleWrapper.remove();
        window.location.replace($5daadc5dcdcf4dfc$var$cburl);
    });
    firstContainer.appendChild(closeBtn);
    const langIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    langIcon.setAttribute("width", "32");
    langIcon.setAttribute("height", "32");
    langIcon.setAttribute("viewBox", "0 0 32 32");
    Object.assign(langIcon.style, {
        display: "inline-block"
    });
    const textA = document.createElementNS("http://www.w3.org/2000/svg", "text");
    textA.setAttribute("x", "2");
    textA.setAttribute("y", "22");
    textA.setAttribute("font-size", "25");
    textA.setAttribute("font-family", "Arial, sans-serif");
    textA.setAttribute("font-weight", "bold");
    textA.setAttribute("fill", "black");
    textA.textContent = "A";
    const textHindi = document.createElementNS("http://www.w3.org/2000/svg", "text");
    textHindi.setAttribute("x", "16");
    textHindi.setAttribute("y", "22");
    textHindi.setAttribute("font-size", "20");
    textHindi.setAttribute("font-family", "Arial, sans-serif");
    textHindi.setAttribute("font-weight", "bold");
    textHindi.setAttribute("fill", "black");
    textHindi.textContent = "\u0905";
    langIcon.appendChild(textA);
    langIcon.appendChild(textHindi);
    const titleContainer = document.createElement("div");
    titleContainer.className = "consent-title-container";
    Object.assign(titleContainer.style, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "10px",
        marginTop: "0.5rem",
        position: "sticky"
    });
    const titleLeftContainer = document.createElement("div");
    titleLeftContainer.className = "consent-title-left";
    Object.assign(titleLeftContainer.style, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "0.5rem"
    });
    $5daadc5dcdcf4dfc$var$title = document.createElement("h2");
    $5daadc5dcdcf4dfc$var$title.className = "consent-title-heading";
    $5daadc5dcdcf4dfc$var$title.innerText = "Manage Consent";
    Object.assign($5daadc5dcdcf4dfc$var$title.style, {
        fontWeight: "900",
        fontSize: "24px"
    });
    const logo = document.createElement("img");
    logo.className = "consent-header-logo";
    logo.src = $5daadc5dcdcf4dfc$var$logoUrl;
    Object.assign(logo.style, {
        width: "32px",
        height: "32px",
        objectFit: "contain"
    });
    titleLeftContainer.appendChild($5daadc5dcdcf4dfc$var$title);
    // Main container
    const container_2 = document.createElement("div");
    container_2.className = "consent-lang-dropdown";
    Object.assign(container_2.style, {
        position: "relative",
        display: "flex",
        borderRadius: "20px",
        cursor: "pointer",
        justifyContent: "space-between",
        alignItems: "center"
    });
    // Dropdown wrapper
    const dropdown = document.createElement("div");
    Object.assign(dropdown.style, {
        position: "relative",
        display: "inline-block",
        alignItems: "center",
        // The language / chevron icons paint with currentColor
        color: $5daadc5dcdcf4dfc$var$languageDropdownFontColor
    });
    const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("width", "20");
    icon.setAttribute("height", "20");
    icon.setAttribute("viewBox", "0 0 25 25");
    Object.assign(icon.style, {
        position: "absolute",
        top: "50%",
        left: "10px",
        transform: "translateY(-50%)",
        pointerEvents: "none"
    });
    icon.innerHTML = `<path d="M21.71 4.29A1 1 0 0021 4h-2.23a1 1 0 00-.71.29 1 1 0 00-.29.71 1 1 0 001 1H19v1.48a2 2 0 01-.85.09 2.3 2.3 0 01-.81-.24A2.29 2.29 0 0016 4.1a2.3 2.3 0 00-2.62.9 1 1 0 00-.15.75 1 1 0 00.43.63 1 1 0 001.39-.28.36.36 0 01.14-.1.54.54 0 01.18 0 .4.4 0 01.15.1.28.28 0 01.07.17.32.32 0 01-.08.21.309.309 0 01-.22.09 1 1 0 00-.92.615 1 1 0 00-.08.385 1 1 0 00.3.7 1 1 0 00.7.3.76.76 0 01.42.12.7.7 0 01.27.34.779.779 0 01.05.43.72.72 0 01-.21.38.78.78 0 01-.38.2A.71.71 0 0115 10a.82.82 0 01-.34-.27.791.791 0 01-.12-.42 1 1 0 00-2 0 2.73 2.73 0 004.56 2.05 2.72 2.72 0 00.9-1.81c.133.01.267.01.4 0 .2.014.402.008.6-.02v1.56c.004.265.108.518.29.71a1.001 1.001 0 001.42 0 1.05 1.05 0 00.29-.71V6a1 1 0 00.71-.29A1.05 1.05 0 0022 5a.999.999 0 00-.29-.71zm-12.28.34a1 1 0 00-1.86 0l-5.5 14a1 1 0 000 .77c.11.24.307.428.55.53a1 1 0 00.77 0c.24-.11.429-.307.53-.55L5.65 15h5.7l1.72 4.37c.049.119.12.228.21.32.09.097.2.175.32.23a1.07 1.07 0 00.79.01c.12-.049.228-.12.32-.21.097-.09.176-.2.23-.32A.998.998 0 0015 19a1.067 1.067 0 00-.07-.39L9.43 4.63zm-3 8.37L8.5 7.73 10.57 13H6.43z" fill="currentColor"/>`;
    const icon2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon2.setAttribute("width", "20");
    icon2.setAttribute("height", "20");
    icon2.setAttribute("viewBox", "0 0 25 25");
    Object.assign(icon2.style, {
        position: "absolute",
        top: "50%",
        right: "10px",
        transform: "translateY(-50%)",
        pointerEvents: "none"
    });
    // Default icon2 (down chevron)
    const downPath = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;
    // Up chevron
    const upPath = `<path d="M16 15a.998.998 0 01-.71-.29L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a.999.999 0 011.42 0l4 4A1.001 1.001 0 0116 15z" fill="currentColor"></path>`;
    // Set default icon
    icon2.innerHTML = downPath;
    // When dropdown opens (focus) → show up chevron
    const languages = [
        "English",
        "Hindi",
        "Bengali",
        "Tamil",
        "Telugu",
        "Kannada",
        "Malayalam",
        "Gujarati",
        "Marathi",
        "Odia",
        "Punjabi",
        "Assamese",
        "Nepali",
        "Sindhi",
        "Kashmiri",
        "Dogri",
        "Konkani",
        "Maithili",
        "Sanskrit",
        "Santali",
        "Bodo",
        "Manipuri"
    ];
    // select dropdown
    $5daadc5dcdcf4dfc$var$select = document.createElement("select");
    Object.assign($5daadc5dcdcf4dfc$var$select.style, {
        padding: "6px 30px 6px 35px",
        fontSize: "14px",
        border: "1px solid #ccc",
        borderRadius: "20px",
        cursor: "pointer",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        color: $5daadc5dcdcf4dfc$var$languageDropdownFontColor,
        background: $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor
    });
    languages.forEach((lang)=>{
        $5daadc5dcdcf4dfc$var$option = document.createElement("option");
        $5daadc5dcdcf4dfc$var$option.value = lang.toUpperCase(); // Use uppercase key for mapping
        $5daadc5dcdcf4dfc$var$option.innerText = lang;
        $5daadc5dcdcf4dfc$var$option.style.color = $5daadc5dcdcf4dfc$var$languageDropdownFontColor;
        $5daadc5dcdcf4dfc$var$option.style.background = $5daadc5dcdcf4dfc$var$languageDropdownBackgroundColor;
        $5daadc5dcdcf4dfc$var$select.appendChild($5daadc5dcdcf4dfc$var$option);
        if ($5daadc5dcdcf4dfc$var$langRecieved) $5daadc5dcdcf4dfc$var$select.value = $5daadc5dcdcf4dfc$var$langRecieved.toUpperCase();
    });
    let isOpen = false;
    // First click -> open
    $5daadc5dcdcf4dfc$var$select.addEventListener("mousedown", ()=>{
        if (!isOpen) {
            icon2.innerHTML = upPath;
            isOpen = true;
        } else {
            // Second click closes dropdown
            icon2.innerHTML = downPath;
            isOpen = false;
        }
    });
    // When selection is made
    $5daadc5dcdcf4dfc$var$select.addEventListener("change", ()=>{
        icon2.innerHTML = downPath;
        isOpen = false;
    });
    // When clicking outside
    $5daadc5dcdcf4dfc$var$select.addEventListener("blur", ()=>{
        icon2.innerHTML = downPath;
        isOpen = false;
    });
    $5daadc5dcdcf4dfc$var$select.addEventListener("change", (e)=>{
        const selectedLangKey = e.target.value;
        $5daadc5dcdcf4dfc$var$changeDesc(selectedLangKey);
    });
    dropdown.appendChild(icon);
    dropdown.appendChild($5daadc5dcdcf4dfc$var$select);
    dropdown.appendChild(icon2);
    container_2.appendChild(dropdown);
    titleLeftContainer.appendChild(container_2);
    titleContainer.appendChild(titleLeftContainer);
    titleContainer.appendChild(logo);
    $5daadc5dcdcf4dfc$var$TopDesc = document.createElement("p");
    $5daadc5dcdcf4dfc$var$TopDesc.innerHTML = `${$5daadc5dcdcf4dfc$var$topDesc}`;
    $5daadc5dcdcf4dfc$var$TopDesc.style.marginTop = "1rem";
    $5daadc5dcdcf4dfc$var$TopDesc.style.marginBottom = "1rem";
    $5daadc5dcdcf4dfc$var$TopDesc.style.fontSize = "14px";
    // TopDesc.style.color = cardFontColor;
    $5daadc5dcdcf4dfc$var$TopDesc.style.fontWeight = "500";
    const customerId = document.createElement("p");
    $5daadc5dcdcf4dfc$var$labelSpan = document.createElement("span");
    $5daadc5dcdcf4dfc$var$labelSpan.innerText = $5daadc5dcdcf4dfc$var$translatedLabel;
    $5daadc5dcdcf4dfc$var$labelSpan.style.fontWeight = "700";
    $5daadc5dcdcf4dfc$var$labelSpan.style.fontSize = "16px";
    const valueSpan = document.createElement("span");
    valueSpan.innerText = `: ${$5daadc5dcdcf4dfc$var$cusId}`;
    valueSpan.style.fontWeight = "400";
    valueSpan.style.fontSize = "16px";
    customerId.appendChild($5daadc5dcdcf4dfc$var$labelSpan);
    customerId.appendChild(valueSpan);
    document.body.appendChild(customerId);
    const mainBody = document.createElement("div");
    Object.assign(mainBody.style, {
        height: "350px",
        overflow: "auto",
        scrollbarWidth: "none"
    });
    const accordion = document.createElement("div");
    Object.assign(accordion.style, {
        margin: "10px 0",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        width: "100%",
        border: "1px solid rgba(224, 224, 224, 1)",
        borderRadius: "12px",
        overflow: "hidden"
    });
    const header = document.createElement("div");
    Object.assign(header.style, {
        display: "grid",
        gridTemplateColumns: "30px 1fr auto",
        alignItems: "center",
        padding: "12px 16px",
        cursor: "pointer",
        userSelect: "none",
        background: $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor,
        color: $5daadc5dcdcf4dfc$var$mainAccordionFontColor
    });
    const arrow = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrow.setAttribute("width", "30");
    arrow.setAttribute("height", "30");
    arrow.setAttribute("viewBox", "5 0 12 23");
    arrow.style.transition = "transform 0.3s ease";
    arrow.style.color = $5daadc5dcdcf4dfc$var$buttonBackgroundColor;
    arrow.style.transform = "rotate(180deg)";
    arrow.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;
    $5daadc5dcdcf4dfc$var$label = document.createElement("span");
    $5daadc5dcdcf4dfc$var$label.innerText = $5daadc5dcdcf4dfc$var$requiredLabel;
    $5daadc5dcdcf4dfc$var$label.style.fontWeight = "700";
    $5daadc5dcdcf4dfc$var$label.style.fontSize = "16px";
    $5daadc5dcdcf4dfc$var$label.style.fontFamily = $5daadc5dcdcf4dfc$var$fontFamily;
    $5daadc5dcdcf4dfc$var$label.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
    header.appendChild(arrow);
    header.appendChild($5daadc5dcdcf4dfc$var$label);
    $5daadc5dcdcf4dfc$var$badge = document.createElement("span");
    $5daadc5dcdcf4dfc$var$badge.innerText = "Always Active";
    Object.assign($5daadc5dcdcf4dfc$var$badge.style, {
        border: "1px solid rgba(181, 181, 181, 1)",
        borderRadius: "80px",
        padding: "4px 12px",
        fontSize: "12px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        fontWeight: 500,
        // Badge background stays white in both light and dark mode
        background: $5daadc5dcdcf4dfc$var$activeBadgeBackgroundColor,
        color: $5daadc5dcdcf4dfc$var$activeBadgeFontColor
    });
    // Required purposes are always granted, so this checkbox is purely indicative:
    // permanently checked and disabled, it drives no consent state.
    const reqCheckbox = document.createElement("input");
    reqCheckbox.type = "checkbox";
    reqCheckbox.checked = true;
    reqCheckbox.disabled = true;
    Object.assign(reqCheckbox.style, {
        width: "24px",
        height: "24px",
        borderRadius: "4px",
        accentColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
        cursor: "not-allowed",
        margin: "0"
    });
    // Grid is "30px 1fr auto", so badge + checkbox share the last column
    const reqRight = document.createElement("div");
    Object.assign(reqRight.style, {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    });
    reqRight.appendChild($5daadc5dcdcf4dfc$var$badge);
    reqRight.appendChild(reqCheckbox);
    header.appendChild(reqRight);
    $5daadc5dcdcf4dfc$var$content = document.createElement("div");
    Object.assign($5daadc5dcdcf4dfc$var$content.style, {
        display: "block",
        fontSize: "14px",
        color: $5daadc5dcdcf4dfc$var$cardFontColor,
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
    });
    const container = document.createElement("div");
    container.className = "consent-purpose-container";
    // Build a translation map after getting data2 from translation API
    // const keyTranslations = {};
    // [
    //   "Purpose",
    //   "Data item",
    //   "Processing activity",
    //   "Used by",
    //   "Duration",
    //   "Id",
    // ].forEach((key) => {
    //   const obj = data2.output.find((o) => o.id === key);
    //   keyTranslations[key] = obj ? obj.target : key;
    // });
    // Render templateList1 with translated labels
    $5daadc5dcdcf4dfc$var$templateList1.forEach((template)=>{
        container.appendChild($5daadc5dcdcf4dfc$var$buildPurposeAccordionItem(template, {
            keyTranslations: $5daadc5dcdcf4dfc$var$keyTranslations,
            arrowColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
            cardColor: $5daadc5dcdcf4dfc$var$cardFontColor
        }));
    });
    $5daadc5dcdcf4dfc$var$content.appendChild(container);
    Object.assign(arrow.style, {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: "6px"
    });
    Object.assign($5daadc5dcdcf4dfc$var$label.style, {
        fontWeight: "700",
        fontSize: "16px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        verticalAlign: "middle"
    });
    // Toggle open/close
    header.addEventListener("click", ()=>{
        const isOpen = $5daadc5dcdcf4dfc$var$content.style.display === "block";
        if (isOpen) {
            // Currently open close it
            $5daadc5dcdcf4dfc$var$content.style.display = "none";
            arrow.style.transform = "rotate(0deg)";
        } else {
            // Currently closed open it
            $5daadc5dcdcf4dfc$var$content.style.display = "block";
            arrow.style.transform = "rotate(180deg)";
        }
    });
    if ($5daadc5dcdcf4dfc$var$templateList1.length > 0) {
        accordion.appendChild(header);
        accordion.appendChild($5daadc5dcdcf4dfc$var$content);
    }
    const accordion2 = document.createElement("div");
    Object.assign(accordion2.style, {
        margin: "10px 0",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        width: "100%",
        border: "1px solid rgba(224, 224, 224, 1)",
        borderRadius: "12px",
        overflow: "hidden"
    });
    const header2 = document.createElement("div");
    Object.assign(header2.style, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        cursor: "pointer",
        userSelect: "none",
        background: $5daadc5dcdcf4dfc$var$mainAccordionBackgroundColor,
        color: $5daadc5dcdcf4dfc$var$mainAccordionFontColor
    });
    const left2 = document.createElement("div");
    Object.assign(left2.style, {
        display: "flex",
        alignItems: "center"
    });
    const arrow2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrow2.setAttribute("width", "30");
    arrow2.setAttribute("height", "30");
    arrow2.setAttribute("viewBox", "5 0 12 23");
    arrow2.style.transition = "transform 0.3s ease";
    arrow2.style.color = $5daadc5dcdcf4dfc$var$buttonBackgroundColor;
    arrow2.style.transform = "rotate(180deg)";
    arrow2.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;
    $5daadc5dcdcf4dfc$var$label2 = document.createElement("span");
    $5daadc5dcdcf4dfc$var$label2.innerText = "Others";
    $5daadc5dcdcf4dfc$var$label2.style.fontWeight = "700";
    $5daadc5dcdcf4dfc$var$label2.style.fontSize = "16px";
    $5daadc5dcdcf4dfc$var$label2.style.fontFamily = $5daadc5dcdcf4dfc$var$fontFamily;
    $5daadc5dcdcf4dfc$var$label2.style.color = $5daadc5dcdcf4dfc$var$mainAccordionFontColor;
    left2.appendChild(arrow2);
    left2.appendChild($5daadc5dcdcf4dfc$var$label2);
    $5daadc5dcdcf4dfc$var$checkbox2 = document.createElement("input");
    $5daadc5dcdcf4dfc$var$checkbox2.type = "checkbox";
    $5daadc5dcdcf4dfc$var$checkbox2.className = "others-master-cb";
    Object.assign($5daadc5dcdcf4dfc$var$checkbox2.style, {
        width: "24px",
        height: "24px",
        borderRadius: "4px",
        border: "1px solid rgba(0,0,0,0.65)",
        cursor: "pointer",
        accentColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor
    });
    $5daadc5dcdcf4dfc$var$checkbox2.addEventListener("change", ()=>{
        const checked = $5daadc5dcdcf4dfc$var$checkbox2.checked;
        $5daadc5dcdcf4dfc$var$rowCheckboxes.forEach(({ checkbox: checkbox, prefId: prefId })=>{
            checkbox.checked = checked;
            if (checked) $5daadc5dcdcf4dfc$var$consentArray[prefId] = "ACCEPTED";
            else delete $5daadc5dcdcf4dfc$var$consentArray[prefId];
        });
    });
    header2.appendChild(left2);
    header2.appendChild($5daadc5dcdcf4dfc$var$checkbox2);
    $5daadc5dcdcf4dfc$var$content2 = document.createElement("div");
    Object.assign($5daadc5dcdcf4dfc$var$content2.style, {
        display: "block",
        fontSize: "14px",
        color: $5daadc5dcdcf4dfc$var$cardFontColor,
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily
    });
    const container2 = document.createElement("div");
    container2.className = "consent-purpose-container";
    // const rowCheckboxes = [];
    $5daadc5dcdcf4dfc$var$templateList2.forEach((template)=>{
        container2.appendChild($5daadc5dcdcf4dfc$var$buildPurposeAccordionItem(template, {
            keyTranslations: $5daadc5dcdcf4dfc$var$keyTranslations,
            showCheckbox: true,
            preferenceId: template.Id,
            arrowColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
            cardColor: $5daadc5dcdcf4dfc$var$cardFontColor,
            syncMasterCheckbox: true
        }));
    });
    $5daadc5dcdcf4dfc$var$content2.appendChild(container2);
    header2.addEventListener("click", ()=>{
        const isOpen = $5daadc5dcdcf4dfc$var$content2.style.display === "block";
        if (isOpen) {
            // Currently open -> close it
            $5daadc5dcdcf4dfc$var$content2.style.display = "none";
            arrow2.style.transform = "rotate(0deg)";
        } else {
            // Currently closed- >open it
            $5daadc5dcdcf4dfc$var$content2.style.display = "block";
            arrow2.style.transform = "rotate(180deg)";
        }
    });
    if ($5daadc5dcdcf4dfc$var$templateList2.length > 0) {
        accordion2.appendChild(header2);
        accordion2.appendChild($5daadc5dcdcf4dfc$var$content2);
    }
    $5daadc5dcdcf4dfc$var$documentLink = document.createElement("p");
    $5daadc5dcdcf4dfc$var$documentLink.innerText = `${$5daadc5dcdcf4dfc$var$doc_name}`;
    Object.assign($5daadc5dcdcf4dfc$var$documentLink.style, {
        color: $5daadc5dcdcf4dfc$var$linkFontColor,
        fontWeight: "700",
        cursor: "pointer",
        margin: "10px 0",
        fontSize: "14px",
        marginBottom: "1rem",
        marginTop: "1rem"
    });
    $5daadc5dcdcf4dfc$var$documentLink.addEventListener("click", async ()=>{
        if (!$5daadc5dcdcf4dfc$var$pdfUrl) $5daadc5dcdcf4dfc$var$pdfUrl = await $5daadc5dcdcf4dfc$var$fetchDocument($5daadc5dcdcf4dfc$var$doc_id);
        if ($5daadc5dcdcf4dfc$var$pdfUrl) window.open($5daadc5dcdcf4dfc$var$pdfUrl, "_blank"); // Opens PDF in new tab
    });
    const checkboxContainer = document.createElement("div");
    Object.assign(checkboxContainer.style, {
        marginTop: "10px",
        marginBottom: "15px",
        display: "flex",
        alignItems: "center",
        gap: "8px"
    });
    $5daadc5dcdcf4dfc$var$checkbox = document.createElement("input");
    $5daadc5dcdcf4dfc$var$checkbox.type = "checkbox";
    Object.assign($5daadc5dcdcf4dfc$var$checkbox.style, {
        width: "16px",
        height: "16px",
        cursor: "pointer",
        borderRadius: "4px",
        border: "1px solid rgba(181, 181, 181, 1)",
        accentColor: $5daadc5dcdcf4dfc$var$buttonBackgroundColor
    });
    // If isParental is true, checkbox should be checked and disabled
    if ($5daadc5dcdcf4dfc$var$isParental) {
        $5daadc5dcdcf4dfc$var$checkbox.checked = true;
        $5daadc5dcdcf4dfc$var$checkbox.disabled = true;
        $5daadc5dcdcf4dfc$var$parentalFlow = true;
    }
    $5daadc5dcdcf4dfc$var$checkbox.addEventListener("change", function() {
        if ($5daadc5dcdcf4dfc$var$checkbox.checked) // openUnder18Modal();
        $5daadc5dcdcf4dfc$var$parentalFlow = true;
        else $5daadc5dcdcf4dfc$var$parentalFlow = false;
    });
    $5daadc5dcdcf4dfc$var$checkboxLabel = document.createElement("label");
    $5daadc5dcdcf4dfc$var$checkboxLabel.innerText = "I am below 18 years of age.";
    $5daadc5dcdcf4dfc$var$checkboxLabel.style.cursor = "pointer";
    $5daadc5dcdcf4dfc$var$checkboxLabel.style.fontSize = "14px";
    // checkboxLabel.style.color = "rgba(0, 0, 0, 0.65)";
    $5daadc5dcdcf4dfc$var$checkboxLabel.style.fontWeight = "bold";
    checkboxContainer.appendChild($5daadc5dcdcf4dfc$var$checkbox);
    checkboxContainer.appendChild($5daadc5dcdcf4dfc$var$checkboxLabel);
    const withdrawContainer = document.createElement("p"); // or "p"
    Object.assign(withdrawContainer.style, {
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        marginTop: "5px",
        fontSize: "14px",
        fontWeight: 500,
        marginBottom: "1rem"
    });
    // Make withdrawLine inline
    $5daadc5dcdcf4dfc$var$withdrawLine = document.createElement("span");
    $5daadc5dcdcf4dfc$var$withdrawLine.innerHTML = `${$5daadc5dcdcf4dfc$var$rightsDesc} `;
    $5daadc5dcdcf4dfc$var$clickHere = document.createElement("span");
    $5daadc5dcdcf4dfc$var$clickHere.innerText = "click here";
    Object.assign($5daadc5dcdcf4dfc$var$clickHere.style, {
        color: $5daadc5dcdcf4dfc$var$linkFontColor,
        fontWeight: "700",
        cursor: "pointer"
    });
    withdrawContainer.appendChild($5daadc5dcdcf4dfc$var$withdrawLine);
    // withdrawContainer.appendChild(clickHere);
    $5daadc5dcdcf4dfc$var$ConsentAllow = document.createElement("p");
    $5daadc5dcdcf4dfc$var$ConsentAllow.innerHTML = `${$5daadc5dcdcf4dfc$var$permissionText}`;
    $5daadc5dcdcf4dfc$var$ConsentAllow.style.marginTop = "5px";
    $5daadc5dcdcf4dfc$var$ConsentAllow.style.fontSize = "14px";
    // ConsentAllow.style.color = cardFontColor;
    $5daadc5dcdcf4dfc$var$ConsentAllow.style.fontWeight = "500";
    $5daadc5dcdcf4dfc$var$ConsentAllow.style.fontFamily = $5daadc5dcdcf4dfc$var$fontFamily;
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "consent-button-container";
    Object.assign(buttonContainer.style, {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "20px",
        position: "sticky"
    });
    $5daadc5dcdcf4dfc$var$saveBtn = document.createElement("button");
    $5daadc5dcdcf4dfc$var$saveBtn.className = "consent-action-btn";
    $5daadc5dcdcf4dfc$var$saveBtn.innerText = "Save My Choices";
    Object.assign($5daadc5dcdcf4dfc$var$saveBtn.style, {
        background: $5daadc5dcdcf4dfc$var$buttonFontColor,
        color: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
        border: "1px solid rgba(181, 181, 181, 1)",
        padding: "12px 24px",
        borderRadius: "250px",
        fontWeight: "700",
        fontSize: "18px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        cursor: "pointer",
        textAlign: "center",
        whiteSpace: "normal",
        wordBreak: "break-word",
        width: "auto",
        maxWidth: "15rem"
    });
    $5daadc5dcdcf4dfc$var$saveBtn.addEventListener("click", ()=>{
        $5daadc5dcdcf4dfc$var$captureConsent($5daadc5dcdcf4dfc$var$consentArray);
    });
    $5daadc5dcdcf4dfc$var$allowBtn = document.createElement("button");
    $5daadc5dcdcf4dfc$var$allowBtn.className = "consent-action-btn";
    $5daadc5dcdcf4dfc$var$allowBtn.innerText = "Allow All";
    // Object.assign(allowBtn.style, {
    //   background: buttonBackgroundColor,
    //   color: buttonFontColor,
    //   border: "none",
    //   padding: "12px 24px",
    //   borderRadius: "250px",
    //   cursor: "pointer",
    //   fontWeight: "700",
    //   fontSize: "18px",
    //   fontFamily: "system-ui",
    //   textAlign: "center",
    //   whiteSpace: "nowrap",
    //   minWidth: "150px", // fallback
    // });
    Object.assign($5daadc5dcdcf4dfc$var$allowBtn.style, {
        background: $5daadc5dcdcf4dfc$var$buttonBackgroundColor,
        color: $5daadc5dcdcf4dfc$var$buttonFontColor,
        border: "1px solid rgba(181, 181, 181, 1)",
        padding: "12px 24px",
        borderRadius: "250px",
        fontWeight: "700",
        fontSize: "18px",
        fontFamily: $5daadc5dcdcf4dfc$var$fontFamily,
        cursor: "pointer",
        textAlign: "center",
        whiteSpace: "normal",
        wordBreak: "break-word",
        width: "auto",
        maxWidth: "15rem"
    });
    $5daadc5dcdcf4dfc$var$allowBtn.addEventListener("click", ()=>{
        // Check the header checkbox
        $5daadc5dcdcf4dfc$var$checkbox2.checked = true;
        // Check all row checkboxes and update consentArray
        $5daadc5dcdcf4dfc$var$rowCheckboxes.forEach(({ checkbox: checkbox, prefId: prefId })=>{
            checkbox.checked = true;
            $5daadc5dcdcf4dfc$var$consentArray2[prefId] = "ACCEPTED";
        });
        $5daadc5dcdcf4dfc$var$captureAllConsent($5daadc5dcdcf4dfc$var$consentArray2);
    });
    buttonContainer.appendChild($5daadc5dcdcf4dfc$var$saveBtn);
    buttonContainer.appendChild($5daadc5dcdcf4dfc$var$allowBtn);
    modal.appendChild(firstContainer);
    modal.appendChild(titleContainer);
    mainBody.appendChild($5daadc5dcdcf4dfc$var$TopDesc);
    mainBody.appendChild(customerId);
    // Only mount an accordion card when it has content, otherwise an empty
    // bordered box shows up as a stray line above/below the one that is shown
    if ($5daadc5dcdcf4dfc$var$templateList1.length > 0) mainBody.appendChild(accordion);
    if ($5daadc5dcdcf4dfc$var$templateList2.length > 0) mainBody.appendChild(accordion2);
    mainBody.appendChild($5daadc5dcdcf4dfc$var$documentLink);
    if ($5daadc5dcdcf4dfc$var$parentalControl == true) mainBody.appendChild(checkboxContainer);
    mainBody.appendChild(withdrawContainer);
    mainBody.appendChild($5daadc5dcdcf4dfc$var$ConsentAllow);
    modal.appendChild(mainBody);
    modal.appendChild(buttonContainer);
    $5daadc5dcdcf4dfc$var$overlay.appendChild(modal);
    $5daadc5dcdcf4dfc$var$overlay.appendChild(style);
    document.body.appendChild($5daadc5dcdcf4dfc$var$overlay);
    if ($5daadc5dcdcf4dfc$var$darkModeVisibility == true) document.body.appendChild(toggleWrapper);
};
var $5daadc5dcdcf4dfc$export$2e2bcd8739ae039 = $5daadc5dcdcf4dfc$var$loadPreferenceCenter;

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$_connect;
var $55388fc2f116d4d7$export$8807b5ba46f9d0b7 = $55388fc2f116d4d7$var$_connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;



parcelRequire("acw62");


var $7484f88fafffadc1$exports = {};

$parcel$export($7484f88fafffadc1$exports, "IcAdd", () => $4c1f85da286cc021$export$27c4cbfb69a3e993);
$parcel$export($7484f88fafffadc1$exports, "IcAddCircle", () => $492c3793f2565770$export$869af20d98048fdb);
$parcel$export($7484f88fafffadc1$exports, "IcBarcode", () => $c785181df5f05ff0$export$a8e06849d04b5a6f);
$parcel$export($7484f88fafffadc1$exports, "IcCalendar", () => $8575d8a7579bc216$export$50599049b1f53719);
$parcel$export($7484f88fafffadc1$exports, "IcCamera", () => $9317423e48146c30$export$7e1befdbe52b3f32);
$parcel$export($7484f88fafffadc1$exports, "IcCloseRemove", () => $41afd5d0591e38b4$export$464f071bbd2cc5e5);
$parcel$export($7484f88fafffadc1$exports, "IcConfirm", () => $81c2e361146d997a$export$5753b5c18d35b7d0);
$parcel$export($7484f88fafffadc1$exports, "IcCopy", () => $e7017ca5d1211e2a$export$d1bc6c264a68b09f);
$parcel$export($7484f88fafffadc1$exports, "IcDownload", () => $60bea030b4289a81$export$bb264a5644c93858);
$parcel$export($7484f88fafffadc1$exports, "IcDownloads", () => $a444653678cb64a6$export$7123f6ef4f453bfb);
$parcel$export($7484f88fafffadc1$exports, "IcEdit", () => $e784d250820e9f29$export$16866440f7f6c8dd);
$parcel$export($7484f88fafffadc1$exports, "IcEditPen", () => $482699419fe250fb$export$55e8bf91189d440f);
$parcel$export($7484f88fafffadc1$exports, "IcExport", () => $29de726ee5eab1bd$export$aca4755275c34537);
$parcel$export($7484f88fafffadc1$exports, "IcFavorite", () => $e91f6485634b0b2d$export$cf9fe37d44aabb87);
$parcel$export($7484f88fafffadc1$exports, "IcFilter", () => $a9dbc27ea69a373d$export$26f46b9510140fcc);
$parcel$export($7484f88fafffadc1$exports, "IcFlipCamera", () => $5dbebc00dddb0397$export$f368e7c219601d0);
$parcel$export($7484f88fafffadc1$exports, "IcForward", () => $5bfc417138d8f1d0$export$78755581f96e0e89);
$parcel$export($7484f88fafffadc1$exports, "IcFullscreenMode", () => $dd63bed1b06632eb$export$bbb3e4be3b42bb9e);
$parcel$export($7484f88fafffadc1$exports, "IcFullscreenModeOff", () => $6ecf4bf16682bccb$export$65093953efbe81ce);
$parcel$export($7484f88fafffadc1$exports, "IcImport", () => $a9954b6e730b1bf2$export$78b80e1f11d67211);
$parcel$export($7484f88fafffadc1$exports, "IcLike", () => $7eac34319dc0f080$export$cbfc8e31e81d3925);
$parcel$export($7484f88fafffadc1$exports, "IcMinimise", () => $c36840204c0c4394$export$28b4ffe30999880e);
$parcel$export($7484f88fafffadc1$exports, "IcMinus", () => $c15dabd2350ae6f1$export$a112cdf9589f07b2);
$parcel$export($7484f88fafffadc1$exports, "IcNotification", () => $22260c4a50157a1d$export$c69b4469075788f4);
$parcel$export($7484f88fafffadc1$exports, "IcNotificationOff", () => $dffc3e9b8ee65686$export$184395fb225b1980);
$parcel$export($7484f88fafffadc1$exports, "IcOpenWith", () => $2a74a59a4eabdf30$export$8d8d10bea6cba17d);
$parcel$export($7484f88fafffadc1$exports, "IcPaste", () => $e6603180443fef86$export$3ff4a916a5aef516);
$parcel$export($7484f88fafffadc1$exports, "IcQrCode", () => $3d7d7f73cd2510e3$export$b085f0ec027ff450);
$parcel$export($7484f88fafffadc1$exports, "IcReply", () => $e6d412d90124b081$export$d8f8141123df49e9);
$parcel$export($7484f88fafffadc1$exports, "IcReplyAll", () => $3ef05a732320915e$export$ee5a0a2b44c8bf7b);
$parcel$export($7484f88fafffadc1$exports, "IcScanQrCode", () => $e85b4fcc36284356$export$b8634ccdc50979ab);
$parcel$export($7484f88fafffadc1$exports, "IcSendMessage", () => $5f9a066e7f58c8de$export$ea9aaa46ca2083e7);
$parcel$export($7484f88fafffadc1$exports, "IcShare", () => $fa655b85abce0796$export$d7bcdec678388771);
$parcel$export($7484f88fafffadc1$exports, "IcSort", () => $c07aaad5de81ca37$export$d802d08b192014d8);
$parcel$export($7484f88fafffadc1$exports, "IcSwap", () => $3f6fa4229d34bf2e$export$7d8d98dd3a766908);
$parcel$export($7484f88fafffadc1$exports, "IcTag", () => $b0cb2302c39973bb$export$af82b8856b912f54);
$parcel$export($7484f88fafffadc1$exports, "IcTime", () => $8c66bf8a36364e42$export$7f3df200d95b839b);
$parcel$export($7484f88fafffadc1$exports, "IcTrash", () => $80b96fbfbd3172e6$export$f4fff73cae16f2b9);
$parcel$export($7484f88fafffadc1$exports, "IcUpload", () => $170225ee6a03579c$export$7a525547346e73a);
$parcel$export($7484f88fafffadc1$exports, "IcUpload1", () => $137d0dfc17372d44$export$904ccf4b059cd9b2);
$parcel$export($7484f88fafffadc1$exports, "IcUploads", () => $9a1d7adf13d086c8$export$6a26d7605291833e);
$parcel$export($7484f88fafffadc1$exports, "IcVisible", () => $35aa9dff24458a00$export$fd7adc84612ab6c3);
$parcel$export($7484f88fafffadc1$exports, "IcVisibleOff", () => $1158e373884bc031$export$2deae51be13efc65);
$parcel$export($7484f88fafffadc1$exports, "IcCard", () => $d736a2a789a742e1$export$d4c35c8bf2c76a77);
$parcel$export($7484f88fafffadc1$exports, "IcCart", () => $e2e2422c14c24c30$export$c7056e444d073e5f);
$parcel$export($7484f88fafffadc1$exports, "IcCcv", () => $b69b9808a49ff611$export$626a5c1c628bf04f);
$parcel$export($7484f88fafffadc1$exports, "IcJiopay", () => $86b1b79c3c2f8f62$export$ba660c68f7598614);
$parcel$export($7484f88fafffadc1$exports, "IcRupee", () => $887f7325e59b5272$export$39cc7d72735656c0);
$parcel$export($7484f88fafffadc1$exports, "IcRupeeCoin", () => $90bdcbe23c465361$export$300912d25f93283a);
$parcel$export($7484f88fafffadc1$exports, "IcLock", () => $ece07e19d3bb23fe$export$445280d67fff5a51);
$parcel$export($7484f88fafffadc1$exports, "IcAlert", () => $3aec256720105e9c$export$eb2e66ed6f7f4580);
$parcel$export($7484f88fafffadc1$exports, "IcError", () => $1b5ba81d287aab3e$export$7e7b259dce3cfe53);
$parcel$export($7484f88fafffadc1$exports, "IcErrorColored", () => $87c0f97f25197d00$export$ed1619aa732c6643);
$parcel$export($7484f88fafffadc1$exports, "IcExclamation", () => $424fd8c04912da5a$export$58992a8aa3d7330d);
$parcel$export($7484f88fafffadc1$exports, "IcHelp", () => $add8a63bd690a801$export$efe9dd4bbd32421a);
$parcel$export($7484f88fafffadc1$exports, "IcInfo", () => $f2a56b92690f077c$export$556fe0871d9b7899);
$parcel$export($7484f88fafffadc1$exports, "IcMessageSend", () => $f20e5c46cb036732$export$cc2840fa1985b883);
$parcel$export($7484f88fafffadc1$exports, "IcSmileyHappy", () => $aede1794a6cdc7a9$export$f528a1ee477aaf33);
$parcel$export($7484f88fafffadc1$exports, "IcSmileyUnhappy", () => $32b7d64435ad8d7d$export$b675dff6d0b6c0c8);
$parcel$export($7484f88fafffadc1$exports, "IcStar", () => $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d);
$parcel$export($7484f88fafffadc1$exports, "IcSuccess", () => $5a00847d48e39b4f$export$13b8539f4be0c);
$parcel$export($7484f88fafffadc1$exports, "IcSuccessColored", () => $dd949b1a0491130c$export$50c1b72d39add9);
$parcel$export($7484f88fafffadc1$exports, "IcWarning", () => $45f8c8717b087f21$export$ff711dd56629d4f5);
$parcel$export($7484f88fafffadc1$exports, "IcWarningColored", () => $7dab575aad091c08$export$47407925ae9f1f0e);
$parcel$export($7484f88fafffadc1$exports, "IcJioDot", () => $fc7e21f78fe2b481$export$faf9e552d710fc5c);
$parcel$export($7484f88fafffadc1$exports, "IcJioDotExclude", () => $9a08af96ef429fe7$export$b15d2693bd1dee35);
$parcel$export($7484f88fafffadc1$exports, "IcJioDotJiofinanceColoured", () => $e93a0cbebb073b75$export$3d9cd62ef287ff59);
$parcel$export($7484f88fafffadc1$exports, "IcLocation", () => $a2a7fa360d9e5b06$export$d586aed94de44e82);
$parcel$export($7484f88fafffadc1$exports, "IcLocationOff", () => $71ffb9683d52e4d1$export$8fe68ed1b5ac245c);
$parcel$export($7484f88fafffadc1$exports, "IcMap", () => $b319dcf7d3363cf8$export$af0a72b1e9c547c5);
$parcel$export($7484f88fafffadc1$exports, "IcMyLocation", () => $aeccc785c2557670$export$51e681bf0729a333);
$parcel$export($7484f88fafffadc1$exports, "IcBrokenImage", () => $2ec6e55380d31e07$export$58f9be5875231b2);
$parcel$export($7484f88fafffadc1$exports, "IcImage", () => $7a6acfb156a88414$export$4736cab3fc47e2fb);
$parcel$export($7484f88fafffadc1$exports, "IcMic", () => $ce2d37347311037b$export$c1c61a3da2c48ae4);
$parcel$export($7484f88fafffadc1$exports, "IcMicOff", () => $5ab3776403d77391$export$4f5b8d1e98c25c06);
$parcel$export($7484f88fafffadc1$exports, "IcPause", () => $5ac5f7859b261b8c$export$1eb29c5f2b0051d3);
$parcel$export($7484f88fafffadc1$exports, "IcPlay", () => $8449ed9a443d9574$export$a93378bd68e53d32);
$parcel$export($7484f88fafffadc1$exports, "IcAppSwitcher", () => $29064e5ed5e1f396$export$af0536a50732761b);
$parcel$export($7484f88fafffadc1$exports, "IcArrowBack", () => $92450cc98193c6d3$export$aed2803299c2cf67);
$parcel$export($7484f88fafffadc1$exports, "IcArrowNext", () => $d8752f0f494f2380$export$a1075cdfac2f932);
$parcel$export($7484f88fafffadc1$exports, "IcBack", () => $575ba915d2bd5d5b$export$740276c76f223dd4);
$parcel$export($7484f88fafffadc1$exports, "IcBurgerMenu", () => $fc255cc0cffe8df6$export$3bb087c30947880a);
$parcel$export($7484f88fafffadc1$exports, "IcChevronDown", () => $fdc94045ec0e5793$export$ec7db1c418c1ec5a);
$parcel$export($7484f88fafffadc1$exports, "IcChevronLeft", () => $1b63d62cdd4af45e$export$8203b8a87ae185f);
$parcel$export($7484f88fafffadc1$exports, "IcChevronRight", () => $735120fcd87dd052$export$a477256bf52ac2f7);
$parcel$export($7484f88fafffadc1$exports, "IcChevronUp", () => $9efe7828a40b52f7$export$acd925e63e14000f);
$parcel$export($7484f88fafffadc1$exports, "IcClose", () => $4b407a2b367f43e3$export$48672c81f0c3f574);
$parcel$export($7484f88fafffadc1$exports, "IcFirstpage", () => $4c01e0333386e8c5$export$885ccec48f920b92);
$parcel$export($7484f88fafffadc1$exports, "IcHome", () => $a612d6b4674022e7$export$10426ed6ef0ab637);
$parcel$export($7484f88fafffadc1$exports, "IcLastpage", () => $bc0db77fbff65188$export$1093b8f29e1cf10c);
$parcel$export($7484f88fafffadc1$exports, "IcLogin", () => $304780aca3b3a13a$export$a883bfa83ec843c8);
$parcel$export($7484f88fafffadc1$exports, "IcLogout", () => $10a623943a1be9a9$export$5c4cc728e7726d4e);
$parcel$export($7484f88fafffadc1$exports, "IcMoreHorizontal", () => $ffc7075420fce577$export$f6c2e7c657f578c5);
$parcel$export($7484f88fafffadc1$exports, "IcMoreVertical", () => $31b79cb94a7f2481$export$76eade3e6c39fefd);
$parcel$export($7484f88fafffadc1$exports, "IcNext", () => $b59efb8c56ba82c0$export$17beb55fda7072f9);
$parcel$export($7484f88fafffadc1$exports, "IcSearch", () => $52f7703976716e4f$export$6da2c307edd95198);
$parcel$export($7484f88fafffadc1$exports, "IcSettings", () => $7aed0775866c148c$export$f7d6d35bb50c6222);
$parcel$export($7484f88fafffadc1$exports, "IcProfile", () => $2f5be6df98c377a7$export$8c6932a2fedd46e4);
$parcel$export($7484f88fafffadc1$exports, "IcUser", () => $807fef1d289a1edd$export$255f0ef2dfc5eb49);

const $4c1f85da286cc021$export$27c4cbfb69a3e993 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-7V4a1 1 0 00-2 0v7H4a1 1 0 000 2h7v7a1 1 0 002 0v-7h7a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $492c3793f2565770$export$869af20d98048fdb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11h-3v3a1 1 0 01-2 0v-3H8a1 1 0 010-2h3V8a1 1 0 012 0v3h3a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c785181df5f05ff0$export$a8e06849d04b5a6f = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zM8 7a1 1 0 00-1 1v8a1 1 0 102 0V8a1 1 0 00-1-1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9-1a1 1 0 00-1 1v8a1 1 0 002 0V8a1 1 0 00-1-1zm9 9a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zm-4 0V8a1 1 0 00-2 0v8a1 1 0 002 0z",
            fill: "currentColor"
        })
    });



const $8575d8a7579bc216$export$50599049b1f53719 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-4.5 14a1 1 0 01-2 0v-3.59l-.29.3a1.004 1.004 0 11-1.42-1.42l2-2a.999.999 0 011.09-.21 1 1 0 01.62.92v6zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $9317423e48146c30$export$7e1befdbe52b3f32 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-7 9a3 3 0 110-5.999A3 3 0 0112 16z",
            fill: "currentColor"
        })
    });



const $41afd5d0591e38b4$export$464f071bbd2cc5e5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $81c2e361146d997a$export$5753b5c18d35b7d0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $e7017ca5d1211e2a$export$d1bc6c264a68b09f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 8H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-8a3 3 0 00-3-3zm6-6h-8a3 3 0 00-3 3v1h5a5 5 0 015 5v5h1a3 3 0 003-3V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $60bea030b4289a81$export$bb264a5644c93858 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 20H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zM16.71 10.29a.996.996 0 00-1.41 0l-2.29 2.29V4.99c0-.55-.45-1-1-1s-1 .45-1 1v7.59l-2.29-2.29a.996.996 0 10-1.41 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $a444653678cb64a6$export$7123f6ef4f453bfb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 12a10 10 0 10-20 0 10 10 0 0020 0zm-10.71 4.71l-3-3a1.001 1.001 0 01.325-1.639 1 1 0 011.095.219l1.29 1.3V8a1 1 0 012 0v5.59l1.29-1.3a1.004 1.004 0 111.42 1.42l-3 3a1 1 0 01-.33.21 1 1 0 01-.76 0 1.001 1.001 0 01-.33-.21z",
            fill: "currentColor"
        })
    });



const $e784d250820e9f29$export$16866440f7f6c8dd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.06 10.82l-.62.62A1.51 1.51 0 0010 12.5V14h1.5a1.51 1.51 0 001.06-.44l.62-.62 7.38-7.38a1.5 1.5 0 10-2.12-2.12l-7.38 7.38zM11.5 16H8v-3.5A3.49 3.49 0 019 10l7-7H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V8l-7 7a3.487 3.487 0 01-2.5 1z",
            fill: "currentColor"
        })
    });



const $482699419fe250fb$export$55e8bf91189d440f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 4.5a3.54 3.54 0 00-5 0l-.29.29 5 5 .29-.29a3.54 3.54 0 000-5zm-13.95 9a3 3 0 00-.76 1.3l-1 3.65a1.5 1.5 0 001.81 1.81l3.65-1.05a3 3 0 001.3-.76l7.24-7.24-5-5-7.24 7.29z",
            fill: "currentColor"
        })
    });



const $29de726ee5eab1bd$export$aca4755275c34537 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 00-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $e91f6485634b0b2d$export$cf9fe37d44aabb87 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c0 3.37 2.63 6.43 7.16 10.56l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4z",
            fill: "currentColor"
        })
    });



const $a9dbc27ea69a373d$export$26f46b9510140fcc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 11H7a1 1 0 000 2h10a1 1 0 000-2zm-3 6h-4a1 1 0 000 2h4a1 1 0 000-2zm6-12H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $5dbebc00dddb0397$export$f368e7c219601d0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 7.88A2.99 2.99 0 0019 7h-.9c-.17 0-.34-.05-.48-.13a.908.908 0 01-.36-.34l-1-1.6c-.19-.29-.44-.52-.73-.69-.3-.16-.64-.24-.97-.24H9.44c-.34 0-.67.08-.97.25-.29.16-.54.39-.72.68l-1 1.6c-.09.14-.22.26-.37.34-.15.09-.31.13-.48.13H5c-.8 0-1.56.31-2.13.88C2.3 8.45 2 9.2 2 10v7c0 .79.31 1.56.87 2.12.57.56 1.33.88 2.13.88h14c.79 0 1.55-.32 2.12-.88.56-.56.88-1.33.88-2.12v-7c0-.8-.32-1.56-.88-2.12zM8 16c-.26 0-.51-.1-.71-.29l-2-2A.996.996 0 116.7 12.3l.33.33c.2-2.58 2.33-4.62 4.96-4.62.39 0 .8.06 1.25.17.53.14.85.68.72 1.22-.14.54-.69.85-1.22.72a3.16 3.16 0 00-.75-.11c-1.5 0-2.73 1.1-2.95 2.54l.25-.25a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29H8zm10.71-2.29c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-.33-.33C16.76 15.96 14.63 18 12 18c-.39 0-.8-.06-1.25-.17-.53-.14-.85-.68-.72-1.22.14-.54.68-.85 1.22-.72.29.07.52.11.75.11 1.5 0 2.73-1.1 2.95-2.54l-.25.25a.996.996 0 11-1.41-1.41l2-2a.996.996 0 011.41 0l2 2c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $5bfc417138d8f1d0$export$78755581f96e0e89 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.41 9.59l-5-5a2 2 0 00-2.18-.44A2 2 0 0013 6v2S2.75 9.86 2 19.84A1.09 1.09 0 003.07 21a1.08 1.08 0 001-.78C4.68 18.39 6.67 14 13 14v2a2 2 0 001.23 1.85 2 2 0 002.18-.44l5-5a2 2 0 000-2.82z",
            fill: "currentColor"
        })
    });



const $dd63bed1b06632eb$export$bbb3e4be3b42bb9e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.92 13.38c-.15.37-.52.62-.92.62H9c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01zM16 12c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3H16z",
            fill: "currentColor"
        })
    });



const $6ecf4bf16682bccb$export$65093953efbe81ce = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-.5 14.5c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3h.01zm5.92-5.62c-.15.37-.52.62-.92.62h-3c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01z",
            fill: "currentColor"
        })
    });



const $a9954b6e730b1bf2$export$78b80e1f11d67211 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.29 16.71a1.002 1.002 0 001.42 0l3-3a1.004 1.004 0 10-1.42-1.42L13 13.59V3a1 1 0 00-2 0v10.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 10-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $7eac34319dc0f080$export$cbfc8e31e81d3925 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 11v7a2 2 0 002 2h2V9H5a2 2 0 00-2 2zm17.24-1A3 3 0 0018 9h-4V5.08a2 2 0 00-3.94-.57l-1 4A2.12 2.12 0 009 9v11h8.44a3 3 0 003-2.67l.55-5a2.999 2.999 0 00-.75-2.33z",
            fill: "currentColor"
        })
    });



const $c36840204c0c4394$export$28b4ffe30999880e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c15dabd2350ae6f1$export$a112cdf9589f07b2 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.293 11.293A1 1 0 014 11h16a1 1 0 010 2H4a1 1 0 01-.707-1.707z",
            fill: "currentColor"
        })
    });



const $22260c4a50157a1d$export$c69b4469075788f4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 16h-1v-6a8 8 0 00-16 0v6H3a1 1 0 000 2h18a1 1 0 000-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $dffc3e9b8ee65686$export$184395fb225b1980 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8v5.76L16.42 3.34A7.89 7.89 0 0012 2zm9 14h-1v-6a8.001 8.001 0 00-.89-3.66L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49L7.44 18H21a1 1 0 100-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $2a74a59a4eabdf30$export$8d8d10bea6cba17d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h6a1 1 0 100-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1zm.92-7.38a1 1 0 00-.54-.54A1 1 0 0020 3h-4a1 1 0 100 2h1.59l-6.3 6.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219L19 6.41V8a1 1 0 002 0V4a1.001 1.001 0 00-.08-.38z",
            fill: "currentColor"
        })
    });



const $e6603180443fef86$export$3ff4a916a5aef516 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2h-8a3 3 0 00-3 3v3H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-3h3a3 3 0 003-3V5a3 3 0 00-3-3zm1 11a1 1 0 01-1 1h-3v-3a3 3 0 00-3-3h-3V5a1 1 0 011-1h8a1 1 0 011 1v8z",
            fill: "currentColor"
        })
    });



const $3d7d7f73cd2510e3$export$b085f0ec027ff450 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 15H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm5-6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm7-6h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 9h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2zm14 2h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm1 8h-7v-6c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1h7v6c0 1.1.9 2 2 2h7c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $e6d412d90124b081$export$d8f8141123df49e9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.59 9.59l5-5a2 2 0 012.18-.44A2 2 0 0111 6v2s10.25 1.86 11 11.84A1.09 1.09 0 0120.93 21a1.08 1.08 0 01-1-.78C19.32 18.39 17.33 14 11 14v2a2 2 0 01-1.23 1.85 2 2 0 01-2.18-.44l-5-5a2 2 0 010-2.82z",
            fill: "currentColor"
        })
    });



const $3ef05a732320915e$export$ee5a0a2b44c8bf7b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 9V7a2 2 0 00-1.23-1.85 2 2 0 00-2.18.44l-5 5a2 2 0 000 2.82l5 5a2 2 0 002.18.44A2 2 0 0011 17v-2c6.33 0 8.32 4.39 8.85 6.22a1.08 1.08 0 001 .78A1.09 1.09 0 0022 20.84C21.25 10.86 11 9 11 9zm2-2v.44a16.37 16.37 0 019 6.81v-.14c-.57-7.63-8.41-9-8.41-9V3.53A1.53 1.53 0 0011 2.45l-.76.76c.1 0 .21 0 .31.09A4 4 0 0113 7z",
            fill: "currentColor"
        })
    });



const $e85b4fcc36284356$export$b8634ccdc50979ab = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 7v2a1 1 0 001 1h2a1 1 0 001-1V7a1 1 0 00-1-1H7a1 1 0 00-1 1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9 2a1 1 0 001-1V7a1 1 0 00-2 0v2a1 1 0 001 1zm3 5h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm0-5h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm6 6a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm-1 15a1 1 0 00-1-1h-4v-4a1 1 0 00-1-1H7a1 1 0 000 2h4v4a1 1 0 001 1h5a1 1 0 001-1zm-9-3H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1zm-2 6H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5f9a066e7f58c8de$export$ea9aaa46ca2083e7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.79 10.16l-14-6A2 2 0 005 4a2 2 0 00-1.965 2.398 2 2 0 00.355.792L6.76 12l-3.35 4.79a2 2 0 002.38 3.05l14-6a2 2 0 000-3.68z",
            fill: "currentColor"
        })
    });



const $fa655b85abce0796$export$d7bcdec678388771 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 15a3 3 0 00-2.15.91L8 12.27c.005-.09.005-.18 0-.27.005-.09.005-.18 0-.27l7.88-3.64A3 3 0 1015 6c-.005.09-.005.18 0 .27L7.15 9.91a3 3 0 100 4.18L15 17.73c-.005.09-.005.18 0 .27a3 3 0 103-3z",
            fill: "currentColor"
        })
    });



const $c07aaad5de81ca37$export$d802d08b192014d8 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 00-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a1 1 0 000-1.42 1.002 1.002 0 00-1.42 0zm11.42-6l-4-4a1 1 0 00-1.42 0l-4 4a1 1 0 00.326 1.639 1 1 0 001.094-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
            fill: "currentColor"
        })
    });



const $3f6fa4229d34bf2e$export$7d8d98dd3a766908 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 12a1.002 1.002 0 001.006-1 1 1 0 00-.296-.71L7.41 8H18a1 1 0 100-2H7.41l2.3-2.29a1.004 1.004 0 10-1.42-1.42l-4 4a1 1 0 000 1.42l4 4A1 1 0 009 12zm10.71 4.29l-4-4a1 1 0 00-1.42 0 1 1 0 000 1.42l2.3 2.29H6a1 1 0 100 2h10.59l-2.3 2.29a1.004 1.004 0 101.42 1.42l4-4a.999.999 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $b0cb2302c39973bb$export$af82b8856b912f54 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.53l-.7-5.24a3 3 0 00-2.59-2.59L13.47 2a3 3 0 00-2.5.86L2.88 11a3 3 0 000 4.24l5.91 5.91a3 3 0 004.24 0L21.12 13a3.052 3.052 0 00.88-2.47zM16.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $8c66bf8a36364e42$export$7f3df200d95b839b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1 11a1 1 0 01-1 1H9a1 1 0 010-2h2V9a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $80b96fbfbd3172e6$export$f4fff73cae16f2b9 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6h-2V5a3 3 0 00-3-3H9a3 3 0 00-3 3v1H4a1 1 0 000 2h1v11a3 3 0 003 3h8a3 3 0 003-3V8h1a1 1 0 100-2zM9 18a1 1 0 11-2 0v-7a1 1 0 112 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zM8 5a1 1 0 011-1h6a1 1 0 011 1v1H8V5z",
            fill: "currentColor"
        })
    });



const $170225ee6a03579c$export$7a525547346e73a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 17.998c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1h8zM12.01 16.002c-.55 0-1-.45-1-1v-7.59l-2.29 2.29a.997.997 0 01-1.41 0h-.02a.996.996 0 010-1.41l4-4c.2-.19.45-.29.71-.29.26 0 .51.09.71.29l4 4a.996.996 0 11-1.41 1.41l-2.29-2.29v7.59c0 .55-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $137d0dfc17372d44$export$904ccf4b059cd9b2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 9h-1a1 1 0 100 2h1a1 1 0 011 1v7a1 1 0 01-1 1H7a1 1 0 01-1-1v-7a1 1 0 011-1h1a1 1 0 100-2H7a3 3 0 00-3 3v7a3 3 0 003 3h10a3 3 0 003-3v-7a3 3 0 00-3-3zM9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42z",
            fill: "currentColor"
        })
    });



const $9a1d7adf13d086c8$export$6a26d7605291833e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 12a10 10 0 1020 0 10 10 0 00-20 0zm10.71-4.71l3 3a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L13 10.41V16a1 1 0 01-2 0v-5.59l-1.29 1.3a1.004 1.004 0 11-1.42-1.42l3-3a1 1 0 01.33-.21 1 1 0 01.76 0 1 1 0 01.33.21z",
            fill: "currentColor"
        })
    });



const $35aa9dff24458a00$export$fd7adc84612ab6c3 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.69 10.74A10.87 10.87 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52A10.87 10.87 0 0012 19a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-9.1 4.2a3 3 0 11-1.183-5.881 3 3 0 011.183 5.881z",
            fill: "currentColor"
        })
    });



const $1158e373884bc031$export$2deae51be13efc65 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.69 10.74A10.539 10.539 0 0018.41 7l-3.7 3.69a3 3 0 01-4 4L20.49 5a1.052 1.052 0 00-.342-1.719A1.053 1.053 0 0019 3.51L3.51 19a1.052 1.052 0 001.148 1.718c.128-.053.244-.13.342-.228L7.42 18c1.439.652 3 .993 4.58 1a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-7.23-5.45A11 11 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52c.469.889 1.061 1.707 1.76 2.43l10.39-10.4z",
            fill: "currentColor"
        })
    });



const $d736a2a789a742e1$export$d4c35c8bf2c76a77 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm3-2h3a1 1 0 010 2H5a1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $e2e2422c14c24c30$export$c7056e444d073e5f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 19a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.12-12.17A2 2 0 0020 6H6.58l-.41-1.52A2 2 0 004.23 3H3a1 1 0 000 2h1.23l2.83 10.48A2 2 0 009 17h8.67a2 2 0 001.89-1.37l2.34-7a2 2 0 00-.28-1.8z",
            fill: "currentColor"
        })
    });



const $b69b9808a49ff611$export$626a5c1c628bf04f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm17-4a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $86b1b79c3c2f8f62$export$ba660c68f7598614 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 5.523-4.477 10-10 10-4.478 0-8.268-2.943-9.542-7H6a1 1 0 100-2H2.05a10.118 10.118 0 010-2H14a1 1 0 100-2H2.458c.22-.703.517-1.373.88-2H11a1 1 0 100-2H4.859A9.97 9.97 0 0112 2c5.523 0 10 4.477 10 10z",
            fill: "currentColor"
        })
    });



const $887f7325e59b5272$export$39cc7d72735656c0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 8h-2.1c-.15-.74-.47-1.42-.91-2H17c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h3a3 3 0 012.82 2H7c-.55 0-1 .45-1 1s.45 1 1 1h5.83a3.001 3.001 0 01-2.81 2H7s-.07 0-.11.01h-.05c-.05 0-.09.02-.14.03-.02 0-.03 0-.05.01-.04.02-.09.04-.13.06-.02 0-.03.02-.05.03-.04.02-.08.05-.11.08-.02.01-.03.02-.05.04l-.1.1c0 .01-.02.02-.03.03v.01c-.03.04-.05.08-.07.12l-.03.06c-.01.03-.03.07-.04.1 0 .03-.02.06-.03.09 0 .03 0 .05-.01.08 0 .04-.01.08-.01.12v.07c0 .04 0 .09.01.13 0 .02.01.04.02.06.01.04.02.08.04.13 0 .02.02.04.02.05.02.04.04.08.07.12 0 .01.02.03.03.04.03.04.06.08.09.11.01.01.02.02.04.03.03.02.05.05.08.07l8 6c.18.14.39.2.6.2.3 0 .6-.14.8-.4.33-.44.24-1.07-.2-1.4l-5.6-4.2c2.41 0 4.43-1.72 4.9-4h2.1c.55 0 1-.45 1-1s-.45-1-1-1L17 8z",
            fill: "currentColor"
        })
    });



const $90bdcbe23c465361$export$300912d25f93283a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 8a1 1 0 010 2h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 01-.15-.14l-.11-.15a1 1 0 01-.08-.18 1.18 1.18 0 010-.2L8 14v-.07a1.29 1.29 0 010-.19c.017-.065.04-.129.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 01.3-.26l.16-.08h.21L9 13h2a2 2 0 001.72-1H8a1 1 0 010-2h4.72A2 2 0 0011 9H8a1 1 0 010-2h8a1 1 0 110 2h-1.56c.187.312.328.649.42 1H16z",
            fill: "currentColor"
        })
    });



const $ece07e19d3bb23fe$export$445280d67fff5a51 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h-1V6a4 4 0 10-8 0v1H7a3 3 0 00-3 3v9a3 3 0 003 3h10a3 3 0 003-3v-9a3 3 0 00-3-3zm-5 9a2 2 0 110-4 2 2 0 010 4zm2-9h-4V6a2 2 0 114 0v1z",
            fill: "currentColor"
        })
    });



const $3aec256720105e9c$export$eb2e66ed6f7f4580 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.74 18l-8-14a2 2 0 00-3.48 0l-8 14A2 2 0 004 21h16a2 2 0 001.74-3zM11 7a1 1 0 012 0v6a1 1 0 11-2 0V7zm1 12a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $1b5ba81d287aab3e$export$7e7b259dce3cfe53 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $87c0f97f25197d00$export$ed1619aa732c6643 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
                fill: "#F50031"
            })
        ]
    });



const $424fd8c04912da5a$export$58992a8aa3d7330d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 17a1 1 0 001-1V3a1 1 0 00-2 0v13a1 1 0 001 1zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $add8a63bd690a801$export$efe9dd4bbd32421a = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.095 1.617c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5zm.685 14.378a.73.73 0 01-.723.732h-.055a.728.728 0 01-.722-.732v-.035a.73.73 0 01.722-.733h.055c.398 0 .723.328.723.733v.035zm1.28-4.213c-.34.38-.748.705-1.04 1.125-.153.22-.163.185-.258.443-.077.21-.03.5-.14.705-.177.33-.545.427-.895.28-.41-.175-.472-.588-.445-.985.03-.453.1-.645.325-1.048.215-.382.533-.69.835-1 .51-.522 1.28-1.435.448-2.067-.733-.558-1.728-.145-1.925.715-.09.392-.22.732-.613.862-.292.098-.605.028-.787-.222-.48-.658.137-1.835.625-2.32 1.247-1.243 3.74-.938 4.415.767l-.008-.017c-.017-.04-.025-.065-.027-.073.002.01.015.04.027.073l.008.017.032.085c-.005-.012-.017-.047-.032-.082.395.987.147 1.97-.545 2.742z",
            fill: "currentColor"
        })
    });



const $f2a56b92690f077c$export$556fe0871d9b7899 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 12h-4a1 1 0 010-2h1v-3h-1a1 1 0 010-2h2a1 1 0 011 1v4h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f20e5c46cb036732$export$cc2840fa1985b883 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $aede1794a6cdc7a9$export$f528a1ee477aaf33 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.58 7.16a5.77 5.77 0 01-.78 1 .472.472 0 01-.06.09 5.617 5.617 0 01-.7.59 5.769 5.769 0 01-1.95.94h-.16a4.515 4.515 0 01-.53.11H11.12a4.515 4.515 0 01-.53-.11h-.16a5.769 5.769 0 01-1.95-.94 5.614 5.614 0 01-.7-.59.47.47 0 01-.06-.09 5.771 5.771 0 01-.78-1 1 1 0 111.67-1.06c.183.292.401.561.65.8.149.14.31.268.48.38l.1.07a4.14 4.14 0 004.32 0l.1-.07c.17-.112.332-.24.48-.38a4.21 4.21 0 00.65-.8 1 1 0 111.69 1.06z",
            fill: "currentColor"
        })
    });



const $32b7d64435ad8d7d$export$b675dff6d0b6c0c8 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.26 8.85a1 1 0 01-1.37-.32 4 4 0 00-6.78 0 1 1 0 11-1.69-1.06 6 6 0 0110.16 0 1.002 1.002 0 01-.32 1.38z",
            fill: "currentColor"
        })
    });



const $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.37 9.61a1.964 1.964 0 00-.58-.856 1.896 1.896 0 00-.94-.428l-4.235-.646-1.899-4.087a1.963 1.963 0 00-.702-.798 1.917 1.917 0 00-1.016-.295c-.361 0-.712.105-1.016.295a1.85 1.85 0 00-.703.798L8.38 7.68l-4.273.646c-.342.057-.674.2-.94.428a1.964 1.964 0 00-.58.855 1.91 1.91 0 00.447 1.901l3.124 3.213-.74 4.553c-.058.351-.01.712.123 1.036.133.323.36.608.655.817.313.238.703.37 1.102.38.332 0 .655-.076.95-.237l3.788-2.091 3.788 2.09c.285.162.618.248.95.238a1.9 1.9 0 001.101-.351c.285-.21.513-.485.655-.818.133-.323.181-.684.124-1.036l-.74-4.552 3.123-3.213c.228-.257.37-.58.437-.922a1.91 1.91 0 00-.104-1.008z",
            fill: "currentColor"
        })
    });



const $5a00847d48e39b4f$export$13b8539f4be0c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $dd949b1a0491130c$export$50c1b72d39add9 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
                fill: "#25AB21"
            })
        ]
    });



const $45f8c8717b087f21$export$ff711dd56629d4f5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $7dab575aad091c08$export$47407925ae9f1f0e = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
                fill: "#F06D0F"
            })
        ]
    });



const $fc7e21f78fe2b481$export$faf9e552d710fc5c = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_svg__clip0_5207_79934)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "#3535F3"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_svg__clip0_5207_79934",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $9a08af96ef429fe7$export$b15d2693bd1dee35 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#ic_jio_dot_exclude_svg__clip0_7826_127526)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.372 12-12S18.627 0 12 0zM9.68 12.693c0 2.568-1.23 3.742-3.564 3.742-1.92 0-2.955-.677-2.955-1.781 0-1.023.87-1.437.91-1.382.429.525.967.815 1.63.815.843 0 1.202-.373 1.202-1.436v-4.13c0-.855.414-1.284 1.173-1.284h.4c.788 0 1.202.429 1.202 1.285l.001 4.17zm3.601 2.333c0 .953-.483 1.285-1.16 1.285h-.277c-.718 0-1.215-.304-1.215-1.285v-4.418c0-.968.511-1.285 1.187-1.285h.277c.718 0 1.187.29 1.187 1.285l.001 4.418zm-1.298-6.407c-.883 0-1.436-.484-1.436-1.257 0-.76.539-1.243 1.395-1.243.884 0 1.436.47 1.436 1.243 0 .774-.538 1.257-1.395 1.257zm5.753 7.816c-2.279 0-3.728-1.409-3.728-3.605 0-2.14 1.505-3.576 3.77-3.576 2.237 0 3.715 1.436 3.715 3.59 0 2.182-1.493 3.591-3.757 3.591zm.014-5.165c-.87 0-1.491.65-1.491 1.56 0 .926.607 1.575 1.491 1.575.856 0 1.492-.663 1.492-1.56 0-.926-.622-1.575-1.492-1.575z",
                    fill: "#3535F3"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_exclude_svg__clip0_7826_127526",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $e93a0cbebb073b75$export$3d9cd62ef287ff59 = (_)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ..._,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "url(#ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799)"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799",
                        x1: .045,
                        y1: .045,
                        x2: 24.027,
                        y2: 24.027,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: .08,
                                stopColor: "#F3B561"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: .45,
                                stopColor: "#F6C586"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#C78724"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799",
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });



const $a2a7fa360d9e5b06$export$d586aed94de44e82 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6A7.82 7.82 0 0012 2zm0 11a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $71ffb9683d52e4d1$export$8fe68ed1b5ac245c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.49 3.51a1.001 1.001 0 00-1.45 0L3.51 19A1.054 1.054 0 105 20.49l2.6-2.61a33.48 33.48 0 003 3.53 2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6c-.001-1.16-.282-2.302-.82-3.33L20.49 5a1.001 1.001 0 000-1.49zM9.08 10.67A2.93 2.93 0 019 10a3 3 0 013-3c.225.001.45.028.67.08l3.79-3.78A8.21 8.21 0 0012 2a7.82 7.82 0 00-8 7.6 10.84 10.84 0 001.36 4.79l3.72-3.72z",
            fill: "currentColor"
        })
    });



const $b319dcf7d3363cf8$export$af0a72b1e9c547c5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 4.91v8.71a3 3 0 001 2.28L7.81 20c.202.17.437.295.69.37V6.64L4.37 3.69A1.5 1.5 0 002 4.91zm19.12 3.21l-4-4a2.069 2.069 0 00-.58-.4V16.5l2.94 2.94A1.5 1.5 0 0022 18.38v-8.14a3 3 0 00-.88-2.12zM9.5 6.71V20.4c.277-.043.54-.15.77-.31l5.23-3.73V3.52a2.08 2.08 0 00-.83.24L9.5 6.71z",
            fill: "currentColor"
        })
    });



const $aeccc785c2557670$export$51e681bf0729a333 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.32 2.17L3.14 9.29a1.9 1.9 0 00.62 3.64l6.77.54.54 6.77a1.9 1.9 0 003.64.62l7.12-16.18a1.9 1.9 0 00-2.51-2.51z",
            fill: "currentColor"
        })
    });



const $2ec6e55380d31e07$export$58f9be5875231b2 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 9.5c0 .83.67 1.5 1.5 1.5S9 10.33 9 9.5 8.33 8 7.5 8 6 8.67 6 9.5zM19 4h-5.4l-2.31 2h7.7c.55 0 1 .45 1 1v6.7l-3.83-3.45c-.38-.34-.96-.34-1.34 0l-2.01 1.83.54.9a1 1 0 01-.22 1.28l-2.08 1.73 2.08 1.73c.23.19.36.47.36.77 0 .3-.13.58-.36.77l-.88.73h6.74c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3H19zM8.5 16c0-.3.13-.58.36-.77l.85-.71-1.57-1.3c-.38-.31-.93-.3-1.3.02L4 15.76V7c0-.55.45-1 1-1h3.24l2.31-2H5C3.35 4 2 5.35 2 7v10c0 1.65 1.35 3 3 3h4.14l1.8-1.5-2.08-1.73A.992.992 0 018.5 16z",
            fill: "currentColor"
        })
    });



const $7a6acfb156a88414$export$4736cab3fc47e2fb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 9.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h12a1 1 0 011 1v6.09z",
            fill: "currentColor"
        })
    });



const $ce2d37347311037b$export$c1c61a3da2c48ae4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a3 3 0 003-3V5a3 3 0 00-6 0v7a3 3 0 003 3zm6-5a1 1 0 00-1 1v1a5 5 0 11-10 0v-1a1 1 0 10-2 0v1a7 7 0 1014 0v-1a1 1 0 00-1-1zm-3 10H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5ab3776403d77391$export$4f5b8d1e98c25c06 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.07 12.69A5.2 5.2 0 017 12v-1a1 1 0 10-2 0v1a7 7 0 00.41 2.34l1.66-1.65zM12 2a3 3 0 00-3 3v5.76l6-6A3 3 0 0012 2zm3 18H9a1 1 0 000 2h6a1 1 0 100-2zm-3-5a3 3 0 003-3v-1.56L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49l2.87-2.88A7 7 0 0019 12v-1a1 1 0 00-2 0v1a5 5 0 01-7.73 4.18l1.46-1.47A3 3 0 0012 15z",
            fill: "currentColor"
        })
    });



const $5ac5f7859b261b8c$export$1eb29c5f2b0051d3 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 4A1.5 1.5 0 007 5.5v13a1.5 1.5 0 003 0v-13A1.5 1.5 0 008.5 4zm7 0A1.5 1.5 0 0014 5.5v13a1.5 1.5 0 103 0v-13A1.5 1.5 0 0015.5 4z",
            fill: "currentColor"
        })
    });



const $8449ed9a443d9574$export$a93378bd68e53d32 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.15 10.36l-10-7A2 2 0 008 3a1.88 1.88 0 00-.92.23A2 2 0 006 5v14a2 2 0 001.08 1.77c.282.154.599.233.92.23a2 2 0 001.15-.36l10-7a2 2 0 000-3.28z",
            fill: "currentColor"
        })
    });



const $29064e5ed5e1f396$export$af0536a50732761b = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
            fill: "currentColor"
        })
    });



const $92450cc98193c6d3$export$aed2803299c2cf67 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.29 12.71l6 6a1.004 1.004 0 101.42-1.42L5.41 13H21a1 1 0 100-2H5.41l4.3-4.29a1 1 0 000-1.42 1 1 0 00-1.42 0l-6 6a1 1 0 000 1.42z",
            fill: "currentColor"
        })
    });



const $d8752f0f494f2380$export$a1075cdfac2f932 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 11.29l-6-6a1.004 1.004 0 10-1.42 1.42l4.3 4.29H3a1 1 0 100 2h15.59l-4.3 4.29a1 1 0 000 1.42 1.002 1.002 0 001.42 0l6-6a1.002 1.002 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $575ba915d2bd5d5b$export$740276c76f223dd4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $fc255cc0cffe8df6$export$3bb087c30947880a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h16a1 1 0 100-2H4a1 1 0 000 2zm16 10H4a1 1 0 000 2h16a1 1 0 000-2zm0-6H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $fdc94045ec0e5793$export$ec7db1c418c1ec5a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
            fill: "currentColor"
        })
    });



const $1b63d62cdd4af45e$export$8203b8a87ae185f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 17a1.003 1.003 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1.005 1.005 0 011.42 1.42L11.41 12l3.3 3.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $735120fcd87dd052$export$a477256bf52ac2f7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l3.3-3.29-3.3-3.29a1.004 1.004 0 011.42-1.42l4 4a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-4 4A1 1 0 0110 17z",
            fill: "currentColor"
        })
    });



const $9efe7828a40b52f7$export$acd925e63e14000f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 15a.998.998 0 01-.71-.29L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a.999.999 0 011.42 0l4 4A1.001 1.001 0 0116 15z",
            fill: "currentColor"
        })
    });



const $4b407a2b367f43e3$export$48672c81f0c3f574 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z",
            fill: "currentColor"
        })
    });



const $4c01e0333386e8c5$export$885ccec48f920b92 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm5.41 8l6.29-6.29a.996.996 0 10-1.41-1.41l-7 7a.996.996 0 000 1.41l7 7c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-6.29-6.29-.01-.01z",
            fill: "currentColor"
        })
    });



const $a612d6b4674022e7$export$10426ed6ef0ab637 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.47 9.31L13.85 2.7a2.8 2.8 0 00-3.7 0L2.53 9.31A1.53 1.53 0 003.45 12H4v7a3 3 0 003 3h3v-6h4v6h3a3 3 0 003-3v-7h.55a1.53 1.53 0 00.92-2.69z",
            fill: "currentColor"
        })
    });



const $bc0db77fbff65188$export$1093b8f29e1cf10c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.71 4.29A.996.996 0 105.3 5.7l6.29 6.29-6.29 6.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l7-7a.996.996 0 000-1.41L6.71 4.29zM17 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $304780aca3b3a13a$export$a883bfa83ec843c8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l3-3a1.002 1.002 0 000-1.42l-3-3a1.004 1.004 0 00-1.42 1.42l1.3 1.29H3a1 1 0 000 2h8.59l-1.3 1.29zM12 2a10.06 10.06 0 00-8.09 4.13 1 1 0 00.575 1.565A1 1 0 005.53 7.31a8 8 0 110 9.38 1.002 1.002 0 10-1.62 1.18A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $10a623943a1be9a9$export$5c4cc728e7726d4e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.87 3.91a1 1 0 00-1.58.966 1 1 0 00.4.654 8 8 0 11-9.38 0 1.002 1.002 0 00-1.18-1.62 10 10 0 1011.74 0zM12 8a1 1 0 001-1V3a1 1 0 00-2 0v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $ffc7075420fce577$export$f6c2e7c657f578c5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $31b79cb94a7f2481$export$76eade3e6c39fefd = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-6.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $b59efb8c56ba82c0$export$17beb55fda7072f9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 20a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l6.3-6.29-6.3-6.29a1.004 1.004 0 011.42-1.42l7 7a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-7 7A1 1 0 019 20z",
            fill: "currentColor"
        })
    });



const $52f7703976716e4f$export$6da2c307edd95198 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.004 2a7 7 0 015.6 11.19l6.11 6.1a1.002 1.002 0 01-.325 1.639.999.999 0 01-1.095-.219l-6.1-6.11A7 7 0 1110.004 2zm0 12a5 5 0 100-10 5 5 0 000 10z",
            fill: "currentColor"
        })
    });



const $7aed0775866c148c$export$f7d6d35bb50c6222 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.43 13.4L19 12.58v-1.16l1.43-.82a2 2 0 00.73-2.73l-1-1.74a2 2 0 00-2.73-.73l-1.18.68-.25.15-1-.58V4a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.65l-.25.14-.75.44-.25-.15-1.18-.68a2 2 0 00-2.73.73l-1 1.74a2 2 0 00.73 2.73l1.43.82v1.16l-1.43.82a2 2 0 00-.73 2.73l1 1.74a2 2 0 002.73.73L8 17.77l1 .58V20a2 2 0 002 2h2a2 2 0 002-2v-1.65l1-.58 1.43.83a2 2 0 002.73-.73l1-1.74a2 2 0 00-.73-2.73zM12 15a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $2f5be6df98c377a7$export$8c6932a2fedd46e4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 6a4 4 0 11-8 0 4 4 0 018 0zm4 10.5c0 3.038-3.582 5.5-8 5.5s-8-2.462-8-5.5S7.582 11 12 11s8 2.462 8 5.5z",
            fill: "currentColor"
        })
    });



const $807fef1d289a1edd$export$255f0ef2dfc5eb49 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a3 3 0 110 6 3 3 0 010-6zm0 14a8 8 0 01-6.54-3.41C6.46 15.08 9 14 12 14s5.54 1.08 6.54 2.59A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });




function $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) {
        const newArray = [];
        for(let i = 0; i < obj.length; i++)newArray[i] = $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj[i]);
        return newArray;
    }
    const newObj = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj[key]);
    return newObj;
}
function $bff35c0dd9851fab$export$79b2f7037acddd43(collection, iteratee) {
    if (Array.isArray(collection)) for (const item of collection)iteratee(item);
    else {
        const keys = Object.keys(collection);
        for (const key of keys)iteratee(collection[key], key);
    }
}
const $bff35c0dd9851fab$export$b460b275d6c6aa0 = (object, predicate)=>{
    if (typeof predicate !== "function") throw new TypeError("Predicate must be a function");
    const result = {};
    for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key], key)) result[key] = object[key];
    return result;
};
const $bff35c0dd9851fab$export$30a06c8d3562193f = (obj, props)=>{
    obj = {
        ...obj
    };
    props.forEach((prop)=>delete obj[prop]);
    return obj;
};
const $bff35c0dd9851fab$export$d7a617dda645b4e3 = (obj, check)=>{
    obj = {
        ...obj
    };
    Object.entries(obj).forEach(([key, value])=>check(value, key) && delete obj[key]);
    return obj;
};
const $bff35c0dd9851fab$export$3988ae62b71be9a3 = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $bff35c0dd9851fab$export$2cbec9495984f5d9 = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
const $bff35c0dd9851fab$export$61fc7d43ac8f84b0 = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $bff35c0dd9851fab$export$5fe300a9008e2bfc = (value)=>value.replace(/[{}]/g, "");
const $bff35c0dd9851fab$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
function $bff35c0dd9851fab$export$4950aa0f605343fb(base, ...rest) {
    let second;
    rest = rest.filter(Boolean);
    if (rest.length > 1) {
        const [first, ...others] = rest;
        second = $bff35c0dd9851fab$export$4950aa0f605343fb(first, ...others);
    } else if (rest.length === 1) second = rest[0];
    else return base;
    return $bff35c0dd9851fab$var$mergeObject(base, second);
}
function $bff35c0dd9851fab$var$mergeObject(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $bff35c0dd9851fab$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $bff35c0dd9851fab$var$mergeValues(base, second) {
    if ($bff35c0dd9851fab$var$isObject(base) && $bff35c0dd9851fab$var$isObject(second)) return $bff35c0dd9851fab$var$mergeObject(base, second);
    return second;
}
function $bff35c0dd9851fab$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
const $bff35c0dd9851fab$export$1839ba460459a826 = (s)=>s?.replace(/./, (m)=>m.toUpperCase());
const $bff35c0dd9851fab$export$8a7688a96d852767 = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : $bff35c0dd9851fab$export$1839ba460459a826(segment)).join("");
const $bff35c0dd9851fab$export$26c6f48841fe1a8a = (s, separator = "-")=>s.split(separator).map($bff35c0dd9851fab$export$1839ba460459a826).join("");
const $bff35c0dd9851fab$export$3e672a90535a3744 = (inputString)=>inputString.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([0-9])([a-zA-Z])/g, "$1-$2").replace(/([a-zA-Z])([0-9])/g, "$1-$2").replace(/\s+/g, "-").toLowerCase();
function $bff35c0dd9851fab$export$848d71df1f759bc(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16) / 255,
        g: parseInt(result[2], 16) / 255,
        b: parseInt(result[3], 16) / 255
    } : {
        r: 0,
        g: 0,
        b: 0
    };
}
function $bff35c0dd9851fab$export$b7d58db314e0ac27(obj) {
    return globalThis.structuredClone ? globalThis.structuredClone(obj) : JSON.parse(JSON.stringify(obj));
}
const $bff35c0dd9851fab$export$feae9a740c003485 = (string)=>{
    return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map((word)=>word.toLowerCase()).join("_");
};


var $6eea7234d56610fe$var$buffer = {};
var $6eea7234d56610fe$var$base64Js = {};
$6eea7234d56610fe$var$base64Js.byteLength = $6eea7234d56610fe$var$byteLength;
$6eea7234d56610fe$var$base64Js.toByteArray = $6eea7234d56610fe$var$toByteArray;
$6eea7234d56610fe$var$base64Js.fromByteArray = $6eea7234d56610fe$var$fromByteArray;
var $6eea7234d56610fe$var$lookup = [];
var $6eea7234d56610fe$var$revLookup = [];
var $6eea7234d56610fe$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $6eea7234d56610fe$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $6eea7234d56610fe$var$i = 0, $6eea7234d56610fe$var$len = $6eea7234d56610fe$var$code.length; $6eea7234d56610fe$var$i < $6eea7234d56610fe$var$len; ++$6eea7234d56610fe$var$i){
    $6eea7234d56610fe$var$lookup[$6eea7234d56610fe$var$i] = $6eea7234d56610fe$var$code[$6eea7234d56610fe$var$i];
    $6eea7234d56610fe$var$revLookup[$6eea7234d56610fe$var$code.charCodeAt($6eea7234d56610fe$var$i)] = $6eea7234d56610fe$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$6eea7234d56610fe$var$revLookup['-'.charCodeAt(0)] = 62;
$6eea7234d56610fe$var$revLookup['_'.charCodeAt(0)] = 63;
function $6eea7234d56610fe$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $6eea7234d56610fe$var$byteLength(b64) {
    var lens = $6eea7234d56610fe$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6eea7234d56610fe$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6eea7234d56610fe$var$toByteArray(b64) {
    var tmp;
    var lens = $6eea7234d56610fe$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $6eea7234d56610fe$var$Arr($6eea7234d56610fe$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 18 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 2 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 10 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $6eea7234d56610fe$var$tripletToBase64(num) {
    return $6eea7234d56610fe$var$lookup[num >> 18 & 0x3F] + $6eea7234d56610fe$var$lookup[num >> 12 & 0x3F] + $6eea7234d56610fe$var$lookup[num >> 6 & 0x3F] + $6eea7234d56610fe$var$lookup[num & 0x3F];
}
function $6eea7234d56610fe$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($6eea7234d56610fe$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $6eea7234d56610fe$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($6eea7234d56610fe$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($6eea7234d56610fe$var$lookup[tmp >> 2] + $6eea7234d56610fe$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($6eea7234d56610fe$var$lookup[tmp >> 10] + $6eea7234d56610fe$var$lookup[tmp >> 4 & 0x3F] + $6eea7234d56610fe$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $6eea7234d56610fe$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ $6eea7234d56610fe$var$ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$6eea7234d56610fe$var$ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    const base64 = $6eea7234d56610fe$var$base64Js;
    const ieee754$1 = $6eea7234d56610fe$var$ieee754;
    const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
     ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    const { Uint8Array: GlobalUint8Array, ArrayBuffer: GlobalArrayBuffer, SharedArrayBuffer: GlobalSharedArrayBuffer } = globalThis;
    /**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            const arr = new GlobalUint8Array(1);
            const proto = {
                foo: function() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, GlobalUint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        const buf = new GlobalUint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (GlobalArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, GlobalArrayBuffer) || value && isInstance(value.buffer, GlobalArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof GlobalSharedArrayBuffer !== 'undefined' && (isInstance(value, GlobalSharedArrayBuffer) || value && isInstance(value.buffer, GlobalSharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, GlobalUint8Array.prototype);
    Object.setPrototypeOf(Buffer, GlobalUint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, GlobalUint8Array)) {
            const copy = new GlobalUint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let buf;
        if (byteOffset === undefined && length === undefined) buf = new GlobalUint8Array(array);
        else if (length === undefined) buf = new GlobalUint8Array(array, byteOffset);
        else buf = new GlobalUint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
        ;
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, GlobalUint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, GlobalUint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        let i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        const buffer = Buffer.allocUnsafe(length);
        let pos = 0;
        for(i = 0; i < list.length; ++i){
            let buf = list[i];
            if (isInstance(buf, GlobalUint8Array)) {
                if (pos + buf.length > buffer.length) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    buf.copy(buffer, pos);
                } else GlobalUint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (GlobalArrayBuffer.isView(string) || isInstance(string, GlobalArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                ;
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        let loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(let i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(let i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        const length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        let str = '';
        const max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, GlobalUint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof GlobalUint8Array.prototype.indexOf === 'function') {
                if (dir) return GlobalUint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return GlobalUint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        let i;
        if (dir) {
            let foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                let found = true;
                for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        const strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        let i;
        for(i = 0; i < length; ++i){
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        const remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
            case 'latin1':
            case 'binary':
                return asciiWrite(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while(i < end){
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                let secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    const MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        let res = '';
        let i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = '';
        for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = '';
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset + --byteLength];
        let mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let i = byteLength;
        let mul = 1;
        let val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24); // Overflow
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
    });
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let i = byteLength - 1;
        let mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
    }
    Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = byteLength - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds');
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        const len = end - start;
        if (this === target && typeof GlobalUint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else GlobalUint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                const code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        let i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // CUSTOM ERRORS
    // =============
    // Simplified versions from Node, changed for Buffer-only usage
    const errors = {};
    function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
            constructor(){
                super();
                Object.defineProperty(this, 'message', {
                    value: getMessage.apply(this, arguments),
                    writable: true,
                    configurable: true
                });
                // Add the error code to the name to include it in the stack trace.
                this.name = `${this.name} [${sym}]`;
                // Access the stack to generate the error message including the error code
                // from the name.
                this.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete this.name;
            }
            get code() {
                return sym;
            }
            set code(value) {
                Object.defineProperty(this, 'code', {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            }
            toString() {
                return `${this.name} [${sym}]: ${this.message}`;
            }
        };
    }
    E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
        if (name) return `${name} is outside of buffer bounds`;
        return 'Attempt to access memory outside buffer bounds';
    }, RangeError);
    E('ERR_INVALID_ARG_TYPE', function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E('ERR_OUT_OF_RANGE', function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
        else if (typeof input === 'bigint') {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
            received += 'n';
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
        let res = '';
        let i = val.length;
        const start = val[0] === '-' ? 1 : 0;
        for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
        return `${val.slice(0, i)}${res}`;
    }
    // CHECK FUNCTIONS
    // ===============
    function checkBounds(buf, offset, byteLength) {
        validateNumber(offset, 'offset');
        if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
    }
    function checkIntBI(value, min, max, buf, offset, byteLength) {
        if (value > max || value < min) {
            const n = typeof min === 'bigint' ? 'n' : '';
            let range;
            if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
                else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
            } else range = `>= ${min}${n} and <= ${max}${n}`;
            throw new errors.ERR_OUT_OF_RANGE('value', range, value);
        }
        checkBounds(buf, offset, byteLength);
    }
    function validateNumber(value, name) {
        if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
    }
    function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
        }
        if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
    }
    // HELPER FUNCTIONS
    // ================
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, '');
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return '';
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for(let i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        const byteArray = [];
        for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for(let i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        let i;
        for(i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj // eslint-disable-line no-self-compare
        ;
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    const hexSliceLookupTable = function() {
        const alphabet = '0123456789abcdef';
        const table = new Array(256);
        for(let i = 0; i < 16; ++i){
            const i16 = i * 16;
            for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
    // Return not function with Error if BigInt not supported
    function defineBigIntMethod(fn) {
        return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
        throw new Error('BigInt not supported');
    }
})($6eea7234d56610fe$var$buffer);
const $6eea7234d56610fe$var$Buffer = $6eea7234d56610fe$var$buffer.Buffer;
const $6eea7234d56610fe$var$container = {
    display: "flex",
    outline: "none",
    gap: "0px",
    "flex-direction": "row",
    width: "fit-content",
    height: "fit-content",
    "border-style": "solid",
    "border-width": "0px",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
    opacity: "100",
    "background-color": "transparent",
    "box-sizing": "border-box",
    "border-radius": "0px",
    "flex-shrink": "initial"
};
const $6eea7234d56610fe$var$input = {
    "border-style": "solid",
    "border-width": "0px"
};
const $6eea7234d56610fe$var$text = {
    display: "inline",
    "text-align": "start",
    "text-decoration": "none"
};
const $6eea7234d56610fe$var$icon = {
    display: "flex"
};
const $6eea7234d56610fe$var$loader = {
    display: "inline-block"
};
const $6eea7234d56610fe$var$image = {
    display: "block",
    width: "100%"
};
const $6eea7234d56610fe$var$slot = {
    display: "flex"
};
const $6eea7234d56610fe$export$bb974f6f0c330fb = {
    container: $6eea7234d56610fe$var$container,
    input: $6eea7234d56610fe$var$input,
    text: $6eea7234d56610fe$var$text,
    icon: $6eea7234d56610fe$var$icon,
    loader: $6eea7234d56610fe$var$loader,
    image: $6eea7234d56610fe$var$image,
    slot: $6eea7234d56610fe$var$slot
};
const $6eea7234d56610fe$var$layerDefaults$1 = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    container: $6eea7234d56610fe$var$container,
    default: $6eea7234d56610fe$export$bb974f6f0c330fb,
    icon: $6eea7234d56610fe$var$icon,
    image: $6eea7234d56610fe$var$image,
    input: $6eea7234d56610fe$var$input,
    loader: $6eea7234d56610fe$var$loader,
    slot: $6eea7234d56610fe$var$slot,
    text: $6eea7234d56610fe$var$text
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $6eea7234d56610fe$var$prefixMap = {
    "background-color": "bg",
    color: "text",
    "border-color": "stroke"
};
const $6eea7234d56610fe$var$colorClassRuleHandler = (rule, ruleVal, tokens)=>{
    if (!$6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn) return;
    if (typeof ruleVal === "object") {
        console.warn("Object values are not supported");
        return;
    }
    const resolved = $6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn(rule, ruleVal, tokens, false);
    const prefix = $6eea7234d56610fe$var$prefixMap[rule];
    if (resolved?.value === "transparent") return `${prefix}-transparent`;
    const scale = resolved?.key?.split(".")[1];
    if (scale) {
        const klass = `${prefix}-${tokens["appearance"]}-${scale}`;
        return klass;
    }
    return void 0;
};
const $6eea7234d56610fe$export$e9552252b443446 = {
    "background-color": $6eea7234d56610fe$var$colorClassRuleHandler,
    color: $6eea7234d56610fe$var$colorClassRuleHandler,
    "border-color": $6eea7234d56610fe$var$colorClassRuleHandler,
    "font-size": ()=>null,
    "line-height": ()=>null,
    "letter-spacing": ()=>null,
    "font-weight": ()=>null
};
const $6eea7234d56610fe$var$permittedKeys = /* @__PURE__ */ new Set([
    "slot_layers",
    "hidden",
    "show",
    "behavior",
    "value",
    "web-tag"
]);
function $6eea7234d56610fe$var$getAllRequiredBaseLayers(base, props, getAllAmpersandTokenLayers = false, getPercentageTokens = []) {
    const hiddenLayers = {};
    for(const layer in base){
        const layerObj = base[layer];
        const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
        for(const key in layerObj){
            const value = layerObj[key];
            if (typeof value !== "string") {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = value;
                continue;
            }
            const hasAmpersandKey = typeof value === "string" && value.includes("&") && (value.includes("stroke") || key.includes("color") || key.includes("fill"));
            const hasPercentKey = typeof value === "string" && value.includes("%");
            const matchedKey = hasPercentKey && value.match($6eea7234d56610fe$export$2b19bce00ae0a812)?.[1];
            const hasPercentToken = matchedKey && getPercentageTokens.includes(matchedKey);
            if (getAllAmpersandTokenLayers && hasAmpersandKey || hasPercentToken || $6eea7234d56610fe$var$permittedKeys.has(key) || layerKey?.startsWith("jds_") || // include all molecule layers
            layerKey?.endsWith("arc")) {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = hasPercentKey ? $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, props) : value;
            }
        }
    }
    return hiddenLayers;
}
function $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, props) {
    const match = value.match($6eea7234d56610fe$export$2b19bce00ae0a812);
    if (!match) return value;
    const key = match[1];
    const replacement = props[key];
    if (replacement === void 0) return value;
    return value.replace(`%${key}`, replacement?.toString() ?? "");
}
function $6eea7234d56610fe$export$e025e4ac3d283105(component, json, config = {
    transformer: false,
    getAmpersandTokens: false,
    getAllBaseLayers: true,
    getPercentageTokens: []
}) {
    const { transformer: transformer = false, getAllBaseLayers: getAllBaseLayers = false, getAmpersandTokens: getAmpersandTokens = false, getPercentageTokens: getPercentageTokens = [] } = config;
    let base = getAllBaseLayers ? (0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base) : $6eea7234d56610fe$var$getAllRequiredBaseLayers((0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base), component, getAmpersandTokens, getPercentageTokens);
    base = $6eea7234d56610fe$export$8c51a6ab64fc75e8(component, base, json.variant, json.api.config);
    if (json.combination && json.combination_config) base = $6eea7234d56610fe$export$376823fb52709d2f(component, base, json.combination, json.combination_config, json.api.config);
    base = $6eea7234d56610fe$export$2918ee16067fdfba(base, json.metadata?.["name"]);
    return json.api.data && !transformer ? $6eea7234d56610fe$var$removeNoDataLayers(base, component, json.api.data) : base;
}
function $6eea7234d56610fe$var$removeNoDataLayers(base, component, data) {
    for(const layer in base){
        if (base[layer]["hidden"]) continue;
        const layerType = $6eea7234d56610fe$export$92b70e511152790f(layer);
        const datum = data[layer];
        if (layerType === "icon" || layerType === "text" || layerType === "image") {
            const value = datum?.["value"];
            const name = value?.name;
            if (!name || name.includes(".")) continue;
            const val = component[value.name] || base[layer]["value"];
            if (val === void 0 || val === null || val === "") base[layer]["hidden"] = true;
        }
    }
    return base;
}
function $6eea7234d56610fe$export$a1a0a7262a295961(componentName, base, hierarchy, invariants = {}, tokens) {
    const layerKeySet = /* @__PURE__ */ new Set();
    return $6eea7234d56610fe$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens);
}
function $6eea7234d56610fe$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens) {
    const root = $6eea7234d56610fe$export$31e4419873013369(hierarchy) || hierarchy;
    if ($6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
    Object.keys(base[root] ?? {}).some((key)=>$6eea7234d56610fe$export$beb192a6dc60a1a7.includes(key))) tokens = $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, base[root]);
    const children = typeof hierarchy === "string" ? [] : hierarchy[root];
    const { styles: rootVars, classes: rootClasses } = $6eea7234d56610fe$var$drawComponentBase(componentName, root, base[root], invariants[root], tokens);
    if (children?.length) {
        const childrenVars = {};
        const childrenClasses = {};
        let hasVisibleChildren = false;
        for (const child of children){
            const childRoot = typeof child === "string" ? child : $6eea7234d56610fe$export$31e4419873013369(child);
            if (typeof child === "string") {
                let newTokens = tokens;
                if ($6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
                Object.keys(base[childRoot] ?? {}).some((key)=>$6eea7234d56610fe$export$beb192a6dc60a1a7.includes(key))) newTokens = $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, base[childRoot]);
                const visible = !base[child]?.["hidden"];
                hasVisibleChildren ||= visible;
                const childVars = $6eea7234d56610fe$var$drawComponentBase(componentName, child, base[child], invariants[child], newTokens);
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            } else {
                const childLayer = $6eea7234d56610fe$export$31e4419873013369(child);
                const childVars = $6eea7234d56610fe$var$drawComponentHierarchy(componentName, child, base, invariants, layerKeySet, tokens);
                const visible = !base[childLayer]?.["hidden"];
                hasVisibleChildren ||= visible;
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            }
        }
        const combinedVars = {
            ...rootVars,
            ...childrenVars
        };
        const combinedClasses = {
            ...rootClasses,
            ...childrenClasses
        };
        base[root] ??= {};
        if (hasVisibleChildren || base[root]["show"]) return {
            styles: combinedVars,
            classes: combinedClasses
        };
        base[root]["hidden"] = true;
        return {
            styles: combinedVars,
            classes: combinedClasses
        };
    }
    return {
        styles: rootVars,
        classes: rootClasses
    };
}
function $6eea7234d56610fe$var$drawComponentBase(componentName, layer, baseMap, invariantsMap, tokens) {
    if (!baseMap) return {
        styles: {},
        classes: {}
    };
    const baseCSSVars = {};
    const baseClasses = {};
    const { behavior: behavior = {}, ...layerObj } = baseMap;
    const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
    const isV3 = tokens?.["brandVersion"] === "jio-v2";
    const { styles: layerStyle, classes: layerClasses } = $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, layerObj, isV3 ? invariantsMap : {}, layer, void 0, tokens);
    if (isV3 && layerKey && [
        "icon",
        "text",
        "jds_text2",
        "jds_icon2",
        "container",
        "jds_container2"
    ].includes(layerKey)) {
        behavior["hover"] = behavior["hover"] || {};
        behavior["active"] = behavior["active"] || {};
        if (layerKey === "icon" || layerKey === "text" || layerKey === "jds_text2" || layerKey === "jds_icon2") {
            if (layerObj["color"]) {
                behavior["hover"]["color"] = layerObj["color"];
                behavior["active"]["color"] = layerObj["color"];
            }
        } else {
            if (layerObj["background-color"]) {
                behavior["hover"]["background-color"] = layerObj["background-color"];
                behavior["active"]["background-color"] = layerObj["background-color"];
            }
            if (layerObj["border-color"]) {
                behavior["hover"]["border-color"] = layerObj["border-color"];
                behavior["active"]["border-color"] = layerObj["border-color"];
            }
        }
    }
    Object.assign(baseCSSVars, layerStyle);
    baseClasses[layer] = layerClasses;
    for(const pseudo in behavior){
        const merged = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(layerObj, behavior[pseudo]);
        const behaviorInvariants = invariantsMap?.behavior?.[pseudo];
        const { styles: pseudoLayerStyle, classes: pseudoLayerClasses } = $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, isV3 ? behavior[pseudo] : merged, isV3 ? behaviorInvariants : void 0, layer, pseudo, tokens ? {
            ...tokens,
            state: pseudo
        } : void 0);
        Object.assign(baseCSSVars, pseudoLayerStyle);
        baseClasses[layer] = baseClasses[layer].concat(pseudoLayerClasses);
    }
    return {
        styles: baseCSSVars,
        classes: baseClasses
    };
}
const $6eea7234d56610fe$export$d72eddc0980b68c9 = (custom)=>{
    const [, base64] = custom?.split("--") || [];
    const convertedCustom = $6eea7234d56610fe$export$9cc362b209501dfe(base64);
    return convertedCustom;
};
function $6eea7234d56610fe$var$withComponentTokensHelper(baseMap, metaCompName, fallback) {
    for(const key in baseMap){
        const value = baseMap[key];
        if (typeof value === "object") baseMap[key] = $6eea7234d56610fe$var$withComponentTokensHelper(baseMap[key], metaCompName, fallback);
        else if (typeof value === "string") {
            const replacement = metaCompName ? $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, metaCompName) : void 0;
            let icon, text;
            if (fallback === "icon") icon = $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, "JDSIcon");
            else if (fallback === "text") text = $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, "JDSText");
            baseMap[key] = replacement ?? icon ?? text ?? value;
        }
    }
    return baseMap;
}
function $6eea7234d56610fe$export$2918ee16067fdfba(base, metaCompName) {
    for(const layer in base){
        const baseMap = base[layer];
        const fallback = layer.includes("icon") ? "icon" : layer.includes("text") ? "text" : void 0;
        base[layer] = $6eea7234d56610fe$var$withComponentTokensHelper(baseMap, metaCompName, fallback);
    }
    return base;
}
const $6eea7234d56610fe$var$defaults = $6eea7234d56610fe$var$layerDefaults$1;
const $6eea7234d56610fe$var$tokenSuffixShortKey = {
    default: "d",
    hover: "h",
    focus: "f",
    active: "a",
    visited: "v"
};
const $6eea7234d56610fe$var$tokenRuleShortKey = {
    "align-items": "al-it",
    "aspect-ratio": "as-rt",
    "background-color": "bg-cl",
    "blur-radius": "bl-rd",
    "border-color": "br-cl",
    "border-radius": "br-rd",
    "border-style": "br-st",
    "border-width": "br-wd",
    "border-top-width": "brt-wd",
    "border-right-width": "brr-wd",
    "border-bottom-width": "brb-wd",
    "border-left-width": "brl-w",
    "border-top-color": "brt-cl",
    "border-right-color": "brr-cl",
    "border-bottom-color": "brb-cl",
    "border-left-color": "brl-cl",
    "border-top-left-radius": "brtl-r",
    "border-top-right-radius": "brtr-r",
    "border-bottom-right-radius": "brbr-r",
    "border-bottom-left-radius": "brbl-r",
    bottom: "bt",
    "box-shadow": "bx-sh",
    "box-sizing": "bx-sz",
    color: "cl",
    cursor: "cur",
    display: "dis",
    flex: "fx",
    "flex-direction": "fx-dr",
    "font-family": "fo-fm",
    "font-size": "fo-sz",
    "font-weight": "fo-wt",
    gap: "gp",
    height: "ht",
    "justify-content": "js-ct",
    left: "lt",
    "letter-spacing": "lt-sp",
    "line-height": "ln-ht",
    "max-height": "mx-ht",
    "max-width": "mx-wd",
    "min-height": "mn-ht",
    "min-width": "mn-wd",
    opacity: "op",
    outline: "ol",
    overflow: "ov",
    "padding-bottom": "pd-b",
    "padding-left": "pd-l",
    "padding-right": "pd-r",
    "padding-top": "pd-t",
    "pointer-events": "pe",
    position: "pos",
    right: "rt",
    rotate: "rot",
    "text-align": "tx-al",
    "text-decoration": "tx-dc",
    "text-overflow": "tx-ol",
    "text-transform": "tx-tf",
    "object-fit": "oj-ft",
    "object-position": "oj-ps",
    size: "sz",
    up: "up",
    width: "wd",
    "z-index": "zi"
};
function $6eea7234d56610fe$export$92b70e511152790f(layerName) {
    return layerName.split("-").pop();
}
function $6eea7234d56610fe$export$82c717ab02da3bac(componentName, layerName) {
    return `${componentName}-${layerName}`;
}
function $6eea7234d56610fe$export$31e4419873013369(hierarchy) {
    const root = hierarchy;
    if (typeof root === "object") return Object.keys(root)[0];
    return "";
}
function $6eea7234d56610fe$export$8bf78da42833d414(hierarchy) {
    if (typeof hierarchy === "string") return [
        hierarchy
    ];
    const root = $6eea7234d56610fe$export$31e4419873013369(hierarchy);
    const layers = [
        root
    ];
    const children = hierarchy[root] ?? [];
    for (const child of children)layers.push(...$6eea7234d56610fe$export$8bf78da42833d414(child));
    return layers;
}
function $6eea7234d56610fe$export$ce4be320c9b7d5be(json) {
    const base = (0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base);
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj){
            const variant = propObj[key];
            for(const layer in variant)base[layer] = $6eea7234d56610fe$var$handleInvariantBaseMap(base[layer], variant[layer]);
        }
    }
    for(const layer in json.api.data || {}){
        for (const apiItem of Object.keys(json.api.data?.[layer] || {}))if (base[layer]?.[apiItem]) delete base[layer][apiItem];
    }
    const combinations = $6eea7234d56610fe$var$getAllCombinations({}, json);
    for(const layer in combinations)base[layer] = $6eea7234d56610fe$var$handleInvariantBaseMap(base[layer], combinations[layer]);
    for(const layer in base)for(const key in base[layer]){
        const value = base[layer][key];
        if (String(value).includes("&color")) delete base[layer][key];
    }
    return base;
}
function $6eea7234d56610fe$var$handleInvariantBaseMap(baseItem, variantItem) {
    const { behavior: variantBehavior, ...variantBaseMap } = variantItem;
    if (!baseItem) return baseItem;
    const { behavior: behavior, ...baseMap } = baseItem;
    baseItem = $6eea7234d56610fe$var$removeVariantProps(baseMap, variantBaseMap);
    if (!behavior || !variantBehavior) return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
    for(const pseudo in variantBehavior){
        const pseudoBaseMap = behavior?.[pseudo];
        if (!pseudoBaseMap) continue;
        const pseudoVariantBaseMap = variantBehavior[pseudo];
        behavior[pseudo] = $6eea7234d56610fe$var$removeVariantProps(pseudoBaseMap, pseudoVariantBaseMap);
    }
    return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
}
function $6eea7234d56610fe$var$removeVariantProps(baseMap, variantBaseMap) {
    if (!baseMap) return baseMap;
    for(const property in variantBaseMap){
        const value = variantBaseMap[property];
        if (typeof value === "object" && !Array.isArray(value)) {
            baseMap[property] = $6eea7234d56610fe$var$removeVariantProps(baseMap[property], value);
            continue;
        }
        if (property in baseMap) delete baseMap[property];
    }
    function handleObject(baseMap2) {
        for(const property in baseMap2){
            const value = baseMap2[property];
            if (!value) continue;
            if (typeof value === "string") {
                if (value.includes("&") || value.includes("%")) delete baseMap2[property];
            } else if (typeof value === "object" && !Array.isArray(value)) handleObject(value);
        }
    }
    handleObject(baseMap);
    return baseMap;
}
const $6eea7234d56610fe$export$c1260eec73bdf31d = (componentName, layer)=>`j-${componentName}-${layer}`;
const $6eea7234d56610fe$export$437bd2c771393299 = (componentName, layer, rule, includeComponentName)=>{
    const shortRule = $6eea7234d56610fe$var$tokenRuleShortKey[rule] || rule;
    const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
    if (!includeComponentName || layerKey !== "container") return `--${layer}-${shortRule}`;
    return `--${componentName.toLowerCase()}--${layer}-${shortRule}`;
};
const $6eea7234d56610fe$export$246d3e180f7f2ea = (componentName, layer, rule, includeComponentName, pseudo)=>{
    const cssVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, rule, includeComponentName);
    if (pseudo) return `${cssVar}-${$6eea7234d56610fe$var$tokenSuffixShortKey[pseudo] || pseudo}`;
    return cssVar;
};
const $6eea7234d56610fe$export$2ee1162feea7fbb0 = (componentName, layer, rule, value, isInvariant, pseudo, tokens)=>{
    return $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, [
        rule
    ], value, isInvariant, pseudo, tokens);
};
const $6eea7234d56610fe$export$e8ddbfc1e3d5162b = (componentName, layer, rule, variables, value, isInvariant, pseudo, tokens)=>{
    return $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens);
};
const $6eea7234d56610fe$var$RULE_DEFAULTS = {
    translate: "0px",
    rotate: "0deg",
    scale: "1",
    "border-top-width": "0px",
    "border-right-width": "0px",
    "border-bottom-width": "0px",
    "border-left-width": "0px"
};
function $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens) {
    const left = rule;
    const right = variables.map((variable, index)=>{
        const ruleDef = $6eea7234d56610fe$var$RULE_DEFAULTS[rule];
        const variableValue = Array.isArray(value) ? value[index] : value;
        const baseCssVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2");
        if (tokens && isInvariant && typeof variableValue !== "object") {
            const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) return resolved;
        }
        if (tokens && typeof variableValue !== "object") {
            const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) {
                if (ruleDef && resolved.includes("var(")) {
                    const innermostVar = /var\(\s*--[^,)]+\)/;
                    const resolvedWithDefault = resolved.replace(innermostVar, (match)=>`${match.slice(0, -1)}, ${ruleDef})`);
                    return `var(${baseCssVar}, ${resolvedWithDefault})`;
                }
                return `var(${baseCssVar}, ${resolved})`;
            }
        }
        const cssVar = ruleDef ? `var(${baseCssVar}, ${ruleDef})` : `var(${baseCssVar})`;
        return pseudo ? `var(${$6eea7234d56610fe$export$246d3e180f7f2ea(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2", pseudo)}, ${cssVar})` : cssVar;
    }).join(" ");
    return {
        [left]: right
    };
}
function $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens) {
    return {
        [$6eea7234d56610fe$export$246d3e180f7f2ea(componentName, layer, rule, tokens?.["brandVersion"] === "jio-v2" && !pseudo, pseudo)]: value?.toString()
    };
}
function $6eea7234d56610fe$export$6ebbb579f04445e(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens) {
    if (rule in $6eea7234d56610fe$export$95994f4e1548c018) return $6eea7234d56610fe$export$95994f4e1548c018[rule](componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
    return {};
}
function $6eea7234d56610fe$export$a8136d362b12b985(rule, ruleVal, tokens, pseudo) {
    if (rule in $6eea7234d56610fe$export$e9552252b443446) return $6eea7234d56610fe$export$e9552252b443446[rule](rule, ruleVal, tokens, pseudo);
    return void 0;
}
const $6eea7234d56610fe$export$875845b80e4c01b3 = (layer, length = 1)=>layer.split("-").map((x, index, arr)=>index !== arr.length - 1 ? x.slice(0, length) : x).filter(Boolean).join("-");
function $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, layerMap, invariantsMap, layerShortKey, pseudo, tokens) {
    const newTokens = {
        ...tokens
    };
    Object.keys(invariantsMap || {}).forEach((key2)=>{
        if (key2 in newTokens) newTokens[key2] = invariantsMap?.[key2]?.toString() ?? newTokens[key2];
    });
    const brandDefaults = $6eea7234d56610fe$export$859883d4ec9c7db4.defaults ?? {};
    const layerCSSVars = {};
    const layerClasses = [];
    const key = !pseudo && $6eea7234d56610fe$export$92b70e511152790f(layer);
    if (newTokens && newTokens?.["brandVersion"] === "jio-v2") {
        if (key && brandDefaults[key]) layerMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(brandDefaults[key] ?? {}, layerMap);
    } else if (key && ($6eea7234d56610fe$var$defaults[key] || brandDefaults[key])) layerMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)($6eea7234d56610fe$var$defaults[key] ?? {}, brandDefaults[key] ?? {}, layerMap);
    for(const rule in layerMap){
        if (invariantsMap?.[rule]) continue;
        const useClasses = rule in $6eea7234d56610fe$export$e9552252b443446 && newTokens && newTokens?.["brandVersion"] === "jio-v2" && // String(layerMap[rule]).includes('&') &&
        !pseudo;
        if (useClasses) {
            const klass = $6eea7234d56610fe$export$a8136d362b12b985(rule, layerMap[rule], newTokens);
            if (klass) {
                layerClasses.push(klass);
                continue;
            }
            if (klass === null) continue;
        }
        Object.assign(layerCSSVars, $6eea7234d56610fe$export$6ebbb579f04445e(componentName, layerShortKey, rule, layerMap[rule], pseudo, layerMap, tokens));
    }
    return {
        styles: layerCSSVars,
        classes: layerClasses
    };
}
const $6eea7234d56610fe$export$beb192a6dc60a1a7 = [
    "appearance",
    "surface",
    "strokeSurface",
    "color",
    "background-color",
    "border-color",
    "fill"
];
function $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, baseMap) {
    const colorProperty = Object.keys(baseMap || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(baseMap || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(baseMap?.[colorProperty ?? ""]) || "");
    const borderColorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(baseMap?.[borderColorProperty ?? ""]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    const baseSurface = baseMap?.["surface"]?.toString();
    const baseStrokeSurface = baseMap?.["strokeSurface"]?.toString();
    const newTokens = {
        ...tokens,
        surface: baseSurface || surface || tokens["surface"],
        strokeSurface: baseStrokeSurface || strokeSurface || tokens["strokeSurface"]
    };
    if (tokens?.["brandVersion"] === "jio-v2" && $6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens) {
        const updatedTokens = $6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens({
            ...newTokens
        });
        updatedTokens["parentScale"] = newTokens["scale"];
        return updatedTokens;
    }
    return newTokens;
}
function $6eea7234d56610fe$export$8c51a6ab64fc75e8(component, base, variant, config) {
    for(const prop in variant)if (prop in component) {
        const propValues = Object.keys(variant[prop]);
        const matchIndex = propValues.indexOf($6eea7234d56610fe$var$getProp(component, prop));
        if (matchIndex > -1) {
            base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, variant[prop][propValues[matchIndex]]);
            Object.keys(base).forEach((layer)=>{
                Object.keys(base[layer]).forEach((key)=>{
                    const value = base[layer][key];
                    if (typeof value === "string" && value.includes("%")) base[layer][key] = $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, component);
                });
            });
        }
    } else base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, variant[prop][String(config?.[0]?.values?.[0])]);
    return base;
}
function $6eea7234d56610fe$var$getProp(component, prop) {
    return Object(component)[prop]?.toString?.() ?? "";
}
function $6eea7234d56610fe$export$376823fb52709d2f(component, base, combinations, combinationConfigs, config) {
    combinationConfigs.forEach((combinationConfig, configIndex)=>{
        let partialCombination = combinations[configIndex];
        for (const prop of combinationConfig){
            if (prop in component && component[prop] !== void 0) partialCombination = partialCombination[$6eea7234d56610fe$var$getProp(component, prop)];
            else {
                const defaultValue = config?.[prop].values?.[0];
                if (typeof defaultValue !== "undefined") partialCombination = partialCombination[defaultValue.toString()];
            }
            if (!partialCombination) break;
        }
        base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, partialCombination);
        Object.keys(base).forEach((layer)=>{
            Object.keys(base[layer]).forEach((key)=>{
                const value = base[layer][key];
                if (typeof value === "string" && value.includes("%")) base[layer][key] = $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, component);
            });
        });
    });
    return base;
}
function $6eea7234d56610fe$export$14c44c1e95c03f0a(json) {
    let combined = {
        ...json.base
    };
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj)combined = $6eea7234d56610fe$var$mergeWithBooleanAnd(combined, propObj[key]);
    }
    combined = $6eea7234d56610fe$var$getAllCombinations(combined, json);
    combined = $6eea7234d56610fe$var$combineBehaviors(combined);
    return combined;
}
function $6eea7234d56610fe$var$mergeWithBooleanAnd(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $6eea7234d56610fe$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $6eea7234d56610fe$var$mergeValues(base, second) {
    if ($6eea7234d56610fe$var$isObject(base) && $6eea7234d56610fe$var$isObject(second)) return $6eea7234d56610fe$var$mergeWithBooleanAnd(base, second);
    else if ($6eea7234d56610fe$var$isArray(base) && $6eea7234d56610fe$var$isArray(second)) return [
        ...base,
        ...second
    ];
    else if (typeof base === "boolean" && typeof second === "boolean") return base && second;
    return second;
}
function $6eea7234d56610fe$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $6eea7234d56610fe$var$isArray(value) {
    return Array.isArray(value);
}
function $6eea7234d56610fe$var$getAllCombinations(combined, json) {
    const { combination: combination, combination_config: combination_config } = json;
    if (combination && combination_config) for(let index = 0; index < combination_config.length; index++){
        const config = combination_config[index];
        const comb = combination[index];
        combined = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(combined, $6eea7234d56610fe$var$getCombination(comb, config));
    }
    return combined;
}
function $6eea7234d56610fe$var$combineBehaviors(combined) {
    for(const layer in combined){
        let baseMap = combined[layer];
        for(const pseudo in baseMap.behavior)baseMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(baseMap, baseMap.behavior[pseudo]);
        combined[layer] = baseMap;
    }
    return combined;
}
function $6eea7234d56610fe$var$getCombination(currentCombination, configKeys) {
    if (configKeys.length === 0) return {};
    else if (configKeys.length === 1) {
        const bases = Object.values(currentCombination);
        return (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(bases[0], ...bases.slice(1));
    }
    const remainingKeys = configKeys.slice(1);
    const combinations = Object.values(currentCombination);
    let result = {};
    for (const comb of combinations){
        const base = $6eea7234d56610fe$var$getCombination(comb, remainingKeys);
        result = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(result, base);
    }
    return result;
}
const $6eea7234d56610fe$var$BufferConverter = (value)=>{
    return $6eea7234d56610fe$var$Buffer.from(value, "base64").toString("utf-8");
};
const $6eea7234d56610fe$export$9cc362b209501dfe = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $6eea7234d56610fe$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $6eea7234d56610fe$export$b46037aad3580cfb = (value)=>{
    return window.btoa(JSON.stringify(value));
};
const $6eea7234d56610fe$export$2b19bce00ae0a812 = /%([A-Za-z]+)/;
function $6eea7234d56610fe$export$61b94149aeb1f59(api) {
    const config = api.config;
    const data = api.data;
    const defaultProps = {};
    for(const key in config){
        const item = config[key];
        if (item.values) {
            const index = item.defaultIndex ?? 0;
            const value = item.values[index] ?? item.values[0];
            if (value) defaultProps[key] = value;
        }
    }
    for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.values) {
                const index = item.defaultIndex ?? 0;
                const value = item.values[index] ?? item.values[0];
                if (value) defaultProps[key] = value;
            }
        }
    }
    return defaultProps;
}
function $6eea7234d56610fe$export$2ea6a22288ddba23(api) {
    const { data: data, config: config } = api;
    if (config?.["appearance"]) {
        const item = config["appearance"];
        if (item.defaultIndex) return item.values?.[item.defaultIndex].toString() ?? item.values?.[0].toString() ?? "auto";
    } else for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.name === "appearance" && item.type === "enum") return item.values?.[0]?.toString() ?? "auto";
        }
    }
    return "auto";
}
function $6eea7234d56610fe$export$bdcbab1cb38db489(val) {
    return typeof val === "string" && /{.*}/.test(val);
}
const $6eea7234d56610fe$var$defaultCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (tokens?.["brandVersion"] === "jio-v2" && !String(value).endsWith("%")) value = `calc(${value} * 1%)`;
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$colorCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const originalValue = value;
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (String(originalValue).includes("elevated")) {
        const bgVarItems = String(value).split(",");
        const [bgColor, shadowColor, x1, y1, r1, x2, y2, r2, borderColor, borderWidth] = String(bgVarItems[1] || value).split(";");
        return {
            ...$6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, bgColor, pseudo, tokens),
            ...borderWidth ? $6eea7234d56610fe$export$c52007b28a606662(component, layer, "border-width", `${borderWidth}px`, pseudo, tokens) : {},
            ...x1 || x2 || y1 || y2 || r1 || r2 ? $6eea7234d56610fe$export$c52007b28a606662(component, layer, "box-shadow", `${x1}px ${y1}px ${r1}px ${shadowColor}, ${x2}px ${y2}px ${r2}px ${shadowColor}`, pseudo, tokens) : {},
            ...$6eea7234d56610fe$export$c52007b28a606662(component, layer, "border-color", `${borderColor}`, pseudo, tokens)
        };
    }
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$isCSSVar = (value)=>value.startsWith("var(--");
const $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    const supportedValues = [
        "100%",
        "fit-content",
        "max",
        "min",
        "intrinsicSize.max",
        "intrinsicSize.min"
    ];
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const layerParts = layer.split("-");
    const baseLayer = layerParts[layerParts.length - 1];
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (!supportedValues.includes(value) && !$6eea7234d56610fe$var$isCSSVar(value)) {
        if (isNaN(parseFloat(value))) value = $6eea7234d56610fe$export$bb974f6f0c330fb[baseLayer]?.[rule];
    }
    if (value === "max") value = "100%";
    if (value === "min") value = "fit-content";
    if (value === "intrinsicSize.max") value = "unset";
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$borderGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $6eea7234d56610fe$var$handleBorderGradientColorObject(component, layer, "border-image", value, pseudo);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "border-image", value, pseudo);
};
const $6eea7234d56610fe$var$backgroundGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $6eea7234d56610fe$var$handleBackgroundGradientColorObject(component, layer, "background-image", value, pseudo);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "background-image", value, pseudo);
};
const $6eea7234d56610fe$var$handleBackgroundGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, angle: angle } = ruleVal;
    const colorStops = Array.from(colors).join(",");
    if (type === "radial") {
        const resolvedValue = `radial-gradient(circle, ${colorStops})`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    } else if (type === "linear") {
        const degAngle = $6eea7234d56610fe$export$95c38a73fd251991("rotate", angle ?? 180);
        const resolvedValue = `linear-gradient(${degAngle}, ${colorStops})`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    }
    console.warn("Unknown background gradient in", componentName, layer);
    return {};
};
const $6eea7234d56610fe$var$handleBorderGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, width: width } = ruleVal;
    const typeMap = {
        radial: "radial-gradient",
        linear: "linear-gradient"
    };
    const colorStops = colors.join(",");
    const resolvedValue = `${typeMap[type]}(circle,${colorStops}) ${width}`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
};
const $6eea7234d56610fe$var$sizeCSSVarRuleHandler = (component, layer, _rule, value, pseudo, layerMap, tokens)=>({
        ...$6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "height", value, pseudo, layerMap, tokens),
        ...$6eea7234d56610fe$var$dimensionsCSSVarRuleHandler(component, layer, "width", value, pseudo, layerMap, tokens)
    });
const $6eea7234d56610fe$var$boxShadowCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    if (typeof ruleVal === "object") return $6eea7234d56610fe$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
};
const $6eea7234d56610fe$var$boxShadowOrderedKeys = [
    "x",
    "y",
    "blur",
    "spread",
    "color"
];
const $6eea7234d56610fe$var$BOX_SHADOW_RULE_MAP = {
    x: "padding",
    y: "padding",
    blur: "padding",
    spread: "padding",
    color: "color"
};
function $6eea7234d56610fe$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens) {
    const values = [];
    for (const key of $6eea7234d56610fe$var$boxShadowOrderedKeys){
        if (!(key in ruleVal)) continue;
        const value = ruleVal[key];
        const rule2 = $6eea7234d56610fe$var$BOX_SHADOW_RULE_MAP[key];
        const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule2, value, tokens);
        values.push(resolved);
    }
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, values.join(" "), pseudo, tokens);
}
const $6eea7234d56610fe$var$flexDirectionCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const result = {};
    let position = "static";
    if (value.includes("stack")) {
        value = "row";
        position = "relative";
    }
    Object.assign(result, $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens), $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens));
    return result;
};
const $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _, tokens)=>{
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
};
const $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    if (rule === "blur-radius") rule = "filter";
    else rule = "backdrop-filter";
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    ruleVal = `blur(${ruleVal})`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "filter", ruleVal, pseudo, tokens);
};
const $6eea7234d56610fe$var$borderRulesMap = {
    "border-radius": [
        "border-top-left-radius",
        "border-top-right-radius",
        "border-bottom-right-radius",
        "border-bottom-left-radius"
    ],
    "border-width": [
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ],
    "border-color": [
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color"
    ]
};
function $6eea7234d56610fe$var$getBorderRules(rule) {
    return $6eea7234d56610fe$var$borderRulesMap[rule] || [];
}
const $6eea7234d56610fe$var$borderCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>$6eea7234d56610fe$var$getBorderRules(rule).map((r)=>{
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, r, ruleVal, pseudo, tokens);
    }).reduce((a, b)=>({
            ...a,
            ...b
        }), {});
const $6eea7234d56610fe$var$zIndexCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    let position = "static";
    const num = parseInt(value);
    if (num !== 0) position = "absolute";
    return {
        ...$6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens),
        ...$6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens)
    };
};
const $6eea7234d56610fe$var$disabledCSSVarRuleHandler = (component, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2("pointer-events", value, tokens);
    value = !value || value === "false" ? "auto" : "none";
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, "pointer-events", value, pseudo, tokens);
};
const $6eea7234d56610fe$var$paddingCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const paddingValue = $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
    const direction = rule.split("-")[1];
    const borderWidthRule = `border-${direction}-width`;
    const borderWidthValue = layerMap?.[borderWidthRule] || layerMap?.["border-width"];
    if (borderWidthValue) {
        const borderWidthCSSVar = $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler(componentName, layer, borderWidthRule, borderWidthValue, pseudo, layerMap, tokens);
        const val = Object.values(borderWidthCSSVar)[0];
        if (val) {
            const key = Object.keys(paddingValue)[0];
            paddingValue[key] = `calc(${paddingValue[key]} - ${val})`;
        }
    }
    return paddingValue;
};
const $6eea7234d56610fe$var$buttonVectorRuleMap = {
    "fill-color": "color",
    "stroke-color": "color"
};
const $6eea7234d56610fe$var$skeletonRuleMap = {
    "primary-color": "color",
    "secondary-color": "color"
};
const $6eea7234d56610fe$var$inputRuleMap = {
    "inactive-color": "color",
    "active-color": "color",
    "ball-size": "height",
    "ball-color": "color",
    "ball-border-color": "color",
    "ball-border-width": "border-width",
    "track-height": "height",
    "placeholder-color": "color",
    "placeholder-font-family": "font-family",
    "placeholder-font-size": "font-size",
    "placeholder-line-height": "line-height",
    "placeholder-letter-spacing": "letter-spacing",
    "placeholder-font-weight": "font-weight",
    "input-color": "color",
    "input-font-family": "font-family",
    "input-font-size": "font-size",
    "input-line-height": "line-height",
    "input-letter-spacing": "letter-spacing",
    "input-font-weight": "font-weight",
    "resize-color": "color",
    "cursor-color": "color"
};
const $6eea7234d56610fe$var$inputCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$inputRuleMap[rule], value, tokens);
    if (rule === "input-line-height") return $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler(componentName, layer, rule, value, pseudo, _, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$buttonVectorRuleMap[rule], value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, `--${rule}`, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$cursorCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>$6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "cursor", value, pseudo, layerMap, tokens);
const $6eea7234d56610fe$var$skeletonCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$skeletonRuleMap[rule], value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitonTimingFunctionHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    value = `cubic-bezier${value}`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitonDurationHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    rule = "transition-duration";
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transformCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    const [ruleName, direction] = rule.split("-");
    if (!direction) return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, ruleName, ruleVal, pseudo, layerMap, tokens);
    if (direction) {
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(ruleName, ruleVal, tokens);
        if (ruleName === "rotate") ruleVal = `${direction} ${ruleVal}`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
    }
    return {};
};
const $6eea7234d56610fe$var$TRANSITION_PROPERTY_MAP = {
    "translate-x": "translate",
    "translate-y": "translate",
    "translate-z": "translate",
    "scale-x": "scale",
    "scale-y": "scale",
    "scale-z": "scale",
    "rotate-x": "rotate",
    "rotate-y": "rotate",
    "rotate-z": "rotate"
};
const $6eea7234d56610fe$var$transitionCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value !== "object" || !value) {
        console.warn("Transition needs to be object.");
        return {};
    }
    const { property: property, duration: duration, "timing-function": timingFunction, delay: delay } = value;
    const result = {};
    if (property) {
        const props = Array().concat(property);
        Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-property", props.map((prop)=>$6eea7234d56610fe$var$TRANSITION_PROPERTY_MAP[prop] ?? prop).join(", "), pseudo, layerMap, tokens));
    }
    if (duration) Object.assign(result, $6eea7234d56610fe$var$transitonDurationHandler(componentName, layer, "transition-duration", duration, pseudo, layerMap, tokens));
    if (timingFunction) Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-timing-function", timingFunction, pseudo, layerMap, tokens));
    if (delay) Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-delay", delay, pseudo, layerMap, tokens));
    return result;
};
const $6eea7234d56610fe$var$clipFirstHalfCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value);
    const baseVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, "--clip-value", tokens?.["brandVersion"] === "jio-v2");
    if (value) value = `inset(0 var(${baseVar}, 0) 0 0)`;
    else value = `inset(0 0 0 var(${baseVar}, 0))`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$clipValueCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const clipFirstHalf = layerMap?.["clip-first-half"];
    if (clipFirstHalf) value = `inset(0 ${value ?? 0} 0 0)`;
    else value = `inset(0 0 0 ${value ?? 0})`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$linearGradientOpacityHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const cssVars = value.map((value2, i)=>{
        const numberValue = value2.split("%")[0];
        const decimalValue = parseFloat(numberValue) + "%";
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "linear-gradient-opacity-" + i, decimalValue, pseudo, tokens);
    });
    return cssVars.reduce((acc, cssVar)=>({
            ...acc,
            ...cssVar
        }), {});
};
const $6eea7234d56610fe$var$linearGradientHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const colors = value.map((value2, i)=>{
        const color = $6eea7234d56610fe$export$6a176e754d54672("color", value2, tokens || {});
        const opacity = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-opacity-${i})`;
        if (color.startsWith("oklch")) return `oklch(from ${color} l c h / ${opacity})`;
        const { r: r, g: g, b: b } = (0, $bff35c0dd9851fab$export$848d71df1f759bc)(color);
        return `rgba(${r},${g},${b}, )`;
    });
    const endCSSVar = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-end,bottom)`;
    const gradient = `linear-gradient(to ${endCSSVar},${colors.join(",")} )`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "background-image", gradient, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitionCSSVarRules = {
    "transition-timing-function": $6eea7234d56610fe$var$transitonTimingFunctionHandler,
    "transition-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "transition-property": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "transition-delay": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    transition: $6eea7234d56610fe$var$transitionCSSVarRuleHandler,
    "enter-animation-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "exit-animation-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "animation-duration": $6eea7234d56610fe$var$transitonDurationHandler
};
const $6eea7234d56610fe$var$inputCSSVarRules = {
    "inactive-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "active-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-border-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-border-width": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "track-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-family": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-line-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-letter-spacing": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-weight": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-family": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-line-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-letter-spacing": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-weight": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "resize-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "cursor-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler
};
const $6eea7234d56610fe$var$skeletonCSSVarRules = {
    "primary-color": $6eea7234d56610fe$var$skeletonCSSVarRuleHandler,
    "secondary-color": $6eea7234d56610fe$var$skeletonCSSVarRuleHandler
};
const $6eea7234d56610fe$var$buttonVectorCSSVarRules = {
    "fill-color": $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler,
    "stroke-color": $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler
};
const $6eea7234d56610fe$var$clipCSSVarRules = {
    "clip-first-half": $6eea7234d56610fe$var$clipFirstHalfCSSVarRuleHandler,
    "clip-value": $6eea7234d56610fe$var$clipValueCSSVarRuleHandler
};
const $6eea7234d56610fe$export$95994f4e1548c018 = {
    "align-items": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "aspect-ratio": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "background-blur": $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler,
    "background-gradient-color": $6eea7234d56610fe$var$backgroundGradientColorCSSVarRuleHandler,
    "background-image": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "background-repeat": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "blur-radius": $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler,
    "border-color": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-radius": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-style": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-width": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-top-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-right-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-bottom-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-left-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-top-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-right-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-left-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-gradient-color": $6eea7234d56610fe$var$borderGradientColorCSSVarRuleHandler,
    "border-top-left-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-top-right-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-right-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-left-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    bottom: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "box-shadow": $6eea7234d56610fe$var$boxShadowCSSVarRuleHandler,
    "box-sizing": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    cursor: $6eea7234d56610fe$var$cursorCSSVarRuleHandler,
    display: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    disabled: $6eea7234d56610fe$var$disabledCSSVarRuleHandler,
    flex: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "flex-shrink": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "flex-direction": $6eea7234d56610fe$var$flexDirectionCSSVarRuleHandler,
    "flex-wrap": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-family": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-size": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-weight": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    gap: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    height: $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "justify-content": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    left: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "letter-spacing": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "line-height": $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler,
    "max-height": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "max-width": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "min-height": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "min-width": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    opacity: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    outline: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    overflow: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "padding-bottom": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-left": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-right": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-top": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "pointer-events": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    position: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    right: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    rotate: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "rotate-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "rotate-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "rotate-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    translate: $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    scale: $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "text-align": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-decoration": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-overflow": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-transform": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "object-fit": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "object-position": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    size: $6eea7234d56610fe$var$sizeCSSVarRuleHandler,
    up: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "web-cursor": $6eea7234d56610fe$var$cursorCSSVarRuleHandler,
    width: $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "z-index": $6eea7234d56610fe$var$zIndexCSSVarRuleHandler,
    "linear-gradient-start": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "linear-gradient-end": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "linear-gradient-colors": $6eea7234d56610fe$var$linearGradientHandler,
    "linear-gradient-opacity": $6eea7234d56610fe$var$linearGradientOpacityHandler,
    ...$6eea7234d56610fe$var$inputCSSVarRules,
    ...$6eea7234d56610fe$var$skeletonCSSVarRules,
    ...$6eea7234d56610fe$var$transitionCSSVarRules,
    ...$6eea7234d56610fe$var$buttonVectorCSSVarRules,
    ...$6eea7234d56610fe$var$clipCSSVarRules,
    "font-style": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    color: $6eea7234d56610fe$var$colorCSSVarRuleHandler,
    "background-color": $6eea7234d56610fe$var$colorCSSVarRuleHandler
};
function $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens) {
    if (value?.toString().includes("&")) return $6eea7234d56610fe$export$6a176e754d54672(rule, String(value), tokens || {});
    if ($6eea7234d56610fe$export$bdcbab1cb38db489(value)) value = $6eea7234d56610fe$export$6404fd1becf96b61(rule, value);
    else value = $6eea7234d56610fe$export$95c38a73fd251991(rule, value);
    return value;
}
const $6eea7234d56610fe$export$585f0f7ef40c9f0 = (tokenString)=>`--${(0, $bff35c0dd9851fab$export$3e672a90535a3744)((0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(tokenString.replace(/\./g, "-")))}`;
class $6eea7234d56610fe$var$Color {
    color;
    colorInstance;
    alpha = 1;
    constructor(color, alpha = 1){
        this.color = color;
        this.alpha = alpha;
        if (!this.colorInstance) this.colorInstance = new $6eea7234d56610fe$var$Color(color);
    }
    to(format) {
        console.info(format);
        return this.colorInstance;
    }
    toString(data) {
        console.info(data);
        return this.color;
    }
    mix(color, value) {
        console.info(color, value);
        return this.colorInstance;
    }
}
const $6eea7234d56610fe$var$alphaColorModifier = (hexColor, alpha)=>{
    let color = new $6eea7234d56610fe$var$Color(hexColor);
    color = color.to("hsl");
    color.alpha = Math.max(0, Math.min(1, Number(alpha)));
    const newColor = new $6eea7234d56610fe$var$Color(color.toString({
        inGamut: true,
        precision: 3
    }));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $6eea7234d56610fe$var$mixColorModifier = (firstColor, secondColor, parameter)=>{
    const color = new $6eea7234d56610fe$var$Color(firstColor);
    const mixColor = new $6eea7234d56610fe$var$Color(secondColor.toString());
    const mixValue = Math.max(0, Math.min(1, Number(parameter)));
    const newColor = new $6eea7234d56610fe$var$Color(color.mix(mixColor, mixValue).toString({}));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $6eea7234d56610fe$var$COLOR_MODIFIER_MAP = {
    alpha: $6eea7234d56610fe$var$alphaColorModifier,
    mix: $6eea7234d56610fe$var$mixColorModifier
};
const $6eea7234d56610fe$var$functionRegex = /(\w+)\(([\w.# ,-]+)\)/;
const $6eea7234d56610fe$var$mulRegex = /(-?[\d.]+)\*(-?[\d.]+)/;
const $6eea7234d56610fe$var$divRegex = /(-?[\d.]+)\/(-?[\d.]+)/;
const $6eea7234d56610fe$var$addRegex = /(-?[\d.]+)\+(-?[\d.]+)/;
const $6eea7234d56610fe$var$subRegex = /(-?[\d.]+)-(-?[\d.]+)/;
const $6eea7234d56610fe$var$expRegex = /(-?[\d.]+)\^(-?[\d.]+)/;
const $6eea7234d56610fe$var$parensRegex = /\((-?[\d.]+)\)/;
function $6eea7234d56610fe$var$colorModify(args) {
    const [type, ...values] = args;
    try {
        return $6eea7234d56610fe$var$COLOR_MODIFIER_MAP[type](...values);
    } catch (e) {
        console.warn("wrong input for type in colorModifier: ", type);
        return "";
    }
}
const $6eea7234d56610fe$var$functionMap = {
    floor: ([value])=>Math.floor(parseFloat(value)).toString(),
    round: ([value])=>Math.round(parseFloat(value)).toString(),
    min: (args)=>Math.min(...args.map(parseFloat)).toString(),
    max: (args)=>Math.max(...args.map(parseFloat)).toString(),
    colorModify: $6eea7234d56610fe$var$colorModify
};
const $6eea7234d56610fe$var$operators = [
    [
        $6eea7234d56610fe$var$expRegex,
        (first, second)=>(parseFloat(first) ** parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$mulRegex,
        (first, second)=>(parseFloat(first) * parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$divRegex,
        (first, second)=>(parseFloat(first) / parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$addRegex,
        (first, second)=>(parseFloat(first) + parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$subRegex,
        (first, second)=>(parseFloat(first) - parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$functionRegex,
        (name, argsString)=>{
            if (name in $6eea7234d56610fe$var$functionMap) return $6eea7234d56610fe$var$functionMap[name](argsString.split(","));
            return "";
        }
    ],
    [
        $6eea7234d56610fe$var$parensRegex,
        (value)=>value
    ]
];
function $6eea7234d56610fe$var$parseMaths(key) {
    if (!$6eea7234d56610fe$var$operators.find(([op])=>op.test(key))) return key;
    let value = key.replace(/[ ']/g, "");
    let operator;
    while(operator = $6eea7234d56610fe$var$operators.find(([op])=>op.test(value))){
        const [op, callback] = operator;
        const match = value.match(op);
        if (match) {
            const left = match[1];
            const right = match[2];
            const replacement = callback(left, right);
            const replaced = value.replace(op, replacement);
            if (replaced === "") break;
            value = replaced.replace(/ /g, "");
        }
    }
    return value;
}
const $6eea7234d56610fe$var$colorJsons = [
    "color"
];
const $6eea7234d56610fe$var$borderRadiusJsons = [
    "borderRadius"
];
const $6eea7234d56610fe$var$sizeJsons = [
    "sizing",
    "layout"
];
const $6eea7234d56610fe$var$borderWidthJsons = [
    "borderWidth",
    ...$6eea7234d56610fe$var$sizeJsons
];
const $6eea7234d56610fe$var$letterSpacingJSONs = [
    "letterSpacing",
    "typography"
];
const $6eea7234d56610fe$var$fontSizeJsons = [
    "fontSizes"
];
const $6eea7234d56610fe$var$lineHeightJsons = [
    "lineHeights",
    "typography"
];
const $6eea7234d56610fe$var$fontFamilyJsons = [
    "fontFamilies",
    "typography"
];
const $6eea7234d56610fe$var$fontWeightJsons = [
    "fontWeights",
    "typography"
];
const $6eea7234d56610fe$var$spacingJsons = [
    "spacing"
];
const $6eea7234d56610fe$var$otherJsons = [
    "layout"
];
const $6eea7234d56610fe$var$opacityJsons = [
    "opacity"
];
const $6eea7234d56610fe$var$shadowsJsons = [
    "shadows"
];
const $6eea7234d56610fe$var$textDecorationJsons = [
    "textDecoration"
];
const $6eea7234d56610fe$var$textTransformJsons = [
    "textCase"
];
const $6eea7234d56610fe$var$transitionDurationJSONs = [
    "transitionsDuration"
];
const $6eea7234d56610fe$var$transitionTimingFunctionJSONs = [
    "transitions"
];
const $6eea7234d56610fe$export$a8c2fb75d5b0e0e = {
    "background-color": $6eea7234d56610fe$var$colorJsons,
    "background-image": $6eea7234d56610fe$var$colorJsons,
    "border-color": $6eea7234d56610fe$var$colorJsons,
    "border-top-color": $6eea7234d56610fe$var$colorJsons,
    "border-right-color": $6eea7234d56610fe$var$colorJsons,
    "border-bottom-color": $6eea7234d56610fe$var$colorJsons,
    "border-left-color": $6eea7234d56610fe$var$colorJsons,
    color: $6eea7234d56610fe$var$colorJsons,
    "border-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-top-left-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-top-right-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-bottom-right-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-bottom-left-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-top-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-right-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-bottom-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-left-width": $6eea7234d56610fe$var$borderWidthJsons,
    "blur-radius": $6eea7234d56610fe$var$sizeJsons,
    filter: $6eea7234d56610fe$var$sizeJsons,
    height: $6eea7234d56610fe$var$sizeJsons,
    "max-height": $6eea7234d56610fe$var$sizeJsons,
    "min-height": $6eea7234d56610fe$var$sizeJsons,
    width: $6eea7234d56610fe$var$sizeJsons,
    "max-width": $6eea7234d56610fe$var$sizeJsons,
    "min-width": $6eea7234d56610fe$var$sizeJsons,
    size: $6eea7234d56610fe$var$sizeJsons,
    "font-size": $6eea7234d56610fe$var$fontSizeJsons,
    "line-height": $6eea7234d56610fe$var$lineHeightJsons,
    "font-family": $6eea7234d56610fe$var$fontFamilyJsons,
    "font-weight": $6eea7234d56610fe$var$fontWeightJsons,
    gap: $6eea7234d56610fe$var$spacingJsons,
    padding: $6eea7234d56610fe$var$spacingJsons,
    "padding-left": $6eea7234d56610fe$var$spacingJsons,
    "padding-right": $6eea7234d56610fe$var$spacingJsons,
    "padding-top": $6eea7234d56610fe$var$spacingJsons,
    "padding-bottom": $6eea7234d56610fe$var$spacingJsons,
    "box-shadow": $6eea7234d56610fe$var$shadowsJsons,
    "text-decoration": $6eea7234d56610fe$var$textDecorationJsons,
    opacity: $6eea7234d56610fe$var$opacityJsons,
    "aspect-ratio": $6eea7234d56610fe$var$otherJsons,
    "flex-direction": $6eea7234d56610fe$var$otherJsons,
    "align-items": $6eea7234d56610fe$var$otherJsons,
    "justify-content": $6eea7234d56610fe$var$otherJsons,
    display: $6eea7234d56610fe$var$otherJsons,
    "font-style": $6eea7234d56610fe$var$otherJsons,
    outline: $6eea7234d56610fe$var$otherJsons,
    "text-align": $6eea7234d56610fe$var$otherJsons,
    rotate: $6eea7234d56610fe$var$otherJsons,
    "letter-spacing": $6eea7234d56610fe$var$letterSpacingJSONs,
    "border-gradient-color": $6eea7234d56610fe$var$colorJsons,
    "linear-gradient-colors": $6eea7234d56610fe$var$colorJsons,
    "text-transform": $6eea7234d56610fe$var$textTransformJsons,
    "enter-animation-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "exit-animation-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "transition-timing-function": $6eea7234d56610fe$var$transitionTimingFunctionJSONs,
    "transition-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "transition-property": $6eea7234d56610fe$var$otherJsons
};
const $6eea7234d56610fe$var$RN_TOKEN_OVERRIDES = {
    "{label.3xs.lineheight}": "110.00000238418579"
};
class $6eea7234d56610fe$export$859883d4ec9c7db4 {
    static constants = {};
    static defaults;
    static fetchTokenMemo = {};
    static switchablesMemo = {};
    static componentTokensMemo = {};
    static brandSwitchableFn;
    static updateFlatTokens;
    static brandResolverFn;
    static brandComponentFn;
    static getDensityMap;
    static getColorsMap;
    static getSwitchables(tokens) {
        const tokensKey = JSON.stringify(tokens);
        const switchables = this.switchablesMemo[tokensKey] ?? this.brandSwitchableFn?.(tokens) ?? {};
        this.switchablesMemo[tokensKey] = switchables;
        return switchables;
    }
    /**
   * Use this to register the brand provided by the user
   * @param brand The brand object to register
   */ static registerBrand(brand) {
        this.constants = brand.tokens;
        this.defaults = brand.defaults;
        this.brandSwitchableFn = brand.getSwitchableTokens;
        this.brandComponentFn = brand.getComponentTokens;
        this.brandResolverFn = brand.brandResolverFn;
        this.updateFlatTokens = brand.updateFlatTokens;
        this.getDensityMap = brand.getDensityMap;
        this.getColorsMap = brand.getColorsMap;
        this.fetchTokenMemo = {};
        this.switchablesMemo = {};
        this.componentTokensMemo = {};
    }
    static registerAdditionalTokens(tokens) {
        this.constants["extras"] = tokens;
    }
    static getValue(rule, key, tokens, forceValue) {
        if ($6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn && String(key).includes("&")) {
            const { value: brandValue, key: brandKey } = $6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn(rule, key, tokens || {}, forceValue) ?? {};
            if (brandKey) {
                if (!forceValue) return `var(${$6eea7234d56610fe$export$585f0f7ef40c9f0(brandKey.replace(/f-(\d+)/, "f-m$1"))})`;
                return brandValue;
            }
            if (typeof brandValue !== "undefined") return $6eea7234d56610fe$export$95c38a73fd251991(rule, brandValue);
        }
        const [jsonKey, ...fallbacks] = $6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule] ?? [];
        if (!jsonKey) return void 0;
        let json = this.constants[jsonKey];
        const switchables = this.getSwitchables(tokens);
        if (!json) json = switchables?.[jsonKey];
        if (this.constants["extras"]) fallbacks.push("extras");
        let value = json?.[key];
        if (value === void 0) for (const fallback2 of fallbacks){
            json = this.constants[fallback2] ?? switchables?.[fallback2];
            value = json?.[key];
            if (value !== void 0) break;
        }
        return value;
    }
    static getComponentToken(key, metaCompName) {
        key = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key);
        if (metaCompName in this.componentTokensMemo) return this.componentTokensMemo[metaCompName]?.[key];
        const compTokens = this.brandComponentFn?.(metaCompName);
        this.componentTokensMemo[metaCompName] = compTokens;
        return compTokens?.[key];
    }
    static getApplicableTokens(tokens) {
        const switchables = this.getSwitchables(tokens);
        const merged = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(this.constants, switchables);
        const tokenKeys = Object.keys(tokens);
        const result = {};
        for(const folderKey in merged){
            const folder = merged[folderKey];
            const filtered = Object.entries(folder || {}).reduce((acc, [key, value])=>{
                if (typeof value === "string" && tokenKeys.some((token)=>value.includes(`$${token}`))) acc[key] = value;
                return acc;
            }, {});
            result[folderKey] = filtered;
        }
        return result;
    }
}
const $6eea7234d56610fe$var$assignTypes = {
    sizing: "size",
    spacing: "padding",
    "font-families": "font-family",
    "font-sizes": "font-size",
    "font-weights": "font-weight",
    "line-heights": "line-height",
    "text-case": "text-transform",
    "transitions-duration": "transition-duration",
    transitions: "transition-timing-function",
    typography: "font-family",
    lineHeights: "line-height",
    fontFamilies: "font-family",
    letterSpacing: "letter-spacing",
    fontWeights: "font-weight",
    fontSizes: "font-size",
    textCase: "text-transform",
    platform: "size"
};
function $6eea7234d56610fe$export$c59eaf4f26921ab2(folder, key, tokens) {
    const rule = $6eea7234d56610fe$var$assignTypes[folder] ?? folder;
    return $6eea7234d56610fe$export$6a176e754d54672(rule, key, tokens);
}
function $6eea7234d56610fe$export$6a176e754d54672(rule, key, tokens, forceValue = false) {
    const memoKey = $6eea7234d56610fe$var$getMemoKey(rule, key, tokens);
    if (memoKey in $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo) return $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo[memoKey];
    let raw = $6eea7234d56610fe$var$parseKey(rule, key, tokens, forceValue);
    if ($6eea7234d56610fe$var$RN_TOKEN_OVERRIDES[key]) raw = $6eea7234d56610fe$var$RN_TOKEN_OVERRIDES[key];
    let value = String(key)?.includes("column") ? raw : $6eea7234d56610fe$export$95c38a73fd251991(rule, raw);
    if (rule === "line-height" && tokens?.["brandVersion"] === "jio-v2") value = value.replace("px", "%");
    if ($6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule]?.includes("sizing")) {
        value = value === "max" ? "100%" : value;
        value = value === "min" ? "100%" : value;
        value = value === "negativeMax" ? "-100%" : value;
        value = value === "intrinsicSize.max" ? "max-content" : value;
    }
    if (rule?.includes("transition-timing-function")) value = `cubic-bezier(${value})`;
    $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo[memoKey] = value;
    return value;
}
const $6eea7234d56610fe$var$getNestedFallbacks = (variables)=>{
    if (variables.length > 1) return `var(${variables[0]}, ${$6eea7234d56610fe$var$getNestedFallbacks(variables.slice(1))})`;
    return `var(${variables[0]})`;
};
function $6eea7234d56610fe$export$6404fd1becf96b61(rule, key) {
    const jsons = $6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule] ?? $6eea7234d56610fe$var$otherJsons;
    return $6eea7234d56610fe$var$getNestedFallbacks(jsons.map((json)=>$6eea7234d56610fe$export$585f0f7ef40c9f0(json ? `${json}-${key}` : key)));
}
const $6eea7234d56610fe$var$tokenReg = /{([\w\-.$]+)}/;
const $6eea7234d56610fe$var$pureTokenReg = /^{([&%?\w\-.]+)}$/;
const $6eea7234d56610fe$var$pureTokenRegWithSwitchable = /^{([&%?\w\-.$]+)}$/;
const $6eea7234d56610fe$var$pureValue = /^[[\],\w\d?%\-. #$]+$/;
function $6eea7234d56610fe$var$getMemoKey(rule, key, tokens) {
    return rule + key + JSON.stringify(tokens);
}
function $6eea7234d56610fe$var$parseKey(rule, key, tokens, forceValue) {
    let value;
    if ($6eea7234d56610fe$var$pureTokenReg.test(key)) {
        key = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key);
        value = $6eea7234d56610fe$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else if ($6eea7234d56610fe$var$pureTokenRegWithSwitchable.test(key)) {
        key = $6eea7234d56610fe$var$replaceTokens((0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key), tokens);
        value = $6eea7234d56610fe$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else value = key;
    if (value === void 0) {
        if (key.includes("typography")) return key;
        return "";
    } else if (typeof value !== "string") return value.toString();
    if ($6eea7234d56610fe$var$pureTokenReg.test(value)) return $6eea7234d56610fe$var$parseKey(rule, value, tokens, forceValue);
    if ($6eea7234d56610fe$var$pureTokenRegWithSwitchable.test(value)) {
        if (Object.keys(tokens).length === 0) {
            console.warn(`No tokens provided, cannot resolve ${key}, ${value}`);
            return "";
        }
        const switched = $6eea7234d56610fe$var$replaceTokens(value, tokens);
        return $6eea7234d56610fe$var$parseKey(rule, switched, tokens, forceValue);
    }
    if ($6eea7234d56610fe$var$tokenReg.test(value)) value = $6eea7234d56610fe$var$handleNonPureTokens(rule, value, tokens, forceValue);
    if ($6eea7234d56610fe$var$pureValue.test(value) || value.startsWith("color-mix")) return value;
    const mathParsed = $6eea7234d56610fe$var$parseMaths(value);
    return mathParsed;
}
function $6eea7234d56610fe$var$handleNonPureTokens(rule, value, tokens, forceValue) {
    let match;
    while(match = $6eea7234d56610fe$var$tokenReg.exec(value)){
        const replacement = $6eea7234d56610fe$var$parseKey(rule, match[0], tokens, forceValue);
        value = value.replace($6eea7234d56610fe$var$tokenReg, replacement);
    }
    return value;
}
const $6eea7234d56610fe$var$UNITS_MAP = {
    filter: "px",
    "backdrop-filter": "px",
    "background-blur": "px",
    "blur-radius": "px",
    "border-radius": "px",
    "border-top-left-radius": "px",
    "border-top-right-radius": "px",
    "border-bottom-right-radius": "px",
    "border-bottom-left-radius": "px",
    "border-width": "px",
    "border-top-width": "px",
    "border-right-width": "px",
    "border-bottom-width": "px",
    "border-left-width": "px",
    height: "px",
    width: "px",
    size: "px",
    "font-size": "px",
    "line-height": "px",
    gap: "px",
    padding: "px",
    "padding-left": "px",
    "padding-right": "px",
    "padding-top": "px",
    "padding-bottom": "px",
    "letter-spacing": "px",
    outline: "%",
    rotate: "deg",
    "transition-duration": "ms",
    "transition-delay": "ms",
    "exit-animation-duration": "ms",
    "enter-animation-duration": "ms",
    "animation-duration": "ms"
};
const $6eea7234d56610fe$var$unitRules = Object.keys($6eea7234d56610fe$var$UNITS_MAP);
const $6eea7234d56610fe$export$fe0319385f0cf5a7 = [
    "px",
    "%",
    "deg",
    "vw",
    "em",
    "rem",
    "vh",
    "ms"
];
function $6eea7234d56610fe$var$needsUnits(value, match) {
    const notString = typeof value !== "string";
    const noMatch = !match;
    if (notString || noMatch) return Boolean(match);
    const isNotNumber = isNaN(parseInt(value));
    const hasUnits = $6eea7234d56610fe$export$fe0319385f0cf5a7.some((unit)=>value.includes(unit));
    return !(isNotNumber || hasUnits);
}
function $6eea7234d56610fe$export$95c38a73fd251991(rule, value) {
    const match = $6eea7234d56610fe$var$unitRules.find((unit)=>rule.includes(unit)) ?? "";
    if ($6eea7234d56610fe$var$needsUnits(value, match)) return `${value}${$6eea7234d56610fe$var$UNITS_MAP[match]}`;
    return value.toString();
}
const $6eea7234d56610fe$var$fallback = {
    lang: "en",
    platform: "desktop"
};
function $6eea7234d56610fe$var$replaceTokens(key, tokens) {
    tokens = {
        ...$6eea7234d56610fe$var$fallback,
        ...tokens
    };
    return Object.entries(tokens).filter(([, value])=>value).reduce((key2, [token, value])=>{
        return key2.replace(RegExp(`\\$${token}`, "g"), value.toString());
    }, key);
}
function $6eea7234d56610fe$export$d785cbf77f40ae28(func, details) {
    const start = performance.now();
    const result = func();
    const end = performance.now();
    setTimeout(()=>{
        console.log(`Time Taken${details ? ` for ${details}` : ""}: ${end - start}`);
    });
    return result;
}
const $6eea7234d56610fe$export$b81511b7d77b08 = (reference, defaultValues)=>{
    Object.keys(defaultValues).forEach((prop)=>{
        if (reference[prop] === void 0) reference[prop] = defaultValues[prop];
    });
    return reference;
};
const $6eea7234d56610fe$export$460dbca19df1617d = (hex)=>{
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8})$/;
    return hexRegex.test(hex);
};



const $f551aa6589c293c2$var$xSmall = "2";
const $f551aa6589c293c2$var$small = "4";
const $f551aa6589c293c2$var$medium$1 = "8";
const $f551aa6589c293c2$var$large = "16";
const $f551aa6589c293c2$var$xl$2 = "24";
const $f551aa6589c293c2$var$xxl$2 = "32";
const $f551aa6589c293c2$var$pill = "25000";
const $f551aa6589c293c2$var$none = "0";
const $f551aa6589c293c2$var$custom_1$3 = "12";
const $f551aa6589c293c2$var$custom_2$3 = "48";
const $f551aa6589c293c2$var$custom_3$2 = "250";
const $f551aa6589c293c2$var$borderRadius = {
    xSmall: $f551aa6589c293c2$var$xSmall,
    small: $f551aa6589c293c2$var$small,
    medium: $f551aa6589c293c2$var$medium$1,
    large: $f551aa6589c293c2$var$large,
    xl: $f551aa6589c293c2$var$xl$2,
    xxl: $f551aa6589c293c2$var$xxl$2,
    pill: $f551aa6589c293c2$var$pill,
    none: $f551aa6589c293c2$var$none,
    custom_1: $f551aa6589c293c2$var$custom_1$3,
    custom_2: $f551aa6589c293c2$var$custom_2$3,
    custom_3: $f551aa6589c293c2$var$custom_3$2
};
const $f551aa6589c293c2$var$border_none = "0";
const $f551aa6589c293c2$var$border_thin = "1";
const $f551aa6589c293c2$var$border_normal = "2";
const $f551aa6589c293c2$var$border_thick = "3";
const $f551aa6589c293c2$var$border_focus = "4";
const $f551aa6589c293c2$var$borderWidth = {
    border_none: $f551aa6589c293c2$var$border_none,
    border_thin: $f551aa6589c293c2$var$border_thin,
    border_normal: $f551aa6589c293c2$var$border_normal,
    border_thick: $f551aa6589c293c2$var$border_thick,
    border_focus: $f551aa6589c293c2$var$border_focus
};
const $f551aa6589c293c2$var$primary20 = "{color.$mode.$primary.20}";
const $f551aa6589c293c2$var$primary30 = "{color.$mode.$primary.30}";
const $f551aa6589c293c2$var$primary40 = "{color.$mode.$primary.40}";
const $f551aa6589c293c2$var$primary50 = "{color.$mode.$primary.50}";
const $f551aa6589c293c2$var$primary60 = "{color.$mode.$primary.60}";
const $f551aa6589c293c2$var$primary70 = "{color.$mode.$primary.70}";
const $f551aa6589c293c2$var$primary80 = "{color.$mode.$primary.80}";
const $f551aa6589c293c2$var$primaryInverse = "{color.$mode.$primary.inverse}";
const $f551aa6589c293c2$var$primaryBackground = "{color.$mode.$primary.background}";
const $f551aa6589c293c2$var$primaryGrey100 = "{color.$mode.$primary.grey.100}";
const $f551aa6589c293c2$var$primaryGrey80 = "{color.$mode.$primary.grey.80}";
const $f551aa6589c293c2$var$primaryGrey60 = "{color.$mode.$primary.grey.60}";
const $f551aa6589c293c2$var$primaryGrey40 = "{color.$mode.$primary.grey.40}";
const $f551aa6589c293c2$var$primaryGrey20 = "{color.$mode.$primary.grey.20}";
const $f551aa6589c293c2$var$secondary20 = "{color.$mode.$secondary.20}";
const $f551aa6589c293c2$var$secondary30 = "{color.$mode.$secondary.30}";
const $f551aa6589c293c2$var$secondary40 = "{color.$mode.$secondary.40}";
const $f551aa6589c293c2$var$secondary50 = "{color.$mode.$secondary.50}";
const $f551aa6589c293c2$var$secondary60 = "{color.$mode.$secondary.60}";
const $f551aa6589c293c2$var$secondary70 = "{color.$mode.$secondary.70}";
const $f551aa6589c293c2$var$secondary80 = "{color.$mode.$secondary.80}";
const $f551aa6589c293c2$var$secondaryInverse = "{color.$mode.$secondary.inverse}";
const $f551aa6589c293c2$var$secondaryBackground = "{color.$mode.$secondary.background}";
const $f551aa6589c293c2$var$secondaryGrey100 = "{color.$mode.$secondary.grey.100}";
const $f551aa6589c293c2$var$secondaryGrey80 = "{color.$mode.$secondary.grey.80}";
const $f551aa6589c293c2$var$secondaryGrey60 = "{color.$mode.$secondary.grey.60}";
const $f551aa6589c293c2$var$secondaryGrey40 = "{color.$mode.$secondary.grey.40}";
const $f551aa6589c293c2$var$secondaryGrey20 = "{color.$mode.$secondary.grey.20}";
const $f551aa6589c293c2$var$sparkle20 = "{color.$mode.$sparkle.20}";
const $f551aa6589c293c2$var$sparkle30 = "{color.$mode.$sparkle.30}";
const $f551aa6589c293c2$var$sparkle40 = "{color.$mode.$sparkle.40}";
const $f551aa6589c293c2$var$sparkle50 = "{color.$mode.$sparkle.50}";
const $f551aa6589c293c2$var$sparkle60 = "{color.$mode.$sparkle.60}";
const $f551aa6589c293c2$var$sparkle70 = "{color.$mode.$sparkle.70}";
const $f551aa6589c293c2$var$sparkle80 = "{color.$mode.$sparkle.80}";
const $f551aa6589c293c2$var$sparkleInverse = "{color.$mode.$sparkle.inverse}";
const $f551aa6589c293c2$var$sparkleBackground = "{color.$mode.$sparkle.background}";
const $f551aa6589c293c2$var$sparkleGrey100 = "{color.$mode.$sparkle.grey.100}";
const $f551aa6589c293c2$var$sparkleGrey80 = "{color.$mode.$sparkle.grey.80}";
const $f551aa6589c293c2$var$sparkleGrey60 = "{color.$mode.$sparkle.grey.60}";
const $f551aa6589c293c2$var$sparkleGrey40 = "{color.$mode.$sparkle.grey.40}";
const $f551aa6589c293c2$var$sparkleGrey20 = "{color.$mode.$sparkle.grey.20}";
const $f551aa6589c293c2$var$feedbackError80 = "{color.$mode.feedback.error.80}";
const $f551aa6589c293c2$var$feedbackError70 = "{color.$mode.feedback.error.70}";
const $f551aa6589c293c2$var$feedbackError60 = "{color.$mode.feedback.error.60}";
const $f551aa6589c293c2$var$feedbackError50 = "{color.$mode.feedback.error.50}";
const $f551aa6589c293c2$var$feedbackError40 = "{color.$mode.feedback.error.40}";
const $f551aa6589c293c2$var$feedbackError30 = "{color.$mode.feedback.error.30}";
const $f551aa6589c293c2$var$feedbackError20 = "{color.$mode.feedback.error.20}";
const $f551aa6589c293c2$var$feedbackWarning80 = "{color.$mode.feedback.warning.80}";
const $f551aa6589c293c2$var$feedbackWarning70 = "{color.$mode.feedback.warning.70}";
const $f551aa6589c293c2$var$feedbackWarning60 = "{color.$mode.feedback.warning.60}";
const $f551aa6589c293c2$var$feedbackWarning50 = "{color.$mode.feedback.warning.50}";
const $f551aa6589c293c2$var$feedbackWarning40 = "{color.$mode.feedback.warning.40}";
const $f551aa6589c293c2$var$feedbackWarning30 = "{color.$mode.feedback.warning.30}";
const $f551aa6589c293c2$var$feedbackWarning20 = "{color.$mode.feedback.warning.20}";
const $f551aa6589c293c2$var$feedbackSuccess80 = "{color.$mode.feedback.success.80}";
const $f551aa6589c293c2$var$feedbackSuccess70 = "{color.$mode.feedback.success.70}";
const $f551aa6589c293c2$var$feedbackSuccess60 = "{color.$mode.feedback.success.60}";
const $f551aa6589c293c2$var$feedbackSuccess50 = "{color.$mode.feedback.success.50}";
const $f551aa6589c293c2$var$feedbackSuccess40 = "{color.$mode.feedback.success.40}";
const $f551aa6589c293c2$var$feedbackSuccess30 = "{color.$mode.feedback.success.30}";
const $f551aa6589c293c2$var$feedbackSuccess20 = "{color.$mode.feedback.success.20}";
const $f551aa6589c293c2$var$elevation1 = "{elevation1.$mode}";
const $f551aa6589c293c2$var$custom_color_1 = "";
const $f551aa6589c293c2$var$custom_color_2 = "#75757580";
const $f551aa6589c293c2$var$custom_color_3 = "#000000D9";
const $f551aa6589c293c2$var$custom_color_4 = "#75757580";
const $f551aa6589c293c2$var$custom_color_5 = "#00000029";
const $f551aa6589c293c2$var$custom_color_6 = "#14151775";
const $f551aa6589c293c2$var$custom_dark_primary_40 = "{color.dark.$primary.40}";
const $f551aa6589c293c2$var$custom_dark_primary_60 = "{color.dark.$primary.60}";
const $f551aa6589c293c2$var$custom_dark_primary_grey_80 = "{color.dark.$primary.grey.80}";
const $f551aa6589c293c2$var$custom_dark_primary_grey_100 = "{color.dark.$primary.grey.100}";
const $f551aa6589c293c2$var$color = {
    primary20: $f551aa6589c293c2$var$primary20,
    primary30: $f551aa6589c293c2$var$primary30,
    primary40: $f551aa6589c293c2$var$primary40,
    primary50: $f551aa6589c293c2$var$primary50,
    primary60: $f551aa6589c293c2$var$primary60,
    primary70: $f551aa6589c293c2$var$primary70,
    primary80: $f551aa6589c293c2$var$primary80,
    primaryInverse: $f551aa6589c293c2$var$primaryInverse,
    primaryBackground: $f551aa6589c293c2$var$primaryBackground,
    primaryGrey100: $f551aa6589c293c2$var$primaryGrey100,
    primaryGrey80: $f551aa6589c293c2$var$primaryGrey80,
    primaryGrey60: $f551aa6589c293c2$var$primaryGrey60,
    primaryGrey40: $f551aa6589c293c2$var$primaryGrey40,
    primaryGrey20: $f551aa6589c293c2$var$primaryGrey20,
    secondary20: $f551aa6589c293c2$var$secondary20,
    secondary30: $f551aa6589c293c2$var$secondary30,
    secondary40: $f551aa6589c293c2$var$secondary40,
    secondary50: $f551aa6589c293c2$var$secondary50,
    secondary60: $f551aa6589c293c2$var$secondary60,
    secondary70: $f551aa6589c293c2$var$secondary70,
    secondary80: $f551aa6589c293c2$var$secondary80,
    secondaryInverse: $f551aa6589c293c2$var$secondaryInverse,
    secondaryBackground: $f551aa6589c293c2$var$secondaryBackground,
    secondaryGrey100: $f551aa6589c293c2$var$secondaryGrey100,
    secondaryGrey80: $f551aa6589c293c2$var$secondaryGrey80,
    secondaryGrey60: $f551aa6589c293c2$var$secondaryGrey60,
    secondaryGrey40: $f551aa6589c293c2$var$secondaryGrey40,
    secondaryGrey20: $f551aa6589c293c2$var$secondaryGrey20,
    sparkle20: $f551aa6589c293c2$var$sparkle20,
    sparkle30: $f551aa6589c293c2$var$sparkle30,
    sparkle40: $f551aa6589c293c2$var$sparkle40,
    sparkle50: $f551aa6589c293c2$var$sparkle50,
    sparkle60: $f551aa6589c293c2$var$sparkle60,
    sparkle70: $f551aa6589c293c2$var$sparkle70,
    sparkle80: $f551aa6589c293c2$var$sparkle80,
    sparkleInverse: $f551aa6589c293c2$var$sparkleInverse,
    sparkleBackground: $f551aa6589c293c2$var$sparkleBackground,
    sparkleGrey100: $f551aa6589c293c2$var$sparkleGrey100,
    sparkleGrey80: $f551aa6589c293c2$var$sparkleGrey80,
    sparkleGrey60: $f551aa6589c293c2$var$sparkleGrey60,
    sparkleGrey40: $f551aa6589c293c2$var$sparkleGrey40,
    sparkleGrey20: $f551aa6589c293c2$var$sparkleGrey20,
    "global.white": "{color.$mode.white}",
    "global.black": "{color.$mode.black}",
    "global.transparent": "transparent",
    feedbackError80: $f551aa6589c293c2$var$feedbackError80,
    feedbackError70: $f551aa6589c293c2$var$feedbackError70,
    feedbackError60: $f551aa6589c293c2$var$feedbackError60,
    feedbackError50: $f551aa6589c293c2$var$feedbackError50,
    feedbackError40: $f551aa6589c293c2$var$feedbackError40,
    feedbackError30: $f551aa6589c293c2$var$feedbackError30,
    feedbackError20: $f551aa6589c293c2$var$feedbackError20,
    feedbackWarning80: $f551aa6589c293c2$var$feedbackWarning80,
    feedbackWarning70: $f551aa6589c293c2$var$feedbackWarning70,
    feedbackWarning60: $f551aa6589c293c2$var$feedbackWarning60,
    feedbackWarning50: $f551aa6589c293c2$var$feedbackWarning50,
    feedbackWarning40: $f551aa6589c293c2$var$feedbackWarning40,
    feedbackWarning30: $f551aa6589c293c2$var$feedbackWarning30,
    feedbackWarning20: $f551aa6589c293c2$var$feedbackWarning20,
    feedbackSuccess80: $f551aa6589c293c2$var$feedbackSuccess80,
    feedbackSuccess70: $f551aa6589c293c2$var$feedbackSuccess70,
    feedbackSuccess60: $f551aa6589c293c2$var$feedbackSuccess60,
    feedbackSuccess50: $f551aa6589c293c2$var$feedbackSuccess50,
    feedbackSuccess40: $f551aa6589c293c2$var$feedbackSuccess40,
    feedbackSuccess30: $f551aa6589c293c2$var$feedbackSuccess30,
    feedbackSuccess20: $f551aa6589c293c2$var$feedbackSuccess20,
    "color.bold.crimson_midnight.20": "#f98ba133",
    "color.bold.crimson_midnight.30": "#f98ba166",
    "color.bold.crimson_midnight.40": "#f98ba199",
    "color.bold.crimson_midnight.50": "#f98ba1ff",
    "color.bold.crimson_midnight.60": "#fbb7c0ff",
    "color.bold.crimson_midnight.70": "#fdd2d8ff",
    "color.bold.crimson_midnight.80": "#feecefff",
    "color.bold.crimson_midnight.inverse": "#38000cff",
    "color.bold.crimson_midnight.background": "#700017ff",
    "color.bold.crimson_midnight.grey.100": "#ffffffff",
    "color.bold.crimson_midnight.grey.80": "#ffffffc7",
    "color.bold.crimson_midnight.grey.60": "#ffffff87",
    "color.bold.crimson_midnight.grey.40": "#ffffff4f",
    "color.bold.crimson_midnight.grey.20": "#ffffff1f",
    "color.dark.crimson_midnight.20": "#3a0611ff",
    "color.dark.crimson_midnight.30": "#600a1cff",
    "color.dark.crimson_midnight.40": "#870f28ff",
    "color.dark.crimson_midnight.50": "#c11539ff",
    "color.dark.crimson_midnight.60": "#d45b74ff",
    "color.dark.crimson_midnight.70": "#e396a6ff",
    "color.dark.crimson_midnight.80": "#f3d0d7ff",
    "color.dark.crimson_midnight.inverse": "#ffffffff",
    "color.dark.crimson_midnight.background": "#141414ff",
    "color.dark.crimson_midnight.grey.100": "#ffffffff",
    "color.dark.crimson_midnight.grey.80": "#ffffffc7",
    "color.dark.crimson_midnight.grey.60": "#a1a1a1ff",
    "color.dark.crimson_midnight.grey.40": "#5a5a5aff",
    "color.dark.crimson_midnight.grey.20": "#2b2b2bff",
    "color.light.crimson_midnight.20": "#f7e5e9ff",
    "color.light.crimson_midnight.30": "#f98ba1ff",
    "color.light.crimson_midnight.40": "#aa0023ff",
    "color.light.crimson_midnight.50": "#700017ff",
    "color.light.crimson_midnight.60": "#4e0010ff",
    "color.light.crimson_midnight.70": "#38000cff",
    "color.light.crimson_midnight.80": "#220007ff",
    "color.light.crimson_midnight.inverse": "#ffffffff",
    "color.light.crimson_midnight.background": "#ffffffff",
    "color.light.crimson_midnight.grey.100": "#141414ff",
    "color.light.crimson_midnight.grey.80": "#000000a6",
    "color.light.crimson_midnight.grey.60": "#b5b5b5ff",
    "color.light.crimson_midnight.grey.40": "#e0e0e0ff",
    "color.light.crimson_midnight.grey.20": "#f5f5f5ff",
    "color.bold.crimson.20": "#f98ba133",
    "color.bold.crimson.30": "#f98ba166",
    "color.bold.crimson.40": "#f98ba199",
    "color.bold.crimson.50": "#f98ba1ff",
    "color.bold.crimson.60": "#fbc0cbff",
    "color.bold.crimson.70": "#fddae1ff",
    "color.bold.crimson.80": "#feedf0ff",
    "color.bold.crimson.inverse": "#4d0010ff",
    "color.bold.crimson.background": "#aa0023ff",
    "color.bold.crimson.grey.100": "#ffffffff",
    "color.bold.crimson.grey.80": "#ffffffc7",
    "color.bold.crimson.grey.60": "#ffffff87",
    "color.bold.crimson.grey.40": "#ffffff4f",
    "color.bold.crimson.grey.20": "#ffffff1f",
    "color.dark.crimson.20": "#3a0611ff",
    "color.dark.crimson.30": "#600a1cff",
    "color.dark.crimson.40": "#870f28ff",
    "color.dark.crimson.50": "#c11539ff",
    "color.dark.crimson.60": "#d45b74ff",
    "color.dark.crimson.70": "#e396a6ff",
    "color.dark.crimson.80": "#f3d0d7ff",
    "color.dark.crimson.inverse": "#ffffffff",
    "color.dark.crimson.background": "#141414ff",
    "color.dark.crimson.grey.100": "#ffffffff",
    "color.dark.crimson.grey.80": "#ffffffc7",
    "color.dark.crimson.grey.60": "#a1a1a1ff",
    "color.dark.crimson.grey.40": "#5a5a5aff",
    "color.dark.crimson.grey.20": "#2b2b2bff",
    "color.light.crimson.20": "#f7e5e9ff",
    "color.light.crimson.30": "#f98ba1ff",
    "color.light.crimson.40": "#ed617fff",
    "color.light.crimson.50": "#aa0023ff",
    "color.light.crimson.60": "#700017ff",
    "color.light.crimson.70": "#4d0010ff",
    "color.light.crimson.80": "#2a0009ff",
    "color.light.crimson.inverse": "#ffffffff",
    "color.light.crimson.background": "#ffffffff",
    "color.light.crimson.grey.100": "#141414ff",
    "color.light.crimson.grey.80": "#000000a6",
    "color.light.crimson.grey.60": "#b5b5b5ff",
    "color.light.crimson.grey.40": "#e0e0e0ff",
    "color.light.crimson.grey.20": "#f5f5f5ff",
    "color.bold.green_midnight.20": "#94f6c533",
    "color.bold.green_midnight.30": "#94f6c566",
    "color.bold.green_midnight.40": "#94f6c599",
    "color.bold.green_midnight.50": "#94f6c5ff",
    "color.bold.green_midnight.60": "#c5fadfff",
    "color.bold.green_midnight.70": "#dcfcebff",
    "color.bold.green_midnight.80": "#f3fef8ff",
    "color.bold.green_midnight.inverse": "#013a1eff",
    "color.bold.green_midnight.background": "#03753cff",
    "color.bold.green_midnight.grey.100": "#ffffffff",
    "color.bold.green_midnight.grey.80": "#ffffffd4",
    "color.bold.green_midnight.grey.60": "#ffffff87",
    "color.bold.green_midnight.grey.40": "#ffffff4f",
    "color.bold.green_midnight.grey.20": "#ffffff1f",
    "color.dark.green_midnight.20": "#06371fff",
    "color.dark.green_midnight.30": "#0a5c33ff",
    "color.dark.green_midnight.40": "#0e8147ff",
    "color.dark.green_midnight.50": "#14b866ff",
    "color.dark.green_midnight.60": "#5acd94ff",
    "color.dark.green_midnight.70": "#95dfbaff",
    "color.dark.green_midnight.80": "#d0f1e0ff",
    "color.dark.green_midnight.inverse": "#06371fff",
    "color.dark.green_midnight.background": "#141414ff",
    "color.dark.green_midnight.grey.100": "#ffffffff",
    "color.dark.green_midnight.grey.80": "#ffffffc7",
    "color.dark.green_midnight.grey.60": "#a1a1a1ff",
    "color.dark.green_midnight.grey.40": "#5a5a5aff",
    "color.dark.green_midnight.grey.20": "#2b2b2bff",
    "color.light.green_midnight.20": "#e5f7eeff",
    "color.light.green_midnight.30": "#94f6c5ff",
    "color.light.green_midnight.40": "#00b259ff",
    "color.light.green_midnight.50": "#03753cff",
    "color.light.green_midnight.60": "#02522aff",
    "color.light.green_midnight.70": "#013a1eff",
    "color.light.green_midnight.80": "#012312ff",
    "color.light.green_midnight.inverse": "#ffffffff",
    "color.light.green_midnight.background": "#ffffffff",
    "color.light.green_midnight.grey.100": "#141414ff",
    "color.light.green_midnight.grey.80": "#000000a6",
    "color.light.green_midnight.grey.60": "#b5b5b5ff",
    "color.light.green_midnight.grey.40": "#e0e0e0ff",
    "color.light.green_midnight.grey.20": "#f5f5f5ff",
    "color.bold.green.20": "#00502833",
    "color.bold.green.30": "#00502866",
    "color.bold.green.40": "#00502899",
    "color.bold.green.50": "#005028ff",
    "color.bold.green.60": "#003b1dff",
    "color.bold.green.70": "#002613ff",
    "color.bold.green.80": "#00170cff",
    "color.bold.green.inverse": "#e5f7eeff",
    "color.bold.green.background": "#00b259ff",
    "color.bold.green.grey.100": "#002d16ff",
    "color.bold.green.grey.80": "#002d16e3",
    "color.bold.green.grey.60": "#002d1687",
    "color.bold.green.grey.40": "#002d164d",
    "color.bold.green.grey.20": "#002d161f",
    "color.dark.green.20": "#06371fff",
    "color.dark.green.30": "#0a5c33ff",
    "color.dark.green.40": "#0e8147ff",
    "color.dark.green.50": "#14b866ff",
    "color.dark.green.60": "#5acd94ff",
    "color.dark.green.70": "#95dfbaff",
    "color.dark.green.80": "#d0f1e0ff",
    "color.dark.green.inverse": "#06371fff",
    "color.dark.green.background": "#141414ff",
    "color.dark.green.grey.100": "#ffffffff",
    "color.dark.green.grey.80": "#ffffffc7",
    "color.dark.green.grey.60": "#a1a1a1ff",
    "color.dark.green.grey.40": "#5a5a5aff",
    "color.dark.green.grey.20": "#2b2b2bff",
    "color.light.green.20": "#e5f7eeff",
    "color.light.green.30": "#94f6c5ff",
    "color.light.green.40": "#10d974ff",
    "color.light.green.50": "#00b259ff",
    "color.light.green.60": "#03753cff",
    "color.light.green.70": "#005028ff",
    "color.light.green.80": "#002d16ff",
    "color.light.green.inverse": "#002d16ff",
    "color.light.green.background": "#ffffffff",
    "color.light.green.grey.100": "#141414ff",
    "color.light.green.grey.80": "#000000a6",
    "color.light.green.grey.60": "#b5b5b5ff",
    "color.light.green.grey.40": "#e0e0e0ff",
    "color.light.green.grey.20": "#f5f5f5ff",
    "color.bold.marigold_midnight.20": "#ffe3ae33",
    "color.bold.marigold_midnight.30": "#ffe3ae66",
    "color.bold.marigold_midnight.40": "#ffe3ae99",
    "color.bold.marigold_midnight.50": "#ffe3aeff",
    "color.bold.marigold_midnight.60": "#ffffffff",
    "color.bold.marigold_midnight.70": "#ffffffff",
    "color.bold.marigold_midnight.80": "#ffffffff",
    "color.bold.marigold_midnight.inverse": "#401d0cff",
    "color.bold.marigold_midnight.background": "#ac660cff",
    "color.bold.marigold_midnight.grey.100": "#ffffffff",
    "color.bold.marigold_midnight.grey.80": "#ffffffff",
    "color.bold.marigold_midnight.grey.60": "#ffffff87",
    "color.bold.marigold_midnight.grey.40": "#ffffff4f",
    "color.bold.marigold_midnight.grey.20": "#ffffff1f",
    "color.dark.marigold_midnight.20": "#3c2e16ff",
    "color.dark.marigold_midnight.30": "#675228ff",
    "color.dark.marigold_midnight.40": "#8d713aff",
    "color.dark.marigold_midnight.50": "#f9be53ff",
    "color.dark.marigold_midnight.60": "#fbd187ff",
    "color.dark.marigold_midnight.70": "#fce2b2ff",
    "color.dark.marigold_midnight.80": "#fef2ddff",
    "color.dark.marigold_midnight.inverse": "#3c2e16ff",
    "color.dark.marigold_midnight.background": "#141414ff",
    "color.dark.marigold_midnight.grey.100": "#ffffffff",
    "color.dark.marigold_midnight.grey.80": "#ffffffc7",
    "color.dark.marigold_midnight.grey.60": "#a1a1a1ff",
    "color.dark.marigold_midnight.grey.40": "#5a5a5aff",
    "color.dark.marigold_midnight.grey.20": "#2b2b2bff",
    "color.light.marigold_midnight.20": "#fef7e9ff",
    "color.light.marigold_midnight.30": "#ffe3aeff",
    "color.light.marigold_midnight.40": "#ffd947ff",
    "color.light.marigold_midnight.50": "#ac660cff",
    "color.light.marigold_midnight.60": "#7f4b10ff",
    "color.light.marigold_midnight.70": "#401d0cff",
    "color.light.marigold_midnight.80": "#341709ff",
    "color.light.marigold_midnight.inverse": "#ffffffff",
    "color.light.marigold_midnight.background": "#ffffffff",
    "color.light.marigold_midnight.grey.100": "#141414ff",
    "color.light.marigold_midnight.grey.80": "#000000a6",
    "color.light.marigold_midnight.grey.60": "#b5b5b5ff",
    "color.light.marigold_midnight.grey.40": "#e0e0e0ff",
    "color.light.marigold_midnight.grey.20": "#f5f5f5ff",
    "color.bold.marigold.20": "#92551b33",
    "color.bold.marigold.30": "#92551b66",
    "color.bold.marigold.40": "#92551b99",
    "color.bold.marigold.50": "#8a3200ff",
    "color.bold.marigold.60": "#5e2200ff",
    "color.bold.marigold.70": "#3d1600ff",
    "color.bold.marigold.80": "#2e1100ff",
    "color.bold.marigold.inverse": "#fef7e9ff",
    "color.bold.marigold.background": "#f7ab20ff",
    "color.bold.marigold.grey.100": "#401d0cff",
    "color.bold.marigold.grey.80": "#401d0cc7",
    "color.bold.marigold.grey.60": "#401d0c87",
    "color.bold.marigold.grey.40": "#401d0c4d",
    "color.bold.marigold.grey.20": "#401d0c1f",
    "color.dark.marigold.20": "#3c2e16ff",
    "color.dark.marigold.30": "#675228ff",
    "color.dark.marigold.40": "#8d713aff",
    "color.dark.marigold.50": "#f9be53ff",
    "color.dark.marigold.60": "#fbd187ff",
    "color.dark.marigold.70": "#fce2b2ff",
    "color.dark.marigold.80": "#fef2ddff",
    "color.dark.marigold.inverse": "#3c2e16ff",
    "color.dark.marigold.background": "#141414ff",
    "color.dark.marigold.grey.100": "#ffffffff",
    "color.dark.marigold.grey.80": "#ffffffc7",
    "color.dark.marigold.grey.60": "#a1a1a1ff",
    "color.dark.marigold.grey.40": "#5a5a5aff",
    "color.dark.marigold.grey.20": "#2b2b2bff",
    "color.light.marigold.20": "#fef7e9ff",
    "color.light.marigold.30": "#ffe3aeff",
    "color.light.marigold.40": "#ffd947ff",
    "color.light.marigold.50": "#f7ab20ff",
    "color.light.marigold.60": "#ac660cff",
    "color.light.marigold.70": "#7f4b10ff",
    "color.light.marigold.80": "#401d0cff",
    "color.light.marigold.inverse": "#401d0cff",
    "color.light.marigold.background": "#ffffffff",
    "color.light.marigold.grey.100": "#141414ff",
    "color.light.marigold.grey.80": "#000000a6",
    "color.light.marigold.grey.60": "#b5b5b5ff",
    "color.light.marigold.grey.40": "#e0e0e0ff",
    "color.light.marigold.grey.20": "#f5f5f5ff",
    "color.bold.mint_midnight.20": "#a7f6e933",
    "color.bold.mint_midnight.30": "#a7f6e966",
    "color.bold.mint_midnight.40": "#a7f6e999",
    "color.bold.mint_midnight.50": "#a7f6e9ff",
    "color.bold.mint_midnight.60": "#c9f9f1ff",
    "color.bold.mint_midnight.70": "#e0fcf7ff",
    "color.bold.mint_midnight.80": "#f3fefcff",
    "color.bold.mint_midnight.inverse": "#0f3e3aff",
    "color.bold.mint_midnight.background": "#1e7b74ff",
    "color.bold.mint_midnight.grey.100": "#ffffffff",
    "color.bold.mint_midnight.grey.80": "#ffffffe8",
    "color.bold.mint_midnight.grey.60": "#ffffff87",
    "color.bold.mint_midnight.grey.40": "#ffffff4f",
    "color.bold.mint_midnight.grey.20": "#ffffff1f",
    "color.dark.mint_midnight.20": "#1a413bff",
    "color.dark.mint_midnight.30": "#245a51ff",
    "color.dark.mint_midnight.40": "#348376ff",
    "color.dark.mint_midnight.50": "#58dac5ff",
    "color.dark.mint_midnight.60": "#8ae5d6ff",
    "color.dark.mint_midnight.70": "#b4eee5ff",
    "color.dark.mint_midnight.80": "#def8f3ff",
    "color.dark.mint_midnight.inverse": "#1a413bff",
    "color.dark.mint_midnight.background": "#141414ff",
    "color.dark.mint_midnight.grey.100": "#ffffffff",
    "color.dark.mint_midnight.grey.80": "#ffffffc7",
    "color.dark.mint_midnight.grey.60": "#a1a1a1ff",
    "color.dark.mint_midnight.grey.40": "#5a5a5aff",
    "color.dark.mint_midnight.grey.20": "#2b2b2bff",
    "color.light.mint_midnight.20": "#e8faf7ff",
    "color.light.mint_midnight.30": "#a7f6e9ff",
    "color.light.mint_midnight.40": "#1eccb0ff",
    "color.light.mint_midnight.50": "#1e7b74ff",
    "color.light.mint_midnight.60": "#155651ff",
    "color.light.mint_midnight.70": "#0f3e3aff",
    "color.light.mint_midnight.80": "#092523ff",
    "color.light.mint_midnight.inverse": "#ffffffff",
    "color.light.mint_midnight.background": "#ffffffff",
    "color.light.mint_midnight.grey.100": "#141414ff",
    "color.light.mint_midnight.grey.80": "#000000a6",
    "color.light.mint_midnight.grey.60": "#b5b5b5ff",
    "color.light.mint_midnight.grey.40": "#e0e0e0ff",
    "color.light.mint_midnight.grey.20": "#f5f5f5ff",
    "color.bold.mint.20": "#0e5c4f33",
    "color.bold.mint.30": "#0e5c4f66",
    "color.bold.mint.40": "#0e5c4f99",
    "color.bold.mint.50": "#0e5c4fff",
    "color.bold.mint.60": "#0a493fff",
    "color.bold.mint.70": "#07362eff",
    "color.bold.mint.80": "#052923ff",
    "color.bold.mint.inverse": "#e8faf7ff",
    "color.bold.mint.background": "#1eccb0ff",
    "color.bold.mint.grey.100": "#08332cff",
    "color.bold.mint.grey.80": "#08332ccf",
    "color.bold.mint.grey.60": "#08332c87",
    "color.bold.mint.grey.40": "#08332c4d",
    "color.bold.mint.grey.20": "#08332c1f",
    "color.dark.mint.20": "#1a413bff",
    "color.dark.mint.30": "#245a51ff",
    "color.dark.mint.40": "#348376ff",
    "color.dark.mint.50": "#58dac5ff",
    "color.dark.mint.60": "#8ae5d6ff",
    "color.dark.mint.70": "#b4eee5ff",
    "color.dark.mint.80": "#def8f3ff",
    "color.dark.mint.inverse": "#1a413bff",
    "color.dark.mint.background": "#141414ff",
    "color.dark.mint.grey.100": "#ffffffff",
    "color.dark.mint.grey.80": "#ffffffc7",
    "color.dark.mint.grey.60": "#a1a1a1ff",
    "color.dark.mint.grey.40": "#5a5a5aff",
    "color.dark.mint.grey.20": "#2b2b2bff",
    "color.light.mint.20": "#e8faf7ff",
    "color.light.mint.30": "#a7f6e9ff",
    "color.light.mint.40": "#7aebd9ff",
    "color.light.mint.50": "#1eccb0ff",
    "color.light.mint.60": "#1e7b74ff",
    "color.light.mint.70": "#0e5c4fff",
    "color.light.mint.80": "#08332cff",
    "color.light.mint.inverse": "#08332cff",
    "color.light.mint.background": "#ffffffff",
    "color.light.mint.grey.100": "#141414ff",
    "color.light.mint.grey.80": "#000000a6",
    "color.light.mint.grey.60": "#b5b5b5ff",
    "color.light.mint.grey.40": "#e0e0e0ff",
    "color.light.mint.grey.20": "#f5f5f5ff",
    "color.bold.navi_midnight.20": "#9999ff33",
    "color.bold.navi_midnight.30": "#9999ff66",
    "color.bold.navi_midnight.40": "#9999ff99",
    "color.bold.navi_midnight.50": "#9999ffff",
    "color.bold.navi_midnight.60": "#b9b9ffff",
    "color.bold.navi_midnight.70": "#ddddffff",
    "color.bold.navi_midnight.80": "#ffffffff",
    "color.bold.navi_midnight.inverse": "#00004aff",
    "color.bold.navi_midnight.background": "#000093ff",
    "color.bold.navi_midnight.grey.100": "#ffffffff",
    "color.bold.navi_midnight.grey.80": "#ffffffc7",
    "color.bold.navi_midnight.grey.60": "#ffffff87",
    "color.bold.navi_midnight.grey.40": "#ffffff4f",
    "color.bold.navi_midnight.grey.20": "#ffffff1f",
    "color.dark.navi_midnight.20": "#16164bff",
    "color.dark.navi_midnight.30": "#24247dff",
    "color.dark.navi_midnight.40": "#3232aeff",
    "color.dark.navi_midnight.50": "#4848f9ff",
    "color.dark.navi_midnight.60": "#7f7ffbff",
    "color.dark.navi_midnight.70": "#adadfcff",
    "color.dark.navi_midnight.80": "#dadafeff",
    "color.dark.navi_midnight.inverse": "#ffffffff",
    "color.dark.navi_midnight.background": "#141414ff",
    "color.dark.navi_midnight.grey.100": "#ffffffff",
    "color.dark.navi_midnight.grey.80": "#ffffffc7",
    "color.dark.navi_midnight.grey.60": "#a1a1a1ff",
    "color.dark.navi_midnight.grey.40": "#5a5a5aff",
    "color.dark.navi_midnight.grey.20": "#2b2b2bff",
    "color.light.navi_midnight.20": "#e8e8fcff",
    "color.light.navi_midnight.30": "#9999ffff",
    "color.light.navi_midnight.40": "#3535f3ff",
    "color.light.navi_midnight.50": "#000093ff",
    "color.light.navi_midnight.60": "#000067ff",
    "color.light.navi_midnight.70": "#00004aff",
    "color.light.navi_midnight.80": "#00002cff",
    "color.light.navi_midnight.inverse": "#ffffffff",
    "color.light.navi_midnight.background": "#ffffffff",
    "color.light.navi_midnight.grey.100": "#141414ff",
    "color.light.navi_midnight.grey.80": "#000000a6",
    "color.light.navi_midnight.grey.60": "#b5b5b5ff",
    "color.light.navi_midnight.grey.40": "#e0e0e0ff",
    "color.light.navi_midnight.grey.20": "#f5f5f5ff",
    "color.bold.navi.20": "#9999ff33",
    "color.bold.navi.30": "#9999ff66",
    "color.bold.navi.40": "#9999ff99",
    "color.bold.navi.50": "#9999ffff",
    "color.bold.navi.60": "#ceceffff",
    "color.bold.navi.70": "#ddddffff",
    "color.bold.navi.80": "#fafaffff",
    "color.bold.navi.inverse": "#00004cff",
    "color.bold.navi.background": "#3535f3ff",
    "color.bold.navi.grey.100": "#ffffffff",
    "color.bold.navi.grey.80": "#ffffffc7",
    "color.bold.navi.grey.60": "#ffffff87",
    "color.bold.navi.grey.40": "#ffffff4f",
    "color.bold.navi.grey.20": "#ffffff1f",
    "color.dark.navi.20": "#16164bff",
    "color.dark.navi.30": "#24247dff",
    "color.dark.navi.40": "#3232aeff",
    "color.dark.navi.50": "#4848f9ff",
    "color.dark.navi.60": "#7f7ffbff",
    "color.dark.navi.70": "#adadfcff",
    "color.dark.navi.80": "#dadafeff",
    "color.dark.navi.inverse": "#ffffffff",
    "color.dark.navi.background": "#141414ff",
    "color.dark.navi.grey.100": "#ffffffff",
    "color.dark.navi.grey.80": "#ffffffc7",
    "color.dark.navi.grey.60": "#a1a1a1ff",
    "color.dark.navi.grey.40": "#5a5a5aff",
    "color.dark.navi.grey.20": "#2b2b2bff",
    "color.light.navi.20": "#e8e8fcff",
    "color.light.navi.30": "#9999ffff",
    "color.light.navi.40": "#6464ffff",
    "color.light.navi.50": "#3535f3ff",
    "color.light.navi.60": "#000093ff",
    "color.light.navi.70": "#00004cff",
    "color.light.navi.80": "#010029ff",
    "color.light.navi.inverse": "#ffffffff",
    "color.light.navi.background": "#ffffffff",
    "color.light.navi.grey.100": "#141414ff",
    "color.light.navi.grey.80": "#000000a6",
    "color.light.navi.grey.60": "#b5b5b5ff",
    "color.light.navi.grey.40": "#e0e0e0ff",
    "color.light.navi.grey.20": "#f5f5f5ff",
    "color.bold.orange_midnight.20": "#ffd2ad33",
    "color.bold.orange_midnight.30": "#ffd2ad66",
    "color.bold.orange_midnight.40": "#ffd2ad99",
    "color.bold.orange_midnight.50": "#ffd2adff",
    "color.bold.orange_midnight.60": "#ffead9ff",
    "color.bold.orange_midnight.70": "#fff5eeff",
    "color.bold.orange_midnight.80": "#ffffffff",
    "color.bold.orange_midnight.inverse": "#661f00ff",
    "color.bold.orange_midnight.background": "#cd3d00ff",
    "color.bold.orange_midnight.grey.100": "#ffffffff",
    "color.bold.orange_midnight.grey.80": "#fffffffc",
    "color.bold.orange_midnight.grey.60": "#ffffff87",
    "color.bold.orange_midnight.grey.40": "#ffffff4f",
    "color.bold.orange_midnight.grey.20": "#ffffff1f",
    "color.dark.orange_midnight.20": "#492b13ff",
    "color.dark.orange_midnight.30": "#7a471fff",
    "color.dark.orange_midnight.40": "#ab642bff",
    "color.dark.orange_midnight.50": "#f48f3eff",
    "color.dark.orange_midnight.60": "#f7b178ff",
    "color.dark.orange_midnight.70": "#facda8ff",
    "color.dark.orange_midnight.80": "#fde9d8ff",
    "color.dark.orange_midnight.inverse": "#492b13ff",
    "color.dark.orange_midnight.background": "#141414ff",
    "color.dark.orange_midnight.grey.100": "#ffffffff",
    "color.dark.orange_midnight.grey.80": "#ffffffc7",
    "color.dark.orange_midnight.grey.60": "#a1a1a1ff",
    "color.dark.orange_midnight.grey.40": "#5a5a5aff",
    "color.dark.orange_midnight.grey.20": "#2b2b2bff",
    "color.light.orange_midnight.20": "#fef2e9ff",
    "color.light.orange_midnight.30": "#ffd2adff",
    "color.light.orange_midnight.40": "#fa7d19ff",
    "color.light.orange_midnight.50": "#cd3d00ff",
    "color.light.orange_midnight.60": "#902b00ff",
    "color.light.orange_midnight.70": "#661f00ff",
    "color.light.orange_midnight.80": "#3d1200ff",
    "color.light.orange_midnight.inverse": "#ffffffff",
    "color.light.orange_midnight.background": "#ffffffff",
    "color.light.orange_midnight.grey.100": "#141414ff",
    "color.light.orange_midnight.grey.80": "#000000a6",
    "color.light.orange_midnight.grey.60": "#b5b5b5ff",
    "color.light.orange_midnight.grey.40": "#e0e0e0ff",
    "color.light.orange_midnight.grey.20": "#f5f5f5ff",
    "color.bold.orange.20": "#7b160433",
    "color.bold.orange.30": "#7b160466",
    "color.bold.orange.40": "#7b160499",
    "color.bold.orange.50": "#7b1604ff",
    "color.bold.orange.60": "#5c1700ff",
    "color.bold.orange.70": "#3d0f00ff",
    "color.bold.orange.80": "#2e0b00ff",
    "color.bold.orange.inverse": "#fef2e9ff",
    "color.bold.orange.background": "#fa7d19ff",
    "color.bold.orange.grey.100": "#46070bff",
    "color.bold.orange.grey.80": "#46070bcf",
    "color.bold.orange.grey.60": "#46070b87",
    "color.bold.orange.grey.40": "#46070b4f",
    "color.bold.orange.grey.20": "#46070b33",
    "color.dark.orange.20": "#492b13ff",
    "color.dark.orange.30": "#7a471fff",
    "color.dark.orange.40": "#ab642bff",
    "color.dark.orange.50": "#f48f3eff",
    "color.dark.orange.60": "#f7b178ff",
    "color.dark.orange.70": "#facda8ff",
    "color.dark.orange.80": "#fde9d8ff",
    "color.dark.orange.inverse": "#492b13ff",
    "color.dark.orange.background": "#141414ff",
    "color.dark.orange.grey.100": "#ffffffff",
    "color.dark.orange.grey.80": "#ffffffc7",
    "color.dark.orange.grey.60": "#a1a1a1ff",
    "color.dark.orange.grey.40": "#5a5a5aff",
    "color.dark.orange.grey.20": "#2b2b2bff",
    "color.light.orange.20": "#fef2e9ff",
    "color.light.orange.30": "#ffd2adff",
    "color.light.orange.40": "#ffaa66ff",
    "color.light.orange.50": "#fa7d19ff",
    "color.light.orange.60": "#cd3d00ff",
    "color.light.orange.70": "#7b1604ff",
    "color.light.orange.80": "#46070bff",
    "color.light.orange.inverse": "#46070bff",
    "color.light.orange.background": "#ffffffff",
    "color.light.orange.grey.100": "#141414ff",
    "color.light.orange.grey.80": "#000000a6",
    "color.light.orange.grey.60": "#b5b5b5ff",
    "color.light.orange.grey.40": "#e0e0e0ff",
    "color.light.orange.grey.20": "#f5f5f5ff",
    "color.bold.pink_midnight.20": "#ff99db33",
    "color.bold.pink_midnight.30": "#ff99db66",
    "color.bold.pink_midnight.40": "#ff99db99",
    "color.bold.pink_midnight.50": "#ff99dbff",
    "color.bold.pink_midnight.60": "#ffbfe9ff",
    "color.bold.pink_midnight.70": "#ffeaf8ff",
    "color.bold.pink_midnight.80": "#fff6fcff",
    "color.bold.pink_midnight.inverse": "#47002fff",
    "color.bold.pink_midnight.background": "#8f005dff",
    "color.bold.pink_midnight.grey.100": "#ffffffff",
    "color.bold.pink_midnight.grey.80": "#ffffffc7",
    "color.bold.pink_midnight.grey.60": "#ffffff87",
    "color.bold.pink_midnight.grey.40": "#ffffff4f",
    "color.bold.pink_midnight.grey.20": "#ffffff1f",
    "color.dark.pink_midnight.20": "#360023ff",
    "color.dark.pink_midnight.30": "#62003fff",
    "color.dark.pink_midnight.40": "#8f005dff",
    "color.dark.pink_midnight.50": "#d9008dff",
    "color.dark.pink_midnight.60": "#ff6dccff",
    "color.dark.pink_midnight.70": "#ff99dbff",
    "color.dark.pink_midnight.80": "#fbe5f4ff",
    "color.dark.pink_midnight.inverse": "#ffffffff",
    "color.dark.pink_midnight.background": "#141414ff",
    "color.dark.pink_midnight.grey.100": "#ffffffff",
    "color.dark.pink_midnight.grey.80": "#ffffffc7",
    "color.dark.pink_midnight.grey.60": "#a1a1a1ff",
    "color.dark.pink_midnight.grey.40": "#5a5a5aff",
    "color.dark.pink_midnight.grey.20": "#2b2b2bff",
    "color.light.pink_midnight.20": "#fbe5f4ff",
    "color.light.pink_midnight.30": "#ff99dbff",
    "color.light.pink_midnight.40": "#d9008dff",
    "color.light.pink_midnight.50": "#8f005dff",
    "color.light.pink_midnight.60": "#640041ff",
    "color.light.pink_midnight.70": "#47002fff",
    "color.light.pink_midnight.80": "#2b001cff",
    "color.light.pink_midnight.inverse": "#ffffffff",
    "color.light.pink_midnight.background": "#ffffffff",
    "color.light.pink_midnight.grey.100": "#141414ff",
    "color.light.pink_midnight.grey.80": "#000000a6",
    "color.light.pink_midnight.grey.60": "#b5b5b5ff",
    "color.light.pink_midnight.grey.40": "#e0e0e0ff",
    "color.light.pink_midnight.grey.20": "#f5f5f5ff",
    "color.bold.pink.20": "#ff99db33",
    "color.bold.pink.30": "#ff99db66",
    "color.bold.pink.40": "#ff99db99",
    "color.bold.pink.50": "#ff99dbff",
    "color.bold.pink.60": "#fff7fcff",
    "color.bold.pink.70": "#ffffffff",
    "color.bold.pink.80": "#ffffffff",
    "color.bold.pink.inverse": "#62003fff",
    "color.bold.pink.background": "#d9008dff",
    "color.bold.pink.grey.100": "#ffffffff",
    "color.bold.pink.grey.80": "#fffffff5",
    "color.bold.pink.grey.60": "#ffffff87",
    "color.bold.pink.grey.40": "#ffffff4f",
    "color.bold.pink.grey.20": "#ffffff1f",
    "color.dark.pink.20": "#360023ff",
    "color.dark.pink.30": "#62003fff",
    "color.dark.pink.40": "#8f005dff",
    "color.dark.pink.50": "#d9008dff",
    "color.dark.pink.60": "#ff6dccff",
    "color.dark.pink.70": "#ff99dbff",
    "color.dark.pink.80": "#fbe5f4ff",
    "color.dark.pink.inverse": "#ffffffff",
    "color.dark.pink.background": "#141414ff",
    "color.dark.pink.grey.100": "#ffffffff",
    "color.dark.pink.grey.80": "#ffffffc7",
    "color.dark.pink.grey.60": "#a1a1a1ff",
    "color.dark.pink.grey.40": "#5a5a5aff",
    "color.dark.pink.grey.20": "#2b2b2bff",
    "color.light.pink.20": "#fbe5f4ff",
    "color.light.pink.30": "#ff99dbff",
    "color.light.pink.40": "#ff6dccff",
    "color.light.pink.50": "#d9008dff",
    "color.light.pink.60": "#8f005dff",
    "color.light.pink.70": "#62003fff",
    "color.light.pink.80": "#360023ff",
    "color.light.pink.inverse": "#ffffffff",
    "color.light.pink.background": "#ffffffff",
    "color.light.pink.grey.100": "#141414ff",
    "color.light.pink.grey.80": "#000000a6",
    "color.light.pink.grey.60": "#b5b5b5ff",
    "color.light.pink.grey.40": "#e0e0e0ff",
    "color.light.pink.grey.20": "#f5f5f5ff",
    "color.bold.purple_midnight.20": "#cba2fa33",
    "color.bold.purple_midnight.30": "#cba2fa66",
    "color.bold.purple_midnight.40": "#cba2fa99",
    "color.bold.purple_midnight.50": "#cba2faff",
    "color.bold.purple_midnight.60": "#e4cffcff",
    "color.bold.purple_midnight.70": "#eee1fdff",
    "color.bold.purple_midnight.80": "#fbf9ffff",
    "color.bold.purple_midnight.inverse": "#1f0042ff",
    "color.bold.purple_midnight.background": "#3e0084ff",
    "color.bold.purple_midnight.grey.100": "#ffffffff",
    "color.bold.purple_midnight.grey.80": "#ffffffc7",
    "color.bold.purple_midnight.grey.60": "#ffffff87",
    "color.bold.purple_midnight.grey.40": "#ffffff4f",
    "color.bold.purple_midnight.grey.20": "#ffffff1f",
    "color.dark.purple_midnight.20": "#281240ff",
    "color.dark.purple_midnight.30": "#421f6bff",
    "color.dark.purple_midnight.40": "#5d2b96ff",
    "color.dark.purple_midnight.50": "#853dd6ff",
    "color.dark.purple_midnight.60": "#aa77e2ff",
    "color.dark.purple_midnight.70": "#c8a8edff",
    "color.dark.purple_midnight.80": "#e7d8f7ff",
    "color.dark.purple_midnight.inverse": "#ffffffff",
    "color.dark.purple_midnight.background": "#141414ff",
    "color.dark.purple_midnight.grey.100": "#ffffffff",
    "color.dark.purple_midnight.grey.80": "#ffffffc7",
    "color.dark.purple_midnight.grey.60": "#a1a1a1ff",
    "color.dark.purple_midnight.grey.40": "#5a5a5aff",
    "color.dark.purple_midnight.grey.20": "#2b2b2bff",
    "color.light.purple_midnight.20": "#f0e8faff",
    "color.light.purple_midnight.30": "#cba2faff",
    "color.light.purple_midnight.40": "#6d17ceff",
    "color.light.purple_midnight.50": "#3e0084ff",
    "color.light.purple_midnight.60": "#2b005cff",
    "color.light.purple_midnight.70": "#1f0042ff",
    "color.light.purple_midnight.80": "#130028ff",
    "color.light.purple_midnight.inverse": "#ffffffff",
    "color.light.purple_midnight.background": "#ffffffff",
    "color.light.purple_midnight.grey.100": "#141414ff",
    "color.light.purple_midnight.grey.80": "#000000a6",
    "color.light.purple_midnight.grey.60": "#b5b5b5ff",
    "color.light.purple_midnight.grey.40": "#e0e0e0ff",
    "color.light.purple_midnight.grey.20": "#f5f5f5ff",
    "color.bold.purple.20": "#cba2fa33",
    "color.bold.purple.30": "#cba2fa66",
    "color.bold.purple.40": "#cba2fa99",
    "color.bold.purple.50": "#cba2faff",
    "color.bold.purple.60": "#dbbefbff",
    "color.bold.purple.70": "#e4cffcff",
    "color.bold.purple.80": "#ecddfdff",
    "color.bold.purple.inverse": "#310a5dff",
    "color.bold.purple.background": "#6d17ceff",
    "color.bold.purple.grey.100": "#ffffffff",
    "color.bold.purple.grey.80": "#ffffffc7",
    "color.bold.purple.grey.60": "#ffffff87",
    "color.bold.purple.grey.40": "#ffffff4f",
    "color.bold.purple.grey.20": "#ffffff1f",
    "color.dark.purple.20": "#281240ff",
    "color.dark.purple.30": "#421f6bff",
    "color.dark.purple.40": "#5d2b96ff",
    "color.dark.purple.50": "#853dd6ff",
    "color.dark.purple.60": "#aa77e2ff",
    "color.dark.purple.70": "#c8a8edff",
    "color.dark.purple.80": "#e7d8f7ff",
    "color.dark.purple.inverse": "#ffffffff",
    "color.dark.purple.background": "#141414ff",
    "color.dark.purple.grey.100": "#ffffffff",
    "color.dark.purple.grey.80": "#ffffffc7",
    "color.dark.purple.grey.60": "#a1a1a1ff",
    "color.dark.purple.grey.40": "#5a5a5aff",
    "color.dark.purple.grey.20": "#2b2b2bff",
    "color.light.purple.20": "#f0e8faff",
    "color.light.purple.30": "#cba2faff",
    "color.light.purple.40": "#a680ffff",
    "color.light.purple.50": "#6d17ceff",
    "color.light.purple.60": "#3e0084ff",
    "color.light.purple.70": "#310a5dff",
    "color.light.purple.80": "#1b0633ff",
    "color.light.purple.inverse": "#ffffffff",
    "color.light.purple.background": "#ffffffff",
    "color.light.purple.grey.100": "#141414ff",
    "color.light.purple.grey.80": "#000000a6",
    "color.light.purple.grey.60": "#b5b5b5ff",
    "color.light.purple.grey.40": "#e0e0e0ff",
    "color.light.purple.grey.20": "#f5f5f5ff",
    "color.bold.red_midnight.20": "#ff9da333",
    "color.bold.red_midnight.30": "#ff9da366",
    "color.bold.red_midnight.40": "#ff9da399",
    "color.bold.red_midnight.50": "#ff9da3ff",
    "color.bold.red_midnight.60": "#ffccd1ff",
    "color.bold.red_midnight.70": "#ffe5e8ff",
    "color.bold.red_midnight.80": "#fff4f5ff",
    "color.bold.red_midnight.inverse": "#540000ff",
    "color.bold.red_midnight.background": "#a80000ff",
    "color.bold.red_midnight.grey.100": "#ffffffff",
    "color.bold.red_midnight.grey.80": "#ffffffc7",
    "color.bold.red_midnight.grey.60": "#ffffff87",
    "color.bold.red_midnight.grey.40": "#ffffff4f",
    "color.bold.red_midnight.grey.20": "#ffffff1f",
    "color.dark.red_midnight.20": "#430c10ff",
    "color.dark.red_midnight.30": "#70141aff",
    "color.dark.red_midnight.40": "#9d1d24ff",
    "color.dark.red_midnight.50": "#e02934ff",
    "color.dark.red_midnight.60": "#e96971ff",
    "color.dark.red_midnight.70": "#f19fa4ff",
    "color.dark.red_midnight.80": "#f9d4d6ff",
    "color.dark.red_midnight.inverse": "#ffffffff",
    "color.dark.red_midnight.background": "#141414ff",
    "color.dark.red_midnight.grey.100": "#ffffffff",
    "color.dark.red_midnight.grey.80": "#ffffffc7",
    "color.dark.red_midnight.grey.60": "#a1a1a1ff",
    "color.dark.red_midnight.grey.40": "#5a5a5aff",
    "color.dark.red_midnight.grey.20": "#2b2b2bff",
    "color.light.red_midnight.20": "#fce6e7ff",
    "color.light.red_midnight.30": "#ff9da3ff",
    "color.light.red_midnight.40": "#e30513ff",
    "color.light.red_midnight.50": "#a80000ff",
    "color.light.red_midnight.60": "#760000ff",
    "color.light.red_midnight.70": "#540000ff",
    "color.light.red_midnight.80": "#320000ff",
    "color.light.red_midnight.inverse": "#ffffffff",
    "color.light.red_midnight.background": "#ffffffff",
    "color.light.red_midnight.grey.100": "#141414ff",
    "color.light.red_midnight.grey.80": "#000000a6",
    "color.light.red_midnight.grey.60": "#b5b5b5ff",
    "color.light.red_midnight.grey.40": "#e0e0e0ff",
    "color.light.red_midnight.grey.20": "#f5f5f5ff",
    "color.bold.red.20": "#ff9da333",
    "color.bold.red.30": "#ff9da366",
    "color.bold.red.40": "#ff9da399",
    "color.bold.red.50": "#ff9da3ff",
    "color.bold.red.60": "#fff6f7ff",
    "color.bold.red.70": "#ffffffff",
    "color.bold.red.80": "#ffffffff",
    "color.bold.red.inverse": "#660209ff",
    "color.bold.red.background": "#e30513ff",
    "color.bold.red.grey.100": "#ffffffff",
    "color.bold.red.grey.80": "#fffffff5",
    "color.bold.red.grey.60": "#ffffff87",
    "color.bold.red.grey.40": "#ffffff4f",
    "color.bold.red.grey.20": "#ffffff1f",
    "color.dark.red.20": "#430c10ff",
    "color.dark.red.30": "#70141aff",
    "color.dark.red.40": "#9d1d24ff",
    "color.dark.red.50": "#e02934ff",
    "color.dark.red.60": "#e96971ff",
    "color.dark.red.70": "#f19fa4ff",
    "color.dark.red.80": "#f9d4d6ff",
    "color.dark.red.inverse": "#ffffffff",
    "color.dark.red.background": "#141414ff",
    "color.dark.red.grey.100": "#ffffffff",
    "color.dark.red.grey.80": "#ffffffc7",
    "color.dark.red.grey.60": "#a1a1a1ff",
    "color.dark.red.grey.40": "#5a5a5aff",
    "color.dark.red.grey.20": "#2b2b2bff",
    "color.light.red.20": "#fce6e7ff",
    "color.light.red.30": "#ff9da3ff",
    "color.light.red.40": "#fc6770ff",
    "color.light.red.50": "#e30513ff",
    "color.light.red.60": "#a80000ff",
    "color.light.red.70": "#660209ff",
    "color.light.red.80": "#390105ff",
    "color.light.red.inverse": "#ffffffff",
    "color.light.red.background": "#ffffffff",
    "color.light.red.grey.100": "#141414ff",
    "color.light.red.grey.80": "#000000a6",
    "color.light.red.grey.60": "#b5b5b5ff",
    "color.light.red.grey.40": "#e0e0e0ff",
    "color.light.red.grey.20": "#f5f5f5ff",
    "color.bold.reliance_midnight.20": "#9eb5fa33",
    "color.bold.reliance_midnight.30": "#9eb5fa66",
    "color.bold.reliance_midnight.40": "#9eb5fa99",
    "color.bold.reliance_midnight.50": "#9eb5faff",
    "color.bold.reliance_midnight.60": "#c7d4fcff",
    "color.bold.reliance_midnight.70": "#dce4fdff",
    "color.bold.reliance_midnight.80": "#f3f5feff",
    "color.bold.reliance_midnight.inverse": "#051442ff",
    "color.bold.reliance_midnight.background": "#0a2885ff",
    "color.bold.reliance_midnight.grey.100": "#ffffffff",
    "color.bold.reliance_midnight.grey.80": "#ffffffc7",
    "color.bold.reliance_midnight.grey.60": "#ffffff87",
    "color.bold.reliance_midnight.grey.40": "#ffffff4f",
    "color.bold.reliance_midnight.grey.20": "#ffffff1f",
    "color.dark.reliance_midnight.20": "#051444ff",
    "color.dark.reliance_midnight.30": "#092272ff",
    "color.dark.reliance_midnight.40": "#0c30a0ff",
    "color.dark.reliance_midnight.50": "#1144e4ff",
    "color.dark.reliance_midnight.60": "#587cecff",
    "color.dark.reliance_midnight.70": "#94abf3ff",
    "color.dark.reliance_midnight.80": "#cfdafaff",
    "color.dark.reliance_midnight.inverse": "#ffffffff",
    "color.dark.reliance_midnight.background": "#141414ff",
    "color.dark.reliance_midnight.grey.100": "#ffffffff",
    "color.dark.reliance_midnight.grey.80": "#ffffffc7",
    "color.dark.reliance_midnight.grey.60": "#a1a1a1ff",
    "color.dark.reliance_midnight.grey.40": "#5a5a5aff",
    "color.dark.reliance_midnight.grey.20": "#2b2b2bff",
    "color.light.reliance_midnight.20": "#e7ebf8ff",
    "color.light.reliance_midnight.30": "#9eb5faff",
    "color.light.reliance_midnight.40": "#0f3cc9ff",
    "color.light.reliance_midnight.50": "#0a2885ff",
    "color.light.reliance_midnight.60": "#071c5dff",
    "color.light.reliance_midnight.70": "#051442ff",
    "color.light.reliance_midnight.80": "#030c28ff",
    "color.light.reliance_midnight.inverse": "#ffffffff",
    "color.light.reliance_midnight.background": "#ffffffff",
    "color.light.reliance_midnight.grey.100": "#141414ff",
    "color.light.reliance_midnight.grey.80": "#000000a6",
    "color.light.reliance_midnight.grey.60": "#b5b5b5ff",
    "color.light.reliance_midnight.grey.40": "#e0e0e0ff",
    "color.light.reliance_midnight.grey.20": "#f5f5f5ff",
    "color.bold.reliance.20": "#9eb5fa33",
    "color.bold.reliance.30": "#9eb5fa66",
    "color.bold.reliance.40": "#9eb5fa99",
    "color.bold.reliance.50": "#9eb5faff",
    "color.bold.reliance.60": "#becefbff",
    "color.bold.reliance.70": "#d0dcfdff",
    "color.bold.reliance.80": "#e8eefeff",
    "color.bold.reliance.inverse": "#061951ff",
    "color.bold.reliance.background": "#0f3cc9ff",
    "color.bold.reliance.grey.100": "#ffffffff",
    "color.bold.reliance.grey.80": "#ffffffc7",
    "color.bold.reliance.grey.60": "#ffffff87",
    "color.bold.reliance.grey.40": "#ffffff4f",
    "color.bold.reliance.grey.20": "#ffffff1f",
    "color.dark.reliance.20": "#051444ff",
    "color.dark.reliance.30": "#092272ff",
    "color.dark.reliance.40": "#0c30a0ff",
    "color.dark.reliance.50": "#1144e4ff",
    "color.dark.reliance.60": "#587cecff",
    "color.dark.reliance.70": "#94abf3ff",
    "color.dark.reliance.80": "#cfdafaff",
    "color.dark.reliance.inverse": "#ffffffff",
    "color.dark.reliance.background": "#141414ff",
    "color.dark.reliance.grey.100": "#ffffffff",
    "color.dark.reliance.grey.80": "#ffffffc7",
    "color.dark.reliance.grey.60": "#a1a1a1ff",
    "color.dark.reliance.grey.40": "#5a5a5aff",
    "color.dark.reliance.grey.20": "#2b2b2bff",
    "color.light.reliance.20": "#e7ebf8ff",
    "color.light.reliance.30": "#9eb5faff",
    "color.light.reliance.40": "#6789f4ff",
    "color.light.reliance.50": "#0f3cc9ff",
    "color.light.reliance.60": "#0a2885ff",
    "color.light.reliance.70": "#061951ff",
    "color.light.reliance.80": "#070e21ff",
    "color.light.reliance.inverse": "#ffffffff",
    "color.light.reliance.background": "#ffffffff",
    "color.light.reliance.grey.100": "#141414ff",
    "color.light.reliance.grey.80": "#000000a6",
    "color.light.reliance.grey.60": "#b5b5b5ff",
    "color.light.reliance.grey.40": "#e0e0e0ff",
    "color.light.reliance.grey.20": "#f5f5f5ff",
    "color.bold.sky_midnight.20": "#89dcff33",
    "color.bold.sky_midnight.30": "#89dcff66",
    "color.bold.sky_midnight.40": "#89dcff99",
    "color.bold.sky_midnight.50": "#89dcffff",
    "color.bold.sky_midnight.60": "#bceaffff",
    "color.bold.sky_midnight.70": "#d4f2ffff",
    "color.bold.sky_midnight.80": "#f2fbffff",
    "color.bold.sky_midnight.inverse": "#062939ff",
    "color.bold.sky_midnight.background": "#0c5273ff",
    "color.bold.sky_midnight.grey.100": "#ffffffff",
    "color.bold.sky_midnight.grey.80": "#ffffffc7",
    "color.bold.sky_midnight.grey.60": "#ffffff87",
    "color.bold.sky_midnight.grey.40": "#ffffff4f",
    "color.bold.sky_midnight.grey.20": "#ffffff1f",
    "color.dark.sky_midnight.20": "#002b3dff",
    "color.dark.sky_midnight.30": "#004766ff",
    "color.dark.sky_midnight.40": "#00638fff",
    "color.dark.sky_midnight.50": "#007fadff",
    "color.dark.sky_midnight.60": "#4ca5c6ff",
    "color.dark.sky_midnight.70": "#8cc5daff",
    "color.dark.sky_midnight.80": "#cce5efff",
    "color.dark.sky_midnight.inverse": "#ffffffff",
    "color.dark.sky_midnight.background": "#141414ff",
    "color.dark.sky_midnight.grey.100": "#ffffffff",
    "color.dark.sky_midnight.grey.80": "#ffffffc7",
    "color.dark.sky_midnight.grey.60": "#a1a1a1ff",
    "color.dark.sky_midnight.grey.40": "#5a5a5aff",
    "color.dark.sky_midnight.grey.20": "#2b2b2bff",
    "color.light.sky_midnight.20": "#e5f1f7ff",
    "color.light.sky_midnight.30": "#89dcffff",
    "color.light.sky_midnight.40": "#0078adff",
    "color.light.sky_midnight.50": "#0c5273ff",
    "color.light.sky_midnight.60": "#083950ff",
    "color.light.sky_midnight.70": "#062939ff",
    "color.light.sky_midnight.80": "#041922ff",
    "color.light.sky_midnight.inverse": "#ffffffff",
    "color.light.sky_midnight.background": "#ffffffff",
    "color.light.sky_midnight.grey.100": "#141414ff",
    "color.light.sky_midnight.grey.80": "#000000a6",
    "color.light.sky_midnight.grey.60": "#b5b5b5ff",
    "color.light.sky_midnight.grey.40": "#e0e0e0ff",
    "color.light.sky_midnight.grey.20": "#f5f5f5ff",
    "color.bold.sky.20": "#89dcff33",
    "color.bold.sky.30": "#89dcff66",
    "color.bold.sky.40": "#89dcff99",
    "color.bold.sky.50": "#89dcffff",
    "color.bold.sky.60": "#eefaffff",
    "color.bold.sky.70": "#ffffffff",
    "color.bold.sky.80": "#ffffffff",
    "color.bold.sky.inverse": "#00364eff",
    "color.bold.sky.background": "#0078adff",
    "color.bold.sky.grey.100": "#ffffffff",
    "color.bold.sky.grey.80": "#fffffff0",
    "color.bold.sky.grey.60": "#ffffff87",
    "color.bold.sky.grey.40": "#ffffff4f",
    "color.bold.sky.grey.20": "#ffffff1f",
    "color.dark.sky.20": "#002b3dff",
    "color.dark.sky.30": "#004766ff",
    "color.dark.sky.40": "#00638fff",
    "color.dark.sky.50": "#007fadff",
    "color.dark.sky.60": "#4ca5c6ff",
    "color.dark.sky.70": "#8cc5daff",
    "color.dark.sky.80": "#cce5efff",
    "color.dark.sky.inverse": "#ffffffff",
    "color.dark.sky.background": "#141414ff",
    "color.dark.sky.grey.100": "#ffffffff",
    "color.dark.sky.grey.80": "#ffffffc7",
    "color.dark.sky.grey.60": "#a1a1a1ff",
    "color.dark.sky.grey.40": "#5a5a5aff",
    "color.dark.sky.grey.20": "#2b2b2bff",
    "color.light.sky.20": "#e5f1f7ff",
    "color.light.sky.30": "#89dcffff",
    "color.light.sky.40": "#67c3efff",
    "color.light.sky.50": "#0078adff",
    "color.light.sky.60": "#0c5273ff",
    "color.light.sky.70": "#00364eff",
    "color.light.sky.80": "#001e2bff",
    "color.light.sky.inverse": "#ffffffff",
    "color.light.sky.background": "#ffffffff",
    "color.light.sky.grey.100": "#141414ff",
    "color.light.sky.grey.80": "#000000a6",
    "color.light.sky.grey.60": "#b5b5b5ff",
    "color.light.sky.grey.40": "#e0e0e0ff",
    "color.light.sky.grey.20": "#f5f5f5ff",
    "color.bold.violet_midnight.20": "#f7a8fa33",
    "color.bold.violet_midnight.30": "#f7a8fa66",
    "color.bold.violet_midnight.40": "#f7a8fa99",
    "color.bold.violet_midnight.50": "#f7a8faff",
    "color.bold.violet_midnight.60": "#fbd1fcff",
    "color.bold.violet_midnight.70": "#fbd3fcff",
    "color.bold.violet_midnight.80": "#fef3feff",
    "color.bold.violet_midnight.inverse": "#3d0040ff",
    "color.bold.violet_midnight.background": "#79007fff",
    "color.bold.violet_midnight.grey.100": "#ffffffff",
    "color.bold.violet_midnight.grey.80": "#ffffffc7",
    "color.bold.violet_midnight.grey.60": "#ffffff87",
    "color.bold.violet_midnight.grey.40": "#ffffff4f",
    "color.bold.violet_midnight.grey.20": "#ffffff1f",
    "color.dark.violet_midnight.20": "#300d31ff",
    "color.dark.violet_midnight.30": "#571859ff",
    "color.dark.violet_midnight.40": "#79007fff",
    "color.dark.violet_midnight.50": "#c135c5ff",
    "color.dark.violet_midnight.60": "#f680f9ff",
    "color.dark.violet_midnight.70": "#f7a8faff",
    "color.dark.violet_midnight.80": "#f9ebf9ff",
    "color.dark.violet_midnight.inverse": "#ffffffff",
    "color.dark.violet_midnight.background": "#141414ff",
    "color.dark.violet_midnight.grey.100": "#ffffffff",
    "color.dark.violet_midnight.grey.80": "#ffffffc7",
    "color.dark.violet_midnight.grey.60": "#a1a1a1ff",
    "color.dark.violet_midnight.grey.40": "#5a5a5aff",
    "color.dark.violet_midnight.grey.20": "#2b2b2bff",
    "color.light.violet_midnight.20": "#f9ebf9ff",
    "color.light.violet_midnight.30": "#f7a8faff",
    "color.light.violet_midnight.40": "#c135c5ff",
    "color.light.violet_midnight.50": "#79007fff",
    "color.light.violet_midnight.60": "#550059ff",
    "color.light.violet_midnight.70": "#3d0040ff",
    "color.light.violet_midnight.80": "#240026ff",
    "color.light.violet_midnight.inverse": "#ffffffff",
    "color.light.violet_midnight.background": "#ffffffff",
    "color.light.violet_midnight.grey.100": "#141414ff",
    "color.light.violet_midnight.grey.80": "#000000a6",
    "color.light.violet_midnight.grey.60": "#b5b5b5ff",
    "color.light.violet_midnight.grey.40": "#e0e0e0ff",
    "color.light.violet_midnight.grey.20": "#f5f5f5ff",
    "color.bold.violet.20": "#f7a8fa33",
    "color.bold.violet.30": "#f7a8fa66",
    "color.bold.violet.40": "#f7a8fa99",
    "color.bold.violet.50": "#f7a8faff",
    "color.bold.violet.60": "#fefdffff",
    "color.bold.violet.70": "#ffffffff",
    "color.bold.violet.80": "#ffffffff",
    "color.bold.violet.inverse": "#571859ff",
    "color.bold.violet.background": "#c135c5ff",
    "color.bold.violet.grey.100": "#ffffffff",
    "color.bold.violet.grey.80": "#fffffffc",
    "color.bold.violet.grey.60": "#ffffff87",
    "color.bold.violet.grey.40": "#ffffff4f",
    "color.bold.violet.grey.20": "#ffffff1f",
    "color.dark.violet.20": "#300d31ff",
    "color.dark.violet.30": "#571859ff",
    "color.dark.violet.40": "#79007fff",
    "color.dark.violet.50": "#c135c5ff",
    "color.dark.violet.60": "#f680f9ff",
    "color.dark.violet.70": "#f7a8faff",
    "color.dark.violet.80": "#f9ebf9ff",
    "color.dark.violet.inverse": "#ffffffff",
    "color.dark.violet.background": "#141414ff",
    "color.dark.violet.grey.100": "#ffffffff",
    "color.dark.violet.grey.80": "#ffffffc7",
    "color.dark.violet.grey.60": "#a1a1a1ff",
    "color.dark.violet.grey.40": "#5a5a5aff",
    "color.dark.violet.grey.20": "#2b2b2bff",
    "color.light.violet.20": "#f9ebf9ff",
    "color.light.violet.30": "#f7a8faff",
    "color.light.violet.40": "#f680f9ff",
    "color.light.violet.50": "#c135c5ff",
    "color.light.violet.60": "#79007fff",
    "color.light.violet.70": "#571859ff",
    "color.light.violet.80": "#300d31ff",
    "color.light.violet.inverse": "#ffffffff",
    "color.light.violet.background": "#ffffffff",
    "color.light.violet.grey.100": "#141414ff",
    "color.light.violet.grey.80": "#000000a6",
    "color.light.violet.grey.60": "#b5b5b5ff",
    "color.light.violet.grey.40": "#e0e0e0ff",
    "color.light.violet.grey.20": "#f5f5f5ff",
    "color.light.feedback.error.80": "#3e0006ff",
    "color.light.feedback.error.70": "#6a000fff",
    "color.light.feedback.error.60": "#cd0027ff",
    "color.light.feedback.error.50": "#fa2F40ff",
    "color.light.feedback.error.40": "#fe9993ff",
    "color.light.feedback.error.30": "#ffCFCBff",
    "color.light.feedback.error.20": "#fff1F0ff",
    "color.light.feedback.warning.80": "#321304ff",
    "color.light.feedback.warning.70": "#582309ff",
    "color.light.feedback.warning.60": "#b04914ff",
    "color.light.feedback.warning.50": "#f06d0fff",
    "color.light.feedback.warning.40": "#fC9E6dff",
    "color.light.feedback.warning.30": "#FCD3BFff",
    "color.light.feedback.warning.20": "#fff2ecff",
    "color.light.feedback.success.80": "#0e540cff",
    "color.light.feedback.success.70": "#136c11ff",
    "color.light.feedback.success.60": "#1a8417ff",
    "color.light.feedback.success.50": "#25ab21ff",
    "color.light.feedback.success.40": "#85ce7fff",
    "color.light.feedback.success.30": "#c8e7c5ff",
    "color.light.feedback.success.20": "#eff8eeff",
    "color.light.white": "#ffffff",
    "color.light.black": "#141414",
    "color.dark.white": "#ffffff",
    "color.dark.black": "#141414",
    "color.bold.white": "#ffffff",
    "color.bold.black": "#141414",
    "color.bold.feedback.error.80": "#FFE1DEff",
    "color.bold.feedback.error.70": "#FFCFCBff",
    "color.bold.feedback.error.60": "#FFBEB9ff",
    "color.bold.feedback.error.50": "#FEABA6ff",
    "color.bold.feedback.error.40": "#FE9993ff",
    "color.bold.feedback.error.30": "#FF847Fff",
    "color.bold.feedback.error.20": "#FF6E6Cff",
    "color.bold.feedback.warning.80": "#FFF2ECff",
    "color.bold.feedback.warning.70": "#FEE3D6ff",
    "color.bold.feedback.warning.60": "#FCD3BFff",
    "color.bold.feedback.warning.50": "#FBC2A6ff",
    "color.bold.feedback.warning.40": "#FBB08Aff",
    "color.bold.feedback.warning.30": "#FC9E6Dff",
    "color.bold.feedback.warning.20": "#FB8C50ff",
    "color.bold.feedback.success.80": "#DCF0DAff",
    "color.bold.feedback.success.70": "#C8E7C5ff",
    "color.bold.feedback.success.60": "#B4DEAFff",
    "color.bold.feedback.success.50": "#9CD696ff",
    "color.bold.feedback.success.40": "#85CE7Fff",
    "color.bold.feedback.success.30": "#6CC765ff",
    "color.bold.feedback.success.20": "#54BE4Eff",
    "color.dark.feedback.error.80": "#fff1f0ff",
    "color.dark.feedback.error.70": "#ffe1deff",
    "color.dark.feedback.error.60": "#feaba6ff",
    "color.dark.feedback.error.50": "#ff5256ff",
    "color.dark.feedback.error.40": "#df042cff",
    "color.dark.feedback.error.30": "#770113ff",
    "color.dark.feedback.error.20": "#4F0109ff",
    "color.dark.feedback.warning.80": "#fff2ecff",
    "color.dark.feedback.warning.70": "#ffd6c2ff",
    "color.dark.feedback.warning.60": "#fbb08Aff",
    "color.dark.feedback.warning.50": "#f87a2eff",
    "color.dark.feedback.warning.40": "#c05016ff",
    "color.dark.feedback.warning.30": "#66270aff",
    "color.dark.feedback.warning.20": "#401a07ff",
    "color.dark.feedback.success.80": "#EFF8EEff",
    "color.dark.feedback.success.70": "#DCF0DAff",
    "color.dark.feedback.success.60": "#9CD696ff",
    "color.dark.feedback.success.50": "#3EB438ff",
    "color.dark.feedback.success.40": "#1D901Aff",
    "color.dark.feedback.success.30": "#167814ff",
    "color.dark.feedback.success.20": "#105F0Eff",
    "color.light.gold.20": "#f9f6efFF",
    "color.dark.gold.20": "#3f3721FF",
    "color.bold.gold.20": "#211d14FF",
    "color.light.gold.30": "#f4ead4FF",
    "color.dark.gold.30": "#746640FF",
    "color.bold.gold.30": "#3f3721FF",
    "color.light.gold.40": "#f0deb2FF",
    "color.dark.gold.40": "#a18e5bFF",
    "color.bold.gold.40": "#746640FF",
    "color.light.gold.50": "#c9b273FF",
    "color.dark.gold.50": "#d2ba78FF",
    "color.bold.gold.50": "#a18e5bFF",
    "color.light.gold.60": "#968454FF",
    "color.dark.gold.60": "#f0deb2FF",
    "color.bold.gold.60": "#f0deb2FF",
    "color.light.gold.70": "#6a5d3aFF",
    "color.dark.gold.70": "#f4ead4FF",
    "color.bold.gold.70": "#f4ead4FF",
    "color.light.gold.80": "#352e1dFF",
    "color.dark.gold.80": "#f9f6efFF",
    "color.bold.gold.80": "#f9f6efFF",
    "color.light.gold.grey.20": "#f5f5f5FF",
    "color.dark.gold.grey.20": "#2b2b2bFF",
    "color.bold.gold.grey.20": "#ffffff1F",
    "color.light.gold.grey.40": "#e0e0e0FF",
    "color.dark.gold.grey.40": "#5a5a5aFF",
    "color.bold.gold.grey.40": "#ffffff52",
    "color.light.gold.grey.60": "#b5b5b5FF",
    "color.dark.gold.grey.60": "#a1a1a1FF",
    "color.bold.gold.grey.60": "#ffffff87",
    "color.light.gold.grey.80": "#000000A6",
    "color.dark.gold.grey.80": "#ffffffC7",
    "color.bold.gold.grey.80": "#ffffffC7",
    "color.light.gold.grey.100": "#141414FF",
    "color.dark.gold.grey.100": "#ffffffFF",
    "color.bold.gold.grey.100": "#ffffffFF",
    "color.light.gold.background": "#ffffffFF",
    "color.dark.gold.background": "#141414FF",
    "color.bold.gold.background": "#c9b273FF",
    "color.light.gold.inverse": "#352e1dFF",
    "color.dark.gold.inverse": "#3f3721FF",
    "color.bold.gold.inverse": "#211d14FF",
    "color.light.rose.20": "#fcf5f5FF",
    "color.dark.rose.20": "#2e070aFF",
    "color.bold.rose.20": "#4e0b19FF",
    "color.light.rose.30": "#fad8d8FF",
    "color.dark.rose.30": "#700b25FF",
    "color.bold.rose.30": "#d8214fFF",
    "color.light.rose.40": "#f9c9caFF",
    "color.dark.rose.40": "#c61d48FF",
    "color.bold.rose.40": "#f8536eFF",
    "color.light.rose.50": "#fa969dFF",
    "color.dark.rose.50": "#f8536eFF",
    "color.bold.rose.50": "#f96e7eFF",
    "color.light.rose.60": "#f96e7eFF",
    "color.dark.rose.60": "#fba5aaFF",
    "color.bold.rose.60": "#fab6b9FF",
    "color.light.rose.70": "#720c26FF",
    "color.dark.rose.70": "#fad7d8FF",
    "color.bold.rose.70": "#fad7d8FF",
    "color.light.rose.80": "#3d0912FF",
    "color.dark.rose.80": "#fae6e7FF",
    "color.bold.rose.80": "#fcf5f5FF",
    "color.light.rose.grey.20": "#f5f5f5FF",
    "color.dark.rose.grey.20": "#2b2b2bFF",
    "color.bold.rose.grey.20": "#ffffff1F",
    "color.light.rose.grey.40": "#e0e0e0FF",
    "color.dark.rose.grey.40": "#5a5a5aFF",
    "color.bold.rose.grey.40": "#ffffff52",
    "color.light.rose.grey.60": "#b5b5b5FF",
    "color.dark.rose.grey.60": "#a1a1a1FF",
    "color.bold.rose.grey.60": "#ffffff87",
    "color.light.rose.grey.80": "#000000A6",
    "color.dark.rose.grey.80": "#ffffffC7",
    "color.bold.rose.grey.80": "#ffffffC7",
    "color.light.rose.grey.100": "#141414FF",
    "color.dark.rose.grey.100": "#ffffffFF",
    "color.bold.rose.grey.100": "#ffffffFF",
    "color.light.rose.background": "#3d0912FF",
    "color.dark.rose.background": "#141414FF",
    "color.bold.rose.background": "#141414FF",
    "color.light.rose.inverse": "#3d0912FF",
    "color.dark.rose.inverse": "#ffffffFF",
    "color.bold.rose.inverse": "#2e070aFF",
    "color.light.warm_gold.20": "#FEF7EF",
    "color.light.warm_gold.30": "#F9D4A9",
    "color.light.warm_gold.40": "#F3B561",
    "color.light.warm_gold.50": "#E39B2B",
    "color.light.warm_gold.60": "#9B6817",
    "color.light.warm_gold.70": "#67440C",
    "color.light.warm_gold.80": "#312109",
    "color.light.warm_gold.grey.20": "#F5F5F5",
    "color.light.warm_gold.grey.40": "#E0E0E0",
    "color.light.warm_gold.grey.60": "#B5B5B5",
    "color.light.warm_gold.grey.80": "#000000A5",
    "color.light.warm_gold.grey.100": "#141414",
    "color.light.warm_gold.background": "#FFFFFF",
    "color.light.warm_gold.inverse": "#312109",
    "color.dark.warm_gold.20": "#312109",
    "color.dark.warm_gold.30": "#67440C",
    "color.dark.warm_gold.40": "#A8711A",
    "color.dark.warm_gold.50": "#EFA73D",
    "color.dark.warm_gold.60": "#F6C586",
    "color.dark.warm_gold.70": "#FCE7D0",
    "color.dark.warm_gold.80": "#FDFDFD",
    "color.dark.warm_gold.grey.20": "#2B2B2B",
    "color.dark.warm_gold.grey.40": "#5A5A5A",
    "color.dark.warm_gold.grey.60": "#A1A1A1",
    "color.dark.warm_gold.grey.80": "#FFFFFFC7",
    "color.dark.warm_gold.grey.100": "#FFFFFF",
    "color.dark.warm_gold.background": "#120C04",
    "color.dark.warm_gold.inverse": "#312109",
    "color.bold.warm_gold.20": "#EFA73D",
    "color.bold.warm_gold.30": "#C78724",
    "color.bold.warm_gold.40": "#8E5F15",
    "color.bold.warm_gold.50": "#67440C",
    "color.bold.warm_gold.60": "#452D09",
    "color.bold.warm_gold.70": "#312109",
    "color.bold.warm_gold.80": "#241908",
    "color.bold.warm_gold.grey.20": "#401D0C1E",
    "color.bold.warm_gold.grey.40": "#401D0C4D",
    "color.bold.warm_gold.grey.60": "#401D0C87",
    "color.bold.warm_gold.grey.80": "#401D0CBF",
    "color.bold.warm_gold.grey.100": "#401D0C",
    "color.bold.warm_gold.background": "#E39B2B",
    "color.bold.warm_gold.inverse": "#FEF7EF",
    "color.light.new_gold.20": "#FDE8C9",
    "color.dark.new_gold.20": "#2C251B",
    "color.bold.new_gold.20": "#4C3D2733",
    "color.light.new_gold.30": "#FBDCAF",
    "color.dark.new_gold.30": "#4C3D27",
    "color.bold.new_gold.30": "#4C3D2766",
    "color.light.new_gold.40": "#E8BC7A",
    "color.dark.new_gold.40": "#795E34",
    "color.bold.new_gold.40": "#4C3D2799",
    "color.light.new_gold.50": "#CEA15A",
    "color.dark.new_gold.50": "#DEB26F",
    "color.bold.new_gold.50": "#4C3D27",
    "color.light.new_gold.60": "#93713A",
    "color.dark.new_gold.60": "#F0C688",
    "color.bold.new_gold.60": "#3B3121",
    "color.light.new_gold.70": "#5A482D",
    "color.dark.new_gold.70": "#F6D19A",
    "color.bold.new_gold.70": "#2C251B",
    "color.light.new_gold.80": "#1E1A14",
    "color.dark.new_gold.80": "#FDE8C9",
    "color.bold.new_gold.80": "#1E1A14",
    "color.light.new_gold.grey.20": "#F5F5F5",
    "color.dark.new_gold.grey.20": "#2b2b2bFF",
    "color.bold.new_gold.grey.20": "#FFFFFF1F",
    "color.light.new_gold.grey.40": "#e0e0e0FF",
    "color.dark.new_gold.grey.40": "#5a5a5aFF",
    "color.bold.new_gold.grey.40": "#FFFFFF4F",
    "color.light.new_gold.grey.60": "#b5b5b5FF",
    "color.dark.new_gold.grey.60": "#a1a1a1FF",
    "color.bold.new_gold.grey.60": "#FFFFFF87",
    "color.light.new_gold.grey.80": "#000000A6",
    "color.dark.new_gold.grey.80": "#FFFFFFC7",
    "color.bold.new_gold.grey.80": "#ffffffC7",
    "color.light.new_gold.grey.100": "#141414FF",
    "color.dark.new_gold.grey.100": "#ffffffFF",
    "color.bold.new_gold.grey.100": "#ffffffFF",
    "color.light.new_gold.background": "#ffffffFF",
    "color.dark.new_gold.background": "#141414FF",
    "color.bold.new_gold.background": "#CEA15A",
    "color.light.new_gold.inverse": "#FFFFFF",
    "color.dark.new_gold.inverse": "#1E1A14",
    "color.bold.new_gold.inverse": "#FFFFFF",
    "color.light.new_purple.20": "#EDE7FF",
    "color.dark.new_purple.20": "#310064",
    "color.bold.new_purple.20": "#C9B7FF33",
    "color.light.new_purple.30": "#C1AAFF",
    "color.dark.new_purple.30": "#4F009B",
    "color.bold.new_purple.30": "#C9B7FF66",
    "color.light.new_purple.40": "#AA83FF",
    "color.dark.new_purple.40": "#5D00B5",
    "color.bold.new_purple.40": "#C9B7FF99",
    "color.light.new_purple.50": "#6D17CE",
    "color.dark.new_purple.50": "#7F38E4",
    "color.bold.new_purple.50": "#C9B7FF",
    "color.light.new_purple.60": "#3F007F",
    "color.dark.new_purple.60": "#B99EFF",
    "color.bold.new_purple.60": "#DBCFFF",
    "color.light.new_purple.70": "#310064",
    "color.dark.new_purple.70": "#C9B7FF",
    "color.bold.new_purple.70": "#EDE7FF",
    "color.light.new_purple.80": "#13002D",
    "color.dark.new_purple.80": "#E4DBFF",
    "color.bold.new_purple.80": "#FFFFFF",
    "color.light.new_purple.grey.20": "#F5F5F5",
    "color.dark.new_purple.grey.20": "#2B2B2B",
    "color.bold.new_purple.grey.20": "#FFFFFF1F",
    "color.light.new_purple.grey.40": "#E0E0E0",
    "color.dark.new_purple.grey.40": "#5A5A5A",
    "color.bold.new_purple.grey.40": "#FFFFFF4F",
    "color.light.new_purple.grey.60": "#B5B5B5",
    "color.dark.new_purple.grey.60": "#A1A1A1",
    "color.bold.new_purple.grey.60": "#FFFFFF87",
    "color.light.new_purple.grey.80": "#000000A6",
    "color.dark.new_purple.grey.80": "#FFFFFFC7",
    "color.bold.new_purple.grey.80": "#FFFFFFC7",
    "color.light.new_purple.grey.100": "#141414FF",
    "color.dark.new_purple.grey.100": "#ffffffFF",
    "color.bold.new_purple.grey.100": "#ffffffFF",
    "color.light.new_purple.background": "#FFFFFF",
    "color.dark.new_purple.background": "#141414FF",
    "color.bold.new_purple.background": "#6D17CE",
    "color.light.new_purple.inverse": "#FFFFFF",
    "color.dark.new_purple.inverse": "#FFFFFF",
    "color.bold.new_purple.inverse": "#22004A",
    "color.light.new_sky.20": "#D8EFFE",
    "color.dark.new_sky.20": "#002A40",
    "color.bold.new_sky.20": "#AFDFFE33",
    "color.light.new_sky.30": "#99D6FF",
    "color.dark.new_sky.30": "#004566",
    "color.bold.new_sky.30": "#AFDFFE66",
    "color.light.new_sky.40": "#6ABBEE",
    "color.dark.new_sky.40": "#005F8A",
    "color.bold.new_sky.40": "#AFDFFE99",
    "color.light.new_sky.50": "#0078AD",
    "color.dark.new_sky.50": "#278BC1",
    "color.bold.new_sky.50": "#AFDFFE",
    "color.light.new_sky.60": "#005177",
    "color.dark.new_sky.60": "#5BB2E7",
    "color.bold.new_sky.60": "#C4E7FF",
    "color.light.new_sky.70": "#013752",
    "color.dark.new_sky.70": "#88CDFA",
    "color.bold.new_sky.70": "#ECF7FF",
    "color.light.new_sky.80": "#001D2E",
    "color.dark.new_sky.80": "#C4E7FF",
    "color.bold.new_sky.80": "#FFFFFF",
    "color.light.new_sky.grey.20": "#F5F5F5",
    "color.dark.new_sky.grey.20": "#2B2B2B",
    "color.bold.new_sky.grey.20": "#FFFFFF1F",
    "color.light.new_sky.grey.40": "#E0E0E0",
    "color.dark.new_sky.grey.40": "#5A5A5A",
    "color.bold.new_sky.grey.40": "#FFFFFF4F",
    "color.light.new_sky.grey.60": "#B5B5B5",
    "color.dark.new_sky.grey.60": "#A1A1A1",
    "color.bold.new_sky.grey.60": "#FFFFFF87",
    "color.light.new_sky.grey.80": "#000000A6",
    "color.dark.new_sky.grey.80": "#FFFFFFC7",
    "color.bold.new_sky.grey.80": "#FFFFFFC7",
    "color.light.new_sky.grey.100": "#141414FF",
    "color.dark.new_sky.grey.100": "#ffffffFF",
    "color.bold.new_sky.grey.100": "#ffffffFF",
    "color.light.new_sky.background": "#ffffffFF",
    "color.dark.new_sky.background": "#141414FF",
    "color.bold.new_sky.background": "#0078AD",
    "color.light.new_sky.inverse": "#FFFFFF",
    "color.dark.new_sky.inverse": "#FFFFFF",
    "color.bold.new_sky.inverse": "#001D2E",
    elevation1: $f551aa6589c293c2$var$elevation1,
    "elevation1.light": "{color.light.$primary.background}",
    "elevation1.dark": "{color.dark.$primary.grey.20}",
    "elevation1.bold": "{color.bold.$primary.background}",
    custom_color_1: $f551aa6589c293c2$var$custom_color_1,
    custom_color_2: $f551aa6589c293c2$var$custom_color_2,
    custom_color_3: $f551aa6589c293c2$var$custom_color_3,
    custom_color_4: $f551aa6589c293c2$var$custom_color_4,
    custom_color_5: $f551aa6589c293c2$var$custom_color_5,
    custom_color_6: $f551aa6589c293c2$var$custom_color_6,
    custom_dark_primary_40: $f551aa6589c293c2$var$custom_dark_primary_40,
    custom_dark_primary_60: $f551aa6589c293c2$var$custom_dark_primary_60,
    custom_dark_primary_grey_80: $f551aa6589c293c2$var$custom_dark_primary_grey_80,
    custom_dark_primary_grey_100: $f551aa6589c293c2$var$custom_dark_primary_grey_100
};
const $f551aa6589c293c2$var$headingXl$4 = "{$lang.$platform.headingXl}";
const $f551aa6589c293c2$var$headingL$4 = "{$lang.$platform.headingL}";
const $f551aa6589c293c2$var$headingM$4 = "{$lang.$platform.headingM}";
const $f551aa6589c293c2$var$headingS$4 = "{$lang.$platform.headingS}";
const $f551aa6589c293c2$var$headingXs$4 = "{$lang.$platform.headingXs}";
const $f551aa6589c293c2$var$headingXxs$4 = "{$lang.$platform.headingXxs}";
const $f551aa6589c293c2$var$overline$5 = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$bodyL$4 = "{$lang.$platform.bodyL}";
const $f551aa6589c293c2$var$bodyLBold$4 = "{$lang.$platform.bodyLBold}";
const $f551aa6589c293c2$var$bodyLLink$4 = "{$lang.$platform.bodyLLink}";
const $f551aa6589c293c2$var$bodyM$4 = "{$lang.$platform.bodyM}";
const $f551aa6589c293c2$var$bodyMBold$4 = "{$lang.$platform.bodyMBold}";
const $f551aa6589c293c2$var$bodyMLink$4 = "{$lang.$platform.bodyMLink}";
const $f551aa6589c293c2$var$bodyS$4 = "{$lang.$platform.bodyS}";
const $f551aa6589c293c2$var$bodySBold$4 = "{$lang.$platform.bodySBold}";
const $f551aa6589c293c2$var$bodySLink$4 = "{$lang.$platform.bodySLink}";
const $f551aa6589c293c2$var$bodyXs$4 = "{$lang.$platform.bodyXs}";
const $f551aa6589c293c2$var$bodyXsBold$4 = "{$lang.$platform.bodyXsBold}";
const $f551aa6589c293c2$var$bodyXsLink$4 = "{$lang.$platform.bodyXsLink}";
const $f551aa6589c293c2$var$bodyXxs$4 = "{$lang.$platform.bodyXxs}";
const $f551aa6589c293c2$var$bodyXxsBold$4 = "{$lang.$platform.bodyXxsBold}";
const $f551aa6589c293c2$var$bodyXxsLink$4 = "{$lang.$platform.bodyXxsLink}";
const $f551aa6589c293c2$var$body3xs$4 = "{$lang.$platform.body3xs}";
const $f551aa6589c293c2$var$body3xsBold$4 = "{$lang.$platform.body3xsBold}";
const $f551aa6589c293c2$var$body3xsLink$4 = "{$lang.$platform.body3xsLink}";
const $f551aa6589c293c2$var$listTitle$4 = "{$lang.$platform.listTitle}";
const $f551aa6589c293c2$var$button$4 = "{$lang.$platform.button}";
const $f551aa6589c293c2$var$code$4 = "{$lang.$platform.code}";
const $f551aa6589c293c2$var$fontFamilies = {
    "as.desktop.headingXl": "Noto Sans",
    "as.desktop.headingL": "Noto Sans",
    "as.desktop.headingM": "Noto Sans",
    "as.desktop.headingS": "Noto Sans",
    "as.desktop.headingXs": "Noto Sans",
    "as.desktop.headingXxs": "Noto Sans",
    "as.desktop.overline": "Noto Sans",
    "as.desktop.bodyL": "Noto Sans",
    "as.desktop.bodyLBold": "Noto Sans",
    "as.desktop.bodyLLink": "Noto Sans",
    "as.desktop.bodyM": "Noto Sans",
    "as.desktop.bodyMBold": "Noto Sans",
    "as.desktop.bodyMLink": "Noto Sans",
    "as.desktop.bodyS": "Noto Sans",
    "as.desktop.bodySBold": "Noto Sans",
    "as.desktop.bodySLink": "Noto Sans",
    "as.desktop.bodyXs": "Noto Sans",
    "as.desktop.bodyXsBold": "Noto Sans",
    "as.desktop.bodyXsLink": "Noto Sans",
    "as.desktop.bodyXxs": "Noto Sans",
    "as.desktop.bodyXxsBold": "Noto Sans",
    "as.desktop.bodyXxsLink": "Noto Sans",
    "as.desktop.body3xs": "Noto Sans",
    "as.desktop.body3xsBold": "Noto Sans",
    "as.desktop.body3xsLink": "Noto Sans",
    "as.desktop.listTitle": "Noto Sans",
    "as.desktop.button": "Noto Sans",
    "as.desktop.code": "JetBrains Mono",
    "as.mobile.headingXl": "Noto Sans",
    "as.mobile.headingL": "Noto Sans",
    "as.mobile.headingM": "Noto Sans",
    "as.mobile.headingS": "Noto Sans",
    "as.mobile.headingXs": "Noto Sans",
    "as.mobile.headingXxs": "Noto Sans",
    "as.mobile.overline": "Noto Sans",
    "as.mobile.bodyL": "Noto Sans",
    "as.mobile.bodyLBold": "Noto Sans",
    "as.mobile.bodyLLink": "Noto Sans",
    "as.mobile.bodyM": "Noto Sans",
    "as.mobile.bodyMBold": "Noto Sans",
    "as.mobile.bodyMLink": "Noto Sans",
    "as.mobile.bodyS": "Noto Sans",
    "as.mobile.bodySBold": "Noto Sans",
    "as.mobile.bodySLink": "Noto Sans",
    "as.mobile.bodyXs": "Noto Sans",
    "as.mobile.bodyXsBold": "Noto Sans",
    "as.mobile.bodyXsLink": "Noto Sans",
    "as.mobile.bodyXxs": "Noto Sans",
    "as.mobile.bodyXxsBold": "Noto Sans",
    "as.mobile.bodyXxsLink": "Noto Sans",
    "as.mobile.body3xs": "Noto Sans",
    "as.mobile.body3xsBold": "Noto Sans",
    "as.mobile.body3xsLink": "Noto Sans",
    "as.mobile.listTitle": "Noto Sans",
    "as.mobile.button": "Noto Sans",
    "as.mobile.code": "JetBrains Mono",
    "bn.desktop.headingXl": "Noto Sans Bengali",
    "bn.desktop.headingL": "Noto Sans Bengali",
    "bn.desktop.headingM": "Noto Sans Bengali",
    "bn.desktop.headingS": "Noto Sans Bengali",
    "bn.desktop.headingXs": "Noto Sans Bengali",
    "bn.desktop.headingXxs": "Noto Sans Bengali",
    "bn.desktop.overline": "Noto Sans Bengali",
    "bn.desktop.bodyL": "Noto Sans Bengali",
    "bn.desktop.bodyLBold": "Noto Sans Bengali",
    "bn.desktop.bodyLLink": "Noto Sans Bengali",
    "bn.desktop.bodyM": "Noto Sans Bengali",
    "bn.desktop.bodyMBold": "Noto Sans Bengali",
    "bn.desktop.bodyMLink": "Noto Sans Bengali",
    "bn.desktop.bodyS": "Noto Sans Bengali",
    "bn.desktop.bodySBold": "Noto Sans Bengali",
    "bn.desktop.bodySLink": "Noto Sans Bengali",
    "bn.desktop.bodyXs": "Noto Sans Bengali",
    "bn.desktop.bodyXsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXsLink": "Noto Sans Bengali",
    "bn.desktop.bodyXxs": "Noto Sans Bengali",
    "bn.desktop.bodyXxsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXxsLink": "Noto Sans Bengali",
    "bn.desktop.body3xs": "Noto Sans Bengali",
    "bn.desktop.body3xsBold": "Noto Sans Bengali",
    "bn.desktop.body3xsLink": "Noto Sans Bengali",
    "bn.desktop.listTitle": "Noto Sans Bengali",
    "bn.desktop.button": "Noto Sans Bengali",
    "bn.desktop.code": "JetBrains Mono",
    "bn.mobile.headingXl": "Noto Sans Bengali",
    "bn.mobile.headingL": "Noto Sans Bengali",
    "bn.mobile.headingM": "Noto Sans Bengali",
    "bn.mobile.headingS": "Noto Sans Bengali",
    "bn.mobile.headingXs": "Noto Sans Bengali",
    "bn.mobile.headingXxs": "Noto Sans Bengali",
    "bn.mobile.overline": "Noto Sans Bengali",
    "bn.mobile.bodyL": "Noto Sans Bengali",
    "bn.mobile.bodyLBold": "Noto Sans Bengali",
    "bn.mobile.bodyLLink": "Noto Sans Bengali",
    "bn.mobile.bodyM": "Noto Sans Bengali",
    "bn.mobile.bodyMBold": "Noto Sans Bengali",
    "bn.mobile.bodyMLink": "Noto Sans Bengali",
    "bn.mobile.bodyS": "Noto Sans Bengali",
    "bn.mobile.bodySBold": "Noto Sans Bengali",
    "bn.mobile.bodySLink": "Noto Sans Bengali",
    "bn.mobile.bodyXs": "Noto Sans Bengali",
    "bn.mobile.bodyXsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXsLink": "Noto Sans Bengali",
    "bn.mobile.bodyXxs": "Noto Sans Bengali",
    "bn.mobile.bodyXxsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXxsLink": "Noto Sans Bengali",
    "bn.mobile.body3xs": "Noto Sans Bengali",
    "bn.mobile.body3xsBold": "Noto Sans Bengali",
    "bn.mobile.body3xsLink": "Noto Sans Bengali",
    "bn.mobile.listTitle": "Noto Sans Bengali",
    "bn.mobile.button": "Noto Sans Bengali",
    "bn.mobile.code": "JetBrains Mono",
    "en.desktop.headingXl": "JioType Black",
    "en.desktop.headingL": "JioType Black",
    "en.desktop.headingM": "JioType Black",
    "en.desktop.headingS": "JioType Black",
    "en.desktop.headingXs": "JioType Black",
    "en.desktop.headingXxs": "JioType Black",
    "en.desktop.overline": "JioType Bold",
    "en.desktop.bodyL": "JioType Medium",
    "en.desktop.bodyLBold": "JioType Bold",
    "en.desktop.bodyLLink": "JioType Bold",
    "en.desktop.bodyM": "JioType Medium",
    "en.desktop.bodyMBold": "JioType Bold",
    "en.desktop.bodyMLink": "JioType Bold",
    "en.desktop.bodyS": "JioType Medium",
    "en.desktop.bodySBold": "JioType Bold",
    "en.desktop.bodySLink": "JioType Bold",
    "en.desktop.bodyXs": "JioType Medium",
    "en.desktop.bodyXsBold": "JioType Bold",
    "en.desktop.bodyXsLink": "JioType Bold",
    "en.desktop.bodyXxs": "JioType Medium",
    "en.desktop.bodyXxsBold": "JioType Bold",
    "en.desktop.bodyXxsLink": "JioType Bold",
    "en.desktop.body3xs": "JioType Medium",
    "en.desktop.body3xsBold": "JioType Bold",
    "en.desktop.body3xsLink": "JioType Bold",
    "en.desktop.listTitle": "JioType Medium",
    "en.desktop.button": "JioType Bold",
    "en.desktop.code": "JetBrains Mono",
    "en.mobile.headingXl": "JioType Black",
    "en.mobile.headingL": "JioType Black",
    "en.mobile.headingM": "JioType Black",
    "en.mobile.headingS": "JioType Black",
    "en.mobile.headingXs": "JioType Black",
    "en.mobile.headingXxs": "JioType Black",
    "en.mobile.overline": "JioType Bold",
    "en.mobile.bodyL": "JioType Medium",
    "en.mobile.bodyLBold": "JioType Bold",
    "en.mobile.bodyLLink": "JioType Bold",
    "en.mobile.bodyM": "JioType Medium",
    "en.mobile.bodyMBold": "JioType Bold",
    "en.mobile.bodyMLink": "JioType Bold",
    "en.mobile.bodyS": "JioType Medium",
    "en.mobile.bodySBold": "JioType Bold",
    "en.mobile.bodySLink": "JioType Bold",
    "en.mobile.bodyXs": "JioType Medium",
    "en.mobile.bodyXsBold": "JioType Bold",
    "en.mobile.bodyXsLink": "JioType Bold",
    "en.mobile.bodyXxs": "JioType Medium",
    "en.mobile.bodyXxsBold": "JioType Bold",
    "en.mobile.bodyXxsLink": "JioType Bold",
    "en.mobile.body3xs": "JioType Medium",
    "en.mobile.body3xsBold": "JioType Bold",
    "en.mobile.body3xsLink": "JioType Bold",
    "en.mobile.listTitle": "JioType Medium",
    "en.mobile.button": "JioType Bold",
    "en.mobile.code": "JetBrains Mono",
    "gu.desktop.headingXl": "Noto Sans Gujarati",
    "gu.desktop.headingL": "Noto Sans Gujarati",
    "gu.desktop.headingM": "Noto Sans Gujarati",
    "gu.desktop.headingS": "Noto Sans Gujarati",
    "gu.desktop.headingXs": "Noto Sans Gujarati",
    "gu.desktop.headingXxs": "Noto Sans Gujarati",
    "gu.desktop.overline": "Noto Sans Gujarati",
    "gu.desktop.bodyL": "Noto Sans Gujarati",
    "gu.desktop.bodyLBold": "Noto Sans Gujarati",
    "gu.desktop.bodyLLink": "Noto Sans Gujarati",
    "gu.desktop.bodyM": "Noto Sans Gujarati",
    "gu.desktop.bodyMBold": "Noto Sans Gujarati",
    "gu.desktop.bodyMLink": "Noto Sans Gujarati",
    "gu.desktop.bodyS": "Noto Sans Gujarati",
    "gu.desktop.bodySBold": "Noto Sans Gujarati",
    "gu.desktop.bodySLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXs": "Noto Sans Gujarati",
    "gu.desktop.bodyXsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXsLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXxs": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsLink": "Noto Sans Gujarati",
    "gu.desktop.body3xs": "Noto Sans Gujarati",
    "gu.desktop.body3xsBold": "Noto Sans Gujarati",
    "gu.desktop.body3xsLink": "Noto Sans Gujarati",
    "gu.desktop.listTitle": "Noto Sans Gujarati",
    "gu.desktop.button": "Noto Sans Gujarati",
    "gu.desktop.code": "JetBrains Mono",
    "gu.mobile.headingXl": "Noto Sans Gujarati",
    "gu.mobile.headingL": "Noto Sans Gujarati",
    "gu.mobile.headingM": "Noto Sans Gujarati",
    "gu.mobile.headingS": "Noto Sans Gujarati",
    "gu.mobile.headingXs": "Noto Sans Gujarati",
    "gu.mobile.headingXxs": "Noto Sans Gujarati",
    "gu.mobile.overline": "Noto Sans Gujarati",
    "gu.mobile.bodyL": "Noto Sans Gujarati",
    "gu.mobile.bodyLBold": "Noto Sans Gujarati",
    "gu.mobile.bodyLLink": "Noto Sans Gujarati",
    "gu.mobile.bodyM": "Noto Sans Gujarati",
    "gu.mobile.bodyMBold": "Noto Sans Gujarati",
    "gu.mobile.bodyMLink": "Noto Sans Gujarati",
    "gu.mobile.bodyS": "Noto Sans Gujarati",
    "gu.mobile.bodySBold": "Noto Sans Gujarati",
    "gu.mobile.bodySLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXs": "Noto Sans Gujarati",
    "gu.mobile.bodyXsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXsLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXxs": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsLink": "Noto Sans Gujarati",
    "gu.mobile.body3xs": "Noto Sans Gujarati",
    "gu.mobile.body3xsBold": "Noto Sans Gujarati",
    "gu.mobile.body3xsLink": "Noto Sans Gujarati",
    "gu.mobile.listTitle": "Noto Sans Gujarati",
    "gu.mobile.button": "Noto Sans Gujarati",
    "gu.mobile.code": "JetBrains Mono",
    "hi.desktop.headingXl": "Noto Sans",
    "hi.desktop.headingL": "Noto Sans",
    "hi.desktop.headingM": "Noto Sans",
    "hi.desktop.headingS": "Noto Sans",
    "hi.desktop.headingXs": "Noto Sans",
    "hi.desktop.headingXxs": "Noto Sans",
    "hi.desktop.overline": "Noto Sans Bengali",
    "hi.desktop.bodyL": "Noto Sans",
    "hi.desktop.bodyLBold": "Noto Sans",
    "hi.desktop.bodyLLink": "Noto Sans",
    "hi.desktop.bodyM": "Noto Sans",
    "hi.desktop.bodyMBold": "Noto Sans",
    "hi.desktop.bodyMLink": "Noto Sans",
    "hi.desktop.bodyS": "Noto Sans",
    "hi.desktop.bodySBold": "Noto Sans",
    "hi.desktop.bodySLink": "Noto Sans",
    "hi.desktop.bodyXs": "Noto Sans",
    "hi.desktop.bodyXsBold": "Noto Sans",
    "hi.desktop.bodyXsLink": "Noto Sans",
    "hi.desktop.bodyXxs": "Noto Sans",
    "hi.desktop.bodyXxsBold": "Noto Sans",
    "hi.desktop.bodyXxsLink": "Noto Sans",
    "hi.desktop.body3xs": "Noto Sans",
    "hi.desktop.body3xsBold": "Noto Sans",
    "hi.desktop.body3xsLink": "Noto Sans",
    "hi.desktop.listTitle": "Noto Sans",
    "hi.desktop.button": "Noto Sans",
    "hi.desktop.code": "JetBrains Mono",
    "hi.mobile.headingXl": "Noto Sans",
    "hi.mobile.headingL": "Noto Sans",
    "hi.mobile.headingM": "Noto Sans",
    "hi.mobile.headingS": "Noto Sans",
    "hi.mobile.headingXs": "Noto Sans",
    "hi.mobile.headingXxs": "Noto Sans",
    "hi.mobile.overline": "Noto Sans",
    "hi.mobile.bodyL": "Noto Sans",
    "hi.mobile.bodyLBold": "Noto Sans",
    "hi.mobile.bodyLLink": "Noto Sans",
    "hi.mobile.bodyM": "Noto Sans",
    "hi.mobile.bodyMBold": "Noto Sans",
    "hi.mobile.bodyMLink": "Noto Sans",
    "hi.mobile.bodyS": "Noto Sans",
    "hi.mobile.bodySBold": "Noto Sans",
    "hi.mobile.bodySLink": "Noto Sans",
    "hi.mobile.bodyXs": "Noto Sans",
    "hi.mobile.bodyXsBold": "Noto Sans",
    "hi.mobile.bodyXsLink": "Noto Sans",
    "hi.mobile.bodyXxs": "Noto Sans",
    "hi.mobile.bodyXxsBold": "Noto Sans",
    "hi.mobile.bodyXxsLink": "Noto Sans",
    "hi.mobile.body3xs": "Noto Sans",
    "hi.mobile.body3xsBold": "Noto Sans",
    "hi.mobile.body3xsLink": "Noto Sans",
    "hi.mobile.listTitle": "Noto Sans",
    "hi.mobile.button": "Noto Sans",
    "hi.mobile.code": "JetBrains Mono",
    "kn.desktop.headingXl": "Noto Sans Kannada",
    "kn.desktop.headingL": "Noto Sans Kannada",
    "kn.desktop.headingM": "Noto Sans Kannada",
    "kn.desktop.headingS": "Noto Sans Kannada",
    "kn.desktop.headingXs": "Noto Sans Kannada",
    "kn.desktop.headingXxs": "Noto Sans Kannada",
    "kn.desktop.overline": "Noto Sans Kannada",
    "kn.desktop.bodyL": "Noto Sans Kannada",
    "kn.desktop.bodyLBold": "Noto Sans Kannada",
    "kn.desktop.bodyLLink": "Noto Sans Kannada",
    "kn.desktop.bodyM": "Noto Sans Kannada",
    "kn.desktop.bodyMBold": "Noto Sans Kannada",
    "kn.desktop.bodyMLink": "Noto Sans Kannada",
    "kn.desktop.bodyS": "Noto Sans Kannada",
    "kn.desktop.bodySBold": "Noto Sans Kannada",
    "kn.desktop.bodySLink": "Noto Sans Kannada",
    "kn.desktop.bodyXs": "Noto Sans Kannada",
    "kn.desktop.bodyXsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXsLink": "Noto Sans Kannada",
    "kn.desktop.bodyXxs": "Noto Sans Kannada",
    "kn.desktop.bodyXxsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXxsLink": "Noto Sans Kannada",
    "kn.desktop.body3xs": "Noto Sans Kannada",
    "kn.desktop.body3xsBold": "Noto Sans Kannada",
    "kn.desktop.body3xsLink": "Noto Sans Kannada",
    "kn.desktop.listTitle": "Noto Sans Kannada",
    "kn.desktop.button": "Noto Sans Kannada",
    "kn.desktop.code": "JetBrains Mono",
    "kn.mobile.headingXl": "Noto Sans Kannada",
    "kn.mobile.headingL": "Noto Sans Kannada",
    "kn.mobile.headingM": "Noto Sans Kannada",
    "kn.mobile.headingS": "Noto Sans Kannada",
    "kn.mobile.headingXs": "Noto Sans Kannada",
    "kn.mobile.headingXxs": "Noto Sans Kannada",
    "kn.mobile.overline": "Noto Sans Kannada",
    "kn.mobile.bodyL": "Noto Sans Kannada",
    "kn.mobile.bodyLBold": "Noto Sans Kannada",
    "kn.mobile.bodyLLink": "Noto Sans Kannada",
    "kn.mobile.bodyM": "Noto Sans Kannada",
    "kn.mobile.bodyMBold": "Noto Sans Kannada",
    "kn.mobile.bodyMLink": "Noto Sans Kannada",
    "kn.mobile.bodyS": "Noto Sans Kannada",
    "kn.mobile.bodySBold": "Noto Sans Kannada",
    "kn.mobile.bodySLink": "Noto Sans Kannada",
    "kn.mobile.bodyXs": "Noto Sans Kannada",
    "kn.mobile.bodyXsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXsLink": "Noto Sans Kannada",
    "kn.mobile.bodyXxs": "Noto Sans Kannada",
    "kn.mobile.bodyXxsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXxsLink": "Noto Sans Kannada",
    "kn.mobile.body3xs": "Noto Sans Kannada",
    "kn.mobile.body3xsBold": "Noto Sans Kannada",
    "kn.mobile.body3xsLink": "Noto Sans Kannada",
    "kn.mobile.listTitle": "Noto Sans Kannada",
    "kn.mobile.button": "Noto Sans Kannada",
    "kn.mobile.code": "JetBrains Mono",
    "ml.desktop.headingXl": "Noto Sans Malayalam",
    "ml.desktop.headingL": "Noto Sans Malayalam",
    "ml.desktop.headingM": "Noto Sans Malayalam",
    "ml.desktop.headingS": "Noto Sans Malayalam",
    "ml.desktop.headingXs": "Noto Sans Malayalam",
    "ml.desktop.headingXxs": "Noto Sans Malayalam",
    "ml.desktop.overline": "Noto Sans Malayalam",
    "ml.desktop.bodyL": "Noto Sans Malayalam",
    "ml.desktop.bodyLBold": "Noto Sans Malayalam",
    "ml.desktop.bodyLLink": "Noto Sans Malayalam",
    "ml.desktop.bodyM": "Noto Sans Malayalam",
    "ml.desktop.bodyMBold": "Noto Sans Malayalam",
    "ml.desktop.bodyMLink": "Noto Sans Malayalam",
    "ml.desktop.bodyS": "Noto Sans Malayalam",
    "ml.desktop.bodySBold": "Noto Sans Malayalam",
    "ml.desktop.bodySLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXs": "Noto Sans Malayalam",
    "ml.desktop.bodyXsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXsLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXxs": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsLink": "Noto Sans Malayalam",
    "ml.desktop.body3xs": "Noto Sans Malayalam",
    "ml.desktop.body3xsBold": "Noto Sans Malayalam",
    "ml.desktop.body3xsLink": "Noto Sans Malayalam",
    "ml.desktop.listTitle": "Noto Sans Malayalam",
    "ml.desktop.button": "Noto Sans Malayalam",
    "ml.desktop.code": "JetBrains Mono",
    "ml.mobile.headingXl": "Noto Sans Malayalam",
    "ml.mobile.headingL": "Noto Sans Malayalam",
    "ml.mobile.headingM": "Noto Sans Malayalam",
    "ml.mobile.headingS": "Noto Sans Malayalam",
    "ml.mobile.headingXs": "Noto Sans Malayalam",
    "ml.mobile.headingXxs": "Noto Sans Malayalam",
    "ml.mobile.overline": "Noto Sans Malayalam",
    "ml.mobile.bodyL": "Noto Sans Malayalam",
    "ml.mobile.bodyLBold": "Noto Sans Malayalam",
    "ml.mobile.bodyLLink": "Noto Sans Malayalam",
    "ml.mobile.bodyM": "Noto Sans Malayalam",
    "ml.mobile.bodyMBold": "Noto Sans Malayalam",
    "ml.mobile.bodyMLink": "Noto Sans Malayalam",
    "ml.mobile.bodyS": "Noto Sans Malayalam",
    "ml.mobile.bodySBold": "Noto Sans Malayalam",
    "ml.mobile.bodySLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXs": "Noto Sans Malayalam",
    "ml.mobile.bodyXsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXsLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXxs": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsLink": "Noto Sans Malayalam",
    "ml.mobile.body3xs": "Noto Sans Malayalam",
    "ml.mobile.body3xsBold": "Noto Sans Malayalam",
    "ml.mobile.body3xsLink": "Noto Sans Malayalam",
    "ml.mobile.listTitle": "Noto Sans Malayalam",
    "ml.mobile.button": "Noto Sans Malayalam",
    "ml.mobile.code": "JetBrains Mono",
    "mr.desktop.headingXl": "Noto Sans",
    "mr.desktop.headingL": "Noto Sans",
    "mr.desktop.headingM": "Noto Sans",
    "mr.desktop.headingS": "Noto Sans",
    "mr.desktop.headingXs": "Noto Sans",
    "mr.desktop.headingXxs": "Noto Sans",
    "mr.desktop.overline": "Noto Sans",
    "mr.desktop.bodyL": "Noto Sans",
    "mr.desktop.bodyLBold": "Noto Sans",
    "mr.desktop.bodyLLink": "Noto Sans",
    "mr.desktop.bodyM": "Noto Sans",
    "mr.desktop.bodyMBold": "Noto Sans",
    "mr.desktop.bodyMLink": "Noto Sans",
    "mr.desktop.bodyS": "Noto Sans",
    "mr.desktop.bodySBold": "Noto Sans",
    "mr.desktop.bodySLink": "Noto Sans",
    "mr.desktop.bodyXs": "Noto Sans",
    "mr.desktop.bodyXsBold": "Noto Sans",
    "mr.desktop.bodyXsLink": "Noto Sans",
    "mr.desktop.bodyXxs": "Noto Sans",
    "mr.desktop.bodyXxsBold": "Noto Sans",
    "mr.desktop.bodyXxsLink": "Noto Sans",
    "mr.desktop.body3xs": "Noto Sans",
    "mr.desktop.body3xsBold": "Noto Sans",
    "mr.desktop.body3xsLink": "Noto Sans",
    "mr.desktop.listTitle": "Noto Sans",
    "mr.desktop.button": "Noto Sans",
    "mr.desktop.code": "JetBrains Mono",
    "mr.mobile.headingXl": "Noto Sans",
    "mr.mobile.headingL": "Noto Sans",
    "mr.mobile.headingM": "Noto Sans",
    "mr.mobile.headingS": "Noto Sans",
    "mr.mobile.headingXs": "Noto Sans",
    "mr.mobile.headingXxs": "Noto Sans",
    "mr.mobile.overline": "Noto Sans Oriya",
    "mr.mobile.bodyL": "Noto Sans",
    "mr.mobile.bodyLBold": "Noto Sans",
    "mr.mobile.bodyLLink": "Noto Sans",
    "mr.mobile.bodyM": "Noto Sans",
    "mr.mobile.bodyMBold": "Noto Sans",
    "mr.mobile.bodyMLink": "Noto Sans",
    "mr.mobile.bodyS": "Noto Sans",
    "mr.mobile.bodySBold": "Noto Sans",
    "mr.mobile.bodySLink": "Noto Sans",
    "mr.mobile.bodyXs": "Noto Sans",
    "mr.mobile.bodyXsBold": "Noto Sans",
    "mr.mobile.bodyXsLink": "Noto Sans",
    "mr.mobile.bodyXxs": "Noto Sans",
    "mr.mobile.bodyXxsBold": "Noto Sans",
    "mr.mobile.bodyXxsLink": "Noto Sans",
    "mr.mobile.body3xs": "Noto Sans",
    "mr.mobile.body3xsBold": "Noto Sans",
    "mr.mobile.body3xsLink": "Noto Sans",
    "mr.mobile.listTitle": "Noto Sans",
    "mr.mobile.button": "Noto Sans",
    "mr.mobile.code": "JetBrains Mono",
    "or.desktop.headingXl": "Noto Sans Oriya",
    "or.desktop.headingL": "Noto Sans Oriya",
    "or.desktop.headingM": "Noto Sans Oriya",
    "or.desktop.headingS": "Noto Sans Oriya",
    "or.desktop.headingXs": "Noto Sans Oriya",
    "or.desktop.headingXxs": "Noto Sans Oriya",
    "or.desktop.overline": "Noto Sans Oriya",
    "or.desktop.bodyL": "Noto Sans Oriya",
    "or.desktop.bodyLBold": "Noto Sans Oriya",
    "or.desktop.bodyLLink": "Noto Sans Oriya",
    "or.desktop.bodyM": "Noto Sans Oriya",
    "or.desktop.bodyMBold": "Noto Sans Oriya",
    "or.desktop.bodyMLink": "Noto Sans Oriya",
    "or.desktop.bodyS": "Noto Sans Oriya",
    "or.desktop.bodySBold": "Noto Sans Oriya",
    "or.desktop.bodySLink": "Noto Sans Oriya",
    "or.desktop.bodyXs": "Noto Sans Oriya",
    "or.desktop.bodyXsBold": "Noto Sans Oriya",
    "or.desktop.bodyXsLink": "Noto Sans Oriya",
    "or.desktop.bodyXxs": "Noto Sans Oriya",
    "or.desktop.bodyXxsBold": "Noto Sans Oriya",
    "or.desktop.bodyXxsLink": "Noto Sans Oriya",
    "or.desktop.body3xs": "Noto Sans Oriya",
    "or.desktop.body3xsBold": "Noto Sans Oriya",
    "or.desktop.body3xsLink": "Noto Sans Oriya",
    "or.desktop.listTitle": "Noto Sans Oriya",
    "or.desktop.button": "Noto Sans Oriya",
    "or.desktop.code": "JetBrains Mono",
    "or.mobile.headingXl": "Noto Sans Oriya",
    "or.mobile.headingL": "Noto Sans Oriya",
    "or.mobile.headingM": "Noto Sans Oriya",
    "or.mobile.headingS": "Noto Sans Oriya",
    "or.mobile.headingXs": "Noto Sans Oriya",
    "or.mobile.headingXxs": "Noto Sans Oriya",
    "or.mobile.overline": "Noto Sans Oriya",
    "or.mobile.bodyL": "Noto Sans Oriya",
    "or.mobile.bodyLBold": "Noto Sans Oriya",
    "or.mobile.bodyLLink": "Noto Sans Oriya",
    "or.mobile.bodyM": "Noto Sans Oriya",
    "or.mobile.bodyMBold": "Noto Sans Oriya",
    "or.mobile.bodyMLink": "Noto Sans Oriya",
    "or.mobile.bodyS": "Noto Sans Oriya",
    "or.mobile.bodySBold": "Noto Sans Oriya",
    "or.mobile.bodySLink": "Noto Sans Oriya",
    "or.mobile.bodyXs": "Noto Sans Oriya",
    "or.mobile.bodyXsBold": "Noto Sans Oriya",
    "or.mobile.bodyXsLink": "Noto Sans Oriya",
    "or.mobile.bodyXxs": "Noto Sans Oriya",
    "or.mobile.bodyXxsBold": "Noto Sans Oriya",
    "or.mobile.bodyXxsLink": "Noto Sans Oriya",
    "or.mobile.body3xs": "Noto Sans Oriya",
    "or.mobile.body3xsBold": "Noto Sans Oriya",
    "or.mobile.body3xsLink": "Noto Sans Oriya",
    "or.mobile.listTitle": "Noto Sans Oriya",
    "or.mobile.button": "Noto Sans Oriya",
    "or.mobile.code": "JetBrains Mono",
    "pa.desktop.headingXl": "Noto Sans Gurmukhi",
    "pa.desktop.headingL": "Noto Sans Gurmukhi",
    "pa.desktop.headingM": "Noto Sans Gurmukhi",
    "pa.desktop.headingS": "Noto Sans Gurmukhi",
    "pa.desktop.headingXs": "Noto Sans Gurmukhi",
    "pa.desktop.headingXxs": "Noto Sans Gurmukhi",
    "pa.desktop.overline": "Noto Sans Gurmukhi",
    "pa.desktop.bodyL": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyM": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyS": "Noto Sans Gurmukhi",
    "pa.desktop.bodySBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodySLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.desktop.body3xs": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsBold": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsLink": "Noto Sans Gurmukhi",
    "pa.desktop.listTitle": "Noto Sans Gurmukhi",
    "pa.desktop.button": "Noto Sans Gurmukhi",
    "pa.desktop.code": "JetBrains Mono",
    "pa.mobile.headingXl": "Noto Sans Gurmukhi",
    "pa.mobile.headingL": "Noto Sans Gurmukhi",
    "pa.mobile.headingM": "Noto Sans Gurmukhi",
    "pa.mobile.headingS": "Noto Sans Gurmukhi",
    "pa.mobile.headingXs": "Noto Sans Gurmukhi",
    "pa.mobile.headingXxs": "Noto Sans Gurmukhi",
    "pa.mobile.overline": "Noto Sans Gurmukhi",
    "pa.mobile.bodyL": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyM": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyS": "Noto Sans Gurmukhi",
    "pa.mobile.bodySBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodySLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.mobile.body3xs": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsBold": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsLink": "Noto Sans Gurmukhi",
    "pa.mobile.listTitle": "Noto Sans Gurmukhi",
    "pa.mobile.button": "Noto Sans Gurmukhi",
    "pa.mobile.code": "JetBrains Mono",
    "ta.desktop.headingXl": "Noto Sans Tamil",
    "ta.desktop.headingL": "Noto Sans Tamil",
    "ta.desktop.headingM": "Noto Sans Tamil",
    "ta.desktop.headingS": "Noto Sans Tamil",
    "ta.desktop.headingXs": "Noto Sans Tamil",
    "ta.desktop.headingXxs": "Noto Sans Tamil",
    "ta.desktop.overline": "Noto Sans Tamil",
    "ta.desktop.bodyL": "Noto Sans Tamil",
    "ta.desktop.bodyLBold": "Noto Sans Tamil",
    "ta.desktop.bodyLLink": "Noto Sans Tamil",
    "ta.desktop.bodyM": "Noto Sans Tamil",
    "ta.desktop.bodyMBold": "Noto Sans Tamil",
    "ta.desktop.bodyMLink": "Noto Sans Tamil",
    "ta.desktop.bodyS": "Noto Sans Tamil",
    "ta.desktop.bodySBold": "Noto Sans Tamil",
    "ta.desktop.bodySLink": "Noto Sans Tamil",
    "ta.desktop.bodyXs": "Noto Sans Tamil",
    "ta.desktop.bodyXsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXsLink": "Noto Sans Tamil",
    "ta.desktop.bodyXxs": "Noto Sans Tamil",
    "ta.desktop.bodyXxsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXxsLink": "Noto Sans Tamil",
    "ta.desktop.body3xs": "Noto Sans Tamil",
    "ta.desktop.body3xsBold": "Noto Sans Tamil",
    "ta.desktop.body3xsLink": "Noto Sans Tamil",
    "ta.desktop.listTitle": "Noto Sans Tamil",
    "ta.desktop.button": "Noto Sans Tamil",
    "ta.desktop.code": "JetBrains Mono",
    "ta.mobile.headingXl": "Noto Sans Tamil",
    "ta.mobile.headingL": "Noto Sans Tamil",
    "ta.mobile.headingM": "Noto Sans Tamil",
    "ta.mobile.headingS": "Noto Sans Tamil",
    "ta.mobile.headingXs": "Noto Sans Tamil",
    "ta.mobile.headingXxs": "Noto Sans Tamil",
    "ta.mobile.overline": "Noto Sans Tamil",
    "ta.mobile.bodyL": "Noto Sans Tamil",
    "ta.mobile.bodyLBold": "Noto Sans Tamil",
    "ta.mobile.bodyLLink": "Noto Sans Tamil",
    "ta.mobile.bodyM": "Noto Sans Tamil",
    "ta.mobile.bodyMBold": "Noto Sans Tamil",
    "ta.mobile.bodyMLink": "Noto Sans Tamil",
    "ta.mobile.bodyS": "Noto Sans Tamil",
    "ta.mobile.bodySBold": "Noto Sans Tamil",
    "ta.mobile.bodySLink": "Noto Sans Tamil",
    "ta.mobile.bodyXs": "Noto Sans Tamil",
    "ta.mobile.bodyXsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXsLink": "Noto Sans Tamil",
    "ta.mobile.bodyXxs": "Noto Sans Tamil",
    "ta.mobile.bodyXxsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXxsLink": "Noto Sans Tamil",
    "ta.mobile.body3xs": "Noto Sans Tamil",
    "ta.mobile.body3xsBold": "Noto Sans Tamil",
    "ta.mobile.body3xsLink": "Noto Sans Tamil",
    "ta.mobile.listTitle": "Noto Sans Tamil",
    "ta.mobile.button": "Noto Sans Tamil",
    "ta.mobile.code": "JetBrains Mono",
    "te.desktop.headingXl": "Noto Sans Telugu",
    "te.desktop.headingL": "Noto Sans Telugu",
    "te.desktop.headingM": "Noto Sans Telugu",
    "te.desktop.headingS": "Noto Sans Telugu",
    "te.desktop.headingXs": "Noto Sans Telugu",
    "te.desktop.headingXxs": "Noto Sans Telugu",
    "te.desktop.overline": "Noto Sans Telugu",
    "te.desktop.bodyL": "Noto Sans Telugu",
    "te.desktop.bodyLBold": "Noto Sans Telugu",
    "te.desktop.bodyLLink": "Noto Sans Telugu",
    "te.desktop.bodyM": "Noto Sans Telugu",
    "te.desktop.bodyMBold": "Noto Sans Telugu",
    "te.desktop.bodyMLink": "Noto Sans Telugu",
    "te.desktop.bodyS": "Noto Sans Telugu",
    "te.desktop.bodySBold": "Noto Sans Telugu",
    "te.desktop.bodySLink": "Noto Sans Telugu",
    "te.desktop.bodyXs": "Noto Sans Telugu",
    "te.desktop.bodyXsBold": "Noto Sans Telugu",
    "te.desktop.bodyXsLink": "Noto Sans Telugu",
    "te.desktop.bodyXxs": "Noto Sans Telugu",
    "te.desktop.bodyXxsBold": "Noto Sans Telugu",
    "te.desktop.bodyXxsLink": "Noto Sans Telugu",
    "te.desktop.body3xs": "Noto Sans Telugu",
    "te.desktop.body3xsBold": "Noto Sans Telugu",
    "te.desktop.body3xsLink": "Noto Sans Telugu",
    "te.desktop.listTitle": "Noto Sans Telugu",
    "te.desktop.button": "Noto Sans Telugu",
    "te.desktop.code": "JetBrains Mono",
    "te.mobile.headingXl": "Noto Sans Telugu",
    "te.mobile.headingL": "Noto Sans Telugu",
    "te.mobile.headingM": "Noto Sans Telugu",
    "te.mobile.headingS": "Noto Sans Telugu",
    "te.mobile.headingXs": "Noto Sans Telugu",
    "te.mobile.headingXxs": "Noto Sans Telugu",
    "te.mobile.overline": "Noto Sans Telugu",
    "te.mobile.bodyL": "Noto Sans Telugu",
    "te.mobile.bodyLBold": "Noto Sans Telugu",
    "te.mobile.bodyLLink": "Noto Sans Telugu",
    "te.mobile.bodyM": "Noto Sans Telugu",
    "te.mobile.bodyMBold": "Noto Sans Telugu",
    "te.mobile.bodyMLink": "Noto Sans Telugu",
    "te.mobile.bodyS": "Noto Sans Telugu",
    "te.mobile.bodySBold": "Noto Sans Telugu",
    "te.mobile.bodySLink": "Noto Sans Telugu",
    "te.mobile.bodyXs": "Noto Sans Telugu",
    "te.mobile.bodyXsBold": "Noto Sans Telugu",
    "te.mobile.bodyXsLink": "Noto Sans Telugu",
    "te.mobile.bodyXxs": "Noto Sans Telugu",
    "te.mobile.bodyXxsBold": "Noto Sans Telugu",
    "te.mobile.bodyXxsLink": "Noto Sans Telugu",
    "te.mobile.body3xs": "Noto Sans Telugu",
    "te.mobile.body3xsBold": "Noto Sans Telugu",
    "te.mobile.body3xsLink": "Noto Sans Telugu",
    "te.mobile.listTitle": "Noto Sans Telugu",
    "te.mobile.button": "Noto Sans Telugu",
    "te.mobile.code": "JetBrains Mono",
    headingXl: $f551aa6589c293c2$var$headingXl$4,
    headingL: $f551aa6589c293c2$var$headingL$4,
    headingM: $f551aa6589c293c2$var$headingM$4,
    headingS: $f551aa6589c293c2$var$headingS$4,
    headingXs: $f551aa6589c293c2$var$headingXs$4,
    headingXxs: $f551aa6589c293c2$var$headingXxs$4,
    overline: $f551aa6589c293c2$var$overline$5,
    bodyL: $f551aa6589c293c2$var$bodyL$4,
    bodyLBold: $f551aa6589c293c2$var$bodyLBold$4,
    bodyLLink: $f551aa6589c293c2$var$bodyLLink$4,
    bodyM: $f551aa6589c293c2$var$bodyM$4,
    bodyMBold: $f551aa6589c293c2$var$bodyMBold$4,
    bodyMLink: $f551aa6589c293c2$var$bodyMLink$4,
    bodyS: $f551aa6589c293c2$var$bodyS$4,
    bodySBold: $f551aa6589c293c2$var$bodySBold$4,
    bodySLink: $f551aa6589c293c2$var$bodySLink$4,
    bodyXs: $f551aa6589c293c2$var$bodyXs$4,
    bodyXsBold: $f551aa6589c293c2$var$bodyXsBold$4,
    bodyXsLink: $f551aa6589c293c2$var$bodyXsLink$4,
    bodyXxs: $f551aa6589c293c2$var$bodyXxs$4,
    bodyXxsBold: $f551aa6589c293c2$var$bodyXxsBold$4,
    bodyXxsLink: $f551aa6589c293c2$var$bodyXxsLink$4,
    body3xs: $f551aa6589c293c2$var$body3xs$4,
    body3xsBold: $f551aa6589c293c2$var$body3xsBold$4,
    body3xsLink: $f551aa6589c293c2$var$body3xsLink$4,
    listTitle: $f551aa6589c293c2$var$listTitle$4,
    button: $f551aa6589c293c2$var$button$4,
    code: $f551aa6589c293c2$var$code$4
};
const $f551aa6589c293c2$var$headingXl$3 = "{$lang.$platform.headingXl}";
const $f551aa6589c293c2$var$headingL$3 = "{$lang.$platform.headingL}";
const $f551aa6589c293c2$var$headingM$3 = "{$lang.$platform.headingM}";
const $f551aa6589c293c2$var$headingS$3 = "{$lang.$platform.headingS}";
const $f551aa6589c293c2$var$headingXs$3 = "{$lang.$platform.headingXs}";
const $f551aa6589c293c2$var$headingXxs$3 = "{$lang.$platform.headingXxs}";
const $f551aa6589c293c2$var$overline$4 = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$bodyL$3 = "{$lang.$platform.bodyL}";
const $f551aa6589c293c2$var$bodyLBold$3 = "{$lang.$platform.bodyLBold}";
const $f551aa6589c293c2$var$bodyLLink$3 = "{$lang.$platform.bodyLLink}";
const $f551aa6589c293c2$var$bodyM$3 = "{$lang.$platform.bodyM}";
const $f551aa6589c293c2$var$bodyMBold$3 = "{$lang.$platform.bodyMBold}";
const $f551aa6589c293c2$var$bodyMLink$3 = "{$lang.$platform.bodyMLink}";
const $f551aa6589c293c2$var$bodyS$3 = "{$lang.$platform.bodyS}";
const $f551aa6589c293c2$var$bodySBold$3 = "{$lang.$platform.bodySBold}";
const $f551aa6589c293c2$var$bodySLink$3 = "{$lang.$platform.bodySLink}";
const $f551aa6589c293c2$var$bodyXs$3 = "{$lang.$platform.bodyXs}";
const $f551aa6589c293c2$var$bodyXsBold$3 = "{$lang.$platform.bodyXsBold}";
const $f551aa6589c293c2$var$bodyXsLink$3 = "{$lang.$platform.bodyXsLink}";
const $f551aa6589c293c2$var$bodyXxs$3 = "{$lang.$platform.bodyXxs}";
const $f551aa6589c293c2$var$bodyXxsBold$3 = "{$lang.$platform.bodyXxsBold}";
const $f551aa6589c293c2$var$bodyXxsLink$3 = "{$lang.$platform.bodyXxsLink}";
const $f551aa6589c293c2$var$body3xs$3 = "{$lang.$platform.body3xs}";
const $f551aa6589c293c2$var$body3xsBold$3 = "{$lang.$platform.body3xsBold}";
const $f551aa6589c293c2$var$body3xsLink$3 = "{$lang.$platform.body3xsLink}";
const $f551aa6589c293c2$var$listTitle$3 = "{$lang.$platform.listTitle}";
const $f551aa6589c293c2$var$button$3 = "{$lang.$platform.button}";
const $f551aa6589c293c2$var$code$3 = "{$lang.$platform.code}";
const $f551aa6589c293c2$var$fontSizes = {
    "as.desktop.headingXl": 88,
    "as.desktop.headingL": 64,
    "as.desktop.headingM": 40,
    "as.desktop.headingS": 32,
    "as.desktop.headingXs": 24,
    "as.desktop.headingXxs": 16,
    "as.desktop.overline": 12,
    "as.desktop.bodyL": 24,
    "as.desktop.bodyLBold": 24,
    "as.desktop.bodyLLink": 24,
    "as.desktop.bodyM": 18,
    "as.desktop.bodyMBold": 18,
    "as.desktop.bodyMLink": 18,
    "as.desktop.bodyS": 16,
    "as.desktop.bodySBold": 16,
    "as.desktop.bodySLink": 16,
    "as.desktop.bodyXs": 14,
    "as.desktop.bodyXsBold": 14,
    "as.desktop.bodyXsLink": 14,
    "as.desktop.bodyXxs": 12,
    "as.desktop.bodyXxsBold": 12,
    "as.desktop.bodyXxsLink": 12,
    "as.desktop.body3xs": 11,
    "as.desktop.body3xsBold": 11,
    "as.desktop.body3xsLink": 11,
    "as.desktop.listTitle": 16,
    "as.desktop.button": 16,
    "as.desktop.code": 12,
    "as.mobile.headingXl": 64,
    "as.mobile.headingL": 48,
    "as.mobile.headingM": 40,
    "as.mobile.headingS": 32,
    "as.mobile.headingXs": 24,
    "as.mobile.headingXxs": 16,
    "as.mobile.overline": 12,
    "as.mobile.bodyL": 24,
    "as.mobile.bodyLBold": 24,
    "as.mobile.bodyLLink": 24,
    "as.mobile.bodyM": 18,
    "as.mobile.bodyMBold": 18,
    "as.mobile.bodyMLink": 18,
    "as.mobile.bodyS": 16,
    "as.mobile.bodySBold": 16,
    "as.mobile.bodySLink": 16,
    "as.mobile.bodyXs": 14,
    "as.mobile.bodyXsBold": 14,
    "as.mobile.bodyXsLink": 14,
    "as.mobile.bodyXxs": 12,
    "as.mobile.bodyXxsBold": 12,
    "as.mobile.bodyXxsLink": 12,
    "as.mobile.body3xs": 11,
    "as.mobile.body3xsBold": 11,
    "as.mobile.body3xsLink": 11,
    "as.mobile.listTitle": 16,
    "as.mobile.button": 16,
    "as.mobile.code": 12,
    "bn.desktop.headingXl": 88,
    "bn.desktop.headingL": 64,
    "bn.desktop.headingM": 40,
    "bn.desktop.headingS": 32,
    "bn.desktop.headingXs": 24,
    "bn.desktop.headingXxs": 16,
    "bn.desktop.overline": 12,
    "bn.desktop.bodyL": 24,
    "bn.desktop.bodyLBold": 24,
    "bn.desktop.bodyLLink": 24,
    "bn.desktop.bodyM": 18,
    "bn.desktop.bodyMBold": 18,
    "bn.desktop.bodyMLink": 18,
    "bn.desktop.bodyS": 16,
    "bn.desktop.bodySBold": 16,
    "bn.desktop.bodySLink": 16,
    "bn.desktop.bodyXs": 14,
    "bn.desktop.bodyXsBold": 14,
    "bn.desktop.bodyXsLink": 14,
    "bn.desktop.bodyXxs": 12,
    "bn.desktop.bodyXxsBold": 12,
    "bn.desktop.bodyXxsLink": 12,
    "bn.desktop.body3xs": 11,
    "bn.desktop.body3xsBold": 11,
    "bn.desktop.body3xsLink": 11,
    "bn.desktop.listTitle": 16,
    "bn.desktop.button": 16,
    "bn.desktop.code": 12,
    "bn.mobile.headingXl": 64,
    "bn.mobile.headingL": 48,
    "bn.mobile.headingM": 40,
    "bn.mobile.headingS": 32,
    "bn.mobile.headingXs": 24,
    "bn.mobile.headingXxs": 16,
    "bn.mobile.overline": 12,
    "bn.mobile.bodyL": 24,
    "bn.mobile.bodyLBold": 24,
    "bn.mobile.bodyLLink": 24,
    "bn.mobile.bodyM": 18,
    "bn.mobile.bodyMBold": 18,
    "bn.mobile.bodyMLink": 18,
    "bn.mobile.bodyS": 16,
    "bn.mobile.bodySBold": 16,
    "bn.mobile.bodySLink": 16,
    "bn.mobile.bodyXs": 14,
    "bn.mobile.bodyXsBold": 14,
    "bn.mobile.bodyXsLink": 14,
    "bn.mobile.bodyXxs": 12,
    "bn.mobile.bodyXxsBold": 12,
    "bn.mobile.bodyXxsLink": 12,
    "bn.mobile.body3xs": 11,
    "bn.mobile.body3xsBold": 11,
    "bn.mobile.body3xsLink": 11,
    "bn.mobile.listTitle": 16,
    "bn.mobile.button": 16,
    "bn.mobile.code": 12,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 24,
    "en.desktop.headingXxs": 16,
    "en.desktop.overline": 12,
    "en.desktop.bodyL": 24,
    "en.desktop.bodyLBold": 24,
    "en.desktop.bodyLLink": 24,
    "en.desktop.bodyM": 18,
    "en.desktop.bodyMBold": 18,
    "en.desktop.bodyMLink": 18,
    "en.desktop.bodyS": 16,
    "en.desktop.bodySBold": 16,
    "en.desktop.bodySLink": 16,
    "en.desktop.bodyXs": 14,
    "en.desktop.bodyXsBold": 14,
    "en.desktop.bodyXsLink": 14,
    "en.desktop.bodyXxs": 12,
    "en.desktop.bodyXxsBold": 12,
    "en.desktop.bodyXxsLink": 12,
    "en.desktop.body3xs": 11,
    "en.desktop.body3xsBold": 11,
    "en.desktop.body3xsLink": 11,
    "en.desktop.listTitle": 16,
    "en.desktop.button": 16,
    "en.desktop.code": 12,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 24,
    "en.mobile.headingXxs": 16,
    "en.mobile.overline": 12,
    "en.mobile.bodyL": 24,
    "en.mobile.bodyLBold": 24,
    "en.mobile.bodyLLink": 24,
    "en.mobile.bodyM": 18,
    "en.mobile.bodyMBold": 18,
    "en.mobile.bodyMLink": 18,
    "en.mobile.bodyS": 16,
    "en.mobile.bodySBold": 16,
    "en.mobile.bodySLink": 16,
    "en.mobile.bodyXs": 14,
    "en.mobile.bodyXsBold": 14,
    "en.mobile.bodyXsLink": 14,
    "en.mobile.bodyXxs": 12,
    "en.mobile.bodyXxsBold": 12,
    "en.mobile.bodyXxsLink": 12,
    "en.mobile.body3xs": 11,
    "en.mobile.body3xsBold": 11,
    "en.mobile.body3xsLink": 11,
    "en.mobile.listTitle": 16,
    "en.mobile.button": 16,
    "en.mobile.code": 12,
    "gu.desktop.headingXl": 88,
    "gu.desktop.headingL": 64,
    "gu.desktop.headingM": 40,
    "gu.desktop.headingS": 32,
    "gu.desktop.headingXs": 24,
    "gu.desktop.headingXxs": 16,
    "gu.desktop.overline": 12,
    "gu.desktop.bodyL": 24,
    "gu.desktop.bodyLBold": 24,
    "gu.desktop.bodyLLink": 24,
    "gu.desktop.bodyM": 18,
    "gu.desktop.bodyMBold": 18,
    "gu.desktop.bodyMLink": 18,
    "gu.desktop.bodyS": 16,
    "gu.desktop.bodySBold": 16,
    "gu.desktop.bodySLink": 16,
    "gu.desktop.bodyXs": 14,
    "gu.desktop.bodyXsBold": 14,
    "gu.desktop.bodyXsLink": 14,
    "gu.desktop.bodyXxs": 12,
    "gu.desktop.bodyXxsBold": 12,
    "gu.desktop.bodyXxsLink": 12,
    "gu.desktop.body3xs": 11,
    "gu.desktop.body3xsBold": 11,
    "gu.desktop.body3xsLink": 11,
    "gu.desktop.listTitle": 16,
    "gu.desktop.button": 16,
    "gu.desktop.code": 12,
    "gu.mobile.headingXl": 64,
    "gu.mobile.headingL": 48,
    "gu.mobile.headingM": 40,
    "gu.mobile.headingS": 32,
    "gu.mobile.headingXs": 24,
    "gu.mobile.headingXxs": 16,
    "gu.mobile.overline": 12,
    "gu.mobile.bodyL": 24,
    "gu.mobile.bodyLBold": 24,
    "gu.mobile.bodyLLink": 24,
    "gu.mobile.bodyM": 18,
    "gu.mobile.bodyMBold": 18,
    "gu.mobile.bodyMLink": 18,
    "gu.mobile.bodyS": 16,
    "gu.mobile.bodySBold": 16,
    "gu.mobile.bodySLink": 16,
    "gu.mobile.bodyXs": 14,
    "gu.mobile.bodyXsBold": 14,
    "gu.mobile.bodyXsLink": 14,
    "gu.mobile.bodyXxs": 12,
    "gu.mobile.bodyXxsBold": 12,
    "gu.mobile.bodyXxsLink": 12,
    "gu.mobile.body3xs": 11,
    "gu.mobile.body3xsBold": 11,
    "gu.mobile.body3xsLink": 11,
    "gu.mobile.listTitle": 16,
    "gu.mobile.button": 16,
    "gu.mobile.code": 12,
    "hi.desktop.headingXl": 88,
    "hi.desktop.headingL": 64,
    "hi.desktop.headingM": 40,
    "hi.desktop.headingS": 32,
    "hi.desktop.headingXs": 24,
    "hi.desktop.headingXxs": 16,
    "hi.desktop.overline": 12,
    "hi.desktop.bodyL": 24,
    "hi.desktop.bodyLBold": 24,
    "hi.desktop.bodyLLink": 24,
    "hi.desktop.bodyM": 18,
    "hi.desktop.bodyMBold": 18,
    "hi.desktop.bodyMLink": 18,
    "hi.desktop.bodyS": 16,
    "hi.desktop.bodySBold": 16,
    "hi.desktop.bodySLink": 16,
    "hi.desktop.bodyXs": 14,
    "hi.desktop.bodyXsBold": 14,
    "hi.desktop.bodyXsLink": 14,
    "hi.desktop.bodyXxs": 12,
    "hi.desktop.bodyXxsBold": 12,
    "hi.desktop.bodyXxsLink": 12,
    "hi.desktop.body3xs": 11,
    "hi.desktop.body3xsBold": 11,
    "hi.desktop.body3xsLink": 11,
    "hi.desktop.listTitle": 16,
    "hi.desktop.button": 16,
    "hi.desktop.code": 12,
    "hi.mobile.headingXl": 64,
    "hi.mobile.headingL": 48,
    "hi.mobile.headingM": 40,
    "hi.mobile.headingS": 32,
    "hi.mobile.headingXs": 24,
    "hi.mobile.headingXxs": 16,
    "hi.mobile.overline": 12,
    "hi.mobile.bodyL": 24,
    "hi.mobile.bodyLBold": 24,
    "hi.mobile.bodyLLink": 24,
    "hi.mobile.bodyM": 18,
    "hi.mobile.bodyMBold": 18,
    "hi.mobile.bodyMLink": 18,
    "hi.mobile.bodyS": 16,
    "hi.mobile.bodySBold": 16,
    "hi.mobile.bodySLink": 16,
    "hi.mobile.bodyXs": 14,
    "hi.mobile.bodyXsBold": 14,
    "hi.mobile.bodyXsLink": 14,
    "hi.mobile.bodyXxs": 12,
    "hi.mobile.bodyXxsBold": 12,
    "hi.mobile.bodyXxsLink": 12,
    "hi.mobile.body3xs": 11,
    "hi.mobile.body3xsBold": 11,
    "hi.mobile.body3xsLink": 11,
    "hi.mobile.listTitle": 16,
    "hi.mobile.button": 16,
    "hi.mobile.code": 12,
    "kn.desktop.headingXl": 88,
    "kn.desktop.headingL": 64,
    "kn.desktop.headingM": 40,
    "kn.desktop.headingS": 32,
    "kn.desktop.headingXs": 24,
    "kn.desktop.headingXxs": 16,
    "kn.desktop.overline": 12,
    "kn.desktop.bodyL": 24,
    "kn.desktop.bodyLBold": 24,
    "kn.desktop.bodyLLink": 24,
    "kn.desktop.bodyM": 18,
    "kn.desktop.bodyMBold": 18,
    "kn.desktop.bodyMLink": 18,
    "kn.desktop.bodyS": 16,
    "kn.desktop.bodySBold": 16,
    "kn.desktop.bodySLink": 16,
    "kn.desktop.bodyXs": 14,
    "kn.desktop.bodyXsBold": 14,
    "kn.desktop.bodyXsLink": 14,
    "kn.desktop.bodyXxs": 12,
    "kn.desktop.bodyXxsBold": 12,
    "kn.desktop.bodyXxsLink": 12,
    "kn.desktop.body3xs": 11,
    "kn.desktop.body3xsBold": 11,
    "kn.desktop.body3xsLink": 11,
    "kn.desktop.listTitle": 16,
    "kn.desktop.button": 16,
    "kn.desktop.code": 12,
    "kn.mobile.headingXl": 64,
    "kn.mobile.headingL": 48,
    "kn.mobile.headingM": 40,
    "kn.mobile.headingS": 32,
    "kn.mobile.headingXs": 24,
    "kn.mobile.headingXxs": 16,
    "kn.mobile.overline": 12,
    "kn.mobile.bodyL": 24,
    "kn.mobile.bodyLBold": 24,
    "kn.mobile.bodyLLink": 24,
    "kn.mobile.bodyM": 18,
    "kn.mobile.bodyMBold": 18,
    "kn.mobile.bodyMLink": 18,
    "kn.mobile.bodyS": 16,
    "kn.mobile.bodySBold": 16,
    "kn.mobile.bodySLink": 16,
    "kn.mobile.bodyXs": 14,
    "kn.mobile.bodyXsBold": 14,
    "kn.mobile.bodyXsLink": 14,
    "kn.mobile.bodyXxs": 12,
    "kn.mobile.bodyXxsBold": 12,
    "kn.mobile.bodyXxsLink": 12,
    "kn.mobile.body3xs": 11,
    "kn.mobile.body3xsBold": 11,
    "kn.mobile.body3xsLink": 11,
    "kn.mobile.listTitle": 16,
    "kn.mobile.button": 16,
    "kn.mobile.code": 12,
    "ml.desktop.headingXl": 88,
    "ml.desktop.headingL": 64,
    "ml.desktop.headingM": 40,
    "ml.desktop.headingS": 32,
    "ml.desktop.headingXs": 24,
    "ml.desktop.headingXxs": 16,
    "ml.desktop.overline": 12,
    "ml.desktop.bodyL": 24,
    "ml.desktop.bodyLBold": 24,
    "ml.desktop.bodyLLink": 24,
    "ml.desktop.bodyM": 18,
    "ml.desktop.bodyMBold": 18,
    "ml.desktop.bodyMLink": 18,
    "ml.desktop.bodyS": 16,
    "ml.desktop.bodySBold": 16,
    "ml.desktop.bodySLink": 16,
    "ml.desktop.bodyXs": 14,
    "ml.desktop.bodyXsBold": 14,
    "ml.desktop.bodyXsLink": 14,
    "ml.desktop.bodyXxs": 12,
    "ml.desktop.bodyXxsBold": 12,
    "ml.desktop.bodyXxsLink": 12,
    "ml.desktop.body3xs": 11,
    "ml.desktop.body3xsBold": 11,
    "ml.desktop.body3xsLink": 11,
    "ml.desktop.listTitle": 16,
    "ml.desktop.button": 16,
    "ml.desktop.code": 12,
    "ml.mobile.headingXl": 64,
    "ml.mobile.headingL": 48,
    "ml.mobile.headingM": 40,
    "ml.mobile.headingS": 32,
    "ml.mobile.headingXs": 24,
    "ml.mobile.headingXxs": 16,
    "ml.mobile.overline": 12,
    "ml.mobile.bodyL": 24,
    "ml.mobile.bodyLBold": 24,
    "ml.mobile.bodyLLink": 24,
    "ml.mobile.bodyM": 18,
    "ml.mobile.bodyMBold": 18,
    "ml.mobile.bodyMLink": 18,
    "ml.mobile.bodyS": 16,
    "ml.mobile.bodySBold": 16,
    "ml.mobile.bodySLink": 16,
    "ml.mobile.bodyXs": 14,
    "ml.mobile.bodyXsBold": 14,
    "ml.mobile.bodyXsLink": 14,
    "ml.mobile.bodyXxs": 12,
    "ml.mobile.bodyXxsBold": 12,
    "ml.mobile.bodyXxsLink": 12,
    "ml.mobile.body3xs": 11,
    "ml.mobile.body3xsBold": 11,
    "ml.mobile.body3xsLink": 11,
    "ml.mobile.listTitle": 16,
    "ml.mobile.button": 16,
    "ml.mobile.code": 12,
    "mr.desktop.headingXl": 88,
    "mr.desktop.headingL": 64,
    "mr.desktop.headingM": 40,
    "mr.desktop.headingS": 32,
    "mr.desktop.headingXs": 24,
    "mr.desktop.headingXxs": 16,
    "mr.desktop.overline": 12,
    "mr.desktop.bodyL": 24,
    "mr.desktop.bodyLBold": 24,
    "mr.desktop.bodyLLink": 24,
    "mr.desktop.bodyM": 18,
    "mr.desktop.bodyMBold": 18,
    "mr.desktop.bodyMLink": 18,
    "mr.desktop.bodyS": 16,
    "mr.desktop.bodySBold": 16,
    "mr.desktop.bodySLink": 16,
    "mr.desktop.bodyXs": 14,
    "mr.desktop.bodyXsBold": 14,
    "mr.desktop.bodyXsLink": 14,
    "mr.desktop.bodyXxs": 12,
    "mr.desktop.bodyXxsBold": 12,
    "mr.desktop.bodyXxsLink": 12,
    "mr.desktop.body3xs": 11,
    "mr.desktop.body3xsBold": 11,
    "mr.desktop.body3xsLink": 11,
    "mr.desktop.listTitle": 16,
    "mr.desktop.button": 16,
    "mr.desktop.code": 12,
    "mr.mobile.headingXl": 64,
    "mr.mobile.headingL": 48,
    "mr.mobile.headingM": 40,
    "mr.mobile.headingS": 32,
    "mr.mobile.headingXs": 24,
    "mr.mobile.headingXxs": 16,
    "mr.mobile.overline": 12,
    "mr.mobile.bodyL": 24,
    "mr.mobile.bodyLBold": 24,
    "mr.mobile.bodyLLink": 24,
    "mr.mobile.bodyM": 18,
    "mr.mobile.bodyMBold": 18,
    "mr.mobile.bodyMLink": 18,
    "mr.mobile.bodyS": 16,
    "mr.mobile.bodySBold": 16,
    "mr.mobile.bodySLink": 16,
    "mr.mobile.bodyXs": 14,
    "mr.mobile.bodyXsBold": 14,
    "mr.mobile.bodyXsLink": 14,
    "mr.mobile.bodyXxs": 12,
    "mr.mobile.bodyXxsBold": 12,
    "mr.mobile.bodyXxsLink": 12,
    "mr.mobile.body3xs": 11,
    "mr.mobile.body3xsBold": 11,
    "mr.mobile.body3xsLink": 11,
    "mr.mobile.listTitle": 16,
    "mr.mobile.button": 16,
    "mr.mobile.code": 12,
    "or.desktop.headingXl": 88,
    "or.desktop.headingL": 64,
    "or.desktop.headingM": 40,
    "or.desktop.headingS": 32,
    "or.desktop.headingXs": 24,
    "or.desktop.headingXxs": 16,
    "or.desktop.overline": 12,
    "or.desktop.bodyL": 24,
    "or.desktop.bodyLBold": 24,
    "or.desktop.bodyLLink": 24,
    "or.desktop.bodyM": 18,
    "or.desktop.bodyMBold": 18,
    "or.desktop.bodyMLink": 18,
    "or.desktop.bodyS": 16,
    "or.desktop.bodySBold": 16,
    "or.desktop.bodySLink": 16,
    "or.desktop.bodyXs": 14,
    "or.desktop.bodyXsBold": 14,
    "or.desktop.bodyXsLink": 14,
    "or.desktop.bodyXxs": 12,
    "or.desktop.bodyXxsBold": 12,
    "or.desktop.bodyXxsLink": 12,
    "or.desktop.body3xs": 11,
    "or.desktop.body3xsBold": 11,
    "or.desktop.body3xsLink": 11,
    "or.desktop.listTitle": 16,
    "or.desktop.button": 16,
    "or.desktop.code": 12,
    "or.mobile.headingXl": 64,
    "or.mobile.headingL": 48,
    "or.mobile.headingM": 40,
    "or.mobile.headingS": 32,
    "or.mobile.headingXs": 24,
    "or.mobile.headingXxs": 16,
    "or.mobile.overline": 12,
    "or.mobile.bodyL": 24,
    "or.mobile.bodyLBold": 24,
    "or.mobile.bodyLLink": 24,
    "or.mobile.bodyM": 18,
    "or.mobile.bodyMBold": 18,
    "or.mobile.bodyMLink": 18,
    "or.mobile.bodyS": 16,
    "or.mobile.bodySBold": 16,
    "or.mobile.bodySLink": 16,
    "or.mobile.bodyXs": 14,
    "or.mobile.bodyXsBold": 14,
    "or.mobile.bodyXsLink": 14,
    "or.mobile.bodyXxs": 12,
    "or.mobile.bodyXxsBold": 12,
    "or.mobile.bodyXxsLink": 12,
    "or.mobile.body3xs": 11,
    "or.mobile.body3xsBold": 11,
    "or.mobile.body3xsLink": 11,
    "or.mobile.listTitle": 16,
    "or.mobile.button": 16,
    "or.mobile.code": 12,
    "pa.desktop.headingXl": 88,
    "pa.desktop.headingL": 64,
    "pa.desktop.headingM": 40,
    "pa.desktop.headingS": 32,
    "pa.desktop.headingXs": 24,
    "pa.desktop.headingXxs": 16,
    "pa.desktop.overline": 12,
    "pa.desktop.bodyL": 24,
    "pa.desktop.bodyLBold": 24,
    "pa.desktop.bodyLLink": 24,
    "pa.desktop.bodyM": 18,
    "pa.desktop.bodyMBold": 18,
    "pa.desktop.bodyMLink": 18,
    "pa.desktop.bodyS": 16,
    "pa.desktop.bodySBold": 16,
    "pa.desktop.bodySLink": 16,
    "pa.desktop.bodyXs": 14,
    "pa.desktop.bodyXsBold": 14,
    "pa.desktop.bodyXsLink": 14,
    "pa.desktop.bodyXxs": 12,
    "pa.desktop.bodyXxsBold": 12,
    "pa.desktop.bodyXxsLink": 12,
    "pa.desktop.body3xs": 11,
    "pa.desktop.body3xsBold": 11,
    "pa.desktop.body3xsLink": 11,
    "pa.desktop.listTitle": 16,
    "pa.desktop.button": 16,
    "pa.desktop.code": 12,
    "pa.mobile.headingXl": 64,
    "pa.mobile.headingL": 48,
    "pa.mobile.headingM": 40,
    "pa.mobile.headingS": 32,
    "pa.mobile.headingXs": 24,
    "pa.mobile.headingXxs": 16,
    "pa.mobile.overline": 12,
    "pa.mobile.bodyL": 24,
    "pa.mobile.bodyLBold": 24,
    "pa.mobile.bodyLLink": 24,
    "pa.mobile.bodyM": 18,
    "pa.mobile.bodyMBold": 18,
    "pa.mobile.bodyMLink": 18,
    "pa.mobile.bodyS": 16,
    "pa.mobile.bodySBold": 16,
    "pa.mobile.bodySLink": 16,
    "pa.mobile.bodyXs": 14,
    "pa.mobile.bodyXsBold": 14,
    "pa.mobile.bodyXsLink": 14,
    "pa.mobile.bodyXxs": 12,
    "pa.mobile.bodyXxsBold": 12,
    "pa.mobile.bodyXxsLink": 12,
    "pa.mobile.body3xs": 11,
    "pa.mobile.body3xsBold": 11,
    "pa.mobile.body3xsLink": 11,
    "pa.mobile.listTitle": 16,
    "pa.mobile.button": 16,
    "pa.mobile.code": 12,
    "ta.desktop.headingXl": 88,
    "ta.desktop.headingL": 64,
    "ta.desktop.headingM": 40,
    "ta.desktop.headingS": 32,
    "ta.desktop.headingXs": 24,
    "ta.desktop.headingXxs": 16,
    "ta.desktop.overline": 12,
    "ta.desktop.bodyL": 24,
    "ta.desktop.bodyLBold": 24,
    "ta.desktop.bodyLLink": 24,
    "ta.desktop.bodyM": 18,
    "ta.desktop.bodyMBold": 18,
    "ta.desktop.bodyMLink": 18,
    "ta.desktop.bodyS": 16,
    "ta.desktop.bodySBold": 16,
    "ta.desktop.bodySLink": 16,
    "ta.desktop.bodyXs": 14,
    "ta.desktop.bodyXsBold": 14,
    "ta.desktop.bodyXsLink": 14,
    "ta.desktop.bodyXxs": 12,
    "ta.desktop.bodyXxsBold": 12,
    "ta.desktop.bodyXxsLink": 12,
    "ta.desktop.body3xs": 11,
    "ta.desktop.body3xsBold": 11,
    "ta.desktop.body3xsLink": 11,
    "ta.desktop.listTitle": 16,
    "ta.desktop.button": 16,
    "ta.desktop.code": 12,
    "ta.mobile.headingXl": 64,
    "ta.mobile.headingL": 48,
    "ta.mobile.headingM": 40,
    "ta.mobile.headingS": 32,
    "ta.mobile.headingXs": 24,
    "ta.mobile.headingXxs": 16,
    "ta.mobile.overline": 12,
    "ta.mobile.bodyL": 24,
    "ta.mobile.bodyLBold": 24,
    "ta.mobile.bodyLLink": 24,
    "ta.mobile.bodyM": 18,
    "ta.mobile.bodyMBold": 18,
    "ta.mobile.bodyMLink": 18,
    "ta.mobile.bodyS": 16,
    "ta.mobile.bodySBold": 16,
    "ta.mobile.bodySLink": 16,
    "ta.mobile.bodyXs": 14,
    "ta.mobile.bodyXsBold": 14,
    "ta.mobile.bodyXsLink": 14,
    "ta.mobile.bodyXxs": 12,
    "ta.mobile.bodyXxsBold": 12,
    "ta.mobile.bodyXxsLink": 12,
    "ta.mobile.body3xs": 11,
    "ta.mobile.body3xsBold": 11,
    "ta.mobile.body3xsLink": 11,
    "ta.mobile.listTitle": 16,
    "ta.mobile.button": 16,
    "ta.mobile.code": 12,
    "te.desktop.headingXl": 88,
    "te.desktop.headingL": 64,
    "te.desktop.headingM": 40,
    "te.desktop.headingS": 32,
    "te.desktop.headingXs": 24,
    "te.desktop.headingXxs": 16,
    "te.desktop.overline": 12,
    "te.desktop.bodyL": 24,
    "te.desktop.bodyLBold": 24,
    "te.desktop.bodyLLink": 24,
    "te.desktop.bodyM": 18,
    "te.desktop.bodyMBold": 18,
    "te.desktop.bodyMLink": 18,
    "te.desktop.bodyS": 16,
    "te.desktop.bodySBold": 16,
    "te.desktop.bodySLink": 16,
    "te.desktop.bodyXs": 14,
    "te.desktop.bodyXsBold": 14,
    "te.desktop.bodyXsLink": 14,
    "te.desktop.bodyXxs": 12,
    "te.desktop.bodyXxsBold": 12,
    "te.desktop.bodyXxsLink": 12,
    "te.desktop.body3xs": 11,
    "te.desktop.body3xsBold": 11,
    "te.desktop.body3xsLink": 11,
    "te.desktop.listTitle": 16,
    "te.desktop.button": 16,
    "te.desktop.code": 12,
    "te.mobile.headingXl": 64,
    "te.mobile.headingL": 48,
    "te.mobile.headingM": 40,
    "te.mobile.headingS": 32,
    "te.mobile.headingXs": 24,
    "te.mobile.headingXxs": 16,
    "te.mobile.overline": 12,
    "te.mobile.bodyL": 24,
    "te.mobile.bodyLBold": 24,
    "te.mobile.bodyLLink": 24,
    "te.mobile.bodyM": 18,
    "te.mobile.bodyMBold": 18,
    "te.mobile.bodyMLink": 18,
    "te.mobile.bodyS": 16,
    "te.mobile.bodySBold": 16,
    "te.mobile.bodySLink": 16,
    "te.mobile.bodyXs": 14,
    "te.mobile.bodyXsBold": 14,
    "te.mobile.bodyXsLink": 14,
    "te.mobile.bodyXxs": 12,
    "te.mobile.bodyXxsBold": 12,
    "te.mobile.bodyXxsLink": 12,
    "te.mobile.body3xs": 11,
    "te.mobile.body3xsBold": 11,
    "te.mobile.body3xsLink": 11,
    "te.mobile.listTitle": 16,
    "te.mobile.button": 16,
    "te.mobile.code": 12,
    headingXl: $f551aa6589c293c2$var$headingXl$3,
    headingL: $f551aa6589c293c2$var$headingL$3,
    headingM: $f551aa6589c293c2$var$headingM$3,
    headingS: $f551aa6589c293c2$var$headingS$3,
    headingXs: $f551aa6589c293c2$var$headingXs$3,
    headingXxs: $f551aa6589c293c2$var$headingXxs$3,
    overline: $f551aa6589c293c2$var$overline$4,
    bodyL: $f551aa6589c293c2$var$bodyL$3,
    bodyLBold: $f551aa6589c293c2$var$bodyLBold$3,
    bodyLLink: $f551aa6589c293c2$var$bodyLLink$3,
    bodyM: $f551aa6589c293c2$var$bodyM$3,
    bodyMBold: $f551aa6589c293c2$var$bodyMBold$3,
    bodyMLink: $f551aa6589c293c2$var$bodyMLink$3,
    bodyS: $f551aa6589c293c2$var$bodyS$3,
    bodySBold: $f551aa6589c293c2$var$bodySBold$3,
    bodySLink: $f551aa6589c293c2$var$bodySLink$3,
    bodyXs: $f551aa6589c293c2$var$bodyXs$3,
    bodyXsBold: $f551aa6589c293c2$var$bodyXsBold$3,
    bodyXsLink: $f551aa6589c293c2$var$bodyXsLink$3,
    bodyXxs: $f551aa6589c293c2$var$bodyXxs$3,
    bodyXxsBold: $f551aa6589c293c2$var$bodyXxsBold$3,
    bodyXxsLink: $f551aa6589c293c2$var$bodyXxsLink$3,
    body3xs: $f551aa6589c293c2$var$body3xs$3,
    body3xsBold: $f551aa6589c293c2$var$body3xsBold$3,
    body3xsLink: $f551aa6589c293c2$var$body3xsLink$3,
    listTitle: $f551aa6589c293c2$var$listTitle$3,
    button: $f551aa6589c293c2$var$button$3,
    code: $f551aa6589c293c2$var$code$3
};
const $f551aa6589c293c2$var$headingXl$2 = "{$lang.$platform.headingXl}";
const $f551aa6589c293c2$var$headingL$2 = "{$lang.$platform.headingL}";
const $f551aa6589c293c2$var$headingM$2 = "{$lang.$platform.headingM}";
const $f551aa6589c293c2$var$headingS$2 = "{$lang.$platform.headingS}";
const $f551aa6589c293c2$var$headingXs$2 = "{$lang.$platform.headingXs}";
const $f551aa6589c293c2$var$headingXxs$2 = "{$lang.$platform.headingXxs}";
const $f551aa6589c293c2$var$overline$3 = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$bodyL$2 = "{$lang.$platform.bodyL}";
const $f551aa6589c293c2$var$bodyLBold$2 = "{$lang.$platform.bodyLBold}";
const $f551aa6589c293c2$var$bodyLLink$2 = "{$lang.$platform.bodyLLink}";
const $f551aa6589c293c2$var$bodyM$2 = "{$lang.$platform.bodyM}";
const $f551aa6589c293c2$var$bodyMBold$2 = "{$lang.$platform.bodyMBold}";
const $f551aa6589c293c2$var$bodyMLink$2 = "{$lang.$platform.bodyMLink}";
const $f551aa6589c293c2$var$bodyS$2 = "{$lang.$platform.bodyS}";
const $f551aa6589c293c2$var$bodySBold$2 = "{$lang.$platform.bodySBold}";
const $f551aa6589c293c2$var$bodySLink$2 = "{$lang.$platform.bodySLink}";
const $f551aa6589c293c2$var$bodyXs$2 = "{$lang.$platform.bodyXs}";
const $f551aa6589c293c2$var$bodyXsBold$2 = "{$lang.$platform.bodyXsBold}";
const $f551aa6589c293c2$var$bodyXsLink$2 = "{$lang.$platform.bodyXsLink}";
const $f551aa6589c293c2$var$bodyXxs$2 = "{$lang.$platform.bodyXxs}";
const $f551aa6589c293c2$var$bodyXxsBold$2 = "{$lang.$platform.bodyXxsBold}";
const $f551aa6589c293c2$var$bodyXxsLink$2 = "{$lang.$platform.bodyXxsLink}";
const $f551aa6589c293c2$var$body3xs$2 = "{$lang.$platform.body3xs}";
const $f551aa6589c293c2$var$body3xsBold$2 = "{$lang.$platform.body3xsBold}";
const $f551aa6589c293c2$var$body3xsLink$2 = "{$lang.$platform.body3xsLink}";
const $f551aa6589c293c2$var$listTitle$2 = "{$lang.$platform.listTitle}";
const $f551aa6589c293c2$var$button$2 = "{$lang.$platform.button}";
const $f551aa6589c293c2$var$code$2 = "{$lang.$platform.code}";
const $f551aa6589c293c2$var$fontWeights = {
    "400": "400",
    "500": "500",
    "700": "700",
    "800": "800",
    "900": "900",
    "avatar.font.weight": "700",
    "badge.font.weight": "700",
    "button.font.weight": "700",
    "as.desktop.headingXl": 700,
    "as.desktop.headingL": 700,
    "as.desktop.headingM": 700,
    "as.desktop.headingS": 700,
    "as.desktop.headingXs": 700,
    "as.desktop.headingXxs": 700,
    "as.desktop.overline": 700,
    "as.desktop.bodyL": 400,
    "as.desktop.bodyLBold": 700,
    "as.desktop.bodyLLink": 700,
    "as.desktop.bodyM": 400,
    "as.desktop.bodyMBold": 700,
    "as.desktop.bodyMLink": 700,
    "as.desktop.bodyS": 400,
    "as.desktop.bodySBold": 700,
    "as.desktop.bodySLink": 700,
    "as.desktop.bodyXs": 400,
    "as.desktop.bodyXsBold": 700,
    "as.desktop.bodyXsLink": 700,
    "as.desktop.bodyXxs": 400,
    "as.desktop.bodyXxsBold": 700,
    "as.desktop.bodyXxsLink": 700,
    "as.desktop.body3xs": 400,
    "as.desktop.body3xsBold": 700,
    "as.desktop.body3xsLink": 700,
    "as.desktop.listTitle": 400,
    "as.desktop.button": 700,
    "as.desktop.code": 500,
    "as.mobile.headingXl": 700,
    "as.mobile.headingL": 700,
    "as.mobile.headingM": 700,
    "as.mobile.headingS": 700,
    "as.mobile.headingXs": 700,
    "as.mobile.headingXxs": 700,
    "as.mobile.overline": 700,
    "as.mobile.bodyL": 400,
    "as.mobile.bodyLBold": 700,
    "as.mobile.bodyLLink": 700,
    "as.mobile.bodyM": 400,
    "as.mobile.bodyMBold": 700,
    "as.mobile.bodyMLink": 700,
    "as.mobile.bodyS": 400,
    "as.mobile.bodySBold": 700,
    "as.mobile.bodySLink": 700,
    "as.mobile.bodyXs": 400,
    "as.mobile.bodyXsBold": 700,
    "as.mobile.bodyXsLink": 700,
    "as.mobile.bodyXxs": 400,
    "as.mobile.bodyXxsBold": 700,
    "as.mobile.bodyXxsLink": 700,
    "as.mobile.body3xs": 400,
    "as.mobile.body3xsBold": 700,
    "as.mobile.body3xsLink": 700,
    "as.mobile.listTitle": 400,
    "as.mobile.button": 700,
    "as.mobile.code": 500,
    "bn.desktop.headingXl": 700,
    "bn.desktop.headingL": 700,
    "bn.desktop.headingM": 700,
    "bn.desktop.headingS": 700,
    "bn.desktop.headingXs": 700,
    "bn.desktop.headingXxs": 700,
    "bn.desktop.overline": 700,
    "bn.desktop.bodyL": 400,
    "bn.desktop.bodyLBold": 700,
    "bn.desktop.bodyLLink": 700,
    "bn.desktop.bodyM": 400,
    "bn.desktop.bodyMBold": 700,
    "bn.desktop.bodyMLink": 700,
    "bn.desktop.bodyS": 400,
    "bn.desktop.bodySBold": 700,
    "bn.desktop.bodySLink": 700,
    "bn.desktop.bodyXs": 400,
    "bn.desktop.bodyXsBold": 700,
    "bn.desktop.bodyXsLink": 700,
    "bn.desktop.bodyXxs": 400,
    "bn.desktop.bodyXxsBold": 700,
    "bn.desktop.bodyXxsLink": 700,
    "bn.desktop.body3xs": 400,
    "bn.desktop.body3xsBold": 700,
    "bn.desktop.body3xsLink": 700,
    "bn.desktop.listTitle": 400,
    "bn.desktop.button": 700,
    "bn.desktop.code": 500,
    "bn.mobile.headingXl": 700,
    "bn.mobile.headingL": 700,
    "bn.mobile.headingM": 700,
    "bn.mobile.headingS": 700,
    "bn.mobile.headingXs": 700,
    "bn.mobile.headingXxs": 700,
    "bn.mobile.overline": 700,
    "bn.mobile.bodyL": 400,
    "bn.mobile.bodyLBold": 700,
    "bn.mobile.bodyLLink": 700,
    "bn.mobile.bodyM": 400,
    "bn.mobile.bodyMBold": 700,
    "bn.mobile.bodyMLink": 700,
    "bn.mobile.bodyS": 400,
    "bn.mobile.bodySBold": 700,
    "bn.mobile.bodySLink": 700,
    "bn.mobile.bodyXs": 400,
    "bn.mobile.bodyXsBold": 700,
    "bn.mobile.bodyXsLink": 700,
    "bn.mobile.bodyXxs": 400,
    "bn.mobile.bodyXxsBold": 700,
    "bn.mobile.bodyXxsLink": 700,
    "bn.mobile.body3xs": 400,
    "bn.mobile.body3xsBold": 700,
    "bn.mobile.body3xsLink": 700,
    "bn.mobile.listTitle": 400,
    "bn.mobile.button": 700,
    "bn.mobile.code": 500,
    "en.desktop.headingXl": 900,
    "en.desktop.headingL": 900,
    "en.desktop.headingM": 900,
    "en.desktop.headingS": 900,
    "en.desktop.headingXs": 900,
    "en.desktop.headingXxs": 900,
    "en.desktop.overline": 700,
    "en.desktop.bodyL": 500,
    "en.desktop.bodyLBold": 700,
    "en.desktop.bodyLLink": 700,
    "en.desktop.bodyM": 500,
    "en.desktop.bodyMBold": 700,
    "en.desktop.bodyMLink": 700,
    "en.desktop.bodyS": 500,
    "en.desktop.bodySBold": 700,
    "en.desktop.bodySLink": 700,
    "en.desktop.bodyXs": 500,
    "en.desktop.bodyXsBold": 700,
    "en.desktop.bodyXsLink": 700,
    "en.desktop.bodyXxs": 500,
    "en.desktop.bodyXxsBold": 700,
    "en.desktop.bodyXxsLink": 700,
    "en.desktop.body3xs": 500,
    "en.desktop.body3xsBold": 700,
    "en.desktop.body3xsLink": 700,
    "en.desktop.listTitle": 500,
    "en.desktop.button": 700,
    "en.desktop.code": 500,
    "en.mobile.headingXl": 900,
    "en.mobile.headingL": 900,
    "en.mobile.headingM": 900,
    "en.mobile.headingS": 900,
    "en.mobile.headingXs": 900,
    "en.mobile.headingXxs": 900,
    "en.mobile.overline": 700,
    "en.mobile.bodyL": 500,
    "en.mobile.bodyLBold": 700,
    "en.mobile.bodyLLink": 700,
    "en.mobile.bodyM": 500,
    "en.mobile.bodyMBold": 700,
    "en.mobile.bodyMLink": 700,
    "en.mobile.bodyS": 500,
    "en.mobile.bodySBold": 700,
    "en.mobile.bodySLink": 700,
    "en.mobile.bodyXs": 500,
    "en.mobile.bodyXsBold": 700,
    "en.mobile.bodyXsLink": 700,
    "en.mobile.bodyXxs": 500,
    "en.mobile.bodyXxsBold": 700,
    "en.mobile.bodyXxsLink": 700,
    "en.mobile.body3xs": 500,
    "en.mobile.body3xsBold": 700,
    "en.mobile.body3xsLink": 700,
    "en.mobile.listTitle": 500,
    "en.mobile.button": 700,
    "en.mobile.code": 500,
    "gu.desktop.headingXl": 700,
    "gu.desktop.headingL": 700,
    "gu.desktop.headingM": 700,
    "gu.desktop.headingS": 700,
    "gu.desktop.headingXs": 700,
    "gu.desktop.headingXxs": 700,
    "gu.desktop.overline": 700,
    "gu.desktop.bodyL": 400,
    "gu.desktop.bodyLBold": 700,
    "gu.desktop.bodyLLink": 700,
    "gu.desktop.bodyM": 400,
    "gu.desktop.bodyMBold": 700,
    "gu.desktop.bodyMLink": 700,
    "gu.desktop.bodyS": 400,
    "gu.desktop.bodySBold": 700,
    "gu.desktop.bodySLink": 700,
    "gu.desktop.bodyXs": 400,
    "gu.desktop.bodyXsBold": 700,
    "gu.desktop.bodyXsLink": 700,
    "gu.desktop.bodyXxs": 400,
    "gu.desktop.bodyXxsBold": 700,
    "gu.desktop.bodyXxsLink": 700,
    "gu.desktop.body3xs": 400,
    "gu.desktop.body3xsBold": 700,
    "gu.desktop.body3xsLink": 700,
    "gu.desktop.listTitle": 400,
    "gu.desktop.button": 700,
    "gu.desktop.code": 500,
    "gu.mobile.headingXl": 700,
    "gu.mobile.headingL": 700,
    "gu.mobile.headingM": 700,
    "gu.mobile.headingS": 700,
    "gu.mobile.headingXs": 700,
    "gu.mobile.headingXxs": 700,
    "gu.mobile.overline": 700,
    "gu.mobile.bodyL": 400,
    "gu.mobile.bodyLBold": 700,
    "gu.mobile.bodyLLink": 700,
    "gu.mobile.bodyM": 400,
    "gu.mobile.bodyMBold": 700,
    "gu.mobile.bodyMLink": 700,
    "gu.mobile.bodyS": 400,
    "gu.mobile.bodySBold": 700,
    "gu.mobile.bodySLink": 700,
    "gu.mobile.bodyXs": 400,
    "gu.mobile.bodyXsBold": 700,
    "gu.mobile.bodyXsLink": 700,
    "gu.mobile.bodyXxs": 400,
    "gu.mobile.bodyXxsBold": 700,
    "gu.mobile.bodyXxsLink": 700,
    "gu.mobile.body3xs": 400,
    "gu.mobile.body3xsBold": 700,
    "gu.mobile.body3xsLink": 700,
    "gu.mobile.listTitle": 400,
    "gu.mobile.button": 700,
    "gu.mobile.code": 500,
    "hi.desktop.headingXl": 700,
    "hi.desktop.headingL": 700,
    "hi.desktop.headingM": 700,
    "hi.desktop.headingS": 700,
    "hi.desktop.headingXs": 700,
    "hi.desktop.headingXxs": 700,
    "hi.desktop.overline": 700,
    "hi.desktop.bodyL": 400,
    "hi.desktop.bodyLBold": 700,
    "hi.desktop.bodyLLink": 700,
    "hi.desktop.bodyM": 400,
    "hi.desktop.bodyMBold": 700,
    "hi.desktop.bodyMLink": 700,
    "hi.desktop.bodyS": 400,
    "hi.desktop.bodySBold": 700,
    "hi.desktop.bodySLink": 700,
    "hi.desktop.bodyXs": 400,
    "hi.desktop.bodyXsBold": 700,
    "hi.desktop.bodyXsLink": 700,
    "hi.desktop.bodyXxs": 400,
    "hi.desktop.bodyXxsBold": 700,
    "hi.desktop.bodyXxsLink": 700,
    "hi.desktop.body3xs": 400,
    "hi.desktop.body3xsBold": 700,
    "hi.desktop.body3xsLink": 700,
    "hi.desktop.listTitle": 400,
    "hi.desktop.button": 700,
    "hi.desktop.code": 500,
    "hi.mobile.headingXl": 700,
    "hi.mobile.headingL": 700,
    "hi.mobile.headingM": 700,
    "hi.mobile.headingS": 700,
    "hi.mobile.headingXs": 700,
    "hi.mobile.headingXxs": 700,
    "hi.mobile.overline": 700,
    "hi.mobile.bodyL": 400,
    "hi.mobile.bodyLBold": 700,
    "hi.mobile.bodyLLink": 700,
    "hi.mobile.bodyM": 400,
    "hi.mobile.bodyMBold": 700,
    "hi.mobile.bodyMLink": 700,
    "hi.mobile.bodyS": 400,
    "hi.mobile.bodySBold": 700,
    "hi.mobile.bodySLink": 700,
    "hi.mobile.bodyXs": 400,
    "hi.mobile.bodyXsBold": 700,
    "hi.mobile.bodyXsLink": 700,
    "hi.mobile.bodyXxs": 400,
    "hi.mobile.bodyXxsBold": 700,
    "hi.mobile.bodyXxsLink": 700,
    "hi.mobile.body3xs": 400,
    "hi.mobile.body3xsBold": 700,
    "hi.mobile.body3xsLink": 700,
    "hi.mobile.listTitle": 400,
    "hi.mobile.button": 700,
    "hi.mobile.code": 500,
    "kn.desktop.headingXl": 700,
    "kn.desktop.headingL": 700,
    "kn.desktop.headingM": 700,
    "kn.desktop.headingS": 700,
    "kn.desktop.headingXs": 700,
    "kn.desktop.headingXxs": 700,
    "kn.desktop.overline": 700,
    "kn.desktop.bodyL": 400,
    "kn.desktop.bodyLBold": 700,
    "kn.desktop.bodyLLink": 700,
    "kn.desktop.bodyM": 400,
    "kn.desktop.bodyMBold": 700,
    "kn.desktop.bodyMLink": 700,
    "kn.desktop.bodyS": 400,
    "kn.desktop.bodySBold": 700,
    "kn.desktop.bodySLink": 700,
    "kn.desktop.bodyXs": 400,
    "kn.desktop.bodyXsBold": 700,
    "kn.desktop.bodyXsLink": 700,
    "kn.desktop.bodyXxs": 400,
    "kn.desktop.bodyXxsBold": 700,
    "kn.desktop.bodyXxsLink": 700,
    "kn.desktop.body3xs": 400,
    "kn.desktop.body3xsBold": 700,
    "kn.desktop.body3xsLink": 700,
    "kn.desktop.listTitle": 400,
    "kn.desktop.button": 700,
    "kn.desktop.code": 500,
    "kn.mobile.headingXl": 700,
    "kn.mobile.headingL": 700,
    "kn.mobile.headingM": 700,
    "kn.mobile.headingS": 700,
    "kn.mobile.headingXs": 700,
    "kn.mobile.headingXxs": 700,
    "kn.mobile.overline": 700,
    "kn.mobile.bodyL": 400,
    "kn.mobile.bodyLBold": 700,
    "kn.mobile.bodyLLink": 700,
    "kn.mobile.bodyM": 400,
    "kn.mobile.bodyMBold": 700,
    "kn.mobile.bodyMLink": 700,
    "kn.mobile.bodyS": 400,
    "kn.mobile.bodySBold": 700,
    "kn.mobile.bodySLink": 700,
    "kn.mobile.bodyXs": 400,
    "kn.mobile.bodyXsBold": 700,
    "kn.mobile.bodyXsLink": 700,
    "kn.mobile.bodyXxs": 400,
    "kn.mobile.bodyXxsBold": 700,
    "kn.mobile.bodyXxsLink": 700,
    "kn.mobile.body3xs": 400,
    "kn.mobile.body3xsBold": 700,
    "kn.mobile.body3xsLink": 700,
    "kn.mobile.listTitle": 400,
    "kn.mobile.button": 700,
    "kn.mobile.code": 500,
    "ml.desktop.headingXl": 700,
    "ml.desktop.headingL": 700,
    "ml.desktop.headingM": 700,
    "ml.desktop.headingS": 700,
    "ml.desktop.headingXs": 700,
    "ml.desktop.headingXxs": 700,
    "ml.desktop.overline": 700,
    "ml.desktop.bodyL": 400,
    "ml.desktop.bodyLBold": 700,
    "ml.desktop.bodyLLink": 700,
    "ml.desktop.bodyM": 400,
    "ml.desktop.bodyMBold": 700,
    "ml.desktop.bodyMLink": 700,
    "ml.desktop.bodyS": 400,
    "ml.desktop.bodySBold": 700,
    "ml.desktop.bodySLink": 700,
    "ml.desktop.bodyXs": 400,
    "ml.desktop.bodyXsBold": 700,
    "ml.desktop.bodyXsLink": 700,
    "ml.desktop.bodyXxs": 400,
    "ml.desktop.bodyXxsBold": 700,
    "ml.desktop.bodyXxsLink": 700,
    "ml.desktop.body3xs": 400,
    "ml.desktop.body3xsBold": 700,
    "ml.desktop.body3xsLink": 700,
    "ml.desktop.listTitle": 400,
    "ml.desktop.button": 700,
    "ml.desktop.code": 500,
    "ml.mobile.headingXl": 700,
    "ml.mobile.headingL": 700,
    "ml.mobile.headingM": 700,
    "ml.mobile.headingS": 700,
    "ml.mobile.headingXs": 700,
    "ml.mobile.headingXxs": 700,
    "ml.mobile.overline": 700,
    "ml.mobile.bodyL": 400,
    "ml.mobile.bodyLBold": 700,
    "ml.mobile.bodyLLink": 700,
    "ml.mobile.bodyM": 400,
    "ml.mobile.bodyMBold": 700,
    "ml.mobile.bodyMLink": 700,
    "ml.mobile.bodyS": 400,
    "ml.mobile.bodySBold": 700,
    "ml.mobile.bodySLink": 700,
    "ml.mobile.bodyXs": 400,
    "ml.mobile.bodyXsBold": 700,
    "ml.mobile.bodyXsLink": 700,
    "ml.mobile.bodyXxs": 400,
    "ml.mobile.bodyXxsBold": 700,
    "ml.mobile.bodyXxsLink": 700,
    "ml.mobile.body3xs": 400,
    "ml.mobile.body3xsBold": 700,
    "ml.mobile.body3xsLink": 700,
    "ml.mobile.listTitle": 400,
    "ml.mobile.button": 700,
    "ml.mobile.code": 500,
    "mr.desktop.headingXl": 700,
    "mr.desktop.headingL": 700,
    "mr.desktop.headingM": 700,
    "mr.desktop.headingS": 700,
    "mr.desktop.headingXs": 700,
    "mr.desktop.headingXxs": 700,
    "mr.desktop.overline": 700,
    "mr.desktop.bodyL": 400,
    "mr.desktop.bodyLBold": 700,
    "mr.desktop.bodyLLink": 700,
    "mr.desktop.bodyM": 400,
    "mr.desktop.bodyMBold": 700,
    "mr.desktop.bodyMLink": 700,
    "mr.desktop.bodyS": 400,
    "mr.desktop.bodySBold": 700,
    "mr.desktop.bodySLink": 700,
    "mr.desktop.bodyXs": 400,
    "mr.desktop.bodyXsBold": 700,
    "mr.desktop.bodyXsLink": 700,
    "mr.desktop.bodyXxs": 400,
    "mr.desktop.bodyXxsBold": 700,
    "mr.desktop.bodyXxsLink": 700,
    "mr.desktop.body3xs": 400,
    "mr.desktop.body3xsBold": 700,
    "mr.desktop.body3xsLink": 700,
    "mr.desktop.listTitle": 400,
    "mr.desktop.button": 700,
    "mr.desktop.code": 500,
    "mr.mobile.headingXl": 700,
    "mr.mobile.headingL": 700,
    "mr.mobile.headingM": 700,
    "mr.mobile.headingS": 700,
    "mr.mobile.headingXs": 700,
    "mr.mobile.headingXxs": 700,
    "mr.mobile.overline": 700,
    "mr.mobile.bodyL": 400,
    "mr.mobile.bodyLBold": 700,
    "mr.mobile.bodyLLink": 700,
    "mr.mobile.bodyM": 400,
    "mr.mobile.bodyMBold": 700,
    "mr.mobile.bodyMLink": 700,
    "mr.mobile.bodyS": 400,
    "mr.mobile.bodySBold": 700,
    "mr.mobile.bodySLink": 700,
    "mr.mobile.bodyXs": 400,
    "mr.mobile.bodyXsBold": 700,
    "mr.mobile.bodyXsLink": 700,
    "mr.mobile.bodyXxs": 400,
    "mr.mobile.bodyXxsBold": 700,
    "mr.mobile.bodyXxsLink": 700,
    "mr.mobile.body3xs": 400,
    "mr.mobile.body3xsBold": 700,
    "mr.mobile.body3xsLink": 700,
    "mr.mobile.listTitle": 400,
    "mr.mobile.button": 700,
    "mr.mobile.code": 500,
    "or.desktop.headingXl": 700,
    "or.desktop.headingL": 700,
    "or.desktop.headingM": 700,
    "or.desktop.headingS": 700,
    "or.desktop.headingXs": 700,
    "or.desktop.headingXxs": 700,
    "or.desktop.overline": 700,
    "or.desktop.bodyL": 400,
    "or.desktop.bodyLBold": 700,
    "or.desktop.bodyLLink": 700,
    "or.desktop.bodyM": 400,
    "or.desktop.bodyMBold": 700,
    "or.desktop.bodyMLink": 700,
    "or.desktop.bodyS": 400,
    "or.desktop.bodySBold": 700,
    "or.desktop.bodySLink": 700,
    "or.desktop.bodyXs": 400,
    "or.desktop.bodyXsBold": 700,
    "or.desktop.bodyXsLink": 700,
    "or.desktop.bodyXxs": 400,
    "or.desktop.bodyXxsBold": 700,
    "or.desktop.bodyXxsLink": 700,
    "or.desktop.body3xs": 400,
    "or.desktop.body3xsBold": 700,
    "or.desktop.body3xsLink": 700,
    "or.desktop.listTitle": 400,
    "or.desktop.button": 700,
    "or.desktop.code": 500,
    "or.mobile.headingXl": 700,
    "or.mobile.headingL": 700,
    "or.mobile.headingM": 700,
    "or.mobile.headingS": 700,
    "or.mobile.headingXs": 700,
    "or.mobile.headingXxs": 700,
    "or.mobile.overline": 700,
    "or.mobile.bodyL": 400,
    "or.mobile.bodyLBold": 700,
    "or.mobile.bodyLLink": 700,
    "or.mobile.bodyM": 400,
    "or.mobile.bodyMBold": 700,
    "or.mobile.bodyMLink": 700,
    "or.mobile.bodyS": 400,
    "or.mobile.bodySBold": 700,
    "or.mobile.bodySLink": 700,
    "or.mobile.bodyXs": 400,
    "or.mobile.bodyXsBold": 700,
    "or.mobile.bodyXsLink": 700,
    "or.mobile.bodyXxs": 400,
    "or.mobile.bodyXxsBold": 700,
    "or.mobile.bodyXxsLink": 700,
    "or.mobile.body3xs": 400,
    "or.mobile.body3xsBold": 700,
    "or.mobile.body3xsLink": 700,
    "or.mobile.listTitle": 400,
    "or.mobile.button": 700,
    "or.mobile.code": 500,
    "pa.desktop.headingXl": 700,
    "pa.desktop.headingL": 700,
    "pa.desktop.headingM": 700,
    "pa.desktop.headingS": 700,
    "pa.desktop.headingXs": 700,
    "pa.desktop.headingXxs": 700,
    "pa.desktop.overline": 700,
    "pa.desktop.bodyL": 400,
    "pa.desktop.bodyLBold": 700,
    "pa.desktop.bodyLLink": 700,
    "pa.desktop.bodyM": 400,
    "pa.desktop.bodyMBold": 700,
    "pa.desktop.bodyMLink": 700,
    "pa.desktop.bodyS": 400,
    "pa.desktop.bodySBold": 700,
    "pa.desktop.bodySLink": 700,
    "pa.desktop.bodyXs": 400,
    "pa.desktop.bodyXsBold": 700,
    "pa.desktop.bodyXsLink": 700,
    "pa.desktop.bodyXxs": 400,
    "pa.desktop.bodyXxsBold": 700,
    "pa.desktop.bodyXxsLink": 700,
    "pa.desktop.body3xs": 400,
    "pa.desktop.body3xsBold": 700,
    "pa.desktop.body3xsLink": 700,
    "pa.desktop.listTitle": 400,
    "pa.desktop.button": 700,
    "pa.desktop.code": 500,
    "pa.mobile.headingXl": 700,
    "pa.mobile.headingL": 700,
    "pa.mobile.headingM": 700,
    "pa.mobile.headingS": 700,
    "pa.mobile.headingXs": 700,
    "pa.mobile.headingXxs": 700,
    "pa.mobile.overline": 700,
    "pa.mobile.bodyL": 400,
    "pa.mobile.bodyLBold": 700,
    "pa.mobile.bodyLLink": 700,
    "pa.mobile.bodyM": 400,
    "pa.mobile.bodyMBold": 700,
    "pa.mobile.bodyMLink": 700,
    "pa.mobile.bodyS": 400,
    "pa.mobile.bodySBold": 700,
    "pa.mobile.bodySLink": 700,
    "pa.mobile.bodyXs": 400,
    "pa.mobile.bodyXsBold": 700,
    "pa.mobile.bodyXsLink": 700,
    "pa.mobile.bodyXxs": 400,
    "pa.mobile.bodyXxsBold": 700,
    "pa.mobile.bodyXxsLink": 700,
    "pa.mobile.body3xs": 400,
    "pa.mobile.body3xsBold": 700,
    "pa.mobile.body3xsLink": 700,
    "pa.mobile.listTitle": 400,
    "pa.mobile.button": 700,
    "pa.mobile.code": 500,
    "ta.desktop.headingXl": 700,
    "ta.desktop.headingL": 700,
    "ta.desktop.headingM": 700,
    "ta.desktop.headingS": 700,
    "ta.desktop.headingXs": 700,
    "ta.desktop.headingXxs": 700,
    "ta.desktop.overline": 700,
    "ta.desktop.bodyL": 400,
    "ta.desktop.bodyLBold": 700,
    "ta.desktop.bodyLLink": 700,
    "ta.desktop.bodyM": 400,
    "ta.desktop.bodyMBold": 700,
    "ta.desktop.bodyMLink": 700,
    "ta.desktop.bodyS": 400,
    "ta.desktop.bodySBold": 700,
    "ta.desktop.bodySLink": 700,
    "ta.desktop.bodyXs": 400,
    "ta.desktop.bodyXsBold": 700,
    "ta.desktop.bodyXsLink": 700,
    "ta.desktop.bodyXxs": 400,
    "ta.desktop.bodyXxsBold": 700,
    "ta.desktop.bodyXxsLink": 700,
    "ta.desktop.body3xs": 400,
    "ta.desktop.body3xsBold": 700,
    "ta.desktop.body3xsLink": 700,
    "ta.desktop.listTitle": 400,
    "ta.desktop.button": 700,
    "ta.desktop.code": 500,
    "ta.mobile.headingXl": 700,
    "ta.mobile.headingL": 700,
    "ta.mobile.headingM": 700,
    "ta.mobile.headingS": 700,
    "ta.mobile.headingXs": 700,
    "ta.mobile.headingXxs": 700,
    "ta.mobile.overline": 700,
    "ta.mobile.bodyL": 400,
    "ta.mobile.bodyLBold": 700,
    "ta.mobile.bodyLLink": 700,
    "ta.mobile.bodyM": 400,
    "ta.mobile.bodyMBold": 700,
    "ta.mobile.bodyMLink": 700,
    "ta.mobile.bodyS": 400,
    "ta.mobile.bodySBold": 700,
    "ta.mobile.bodySLink": 700,
    "ta.mobile.bodyXs": 400,
    "ta.mobile.bodyXsBold": 700,
    "ta.mobile.bodyXsLink": 700,
    "ta.mobile.bodyXxs": 400,
    "ta.mobile.bodyXxsBold": 700,
    "ta.mobile.bodyXxsLink": 700,
    "ta.mobile.body3xs": 400,
    "ta.mobile.body3xsBold": 700,
    "ta.mobile.body3xsLink": 700,
    "ta.mobile.listTitle": 400,
    "ta.mobile.button": 700,
    "ta.mobile.code": 500,
    "te.desktop.headingXl": 700,
    "te.desktop.headingL": 700,
    "te.desktop.headingM": 700,
    "te.desktop.headingS": 700,
    "te.desktop.headingXs": 700,
    "te.desktop.headingXxs": 700,
    "te.desktop.overline": 700,
    "te.desktop.bodyL": 400,
    "te.desktop.bodyLBold": 700,
    "te.desktop.bodyLLink": 700,
    "te.desktop.bodyM": 400,
    "te.desktop.bodyMBold": 700,
    "te.desktop.bodyMLink": 700,
    "te.desktop.bodyS": 400,
    "te.desktop.bodySBold": 700,
    "te.desktop.bodySLink": 700,
    "te.desktop.bodyXs": 400,
    "te.desktop.bodyXsBold": 700,
    "te.desktop.bodyXsLink": 700,
    "te.desktop.bodyXxs": 400,
    "te.desktop.bodyXxsBold": 700,
    "te.desktop.bodyXxsLink": 700,
    "te.desktop.body3xs": 400,
    "te.desktop.body3xsBold": 700,
    "te.desktop.body3xsLink": 700,
    "te.desktop.listTitle": 400,
    "te.desktop.button": 700,
    "te.desktop.code": 500,
    "te.mobile.headingXl": 700,
    "te.mobile.headingL": 700,
    "te.mobile.headingM": 700,
    "te.mobile.headingS": 700,
    "te.mobile.headingXs": 700,
    "te.mobile.headingXxs": 700,
    "te.mobile.overline": 700,
    "te.mobile.bodyL": 400,
    "te.mobile.bodyLBold": 700,
    "te.mobile.bodyLLink": 700,
    "te.mobile.bodyM": 400,
    "te.mobile.bodyMBold": 700,
    "te.mobile.bodyMLink": 700,
    "te.mobile.bodyS": 400,
    "te.mobile.bodySBold": 700,
    "te.mobile.bodySLink": 700,
    "te.mobile.bodyXs": 400,
    "te.mobile.bodyXsBold": 700,
    "te.mobile.bodyXsLink": 700,
    "te.mobile.bodyXxs": 400,
    "te.mobile.bodyXxsBold": 700,
    "te.mobile.bodyXxsLink": 700,
    "te.mobile.body3xs": 400,
    "te.mobile.body3xsBold": 700,
    "te.mobile.body3xsLink": 700,
    "te.mobile.listTitle": 400,
    "te.mobile.button": 700,
    "te.mobile.code": 500,
    headingXl: $f551aa6589c293c2$var$headingXl$2,
    headingL: $f551aa6589c293c2$var$headingL$2,
    headingM: $f551aa6589c293c2$var$headingM$2,
    headingS: $f551aa6589c293c2$var$headingS$2,
    headingXs: $f551aa6589c293c2$var$headingXs$2,
    headingXxs: $f551aa6589c293c2$var$headingXxs$2,
    overline: $f551aa6589c293c2$var$overline$3,
    bodyL: $f551aa6589c293c2$var$bodyL$2,
    bodyLBold: $f551aa6589c293c2$var$bodyLBold$2,
    bodyLLink: $f551aa6589c293c2$var$bodyLLink$2,
    bodyM: $f551aa6589c293c2$var$bodyM$2,
    bodyMBold: $f551aa6589c293c2$var$bodyMBold$2,
    bodyMLink: $f551aa6589c293c2$var$bodyMLink$2,
    bodyS: $f551aa6589c293c2$var$bodyS$2,
    bodySBold: $f551aa6589c293c2$var$bodySBold$2,
    bodySLink: $f551aa6589c293c2$var$bodySLink$2,
    bodyXs: $f551aa6589c293c2$var$bodyXs$2,
    bodyXsBold: $f551aa6589c293c2$var$bodyXsBold$2,
    bodyXsLink: $f551aa6589c293c2$var$bodyXsLink$2,
    bodyXxs: $f551aa6589c293c2$var$bodyXxs$2,
    bodyXxsBold: $f551aa6589c293c2$var$bodyXxsBold$2,
    bodyXxsLink: $f551aa6589c293c2$var$bodyXxsLink$2,
    body3xs: $f551aa6589c293c2$var$body3xs$2,
    body3xsBold: $f551aa6589c293c2$var$body3xsBold$2,
    body3xsLink: $f551aa6589c293c2$var$body3xsLink$2,
    listTitle: $f551aa6589c293c2$var$listTitle$2,
    button: $f551aa6589c293c2$var$button$2,
    code: $f551aa6589c293c2$var$code$2
};
const $f551aa6589c293c2$var$JSON_MAP$1 = {
    "JDSActionButton": {
        "a_0": "{global.transparent}",
        "a_1": "{opacity.enabled}",
        "a_2": "{flexDirection.stack}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.center}",
        "a_5": "{pill}",
        "a_6": "{primary50}",
        "a_7": "{flexDirection.row}",
        "a_8": "{alignItems.center}",
        "a_9": "{justifyContent.center}",
        "a_10": "{pill}",
        "a_11": "{xs}",
        "a_12": "{base}",
        "a_13": "{xs}",
        "a_14": "{base}",
        "a_15": "{xs}",
        "a_16": "{primary30}",
        "a_17": "{primary60}",
        "a_18": "{border_focus}",
        "a_19": "{primary60}",
        "a_20": "{primary50}",
        "a_21": "{global.transparent}",
        "a_22": "{primaryGrey40}",
        "a_23": "{border_focus}",
        "a_24": "{border_none}",
        "a_25": "{opacity.enabled}",
        "a_26": "{m}",
        "a_27": "{m}",
        "a_28": "{primaryInverse}",
        "a_29": "{primary70}",
        "a_30": "{primaryInverse}",
        "a_31": "{m}",
        "a_32": "{primaryInverse}",
        "a_33": "{primary70}",
        "a_34": "{primaryInverse}",
        "a_35": "{xxs}",
        "a_36": "{s}",
        "a_37": "{xxs}",
        "a_38": "{s}",
        "a_39": "{xxs}",
        "a_40": "{base}",
        "a_41": "{base}",
        "a_42": "{m}",
        "a_43": "{s}",
        "a_44": "{m}",
        "a_45": "{s}",
        "a_46": "{m}",
        "a_47": "{xs}",
        "a_48": "{m}",
        "a_49": "{m}",
        "a_50": "{m}",
        "a_51": "{base}",
        "a_52": "{l}",
        "a_53": "{base}",
        "a_54": "{l}",
        "a_55": "{xs}",
        "a_56": "{l}",
        "a_57": "{l}",
        "a_58": "{xxl}",
        "a_59": "{opacity.disabled}",
        "a_60": "{opacity.invisible}",
        "a_61": "{opacity.invisible}",
        "a_62": "{opacity.invisible}",
        "a_63": "{opacity.disabled}",
        "a_64": "{opacity.enabled}",
        "a_65": "{global.transparent}",
        "a_66": "{border_thin}",
        "a_67": "{primaryGrey60}",
        "a_68": "{primary20}",
        "a_69": "{primary30}",
        "a_70": "{border_focus}",
        "a_71": "{primary60}",
        "a_72": "{primary60}",
        "a_73": "{primary60}",
        "a_74": "{primary70}",
        "a_75": "{primary60}",
        "a_76": "{primary60}",
        "a_77": "{primary70}",
        "a_78": "{custom_5}",
        "a_79": "{custom_5}",
        "a_80": "{custom_5}",
        "a_81": "{custom_5}",
        "a_82": "{global.transparent}",
        "a_83": "{primary20}",
        "a_84": "{primary30}",
        "a_85": "{border_focus}",
        "a_86": "{custom_1}",
        "a_87": "{primary60}",
        "a_88": "{primary60}",
        "a_89": "{primary50}",
        "a_90": "{primary70}",
        "a_91": "{primary60}",
        "a_92": "{primary50}",
        "a_93": "{primary70}",
        "a_94": "{feedbackSuccess50}",
        "a_95": "{feedbackSuccess20}",
        "a_96": "{feedbackSuccess80}",
        "a_97": "{primary60}",
        "a_98": "{global.white}",
        "a_99": "{feedbackSuccess80}",
        "a_100": "{primaryBackground}",
        "a_101": "{global.white}",
        "a_102": "{feedbackSuccess80}",
        "a_103": "{primaryBackground}",
        "a_104": "{global.transparent}",
        "a_105": "{border_thin}",
        "a_106": "{primaryGrey60}",
        "a_107": "{feedbackSuccess20}",
        "a_108": "{feedbackSuccess80}",
        "a_109": "{primary60}",
        "a_110": "{feedbackSuccess80}",
        "a_111": "{feedbackSuccess80}",
        "a_112": "{primaryBackground}",
        "a_113": "{feedbackSuccess80}",
        "a_114": "{feedbackSuccess80}",
        "a_115": "{primaryBackground}",
        "a_116": "{global.transparent}",
        "a_117": "{custom_1}",
        "a_118": "{feedbackSuccess20}",
        "a_119": "{feedbackSuccess80}",
        "a_120": "{primary60}",
        "a_121": "{feedbackSuccess80}",
        "a_122": "{feedbackSuccess50}",
        "a_123": "{primaryGrey100}",
        "a_124": "{feedbackSuccess80}",
        "a_125": "{feedbackSuccess50}",
        "a_126": "{primaryGrey100}",
        "a_127": "{custom_5}",
        "a_128": "{custom_5}",
        "a_129": "{feedbackError50}",
        "a_130": "{feedbackError20}",
        "a_131": "{feedbackError80}",
        "a_132": "{primary60}",
        "a_133": "{global.white}",
        "a_134": "{feedbackError80}",
        "a_135": "{primaryBackground}",
        "a_136": "{global.white}",
        "a_137": "{feedbackError80}",
        "a_138": "{primaryBackground}",
        "a_139": "{global.transparent}",
        "a_140": "{border_thin}",
        "a_141": "{primaryGrey60}",
        "a_142": "{feedbackError20}",
        "a_143": "{feedbackError80}",
        "a_144": "{primary60}",
        "a_145": "{feedbackError80}",
        "a_146": "{feedbackError80}",
        "a_147": "{primaryBackground}",
        "a_148": "{feedbackError80}",
        "a_149": "{feedbackError80}",
        "a_150": "{primaryBackground}",
        "a_151": "{global.transparent}",
        "a_152": "{pill}",
        "a_153": "{feedbackError20}",
        "a_154": "{feedbackError80}",
        "a_155": "{primary60}",
        "a_156": "{feedbackError80}",
        "a_157": "{feedbackError50}",
        "a_158": "{primaryGrey100}",
        "a_159": "{feedbackError80}",
        "a_160": "{feedbackError50}",
        "a_161": "{primaryGrey100}",
        "a_162": "{custom_5}",
        "a_163": "{custom_5}",
        "a_164": "{primaryBackground}",
        "a_165": "{primary20}",
        "a_166": "{primary30}",
        "a_167": "{primary50}",
        "a_168": "{primaryGrey100}",
        "a_169": "{primaryGrey100}",
        "a_170": "{primaryGrey100}",
        "a_171": "{primaryGrey100}",
        "a_172": "{primaryGrey100}",
        "a_173": "{primaryGrey100}",
        "a_174": "{global.transparent}",
        "a_175": "{border_thin}",
        "a_176": "{primaryGrey60}",
        "a_177": "{primary20}",
        "a_178": "{primary30}",
        "a_179": "{border_focus}",
        "a_180": "{primary50}",
        "a_181": "{primaryBackground}",
        "a_182": "{primaryGrey100}",
        "a_183": "{primaryGrey100}",
        "a_184": "{primaryBackground}",
        "a_185": "{primaryGrey100}",
        "a_186": "{primaryGrey100}",
        "a_187": "{global.transparent}",
        "a_188": "{pill}",
        "a_189": "{primary20}",
        "a_190": "{primary30}",
        "a_191": "{border_focus}",
        "a_192": "{primary50}",
        "a_193": "{primaryBackground}",
        "a_194": "{primaryGrey100}",
        "a_195": "{primaryGrey100}",
        "a_196": "{primaryBackground}",
        "a_197": "{primaryGrey100}",
        "a_198": "{primaryGrey100}",
        "a_199": "{base}",
        "a_200": "{base}",
        "a_201": "{m}",
        "a_202": "{m}",
        "a_203": "{l}",
        "a_204": "{l}",
        "a_205": "{size.max}",
        "a_206": "{size.max}"
    },
    "JDSAvatar": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary80}",
        "a_9": "{m}",
        "a_10": "{m}",
        "a_11": "{l}",
        "a_12": "{l}",
        "a_13": "{xxl}",
        "a_14": "{xxl}",
        "a_15": "{custom_1}",
        "a_16": "{custom_1}",
        "a_17": "{opacity.enabled}",
        "a_18": "{opacity.disabled}",
        "a_19": "{sparkle20}",
        "a_20": "{border_focus}",
        "a_21": "{sparkle40}",
        "a_22": "{border_focus}",
        "a_23": "{sparkle40}",
        "a_24": "{opacity.disabled}",
        "a_25": "{border_focus}",
        "a_26": "{opacity.disabled}"
    },
    "JDSAvatarV2Default": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary60}",
        "a_9": "{opacity.enabled}",
        "a_10": "{primary30}",
        "a_11": "{border_focus}",
        "a_12": "{custom_3}",
        "a_13": "{primary60}",
        "a_14": "{primary50}",
        "a_15": "{primary70}",
        "a_16": "{m}",
        "a_17": "{m}",
        "a_18": "{l}",
        "a_19": "{l}",
        "a_20": "{xxl}",
        "a_21": "{xxl}",
        "a_22": "{custom_11}",
        "a_23": "{custom_11}",
        "a_24": "{custom_1}",
        "a_25": "{custom_1}",
        "a_26": "{base}",
        "a_27": "{m}",
        "a_28": "{l}",
        "a_29": "{xl}",
        "a_30": "{xxl}",
        "a_31": "{opacity.disabled}",
        "a_32": "{sparkle20}",
        "a_33": "{opacity.disabled}",
        "a_34": "{primaryBackground}",
        "a_35": "{opacity.disabled}",
        "a_36": "{primaryGrey80}"
    },
    "JDSAccordionList": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.column}",
        "a_3": "{size.max}"
    },
    "JDSMobileBottomSheet": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{custom_color_3}",
        "m_5": "{opacity.invisible}",
        "m_6": "{medium}",
        "m_7": "{easeEntrance}",
        "m_8": "{global.transparent}",
        "m_9": "{global.transparent}",
        "m_10": "{opacity.enabled}",
        "m_11": "{easeExit}"
    },
    "JDSMobileBottomSheetInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.end}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{primaryBackground}",
        "m_7": "{alignItems.start}",
        "m_8": "{xl}",
        "m_9": "{xl}",
        "m_10": "{size.max}",
        "m_11": "{size.max}",
        "m_12": "{medium}",
        "m_13": "{easeEntrance}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.end}",
        "m_16": "{alignItems.center}",
        "m_17": "{size.max}",
        "m_18": "{xxs}",
        "m_19": "{xxs}",
        "m_20": "{xs}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": 1,
        "m_24": 1,
        "m_25": "{base}",
        "m_26": "{flexDirection.column}",
        "m_27": "{justifyContent.start}",
        "m_28": "{alignItems.start}",
        "m_29": "{m}",
        "m_30": "{m}",
        "m_31": "{size.max}",
        "m_32": "{xs}",
        "m_33": "{m}",
        "m_34": "{flexDirection.column}",
        "m_35": "{base}",
        "m_36": "{size.max}",
        "m_37": "{m}",
        "m_38": "{m}",
        "m_39": "{flexDirection.column}",
        "m_40": "{justifyContent.start}",
        "m_41": "{alignItems.start}",
        "m_42": "{primaryBackground}",
        "m_43": "{xl}",
        "m_44": "{xl}",
        "m_45": "{m}",
        "m_46": "{m}",
        "m_47": "{m}",
        "m_48": "{m}",
        "m_49": "{size.max}",
        "m_50": "{size.max}",
        "m_51": "{medium}",
        "m_52": "{easeEntrance}",
        "m_53": 0,
        "m_54": 4,
        "m_55": 24,
        "m_56": 0,
        "m_57": "{custom_color_5}",
        "m_58": 0,
        "m_59": "{m}",
        "m_60": 0,
        "m_61": "{size.max}"
    },
    "JDSBadge": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xxs}",
        "b_4": "{xs}",
        "b_5": "{xs}",
        "b_6": "{xxs}",
        "b_7": "{xxs}",
        "b_8": "{sparkle60}",
        "b_9": "{medium}",
        "b_10": "{base}",
        "b_11": "{sparkleGrey20}",
        "b_12": "{justifyContent.start}",
        "b_13": "{alignItems.start}",
        "b_14": "{bodySBold}",
        "b_15": "{bodySBold}",
        "b_16": "{bodySBold}",
        "b_17": "{bodySBold}",
        "b_18": "{bodySBold}",
        "b_19": "{sparkleGrey20}",
        "b_20": "{text-case.uppercase}",
        "b_21": "{pill}",
        "b_22": "{custom_color_2}",
        "b_23": "{xxs}",
        "b_24": "{xxs}",
        "b_25": "{s}",
        "b_26": "{xxs}",
        "b_27": "{xs}",
        "b_28": "{bodyMBold}",
        "b_29": "{bodyMBold}",
        "b_30": "{bodyMBold}",
        "b_31": "{bodyMBold}",
        "b_32": "{bodyMBold}",
        "b_33": "{global.white}",
        "b_34": "{m}",
        "b_35": "{custom_color_1}",
        "b_36": "{small}",
        "b_37": "{s}",
        "b_38": "{bodyXxsBold}",
        "b_39": "{bodyXxsBold}",
        "b_40": "{bodyXxsBold}",
        "b_41": "{bodyXxsBold}",
        "b_42": "{bodyXxsBold}",
        "b_43": "{s}",
        "b_44": "{s}",
        "b_45": "{xs}",
        "b_46": "{m}",
        "b_47": "{bodyLBold}",
        "b_48": "{bodyLBold}",
        "b_49": "{bodyLBold}",
        "b_50": "{bodyLBold}",
        "b_51": "{bodyLBold}"
    },
    "JDSBadgeV2Brand": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{primary50}",
        "b_4": "{xxs}",
        "b_5": "{pill}",
        "b_6": "{xs}",
        "b_7": "{s}",
        "b_8": "{xxs}",
        "b_9": "{xxs}",
        "b_10": "{pill}",
        "b_11": "{custom_18}",
        "b_12": "{medium}",
        "b_13": "{medium}",
        "b_14": "{medium}",
        "b_15": "{medium}",
        "b_16": "{small}",
        "b_17": "{xxs}",
        "b_18": "{xxs}",
        "b_19": "{custom_5}",
        "b_20": "{custom_5}",
        "b_21": "{s}",
        "b_22": "{xxs}",
        "b_23": "{xs}",
        "b_24": "{custom_4}",
        "b_25": "{custom_4}",
        "b_26": "{s}",
        "b_27": "{xxs}",
        "b_28": "{xs}",
        "b_29": "{custom_4}",
        "b_30": "{custom_4}",
        "b_31": "{base}",
        "b_32": "{xxs}",
        "b_33": "{xs}",
        "b_34": "{xxs}",
        "b_35": "{xxs}",
        "b_36": "{custom_18}",
        "b_37": "{xs}",
        "b_38": "{custom_3}",
        "b_39": "{primary60}",
        "b_40": "{custom_5}",
        "b_41": "{custom_5}",
        "b_42": "{custom_5}",
        "b_43": "{base}",
        "b_44": "{custom_5}",
        "b_45": "{custom_18}",
        "b_46": "{custom_5}",
        "b_47": "{m}",
        "b_48": "{custom_5}",
        "b_49": "{custom_3}",
        "b_50": "{custom_5}",
        "b_51": "{l}",
        "b_52": "{custom_5}",
        "b_53": "{xl}",
        "b_54": "{small}",
        "b_55": "{custom_5}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{small}",
        "b_59": "{custom_5}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{small}",
        "b_63": "{custom_5}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{small}",
        "b_67": "{custom_5}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{l}",
        "b_71": "{xl}",
        "b_72": "{medium}",
        "b_73": "{small}",
        "b_74": "{small}",
        "b_75": "{xxs}",
        "b_76": "{small}",
        "b_77": "{xxs}",
        "b_78": "{xs}",
        "b_79": "{base}",
        "b_80": "{xs}",
        "b_81": "{small}",
        "b_82": "{xs}"
    },
    "JDSBadgeV2Information": {
        "b_0": "{small}",
        "b_1": "{alignItems.center}",
        "b_2": "{flexDirection.row}",
        "b_3": "{justifyContent.center}",
        "b_4": "{alignItems.center}",
        "b_5": "{sparkle60}",
        "b_6": "{xxs}",
        "b_7": "{small}",
        "b_8": "{xxs}",
        "b_9": "{xs}",
        "b_10": "{custom_4}",
        "b_11": "{custom_4}",
        "b_12": "{flexDirection.row}",
        "b_13": "{justifyContent.center}",
        "b_14": "{alignItems.center}",
        "b_15": "{base}",
        "b_16": "{primaryBackground}",
        "b_17": "{base}",
        "b_18": "{flexDirection.row}",
        "b_19": "{justifyContent.center}",
        "b_20": "{alignItems.center}",
        "b_21": "{base}",
        "b_22": "{secondary60}",
        "b_23": "{secondary60}",
        "b_24": "{primaryBackground}",
        "b_25": "{xxs}",
        "b_26": "{custom_5}",
        "b_27": "{custom_5}",
        "b_28": "{s}",
        "b_29": "{s}",
        "b_30": "{s}",
        "b_31": "{xxs}",
        "b_32": "{custom_5}",
        "b_33": "{custom_5}",
        "b_34": "{s}",
        "b_35": "{s}",
        "b_36": "{s}",
        "b_37": "{xxs}",
        "b_38": "{custom_5}",
        "b_39": "{custom_5}",
        "b_40": "{s}",
        "b_41": "{s}",
        "b_42": "{s}",
        "b_43": "{xs}",
        "b_44": "{xxs}",
        "b_45": "{xxs}",
        "b_46": "{medium}",
        "b_47": "{medium}",
        "b_48": "{xs}",
        "b_49": "{xxs}",
        "b_50": "{xxs}",
        "b_51": "{custom_18}",
        "b_52": "{custom_18}",
        "b_53": "{custom_18}",
        "b_54": "{medium}",
        "b_55": "{medium}",
        "b_56": "{xs}",
        "b_57": "{s}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_3}",
        "b_61": "{custom_3}",
        "b_62": "{custom_3}",
        "b_63": "{feedbackSuccess50}",
        "b_64": "{feedbackSuccess50}",
        "b_65": "{feedbackWarning50}",
        "b_66": "{feedbackWarning50}",
        "b_67": "{feedbackError50}",
        "b_68": "{feedbackError50}",
        "b_69": "{primaryGrey80}",
        "b_70": "{global.transparent}",
        "b_71": "{custom_16}",
        "b_72": "{primaryBackground}",
        "b_73": "{custom_5}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{custom_5}",
        "b_77": "{s}",
        "b_78": "{s}",
        "b_79": "{custom_5}",
        "b_80": "{base}",
        "b_81": "{base}",
        "b_82": "{custom_5}",
        "b_83": "{custom_5}",
        "b_84": "{custom_5}",
        "b_85": "{custom_5}",
        "b_86": "{custom_5}",
        "b_87": "{custom_18}",
        "b_88": "{custom_18}",
        "b_89": "{m}",
        "b_90": "{m}",
        "b_91": "{custom_3}",
        "b_92": "{custom_3}",
        "b_93": "{l}",
        "b_94": "{l}",
        "b_95": "{xl}",
        "b_96": "{xl}",
        "b_97": "{pill}",
        "b_98": "{pill}",
        "b_99": "{custom_5}",
        "b_100": "{s}",
        "b_101": "{pill}",
        "b_102": "{xs}",
        "b_103": "{pill}",
        "b_104": "{pill}",
        "b_105": "{custom_5}",
        "b_106": "{s}",
        "b_107": "{pill}",
        "b_108": "{xs}",
        "b_109": "{pill}",
        "b_110": "{custom_5}",
        "b_111": "{base}",
        "b_112": "{pill}",
        "b_113": "{custom_19}",
        "b_114": "{pill}",
        "b_115": "{custom_5}",
        "b_116": "{custom_18}",
        "b_117": "{pill}",
        "b_118": "{s}",
        "b_119": "{pill}",
        "b_120": "{custom_5}",
        "b_121": "{m}",
        "b_122": "{pill}",
        "b_123": "{base}",
        "b_124": "{pill}",
        "b_125": "{custom_5}",
        "b_126": "{custom_3}",
        "b_127": "{pill}",
        "b_128": "{base}",
        "b_129": "{pill}",
        "b_130": "{custom_5}",
        "b_131": "{l}",
        "b_132": "{pill}",
        "b_133": "{custom_18}",
        "b_134": "{pill}",
        "b_135": "{custom_5}",
        "b_136": "{xl}",
        "b_137": "{pill}",
        "b_138": "{m}",
        "b_139": "{small}",
        "b_140": "{small}",
        "b_141": "{custom_5}",
        "b_142": "{s}",
        "b_143": "{small}",
        "b_144": "{xs}",
        "b_145": "{small}",
        "b_146": "{custom_5}",
        "b_147": "{s}",
        "b_148": "{small}",
        "b_149": "{xs}",
        "b_150": "{small}",
        "b_151": "{custom_5}",
        "b_152": "{base}",
        "b_153": "{small}",
        "b_154": "{custom_19}",
        "b_155": "{small}",
        "b_156": "{custom_5}",
        "b_157": "{custom_18}",
        "b_158": "{small}",
        "b_159": "{s}",
        "b_160": "{small}",
        "b_161": "{custom_5}",
        "b_162": "{m}",
        "b_163": "{small}",
        "b_164": "{base}",
        "b_165": "{small}",
        "b_166": "{custom_5}",
        "b_167": "{custom_3}",
        "b_168": "{small}",
        "b_169": "{base}",
        "b_170": "{medium}",
        "b_171": "{custom_5}",
        "b_172": "{l}",
        "b_173": "{medium}",
        "b_174": "{custom_18}",
        "b_175": "{custom_1}",
        "b_176": "{custom_5}",
        "b_177": "{xl}",
        "b_178": "{custom_1}",
        "b_179": "{m}",
        "b_180": "{base}",
        "b_181": "{base}",
        "b_182": "{base}",
        "b_183": "{custom_18}",
        "b_184": "{xs}",
        "b_185": "{m}",
        "b_186": "{xs}",
        "b_187": "{custom_3}",
        "b_188": "{l}",
        "b_189": "{xl}",
        "b_190": "{s}",
        "b_191": "{base}",
        "b_192": "{base}",
        "b_193": "{base}",
        "b_194": "{custom_18}",
        "b_195": "{m}",
        "b_196": "{custom_3}",
        "b_197": "{l}",
        "b_198": "{xl}",
        "b_199": "{base}",
        "b_200": "{base}",
        "b_201": "{base}",
        "b_202": "{custom_18}",
        "b_203": "{m}",
        "b_204": "{custom_3}",
        "b_205": "{l}",
        "b_206": "{xl}",
        "b_207": "{sparkle20}",
        "b_208": "{sparkle20}",
        "b_209": "{sparkle60}",
        "b_210": "{feedbackSuccess20}",
        "b_211": "{feedbackSuccess20}",
        "b_212": "{feedbackSuccess50}",
        "b_213": "{feedbackWarning20}",
        "b_214": "{feedbackWarning20}",
        "b_215": "{feedbackWarning50}",
        "b_216": "{feedbackError20}",
        "b_217": "{feedbackError20}",
        "b_218": "{feedbackError50}",
        "b_219": "{primaryGrey20}",
        "b_220": "{primaryGrey20}",
        "b_221": "{primaryGrey80}",
        "b_222": "{global.transparent}",
        "b_223": "{global.transparent}",
        "b_224": "{sparkle60}",
        "b_225": "{global.transparent}",
        "b_226": "{global.transparent}",
        "b_227": "{feedbackSuccess50}",
        "b_228": "{global.transparent}",
        "b_229": "{global.transparent}",
        "b_230": "{feedbackWarning50}",
        "b_231": "{global.transparent}",
        "b_232": "{global.transparent}",
        "b_233": "{feedbackError50}",
        "b_234": "{global.transparent}",
        "b_235": "{global.transparent}",
        "b_236": "{primaryGrey80}",
        "b_237": "{global.transparent}",
        "b_238": "{global.transparent}",
        "b_239": "{sparkle60}",
        "b_240": "{global.transparent}",
        "b_241": "{global.transparent}",
        "b_242": "{feedbackSuccess50}",
        "b_243": "{global.transparent}",
        "b_244": "{global.transparent}",
        "b_245": "{feedbackWarning50}",
        "b_246": "{global.transparent}",
        "b_247": "{global.transparent}",
        "b_248": "{feedbackError50}",
        "b_249": "{global.transparent}",
        "b_250": "{global.transparent}",
        "b_251": "{primaryGrey80}",
        "b_252": "{custom_4}",
        "b_253": "{custom_4}",
        "b_254": "{custom_4}",
        "b_255": "{custom_16}",
        "b_256": "{custom_16}",
        "b_257": "{custom_16}",
        "b_258": "{xxs}",
        "b_259": "{custom_4}",
        "b_260": "{custom_4}",
        "b_261": "{global.transparent}",
        "b_262": "{global.transparent}",
        "b_263": "{secondary60}",
        "b_264": "{global.transparent}",
        "b_265": "{global.tansparent}",
        "b_266": "{secondary60}",
        "b_267": "{secondary20}",
        "b_268": "{secondary20}",
        "b_269": "{secondary60}",
        "b_270": "{global.transparent}",
        "b_271": "{custom_5}"
    },
    "JDSBadgeV2Notification": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{xs}",
        "b_5": "{feedbackError50}",
        "b_6": "{pill}",
        "b_7": "{custom_5}",
        "b_8": "{global.transparent}",
        "b_9": "{primaryBackground}",
        "b_10": "{custom_4}",
        "b_11": "{s}",
        "b_12": "{s}",
        "b_13": "{base}",
        "b_14": "{base}",
        "b_15": "{custom_4}",
        "b_16": "{custom_18}",
        "b_17": "{custom_18}",
        "b_18": "{custom_4}",
        "b_19": "{m}",
        "b_20": "{m}",
        "b_21": "{custom_16}",
        "b_22": "{custom_3}",
        "b_23": "{custom_3}",
        "b_24": "{custom_16}",
        "b_25": "{l}",
        "b_26": "{l}",
        "b_27": "{custom_16}",
        "b_28": "{xl}",
        "b_29": "{xl}",
        "b_30": "{xxs}",
        "b_31": "{custom_1}",
        "b_32": "{base}",
        "b_33": "{base}",
        "b_34": "{base}",
        "b_35": "{base}",
        "b_36": "{base}",
        "b_37": "{base}",
        "b_38": "{custom_18}",
        "b_39": "{custom_18}",
        "b_40": "{m}",
        "b_41": "{m}",
        "b_42": "{custom_3}",
        "b_43": "{custom_3}",
        "b_44": "{l}",
        "b_45": "{l}",
        "b_46": "{xl}",
        "b_47": "{xl}",
        "b_48": "{base}",
        "b_49": "{small}",
        "b_50": "{xxs}",
        "b_51": "{xxs}",
        "b_52": "{base}",
        "b_53": "{small}",
        "b_54": "{xxs}",
        "b_55": "{xxs}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{custom_18}",
        "b_63": "{custom_18}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{custom_18}",
        "b_67": "{custom_18}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{custom_18}",
        "b_71": "{custom_18}",
        "b_72": "{l}",
        "b_73": "{medium}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{xl}",
        "b_77": "{medium}",
        "b_78": "{xs}",
        "b_79": "{xs}",
        "b_80": "{custom_4}"
    },
    "JDSBadgeV2Status": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.center}",
        "b_6": "{alignItems.center}",
        "b_7": "{m}",
        "b_8": "{pill}",
        "b_9": "{feedbackSuccess50}",
        "b_10": "{global.white}",
        "b_11": "{base}",
        "b_12": "{s}",
        "b_13": "{s}",
        "b_14": "{small}",
        "b_15": "{xs}",
        "b_16": "{xs}",
        "b_17": "{small}",
        "b_18": "{xs}",
        "b_19": "{xs}",
        "b_20": "{s}",
        "b_21": "{small}",
        "b_22": "{xs}",
        "b_23": "{xs}",
        "b_24": "{base}",
        "b_25": "{s}",
        "b_26": "{l}",
        "b_27": "{m}",
        "b_28": "{xl}",
        "b_29": "{custom_3}",
        "b_30": "{feedbackError50}",
        "b_31": "{feedbackWarning50}",
        "b_32": "{primaryGrey60}",
        "b_33": "{primaryBackground}",
        "b_34": "{primaryBackground}",
        "b_35": "{xs}",
        "b_36": "{base}",
        "b_37": "{m}",
        "b_38": "{l}",
        "b_39": "{xs}",
        "b_40": "{base}",
        "b_41": "{m}",
        "b_42": "{l}",
        "b_43": "{m}",
        "b_44": "{base}",
        "b_45": "{m}",
        "b_46": "{base}",
        "b_47": "{medium}",
        "b_48": "{medium}",
        "b_49": "{xs}",
        "b_50": "{medium}",
        "b_51": "{base}",
        "b_52": "{medium}",
        "b_53": "{m}",
        "b_54": "{l}",
        "b_55": "{medium}",
        "b_56": "{base}",
        "b_57": "{s}",
        "b_58": "{medium}",
        "b_59": "{m}",
        "b_60": "{base}",
        "b_61": "{feedbackSuccess50}",
        "b_62": "{feedbackError50}",
        "b_63": "{feedbackWarning50}",
        "b_64": "{primaryGrey60}",
        "b_65": "{feedbackSuccess50}",
        "b_66": "{global.white}",
        "b_67": "{feedbackError50}",
        "b_68": "{global.white}",
        "b_69": "{feedbackWarning50}",
        "b_70": "{global.white}",
        "b_71": "{primaryGrey60}",
        "b_72": "{global.white}",
        "b_73": "{feedbackSuccess50}",
        "b_74": "{global.white}",
        "b_75": "{feedbackSuccess50}",
        "b_76": "{feedbackError50}",
        "b_77": "{global.white}",
        "b_78": "{feedbackError50}",
        "b_79": "{feedbackWarning50}",
        "b_80": "{global.white}",
        "b_81": "{feedbackWarning50}",
        "b_82": "{primaryGrey60}",
        "b_83": "{global.white}",
        "b_84": "{primaryGrey60}",
        "b_85": "{border_normal}",
        "b_86": "{border_normal}",
        "b_87": "{border_thick}",
        "b_88": "{border_thick}",
        "b_89": "{border_thick}",
        "b_90": "{border_normal}",
        "b_91": "{border_normal}",
        "b_92": "{border_thick}",
        "b_93": "{border_thick}",
        "b_94": "{border_thick}",
        "b_95": "{border_normal}",
        "b_96": "{border_normal}",
        "b_97": "{border_thick}",
        "b_98": "{border_thick}",
        "b_99": "{border_thick}"
    },
    "JDSBaseIcon": {
        "b_0": "{base}",
        "b_1": "{primary50}",
        "b_2": "{primary30}",
        "b_3": "{primary60}",
        "b_4": "{primary70}",
        "b_5": "{primaryBackground}",
        "b_6": "{secondary50}",
        "b_7": "{sparkle50}",
        "b_8": "{primaryGrey60}",
        "b_9": "{primaryGrey80}",
        "b_10": "{primaryGrey100}",
        "b_11": "{feedbackSuccess50}",
        "b_12": "{feedbackError50}",
        "b_13": "{feedbackWarning50}",
        "b_14": "{global.white}",
        "b_15": "{custom_color_1}"
    },
    "JDSDesktopBottomSheet": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.end}",
        "d_2": "{alignItems.end}",
        "d_3": "{custom_color_3}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{primaryBackground}",
        "d_8": "{alignItems.start}",
        "d_9": "{xl}",
        "d_10": "{xl}",
        "d_11": "{flexDirection.row}",
        "d_12": "{justifyContent.end}",
        "d_13": "{alignItems.center}",
        "d_14": "{size.max}",
        "d_15": "{xxs}",
        "d_16": "{xxs}",
        "d_17": "{xs}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{flexDirection.column}",
        "d_21": "{justifyContent.start}",
        "d_22": "{alignItems.start}",
        "d_23": "{m}",
        "d_24": "{m}",
        "d_25": "{size.max}",
        "d_26": "{xs}",
        "d_27": "{m}",
        "d_28": "{flexDirection.column}",
        "d_29": "{base}",
        "d_30": "{size.max}",
        "d_31": "{m}",
        "d_32": "{m}",
        "d_33": "{base}",
        "d_34": "{custom_color_5}"
    },
    "JDSDesktopBottomSheetInternal": {
        "d_0": "{flexDirection.stack}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.start}",
        "d_4": "{primaryBackground}",
        "d_5": "{xl}",
        "d_6": "{xl}",
        "d_7": "{m}",
        "d_8": "{m}",
        "d_9": "{m}",
        "d_10": "{m}",
        "d_11": "{custom_28}",
        "d_12": "{size.max}",
        "d_13": "{justifyContent.end}",
        "d_14": "{alignItems.end}",
        "d_15": "{custom_28}",
        "d_16": "{size.max}",
        "d_17": "{medium}",
        "d_18": "{easeEntrance}",
        "d_19": "{flexDirection.row}",
        "d_20": "{justifyContent.end}",
        "d_21": "{alignItems.end}",
        "d_22": "{custom_color_3}",
        "d_23": "{size.max}",
        "d_24": "{flexDirection.column}",
        "d_25": "{justifyContent.start}",
        "d_26": "{primaryBackground}",
        "d_27": "{alignItems.start}",
        "d_28": "{xl}",
        "d_29": "{xl}",
        "d_30": "{flexDirection.row}",
        "d_31": "{justifyContent.end}",
        "d_32": "{alignItems.center}",
        "d_33": "{size.max}",
        "d_34": "{xxs}",
        "d_35": "{xxs}",
        "d_36": "{xs}",
        "d_37": "{s}",
        "d_38": "{s}",
        "d_39": "{flexDirection.column}",
        "d_40": "{justifyContent.start}",
        "d_41": "{alignItems.start}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{size.max}",
        "d_45": "{xs}",
        "d_46": "{m}",
        "d_47": "{flexDirection.column}",
        "d_48": "{base}",
        "d_49": "{size.max}",
        "d_50": "{m}",
        "d_51": "{m}",
        "d_52": "{base}",
        "d_53": "{custom_color_5}",
        "d_54": "{bottomsheet_padding_right}",
        "d_55": "{opacity.invisible}",
        "d_56": "{medium}",
        "d_57": "{easeEntrance}",
        "d_58": "{global.transparent}",
        "d_59": "{global.transparent}",
        "d_60": "{opacity.enabled}",
        "d_61": "{easeExit}"
    },
    "JDSBreadcrumbs": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.start}",
        "b_2": "{alignItems.start}",
        "b_3": "{m}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.start}",
        "b_6": "{alignItems.start}"
    },
    "JDSCarousel": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{base}",
        "c_4": "{size.max}",
        "c_5": "{size.max}",
        "c_6": "{flexDirection.row}",
        "c_7": "{justifyContent.spaceBetween}",
        "c_8": "{alignItems.center}",
        "c_9": "{base}",
        "c_10": "{size.max}",
        "c_11": "{size.max}",
        "c_12": "{flexDirection.row}",
        "c_13": "{justifyContent.start}",
        "c_14": "{alignItems.center}",
        "c_15": "{base}",
        "c_16": "{xs}",
        "c_17": "{xs}",
        "c_18": "{flexDirection.column}",
        "c_19": "{justifyContent.center}",
        "c_20": "{alignItems.start}",
        "c_21": "{flexDirection.stack}",
        "c_22": "{justifyContent.center}",
        "c_23": "{alignItems.center}",
        "c_24": "{flexDirection.row}",
        "c_25": "{justifyContent.start}",
        "c_26": "{alignItems.start}",
        "c_27": "{size.max}",
        "c_28": "{flexDirection.row}",
        "c_29": "{justifyContent.end}",
        "c_30": "{alignItems.start}",
        "c_31": "{s}",
        "c_32": "{xs}",
        "c_33": "{xs}",
        "c_34": "{xs}"
    },
    "JDSCarouselPagination": {
        "c_0": "{flexDirection.row}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{s}",
        "c_4": "{xs}",
        "c_5": "{size.max}",
        "c_6": "{xs}",
        "c_7": "{xs}"
    },
    "JDSButton": {
        "b_0": "{opacity.enabled}",
        "b_1": "{primary50}",
        "b_2": "{flexDirection.row}",
        "b_3": "{alignItems.center}",
        "b_4": "{justifyContent.center}",
        "b_5": "{pill}",
        "b_6": "0",
        "b_7": "",
        "b_8": "{xs}",
        "b_9": 0,
        "b_10": "{primary60}",
        "b_11": "{primary60}",
        "b_12": "{border_focus}",
        "b_13": "{primary80}",
        "b_14": "{flexDirection.row}",
        "b_15": "{alignItems.center}",
        "b_16": "{justifyContent.start}",
        "b_17": "{xs}",
        "b_18": "{primaryInverse}",
        "b_19": "{global.transparent}",
        "b_20": "{border_focus}",
        "b_21": "{opacity.enabled}",
        "b_22": "{base}",
        "b_23": "{m}",
        "b_24": "{primaryInverse}",
        "b_25": "{m}",
        "b_26": "{primaryInverse}",
        "b_27": "{size.max}",
        "b_28": "{justifyContent.spaceBetween}",
        "b_29": "{opacity.disabled}",
        "b_30": "{primary30}",
        "b_31": "{primary30}",
        "b_32": "{feedbackError20}",
        "b_33": "{feedbackError50}",
        "b_34": "{feedbackError80}",
        "b_35": "{feedbackError50}",
        "b_36": "{feedbackError80}",
        "b_37": "{feedbackError80}",
        "b_38": "{global.white}",
        "b_39": "{feedbackError20}",
        "b_40": "{global.white}",
        "b_41": "{feedbackError80}",
        "b_42": "{feedbackError20}",
        "b_43": "{feedbackSuccess20}",
        "b_44": "{feedbackSuccess50}",
        "b_45": "{feedbackSuccess80}",
        "b_46": "{feedbackSuccess50}",
        "b_47": "{feedbackSuccess80}",
        "b_48": "{feedbackSuccess80}",
        "b_49": "{global.white}",
        "b_50": "{feedbackSuccess20}",
        "b_51": "{feedbackSuccess80}",
        "b_52": "{global.white}",
        "b_53": "{feedbackSuccess20}",
        "b_54": "{global.transparent}",
        "b_55": "{border_thin}",
        "b_56": "{primaryGrey40}",
        "b_57": "{primary60}",
        "b_58": "{global.transparent}",
        "b_59": "{primary20}",
        "b_60": "{primary60}",
        "b_61": "{primary80}",
        "b_62": "{primary60}",
        "b_63": "{primary60}",
        "b_64": "{primary60}",
        "b_65": "{global.transparent}",
        "b_66": "{border_thin}",
        "b_67": "{primaryGrey40}",
        "b_68": "{feedbackError20}",
        "b_69": "{feedbackError80}",
        "b_70": "{feedbackError50}",
        "b_71": "{border_focus}",
        "b_72": "{feedbackError80}",
        "b_73": "{feedbackError80}",
        "b_74": "{feedbackError80}",
        "b_75": "{global.transparent}",
        "b_76": "{border_thin}",
        "b_77": "{primaryGrey40}",
        "b_78": "{feedbackSuccess20}",
        "b_79": "{feedbackSuccess80}",
        "b_80": "{feedbackSuccess50}",
        "b_81": "{border_focus}",
        "b_82": "{feedbackSuccess80}",
        "b_83": "{feedbackSuccess80}",
        "b_84": "{feedbackSuccess80}",
        "b_85": "{global.transparent}",
        "b_86": "{primary20}",
        "b_87": "{primary30}",
        "b_88": "{primary80}",
        "b_89": "{primary20}",
        "b_90": "{primary60}",
        "b_91": "{primary60}",
        "b_92": "{primary60}",
        "b_93": "{global.transparent}",
        "b_94": "{feedbackError20}",
        "b_95": "{feedbackError80}",
        "b_96": "{feedbackError50}",
        "b_97": "{border_focus}",
        "b_98": "{feedbackError20}",
        "b_99": "{feedbackError80}",
        "b_100": "{feedbackError80}",
        "b_101": "{feedbackError80}",
        "b_102": "{global.transparent}",
        "b_103": "{feedbackSuccess20}",
        "b_104": "{feedbackSuccess50}",
        "b_105": "{border_focus}",
        "b_106": "{feedbackSuccess80}",
        "b_107": "{feedbackSuccess80}",
        "b_108": "{feedbackSuccess80}",
        "b_109": "{xxs}",
        "b_110": "{base}",
        "b_111": "{xxs}",
        "b_112": "{base}",
        "b_113": "{base}",
        "b_114": "{base}",
        "b_115": "{base}",
        "b_116": "{s}",
        "b_117": "{base}",
        "b_118": "{s}",
        "b_119": "{base}",
        "b_120": "{m}",
        "b_121": "{m}",
        "b_122": "{m}",
        "b_123": "{base}",
        "b_124": "{m}",
        "b_125": "{base}",
        "b_126": "{m}",
        "b_127": "{m}",
        "b_128": "{m}",
        "b_129": "{m}",
        "b_130": "{l}",
        "b_131": "{l}",
        "b_132": "{base}",
        "b_133": "{base}",
        "b_134": "{base}",
        "b_135": "{xxl}",
        "b_136": "{xxl}",
        "b_137": "{m}",
        "b_138": "{m}",
        "b_139": "{m}",
        "b_140": "{m}",
        "b_141": "{m}",
        "b_142": "{m}",
        "b_143": "{justifyContent.center}",
        "b_144": "{justifyContent.center}",
        "b_145": "{justifyContent.center}",
        "b_146": "{justifyContent.center}",
        "b_147": "{justifyContent.center}"
    },
    "JDSCarouselPaginationItem": {
        "c_0": "{s}",
        "c_1": "{s}",
        "c_2": "{primary60}",
        "c_3": "{opacity.disabled}",
        "c_4": "{pill}",
        "c_5": "{primary40}",
        "c_6": "{opacity.enabled}",
        "c_7": "{primary60}",
        "c_8": "{opacity.enabled}",
        "c_9": "{xs}",
        "c_10": "{opacity.enabled}",
        "c_11": "{primary70}",
        "c_12": "{primary70}",
        "c_13": "{s}",
        "c_14": "{xs}",
        "c_15": "{xs}",
        "c_16": "{custom_15}",
        "c_17": "{custom_15}",
        "c_18": "{xs}",
        "c_19": "{custom_15}",
        "c_20": "{custom_15}",
        "c_21": "{xxs}",
        "c_22": "{xxs}",
        "c_23": "{m}",
        "c_24": "{m}",
        "c_25": "{m}",
        "c_26": "{l}",
        "c_27": "{l}",
        "c_28": "{l}"
    },
    "JDSCarouselSlide": {
        "c_0": "{size.max}",
        "c_1": "{small}",
        "c_2": "{size.max}"
    },
    "JDSCheckbox": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.start}",
        "c_2": "{alignItems.start}",
        "c_3": "{xs}",
        "c_4": "{flexDirection.row}",
        "c_5": "{justifyContent.start}",
        "c_6": "{alignItems.center}",
        "c_7": "{xs}",
        "c_8": "{m}",
        "c_9": "{m}",
        "c_10": "{flexDirection.row}",
        "c_11": "{justifyContent.center}",
        "c_12": "{alignItems.center}",
        "c_13": "{global.transparent}",
        "c_14": "{small}",
        "c_15": "{border_thin}",
        "c_16": "{primaryGrey80}",
        "c_17": "{primary40}",
        "c_18": "{primary60}",
        "c_19": "{border_focus}",
        "c_20": "{primary60}",
        "c_21": "{base}",
        "c_22": "{textAlign.start}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{xxs}",
        "c_26": "{s}",
        "c_27": "ic_confirm",
        "c_28": "{primary50}",
        "c_29": "{primary40}",
        "c_30": "{primary60}",
        "c_31": "{primaryInverse}",
        "c_32": "ic_minus",
        "c_33": "{primary50}",
        "c_34": "{primary40}",
        "c_35": "{primary50}",
        "c_36": "{primaryInverse}",
        "c_37": "{opacity.disabled}",
        "c_38": "{opacity.enabled}"
    },
    "JDSContentBlock": {
        "c_0": "{flexDirection.column}",
        "c_1": "{alignItems.start}",
        "c_2": "{justifyContent.start}",
        "c_3": "{size.max}",
        "c_4": "{flexDirection.column}",
        "c_5": "{alignItems.start}",
        "c_6": "{justifyContent.start}",
        "c_7": "{size.max}",
        "c_8": "{xs}",
        "c_9": "{xxs}",
        "c_10": "{m}",
        "c_11": "{m}",
        "c_12": "{flexDirection.row}",
        "c_13": "{size.max}",
        "c_14": "{xs}",
        "c_15": "{s}",
        "c_16": "{s}",
        "c_17": "{s}",
        "c_18": "{s}",
        "c_19": "{base}",
        "c_20": "{base}",
        "c_21": "{l}",
        "c_22": "{s}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{l}",
        "c_26": "{s}",
        "c_27": "{flexDirection.column}",
        "c_28": "{size.max}",
        "c_29": "{size.max}",
        "c_30": "{base}",
        "c_31": "{m}",
        "c_32": "{m}",
        "c_33": "{flexDirection.row}",
        "c_34": "{justifyContent.spaceBetween}",
        "c_35": "{alignItems.center}",
        "c_36": "{flexDirection.row}",
        "c_37": "{justifyContent.end}",
        "c_38": "{alignItems.center}"
    },
    "JDSDatepickerButton": {
        "d_0": "{xxl}",
        "d_1": "{custom_9}",
        "d_2": "{pill}",
        "d_3": "{global.transparent}",
        "d_4": "{border_thin}",
        "d_5": "{primaryGrey40}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{xs}",
        "d_10": "{base}",
        "d_11": "{base}",
        "d_12": "{primary60}",
        "d_13": "{primaryGrey100}",
        "d_14": "{border_focus}",
        "d_15": "{primary60}",
        "d_16": "{primary20}",
        "d_17": "{primary20}",
        "d_18": "{primary60}",
        "d_19": "{border_none}",
        "d_20": "{opacity.disabled}",
        "d_21": "{border_none}"
    },
    "JDSContentCard": {
        "c_0": "{size.max}",
        "c_1": "{xl}",
        "c_2": "{flexDirection.column}",
        "c_3": "{justifyContent.start}",
        "c_4": "{alignItems.start}",
        "c_5": "{primaryBackground}",
        "c_6": "{justifyContent.start}",
        "c_7": "{alignItems.start}",
        "c_8": "{size.max}",
        "c_9": "{base}",
        "c_10": "{base}",
        "c_11": "{base}",
        "c_12": "{justifyContent.start}",
        "c_13": "{alignItems.start}",
        "c_14": "{size.max}",
        "c_15": "{base}",
        "c_16": "{base}",
        "c_17": "{base}",
        "c_18": "{flexDirection.column}",
        "c_19": "{size.max}",
        "c_20": "{justifyContent.start}",
        "c_21": "{alignItems.start}",
        "c_22": "{base}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{base}",
        "c_26": "{base}",
        "c_27": "{base}",
        "c_28": "{base}",
        "c_29": "{base}",
        "c_30": "{base}",
        "c_31": "{base}",
        "c_32": "{flexDirection.row}",
        "c_33": "{custom_10}",
        "c_34": "{size.max}",
        "c_35": "{base}",
        "c_36": "{base}",
        "c_37": "{flexDirection.row}",
        "c_38": "{size.max}"
    },
    "JDSDatepickerCalendarButton": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{custom_7}",
        "d_4": "{m}",
        "d_5": "{size.max}",
        "d_6": "{xxl}",
        "d_7": "{m}",
        "d_8": "{flexDirection.row}",
        "d_9": "{justifyContent.center}",
        "d_10": "{alignItems.center}",
        "d_11": "{xxl}",
        "d_12": "{intrinsicSize.min}",
        "d_13": "{xxl}",
        "d_14": "{pill}",
        "d_15": "{primaryGrey100}",
        "d_16": "{global.transparent}",
        "d_17": "{primary20}",
        "d_18": "{primary40}",
        "d_19": "{primary20}",
        "d_20": "{border_focus}",
        "d_21": "{primary50}",
        "d_22": "{primary20}",
        "d_23": "{opacity.disabled}",
        "d_24": "{base}",
        "d_25": "{base}"
    },
    "JDSDatepickerCalendar": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{s}",
        "d_4": "{flexDirection.column}"
    },
    "JDSDatepickerCalendarRow": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSAccordion": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.row}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.start}",
        "a_5": "{size.max}",
        "a_6": "{xxs}",
        "a_7": "{s}",
        "a_8": "{flexDirection.column}",
        "a_9": "{justifyContent.start}",
        "a_10": "{alignItems.start}",
        "a_11": "{xxs}",
        "a_12": "0",
        "a_13": "{size.max}",
        "a_14": "{size.max}",
        "a_15": "{opacity.enabled}",
        "a_16": "{base}",
        "a_17": "{opacity.disabled}",
        "a_18": "ic_minus",
        "a_19": "ic_add",
        "a_20": "ic_chevron_up",
        "a_21": "ic_chevron_down"
    },
    "JDSDatepickerCalendarHeader": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSDatepickerDesktop": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerDesktopInternal": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerHeader": {
        "d_0": "{size.max}",
        "d_1": "{xxl}",
        "d_2": "{flexDirection.row}",
        "d_3": "{justifyContent.spaceBetween}",
        "d_4": "{alignItems.center}",
        "d_5": "{xxl}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{s}"
    },
    "JDSDatepickerYearView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{size.max}",
        "d_2": "{alignItems.center}"
    },
    "JDSDatepickerMonthView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{custom_8}",
        "d_2": "{size.max}",
        "d_3": "{alignItems.center}"
    },
    "JDSDatepickerMobile": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerMobileInteral": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDivider": {
        "d_0": "{global.transparent}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xs}",
        "d_5": "{s}",
        "d_6": "{s}",
        "d_7": "{s}",
        "d_8": "{s}",
        "d_9": "{custom_5}",
        "d_10": "{custom_5}",
        "d_11": "{flexDirection.row}",
        "d_12": "{primaryGrey40}",
        "d_13": "{pill}",
        "d_14": "{custom_5}",
        "d_15": "{custom_5}",
        "d_16": "{flexDirection.row}",
        "d_17": "{primaryGrey40}",
        "d_18": "{pill}",
        "d_19": "{sparkle50}",
        "d_20": "{sparkle50}",
        "d_21": "{size.max}",
        "d_22": "{size.max}",
        "d_23": "{flexDirection.column}",
        "d_24": "{flexDirection.column}",
        "d_25": "{flexDirection.column}",
        "d_26": "{base}",
        "d_27": "{base}",
        "d_28": "{base}",
        "d_29": "{base}",
        "d_30": "{base}",
        "d_31": "{base}",
        "d_32": "{base}",
        "d_33": "{base}",
        "d_34": "{base}",
        "d_35": "{base}",
        "d_36": "{base}",
        "d_37": "{base}",
        "d_38": "{m}",
        "d_39": "{m}",
        "d_40": "{m}",
        "d_41": "{m}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{m}",
        "d_45": "{m}",
        "d_46": "{m}",
        "d_47": "{m}",
        "d_48": "{m}",
        "d_49": "{m}",
        "d_50": "{xs}",
        "d_51": "{xs}",
        "d_52": "{xs}",
        "d_53": "{xs}",
        "d_54": "{xs}",
        "d_55": "{xs}",
        "d_56": "{xs}",
        "d_57": "{xs}",
        "d_58": "{xs}",
        "d_59": "{xs}",
        "d_60": "{xs}",
        "d_61": "{xs}",
        "d_62": "{xxs}",
        "d_63": "{xxs}",
        "d_64": "{xxs}",
        "d_65": "{xxs}",
        "d_66": "{xxs}",
        "d_67": "{xxs}",
        "d_68": "{xxs}",
        "d_69": "{xxs}",
        "d_70": "{xxs}",
        "d_71": "{xxs}",
        "d_72": "{xxs}",
        "d_73": "{xxs}",
        "d_74": "{xxl}",
        "d_75": "{xxl}",
        "d_76": "{xxl}",
        "d_77": "{xxl}",
        "d_78": "{xxl}",
        "d_79": "{xxl}",
        "d_80": "{xxl}",
        "d_81": "{xxl}",
        "d_82": "{xxl}",
        "d_83": "{xxl}",
        "d_84": "{xxl}",
        "d_85": "{xxl}",
        "d_86": "{xl}",
        "d_87": "{xl}",
        "d_88": "{xl}",
        "d_89": "{xl}",
        "d_90": "{xl}",
        "d_91": "{xl}",
        "d_92": "{xl}",
        "d_93": "{xl}",
        "d_94": "{xl}",
        "d_95": "{xl}",
        "d_96": "{xl}",
        "d_97": "{xl}",
        "d_98": "{l}",
        "d_99": "{l}",
        "d_100": "{l}",
        "d_101": "{l}",
        "d_102": "{l}",
        "d_103": "{l}",
        "d_104": "{l}",
        "d_105": "{l}",
        "d_106": "{l}",
        "d_107": "{l}",
        "d_108": "{l}",
        "d_109": "{l}",
        "d_110": "{huge}",
        "d_111": "{huge}",
        "d_112": "{huge}",
        "d_113": "{huge}",
        "d_114": "{huge}",
        "d_115": "{huge}",
        "d_116": "{huge}",
        "d_117": "{huge}",
        "d_118": "{huge}",
        "d_119": "{huge}",
        "d_120": "{huge}",
        "d_121": "{huge}",
        "d_122": "{massive}",
        "d_123": "{massive}",
        "d_124": "{massive}",
        "d_125": "{massive}",
        "d_126": "{massive}",
        "d_127": "{massive}",
        "d_128": "{massive}",
        "d_129": "{massive}",
        "d_130": "{massive}",
        "d_131": "{massive}",
        "d_132": "{massive}",
        "d_133": "{massive}"
    },
    "JDSDatepickerViewButton": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xxl}",
        "d_5": "{custom_7}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}"
    },
    "JDSFAB": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSFABInternal": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSDropdown": {
        "d_0": "{flexDirection.column}",
        "d_1": "{xxs}",
        "d_2": "{size.max}",
        "d_3": "{justifyContent.start}",
        "d_4": "{alignItems.start}",
        "d_5": "{flexDirection.stack}",
        "d_6": "{size.max}",
        "d_7": "{alignItems.end}",
        "d_8": "{justifyContent.start}",
        "d_9": "{xxs}",
        "d_10": "{flexDirection.row}",
        "d_11": "{xs}",
        "d_12": "{flexDirection.row}",
        "d_13": "{justifyContent.end}",
        "d_14": "{size.max}",
        "d_15": "{alignItems.center}",
        "d_16": "{flexDirection.column}",
        "d_17": "{size.max}",
        "d_18": "{alignItems.center}",
        "d_19": "{size.max}",
        "d_20": "{primaryGrey100}",
        "d_21": "{primary50}",
        "d_22": "{primary50}",
        "d_23": "{primary50}",
        "d_24": "{border_thin}",
        "d_25": "{primaryGrey60}",
        "d_26": "{medium}",
        "d_27": "{custom_17}",
        "d_28": "{custom_17}",
        "d_29": "{s}",
        "d_30": "{xs}",
        "d_31": "{primartGrey60}",
        "d_32": "{white}",
        "d_33": "{white}",
        "d_34": "{m}",
        "d_35": "{primaryGrey80}",
        "d_36": "{opacity.disabled}",
        "d_37": "{opacity.enabled}",
        "d_38": "{feedbackSuccess50}",
        "d_39": "{feedbackSuccess50}",
        "d_40": "{feedbackSuccess50}",
        "d_41": "{feedbackSuccess50}",
        "d_42": "{feedbackError50}",
        "d_43": "{feedbackError50}",
        "d_44": "{feedbackError50}",
        "d_45": "{feedbackError50}",
        "d_46": "{feedbackWarning50}",
        "d_47": "{feedbackWarning50}",
        "d_48": "{feedbackWarning50}",
        "d_49": "{feedbackWarning50}",
        "d_50": "{primaryGrey20}",
        "d_51": "{xl}",
        "d_52": "{alignItems.start}",
        "d_53": "{alignItems.start}",
        "d_54": "{alignItems.end}",
        "d_55": "{l}",
        "d_56": "{alignItems.end}",
        "d_57": "{s}",
        "d_58": "{primary60}"
    },
    "JDSDropdownMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuInternal": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuItem": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuItemMobile": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuGroup": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.column}",
        "d_2": "{flexDirection.column}",
        "d_3": "{xs}",
        "d_4": "{base}",
        "d_5": "{base}",
        "d_6": "{size.max}",
        "d_7": "{primaryGrey20}",
        "d_8": "{size.max}"
    },
    "JDSDropdownMenuSubMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{large}",
        "d_4": "{xs}",
        "d_5": "{xs}",
        "d_6": "{custom_color_5}",
        "d_7": "{size.max}",
        "d_8": "{size.max}",
        "d_9": "{opacity.invisible}",
        "d_10": "{opacity.enabled}"
    },
    "JDSFeedbackBlock": {
        "f_0": "{flexDirection.row}",
        "f_1": "{justifyContent.center}",
        "f_2": "{alignItems.center}",
        "f_3": "{xs}",
        "f_4": "{alignItems.start}",
        "f_5": "{flexDirection.row}",
        "f_6": "{justifyContent.center}",
        "f_7": "{alignItems.center}",
        "f_8": "{m}",
        "f_9": "{m}",
        "f_10": "{custom_18}",
        "f_11": "{base}"
    },
    "JDSBottomFooterLinkItem": {
        "b_0": "{base}"
    },
    "JDSFooterIconLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{base}"
    },
    "JDSFooter": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.center}",
        "f_2": "{size.max}",
        "f_3": "{primaryGrey20}",
        "f_4": "{flexDirection.row}",
        "f_5": "{justifyContent.spaceBetween}",
        "f_6": "{alignItems.start}",
        "f_7": "{base}",
        "f_8": "{size.max}",
        "f_9": "{xl}",
        "f_10": "{xl}",
        "f_11": "{huge}",
        "f_12": "{huge}",
        "f_13": "{xs}",
        "f_14": "{flexDirection.column}",
        "f_15": "{l}",
        "f_16": "{flexDirection.column}",
        "f_17": "{alignItems.start}",
        "f_18": "{size.max}",
        "f_19": "{size.max}",
        "f_20": "{size.max}",
        "f_21": "{m}",
        "f_22": "{flexDirection.column}",
        "f_23": "{justifyContent.start}",
        "f_24": "{m}",
        "f_25": "{xl}",
        "f_26": "{m}",
        "f_27": "{m}",
        "f_28": "{custom_17}"
    },
    "JDSBottomFooter": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.spaceBetween}",
        "b_2": "{alignItems.center}",
        "b_3": "{base}",
        "b_4": "{huge}",
        "b_5": "{base}",
        "b_6": "{huge}",
        "b_7": "{global.transparent}",
        "b_8": "{base}",
        "b_9": "{flexDirection.row}",
        "b_10": "{alignItems.center}",
        "b_11": "{alignItems.center}",
        "b_12": "{size.max}",
        "b_13": "{flexDirection.column}",
        "b_14": "{justifyContent.start}",
        "b_15": "{alignItems.start}",
        "b_16": "{m}",
        "b_17": "{m}",
        "b_18": "{m}",
        "b_19": "{base}",
        "b_20": "{flexDirection.column}",
        "b_21": "{alignItems.start}",
        "b_22": "{base}"
    },
    "JDSFooterLinksGrid": {
        "f_0": "{flexDirection.row}",
        "f_1": "{size.max}",
        "f_2": "{base}"
    },
    "JDSFooterLinks": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.start}",
        "f_2": "{size.max}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{xs}",
        "f_6": "{flexDirection.column}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.start}",
        "f_9": "{global.transparent}",
        "f_10": "{primaryGrey40}",
        "f_11": "{xs}",
        "f_12": "{xs}",
        "f_13": "{s}",
        "f_14": "{size.max}",
        "f_15": "{flexDirection.column}"
    },
    "JDSIcon": {
        "icon_0": "{global.transparent}",
        "icon_1": "{pill}",
        "icon_2": "{m}",
        "icon_3": "{justifyContent.center}",
        "icon_4": "{alignItems.center}",
        "icon_5": "{m}",
        "icon_6": "{custom_color_1}",
        "icon_7": "{primary50}",
        "icon_8": "{primary30}",
        "icon_9": "{primary60}",
        "icon_10": "{primary70}",
        "icon_11": "{primaryBackground}",
        "icon_12": "{secondary50}",
        "icon_13": "{sparkle50}",
        "icon_14": "{primaryGrey60}",
        "icon_15": "{primaryGrey80}",
        "icon_16": "{primaryGrey100}",
        "icon_17": "{feedbackSuccess50}",
        "icon_18": "{feedbackError50}",
        "icon_19": "{feedbackWarning50}",
        "icon_20": "{global.white}",
        "icon_21": "{base}",
        "icon_22": "{base}",
        "icon_23": "{l}",
        "icon_24": "{l}",
        "icon_25": "{xl}",
        "icon_26": "{xl}",
        "icon_27": "{xxl}",
        "icon_28": "{xxl}",
        "icon_29": "{size.max}",
        "icon_30": "{size.max}",
        "icon_31": "{primary20}",
        "icon_32": "{primary20}",
        "icon_33": "{primary20}",
        "icon_34": "{primary20}",
        "icon_35": "{primary20}",
        "icon_36": "{secondary20}",
        "icon_37": "{sparkle20}",
        "icon_38": "{primaryGrey20}",
        "icon_39": "{primaryGrey20}",
        "icon_40": "{primaryGrey20}",
        "icon_41": "{primary20}",
        "icon_42": "{feedbackSuccess20}",
        "icon_43": "{feedbackError20}",
        "icon_44": "{feedbackWarning20}",
        "icon_45": "{primary50}",
        "icon_46": "{primaryInverse}",
        "icon_47": "{primary30}",
        "icon_48": "{primary30}",
        "icon_49": "{primary60}",
        "icon_50": "{primaryInverse}",
        "icon_51": "{primary70}",
        "icon_52": "{primaryInverse}",
        "icon_53": "{primaryBackground}",
        "icon_54": "{primaryInverse}",
        "icon_55": "{secondary50}",
        "icon_56": "{secondaryInverse}",
        "icon_57": "{sparkle50}",
        "icon_58": "{sparkleInverse}",
        "icon_59": "{primaryGrey60}",
        "icon_60": "{primaryInverse}",
        "icon_61": "{primaryGrey80}",
        "icon_62": "{primaryInverse}",
        "icon_63": "{primaryGrey100}",
        "icon_64": "{primaryInverse}",
        "icon_65": "{global.white}",
        "icon_66": "{global.white}",
        "icon_67": "{feedbackSuccess50}",
        "icon_68": "{primaryInverse}",
        "icon_69": "{feedbackError50}",
        "icon_70": "{primaryInverse}",
        "icon_71": "{feedbackWarning50}",
        "icon_72": "{primaryInverse}",
        "icon_73": "{m}",
        "icon_74": "{base}",
        "icon_75": "{base}",
        "icon_76": "{global.transparent}",
        "icon_77": "{base}",
        "icon_78": "{l}",
        "icon_79": "{m}",
        "icon_80": "{xl}",
        "icon_81": "{custom_3}",
        "icon_82": "{xxl}",
        "icon_83": "{l}",
        "icon_84": "{global.transparent}",
        "icon_85": "{primary50}",
        "icon_86": "{global.transparent}",
        "icon_87": "{primary30}",
        "icon_88": "{global.transparent}",
        "icon_89": "{primary60}",
        "icon_90": "{global.transparent}",
        "icon_91": "{primary70}",
        "icon_92": "{global.transparent}",
        "icon_93": "{primaryBackground}",
        "icon_94": "{global.transparent}",
        "icon_95": "{secondary50}",
        "icon_96": "{global.transparent}",
        "icon_97": "{sparkle50}",
        "icon_98": "{global.transparent}",
        "icon_99": "{primaryGrey60}",
        "icon_100": "{global.transparent}",
        "icon_101": "{primaryGrey80}",
        "icon_102": "{global.transparent}",
        "icon_103": "{primaryGrey100}",
        "icon_104": "{global.transparent}",
        "icon_105": "{global.white}",
        "icon_106": "{global.transparent}",
        "icon_107": "{feedbackSuccess50}",
        "icon_108": "{global.transparent}",
        "icon_109": "{feedbackError50}",
        "icon_110": "{global.transparent}",
        "icon_111": "{feedbackWarning50}",
        "icon_112": "{m}",
        "icon_113": "{base}",
        "icon_114": "{base}",
        "icon_115": "{base}",
        "icon_116": "{l}",
        "icon_117": "{m}",
        "icon_118": "{xl}",
        "icon_119": "{custom_3}",
        "icon_120": "{xxl}",
        "icon_121": "{l}",
        "icon_122": "{m}",
        "icon_123": "{m}",
        "icon_124": "{m}",
        "icon_125": "{m}",
        "icon_126": "{m}",
        "icon_127": "{m}",
        "icon_128": "{m}",
        "icon_129": "{m}",
        "icon_130": "{m}",
        "icon_131": "{m}",
        "icon_132": "{m}",
        "icon_133": "{m}",
        "icon_134": "{l}",
        "icon_135": "{l}",
        "icon_136": "{l}",
        "icon_137": "{l}",
        "icon_138": "{l}",
        "icon_139": "{l}",
        "icon_140": "{l}",
        "icon_141": "{l}",
        "icon_142": "{l}",
        "icon_143": "{l}",
        "icon_144": "{l}",
        "icon_145": "{l}",
        "icon_146": "{xl}",
        "icon_147": "{xl}",
        "icon_148": "{xl}",
        "icon_149": "{xl}",
        "icon_150": "{xl}",
        "icon_151": "{xl}",
        "icon_152": "{xl}",
        "icon_153": "{xl}",
        "icon_154": "{xl}",
        "icon_155": "{xl}",
        "icon_156": "{xl}",
        "icon_157": "{xl}",
        "icon_158": "{xxl}",
        "icon_159": "{xxl}",
        "icon_160": "{xxl}",
        "icon_161": "{xxl}",
        "icon_162": "{xxl}",
        "icon_163": "{xxl}",
        "icon_164": "{xxl}",
        "icon_165": "{xxl}",
        "icon_166": "{xxl}",
        "icon_167": "{xxl}",
        "icon_168": "{xxl}",
        "icon_169": "{xxl}",
        "icon_170": "{primaryInverse}",
        "icon_171": "{secondaryInverse}",
        "icon_172": "{sparkleInverse}",
        "icon_173": "{global.white}"
    },
    "JDSFooterMarketLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{alignItems.center}",
        "f_5": "{base}"
    },
    "JDSImage": {
        "i_0": "{global.transparent}",
        "i_1": "{flexDirection.stack}",
        "i_2": "{justifyContent.center}",
        "i_3": "{alignItems.center}",
        "i_4": "{size.min}",
        "i_5": "{size.min}",
        "i_6": "{xl}",
        "i_7": "{aspect_ratio.1.1}",
        "i_8": "{xl}",
        "i_9": "{size.max}",
        "i_10": "{size.max}",
        "i_11": "{l}",
        "i_12": "{primaryGrey80}",
        "i_13": "{size.max}",
        "i_14": "{aspect_ratio.1.1}",
        "i_15": "{size.max}",
        "i_16": "{size.max}",
        "i_17": "{primaryGrey20}",
        "i_18": "{opacity.invisible}",
        "i_19": "{primaryGrey20}",
        "i_20": "{opacity.invisible}",
        "i_21": "{primaryGrey20}",
        "i_22": "{opacity.invisible}",
        "i_23": "{aspect_ratio.4.3}",
        "i_24": "{aspect_ratio.4.3}",
        "i_25": "{aspect_ratio.4.3}",
        "i_26": "{aspect_ratio.4.3}",
        "i_27": "{aspect_ratio.5.4}",
        "i_28": "{aspect_ratio.5.4}",
        "i_29": "{aspect_ratio.5.4}",
        "i_30": "{aspect_ratio.5.4}",
        "i_31": "{aspect_ratio.16.9}",
        "i_32": "{aspect_ratio.16.9}",
        "i_33": "{aspect_ratio.16.9}",
        "i_34": "{aspect_ratio.16.9}",
        "i_35": "{aspect_ratio.4.5}",
        "i_36": "{aspect_ratio.4.5}",
        "i_37": "{aspect_ratio.4.5}",
        "i_38": "{aspect_ratio.4.5}",
        "i_39": "{aspect_ratio.3.4}",
        "i_40": "{aspect_ratio.3.4}",
        "i_41": "{aspect_ratio.3.4}",
        "i_42": "{aspect_ratio.3.4}",
        "i_43": "{aspect_ratio.9.16}",
        "i_44": "{aspect_ratio.9.16}",
        "i_45": "{aspect_ratio.9.16}",
        "i_46": "{aspect_ratio.9.16}",
        "i_47": "{aspect_ratio.2_75.1}",
        "i_48": "{aspect_ratio.2_75.1}",
        "i_49": "{aspect_ratio.2_75.1}",
        "i_50": "{aspect_ratio.2_75.1}"
    },
    "JDSInput": {
        "i_0": "{textAlign.start}",
        "i_1": "{primaryGrey60}",
        "i_2": "{bodyS}",
        "i_3": "{bodyS}",
        "i_4": "{bodyS}",
        "i_5": "{bodyS}",
        "i_6": "{bodyS}",
        "i_7": "{primaryGrey100}",
        "i_8": "{bodyS}",
        "i_9": "{bodyS}",
        "i_10": "{bodyS}",
        "i_11": "{bodyS}",
        "i_12": "{bodyS}",
        "i_13": "{primaryGrey100}",
        "i_14": "{size.max}",
        "i_15": "{opacity.disabled}",
        "i_16": "{textAlign.center}",
        "i_17": "{textAlign.end}",
        "i_18": "{textAlign.justify}",
        "i_19": "{bodyL}",
        "i_20": "{bodyL}",
        "i_21": "{bodyL}",
        "i_22": "{bodyL}",
        "i_23": "{bodyL}",
        "i_24": "{bodyL}",
        "i_25": "{bodyL}",
        "i_26": "{bodyL}",
        "i_27": "{primary80}",
        "i_28": "{primary70}",
        "i_29": "{primary60}",
        "i_30": "{primary50}",
        "i_31": "{primary40}",
        "i_32": "{primary30}",
        "i_33": "{primary20}",
        "i_34": "{primaryInverse}",
        "i_35": "{primaryBackground}",
        "i_36": "{primaryGrey100}",
        "i_37": "{primaryGrey80}",
        "i_38": "{primaryGrey60}",
        "i_39": "{primaryGrey40}",
        "i_40": "{primaryGrey20}",
        "i_41": "{secondary80}",
        "i_42": "{secondary70}",
        "i_43": "{secondary60}",
        "i_44": "{secondary50}",
        "i_45": "{secondary40}",
        "i_46": "{secondary30}",
        "i_47": "{secondary20}",
        "i_48": "{secondaryInverse}",
        "i_49": "{secondaryBackground}",
        "i_50": "{secondaryGrey100}",
        "i_51": "{secondaryGrey80}",
        "i_52": "{secondaryGrey60}",
        "i_53": "{secondaryGrey40}",
        "i_54": "{secondaryGrey20}",
        "i_55": "{sparkle80}",
        "i_56": "{sparkle70}",
        "i_57": "{sparkle60}",
        "i_58": "{sparkle50}",
        "i_59": "{sparkle40}",
        "i_60": "{sparkle30}",
        "i_61": "{sparkle20}",
        "i_62": "{sparkleInverse}",
        "i_63": "{sparkleBackground}",
        "i_64": "{sparkleGrey100}",
        "i_65": "{sparkleGrey80}",
        "i_66": "{sparkleGrey60}",
        "i_67": "{sparkleGrey40}",
        "i_68": "{sparkleGrey20}",
        "i_69": "{feedbackError80}",
        "i_70": "{feedbackError50}",
        "i_71": "{feedbackError20}",
        "i_72": "{feedbackWarning80}",
        "i_73": "{feedbackWarning50}",
        "i_74": "{feedbackWarning20}",
        "i_75": "{feedbackSuccess80}",
        "i_76": "{feedbackSuccess50}",
        "i_77": "{feedbackSuccess20}",
        "i_78": "{global.white}",
        "i_79": "{global.black}",
        "i_80": "{global.transparent}"
    },
    "JDSInputCodeItem": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.center}",
        "i_2": "{alignItems.center}",
        "i_3": "{xs}",
        "i_4": "{size.max}",
        "i_5": "{size.max}",
        "i_6": "{flexDirection.column}",
        "i_7": "{justifyContent.center}",
        "i_8": "{alignItems.center}",
        "i_9": "{size.max}",
        "i_10": "{custom_1}",
        "i_11": "{custom_1}",
        "i_12": "{size.max}",
        "i_13": "{custom_4}",
        "i_14": "{primaryGrey100}",
        "i_15": "{custom_2}",
        "i_16": "{primary50}",
        "i_17": "{primary50}",
        "i_18": "{primary50}",
        "i_19": "{feedbackSuccess50}",
        "i_20": "{feedbackError50}",
        "i_21": "{feedbackWarning50}",
        "i_22": "{primary60}"
    },
    "JDSInputDate": {
        "i_0": "{flexDirection.column}",
        "i_1": "{alignItems.start}",
        "i_2": "{xs}",
        "i_3": "{size.max}",
        "i_4": "{flexDirection.row}",
        "i_5": "{size.max}",
        "i_6": "{alignItems.center}",
        "i_7": "{flexDirection.column}",
        "i_8": "{size.max}",
        "i_9": "{alignItems.start}",
        "i_10": "{size.max}",
        "i_11": "{s}",
        "i_12": "{alignItems.stretch}",
        "i_13": "{flexDirection.column}",
        "i_14": "{xs}",
        "i_15": "{alignItems.start}",
        "i_16": "{textAlign.start}",
        "i_17": "{size.max}",
        "i_18": "{size.max}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primaryGrey60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{xs}",
        "i_23": "{alignItems.start}",
        "i_24": "{textAlign.start}",
        "i_25": "{size.max}",
        "i_26": "{size.max}",
        "i_27": "{primaryGrey80}",
        "i_28": "{primaryGrey60}",
        "i_29": "{flexDirection.column}",
        "i_30": "{xs}",
        "i_31": "{alignItems.start}",
        "i_32": "{textAlign.start}",
        "i_33": "{size.max}",
        "i_34": "{size.max}",
        "i_35": "{primaryGrey80}",
        "i_36": "{justifyContent.center}",
        "i_37": "{alignItems.center}",
        "i_38": "{flexDirection.column}",
        "i_39": "{alignItems.start}",
        "i_40": "{xs}",
        "i_41": "{size.max}",
        "i_42": "{opacity.disabled}",
        "i_43": "{opacity.disabled}",
        "i_44": "{feedbackError50}",
        "i_45": "{feedbackError50}",
        "i_46": "{feedbackError50}",
        "i_47": "{feedbackError50}",
        "i_48": "{feedbackError50}",
        "i_49": "{feedbackError50}"
    },
    "JDSLink": {
        "l_0": "{global.transparent}",
        "l_1": "{flexDirection.row}",
        "l_2": "{justifyContent.center}",
        "l_3": "{alignItems.center}",
        "l_4": "{small}",
        "l_5": "{border_normal}",
        "l_6": "{primary60}",
        "l_7": "{primary30}",
        "l_8": "{text-decoration.underline}",
        "l_9": "{text-decoration.underline}",
        "l_10": "{text-decoration.underline}",
        "l_11": "{text-decoration.none}",
        "l_12": "{text-decoration.underline}"
    },
    "JDSFileUploader": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{opacity.enabled}"
    },
    "JDSFileUploaderControl": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{xxs}",
        "f_4": "{size.max}",
        "f_5": "{opacity.enabled}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.center}",
        "f_9": "{xxs}"
    },
    "JDSFileUploaderItem": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.spaceBetween}",
        "f_8": "{alignItems.center}",
        "f_9": "{xs}",
        "f_10": "{s}",
        "f_11": "{size.max}",
        "f_12": "{flexDirection.row}",
        "f_13": "{justifyContent.start}",
        "f_14": "{alignItems.center}",
        "f_15": "{xs}",
        "f_16": "{alignItems.center}"
    },
    "JDSFileUploaderList": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}"
    },
    "JDSFileUploaderPanel": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}",
        "f_7": "{xs}",
        "f_8": "{xs}",
        "f_9": "{xs}",
        "f_10": "{xs}",
        "f_11": "{s}",
        "f_12": "{s}",
        "f_13": "{size.max}"
    },
    "JDSMenuBlock": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSMenuBlockInternal": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSListBlock": {
        "l_0": "{flexDirection.column}",
        "l_1": "{size.max}",
        "l_2": "{justifyContent.start}",
        "l_3": "{alignItems.start}",
        "l_4": "{xs}",
        "l_5": "{xs}",
        "l_6": "{xs}",
        "l_7": "{flexDirection.row}",
        "l_8": "{size.max}",
        "l_9": "{base}",
        "l_10": "{justifyContent.start}",
        "l_11": "{alignItems.center}",
        "l_12": "{flexDirection.column}",
        "l_13": "{xxs}",
        "l_14": "{justifyContent.start}",
        "l_15": "{alignItems.start}",
        "l_16": "{flexDirection.row}",
        "l_17": "{size.max}",
        "l_18": "{justifyContent.spaceBetween}",
        "l_19": "{alignItems.center}",
        "l_20": "{s}",
        "l_21": "{flexDirection.row}",
        "l_22": "{justifyContent.start}",
        "l_23": "{alignItems.center}",
        "l_24": "{s}",
        "l_25": "{flexDirection.row}",
        "l_26": "{size.max}",
        "l_27": "{justifyContent.spaceBetween}",
        "l_28": "{alignItems.center}",
        "l_29": "{s}",
        "l_30": "{flexDirection.row}",
        "l_31": "{justifyContent.start}",
        "l_32": "{alignItems.center}",
        "l_33": "{s}",
        "l_34": "{flexDirection.row}",
        "l_35": "{size.max}",
        "l_36": "{justifyContent.spaceBetween}",
        "l_37": "{alignItems.center}",
        "l_38": "{s}",
        "l_39": "{flexDirection.row}",
        "l_40": "{justifyContent.start}",
        "l_41": "{alignItems.center}",
        "l_42": "{s}",
        "l_43": "{s}",
        "l_44": "{xxs}",
        "l_45": "{alignItems.start}"
    },
    "JDSInputField": {
        "i_0": "{flexDirection.column}",
        "i_1": "{xxs}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{flexDirection.stack}",
        "i_6": "{size.max}",
        "i_7": "{alignItems.end}",
        "i_8": "{justifyContent.start}",
        "i_9": "{xxs}",
        "i_10": "{flexDirection.row}",
        "i_11": "{justifyContent.start}",
        "i_12": "{size.max}",
        "i_13": "{xs}",
        "i_14": "{alignItems.center}",
        "i_15": "{m}",
        "i_16": "{primaryGrey80}",
        "i_17": "{textAlign.start}",
        "i_18": "{m}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primary60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{size.max}",
        "i_23": "{alignItems.center}",
        "i_24": "{size.max}",
        "i_25": "{primaryGrey80}",
        "i_26": "{primary50}",
        "i_27": "{primary60}",
        "i_28": "{primary60}",
        "i_29": "{opacity.disabled}",
        "i_30": "{opacity.enabled}",
        "i_31": "{feedbackSuccess50}",
        "i_32": "{feedbackSuccess50}",
        "i_33": "{feedbackSuccess50}",
        "i_34": "{feedbackSuccess50}",
        "i_35": "{feedbackError50}",
        "i_36": "{feedbackError50}",
        "i_37": "{feedbackError50}",
        "i_38": "{feedbackError50}",
        "i_39": "{feedbackWarning50}",
        "i_40": "{feedbackWarning50}",
        "i_41": "{feedbackWarning50}",
        "i_42": "{feedbackWarning50}",
        "i_43": "{alignItems.start}",
        "i_44": "{alignItems.start}",
        "i_45": "{alignItems.end}",
        "i_46": "{l}",
        "i_47": "{alignItems.end}",
        "i_48": "{primary60}"
    },
    "JDSInputFieldV2": {
        "i_0": "{s}",
        "i_1": "{flexDirection.column}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{opacity.enabled}",
        "i_6": "{flexDirection.row}",
        "i_7": "{justifyContent.start}",
        "i_8": "{alignItems.center}",
        "i_9": "{xxs}",
        "i_10": "{xs}",
        "i_11": "{xs}",
        "i_12": "{xxs}",
        "i_13": "{flexDirection.row}",
        "i_14": "{justifyContent.start}",
        "i_15": "{alignItems.center}",
        "i_16": "{size.max}",
        "i_17": "{xl}",
        "i_18": "{xs}",
        "i_19": "{xs}",
        "i_20": "{xs}",
        "i_21": "{xs}",
        "i_22": "{xs}",
        "i_23": "{border_thin}",
        "i_24": "{primaryGrey60}",
        "i_25": "{primaryGrey40}",
        "i_26": "{medium}",
        "i_27": "{primary50}",
        "i_28": "{primary60}",
        "i_29": "{primary60}",
        "i_30": "{textAlign.start}",
        "i_31": 1,
        "i_32": "{flexDirection.column}",
        "i_33": "{justifyContent.start}",
        "i_34": "{alignItems.start}",
        "i_35": "{xxs}",
        "i_36": "{xxs}",
        "i_37": "{xs}",
        "i_38": "{xs}",
        "i_39": "{xxs}",
        "i_40": "{flexDirection.row}",
        "i_41": "{justifyContent.start}",
        "i_42": "{alignItems.center}",
        "i_43": "{xs}",
        "i_44": "{xs}",
        "i_45": "{opacity.disabled}",
        "i_46": "{feedbackSuccess50}",
        "i_47": "{feedbackSuccess50}",
        "i_48": "{feedbackSuccess50}",
        "i_49": "{feedbackSuccess50}",
        "i_50": "{feedbackError50}",
        "i_51": "{feedbackError50}",
        "i_52": "{feedbackError50}",
        "i_53": "{feedbackError50}",
        "i_54": "{feedbackWarning50}",
        "i_55": "{feedbackWarning50}",
        "i_56": "{feedbackWarning50}",
        "i_57": "{feedbackWarning50}",
        "i_58": "{l}",
        "i_59": "{xxs}",
        "i_60": "{xxs}",
        "i_61": "{xxl}",
        "i_62": "{s}",
        "i_63": "{s}",
        "i_64": "{s}",
        "i_65": "{xs}",
        "i_66": "{xs}"
    },
    "JDSModalDesktop": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{opacity.invisible}",
        "m_2": "{opacity.enabled}",
        "m_3": "{justifyContent.center}",
        "m_4": "{alignItems.center}",
        "m_5": "{size.max}",
        "m_6": "{size.max}",
        "m_7": "{global.black}",
        "m_8": "{custom_2}",
        "m_9": "{flexDirection.column}",
        "m_10": "{justifyContent.start}",
        "m_11": "{alignItems.start}",
        "m_12": "{xxl}",
        "m_13": "{primaryBackground}",
        "m_14": "{size.max}",
        "m_15": "{flexDirection.row}",
        "m_16": "{justifyContent.end}",
        "m_17": "{alignItems.center}",
        "m_18": "{size.max}",
        "m_19": "{s}",
        "m_20": "{s}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{flexDirection.column}",
        "m_24": "{justifyContent.start}",
        "m_25": "{alignItems.start}",
        "m_26": "{l}",
        "m_27": "{l}",
        "m_28": "{l}",
        "m_29": "{size.max}",
        "m_30": "auto",
        "m_31": "auto",
        "m_32": "{flexDirection.row}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.center}",
        "m_35": "{size.max}",
        "m_36": "{base}",
        "m_37": "{size.max}",
        "m_38": "auto",
        "m_39": "{size.max}",
        "m_40": "{justifyContent.end}",
        "m_41": "{alignItems.start}",
        "m_42": "{flexDirection.row}",
        "m_43": "{s}",
        "m_44": "{base}",
        "m_45": "{flexDirection.column}",
        "m_46": "{justifyContent.start}",
        "m_47": "{alignItems.start}",
        "m_48": "{xxl}",
        "m_49": "{primaryBackground}",
        "m_50": "{l}",
        "m_51": "{l}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{size.max}",
        "m_55": "{size.max}",
        "m_56": "{justifyContent.end}",
        "m_57": "{justifyContent.center}",
        "m_58": "{m}",
        "m_59": "{m}",
        "m_60": "{m}",
        "m_61": "{l}",
        "m_62": "{l}"
    },
    "JDSModalDesktopInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{size.max}",
        "m_8": "{global.black}",
        "m_9": "{custom_2}",
        "m_10": "{flexDirection.column}",
        "m_11": "{justifyContent.start}",
        "m_12": "{alignItems.start}",
        "m_13": "{xxl}",
        "m_14": "{elevation1}",
        "m_15": "{custom_27}",
        "m_16": "{size.max}",
        "m_17": "{flexDirection.row}",
        "m_18": "{justifyContent.end}",
        "m_19": "{alignItems.center}",
        "m_20": "{size.max}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{s}",
        "m_24": "{s}",
        "m_25": "{flexDirection.column}",
        "m_26": "{justifyContent.start}",
        "m_27": "{alignItems.start}",
        "m_28": "{l}",
        "m_29": "{l}",
        "m_30": "{l}",
        "m_31": "{size.max}",
        "m_32": "auto",
        "m_33": "auto",
        "m_34": "{flexDirection.row}",
        "m_35": "{justifyContent.start}",
        "m_36": "{alignItems.center}",
        "m_37": "{size.max}",
        "m_38": "{base}",
        "m_39": "{size.max}",
        "m_40": "auto",
        "m_41": "{size.max}",
        "m_42": "{justifyContent.end}",
        "m_43": "{alignItems.start}",
        "m_44": "{flexDirection.row}",
        "m_45": "{s}",
        "m_46": "{base}",
        "m_47": "{flexDirection.column}",
        "m_48": "{justifyContent.start}",
        "m_49": "{alignItems.start}",
        "m_50": "{xxl}",
        "m_51": "{primaryBackground}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{l}",
        "m_55": "{l}",
        "m_56": "80%",
        "m_57": "80%",
        "m_58": "{justifyContent.end}",
        "m_59": "{justifyContent.center}",
        "m_60": "{m}",
        "m_61": "{m}",
        "m_62": "{m}",
        "m_63": "{l}",
        "m_64": "{l}",
        "m_65": "{opacity.enabled}",
        "m_66": "{easeExit}",
        "m_67": "{custom_27}",
        "m_68": "{modal_desktop_comibation_medium_width}",
        "m_69": "{modal_desktop_combination_small_width}",
        "m_70": "{modal_desktop_combination_small_width}"
    },
    "JDSMenuBlockItem": {
        "m_0": "{opacity.enabled}",
        "m_1": "{global.transparent}",
        "m_2": "{size.max}",
        "m_3": "{global.transparent}",
        "m_4": "{size.max}",
        "m_5": "{xs}",
        "m_6": "{base}",
        "m_7": "{xs}",
        "m_8": "{base}",
        "m_9": "{flexDirection.row}",
        "m_10": "{alignItems.center}",
        "m_11": "{justifyContent.spaceBetween}",
        "m_12": "{global.transparent}",
        "m_13": "{primaryGrey20}",
        "m_14": "{primary60}",
        "m_15": "{small}",
        "m_16": "{size.max}",
        "m_17": "{xs}",
        "m_18": "{base}",
        "m_19": "{xs}",
        "m_20": "{base}",
        "m_21": "{size.max}",
        "m_22": "{alignItems.center}",
        "m_23": "{justifyContent.start}",
        "m_24": "{xs}",
        "m_25": "{flexDirection.row}",
        "m_26": "{alignItems.center}",
        "m_27": "{primaryGrey20}",
        "m_28": "{opacity.disabled}",
        "m_29": "{xxl}"
    },
    "JDSModalMobile": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{opacity.enabled}",
        "m_8": "{easeExit}"
    },
    "JDSModalMobileInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{size.max}",
        "m_5": "{global.black}",
        "m_6": "{custom_2}",
        "m_7": "{flexDirection.column}",
        "m_8": "{justifyContent.start}",
        "m_9": "{alignItems.start}",
        "m_10": "{xl}",
        "m_11": "{size.max}",
        "m_12": "{custom_31}",
        "m_13": "{elevation1}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.center}",
        "m_16": "{alignItems.center}",
        "m_17": "{xl}",
        "m_18": "{size.max}",
        "m_19": "{size.max}",
        "m_20": "{m}",
        "m_21": "{m}",
        "m_22": "{m}",
        "m_23": "{m}",
        "m_24": "{flexDirection.row}",
        "m_25": "{justifyContent.end}",
        "m_26": "{alignItems.center}",
        "m_27": "{size.max}",
        "m_28": "{s}",
        "m_29": "{s}",
        "m_30": "{s}",
        "m_31": "{s}",
        "m_32": "{flexDirection.column}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.start}",
        "m_35": "{size.max}",
        "m_36": "{l}",
        "m_37": "{l}",
        "m_38": "{l}",
        "m_39": "auto",
        "m_40": "{flexDirection.row}",
        "m_41": "{justifyContent.start}",
        "m_42": "{alignItems.center}",
        "m_43": "{size.max}",
        "m_44": "{base}",
        "m_45": "{alignItems.start}",
        "m_46": "{size.max}",
        "m_47": "auto",
        "m_48": "{flexDirection.column}",
        "m_49": "{size.max}",
        "m_50": "{justifyContent.start}",
        "m_51": "{alignItems.start}",
        "m_52": "{flexDirection.column}",
        "m_53": "{s}",
        "m_54": "{base}",
        "m_55": "{flexDirection.column}",
        "m_56": "{justifyContent.start}",
        "m_57": "{alignItems.start}",
        "m_58": "{xl}",
        "m_59": "{elevation1}",
        "m_60": "{l}",
        "m_61": "{l}",
        "m_62": "{l}",
        "m_63": "{l}",
        "m_64": "{size.max}",
        "m_65": "{justifyContent.end}",
        "m_66": "{justifyContent.center}",
        "m_67": "{m}",
        "m_68": "{m}",
        "m_69": "{m}",
        "m_70": "{l}",
        "m_71": "{l}",
        "m_72": "{opacity.enabled}",
        "m_73": "{easeExit}"
    },
    "JDSHeaderDesktop": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{flexDirection.row}",
        "h_3": "{justifyContent.start}",
        "h_4": "{alignItems.center}",
        "h_5": "{xs}",
        "h_6": "{size.max}",
        "h_7": "{primary50}",
        "h_8": "{flexDirection.row}",
        "h_9": "{justifyContent.spaceBetween}",
        "h_10": "{alignItems.center}",
        "h_11": "{xxl}",
        "h_12": "{s}",
        "h_13": "{xxl}",
        "h_14": "{s}",
        "h_15": "{base}",
        "h_16": "{custom_16}",
        "h_17": "{flexDirection.row}",
        "h_18": "{justifyContent.start}",
        "h_19": "{alignItems.center}",
        "h_20": "{base}",
        "h_21": "{flexDirection.row}",
        "h_22": "{justifyContent.center}",
        "h_23": "{alignItems.center}",
        "h_24": "{xs}",
        "h_25": "{flexDirection.row}",
        "h_26": "{justifyContent.center}",
        "h_27": "{alignItems.center}",
        "h_28": "{xs}",
        "h_29": "{flexDirection.row}",
        "h_30": "{justifyContent.start}",
        "h_31": "{alignItems.center}",
        "h_32": "{l}",
        "h_33": "{huge}",
        "h_34": "{flexDirection.row}",
        "h_35": "{justifyContent.end}",
        "h_36": "{alignItems.center}",
        "h_37": "{s}",
        "h_38": "{flexDirection.row}",
        "h_39": "{justifyContent.end}",
        "h_40": "{alignItems.center}",
        "h_41": "{s}",
        "h_42": "{size.max}",
        "h_43": "{flexDirection.row}",
        "h_44": "{justifyContent.center}",
        "h_45": "{alignItems.center}",
        "h_46": "{s}",
        "h_47": "{size.max}",
        "h_48": "{huge}",
        "h_49": "{s}",
        "h_50": "{s}",
        "h_51": "{s}",
        "h_52": "{xs}",
        "h_53": "{xs}",
        "h_54": "{xs}",
        "h_55": "{size.max}",
        "h_56": "{justifyContent.spaceBetween}",
        "h_57": "{size.max}",
        "h_58": "{intrinsicSize.max}",
        "h_59": "{justifyContent.spaceBetween}"
    },
    "JDSBottomNavigation": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.row}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{primaryBackground}",
        "b_5": "{m}",
        "b_6": "{base}",
        "b_7": "{m}",
        "b_8": "{base}",
        "b_9": "{m}",
        "b_10": 0,
        "b_11": -1,
        "b_12": 0,
        "b_13": 0,
        "b_14": 1,
        "b_15": "{primaryGrey40}"
    },
    "JDSBottomNavigationItem": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.column}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{xxs}",
        "b_5": "{opacity.disabled}",
        "b_6": "{opacity.enabled}"
    },
    "JDSMegaMenu": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSMegaMenuInternal": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSHeaderMobile": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{size.max}",
        "h_4": "{primary50}",
        "h_5": "{flexDirection.row}",
        "h_6": "{justifyContent.spaceBetween}",
        "h_7": "{alignItems.center}",
        "h_8": "{s}",
        "h_9": "{xs}",
        "h_10": "{s}",
        "h_11": "{xs}",
        "h_12": "{base}",
        "h_13": "{huge}",
        "h_14": "{flexDirection.row}",
        "h_15": "{justifyContent.start}",
        "h_16": "{alignItems.center}",
        "h_17": "{base}",
        "h_18": "{flexDirection.row}",
        "h_19": "{justifyContent.start}",
        "h_20": "{alignItems.center}",
        "h_21": "{xs}",
        "h_22": "{flexDirection.row}",
        "h_23": "{justifyContent.center}",
        "h_24": "{alignItems.center}",
        "h_25": "{xs}",
        "h_26": "{flexDirection.row}",
        "h_27": "{justifyContent.start}",
        "h_28": "{alignItems.center}",
        "h_29": "{l}",
        "h_30": "{huge}",
        "h_31": "{flexDirection.row}",
        "h_32": "{justifyContent.end}",
        "h_33": "{alignItems.center}",
        "h_34": "{s}",
        "h_35": "{flexDirection.row}",
        "h_36": "{justifyContent.end}",
        "h_37": "{alignItems.center}",
        "h_38": "{s}",
        "h_39": "{flexDirection.row}",
        "h_40": "{justifyContent.center}",
        "h_41": "{alignItems.center}",
        "h_42": "{s}",
        "h_43": "{s}",
        "h_44": "{s}",
        "h_45": "{xxs}",
        "h_46": "{xs}",
        "h_47": "{xs}",
        "h_48": "{xs}",
        "h_49": "{intrinsicSize.max}",
        "h_50": "{m}"
    },
    "JDSMegaMenuItem": {
        "m_0": "{flexDirection.row}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{xs}",
        "m_4": "{xs}"
    },
    "JDSTextarea": {
        "t_0": "{flexDirection.column}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{xxs}",
        "t_4": "{size.max}",
        "t_5": "{flexDirection.stack}",
        "t_6": "{size.max}",
        "t_7": "{xxs}",
        "t_8": "{justifyContent.start}",
        "t_9": "{alignItems.end}",
        "t_10": "{flexDirection.row}",
        "t_11": "{justifyContent.start}",
        "t_12": "{size.max}",
        "t_13": "{alignItems.center}",
        "t_14": "{textAlign.start}",
        "t_15": "{primaryGrey60}",
        "t_16": "{bodyS}",
        "t_17": "{bodyS}",
        "t_18": "{bodyS}",
        "t_19": "{bodyS}",
        "t_20": "{bodyS}",
        "t_21": "{primaryGrey100}",
        "t_22": "{bodyS}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{primaryGrey100}",
        "t_28": "{primaryGrey100}",
        "t_29": "{size.max}",
        "t_30": "{primary50}",
        "t_31": "{primary60}",
        "t_32": "{primary60}",
        "t_33": "{flexDirection.column}",
        "t_34": "{size.max}",
        "t_35": "{alignItems.center}",
        "t_36": "{size.max}",
        "t_37": "{primaryGrey100}",
        "t_38": "{primary50}",
        "t_39": "{primary60}",
        "t_40": "{primary60}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}",
        "t_43": "{border_thin}",
        "t_44": "{primaryGrey60}",
        "t_45": "{custom_17}",
        "t_46": "{medium}",
        "t_47": "{custom_17}",
        "t_48": "{base}",
        "t_49": "{s}",
        "t_50": "{feedbackSuccess50}",
        "t_51": "{feedbackSuccess50}",
        "t_52": "{feedbackSuccess50}",
        "t_53": "{feedbackSuccess50}",
        "t_54": "{feedbackSuccess50}",
        "t_55": "{feedbackSuccess50}",
        "t_56": "{feedbackSuccess50}",
        "t_57": "{feedbackSuccess50}",
        "t_58": "{feedbackError50}",
        "t_59": "{feedbackError50}",
        "t_60": "{feedbackError50}",
        "t_61": "{feedbackError50}",
        "t_62": "{feedbackError50}",
        "t_63": "{feedbackError50}",
        "t_64": "{feedbackError50}",
        "t_65": "{feedbackError50}",
        "t_66": "{feedbackWarning50}",
        "t_67": "{feedbackWarning50}",
        "t_68": "{feedbackWarning50}",
        "t_69": "{feedbackWarning50}",
        "t_70": "{feedbackWarning50}",
        "t_71": "{feedbackWarning50}",
        "t_72": "{feedbackWarning50}",
        "t_73": "{feedbackWarning50}",
        "t_74": "{alignItems.start}",
        "t_75": "{primary60}",
        "t_76": "{primary60}",
        "t_77": "{primaryGrey40}",
        "t_78": "{primaryGrey60}",
        "t_79": "{primaryGrey80}"
    },
    "JDSSidePanelItem": {
        "s_0": "{xl}",
        "s_1": "{xs}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.spaceBetween}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.row}",
        "s_7": "{justifyContent.start}",
        "s_8": "{alignItems.center}",
        "s_9": "{base}",
        "s_10": "{s}",
        "s_11": "{s}"
    },
    "JDSMegaMenuBlock": {
        "m_0": "{flexDirection.column}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{base}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{alignItems.start}",
        "m_7": "{xs}"
    },
    "JDSNotificationButton": {
        "n_0": "{xxs}",
        "n_1": "{base}",
        "n_2": "{xxs}",
        "n_3": "{base}",
        "n_4": "{global.transparent}",
        "n_5": "{primaryGrey60}",
        "n_6": "{primary20}",
        "n_7": "{primary30}",
        "n_8": "{primary50}",
        "n_9": "{opacity.disabled}",
        "n_10": "{primary30}",
        "n_11": "{primary40}",
        "n_12": "{primary30}",
        "n_13": "{primary20}",
        "n_14": "{base}",
        "n_15": "{xs}",
        "n_16": "{xs}",
        "n_17": "{xs}",
        "n_18": "{xs}"
    },
    "JDSNotificationBanner": {
        "n_0": "{custom_11}",
        "n_1": "{size.max}",
        "n_2": "{flexDirection.column}",
        "n_3": "{justifyContent.center}",
        "n_4": "{alignItems.center}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{large}",
        "n_11": "{primaryGrey20}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.start}",
        "n_15": "{size.max}",
        "n_16": "{s}",
        "n_17": "{justifyContent.start}",
        "n_18": "{alignItems.start}",
        "n_19": "{flexDirection.column}",
        "n_20": "{xxs}",
        "n_21": "{flexDirection.row}",
        "n_22": "{xs}",
        "n_23": "{size.max}",
        "n_24": "{flexDirection.row}",
        "n_25": "{justifyContent.end}",
        "n_26": "{alignItems.center}",
        "n_27": "{alignItems.center}",
        "n_28": "{custom_3}",
        "n_29": "{custom_3}",
        "n_30": "{m}",
        "n_31": "{m}",
        "n_32": "{l}",
        "n_33": "{l}"
    },
    "JDSNudgeContainer": {
        "n_0": "{flexDirection.stack}",
        "n_1": "{size.max}",
        "n_2": "{base}",
        "n_3": "{base}",
        "n_4": "{base}",
        "n_5": "{base}",
        "n_6": "{flexDirection.column}",
        "n_7": "{justifyContent.start}",
        "n_8": "{alignItems.end}",
        "n_9": "{size.max}",
        "n_10": "{xs}"
    },
    "JDSToastContainer": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{base}",
        "t_3": "{base}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{flexDirection.column}",
        "t_7": "{justifyContent.end}",
        "t_8": "{alignItems.start}",
        "t_9": "{size.max}",
        "t_10": "{xs}"
    },
    "JDSToast": {
        "t_0": "{size.max}",
        "t_1": "{size.max}",
        "t_2": "{xl}",
        "t_3": "{primaryGrey80}",
        "t_4": "{flexDirection.column}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{s}",
        "t_11": "{size.max}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{flexDirection.column}",
        "t_16": "{justifyContent.start}",
        "t_17": "{alignItems.start}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{s}",
        "t_21": "{flexDirection.row}",
        "t_22": "{justifyContent.end}",
        "t_23": "{custom_13}",
        "t_24": "{custom_14}"
    },
    "JDSNudge": {
        "n_0": "{size.max}",
        "n_1": "{size.max}",
        "n_2": "{xl}",
        "n_3": "{primaryGrey80}",
        "n_4": "{flexDirection.column}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{s}",
        "n_11": "{size.max}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.center}",
        "n_15": "{flexDirection.column}",
        "n_16": "{justifyContent.start}",
        "n_17": "{alignItems.start}",
        "n_18": "{s}",
        "n_19": "{size.max}",
        "n_20": "{s}",
        "n_21": "{flexDirection.row}",
        "n_22": "{justifyContent.end}",
        "n_23": "{custom_13}",
        "n_24": "{custom_14}"
    },
    "JDSPagination": {
        "p_0": "{global.transparent}",
        "p_1": "{flexDirection.row}",
        "p_2": "{alignItems.center}",
        "p_3": "{alignItems.center}",
        "p_4": "{custom_25}",
        "p_5": "{custom_25}",
        "p_6": "{size.max}",
        "p_7": "{xxl}",
        "p_8": "{flexDirection.row}",
        "p_9": "{flexDirection.row}",
        "p_10": "{xxs}",
        "p_11": "{base}",
        "p_12": "{base}"
    },
    "JDSPromoCard": {
        "p_0": "{global.white}",
        "p_1": "{flexDirection.column}",
        "p_2": "{size.max}",
        "p_3": "{justifyContent.start}",
        "p_4": "{alignItems.start}",
        "p_5": "{xl}",
        "p_6": "{flexDirection.column}",
        "p_7": "{alignItems.start}",
        "p_8": "{justifyContent.start}",
        "p_9": "{size.max}",
        "p_10": "{xl}",
        "p_11": "{primaryBackground}",
        "p_12": "{flexDirection.row}",
        "p_13": "{alignItems.stretch}",
        "p_14": "{justifyContent.start}",
        "p_15": "{size.max}",
        "p_16": "{xl}",
        "p_17": "{intrinsicSize.max}",
        "p_18": "{primaryBackground}",
        "p_19": "{flexDirection.row}",
        "p_20": "{alignItems.start}",
        "p_21": "{justifyContent.start}",
        "p_22": "{size.max}",
        "p_23": "{primaryBackground}",
        "p_24": "{xl}",
        "p_25": "{xl}",
        "p_26": "{m}",
        "p_27": "{m}",
        "p_28": "{m}",
        "p_29": "{flexDirection.row}",
        "p_30": "{alignItems.start}",
        "p_31": "{justifyContent.start}",
        "p_32": "{size.max}",
        "p_33": "{primaryBackground}",
        "p_34": "{m}",
        "p_35": "{m}",
        "p_36": "{m}",
        "p_37": "{m}",
        "p_38": "{size.max}",
        "p_39": "{flexDirection.stack}",
        "p_40": "{alignItems.end}",
        "p_41": "{size.max}",
        "p_42": "{flexDirection.stack}",
        "p_43": "{alignItems.center}",
        "p_44": "{justifyContent.start}",
        "p_45": "{size.max}",
        "p_46": "{primaryBackground}",
        "p_47": "{size.max}",
        "p_48": "{xl}",
        "p_49": "{primaryBackground}",
        "p_50": "{size.max}",
        "p_51": "{xl}",
        "p_52": "{primaryBackground}",
        "p_53": "{size.max}",
        "p_54": "{justifyContent.spaceBetween}",
        "p_55": "{alignItems.center}",
        "p_56": "{flexDirection.row}",
        "p_57": "{base}",
        "p_58": "{m}",
        "p_59": "{m}",
        "p_60": "{base}",
        "p_61": "{base}",
        "p_62": "{l}",
        "p_63": "{l}",
        "p_64": "{l}",
        "p_65": "{l}",
        "p_66": "{l}",
        "p_67": "{l}",
        "p_68": "{l}",
        "p_69": "{l}"
    },
    "JDSSidePanel": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSSidePanelInternal": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSProgressBar": {
        "p_0": "{flexDirection.column}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.start}",
        "p_3": "{base}",
        "p_4": "{size.max}",
        "p_5": "{global.transparent}",
        "p_6": "{global.transparent}",
        "p_7": "{flexDirection.row}",
        "p_8": "{justifyContent.spaceBetween}",
        "p_9": "{alignItems.center}",
        "p_10": "{size.max}",
        "p_11": "{m}",
        "p_12": "{primaryGrey40}",
        "p_13": "{xs}",
        "p_14": "{size.max}",
        "p_15": "{flexDirection.row}",
        "p_16": "{justifyContent.start}",
        "p_17": "{alignItems.start}",
        "p_18": "{pill}",
        "p_19": "{primary50}",
        "p_20": "{xs}",
        "p_21": "{pill}",
        "p_22": "{xs}",
        "p_23": "{flexDirection.stack}",
        "p_24": "{primaryGrey40}",
        "p_25": "{xs}",
        "p_26": "{size.max}",
        "p_27": "{pill}",
        "p_28": "{size.max}",
        "p_29": "{size.max}",
        "p_30": "{massive}",
        "p_31": "{primary50}",
        "p_32": "{pill}",
        "p_33": "{feedbackSuccess50}",
        "p_34": "{feedbackSuccess50}",
        "p_35": "{feedbackError50}",
        "p_36": "{feedbackError50}",
        "p_37": "{feedbackWarning50}",
        "p_38": "{feedbackWarning50}",
        "p_39": "{justifyContent.center}"
    },
    "JDSSearchBox": {
        "s_0": "{primaryGrey20}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.start}",
        "s_3": "{alignItems.center}",
        "s_4": "{s}",
        "s_5": "{s}",
        "s_6": "{size.max}",
        "s_7": "{xl}",
        "s_8": "{pill}",
        "s_9": "{s}",
        "s_10": "{opacity.enabled}",
        "s_11": "{primary60}",
        "s_12": "{border_focus}",
        "s_13": "{primaryGrey40}",
        "s_14": "{textAlign.start}",
        "s_15": "{primaryGrey100}",
        "s_16": "{bodyS}",
        "s_17": "{bodyS}",
        "s_18": "{bodyS}",
        "s_19": "{bodyS}",
        "s_20": "{bodyS}",
        "s_21": "{primaryGrey100}",
        "s_22": "{bodyS}",
        "s_23": "{bodyS}",
        "s_24": "{bodyS}",
        "s_25": "{bodyS}",
        "s_26": "{bodyS}",
        "s_27": "{primary60}",
        "s_28": "{primary60}",
        "s_29": "{primary60}",
        "s_30": "{primary60}",
        "s_31": "{flexDirection.row}",
        "s_32": "{justifyContent.center}",
        "s_33": "{alignItems.center}",
        "s_34": "{m}",
        "s_35": "{primaryGrey100}",
        "s_36": "{primary60}",
        "s_37": "{primary60}",
        "s_38": "{primaryGrey80}",
        "s_39": "{flexDirection.row}",
        "s_40": "{justifyContent.center}",
        "s_41": "{alignItems.center}",
        "s_42": "{m}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary60}",
        "s_46": "{primaryGrey100}",
        "s_47": "{primary60}",
        "s_48": "{primary80}",
        "s_49": "{primary70}",
        "s_50": "{primaryBackground}",
        "s_51": "{primary30}",
        "s_52": "{primary30}",
        "s_53": "{primaryBackground}",
        "s_54": "{primary30}",
        "s_55": "{primary30}",
        "s_56": "{primaryBackground}",
        "s_57": "{primary40}",
        "s_58": "{primary30}",
        "s_59": "{primary30}",
        "s_60": "{primaryBackground}",
        "s_61": "{primaryGrey60}",
        "s_62": "{primary50}",
        "s_63": "{primary80}",
        "s_64": "{primary60}",
        "s_65": "{border_thin}",
        "s_66": "{border_focus}",
        "s_67": "{primaryGrey100}",
        "s_68": "{primary60}",
        "s_69": "{primaryGrey100}",
        "s_70": "{primaryGrey100}",
        "s_71": "{primary60}",
        "s_72": "{primary60}",
        "s_73": "{primaryGrey100}",
        "s_74": "{primary60}",
        "s_75": "{primary60}",
        "s_76": "{opacity.disabled}",
        "s_77": "{primaryGrey80}",
        "s_78": "{primary30}",
        "s_79": "{primaryGrey60}",
        "s_80": "{primaryGrey80}",
        "s_81": "{primary60}"
    },
    "JDSPaginationButton": {
        "p_0": "{xxl}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.center}",
        "p_3": "{global.transparent}",
        "p_4": "{flexDirection.row}",
        "p_5": "{justifyContent.center}",
        "p_6": "{alignItems.center}",
        "p_7": "{pill}",
        "p_8": "{l}",
        "p_9": "{l}",
        "p_10": "{opacity.enabled}",
        "p_11": "{xs}",
        "p_12": "{primary80}",
        "p_13": "{primary20}",
        "p_14": "{primary30}",
        "p_15": "{border_focus}",
        "p_16": "{primary70}",
        "p_17": "{global.transparent}"
    },
    "JDSSearchResultItem": {
        "s_0": "{flexDirection.row}",
        "s_1": "{base}",
        "s_2": "{xs}",
        "s_3": "{xs}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{primaryGrey20}",
        "s_7": "{primaryGrey20}",
        "s_8": "{primaryGrey20}",
        "s_9": "{l}",
        "s_10": "{primaryGrey80}",
        "s_11": "{flexDirection.row}",
        "s_12": "{justifyContent.start}",
        "s_13": "{alignItems.center}"
    },
    "JDSSearchResultText": {},
    "JDSRadioButton": {
        "r_0": "{flexDirection.column}",
        "r_1": "{justifyContent.start}",
        "r_2": "{alignItems.start}",
        "r_3": "{xs}",
        "r_4": "{flexDirection.row}",
        "r_5": "{justifyContent.start}",
        "r_6": "{alignItems.center}",
        "r_7": "{xs}",
        "r_8": "{m}",
        "r_9": "{m}",
        "r_10": "{flexDirection.row}",
        "r_11": "{justifyContent.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{global.transparent}",
        "r_14": "{pill}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_thin}",
        "r_17": "{border_none}",
        "r_18": "{primary40}",
        "r_19": "{primary60}",
        "r_20": "{primary60}",
        "r_21": "{s}",
        "r_22": "{s}",
        "r_23": "{pill}",
        "r_24": "{textAlign.start}",
        "r_25": "{base}",
        "r_26": "{base}",
        "r_27": "{xxs}",
        "r_28": "{xs}",
        "r_29": "{xs}",
        "r_30": "{primary50}",
        "r_31": "{primary40}",
        "r_32": "{primary60}",
        "r_33": "{primary50}",
        "r_34": "{primaryInverse}",
        "r_35": "{opacity.disabled}",
        "r_36": "{opacity.enabled}",
        "r_37": "{global.white}",
        "r_38": "{global.white}",
        "r_39": "{global.white}"
    },
    "JDSSelector": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{opacity.enabled}",
        "s_2": "{alignItems.center}",
        "s_3": "{justifyContent.center}",
        "s_4": "{pill}",
        "s_5": "{xxs}",
        "s_6": "{xxs}",
        "s_7": "{xxs}",
        "s_8": "{xxs}",
        "s_9": "{xxs}",
        "s_10": "{xxs}",
        "s_11": "{xxs}",
        "s_12": "{xxs}",
        "s_13": "{primaryGrey20}",
        "s_14": "{pill}",
        "s_15": "{xxs}",
        "s_16": "{flexDirection.row}",
        "s_17": "{size.max}",
        "s_18": "{intrinsicSize.max}",
        "s_19": "{justifyContent.start}",
        "s_20": "{alignItems.center}",
        "s_21": "{primary50}",
        "s_22": "{pill}",
        "s_23": "{size.max}",
        "s_24": "{size.max}",
        "s_25": "{primary50}"
    },
    "JDSSelectorItem": {
        "s_0": "{opacity.enabled}",
        "s_1": "{global.transparent}",
        "s_2": "{flexDirection.row}",
        "s_3": "{alignItems.center}",
        "s_4": "{justifyContent.center}",
        "s_5": "{pill}",
        "s_6": "{xs}",
        "s_7": "{xs}",
        "s_8": "{base}",
        "s_9": "{xs}",
        "s_10": "{base}",
        "s_11": "{primary20}",
        "s_12": "{xxs}",
        "s_13": "{primary60}",
        "s_14": "{primary20}",
        "s_15": "{primary30}",
        "s_16": "{m}",
        "s_17": "{primary60}",
        "s_18": "{primary50}",
        "s_19": "{primary60}",
        "s_20": "{primary60}",
        "s_21": "{primary50}",
        "s_22": "{primaryInverse}",
        "s_23": "{primary30}",
        "s_24": "{flexDirection.column}",
        "s_25": "{size.max}",
        "s_26": "{opacity.disabled}",
        "s_27": "{xxs}"
    },
    "JDSSearchResults": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSearchResultsInternal": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSkeleton": {
        "s_0": "{primaryGrey20}",
        "s_1": "{primaryGrey20}",
        "s_2": "{primaryGrey40}",
        "s_3": "{pill}",
        "s_4": "{xxl}",
        "s_5": "{pill}",
        "s_6": "{pill}",
        "s_7": "{base}",
        "s_8": "{xl}",
        "s_9": "{xxl}",
        "s_10": "{size.max}",
        "s_11": "{size.max}"
    },
    "JDSServiceCard": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{size.max}",
        "s_3": "{size.max}",
        "s_4": "{justifyContent.start}",
        "s_5": "{justifyContent.start}",
        "s_6": "{alignItems.start}",
        "s_7": "{xl}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{xl}",
        "s_11": "{aspect_ratio.16.9}",
        "s_12": "{flexDirection.column}",
        "s_13": "{size.max}",
        "s_14": "{justifyContent.start}",
        "s_15": "{alignItems.start}",
        "s_16": "{flexDirection.row}",
        "s_17": "{justifyContent.start}",
        "s_18": "{alignItems.start}",
        "s_19": "{size.max}",
        "s_20": "{size.max}",
        "s_21": "{base}",
        "s_22": "{base}",
        "s_23": "{custom_color_4}",
        "s_24": "{size.max}",
        "s_25": "{base}",
        "s_26": "{base}",
        "s_27": "{base}",
        "s_28": "{base}",
        "s_29": "{size.max}",
        "s_30": "{aspect_ratio.1.1}",
        "s_31": "{aspect_ratio.4.3}",
        "s_32": "{aspect_ratio.4.5}"
    },
    "JDSNotificationIconButton": {
        "n_0": "{l}",
        "n_1": "{l}",
        "n_2": "{justifyContent.center}",
        "n_3": "{alignItems.center}",
        "n_4": "{global.transparent}",
        "n_5": "{global.transparent}",
        "n_6": "{primary30}",
        "n_7": "{primary40}",
        "n_8": "{primary30}",
        "n_9": "{primary50}",
        "n_10": "{base}",
        "n_11": "{primary20}",
        "n_12": "{opacity.disabled}"
    },
    "JDSSpinner": {
        "s_0": "{global.transparent}",
        "s_1": "{base}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{flexDirection.row}",
        "s_5": "{xxl}",
        "s_6": "{flexDirection.stack}",
        "s_7": "{justifyContent.center}",
        "s_8": "{alignItems.center}",
        "s_9": "{size.max}",
        "s_10": "{primaryGrey40}",
        "s_11": "{m}",
        "s_12": "{xs}",
        "s_13": 0,
        "s_14": 360,
        "s_15": "{primary50}",
        "s_16": "{m}",
        "s_17": "{xs}",
        "s_18": 0,
        "s_19": 120,
        "s_20": "1000",
        "s_21": "{primary50}",
        "s_22": "{m}",
        "s_23": "{xs}",
        "s_24": 0,
        "s_25": 360,
        "s_26": "300",
        "s_27": "1300",
        "s_28": "{secondary50}",
        "s_29": "{m}",
        "s_30": "{xs}",
        "s_31": 0,
        "s_32": 360,
        "s_33": "150",
        "s_34": "1300",
        "s_35": "{sparkle50}",
        "s_36": "{m}",
        "s_37": "{xs}",
        "s_38": 0,
        "s_39": 360,
        "s_40": "1300",
        "s_41": "{flexDirection.column}",
        "s_42": "{s}",
        "s_43": "{m}",
        "s_44": "{xxs}",
        "s_45": "{s}",
        "s_46": "{xxs}",
        "s_47": "{s}",
        "s_48": "{xxs}",
        "s_49": "{s}",
        "s_50": "{xxs}",
        "s_51": "{s}",
        "s_52": "{xxs}",
        "s_53": "{s}",
        "s_54": "{primaryGrey80}",
        "s_55": "{flexDirection.row}"
    },
    "JDSSelectorButton": {
        "s_0": "{primary50}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{pill}",
        "s_5": "{xs}",
        "s_6": "{xs}",
        "s_7": "{base}",
        "s_8": "{base}",
        "s_9": "{border_none}",
        "s_10": "{xs}",
        "s_11": "{opacity.enabled}",
        "s_12": "{primary30}",
        "s_13": "{primary60}",
        "s_14": "{border_focus}",
        "s_15": "{primary60}",
        "s_16": "{m}",
        "s_17": "{primaryInverse}",
        "s_18": "{primary70}",
        "s_19": "{m}",
        "s_20": "{primaryInverse}",
        "s_21": "{primary70}",
        "s_22": "{opacity.disabled}",
        "s_23": "{primary60}",
        "s_24": "{primary50}",
        "s_25": "{primary70}",
        "s_26": "{primary70}",
        "s_27": "{global.transparent}",
        "s_28": "{border_thin}",
        "s_29": "{primaryGrey60}",
        "s_30": "{primary20}",
        "s_31": "{primary60}",
        "s_32": "{primary20}",
        "s_33": "{border_focus}",
        "s_34": "{primary60}",
        "s_35": "{primary60}",
        "s_36": "{primary60}",
        "s_37": "{primary20}",
        "s_38": "{border_thin}",
        "s_39": "{primaryGrey60}",
        "s_40": "{primary60}",
        "s_41": "{primary30}",
        "s_42": "{border_focus}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary70}",
        "s_46": "{primary60}",
        "s_47": "{primary70}",
        "s_48": "{primary20}",
        "s_49": "{primary20}",
        "s_50": "{primary60}",
        "s_51": "{border_thin}",
        "s_52": "{primary30}",
        "s_53": "{border_focus}",
        "s_54": "{primary60}",
        "s_55": "{primary60}",
        "s_56": "{primary70}",
        "s_57": "{primary60}",
        "s_58": "{primary60}",
        "s_59": "{primary70}",
        "s_60": "{primary60}",
        "s_61": "{global.transparent}",
        "s_62": "{border_thin}",
        "s_63": "{primary60}",
        "s_64": "{primary20}",
        "s_65": "{primary20}",
        "s_66": "{primary60}",
        "s_67": "{primary60}",
        "s_68": "{primary60}",
        "s_69": "{primary60}",
        "s_70": "{primary60}",
        "s_71": "{primary60}",
        "s_72": "{global.transparent}",
        "s_73": "{border_focus}",
        "s_74": "{primary60}",
        "s_75": "{global.transparent}",
        "s_76": "{global.transparent}",
        "s_77": "{primary70}",
        "s_78": "{primary60}",
        "s_79": "{primary80}",
        "s_80": "{primary70}",
        "s_81": "{primary60}",
        "s_82": "{primary80}",
        "s_83": "{global.transparent}",
        "s_84": "{global.transparent}",
        "s_85": "{global.transparent}",
        "s_86": "{primary60}",
        "s_87": "{primary50}",
        "s_88": "{primary70}",
        "s_89": "{primary60}",
        "s_90": "{primary50}",
        "s_91": "{primary70}",
        "s_92": "{primaryGrey80}",
        "s_93": "{primary30}",
        "s_94": "{primary50}",
        "s_95": "{border_focus}",
        "s_96": "{primary60}",
        "s_97": "{primaryBackground}",
        "s_98": "{primary70}",
        "s_99": "{primaryInverse}",
        "s_100": "{primaryBackground}",
        "s_101": "{primary70}",
        "s_102": "{primaryInverse}",
        "s_103": "{global.transparent}",
        "s_104": "{border_thin}",
        "s_105": "{primaryGrey60}",
        "s_106": "{primary20}",
        "s_107": "{primary60}",
        "s_108": "{primary20}",
        "s_109": "{border_focus}",
        "s_110": "{primary60}",
        "s_111": "{primaryGrey80}",
        "s_112": "{primaryGrey80}",
        "s_113": "{primary20}",
        "s_114": "{primaryGrey60}",
        "s_115": "{primary60}",
        "s_116": "{primary30}",
        "s_117": "{border_focus}",
        "s_118": "{primary60}",
        "s_119": "{primary60}",
        "s_120": "{primary70}",
        "s_121": "{primary60}",
        "s_122": "{primary70}",
        "s_123": "{primary20}",
        "s_124": "{primary60}",
        "s_125": "{border_thin}",
        "s_126": "{primary30}",
        "s_127": "{border_focus}",
        "s_128": "{primary60}",
        "s_129": "{primary60}",
        "s_130": "{primary70}",
        "s_131": "{primary60}",
        "s_132": "{primary70}",
        "s_133": "{global.transparent}",
        "s_134": "{primary60}",
        "s_135": "{border_thin}",
        "s_136": "{primary20}",
        "s_137": "{primary20}",
        "s_138": "{border_focus}",
        "s_139": "{primary60}",
        "s_140": "{primaryGrey80}",
        "s_141": "{primary60}",
        "s_142": "{primary60}",
        "s_143": "{primaryGrey80}",
        "s_144": "{primary60}",
        "s_145": "{primary60}",
        "s_146": "{global.transparent}",
        "s_147": "{global.transparent}",
        "s_148": "{border_focus}",
        "s_149": "{primary60}",
        "s_150": "{primary60}",
        "s_151": "{primary50}",
        "s_152": "{primary80}",
        "s_153": "{primary60}",
        "s_154": "{primary50}",
        "s_155": "{primary80}",
        "s_156": "{global.transparent}",
        "s_157": "{global.transparent}",
        "s_158": "{border_focus}",
        "s_159": "{primary60}",
        "s_160": "{primaryGrey80}",
        "s_161": "{primary50}",
        "s_162": "{primary60}",
        "s_163": "{primaryGrey80}",
        "s_164": "{primary50}",
        "s_165": "{primary60}",
        "s_166": "{primaryBackground}",
        "s_167": "{primary30}",
        "s_168": "{primary50}",
        "s_169": "{border_focus}",
        "s_170": "{primary50}",
        "s_171": "{primaryGrey100}",
        "s_172": "{primaryGrey100}",
        "s_173": "{primaryGrey100}",
        "s_174": "{primaryInverse}",
        "s_175": "{primaryGrey100}",
        "s_176": "{primaryGrey100}",
        "s_177": "{primaryGrey100}",
        "s_178": "{primaryInverse}",
        "s_179": "{primary50}",
        "s_180": "{primary30}",
        "s_181": "{primary60}",
        "s_182": "{primary50}",
        "s_183": "{border_focus}",
        "s_184": "{primary40}",
        "s_185": "{primaryInverse}",
        "s_186": "{primaryGrey100}",
        "s_187": "{primaryInverse}",
        "s_188": "{primaryGrey100}",
        "s_189": "{global.transparent}",
        "s_190": "{border_thin}",
        "s_191": "{primaryGrey60}",
        "s_192": "{primary30}",
        "s_193": "{primary50}",
        "s_194": "{primary30}",
        "s_195": "{border_focus}",
        "s_196": "{primary50}",
        "s_197": "{primaryBackground}",
        "s_198": "{primaryGrey100}",
        "s_199": "{primaryGrey100}",
        "s_200": "{primaryBackground}",
        "s_201": "{primaryGrey100}",
        "s_202": "{primaryGrey100}",
        "s_203": "{primary30}",
        "s_204": "{primaryGrey60}",
        "s_205": "{primary50}",
        "s_206": "{primary50}",
        "s_207": "{border_focus}",
        "s_208": "{primary50}",
        "s_209": "{primaryGrey100}",
        "s_210": "{primaryInverse}",
        "s_211": "{primaryGrey100}",
        "s_212": "{primaryInverse}",
        "s_213": "{global.transparent}",
        "s_214": "{primary30}",
        "s_215": "{primary50}",
        "s_216": "{primary30}",
        "s_217": "{border_focus}",
        "s_218": "{primary50}",
        "s_219": "{primaryBackground}",
        "s_220": "{primaryGrey100}",
        "s_221": "{primaryGrey100}",
        "s_222": "{primaryBackground}",
        "s_223": "{primaryGrey100}",
        "s_224": "{primaryGrey100}",
        "s_225": "{primary30}",
        "s_226": "{primary50}",
        "s_227": "{border_focus}",
        "s_228": "{primary50}",
        "s_229": "{primary50}",
        "s_230": "{primaryGrey100}",
        "s_231": "{primaryInverse}",
        "s_232": "{primaryGrey100}",
        "s_233": "{primaryInverse}",
        "s_234": "{global.transparent}",
        "s_235": "{border_focus}",
        "s_236": "{primary50}",
        "s_237": "{global.transparent}",
        "s_238": "{global.transparent}",
        "s_239": "{primaryBackground}",
        "s_240": "{primary20}",
        "s_241": "{primary30}",
        "s_242": "{primaryBackground}",
        "s_243": "{primary20}",
        "s_244": "{primary30}",
        "s_245": "{global.transparent}",
        "s_246": "{border_focus}",
        "s_247": "{primary50}",
        "s_248": "{global.transparent}",
        "s_249": "{global.transparent}",
        "s_250": "{primary30}",
        "s_251": "{primary20}",
        "s_252": "{primary30}",
        "s_253": "{primary30}",
        "s_254": "{primary30}",
        "s_255": "{primary20}",
        "s_256": "{primary30}",
        "s_257": "{primary30}",
        "s_258": "{xxs}",
        "s_259": "{xxs}",
        "s_260": "{xs}",
        "s_261": "{xs}",
        "s_262": "{s}",
        "s_263": "{s}",
        "s_264": "{base}",
        "s_265": "{base}",
        "s_266": "{xxs}",
        "s_267": "{xxs}",
        "s_268": "{base}",
        "s_269": "{base}",
        "s_270": "{s}",
        "s_271": "{m}",
        "s_272": "{s}",
        "s_273": "{m}",
        "s_274": "{m}",
        "s_275": "{m}",
        "s_276": "{base}",
        "s_277": "{l}",
        "s_278": "{base}",
        "s_279": "{l}",
        "s_280": "{l}",
        "s_281": "{l}",
        "s_282": "{l}",
        "s_283": "{l}",
        "s_284": "{base}",
        "s_285": "{xl}",
        "s_286": "{xl}",
        "s_287": "{xxl}",
        "s_288": "{xxl}",
        "s_289": "{m}",
        "s_290": "{huge}",
        "s_291": "{huge}",
        "s_292": "{l}",
        "s_293": "{size.max}",
        "s_294": "{justifyContent.spaceBetween}",
        "s_295": "{primary60}",
        "s_296": "{primary60}"
    },
    "JDSSlider": {
        "s_0": "{flexDirection.column}",
        "s_1": "{justifyContent.start}",
        "s_2": "{alignItems.start}",
        "s_3": "{size.max}",
        "s_4": "{xs}",
        "s_5": "{flexDirection.row}",
        "s_6": "{justifyContent.start}",
        "s_7": "{alignItems.center}",
        "s_8": "{size.max}",
        "s_9": "{xs}",
        "s_10": "{justifyContent.start}",
        "s_11": "{alignItems.center}",
        "s_12": "{alignItems.center}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{border_thin}",
        "s_16": "{primaryGrey80}",
        "s_17": "{medium}",
        "s_18": "{size.max}",
        "s_19": "{xxs}",
        "s_20": "{primaryGrey40}",
        "s_21": "{primary50}",
        "s_22": "{primary50}",
        "s_23": "{primary80}",
        "s_24": "{small}",
        "s_25": "{primary60}",
        "s_26": "{primary60}",
        "s_27": "{primary60}",
        "s_28": "{border_focus}",
        "s_29": "{flexDirection.row}",
        "s_30": "{justifyContent.spaceBetween}",
        "s_31": "{alignItems.center}",
        "s_32": "{size.max}",
        "s_33": "{feedbackSuccess50}",
        "s_34": "{feedbackError50}",
        "s_35": "{feedbackWarning50}",
        "s_36": "{opacity.disabled}",
        "s_37": "{primary50}",
        "s_38": "{primary50}",
        "s_39": "{primary50}"
    },
    "JDSStepperDot": {
        "s_0": "{global.transparent}",
        "s_1": "{border_thin}",
        "s_2": "{sparkleGrey60}",
        "s_3": "{l}",
        "s_4": "{l}",
        "s_5": "{justifyContent.center}",
        "s_6": "{alignItems.center}",
        "s_7": "{pill}",
        "s_8": "{sparkleGrey60}",
        "s_9": "{base}",
        "s_10": "{sparkle60}",
        "s_11": "{base}",
        "s_12": "{sparkleGrey60}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{pill}",
        "s_16": "{sparkle50}",
        "s_17": "{sparkle50}",
        "s_18": "{sparkleInverse}",
        "s_19": "{sparkleInverse}",
        "s_20": "{sparkle20}",
        "s_21": "{sparkle50}",
        "s_22": "{l}",
        "s_23": "{l}",
        "s_24": "{sparkle60}",
        "s_25": "{sparkle60}",
        "s_26": "{opacity.disabled}"
    },
    "JDSHorizontalStepItem": {
        "h_0": "{flexDirection.column}",
        "h_1": "{alignItems.center}",
        "h_2": "{justifyContent.start}",
        "h_3": "{size.max}",
        "h_4": "{xs}",
        "h_5": "{flexDirection.row}",
        "h_6": "{size.max}",
        "h_7": "{alignItems.center}",
        "h_8": "{xs}",
        "h_9": "{xs}",
        "h_10": "{xs}",
        "h_11": "{opacity.enabled}",
        "h_12": "{opacity.enabled}",
        "h_13": "{opacity.invisible}",
        "h_14": "{opacity.invisible}"
    },
    "JDSVerticalStepItem": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{xs}",
        "v_4": "{size.max}",
        "v_5": "{opacity.enabled}",
        "v_6": "{flexDirection.row}",
        "v_7": "{justifyContent.start}",
        "v_8": "{alignItems.center}",
        "v_9": "{intrinsicSize.max}",
        "v_10": "{flexDirection.row}",
        "v_11": "{justifyContent.start}",
        "v_12": "{alignItems.stretch}",
        "v_13": "{l}",
        "v_14": "{custom_23}",
        "v_15": "{flexDirection.row}",
        "v_16": "{justifyContent.start}",
        "v_17": "{alignItems.center}",
        "v_18": "{base}",
        "v_19": "0",
        "v_20": "0",
        "v_21": "{custom_24}",
        "v_22": "{xs}",
        "v_23": "{m}",
        "v_24": "{opacity.invisible}"
    },
    "JDSTableCell": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{global.transparent}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{primaryGrey40}",
        "t_9": "{size.max}",
        "t_10": "{xs}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{primaryGrey40}",
        "t_15": 1,
        "t_16": "{primary50}",
        "t_17": "{primary60}",
        "t_18": "{primaryGrey20}",
        "t_19": 1,
        "t_20": 4,
        "t_21": 0
    },
    "JDSTableBody": {
        "t_0": "{size.max}",
        "t_1": "{flexDirection.row}",
        "t_2": "{size.max}"
    },
    "JDSTableRow": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}"
    },
    "JDSTabBar": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{justifyContent.start}",
        "t_4": "{alignItems.end}",
        "t_5": "{size.max}",
        "t_6": "{opacity.enabled}",
        "t_7": "{global.transparent}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.start}",
        "t_10": "{m}",
        "t_11": "{flexDirection.row}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{size.max}",
        "t_16": "{pill}",
        "t_17": "{primary50}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{justifyContent.center}",
        "t_21": "{primary60}",
        "t_22": "{xxl}",
        "t_23": "{xxl}",
        "t_24": "{custom_dark_primary_60}",
        "t_25": "{m}",
        "t_26": "{m}"
    },
    "JDSVerticalStepper": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{size.max}",
        "v_4": "{xs}"
    },
    "JDSTabItem": {
        "t_0": "{global.transparent}",
        "t_1": "{flexDirection.column}",
        "t_2": "{alignItems.center}",
        "t_3": "{justifyContent.center}",
        "t_4": "{xxl}",
        "t_5": "{intrinsicSize.max}",
        "t_6": "{intrinsicSize.max}",
        "t_7": "{flexDirection.row}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.center}",
        "t_10": "{xs}",
        "t_11": "{s}",
        "t_12": "{s}",
        "t_13": "{xs}",
        "t_14": "{xs}",
        "t_15": "{border_normal}",
        "t_16": "{primary80}",
        "t_17": "{large}",
        "t_18": "{m}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primaryGrey100}",
        "t_21": "{primary60}",
        "t_22": "{primaryGrey80}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{bodyS}",
        "t_28": "{primary60}",
        "t_29": "{global.transparent}",
        "t_30": "{xxs}",
        "t_31": "{size.max}",
        "t_32": "{pill}",
        "t_33": "{opacity.enabled}",
        "t_34": "{opacity.disabled}",
        "t_35": "{primaryGrey100}",
        "t_36": "{primary60}",
        "t_37": "{custom_dark_primary_40}",
        "t_38": "{custom_dark_primary_60}",
        "t_39": "{custom_dark_primary_grey_100}",
        "t_40": "{custom_dark_primary_grey_80}",
        "t_41": "{custom_dark_primary_grey_100}",
        "t_42": "{custom_dark_primary_grey_100}",
        "t_43": "{custom_dark_primary_grey_80}",
        "t_44": "{custom_dark_primary_grey_100}",
        "t_45": "{primaryGrey100}",
        "t_46": "{primaryGrey100}"
    },
    "JDSTabsDesktop": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{flexDirection.row}",
        "t_4": "{size.max}",
        "t_5": "{alignItems.center}",
        "t_6": "{size.max}",
        "t_7": "{base}",
        "t_8": "{primary60}"
    },
    "JDSTag": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{xxs}",
        "t_4": "{s}",
        "t_5": "{s}",
        "t_6": "{xxs}",
        "t_7": "{xxs}",
        "t_8": "{global.transparent}",
        "t_9": "{pill}",
        "t_10": "{border_thin}",
        "t_11": "{primaryGrey80}",
        "t_12": "{primaryGrey80}",
        "t_13": "{sparkle20}",
        "t_14": "{sparkle80}",
        "t_15": "{border_focus}",
        "t_16": "{base}",
        "t_17": "{primaryGrey100}",
        "t_18": "{sparkle80}",
        "t_19": "{sparkle80}",
        "t_20": "{sparkle80}",
        "t_21": "{border_none}",
        "t_22": "{primaryGrey80}",
        "t_23": "{sparkle20}",
        "t_24": "{sparkle30}",
        "t_25": "{global.transparent}",
        "t_26": "{primaryGrey40}",
        "t_27": "{sparkle30}",
        "t_28": "{sparkle80}",
        "t_29": "{opacity.disabled}",
        "t_30": "{opacity.enabled}",
        "t_31": "{custom_4}",
        "t_32": "{xs}",
        "t_33": "{xs}",
        "t_34": "{custom_4}"
    },
    "JDSHorizontalStepper": {
        "h_0": "{stepper_horizontal}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{flexDirection.row}",
        "h_4": "{justifyContent.center}",
        "h_5": "{alignItems.center}",
        "h_6": "{size.max}",
        "h_7": "{l}",
        "h_8": "{l}",
        "h_9": "{size.max}",
        "h_10": "{flexDirection.row}",
        "h_11": "{justifyContent.start}",
        "h_12": "{alignItems.center}"
    },
    "JDSTable": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{medium}",
        "t_3": "{border_thin}",
        "t_4": "{primaryGrey40}",
        "t_5": "{size.max}",
        "t_6": "{alignItems.start}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{base}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{xs}"
    },
    "JDSToggle": {
        "t_0": "{flexDirection.column}",
        "t_1": "{flexDirection.column}",
        "t_2": "{justifyContent.start}",
        "t_3": "{alignItems.start}",
        "t_4": "{xs}",
        "t_5": "{flexDirection.row}",
        "t_6": "{justifyContent.start}",
        "t_7": "{alignItems.center}",
        "t_8": "{xs}",
        "t_9": "{custom_2}",
        "t_10": "{m}",
        "t_11": "{flexDirection.row}",
        "t_12": "{justifyContent.start}",
        "t_13": "{alignItems.center}",
        "t_14": "{xxs}",
        "t_15": "{xxs}",
        "t_16": "{global.transparent}",
        "t_17": "{pill}",
        "t_18": "{border_thin}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primary40}",
        "t_21": "{primary60}",
        "t_22": "{xxs}",
        "t_23": "{primary60}",
        "t_24": "{border_none}",
        "t_25": "{base}",
        "t_26": "{base}",
        "t_27": "{primaryGrey80}",
        "t_28": "{pill}",
        "t_29": "{textAlign.start}",
        "t_30": "{custom_3}",
        "t_31": "{base}",
        "t_32": "{xxs}",
        "t_33": "{xs}",
        "t_34": "{xs}",
        "t_35": "{justifyContent.end}",
        "t_36": "{primary50}",
        "t_37": "{border_none}",
        "t_38": "{primary40}",
        "t_39": "{primary60}",
        "t_40": "{primaryInverse}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}"
    },
    "JDSText": {
        "text_0": "{primary60}",
        "text_1": "{bodyS}",
        "text_2": "{primaryGrey100}",
        "text_3": "{bodyS}",
        "text_4": "{bodyS}",
        "text_5": "{bodyS}",
        "text_6": "{bodyS}",
        "text_7": "{text-decoration.none}",
        "text_8": "{text-case.none}",
        "text_9": "{text-decoration.underline}",
        "text_10": "{text-decoration.line-through}",
        "text_11": "{text-decoration.overline}",
        "text_12": "{primary80}",
        "text_13": "{primary70}",
        "text_14": "{primary60}",
        "text_15": "{primary50}",
        "text_16": "{primary40}",
        "text_17": "{primary30}",
        "text_18": "{primary20}",
        "text_19": "{primaryInverse}",
        "text_20": "{primaryBackground}",
        "text_21": "{primaryGrey100}",
        "text_22": "{primaryGrey80}",
        "text_23": "{primaryGrey60}",
        "text_24": "{primaryGrey40}",
        "text_25": "{primaryGrey20}",
        "text_26": "{secondary80}",
        "text_27": "{secondary70}",
        "text_28": "{secondary60}",
        "text_29": "{secondary50}",
        "text_30": "{secondary40}",
        "text_31": "{secondary30}",
        "text_32": "{secondary20}",
        "text_33": "{secondaryInverse}",
        "text_34": "{secondaryBackground}",
        "text_35": "{secondaryGrey100}",
        "text_36": "{secondaryGrey80}",
        "text_37": "{secondaryGrey60}",
        "text_38": "{secondaryGrey40}",
        "text_39": "{secondaryGrey20}",
        "text_40": "{sparkle80}",
        "text_41": "{sparkle70}",
        "text_42": "{sparkle60}",
        "text_43": "{sparkle50}",
        "text_44": "{sparkle40}",
        "text_45": "{sparkle30}",
        "text_46": "{sparkle20}",
        "text_47": "{sparkleInverse}",
        "text_48": "{sparkleBackground}",
        "text_49": "{sparkleGrey100}",
        "text_50": "{sparkleGrey80}",
        "text_51": "{sparkleGrey60}",
        "text_52": "{sparkleGrey40}",
        "text_53": "{sparkleGrey20}",
        "text_54": "{feedbackError80}",
        "text_55": "{feedbackError50}",
        "text_56": "{feedbackError20}",
        "text_57": "{feedbackWarning80}",
        "text_58": "{feedbackWarning50}",
        "text_59": "{feedbackWarning20}",
        "text_60": "{feedbackSuccess80}",
        "text_61": "{feedbackSuccess50}",
        "text_62": "{feedbackSuccess20}",
        "text_63": "{global.white}",
        "text_64": "{global.black}",
        "text_65": "{global.transparent}",
        "text_66": "{headingXl}",
        "text_67": "{headingXl}",
        "text_68": "{headingXl}",
        "text_69": "{headingXl}",
        "text_70": "{headingXl}",
        "text_71": "{headingL}",
        "text_72": "{headingL}",
        "text_73": "{headingL}",
        "text_74": "{headingL}",
        "text_75": "{headingL}",
        "text_76": "{headingM}",
        "text_77": "{headingM}",
        "text_78": "{headingM}",
        "text_79": "{headingM}",
        "text_80": "{headingM}",
        "text_81": "{headingS}",
        "text_82": "{headingS}",
        "text_83": "{headingS}",
        "text_84": "{headingS}",
        "text_85": "{headingS}",
        "text_86": "{headingXs}",
        "text_87": "{headingXs}",
        "text_88": "{headingXs}",
        "text_89": "{headingXs}",
        "text_90": "{headingXs}",
        "text_91": "{headingXxs}",
        "text_92": "{headingXxs}",
        "text_93": "{headingXxs}",
        "text_94": "{headingXxs}",
        "text_95": "{headingXxs}",
        "text_96": "{overline}",
        "text_97": "{overline}",
        "text_98": "{overline}",
        "text_99": "{overline}",
        "text_100": "{overline}",
        "text_101": "{overline}",
        "text_102": "{bodyL}",
        "text_103": "{bodyL}",
        "text_104": "{bodyL}",
        "text_105": "{bodyL}",
        "text_106": "{bodyL}",
        "text_107": "{bodyLBold}",
        "text_108": "{bodyLBold}",
        "text_109": "{bodyLBold}",
        "text_110": "{bodyLBold}",
        "text_111": "{bodyLBold}",
        "text_112": "{bodyLLink}",
        "text_113": "{bodyLLink}",
        "text_114": "{bodyLLink}",
        "text_115": "{bodyLLink}",
        "text_116": "{bodyLLink}",
        "text_117": "{bodyM}",
        "text_118": "{bodyM}",
        "text_119": "{bodyM}",
        "text_120": "{bodyM}",
        "text_121": "{bodyM}",
        "text_122": "{bodyMBold}",
        "text_123": "{bodyMBold}",
        "text_124": "{bodyMBold}",
        "text_125": "{bodyMBold}",
        "text_126": "{bodyMBold}",
        "text_127": "{bodyMLink}",
        "text_128": "{bodyMLink}",
        "text_129": "{bodyMLink}",
        "text_130": "{bodyMLink}",
        "text_131": "{bodyMLink}",
        "text_132": "{bodyS}",
        "text_133": "{bodyS}",
        "text_134": "{bodyS}",
        "text_135": "{bodyS}",
        "text_136": "{bodyS}",
        "text_137": "{bodySBold}",
        "text_138": "{bodySBold}",
        "text_139": "{bodySBold}",
        "text_140": "{bodySBold}",
        "text_141": "{bodySBold}",
        "text_142": "{bodySLink}",
        "text_143": "{bodySLink}",
        "text_144": "{bodySLink}",
        "text_145": "{bodySLink}",
        "text_146": "{bodySLink}",
        "text_147": "{bodyXs}",
        "text_148": "{bodyXs}",
        "text_149": "{bodyXs}",
        "text_150": "{bodyXs}",
        "text_151": "{bodyXs}",
        "text_152": "{bodyXsBold}",
        "text_153": "{bodyXsBold}",
        "text_154": "{bodyXsBold}",
        "text_155": "{bodyXsBold}",
        "text_156": "{bodyXsBold}",
        "text_157": "{bodyXsLink}",
        "text_158": "{bodyXsLink}",
        "text_159": "{bodyXsLink}",
        "text_160": "{bodyXsLink}",
        "text_161": "{bodyXsLink}",
        "text_162": "{bodyXs}",
        "text_163": "{bodyXs}",
        "text_164": "{bodyS}",
        "text_165": "{bodyXs}",
        "text_166": "{bodyXs}",
        "text_167": "{bodyXxs}",
        "text_168": "{bodyXxs}",
        "text_169": "{bodyXxs}",
        "text_170": "{bodyXxs}",
        "text_171": "{bodyXxs}",
        "text_172": "{bodyXxsBold}",
        "text_173": "{bodyXxsBold}",
        "text_174": "{bodyXxsBold}",
        "text_175": "{bodyXxsBold}",
        "text_176": "{bodyXxsBold}",
        "text_177": "{bodyXxsLink}",
        "text_178": "{bodyXxsLink}",
        "text_179": "{bodyXxsLink}",
        "text_180": "{bodyXxsLink}",
        "text_181": "{bodyXxsLink}",
        "text_182": "{body3xs}",
        "text_183": "{body3xs}",
        "text_184": "{body3xs}",
        "text_185": "{body3xs}",
        "text_186": "{body3xs}",
        "text_187": "{body3xsBold}",
        "text_188": "{body3xsBold}",
        "text_189": "{body3xsBold}",
        "text_190": "{body3xsBold}",
        "text_191": "{body3xsBold}",
        "text_192": "{body3xsLink}",
        "text_193": "{body3xsLink}",
        "text_194": "{body3xsLink}",
        "text_195": "{body3xsLink}",
        "text_196": "{body3xsLink}",
        "text_197": "{listTitle}",
        "text_198": "{listTitle}",
        "text_199": "{listTitle}",
        "text_200": "{listTitle}",
        "text_201": "{listTitle}",
        "text_202": "{button}",
        "text_203": "{button}",
        "text_204": "{button}",
        "text_205": "{button}",
        "text_206": "{button}",
        "text_207": "{code}",
        "text_208": "{code}",
        "text_209": "{code}",
        "text_210": "{code}",
        "text_211": "{code}",
        "text_212": "{bodyS}",
        "text_213": "{bodyS}",
        "text_214": "{bodyS}",
        "text_215": "{bodyS}",
        "text_216": "{bodyS}"
    },
    "JDSTooltip": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSTooltipInternal": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSInputCode": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.start}",
        "i_2": "{alignItems.start}",
        "i_3": "{size.max}",
        "i_4": "{xs}",
        "i_5": "{flexDirection.row}",
        "i_6": "{justifyContent.center}",
        "i_7": "{alignItems.center}",
        "i_8": "{size.max}",
        "i_9": "{xs}",
        "i_10": "{opacity.disabled}",
        "i_11": "{opacity.enabled}"
    },
    "JDSRatingBar": {
        "r_0": "{flexDirection.column}",
        "r_1": "{alignItems.start}",
        "r_2": "{justifyContent.start}",
        "r_3": "{xxs}",
        "r_4": "{flexDirection.row}",
        "a_5": "{alignItems.center}",
        "r_6": "{justifyContent.start}",
        "r_7": "{xs}",
        "r_8": "{flexDirection.row}",
        "r_9": "{xxs}",
        "r_10": "{xs}",
        "r_11": "{alignItems.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{opacity.disabled}",
        "r_14": "{xxs}",
        "r_15": "{xxs}",
        "r_16": "{xs}",
        "r_17": "{xs}",
        "r_18": "{xs}",
        "r_19": "{xs}",
        "r_20": "{xxs}",
        "r_21": "{xxs}",
        "r_22": "{xs}",
        "r_23": "{xs}",
        "r_24": "{xs}",
        "r_25": "{xs}",
        "r_26": "{alignItems.center}"
    },
    "JDSRatingBarItem": {
        "r_0": "{flexDirection.stack}",
        "r_1": "{border_focus}",
        "r_2": "{primary60}",
        "r_3": "{m}",
        "r_4": "{m}",
        "r_5": "{xl}",
        "r_6": "{xl}",
        "r_7": "{opacity.disabled}",
        "r_8": "{primaryGrey60}",
        "r_9": "{primaryGrey60}",
        "r_10": "{primaryGrey60}",
        "r_11": "{primaryGrey60}",
        "r_12": "{primaryGrey80}",
        "r_13": "{primaryGrey80}",
        "r_14": "{primaryGrey80}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_focus}",
        "r_17": "{border_focus}",
        "r_18": "{primary60}",
        "r_19": "{primary60}",
        "r_20": "{primaryGrey60}",
        "r_21": "{primaryGrey60}",
        "r_22": "{primary50}",
        "r_23": "{primary50}",
        "r_24": "{primary70}",
        "r_25": "{primary70}",
        "r_26": "{primary60}",
        "r_27": "{primary60}",
        "r_28": "{border_focus}",
        "r_29": "{border_focus}",
        "r_30": "{primary60}",
        "r_31": "{primary60}",
        "r_32": "{primary50}",
        "r_33": "{primary50}",
        "r_34": "{primary70}",
        "r_35": "{primary70}",
        "r_36": "{primary70}",
        "r_37": "{primary70}",
        "r_38": "{primaryGrey80}",
        "r_39": "{primaryGrey60}"
    }
};
function $f551aa6589c293c2$var$getComponentTokens(componentName) {
    return $f551aa6589c293c2$var$JSON_MAP$1[componentName];
}
const $f551aa6589c293c2$var$layout = {
    "flexDirection.row": "row",
    "flexDirection.column": "column",
    "flexDirection.stack": "stack",
    "alignItems.start": "flex-start",
    "alignItems.center": "center",
    "alignItems.end": "flex-end",
    "alignItems.spaceBetween": "space-between",
    "alignItems.spaceAround": "space-around",
    "alignItems.spaceEvenly": "space-evenly",
    "alignItems.stretch": "stretch",
    "justifyContent.start": "flex-start",
    "justifyContent.center": "center",
    "justifyContent.end": "flex-end",
    "justifyContent.spaceBetween": "space-between",
    "justifyContent.spaceAround": "space-around",
    "justifyContent.spaceEvenly": "space-evenly",
    "textAlign.start": "start",
    "textAlign.center": "center",
    "textAlign.end": "end",
    "textAlign.justify": "justify",
    "aspect_ratio.1.1": "1",
    "aspect_ratio.3.4": "0.75",
    "aspect_ratio.4.3": "1.33",
    "aspect_ratio.4.5": "0.8",
    "aspect_ratio.5.4": "1.25",
    "aspect_ratio.9.16": "0.56",
    "aspect_ratio.16.9": "1.77",
    "aspect_ratio.2_75.1": "2.75",
    "size.max": "max",
    "size.min": "min",
    "size.negativeMax": "negativeMax",
    "intrinsicSize.min": "intrinsicSize.min",
    "intrinsicSize.max": "intrinsicSize.max",
    "zIndex-1": 1,
    "size.fit": "fit-content"
};
const $f551aa6589c293c2$var$headingXl$1 = "{$lang.$platform.headingXl}";
const $f551aa6589c293c2$var$headingL$1 = "{$lang.$platform.headingL}";
const $f551aa6589c293c2$var$headingM$1 = "{$lang.$platform.headingM}";
const $f551aa6589c293c2$var$headingS$1 = "{$lang.$platform.headingS}";
const $f551aa6589c293c2$var$headingXs$1 = "{$lang.$platform.headingXs}";
const $f551aa6589c293c2$var$headingXxs$1 = "{$lang.$platform.headingXxs}";
const $f551aa6589c293c2$var$overline$2 = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$bodyL$1 = "{$lang.$platform.bodyL}";
const $f551aa6589c293c2$var$bodyLBold$1 = "{$lang.$platform.bodyLBold}";
const $f551aa6589c293c2$var$bodyLLink$1 = "{$lang.$platform.bodyLLink}";
const $f551aa6589c293c2$var$bodyM$1 = "{$lang.$platform.bodyM}";
const $f551aa6589c293c2$var$bodyMBold$1 = "{$lang.$platform.bodyMBold}";
const $f551aa6589c293c2$var$bodyMLink$1 = "{$lang.$platform.bodyMLink}";
const $f551aa6589c293c2$var$bodyS$1 = "{$lang.$platform.bodyS}";
const $f551aa6589c293c2$var$bodySBold$1 = "{$lang.$platform.bodySBold}";
const $f551aa6589c293c2$var$bodySLink$1 = "{$lang.$platform.bodySLink}";
const $f551aa6589c293c2$var$bodyXs$1 = "{$lang.$platform.bodyXs}";
const $f551aa6589c293c2$var$bodyXsBold$1 = "{$lang.$platform.bodyXsBold}";
const $f551aa6589c293c2$var$bodyXsLink$1 = "{$lang.$platform.bodyXsLink}";
const $f551aa6589c293c2$var$bodyXxs$1 = "{$lang.$platform.bodyXxs}";
const $f551aa6589c293c2$var$bodyXxsBold$1 = "{$lang.$platform.bodyXxsBold}";
const $f551aa6589c293c2$var$bodyXxsLink$1 = "{$lang.$platform.bodyXxsLink}";
const $f551aa6589c293c2$var$body3xs$1 = "{$lang.$platform.body3xs}";
const $f551aa6589c293c2$var$body3xsBold$1 = "{$lang.$platform.body3xsBold}";
const $f551aa6589c293c2$var$body3xsLink$1 = "{$lang.$platform.body3xsLink}";
const $f551aa6589c293c2$var$listTitle$1 = "{$lang.$platform.listTitle}";
const $f551aa6589c293c2$var$button$1 = "{$lang.$platform.button}";
const $f551aa6589c293c2$var$code$1 = "{$lang.$platform.code}";
const $f551aa6589c293c2$var$letterSpacing = {
    "letter-spacing.0": "0",
    "as.desktop.headingXl": -2.6399999999999997,
    "as.desktop.headingL": -1.92,
    "as.desktop.headingM": -1.2,
    "as.desktop.headingS": -0.96,
    "as.desktop.headingXs": -0.72,
    "as.desktop.headingXxs": -0.48,
    "as.desktop.overline": -0.06,
    "as.desktop.bodyL": -0.12,
    "as.desktop.bodyLBold": -0.12,
    "as.desktop.bodyLLink": -0.12,
    "as.desktop.bodyM": -0.09,
    "as.desktop.bodyMBold": -0.09,
    "as.desktop.bodyMLink": -0.09,
    "as.desktop.bodyS": -0.08,
    "as.desktop.bodySBold": -0.08,
    "as.desktop.bodySLink": -0.08,
    "as.desktop.bodyXs": -0.07,
    "as.desktop.bodyXsBold": -0.07,
    "as.desktop.bodyXsLink": -0.07,
    "as.desktop.bodyXxs": -0.06,
    "as.desktop.bodyXxsBold": -0.06,
    "as.desktop.bodyXxsLink": -0.06,
    "as.desktop.body3xs": -0.055,
    "as.desktop.body3xsBold": -0.055,
    "as.desktop.body3xsLink": -0.055,
    "as.desktop.listTitle": -0.08,
    "as.desktop.button": -0.08,
    "as.desktop.code": 0,
    "as.mobile.headingXl": -1.92,
    "as.mobile.headingL": -1.44,
    "as.mobile.headingM": -1.2,
    "as.mobile.headingS": -0.96,
    "as.mobile.headingXs": -0.72,
    "as.mobile.headingXxs": -0.48,
    "as.mobile.overline": -0.06,
    "as.mobile.bodyL": -0.12,
    "as.mobile.bodyLBold": -0.12,
    "as.mobile.bodyLLink": -0.12,
    "as.mobile.bodyM": -0.09,
    "as.mobile.bodyMBold": -0.09,
    "as.mobile.bodyMLink": -0.09,
    "as.mobile.bodyS": 0.08,
    "as.mobile.bodySBold": -0.08,
    "as.mobile.bodySLink": -0.08,
    "as.mobile.bodyXs": -0.07,
    "as.mobile.bodyXsBold": -0.07,
    "as.mobile.bodyXsLink": -0.07,
    "as.mobile.bodyXxs": -0.06,
    "as.mobile.bodyXxsBold": -0.06,
    "as.mobile.bodyXxsLink": -0.06,
    "as.mobile.body3xs": -0.055,
    "as.mobile.body3xsBold": -0.055,
    "as.mobile.body3xsLink": -0.055,
    "as.mobile.listTitle": -0.08,
    "as.mobile.button": -0.08,
    "as.mobile.code": 0,
    "bn.desktop.headingXl": -2.6399999999999997,
    "bn.desktop.headingL": -1.92,
    "bn.desktop.headingM": -1.2,
    "bn.desktop.headingS": -0.96,
    "bn.desktop.headingXs": -0.72,
    "bn.desktop.headingXxs": -0.48,
    "bn.desktop.overline": -0.06,
    "bn.desktop.bodyL": -0.12,
    "bn.desktop.bodyLBold": -0.12,
    "bn.desktop.bodyLLink": -0.12,
    "bn.desktop.bodyM": -0.09,
    "bn.desktop.bodyMBold": -0.09,
    "bn.desktop.bodyMLink": -0.09,
    "bn.desktop.bodyS": -0.08,
    "bn.desktop.bodySBold": -0.08,
    "bn.desktop.bodySLink": -0.08,
    "bn.desktop.bodyXs": -0.07,
    "bn.desktop.bodyXsBold": -0.07,
    "bn.desktop.bodyXsLink": -0.07,
    "bn.desktop.bodyXxs": -0.06,
    "bn.desktop.bodyXxsBold": -0.06,
    "bn.desktop.bodyXxsLink": -0.06,
    "bn.desktop.body3xs": -0.055,
    "bn.desktop.body3xsBold": -0.055,
    "bn.desktop.body3xsLink": -0.055,
    "bn.desktop.listTitle": -0.08,
    "bn.desktop.button": -0.08,
    "bn.desktop.code": 0,
    "bn.mobile.headingXl": -1.92,
    "bn.mobile.headingL": -1.44,
    "bn.mobile.headingM": -1.2,
    "bn.mobile.headingS": -0.96,
    "bn.mobile.headingXs": -0.72,
    "bn.mobile.headingXxs": -0.48,
    "bn.mobile.overline": -0.06,
    "bn.mobile.bodyL": -0.12,
    "bn.mobile.bodyLBold": -0.12,
    "bn.mobile.bodyLLink": -0.12,
    "bn.mobile.bodyM": -0.09,
    "bn.mobile.bodyMBold": -0.09,
    "bn.mobile.bodyMLink": -0.09,
    "bn.mobile.bodyS": 0.08,
    "bn.mobile.bodySBold": -0.08,
    "bn.mobile.bodySLink": -0.08,
    "bn.mobile.bodyXs": -0.07,
    "bn.mobile.bodyXsBold": -0.07,
    "bn.mobile.bodyXsLink": -0.07,
    "bn.mobile.bodyXxs": -0.06,
    "bn.mobile.bodyXxsBold": -0.06,
    "bn.mobile.bodyXxsLink": -0.06,
    "bn.mobile.body3xs": -0.055,
    "bn.mobile.body3xsBold": -0.055,
    "bn.mobile.body3xsLink": -0.055,
    "bn.mobile.listTitle": -0.08,
    "bn.mobile.button": -0.08,
    "bn.mobile.code": 0,
    "en.desktop.headingXl": -2.6399999999999997,
    "en.desktop.headingL": -1.92,
    "en.desktop.headingM": -1.2,
    "en.desktop.headingS": -0.96,
    "en.desktop.headingXs": -0.72,
    "en.desktop.headingXxs": -0.48,
    "en.desktop.overline": 0.06,
    "en.desktop.bodyL": -0.12,
    "en.desktop.bodyLBold": -0.12,
    "en.desktop.bodyLLink": -0.12,
    "en.desktop.bodyM": -0.09,
    "en.desktop.bodyMBold": -0.09,
    "en.desktop.bodyMLink": -0.09,
    "en.desktop.bodyS": -0.08,
    "en.desktop.bodySBold": -0.08,
    "en.desktop.bodySLink": -0.08,
    "en.desktop.bodyXs": -0.07,
    "en.desktop.bodyXsBold": -0.07,
    "en.desktop.bodyXsLink": -0.07,
    "en.desktop.bodyXxs": -0.06,
    "en.desktop.bodyXxsBold": -0.06,
    "en.desktop.bodyXxsLink": -0.06,
    "en.desktop.body3xs": -0.055,
    "en.desktop.body3xsBold": -0.055,
    "en.desktop.body3xsLink": -0.055,
    "en.desktop.listTitle": -0.08,
    "en.desktop.button": -0.08,
    "en.desktop.code": 0,
    "en.mobile.headingXl": -1.92,
    "en.mobile.headingL": -1.44,
    "en.mobile.headingM": -1.2,
    "en.mobile.headingS": -0.96,
    "en.mobile.headingXs": -0.72,
    "en.mobile.headingXxs": -0.48,
    "en.mobile.overline": 0.06,
    "en.mobile.bodyL": -0.12,
    "en.mobile.bodyLBold": -0.12,
    "en.mobile.bodyLLink": -0.12,
    "en.mobile.bodyM": -0.09,
    "en.mobile.bodyMBold": -0.09,
    "en.mobile.bodyMLink": -0.09,
    "en.mobile.bodyS": -0.08,
    "en.mobile.bodySBold": -0.08,
    "en.mobile.bodySLink": -0.08,
    "en.mobile.bodyXs": -0.07,
    "en.mobile.bodyXsBold": -0.07,
    "en.mobile.bodyXsLink": -0.07,
    "en.mobile.bodyXxs": -0.06,
    "en.mobile.bodyXxsBold": -0.06,
    "en.mobile.bodyXxsLink": -0.06,
    "en.mobile.body3xs": -0.055,
    "en.mobile.body3xsBold": -0.055,
    "en.mobile.body3xsLink": -0.055,
    "en.mobile.listTitle": -0.08,
    "en.mobile.button": -0.08,
    "en.mobile.code": 0,
    "gu.desktop.headingXl": -2.6399999999999997,
    "gu.desktop.headingL": -1.92,
    "gu.desktop.headingM": -1.2,
    "gu.desktop.headingS": -0.96,
    "gu.desktop.headingXs": -0.72,
    "gu.desktop.headingXxs": -0.48,
    "gu.desktop.overline": -0.06,
    "gu.desktop.bodyL": -0.12,
    "gu.desktop.bodyLBold": -0.12,
    "gu.desktop.bodyLLink": -0.12,
    "gu.desktop.bodyM": -0.09,
    "gu.desktop.bodyMBold": -0.09,
    "gu.desktop.bodyMLink": -0.09,
    "gu.desktop.bodyS": -0.08,
    "gu.desktop.bodySBold": -0.08,
    "gu.desktop.bodySLink": -0.08,
    "gu.desktop.bodyXs": -0.07,
    "gu.desktop.bodyXsBold": -0.07,
    "gu.desktop.bodyXsLink": -0.07,
    "gu.desktop.bodyXxs": -0.06,
    "gu.desktop.bodyXxsBold": -0.06,
    "gu.desktop.bodyXxsLink": -0.06,
    "gu.desktop.body3xs": -0.055,
    "gu.desktop.body3xsBold": -0.055,
    "gu.desktop.body3xsLink": -0.055,
    "gu.desktop.listTitle": -0.08,
    "gu.desktop.button": -0.08,
    "gu.desktop.code": 0,
    "gu.mobile.headingXl": -1.92,
    "gu.mobile.headingL": -1.44,
    "gu.mobile.headingM": -1.2,
    "gu.mobile.headingS": -0.96,
    "gu.mobile.headingXs": -0.72,
    "gu.mobile.headingXxs": -0.48,
    "gu.mobile.overline": -0.06,
    "gu.mobile.bodyL": -0.12,
    "gu.mobile.bodyLBold": -0.12,
    "gu.mobile.bodyLLink": -0.12,
    "gu.mobile.bodyM": -0.09,
    "gu.mobile.bodyMBold": -0.09,
    "gu.mobile.bodyMLink": -0.09,
    "gu.mobile.bodyS": 0.08,
    "gu.mobile.bodySBold": -0.08,
    "gu.mobile.bodySLink": -0.08,
    "gu.mobile.bodyXs": -0.07,
    "gu.mobile.bodyXsBold": -0.07,
    "gu.mobile.bodyXsLink": -0.07,
    "gu.mobile.bodyXxs": -0.06,
    "gu.mobile.bodyXxsBold": -0.06,
    "gu.mobile.bodyXxsLink": -0.06,
    "gu.mobile.body3xs": -0.055,
    "gu.mobile.body3xsBold": -0.055,
    "gu.mobile.body3xsLink": -0.055,
    "gu.mobile.listTitle": -0.08,
    "gu.mobile.button": -0.08,
    "gu.mobile.code": 0,
    "hi.desktop.headingXl": -2.6399999999999997,
    "hi.desktop.headingL": -1.92,
    "hi.desktop.headingM": -1.2,
    "hi.desktop.headingS": -0.96,
    "hi.desktop.headingXs": -0.72,
    "hi.desktop.headingXxs": -0.48,
    "hi.desktop.overline": -0.06,
    "hi.desktop.bodyL": -0.12,
    "hi.desktop.bodyLBold": -0.12,
    "hi.desktop.bodyLLink": -0.12,
    "hi.desktop.bodyM": -0.09,
    "hi.desktop.bodyMBold": -0.09,
    "hi.desktop.bodyMLink": -0.09,
    "hi.desktop.bodyS": -0.08,
    "hi.desktop.bodySBold": -0.08,
    "hi.desktop.bodySLink": -0.08,
    "hi.desktop.bodyXs": -0.07,
    "hi.desktop.bodyXsBold": -0.07,
    "hi.desktop.bodyXsLink": -0.07,
    "hi.desktop.bodyXxs": -0.06,
    "hi.desktop.bodyXxsBold": -0.06,
    "hi.desktop.bodyXxsLink": -0.06,
    "hi.desktop.body3xs": -0.055,
    "hi.desktop.body3xsBold": -0.055,
    "hi.desktop.body3xsLink": -0.055,
    "hi.desktop.listTitle": -0.08,
    "hi.desktop.button": -0.08,
    "hi.desktop.code": 0,
    "hi.mobile.headingXl": -1.92,
    "hi.mobile.headingL": -1.44,
    "hi.mobile.headingM": -1.2,
    "hi.mobile.headingS": -0.96,
    "hi.mobile.headingXs": -0.72,
    "hi.mobile.headingXxs": -0.48,
    "hi.mobile.overline": -0.06,
    "hi.mobile.bodyL": -0.12,
    "hi.mobile.bodyLBold": -0.12,
    "hi.mobile.bodyLLink": -0.12,
    "hi.mobile.bodyM": -0.09,
    "hi.mobile.bodyMBold": -0.09,
    "hi.mobile.bodyMLink": -0.09,
    "hi.mobile.bodyS": 0.08,
    "hi.mobile.bodySBold": -0.08,
    "hi.mobile.bodySLink": -0.08,
    "hi.mobile.bodyXs": -0.07,
    "hi.mobile.bodyXsBold": -0.07,
    "hi.mobile.bodyXsLink": -0.07,
    "hi.mobile.bodyXxs": -0.06,
    "hi.mobile.bodyXxsBold": -0.06,
    "hi.mobile.bodyXxsLink": -0.06,
    "hi.mobile.body3xs": -0.055,
    "hi.mobile.body3xsBold": -0.055,
    "hi.mobile.body3xsLink": -0.055,
    "hi.mobile.listTitle": -0.08,
    "hi.mobile.button": -0.08,
    "hi.mobile.code": 0,
    "kn.desktop.headingXl": -2.6399999999999997,
    "kn.desktop.headingL": -1.92,
    "kn.desktop.headingM": -1.2,
    "kn.desktop.headingS": -0.96,
    "kn.desktop.headingXs": -0.72,
    "kn.desktop.headingXxs": -0.48,
    "kn.desktop.overline": -0.06,
    "kn.desktop.bodyL": -0.12,
    "kn.desktop.bodyLBold": -0.12,
    "kn.desktop.bodyLLink": -0.12,
    "kn.desktop.bodyM": -0.09,
    "kn.desktop.bodyMBold": -0.09,
    "kn.desktop.bodyMLink": -0.09,
    "kn.desktop.bodyS": -0.08,
    "kn.desktop.bodySBold": -0.08,
    "kn.desktop.bodySLink": -0.08,
    "kn.desktop.bodyXs": -0.07,
    "kn.desktop.bodyXsBold": -0.07,
    "kn.desktop.bodyXsLink": -0.07,
    "kn.desktop.bodyXxs": -0.06,
    "kn.desktop.bodyXxsBold": -0.06,
    "kn.desktop.bodyXxsLink": -0.06,
    "kn.desktop.body3xs": -0.055,
    "kn.desktop.body3xsBold": -0.055,
    "kn.desktop.body3xsLink": -0.055,
    "kn.desktop.listTitle": -0.08,
    "kn.desktop.button": -0.08,
    "kn.desktop.code": 0,
    "kn.mobile.headingXl": -1.92,
    "kn.mobile.headingL": -1.44,
    "kn.mobile.headingM": -1.2,
    "kn.mobile.headingS": -0.96,
    "kn.mobile.headingXs": -0.72,
    "kn.mobile.headingXxs": -0.48,
    "kn.mobile.overline": -0.06,
    "kn.mobile.bodyL": -0.12,
    "kn.mobile.bodyLBold": -0.12,
    "kn.mobile.bodyLLink": -0.12,
    "kn.mobile.bodyM": -0.09,
    "kn.mobile.bodyMBold": -0.09,
    "kn.mobile.bodyMLink": -0.09,
    "kn.mobile.bodyS": 0.08,
    "kn.mobile.bodySBold": -0.08,
    "kn.mobile.bodySLink": -0.08,
    "kn.mobile.bodyXs": -0.07,
    "kn.mobile.bodyXsBold": -0.07,
    "kn.mobile.bodyXsLink": -0.07,
    "kn.mobile.bodyXxs": -0.06,
    "kn.mobile.bodyXxsBold": -0.06,
    "kn.mobile.bodyXxsLink": -0.06,
    "kn.mobile.body3xs": -0.055,
    "kn.mobile.body3xsBold": -0.055,
    "kn.mobile.body3xsLink": -0.055,
    "kn.mobile.listTitle": -0.08,
    "kn.mobile.button": -0.08,
    "kn.mobile.code": 0,
    "ml.desktop.headingXl": -2.6399999999999997,
    "ml.desktop.headingL": -1.92,
    "ml.desktop.headingM": -1.2,
    "ml.desktop.headingS": -0.96,
    "ml.desktop.headingXs": -0.72,
    "ml.desktop.headingXxs": -0.48,
    "ml.desktop.overline": -0.06,
    "ml.desktop.bodyL": -0.12,
    "ml.desktop.bodyLBold": -0.12,
    "ml.desktop.bodyLLink": -0.12,
    "ml.desktop.bodyM": -0.09,
    "ml.desktop.bodyMBold": -0.09,
    "ml.desktop.bodyMLink": -0.09,
    "ml.desktop.bodyS": -0.08,
    "ml.desktop.bodySBold": -0.08,
    "ml.desktop.bodySLink": -0.08,
    "ml.desktop.bodyXs": -0.07,
    "ml.desktop.bodyXsBold": -0.07,
    "ml.desktop.bodyXsLink": -0.07,
    "ml.desktop.bodyXxs": -0.06,
    "ml.desktop.bodyXxsBold": -0.06,
    "ml.desktop.bodyXxsLink": -0.06,
    "ml.desktop.body3xs": -0.055,
    "ml.desktop.body3xsBold": -0.055,
    "ml.desktop.body3xsLink": -0.055,
    "ml.desktop.listTitle": -0.08,
    "ml.desktop.button": -0.08,
    "ml.desktop.code": 0,
    "ml.mobile.headingXl": -1.92,
    "ml.mobile.headingL": -1.44,
    "ml.mobile.headingM": -1.2,
    "ml.mobile.headingS": -0.96,
    "ml.mobile.headingXs": -0.72,
    "ml.mobile.headingXxs": -0.48,
    "ml.mobile.overline": -0.06,
    "ml.mobile.bodyL": -0.12,
    "ml.mobile.bodyLBold": -0.12,
    "ml.mobile.bodyLLink": -0.12,
    "ml.mobile.bodyM": -0.09,
    "ml.mobile.bodyMBold": -0.09,
    "ml.mobile.bodyMLink": -0.09,
    "ml.mobile.bodyS": 0.08,
    "ml.mobile.bodySBold": -0.08,
    "ml.mobile.bodySLink": -0.08,
    "ml.mobile.bodyXs": -0.07,
    "ml.mobile.bodyXsBold": -0.07,
    "ml.mobile.bodyXsLink": -0.07,
    "ml.mobile.bodyXxs": -0.06,
    "ml.mobile.bodyXxsBold": -0.06,
    "ml.mobile.bodyXxsLink": -0.06,
    "ml.mobile.body3xs": -0.055,
    "ml.mobile.body3xsBold": -0.055,
    "ml.mobile.body3xsLink": -0.055,
    "ml.mobile.listTitle": -0.08,
    "ml.mobile.button": -0.08,
    "ml.mobile.code": 0,
    "mr.desktop.headingXl": -2.6399999999999997,
    "mr.desktop.headingL": -1.92,
    "mr.desktop.headingM": -1.2,
    "mr.desktop.headingS": -0.96,
    "mr.desktop.headingXs": -0.72,
    "mr.desktop.headingXxs": -0.48,
    "mr.desktop.overline": -0.06,
    "mr.desktop.bodyL": -0.12,
    "mr.desktop.bodyLBold": -0.12,
    "mr.desktop.bodyLLink": -0.12,
    "mr.desktop.bodyM": -0.09,
    "mr.desktop.bodyMBold": -0.09,
    "mr.desktop.bodyMLink": -0.09,
    "mr.desktop.bodyS": -0.08,
    "mr.desktop.bodySBold": -0.08,
    "mr.desktop.bodySLink": -0.08,
    "mr.desktop.bodyXs": -0.07,
    "mr.desktop.bodyXsBold": -0.07,
    "mr.desktop.bodyXsLink": -0.07,
    "mr.desktop.bodyXxs": -0.06,
    "mr.desktop.bodyXxsBold": -0.06,
    "mr.desktop.bodyXxsLink": -0.06,
    "mr.desktop.body3xs": -0.055,
    "mr.desktop.body3xsBold": -0.055,
    "mr.desktop.body3xsLink": -0.055,
    "mr.desktop.listTitle": -0.08,
    "mr.desktop.button": -0.08,
    "mr.desktop.code": 0,
    "mr.mobile.headingXl": -1.92,
    "mr.mobile.headingL": -1.44,
    "mr.mobile.headingM": -1.2,
    "mr.mobile.headingS": -0.96,
    "mr.mobile.headingXs": -0.72,
    "mr.mobile.headingXxs": -0.48,
    "mr.mobile.overline": -0.06,
    "mr.mobile.bodyL": -0.12,
    "mr.mobile.bodyLBold": -0.12,
    "mr.mobile.bodyLLink": -0.12,
    "mr.mobile.bodyM": -0.09,
    "mr.mobile.bodyMBold": -0.09,
    "mr.mobile.bodyMLink": -0.09,
    "mr.mobile.bodyS": 0.08,
    "mr.mobile.bodySBold": -0.08,
    "mr.mobile.bodySLink": -0.08,
    "mr.mobile.bodyXs": -0.07,
    "mr.mobile.bodyXsBold": -0.07,
    "mr.mobile.bodyXsLink": -0.07,
    "mr.mobile.bodyXxs": -0.06,
    "mr.mobile.bodyXxsBold": -0.06,
    "mr.mobile.bodyXxsLink": -0.06,
    "mr.mobile.body3xs": -0.055,
    "mr.mobile.body3xsBold": -0.055,
    "mr.mobile.body3xsLink": -0.055,
    "mr.mobile.listTitle": -0.08,
    "mr.mobile.button": -0.08,
    "mr.mobile.code": 0,
    "or.desktop.headingXl": -2.6399999999999997,
    "or.desktop.headingL": -1.92,
    "or.desktop.headingM": -1.2,
    "or.desktop.headingS": -0.96,
    "or.desktop.headingXs": -0.72,
    "or.desktop.headingXxs": -0.48,
    "or.desktop.overline": -0.06,
    "or.desktop.bodyL": -0.12,
    "or.desktop.bodyLBold": -0.12,
    "or.desktop.bodyLLink": -0.12,
    "or.desktop.bodyM": -0.09,
    "or.desktop.bodyMBold": -0.09,
    "or.desktop.bodyMLink": -0.09,
    "or.desktop.bodyS": -0.08,
    "or.desktop.bodySBold": -0.08,
    "or.desktop.bodySLink": -0.08,
    "or.desktop.bodyXs": -0.07,
    "or.desktop.bodyXsBold": -0.07,
    "or.desktop.bodyXsLink": -0.07,
    "or.desktop.bodyXxs": -0.06,
    "or.desktop.bodyXxsBold": -0.06,
    "or.desktop.bodyXxsLink": -0.06,
    "or.desktop.body3xs": -0.055,
    "or.desktop.body3xsBold": -0.055,
    "or.desktop.body3xsLink": -0.055,
    "or.desktop.listTitle": -0.08,
    "or.desktop.button": -0.08,
    "or.desktop.code": 0,
    "or.mobile.headingXl": -1.92,
    "or.mobile.headingL": -1.44,
    "or.mobile.headingM": -1.2,
    "or.mobile.headingS": -0.96,
    "or.mobile.headingXs": -0.72,
    "or.mobile.headingXxs": -0.48,
    "or.mobile.overline": -0.06,
    "or.mobile.bodyL": -0.12,
    "or.mobile.bodyLBold": -0.12,
    "or.mobile.bodyLLink": -0.12,
    "or.mobile.bodyM": -0.09,
    "or.mobile.bodyMBold": -0.09,
    "or.mobile.bodyMLink": -0.09,
    "or.mobile.bodyS": 0.08,
    "or.mobile.bodySBold": -0.08,
    "or.mobile.bodySLink": -0.08,
    "or.mobile.bodyXs": -0.07,
    "or.mobile.bodyXsBold": -0.07,
    "or.mobile.bodyXsLink": -0.07,
    "or.mobile.bodyXxs": -0.06,
    "or.mobile.bodyXxsBold": -0.06,
    "or.mobile.bodyXxsLink": -0.06,
    "or.mobile.body3xs": -0.055,
    "or.mobile.body3xsBold": -0.055,
    "or.mobile.body3xsLink": -0.055,
    "or.mobile.listTitle": -0.08,
    "or.mobile.button": -0.08,
    "or.mobile.code": 0,
    "pa.desktop.headingXl": -2.6399999999999997,
    "pa.desktop.headingL": -1.92,
    "pa.desktop.headingM": -1.2,
    "pa.desktop.headingS": -0.96,
    "pa.desktop.headingXs": -0.72,
    "pa.desktop.headingXxs": -0.48,
    "pa.desktop.overline": -0.06,
    "pa.desktop.bodyL": -0.12,
    "pa.desktop.bodyLBold": -0.12,
    "pa.desktop.bodyLLink": -0.12,
    "pa.desktop.bodyM": -0.09,
    "pa.desktop.bodyMBold": -0.09,
    "pa.desktop.bodyMLink": -0.09,
    "pa.desktop.bodyS": -0.08,
    "pa.desktop.bodySBold": -0.08,
    "pa.desktop.bodySLink": -0.08,
    "pa.desktop.bodyXs": -0.07,
    "pa.desktop.bodyXsBold": -0.07,
    "pa.desktop.bodyXsLink": -0.07,
    "pa.desktop.bodyXxs": -0.06,
    "pa.desktop.bodyXxsBold": -0.06,
    "pa.desktop.bodyXxsLink": -0.06,
    "pa.desktop.body3xs": -0.055,
    "pa.desktop.body3xsBold": -0.055,
    "pa.desktop.body3xsLink": -0.055,
    "pa.desktop.listTitle": -0.08,
    "pa.desktop.button": -0.08,
    "pa.desktop.code": 0,
    "pa.mobile.headingXl": -1.92,
    "pa.mobile.headingL": -1.44,
    "pa.mobile.headingM": -1.2,
    "pa.mobile.headingS": -0.96,
    "pa.mobile.headingXs": -0.72,
    "pa.mobile.headingXxs": -0.48,
    "pa.mobile.overline": -0.06,
    "pa.mobile.bodyL": -0.12,
    "pa.mobile.bodyLBold": -0.12,
    "pa.mobile.bodyLLink": -0.12,
    "pa.mobile.bodyM": -0.09,
    "pa.mobile.bodyMBold": -0.09,
    "pa.mobile.bodyMLink": -0.09,
    "pa.mobile.bodyS": 0.08,
    "pa.mobile.bodySBold": -0.08,
    "pa.mobile.bodySLink": -0.08,
    "pa.mobile.bodyXs": -0.07,
    "pa.mobile.bodyXsBold": -0.07,
    "pa.mobile.bodyXsLink": -0.07,
    "pa.mobile.bodyXxs": -0.06,
    "pa.mobile.bodyXxsBold": -0.06,
    "pa.mobile.bodyXxsLink": -0.06,
    "pa.mobile.body3xs": -0.055,
    "pa.mobile.body3xsBold": -0.055,
    "pa.mobile.body3xsLink": -0.055,
    "pa.mobile.listTitle": -0.08,
    "pa.mobile.button": -0.08,
    "pa.mobile.code": 0,
    "ta.desktop.headingXl": -2.6399999999999997,
    "ta.desktop.headingL": -1.92,
    "ta.desktop.headingM": -1.2,
    "ta.desktop.headingS": -0.96,
    "ta.desktop.headingXs": -0.72,
    "ta.desktop.headingXxs": -0.48,
    "ta.desktop.overline": -0.06,
    "ta.desktop.bodyL": -0.12,
    "ta.desktop.bodyLBold": -0.12,
    "ta.desktop.bodyLLink": -0.12,
    "ta.desktop.bodyM": -0.09,
    "ta.desktop.bodyMBold": -0.09,
    "ta.desktop.bodyMLink": -0.09,
    "ta.desktop.bodyS": -0.08,
    "ta.desktop.bodySBold": -0.08,
    "ta.desktop.bodySLink": -0.08,
    "ta.desktop.bodyXs": -0.07,
    "ta.desktop.bodyXsBold": -0.07,
    "ta.desktop.bodyXsLink": -0.07,
    "ta.desktop.bodyXxs": -0.06,
    "ta.desktop.bodyXxsBold": -0.06,
    "ta.desktop.bodyXxsLink": -0.06,
    "ta.desktop.body3xs": -0.055,
    "ta.desktop.body3xsBold": -0.055,
    "ta.desktop.body3xsLink": -0.055,
    "ta.desktop.listTitle": -0.08,
    "ta.desktop.button": -0.08,
    "ta.desktop.code": 0,
    "ta.mobile.headingXl": -1.92,
    "ta.mobile.headingL": -1.44,
    "ta.mobile.headingM": -1.2,
    "ta.mobile.headingS": -0.96,
    "ta.mobile.headingXs": -0.72,
    "ta.mobile.headingXxs": -0.48,
    "ta.mobile.overline": -0.06,
    "ta.mobile.bodyL": -0.12,
    "ta.mobile.bodyLBold": -0.12,
    "ta.mobile.bodyLLink": -0.12,
    "ta.mobile.bodyM": -0.09,
    "ta.mobile.bodyMBold": -0.09,
    "ta.mobile.bodyMLink": -0.09,
    "ta.mobile.bodyS": 0.08,
    "ta.mobile.bodySBold": -0.08,
    "ta.mobile.bodySLink": -0.08,
    "ta.mobile.bodyXs": -0.07,
    "ta.mobile.bodyXsBold": -0.07,
    "ta.mobile.bodyXsLink": -0.07,
    "ta.mobile.bodyXxs": -0.06,
    "ta.mobile.bodyXxsBold": -0.06,
    "ta.mobile.bodyXxsLink": -0.06,
    "ta.mobile.body3xs": -0.055,
    "ta.mobile.body3xsBold": -0.055,
    "ta.mobile.body3xsLink": -0.055,
    "ta.mobile.listTitle": -0.08,
    "ta.mobile.button": -0.08,
    "ta.mobile.code": 0,
    "te.desktop.headingXl": -2.6399999999999997,
    "te.desktop.headingL": -1.92,
    "te.desktop.headingM": -1.2,
    "te.desktop.headingS": -0.96,
    "te.desktop.headingXs": -0.72,
    "te.desktop.headingXxs": -0.48,
    "te.desktop.overline": -0.06,
    "te.desktop.bodyL": -0.12,
    "te.desktop.bodyLBold": -0.12,
    "te.desktop.bodyLLink": -0.12,
    "te.desktop.bodyM": -0.09,
    "te.desktop.bodyMBold": -0.09,
    "te.desktop.bodyMLink": -0.09,
    "te.desktop.bodyS": -0.08,
    "te.desktop.bodySBold": -0.08,
    "te.desktop.bodySLink": -0.08,
    "te.desktop.bodyXs": -0.07,
    "te.desktop.bodyXsBold": -0.07,
    "te.desktop.bodyXsLink": -0.07,
    "te.desktop.bodyXxs": -0.06,
    "te.desktop.bodyXxsBold": -0.06,
    "te.desktop.bodyXxsLink": -0.06,
    "te.desktop.body3xs": -0.055,
    "te.desktop.body3xsBold": -0.055,
    "te.desktop.body3xsLink": -0.055,
    "te.desktop.listTitle": -0.08,
    "te.desktop.button": -0.08,
    "te.desktop.code": 0,
    "te.mobile.headingXl": -1.92,
    "te.mobile.headingL": -1.44,
    "te.mobile.headingM": -1.2,
    "te.mobile.headingS": -0.96,
    "te.mobile.headingXs": -0.72,
    "te.mobile.headingXxs": -0.48,
    "te.mobile.overline": -0.06,
    "te.mobile.bodyL": -0.12,
    "te.mobile.bodyLBold": -0.12,
    "te.mobile.bodyLLink": -0.12,
    "te.mobile.bodyM": -0.09,
    "te.mobile.bodyMBold": -0.09,
    "te.mobile.bodyMLink": -0.09,
    "te.mobile.bodyS": 0.08,
    "te.mobile.bodySBold": -0.08,
    "te.mobile.bodySLink": -0.08,
    "te.mobile.bodyXs": -0.07,
    "te.mobile.bodyXsBold": -0.07,
    "te.mobile.bodyXsLink": -0.07,
    "te.mobile.bodyXxs": -0.06,
    "te.mobile.bodyXxsBold": -0.06,
    "te.mobile.bodyXxsLink": -0.06,
    "te.mobile.body3xs": -0.055,
    "te.mobile.body3xsBold": -0.055,
    "te.mobile.body3xsLink": -0.055,
    "te.mobile.listTitle": -0.08,
    "te.mobile.button": -0.08,
    "te.mobile.code": 0,
    headingXl: $f551aa6589c293c2$var$headingXl$1,
    headingL: $f551aa6589c293c2$var$headingL$1,
    headingM: $f551aa6589c293c2$var$headingM$1,
    headingS: $f551aa6589c293c2$var$headingS$1,
    headingXs: $f551aa6589c293c2$var$headingXs$1,
    headingXxs: $f551aa6589c293c2$var$headingXxs$1,
    overline: $f551aa6589c293c2$var$overline$2,
    bodyL: $f551aa6589c293c2$var$bodyL$1,
    bodyLBold: $f551aa6589c293c2$var$bodyLBold$1,
    bodyLLink: $f551aa6589c293c2$var$bodyLLink$1,
    bodyM: $f551aa6589c293c2$var$bodyM$1,
    bodyMBold: $f551aa6589c293c2$var$bodyMBold$1,
    bodyMLink: $f551aa6589c293c2$var$bodyMLink$1,
    bodyS: $f551aa6589c293c2$var$bodyS$1,
    bodySBold: $f551aa6589c293c2$var$bodySBold$1,
    bodySLink: $f551aa6589c293c2$var$bodySLink$1,
    bodyXs: $f551aa6589c293c2$var$bodyXs$1,
    bodyXsBold: $f551aa6589c293c2$var$bodyXsBold$1,
    bodyXsLink: $f551aa6589c293c2$var$bodyXsLink$1,
    bodyXxs: $f551aa6589c293c2$var$bodyXxs$1,
    bodyXxsBold: $f551aa6589c293c2$var$bodyXxsBold$1,
    bodyXxsLink: $f551aa6589c293c2$var$bodyXxsLink$1,
    body3xs: $f551aa6589c293c2$var$body3xs$1,
    body3xsBold: $f551aa6589c293c2$var$body3xsBold$1,
    body3xsLink: $f551aa6589c293c2$var$body3xsLink$1,
    listTitle: $f551aa6589c293c2$var$listTitle$1,
    button: $f551aa6589c293c2$var$button$1,
    code: $f551aa6589c293c2$var$code$1
};
const $f551aa6589c293c2$var$headingXl = "{$lang.$platform.headingXl}";
const $f551aa6589c293c2$var$headingL = "{$lang.$platform.headingL}";
const $f551aa6589c293c2$var$headingM = "{$lang.$platform.headingM}";
const $f551aa6589c293c2$var$headingS = "{$lang.$platform.headingS}";
const $f551aa6589c293c2$var$headingXs = "{$lang.$platform.headingXs}";
const $f551aa6589c293c2$var$headingXxs = "{$lang.$platform.headingXxs}";
const $f551aa6589c293c2$var$overline$1 = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$bodyL = "{$lang.$platform.bodyL}";
const $f551aa6589c293c2$var$bodyLBold = "{$lang.$platform.bodyLBold}";
const $f551aa6589c293c2$var$bodyLLink = "{$lang.$platform.bodyLLink}";
const $f551aa6589c293c2$var$bodyM = "{$lang.$platform.bodyM}";
const $f551aa6589c293c2$var$bodyMBold = "{$lang.$platform.bodyMBold}";
const $f551aa6589c293c2$var$bodyMLink = "{$lang.$platform.bodyMLink}";
const $f551aa6589c293c2$var$bodyS = "{$lang.$platform.bodyS}";
const $f551aa6589c293c2$var$bodySBold = "{$lang.$platform.bodySBold}";
const $f551aa6589c293c2$var$bodySLink = "{$lang.$platform.bodySLink}";
const $f551aa6589c293c2$var$bodyXs = "{$lang.$platform.bodyXs}";
const $f551aa6589c293c2$var$bodyXsBold = "{$lang.$platform.bodyXsBold}";
const $f551aa6589c293c2$var$bodyXsLink = "{$lang.$platform.bodyXsLink}";
const $f551aa6589c293c2$var$bodyXxs = "{$lang.$platform.bodyXxs}";
const $f551aa6589c293c2$var$bodyXxsBold = "{$lang.$platform.bodyXxsBold}";
const $f551aa6589c293c2$var$bodyXxsLink = "{$lang.$platform.bodyXxsLink}";
const $f551aa6589c293c2$var$body3xs = "{$lang.$platform.body3xs}";
const $f551aa6589c293c2$var$body3xsBold = "{$lang.$platform.body3xsBold}";
const $f551aa6589c293c2$var$body3xsLink = "{$lang.$platform.body3xsLink}";
const $f551aa6589c293c2$var$listTitle = "{$lang.$platform.listTitle}";
const $f551aa6589c293c2$var$button = "{$lang.$platform.button}";
const $f551aa6589c293c2$var$code = "{$lang.$platform.code}";
const $f551aa6589c293c2$var$lineHeights = {
    "as.desktop.headingXl": 92,
    "as.desktop.headingL": 68,
    "as.desktop.headingM": 44,
    "as.desktop.headingS": 36,
    "as.desktop.headingXs": 32,
    "as.desktop.headingXxs": 24,
    "as.desktop.overline": 16,
    "as.desktop.bodyL": 28,
    "as.desktop.bodyLBold": 28,
    "as.desktop.bodyLLink": 28,
    "as.desktop.bodyM": 24,
    "as.desktop.bodyMBold": 24,
    "as.desktop.bodyMLink": 24,
    "as.desktop.bodyS": 24,
    "as.desktop.bodySBold": 24,
    "as.desktop.bodySLink": 24,
    "as.desktop.bodyXs": 16,
    "as.desktop.bodyXsBold": 16,
    "as.desktop.bodyXsLink": 16,
    "as.desktop.bodyXxs": 16,
    "as.desktop.bodyXxsBold": 20,
    "as.desktop.bodyXxsLink": 16,
    "as.desktop.body3xs": 14,
    "as.desktop.body3xsBold": 14,
    "as.desktop.body3xsLink": 14,
    "as.desktop.listTitle": 20,
    "as.desktop.button": 24,
    "as.desktop.code": 16,
    "as.mobile.headingXl": 68,
    "as.mobile.headingL": 52,
    "as.mobile.headingM": 44,
    "as.mobile.headingS": 36,
    "as.mobile.headingXs": 32,
    "as.mobile.headingXxs": 24,
    "as.mobile.overline": 16,
    "as.mobile.bodyL": 32,
    "as.mobile.bodyLBold": 32,
    "as.mobile.bodyLLink": 32,
    "as.mobile.bodyM": 24,
    "as.mobile.bodyMBold": 24,
    "as.mobile.bodyMLink": 24,
    "as.mobile.bodyS": 24,
    "as.mobile.bodySBold": 24,
    "as.mobile.bodySLink": 24,
    "as.mobile.bodyXs": 16,
    "as.mobile.bodyXsBold": 16,
    "as.mobile.bodyXsLink": 16,
    "as.mobile.bodyXxs": 16,
    "as.mobile.bodyXxsBold": 16,
    "as.mobile.bodyXxsLink": 16,
    "as.mobile.body3xs": 14,
    "as.mobile.body3xsBold": 14,
    "as.mobile.body3xsLink": 14,
    "as.mobile.listTitle": 20,
    "as.mobile.button": 24,
    "as.mobile.code": 16,
    "bn.desktop.headingXl": 92,
    "bn.desktop.headingL": 68,
    "bn.desktop.headingM": 44,
    "bn.desktop.headingS": 36,
    "bn.desktop.headingXs": 32,
    "bn.desktop.headingXxs": 24,
    "bn.desktop.overline": 16,
    "bn.desktop.bodyL": 28,
    "bn.desktop.bodyLBold": 28,
    "bn.desktop.bodyLLink": 28,
    "bn.desktop.bodyM": 24,
    "bn.desktop.bodyMBold": 24,
    "bn.desktop.bodyMLink": 24,
    "bn.desktop.bodyS": 24,
    "bn.desktop.bodySBold": 24,
    "bn.desktop.bodySLink": 24,
    "bn.desktop.bodyXs": 16,
    "bn.desktop.bodyXsBold": 16,
    "bn.desktop.bodyXsLink": 16,
    "bn.desktop.bodyXxs": 16,
    "bn.desktop.bodyXxsBold": 16,
    "bn.desktop.bodyXxsLink": 16,
    "bn.desktop.body3xs": 14,
    "bn.desktop.body3xsBold": 14,
    "bn.desktop.body3xsLink": 14,
    "bn.desktop.listTitle": 20,
    "bn.desktop.button": 24,
    "bn.desktop.code": 16,
    "bn.mobile.headingXl": 68,
    "bn.mobile.headingL": 52,
    "bn.mobile.headingM": 44,
    "bn.mobile.headingS": 36,
    "bn.mobile.headingXs": 32,
    "bn.mobile.headingXxs": 24,
    "bn.mobile.overline": 16,
    "bn.mobile.bodyL": 32,
    "bn.mobile.bodyLBold": 32,
    "bn.mobile.bodyLLink": 32,
    "bn.mobile.bodyM": 24,
    "bn.mobile.bodyMBold": 24,
    "bn.mobile.bodyMLink": 24,
    "bn.mobile.bodyS": 24,
    "bn.mobile.bodySBold": 24,
    "bn.mobile.bodySLink": 24,
    "bn.mobile.bodyXs": 16,
    "bn.mobile.bodyXsBold": 16,
    "bn.mobile.bodyXsLink": 16,
    "bn.mobile.bodyXxs": 16,
    "bn.mobile.bodyXxsBold": 16,
    "bn.mobile.bodyXxsLink": 16,
    "bn.mobile.body3xs": 14,
    "bn.mobile.body3xsBold": 14,
    "bn.mobile.body3xsLink": 14,
    "bn.mobile.listTitle": 20,
    "bn.mobile.button": 24,
    "bn.mobile.code": 16,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 28,
    "en.desktop.headingXxs": 20,
    "en.desktop.overline": 16,
    "en.desktop.bodyL": 32,
    "en.desktop.bodyLBold": 32,
    "en.desktop.bodyLLink": 32,
    "en.desktop.bodyM": 24,
    "en.desktop.bodyMBold": 24,
    "en.desktop.bodyMLink": 24,
    "en.desktop.bodyS": 24,
    "en.desktop.bodySBold": 24,
    "en.desktop.bodySLink": 24,
    "en.desktop.bodyXs": 20,
    "en.desktop.bodyXsBold": 20,
    "en.desktop.bodyXsLink": 20,
    "en.desktop.bodyXxs": 16,
    "en.desktop.bodyXxsBold": 16,
    "en.desktop.bodyXxsLink": 16,
    "en.desktop.body3xs": 14,
    "en.desktop.body3xsBold": 14,
    "en.desktop.body3xsLink": 14,
    "en.desktop.listTitle": 20,
    "en.desktop.button": 24,
    "en.desktop.code": 16,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 28,
    "en.mobile.headingXxs": 20,
    "en.mobile.overline": 16,
    "en.mobile.bodyL": 32,
    "en.mobile.bodyLBold": 32,
    "en.mobile.bodyLLink": 32,
    "en.mobile.bodyM": 24,
    "en.mobile.bodyMBold": 24,
    "en.mobile.bodyMLink": 24,
    "en.mobile.bodyS": 24,
    "en.mobile.bodySBold": 24,
    "en.mobile.bodySLink": 24,
    "en.mobile.bodyXs": 20,
    "en.mobile.bodyXsBold": 20,
    "en.mobile.bodyXsLink": 20,
    "en.mobile.bodyXxs": 16,
    "en.mobile.bodyXxsBold": 16,
    "en.mobile.bodyXxsLink": 16,
    "en.mobile.body3xs": 14,
    "en.mobile.body3xsBold": 14,
    "en.mobile.body3xsLink": 14,
    "en.mobile.listTitle": 20,
    "en.mobile.button": 24,
    "en.mobile.code": 16,
    "gu.desktop.headingXl": 112,
    "gu.desktop.headingL": 88,
    "gu.desktop.headingM": 64,
    "gu.desktop.headingS": 44,
    "gu.desktop.headingXs": 32,
    "gu.desktop.headingXxs": 24,
    "gu.desktop.overline": 16,
    "gu.desktop.bodyL": 28,
    "gu.desktop.bodyLBold": 28,
    "gu.desktop.bodyLLink": 28,
    "gu.desktop.bodyM": 24,
    "gu.desktop.bodyMBold": 24,
    "gu.desktop.bodyMLink": 24,
    "gu.desktop.bodyS": 24,
    "gu.desktop.bodySBold": 24,
    "gu.desktop.bodySLink": 24,
    "gu.desktop.bodyXs": 20,
    "gu.desktop.bodyXsBold": 16,
    "gu.desktop.bodyXsLink": 16,
    "gu.desktop.bodyXxs": 16,
    "gu.desktop.bodyXxsBold": 16,
    "gu.desktop.bodyXxsLink": 16,
    "gu.desktop.body3xs": 14,
    "gu.desktop.body3xsBold": 14,
    "gu.desktop.body3xsLink": 14,
    "gu.desktop.listTitle": 20,
    "gu.desktop.button": 24,
    "gu.desktop.code": 16,
    "gu.mobile.headingXl": 68,
    "gu.mobile.headingL": 52,
    "gu.mobile.headingM": 44,
    "gu.mobile.headingS": 36,
    "gu.mobile.headingXs": 32,
    "gu.mobile.headingXxs": 24,
    "gu.mobile.overline": 16,
    "gu.mobile.bodyL": 32,
    "gu.mobile.bodyLBold": 32,
    "gu.mobile.bodyLLink": 32,
    "gu.mobile.bodyM": 24,
    "gu.mobile.bodyMBold": 24,
    "gu.mobile.bodyMLink": 24,
    "gu.mobile.bodyS": 24,
    "gu.mobile.bodySBold": 24,
    "gu.mobile.bodySLink": 24,
    "gu.mobile.bodyXs": 16,
    "gu.mobile.bodyXsBold": 16,
    "gu.mobile.bodyXsLink": 16,
    "gu.mobile.bodyXxs": 16,
    "gu.mobile.bodyXxsBold": 16,
    "gu.mobile.bodyXxsLink": 16,
    "gu.mobile.body3xs": 14,
    "gu.mobile.body3xsBold": 14,
    "gu.mobile.body3xsLink": 14,
    "gu.mobile.listTitle": 20,
    "gu.mobile.button": 24,
    "gu.mobile.code": 16,
    "hi.desktop.headingXl": 92,
    "hi.desktop.headingL": 68,
    "hi.desktop.headingM": 44,
    "hi.desktop.headingS": 36,
    "hi.desktop.headingXs": 32,
    "hi.desktop.headingXxs": 24,
    "hi.desktop.overline": 16,
    "hi.desktop.bodyL": 28,
    "hi.desktop.bodyLBold": 28,
    "hi.desktop.bodyLLink": 28,
    "hi.desktop.bodyM": 24,
    "hi.desktop.bodyMBold": 24,
    "hi.desktop.bodyMLink": 24,
    "hi.desktop.bodyS": 24,
    "hi.desktop.bodySBold": 24,
    "hi.desktop.bodySLink": 24,
    "hi.desktop.bodyXs": 16,
    "hi.desktop.bodyXsBold": 16,
    "hi.desktop.bodyXsLink": 16,
    "hi.desktop.bodyXxs": 16,
    "hi.desktop.bodyXxsBold": 20,
    "hi.desktop.bodyXxsLink": 16,
    "hi.desktop.body3xs": 14,
    "hi.desktop.body3xsBold": 14,
    "hi.desktop.body3xsLink": 14,
    "hi.desktop.listTitle": 20,
    "hi.desktop.button": 24,
    "hi.desktop.code": 16,
    "hi.mobile.headingXl": 68,
    "hi.mobile.headingL": 52,
    "hi.mobile.headingM": 44,
    "hi.mobile.headingS": 36,
    "hi.mobile.headingXs": 32,
    "hi.mobile.headingXxs": 24,
    "hi.mobile.overline": 16,
    "hi.mobile.bodyL": 32,
    "hi.mobile.bodyLBold": 32,
    "hi.mobile.bodyLLink": 32,
    "hi.mobile.bodyM": 24,
    "hi.mobile.bodyMBold": 24,
    "hi.mobile.bodyMLink": 24,
    "hi.mobile.bodyS": 24,
    "hi.mobile.bodySBold": 24,
    "hi.mobile.bodySLink": 24,
    "hi.mobile.bodyXs": 16,
    "hi.mobile.bodyXsBold": 16,
    "hi.mobile.bodyXsLink": 16,
    "hi.mobile.bodyXxs": 16,
    "hi.mobile.bodyXxsBold": 16,
    "hi.mobile.bodyXxsLink": 16,
    "hi.mobile.body3xs": 14,
    "hi.mobile.body3xsBold": 14,
    "hi.mobile.body3xsLink": 14,
    "hi.mobile.listTitle": 20,
    "hi.mobile.button": 24,
    "hi.mobile.code": 16,
    "kn.desktop.headingXl": 112,
    "kn.desktop.headingL": 88,
    "kn.desktop.headingM": 64,
    "kn.desktop.headingS": 44,
    "kn.desktop.headingXs": 32,
    "kn.desktop.headingXxs": 24,
    "kn.desktop.overline": 16,
    "kn.desktop.bodyL": 28,
    "kn.desktop.bodyLBold": 28,
    "kn.desktop.bodyLLink": 28,
    "kn.desktop.bodyM": 24,
    "kn.desktop.bodyMBold": 24,
    "kn.desktop.bodyMLink": 24,
    "kn.desktop.bodyS": 24,
    "kn.desktop.bodySBold": 24,
    "kn.desktop.bodySLink": 24,
    "kn.desktop.bodyXs": 20,
    "kn.desktop.bodyXsBold": 16,
    "kn.desktop.bodyXsLink": 16,
    "kn.desktop.bodyXxs": 16,
    "kn.desktop.bodyXxsBold": 16,
    "kn.desktop.bodyXxsLink": 16,
    "kn.desktop.body3xs": 14,
    "kn.desktop.body3xsBold": 14,
    "kn.desktop.body3xsLink": 14,
    "kn.desktop.listTitle": 20,
    "kn.desktop.button": 24,
    "kn.desktop.code": 16,
    "kn.mobile.headingXl": 68,
    "kn.mobile.headingL": 52,
    "kn.mobile.headingM": 44,
    "kn.mobile.headingS": 36,
    "kn.mobile.headingXs": 32,
    "kn.mobile.headingXxs": 24,
    "kn.mobile.overline": 16,
    "kn.mobile.bodyL": 32,
    "kn.mobile.bodyLBold": 32,
    "kn.mobile.bodyLLink": 32,
    "kn.mobile.bodyM": 24,
    "kn.mobile.bodyMBold": 24,
    "kn.mobile.bodyMLink": 24,
    "kn.mobile.bodyS": 24,
    "kn.mobile.bodySBold": 24,
    "kn.mobile.bodySLink": 24,
    "kn.mobile.bodyXs": 16,
    "kn.mobile.bodyXsBold": 16,
    "kn.mobile.bodyXsLink": 16,
    "kn.mobile.bodyXxs": 16,
    "kn.mobile.bodyXxsBold": 16,
    "kn.mobile.bodyXxsLink": 16,
    "kn.mobile.body3xs": 14,
    "kn.mobile.body3xsBold": 14,
    "kn.mobile.body3xsLink": 14,
    "kn.mobile.listTitle": 20,
    "kn.mobile.button": 24,
    "kn.mobile.code": 16,
    "ml.desktop.headingXl": 92,
    "ml.desktop.headingL": 68,
    "ml.desktop.headingM": 44,
    "ml.desktop.headingS": 36,
    "ml.desktop.headingXs": 32,
    "ml.desktop.headingXxs": 24,
    "ml.desktop.overline": 16,
    "ml.desktop.bodyL": 28,
    "ml.desktop.bodyLBold": 28,
    "ml.desktop.bodyLLink": 28,
    "ml.desktop.bodyM": 24,
    "ml.desktop.bodyMBold": 24,
    "ml.desktop.bodyMLink": 24,
    "ml.desktop.bodyS": 24,
    "ml.desktop.bodySBold": 24,
    "ml.desktop.bodySLink": 24,
    "ml.desktop.bodyXs": 20,
    "ml.desktop.bodyXsBold": 16,
    "ml.desktop.bodyXsLink": 16,
    "ml.desktop.bodyXxs": 16,
    "ml.desktop.bodyXxsBold": 16,
    "ml.desktop.bodyXxsLink": 16,
    "ml.desktop.body3xs": 14,
    "ml.desktop.body3xsBold": 14,
    "ml.desktop.body3xsLink": 14,
    "ml.desktop.listTitle": 20,
    "ml.desktop.button": 24,
    "ml.desktop.code": 16,
    "ml.mobile.headingXl": 68,
    "ml.mobile.headingL": 52,
    "ml.mobile.headingM": 44,
    "ml.mobile.headingS": 36,
    "ml.mobile.headingXs": 32,
    "ml.mobile.headingXxs": 24,
    "ml.mobile.overline": 16,
    "ml.mobile.bodyL": 32,
    "ml.mobile.bodyLBold": 32,
    "ml.mobile.bodyLLink": 32,
    "ml.mobile.bodyM": 24,
    "ml.mobile.bodyMBold": 24,
    "ml.mobile.bodyMLink": 24,
    "ml.mobile.bodyS": 24,
    "ml.mobile.bodySBold": 24,
    "ml.mobile.bodySLink": 24,
    "ml.mobile.bodyXs": 16,
    "ml.mobile.bodyXsBold": 16,
    "ml.mobile.bodyXsLink": 16,
    "ml.mobile.bodyXxs": 16,
    "ml.mobile.bodyXxsBold": 16,
    "ml.mobile.bodyXxsLink": 16,
    "ml.mobile.body3xs": 14,
    "ml.mobile.body3xsBold": 14,
    "ml.mobile.body3xsLink": 14,
    "ml.mobile.listTitle": 20,
    "ml.mobile.button": 24,
    "ml.mobile.code": 16,
    "mr.desktop.headingXl": 92,
    "mr.desktop.headingL": 68,
    "mr.desktop.headingM": 44,
    "mr.desktop.headingS": 36,
    "mr.desktop.headingXs": 32,
    "mr.desktop.headingXxs": 24,
    "mr.desktop.overline": 16,
    "mr.desktop.bodyL": 28,
    "mr.desktop.bodyLBold": 28,
    "mr.desktop.bodyLLink": 28,
    "mr.desktop.bodyM": 24,
    "mr.desktop.bodyMBold": 24,
    "mr.desktop.bodyMLink": 24,
    "mr.desktop.bodyS": 24,
    "mr.desktop.bodySBold": 24,
    "mr.desktop.bodySLink": 24,
    "mr.desktop.bodyXs": 16,
    "mr.desktop.bodyXsBold": 16,
    "mr.desktop.bodyXsLink": 16,
    "mr.desktop.bodyXxs": 16,
    "mr.desktop.bodyXxsBold": 16,
    "mr.desktop.bodyXxsLink": 16,
    "mr.desktop.body3xs": 14,
    "mr.desktop.body3xsBold": 14,
    "mr.desktop.body3xsLink": 14,
    "mr.desktop.listTitle": 20,
    "mr.desktop.button": 24,
    "mr.desktop.code": 16,
    "mr.mobile.headingXl": 68,
    "mr.mobile.headingL": 52,
    "mr.mobile.headingM": 44,
    "mr.mobile.headingS": 36,
    "mr.mobile.headingXs": 32,
    "mr.mobile.headingXxs": 24,
    "mr.mobile.overline": 16,
    "mr.mobile.bodyL": 32,
    "mr.mobile.bodyLBold": 32,
    "mr.mobile.bodyLLink": 32,
    "mr.mobile.bodyM": 24,
    "mr.mobile.bodyMBold": 24,
    "mr.mobile.bodyMLink": 24,
    "mr.mobile.bodyS": 24,
    "mr.mobile.bodySBold": 24,
    "mr.mobile.bodySLink": 24,
    "mr.mobile.bodyXs": 16,
    "mr.mobile.bodyXsBold": 16,
    "mr.mobile.bodyXsLink": 16,
    "mr.mobile.bodyXxs": 16,
    "mr.mobile.bodyXxsBold": 16,
    "mr.mobile.bodyXxsLink": 16,
    "mr.mobile.body3xs": 14,
    "mr.mobile.body3xsBold": 14,
    "mr.mobile.body3xsLink": 14,
    "mr.mobile.listTitle": 20,
    "mr.mobile.button": 24,
    "mr.mobile.code": 16,
    "or.desktop.headingXl": 92,
    "or.desktop.headingL": 68,
    "or.desktop.headingM": 44,
    "or.desktop.headingS": 36,
    "or.desktop.headingXs": 32,
    "or.desktop.headingXxs": 24,
    "or.desktop.overline": 16,
    "or.desktop.bodyL": 28,
    "or.desktop.bodyLBold": 28,
    "or.desktop.bodyLLink": 28,
    "or.desktop.bodyM": 24,
    "or.desktop.bodyMBold": 24,
    "or.desktop.bodyMLink": 24,
    "or.desktop.bodyS": 24,
    "or.desktop.bodySBold": 24,
    "or.desktop.bodySLink": 24,
    "or.desktop.bodyXs": 16,
    "or.desktop.bodyXsBold": 16,
    "or.desktop.bodyXsLink": 16,
    "or.desktop.bodyXxs": 16,
    "or.desktop.bodyXxsBold": 16,
    "or.desktop.bodyXxsLink": 16,
    "or.desktop.body3xs": 14,
    "or.desktop.body3xsBold": 14,
    "or.desktop.body3xsLink": 14,
    "or.desktop.listTitle": 20,
    "or.desktop.button": 24,
    "or.desktop.code": 16,
    "or.mobile.headingXl": 68,
    "or.mobile.headingL": 52,
    "or.mobile.headingM": 44,
    "or.mobile.headingS": 36,
    "or.mobile.headingXs": 32,
    "or.mobile.headingXxs": 24,
    "or.mobile.overline": 16,
    "or.mobile.bodyL": 32,
    "or.mobile.bodyLBold": 32,
    "or.mobile.bodyLLink": 32,
    "or.mobile.bodyM": 24,
    "or.mobile.bodyMBold": 24,
    "or.mobile.bodyMLink": 24,
    "or.mobile.bodyS": 24,
    "or.mobile.bodySBold": 24,
    "or.mobile.bodySLink": 24,
    "or.mobile.bodyXs": 16,
    "or.mobile.bodyXsBold": 16,
    "or.mobile.bodyXsLink": 16,
    "or.mobile.bodyXxs": 16,
    "or.mobile.bodyXxsBold": 16,
    "or.mobile.bodyXxsLink": 16,
    "or.mobile.body3xs": 14,
    "or.mobile.body3xsBold": 14,
    "or.mobile.body3xsLink": 14,
    "or.mobile.listTitle": 20,
    "or.mobile.button": 24,
    "or.mobile.code": 16,
    "pa.desktop.headingXl": 92,
    "pa.desktop.headingL": 68,
    "pa.desktop.headingM": 44,
    "pa.desktop.headingS": 36,
    "pa.desktop.headingXs": 32,
    "pa.desktop.headingXxs": 24,
    "pa.desktop.overline": 16,
    "pa.desktop.bodyL": 28,
    "pa.desktop.bodyLBold": 28,
    "pa.desktop.bodyLLink": 28,
    "pa.desktop.bodyM": 24,
    "pa.desktop.bodyMBold": 24,
    "pa.desktop.bodyMLink": 24,
    "pa.desktop.bodyS": 24,
    "pa.desktop.bodySBold": 24,
    "pa.desktop.bodySLink": 24,
    "pa.desktop.bodyXs": 20,
    "pa.desktop.bodyXsBold": 16,
    "pa.desktop.bodyXsLink": 16,
    "pa.desktop.bodyXxs": 16,
    "pa.desktop.bodyXxsBold": 16,
    "pa.desktop.bodyXxsLink": 16,
    "pa.desktop.body3xs": 14,
    "pa.desktop.body3xsBold": 14,
    "pa.desktop.body3xsLink": 14,
    "pa.desktop.listTitle": 20,
    "pa.desktop.button": 24,
    "pa.desktop.code": 16,
    "pa.mobile.headingXl": 68,
    "pa.mobile.headingL": 52,
    "pa.mobile.headingM": 44,
    "pa.mobile.headingS": 36,
    "pa.mobile.headingXs": 32,
    "pa.mobile.headingXxs": 24,
    "pa.mobile.overline": 16,
    "pa.mobile.bodyL": 32,
    "pa.mobile.bodyLBold": 32,
    "pa.mobile.bodyLLink": 32,
    "pa.mobile.bodyM": 24,
    "pa.mobile.bodyMBold": 24,
    "pa.mobile.bodyMLink": 24,
    "pa.mobile.bodyS": 24,
    "pa.mobile.bodySBold": 24,
    "pa.mobile.bodySLink": 24,
    "pa.mobile.bodyXs": 16,
    "pa.mobile.bodyXsBold": 16,
    "pa.mobile.bodyXsLink": 16,
    "pa.mobile.bodyXxs": 16,
    "pa.mobile.bodyXxsBold": 16,
    "pa.mobile.bodyXxsLink": 16,
    "pa.mobile.body3xs": 14,
    "pa.mobile.body3xsBold": 14,
    "pa.mobile.body3xsLink": 14,
    "pa.mobile.listTitle": 20,
    "pa.mobile.button": 24,
    "pa.mobile.code": 16,
    "ta.desktop.headingXl": 112,
    "ta.desktop.headingL": 88,
    "ta.desktop.headingM": 64,
    "ta.desktop.headingS": 44,
    "ta.desktop.headingXs": 32,
    "ta.desktop.headingXxs": 24,
    "ta.desktop.overline": 16,
    "ta.desktop.bodyL": 28,
    "ta.desktop.bodyLBold": 28,
    "ta.desktop.bodyLLink": 28,
    "ta.desktop.bodyM": 24,
    "ta.desktop.bodyMBold": 24,
    "ta.desktop.bodyMLink": 24,
    "ta.desktop.bodyS": 24,
    "ta.desktop.bodySBold": 24,
    "ta.desktop.bodySLink": 24,
    "ta.desktop.bodyXs": 16,
    "ta.desktop.bodyXsBold": 16,
    "ta.desktop.bodyXsLink": 16,
    "ta.desktop.bodyXxs": 16,
    "ta.desktop.bodyXxsBold": 16,
    "ta.desktop.bodyXxsLink": 16,
    "ta.desktop.body3xs": 14,
    "ta.desktop.body3xsBold": 14,
    "ta.desktop.body3xsLink": 14,
    "ta.desktop.listTitle": 20,
    "ta.desktop.button": 24,
    "ta.desktop.code": 16,
    "ta.mobile.headingXl": 68,
    "ta.mobile.headingL": 52,
    "ta.mobile.headingM": 44,
    "ta.mobile.headingS": 36,
    "ta.mobile.headingXs": 32,
    "ta.mobile.headingXxs": 24,
    "ta.mobile.overline": 16,
    "ta.mobile.bodyL": 32,
    "ta.mobile.bodyLBold": 32,
    "ta.mobile.bodyLLink": 32,
    "ta.mobile.bodyM": 24,
    "ta.mobile.bodyMBold": 24,
    "ta.mobile.bodyMLink": 24,
    "ta.mobile.bodyS": 24,
    "ta.mobile.bodySBold": 24,
    "ta.mobile.bodySLink": 24,
    "ta.mobile.bodyXs": 20,
    "ta.mobile.bodyXsBold": 16,
    "ta.mobile.bodyXsLink": 16,
    "ta.mobile.bodyXxs": 16,
    "ta.mobile.bodyXxsBold": 16,
    "ta.mobile.bodyXxsLink": 16,
    "ta.mobile.body3xs": 14,
    "ta.mobile.body3xsBold": 14,
    "ta.mobile.body3xsLink": 14,
    "ta.mobile.listTitle": 20,
    "ta.mobile.button": 24,
    "ta.mobile.code": 16,
    "te.desktop.headingXl": 92,
    "te.desktop.headingL": 68,
    "te.desktop.headingM": 44,
    "te.desktop.headingS": 36,
    "te.desktop.headingXs": 32,
    "te.desktop.headingXxs": 24,
    "te.desktop.overline": 16,
    "te.desktop.bodyL": 28,
    "te.desktop.bodyLBold": 28,
    "te.desktop.bodyLLink": 28,
    "te.desktop.bodyM": 24,
    "te.desktop.bodyMBold": 24,
    "te.desktop.bodyMLink": 24,
    "te.desktop.bodyS": 24,
    "te.desktop.bodySBold": 24,
    "te.desktop.bodySLink": 24,
    "te.desktop.bodyXs": 16,
    "te.desktop.bodyXsBold": 16,
    "te.desktop.bodyXsLink": 16,
    "te.desktop.bodyXxs": 16,
    "te.desktop.bodyXxsBold": 16,
    "te.desktop.bodyXxsLink": 16,
    "te.desktop.body3xs": 14,
    "te.desktop.body3xsBold": 14,
    "te.desktop.body3xsLink": 14,
    "te.desktop.listTitle": 20,
    "te.desktop.button": 24,
    "te.desktop.code": 16,
    "te.mobile.headingXl": 68,
    "te.mobile.headingL": 52,
    "te.mobile.headingM": 44,
    "te.mobile.headingS": 36,
    "te.mobile.headingXs": 32,
    "te.mobile.headingXxs": 24,
    "te.mobile.overline": 16,
    "te.mobile.bodyL": 32,
    "te.mobile.bodyLBold": 32,
    "te.mobile.bodyLLink": 32,
    "te.mobile.bodyM": 24,
    "te.mobile.bodyMBold": 24,
    "te.mobile.bodyMLink": 24,
    "te.mobile.bodyS": 24,
    "te.mobile.bodySBold": 24,
    "te.mobile.bodySLink": 24,
    "te.mobile.bodyXs": 16,
    "te.mobile.bodyXsBold": 16,
    "te.mobile.bodyXsLink": 16,
    "te.mobile.bodyXxs": 16,
    "te.mobile.bodyXxsBold": 16,
    "te.mobile.bodyXxsLink": 16,
    "te.mobile.body3xs": 14,
    "te.mobile.body3xsBold": 14,
    "te.mobile.body3xsLink": 14,
    "te.mobile.listTitle": 20,
    "te.mobile.button": 24,
    "te.mobile.code": 16,
    headingXl: $f551aa6589c293c2$var$headingXl,
    headingL: $f551aa6589c293c2$var$headingL,
    headingM: $f551aa6589c293c2$var$headingM,
    headingS: $f551aa6589c293c2$var$headingS,
    headingXs: $f551aa6589c293c2$var$headingXs,
    headingXxs: $f551aa6589c293c2$var$headingXxs,
    overline: $f551aa6589c293c2$var$overline$1,
    bodyL: $f551aa6589c293c2$var$bodyL,
    bodyLBold: $f551aa6589c293c2$var$bodyLBold,
    bodyLLink: $f551aa6589c293c2$var$bodyLLink,
    bodyM: $f551aa6589c293c2$var$bodyM,
    bodyMBold: $f551aa6589c293c2$var$bodyMBold,
    bodyMLink: $f551aa6589c293c2$var$bodyMLink,
    bodyS: $f551aa6589c293c2$var$bodyS,
    bodySBold: $f551aa6589c293c2$var$bodySBold,
    bodySLink: $f551aa6589c293c2$var$bodySLink,
    bodyXs: $f551aa6589c293c2$var$bodyXs,
    bodyXsBold: $f551aa6589c293c2$var$bodyXsBold,
    bodyXsLink: $f551aa6589c293c2$var$bodyXsLink,
    bodyXxs: $f551aa6589c293c2$var$bodyXxs,
    bodyXxsBold: $f551aa6589c293c2$var$bodyXxsBold,
    bodyXxsLink: $f551aa6589c293c2$var$bodyXxsLink,
    body3xs: $f551aa6589c293c2$var$body3xs,
    body3xsBold: $f551aa6589c293c2$var$body3xsBold,
    body3xsLink: $f551aa6589c293c2$var$body3xsLink,
    listTitle: $f551aa6589c293c2$var$listTitle,
    button: $f551aa6589c293c2$var$button,
    code: $f551aa6589c293c2$var$code
};
const $f551aa6589c293c2$var$custom_1$2 = "85%";
const $f551aa6589c293c2$var$custom_2$2 = "80%";
const $f551aa6589c293c2$var$opacity = {
    "opacity.invisible": "0%",
    "opacity.disabled": "30%",
    "opacity.enabled": "100%",
    custom_1: $f551aa6589c293c2$var$custom_1$2,
    custom_2: $f551aa6589c293c2$var$custom_2$2
};
const $f551aa6589c293c2$var$paragraphSpacing = {
    "paragraph-spacing.0": "0"
};
const $f551aa6589c293c2$var$semantic = {
    "color.bold.default.description": "Used for default focus and disable backgrounds",
    "color.bold.emphasised.description": "Used for hover bg",
    "color.bold.muted.description": "Used as fg on dissabled",
    "color.bold.subtle.description": "Used for the fg on pressed",
    "color.bold.discreet.description": "Used as fg on hover",
    "color.bold.on-bold.description": "Used on the default fg",
    "color.bold.disabled.description": "Used on the default fg"
};
const $f551aa6589c293c2$var$shadows = {
    "box-shadow.1.true": "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    "box-shadow.false": "none"
};
const $f551aa6589c293c2$var$xxs$1 = "4";
const $f551aa6589c293c2$var$xs$1 = "8";
const $f551aa6589c293c2$var$s$1 = "12";
const $f551aa6589c293c2$var$base$1 = "16";
const $f551aa6589c293c2$var$m$1 = "24";
const $f551aa6589c293c2$var$l$1 = "32";
const $f551aa6589c293c2$var$xl$1 = "40";
const $f551aa6589c293c2$var$xxl$1 = "48";
const $f551aa6589c293c2$var$huge$1 = "64";
const $f551aa6589c293c2$var$massive$1 = "80";
const $f551aa6589c293c2$var$custom_1$1 = "120";
const $f551aa6589c293c2$var$custom_2$1 = "44";
const $f551aa6589c293c2$var$custom_3$1 = "28";
const $f551aa6589c293c2$var$custom_4$1 = "2";
const $f551aa6589c293c2$var$custom_5$1 = "1";
const $f551aa6589c293c2$var$custom_6$1 = "384";
const $f551aa6589c293c2$var$custom_7$1 = "156";
const $f551aa6589c293c2$var$custom_8$1 = "300";
const $f551aa6589c293c2$var$custom_9$1 = "102";
const $f551aa6589c293c2$var$custom_10$1 = "184";
const $f551aa6589c293c2$var$custom_11$1 = "56";
const $f551aa6589c293c2$var$custom_12$1 = "280";
const $f551aa6589c293c2$var$custom_13$1 = "312";
const $f551aa6589c293c2$var$custom_14$1 = "384";
const $f551aa6589c293c2$var$custom_15$1 = "6";
const $f551aa6589c293c2$var$custom_16$1 = "72";
const $f551aa6589c293c2$var$custom_17$1 = "560";
const $f551aa6589c293c2$var$custom_18$1 = "20";
const $f551aa6589c293c2$var$custom_19$1 = "10";
const $f551aa6589c293c2$var$custom_20$1 = "9";
const $f551aa6589c293c2$var$custom_21$1 = "15";
const $f551aa6589c293c2$var$custom_22$1 = "17";
const $f551aa6589c293c2$var$custom_23$1 = "7";
const $f551aa6589c293c2$var$custom_24$1 = "13";
const $f551aa6589c293c2$var$custom_25$1 = "18";
const $f551aa6589c293c2$var$custom_26 = "27";
const $f551aa6589c293c2$var$custom_27 = "584";
const $f551aa6589c293c2$var$custom_28 = "331";
const $f551aa6589c293c2$var$custom_29 = "33";
const $f551aa6589c293c2$var$custom_30 = "23";
const $f551aa6589c293c2$var$custom_31 = "592";
const $f551aa6589c293c2$var$sizing = {
    xxs: $f551aa6589c293c2$var$xxs$1,
    xs: $f551aa6589c293c2$var$xs$1,
    s: $f551aa6589c293c2$var$s$1,
    base: $f551aa6589c293c2$var$base$1,
    m: $f551aa6589c293c2$var$m$1,
    l: $f551aa6589c293c2$var$l$1,
    xl: $f551aa6589c293c2$var$xl$1,
    xxl: $f551aa6589c293c2$var$xxl$1,
    huge: $f551aa6589c293c2$var$huge$1,
    massive: $f551aa6589c293c2$var$massive$1,
    custom_1: $f551aa6589c293c2$var$custom_1$1,
    custom_2: $f551aa6589c293c2$var$custom_2$1,
    custom_3: $f551aa6589c293c2$var$custom_3$1,
    custom_4: $f551aa6589c293c2$var$custom_4$1,
    custom_5: $f551aa6589c293c2$var$custom_5$1,
    custom_6: $f551aa6589c293c2$var$custom_6$1,
    custom_7: $f551aa6589c293c2$var$custom_7$1,
    custom_8: $f551aa6589c293c2$var$custom_8$1,
    custom_9: $f551aa6589c293c2$var$custom_9$1,
    custom_10: $f551aa6589c293c2$var$custom_10$1,
    custom_11: $f551aa6589c293c2$var$custom_11$1,
    custom_12: $f551aa6589c293c2$var$custom_12$1,
    custom_13: $f551aa6589c293c2$var$custom_13$1,
    custom_14: $f551aa6589c293c2$var$custom_14$1,
    custom_15: $f551aa6589c293c2$var$custom_15$1,
    custom_16: $f551aa6589c293c2$var$custom_16$1,
    custom_17: $f551aa6589c293c2$var$custom_17$1,
    custom_18: $f551aa6589c293c2$var$custom_18$1,
    custom_19: $f551aa6589c293c2$var$custom_19$1,
    custom_20: $f551aa6589c293c2$var$custom_20$1,
    custom_21: $f551aa6589c293c2$var$custom_21$1,
    custom_22: $f551aa6589c293c2$var$custom_22$1,
    custom_23: $f551aa6589c293c2$var$custom_23$1,
    custom_24: $f551aa6589c293c2$var$custom_24$1,
    custom_25: $f551aa6589c293c2$var$custom_25$1,
    custom_26: $f551aa6589c293c2$var$custom_26,
    custom_27: $f551aa6589c293c2$var$custom_27,
    custom_28: $f551aa6589c293c2$var$custom_28,
    custom_29: $f551aa6589c293c2$var$custom_29,
    custom_30: $f551aa6589c293c2$var$custom_30,
    custom_31: $f551aa6589c293c2$var$custom_31
};
const $f551aa6589c293c2$var$xxs = "4";
const $f551aa6589c293c2$var$xs = "8";
const $f551aa6589c293c2$var$s = "12";
const $f551aa6589c293c2$var$base = "16";
const $f551aa6589c293c2$var$m = "24";
const $f551aa6589c293c2$var$l = "32";
const $f551aa6589c293c2$var$xl = "40";
const $f551aa6589c293c2$var$xxl = "48";
const $f551aa6589c293c2$var$huge = "64";
const $f551aa6589c293c2$var$massive = "80";
const $f551aa6589c293c2$var$custom_1 = "1";
const $f551aa6589c293c2$var$stepper_horizontal = "{$platform.stepper_horizontal}";
const $f551aa6589c293c2$var$custom_2 = "11";
const $f551aa6589c293c2$var$custom_3 = "128";
const $f551aa6589c293c2$var$custom_4 = "2";
const $f551aa6589c293c2$var$custom_5 = "0";
const $f551aa6589c293c2$var$custom_6 = "84";
const $f551aa6589c293c2$var$custom_7 = "88";
const $f551aa6589c293c2$var$custom_8 = "42";
const $f551aa6589c293c2$var$custom_9 = "10";
const $f551aa6589c293c2$var$custom_10 = "38";
const $f551aa6589c293c2$var$custom_11 = "26";
const $f551aa6589c293c2$var$custom_12 = "30";
const $f551aa6589c293c2$var$custom_13 = "22";
const $f551aa6589c293c2$var$custom_14 = "28";
const $f551aa6589c293c2$var$custom_15 = "20";
const $f551aa6589c293c2$var$custom_16 = "3";
const $f551aa6589c293c2$var$custom_17 = "5";
const $f551aa6589c293c2$var$custom_18 = "6";
const $f551aa6589c293c2$var$custom_19 = "56";
const $f551aa6589c293c2$var$custom_20 = "46";
const $f551aa6589c293c2$var$custom_21 = "110";
const $f551aa6589c293c2$var$custom_22 = "114";
const $f551aa6589c293c2$var$custom_23 = "15";
const $f551aa6589c293c2$var$custom_24 = "31";
const $f551aa6589c293c2$var$custom_25 = "17";
const $f551aa6589c293c2$var$bottomsheet_padding_right = "90";
const $f551aa6589c293c2$var$spacing = {
    xxs: $f551aa6589c293c2$var$xxs,
    xs: $f551aa6589c293c2$var$xs,
    s: $f551aa6589c293c2$var$s,
    base: $f551aa6589c293c2$var$base,
    m: $f551aa6589c293c2$var$m,
    l: $f551aa6589c293c2$var$l,
    xl: $f551aa6589c293c2$var$xl,
    xxl: $f551aa6589c293c2$var$xxl,
    huge: $f551aa6589c293c2$var$huge,
    massive: $f551aa6589c293c2$var$massive,
    custom_1: $f551aa6589c293c2$var$custom_1,
    "desktop.stepper_horizontal": "{massive}",
    "tablet.stepper_horizontal": "{m}",
    "mobile.stepper_horizontal": "{m}",
    stepper_horizontal: $f551aa6589c293c2$var$stepper_horizontal,
    custom_2: $f551aa6589c293c2$var$custom_2,
    custom_3: $f551aa6589c293c2$var$custom_3,
    custom_4: $f551aa6589c293c2$var$custom_4,
    custom_5: $f551aa6589c293c2$var$custom_5,
    custom_6: $f551aa6589c293c2$var$custom_6,
    custom_7: $f551aa6589c293c2$var$custom_7,
    custom_8: $f551aa6589c293c2$var$custom_8,
    custom_9: $f551aa6589c293c2$var$custom_9,
    custom_10: $f551aa6589c293c2$var$custom_10,
    custom_11: $f551aa6589c293c2$var$custom_11,
    custom_12: $f551aa6589c293c2$var$custom_12,
    custom_13: $f551aa6589c293c2$var$custom_13,
    custom_14: $f551aa6589c293c2$var$custom_14,
    custom_15: $f551aa6589c293c2$var$custom_15,
    custom_16: $f551aa6589c293c2$var$custom_16,
    custom_17: $f551aa6589c293c2$var$custom_17,
    custom_18: $f551aa6589c293c2$var$custom_18,
    custom_19: $f551aa6589c293c2$var$custom_19,
    custom_20: $f551aa6589c293c2$var$custom_20,
    custom_21: $f551aa6589c293c2$var$custom_21,
    custom_22: $f551aa6589c293c2$var$custom_22,
    custom_23: $f551aa6589c293c2$var$custom_23,
    custom_24: $f551aa6589c293c2$var$custom_24,
    custom_25: $f551aa6589c293c2$var$custom_25,
    bottomsheet_padding_right: $f551aa6589c293c2$var$bottomsheet_padding_right
};
const $f551aa6589c293c2$var$overline = "{$lang.$platform.overline}";
const $f551aa6589c293c2$var$textCase = {
    "text-case.none": "none",
    "text-case.uppercase": "uppercase",
    "text-case.lowercase": "lowercase",
    "text-case.capitalize": "capitalize",
    "as.desktop.overline": "uppercase",
    "as.mobile.overline": "uppercase",
    "bn.desktop.overline": "uppercase",
    "bn.mobile.overline": "uppercase",
    "en.desktop.overline": "uppercase",
    "en.mobile.overline": "uppercase",
    "gu.desktop.overline": "uppercase",
    "gu.mobile.overline": "uppercase",
    "hi.desktop.overline": "uppercase",
    "hi.mobile.overline": "uppercase",
    "kn.desktop.overline": "uppercase",
    "kn.mobile.overline": "uppercase",
    "ml.desktop.overline": "uppercase",
    "mr.desktop.overline": "uppercase",
    "mr.mobile.overline": "uppercase",
    "or.desktop.overline": "uppercase",
    "pa.desktop.overline": "uppercase",
    "pa.mobile.overline": "uppercase",
    "ta.desktop.overline": "uppercase",
    "ta.mobile.overline": "uppercase",
    "te.desktop.overline": "uppercase",
    "te.mobile.overline": "uppercase",
    overline: $f551aa6589c293c2$var$overline
};
const $f551aa6589c293c2$var$textDecoration = {
    "text-decoration.none": "none",
    "text-decoration.underline": "underline",
    "text-decoration.line-through": "line-through",
    "text-decoration.overline": "overline",
    "max.lines.1": "1",
    "text-overflow.ellipsis": "ellipsis"
};
const $f551aa6589c293c2$var$easeRapid = "0.35, 0, 0.5, 1";
const $f551aa6589c293c2$var$easeQuick = "0.35, 0, 0.25, 1";
const $f551aa6589c293c2$var$easeJoyful = "0.35, 1.3, 0.3, 1";
const $f551aa6589c293c2$var$easeEntrance = "0, 0, 0.1, 1";
const $f551aa6589c293c2$var$easeExit = "0.35, 0, 0.8, 1";
const $f551aa6589c293c2$var$easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const $f551aa6589c293c2$var$easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const $f551aa6589c293c2$var$easeJoyfulentrance = "0.15, 1.3, 0.3, 1";
const $f551aa6589c293c2$var$easeJoyfulexit = "0.7, -0.1, 0.6, 0.1";
const $f551aa6589c293c2$var$transitions = {
    easeRapid: $f551aa6589c293c2$var$easeRapid,
    easeQuick: $f551aa6589c293c2$var$easeQuick,
    easeJoyful: $f551aa6589c293c2$var$easeJoyful,
    easeEntrance: $f551aa6589c293c2$var$easeEntrance,
    easeExit: $f551aa6589c293c2$var$easeExit,
    easeJoyfulEntrance: $f551aa6589c293c2$var$easeJoyfulEntrance,
    easeJoyfulExit: $f551aa6589c293c2$var$easeJoyfulExit,
    easeJoyfulentrance: $f551aa6589c293c2$var$easeJoyfulentrance,
    easeJoyfulexit: $f551aa6589c293c2$var$easeJoyfulexit
};
const $f551aa6589c293c2$var$rapid = "300";
const $f551aa6589c293c2$var$medium = "500";
const $f551aa6589c293c2$var$slow = "1000";
const $f551aa6589c293c2$var$transitionsDuration = {
    rapid: $f551aa6589c293c2$var$rapid,
    medium: $f551aa6589c293c2$var$medium,
    slow: $f551aa6589c293c2$var$slow
};
const $f551aa6589c293c2$var$typography = {};
const $f551aa6589c293c2$export$6ad93df59e712c43 = {
    tokens: {
        borderRadius: $f551aa6589c293c2$var$borderRadius,
        borderWidth: $f551aa6589c293c2$var$borderWidth,
        color: $f551aa6589c293c2$var$color,
        fontFamilies: $f551aa6589c293c2$var$fontFamilies,
        fontSizes: $f551aa6589c293c2$var$fontSizes,
        fontWeights: $f551aa6589c293c2$var$fontWeights,
        letterSpacing: $f551aa6589c293c2$var$letterSpacing,
        lineHeights: $f551aa6589c293c2$var$lineHeights,
        opacity: $f551aa6589c293c2$var$opacity,
        paragraphSpacing: $f551aa6589c293c2$var$paragraphSpacing,
        semantic: $f551aa6589c293c2$var$semantic,
        sizing: $f551aa6589c293c2$var$sizing,
        spacing: $f551aa6589c293c2$var$spacing,
        textCase: $f551aa6589c293c2$var$textCase,
        textDecoration: $f551aa6589c293c2$var$textDecoration,
        typography: $f551aa6589c293c2$var$typography,
        layout: $f551aa6589c293c2$var$layout,
        shadows: $f551aa6589c293c2$var$shadows,
        transitions: $f551aa6589c293c2$var$transitions,
        transitionsDuration: $f551aa6589c293c2$var$transitionsDuration
    },
    getComponentTokens: $f551aa6589c293c2$var$getComponentTokens
};
const $f551aa6589c293c2$var$accordionlist_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$AccordionListTokens = {
    "accordionlist_base_root-container_flex-direction": "{flexDirection.column}",
    "accordionlist_base_root-container_width": "{size.max}",
    "accordionlist_base_container_flex-direction": "{flexDirection.column}",
    accordionlist_base_container_width: $f551aa6589c293c2$var$accordionlist_base_container_width
};
const $f551aa6589c293c2$var$avatar_base_container_width$1 = "{xl}";
const $f551aa6589c293c2$var$avatar_base_container_height$1 = "{xl}";
const $f551aa6589c293c2$var$avatar_variant_size_small_container_width$1 = "{l}";
const $f551aa6589c293c2$var$avatar_variant_size_small_container_height$1 = "{l}";
const $f551aa6589c293c2$var$avatar_variant_size_large_container_width$1 = "{xxl}";
const $f551aa6589c293c2$var$avatar_variant_size_large_container_height$1 = "{xxl}";
const $f551aa6589c293c2$var$avatar_base_container_opacity$1 = "{opacity.enabled}";
const $f551aa6589c293c2$var$avatar_variant_disabled_true_container_opacity$1 = "{opacity.disabled}";
const $f551aa6589c293c2$var$avatar_combination_true_image_container_behavior_hover_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$avatar_combination_true_image_container_behavior_focus_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$AvatarTokens = {
    avatar_base_container_width: $f551aa6589c293c2$var$avatar_base_container_width$1,
    avatar_base_container_height: $f551aa6589c293c2$var$avatar_base_container_height$1,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary80}",
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $f551aa6589c293c2$var$avatar_variant_size_small_container_width$1,
    avatar_variant_size_small_container_height: $f551aa6589c293c2$var$avatar_variant_size_small_container_height$1,
    avatar_variant_size_large_container_width: $f551aa6589c293c2$var$avatar_variant_size_large_container_width$1,
    avatar_variant_size_large_container_height: $f551aa6589c293c2$var$avatar_variant_size_large_container_height$1,
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    avatar_base_container_opacity: $f551aa6589c293c2$var$avatar_base_container_opacity$1,
    avatar_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$avatar_variant_disabled_true_container_opacity$1,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    "avatar_combination_true_icon_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_hover_background-color": "{sparkle40}",
    "avatar_combination_true_initials_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_focus_background-color": "{sparkle40}",
    avatar_combination_true_image_container_behavior_hover_opacity: $f551aa6589c293c2$var$avatar_combination_true_image_container_behavior_hover_opacity,
    "avatar_combination_true_image_container_behavior_focus_border-width": "{border_focus}",
    avatar_combination_true_image_container_behavior_focus_opacity: $f551aa6589c293c2$var$avatar_combination_true_image_container_behavior_focus_opacity
};
const $f551aa6589c293c2$var$avatar_base_container_width = "{xl}";
const $f551aa6589c293c2$var$avatar_base_container_height = "{xl}";
const $f551aa6589c293c2$var$avatar_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$avatar_base_icon_size = "{custom_3}";
const $f551aa6589c293c2$var$avatar_base_icon_color = "{primary60}";
const $f551aa6589c293c2$var$avatar_base_icon_behavior_hover_color = "{primary50}";
const $f551aa6589c293c2$var$avatar_base_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$avatar_variant_size_small_container_width = "{l}";
const $f551aa6589c293c2$var$avatar_variant_size_small_container_height = "{l}";
const $f551aa6589c293c2$var$avatar_variant_size_large_container_width = "{xxl}";
const $f551aa6589c293c2$var$avatar_variant_size_large_container_height = "{xxl}";
const $f551aa6589c293c2$var$avatar_variant_size_small_icon_size = "{m}";
const $f551aa6589c293c2$var$avatar_variant_size_large_icon_size = "{l}";
const $f551aa6589c293c2$var$avatar_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$avatar_variant_kind_image_jds_image_behavior_active_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$AvatarV2DefaultTokens = {
    avatar_base_container_width: $f551aa6589c293c2$var$avatar_base_container_width,
    avatar_base_container_height: $f551aa6589c293c2$var$avatar_base_container_height,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary60}",
    avatar_base_container_opacity: $f551aa6589c293c2$var$avatar_base_container_opacity,
    "avatar_base_container_behavior_active_background-color": "{primary30}",
    "avatar_base_container_behavior_focus_border-width": "{border_focus}",
    avatar_base_icon_size: $f551aa6589c293c2$var$avatar_base_icon_size,
    avatar_base_icon_color: $f551aa6589c293c2$var$avatar_base_icon_color,
    avatar_base_icon_behavior_hover_color: $f551aa6589c293c2$var$avatar_base_icon_behavior_hover_color,
    avatar_base_icon_behavior_active_color: $f551aa6589c293c2$var$avatar_base_icon_behavior_active_color,
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $f551aa6589c293c2$var$avatar_variant_size_small_container_width,
    avatar_variant_size_small_container_height: $f551aa6589c293c2$var$avatar_variant_size_small_container_height,
    avatar_variant_size_large_container_width: $f551aa6589c293c2$var$avatar_variant_size_large_container_width,
    avatar_variant_size_large_container_height: $f551aa6589c293c2$var$avatar_variant_size_large_container_height,
    "avatar_variant_size_xtra-large_container_width": "{custom_11}",
    "avatar_variant_size_xtra-large_container_height": "{custom_11}",
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    "avatar_variant_size_xtra-small_icon_size": "{base}",
    avatar_variant_size_small_icon_size: $f551aa6589c293c2$var$avatar_variant_size_small_icon_size,
    avatar_variant_size_large_icon_size: $f551aa6589c293c2$var$avatar_variant_size_large_icon_size,
    "avatar_variant_size_xtra-large_icon_size": "{xl}",
    "avatar_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    avatar_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$avatar_variant_disabled_true_container_opacity,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    avatar_variant_kind_image_jds_image_behavior_hover_opacity: $f551aa6589c293c2$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity,
    "avatar_variant_kind_image_container_behavior_hover_background-color": "{primaryBackground}",
    avatar_variant_kind_image_jds_image_behavior_active_opacity: $f551aa6589c293c2$var$avatar_variant_kind_image_jds_image_behavior_active_opacity,
    "avatar_variant_kind_image_container_behavior_active_background-color": "{primaryGrey80}"
};
const $f551aa6589c293c2$var$actionbutton_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$actionbutton_base_loader_color = "{primary50}";
const $f551aa6589c293c2$var$actionbutton_base_loader_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$actionbutton_base_loader_size = "{m}";
const $f551aa6589c293c2$var$actionbutton_variant_size_small_loader_size = "{m}";
const $f551aa6589c293c2$var$actionbutton_variant_size_large_loader_size = "{m}";
const $f551aa6589c293c2$var$actionbutton_variant_state_loading_jds_text_opacity = "{opacity.invisible}";
const $f551aa6589c293c2$var$actionbutton_combination_false_small_loader_size = "{base}";
const $f551aa6589c293c2$var$actionbutton_combination_false_large_loader_size = "{m}";
const $f551aa6589c293c2$var$actionbutton_combination_true_true_container_width = "{size.max}";
const $f551aa6589c293c2$var$ActionButtonTokens = {
    "actionbutton_base_container_background-color": "{global.transparent}",
    actionbutton_base_container_opacity: $f551aa6589c293c2$var$actionbutton_base_container_opacity,
    "actionbutton_base_container_flex-direction": "{flexDirection.stack}",
    "actionbutton_base_container_align-items": "{alignItems.center}",
    "actionbutton_base_container_justify-content": "{justifyContent.center}",
    "actionbutton_base_container_border-radius": "{pill}",
    "actionbutton_base_inner-container_background-color": "{primary50}",
    "actionbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "actionbutton_base_inner-container_align-items": "{alignItems.center}",
    "actionbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "actionbutton_base_inner-container_border-radius": "{pill}",
    "actionbutton_base_inner-container_padding-top": "{xs}",
    "actionbutton_base_inner-container_padding-right": "{base}",
    "actionbutton_base_inner-container_padding-bottom": "{xs}",
    "actionbutton_base_inner-container_padding-left": "{base}",
    "actionbutton_base_inner-container_gap": "{xs}",
    "actionbutton_base_inner-container_behavior_hover_background-color": "{primary30}",
    "actionbutton_base_inner-container_behavior_active_background-color": "{primary60}",
    "actionbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_base_inner-container_behavior_focus_border-color": "{primary60}",
    actionbutton_base_loader_color: $f551aa6589c293c2$var$actionbutton_base_loader_color,
    "actionbutton_base_loader_background-color": "{global.transparent}",
    "actionbutton_base_loader_track-color": "{primaryGrey40}",
    "actionbutton_base_loader_border-width": "{border_focus}",
    "actionbutton_base_inner-container_border-width": "{border_none}",
    actionbutton_base_loader_opacity: $f551aa6589c293c2$var$actionbutton_base_loader_opacity,
    actionbutton_base_loader_size: $f551aa6589c293c2$var$actionbutton_base_loader_size,
    "actionbutton_base_left-icon_size": "{m}",
    "actionbutton_base_left-icon_color": "{primaryInverse}",
    "actionbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_left-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_base_right-icon_size": "{m}",
    "actionbutton_base_right-icon_color": "{primaryInverse}",
    "actionbutton_base_right-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_right-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_variant_size_small_inner-container_padding-top": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-right": "{s}",
    "actionbutton_variant_size_small_inner-container_padding-bottom": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-left": "{s}",
    "actionbutton_variant_size_small_inner-container_gap": "{xxs}",
    "actionbutton_variant_size_small_left-icon_size": "{base}",
    "actionbutton_variant_size_small_right-icon_size": "{base}",
    actionbutton_variant_size_small_loader_size: $f551aa6589c293c2$var$actionbutton_variant_size_small_loader_size,
    "actionbutton_variant_size_large_inner-container_padding-top": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-left": "{m}",
    "actionbutton_variant_size_large_inner-container_padding-bottom": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-right": "{m}",
    "actionbutton_variant_size_large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_large_left-icon_size": "{m}",
    "actionbutton_variant_size_large_right-icon_size": "{m}",
    actionbutton_variant_size_large_loader_size: $f551aa6589c293c2$var$actionbutton_variant_size_large_loader_size,
    "actionbutton_variant_size_extra-large_inner-container_padding-top": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-right": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_padding-bottom": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-left": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_extra-large_left-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_right-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_loader_size": "{xxl}",
    "actionbutton_variant_state_loading_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_variant_state_loading_left-icon_opacity": "{opacity.invisible}",
    "actionbutton_variant_state_loading_right-icon_opacity": "{opacity.invisible}",
    actionbutton_variant_state_loading_jds_text_opacity: $f551aa6589c293c2$var$actionbutton_variant_state_loading_jds_text_opacity,
    "actionbutton_variant_state_disabled_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_base_inner-container_opacity": "{opacity.enabled}",
    "actionbutton_combination_normal_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_normal_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_secondary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-radius": "{custom_1}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_positive_primary_inner-container_background-color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_primary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_primary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_positive_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_secondary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_tertiary_inner-container_border-radius": "{custom_1}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_tertiary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_positive_tertiary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_negative_primary_inner-container_background-color": "{feedbackError50}",
    "actionbutton_combination_negative_primary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_primary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_negative_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_secondary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_tertiary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_contrast_primary_inner-container_background-color": "{primaryBackground}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_primary_left-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_contrast_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_secondary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_tertiary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_false_small_left-icon_size": "{base}",
    actionbutton_combination_false_small_loader_size: $f551aa6589c293c2$var$actionbutton_combination_false_small_loader_size,
    "actionbutton_combination_false_large_left-icon_size": "{m}",
    actionbutton_combination_false_large_loader_size: $f551aa6589c293c2$var$actionbutton_combination_false_large_loader_size,
    "actionbutton_combination_false_extra-large_left-icon_size": "{l}",
    "actionbutton_combination_false_extra-large_loader_size": "{l}",
    actionbutton_combination_true_true_container_width: $f551aa6589c293c2$var$actionbutton_combination_true_true_container_width,
    "actionbutton_combination_true_true_inner-container_width": "{size.max}"
};
const $f551aa6589c293c2$var$accordion_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$accordion_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$accordion_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$accordion_combination_plus_true_jds_button_icon = "ic_minus";
const $f551aa6589c293c2$var$accordion_combination_plus_false_jds_button_icon = "ic_add";
const $f551aa6589c293c2$var$accordion_combination_chevron_true_jds_button_icon = "ic_chevron_up";
const $f551aa6589c293c2$var$accordion_combination_chevron_false_jds_button_icon = "ic_chevron_down";
const $f551aa6589c293c2$var$AccordionTokens = {
    "accordion_base_container_flex-direction": "{flexDirection.column}",
    accordion_base_container_width: $f551aa6589c293c2$var$accordion_base_container_width,
    "accordion_base_accordion-header-container_flex-direction": "{flexDirection.row}",
    "accordion_base_accordion-header-container_align-items": "{alignItems.center}",
    "accordion_base_accordion-header-container_justify-content": "{justifyContent.start}",
    "accordion_base_accordion-header-container_width": "{size.max}",
    "accordion_base_accordion-header-container_padding-top": "{xxs}",
    "accordion_base_accordion-header-container_gap": "{s}",
    "accordion_base_text-container_flex-direction": "{flexDirection.column}",
    "accordion_base_text-container_justify-content": "{justifyContent.start}",
    "accordion_base_text-container_align-items": "{alignItems.start}",
    "accordion_base_text-container_gap": "{xxs}",
    "accordion_base_children-container_padding-top": "0",
    "accordion_base_children-container_width": "{size.max}",
    "accordion_base_child-content-container_width": "{size.max}",
    accordion_base_container_opacity: $f551aa6589c293c2$var$accordion_base_container_opacity,
    "accordion_variant_expandedPanel_true_children-container_padding-top": "{base}",
    accordion_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$accordion_variant_disabled_true_container_opacity,
    accordion_combination_plus_true_jds_button_icon: $f551aa6589c293c2$var$accordion_combination_plus_true_jds_button_icon,
    accordion_combination_plus_false_jds_button_icon: $f551aa6589c293c2$var$accordion_combination_plus_false_jds_button_icon,
    accordion_combination_chevron_true_jds_button_icon: $f551aa6589c293c2$var$accordion_combination_chevron_true_jds_button_icon,
    accordion_combination_chevron_false_jds_button_icon: $f551aa6589c293c2$var$accordion_combination_chevron_false_jds_button_icon
};
const $f551aa6589c293c2$var$badge_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$badge_base_icon_size = "{base}";
const $f551aa6589c293c2$var$badge_base_icon_color = "{sparkleGrey20}";
const $f551aa6589c293c2$var$badge_base_text_color = "{sparkleGrey20}";
const $f551aa6589c293c2$var$badge_variant_kind_service_container_gap = "{xs}";
const $f551aa6589c293c2$var$badge_variant_kind_service_text_color = "{global.white}";
const $f551aa6589c293c2$var$badge_variant_kind_service_icon_size = "{m}";
const $f551aa6589c293c2$var$badge_variant_kind_service_icon_color = "{custom_color_1}";
const $f551aa6589c293c2$var$badge_combination_normal_small_icon_size = "{s}";
const $f551aa6589c293c2$var$badge_combination_normal_large_container_gap = "{xs}";
const $f551aa6589c293c2$var$badge_combination_normal_large_icon_size = "{m}";
const $f551aa6589c293c2$var$BadgeTokens = {
    "badge_base_container_flex-direction": "{flexDirection.row}",
    "badge_base_container_justify-content": "{justifyContent.center}",
    "badge_base_container_align-items": "{alignItems.center}",
    "badge_base_container_padding-top": "{xxs}",
    "badge_base_container_padding-left": "{xs}",
    "badge_base_container_padding-right": "{xs}",
    "badge_base_container_padding-bottom": "{xxs}",
    badge_base_container_gap: $f551aa6589c293c2$var$badge_base_container_gap,
    "badge_base_container_background-color": "{sparkle60}",
    "badge_base_container_border-radius": "{medium}",
    badge_base_icon_size: $f551aa6589c293c2$var$badge_base_icon_size,
    badge_base_icon_color: $f551aa6589c293c2$var$badge_base_icon_color,
    "badge_base_icon_justify-content": "{justifyContent.start}",
    "badge_base_icon_align-items": "{alignItems.start}",
    "badge_base_text_font-family": "{bodySBold}",
    "badge_base_text_font-size": "{bodySBold}",
    "badge_base_text_line-height": "{bodySBold}",
    "badge_base_text_letter-spacing": "{bodySBold}",
    "badge_base_text_font-weight": "{bodySBold}",
    badge_base_text_color: $f551aa6589c293c2$var$badge_base_text_color,
    "badge_base_text_text-transform": "{text-case.uppercase}",
    "badge_variant_kind_service_container_border-radius": "{pill}",
    "badge_variant_kind_service_container_background-color": "{custom_color_2}",
    "badge_variant_kind_service_container_padding-top": "{xxs}",
    "badge_variant_kind_service_container_padding-left": "{xxs}",
    "badge_variant_kind_service_container_padding-right": "{s}",
    "badge_variant_kind_service_container_padding-bottom": "{xxs}",
    badge_variant_kind_service_container_gap: $f551aa6589c293c2$var$badge_variant_kind_service_container_gap,
    "badge_variant_kind_service_text_font-family": "{bodyMBold}",
    "badge_variant_kind_service_text_font-size": "{bodyMBold}",
    "badge_variant_kind_service_text_line-height": "{bodyMBold}",
    "badge_variant_kind_service_text_letter-spacing": "{bodyMBold}",
    "badge_variant_kind_service_text_font-weight": "{bodyMBold}",
    badge_variant_kind_service_text_color: $f551aa6589c293c2$var$badge_variant_kind_service_text_color,
    badge_variant_kind_service_icon_size: $f551aa6589c293c2$var$badge_variant_kind_service_icon_size,
    badge_variant_kind_service_icon_color: $f551aa6589c293c2$var$badge_variant_kind_service_icon_color,
    "badge_combination_normal_small_container_border-radius": "{small}",
    badge_combination_normal_small_icon_size: $f551aa6589c293c2$var$badge_combination_normal_small_icon_size,
    "badge_combination_normal_small_text_font-family": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-size": "{bodyXxsBold}",
    "badge_combination_normal_small_text_line-height": "{bodyXxsBold}",
    "badge_combination_normal_small_text_letter-spacing": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-weight": "{bodyXxsBold}",
    "badge_combination_normal_large_container_padding-left": "{s}",
    "badge_combination_normal_large_container_padding-right": "{s}",
    badge_combination_normal_large_container_gap: $f551aa6589c293c2$var$badge_combination_normal_large_container_gap,
    badge_combination_normal_large_icon_size: $f551aa6589c293c2$var$badge_combination_normal_large_icon_size,
    "badge_combination_normal_large_text_font-family": "{bodyLBold}",
    "badge_combination_normal_large_text_font-size": "{bodyLBold}",
    "badge_combination_normal_large_text_line-height": "{bodyLBold}",
    "badge_combination_normal_large_text_letter-spacing": "{bodyLBold}",
    "badge_combination_normal_large_text_font-weight": "{bodyLBold}"
};
const $f551aa6589c293c2$var$badgev2brand_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$badgev2brand_variant_kind_circle_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2brand_variant_kind_square_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2brand_combination_circle_medium_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2brand_combination_circle_large_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2brand_combination_square_medium_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2brand_combination_square_large_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$BadgeV2BrandTokens = {
    "badgev2brand_base_container_flex-direction": "{flexDirection.row}",
    "badgev2brand_base_container_justify-content": "{justifyContent.center}",
    "badgev2brand_base_container_align-items": "{alignItems.center}",
    "badgev2brand_base_container_background-color": "{primary50}",
    badgev2brand_base_container_gap: $f551aa6589c293c2$var$badgev2brand_base_container_gap,
    "badgev2brand_base_container_border-radius": "{pill}",
    "badgev2brand_base_container_padding-left": "{xs}",
    "badgev2brand_base_container_padding-right": "{s}",
    "badgev2brand_base_container_padding-top": "{xxs}",
    "badgev2brand_base_container_padding-bottom": "{xxs}",
    "badgev2brand_base_image-container_border-radius": "{pill}",
    "badgev2brand_base_image-container_size": "{custom_18}",
    "badgev2brand_variant_kind_square_image-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square_brand-jds_image_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_image-container_border-radius": "{small}",
    "badgev2brand_variant_size_medium_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-right": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-top": "{custom_5}",
    "badgev2brand_variant_size_medium_container_padding-bottom": "{custom_5}",
    "badgev2brand_variant_size_medium_image-container_size": "{s}",
    "badgev2brand_variant_size_large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_large_image-container_size": "{s}",
    "badgev2brand_variant_size_xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_image-container_size": "{base}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-top": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-bottom": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_variant_emphasis_bold_container_background-color": "{primary60}",
    badgev2brand_variant_kind_circle_container_padding: $f551aa6589c293c2$var$badgev2brand_variant_kind_circle_container_padding,
    badgev2brand_variant_kind_square_container_padding: $f551aa6589c293c2$var$badgev2brand_variant_kind_square_container_padding,
    badgev2brand_combination_circle_medium_container_padding: $f551aa6589c293c2$var$badgev2brand_combination_circle_medium_container_padding,
    "badgev2brand_combination_circle_medium_image-container_size": "{base}",
    badgev2brand_combination_circle_large_container_padding: $f551aa6589c293c2$var$badgev2brand_combination_circle_large_container_padding,
    "badgev2brand_combination_circle_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_circle_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square_medium_container_border-radius": "{small}",
    badgev2brand_combination_square_medium_container_padding: $f551aa6589c293c2$var$badgev2brand_combination_square_medium_container_padding,
    "badgev2brand_combination_square_medium_image-container_size": "{base}",
    "badgev2brand_combination_square_medium_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_large_container_border-radius": "{small}",
    badgev2brand_combination_square_large_container_padding: $f551aa6589c293c2$var$badgev2brand_combination_square_large_container_padding,
    "badgev2brand_combination_square_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_square_large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_square_xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_square_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_image-container_border-radius": "{medium}",
    "badgev2brand_combination_square-label_medium_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_image-container_size": "{base}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}"
};
const $f551aa6589c293c2$var$badgev2information_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$badgev2information_base_icon_color = "{primaryBackground}";
const $f551aa6589c293c2$var$badgev2information_base_icon_size = "{base}";
const $f551aa6589c293c2$var$badgev2information_variant_color_secondary_icon_color = "{primaryBackground}";
const $f551aa6589c293c2$var$badgev2information_variant_size_small_icon_size = "{s}";
const $f551aa6589c293c2$var$badgev2information_variant_size_medium_icon_size = "{s}";
const $f551aa6589c293c2$var$badgev2information_variant_border_true_container_padding = "{custom_16}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_small_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_small_icon_size = "{s}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_medium_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_medium_icon_size = "{base}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_large_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_large_icon_size = "{custom_18}";
const $f551aa6589c293c2$var$badgev2information_combination_label_small_container_size = "{base}";
const $f551aa6589c293c2$var$badgev2information_combination_label_medium_container_size = "{base}";
const $f551aa6589c293c2$var$badgev2information_combination_label_large_container_size = "{custom_18}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_default_icon_color = "{sparkle60}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_positive_icon_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_warning_icon_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_negative_icon_color = "{feedbackError50}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_neutral_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_default_icon_color = "{sparkle60}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_positive_icon_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_warning_icon_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_negative_icon_color = "{feedbackError50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_neutral_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_default_icon_color = "{sparkle60}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_positive_icon_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_warning_icon_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_negative_icon_color = "{feedbackError50}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_neutral_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$badgev2information_combination_true_small_container_padding = "{custom_4}";
const $f551aa6589c293c2$var$badgev2information_combination_true_medium_container_padding = "{custom_4}";
const $f551aa6589c293c2$var$badgev2information_combination_true_large_container_padding = "{custom_16}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_secondary_icon_color = "{secondary60}";
const $f551aa6589c293c2$var$badgev2information_combination_icon_bold_secondary_icon_color = "{secondary60}";
const $f551aa6589c293c2$var$badgev2information_combination_subtle_secondary_icon_color = "{secondary60}";
const $f551aa6589c293c2$var$badgev2information_combination_true_icon_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$BadgeV2InformationTokens = {
    "badgev2information_base_outer-container_border-radius": "{small}",
    "badgev2information_base_outer-container_align-items": "{alignItems.center}",
    "badgev2information_base_container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_container_justify-content": "{justifyContent.center}",
    "badgev2information_base_container_align-items": "{alignItems.center}",
    "badgev2information_base_container_background-color": "{sparkle60}",
    badgev2information_base_container_gap: $f551aa6589c293c2$var$badgev2information_base_container_gap,
    "badgev2information_base_container_border-radius": "{small}",
    "badgev2information_base_container_padding-left": "{xxs}",
    "badgev2information_base_container_padding-right": "{xs}",
    "badgev2information_base_container_padding-top": "{custom_4}",
    "badgev2information_base_container_padding-bottom": "{custom_4}",
    "badgev2information_base_icon-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_icon-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_icon-container_align-items": "{alignItems.center}",
    "badgev2information_base_icon-container_size": "{base}",
    badgev2information_base_icon_color: $f551aa6589c293c2$var$badgev2information_base_icon_color,
    badgev2information_base_icon_size: $f551aa6589c293c2$var$badgev2information_base_icon_size,
    "badgev2information_base_image-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_image-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_image-container_align-items": "{alignItems.center}",
    "badgev2information_base_image-container_size": "{base}",
    "badgev2information_variant_color_secondary_container_background-color": "{secondary60}",
    "badgev2information_variant_color_secondary_icon-container_background-color": "{secondary60}",
    badgev2information_variant_color_secondary_icon_color: $f551aa6589c293c2$var$badgev2information_variant_color_secondary_icon_color,
    "badgev2information_variant_size_xtra-small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_xtra-small_icon-container_size": "{s}",
    "badgev2information_variant_size_xtra-small_icon_size": "{s}",
    "badgev2information_variant_size_xtra-small_image-container_size": "{s}",
    "badgev2information_variant_size_small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_small_icon-container_size": "{s}",
    badgev2information_variant_size_small_icon_size: $f551aa6589c293c2$var$badgev2information_variant_size_small_icon_size,
    "badgev2information_variant_size_small_image-container_size": "{s}",
    "badgev2information_variant_size_medium_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_medium_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_medium_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_medium_icon-container_size": "{s}",
    badgev2information_variant_size_medium_icon_size: $f551aa6589c293c2$var$badgev2information_variant_size_medium_icon_size,
    "badgev2information_variant_size_medium_image-container_size": "{s}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-right": "{s}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2information_variant_color_positive_container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_positive_icon-container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_warning_container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_warning_icon-container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_negative_container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_negative_icon-container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_neutral_container_background-color": "{primaryGrey80}",
    "badgev2information_variant_color_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_variant_border_true_container_padding: $f551aa6589c293c2$var$badgev2information_variant_border_true_container_padding,
    "badgev2information_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2information_combination_icon_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-small_icon-container_size": "{xs}",
    "badgev2information_combination_icon_xtra-small_icon_size": "{xs}",
    badgev2information_combination_icon_small_container_padding: $f551aa6589c293c2$var$badgev2information_combination_icon_small_container_padding,
    "badgev2information_combination_icon_small_icon-container_size": "{s}",
    badgev2information_combination_icon_small_icon_size: $f551aa6589c293c2$var$badgev2information_combination_icon_small_icon_size,
    badgev2information_combination_icon_medium_container_padding: $f551aa6589c293c2$var$badgev2information_combination_icon_medium_container_padding,
    "badgev2information_combination_icon_medium_icon-container_size": "{base}",
    badgev2information_combination_icon_medium_icon_size: $f551aa6589c293c2$var$badgev2information_combination_icon_medium_icon_size,
    badgev2information_combination_icon_large_container_padding: $f551aa6589c293c2$var$badgev2information_combination_icon_large_container_padding,
    "badgev2information_combination_icon_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_large_icon-container_size": "{custom_18}",
    badgev2information_combination_icon_large_icon_size: $f551aa6589c293c2$var$badgev2information_combination_icon_large_icon_size,
    "badgev2information_combination_icon_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon_xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_medium_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-circle_medium_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-circle_large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-circle_large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_icon_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon-square_xtra-small_outer-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_medium_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-square_medium_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-square_large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-square_large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_icon_size": "{s}",
    "badgev2information_combination_icon-square_xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_label_xtra-small_container_size": "{base}",
    badgev2information_combination_label_small_container_size: $f551aa6589c293c2$var$badgev2information_combination_label_small_container_size,
    badgev2information_combination_label_medium_container_size: $f551aa6589c293c2$var$badgev2information_combination_label_medium_container_size,
    badgev2information_combination_label_large_container_size: $f551aa6589c293c2$var$badgev2information_combination_label_large_container_size,
    "badgev2information_combination_label_large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-large_container_size": "{m}",
    "badgev2information_combination_label_xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{s}",
    "badgev2information_combination_label-icon_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-icon_small_container_size": "{base}",
    "badgev2information_combination_label-icon_medium_container_size": "{base}",
    "badgev2information_combination_label-icon_large_container_size": "{custom_18}",
    "badgev2information_combination_label-icon_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-icon_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label-image_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-image_small_container_size": "{base}",
    "badgev2information_combination_label-image_medium_container_size": "{base}",
    "badgev2information_combination_label-image_large_container_size": "{custom_18}",
    "badgev2information_combination_label-image_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-image_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_subtle_default_container_background-color": "{sparkle20}",
    "badgev2information_combination_subtle_default_icon-container_background-color": "{sparkle20}",
    badgev2information_combination_subtle_default_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_default_icon_color,
    "badgev2information_combination_subtle_positive_container_background-color": "{feedbackSuccess20}",
    "badgev2information_combination_subtle_positive_icon-container_background-color": "{feedbackSuccess20}",
    badgev2information_combination_subtle_positive_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_positive_icon_color,
    "badgev2information_combination_subtle_warning_container_background-color": "{feedbackWarning20}",
    "badgev2information_combination_subtle_warning_icon-container_background-color": "{feedbackWarning20}",
    badgev2information_combination_subtle_warning_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_warning_icon_color,
    "badgev2information_combination_subtle_negative_container_background-color": "{feedbackError20}",
    "badgev2information_combination_subtle_negative_icon-container_background-color": "{feedbackError20}",
    badgev2information_combination_subtle_negative_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_negative_icon_color,
    "badgev2information_combination_subtle_neutral_container_background-color": "{primaryGrey20}",
    "badgev2information_combination_subtle_neutral_icon-container_background-color": "{primaryGrey20}",
    badgev2information_combination_subtle_neutral_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_neutral_icon_color,
    "badgev2information_combination_icon_bold_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_default_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_default_icon_color,
    "badgev2information_combination_icon_bold_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_positive_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_positive_icon_color,
    "badgev2information_combination_icon_bold_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_warning_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_warning_icon_color,
    "badgev2information_combination_icon_bold_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_negative_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_negative_icon_color,
    "badgev2information_combination_icon_bold_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_neutral_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_neutral_icon_color,
    "badgev2information_combination_icon_subtle_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_default_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_default_icon_color,
    "badgev2information_combination_icon_subtle_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_positive_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_positive_icon_color,
    "badgev2information_combination_icon_subtle_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_warning_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_warning_icon_color,
    "badgev2information_combination_icon_subtle_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_negative_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_negative_icon_color,
    "badgev2information_combination_icon_subtle_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_neutral_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_neutral_icon_color,
    "badgev2information_combination_true_xtra-small_container_padding": "{custom_4}",
    badgev2information_combination_true_small_container_padding: $f551aa6589c293c2$var$badgev2information_combination_true_small_container_padding,
    badgev2information_combination_true_medium_container_padding: $f551aa6589c293c2$var$badgev2information_combination_true_medium_container_padding,
    badgev2information_combination_true_large_container_padding: $f551aa6589c293c2$var$badgev2information_combination_true_large_container_padding,
    "badgev2information_combination_true_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    "badgev2information_combination_true_icon-circle_large_container_padding": "{custom_4}",
    "badgev2information_combination_true_icon-square_large_container_padding": "{custom_4}",
    "badgev2information_combination_icon_subtle_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_secondary_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_secondary_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_subtle_secondary_icon_color,
    "badgev2information_combination_icon_bold_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_secondary_icon-container_background-color": "{global.tansparent}",
    badgev2information_combination_icon_bold_secondary_icon_color: $f551aa6589c293c2$var$badgev2information_combination_icon_bold_secondary_icon_color,
    "badgev2information_combination_subtle_secondary_container_background-color": "{secondary20}",
    "badgev2information_combination_subtle_secondary_icon-container_background-color": "{secondary20}",
    badgev2information_combination_subtle_secondary_icon_color: $f551aa6589c293c2$var$badgev2information_combination_subtle_secondary_icon_color,
    "badgev2information_combination_true_icon_container_border-color": "{global.transparent}",
    badgev2information_combination_true_icon_container_padding: $f551aa6589c293c2$var$badgev2information_combination_true_icon_container_padding
};
const $f551aa6589c293c2$var$badgev2notification_base_container_width = "{xs}";
const $f551aa6589c293c2$var$badgev2notification_base_container_height = "{xs}";
const $f551aa6589c293c2$var$badgev2notification_base_container_padding = "{custom_5}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_padding = "{custom_4}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_width = "{s}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_height = "{s}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_width = "{base}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_height = "{base}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_padding = "{custom_4}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_width = "{custom_18}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_height = "{custom_18}";
const $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_padding = "{custom_4}";
const $f551aa6589c293c2$var$badgev2notification_variant_border_true_container_padding = "{custom_1}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_small_container_width = "{base}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_small_container_height = "{base}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_medium_container_width = "{base}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_medium_container_height = "{base}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_large_container_width = "{custom_18}";
const $f551aa6589c293c2$var$badgev2notification_combination_number_large_container_height = "{custom_18}";
const $f551aa6589c293c2$var$BadgeV2NotificationTokens = {
    "badgev2notification_base_container_flex-direction": "{flexDirection.row}",
    "badgev2notification_base_container_justify-content": "{justifyContent.center}",
    "badgev2notification_base_container_align-items": "{alignItems.center}",
    badgev2notification_base_container_width: $f551aa6589c293c2$var$badgev2notification_base_container_width,
    badgev2notification_base_container_height: $f551aa6589c293c2$var$badgev2notification_base_container_height,
    "badgev2notification_base_container_background-color": "{feedbackError50}",
    "badgev2notification_base_container_border-radius": "{pill}",
    badgev2notification_base_container_padding: $f551aa6589c293c2$var$badgev2notification_base_container_padding,
    "badgev2notification_base_container_border-color": "{global.transparent}",
    "badgev2notification_variant_border_true_container_border-color": "{primaryBackground}",
    badgev2notification_variant_size_small_container_padding: $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_padding,
    badgev2notification_variant_size_small_container_width: $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_width,
    badgev2notification_variant_size_small_container_height: $f551aa6589c293c2$var$badgev2notification_variant_size_small_container_height,
    badgev2notification_variant_size_medium_container_width: $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_width,
    badgev2notification_variant_size_medium_container_height: $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_height,
    badgev2notification_variant_size_medium_container_padding: $f551aa6589c293c2$var$badgev2notification_variant_size_medium_container_padding,
    badgev2notification_variant_size_large_container_width: $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_width,
    badgev2notification_variant_size_large_container_height: $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_height,
    badgev2notification_variant_size_large_container_padding: $f551aa6589c293c2$var$badgev2notification_variant_size_large_container_padding,
    "badgev2notification_variant_size_xtra-large_container_width": "{m}",
    "badgev2notification_variant_size_xtra-large_container_height": "{m}",
    "badgev2notification_variant_size_xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    badgev2notification_variant_border_true_container_padding: $f551aa6589c293c2$var$badgev2notification_variant_border_true_container_padding,
    "badgev2notification_combination_number_xtra-small_container_width": "{base}",
    "badgev2notification_combination_number_xtra-small_container_height": "{base}",
    badgev2notification_combination_number_small_container_width: $f551aa6589c293c2$var$badgev2notification_combination_number_small_container_width,
    badgev2notification_combination_number_small_container_height: $f551aa6589c293c2$var$badgev2notification_combination_number_small_container_height,
    badgev2notification_combination_number_medium_container_width: $f551aa6589c293c2$var$badgev2notification_combination_number_medium_container_width,
    badgev2notification_combination_number_medium_container_height: $f551aa6589c293c2$var$badgev2notification_combination_number_medium_container_height,
    badgev2notification_combination_number_large_container_width: $f551aa6589c293c2$var$badgev2notification_combination_number_large_container_width,
    badgev2notification_combination_number_large_container_height: $f551aa6589c293c2$var$badgev2notification_combination_number_large_container_height,
    "badgev2notification_combination_number_xtra-large_container_width": "{m}",
    "badgev2notification_combination_number_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_xtra-small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_height": "{base}",
    "badgev2notification_combination_number-symbol_medium_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_medium_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_large_container_height": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number-symbol_xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_true_number_xtra-small_container_padding": "{custom_4}"
};
const $f551aa6589c293c2$var$badgev2status_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$BadgeV2StatusTokens = {
    "badgev2status_base_container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_container_justify-content": "{justifyContent.center}",
    "badgev2status_base_container_align-items": "{alignItems.center}",
    badgev2status_base_container_gap: $f551aa6589c293c2$var$badgev2status_base_container_gap,
    "badgev2status_base_status-container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_status-container_justify-content": "{justifyContent.center}",
    "badgev2status_base_status-container_align-items": "{alignItems.center}",
    "badgev2status_base_status-container_size": "{m}",
    "badgev2status_base_status-container_border-radius": "{pill}",
    "badgev2status_base_status-container_background-color": "{feedbackSuccess50}",
    "badgev2status_base_status-icon_color": "{global.white}",
    "badgev2status_base_status-icon_size": "{base}",
    "badgev2status_variant_kind_dot_status-container_size": "{s}",
    "badgev2status_variant_kind_dot-label_status-container_size": "{s}",
    "badgev2status_variant_kind_label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_dot-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_status-container_size": "{s}",
    "badgev2status_variant_kind_icon-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_icon-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_icon-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_size_xtra-small_status-container_size": "{base}",
    "badgev2status_variant_size_xtra-small_status-icon_size": "{s}",
    "badgev2status_variant_size_medium_status-container_size": "{l}",
    "badgev2status_variant_size_medium_status-icon_size": "{m}",
    "badgev2status_variant_size_large_status-container_size": "{xl}",
    "badgev2status_variant_size_large_status-icon_size": "{custom_3}",
    "badgev2status_variant_status_error_status-container_background-color": "{feedbackError50}",
    "badgev2status_variant_status_warning_status-container_background-color": "{feedbackWarning50}",
    "badgev2status_variant_status_disabled_status-container_background-color": "{primaryGrey60}",
    "badgev2status_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2status_variant_border_true_status-container_border-color": "{primaryBackground}",
    "badgev2status_combination_dot_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot_medium_status-container_size": "{base}",
    "badgev2status_combination_dot_large_status-container_size": "{m}",
    "badgev2status_combination_dot_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_dot-label_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label_medium_status-container_size": "{m}",
    "badgev2status_combination_icon-label_medium_status-icon_size": "{base}",
    "badgev2status_combination_icon-label_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label-container_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_icon-label-container_medium_status-icon_size": "{s}",
    "badgev2status_combination_icon-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label-container_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_dot-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_dot-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_dot-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_status-icon_color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_error_status-icon_color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_warning_status-icon_color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_icon-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_disabled_status-icon_color": "{primaryGrey60}",
    "badgev2status_combination_true_dot_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_medium_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_large_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-large_container_border-width": "{border_thick}"
};
const $f551aa6589c293c2$var$breadcrumbs_base_container_height = "{m}";
const $f551aa6589c293c2$var$BreadcrumbsTokens = {
    "breadcrumbs_base_container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_container_align-items": "{alignItems.start}",
    breadcrumbs_base_container_height: $f551aa6589c293c2$var$breadcrumbs_base_container_height,
    "breadcrumbs_base_link-container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_link-container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_link-container_align-items": "{alignItems.start}"
};
const $f551aa6589c293c2$var$MobileBottomSheetTokens = {
    "mobilebottomsheet_base_popup-container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheet_base_popup-container_justify-content": "{justifyContent.center}",
    "mobilebottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "mobilebottomsheet_base_popup-container_size": "{size.max}",
    "mobilebottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "mobilebottomsheet_base_popup-container_opacity": "{opacity.invisible}",
    "mobilebottomsheet_base_popup-container_transition_duration": "{medium}",
    "mobilebottomsheet_base_popup-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheet_variant_kind_passive_popup_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "mobilebottomsheet_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $f551aa6589c293c2$var$mobilebottomsheetinternal_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$MobileBottomSheetInternalTokens = {
    "mobilebottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_container_align-items": "{alignItems.end}",
    mobilebottomsheetinternal_base_container_width: $f551aa6589c293c2$var$mobilebottomsheetinternal_base_container_width,
    "mobilebottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "mobilebottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "mobilebottomsheetinternal_base_cancel-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "mobilebottomsheetinternal_base_cancel-container_gap": "{s}",
    "mobilebottomsheetinternal_base_back-container_flex": 1,
    "mobilebottomsheetinternal_base_empty-container_flex": 1,
    "mobilebottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "mobilebottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "mobilebottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_cta-container_gap": "{base}",
    "mobilebottomsheetinternal_base_cta-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_custom-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_custom-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_x": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_y": 4,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_blur": 24,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_spread": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "mobilebottomsheetinternal_variant_close_false_root-container_translate-y": 0,
    "mobilebottomsheetinternal_variant__noButton_true_root-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_combination_false_true_custom-container_translate-y": 0,
    "mobilebottomsheetinternal_combination_false_true_root-container_translate-y": "{size.max}"
};
const $f551aa6589c293c2$var$DesktopBottomSheetInternalTokens = {
    "desktopbottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "desktopbottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_custom-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_root-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheetinternal_base_popup-container_size": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheetinternal_base_cancel-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheetinternal_base_cancel-container_gap": "{s}",
    "desktopbottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_cta-container_gap": "{base}",
    "desktopbottomsheetinternal_base_cta-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "desktopbottomsheetinternal_base_popup-container_padding-right": "{bottomsheet_padding_right}",
    "desktopbottomsheetinternal_base_popup-container_opacity": "{opacity.invisible}",
    "desktopbottomsheetinternal_base_popup-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_variant_kind_passive_popup_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $f551aa6589c293c2$var$DesktopBottomSheetTokens = {
    "desktopbottomsheet_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheet_base_popup-container_size": "{size.max}",
    "desktopbottomsheet_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheet_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheet_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheet_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheet_base_cancel-container_width": "{size.max}",
    "desktopbottomsheet_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheet_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheet_base_cancel-container_gap": "{s}",
    "desktopbottomsheet_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheet_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheet_base_vertical-container_width": "{size.max}",
    "desktopbottomsheet_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheet_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_cta-container_gap": "{base}",
    "desktopbottomsheet_base_cta-container_width": "{size.max}",
    "desktopbottomsheet_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_padding-top": "{m}",
    "desktopbottomsheet_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheet_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}"
};
const $f551aa6589c293c2$var$carousel_base_container_gap = "{base}";
const $f551aa6589c293c2$var$carousel_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$carousel_variant_density_condensed_container_gap = "{xs}";
const $f551aa6589c293c2$var$CarouselTokens = {
    "carousel_base_container_flex-direction": "{flexDirection.column}",
    "carousel_base_container_justify-content": "{justifyContent.center}",
    "carousel_base_container_align-items": "{alignItems.center}",
    carousel_base_container_gap: $f551aa6589c293c2$var$carousel_base_container_gap,
    carousel_base_container_width: $f551aa6589c293c2$var$carousel_base_container_width,
    "carousel_base_slider-container_width": "{size.max}",
    "carousel_base_control-container_flex-direction": "{flexDirection.row}",
    "carousel_base_control-container_justify-content": "{justifyContent.spaceBetween}",
    "carousel_base_control-container_align-items": "{alignItems.center}",
    "carousel_base_control-container_gap": "{base}",
    "carousel_base_control-container_width": "{size.max}",
    "carousel_base_left-container_max-width": "{size.max}",
    "carousel_base_left-container_flex-direction": "{flexDirection.row}",
    "carousel_base_left-container_justify-content": "{justifyContent.start}",
    "carousel_base_left-container_align-items": "{alignItems.center}",
    "carousel_base_left-container_gap": "{base}",
    "carousel_base_left-container_padding-top": "{xs}",
    "carousel_base_left-container_padding-bottom": "{xs}",
    "carousel_base_prefix-container_flex-direction": "{flexDirection.column}",
    "carousel_base_prefix-container_justify-content": "{justifyContent.center}",
    "carousel_base_prefix-container_align-items": "{alignItems.start}",
    "carousel_base_progress-container_flex-direction": "{flexDirection.stack}",
    "carousel_base_progress-container_justify-content": "{justifyContent.center}",
    "carousel_base_progress-container_align-items": "{alignItems.center}",
    "carousel_base_inner-container_flex-direction": "{flexDirection.row}",
    "carousel_base_inner-container_justify-content": "{justifyContent.start}",
    "carousel_base_inner-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_max-width": "{size.max}",
    "carousel_base_right-container_flex-direction": "{flexDirection.row}",
    "carousel_base_right-container_justify-content": "{justifyContent.end}",
    "carousel_base_right-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_gap": "{s}",
    "carousel_base_right-container_padding-top": "{xs}",
    "carousel_base_right-container_padding-bottom": "{xs}",
    carousel_variant_density_condensed_container_gap: $f551aa6589c293c2$var$carousel_variant_density_condensed_container_gap
};
const $f551aa6589c293c2$var$carouselpaginationitem_base_container_width = "{s}";
const $f551aa6589c293c2$var$carouselpaginationitem_base_container_height = "{s}";
const $f551aa6589c293c2$var$carouselpaginationitem_base_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$carouselpaginationitem_base_container_behavior_hover_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$carouselpaginationitem_base_container_behavior_active_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$carouselpaginationitem_variant_density_condensed_container_height = "{xs}";
const $f551aa6589c293c2$var$carouselpaginationitem_variant_active_true_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_normal_container_width = "{s}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width = "{xs}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height = "{xs}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width = "{custom_15}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height = "{custom_15}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_normal_container_width = "{xs}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width = "{custom_15}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height = "{custom_15}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width = "{xxs}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height = "{xxs}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_normal_container_width = "{m}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width = "{m}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width = "{m}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_normal_container_width = "{l}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width = "{l}";
const $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width = "{l}";
const $f551aa6589c293c2$var$CarouselPaginationItemTokens = {
    carouselpaginationitem_base_container_width: $f551aa6589c293c2$var$carouselpaginationitem_base_container_width,
    carouselpaginationitem_base_container_height: $f551aa6589c293c2$var$carouselpaginationitem_base_container_height,
    "carouselpaginationitem_base_container_background-color": "{primary60}",
    carouselpaginationitem_base_container_opacity: $f551aa6589c293c2$var$carouselpaginationitem_base_container_opacity,
    "carouselpaginationitem_base_container_border-radius": "{pill}",
    "carouselpaginationitem_base_container_behavior_hover_background-color": "{primary40}",
    carouselpaginationitem_base_container_behavior_hover_opacity: $f551aa6589c293c2$var$carouselpaginationitem_base_container_behavior_hover_opacity,
    "carouselpaginationitem_base_container_behavior_active_background-color": "{primary60}",
    carouselpaginationitem_base_container_behavior_active_opacity: $f551aa6589c293c2$var$carouselpaginationitem_base_container_behavior_active_opacity,
    carouselpaginationitem_variant_density_condensed_container_height: $f551aa6589c293c2$var$carouselpaginationitem_variant_density_condensed_container_height,
    carouselpaginationitem_variant_active_true_container_opacity: $f551aa6589c293c2$var$carouselpaginationitem_variant_active_true_container_opacity,
    "carouselpaginationitem_variant_active_true_container_behavior_hover_background-color": "{primary70}",
    "carouselpaginationitem_variant_active_true_container_behavior_active_background-color": "{primary70}",
    carouselpaginationitem_combination_relaxed_false_normal_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_normal_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_false_normal_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_normal_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_true_normal_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_normal_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_true_normal_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_normal_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width: $f551aa6589c293c2$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width
};
const $f551aa6589c293c2$var$carouselpagination_base_container_gap = "{s}";
const $f551aa6589c293c2$var$carouselpagination_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$carouselpagination_variant_density_condensed_container_gap = "{xs}";
const $f551aa6589c293c2$var$CarouselPaginationTokens = {
    "carouselpagination_base_container_flex-direction": "{flexDirection.row}",
    "carouselpagination_base_container_justify-content": "{justifyContent.center}",
    "carouselpagination_base_container_align-items": "{alignItems.center}",
    carouselpagination_base_container_gap: $f551aa6589c293c2$var$carouselpagination_base_container_gap,
    "carouselpagination_base_container_padding-top": "{xs}",
    carouselpagination_base_container_width: $f551aa6589c293c2$var$carouselpagination_base_container_width,
    "carouselpagination_base_container_padding-bottom": "{xs}",
    carouselpagination_variant_density_condensed_container_gap: $f551aa6589c293c2$var$carouselpagination_variant_density_condensed_container_gap
};
const $f551aa6589c293c2$var$button_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$button_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$button_base_loader_color = "{primaryInverse}";
const $f551aa6589c293c2$var$button_base_loader_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$button_base_loader_size = "{base}";
const $f551aa6589c293c2$var$button_variant_fullWidth_true_container_width = "{size.max}";
const $f551aa6589c293c2$var$button_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$button_combination_primary_destructive_loader_color = "{feedbackError80}";
const $f551aa6589c293c2$var$button_combination_primary_positive_loader_color = "{feedbackSuccess80}";
const $f551aa6589c293c2$var$button_combination_secondary_normal_loader_color = "{primary60}";
const $f551aa6589c293c2$var$button_combination_secondary_destructive_loader_color = "{feedbackError80}";
const $f551aa6589c293c2$var$button_combination_secondary_positive_loader_color = "{feedbackSuccess80}";
const $f551aa6589c293c2$var$button_combination_tertiary_normal_loader_color = "{primary60}";
const $f551aa6589c293c2$var$button_combination_tertiary_destructive_loader_color = "{feedbackError80}";
const $f551aa6589c293c2$var$button_combination_tertiary_positive_loader_color = "{feedbackSuccess80}";
const $f551aa6589c293c2$var$button_combination_true_small_loader_size = "{base}";
const $f551aa6589c293c2$var$button_combination_true_medium_loader_size = "{m}";
const $f551aa6589c293c2$var$button_combination_true_large_loader_size = "{m}";
const $f551aa6589c293c2$var$button_combination_false_small_loader_size = "{base}";
const $f551aa6589c293c2$var$button_combination_false_medium_loader_size = "{m}";
const $f551aa6589c293c2$var$button_combination_false_large_loader_size = "{m}";
const $f551aa6589c293c2$var$ButtonTokens = {
    button_base_container_opacity: $f551aa6589c293c2$var$button_base_container_opacity,
    "button_base_container_background-color": "{primary50}",
    "button_base_container_flex-direction": "{flexDirection.row}",
    "button_base_container_align-items": "{alignItems.center}",
    "button_base_container_justify-content": "{justifyContent.center}",
    "button_base_container_border-radius": "{pill}",
    "button_base_container_border-width": "0",
    "button_base_container_border-color": "",
    button_base_container_gap: $f551aa6589c293c2$var$button_base_container_gap,
    "button_combination_tertiary_normal_container_border-width": 0,
    "button_base_container_behavior_hover_background-color": "{primary60}",
    "button_base_container_behavior_active_background-color": "{primary60}",
    "button_base_container_behavior_focus_border-width": "{border_focus}",
    "button_base_container_behavior_focus_border-color": "{primary80}",
    "button_base_left-container_flex-direction": "{flexDirection.row}",
    "button_base_left-container_align-items": "{alignItems.center}",
    "button_base_left-container_justify-content": "{justifyContent.start}",
    "button_base_left-container_gap": "{xs}",
    button_base_loader_color: $f551aa6589c293c2$var$button_base_loader_color,
    "button_base_loader_background-color": "{global.transparent}",
    "button_base_loader_border-width": "{border_focus}",
    button_base_loader_opacity: $f551aa6589c293c2$var$button_base_loader_opacity,
    button_base_loader_size: $f551aa6589c293c2$var$button_base_loader_size,
    "button_base_left-icon_size": "{m}",
    "button_base_left-icon_color": "{primaryInverse}",
    "button_base_right-icon_size": "{m}",
    "button_base_right-icon_color": "{primaryInverse}",
    button_variant_fullWidth_true_container_width: $f551aa6589c293c2$var$button_variant_fullWidth_true_container_width,
    "button_variant_fullWidth_true_container_justify-content": "{justifyContent.spaceBetween}",
    button_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$button_variant_disabled_true_container_opacity,
    "button_combination_primary_normal_left-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_normal_right-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_destructive_container_background-color": "{feedbackError20}",
    "button_combination_primary_destructive_container_behavior_hover_background-color": "{feedbackError50}",
    "button_combination_primary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_primary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    button_combination_primary_destructive_loader_color: $f551aa6589c293c2$var$button_combination_primary_destructive_loader_color,
    "button_combination_primary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_left-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_destructive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_right-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_positive_container_background-color": "{feedbackSuccess20}",
    "button_combination_primary_positive_container_behavior_hover_background-color": "{feedbackSuccess50}",
    "button_combination_primary_positive_container_behavior_active_background-color": "{feedbackSuccess80}",
    "button_combination_primary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    button_combination_primary_positive_loader_color: $f551aa6589c293c2$var$button_combination_primary_positive_loader_color,
    "button_combination_primary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_left-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_primary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_right-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_secondary_normal_container_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_border-width": "{border_thin}",
    "button_combination_secondary_normal_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_normal_container_behavior_hover_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_hover_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_behavior_active_background-color": "{primary20}",
    "button_combination_secondary_normal_container_behavior_active_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_focus_border-color": "{primary80}",
    button_combination_secondary_normal_loader_color: $f551aa6589c293c2$var$button_combination_secondary_normal_loader_color,
    "button_combination_secondary_normal_left-icon_color": "{primary60}",
    "button_combination_secondary_normal_right-icon_color": "{primary60}",
    "button_combination_secondary_destructive_container_background-color": "{global.transparent}",
    "button_combination_secondary_destructive_container_border-width": "{border_thin}",
    "button_combination_secondary_destructive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_destructive_container_behavior_active_background-color": "{feedbackError20}",
    "button_combination_secondary_destructive_container_behavior_active_border-color": "{feedbackError80}",
    "button_combination_secondary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_secondary_destructive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_destructive_loader_color: $f551aa6589c293c2$var$button_combination_secondary_destructive_loader_color,
    "button_combination_secondary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_secondary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_secondary_positive_container_background-color": "{global.transparent}",
    "button_combination_secondary_positive_container_border-width": "{border_thin}",
    "button_combination_secondary_positive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_secondary_positive_container_behavior_active_border-color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_secondary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_positive_loader_color: $f551aa6589c293c2$var$button_combination_secondary_positive_loader_color,
    "button_combination_secondary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_normal_container_background-color": "{global.transparent}",
    "button_combination_tertiary_normal_container_behavior_hover_background-color": "{primary20}",
    "button_combination_tertiary_normal_container_behavior_active_background-color": "{primary30}",
    "button_combination_tertiary_normal_container_behavior_focus_border-color": "{primary80}",
    "button_combination_tertiary_normal_container_behavior_focus_background-color": "{primary20}",
    button_combination_tertiary_normal_loader_color: $f551aa6589c293c2$var$button_combination_tertiary_normal_loader_color,
    "button_combination_tertiary_normal_left-icon_color": "{primary60}",
    "button_combination_tertiary_normal_right-icon_color": "{primary60}",
    "button_combination_tertiary_destructive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_destructive_container_behavior_hover_background-color": "{feedbackError20}",
    "button_combination_tertiary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-width": "{border_focus}",
    "button_combination_tertiary_destructive_container_behavior_focus_background-color": "{feedbackError20}",
    button_combination_tertiary_destructive_loader_color: $f551aa6589c293c2$var$button_combination_tertiary_destructive_loader_color,
    "button_combination_tertiary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_tertiary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_tertiary_positive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_tertiary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_tertiary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_tertiary_positive_loader_color: $f551aa6589c293c2$var$button_combination_tertiary_positive_loader_color,
    "button_combination_tertiary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_true_small_container_padding-top": "{xxs}",
    "button_combination_true_small_container_padding-right": "{base}",
    "button_combination_true_small_container_padding-bottom": "{xxs}",
    "button_combination_true_small_container_padding-left": "{base}",
    "button_combination_true_small_left-icon_size": "{base}",
    "button_combination_true_small_right-icon_size": "{base}",
    button_combination_true_small_loader_size: $f551aa6589c293c2$var$button_combination_true_small_loader_size,
    "button_combination_true_medium_container_padding-top": "{s}",
    "button_combination_true_medium_container_padding-right": "{base}",
    "button_combination_true_medium_container_padding-bottom": "{s}",
    "button_combination_true_medium_container_padding-left": "{base}",
    "button_combination_true_medium_left-icon_size": "{m}",
    "button_combination_true_medium_right-icon_size": "{m}",
    button_combination_true_medium_loader_size: $f551aa6589c293c2$var$button_combination_true_medium_loader_size,
    "button_combination_true_large_container_padding-top": "{base}",
    "button_combination_true_large_container_padding-left": "{m}",
    "button_combination_true_large_container_padding-bottom": "{base}",
    "button_combination_true_large_container_padding-right": "{m}",
    "button_combination_true_large_left-icon_size": "{m}",
    "button_combination_true_large_right-icon_size": "{m}",
    button_combination_true_large_loader_size: $f551aa6589c293c2$var$button_combination_true_large_loader_size,
    "button_combination_false_small_container_min-height": "{l}",
    "button_combination_false_small_container_min-width": "{l}",
    "button_combination_false_small_left-icon_size": "{base}",
    "button_combination_false_small_right-icon_size": "{base}",
    button_combination_false_small_loader_size: $f551aa6589c293c2$var$button_combination_false_small_loader_size,
    "button_combination_false_medium_container_min-height": "{xxl}",
    "button_combination_false_medium_container_min-width": "{xxl}",
    "button_combination_false_medium_left-icon_size": "{m}",
    "button_combination_false_medium_right-icon_size": "{m}",
    button_combination_false_medium_loader_size: $f551aa6589c293c2$var$button_combination_false_medium_loader_size,
    "button_combination_false_large_left-icon_size": "{m}",
    "button_combination_false_large_right-icon_size": "{m}",
    button_combination_false_large_loader_size: $f551aa6589c293c2$var$button_combination_false_large_loader_size,
    "button_combination_true_true_true_false_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_true_true_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_true_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_true_true_false_container_justify-content": "{justifyContent.center}"
};
const $f551aa6589c293c2$var$ContentCardTokens = {
    "contentcard_base_root-container_width": "{size.max}",
    "contentcard_base_root-container_border-radius": "{xl}",
    "contentcard_base_root-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_root-container_justify-content": "{justifyContent.start}",
    "contentcard_base_root-container_align-items": "{alignItems.start}",
    "contentcard_base_root-container_background-color": "{primaryBackground}",
    "contentcard_base_header-container_justify-content": "{justifyContent.start}",
    "contentcard_base_header-container_align-items": "{alignItems.start}",
    "contentcard_base_header-container_width": "{size.max}",
    "contentcard_base_header-container_padding-left": "{base}",
    "contentcard_base_header-container_padding-right": "{base}",
    "contentcard_base_header-container_padding-top": "{base}",
    "contentcard_base_children-container_justify-content": "{justifyContent.start}",
    "contentcard_base_children-container_align-items": "{alignItems.start}",
    "contentcard_base_children-container_width": "{size.max}",
    "contentcard_base_children-container_padding-left": "{base}",
    "contentcard_base_children-container_padding-right": "{base}",
    "contentcard_base_children-container_padding-bottom": "{base}",
    "contentcard_base_image-content-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_image-content-container_width": "{size.max}",
    "contentcard_base_image-content-container_justify-content": "{justifyContent.start}",
    "contentcard_base_image-content-container_align-items": "{alignItems.start}",
    "contentcard_base_image-content-container_padding-top": "{base}",
    "contentcard_base_image-content-container_padding-bottom": "{base}",
    "contentcard_base_jds_content_block_padding-left": "{base}",
    "contentcard_base_jds_content_block_padding-right": "{base}",
    "contentcard_base_jds_content_block_padding-top": "{base}",
    "contentcard_base_footer-jds_text_padding-left": "{base}",
    "contentcard_base_footer-jds_text_padding-right": "{base}",
    "contentcard_base_footer-jds_text_padding-bottom": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_root-container_width": "{custom_10}",
    "contentcard_combination_false_horizontal_root-container_width": "{size.max}",
    "contentcard_combination_false_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_mobile_root-container_width": "{size.max}"
};
const $f551aa6589c293c2$var$carouselslide_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$carouselslide_base_jds_image_width = "{size.max}";
const $f551aa6589c293c2$var$CarouselSlideTokens = {
    carouselslide_base_container_width: $f551aa6589c293c2$var$carouselslide_base_container_width,
    "carouselslide_base_container_border-radius": "{small}",
    carouselslide_base_jds_image_width: $f551aa6589c293c2$var$carouselslide_base_jds_image_width
};
const $f551aa6589c293c2$var$ContentBlockTokens = {
    "contentblock_base_root-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_root-container_align-items": "{alignItems.start}",
    "contentblock_base_root-container_justify-content": "{justifyContent.start}",
    "contentblock_base_root-container_width": "{size.max}",
    "contentblock_base_inner-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_inner-container_align-items": "{alignItems.start}",
    "contentblock_base_inner-container_justify-content": "{justifyContent.start}",
    "contentblock_base_inner-container_width": "{size.max}",
    "contentblock_base_caption-container_padding-bottom": "{xs}",
    "contentblock_base_title-jds_text_padding-bottom": "{xxs}",
    "contentblock_base_description-jds_text_padding-bottom": "{m}",
    "contentblock_base_children-container_padding-bottom": "{m}",
    "contentblock_base_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_base_button-container_width": "{size.max}",
    "contentblock_base_button-container_gap": "{xs}",
    "contentblock_variant_size_small_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_caption-container_padding-bottom": "{s}",
    "contentblock_variant_size_medium_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_button-container_gap": "{s}",
    "contentblock_variant_size_large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_large_button-container_gap": "{s}",
    "contentblock_variant_size_xtra-large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_xtra-large_button-container_gap": "{s}",
    "contentblock_variant_ctaWrap_vertical_button-container_flex-direction": "{flexDirection.column}",
    "contentblock_variant_singleButton_false_inner-container_width": "{size.max}",
    "contentblock_variant_singleButton_false_button-container_width": "{size.max}",
    "contentblock_combination_desktop_medium_title-jds_text_padding-bottom": "{base}",
    "contentblock_combination_desktop_large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_desktop_xtra-large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_true_xtra-xtra-small_root-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_root-container_justify-content": "{justifyContent.spaceBetween}",
    "contentblock_combination_true_xtra-xtra-small_root-container_align-items": "{alignItems.center}",
    "contentblock_combination_true_xtra-xtra-small_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_button-container_justify-content": "{justifyContent.end}",
    "contentblock_combination_true_xtra-xtra-small_button-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$CheckboxTokens = {
    "checkbox_base_vertical-container_flex-direction": "{flexDirection.column}",
    "checkbox_base_vertical-container_justify-content": "{justifyContent.start}",
    "checkbox_base_vertical-container_align-items": "{alignItems.start}",
    "checkbox_base_vertical-container_gap": "{xs}",
    "checkbox_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_horizontal-container_justify-content": "{justifyContent.start}",
    "checkbox_base_horizontal-container_align-items": "{alignItems.center}",
    "checkbox_base_horizontal-container_gap": "{xs}",
    "checkbox_base_control-container_min-width": "{m}",
    "checkbox_base_control-container_min-height": "{m}",
    "checkbox_base_control-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_control-container_justify-content": "{justifyContent.center}",
    "checkbox_base_control-container_align-items": "{alignItems.center}",
    "checkbox_base_control-container_background-color": "{global.transparent}",
    "checkbox_base_control-container_border-radius": "{small}",
    "checkbox_base_control-container_border-width": "{border_thin}",
    "checkbox_base_control-container_border-color": "{primaryGrey80}",
    "checkbox_base_control-container_behavior_hover_border-color": "{primary40}",
    "checkbox_base_control-container_behavior_active_border-color": "{primary60}",
    "checkbox_base_control-container_behavior_focus_border-width": "{border_focus}",
    "checkbox_base_control-container_behavior_focus_border-color": "{primary60}",
    "checkbox_base_control-icon_size": "{base}",
    "checkbox_base_label-jds_text_text-align": "{textAlign.start}",
    "checkbox_variant_size_small_control-container_min-width": "{base}",
    "checkbox_variant_size_small_control-container_min-height": "{base}",
    "checkbox_variant_size_small_vertical-container_gap": "{xxs}",
    "checkbox_variant_size_small_control-icon_size": "{s}",
    "checkbox_variant_checked_true_control-icon_value": "ic_confirm",
    "checkbox_variant_checked_true_control-container_background-color": "{primary50}",
    "checkbox_variant_checked_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_checked_true_control-container_behavior_active_background-color": "{primary60}",
    "checkbox_variant_checked_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_indeterminate_true_control-icon_value": "ic_minus",
    "checkbox_variant_indeterminate_true_control-container_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_indeterminate_true_control-container_behavior_focus_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "checkbox_base_vertical-container_opacity": "{opacity.enabled}"
};
const $f551aa6589c293c2$var$datepickercalendarbutton_base_container_width = "{custom_7}";
const $f551aa6589c293c2$var$datepickercalendarbutton_button_container_width = "{m}";
const $f551aa6589c293c2$var$datepickercalendarbutton_base_container_height = "{xxl}";
const $f551aa6589c293c2$var$datepickercalendarbutton_button_container_height = "{m}";
const $f551aa6589c293c2$var$datepickercalendarbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$DatepickerCalendarButtonTokens = {
    "datepickercalendarbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_container_align-items": "{alignItems.center}",
    datepickercalendarbutton_base_container_width: $f551aa6589c293c2$var$datepickercalendarbutton_base_container_width,
    datepickercalendarbutton_button_container_width: $f551aa6589c293c2$var$datepickercalendarbutton_button_container_width,
    "datepickercalendarbutton_base_root-container_max_width": "{size.max}",
    datepickercalendarbutton_base_container_height: $f551aa6589c293c2$var$datepickercalendarbutton_base_container_height,
    datepickercalendarbutton_button_container_height: $f551aa6589c293c2$var$datepickercalendarbutton_button_container_height,
    "datepickercalendarbutton_base_button-container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_button-container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_button-container_align-items": "{alignItems.center}",
    "datepickercalendarbutton_base_button-container_width": "{xxl}",
    "datepickercalendarbutton_base_button-container_instrinsic_width": "{intrinsicSize.min}",
    "datepickercalendarbutton_base_button-container_height": "{xxl}",
    "datepickercalendarbutton_base_button-container_border-radius": "{pill}",
    "datepickercalendarbutton_base_button-container_border-color": "{primaryGrey100}",
    "datepickercalendarbutton_base_button-container_background-color": "{global.transparent}",
    "datepickercalendarbutton_base_button-container_behavior_hover_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_active_background-color": "{primary40}",
    "datepickercalendarbutton_base_button-container_behavior_focus_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_focus_border-width": "{border_focus}",
    "datepickercalendarbutton_variant_state_selected_button-container_background-color": "{primary50}",
    "datepickercalendarbutton_variant_state_current_button-container_background-color": "{primary20}",
    datepickercalendarbutton_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$datepickercalendarbutton_variant_disabled_true_container_opacity,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}"
};
const $f551aa6589c293c2$var$datepickerbutton_base_container_height = "{xxl}";
const $f551aa6589c293c2$var$datepickerbutton_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$datepickerbutton_variant_state_disabled_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$DatepickerButtonTokens = {
    datepickerbutton_base_container_height: $f551aa6589c293c2$var$datepickerbutton_base_container_height,
    "datepickerbutton_base_container_max-width": "{custom_9}",
    "datepickerbutton_base_container_border-radius": "{pill}",
    "datepickerbutton_base_container_background-color": "{global.transparent}",
    "datepickerbutton_base_container_border-width": "{border_thin}",
    "datepickerbutton_base_container_border-color": "{primaryGrey40}",
    "datepickerbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerbutton_base_container_align-items": "{alignItems.center}",
    datepickerbutton_base_container_gap: $f551aa6589c293c2$var$datepickerbutton_base_container_gap,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}",
    "datepickerbutton_base_container_behavior_hover_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_focus_border-color": "{primaryGrey100}",
    "datepickerbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "datepickerbutton_base_container_behavior_active_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_active_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_border-color": "{primary60}",
    "datepickerbutton_variant_state_disabled_container_border-width": "{border_none}",
    datepickerbutton_variant_state_disabled_container_opacity: $f551aa6589c293c2$var$datepickerbutton_variant_state_disabled_container_opacity,
    "datepickerbutton_variant_state_text_only_container_border-width": "{border_none}"
};
const $f551aa6589c293c2$var$datepickercalendar_base_container_gap = "{s}";
const $f551aa6589c293c2$var$DatepickerCalendarTokens = {
    "datepickercalendar_base_container_flex-direction": "{flexDirection.column}",
    "datepickercalendar_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendar_base_container_align-items": "{alignItems.center}",
    datepickercalendar_base_container_gap: $f551aa6589c293c2$var$datepickercalendar_base_container_gap,
    "datepickercalendar_base_rows-container_flex-direction": "{flexDirection.column}"
};
const $f551aa6589c293c2$var$datepickerheader_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$datepickerheader_base_container_height = "{xxl}";
const $f551aa6589c293c2$var$DatepickerHeaderTokens = {
    datepickerheader_base_container_width: $f551aa6589c293c2$var$datepickerheader_base_container_width,
    datepickerheader_base_container_height: $f551aa6589c293c2$var$datepickerheader_base_container_height,
    "datepickerheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerheader_base_container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_height": "{xxl}",
    "datepickerheader_base_inner-container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_inner-container_justify-content": "{justifyContent.center}",
    "datepickerheader_base_inner-container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_gap": "{s}"
};
const $f551aa6589c293c2$var$datepickerdesktop_base_container_opacity = "{opacity.invisible}";
const $f551aa6589c293c2$var$datapickerdesktop_variant_open_true_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$DatepickerDesktopTokens = {
    "datepickerdesktop_base_popup-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_popup-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_popup-container_align-items": "{alignItems.center}",
    datepickerdesktop_base_container_opacity: $f551aa6589c293c2$var$datepickerdesktop_base_container_opacity,
    "datepickerdesktop_base_container_background-color": "{primaryBackground}",
    "datepickerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_container_border-radius": "{xl}",
    "datepickerdesktop_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickerdesktop_base_top-container_justify-content": "{justifyContent.end}",
    "datepickerdesktop_base_top-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_top-container_padding-top": "{xs}",
    "datepickerdesktop_base_top-container_padding-right": "{s}",
    "datepickerdesktop_base_top-container_padding-bottom": "{xs}",
    "datepickerdesktop_base_top-container_padding-left": "{s}",
    "datepickerdesktop_base_top-container_width": "{custom_6}",
    "datepickerdesktop_base_jds_datepicker_header_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_header_padding-left": "{m}",
    "datepickerdesktop_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_controls-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_controls-container_gap": "{m}",
    "datepickerdesktop_base_calender-view-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_calender-view-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_calender-view-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_calender-view-container_height": "{size.max}",
    "datepickerdesktop_base_calender-view-container_width": "{size.max}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-left": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-bottom": "{m}",
    datapickerdesktop_variant_open_true_container_opacity: $f551aa6589c293c2$var$datapickerdesktop_variant_open_true_container_opacity,
    "datepickerdesktop_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerdesktop_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $f551aa6589c293c2$var$datepickercalendarrow_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$DatepickerCalendarRowTokens = {
    "datepickercalendarrow_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarrow_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendarrow_base_container_align-items": "{alignItems.center}",
    datepickercalendarrow_base_container_width: $f551aa6589c293c2$var$datepickercalendarrow_base_container_width
};
const $f551aa6589c293c2$var$datepickerviewbutton_base_container_height = "{xxl}";
const $f551aa6589c293c2$var$datepickerviewbutton_base_container_width = "{custom_7}";
const $f551aa6589c293c2$var$DatepickerViewButtonTokens = {
    "datepickerviewbutton_base_root-container_width": "{size.max}",
    "datepickerviewbutton_base_root-container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_root-container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_root-container_align-items": "{alignItems.center}",
    datepickerviewbutton_base_container_height: $f551aa6589c293c2$var$datepickerviewbutton_base_container_height,
    datepickerviewbutton_base_container_width: $f551aa6589c293c2$var$datepickerviewbutton_base_container_width,
    "datepickerviewbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$datepickercalendarheader_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$DatepickerCalendarHeaderTokens = {
    "datepickercalendarheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarheader_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarheader_base_container_align-items": "{alignItems.center}",
    datepickercalendarheader_base_container_width: $f551aa6589c293c2$var$datepickercalendarheader_base_container_width
};
const $f551aa6589c293c2$var$datepickeryearview_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$DatepickerYearViewTokens = {
    "datepickeryearview_base_container_flex-direction": "{flexDirection.column}",
    datepickeryearview_base_container_width: $f551aa6589c293c2$var$datepickeryearview_base_container_width,
    "datepickeryearview_base_container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$datepickermobile_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$DatepickerMobileTokens = {
    "datepickermobile_base_container_background-color": "{primaryBackground}",
    "datepickermobile_base_container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_container_align-items": "{alignItems.center}",
    datepickermobile_base_container_size: $f551aa6589c293c2$var$datepickermobile_base_container_size,
    "datepickermobile_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickermobile_base_top-container_justify-content": "{justifyContent.end}",
    "datepickermobile_base_top-container_align-items": "{alignItems.center}",
    "datepickermobile_base_top-container_padding-top": "{xs}",
    "datepickermobile_base_top-container_padding-bottom": "{xs}",
    "datepickermobile_base_top-container_padding-left": "{s}",
    "datepickermobile_base_top-container_padding-right": "{s}",
    "datepickermobile_base_top-container_width": "{size.max}",
    "datepickermobile_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_controls-container_align-items": "{alignItems.center}",
    "datepickermobile_base_controls-container_gap": "{m}",
    "datepickermobile_base_jds_datepicker_header_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_header_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-bottom": "{m}",
    "datepickermobile_base_jds_datepicker_month_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_month_view_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-right": "{s}",
    "datepickermobile_base_confirmation-container_padding-bottom": "{m}",
    "datepickermobile_base_confirmation-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-container_gap": "{s}",
    "datepickermobile_base_confirmation-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-container_width": "{size.max}",
    "datepickermobile_base_confirmation-group-container_padding-right": "{m}",
    "datepickermobile_base_confirmation-group-container_padding-left": "{m}",
    "datepickermobile_base_confirmation-group-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-group-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-group-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-group-container_gap": "{s}",
    "datepickermobile_base_confirmation-group-container_width": "{size.max}",
    "datepickermobile_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickermobile_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $f551aa6589c293c2$var$datepickermonthview_base_container_height = "{custom_8}";
const $f551aa6589c293c2$var$datepickermonthview_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$DatepickerMonthViewTokens = {
    "datepickermonthview_base_container_flex-direction": "{flexDirection.column}",
    datepickermonthview_base_container_height: $f551aa6589c293c2$var$datepickermonthview_base_container_height,
    datepickermonthview_base_container_width: $f551aa6589c293c2$var$datepickermonthview_base_container_width,
    "datepickermonthview_base_container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$dropdownmenu_base_jds_search_box_width = "{size.max}";
const $f551aa6589c293c2$var$DropdownMenuTokens = {
    "dropdownmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-group-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenu_base_menu-group-container_padding-top": "{xs}",
    "dropdownmenu_base_menu-group-container_padding-bottom": "{xs}",
    "dropdownmenu_base_search-container_padding-top": "{base}",
    "dropdownmenu_base_search-container_padding-left": "{base}",
    "dropdownmenu_base_search-container_padding-right": "{base}",
    "dropdownmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_base_search-container_width": "{size.max}",
    dropdownmenu_base_jds_search_box_width: $f551aa6589c293c2$var$dropdownmenu_base_jds_search_box_width,
    "dropdownmenu_base_menu-group-container_width": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_popup-container_size": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_menu-container_size": "{size.max}",
    "dropdownmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $f551aa6589c293c2$var$dropdownmenuitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$dropdownmenuitem_base_container_gap = "{s}";
const $f551aa6589c293c2$var$dropdownmenuitem_base_icon_color = "{primary60}";
const $f551aa6589c293c2$var$dropdownmenuitem_base_icon_size = "{m}";
const $f551aa6589c293c2$var$dropdownmenuitem_base_icon_behaviour_active_color = "{primaryInverse}";
const $f551aa6589c293c2$var$dropdownmenuitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$DropdownMenuItemTokens = {
    dropdownmenuitem_base_container_width: $f551aa6589c293c2$var$dropdownmenuitem_base_container_width,
    "dropdownmenuitem_base_container_flex-direction": "{flexDirection.row}",
    "dropdownmenuitem_base_content-container_flex-direction": "{flexDirection.column}",
    dropdownmenuitem_base_container_gap: $f551aa6589c293c2$var$dropdownmenuitem_base_container_gap,
    "dropdownmenuitem_base_container_background-color": "{primaryGrey20}",
    "dropdownmenuitem_base_container_behavior_hover_background-color": "{primaryBackground}",
    "dropdownmenuitem_base_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_label-jds_text_behavior_color": "{primaryGrey100}",
    "dropdownmenuitem_base_container_padding-top": "{xs}",
    "dropdownmenuitem_base_container_padding-right": "{base}",
    "dropdownmenuitem_base_container_padding-bottom": "{xs}",
    "dropdownmenuitem_base_container_padding-left": "{base}",
    "dropdownmenuitem_variant_selected_true_container_background-color": "{primary50}",
    "dropdownmenuitem_variant_selected_true_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_content-container_justify-content": "{justifyContent.start}",
    "dropdownmenuitem_base_content-container_align-items": "{alignItems.start}",
    "dropdownmenuitem_base_container_align-items": "{alignItems.center}",
    "dropdownmenuitem_base_prefix-container_align-self": "{alignItems.start}",
    dropdownmenuitem_base_icon_color: $f551aa6589c293c2$var$dropdownmenuitem_base_icon_color,
    dropdownmenuitem_base_icon_size: $f551aa6589c293c2$var$dropdownmenuitem_base_icon_size,
    dropdownmenuitem_base_icon_behaviour_active_color: $f551aa6589c293c2$var$dropdownmenuitem_base_icon_behaviour_active_color,
    "dropdownmenuitem_variant_selected_true_icon-color": "{primaryInverse}",
    dropdownmenuitem_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$dropdownmenuitem_variant_disabled_true_container_opacity,
    "dropdownmenuitem_base_container_behavior_focus_border-radius": "{small}",
    "dropdownmenuitem_base_root-container_width": "{size.max}"
};
const $f551aa6589c293c2$var$dropdownmenugroup_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$DropdownMenuGroupTokens = {
    dropdownmenugroup_base_container_width: $f551aa6589c293c2$var$dropdownmenugroup_base_container_width,
    "dropdownmenugroup_base_container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_menu-item-container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_label-container_padding-top": "{xs}",
    "dropdownmenugroup_base_label-container_padding-left": "{base}",
    "dropdownmenugroup_base_label-container_padding-right": "{base}",
    "dropdownmenugroup_base_label-container_width": "{size.max}",
    "dropdownmenugroup_base_container_background-color": "{primaryGrey20}",
    "dropdownmenugroup_base_menu-item-container_width": "{size.max}"
};
const $f551aa6589c293c2$var$DropdownMenuSubMenuTokens = {
    "dropdownmenusubmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenusubmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenusubmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenusubmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenusubmenu_base_menu-container_padding-top": "{xs}",
    "dropdownmenusubmenu_base_menu-container_padding-bottom": "{xs}",
    "dropdownmenusubmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_variant__platform_mobile_popup-container_size": "{size.max}",
    "dropdownmenu_variant__platform_mobile_menu-container_size": "{size.max}",
    "dropdownmenusubmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenusubmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $f551aa6589c293c2$var$bottomfooter_base_container_background = "{global.transparent}";
const $f551aa6589c293c2$var$bottomfooter_variant__platform_desktop_container_width = "{size.max}";
const $f551aa6589c293c2$var$bottomfooter_variant__platform_mobile_container_gap = "{base}";
const $f551aa6589c293c2$var$BottomFooterTokens = {
    "bottomfooter_base_container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_container_justify-content": "{justifyContent.spaceBetween}",
    "bottomfooter_base_container_align-items": "{alignItems.center}",
    "bottomfooter_base_container_padding-top": "{base}",
    "bottomfooter_base_container_padding-right": "{huge}",
    "bottomfooter_base_container_padding-bottom": "{base}",
    "bottomfooter_base_container_padding-left": "{huge}",
    bottomfooter_base_container_background: $f551aa6589c293c2$var$bottomfooter_base_container_background,
    "bottomfooter_base_copyright-container_gap": "{base}",
    "bottomfooter_base_copyright-container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_copyright-container_align-items": "{alignItems.center}",
    "bottomfooter_base_informational-links-container_align-items": "{alignItems.center}",
    bottomfooter_variant__platform_desktop_container_width: $f551aa6589c293c2$var$bottomfooter_variant__platform_desktop_container_width,
    "bottomfooter_variant__platform_mobile_container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_container_justify-content": "{justifyContent.start}",
    "bottomfooter_variant__platform_mobile_container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_container_padding-right": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-bottom": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-left": "{m}",
    bottomfooter_variant__platform_mobile_container_gap: $f551aa6589c293c2$var$bottomfooter_variant__platform_mobile_container_gap,
    "bottomfooter_variant__platform_mobile_copyright-container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_copyright-container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_copyright-container_gap": "{base}"
};
const $f551aa6589c293c2$var$divider_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$divider_variant_orientation_horizontal_container_width = "{size.max}";
const $f551aa6589c293c2$var$divider_variant_orientation_vertical_container_height = "{size.max}";
const $f551aa6589c293c2$var$DividerTokens = {
    "divider_base_container_background-color": "{global.transparent}",
    "divider_base_container_flex-direction": "{flexDirection.row}",
    "divider_base_container_justify-content": "{justifyContent.center}",
    "divider_base_container_align-items": "{alignItems.center}",
    divider_base_container_gap: $f551aa6589c293c2$var$divider_base_container_gap,
    "divider_base_container_padding-left": "{s}",
    "divider_base_container_padding-right": "{s}",
    "divider_base_container_padding-top": "{s}",
    "divider_base_container_padding-bottom": "{s}",
    "divider_base_start-container_min-height": "{custom_5}",
    "divider_base_start-container_min-width": "{custom_5}",
    "divider_base_start-container_flex-direction": "{flexDirection.row}",
    "divider_base_start-container_background-color": "{primaryGrey40}",
    "divider_base_start-container_border-radius": "{pill}",
    "divider_base_end-container_min-height": "{custom_5}",
    "divider_base_end-container_min-width": "{custom_5}",
    "divider_base_end-container_flex-direction": "{flexDirection.row}",
    "divider_base_end-container_background-color": "{primaryGrey40}",
    "divider_base_end-container_border-radius": "{pill}",
    "divider_variant_variant_stepper_start-container_background-color": "{sparkle50}",
    "divider_variant_variant_stepper_end-container_background-color": "{sparkle50}",
    divider_variant_orientation_horizontal_container_width: $f551aa6589c293c2$var$divider_variant_orientation_horizontal_container_width,
    divider_variant_orientation_vertical_container_height: $f551aa6589c293c2$var$divider_variant_orientation_vertical_container_height,
    "divider_variant_orientation_vertical_container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_start-container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_end-container_flex-direction": "{flexDirection.column}",
    "divider_combination_base_all_container_padding-left": "{base}",
    "divider_combination_base_all_container_padding-right": "{base}",
    "divider_combination_base_all_container_padding-top": "{base}",
    "divider_combination_base_all_container_padding-bottom": "{base}",
    "divider_combination_base_left_container_padding-left": "{base}",
    "divider_combination_base_right_container_padding-right": "{base}",
    "divider_combination_base_top_container_padding-top": "{base}",
    "divider_combination_base_bottom_container_padding-bottom": "{base}",
    "divider_combination_base_vertical_container_padding-top": "{base}",
    "divider_combination_base_vertical_container_padding-bottom": "{base}",
    "divider_combination_base_horizontal_container_padding-left": "{base}",
    "divider_combination_base_horizontal_container_padding-right": "{base}",
    "divider_combination_medium_all_container_padding-left": "{m}",
    "divider_combination_medium_all_container_padding-right": "{m}",
    "divider_combination_medium_all_container_padding-top": "{m}",
    "divider_combination_medium_all_container_padding-bottom": "{m}",
    "divider_combination_medium_left_container_padding-left": "{m}",
    "divider_combination_medium_right_container_padding-right": "{m}",
    "divider_combination_medium_top_container_padding-top": "{m}",
    "divider_combination_medium_bottom_container_padding-bottom": "{m}",
    "divider_combination_medium_vertical_container_padding-top": "{m}",
    "divider_combination_medium_vertical_container_padding-bottom": "{m}",
    "divider_combination_medium_horizontal_container_padding-left": "{m}",
    "divider_combination_medium_horizontal_container_padding-right": "{m}",
    "divider_combination_xtra-small_all_container_padding-left": "{xs}",
    "divider_combination_xtra-small_all_container_padding-right": "{xs}",
    "divider_combination_xtra-small_all_container_padding-top": "{xs}",
    "divider_combination_xtra-small_all_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_left_container_padding-left": "{xs}",
    "divider_combination_xtra-small_right_container_padding-right": "{xs}",
    "divider_combination_xtra-small_top_container_padding-top": "{xs}",
    "divider_combination_xtra-small_bottom_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-top": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-left": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-right": "{xs}",
    "divider_combination_xtra-xtra-small_all_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_left_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_right_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_top_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_bottom_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-large_all_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_left_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_right_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_top_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_bottom_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-right": "{xxl}",
    "divider_combination_xtra-large_all_container_padding-left": "{xl}",
    "divider_combination_xtra-large_all_container_padding-right": "{xl}",
    "divider_combination_xtra-large_all_container_padding-top": "{xl}",
    "divider_combination_xtra-large_all_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_left_container_padding-left": "{xl}",
    "divider_combination_xtra-large_right_container_padding-right": "{xl}",
    "divider_combination_xtra-large_top_container_padding-top": "{xl}",
    "divider_combination_xtra-large_bottom_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-top": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-left": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-right": "{xl}",
    "divider_combination_large_all_container_padding-left": "{l}",
    "divider_combination_large_all_container_padding-right": "{l}",
    "divider_combination_large_all_container_padding-top": "{l}",
    "divider_combination_large_all_container_padding-bottom": "{l}",
    "divider_combination_large_left_container_padding-left": "{l}",
    "divider_combination_large_right_container_padding-right": "{l}",
    "divider_combination_large_top_container_padding-top": "{l}",
    "divider_combination_large_bottom_container_padding-bottom": "{l}",
    "divider_combination_large_vertical_container_padding-top": "{l}",
    "divider_combination_large_vertical_container_padding-bottom": "{l}",
    "divider_combination_large_horizontal_container_padding-left": "{l}",
    "divider_combination_large_horizontal_container_padding-right": "{l}",
    "divider_combination_huge_all_container_padding-left": "{huge}",
    "divider_combination_huge_all_container_padding-right": "{huge}",
    "divider_combination_huge_all_container_padding-top": "{huge}",
    "divider_combination_huge_all_container_padding-bottom": "{huge}",
    "divider_combination_huge_left_container_padding-left": "{huge}",
    "divider_combination_huge_right_container_padding-right": "{huge}",
    "divider_combination_huge_top_container_padding-top": "{huge}",
    "divider_combination_huge_bottom_container_padding-bottom": "{huge}",
    "divider_combination_huge_vertical_container_padding-top": "{huge}",
    "divider_combination_huge_vertical_container_padding-bottom": "{huge}",
    "divider_combination_huge_horizontal_container_padding-left": "{huge}",
    "divider_combination_huge_horizontal_container_padding-right": "{huge}",
    "divider_combination_massive_all_container_padding-left": "{massive}",
    "divider_combination_massive_all_container_padding-right": "{massive}",
    "divider_combination_massive_all_container_padding-top": "{massive}",
    "divider_combination_massive_all_container_padding-bottom": "{massive}",
    "divider_combination_massive_left_container_padding-left": "{massive}",
    "divider_combination_massive_right_container_padding-right": "{massive}",
    "divider_combination_massive_top_container_padding-top": "{massive}",
    "divider_combination_massive_bottom_container_padding-bottom": "{massive}",
    "divider_combination_massive_vertical_container_padding-top": "{massive}",
    "divider_combination_massive_vertical_container_padding-bottom": "{massive}",
    "divider_combination_massive_horizontal_container_padding-left": "{massive}",
    "divider_combination_massive_horizontal_container_padding-right": "{massive}"
};
const $f551aa6589c293c2$var$fab_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$fab_base_icon_size = "{m}";
const $f551aa6589c293c2$var$fab_base_icon_color = "{secondaryInverse}";
const $f551aa6589c293c2$var$fab_base_icon_behavior_active_color = "{secondary30}";
const $f551aa6589c293c2$var$FABTokens = {
    "fab_base_popup-container_flex-direction": "{flexDirection.stack}",
    "fab_base_popup-container_justify-content": "{justifyContent.end}",
    "fab_base_popup-container_align-items": "{alignItems.end}",
    "fab_base_popup-container_size": "{size.max}",
    "fab_base_popup-container_padding-right": "{base}",
    "fab_base_popup-container_padding-bottom": "{base}",
    "fab_base_container_background-color": "{secondary50}",
    "fab_base_container_flex-direction": "{flexDirection.row}",
    "fab_base_container_justify-content": "{justifyContent.center}",
    "fab_base_container_align-items": "{alignItems.center}",
    fab_base_container_gap: $f551aa6589c293c2$var$fab_base_container_gap,
    "fab_base_container_border-radius": "{pill}",
    "fab_base_container_padding-top": "{base}",
    "fab_base_container_padding-left": "{m}",
    "fab_base_container_padding-right": "{m}",
    "fab_base_container_padding-bottom": "{base}",
    "fab_base_container_border-color": "{primary80}",
    "fab_base_container_border-width": "{border_none}",
    "fab_base_container_behavior_hover_background-color": "{secondary60}",
    "fab_base_container_behavior_active_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_border-width": "{border_focus}",
    fab_base_icon_size: $f551aa6589c293c2$var$fab_base_icon_size,
    fab_base_icon_color: $f551aa6589c293c2$var$fab_base_icon_color,
    "fab_base_icon_border-radius": "{pill}",
    fab_base_icon_behavior_active_color: $f551aa6589c293c2$var$fab_base_icon_behavior_active_color,
    "fab_variant_extend_false_container_padding-left": "{base}",
    "fab_variant_extend_false_container_padding-right": "{base}"
};
const $f551aa6589c293c2$var$feedbackblock_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$feedbackblock_base_icon_size = "{m}";
const $f551aa6589c293c2$var$feedbackblock_variant_size_s_icon_size = "{base}";
const $f551aa6589c293c2$var$FeedbackBlockTokens = {
    "feedbackblock_base_container_flex-direction": "{flexDirection.row}",
    "feedbackblock_base_container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_container_align-items": "{alignItems.center}",
    feedbackblock_base_container_gap: $f551aa6589c293c2$var$feedbackblock_base_container_gap,
    "feedbackblock_variant_alignment_top_container_align-items": "{alignItems.start}",
    "feedbackblock_base_icon-flex-direction": "{flexDirection.row}",
    "feedbackblock_base_icon-container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_icon-container_align-items": "{alignItems.center}",
    "feedbackblock_base_icon-container_height": "{m}",
    feedbackblock_base_icon_size: $f551aa6589c293c2$var$feedbackblock_base_icon_size,
    "feedbackblock_variant_size_s_icon-container_height": "{custom_18}",
    feedbackblock_variant_size_s_icon_size: $f551aa6589c293c2$var$feedbackblock_variant_size_s_icon_size
};
const $f551aa6589c293c2$var$dropdown_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$dropdown_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$dropdown_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$dropdown_base_conatiner_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$DropdownTokens = {
    "dropdown_base_container_flex-direction": "{flexDirection.column}",
    dropdown_base_container_gap: $f551aa6589c293c2$var$dropdown_base_container_gap,
    dropdown_base_container_width: $f551aa6589c293c2$var$dropdown_base_container_width,
    "dropdown_base_container_justify-content": "{justifyContent.start}",
    "dropdown_base_container_align-items": "{alignItems.start}",
    "dropdown_base_field-container_flex-direction": "{flexDirection.stack}",
    "dropdown_base_field-container_width": "{size.max}",
    "dropdown_base_field-container_align-items": "{alignItems.end}",
    "dropdown_base_field-container_justify-content": "{justifyContent.start}",
    "dropdown_base_field-container_padding-bottom": "{xxs}",
    "dropdown_base_text-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_text-container_gap": "{xs}",
    "dropdown_base_select-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_select-container_justify-content": "{justifyContent.end}",
    "dropdown_base_select-container_width": "{size.max}",
    "dropdown_base_select-container_align-items": "{alignItems.center}",
    "dropdown_base_active-line-container_flex-direction": "{flexDirection.column}",
    "dropdown_base_active-line-container_width": "{size.max}",
    "dropdown_base_active-line-container_align-items": "{alignItems.center}",
    "dropdown_base_feedback-container_width": "{size.max}",
    "dropdown_base_feedback-container_background-color": "{primaryGrey100}",
    "dropdown_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_active_background-color": "{primary50}",
    "dropdown_variant_border_true-select-container_border-width": "{border_thin}",
    "dropdown_variant_border_true-select-container_border-color": "{primaryGrey60}",
    "dropdown_variant_border_true-select-container_border-radius": "{medium}",
    "dropdown_variant_border_true-select-container_padding-top": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-bottom": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-left": "{s}",
    "dropdown_variant_border_true-select-container_padding-right": "{xs}",
    "dropdown_variant_border_true-select-container_behavior_hover_background-color": "{primartGrey60}",
    "dropdown_variant_border_true-select-container_behavior_focus_background-color": "{white}",
    "dropdown_variant_border_true-select-container_behavior_active_background-color": "{white}",
    "dropdown_base_prefix-icon_size": "{m}",
    "dropdown_base_prefix-icon_color": "{primaryGrey80}",
    dropdown_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$dropdown_variant_disabled_true_container_opacity,
    dropdown_base_conatiner_opacity: $f551aa6589c293c2$var$dropdown_base_conatiner_opacity,
    "dropdown_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "dropdown_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "dropdown_variant_border_true-select-container_background-color": "{primaryGrey20}",
    "dropdown_variant_border_true-select-container_height": "{xl}",
    "dropdown_combination_true_true_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_true_false_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_false_true_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_label-jds_text_padding-left": "{l}",
    "dropdown_combination_false_false_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_select-container_padding-left": "{s}",
    "dropdown_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $f551aa6589c293c2$var$bottomfooterlinkitem_base_container_gap = "{base}";
const $f551aa6589c293c2$var$BottomFooterLinkItemTokens = {
    bottomfooterlinkitem_base_container_gap: $f551aa6589c293c2$var$bottomfooterlinkitem_base_container_gap
};
const $f551aa6589c293c2$var$footer_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$FooterTokens = {
    "footer_base_container_flex-direction": "{flexDirection.column}",
    "footer_base_container_align-items": "{alignItems.center}",
    footer_base_container_size: $f551aa6589c293c2$var$footer_base_container_size,
    "footer_base_container_background-color": "{primaryGrey20}",
    "footer_base_main-container_flex-direction": "{flexDirection.row}",
    "footer_base_main-container_justify-content": "{justifyContent.spaceBetween}",
    "footer_base_main-container_align-items": "{alignItems.start}",
    "footer_base_main-container_gap": "{base}",
    "footer_base_main-container_size": "{size.max}",
    "footer_base_main-container_padding-top": "{xl}",
    "footer_base_main-container_padding-bottom": "{xl}",
    "footer_base_main-container_padding-left": "{huge}",
    "footer_base_main-container_padding-right": "{huge}",
    "footer_base_social-links-container_padding-top": "{xs}",
    "footer_base_social-links-container_flex-direction": "{flexDirection.column}",
    "footer_base_social-links-container_gap": "{l}",
    "footer_base_bottom-container_flex-direction": "{flexDirection.column}",
    "footer_base_bottom-container_align-items": "{alignItems.start}",
    "footer_base_bottom-container_width": "{size.max}",
    "footer_base_content-container_width": "{size.max}",
    "footer_base_content-slot_width": "{size.max}",
    "footer_variant__platform_mobile_bottom-container_gap": "{m}",
    "footer_variant__platform_mobile_main-container_flex-direction": "{flexDirection.column}",
    "footer_variant__platform_mobile_main-container_justify-content": "{justifyContent.start}",
    "footer_variant__platform_mobile_main-container_padding-top": "{m}",
    "footer_variant__platform_mobile_main-container_padding-bottom": "{xl}",
    "footer_variant__platform_mobile_main-container_padding-left": "{m}",
    "footer_variant__platform_mobile_main-container_padding-right": "{m}",
    "footer_base_social-links-container_width": "{custom_17}"
};
const $f551aa6589c293c2$var$footerlinksgrid_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$footerlinksgrid_base_container_gap = "{base}";
const $f551aa6589c293c2$var$FooterLinksGridTokens = {
    "footerlinksgrid_base_container_flex-direction": "{flexDirection.row}",
    footerlinksgrid_base_container_size: $f551aa6589c293c2$var$footerlinksgrid_base_container_size,
    footerlinksgrid_base_container_gap: $f551aa6589c293c2$var$footerlinksgrid_base_container_gap
};
const $f551aa6589c293c2$var$footericonlinks_base_container_gap = "{base}";
const $f551aa6589c293c2$var$FooterIconLinksTokens = {
    footericonlinks_base_container_gap: $f551aa6589c293c2$var$footericonlinks_base_container_gap,
    "footericonlinks_base_container_flex-direction": "{flexDirection.column}",
    "footericonlinks_base_container_align-items": "{alignItems.start}",
    "footericonlinks_base_icons-container_flex-direction": "{flexDirection.row}",
    "footericonlinks_base_icons-container_gap": "{base}"
};
const $f551aa6589c293c2$var$footermarketlinks_base_container_gap = "{base}";
const $f551aa6589c293c2$var$FooterMarketLinksTokens = {
    footermarketlinks_base_container_gap: $f551aa6589c293c2$var$footermarketlinks_base_container_gap,
    "footermarketlinks_base_container_flex-direction": "{flexDirection.column}",
    "footermarketlinks_base_container_align-items": "{alignItems.start}",
    "footermarketlinks_base_assets-container_flex-direction": "{flexDirection.row}",
    "footermarketlinks_base_assets-container_align-items": "{alignItems.center}",
    "footermarketlinks_base_assets-container_gap": "{base}"
};
const $f551aa6589c293c2$var$footerlinks_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$FooterLinksTokens = {
    "footerlinks_base_container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_container_align-items": "{alignItems.start}",
    footerlinks_base_container_size: $f551aa6589c293c2$var$footerlinks_base_container_size,
    "footerlinks_base_link-item-container_size": "{size.max}",
    "footerlinks_base_link-item-container_padding-top": "{xs}",
    "footerlinks_base_link-item-container_padding-bottom": "{xs}",
    "footerlinks_base_link-item-container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_link-item-container_justify-content": "{justifyContent.start}",
    "footerlinks_base_link-item-container_align-items": "{alignItems.start}",
    "footerlinks_base_link-item-container_background-color": "{global.transparent}",
    "footerlinks_base_link-item-container_behavior_hover_background-color": "{primaryGrey40}",
    "footerlinks_base_title-jds_text_padding-top": "{xs}",
    "footerlinks_base_title-jds_text_padding-bottom": "{xs}",
    "footerlinks_base_links-container_padding-top": "{s}",
    "footerlinks_base_links-container_size": "{size.max}",
    "footerlinks_base_links-container_flex-direction": "{flexDirection.column}"
};
const $f551aa6589c293c2$var$BaseIconTokens = {
    "base-icon_base_icon_size": "{base}",
    "base-icon_base_icon_color": "{primary50}",
    "base-icon_variant_color_primary_30_icon_color": "{primary30}",
    "base-icon_variant_color_primary_60_icon_color": "{primary60}",
    "base-icon_variant_color_primary_70_icon_color": "{primary70}",
    "base-icon_variant_color_primary_background_icon_color": "{primaryBackground}",
    "base-icon_variant_color_secondary_50_icon_color": "{secondary50}",
    "base-icon_variant_color_sparkle_50_icon_color": "{sparkle50}",
    "base-icon_variant_color_primary_grey_60_icon_color": "{primaryGrey60}",
    "base-icon_variant_color_primary_grey_80_icon_color": "{primaryGrey80}",
    "base-icon_variant_color_primary_grey_100_icon_color": "{primaryGrey100}",
    "base-icon_variant_color_feedback_success_icon_color": "{feedbackSuccess50}",
    "base-icon_variant_color_feedback_error_icon_color": "{feedbackError50}",
    "base-icon_variant_color_feedback_warning_icon_color": "{feedbackWarning50}",
    "base-icon_variant_color_white_icon_color": "{global.white}",
    "base-icon_variant_color_none_icon_color": "{custom_color_1}"
};
const $f551aa6589c293c2$var$icon_base_container_size = "{m}";
const $f551aa6589c293c2$var$icon_base_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_base_icon_color = "{custom_color_1}";
const $f551aa6589c293c2$var$icon_variant_color_primary_50_icon_color = "{primary50}";
const $f551aa6589c293c2$var$icon_variant_color_primary_30_icon_color = "{primary30}";
const $f551aa6589c293c2$var$icon_variant_color_primary_60_icon_color = "{primary60}";
const $f551aa6589c293c2$var$icon_variant_color_primary_70_icon_color = "{primary70}";
const $f551aa6589c293c2$var$icon_variant_color_primary_background_icon_color = "{primaryBackground}";
const $f551aa6589c293c2$var$icon_variant_color_secondary_50_icon_color = "{secondary50}";
const $f551aa6589c293c2$var$icon_variant_color_sparkle_50_icon_color = "{sparkle50}";
const $f551aa6589c293c2$var$icon_variant_color_primary_grey_60_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$icon_variant_color_primary_grey_80_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$icon_variant_color_primary_grey_100_icon_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$icon_variant_color_feedback_success_icon_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$icon_variant_color_feedback_error_icon_color = "{feedbackError50}";
const $f551aa6589c293c2$var$icon_variant_color_feedback_warning_icon_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$icon_variant_color_white_icon_color = "{global.white}";
const $f551aa6589c293c2$var$icon_variant_size_small_container_size = "{base}";
const $f551aa6589c293c2$var$icon_variant_size_small_icon_size = "{base}";
const $f551aa6589c293c2$var$icon_variant_size_large_container_size = "{l}";
const $f551aa6589c293c2$var$icon_variant_size_large_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_variant_size_fill_container_size = "{size.max}";
const $f551aa6589c293c2$var$icon_variant_size_fill_icon_size = "{size.max}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_50_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_30_icon_color = "{primary30}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_60_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_70_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_background_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_secondary_50_icon_color = "{secondaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_sparkle_50_icon_color = "{sparkleInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_60_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_80_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_100_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_white_icon_color = "{global.white}";
const $f551aa6589c293c2$var$icon_combination_background_bold_feedback_success_50_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_feedback_error_50_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_background_bold_feedback_warning_50_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_medium_background_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_icon_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_small_background_container_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_small_background_icon_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_large_background_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_50_icon_color = "{primary50}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_30_icon_color = "{primary30}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_60_icon_color = "{primary60}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_70_icon_color = "{primary70}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_background_icon_color = "{primaryBackground}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_secondary_50_icon_color = "{secondary50}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_sparkle_50_icon_color = "{sparkle50}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_60_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_80_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_100_icon_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_white_icon_color = "{global.white}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_success_50_icon_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_error_50_icon_color = "{feedbackError50}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_warning_50_icon_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_icon_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_container_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_small_background_bold_icon_size = "{base}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_success_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_error_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_warning_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_success_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_error_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_feedback_warning_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_success_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_error_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_warning_container_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_success_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_error_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_warning_icon_size = "{m}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_success_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_error_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_warning_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_success_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_error_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_feedback_warning_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_success_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_error_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_warning_container_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_success_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_error_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_warning_icon_size = "{l}";
const $f551aa6589c293c2$var$icon_combination_inverse_primary_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$icon_combination_inverse_secondary_icon_color = "{secondaryInverse}";
const $f551aa6589c293c2$var$icon_combination_inverse_sparkle_icon_color = "{sparkleInverse}";
const $f551aa6589c293c2$var$icon_combination_inverse_feedback_icon_color = "{global.white}";
const $f551aa6589c293c2$var$IconTokens = {
    "icon_base_container_background-color": "{global.transparent}",
    "icon_base_container_border-radius": "{pill}",
    icon_base_container_size: $f551aa6589c293c2$var$icon_base_container_size,
    "icon_base_container_justify-content": "{justifyContent.center}",
    "icon_base_container_align-items": "{alignItems.center}",
    icon_base_icon_size: $f551aa6589c293c2$var$icon_base_icon_size,
    icon_base_icon_color: $f551aa6589c293c2$var$icon_base_icon_color,
    icon_variant_color_primary_50_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_50_icon_color,
    icon_variant_color_primary_30_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_30_icon_color,
    icon_variant_color_primary_60_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_60_icon_color,
    icon_variant_color_primary_70_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_70_icon_color,
    icon_variant_color_primary_background_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_background_icon_color,
    icon_variant_color_secondary_50_icon_color: $f551aa6589c293c2$var$icon_variant_color_secondary_50_icon_color,
    icon_variant_color_sparkle_50_icon_color: $f551aa6589c293c2$var$icon_variant_color_sparkle_50_icon_color,
    icon_variant_color_primary_grey_60_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_grey_60_icon_color,
    icon_variant_color_primary_grey_80_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_grey_80_icon_color,
    icon_variant_color_primary_grey_100_icon_color: $f551aa6589c293c2$var$icon_variant_color_primary_grey_100_icon_color,
    icon_variant_color_feedback_success_icon_color: $f551aa6589c293c2$var$icon_variant_color_feedback_success_icon_color,
    icon_variant_color_feedback_error_icon_color: $f551aa6589c293c2$var$icon_variant_color_feedback_error_icon_color,
    icon_variant_color_feedback_warning_icon_color: $f551aa6589c293c2$var$icon_variant_color_feedback_warning_icon_color,
    icon_variant_color_white_icon_color: $f551aa6589c293c2$var$icon_variant_color_white_icon_color,
    icon_variant_size_small_container_size: $f551aa6589c293c2$var$icon_variant_size_small_container_size,
    icon_variant_size_small_icon_size: $f551aa6589c293c2$var$icon_variant_size_small_icon_size,
    icon_variant_size_large_container_size: $f551aa6589c293c2$var$icon_variant_size_large_container_size,
    icon_variant_size_large_icon_size: $f551aa6589c293c2$var$icon_variant_size_large_icon_size,
    "icon_variant_size_xtra-large_container_size": "{xl}",
    "icon_variant_size_xtra-large_icon_size": "{xl}",
    "icon_variant_size_xtra-xtra-large_container_size": "{xxl}",
    "icon_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    icon_variant_size_fill_container_size: $f551aa6589c293c2$var$icon_variant_size_fill_container_size,
    icon_variant_size_fill_icon_size: $f551aa6589c293c2$var$icon_variant_size_fill_icon_size,
    "icon_combination_background_primary_50_container_background-color": "{primary20}",
    "icon_combination_background_primary_30_container_background-color": "{primary20}",
    "icon_combination_background_primary_60_container_background-color": "{primary20}",
    "icon_combination_background_primary_70_container_background-color": "{primary20}",
    "icon_combination_background_primary_background_container_background-color": "{primary20}",
    "icon_combination_background_secondary_50_container_background-color": "{secondary20}",
    "icon_combination_background_sparkle_50_container_background-color": "{sparkle20}",
    "icon_combination_background_primary_grey_60_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_80_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_100_container_background-color": "{primaryGrey20}",
    "icon_combination_background_white_container_background-color": "{primary20}",
    "icon_combination_background_feedback_success_50_container_background-color": "{feedbackSuccess20}",
    "icon_combination_background_feedback_error_50_container_background-color": "{feedbackError20}",
    "icon_combination_background_feedback_warning_50_container_background-color": "{feedbackWarning20}",
    "icon_combination_background_bold_primary_50_container_background-color": "{primary50}",
    icon_combination_background_bold_primary_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_50_icon_color,
    "icon_combination_background_bold_primary_30_container_background-color": "{primary30}",
    icon_combination_background_bold_primary_30_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_30_icon_color,
    "icon_combination_background_bold_primary_60_container_background-color": "{primary60}",
    icon_combination_background_bold_primary_60_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_60_icon_color,
    "icon_combination_background_bold_primary_70_container_background-color": "{primary70}",
    icon_combination_background_bold_primary_70_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_70_icon_color,
    "icon_combination_background_bold_primary_background_container_background-color": "{primaryBackground}",
    icon_combination_background_bold_primary_background_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_background_icon_color,
    "icon_combination_background_bold_secondary_50_container_background-color": "{secondary50}",
    icon_combination_background_bold_secondary_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_secondary_50_icon_color,
    "icon_combination_background_bold_sparkle_50_container_background-color": "{sparkle50}",
    icon_combination_background_bold_sparkle_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_sparkle_50_icon_color,
    "icon_combination_background_bold_primary_grey_60_container_background-color": "{primaryGrey60}",
    icon_combination_background_bold_primary_grey_60_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_60_icon_color,
    "icon_combination_background_bold_primary_grey_80_container_background-color": "{primaryGrey80}",
    icon_combination_background_bold_primary_grey_80_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_80_icon_color,
    "icon_combination_background_bold_primary_grey_100_container_background-color": "{primaryGrey100}",
    icon_combination_background_bold_primary_grey_100_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_primary_grey_100_icon_color,
    "icon_combination_background_bold_white_container_background-color": "{global.white}",
    icon_combination_background_bold_white_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_white_icon_color,
    "icon_combination_background_bold_feedback_success_50_container_background-color": "{feedbackSuccess50}",
    icon_combination_background_bold_feedback_success_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_feedback_success_50_icon_color,
    "icon_combination_background_bold_feedback_error_50_container_background-color": "{feedbackError50}",
    icon_combination_background_bold_feedback_error_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_feedback_error_50_icon_color,
    "icon_combination_background_bold_feedback_warning_50_container_background-color": "{feedbackWarning50}",
    icon_combination_background_bold_feedback_warning_50_icon_color: $f551aa6589c293c2$var$icon_combination_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_container_size,
    icon_combination_medium_background_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_icon_size,
    icon_combination_small_background_container_size: $f551aa6589c293c2$var$icon_combination_small_background_container_size,
    "icon_combination_small_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_icon_size: $f551aa6589c293c2$var$icon_combination_small_background_icon_size,
    icon_combination_large_background_container_size: $f551aa6589c293c2$var$icon_combination_large_background_container_size,
    icon_combination_large_background_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_icon_size,
    "icon_combination_xtra-large_background_container_size": "{xl}",
    "icon_combination_xtra-large_background_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_icon_size": "{l}",
    "icon_combination_small_background_bold_primary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_50_icon_color,
    "icon_combination_small_background_bold_primary_30_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_30_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_30_icon_color,
    "icon_combination_small_background_bold_primary_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_60_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_60_icon_color,
    "icon_combination_small_background_bold_primary_70_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_70_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_70_icon_color,
    "icon_combination_small_background_bold_primary_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_background_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_background_icon_color,
    "icon_combination_small_background_bold_secondary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_secondary_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_secondary_50_icon_color,
    "icon_combination_small_background_bold_sparkle_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_sparkle_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_sparkle_50_icon_color,
    "icon_combination_small_background_bold_primary_grey_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_60_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_60_icon_color,
    "icon_combination_small_background_bold_primary_grey_80_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_80_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_80_icon_color,
    "icon_combination_small_background_bold_primary_grey_100_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_100_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_primary_grey_100_icon_color,
    "icon_combination_small_background_bold_white_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_white_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_white_icon_color,
    "icon_combination_small_background_bold_feedback_success_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_success_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_success_50_icon_color,
    "icon_combination_small_background_bold_feedback_error_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_error_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_error_50_icon_color,
    "icon_combination_small_background_bold_feedback_warning_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_warning_50_icon_color: $f551aa6589c293c2$var$icon_combination_small_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_bold_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_container_size,
    icon_combination_medium_background_bold_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_icon_size,
    icon_combination_small_background_bold_container_size: $f551aa6589c293c2$var$icon_combination_small_background_bold_container_size,
    icon_combination_small_background_bold_icon_size: $f551aa6589c293c2$var$icon_combination_small_background_bold_icon_size,
    icon_combination_large_background_bold_container_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_container_size,
    icon_combination_large_background_bold_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_icon_size,
    "icon_combination_xtra-large_background_bold_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_bold_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_icon_size": "{l}",
    icon_combination_medium_background_feedback_success_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_success_container_size,
    icon_combination_medium_background_feedback_error_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_error_container_size,
    icon_combination_medium_background_feedback_warning_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_warning_container_size,
    icon_combination_medium_background_feedback_success_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_success_icon_size,
    icon_combination_medium_background_feedback_error_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_error_icon_size,
    icon_combination_medium_background_feedback_warning_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_feedback_warning_icon_size,
    icon_combination_medium_background_bold_feedback_success_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_success_container_size,
    icon_combination_medium_background_bold_feedback_error_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_error_container_size,
    icon_combination_medium_background_bold_feedback_warning_container_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_warning_container_size,
    icon_combination_medium_background_bold_feedback_success_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_success_icon_size,
    icon_combination_medium_background_bold_feedback_error_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_error_icon_size,
    icon_combination_medium_background_bold_feedback_warning_icon_size: $f551aa6589c293c2$var$icon_combination_medium_background_bold_feedback_warning_icon_size,
    icon_combination_large_background_feedback_success_container_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_success_container_size,
    icon_combination_large_background_feedback_error_container_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_error_container_size,
    icon_combination_large_background_feedback_warning_container_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_warning_container_size,
    icon_combination_large_background_feedback_success_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_success_icon_size,
    icon_combination_large_background_feedback_error_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_error_icon_size,
    icon_combination_large_background_feedback_warning_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_feedback_warning_icon_size,
    icon_combination_large_background_bold_feedback_success_container_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_success_container_size,
    icon_combination_large_background_bold_feedback_error_container_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_error_container_size,
    icon_combination_large_background_bold_feedback_warning_container_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_warning_container_size,
    icon_combination_large_background_bold_feedback_success_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_success_icon_size,
    icon_combination_large_background_bold_feedback_error_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_error_icon_size,
    icon_combination_large_background_bold_feedback_warning_icon_size: $f551aa6589c293c2$var$icon_combination_large_background_bold_feedback_warning_icon_size,
    "icon_combination_xtra-large_background_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_icon_size": "{xxl}",
    icon_combination_inverse_primary_icon_color: $f551aa6589c293c2$var$icon_combination_inverse_primary_icon_color,
    icon_combination_inverse_secondary_icon_color: $f551aa6589c293c2$var$icon_combination_inverse_secondary_icon_color,
    icon_combination_inverse_sparkle_icon_color: $f551aa6589c293c2$var$icon_combination_inverse_sparkle_icon_color,
    icon_combination_inverse_feedback_icon_color: $f551aa6589c293c2$var$icon_combination_inverse_feedback_icon_color
};
const $f551aa6589c293c2$var$image_base_container_width = "{size.min}";
const $f551aa6589c293c2$var$image_base_container_height = "{size.min}";
const $f551aa6589c293c2$var$image_base_image_width = "{size.max}";
const $f551aa6589c293c2$var$image_base_lottie_size = "{size.max}";
const $f551aa6589c293c2$var$image_base_icon_size = "{l}";
const $f551aa6589c293c2$var$image_base_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$image_variant_state_loading_image_opacity = "{opacity.invisible}";
const $f551aa6589c293c2$var$image_variant_state_empty_image_opacity = "{opacity.invisible}";
const $f551aa6589c293c2$var$image_variant_state_error_image_opacity = "{opacity.invisible}";
const $f551aa6589c293c2$var$ImageTokens = {
    "image_base_container_background-color": "{global.transparent}",
    "image_base_container_flex-direction": "{flexDirection.stack}",
    "image_base_container_justify-content": "{justifyContent.center}",
    "image_base_container_align-items": "{alignItems.center}",
    image_base_container_width: $f551aa6589c293c2$var$image_base_container_width,
    image_base_container_height: $f551aa6589c293c2$var$image_base_container_height,
    "image_base_container_border-radius": "{xl}",
    "image_base_image_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_image_border-radius": "{xl}",
    image_base_image_width: $f551aa6589c293c2$var$image_base_image_width,
    image_base_lottie_size: $f551aa6589c293c2$var$image_base_lottie_size,
    image_base_icon_size: $f551aa6589c293c2$var$image_base_icon_size,
    image_base_icon_color: $f551aa6589c293c2$var$image_base_icon_color,
    "image_base_provider-slot_width": "{size.max}",
    "image_base_skeleton-container_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_skeleton-container_width": "{size.max}",
    "image_base_skeleton-slot_size": "{size.max}",
    "image_variant_state_loading_container_background-color": "{primaryGrey20}",
    image_variant_state_loading_image_opacity: $f551aa6589c293c2$var$image_variant_state_loading_image_opacity,
    "image_variant_state_empty_container_background-color": "{primaryGrey20}",
    image_variant_state_empty_image_opacity: $f551aa6589c293c2$var$image_variant_state_empty_image_opacity,
    "image_variant_state_error_container_background-color": "{primaryGrey20}",
    image_variant_state_error_image_opacity: $f551aa6589c293c2$var$image_variant_state_error_image_opacity,
    "image_combination_horizontal_4_3_true_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_5_4_true_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_16_9_true_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_true_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_vertical_4_5_true_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_3_4_true_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_9_16_true_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_true_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_horizontal_2_75__1_true_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_true_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}"
};
const $f551aa6589c293c2$var$inputcode_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$inputcode_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$inputcode_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$inputcode_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$InputCodeTokens = {
    "inputcode_base_container_flex-direction": "{flexDirection.column}",
    "inputcode_base_container_justify-content": "{justifyContent.start}",
    "inputcode_base_container_align-items": "{alignItems.start}",
    inputcode_base_container_width: $f551aa6589c293c2$var$inputcode_base_container_width,
    inputcode_base_container_gap: $f551aa6589c293c2$var$inputcode_base_container_gap,
    "inputcode_base_field-container_flex-direction": "{flexDirection.row}",
    "inputcode_base_field-container_justify-content": "{justifyContent.center}",
    "inputcode_base_field-container_align-items": "{alignItems.center}",
    "inputcode_base_field-container_width": "{size.max}",
    "inputcode_base_field-container_gap": "{xs}",
    inputcode_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$inputcode_variant_disabled_true_container_opacity,
    inputcode_base_container_opacity: $f551aa6589c293c2$var$inputcode_base_container_opacity
};
const $f551aa6589c293c2$var$input_base_input_width = "{size.max}";
const $f551aa6589c293c2$var$input_variant_disabled_true_input_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$input_variant_color_primary_80_input_text_color = "{primary80}";
const $f551aa6589c293c2$var$input_variant_color_primary_70_input_text_color = "{primary70}";
const $f551aa6589c293c2$var$input_variant_color_primary_60_input_text_color = "{primary60}";
const $f551aa6589c293c2$var$input_variant_color_primary_50_input_text_color = "{primary50}";
const $f551aa6589c293c2$var$input_variant_color_primary_40_input_text_color = "{primary40}";
const $f551aa6589c293c2$var$input_variant_color_primary_30_input_text_color = "{primary30}";
const $f551aa6589c293c2$var$input_variant_color_primary_20_input_text_color = "{primary20}";
const $f551aa6589c293c2$var$input_variant_color_primary_inverse_input_text_color = "{primaryInverse}";
const $f551aa6589c293c2$var$input_variant_color_primary_background_input_text_color = "{primaryBackground}";
const $f551aa6589c293c2$var$input_variant_color_primary_grey_100_input_text_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$input_variant_color_primary_grey_80_input_text_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$input_variant_color_primary_grey_60_input_text_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$input_variant_color_primary_grey_40_input_text_color = "{primaryGrey40}";
const $f551aa6589c293c2$var$input_variant_color_primary_grey_20_input_text_color = "{primaryGrey20}";
const $f551aa6589c293c2$var$input_variant_color_secondary_80_input_text_color = "{secondary80}";
const $f551aa6589c293c2$var$input_variant_color_secondary_70_input_text_color = "{secondary70}";
const $f551aa6589c293c2$var$input_variant_color_secondary_60_input_text_color = "{secondary60}";
const $f551aa6589c293c2$var$input_variant_color_secondary_50_input_text_color = "{secondary50}";
const $f551aa6589c293c2$var$input_variant_color_secondary_40_input_text_color = "{secondary40}";
const $f551aa6589c293c2$var$input_variant_color_secondary_30_input_text_color = "{secondary30}";
const $f551aa6589c293c2$var$input_variant_color_secondary_20_input_text_color = "{secondary20}";
const $f551aa6589c293c2$var$input_variant_color_secondary_inverse_input_text_color = "{secondaryInverse}";
const $f551aa6589c293c2$var$input_variant_color_secondary_background_input_text_color = "{secondaryBackground}";
const $f551aa6589c293c2$var$input_variant_color_secondary_grey_100_input_text_color = "{secondaryGrey100}";
const $f551aa6589c293c2$var$input_variant_color_secondary_grey_80_input_text_color = "{secondaryGrey80}";
const $f551aa6589c293c2$var$input_variant_color_secondary_grey_60_input_text_color = "{secondaryGrey60}";
const $f551aa6589c293c2$var$input_variant_color_secondary_grey_40_input_text_color = "{secondaryGrey40}";
const $f551aa6589c293c2$var$input_variant_color_secondary_grey_20_input_text_color = "{secondaryGrey20}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_80_input_text_color = "{sparkle80}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_70_input_text_color = "{sparkle70}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_60_input_text_color = "{sparkle60}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_50_input_text_color = "{sparkle50}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_40_input_text_color = "{sparkle40}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_30_input_text_color = "{sparkle30}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_20_input_text_color = "{sparkle20}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_inverse_input_text_color = "{sparkleInverse}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_background_input_text_color = "{sparkleBackground}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_grey_100_input_text_color = "{sparkleGrey100}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_grey_80_input_text_color = "{sparkleGrey80}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_grey_60_input_text_color = "{sparkleGrey60}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_grey_40_input_text_color = "{sparkleGrey40}";
const $f551aa6589c293c2$var$input_variant_color_sparkle_grey_20_input_text_color = "{sparkleGrey20}";
const $f551aa6589c293c2$var$input_variant_color_feedback_error_80_input_text_color = "{feedbackError80}";
const $f551aa6589c293c2$var$input_variant_color_feedback_error_50_input_text_color = "{feedbackError50}";
const $f551aa6589c293c2$var$input_variant_color_feedback_error_20_input_text_color = "{feedbackError20}";
const $f551aa6589c293c2$var$input_variant_color_feedback_warning_80_input_text_color = "{feedbackWarning80}";
const $f551aa6589c293c2$var$input_variant_color_feedback_warning_50_input_text_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$input_variant_color_feedback_warning_20_input_text_color = "{feedbackWarning20}";
const $f551aa6589c293c2$var$input_variant_color_feedback_success_80_input_text_color = "{feedbackSuccess80}";
const $f551aa6589c293c2$var$input_variant_color_feedback_success_50_input_text_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$input_variant_color_feedback_success_20_input_text_color = "{feedbackSuccess20}";
const $f551aa6589c293c2$var$input_variant_color_white_input_text_color = "{global.white}";
const $f551aa6589c293c2$var$input_variant_color_black_input_text_color = "{global.black}";
const $f551aa6589c293c2$var$input_variant_color_transparent_input_text_color = "{global.transparent}";
const $f551aa6589c293c2$var$InputTokens = {
    "input_base_input_text-align": "{textAlign.start}",
    "input_base_input_placeholder-color": "{primaryGrey60}",
    "input_base_input_placeholder-font-family": "{bodyS}",
    "input_base_input_placeholder-font-size": "{bodyS}",
    "input_base_input_placeholder-font-weight": "{bodyS}",
    "input_base_input_placeholder-line-height": "{bodyS}",
    "input_base_input_placeholder-letter-spacing": "{bodyS}",
    "input_base_input_input-color": "{primaryGrey100}",
    "input_base_input_input-font-family": "{bodyS}",
    "input_base_input_input-font-size": "{bodyS}",
    "input_base_input_input-font-weight": "{bodyS}",
    "input_base_input_input-line-height": "{bodyS}",
    "input_base_input_input-letter-spacing": "{bodyS}",
    "input_base_input_cursor-color": "{primaryGrey100}",
    input_base_input_width: $f551aa6589c293c2$var$input_base_input_width,
    input_variant_disabled_true_input_opacity: $f551aa6589c293c2$var$input_variant_disabled_true_input_opacity,
    "input_variant_textAlign_center_input_text-align": "{textAlign.center}",
    "input_variant_textAlign_end_input_text-align": "{textAlign.end}",
    "input_variant_textAlign_justify_input_text-align": "{textAlign.justify}",
    "input_variant_textSize_large_input_placeholder-font-family": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-size": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-line-height": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-weight": "{bodyL}",
    "input_variant_textSize_large_input_input-font-family": "{bodyL}",
    "input_variant_textSize_large_input_input-font-size": "{bodyL}",
    "input_variant_textSize_large_input_input-line-height": "{bodyL}",
    "input_variant_textSize_large_input_input-font-weight": "{bodyL}",
    input_variant_color_primary_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_80_input_text_color,
    input_variant_color_primary_70_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_70_input_text_color,
    input_variant_color_primary_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_60_input_text_color,
    input_variant_color_primary_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_50_input_text_color,
    input_variant_color_primary_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_40_input_text_color,
    input_variant_color_primary_30_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_30_input_text_color,
    input_variant_color_primary_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_20_input_text_color,
    input_variant_color_primary_inverse_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_inverse_input_text_color,
    input_variant_color_primary_background_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_background_input_text_color,
    input_variant_color_primary_grey_100_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_grey_100_input_text_color,
    input_variant_color_primary_grey_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_grey_80_input_text_color,
    input_variant_color_primary_grey_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_grey_60_input_text_color,
    input_variant_color_primary_grey_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_grey_40_input_text_color,
    input_variant_color_primary_grey_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_primary_grey_20_input_text_color,
    input_variant_color_secondary_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_80_input_text_color,
    input_variant_color_secondary_70_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_70_input_text_color,
    input_variant_color_secondary_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_60_input_text_color,
    input_variant_color_secondary_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_50_input_text_color,
    input_variant_color_secondary_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_40_input_text_color,
    input_variant_color_secondary_30_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_30_input_text_color,
    input_variant_color_secondary_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_20_input_text_color,
    input_variant_color_secondary_inverse_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_inverse_input_text_color,
    input_variant_color_secondary_background_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_background_input_text_color,
    input_variant_color_secondary_grey_100_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_grey_100_input_text_color,
    input_variant_color_secondary_grey_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_grey_80_input_text_color,
    input_variant_color_secondary_grey_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_grey_60_input_text_color,
    input_variant_color_secondary_grey_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_grey_40_input_text_color,
    input_variant_color_secondary_grey_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_secondary_grey_20_input_text_color,
    input_variant_color_sparkle_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_80_input_text_color,
    input_variant_color_sparkle_70_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_70_input_text_color,
    input_variant_color_sparkle_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_60_input_text_color,
    input_variant_color_sparkle_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_50_input_text_color,
    input_variant_color_sparkle_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_40_input_text_color,
    input_variant_color_sparkle_30_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_30_input_text_color,
    input_variant_color_sparkle_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_20_input_text_color,
    input_variant_color_sparkle_inverse_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_inverse_input_text_color,
    input_variant_color_sparkle_background_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_background_input_text_color,
    input_variant_color_sparkle_grey_100_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_grey_100_input_text_color,
    input_variant_color_sparkle_grey_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_grey_80_input_text_color,
    input_variant_color_sparkle_grey_60_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_grey_60_input_text_color,
    input_variant_color_sparkle_grey_40_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_grey_40_input_text_color,
    input_variant_color_sparkle_grey_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_sparkle_grey_20_input_text_color,
    input_variant_color_feedback_error_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_error_80_input_text_color,
    input_variant_color_feedback_error_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_error_50_input_text_color,
    input_variant_color_feedback_error_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_error_20_input_text_color,
    input_variant_color_feedback_warning_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_warning_80_input_text_color,
    input_variant_color_feedback_warning_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_warning_50_input_text_color,
    input_variant_color_feedback_warning_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_warning_20_input_text_color,
    input_variant_color_feedback_success_80_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_success_80_input_text_color,
    input_variant_color_feedback_success_50_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_success_50_input_text_color,
    input_variant_color_feedback_success_20_input_text_color: $f551aa6589c293c2$var$input_variant_color_feedback_success_20_input_text_color,
    input_variant_color_white_input_text_color: $f551aa6589c293c2$var$input_variant_color_white_input_text_color,
    input_variant_color_black_input_text_color: $f551aa6589c293c2$var$input_variant_color_black_input_text_color,
    input_variant_color_transparent_input_text_color: $f551aa6589c293c2$var$input_variant_color_transparent_input_text_color
};
const $f551aa6589c293c2$var$inputdate_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$inputdate_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$inputdate_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$InputDateTokens = {
    "inputdate_base_container_flex-direction": "{flexDirection.column}",
    "inputdate_base_container_align-items": "{alignItems.start}",
    inputdate_base_container_gap: $f551aa6589c293c2$var$inputdate_base_container_gap,
    inputdate_base_container_width: $f551aa6589c293c2$var$inputdate_base_container_width,
    "inputdate_base_outer-container_flex-direction": "{flexDirection.row}",
    "inputdate_base_outer-container_width": "{size.max}",
    "inputdate_base_outer-container_align-items": "{alignItems.center}",
    "inputdate_base_field-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_field-container_width": "{size.max}",
    "inputdate_base_field-container_align-items": "{alignItems.start}",
    "inputdate_base_input-container_width": "{size.max}",
    "inputdate_base_input-container_gap": "{s}",
    "inputdate_base_input-container_align-items": "{alignItems.stretch}",
    "inputdate_base_dd-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_dd-container_gap": "{xs}",
    "inputdate_base_dd-container_align-items": "{alignItems.start}",
    "inputdate_base_dd-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_dd-active-line-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_left-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_mm-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_mm-container_gap": "{xs}",
    "inputdate_base_mm-container_align-items": "{alignItems.start}",
    "inputdate_base_mm-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_mm-active-line-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_right-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_yy-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_yy-container_gap": "{xs}",
    "inputdate_base_yy-container_align-items": "{alignItems.start}",
    "inputdate_base_yy-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_yy-active-line-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_calendar-container_justify-content": "{justifyContent.center}",
    "inputdate_base_calendar-container_align-items": "{alignItems.center}",
    "inputdate_base_bottom-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_bottom-container_align-items": "{alignItems.start}",
    "inputdate_base_bottom-container_gap": "{xs}",
    "inputdate_base_bottom-container_width": "{size.max}",
    inputdate_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$inputdate_variant_disabled_true_container_opacity,
    "inputdate_variant_disabled_true_bottom-container_opacity": "{opacity.disabled}",
    "inputdate_variant_error_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_yy-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_ddError_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_mmError_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_yyError_true_yy-feedback-container_background-color": "{feedbackError50}"
};
const $f551aa6589c293c2$var$inputcodeitem_base_jds_input_width = "{size.max}";
const $f551aa6589c293c2$var$InputCodeItemTokens = {
    "inputcodeitem_base_input-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_input-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_input-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_input-container_gap": "{xs}",
    "inputcodeitem_base_input-container_input_width": "{size.max}",
    inputcodeitem_base_jds_input_width: $f551aa6589c293c2$var$inputcodeitem_base_jds_input_width,
    "inputcodeitem_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_active-line-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_active-line-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_active-line-container_width": "{size.max}",
    "inputcodeitem_base_active-line-container_padding-top": "{custom_1}",
    "inputcodeitem_base_active-line-container_padding-bottom": "{custom_1}",
    "inputcodeitem_base_feedback-container_width": "{size.max}",
    "inputcodeitem_base_feedback-container_height": "{custom_4}",
    "inputcodeitem_base_feedback-container_background-color": "{primaryGrey100}",
    "inputcodeitem_base_feedback-container_border-radius": "{custom_2}",
    "inputcodeitem_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_active_background-color": "{primary50}",
    "inputcodeitem_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputcodeitem_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputcodeitem_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputcodeitem_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $f551aa6589c293c2$var$fileuploader_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$fileuploader_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$fileuploader_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$FileUploaderTokens = {
    "fileuploader_base_container_flex-direction": "{flexDirection.column}",
    "fileuploader_base_container_justify-content": "{justifyContent.start}",
    "fileuploader_base_container_align-items": "{alignItems.start}",
    fileuploader_base_container_width: $f551aa6589c293c2$var$fileuploader_base_container_width,
    fileuploader_base_container_gap: $f551aa6589c293c2$var$fileuploader_base_container_gap,
    fileuploader_base_container_opacity: $f551aa6589c293c2$var$fileuploader_base_container_opacity
};
const $f551aa6589c293c2$var$fileuploadercontrol_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$fileuploadercontrol_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$fileuploadercontrol_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$FileUploaderControlTokens = {
    "fileuploadercontrol_base_container_flex-direction": "{flexDirection.column}",
    "fileuploadercontrol_base_container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_container_align-items": "{alignItems.start}",
    fileuploadercontrol_base_container_gap: $f551aa6589c293c2$var$fileuploadercontrol_base_container_gap,
    fileuploadercontrol_base_container_width: $f551aa6589c293c2$var$fileuploadercontrol_base_container_width,
    fileuploadercontrol_base_container_opacity: $f551aa6589c293c2$var$fileuploadercontrol_base_container_opacity,
    "fileuploadercontrol_base_label-container_flex-direction": "{flexDirection.row}",
    "fileuploadercontrol_base_label-container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_label-container_align-items": "{alignItems.center}",
    "fileuploadercontrol_base_label-container_gap": "{xxs}"
};
const $f551aa6589c293c2$var$fileuploaderitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$fileuploaderitem_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$FileUploaderItemTokens = {
    "fileuploaderitem_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderitem_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_container_align-items": "{alignItems.start}",
    fileuploaderitem_base_container_width: $f551aa6589c293c2$var$fileuploaderitem_base_container_width,
    fileuploaderitem_base_container_opacity: $f551aa6589c293c2$var$fileuploaderitem_base_container_opacity,
    "fileuploaderitem_base_container_background-color": "{primaryGrey20}",
    "fileuploaderitem_base_file-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_file-container_justify-content": "{justifyContent.spaceBetween}",
    "fileuploaderitem_base_file-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_file-container_gap": "{xs}",
    "fileuploaderitem_base_file-container_padding-left": "{s}",
    "fileuploaderitem_base_file-container_width": "{size.max}",
    "fileuploaderitem_base_state-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_state-container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_state-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_state-container_gap": "{xs}",
    "fileuploaderitem_base_button-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$fileuploaderlist_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$fileuploaderlist_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$FileUploaderListTokens = {
    "fileuploaderlist_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderlist_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderlist_base_container_align-items": "{alignItems.start}",
    fileuploaderlist_base_container_width: $f551aa6589c293c2$var$fileuploaderlist_base_container_width,
    fileuploaderlist_base_container_opacity: $f551aa6589c293c2$var$fileuploaderlist_base_container_opacity,
    "fileuploaderlist_base_container_background-color": "{primaryGrey20}",
    "fileuploaderlist_base_container_border-radius": "{large}"
};
const $f551aa6589c293c2$var$fileuploaderpanel_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$fileuploaderpanel_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$FileUploaderPanelTokens = {
    "fileuploaderpanel_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderpanel_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderpanel_base_container_align-items": "{alignItems.start}",
    fileuploaderpanel_base_container_width: $f551aa6589c293c2$var$fileuploaderpanel_base_container_width,
    fileuploaderpanel_base_container_opacity: $f551aa6589c293c2$var$fileuploaderpanel_base_container_opacity,
    "fileuploaderpanel_base_container_background-color": "{primaryGrey20}",
    "fileuploaderpanel_base_container_border-radius": "{large}",
    "fileuploaderpanel_base_container_padding-top": "{xs}",
    "fileuploaderpanel_base_container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-top": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-left": "{s}",
    "fileuploaderpanel_base_inner-container_padding-right": "{s}",
    "fileuploaderpanel_base_inner-container_width": "{size.max}"
};
const $f551aa6589c293c2$var$textarea_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$textarea_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$textarea_base_input_width = "{size.max}";
const $f551aa6589c293c2$var$textarea_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$textarea_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$TextareaTokens = {
    "textarea_base_container_flex-direction": "{flexDirection.column}",
    "textarea_base_container_justify-content": "{justifyContent.start}",
    "textarea_base_container_align-items": "{alignItems.start}",
    textarea_base_container_gap: $f551aa6589c293c2$var$textarea_base_container_gap,
    textarea_base_container_width: $f551aa6589c293c2$var$textarea_base_container_width,
    "textarea_base_field-container_flex-direction": "{flexDirection.stack}",
    "textarea_base_field-container_width": "{size.max}",
    "textarea_base_field-container_padding-bottom": "{xxs}",
    "textarea_base_field-container_justify-content": "{justifyContent.start}",
    "textarea_base_field-container_align-items": "{alignItems.end}",
    "textarea_base_input-container_flex-direction": "{flexDirection.row}",
    "textarea_base_input-container_justify-content": "{justifyContent.start}",
    "textarea_base_input-container_width": "{size.max}",
    "textarea_base_input-container_align-items": "{alignItems.center}",
    "textarea_base_input_text-align": "{textAlign.start}",
    "textarea_base_input_placeholder-color": "{primaryGrey60}",
    "textarea_base_input_placeholder-font-family": "{bodyS}",
    "textarea_base_input_placeholder-font-size": "{bodyS}",
    "textarea_base_input_placeholder-line-height": "{bodyS}",
    "textarea_base_input_placeholder-letter-spacing": "{bodyS}",
    "textarea_base_input_placeholder-font-weight": "{bodyS}",
    "textarea_base_input_input-color": "{primaryGrey100}",
    "textarea_base_input_input-font-family": "{bodyS}",
    "textarea_base_input_input-font-size": "{bodyS}",
    "textarea_base_input_input-line-height": "{bodyS}",
    "textarea_base_input_input-letter-spacing": "{bodyS}",
    "textarea_base_input_input-font-weight": "{bodyS}",
    "textarea_base_input_resize-color": "{primaryGrey100}",
    "textarea_base_input_cursor-color": "{primaryGrey100}",
    textarea_base_input_width: $f551aa6589c293c2$var$textarea_base_input_width,
    "textarea_base_input_behavior_hover_resize-color": "{primary50}",
    "textarea_base_input_behavior_focus_resize-color": "{primary60}",
    "textarea_base_input_behavior_active_resize-color": "{primary60}",
    "textarea_base_active-line-container_flex-direction": "{flexDirection.column}",
    "textarea_base_active-line-container_width": "{size.max}",
    "textarea_base_active-line-container_align-items": "{alignItems.center}",
    "textarea_base_feedback-container_width": "{size.max}",
    "textarea_base_feedback-container_background-color": "{primaryGrey100}",
    "textarea_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "textarea_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "textarea_base_feedback-container_behavior_active_background-color": "{primary60}",
    textarea_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$textarea_variant_disabled_true_container_opacity,
    textarea_base_container_opacity: $f551aa6589c293c2$var$textarea_base_container_opacity,
    "textarea_variant_border_true-input-container_border-width": "{border_thin}",
    "textarea_variant_border_true-input-container_background-color": "{primaryGrey60}",
    "textarea_variant_border_true-input-container_padding-top": "{custom_17}",
    "textarea_variant_border_true-input-container_border-radius": "{medium}",
    "textarea_variant_border_true-input-container_padding-bottom": "{custom_17}",
    "textarea_variant_border_true-input-container_padding-left": "{base}",
    "textarea_variant_border_true-input-container_padding-right": "{s}",
    "textarea_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_hover_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_focus_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_active_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "textarea_variant_state_error_input_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_hover_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_focus_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_active_resize-color": "{feedbackError50}",
    "textarea_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_hover_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_focus_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_active_resize-color": "{feedbackWarning50}",
    "textarea_variant__labelFocus_true_field-container_align-items": "{alignItems.start}",
    "textarea_combination_none_true_feedback-container_background-color": "{primary60}",
    "textarea_combination_none_true_input_resize-color": "{primary60}",
    "textarea_combination_true_true_field-container_border-color": "{primaryGrey40}",
    "textarea_combination_true_true_input_resize-color": "{primaryGrey60}",
    "textarea_combination_true_true_input_input-color": "{primaryGrey80}"
};
const $f551aa6589c293c2$var$LinkTokens = {
    "link_base_container_background-color": "{global.transparent}",
    "link_base_container_flex-direction": "{flexDirection.row}",
    "link_base_container_justify-content": "{justifyContent.center}",
    "link_base_container_align-items": "{alignItems.center}",
    "link_base_container_behavior_focus_border-radius": "{small}",
    "link_base_container_behavior_focus_border-width": "{border_normal}",
    "link_base_container_behavior_focus_border-color": "{primary60}",
    "link_variant_kind_header_container_behavior_focus_border-color": "{primary30}",
    "link_variant_kind_submenu_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_header_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_behavior_hover_text-decoration": "{text-decoration.none}",
    "link_combination_default_none_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}"
};
const $f551aa6589c293c2$var$menublock_base_container_width = "{intrinsicSize.max}";
const $f551aa6589c293c2$var$MenuBlockTokens = {
    "menublock_base_popup_background-color": "{global.transparent}",
    "menublock_base_popup-container_flex-direction": "{flexDirection.stack}",
    "menublock_base_popup-container_padding-right": "{base}",
    "menublock_base_popup-container_padding-bottom": "{base}",
    "menublock_base_popup-container_width": "{size.max}",
    menublock_base_container_width: $f551aa6589c293c2$var$menublock_base_container_width,
    "menublock_base_container_background-color": "{primaryBackground}",
    "menublock_base_container_flex-direction": "{flexDirection.column}",
    "menublock_base_container_border-radius": "{medium}",
    "menublock_base_popup-container_max-height": "{size.max}"
};
const $f551aa6589c293c2$var$inputfield_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$inputfield_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$inputfield_base_jds_input_textAlign = "{textAlign.start}";
const $f551aa6589c293c2$var$inputfield_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$inputfield_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$InputFieldTokens = {
    "inputfield_base_container_flex-direction": "{flexDirection.column}",
    inputfield_base_container_gap: $f551aa6589c293c2$var$inputfield_base_container_gap,
    inputfield_base_container_width: $f551aa6589c293c2$var$inputfield_base_container_width,
    "inputfield_base_container_justify-content": "{justifyContent.start}",
    "inputfield_base_container_align-items": "{alignItems.start}",
    "inputfield_base_field-container_flex-direction": "{flexDirection.stack}",
    "inputfield_base_field-container_width": "{size.max}",
    "inputfield_base_field-container_align-items": "{alignItems.end}",
    "inputfield_base_field-container_justify-content": "{justifyContent.start}",
    "inputfield_base_field-container_padding-bottom": "{xxs}",
    "inputfield_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfield_base_input-container_justify-content": "{justifyContent.start}",
    "inputfield_base_input-container_width": "{size.max}",
    "inputfield_base_input-container_gap": "{xs}",
    "inputfield_base_input-container_align-items": "{alignItems.center}",
    "inputfield_base_prefix-icon_size": "{m}",
    "inputfield_base_prefix-icon_color": "{primaryGrey80}",
    inputfield_base_jds_input_textAlign: $f551aa6589c293c2$var$inputfield_base_jds_input_textAlign,
    "inputfield_base_suffix-icon_size": "{m}",
    "inputfield_base_suffix-icon_color": "{primaryGrey80}",
    "inputfield_base_suffix-icon_behavior_hover_color": "{primary60}",
    "inputfield_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputfield_base_active-line-container_width": "{size.max}",
    "inputfield_base_active-line-container_align-items": "{alignItems.center}",
    "inputfield_base_feedback-container_width": "{size.max}",
    "inputfield_base_feedback-container_background-color": "{primaryGrey80}",
    "inputfield_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputfield_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "inputfield_base_feedback-container_behavior_active_background-color": "{primary60}",
    inputfield_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$inputfield_variant_disabled_true_container_opacity,
    inputfield_base_container_opacity: $f551aa6589c293c2$var$inputfield_base_container_opacity,
    "inputfield_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "inputfield_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "inputfield_combination_true_true_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_true_false_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_false_true_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_false_true_input_label-jds_text_padding-left": "{l}",
    "inputfield_combination_false_false_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $f551aa6589c293c2$var$inputfieldv2_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$inputfieldv2_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$inputfieldv2_base_jds_input_textAlign = "{textAlign.start}";
const $f551aa6589c293c2$var$inputfieldv2_base_jds_input_flex = 1;
const $f551aa6589c293c2$var$inputfieldv2_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$InputFieldV2Tokens = {
    "inputfieldv2_variant_noPrefix_input-container_padding-left": "{s}",
    "inputfieldv2_base_container_flex-direction": "{flexDirection.column}",
    inputfieldv2_base_container_width: $f551aa6589c293c2$var$inputfieldv2_base_container_width,
    "inputfieldv2_base_container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_container_align-items": "{alignItems.start}",
    inputfieldv2_base_container_opacity: $f551aa6589c293c2$var$inputfieldv2_base_container_opacity,
    "inputfieldv2_base_label-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_label-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_label-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_label-container_gap": "{xxs}",
    "inputfieldv2_base_label-container_padding-left": "{xs}",
    "inputfieldv2_base_label-container_padding-right": "{xs}",
    "inputfieldv2_base_label-container_padding-bottom": "{xxs}",
    "inputfieldv2_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_input-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_input-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_input-container_width": "{size.max}",
    "inputfieldv2_base_input-container_height": "{xl}",
    "inputfieldv2_base_input-container_gap": "{xs}",
    "inputfieldv2_base_input-container_padding-left": "{xs}",
    "inputfieldv2_base_input-container_padding-right": "{xs}",
    "inputfieldv2_base_input-container_padding-top": "{xs}",
    "inputfieldv2_base_input-container_padding-bottom": "{xs}",
    "inputfieldv2_base_input-container_border-width": "{border_thin}",
    "inputfieldv2_base_input-container_border-color": "{primaryGrey60}",
    "inputfieldv2_variant_readOnly_true_input-container_border-color": "{primaryGrey40}",
    "inputfieldv2_base_input-container_border-radius": "{medium}",
    "inputfieldv2_base_input-container_behavior_hover_border-color": "{primary50}",
    "inputfieldv2_base_input-container_behavior_active_border-color": "{primary60}",
    "inputfieldv2_base_input-container_behavior_focus_border-color": "{primary60}",
    inputfieldv2_base_jds_input_textAlign: $f551aa6589c293c2$var$inputfieldv2_base_jds_input_textAlign,
    inputfieldv2_base_jds_input_flex: $f551aa6589c293c2$var$inputfieldv2_base_jds_input_flex,
    "inputfieldv2_base_helper-container_flex-direction": "{flexDirection.column}",
    "inputfieldv2_base_helper-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_helper-container_align-items": "{alignItems.start}",
    "inputfieldv2_base_helper-container_gap": "{xxs}",
    "inputfieldv2_base_dynamic-container_gap": "{xxs}",
    "inputfieldv2_base_helper-container_padding-left": "{xs}",
    "inputfieldv2_base_helper-container_padding-right": "{xs}",
    "inputfieldv2_base_helper-container_padding-top": "{xxs}",
    "inputfieldv2_base_dynamic-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_dynamic-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_dynamic-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_dynamic-container_padding-left": "{xs}",
    "inputfieldv2_base_dynamic-container_padding-right": "{xs}",
    inputfieldv2_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$inputfieldv2_variant_disabled_true_container_opacity,
    "inputfieldv2_variant_state_success_input-container_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_hover_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_focus_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_active_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_error_input-container_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_hover_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_focus_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_active_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_warning_input-container_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_hover_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_focus_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_active_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_size_small_input-container_height": "{l}",
    "inputfieldv2_variant_size_small_input-container_padding-top": "{xxs}",
    "inputfieldv2_variant_size_small_input-container_padding-bottom": "{xxs}",
    "inputfieldv2_variant_size_large_input-container_height": "{xxl}",
    "inputfieldv2_variant_size_large_input-container_gap": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-top": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-bottom": "{s}",
    "inputfieldv2_variant_size_large_helper-container_gap": "{xs}",
    "inputfieldv2_variant_size_large_helper-container_padding-top": "{xs}"
};
const $f551aa6589c293c2$var$menublockitem_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$menublockitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$menublockitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$MenuBlockItemTokens = {
    menublockitem_base_container_opacity: $f551aa6589c293c2$var$menublockitem_base_container_opacity,
    "menublockitem_base_container_background-color": "{global.transparent}",
    menublockitem_base_container_width: $f551aa6589c293c2$var$menublockitem_base_container_width,
    "menublockitem_base_entry-container_background-color": "{global.transparent}",
    "menublockitem_base_entry-container_width": "{size.max}",
    "menublockitem_base_entry-container_padding-top": "{xs}",
    "menublockitem_base_entry-container_padding-right": "{base}",
    "menublockitem_base_entry-container_padding-bottom": "{xs}",
    "menublockitem_base_entry-container_padding-left": "{base}",
    "menublockitem_base_entry-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_entry-container_align-items": "{alignItems.center}",
    "menublockitem_base_entry-container_justify-content": "{justifyContent.spaceBetween}",
    "menublockitem_base_entry-container_border-color": "{global.transparent}",
    "menublockitem_base_entry-container_behavior_hover_background-color": "{primaryGrey20}",
    "menublockitem_base_entry-container_behavior_focus_border-color": "{primary60}",
    "menublockitem_base_entry-container_behavior_focus_border-radius": "{small}",
    "menublockitem_base_divider-container_width": "{size.max}",
    "menublockitem_base_heading-container_padding-top": "{xs}",
    "menublockitem_base_heading-container_padding-right": "{base}",
    "menublockitem_base_heading-container_padding-bottom": "{xs}",
    "menublockitem_base_heading-container_padding-left": "{base}",
    "menublockitem_base_heading-container_width": "{size.max}",
    "menublockitem_base_heading-container_align-items": "{alignItems.center}",
    "menublockitem_base_heading-container_justify-content": "{justifyContent.start}",
    "menublockitem_base_left-container_gap": "{xs}",
    "menublockitem_base_left-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_left-container_align-items": "{alignItems.center}",
    "menublockitem_variant_selected_true_container_background-color": "{primaryGrey20}",
    menublockitem_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$menublockitem_variant_disabled_true_container_opacity,
    "menublockitem_variant_hasIcon_true_heading-container_padding-left": "{xxl}"
};
const $f551aa6589c293c2$var$ListBlockTokens = {
    "listblock_base_root-container_flex-direction": "{flexDirection.column}",
    "listblock_base_root-container_width": "{size.max}",
    "listblock_base_root-container_justify-content": "{justifyContent.start}",
    "listblock_base_root-container_align-items": "{alignItems.start}",
    "listblock_base_root-container_gap": "{xs}",
    "listblock_base_root-container_padding-top": "{xs}",
    "listblock_base_root-container_padding-bottom": "{xs}",
    "listblock_base_main-container_flex-direction": "{flexDirection.row}",
    "listblock_base_main-container_width": "{size.max}",
    "listblock_base_main-container_gap": "{base}",
    "listblock_base_main-container_justify-content": "{justifyContent.start}",
    "listblock_base_main-container_align-items": "{alignItems.center}",
    "listblock_base_block-container_flex-direction": "{flexDirection.column}",
    "listblock_base_block-container_gap": "{xxs}",
    "listblock_base_block-container_justify-content": "{justifyContent.start}",
    "listblock_base_block-container_align-items": "{alignItems.start}",
    "listblock_base_caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_caption-container_width": "{size.max}",
    "listblock_base_caption-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_caption-container_align-items": "{alignItems.center}",
    "listblock_base_caption-container_gap": "{s}",
    "listblock_base_inner-caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-caption-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-caption-container_align-items": "{alignItems.center}",
    "listblock_base_inner-caption-container_gap": "{s}",
    "listblock_base_title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_title-container_width": "{size.max}",
    "listblock_base_title-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_title-container_align-items": "{alignItems.center}",
    "listblock_base_title-container_gap": "{s}",
    "listblock_base_inner-title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-title-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-title-container_align-items": "{alignItems.center}",
    "listblock_base_inner-title-container_gap": "{s}",
    "listblock_base_helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_helper-container_width": "{size.max}",
    "listblock_base_helper-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_helper-container_align-items": "{alignItems.center}",
    "listblock_base_helper-container_gap": "{s}",
    "listblock_base_inner-helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-helper-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-helper-container_align-items": "{alignItems.center}",
    "listblock_base_inner-helper-container_gap": "{s}",
    "listblock_variant_spacing_small_main-container_gap": "{s}",
    "listblock_variant_spacing_small_root-container_gap": "{xxs}",
    "listblock_variant_verticalAlignment_top_main-container_align-items": "{alignItems.start}"
};
const $f551aa6589c293c2$var$bottomnavigation_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$bottomnavigation_base_container_gap = "{m}";
const $f551aa6589c293c2$var$bottomnavigation_base_jds_bottom_navigation_item_flex = 1;
const $f551aa6589c293c2$var$BottomNavigationTokens = {
    bottomnavigation_base_container_width: $f551aa6589c293c2$var$bottomnavigation_base_container_width,
    "bottomnavigation_base_container_flex-direction": "{flexDirection.row}",
    "bottomnavigation_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigation_base_container_align-items": "{alignItems.center}",
    "bottomnavigation_base_container_background-color": "{primaryBackground}",
    "bottomnavigation_base_container_padding-left": "{m}",
    "bottomnavigation_base_container_padding-top": "{base}",
    "bottomnavigation_base_container_padding-right": "{m}",
    "bottomnavigation_base_container_padding-bottom": "{base}",
    bottomnavigation_base_container_gap: $f551aa6589c293c2$var$bottomnavigation_base_container_gap,
    "bottomnavigation_base_container_box-shadow_x": 0,
    "bottomnavigation_base_container_box-shadow_y": -1,
    "bottomnavigation_base_container_box-shadow_blur": 0,
    "bottomnavigation_base_container_box-shadow_spread": 0,
    bottomnavigation_base_jds_bottom_navigation_item_flex: $f551aa6589c293c2$var$bottomnavigation_base_jds_bottom_navigation_item_flex,
    "bottomnavigation_base_container_box-shadow_color": "{primaryGrey40}"
};
const $f551aa6589c293c2$var$ModalDesktopTokens = {
    "modaldesktop_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modaldesktop_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktop_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktop_base_popup-container_justify-content": "{justifyContent.center}",
    "modaldesktop_base_popup-container_align-items": "{alignItems.center}",
    "modaldesktop_base_popup-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_background-color": "{global.black}",
    "modaldesktop_base_overlay-container_opacity": "{custom_2}",
    "modaldesktop_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_root-container_align-items": "{alignItems.start}",
    "modaldesktop_base_root-container_border-radius": "{xxl}",
    "modaldesktop_base_root-container_background-color": "{primaryBackground}",
    "modaldesktop_base_root-container_max-height": "{size.max}",
    "modaldesktop_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktop_base_cancel-container_width": "{size.max}",
    "modaldesktop_base_cancel-container_padding-top": "{s}",
    "modaldesktop_base_cancel-container_padding-bottom": "{s}",
    "modaldesktop_base_cancel-container_padding-left": "{s}",
    "modaldesktop_base_cancel-container_padding-right": "{s}",
    "modaldesktop_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktop_base_vertical-container_padding-left": "{l}",
    "modaldesktop_base_vertical-container_padding-right": "{l}",
    "modaldesktop_base_vertical-container_padding-bottom": "{l}",
    "modaldesktop_base_vertical-container_width": "{size.max}",
    "modaldesktop_base_vertical-container_overflow": "auto",
    "modaldesktop_base_custom-container_overflow": "auto",
    "modaldesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_header-container_align-items": "{alignItems.center}",
    "modaldesktop_base_header-container_width": "{size.max}",
    "modaldesktop_base_header-container_padding-bottom": "{base}",
    "modaldesktop_base_children-container_width": "{size.max}",
    "modaldesktop_base_children-container_overflow": "auto",
    "modaldesktop_base_button-container_width": "{size.max}",
    "modaldesktop_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_button-container_align-items": "{alignItems.start}",
    "modaldesktop_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_button-container_gap": "{s}",
    "modaldesktop_base_button-container_padding-top": "{base}",
    "modaldesktop_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktop_base_custom-container_border-radius": "{xxl}",
    "modaldesktop_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktop_base_custom-container_padding-left": "{l}",
    "modaldesktop_base_custom-container_padding-right": "{l}",
    "modaldesktop_base_custom-container_padding-top": "{l}",
    "modaldesktop_base_custom-container_padding-bottom": "{l}",
    "modaldesktop_base_custom-container_width": "{size.max}",
    "modaldesktop_base_custom-container_max-height": "{size.max}",
    "modaldesktop_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktop_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktop_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktop_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktop_combination_acknowledgement_false_vertical-container_padding-top": "{l}"
};
const $f551aa6589c293c2$var$modaldesktopinternal_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$ModalDesktopInternalTokens = {
    "modaldesktopinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modaldesktopinternal_base_container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_base_container_align-items": "{alignItems.center}",
    modaldesktopinternal_base_container_size: $f551aa6589c293c2$var$modaldesktopinternal_base_container_size,
    "modaldesktopinternal_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktopinternal_base_popup-container_transition_duration": "{medium}",
    "modaldesktopinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modaldesktopinternal_base_overlay-container_size": "{size.max}",
    "modaldesktopinternal_base_overlay-container_background-color": "{global.black}",
    "modaldesktopinternal_base_overlay-container_opacity": "{custom_2}",
    "modaldesktopinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_root-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_root-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_root-container_background-color": "{elevation1}",
    "modaldesktopinternal_base_root-container_width": "{custom_27}",
    "modaldesktopinternal_base_root-container_max-height": "{size.max}",
    "modaldesktopinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_cancel-container_width": "{size.max}",
    "modaldesktopinternal_base_cancel-container_padding-top": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-bottom": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-left": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-right": "{s}",
    "modaldesktopinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_vertical-container_padding-left": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-right": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_vertical-container_width": "{size.max}",
    "modaldesktopinternal_base_vertical-container_overflow": "auto",
    "modaldesktopinternal_base_custom-container_overflow": "auto",
    "modaldesktopinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_header-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_header-container_width": "{size.max}",
    "modaldesktopinternal_base_header-container_padding-bottom": "{base}",
    "modaldesktopinternal_base_children-container_width": "{size.max}",
    "modaldesktopinternal_base_children-container_overflow": "auto",
    "modaldesktopinternal_base_button-container_width": "{size.max}",
    "modaldesktopinternal_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_button-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_button-container_gap": "{s}",
    "modaldesktopinternal_base_button-container_padding-top": "{base}",
    "modaldesktopinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_custom-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktopinternal_base_custom-container_padding-left": "{l}",
    "modaldesktopinternal_base_custom-container_padding-right": "{l}",
    "modaldesktopinternal_base_custom-container_padding-top": "{l}",
    "modaldesktopinternal_base_custom-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_custom-container_max-width": "80%",
    "modaldesktopinternal_base_custom-container_max-height": "80%",
    "modaldesktopinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktopinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktopinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}",
    "modaldesktopinternal_combination_medium_desktop_root-container_width": "{custom_27}",
    "modaldesktopinternal_combination_medium_tablet_root-container_width": "{modal_desktop_comibation_medium_width}",
    "modaldesktopinternal_combination_small_desktop_root-container_width": "{modal_desktop_combination_small_width}",
    "modaldesktopinternal_combination_small_tablet_root-container_width": "{modal_desktop_combination_small_width}"
};
const $f551aa6589c293c2$var$bottomnavigationitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$bottomnavigationitem_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$bottomnavigationitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$bottomnavigationitem_variant_enabled_true_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$BottomNavigationItemTokens = {
    bottomnavigationitem_base_container_width: $f551aa6589c293c2$var$bottomnavigationitem_base_container_width,
    "bottomnavigationitem_base_container_flex-direction": "{flexDirection.column}",
    "bottomnavigationitem_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigationitem_base_container_align-items": "{alignItems.center}",
    bottomnavigationitem_base_container_gap: $f551aa6589c293c2$var$bottomnavigationitem_base_container_gap,
    bottomnavigationitem_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$bottomnavigationitem_variant_disabled_true_container_opacity,
    bottomnavigationitem_variant_enabled_true_container_opacity: $f551aa6589c293c2$var$bottomnavigationitem_variant_enabled_true_container_opacity
};
const $f551aa6589c293c2$var$ModalMobileTokens = {
    "modalmobile_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modalmobile_base_popup-container_justify-content": "{justifyContent.center}",
    "modalmobile_base_popup-container_align-items": "{alignItems.center}",
    "modalmobile_base_popup-container_size": "{size.max}",
    "modalmobile_base_popup-container_opacity": "{opacity.invisible}",
    "modalmobile_base_popup-container_transition_duration": "{medium}",
    "modalmobile_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modalmobile_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobile_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $f551aa6589c293c2$var$modalmobileinternal_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$ModalMobileInternalTokens = {
    "modalmobileinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modalmobileinternal_base_container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_container_align-items": "{alignItems.center}",
    modalmobileinternal_base_container_size: $f551aa6589c293c2$var$modalmobileinternal_base_container_size,
    "modalmobileinternal_base_overlay-container_size": "{size.max}",
    "modalmobileinternal_base_overlay-container_background-color": "{global.black}",
    "modalmobileinternal_base_overlay-container_opacity": "{custom_2}",
    "modalmobileinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_root-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_root-container_border-radius": "{xl}",
    "modalmobileinternal_base_root-container_width": "{size.max}",
    "modalmobileinternal_base_root-container_max-height": "{custom_31}",
    "modalmobileinternal_base_root-container_background-color": "{elevation1}",
    "modalmobileinternal_base_outer-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_outer-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_outer-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_outer-container_border-radius": "{xl}",
    "modalmobileinternal_base_outer-container_width": "{size.max}",
    "modalmobileinternal_base_outer-container_max-height": "{size.max}",
    "modalmobileinternal_base_outer-container_padding-top": "{m}",
    "modalmobileinternal_base_outer-container_padding-bottom": "{m}",
    "modalmobileinternal_base_outer-container_padding-left": "{m}",
    "modalmobileinternal_base_outer-container_padding-right": "{m}",
    "modalmobileinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_cancel-container_width": "{size.max}",
    "modalmobileinternal_base_cancel-container_padding-top": "{s}",
    "modalmobileinternal_base_cancel-container_padding-bottom": "{s}",
    "modalmobileinternal_base_cancel-container_padding-left": "{s}",
    "modalmobileinternal_base_cancel-container_padding-right": "{s}",
    "modalmobileinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_vertical-container_width": "{size.max}",
    "modalmobileinternal_base_vertical-container_padding-left": "{l}",
    "modalmobileinternal_base_vertical-container_padding-right": "{l}",
    "modalmobileinternal_base_vertical-container_padding-bottom": "{l}",
    "modalmobileinternal_base_vertical-container_overflow": "auto",
    "modalmobileinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_header-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_header-container_width": "{size.max}",
    "modalmobileinternal_base_header-container_padding-bottom": "{base}",
    "modalmobileinternal_base_children-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_children-container_width": "{size.max}",
    "modalmobileinternal_base_children-container_overflow": "auto",
    "modalmobileinternal_base_children-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_width": "{size.max}",
    "modalmobileinternal_base_button-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_button-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_button-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_gap": "{s}",
    "modalmobileinternal_base_button-container_padding-top": "{base}",
    "modalmobileinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_custom-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_custom-container_border-radius": "{xl}",
    "modalmobileinternal_base_custom-container_background-color": "{elevation1}",
    "modalmobileinternal_base_custom-container_padding-left": "{l}",
    "modalmobileinternal_base_custom-container_padding-right": "{l}",
    "modalmobileinternal_base_custom-container_padding-top": "{l}",
    "modalmobileinternal_base_custom-container_padding-bottom": "{l}",
    "modalmobileinternal_base_custom-container_width": "{size.max}",
    "modalmobileinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modalmobileinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobileinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $f551aa6589c293c2$var$headermobile_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $f551aa6589c293c2$var$HeaderMobileTokens = {
    "headermobile_base_container_min-width": "{size.max}",
    "headermobile_base_container_flex-direction": "{flexDirection.column}",
    "headermobile_base_header-container_min-width": "{size.max}",
    "headermobile_base_header-container_width": "{size.max}",
    "headermobile_base_header-container_background-color": "{primary50}",
    "headermobile_base_header-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headermobile_base_header-container_align-items": "{alignItems.center}",
    "headermobile_base_header-container_padding-left": "{s}",
    "headermobile_base_header-container_padding-top": "{xs}",
    "headermobile_base_header-container_padding-right": "{s}",
    "headermobile_base_header-container_padding-bottom": "{xs}",
    "headermobile_base_header-container_gap": "{base}",
    "headermobile_base_header-container_height": "{huge}",
    "headermobile_base_left-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_left-container_justify-content": "{justifyContent.start}",
    "headermobile_base_left-container_align-items": "{alignItems.center}",
    "headermobile_base_left-container_gap": "{base}",
    "headermobile_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_prefix-container_justify-content": "{justifyContent.start}",
    "headermobile_base_prefix-container_align-items": "{alignItems.center}",
    "headermobile_base_prefix-container_gap": "{xs}",
    "headermobile_base_logo-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_logo-container_justify-content": "{justifyContent.center}",
    "headermobile_base_logo-container_align-items": "{alignItems.center}",
    "headermobile_base_logo-container_gap": "{xs}",
    "headermobile_base_links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_links-container_justify-content": "{justifyContent.start}",
    "headermobile_base_links-container_align-items": "{alignItems.center}",
    "headermobile_base_links-container_gap": "{l}",
    "headermobile_base_links-container_padding-left": "{huge}",
    "headermobile_base_right-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_right-container_justify-content": "{justifyContent.end}",
    "headermobile_base_right-container_align-items": "{alignItems.center}",
    "headermobile_base_right-container_gap": "{s}",
    "headermobile_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_suffix-container_justify-content": "{justifyContent.end}",
    "headermobile_base_suffix-container_align-items": "{alignItems.center}",
    "headermobile_base_suffix-container_gap": "{s}",
    "headermobile_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headermobile_base_icon-links-container_align-items": "{alignItems.center}",
    "headermobile_base_icon-links-container_gap": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-left": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-right": "{s}",
    "headermobile_variant__platform_mobile_header-container_gap": "{xxs}",
    "headermobile_variant__platform_mobile_left-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_right-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_suffix-container_gap": "{xs}",
    headermobile_variant_fullWidth_false_container_width: $f551aa6589c293c2$var$headermobile_variant_fullWidth_false_container_width,
    "headermobile_variant__platform_mobile__isPrefixButtonMissing_true_header-container_padding-left": "{m}"
};
const $f551aa6589c293c2$var$megamenu_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$megamenu_base_container_gap = "{base}";
const $f551aa6589c293c2$var$MegaMenuTokens = {
    "megamenu_base_popup-container_flex-direction": "{flexDirection.row}",
    megamenu_base_container_width: $f551aa6589c293c2$var$megamenu_base_container_width,
    "megamenu_base_container_flex-direction": "{flexDirection.row}",
    "megamenu_base_container_justify-content": "{justifyContent.start}",
    "megamenu_base_container_align-items": "{alignItems.start}",
    "megamenu_base_container_background-color": "{primaryBackground}",
    "megamenu_base_container_padding-top": "{m}",
    "megamenu_base_container_padding-bottom": "{m}",
    "megamenu_base_container_padding-right": "{xxl}",
    "megamenu_base_container_padding-left": "{xxl}",
    megamenu_base_container_gap: $f551aa6589c293c2$var$megamenu_base_container_gap
};
const $f551aa6589c293c2$var$megamenublock_base_container_gap = "{base}";
const $f551aa6589c293c2$var$MegaMenuBlockTokens = {
    "megamenublock_base_container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_container_justify-content": "{justifyContent.start}",
    "megamenublock_base_container_align-items": "{alignItems.start}",
    megamenublock_base_container_gap: $f551aa6589c293c2$var$megamenublock_base_container_gap,
    "megamenublock_base_links-container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_links-container_justify-content": "{justifyContent.start}",
    "megamenublock_base_links-container_align-items": "{alignItems.start}",
    "megamenublock_base_heading-jds_text_padding-top": "{xs}"
};
const $f551aa6589c293c2$var$headerdesktop_base_header_container_height = "{custom_16}";
const $f551aa6589c293c2$var$headerdesktop_base_jds_search_box_width = "{size.max}";
const $f551aa6589c293c2$var$headerdesktop_variant__platform_mobile_header_container_height = "{huge}";
const $f551aa6589c293c2$var$headerdesktop_variant_variant_active_search_jds_search_box_width = "{size.max}";
const $f551aa6589c293c2$var$headerdesktop_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $f551aa6589c293c2$var$HeaderDesktopTokens = {
    "headerdesktop_base_container_min-width": "{size.max}",
    "headerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "headerdesktop_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_prefix-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_prefix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_prefix-container_gap": "{xs}",
    "headerdesktop_base_header-container_min-width": "{size.max}",
    "headerdesktop_base_header-container_background-color": "{primary50}",
    "headerdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headerdesktop_base_header-container_align-items": "{alignItems.center}",
    "headerdesktop_base_header-container_padding-left": "{xxl}",
    "headerdesktop_base_header-container_padding-top": "{s}",
    "headerdesktop_base_header-container_padding-right": "{xxl}",
    "headerdesktop_base_header-container_padding-bottom": "{s}",
    "headerdesktop_base_header-container_gap": "{base}",
    headerdesktop_base_header_container_height: $f551aa6589c293c2$var$headerdesktop_base_header_container_height,
    "headerdesktop_base_left-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_left-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_left-container_align-items": "{alignItems.center}",
    "headerdesktop_base_left-container_gap": "{base}",
    "headerdesktop_base_logo-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_logo-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_logo-container_align-items": "{alignItems.center}",
    "headerdesktop_base_logo-container_gap": "{xs}",
    "headerdesktop_base_profile-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_profile-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_profile-container_align-items": "{alignItems.center}",
    "headerdesktop_base_profile-container_gap": "{xs}",
    "headerdesktop_base_links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_links-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_links-container_gap": "{l}",
    "headerdesktop_base_links-container_padding-left": "{huge}",
    "headerdesktop_base_right-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_right-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_right-container_align-items": "{alignItems.center}",
    "headerdesktop_base_right-container_gap": "{s}",
    "headerdesktop_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_suffix-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_suffix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_suffix-container_gap": "{s}",
    "headerdesktop_base_suffix-container_width": "{size.max}",
    "headerdesktop_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_icon-links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_icon-links-container_gap": "{s}",
    headerdesktop_base_jds_search_box_width: $f551aa6589c293c2$var$headerdesktop_base_jds_search_box_width,
    headerdesktop_variant__platform_mobile_header_container_height: $f551aa6589c293c2$var$headerdesktop_variant__platform_mobile_header_container_height,
    "headerdesktop_variant__platform_mobile_header-container_padding-left": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_padding-right": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_gap": "{s}",
    "headerdesktop_variant__platform_mobile_left-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_right-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_suffix-container_gap": "{xs}",
    "headerdesktop_variant_variant_default_left-container_width": "{size.max}",
    "headerdesktop_variant_variant_active_search_header-container_justify-content": "{justifyContent.spaceBetween}",
    headerdesktop_variant_variant_active_search_jds_search_box_width: $f551aa6589c293c2$var$headerdesktop_variant_variant_active_search_jds_search_box_width,
    headerdesktop_variant_fullWidth_false_container_width: $f551aa6589c293c2$var$headerdesktop_variant_fullWidth_false_container_width,
    "headerdesktop_combinaton_mobile_false_header-container_justify-content": "{justifyContent.spaceBetween}"
};
const $f551aa6589c293c2$var$sidepanel_base_container_height = "{size.max}";
const $f551aa6589c293c2$var$sidepanel_combination_true_desktop_container_width = "{size.max}";
const $f551aa6589c293c2$var$sidepanel_combination_true_mobile_container_width = "{size.max}";
const $f551aa6589c293c2$var$sidepanel_combination_false_mobile_container_width = 376;
const $f551aa6589c293c2$var$SidePanelTokens = {
    "sidepanel_base_popup-container_height": "{size.max}",
    "sidepanel_base_popup-container_width": "{size.max}",
    "sidepanel_base_popup-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_popup-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_popup-container_align-items": "{alignItems.center}",
    sidepanel_base_container_height: $f551aa6589c293c2$var$sidepanel_base_container_height,
    "sidepanel_base_container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_container_background-color": "{primaryBackground}",
    "sidepanel_base_section-container_height": "{size.max}",
    "sidepanel_base_section-container_width": "{size.max}",
    "sidepanel_base_section-container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_section-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_section-container_align-items": "{alignItems.center}",
    "sidepanel_base_section-container_padding-left": "{m}",
    "sidepanel_base_section-container_padding-top": "{m}",
    "sidepanel_base_section-container_padding-right": "{m}",
    "sidepanel_base_header-container_background-color": "{primary50}",
    "sidepanel_base_header-container_padding-top": "{s}",
    "sidepanel_base_header-container_padding-bottom": "{s}",
    "sidepanel_base_header-container_padding-right": "{m}",
    "sidepanel_base_header-container_padding-left": "{m}",
    "sidepanel_base_header-container_width": "{size.max}",
    "sidepanel_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanel_base_header-container_align-items": "{alignItems.center}",
    "sidepanel_base_left-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_left-container_gap": "{s}",
    "sidepanel_base_left-container_align-items": "{alignItems.center}",
    "sidepanel_variant_direction_right_popup-container_justify-content": "{justifyContent.end}",
    sidepanel_combination_true_desktop_container_width: $f551aa6589c293c2$var$sidepanel_combination_true_desktop_container_width,
    sidepanel_combination_true_mobile_container_width: $f551aa6589c293c2$var$sidepanel_combination_true_mobile_container_width,
    sidepanel_combination_false_mobile_container_width: $f551aa6589c293c2$var$sidepanel_combination_false_mobile_container_width
};
const $f551aa6589c293c2$var$MegaMenuItemTokens = {
    "megamenuitem_base_container_flex-direction": "{flexDirection.row}",
    "megamenuitem_base_container_justify-content": "{justifyContent.start}",
    "megamenuitem_base_container_align-items": "{alignItems.start}",
    "megamenuitem_base_container_padding-top": "{xs}",
    "megamenuitem_base_container_padding-bottom": "{xs}"
};
const $f551aa6589c293c2$var$sidepanelitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$SidePanelItemTokens = {
    "sidepanelitem_base_heading-jds_text_padding-top": "{xl}",
    "sidepanelitem_base_heading-jds_text_padding-bottom": "{xs}",
    "sidepanelitem_base_container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanelitem_base_container_align-items": "{alignItems.center}",
    sidepanelitem_base_container_width: $f551aa6589c293c2$var$sidepanelitem_base_container_width,
    "sidepanelitem_base_inner-container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_inner-container_justify-content": "{justifyContent.start}",
    "sidepanelitem_base_inner-container_align-items": "{alignItems.center}",
    "sidepanelitem_base_inner-container_gap": "{base}",
    "sidepanelitem_base_inner-container_padding-top": "{s}",
    "sidepanelitem_base_inner-container_padding-bottom": "{s}"
};
const $f551aa6589c293c2$var$NotificationBannerTokens = {
    "notificationbanner_base_root-container_min-height": "{custom_11}",
    "notificationbanner_base_root-container_width": "{size.max}",
    "notificationbanner_base_root-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_root-container_justify-content": "{justifyContent.center}",
    "notificationbanner_base_root-container_align-items": "{alignItems.center}",
    "notificationbanner_base_root-container_padding-top": "{base}",
    "notificationbanner_base_root-container_padding-right": "{base}",
    "notificationbanner_base_root-container_padding-bottom": "{base}",
    "notificationbanner_base_root-container_padding-left": "{base}",
    "notificationbanner_base_root-container_gap": "{base}",
    "notificationbanner_base_root-container_border-radius": "{large}",
    "notificationbanner_base_root-container_background-color": "{primaryGrey20}",
    "notificationbanner_base_main-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_main-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_main-container_align-items": "{alignItems.start}",
    "notificationbanner_base_main-container_width": "{size.max}",
    "notificationbanner_base_main-container_gap": "{s}",
    "notificationbanner_base_text-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_text-container_align-items": "{alignItems.start}",
    "notificationbanner_base_text-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_text-container_gap": "{xxs}",
    "notificationbanner_base_button-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_button-container_gap": "{xs}",
    "notificationbanner_base_bottom-container_width": "{size.max}",
    "notificationbanner_base_bottom-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_bottom-container_justify-content": "{justifyContent.end}",
    "notificationbanner_base_bottom-container_align-items": "{alignItems.center}",
    "notificationbanner_variant__hasDescription_false_main-container_align-items": "{alignItems.center}",
    "notificationbanner_combination_true_desktop_root-container_padding-left": "{custom_3}",
    "notificationbanner_combination_true_desktop_root-container_padding-right": "{custom_3}",
    "notificationbanner_combination_true_mobile_root-container_padding-left": "{m}",
    "notificationbanner_combination_true_mobile_root-container_padding-right": "{m}",
    "notificationbanner_combination_true_tablet_root-container_padding-left": "{l}",
    "notificationbanner_combination_true_tablet_root-container_padding-right": "{l}"
};
const $f551aa6589c293c2$var$notificationbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$notificationbutton_base_icon_color = "{primary20}";
const $f551aa6589c293c2$var$notificationbutton_base_icon_size = "{base}";
const $f551aa6589c293c2$var$NotificationButtonTokens = {
    "notificationbutton_base_container_padding-top": "{xxs}",
    "notificationbutton_base_container_padding-right": "{base}",
    "notificationbutton_base_container_padding-bottom": "{xxs}",
    "notificationbutton_base_container_padding-left": "{base}",
    "notificationbutton_base_container_background-color": "{global.transparent}",
    "notificationbutton_base_container_border-color": "{primaryGrey60}",
    "notificationbutton_base_container_behavior_hover_border-color": "{primary20}",
    "notificationbutton_base_container_behavior_active_background-color": "{primary30}",
    "notificationbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationbutton_variant_isDisabled_true_container_opacity: $f551aa6589c293c2$var$notificationbutton_variant_isDisabled_true_container_opacity,
    "notificationbutton_variant_kind_tertiary_container_behavior_hover_background-color": "{primary30}",
    "notificationbutton_variant_kind_tertiary_container_behavior_active_background-color": "{primary40}",
    "notificationbutton_variant_kind_tertiary_container_behavior_focus_background-color": "{primary30}",
    notificationbutton_base_icon_color: $f551aa6589c293c2$var$notificationbutton_base_icon_color,
    notificationbutton_base_icon_size: $f551aa6589c293c2$var$notificationbutton_base_icon_size,
    "notificationbutton_variant__hasLabel_false_container_padding-top": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-bottom": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-left": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-right": "{xs}"
};
const $f551aa6589c293c2$var$notificationiconbutton_base_container_height = "{l}";
const $f551aa6589c293c2$var$notificationiconbutton_base_container_width = "{l}";
const $f551aa6589c293c2$var$notificationiconbutton_base_icon_size = "{base}";
const $f551aa6589c293c2$var$notificationiconbutton_base_icon_color = "{primary20}";
const $f551aa6589c293c2$var$notificationiconbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$NotificationIconButtonTokens = {
    notificationiconbutton_base_container_height: $f551aa6589c293c2$var$notificationiconbutton_base_container_height,
    notificationiconbutton_base_container_width: $f551aa6589c293c2$var$notificationiconbutton_base_container_width,
    "notificationiconbutton_base_container_justify-content": "{justifyContent.center}",
    "notificationiconbutton_base_container_align-items": "{alignItems.center}",
    "notificationiconbutton_base_container_background-color": "{global.transparent}",
    "notificationiconbutton_base_container_border-color": "{global.transparent}",
    "notificationiconbutton_base_container_behavior_hover_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_active_background-color": "{primary40}",
    "notificationiconbutton_base_container_behavior_focus_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationiconbutton_base_icon_size: $f551aa6589c293c2$var$notificationiconbutton_base_icon_size,
    notificationiconbutton_base_icon_color: $f551aa6589c293c2$var$notificationiconbutton_base_icon_color,
    notificationiconbutton_variant_isDisabled_true_container_opacity: $f551aa6589c293c2$var$notificationiconbutton_variant_isDisabled_true_container_opacity
};
const $f551aa6589c293c2$var$NudgeTokens = {
    "nudge_base_root-container_width": "{size.max}",
    "nudge_base_root-container_max-width": "{size.max}",
    "nudge_base_root-container_border-radius": "{xl}",
    "nudge_base_root-container_background-color": "{primaryGrey80}",
    "nudge_base_root-container_flex-direction": "{flexDirection.column}",
    "nudge_base_root-container_gap": "{base}",
    "nudge_base_root-container_padding-top": "{base}",
    "nudge_base_root-container_padding-right": "{base}",
    "nudge_base_root-container_padding-bottom": "{base}",
    "nudge_base_root-container_padding-left": "{base}",
    "nudge_base_base-container_gap": "{s}",
    "nudge_base_base-container_width": "{size.max}",
    "nudge_base_base-container_flex-direction": "{flexDirection.row}",
    "nudge_base_base-container_justify-content": "{justifyContent.start}",
    "nudge_base_base-container_align-items": "{alignItems.center}",
    "nudge_base_center-container_flex-direction": "{flexDirection.column}",
    "nudge_base_center-container_justify-content": "{justifyContent.start}",
    "nudge_base_center-container_align-items": "{alignItems.start}",
    "nudge_base_center-container_gap": "{s}",
    "nudge_base_buttons-container_width": "{size.max}",
    "nudge_base_buttons-container_gap": "{s}",
    "nudge_base_buttons-container_flex-direction": "{flexDirection.row}",
    "nudge_base_buttons-container_justify-content": "{justifyContent.end}",
    "nudge_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "nudge_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $f551aa6589c293c2$var$ToastTokens = {
    "toast_base_root-container_width": "{size.max}",
    "toast_base_root-container_max-width": "{size.max}",
    "toast_base_root-container_border-radius": "{xl}",
    "toast_base_root-container_background-color": "{primaryGrey80}",
    "toast_base_root-container_flex-direction": "{flexDirection.column}",
    "toast_base_root-container_gap": "{base}",
    "toast_base_root-container_padding-top": "{base}",
    "toast_base_root-container_padding-right": "{base}",
    "toast_base_root-container_padding-bottom": "{base}",
    "toast_base_root-container_padding-left": "{base}",
    "toast_base_base-container_gap": "{s}",
    "toast_base_base-container_width": "{size.max}",
    "toast_base_base-container_flex-direction": "{flexDirection.row}",
    "toast_base_base-container_justify-content": "{justifyContent.start}",
    "toast_base_base-container_align-items": "{alignItems.center}",
    "toast_base_center-container_flex-direction": "{flexDirection.column}",
    "toast_base_center-container_justify-content": "{justifyContent.start}",
    "toast_base_center-container_align-items": "{alignItems.start}",
    "toast_base_center-container_gap": "{xxs}",
    "toast_base_buttons-container_width": "{size.max}",
    "toast_base_buttons-container_gap": "{s}",
    "toast_base_buttons-container_flex-direction": "{flexDirection.row}",
    "toast_base_buttons-container_justify-content": "{justifyContent.end}",
    "toast_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "toast_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $f551aa6589c293c2$var$NudgeContainerTokens = {
    "nudgecontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "nudgecontainer_base_popup-container_size": "{size.max}",
    "nudgecontainer_base_popup-container_padding-top": "{base}",
    "nudgecontainer_base_popup-container_padding-right": "{base}",
    "nudgecontainer_base_popup-container_padding-bottom": "{base}",
    "nudgecontainer_base_popup-container_padding-left": "{base}",
    "nudgecontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "nudgecontainer_base_root-container_justify-content": "{justifyContent.start}",
    "nudgecontainer_base_root-container_align-items": "{alignItems.end}",
    "nudgecontainer_base_root-container_size": "{size.max}",
    "nudgecontainer_base_root-container_gap": "{xs}"
};
const $f551aa6589c293c2$var$ToastContainerTokens = {
    "toastcontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "toastcontainer_base_popup-container_size": "{size.max}",
    "toastcontainer_base_popup-container_padding-top": "{base}",
    "toastcontainer_base_popup-container_padding-right": "{base}",
    "toastcontainer_base_popup-container_padding-bottom": "{base}",
    "toastcontainer_base_popup-container_padding-left": "{base}",
    "toastcontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "toastcontainer_base_root-container_justify-content": "{justifyContent.end}",
    "toastcontainer_base_root-container_align-items": "{alignItems.start}",
    "toastcontainer_base_root-container_size": "{size.max}",
    "toastcontainer_base_root-container_gap": "{xs}"
};
const $f551aa6589c293c2$var$progressbar_base_container_gap = "{base}";
const $f551aa6589c293c2$var$progressbar_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$ProgressBarTokens = {
    "progressbar_base_container_flex-direction": "{flexDirection.column}",
    "progressbar_base_container_justify-content": "{justifyContent.center}",
    "progressbar_base_container_align-items": "{alignItems.start}",
    progressbar_base_container_gap: $f551aa6589c293c2$var$progressbar_base_container_gap,
    progressbar_base_container_width: $f551aa6589c293c2$var$progressbar_base_container_width,
    "progressbar_base_container_background-color": "{global.transparent}",
    "progressbar_base_top-container_background-color": "{global.transparent}",
    "progressbar_base_top-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_top-container_justify-content": "{justifyContent.spaceBetween}",
    "progressbar_base_top-container_align-items": "{alignItems.center}",
    "progressbar_base_top-container_width": "{size.max}",
    "progressbar_base_top-container_gap": "{m}",
    "progressbar_base_determinate-container_background-color": "{primaryGrey40}",
    "progressbar_base_determinate-container_height": "{xs}",
    "progressbar_base_determinate-container_width": "{size.max}",
    "progressbar_base_determinate-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_determinate-container_justify-content": "{justifyContent.start}",
    "progressbar_base_determinate-container_align-items": "{alignItems.start}",
    "progressbar_base_determinate-container_border-radius": "{pill}",
    "progressbar_base_active-container_background-color": "{primary50}",
    "progressbar_base_active-container_height": "{xs}",
    "progressbar_base_active-container_border-radius": "{pill}",
    "progressbar_base_invisible-container_height": "{xs}",
    "progressbar_base_indeterminate-container_flex-direction": "{flexDirection.stack}",
    "progressbar_base_indeterminate-container_background-color": "{primaryGrey40}",
    "progressbar_base_indeterminate-container_height": "{xs}",
    "progressbar_base_indeterminate-container_width": "{size.max}",
    "progressbar_base_indeterminate-container_border-radius": "{pill}",
    "progressbar_base_track-container_height": "{size.max}",
    "progressbar_base_active-animatedContainer_height": "{size.max}",
    "progressbar_base_active-animatedContainer_width": "{massive}",
    "progressbar_base_active-animatedContainer_background-color": "{primary50}",
    "progressbar_base_active-animatedContainer_border-radius": "{pill}",
    "progressbar_variant_state_success_active-container_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_success_active-animatedContainer_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_error_active-container_background-color": "{feedbackError50}",
    "progressbar_variant_state_error_active-animatedContainer_background-color": "{feedbackError50}",
    "progressbar_variant_state_warning_active-container_background-color": "{feedbackWarning50}",
    "progressbar_variant_state_warning_active-animatedContainer_background-color": "{feedbackWarning50}",
    "progressbar_variant_labelPosition_center_top-container_justify-content": "{justifyContent.center}"
};
const $f551aa6589c293c2$var$pagination_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$PaginationTokens = {
    "pagination_base_container_background-color": "{global.transparent}",
    "pagination_base_container_flex-direction": "{flexDirection.row}",
    "pagination_base_container_justify-content": "{alignItems.center}",
    "pagination_base_container_align-items": "{alignItems.center}",
    "pagination_base_container_padding-left": "{custom_25}",
    "pagination_base_container_padding-right": "{custom_25}",
    pagination_base_container_width: $f551aa6589c293c2$var$pagination_base_container_width,
    "pagination_base_container_min-height": "{xxl}",
    "pagination_base_basic-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_gap": "{xxs}",
    "pagination_base_compact-container_padding-left": "{base}",
    "pagination_base_compact-container_padding-right": "{base}"
};
const $f551aa6589c293c2$var$PromoCardTokens = {
    "promocard_base_root-container_background-color": "{global.white}",
    "promocard_base_root-container_flex-direction": "{flexDirection.column}",
    "promocard_base_root-container_width": "{size.max}",
    "promocard_base_root-container_justify-content": "{justifyContent.start}",
    "promocard_base_root-container_align-items": "{alignItems.start}",
    "promocard_base_root-container_border-radius": "{xl}",
    "promocard_base_vertical-container_flex-direction": "{flexDirection.column}",
    "promocard_base_vertical-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-container_width": "{size.max}",
    "promocard_base_vertical-container_border-radius": "{xl}",
    "promocard_base_vertical-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-container_align-items": "{alignItems.stretch}",
    "promocard_base_horizontal-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-container_width": "{size.max}",
    "promocard_base_horizontal-container_border-radius": "{xl}",
    "promocard_base_horizontal-container_height": "{intrinsicSize.max}",
    "promocard_base_horizontal-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_vertical-content-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-content-container_width": "{size.max}",
    "promocard_base_vertical-content-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_border-bottom-left-radius": "{xl}",
    "promocard_base_vertical-content-container_border-bottom-right-radius": "{xl}",
    "promocard_base_vertical-content-container_padding-right": "{m}",
    "promocard_base_vertical-content-container_padding-bottom": "{m}",
    "promocard_base_vertical-content-container_padding-left": "{m}",
    "promocard_base_horizontal-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-content-container_align-items": "{alignItems.start}",
    "promocard_base_horizontal-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-content-container_height": "{size.max}",
    "promocard_base_horizontal-content-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-content-container_padding-top": "{m}",
    "promocard_base_horizontal-content-container_padding-right": "{m}",
    "promocard_base_horizontal-content-container_padding-bottom": "{m}",
    "promocard_base_horizontal-content-container_padding-left": "{m}",
    "promocard_base_vertical-image-container_width": "{size.max}",
    "promocard_base_vertical-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_vertical-image-container_align-items": "{alignItems.end}",
    "promocard_base_horizontal-image-container_height": "{size.max}",
    "promocard_base_horizontal-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_horizontal-image-container_align-items": "{alignItems.center}",
    "promocard_base_horizontal-image-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-image_height": "{size.max}",
    "promocard_base_vertical-promoCardArc_color": "{primaryBackground}",
    "promocard_base_vertical-promoCardArc_width": "{size.max}",
    "promocard_base_vertical-promoCardArc_height": "{xl}",
    "promocard_base_horizontal-promoCardArc_color": "{primaryBackground}",
    "promocard_base_horizontal-promoCardArc_height": "{size.max}",
    "promocard_base_horizontal-promoCardArc_width": "{xl}",
    "promocard_base_footer-container_color": "{primaryBackground}",
    "promocard_base_footer-container_width": "{size.max}",
    "promocard_base_footer-container_justify-content": "{justifyContent.spaceBetween}",
    "promocard_base_footer-container_align-items": "{alignItems.center}",
    "promocard_base_footer-container_flex-direction": "{flexDirection.row}",
    "promocard_base_footer-container_gap": "{base}",
    "promocard_base_footer-container_padding-left": "{m}",
    "promocard_base_footer-container_padding-right": "{m}",
    "promocard_base_footer-container_padding-top": "{base}",
    "promocard_base_footer-container_padding-bottom": "{base}",
    "promocard_variant_size_medium_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-left": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-left": "{l}"
};
const $f551aa6589c293c2$var$searchresultitem_base_container_gap = "{base}";
const $f551aa6589c293c2$var$searchresultitem_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$searchresultitem_base_icon_size = "{l}";
const $f551aa6589c293c2$var$searchresultitem_base_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$SearchResultItemTokens = {
    "searchresultitem_base_container_flex-direction": "{flexDirection.row}",
    searchresultitem_base_container_gap: $f551aa6589c293c2$var$searchresultitem_base_container_gap,
    "searchresultitem_base_container_padding-top": "{xs}",
    "searchresultitem_base_container_padding-bottom": "{xs}",
    "searchresultitem_base_container_align-items": "{alignItems.center}",
    searchresultitem_base_container_width: $f551aa6589c293c2$var$searchresultitem_base_container_width,
    "searchresultitem_base_container_behavior_hover_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_active_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_focus_background-color": "{primaryGrey20}",
    searchresultitem_base_icon_size: $f551aa6589c293c2$var$searchresultitem_base_icon_size,
    searchresultitem_base_icon_color: $f551aa6589c293c2$var$searchresultitem_base_icon_color,
    "searchresultitem_base_text-container_flex-direction": "{flexDirection.row}",
    "searchresultitem_base_text-container_justify-content": "{justifyContent.start}",
    "searchresultitem_base_text-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$SearchResultTextTokens = {};
const $f551aa6589c293c2$var$searchresults_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$SearchResultsTokens = {
    "searchresults_base_popup_background-color": "{global.transparent}",
    "searchresults_base_popup-container_flex-direction": "{flexDirection.stack}",
    "searchresults_base_popup-container_justify-content": "{justifyContent.center}",
    "searchresults_base_popup-container_width": "{size.max}",
    "searchresults_base_popup-container_background-color": "{global.transparent}",
    "searchresults_base_root-container_background-color": "{primaryBackground}",
    "searchresults_base_root-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_root-container_align-items": "{alignItems.center}",
    "searchresults_base_root-container_padding-top": "{base}",
    "searchresults_base_root-container_padding-right": "{base}",
    "searchresults_base_root-container_padding-bottom": "{base}",
    "searchresults_base_root-container_padding-left": "{base}",
    "searchresults_base_root-container_gap": "{base}",
    "searchresults_base_root-container_width": "{size.max}",
    searchresults_base_container_width: $f551aa6589c293c2$var$searchresults_base_container_width,
    "searchresults_base_container_flex-direction": "{flexDirection.column}",
    "searchresults_base_container_align-items": "{alignItems.center}",
    "searchresults_base_heading-container_flex-direction": "{flexDirection.row}",
    "searchresults_base_heading-container_justify-content": "{justifyContent.spaceBetween}",
    "searchresults_base_heading-container_align-items": "{alignItems.start}",
    "searchresults_base_heading-container_width": "{size.max}",
    "searchresults_base_results-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_results-container_align-items": "{alignItems.start}",
    "searchresults_base_results-container_gap": "{base}",
    "searchresults_base_results-container_width": "{size.max}",
    "searchresults_variant_appearance_box_root-container_border-radius": "{xl}"
};
const $f551aa6589c293c2$var$RadioButtonTokens = {
    "radiobutton_base_vertical-container_flex-direction": "{flexDirection.column}",
    "radiobutton_base_vertical-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_vertical-container_align-items": "{alignItems.start}",
    "radiobutton_base_vertical-container_gap": "{xs}",
    "radiobutton_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_horizontal-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_horizontal-container_align-items": "{alignItems.center}",
    "radiobutton_base_horizontal-container_gap": "{xs}",
    "radiobutton_base_outer-container_min-width": "{m}",
    "radiobutton_base_outer-container_min-height": "{m}",
    "radiobutton_base_outer-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_outer-container_justify-content": "{justifyContent.center}",
    "radiobutton_base_outer-container_align-items": "{alignItems.center}",
    "radiobutton_base_outer-container_background-color": "{global.transparent}",
    "radiobutton_base_outer-container_border-radius": "{pill}",
    "radiobutton_base_outer-container_border-color": "{primaryGrey80}",
    "radiobutton_base_outer-container_border-width": "{border_thin}",
    "radiobutton_variant_checked_true_outer-container_border-width": "{border_none}",
    "radiobutton_base_outer-container_behavior_hover_border-color": "{primary40}",
    "radiobutton_base_outer-container_behavior_active_border-color": "{primary60}",
    "radiobutton_base_outer-container_behavior_focus_border-color": "{primary60}",
    "radiobutton_base_inner-container_min-width": "{s}",
    "radiobutton_base_inner-container_min-height": "{s}",
    "radiobutton_base_inner-container_border-radius": "{pill}",
    "radiobutton_base_label-jds_text_text-align": "{textAlign.start}",
    "radiobutton_variant_size_small_outer-container_min-width": "{base}",
    "radiobutton_variant_size_small_outer-container_min-height": "{base}",
    "radiobutton_variant_size_small_vertical-container_gap": "{xxs}",
    "radiobutton_variant_size_small_inner-container_min-width": "{xs}",
    "radiobutton_variant_size_small_inner-container_min-height": "{xs}",
    "radiobutton_variant_checked_true_outer-container_background-color": "{primary50}",
    "radiobutton_variant_checked_true_outer-container_behavior_hover_background-color": "{primary40}",
    "radiobutton_variant_checked_true_outer-container_behavior_active_background-color": "{primary60}",
    "radiobutton_variant_checked_true_outer-container_behavior_focus_background-color": "{primary50}",
    "radiobutton_variant_checked_true_inner-container_background-color": "{primaryInverse}",
    "radiobutton_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "radiobutton_base_vertical-container_opacity": "{opacity.enabled}",
    "radiobutton_combination_true_success_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_error_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_warning_inner-container_background-color": "{global.white}"
};
const $f551aa6589c293c2$var$skeleton_variant_shape_heading_container_height = "{xxl}";
const $f551aa6589c293c2$var$skeleton_variant_shape_paragraph_container_height = "{base}";
const $f551aa6589c293c2$var$skeleton_variant_shape_custom_container_width = "{size.max}";
const $f551aa6589c293c2$var$skeleton_variant_shape_custom_container_height = "{size.max}";
const $f551aa6589c293c2$var$SkeletonTokens = {
    "skeleton_base_container_background-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_primary-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_secondary-color": "{primaryGrey40}",
    "skeleton_variant_shape_circle_container_border-radius": "{pill}",
    skeleton_variant_shape_heading_container_height: $f551aa6589c293c2$var$skeleton_variant_shape_heading_container_height,
    "skeleton_variant_shape_heading_container_border-radius": "{pill}",
    "skeleton_variant_shape_paragraph_container_border-radius": "{pill}",
    skeleton_variant_shape_paragraph_container_height: $f551aa6589c293c2$var$skeleton_variant_shape_paragraph_container_height,
    "skeleton_variant_shape_rectangle_container_border-radius": "{xl}",
    "skeleton_variant_shape_square_container_border-radius": "{xxl}",
    skeleton_variant_shape_custom_container_width: $f551aa6589c293c2$var$skeleton_variant_shape_custom_container_width,
    skeleton_variant_shape_custom_container_height: $f551aa6589c293c2$var$skeleton_variant_shape_custom_container_height
};
const $f551aa6589c293c2$var$selector_variant_stretch_true_container_width = "{size.max}";
const $f551aa6589c293c2$var$SelectorTokens = {
    "selector_base_container_flex-direction": "{flexDirection.stack}",
    "selector_base_selector-container_opacity": "{opacity.enabled}",
    "selector_base_selector-container_align-items": "{alignItems.center}",
    "selector_base_selector-container_justify-content": "{justifyContent.center}",
    "selector_base_selector-container_border-radius": "{pill}",
    "selector_base_selector-container_padding-top": "{xxs}",
    "selector_base_selector-container_padding-right": "{xxs}",
    "selector_base_selector-container_padding-bottom": "{xxs}",
    "selector_base_selector-container_padding-left": "{xxs}",
    "selector_base_outer-container_padding-top": "{xxs}",
    "selector_base_outer-container_padding-right": "{xxs}",
    "selector_base_outer-container_padding-bottom": "{xxs}",
    "selector_base_outer-container_padding-left": "{xxs}",
    "selector_base_outer-container_background-color": "{primaryGrey20}",
    "selector_base_outer-container_border-radius": "{pill}",
    "selector_base_selector-container_gap": "{xxs}",
    "selector_base_selector-container_flex-direction": "{flexDirection.row}",
    "selector_base_outer-container_width": "{size.max}",
    "selector_base_outer-container_height": "{intrinsicSize.max}",
    "selector_base_outer-container_justify-content": "{justifyContent.start}",
    "selector_base_outer-container_align-items": "{alignItems.center}",
    "selector_base_inner-container_background-color": "{primary50}",
    "selector_base_inner-container_border-radius": "{pill}",
    selector_variant_stretch_true_container_width: $f551aa6589c293c2$var$selector_variant_stretch_true_container_width,
    "selector_variant_stretch_true_selector-container_width": "{size.max}",
    "selector_variant__animating_true_inner-container_background-color": "{primary50}"
};
const $f551aa6589c293c2$var$selectoritem_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$selectoritem_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$selectoritem_base_icon_size = "{m}";
const $f551aa6589c293c2$var$selectoritem_base_icon_color = "{primary60}";
const $f551aa6589c293c2$var$selectoritem_variant_selected_true_icon_color = "{primaryInverse}";
const $f551aa6589c293c2$var$selectoritem_variant_selected_true_icon_behavior_active_color = "{primary30}";
const $f551aa6589c293c2$var$selectoritem_variant_stretch_true_container_width = "{size.max}";
const $f551aa6589c293c2$var$selectoritem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$selectoritem_variant_wrap_vertical_container_gap = "{xxs}";
const $f551aa6589c293c2$var$SelectorItemTokens = {
    selectoritem_base_container_opacity: $f551aa6589c293c2$var$selectoritem_base_container_opacity,
    "selectoritem_base_container_background-color": "{global.transparent}",
    "selectoritem_base_container_flex-direction": "{flexDirection.row}",
    "selectoritem_base_container_align-items": "{alignItems.center}",
    "selectoritem_base_container_justify-content": "{justifyContent.center}",
    "selectoritem_base_container_border-radius": "{pill}",
    selectoritem_base_container_gap: $f551aa6589c293c2$var$selectoritem_base_container_gap,
    "selectoritem_base_container_padding-top": "{xs}",
    "selectoritem_base_container_padding-right": "{base}",
    "selectoritem_base_container_padding-bottom": "{xs}",
    "selectoritem_base_container_padding-left": "{base}",
    "selectoritem_base_container_behavior_focus_background-color": "{primary20}",
    "selectoritem_base_container_behavior_focus_box-shadow_spread": "{xxs}",
    "selectoritem_base_container_behavior_focus_box-shadow_color": "{primary60}",
    "selectoritem_base_container_behavior_hover_background-color": "{primary20}",
    "selectoritem_base_container_behavior_active_background-color": "{primary30}",
    selectoritem_base_icon_size: $f551aa6589c293c2$var$selectoritem_base_icon_size,
    selectoritem_base_icon_color: $f551aa6589c293c2$var$selectoritem_base_icon_color,
    "selectoritem_variant_selected_true_container_background-color": "{primary50}",
    "selectoritem_variant_selected_true_container_behavior_hover_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_active_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_focus_background-color": "{primary50}",
    selectoritem_variant_selected_true_icon_color: $f551aa6589c293c2$var$selectoritem_variant_selected_true_icon_color,
    selectoritem_variant_selected_true_icon_behavior_active_color: $f551aa6589c293c2$var$selectoritem_variant_selected_true_icon_behavior_active_color,
    "selectoritem_variant_wrap_vertical_container_flex-direction": "{flexDirection.column}",
    selectoritem_variant_stretch_true_container_width: $f551aa6589c293c2$var$selectoritem_variant_stretch_true_container_width,
    selectoritem_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$selectoritem_variant_disabled_true_container_opacity,
    selectoritem_variant_wrap_vertical_container_gap: $f551aa6589c293c2$var$selectoritem_variant_wrap_vertical_container_gap
};
const $f551aa6589c293c2$var$servicecard_base_jds_content_block_width = "{size.max}";
const $f551aa6589c293c2$var$ServiceCardTokens = {
    "servicecard_base_root-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_inner-stack-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_root-container_size": "{size.max}",
    "servicecard_base_inner-stack-container_size": "{size.max}",
    "servicecard_base_root-container_justify-content": "{justifyContent.start}",
    "servicecard_base_inner-stack-container_justify-content": "{justifyContent.start}",
    "servicecard_base_root-container_align-items": "{alignItems.start}",
    "servicecard_base_root-container_border-radius": "{xl}",
    "servicecard_base_blur-image_height": "{size.max}",
    "servicecard_base_blur-image_width": "{size.max}",
    "servicecard_base_blur-image_blur-radius": "{xl}",
    "servicecard_base_blur-image_aspect-ratio": "{aspect_ratio.16.9}",
    "servicecard_base_internal-vertical-container_flex-direction": "{flexDirection.column}",
    "servicecard_base_internal-vertical-container_size": "{size.max}",
    "servicecard_base_internal-vertical-container_justify-content": "{justifyContent.start}",
    "servicecard_base_internal-vertical-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_flex-direction": "{flexDirection.row}",
    "servicecard_base_image-container_justify-content": "{justifyContent.start}",
    "servicecard_base_image-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_height": "{size.max}",
    "servicecard_base_image-container_width": "{size.max}",
    "servicecard_base_jds_badge_padding-top": "{base}",
    "servicecard_base_jds_badge_padding-left": "{base}",
    "servicecard_base_content-block-container_background-color": "{custom_color_4}",
    "servicecard_base_content-block-container_width": "{size.max}",
    "servicecard_base_content-block-container_padding-top": "{base}",
    "servicecard_base_content-block-container_padding-bottom": "{base}",
    "servicecard_base_content-block-container_padding-left": "{base}",
    "servicecard_base_content-block-container_padding-right": "{base}",
    servicecard_base_jds_content_block_width: $f551aa6589c293c2$var$servicecard_base_jds_content_block_width,
    "servicecard_variant_imageRatio_square_blur_image_aspect-ratio": "{aspect_ratio.1.1}",
    "servicecard_variant_imageRatio_landscape_blur_image_aspect-ratio": "{aspect_ratio.4.3}",
    "servicecard_variant_imageRatio_portrait_blur_image_aspect-ratio": "{aspect_ratio.4.5}"
};
const $f551aa6589c293c2$var$slider_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$slider_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$slider_base_slider_width = "{size.max}";
const $f551aa6589c293c2$var$slider_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$SliderTokens = {
    "slider_base_container_flex-direction": "{flexDirection.column}",
    "slider_base_container_justify-content": "{justifyContent.start}",
    "slider_base_container_align-items": "{alignItems.start}",
    slider_base_container_width: $f551aa6589c293c2$var$slider_base_container_width,
    slider_base_container_gap: $f551aa6589c293c2$var$slider_base_container_gap,
    "slider_base_top-container_flex-direction": "{flexDirection.row}",
    "slider_base_top-container_justify-content": "{justifyContent.start}",
    "slider_base_top-container_align-items": "{alignItems.center}",
    "slider_base_top-container_width": "{size.max}",
    "slider_base_top-container_gap": "{xs}",
    "slider_base_label-jds_text_justify-content": "{justifyContent.start}",
    "slider_base_label-jds_text_align-items": "{alignItems.center}",
    "slider_base_inner-container_align-items": "{alignItems.center}",
    "slider_base_inner-container_padding-left": "{xs}",
    "slider_base_inner-container_padding-right": "{xs}",
    "slider_base_inner-container_border-width": "{border_thin}",
    "slider_base_inner-container_border-color": "{primaryGrey80}",
    "slider_base_inner-container_border-radius": "{medium}",
    slider_base_slider_width: $f551aa6589c293c2$var$slider_base_slider_width,
    "slider_base_slider_track-height": "{xxs}",
    "slider_base_slider_inactive-color": "{primaryGrey40}",
    "slider_base_slider_active-color": "{primary50}",
    "slider_base_slider_ball-color": "{primary50}",
    "slider_base_slider_ball-border-color": "{primary80}",
    "slider_base_slider_border-radius": "{small}",
    "slider_base_slider_behavior_hover_ball-color": "{primary60}",
    "slider_base_slider_behavior_active_active-color": "{primary60}",
    "slider_base_slider_behavior_active_ball-color": "{primary60}",
    "slider_base_slider_behavior_focus_ball-border-width": "{border_focus}",
    "slider_base_bottom-container_flex-direction": "{flexDirection.row}",
    "slider_base_bottom-container_justify-content": "{justifyContent.spaceBetween}",
    "slider_base_bottom-container_align-items": "{alignItems.center}",
    "slider_base_bottom-container_width": "{size.max}",
    "slider_variant_state_success_inner-container_border-color": "{feedbackSuccess50}",
    "slider_variant_state_error_inner-container_border-color": "{feedbackError50}",
    "slider_variant_state_warning_inner-container_border-color": "{feedbackWarning50}",
    slider_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$slider_variant_disabled_true_container_opacity,
    "slider_variant_disabled_true_slider_behavior_hover_ball-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_active-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_ball-color": "{primary50}"
};
const $f551aa6589c293c2$var$paginationbutton_base_container_size = "{xxl}";
const $f551aa6589c293c2$var$PaginationButtonTokens = {
    paginationbutton_base_container_size: $f551aa6589c293c2$var$paginationbutton_base_container_size,
    "paginationbutton_base_container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_background-color": "{global.transparent}",
    "paginationbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "paginationbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_inner-container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_border-radius": "{pill}",
    "paginationbutton_base_inner-container_width": "{l}",
    "paginationbutton_base_inner-container_height": "{l}",
    "paginationbutton_base_inner-container_opacity": "{opacity.enabled}",
    "paginationbutton_base_inner-container_gap": "{xs}",
    "paginationbutton_base_inner-container_border-color": "{primary80}",
    "paginationbutton_base_inner-container_behavior_hover_background-color": "{primary20}",
    "paginationbutton_base_inner-container_behavior_active_background-color": "{primary30}",
    "paginationbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "paginationbutton_variant_state_selected_inner-container_background-color": "{primary70}",
    "paginationbutton_variant_state_ellipsis_inner-container_background-color": "{global.transparent}"
};
const $f551aa6589c293c2$var$searchbox_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$searchbox_base_container_height = "{xl}";
const $f551aa6589c293c2$var$searchbox_base_container_gap = "{s}";
const $f551aa6589c293c2$var$searchbox_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$searchbox_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$SearchBoxTokens = {
    "searchbox_base_container_background-color": "{primaryGrey20}",
    "searchbox_base_container_flex-direction": "{flexDirection.row}",
    "searchbox_base_container_justify-content": "{justifyContent.start}",
    "searchbox_base_container_align-items": "{alignItems.center}",
    "searchbox_base_container_padding-right": "{s}",
    "searchbox_base_container_padding-left": "{s}",
    searchbox_base_container_width: $f551aa6589c293c2$var$searchbox_base_container_width,
    searchbox_base_container_height: $f551aa6589c293c2$var$searchbox_base_container_height,
    "searchbox_base_container_border-radius": "{pill}",
    searchbox_base_container_gap: $f551aa6589c293c2$var$searchbox_base_container_gap,
    searchbox_base_container_opacity: $f551aa6589c293c2$var$searchbox_base_container_opacity,
    "searchbox_base_container_behavior_focus_border-color": "{primary60}",
    "searchbox_base_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_base_container_behavior_active_background-color": "{primaryGrey40}",
    "searchbox_base_input_text-align": "{textAlign.start}",
    "searchbox_base_input_placeholder-color": "{primaryGrey100}",
    "searchbox_base_input_placeholder-font-family": "{bodyS}",
    "searchbox_base_input_placeholder-font-size": "{bodyS}",
    "searchbox_base_input_placeholder-line-height": "{bodyS}",
    "searchbox_base_input_placeholder-letter-spacing": "{bodyS}",
    "searchbox_base_input_placeholder-font-weight": "{bodyS}",
    "searchbox_base_input_input-color": "{primaryGrey100}",
    "searchbox_base_input_input-font-family": "{bodyS}",
    "searchbox_base_input_input-font-size": "{bodyS}",
    "searchbox_base_input_input-line-height": "{bodyS}",
    "searchbox_base_input_input-letter-spacing": "{bodyS}",
    "searchbox_base_input_input-font-weight": "{bodyS}",
    "searchbox_base_input_cursor-color": "{primary60}",
    "searchbox_base_input_behavior_hover_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_focus_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_active_placeholder-color": "{primary60}",
    "searchbox_base_prefix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_prefix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_prefix-container_align-items": "{alignItems.center}",
    "searchbox_base_prefix-icon_size": "{m}",
    "searchbox_base_prefix-icon_color": "{primaryGrey100}",
    "searchbox_base_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_active_color": "{primaryGrey80}",
    "searchbox_base_suffix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_suffix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_suffix-container_align-items": "{alignItems.center}",
    "searchbox_base_suffix-icon_size": "{m}",
    "searchbox_base_suffix-icon_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_header_container_background-color": "{primary60}",
    "searchbox_variant_kind_header_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_header_container_behavior_active_background-color": "{primary70}",
    "searchbox_variant_kind_header_prefix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_prefix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_prefix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_suffix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_input_input-color": "{primaryBackground}",
    "searchbox_variant_kind_header_input_placeholder-color": "{primary40}",
    "searchbox_variant_kind_header_input_cursor-color": "{primary30}",
    "searchbox_variant_kind_header_input_behavior_hover_placeholder-color": "{primary30}",
    "searchbox_variant_kind_light_background_container_background-color": "{primaryBackground}",
    "searchbox_variant_kind_light_background_container_border-color": "{primaryGrey60}",
    "searchbox_variant_kind_light_background_container_behavior_hover_border-color": "{primary50}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_light_background_container_behavior_active_border-color": "{primary60}",
    "searchbox_variant_kind_light_background_container_border-width": "{border_thin}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_variant_kind_light_background_input_input-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_input_cursor-color": "{primary60}",
    "searchbox_variant_kind_light_background_input_behavior_active_placeholder-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_suffix-icon_color": "{primary60}",
    "searchbox_variant_kind_light_background_suffix-icon_behavior_active_color": "{primary60}",
    searchbox_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$searchbox_variant_disabled_true_container_opacity,
    "searchbox_variant__isValueEmpty_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_header_false_suffix-icon_color": "{primary30}",
    "searchbox_variant__inputFocus_true_input_placeholder-color": "{primaryGrey60}",
    "searchbox_combination_light_background_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_light_background_true_container_border-color": "{primary60}"
};
const $f551aa6589c293c2$var$spinner_base_container_gap = "{base}";
const $f551aa6589c293c2$var$spinner_variant_size_small_container_gap = "{s}";
const $f551aa6589c293c2$var$SpinnerTokens = {
    "spinner_base_container_background-color": "{global.transparent}",
    spinner_base_container_gap: $f551aa6589c293c2$var$spinner_base_container_gap,
    "spinner_base_container_justify-content": "{justifyContent.center}",
    "spinner_base_container_align-items": "{alignItems.center}",
    "spinner_base_container_flex-direction": "{flexDirection.row}",
    "spinner_base_spinner-container_size": "{xxl}",
    "spinner_base_arc-container_flex-direction": "{flexDirection.stack}",
    "spinner_base_arc-container_justify-content": "{justifyContent.center}",
    "spinner_base_arc-container_align-items": "{alignItems.center}",
    "spinner_base_arc-container_size": "{size.max}",
    "spinner_base_base-arc_fill": "{primaryGrey40}",
    "spinner_base_base-arc_radius": "{m}",
    "spinner_base_base-arc_arcWidth": "{xs}",
    "spinner_base_base-arc_start": 0,
    "spinner_base_base-arc_end": 360,
    "spinner_base_normal-arc_fill": "{primary50}",
    "spinner_base_normal-arc_radius": "{m}",
    "spinner_base_normal-arc_arcWidth": "{xs}",
    "spinner_base_normal-arc_start": 0,
    "spinner_base_normal-arc_end": 120,
    "spinner_base_normal-arc_animation-duration": "1000",
    "spinner_base_first-arc_fill": "{primary50}",
    "spinner_base_first-arc_radius": "{m}",
    "spinner_base_first-arc_arcWidth": "{xs}",
    "spinner_base_first-arc_start": 0,
    "spinner_base_first-arc_end": 360,
    "spinner_base_first-arc_animation-delay": "300",
    "spinner_base_first-arc_animation-duration": "1300",
    "spinner_base_second-arc_fill": "{secondary50}",
    "spinner_base_second-arc_radius": "{m}",
    "spinner_base_second-arc_arcWidth": "{xs}",
    "spinner_base_second-arc_start": 0,
    "spinner_base_second-arc_end": 360,
    "spinner_base_second-arc_animation-delay": "150",
    "spinner_base_second-arc_animation-duration": "1300",
    "spinner_base_third-arc_fill": "{sparkle50}",
    "spinner_base_third-arc_radius": "{m}",
    "spinner_base_third-arc_arcWidth": "{xs}",
    "spinner_base_third-arc_start": 0,
    "spinner_base_third-arc_end": 360,
    "spinner_base_third-arc_animation-duration": "1300",
    "spinner_variant_labelPosition_bottom_container_flex-direction": "{flexDirection.column}",
    spinner_variant_size_small_container_gap: $f551aa6589c293c2$var$spinner_variant_size_small_container_gap,
    "spinner_variant_size_small_spinner-container_size": "{m}",
    "spinner_variant_size_small_base-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_base-arc_radius": "{s}",
    "spinner_variant_size_small_normal-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_normal-arc_radius": "{s}",
    "spinner_variant_size_small_first-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_first-arc_radius": "{s}",
    "spinner_variant_size_small_second-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_second-arc_radius": "{s}",
    "spinner_variant_size_small_third-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_third-arc_radius": "{s}",
    "spinner_combination_false_inline_normal-arc_fill": "{primaryGrey80}",
    "spinner_combination_small_bottom_container_flex-direction": "{flexDirection.row}"
};
const $f551aa6589c293c2$var$selectorbutton_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$selectorbutton_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$selectorbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_small_container_width = "{l}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_small_container_height = "{l}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_medium_container_width = "{xl}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_medium_container_height = "{xl}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_large_container_width = "{xxl}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_large_container_height = "{xxl}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_extra_large_container_width = "{huge}";
const $f551aa6589c293c2$var$selectorbutton_combination_false_extra_large_container_height = "{huge}";
const $f551aa6589c293c2$var$selectorbutton_combination_true_true_container_width = "{size.max}";
const $f551aa6589c293c2$var$SelectorButtonTokens = {
    "selectorbutton_base_container_background-color": "{primary50}",
    "selectorbutton_base_container_flex-direction": "{flexDirection.row}",
    "selectorbutton_base_container_justify-content": "{justifyContent.center}",
    "selectorbutton_base_container_align-items": "{alignItems.center}",
    "selectorbutton_base_container_border-radius": "{pill}",
    "selectorbutton_base_container_padding-bottom": "{xs}",
    "selectorbutton_base_container_padding-top": "{xs}",
    "selectorbutton_base_container_padding-left": "{base}",
    "selectorbutton_base_container_padding-right": "{base}",
    "selectorbutton_base_container_border-width": "{border_none}",
    selectorbutton_base_container_gap: $f551aa6589c293c2$var$selectorbutton_base_container_gap,
    selectorbutton_base_container_opacity: $f551aa6589c293c2$var$selectorbutton_base_container_opacity,
    "selectorbutton_base_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_base_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_base_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_base_left-icon_size": "{m}",
    "selectorbutton_base_left-icon_color": "{primaryInverse}",
    "selectorbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_base_right-icon_size": "{m}",
    "selectorbutton_base_right-icon_color": "{primaryInverse}",
    "selectorbutton_base_right-icon_behavior_hover_color": "{primary70}",
    selectorbutton_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$selectorbutton_variant_disabled_true_container_opacity,
    "selectorbutton_combination_normal_primary_true_container_background-color": "{primary60}",
    "selectorbutton_combination_normal_primary_true_container_behavior_hover_background-color": "{primary50}",
    "selectorbutton_combination_normal_primary_true_container_behavior_active_background-color": "{primary70}",
    "selectorbutton_combination_normal_primary_true_container_behavior_focus_border-color": "{primary70}",
    "selectorbutton_combination_normal_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_true_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_container_background-color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_contrast_primary_false_container_background-color": "{primaryBackground}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_false_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_container_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-color": "{primary40}",
    "selectorbutton_combination_contrast_primary_true_left-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_true_right-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_contrast_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-bottom": "{xs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-top": "{xs}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-top": "{s}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_true_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_true_small_left-icon_size": "{base}",
    "selectorbutton_combination_true_small_right-icon_size": "{base}",
    "selectorbutton_combination_true_large_container_padding-top": "{s}",
    "selectorbutton_combination_true_large_container_padding-left": "{m}",
    "selectorbutton_combination_true_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_true_large_container_padding-right": "{m}",
    "selectorbutton_combination_true_large_left-icon_size": "{m}",
    "selectorbutton_combination_true_large_right-icon_size": "{m}",
    "selectorbutton_combination_true_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-right": "{l}",
    "selectorbutton_combination_true_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-left": "{l}",
    "selectorbutton_combination_true_extra_large_left-icon_size": "{l}",
    "selectorbutton_combination_true_extra_large_right-icon_size": "{l}",
    selectorbutton_combination_false_small_container_width: $f551aa6589c293c2$var$selectorbutton_combination_false_small_container_width,
    selectorbutton_combination_false_small_container_height: $f551aa6589c293c2$var$selectorbutton_combination_false_small_container_height,
    "selectorbutton_combination_false_small_left-icon_size": "{base}",
    selectorbutton_combination_false_medium_container_width: $f551aa6589c293c2$var$selectorbutton_combination_false_medium_container_width,
    selectorbutton_combination_false_medium_container_height: $f551aa6589c293c2$var$selectorbutton_combination_false_medium_container_height,
    selectorbutton_combination_false_large_container_width: $f551aa6589c293c2$var$selectorbutton_combination_false_large_container_width,
    selectorbutton_combination_false_large_container_height: $f551aa6589c293c2$var$selectorbutton_combination_false_large_container_height,
    "selectorbutton_combination_false_large_left-icon_size": "{m}",
    selectorbutton_combination_false_extra_large_container_width: $f551aa6589c293c2$var$selectorbutton_combination_false_extra_large_container_width,
    selectorbutton_combination_false_extra_large_container_height: $f551aa6589c293c2$var$selectorbutton_combination_false_extra_large_container_height,
    "selectorbutton_combination_false_extra_large_left-icon_size": "{l}",
    selectorbutton_combination_true_true_container_width: $f551aa6589c293c2$var$selectorbutton_combination_true_true_container_width,
    "selectorbutton_combination_true_true_container_justify-content": "{justifyContent.spaceBetween}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_behavior_hover_color": "{primary60}"
};
const $f551aa6589c293c2$var$HorizontalStepItemTokens = {
    "horizontalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "horizontalstepitem_base_stepper-outer-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "horizontalstepitem_base_stepper-outer-container_size": "{size.max}",
    "horizontalstepitem_base_stepper-outer-container_gap": "{xs}",
    "horizontalstepitem_base_stepper-inner-container_flex-direction": "{flexDirection.row}",
    "horizontalstepitem_base_stepper-inner-container_width": "{size.max}",
    "horizontalstepitem_base_stepper-inner-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-inner-container_gap": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-right": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-left": "{xs}",
    "horizontalstepitem_base_start-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_base_end-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}",
    "horizontalstepitem_variant_direction_end_start-jds_divider_opacity": "{opacity.invisible}"
};
const $f551aa6589c293c2$var$stepperdot_base_icon_color = "{sparkleGrey60}";
const $f551aa6589c293c2$var$stepperdot_base_icon_size = "{base}";
const $f551aa6589c293c2$var$stepperdot_combination_warning_active_icon_color = "{sparkle60}";
const $f551aa6589c293c2$var$stepperdot_combination_warning_complete_icon_color = "{sparkle60}";
const $f551aa6589c293c2$var$StepperDotTokens = {
    "stepperdot_base_step-icon-container_background-color": "{global.transparent}",
    "stepperdot_base_step-icon-container_border-width": "{border_thin}",
    "stepperdot_base_step-icon-container_border-color": "{sparkleGrey60}",
    "stepperdot_base_step-icon-container_min-height": "{l}",
    "stepperdot_base_step-icon-container_min-width": "{l}",
    "stepperdot_base_step-icon-container_justify-content": "{justifyContent.center}",
    "stepperdot_base_step-icon-container_align-items": "{alignItems.center}",
    "stepperdot_base_step-icon-container_border-radius": "{pill}",
    stepperdot_base_icon_color: $f551aa6589c293c2$var$stepperdot_base_icon_color,
    stepperdot_base_icon_size: $f551aa6589c293c2$var$stepperdot_base_icon_size,
    "stepperdot_base_complete-icon_color": "{sparkle60}",
    "stepperdot_base_complete-icon_size": "{base}",
    "stepperdot_base_dot-container_background-color": "{sparkleGrey60}",
    "stepperdot_base_dot-container_width": "{xs}",
    "stepperdot_base_dot-container_height": "{xs}",
    "stepperdot_base_dot-container_border-radius": "{pill}",
    "stepperdot_variant_state_active_step-icon-container_background-color": "{sparkle50}",
    "stepperdot_variant_state_active_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_state_active_icon-color": "{sparkleInverse}",
    "stepperdot_variant_state_active_dot-container_background-color": "{sparkleInverse}",
    "stepperdot_variant_state_complete_step-icon-container_background-color": "{sparkle20}",
    "stepperdot_variant_state_complete_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_itemsType_icon_step-icon-container_height": "{l}",
    "stepperdot_variant_itemsType_icon_step-icon-container_width": "{l}",
    stepperdot_combination_warning_active_icon_color: $f551aa6589c293c2$var$stepperdot_combination_warning_active_icon_color,
    stepperdot_combination_warning_complete_icon_color: $f551aa6589c293c2$var$stepperdot_combination_warning_complete_icon_color,
    "stepperdot_variant_state_disabled_step-icon-container_opacity": "{opacity.disabled}"
};
const $f551aa6589c293c2$var$VerticalStepItemTokens = {
    "verticalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "verticalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_stepper-outer-container_align-items": "{alignItems.start}",
    "verticalstepitem_base_stepper-outer-container_gap": "{xs}",
    "verticalstepitem_base_stepper-outer-container_size": "{size.max}",
    "verticalstepitem_base_end-container_opacity": "{opacity.enabled}",
    "verticalstepitem_base_content-child-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_content-child-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_content-child-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-indicator-container_height": "{intrinsicSize.max}",
    "verticalstepitem_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-indicator-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-indicator-container_align-items": "{alignItems.stretch}",
    "verticalstepitem_base_step-indicator-container_min-height": "{l}",
    "verticalstepitem_base_step-indicator-container_padding-left": "{custom_23}",
    "verticalstepitem_base_step-dot-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-dot-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-dot-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-dot-container_gap": "{base}",
    "verticalstepitem_base_content-container_padding-top": "0",
    "verticalstepitem_base_content-container_padding-bottom": "0",
    "verticalstepitem_base_content-container_padding-left": "{custom_24}",
    "verticalstepitem__hideChild_true_content-container_padding-top": "{xs}",
    "verticalstepitem__hideChild_true_content-container_padding-bottom": "{m}",
    "verticalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}"
};
const $f551aa6589c293c2$var$verticalstepper_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$verticalstepper_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$VerticalStepperTokens = {
    "verticalstepper_base_container_flex-direction": "{flexDirection.column}",
    "verticalstepper_base_container_justify-content": "{justifyContent.start}",
    "verticalstepper_base_container_align-items": "{alignItems.start}",
    verticalstepper_base_container_size: $f551aa6589c293c2$var$verticalstepper_base_container_size,
    verticalstepper_base_container_gap: $f551aa6589c293c2$var$verticalstepper_base_container_gap
};
const $f551aa6589c293c2$var$horizontalstepper_base_container_gap = "{stepper_horizontal}";
const $f551aa6589c293c2$var$horizontalstepper_base_container_size = "{size.max}";
const $f551aa6589c293c2$var$HorizontalStepperTokens = {
    horizontalstepper_base_container_gap: $f551aa6589c293c2$var$horizontalstepper_base_container_gap,
    "horizontalstepper_base_container_flex-direction": "{flexDirection.column}",
    horizontalstepper_base_container_size: $f551aa6589c293c2$var$horizontalstepper_base_container_size,
    "horizontalstepper_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_step-indicator-container_justify-content": "{justifyContent.center}",
    "horizontalstepper_base_step-indicator-container_align-items": "{alignItems.center}",
    "horizontalstepper_base_step-indicator-container_size": "{size.max}",
    "horizontalstepper_base_step-indicator-container_padding-left": "{l}",
    "horizontalstepper_base_step-indicator-container_padding-right": "{l}",
    "horizontalstepper_base_stepper-children-container_size": "{size.max}",
    "horizontalstepper_base_stepper-children-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_stepper-children-container_justify-content": "{justifyContent.start}",
    "horizontalstepper_base_stepper-children-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$tablebody_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$tablebody_variant_fullWidth_container_width = "{size.max}";
const $f551aa6589c293c2$var$TableBodyTokens = {
    tablebody_base_container_width: $f551aa6589c293c2$var$tablebody_base_container_width,
    "tablebody_base_container_flex-direction": "{flexDirection.row}",
    tablebody_variant_fullWidth_container_width: $f551aa6589c293c2$var$tablebody_variant_fullWidth_container_width
};
const $f551aa6589c293c2$var$table_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$table_variant_fullWidth_container_width = "{size.max}";
const $f551aa6589c293c2$var$TableTokens = {
    "table_base_container_flex-direction": "{flexDirection.column}",
    table_base_container_width: $f551aa6589c293c2$var$table_base_container_width,
    "table_base_container_border-radius": "{medium}",
    "table_base_container_border-width": "{border_thin}",
    "table_base_container_border-color": "{primaryGrey40}",
    table_variant_fullWidth_container_width: $f551aa6589c293c2$var$table_variant_fullWidth_container_width,
    "table_base_container_align-items": "{alignItems.start}",
    "table_base_footer-jds_text_padding-left": "{base}",
    "table_base_footer-jds_text_padding-right": "{base}",
    "table_base_footer-jds_text_padding-top": "{base}",
    "table_base_footer-jds_text_padding-bottom": "{base}",
    "table_variant_density_condensed_footer-jds_text_padding-left": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-right": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-top": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-bottom": "{xs}"
};
const $f551aa6589c293c2$var$tablerow_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$tablerow_variant_fullWidth_container_width = "{size.max}";
const $f551aa6589c293c2$var$TableRowTokens = {
    "tablerow_base_container_flex-direction": "{flexDirection.column}",
    tablerow_base_container_width: $f551aa6589c293c2$var$tablerow_base_container_width,
    tablerow_variant_fullWidth_container_width: $f551aa6589c293c2$var$tablerow_variant_fullWidth_container_width
};
const $f551aa6589c293c2$var$tablecell_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$TableCellTokens = {
    "tablecell_base_container_flex-direction": "{flexDirection.row}",
    "tablecell_base_container_justify-content": "{justifyContent.start}",
    "tablecell_base_container_align-items": "{alignItems.center}",
    "tablecell_base_container_background-color": "{global.transparent}",
    "tablecell_base_container_padding-left": "{base}",
    "tablecell_base_container_padding-right": "{base}",
    "tablecell_base_container_padding-top": "{base}",
    "tablecell_base_container_padding-bottom": "{base}",
    "tablecell_base_container_border-color": "{primaryGrey40}",
    tablecell_base_container_width: $f551aa6589c293c2$var$tablecell_base_container_width,
    "tablecell_variant_density_condensed_container_padding-left": "{xs}",
    "tablecell_variant_density_condensed_container_padding-right": "{xs}",
    "tablecell_variant_density_condensed_container_padding-top": "{xs}",
    "tablecell_variant_density_condensed_container_padding-bottom": "{xs}",
    "tablecell_variant_columnDivider_true_container_border-color": "{primaryGrey40}",
    "tablecell_variant_columnDivider_true_container_border-right-width": 1,
    "tablecell_combination_header_true_container_background-color": "{primary50}",
    "tablecell_combination_header_true_container_border-color": "{primary60}",
    "tablecell_combination_cell_true_container_background-color": "{primaryGrey20}",
    "tablecell_combination_header_true_container_border-bottom-width": 1,
    "tablecell_combination_header_false_container_border-bottom-width": 4,
    "tablecell_combination_cell_true_container_border-bottom-width": 0
};
const $f551aa6589c293c2$var$tabbar_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$TabBarTokens = {
    "tabbar_base_container_flex-direction": "{flexDirection.stack}",
    tabbar_base_container_width: $f551aa6589c293c2$var$tabbar_base_container_width,
    "tabbar_base_indicator-container_width": "{size.max}",
    "tabbar_base_container_justify-content": "{justifyContent.start}",
    "tabbar_base_container_align-items": "{alignItems.end}",
    "tabbar_base_tab-container_width": "{size.max}",
    "tabbar_base_tab-container_opacity": "{opacity.enabled}",
    "tabbar_base_tab-container_background-color": "{global.transparent}",
    "tabbar_base_tab-container_align-items": "{alignItems.center}",
    "tabbar_base_tab-container_justify-content": "{justifyContent.start}",
    "tabbar_base_tab-container_gap": "{m}",
    "tabbar_base_tab-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_justify-content": "{justifyContent.start}",
    "tabbar_base_outer-container_align-items": "{alignItems.center}",
    "tabbar_base_outer-container_width": "{size.max}",
    "tabbar_base_inner-container_border-radius": "{pill}",
    "tabbar_base_inner-container_background-color": "{primary50}",
    "tabbar_base_inner-container_height": "{xxs}",
    "tabbar_variant_overflow_fit_tab-container_width": "{size.max}",
    "tabbar_variant_overflow_fit_tab-container_justify-content": "{justifyContent.center}",
    "tabbar_variant_appearance_tab_bar_tab-container_background-color": "{primary60}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-right": "{xxl}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-left": "{xxl}",
    "tabbar_variant_appearance_tab_bar_inner-container_background-color": "{custom_dark_primary_60}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-right": "{m}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-left": "{m}"
};
const $f551aa6589c293c2$var$tag_base_container_gap = "{xxs}";
const $f551aa6589c293c2$var$tag_base_icon_size = "{base}";
const $f551aa6589c293c2$var$tag_base_icon_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$tag_base_icon_behavior_hover_color = "{sparkle80}";
const $f551aa6589c293c2$var$tag_base_icon_behavior_active_color = "{sparkle80}";
const $f551aa6589c293c2$var$tag_base_icon_behavior_focus_color = "{sparkle80}";
const $f551aa6589c293c2$var$tag_variant_active_true_icon_color = "{sparkle80}";
const $f551aa6589c293c2$var$tag_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$tag_base_container_opacity = "{opacity.enabled}";
const $f551aa6589c293c2$var$TagTokens = {
    "tag_base_container_flex-direction": "{flexDirection.row}",
    "tag_base_container_justify-content": "{justifyContent.start}",
    "tag_base_container_align-items": "{alignItems.center}",
    "tag_base_container_padding-top": "{xxs}",
    "tag_base_container_padding-left": "{s}",
    "tag_base_container_padding-right": "{s}",
    "tag_base_container_padding-bottom": "{xxs}",
    tag_base_container_gap: $f551aa6589c293c2$var$tag_base_container_gap,
    "tag_base_container_background-color": "{global.transparent}",
    "tag_base_container_border-radius": "{pill}",
    "tag_base_container_border-width": "{border_thin}",
    "tag_base_container_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_hover_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_active_border-color": "{sparkle20}",
    "tag_base_container_behavior_focus_border-color": "{sparkle80}",
    "tag_base_container_behavior_focus_border-width": "{border_focus}",
    tag_base_icon_size: $f551aa6589c293c2$var$tag_base_icon_size,
    tag_base_icon_color: $f551aa6589c293c2$var$tag_base_icon_color,
    tag_base_icon_behavior_hover_color: $f551aa6589c293c2$var$tag_base_icon_behavior_hover_color,
    tag_base_icon_behavior_active_color: $f551aa6589c293c2$var$tag_base_icon_behavior_active_color,
    tag_base_icon_behavior_focus_color: $f551aa6589c293c2$var$tag_base_icon_behavior_focus_color,
    "tag_variant_active_true_container_border-width": "{border_none}",
    "tag_variant_active_true_container_border-color": "{primaryGrey80}",
    "tag_variant_active_true_container_background-color": "{sparkle20}",
    "tag_variant_active_true_container_behavior_hover_background-color": "{sparkle30}",
    "tag_variant_active_true_container_behavior_active_background-color": "{global.transparent}",
    "tag_variant_active_true_container_behavior_active_border-color": "{primaryGrey40}",
    "tag_variant_active_true_container_behavior_focus_background-color": "{sparkle30}",
    tag_variant_active_true_icon_color: $f551aa6589c293c2$var$tag_variant_active_true_icon_color,
    tag_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$tag_variant_disabled_true_container_opacity,
    tag_base_container_opacity: $f551aa6589c293c2$var$tag_base_container_opacity,
    "tag_variant_size_small_container_padding-top": "{custom_4}",
    "tag_variant_size_small_container_padding-left": "{xs}",
    "tag_variant_size_small_container_padding-right": "{xs}",
    "tag_variant_size_small_container_padding-bottom": "{custom_4}"
};
const $f551aa6589c293c2$var$tabsdesktop_base_container_width = "{size.max}";
const $f551aa6589c293c2$var$tabsdesktop_base_jds_tab_bar_width = "{size.max}";
const $f551aa6589c293c2$var$TabsDesktopTokens = {
    "tabsdesktop_base_container_flex-direction": "{flexDirection.column}",
    tabsdesktop_base_container_width: $f551aa6589c293c2$var$tabsdesktop_base_container_width,
    tabsdesktop_base_jds_tab_bar_width: $f551aa6589c293c2$var$tabsdesktop_base_jds_tab_bar_width,
    "tabsdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "tabsdesktop_base_header-container_width": "{size.max}",
    "tabsdesktop_base_header-container_align-items": "{alignItems.center}",
    "tabsdesktop_base_tablist-container_width": "{size.max}",
    "tabsdesktop_variant_overflow_arrows_header-container_gap": "{base}",
    "tabsdesktop_variant_appearance_tab_bar_header-container_background-color": "{primary60}"
};
const $f551aa6589c293c2$var$tabitem_base_container_gap = "{xs}";
const $f551aa6589c293c2$var$tabitem_base_icon_size = "{m}";
const $f551aa6589c293c2$var$tabitem_base_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$tabitem_base_icon_behavior_hover_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$tabitem_base_icon_behavior_active_color = "{primary60}";
const $f551aa6589c293c2$var$tabitem_base_text_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$tabitem_base_text_behavior_hover_color = "{primary60}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_normal_text_behavior_hover_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_normal_text_behavior_active_color = "{primary60}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_color = "{custom_dark_primary_grey_100}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color = "{custom_dark_primary_grey_100}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_color = "{custom_dark_primary_grey_100}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color = "{custom_dark_primary_grey_100}";
const $f551aa6589c293c2$var$tabitem_combination_active_normal_icon_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$tabitem_combination_active_normal_text_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$TabItemTokens = {
    "tabitem_base_outer-container_background-color": "{global.transparent}",
    "tabitem_base_outer-container_flex-direction": "{flexDirection.column}",
    "tabitem_base_outer-container_align-items": "{alignItems.center}",
    "tabitem_base_outer-container_justify-content": "{justifyContent.center}",
    "tabitem_base_outer-container_min-height": "{xxl}",
    "tabitem_base_outer-container_width": "{intrinsicSize.max}",
    "tabitem_base_outer-container_height": "{intrinsicSize.max}",
    "tabitem_base_container_flex-direction": "{flexDirection.row}",
    "tabitem_base_container_align-items": "{alignItems.center}",
    "tabitem_base_container_justify-content": "{justifyContent.center}",
    tabitem_base_container_gap: $f551aa6589c293c2$var$tabitem_base_container_gap,
    "tabitem_base_container_padding-top": "{s}",
    "tabitem_base_container_padding-bottom": "{s}",
    "tabitem_base_container_padding-right": "{xs}",
    "tabitem_base_container_padding-left": "{xs}",
    "tabitem_base_container_behavior_focus_border-width": "{border_normal}",
    "tabitem_base_container_behavior_focus_border-color": "{primary80}",
    "tabitem_base_container_behavior_focus_border-radius": "{large}",
    tabitem_base_icon_size: $f551aa6589c293c2$var$tabitem_base_icon_size,
    tabitem_base_icon_color: $f551aa6589c293c2$var$tabitem_base_icon_color,
    tabitem_base_icon_behavior_hover_color: $f551aa6589c293c2$var$tabitem_base_icon_behavior_hover_color,
    tabitem_base_icon_behavior_active_color: $f551aa6589c293c2$var$tabitem_base_icon_behavior_active_color,
    tabitem_base_text_color: $f551aa6589c293c2$var$tabitem_base_text_color,
    "tabitem_base_text_font-size": "{bodyS}",
    "tabitem_base_text_font-family": "{bodyS}",
    "tabitem_base_text_font-weight": "{bodyS}",
    "tabitem_base_text_line-height": "{bodyS}",
    "tabitem_base_text_letter-spacing": "{bodyS}",
    tabitem_base_text_behavior_hover_color: $f551aa6589c293c2$var$tabitem_base_text_behavior_hover_color,
    "tabitem_base_indicator-container_background-color": "{global.transparent}",
    "tabitem_base_indicator-container_height": "{xxs}",
    "tabitem_base_indicator-container_width": "{size.max}",
    "tabitem_base_indicator-container_border-radius": "{pill}",
    "tabitem_base_outer-container_opacity": "{opacity.enabled}",
    "tabitem_variant_disabled_true_outer-container_opacity": "{opacity.disabled}",
    tabitem_variant_appearance_normal_text_behavior_hover_color: $f551aa6589c293c2$var$tabitem_variant_appearance_normal_text_behavior_hover_color,
    tabitem_variant_appearance_normal_text_behavior_active_color: $f551aa6589c293c2$var$tabitem_variant_appearance_normal_text_behavior_active_color,
    "tabitem_variant_appearance_tab_bar_container_behavior_active_background-color": "{custom_dark_primary_40}",
    "tabitem_variant_appearance_tab_bar_container_behavior_focus_border-color": "{custom_dark_primary_60}",
    tabitem_variant_appearance_tab_bar_icon_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_hover_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_active_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color,
    tabitem_variant_appearance_tab_bar_text_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_color,
    tabitem_variant_appearance_tab_bar_text_behavior_hover_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_text_behavior_active_color: $f551aa6589c293c2$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color,
    tabitem_combination_active_normal_icon_color: $f551aa6589c293c2$var$tabitem_combination_active_normal_icon_color,
    tabitem_combination_active_normal_text_color: $f551aa6589c293c2$var$tabitem_combination_active_normal_text_color
};
const $f551aa6589c293c2$var$TooltipTokens = {
    "tooltip_base_popup-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_popup-container_justify-content": "{justifyContent.start}",
    "tooltip_base_popup-container_align-items": "{alignItems.start}",
    "tooltip_base_root-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_root-container_justify-content": "{justifyContent.start}",
    "tooltip_base_root-container_align-items": "{alignItems.center}",
    "tooltip_base_root-container_overflow": "hidden",
    "tooltip_base_text-container_border-radius": "{medium}",
    "tooltip_base_text-container_border-width": "{border_thin}",
    "tooltip_base_text-container_background-color": "{primaryGrey100}",
    "tooltip_base_start-tooltip_color": "{primaryGrey100}",
    "tooltip_base_end-tooltip_color": "{primaryGrey100}",
    "tooltip_base_text-container_padding-left": "{base}",
    "tooltip_base_text-container_padding-right": "{base}",
    "tooltip_base_text-container_padding-top": "{xs}",
    "tooltip_base_text-container_padding-bottom": "{xs}",
    "tooltip_variant_position_right_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_right_start_start-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_right_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_right_end_start-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_left_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_left_start_end-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_left_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_left_end_end-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_top_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_top_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_top_start_end-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_top_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_top_end_end-tooltip_padding-right": "{xs}",
    "tooltip_variant_position_bottom_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_bottom_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_bottom_start_start-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_bottom_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_bottom_end_start-tooltip_padding-right": "{xs}",
    "tooltip_base_text-container_min-height": "{xl}",
    "tooltip_base_text-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$ToggleTokens = {
    "toggle_base_prefix-icon-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_justify-content": "{justifyContent.start}",
    "toggle_base_vertical-container_align-items": "{alignItems.start}",
    "toggle_base_vertical-container_gap": "{xs}",
    "toggle_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "toggle_base_horizontal-container_justify-content": "{justifyContent.start}",
    "toggle_base_horizontal-container_align-items": "{alignItems.center}",
    "toggle_base_horizontal-container_gap": "{xs}",
    "toggle_base_pill-container_min-width": "{custom_2}",
    "toggle_base_pill-container_min-height": "{m}",
    "toggle_base_pill-container_flex-direction": "{flexDirection.row}",
    "toggle_base_pill-container_justify-content": "{justifyContent.start}",
    "toggle_base_pill-container_align-items": "{alignItems.center}",
    "toggle_base_pill-container_padding-left": "{xxs}",
    "toggle_base_pill-container_padding-right": "{xxs}",
    "toggle_base_pill-container_background-color": "{global.transparent}",
    "toggle_base_pill-container_border-radius": "{pill}",
    "toggle_base_pill-container_border-width": "{border_thin}",
    "toggle_base_pill-container_border-color": "{primaryGrey80}",
    "toggle_base_pill-container_behavior_hover_border-color": "{primary40}",
    "toggle_base_pill-container_behavior_active_border-color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_box-shadow_spread": "{xxs}",
    "toggle_base_pill-container_behavior_focus_box-shadow_color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_border-width": "{border_none}",
    "toggle_base_ball-container_min-width": "{base}",
    "toggle_base_ball-container_min-height": "{base}",
    "toggle_base_ball-container_background-color": "{primaryGrey80}",
    "toggle_base_ball-container_border-radius": "{pill}",
    "toggle_base_left-jds_text_text-align": "{textAlign.start}",
    "toggle_variant_size_small_pill-container_min-width": "{custom_3}",
    "toggle_variant_size_small_pill-container_min-height": "{base}",
    "toggle_variant_size_small_vertical-container_gap": "{xxs}",
    "toggle_variant_size_small_ball-container_min-width": "{xs}",
    "toggle_variant_size_small_ball-container_min-height": "{xs}",
    "toggle_variant_checked_true_pill-container_justify-content": "{justifyContent.end}",
    "toggle_variant_checked_true_pill-container_background-color": "{primary50}",
    "toggle_variant_checked_true_pill-container_border-width": "{border_none}",
    "toggle_variant_checked_true_pill-container_behavior_hover_background-color": "{primary40}",
    "toggle_variant_checked_true_pill-container_behavior_active_background-color": "{primary60}",
    "toggle_variant_checked_true_ball-container_background-color": "{primaryInverse}",
    "toggle_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "toggle_base_vertical-container_opacity": "{opacity.enabled}"
};
const $f551aa6589c293c2$var$text_link_color = "{primary60}";
const $f551aa6589c293c2$var$text_base_text_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$text_variant_color_primary_80_text_color = "{primary80}";
const $f551aa6589c293c2$var$text_variant_color_primary_70_text_color = "{primary70}";
const $f551aa6589c293c2$var$text_variant_color_primary_60_text_color = "{primary60}";
const $f551aa6589c293c2$var$text_variant_color_primary_50_text_color = "{primary50}";
const $f551aa6589c293c2$var$text_variant_color_primary_40_text_color = "{primary40}";
const $f551aa6589c293c2$var$text_variant_color_primary_30_text_color = "{primary30}";
const $f551aa6589c293c2$var$text_variant_color_primary_20_text_color = "{primary20}";
const $f551aa6589c293c2$var$text_variant_color_primary_inverse_text_color = "{primaryInverse}";
const $f551aa6589c293c2$var$text_variant_color_primary_background_text_color = "{primaryBackground}";
const $f551aa6589c293c2$var$text_variant_color_primary_grey_100_text_color = "{primaryGrey100}";
const $f551aa6589c293c2$var$text_variant_color_primary_grey_80_text_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$text_variant_color_primary_grey_60_text_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$text_variant_color_primary_grey_40_text_color = "{primaryGrey40}";
const $f551aa6589c293c2$var$text_variant_color_primary_grey_20_text_color = "{primaryGrey20}";
const $f551aa6589c293c2$var$text_variant_color_secondary_80_text_color = "{secondary80}";
const $f551aa6589c293c2$var$text_variant_color_secondary_70_text_color = "{secondary70}";
const $f551aa6589c293c2$var$text_variant_color_secondary_60_text_color = "{secondary60}";
const $f551aa6589c293c2$var$text_variant_color_secondary_50_text_color = "{secondary50}";
const $f551aa6589c293c2$var$text_variant_color_secondary_40_text_color = "{secondary40}";
const $f551aa6589c293c2$var$text_variant_color_secondary_30_text_color = "{secondary30}";
const $f551aa6589c293c2$var$text_variant_color_secondary_20_text_color = "{secondary20}";
const $f551aa6589c293c2$var$text_variant_color_secondary_inverse_text_color = "{secondaryInverse}";
const $f551aa6589c293c2$var$text_variant_color_secondary_background_text_color = "{secondaryBackground}";
const $f551aa6589c293c2$var$text_variant_color_secondary_grey_100_text_color = "{secondaryGrey100}";
const $f551aa6589c293c2$var$text_variant_color_secondary_grey_80_text_color = "{secondaryGrey80}";
const $f551aa6589c293c2$var$text_variant_color_secondary_grey_60_text_color = "{secondaryGrey60}";
const $f551aa6589c293c2$var$text_variant_color_secondary_grey_40_text_color = "{secondaryGrey40}";
const $f551aa6589c293c2$var$text_variant_color_secondary_grey_20_text_color = "{secondaryGrey20}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_80_text_color = "{sparkle80}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_70_text_color = "{sparkle70}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_60_text_color = "{sparkle60}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_50_text_color = "{sparkle50}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_40_text_color = "{sparkle40}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_30_text_color = "{sparkle30}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_20_text_color = "{sparkle20}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_inverse_text_color = "{sparkleInverse}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_background_text_color = "{sparkleBackground}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_grey_100_text_color = "{sparkleGrey100}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_grey_80_text_color = "{sparkleGrey80}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_grey_60_text_color = "{sparkleGrey60}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_grey_40_text_color = "{sparkleGrey40}";
const $f551aa6589c293c2$var$text_variant_color_sparkle_grey_20_text_color = "{sparkleGrey20}";
const $f551aa6589c293c2$var$text_variant_color_feedback_error_80_text_color = "{feedbackError80}";
const $f551aa6589c293c2$var$text_variant_color_feedback_error_50_text_color = "{feedbackError50}";
const $f551aa6589c293c2$var$text_variant_color_feedback_error_20_text_color = "{feedbackError20}";
const $f551aa6589c293c2$var$text_variant_color_feedback_warning_80_text_color = "{feedbackWarning80}";
const $f551aa6589c293c2$var$text_variant_color_feedback_warning_50_text_color = "{feedbackWarning50}";
const $f551aa6589c293c2$var$text_variant_color_feedback_warning_20_text_color = "{feedbackWarning20}";
const $f551aa6589c293c2$var$text_variant_color_feedback_success_80_text_color = "{feedbackSuccess80}";
const $f551aa6589c293c2$var$text_variant_color_feedback_success_50_text_color = "{feedbackSuccess50}";
const $f551aa6589c293c2$var$text_variant_color_feedback_success_20_text_color = "{feedbackSuccess20}";
const $f551aa6589c293c2$var$text_variant_color_white_text_color = "{global.white}";
const $f551aa6589c293c2$var$text_variant_color_black_text_color = "{global.black}";
const $f551aa6589c293c2$var$text_variant_color_transparent_text_color = "{global.transparent}";
const $f551aa6589c293c2$var$TextTokens = {
    text_link_color: $f551aa6589c293c2$var$text_link_color,
    "text_base_text_font-family": "{bodyS}",
    text_base_text_color: $f551aa6589c293c2$var$text_base_text_color,
    "text_base_text_font-size": "{bodyS}",
    "text_base_text_line-height": "{bodyS}",
    "text_base_text_letter-spacing": "{bodyS}",
    "text_base_text_font-weight": "{bodyS}",
    "text_base_text_text-decoration": "{text-decoration.none}",
    "text_base_text_text-transform": "{text-case.none}",
    "text_variant_textDecoration_underline_text_text-decoration": "{text-decoration.underline}",
    "text_variant_textDecoration_line-through_text_text-decoration": "{text-decoration.line-through}",
    "text_variant_textDecoration_overline_text_text-decoration": "{text-decoration.overline}",
    text_variant_color_primary_80_text_color: $f551aa6589c293c2$var$text_variant_color_primary_80_text_color,
    text_variant_color_primary_70_text_color: $f551aa6589c293c2$var$text_variant_color_primary_70_text_color,
    text_variant_color_primary_60_text_color: $f551aa6589c293c2$var$text_variant_color_primary_60_text_color,
    text_variant_color_primary_50_text_color: $f551aa6589c293c2$var$text_variant_color_primary_50_text_color,
    text_variant_color_primary_40_text_color: $f551aa6589c293c2$var$text_variant_color_primary_40_text_color,
    text_variant_color_primary_30_text_color: $f551aa6589c293c2$var$text_variant_color_primary_30_text_color,
    text_variant_color_primary_20_text_color: $f551aa6589c293c2$var$text_variant_color_primary_20_text_color,
    text_variant_color_primary_inverse_text_color: $f551aa6589c293c2$var$text_variant_color_primary_inverse_text_color,
    text_variant_color_primary_background_text_color: $f551aa6589c293c2$var$text_variant_color_primary_background_text_color,
    text_variant_color_primary_grey_100_text_color: $f551aa6589c293c2$var$text_variant_color_primary_grey_100_text_color,
    text_variant_color_primary_grey_80_text_color: $f551aa6589c293c2$var$text_variant_color_primary_grey_80_text_color,
    text_variant_color_primary_grey_60_text_color: $f551aa6589c293c2$var$text_variant_color_primary_grey_60_text_color,
    text_variant_color_primary_grey_40_text_color: $f551aa6589c293c2$var$text_variant_color_primary_grey_40_text_color,
    text_variant_color_primary_grey_20_text_color: $f551aa6589c293c2$var$text_variant_color_primary_grey_20_text_color,
    text_variant_color_secondary_80_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_80_text_color,
    text_variant_color_secondary_70_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_70_text_color,
    text_variant_color_secondary_60_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_60_text_color,
    text_variant_color_secondary_50_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_50_text_color,
    text_variant_color_secondary_40_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_40_text_color,
    text_variant_color_secondary_30_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_30_text_color,
    text_variant_color_secondary_20_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_20_text_color,
    text_variant_color_secondary_inverse_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_inverse_text_color,
    text_variant_color_secondary_background_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_background_text_color,
    text_variant_color_secondary_grey_100_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_grey_100_text_color,
    text_variant_color_secondary_grey_80_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_grey_80_text_color,
    text_variant_color_secondary_grey_60_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_grey_60_text_color,
    text_variant_color_secondary_grey_40_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_grey_40_text_color,
    text_variant_color_secondary_grey_20_text_color: $f551aa6589c293c2$var$text_variant_color_secondary_grey_20_text_color,
    text_variant_color_sparkle_80_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_80_text_color,
    text_variant_color_sparkle_70_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_70_text_color,
    text_variant_color_sparkle_60_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_60_text_color,
    text_variant_color_sparkle_50_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_50_text_color,
    text_variant_color_sparkle_40_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_40_text_color,
    text_variant_color_sparkle_30_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_30_text_color,
    text_variant_color_sparkle_20_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_20_text_color,
    text_variant_color_sparkle_inverse_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_inverse_text_color,
    text_variant_color_sparkle_background_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_background_text_color,
    text_variant_color_sparkle_grey_100_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_grey_100_text_color,
    text_variant_color_sparkle_grey_80_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_grey_80_text_color,
    text_variant_color_sparkle_grey_60_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_grey_60_text_color,
    text_variant_color_sparkle_grey_40_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_grey_40_text_color,
    text_variant_color_sparkle_grey_20_text_color: $f551aa6589c293c2$var$text_variant_color_sparkle_grey_20_text_color,
    text_variant_color_feedback_error_80_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_error_80_text_color,
    text_variant_color_feedback_error_50_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_error_50_text_color,
    text_variant_color_feedback_error_20_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_error_20_text_color,
    text_variant_color_feedback_warning_80_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_warning_80_text_color,
    text_variant_color_feedback_warning_50_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_warning_50_text_color,
    text_variant_color_feedback_warning_20_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_warning_20_text_color,
    text_variant_color_feedback_success_80_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_success_80_text_color,
    text_variant_color_feedback_success_50_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_success_50_text_color,
    text_variant_color_feedback_success_20_text_color: $f551aa6589c293c2$var$text_variant_color_feedback_success_20_text_color,
    text_variant_color_white_text_color: $f551aa6589c293c2$var$text_variant_color_white_text_color,
    text_variant_color_black_text_color: $f551aa6589c293c2$var$text_variant_color_black_text_color,
    text_variant_color_transparent_text_color: $f551aa6589c293c2$var$text_variant_color_transparent_text_color,
    "text_variant_appearance_heading_xl_text_font-size": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-family": "{headingXl}",
    "text_variant_appearance_heading_xl_text_line-height": "{headingXl}",
    "text_variant_appearance_heading_xl_text_letter-spacing": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-weight": "{headingXl}",
    "text_variant_appearance_heading_l_text_font-size": "{headingL}",
    "text_variant_appearance_heading_l_text_font-family": "{headingL}",
    "text_variant_appearance_heading_l_text_line-height": "{headingL}",
    "text_variant_appearance_heading_l_text_letter-spacing": "{headingL}",
    "text_variant_appearance_heading_l_text_font-weight": "{headingL}",
    "text_variant_appearance_heading_m_text_font-size": "{headingM}",
    "text_variant_appearance_heading_m_text_font-family": "{headingM}",
    "text_variant_appearance_heading_m_text_line-height": "{headingM}",
    "text_variant_appearance_heading_m_text_letter-spacing": "{headingM}",
    "text_variant_appearance_heading_m_text_font-weight": "{headingM}",
    "text_variant_appearance_heading_s_text_font-size": "{headingS}",
    "text_variant_appearance_heading_s_text_font-family": "{headingS}",
    "text_variant_appearance_heading_s_text_line-height": "{headingS}",
    "text_variant_appearance_heading_s_text_letter-spacing": "{headingS}",
    "text_variant_appearance_heading_s_text_font-weight": "{headingS}",
    "text_variant_appearance_heading_xs_text_font-size": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-family": "{headingXs}",
    "text_variant_appearance_heading_xs_text_line-height": "{headingXs}",
    "text_variant_appearance_heading_xs_text_letter-spacing": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-weight": "{headingXs}",
    "text_variant_appearance_heading_xxs_text_font-size": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-family": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_line-height": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_letter-spacing": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-weight": "{headingXxs}",
    "text_variant_appearance_overline_text_font-size": "{overline}",
    "text_variant_appearance_overline_text_font-family": "{overline}",
    "text_variant_appearance_overline_text_line-height": "{overline}",
    "text_variant_appearance_overline_text_letter-spacing": "{overline}",
    "text_variant_appearance_overline_text_font-weight": "{overline}",
    "text_variant_appearance_overline_text_text-transform": "{overline}",
    "text_variant_appearance_body_l_text_font-size": "{bodyL}",
    "text_variant_appearance_body_l_text_font-family": "{bodyL}",
    "text_variant_appearance_body_l_text_line-height": "{bodyL}",
    "text_variant_appearance_body_l_text_letter-spacing": "{bodyL}",
    "text_variant_appearance_body_l_text_font-weight": "{bodyL}",
    "text_variant_appearance_body_l_bold_text_font-size": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-family": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_line-height": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_letter-spacing": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-weight": "{bodyLBold}",
    "text_variant_appearance_body_l_link_text_font-size": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-family": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_line-height": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_letter-spacing": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-weight": "{bodyLLink}",
    "text_variant_appearance_body_m_text_font-size": "{bodyM}",
    "text_variant_appearance_body_m_text_font-family": "{bodyM}",
    "text_variant_appearance_body_m_text_line-height": "{bodyM}",
    "text_variant_appearance_body_m_text_letter-spacing": "{bodyM}",
    "text_variant_appearance_body_m_text_font-weight": "{bodyM}",
    "text_variant_appearance_body_m_bold_text_font-size": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-family": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_line-height": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_letter-spacing": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-weight": "{bodyMBold}",
    "text_variant_appearance_body_m_link_text_font-size": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-family": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_line-height": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_letter-spacing": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-weight": "{bodyMLink}",
    "text_variant_appearance_body_s_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_text_font-family": "{bodyS}",
    "text_variant_appearance_body_s_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_bold_text_font-size": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-family": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_line-height": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_letter-spacing": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-weight": "{bodySBold}",
    "text_variant_appearance_body_s_link_text_font-size": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-family": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_line-height": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_letter-spacing": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-weight": "{bodySLink}",
    "text_variant_appearance_body_xs_text_font-size": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xs_bold_text_font-size": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-family": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_line-height": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_letter-spacing": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-weight": "{bodyXsBold}",
    "text_variant_appearance_body_xs_link_text_font-size": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-family": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_line-height": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_letter-spacing": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-weight": "{bodyXsLink}",
    "text_variant_appearance_body_xs_caps_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_text-transform": "{bodyS}",
    "text_variant_appearance_body_xs_caps_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xxs_text_font-size": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-family": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_line-height": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_letter-spacing": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-weight": "{bodyXxs}",
    "text_variant_appearance_body_xxs_bold_text_font-size": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-family": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_line-height": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_letter-spacing": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-weight": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_link_text_font-size": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-family": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_line-height": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_letter-spacing": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-weight": "{bodyXxsLink}",
    "text_variant_appearance_body_3xs_text_font-size": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-family": "{body3xs}",
    "text_variant_appearance_body_3xs_text_line-height": "{body3xs}",
    "text_variant_appearance_body_3xs_text_letter-spacing": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-weight": "{body3xs}",
    "text_variant_appearance_body_3xs_bold_text_font-size": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-family": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_line-height": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_letter-spacing": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-weight": "{body3xsBold}",
    "text_variant_appearance_body_3xs_link_text_font-size": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-family": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_line-height": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_letter-spacing": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-weight": "{body3xsLink}",
    "text_variant_appearance_list_title_text_font-size": "{listTitle}",
    "text_variant_appearance_list_title_text_font-family": "{listTitle}",
    "text_variant_appearance_list_title_text_line-height": "{listTitle}",
    "text_variant_appearance_list_title_text_letter-spacing": "{listTitle}",
    "text_variant_appearance_list_title_text_font-weight": "{listTitle}",
    "text_variant_appearance_button_text_font-size": "{button}",
    "text_variant_appearance_button_text_font-family": "{button}",
    "text_variant_appearance_button_text_line-height": "{button}",
    "text_variant_appearance_button_text_letter-spacing": "{button}",
    "text_variant_appearance_button_text_font-weight": "{button}",
    "text_variant_appearance_code_text_font-size": "{code}",
    "text_variant_appearance_code_text_font-family": "{code}",
    "text_variant_appearance_code_text_line-height": "{code}",
    "text_variant_appearance_code_text_letter-spacing": "{code}",
    "text_variant_appearance_code_text_font-weight": "{code}",
    "text_variant_appearance_body_s_regular_para_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-family": "{bodyS}"
};
const $f551aa6589c293c2$var$RatingBarTokens = {
    "ratingbar_base_vertical-container_flex-direction": "{flexDirection.column}",
    "ratingbar_base_vertical-container_align-items": "{alignItems.start}",
    "ratingbar_base_vertical-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_vertical-container_gap": "{xxs}",
    "ratingbar_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "align-items": "{alignItems.center}",
    "ratingbar_base_horizontal-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_horizontal-container_gap": "{xs}",
    "ratingbar_base_rating-bar-container_flex-direction": "{flexDirection.row}",
    "ratingbar_variant_size_small_vertical-container_gap": "{xxs}",
    "ratingbar_variant_size_small_horizontal-container_gap": "{xs}",
    "ratingbar_variant_labelPosition_bottom_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_labelPosition_top_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "ratingbar_combination_read_only_expanded_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_horizontal-container_gap": "{xs}",
    "ratingbar_base_horizontal-container_align-items": "{alignItems.center}"
};
const $f551aa6589c293c2$var$ratingBarItem_variant_size_small_start_icon_size = "{m}";
const $f551aa6589c293c2$var$ratingBarItem_variant_size_small_end_icon_size = "{m}";
const $f551aa6589c293c2$var$ratingBarItem_variant_size_large_start_icon_size = "{xl}";
const $f551aa6589c293c2$var$ratingBarItem_variant_size_large_end_icon_size = "{xl}";
const $f551aa6589c293c2$var$ratingBarItem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color = "{primary50}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color = "{primary50}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color = "{primary60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color = "{primary60}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color = "{primary50}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color = "{primary50}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color = "{primary70}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color = "{primaryGrey80}";
const $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color = "{primaryGrey60}";
const $f551aa6589c293c2$var$RatingBarItemTokens = {
    "ratingBarItem_base_container_flex-direction": "{flexDirection.stack}",
    "ratingBarItem_base_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_base_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_variant_size_small_start_icon_size: $f551aa6589c293c2$var$ratingBarItem_variant_size_small_start_icon_size,
    ratingBarItem_variant_size_small_end_icon_size: $f551aa6589c293c2$var$ratingBarItem_variant_size_small_end_icon_size,
    ratingBarItem_variant_size_large_start_icon_size: $f551aa6589c293c2$var$ratingBarItem_variant_size_large_start_icon_size,
    ratingBarItem_variant_size_large_end_icon_size: $f551aa6589c293c2$var$ratingBarItem_variant_size_large_end_icon_size,
    ratingBarItem_variant_disabled_true_container_opacity: $f551aa6589c293c2$var$ratingBarItem_variant_disabled_true_container_opacity,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-width": "{border_focus}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color: $f551aa6589c293c2$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color
};
const $f551aa6589c293c2$export$a744e0ee3d364193 = {
    JDSActionButton: $f551aa6589c293c2$var$ActionButtonTokens,
    JDSAvatar: $f551aa6589c293c2$var$AvatarTokens,
    JDSAvatarV2Default: $f551aa6589c293c2$var$AvatarV2DefaultTokens,
    JDSAccordionList: $f551aa6589c293c2$var$AccordionListTokens,
    JDSMobileBottomSheet: $f551aa6589c293c2$var$MobileBottomSheetTokens,
    JDSMobileBottomSheetInternal: $f551aa6589c293c2$var$MobileBottomSheetInternalTokens,
    JDSBadge: $f551aa6589c293c2$var$BadgeTokens,
    JDSBadgeV2Brand: $f551aa6589c293c2$var$BadgeV2BrandTokens,
    JDSBadgeV2Information: $f551aa6589c293c2$var$BadgeV2InformationTokens,
    JDSBadgeV2Notification: $f551aa6589c293c2$var$BadgeV2NotificationTokens,
    JDSBadgeV2Status: $f551aa6589c293c2$var$BadgeV2StatusTokens,
    JDSBaseIcon: $f551aa6589c293c2$var$BaseIconTokens,
    JDSDesktopBottomSheet: $f551aa6589c293c2$var$DesktopBottomSheetTokens,
    JDSDesktopBottomSheetInternal: $f551aa6589c293c2$var$DesktopBottomSheetInternalTokens,
    JDSBreadcrumbs: $f551aa6589c293c2$var$BreadcrumbsTokens,
    JDSCarousel: $f551aa6589c293c2$var$CarouselTokens,
    JDSCarouselPagination: $f551aa6589c293c2$var$CarouselPaginationTokens,
    JDSButton: $f551aa6589c293c2$var$ButtonTokens,
    JDSCarouselPaginationItem: $f551aa6589c293c2$var$CarouselPaginationItemTokens,
    JDSCarouselSlide: $f551aa6589c293c2$var$CarouselSlideTokens,
    JDSCheckbox: $f551aa6589c293c2$var$CheckboxTokens,
    JDSContentBlock: $f551aa6589c293c2$var$ContentBlockTokens,
    JDSDatepickerButton: $f551aa6589c293c2$var$DatepickerButtonTokens,
    JDSContentCard: $f551aa6589c293c2$var$ContentCardTokens,
    JDSDatepickerCalendarButton: $f551aa6589c293c2$var$DatepickerCalendarButtonTokens,
    JDSDatepickerCalendar: $f551aa6589c293c2$var$DatepickerCalendarTokens,
    JDSDatepickerCalendarRow: $f551aa6589c293c2$var$DatepickerCalendarRowTokens,
    JDSAccordion: $f551aa6589c293c2$var$AccordionTokens,
    JDSDatepickerCalendarHeader: $f551aa6589c293c2$var$DatepickerCalendarHeaderTokens,
    JDSDatepickerDesktop: $f551aa6589c293c2$var$DatepickerDesktopTokens,
    JDSDatepickerDesktopInternal: $f551aa6589c293c2$var$DatepickerDesktopTokens,
    JDSDatepickerHeader: $f551aa6589c293c2$var$DatepickerHeaderTokens,
    JDSDatepickerYearView: $f551aa6589c293c2$var$DatepickerYearViewTokens,
    JDSDatepickerMonthView: $f551aa6589c293c2$var$DatepickerMonthViewTokens,
    JDSDatepickerMobile: $f551aa6589c293c2$var$DatepickerMobileTokens,
    JDSDatepickerMobileInteral: $f551aa6589c293c2$var$DatepickerMobileTokens,
    JDSDivider: $f551aa6589c293c2$var$DividerTokens,
    JDSDatepickerViewButton: $f551aa6589c293c2$var$DatepickerViewButtonTokens,
    JDSFAB: $f551aa6589c293c2$var$FABTokens,
    JDSFABInternal: $f551aa6589c293c2$var$FABTokens,
    JDSDropdown: $f551aa6589c293c2$var$DropdownTokens,
    JDSDropdownMenu: $f551aa6589c293c2$var$DropdownMenuTokens,
    JDSDropdownMenuInternal: $f551aa6589c293c2$var$DropdownMenuTokens,
    JDSDropdownMenuItem: $f551aa6589c293c2$var$DropdownMenuItemTokens,
    JDSDropdownMenuItemMobile: $f551aa6589c293c2$var$DropdownMenuItemTokens,
    JDSDropdownMenuGroup: $f551aa6589c293c2$var$DropdownMenuGroupTokens,
    JDSDropdownMenuSubMenu: $f551aa6589c293c2$var$DropdownMenuSubMenuTokens,
    JDSFeedbackBlock: $f551aa6589c293c2$var$FeedbackBlockTokens,
    JDSBottomFooterLinkItem: $f551aa6589c293c2$var$BottomFooterLinkItemTokens,
    JDSFooterIconLinks: $f551aa6589c293c2$var$FooterIconLinksTokens,
    JDSFooter: $f551aa6589c293c2$var$FooterTokens,
    JDSBottomFooter: $f551aa6589c293c2$var$BottomFooterTokens,
    JDSFooterLinksGrid: $f551aa6589c293c2$var$FooterLinksGridTokens,
    JDSFooterLinks: $f551aa6589c293c2$var$FooterLinksTokens,
    JDSIcon: $f551aa6589c293c2$var$IconTokens,
    JDSFooterMarketLinks: $f551aa6589c293c2$var$FooterMarketLinksTokens,
    JDSImage: $f551aa6589c293c2$var$ImageTokens,
    JDSInput: $f551aa6589c293c2$var$InputTokens,
    JDSInputCodeItem: $f551aa6589c293c2$var$InputCodeItemTokens,
    JDSInputDate: $f551aa6589c293c2$var$InputDateTokens,
    JDSLink: $f551aa6589c293c2$var$LinkTokens,
    JDSFileUploader: $f551aa6589c293c2$var$FileUploaderTokens,
    JDSFileUploaderControl: $f551aa6589c293c2$var$FileUploaderControlTokens,
    JDSFileUploaderItem: $f551aa6589c293c2$var$FileUploaderItemTokens,
    JDSFileUploaderList: $f551aa6589c293c2$var$FileUploaderListTokens,
    JDSFileUploaderPanel: $f551aa6589c293c2$var$FileUploaderPanelTokens,
    JDSMenuBlock: $f551aa6589c293c2$var$MenuBlockTokens,
    JDSMenuBlockInternal: $f551aa6589c293c2$var$MenuBlockTokens,
    JDSListBlock: $f551aa6589c293c2$var$ListBlockTokens,
    JDSInputField: $f551aa6589c293c2$var$InputFieldTokens,
    JDSInputFieldV2: $f551aa6589c293c2$var$InputFieldV2Tokens,
    JDSModalDesktop: $f551aa6589c293c2$var$ModalDesktopTokens,
    JDSModalDesktopInternal: $f551aa6589c293c2$var$ModalDesktopInternalTokens,
    JDSMenuBlockItem: $f551aa6589c293c2$var$MenuBlockItemTokens,
    JDSModalMobile: $f551aa6589c293c2$var$ModalMobileTokens,
    JDSModalMobileInternal: $f551aa6589c293c2$var$ModalMobileInternalTokens,
    JDSHeaderDesktop: $f551aa6589c293c2$var$HeaderDesktopTokens,
    JDSBottomNavigation: $f551aa6589c293c2$var$BottomNavigationTokens,
    JDSBottomNavigationItem: $f551aa6589c293c2$var$BottomNavigationItemTokens,
    JDSMegaMenu: $f551aa6589c293c2$var$MegaMenuTokens,
    JDSMegaMenuInternal: $f551aa6589c293c2$var$MegaMenuTokens,
    JDSHeaderMobile: $f551aa6589c293c2$var$HeaderMobileTokens,
    JDSMegaMenuItem: $f551aa6589c293c2$var$MegaMenuItemTokens,
    JDSTextarea: $f551aa6589c293c2$var$TextareaTokens,
    JDSSidePanelItem: $f551aa6589c293c2$var$SidePanelItemTokens,
    JDSMegaMenuBlock: $f551aa6589c293c2$var$MegaMenuBlockTokens,
    JDSNotificationButton: $f551aa6589c293c2$var$NotificationButtonTokens,
    JDSNotificationBanner: $f551aa6589c293c2$var$NotificationBannerTokens,
    JDSNudgeContainer: $f551aa6589c293c2$var$NudgeContainerTokens,
    JDSToastContainer: $f551aa6589c293c2$var$ToastContainerTokens,
    JDSToast: $f551aa6589c293c2$var$ToastTokens,
    JDSNudge: $f551aa6589c293c2$var$NudgeTokens,
    JDSPagination: $f551aa6589c293c2$var$PaginationTokens,
    JDSPromoCard: $f551aa6589c293c2$var$PromoCardTokens,
    JDSSidePanel: $f551aa6589c293c2$var$SidePanelTokens,
    JDSSidePanelInternal: $f551aa6589c293c2$var$SidePanelTokens,
    JDSProgressBar: $f551aa6589c293c2$var$ProgressBarTokens,
    JDSSearchBox: $f551aa6589c293c2$var$SearchBoxTokens,
    JDSPaginationButton: $f551aa6589c293c2$var$PaginationButtonTokens,
    JDSSearchResultItem: $f551aa6589c293c2$var$SearchResultItemTokens,
    JDSSearchResultText: $f551aa6589c293c2$var$SearchResultTextTokens,
    JDSRadioButton: $f551aa6589c293c2$var$RadioButtonTokens,
    JDSSelector: $f551aa6589c293c2$var$SelectorTokens,
    JDSSelectorItem: $f551aa6589c293c2$var$SelectorItemTokens,
    JDSSearchResults: $f551aa6589c293c2$var$SearchResultsTokens,
    JDSSearchResultsInternal: $f551aa6589c293c2$var$SearchResultsTokens,
    JDSSkeleton: $f551aa6589c293c2$var$SkeletonTokens,
    JDSServiceCard: $f551aa6589c293c2$var$ServiceCardTokens,
    JDSNotificationIconButton: $f551aa6589c293c2$var$NotificationIconButtonTokens,
    JDSSpinner: $f551aa6589c293c2$var$SpinnerTokens,
    JDSSelectorButton: $f551aa6589c293c2$var$SelectorButtonTokens,
    JDSSlider: $f551aa6589c293c2$var$SliderTokens,
    JDSStepperDot: $f551aa6589c293c2$var$StepperDotTokens,
    JDSHorizontalStepItem: $f551aa6589c293c2$var$HorizontalStepItemTokens,
    JDSVerticalStepItem: $f551aa6589c293c2$var$VerticalStepItemTokens,
    JDSTableCell: $f551aa6589c293c2$var$TableCellTokens,
    JDSTableBody: $f551aa6589c293c2$var$TableBodyTokens,
    JDSTableRow: $f551aa6589c293c2$var$TableRowTokens,
    JDSTabBar: $f551aa6589c293c2$var$TabBarTokens,
    JDSVerticalStepper: $f551aa6589c293c2$var$VerticalStepperTokens,
    JDSTabItem: $f551aa6589c293c2$var$TabItemTokens,
    JDSTabsDesktop: $f551aa6589c293c2$var$TabsDesktopTokens,
    JDSTag: $f551aa6589c293c2$var$TagTokens,
    JDSHorizontalStepper: $f551aa6589c293c2$var$HorizontalStepperTokens,
    JDSTable: $f551aa6589c293c2$var$TableTokens,
    JDSToggle: $f551aa6589c293c2$var$ToggleTokens,
    JDSText: $f551aa6589c293c2$var$TextTokens,
    JDSTooltip: $f551aa6589c293c2$var$TooltipTokens,
    JDSTooltipInternal: $f551aa6589c293c2$var$TooltipTokens,
    JDSInputCode: $f551aa6589c293c2$var$InputCodeTokens,
    JDSRatingBar: $f551aa6589c293c2$var$RatingBarTokens,
    JDSRatingBarItem: $f551aa6589c293c2$var$RatingBarItemTokens
};
const $f551aa6589c293c2$export$616d0e83e98f2255 = [
    {
        name: "JioMeet",
        primaryColor: "orange",
        secondaryColor: "purple",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Express",
        primaryColor: "navi_midnight",
        secondaryColor: "red",
        sparkleColor: "pink"
    },
    {
        name: "JioSnap",
        primaryColor: "violet",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioMart Digital Partner",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioTrue5G",
        primaryColor: "navi_midnight",
        secondaryColor: "orange",
        sparkleColor: "reliance"
    },
    {
        name: "JioNetVelocity",
        primaryColor: "reliance",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioSociety",
        primaryColor: "violet_midnight",
        secondaryColor: "mint",
        sparkleColor: "orange"
    },
    {
        name: "JioVideoCall",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioSwitch",
        primaryColor: "reliance_midnight",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "DSP",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioPhotos",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioPay",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioTranslate",
        primaryColor: "pink_midnight",
        secondaryColor: "marigold",
        sparkleColor: "purple"
    },
    {
        name: "JioTV",
        primaryColor: "crimson",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioGames",
        primaryColor: "green",
        secondaryColor: "mint_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JustDial",
        primaryColor: "sky",
        secondaryColor: "orange",
        sparkleColor: "mint"
    },
    {
        name: "JioTVplus",
        primaryColor: "crimson",
        secondaryColor: "marigold",
        sparkleColor: "red"
    },
    {
        name: "JioHealthHub",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "red"
    },
    {
        name: "JioGlobal",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioSaavn",
        primaryColor: "mint",
        secondaryColor: "sky",
        sparkleColor: "navi"
    },
    {
        name: "JioEvents",
        primaryColor: "mint",
        secondaryColor: "purple",
        sparkleColor: "pink"
    },
    {
        name: "JioFit",
        primaryColor: "Orange",
        secondaryColor: "Purple",
        sparkleColor: "Mint"
    },
    {
        name: "JioMarket",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "orange"
    },
    {
        name: "JioAssist",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "mint"
    },
    {
        name: "JioChannels",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioBase",
        primaryColor: "navi",
        secondaryColor: "marigold",
        sparkleColor: "mint"
    },
    {
        name: "JioCloud",
        primaryColor: "sky",
        secondaryColor: "mint",
        sparkleColor: "marigold"
    },
    {
        name: "JioAds",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioKrishi",
        primaryColor: "green_midnight",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioCinema",
        primaryColor: "pink",
        secondaryColor: "violet_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioMart Digital Business",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "MyJio",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioGlass",
        primaryColor: "crimson",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioDive",
        primaryColor: "purple",
        secondaryColor: "mint",
        sparkleColor: "sky"
    },
    {
        name: "JioCall",
        primaryColor: "green",
        secondaryColor: "violet",
        sparkleColor: "navi"
    },
    {
        name: "JioEngage",
        primaryColor: "violet_midnight",
        secondaryColor: "red",
        sparkleColor: "marigold"
    },
    {
        name: "JioCX",
        primaryColor: "purple",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioFinance",
        primaryColor: "gold",
        secondaryColor: "orange_midnight",
        sparkleColor: "sky_midnight"
    },
    {
        name: "JioFinance_new",
        primaryColor: "new_gold",
        secondaryColor: "new_purple",
        sparkleColor: "new_sky"
    },
    {
        name: "JioPos",
        primaryColor: "mint",
        secondaryColor: "red_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioNews",
        primaryColor: "crimson",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Digital",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioID",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "green"
    },
    {
        name: "JioHome",
        primaryColor: "sky",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioMart",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioMart Partner",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioGauSamridhhi",
        primaryColor: "orange",
        secondaryColor: "green_midnight",
        sparkleColor: "pink_midnight"
    },
    {
        name: "JioWallet",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioJoin",
        primaryColor: "green",
        secondaryColor: "purple",
        sparkleColor: "marigold"
    },
    {
        name: "JioSecure",
        primaryColor: "mint",
        secondaryColor: "reliance_midnight",
        sparkleColor: "sky_light"
    },
    {
        name: "JioCare",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "pink"
    },
    {
        name: "JioSphere",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioChat",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioCloud PC",
        primaryColor: "sky",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "jio com",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioWave",
        primaryColor: "purple",
        secondaryColor: "sky",
        sparkleColor: "mint"
    },
    {
        name: "JioWorkspace",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "reliance"
    },
    {
        name: "JioFacility",
        primaryColor: "indigo",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "MyJio1",
        primaryColor: "indigo",
        secondaryColor: "saffron",
        sparkleColor: "green"
    },
    {
        name: "JioBusiness",
        primaryColor: "purple",
        secondaryColor: "reliance",
        sparkleColor: "mint"
    }
];
const $f551aa6589c293c2$var$camelCase = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $f551aa6589c293c2$var$clearModeFromColor = (color)=>{
    return color.replace(/_(light|dark|dim)+/i, "");
};
const $f551aa6589c293c2$var$transformThemeName = (name)=>{
    if (name.includes("_")) return name;
    else return name.split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
};
const $f551aa6589c293c2$var$normalizedThemeData = $f551aa6589c293c2$export$616d0e83e98f2255.map((data)=>({
        ...data,
        name: $f551aa6589c293c2$var$transformThemeName(data.name)
    }));
const $f551aa6589c293c2$export$e330aa996edc4437 = (theme)=>{
    const normalizedTheme = $f551aa6589c293c2$var$transformThemeName(theme);
    const currentTheme = $f551aa6589c293c2$var$normalizedThemeData.find((data)=>$f551aa6589c293c2$var$camelCase(normalizedTheme) === $f551aa6589c293c2$var$camelCase(data.name));
    let colors = {
        primary: $f551aa6589c293c2$export$616d0e83e98f2255[0].primaryColor,
        secondary: $f551aa6589c293c2$export$616d0e83e98f2255[0].secondaryColor,
        sparkle: $f551aa6589c293c2$export$616d0e83e98f2255[0].sparkleColor,
        neutral: "neutral"
    };
    if (currentTheme) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor, sparkleColor: sparkleColor } = currentTheme;
        colors = {
            primary: primaryColor?.toLowerCase(),
            secondary: secondaryColor?.toLowerCase(),
            sparkle: sparkleColor?.toLowerCase(),
            neutral: "neutral"
        };
    }
    colors.primary = $f551aa6589c293c2$var$clearModeFromColor(colors.primary);
    colors.secondary = $f551aa6589c293c2$var$clearModeFromColor(colors.secondary);
    colors.sparkle = $f551aa6589c293c2$var$clearModeFromColor(colors.sparkle);
    return colors;
};




var $acw62 = parcelRequire("acw62");


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $5c2cbe2b2431bcd1$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $5c2cbe2b2431bcd1$var$index = '';
const $5c2cbe2b2431bcd1$export$1ec1d45228a8d241 = [
    "primary",
    "secondary",
    "sparkle",
    "theme",
    "mode",
    "surface",
    "scale",
    "emphasis",
    "appearance",
    "strokeSurface",
    "accent"
];
let $5c2cbe2b2431bcd1$var$defaultTokenValues = {
    theme: "MyJio",
    mode: "light",
    scale: 25,
    density: "default",
    lang: "en",
    platform: "mobile",
    appearance: "neutral",
    surface: "default"
};
function $5c2cbe2b2431bcd1$export$d239735146a56826(value) {
    $5c2cbe2b2431bcd1$var$defaultTokenValues = {
        ...$5c2cbe2b2431bcd1$var$defaultTokenValues,
        ...value,
        ...(0, $f551aa6589c293c2$export$e330aa996edc4437)(value.theme || $5c2cbe2b2431bcd1$var$defaultTokenValues.theme)
    };
}
function $5c2cbe2b2431bcd1$export$dfce236e857ed8b0() {
    return {
        ...$5c2cbe2b2431bcd1$var$defaultTokenValues,
        ...(0, $f551aa6589c293c2$export$e330aa996edc4437)($5c2cbe2b2431bcd1$var$defaultTokenValues.theme)
    };
}
const $5c2cbe2b2431bcd1$var$EVENTS_MAP = {
    onClick: "onClick",
    onFocus: "onFocus",
    onBlur: "onBlur",
    onHover: "onMouseEnter",
    onChange: "onChange",
    onHoverEnd: "onMouseLeave",
    onKeydown: "onKeyDown",
    onKeyup: "onKeyUp",
    onInvalid: "onInvalid",
    onLoad: "onLoad",
    onError: "onError",
    onPaste: "onPaste",
    onScroll: "onScroll",
    onSwipeLeft: [
        "onPointerDown",
        "onPointerMove",
        "onPointerUp",
        "onPointerOut",
        "onDragStart",
        "onDragEnd"
    ]
};
const $5c2cbe2b2431bcd1$var$filterInvalidValue = (v)=>{
    if (typeof v === "undefined") return false;
    if (v === "") return false;
    if (v === null) return false;
    return true;
};
function $5c2cbe2b2431bcd1$var$getEventName(key) {
    const match = Object.keys($5c2cbe2b2431bcd1$var$EVENTS_MAP).find((evt)=>key === evt);
    const matchedEvent = $5c2cbe2b2431bcd1$var$EVENTS_MAP[match];
    return matchedEvent;
}
const $5c2cbe2b2431bcd1$var$internalLayerPrefixes = [
    "jds",
    "tooltip"
];
const $5c2cbe2b2431bcd1$var$processConfigAPI = (config, values, layerProps)=>{
    if (!values) return {};
    const finalData = {};
    Object.entries(config || {}).forEach(([name, item])=>{
        const resolvedConfigValues = item.values || [];
        if (!layerProps?.[name]) {
            if (!resolvedConfigValues.includes(values[name])) {
                if ($5c2cbe2b2431bcd1$var$filterInvalidValue(resolvedConfigValues[0])) finalData[name] = resolvedConfigValues[0];
            } else if ($5c2cbe2b2431bcd1$var$filterInvalidValue(values[name])) finalData[name] = values[name];
        }
    });
    return finalData;
};
const $5c2cbe2b2431bcd1$var$acceptedInternalProps = [
    "internalIndex",
    "layerRefs",
    "className",
    "internalClasses",
    "tabIndex",
    "slideIndex"
];
const $5c2cbe2b2431bcd1$var$processDataAPI = (api, currentLayer, values)=>{
    if (!currentLayer) return {};
    const processData = {};
    const processChildren = {};
    const processedEvents = {};
    let processedA11y = {};
    const { data: data = {}, events: events, children: children = {} } = api;
    if (children[currentLayer]) processChildren[currentLayer] = values[children[currentLayer].name];
    const currentDataItem = data[currentLayer];
    Object.entries(currentDataItem || {}).forEach(([name, { name: propName = "" }])=>{
        const currentName = propName.slice(propName.lastIndexOf(".") + 1, propName.length);
        const value = (0, $bff35c0dd9851fab$export$3988ae62b71be9a3)(values, propName, void 0) || (0, $bff35c0dd9851fab$export$3988ae62b71be9a3)(values, currentName, void 0);
        if (typeof value !== "undefined") processData[name] = value;
    });
    if (events) {
        const currentEventItem = events[currentLayer];
        if (currentEventItem) Object.entries(currentEventItem).forEach(([internalName, valueName])=>{
            const eventMapItem = $5c2cbe2b2431bcd1$var$getEventName(internalName);
            const resolvedName = typeof valueName === "string" ? valueName : valueName.name;
            if (!Array.isArray(eventMapItem)) {
                const baseLayer = $5c2cbe2b2431bcd1$var$getBaseLayerName(currentLayer);
                const key = baseLayer.startsWith("jds_") ? internalName : eventMapItem;
                if (!key) return;
                processedEvents[key] = values[resolvedName] || values[eventMapItem];
            } else {
                eventMapItem.forEach((item)=>{
                    if (item) processedEvents[item] = values[item];
                });
                if (internalName) processedEvents[internalName] = values[resolvedName];
            }
        });
    }
    if (api.a11y) processedA11y = $5c2cbe2b2431bcd1$var$processA11yData(api.a11y, currentLayer, values);
    $5c2cbe2b2431bcd1$var$acceptedInternalProps.map((item)=>{
        if (item in values) processData[item] = values[item];
    });
    return {
        processData: processData,
        processedEvents: processedEvents,
        processedA11y: processedA11y,
        processedChildren: processChildren
    };
};
const $5c2cbe2b2431bcd1$var$processA11yData = (data, layer, api)=>{
    if (!data[layer]) return {};
    const { properties: properties } = data[layer];
    if (!properties) return {};
    const processed = {};
    Object.entries(properties).forEach(([internalProperty, property])=>{
        if (typeof property === "string") {
            const normalisedProperty = property.slice(property.lastIndexOf(".") + 1, property.length);
            processed[internalProperty] = api[normalisedProperty];
        } else {
            const { name: name, value: value, prop: prop } = property;
            const normalisedName = name?.slice(name.lastIndexOf(".") + 1, name.length);
            const defaultValue = api[prop || ""] || value;
            processed[internalProperty] = api[normalisedName] || defaultValue;
        }
    });
    return processed;
};
const $5c2cbe2b2431bcd1$var$validateProp = (prop)=>{
    if (typeof prop === "undefined") return false;
    if (prop === null) return false;
    if (prop === "") return false;
    return true;
};
const $5c2cbe2b2431bcd1$var$mergeStyleProperties = (props, uiTokens, data, layerProps)=>{
    const modifiedStyles = (0, $bff35c0dd9851fab$export$629a2bd3f5a49ecc)(uiTokens);
    Object.entries(data || {}).forEach(([layer, properties])=>{
        Object.entries(properties).forEach(([internalName, { name: name }])=>{
            modifiedStyles[layer] = modifiedStyles[layer] || {};
            if ($5c2cbe2b2431bcd1$var$validateProp(props[name])) {
                if (name in (0, $6eea7234d56610fe$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(name in layerProps[layer]) || $5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(name)) modifiedStyles[layer][name] = props[name];
                    else delete modifiedStyles[layer][name];
                } else delete modifiedStyles[layer][name];
                if (internalName in (0, $6eea7234d56610fe$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(internalName in layerProps[layer])) modifiedStyles[layer][internalName] = props[name];
                    else delete modifiedStyles[layer][internalName];
                } else delete modifiedStyles[layer][internalName];
            }
        });
    });
    return modifiedStyles;
};
const $5c2cbe2b2431bcd1$var$allowedLayerProps = [
    "disabled",
    "transition"
];
const $5c2cbe2b2431bcd1$var$seperateComponentLayerProps = (styles = {}, props)=>{
    const layerProps = {};
    Object.entries(styles).forEach(([currentlayer, currentStyles])=>{
        const layerElements = currentlayer.split("-");
        const layerName = layerElements[layerElements.length - 1];
        if (!layerProps[currentlayer]) layerProps[currentlayer] = {};
        const isInternalLayer = $5c2cbe2b2431bcd1$var$internalLayerPrefixes.find((i)=>layerName.startsWith(i));
        if (isInternalLayer) Object.entries(currentStyles || {}).forEach(([property, value])=>{
            layerProps[currentlayer][property] = value;
        });
        if (styles.value) layerProps[currentlayer].value = currentStyles.value;
        Object.entries(currentStyles).forEach(([property, value])=>{
            if (!(property in (0, $6eea7234d56610fe$export$95994f4e1548c018))) {
                if (!(currentlayer in layerProps)) layerProps[currentlayer] = {};
                layerProps[currentlayer][property] = value;
            } else if ($5c2cbe2b2431bcd1$var$allowedLayerProps.includes(property)) layerProps[currentlayer][property] = value;
        });
    });
    return {
        layerProps: layerProps,
        styles: styles
    };
};
const $5c2cbe2b2431bcd1$var$BufferConverter = (value)=>{
    return $5c2cbe2b2431bcd1$require$Buffer.from(value, "base64").toString("utf-8");
};
const $5c2cbe2b2431bcd1$var$convertBase64ToObject = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $5c2cbe2b2431bcd1$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $5c2cbe2b2431bcd1$var$classNames = (...classes)=>classes.filter(Boolean).join(" ");
const $5c2cbe2b2431bcd1$export$d72eddc0980b68c9 = (custom)=>{
    const base64 = custom.includes("--") ? (custom?.split("--") || [])[1] : custom;
    const convertedCustom = $5c2cbe2b2431bcd1$var$convertBase64ToObject(base64);
    return convertedCustom;
};
const $5c2cbe2b2431bcd1$var$getBaseLayerName = (layer = "")=>{
    const parts = layer.split("-");
    return parts[parts.length - 1];
};
const $5c2cbe2b2431bcd1$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
const $5c2cbe2b2431bcd1$export$9382739d0e79620f = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: props.style,
        className: $5c2cbe2b2431bcd1$var$classNames(props.className, "progress-animateContainer")
    });
};
function $5c2cbe2b2431bcd1$var$polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
function $5c2cbe2b2431bcd1$var$describeArc(x, y, radius, startAngle, endAngle) {
    const start = $5c2cbe2b2431bcd1$var$polarToCartesian(x, y, radius, endAngle);
    const end = $5c2cbe2b2431bcd1$var$polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    const d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
function $5c2cbe2b2431bcd1$var$getColorVariable(val, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) {
            if (val.includes("&")) tokens = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens({
                ...tokens,
                surface: val.split("_")[2].replace("}", "")
            });
            return (0, $6eea7234d56610fe$export$6a176e754d54672)("color", val, tokens);
        }
    }
    return val.toString();
}
function $5c2cbe2b2431bcd1$var$getValue(val, rule, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) return (0, $6eea7234d56610fe$export$6a176e754d54672)(rule, val, tokens);
    }
    return (0, $6eea7234d56610fe$export$95c38a73fd251991)(rule, val);
}
const $5c2cbe2b2431bcd1$export$6ef80ffb606dd232 = ({ radius: radius = 0, start: start = 0, end: end = 0, fill: fill, className: className, arcWidth: arcWidth = 10, "animation-delay": animationDelay = "0ms", layer: layer, animate: animate, ...rest })=>{
    start = parseInt($5c2cbe2b2431bcd1$var$getValue(start, "rotate"), 10);
    end = parseInt($5c2cbe2b2431bcd1$var$getValue(end, "rotate"), 10);
    radius = parseInt($5c2cbe2b2431bcd1$var$getValue(radius, "width"), 10);
    arcWidth = parseInt($5c2cbe2b2431bcd1$var$getValue(arcWidth, "width"), 10);
    animationDelay = $5c2cbe2b2431bcd1$var$getValue(animationDelay, "transition-delay");
    animationDelay = animationDelay.includes("ms") ? animationDelay : animationDelay + "ms";
    const strokeWidth = end - start === 0 ? 0 : arcWidth / 2;
    const diameter = radius * 2;
    const halfRadius = radius / 2;
    const circumference = 2 * Math.PI * halfRadius;
    const percent = end / 360 * 100;
    const dash = percent * circumference / 100;
    const midRadius = radius + strokeWidth;
    const durationKey = Object.keys(rest.style || {}).find((key)=>key.endsWith("transition-duration"));
    const variables = {
        "--diameter": diameter,
        "--rotate": `-${end}deg`,
        "--fill-color": $5c2cbe2b2431bcd1$var$getColorVariable(fill || "currentcolor", $5c2cbe2b2431bcd1$export$f34d637a75323a1e()),
        "--animation-delay": animationDelay,
        "--animation-duration": rest.style?.[durationKey] || (rest["animation-duration"] || 2.5) + "s",
        "--offset": animate ? "100px" : `${dash}px ${circumference - dash}px`,
        "--end": end * Math.PI / 180,
        "--start": start * Math.PI / 180,
        "--start-anim-offset": `${circumference}px`,
        "--end-anim-offset": `-${circumference}px`
    };
    const animateClass = animate ? "jds-spinner-circle-animate" : "";
    const arc = (0, $acw62.useMemo)(()=>{
        return $5c2cbe2b2431bcd1$var$describeArc(midRadius / 2, midRadius / 2, radius / 2, start, end);
    }, [
        start,
        end,
        midRadius
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $5c2cbe2b2431bcd1$var$classNames(className, animateClass),
        style: {
            width: diameter,
            height: diameter,
            ...variables
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            className: $5c2cbe2b2431bcd1$var$classNames("jds-spinner-circle", `circle-${layer}`, animate ? "animate" : ""),
            viewBox: `0 0 ${radius + arcWidth / 2} ${radius + arcWidth / 2}`,
            children: Math.abs(end - start) === 360 || animate ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                stroke: variables["--fill-color"],
                r: halfRadius,
                cx: midRadius / 2,
                cy: midRadius / 2,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: arc,
                strokeLinecap: "round",
                className: $5c2cbe2b2431bcd1$var$classNames(animate ? "animated" : ""),
                strokeWidth: strokeWidth,
                stroke: variables["--fill-color"],
                fill: "none",
                "data-dimension": `${end}-${start}-${end - start}`
            })
        })
    });
};
const $5c2cbe2b2431bcd1$var$unsafeProps = [
    "height",
    "padding",
    "opacity",
    "translate-y",
    "translate-x",
    "max-height"
];
const $5c2cbe2b2431bcd1$export$31627395a3b18e54 = (props)=>{
    const [internalHidden, setInternalHidden] = (0, $acw62.useState)(!props.animatedProperties?.length);
    (0, $acw62.useEffect)(()=>{
        if (!props.hidden) setInternalHidden(false);
    }, [
        props.hidden
    ]);
    const hasProperties = $5c2cbe2b2431bcd1$var$unsafeProps.some((property)=>props.animatedProperties?.includes(property));
    if (props.hidden) {
        if (!props.animatedProperties?.length) return null;
        if (!internalHidden) {
            if (!hasProperties) return null;
            return props.children || null;
        }
        if (hasProperties) return props.children;
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}), {
        onTransitionEnd: (ev)=>{
            if (props.hidden) setInternalHidden(true);
        }
    });
};
const $5c2cbe2b2431bcd1$var$registeredIcons = {
    ...$7484f88fafffadc1$exports
};
const $5c2cbe2b2431bcd1$export$99b432e1290ef823 = (icons)=>{
    Object.assign($5c2cbe2b2431bcd1$var$registeredIcons, icons);
};
const $5c2cbe2b2431bcd1$export$d824b604106683ab = (icons)=>Object.keys(icons).filter((icon)=>typeof icons[icon] === "function");
const $5c2cbe2b2431bcd1$export$75b0b37acc90e887 = (ic)=>{
    if (typeof ic === "string") {
        const NewIcon = $5c2cbe2b2431bcd1$var$registeredIcons[ic];
        if (!NewIcon) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(NewIcon, {});
    }
    return ic;
};
const $5c2cbe2b2431bcd1$export$f04a61298a47a40f = ({ value: value, events: events, style: style, layer: layer, className: className, role: role, _isLottieVisible: _isLottieVisible, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, ...rest })=>{
    const stringIcon = typeof value === "string";
    const camelCaseIcon = !stringIcon ? value : (0, $bff35c0dd9851fab$export$26c6f48841fe1a8a)(value || "", "_");
    const icon = $5c2cbe2b2431bcd1$export$75b0b37acc90e887(camelCaseIcon);
    if (!value) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(icon) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
            "data-testid": rest?.["data-testid"] || "icon-root",
            className: $5c2cbe2b2431bcd1$var$classNames("icon-atom", className),
            ...events,
            style: style,
            "data-iconname": stringIcon ? value?.toLowerCase() : void 0,
            "data-hidden": rest.hidden,
            "data-transition": Boolean(rest.transition),
            role: role,
            "aria-label": ariaLabel,
            "aria-describedby": ariaDescribedby
        })
    });
};
const $5c2cbe2b2431bcd1$export$f5b8910cec6cf069 = (props)=>{
    const { disabled: disabled, className: className, children: children, type: type = "text", internalIndex: internalIndex, root: root, rootRef: rootRef, textAlign: textAlign, events: events = {}, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-invalid": ariaInvalid, "aria-required": _ariaRequired, "aria-placeholder": _ariaPlaceholder, _childrenProps: _childrenProps, processedA11y: processedA11y, textSize: textSize, layerRefs: layerRefs, isContainerFocusable: isContainerFocusable, componentTag: componentTag, ...rest } = props;
    const combinedStyles = {
        ...rest?.style,
        textAlign: textAlign
    };
    const commonProps = {
        ...events,
        ...rest,
        style: combinedStyles,
        disabled: disabled,
        maxLength: rest["max-length"],
        value: rest.value
    };
    switch(type.toLowerCase()){
        case "textarea":
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-area-wrapper",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                    ref: layerRefs?.[rest.layer],
                    ...commonProps,
                    className: $5c2cbe2b2431bcd1$var$classNames("jds-input-atom", className, "jds-textarea-atom"),
                    "aria-label": ariaLabel,
                    "aria-describedby": ariaDescribedby,
                    "aria-invalid": ariaInvalid,
                    "aria-required": _ariaRequired,
                    "aria-placeholder": _ariaPlaceholder
                })
            });
        case "phone":
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                ref: layerRefs?.[rest.layer],
                type: "tel",
                className: $5c2cbe2b2431bcd1$var$classNames("jds-input-atom", className)
            });
        default:
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                type: type,
                ref: layerRefs?.[rest.layer],
                className: $5c2cbe2b2431bcd1$var$classNames("jds-input-atom", className),
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedby,
                "aria-invalid": ariaInvalid,
                "aria-required": _ariaRequired,
                "aria-placeholder": _ariaPlaceholder
            });
    }
};
const $5c2cbe2b2431bcd1$export$3b0d6d7590275603 = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "loader-root",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$var$Spinner, {})
    });
};
const $5c2cbe2b2431bcd1$var$Spinner = ()=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "j-spinner",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "circle circle-0",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "circle circle-1",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            })
        ]
    });
};
const $5c2cbe2b2431bcd1$var$WINDOW = typeof window === "object" && window || void 0;
const $5c2cbe2b2431bcd1$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $5c2cbe2b2431bcd1$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $5c2cbe2b2431bcd1$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$5c2cbe2b2431bcd1$var$WINDOW?.matchMedia && $5c2cbe2b2431bcd1$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $acw62.useState)(getValue);
        (0, $acw62.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$5c2cbe2b2431bcd1$var$Devices.breakpoints = $5c2cbe2b2431bcd1$var$defaultBreakpoints;
const $5c2cbe2b2431bcd1$var$layersWithStyleAttr = [
    "button",
    "div"
];
const $5c2cbe2b2431bcd1$var$filterUniqueTokens = (newTokens, existingTokens)=>{
    if (newTokens._source === "popup") return newTokens;
    return (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newTokens, (value, key)=>!(key in existingTokens) || existingTokens[key] !== value);
};
const $5c2cbe2b2431bcd1$var$resolvePlatform = (exisintPlatform)=>{
    const platform = $5c2cbe2b2431bcd1$var$Devices.useMedia();
    if (platform.desktop || platform.widescreen || platform.hd) return "desktop";
    if (platform.tablet) return "tablet";
    return "mobile";
};
const $5c2cbe2b2431bcd1$export$3e90a26ba68b9c65 = (0, $acw62.createContext)({});
const $5c2cbe2b2431bcd1$var$registerBrandAndFetchTokenVars = (value, existingTokens, brandTokens)=>{
    const defaultTokenValues = $5c2cbe2b2431bcd1$export$dfce236e857ed8b0();
    const mode = value.mode || existingTokens.mode || defaultTokenValues.mode;
    let tokens$1 = {
        scale: existingTokens.scale || (mode === "dark" ? 2 : 25),
        ...defaultTokenValues,
        ...existingTokens,
        parentAppearance: existingTokens.appearance,
        currentAppearance: value.appearance || "auto",
        surface: value.surface || "ghost",
        ...(0, $f551aa6589c293c2$export$e330aa996edc4437)(value.theme || existingTokens.theme || defaultTokenValues.theme),
        ...Object.fromEntries(Object.entries(value).filter(([_, v])=>v !== "auto"))
    };
    if (!tokens$1._registered || brandTokens) {
        (0, $6eea7234d56610fe$export$859883d4ec9c7db4).registerBrand(brandTokens || (0, $f551aa6589c293c2$export$6ad93df59e712c43));
        tokens$1._registered = true;
    }
    if ((0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens) {
        tokens$1 = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens(tokens$1);
        tokens$1.parentScale = existingTokens.scale;
    }
    const equalThemeTokens = $5c2cbe2b2431bcd1$export$1ec1d45228a8d241.every((key)=>existingTokens[key] === value[key]);
    const entries = [];
    if (!(equalThemeTokens && !(value._source === "popup"))) {
        const mergedTokens = {
            ...defaultTokenValues,
            ...(0, $f551aa6589c293c2$export$e330aa996edc4437)(existingTokens.theme || defaultTokenValues.theme),
            ...existingTokens
        };
        const uniqueTokens = $5c2cbe2b2431bcd1$var$filterUniqueTokens(tokens$1, mergedTokens);
        if ((0, $6eea7234d56610fe$export$859883d4ec9c7db4).brandResolverFn) {
            if ([
                "density"
            ].some((item)=>uniqueTokens[item])) {
                const densityMap = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getDensityMap?.(tokens$1.density ?? "default") ?? {};
                entries.push(...Object.entries(densityMap));
            }
            if ([
                "theme"
            ].some((item)=>uniqueTokens[item])) {
                const colorMap = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getColorsMap({
                    primary: tokens$1.primary,
                    secondary: tokens$1.secondary,
                    sparkle: tokens$1.sparkle
                });
                entries.push(...Object.entries(colorMap));
            }
        } else {
            const applicableTokens = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getApplicableTokens(uniqueTokens);
            Object.entries(applicableTokens).forEach(([folderKey, folder])=>Object.entries(folder).forEach(([key, value2])=>{
                    entries.push([
                        (0, $6eea7234d56610fe$export$585f0f7ef40c9f0)(`${folderKey}-${key}`),
                        (0, $6eea7234d56610fe$export$bdcbab1cb38db489)(value2) ? (0, $6eea7234d56610fe$export$c59eaf4f26921ab2)(folderKey, value2, tokens$1) : (0, $6eea7234d56610fe$export$95c38a73fd251991)(folderKey, value2)
                    ]);
                }));
        }
    }
    const styles = Object.fromEntries(entries);
    return {
        styles: styles,
        tokens: tokens$1
    };
};
const $5c2cbe2b2431bcd1$export$e5cf4eff53e7947d = ({ value: value, children: children, tokens: brandTokens })=>{
    const defaultTokenValues = $5c2cbe2b2431bcd1$export$dfce236e857ed8b0();
    const rootRef = (0, $acw62.useRef)();
    const timeoutRef = (0, $acw62.useRef)();
    value ??= defaultTokenValues;
    const existingTokens = (0, $acw62.useContext)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65);
    value.platform = $5c2cbe2b2431bcd1$var$resolvePlatform(value.platform || existingTokens.platform);
    const { styles: styles, tokens: tokens } = (0, $acw62.useMemo)(()=>$5c2cbe2b2431bcd1$var$registerBrandAndFetchTokenVars(value, existingTokens, brandTokens), [
        value,
        brandTokens
    ]);
    const isRootProvider = !Object.keys(existingTokens).length;
    (0, $acw62.useEffect)(()=>{
        function listener() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                const root = rootRef.current;
                if (root) {
                    const { padding: padding } = getComputedStyle(root);
                    const base = parseFloat(padding);
                    root.style.setProperty("--base", base.toString());
                }
            }, 100);
        }
        if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") {
            window.addEventListener("resize", listener);
            listener();
        }
        return ()=>{
            if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") window.removeEventListener("resize", listener);
        };
    }, [
        tokens?.["brandVersion"],
        isRootProvider
    ]);
    if (!("brandVersion" in tokens) || tokens?.["brandVersion"] !== "jio-v2") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            ...styles,
            display: "contents"
        },
        className: "tokens",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    if (isRootProvider) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tokens-provider v3",
        style: {
            display: "contents",
            padding: "var(--pre-base)",
            ...tokens.maxWidth ? {
                "--viewport": tokens.maxWidth / 100 + "px"
            } : {},
            ...styles
        },
        ref: rootRef,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    const newChildren = !Object.keys(styles).length ? children : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
            if ($5c2cbe2b2431bcd1$var$layersWithStyleAttr.includes(typeof child.type === "string" ? child.type : child.type.name) && !isRootProvider) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                ...child.props,
                style: {
                    ...child.props.style,
                    ...styles
                }
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tokens-provider",
                style: {
                    ...styles,
                    display: "contents"
                },
                children: child
            });
        }
        return child;
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65.Provider, {
        value: {
            ...tokens
        },
        children: newChildren
    });
};
function $5c2cbe2b2431bcd1$export$f34d637a75323a1e() {
    const tokenValues = (0, $acw62.useContext)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65);
    if (tokenValues === void 0) throw new Error("useTokenValues must be used within a TokenProvider");
    return tokenValues;
}
const $5c2cbe2b2431bcd1$export$31dcd79391e423fe = (value, type)=>{
    const tokens = (0, $acw62.useContext)($5c2cbe2b2431bcd1$export$3e90a26ba68b9c65);
    if (tokens === void 0) throw new Error("Please wrap your app in a TokenProvider");
    return (0, $6eea7234d56610fe$export$6a176e754d54672)(type, value, tokens);
};
function $5c2cbe2b2431bcd1$var$CustomPortal({ children: children }) {
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    return mounted && typeof window !== "undefined" ? (0, $11492dca620dcaa5$exports.createPortal)(children, document.body) : null;
}
const $5c2cbe2b2431bcd1$export$129a32eedafa97c5 = ({ children: children, className: className, style: style, events: events, rootRef: rootRef, layer: layer, ...rest })=>{
    const { alignment: alignment = "top-start", priority: priority } = rest;
    const x = rest.offsetX;
    const y = rest.offsetY;
    const left = alignment.includes("start") && x ? `${x}px` : void 0;
    const right = alignment.includes("end") && x ? `${x}px` : void 0;
    const top = alignment.includes("top") && y ? `${y}px` : void 0;
    const bottom = alignment.includes("bottom") && y ? `${y}px` : void 0;
    const styles = {
        backgroundColor: rest["background-color"],
        pointerEvents: rest.passive ? "none" : "auto",
        "--popup-priority": priority,
        "--popup-left": left,
        "--popup-right": right,
        "--popup-top": top,
        "--popup-bottom": bottom
    };
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    if (tokens.fromPlugin) return children;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$var$CustomPortal, {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$e5cf4eff53e7947d, {
            value: {
                ...tokens,
                _source: "popup"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$31627395a3b18e54, {
                hidden: rest.hidden,
                animatedProperties: rest.transition?.property,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": rest?.["data-testid"],
                    ref: rootRef,
                    style: {
                        ...styles,
                        ...style,
                        pointerEvents: !rest.passive ? "auto" : "none",
                        touchAction: events?.onClick || !rest.passive ? "auto" : "none"
                    },
                    className: $5c2cbe2b2431bcd1$var$classNames("jds-popup-layer", className),
                    ...events,
                    onClick: (ev)=>{
                        if (events?.onClick) ev.stopPropagation();
                        events?.onClick?.(ev);
                    },
                    children: children
                })
            })
        })
    });
};
const $5c2cbe2b2431bcd1$export$d50980d2cec56085 = ({ layer: layer, style: style, className: className, ...rest })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $5c2cbe2b2431bcd1$var$classNames("skeleton-animate-loader-container", className),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": rest["data-testid"],
            style: style
        })
    });
};
const $5c2cbe2b2431bcd1$var$getTokenValue = (type, tokens, value)=>{
    if (!value) return "";
    return (0, $6eea7234d56610fe$export$6404fd1becf96b61)(type, value.toString() || "");
};
function $5c2cbe2b2431bcd1$export$1947d5eba3dbedea(value = 0, min = 0, max = 100) {
    const offset = value - min;
    const range = max - min;
    const ratio = offset / range;
    const percentage = (1 - ratio) * 100;
    return Math.round(percentage);
}
function $5c2cbe2b2431bcd1$export$762ec5ce8fb56ed0(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $5c2cbe2b2431bcd1$export$7d15b64cf5a3a4c4(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $5c2cbe2b2431bcd1$export$472062a354075cee = ({ min: min = 0, max: max = 100, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-valuenow": _ariaValuenow, "aria-valuemin": _ariaValuemin, "aria-valuemax": _ariaValuemax, ...props })=>{
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    const ballProperties = {
        "--ball-color": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props["ball-color"]),
        "--ball-color--active": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props?.behavior.active["ball-color-active"]),
        "--ball-color--hover": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props?.behavior.hover["ball-color-active"]),
        "--ball-size": $5c2cbe2b2431bcd1$var$getTokenValue("width", tokens, props["ball-size"]),
        "--ball-border-width": $5c2cbe2b2431bcd1$var$getTokenValue("width", tokens, props["ball-border-width"]),
        "--ball-border-color": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props["ball-border-color"]),
        "--active-color": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props["active-color"]),
        "--active-color--active": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props?.behavior.active["active-color-active"]),
        "--inactive-color": $5c2cbe2b2431bcd1$var$getTokenValue("color", tokens, props["inactive-color"])
    };
    const requiredValue = $5c2cbe2b2431bcd1$export$762ec5ce8fb56ed0(props.value, props.step, min, max) || 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: "range",
        step: props.step,
        value: requiredValue,
        min: min,
        max: max,
        size: 2,
        onChange: props.onChange,
        className: [
            props.className,
            "jds-slider-atom"
        ].join(" "),
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-valuenow": _ariaValuenow,
        "aria-valuemin": _ariaValuemin,
        "aria-valuemax": _ariaValuemax,
        style: {
            ...props.style,
            ...ballProperties,
            height: $5c2cbe2b2431bcd1$var$getTokenValue("height", tokens, props["track-height"]),
            "--progress": `${$5c2cbe2b2431bcd1$export$1947d5eba3dbedea(requiredValue, min, max)}%`
        }
    });
};
const $5c2cbe2b2431bcd1$var$alignClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
    justify: "text-justify"
};
const $5c2cbe2b2431bcd1$var$textAlignmentVariable = "--text-tx-al";
const $5c2cbe2b2431bcd1$export$5f1af8db9871e1d6 = ({ value: value, events: { onTextLayout: onTextLayout, ...restEvents } = {}, className: className, style: style, layer: layer, textType: textType = "div", role: role, "aria-describedby": ariaDescribedby, ...rest })=>{
    if (typeof value === "undefined" || value === "") return null;
    const currentStyle = typeof style === "object" ? {
        ...style
    } : {};
    const Type = textType?.trim() === "" ? "div" : textType;
    const maxLines = Number(rest["max-lines"]) || 0;
    const maxLineClass = maxLines > 0 && "multi-line";
    const align = currentStyle[$5c2cbe2b2431bcd1$var$textAlignmentVariable];
    const alignClass = align ? $5c2cbe2b2431bcd1$var$alignClasses[align] ?? "" : "";
    currentStyle["--max-lines"] = maxLines || void 0;
    if (alignClass) delete currentStyle[$5c2cbe2b2431bcd1$var$textAlignmentVariable];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$31627395a3b18e54, {
        hidden: [
            "true",
            true
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Type, {
            className: $5c2cbe2b2431bcd1$var$classNames("text-atom", className, maxLineClass, alignClass),
            style: currentStyle,
            ...restEvents,
            "data-testid": rest["data-testid"],
            "aria-describedby": ariaDescribedby,
            role: role,
            children: value
        })
    });
};
const $5c2cbe2b2431bcd1$export$379139ebc1c2b235 = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("textarea", {
        ...props,
        className: "jds-input-textarea-atom"
    });
};
const $5c2cbe2b2431bcd1$var$VerticalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.className,
        style: {
            boxSizing: "content-box",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "8",
            height: "24",
            viewBox: "0 0 8 24",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "Vector 5",
                d: "M6.87661 14.4244L2.7121 18.1471C0.97557 19.6994 -9.59586e-08 21.8047 0 24L-1.04907e-06 -2.38419e-07C-9.53115e-07 2.19528 0.975566 4.30064 2.71209 5.85293L6.87661 9.57563C8.37446 10.9146 8.37446 13.0854 6.87661 14.4244Z"
            })
        })
    });
};
const $5c2cbe2b2431bcd1$var$HorizontalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.className,
        style: {
            display: "flex",
            flexDirection: "column",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "24",
            height: "8",
            viewBox: "0 0 24 8",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "Vector 5",
                d: "M14.4244 1.12338L18.1471 5.2879C19.6994 7.02443 21.8047 8 24 8L-2.38419e-07 8C2.19528 8 4.30064 7.02443 5.85294 5.28791L9.57564 1.12339C10.9146 -0.374462 13.0854 -0.374465 14.4244 1.12338Z"
            })
        })
    });
};
const $5c2cbe2b2431bcd1$var$svgDirectionConfig = {
    vertical: $5c2cbe2b2431bcd1$var$VerticalTip,
    horizontal: $5c2cbe2b2431bcd1$var$HorizontalTip
};
const $5c2cbe2b2431bcd1$export$c92c6401b52a9298 = (props)=>{
    const { position: position = "right", className: className } = props;
    const positionPrefix = position.split("_")?.[0].toLowerCase();
    const tipClass = `j_tooltip-tip-${positionPrefix}`;
    const direction = [
        "top",
        "bottom"
    ].includes(positionPrefix) ? "horizontal" : "vertical";
    const Component = $5c2cbe2b2431bcd1$var$svgDirectionConfig[direction];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        className: className,
        svgClassName: tipClass
    });
};
const $5c2cbe2b2431bcd1$var$focusableSelectors = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
const $5c2cbe2b2431bcd1$var$isVisible = (element)=>{
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
};
const $5c2cbe2b2431bcd1$var$getFocusableChildren = (root)=>{
    if (!root) return null;
    const elements = [];
    root.querySelectorAll($5c2cbe2b2431bcd1$var$focusableSelectors.join(",")).forEach((ele)=>elements.push(ele));
    return elements.filter($5c2cbe2b2431bcd1$var$isVisible);
};
const $5c2cbe2b2431bcd1$export$31e8f018cc5f8f35 = (props)=>{
    const ref = (0, $acw62.useRef)(null);
    const { trap: trap, children: children, ...rest } = props;
    const [lastFocus, setLastFocus] = (0, $acw62.useState)(()=>trap ? document.activeElement : null);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            lastFocus && lastFocus.focus?.();
        };
    }, []);
    const trapTabKey = (element, event)=>{
        const focusableChildren = $5c2cbe2b2431bcd1$var$getFocusableChildren(element);
        if (!focusableChildren) return;
        const focusedItemIndex = document.activeElement ? focusableChildren.indexOf(document.activeElement) : -1;
        const lastIndex = focusableChildren.length - 1;
        const withShift = event.shiftKey;
        if (withShift && focusedItemIndex === 0) {
            focusableChildren?.[lastIndex]?.focus?.();
            event.preventDefault();
        } else if (!withShift && focusedItemIndex === lastIndex) {
            focusableChildren?.[0]?.focus?.();
            event.preventDefault();
        }
    };
    const moveFocusIn = ()=>{
        if (!$5c2cbe2b2431bcd1$var$getFocusableChildren(ref.current)?.includes(document?.activeElement)) {
            const target = ref?.current?.querySelector("[autofocus]") || $5c2cbe2b2431bcd1$var$getFocusableChildren(ref.current)?.[0];
            requestAnimationFrame(()=>{
                target && target?.focus?.();
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (trap) {
            setLastFocus(document.activeElement);
            moveFocusIn();
        } else lastFocus && lastFocus.focus?.();
    }, [
        trap
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (trap) {
                if (event.key === "Tab") trapTabKey(ref?.current, event);
            }
        };
        document.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        ref,
        lastFocus,
        trap
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: "contents"
        },
        ref: ref,
        ...rest,
        children: children
    });
};
$5c2cbe2b2431bcd1$export$31e8f018cc5f8f35.displayName = "TrapFocus";
$5c2cbe2b2431bcd1$export$31e8f018cc5f8f35.defaultProps = {
    trap: false
};
const $5c2cbe2b2431bcd1$var$filterInternalEvents = (events)=>{
    const internalEvents = [
        "onSwipeLeft",
        "onSwipeRight",
        "onSwipeUp",
        "onSwipeDown",
        "onPinch",
        "onRotate",
        "onLongPress",
        "onDoubleTap"
    ];
    const filteredEvents = {};
    Object.entries(events).forEach(([key, handler])=>{
        if (!internalEvents.includes(key)) filteredEvents[key] = handler;
    });
    return filteredEvents;
};
const $5c2cbe2b2431bcd1$var$resolveDisabled = (disabled)=>{
    if (typeof disabled === "object") return false;
    return disabled;
};
const $5c2cbe2b2431bcd1$var$disabledStyles = {
    cursor: "not-allowed",
    pointerEvents: "none",
    userSelect: "none"
};
const $5c2cbe2b2431bcd1$export$42a852a2b6b56249 = (props)=>{
    const { children: children, elementRef: elementRef, events: events = {}, className: className, style: style, disabled: disabled, passive: passive, target: target, href: href, title: title, internalIndex: internalIndex, isContainerFocusable: isContainerFocusable, root: root, rootRef: rootRef, show: show, componentTag: componentTag, ...rest } = props;
    const hasFocus = Boolean(isContainerFocusable && events?.onClick);
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    const isJioV2 = tokens?.["brandVersion"] === "jio-v2";
    const isButton = className.includes("j-JDSButton-container") || className.includes("j-JDSButton2-container");
    const POINTER_CURSOR_CLASSES = [
        "j-JDSButton-container",
        "j-JDSLink-container",
        "j-JDSActionButton-inner-container",
        "j-JDSTabItem-container"
    ];
    const Element = String(componentTag) === "undefined" && String(props["web-tag"]) === "undefined" ? isButton ? "button" : "div" : props["web-tag"] || componentTag;
    if (!show && (!children || Array.isArray(children) && children.every((c)=>c === null))) return null;
    const resolvedDisabled = $5c2cbe2b2431bcd1$var$resolveDisabled(disabled);
    const shouldHavePointerCursor = POINTER_CURSOR_CLASSES.some((cls)=>className?.includes(cls));
    const filteredEvents = $5c2cbe2b2431bcd1$var$filterInternalEvents(events);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(props.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, {
            ...filteredEvents,
            type: rest.type,
            "data-testid": rest?.["data-testid"],
            "data-index": internalIndex,
            className: $5c2cbe2b2431bcd1$var$classNames(className, hasFocus ? "hasFocus" : "", hasFocus && isJioV2 ? "engine-container" : ""),
            ref: elementRef || rootRef,
            disabled: resolvedDisabled,
            onKeyDown: (ev)=>{
                if (document.activeElement === ev.target && ev.currentTarget === ev.target && // Only handle on the actual target, not during bubbling
                ev.target.tagName !== "BUTTON") {
                    if (ev.key === "Enter" || ev.key === " ") {
                        const event = new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        });
                        ev.target.dispatchEvent(event);
                    }
                }
                props.onKeyDown?.(ev);
            },
            title: title,
            style: {
                ...style,
                overflow: props["overflow"],
                touchAction: passive ? "none" : void 0,
                cursor: shouldHavePointerCursor ? "pointer" : events.onClick ? "default" : void 0,
                ...resolvedDisabled ? $5c2cbe2b2431bcd1$var$disabledStyles : void 0
            },
            tabIndex: props.tabIndex ?? (disabled ? -1 : hasFocus ? 0 : void 0),
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            "aria-describedby": props["aria-describedby"],
            "aria-disabled": props["aria-disabled"],
            role: props.role,
            "aria-checked": props["aria-checked"],
            "aria-orientation": props["aria-orientation"],
            "aria-current": props["aria-current"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-valuemin": props["aria-valuemin"],
            "aria-valuemax": props["aria-valuemax"],
            "aria-valuenow": props["aria-valuenow"],
            "aria-busy": props["aria-busy"],
            "aria-valuetext": props["aria-valuetext"],
            "aria-selected": props["aria-selected"],
            "aria-pressed": props["aria-pressed"],
            "aria-hidden": props["aria-hidden"],
            "aria-modal": props["aria-modal"],
            "aria-haspopup": props["aria-haspopup"],
            "aria-live": props["aria-live"]
        }, children)
    });
};
const $5c2cbe2b2431bcd1$export$3e431a229df88919 = (props)=>{
    const { value: value, semantics: semantics, events: events, internalIndex: internalIndex, processedA11y: processedA11y, imageFocus: imageFocus, aspectRatio: aspectRatio, _childrenProps: _childrenProps, _isLottieVisible: _isLottieVisible, isContainerFocusable: isContainerFocusable, roundedCorner: roundedCorner, contentScale: contentScale, ...props_ } = props;
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    const [src, setSrc] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        setSrc(value);
    }, [
        value
    ]);
    const handleError = ()=>{
        if (tokens?.["brandVersion"] === "jio-v2") setSrc("https://picsum.photos/seed/picsum/200/300");
    };
    const formatImageName = (imagePath = value || "")=>{
        const parts = imagePath.split("/");
        const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
        if (imageName) {
            const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
            return formattedName;
        }
        return "Image name not found";
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("img", {
        "data-testid": "image-root",
        alt: semantics || formatImageName(src),
        src: src,
        onError: handleError,
        ...props_,
        ...events,
        style: {
            ...props_.style,
            width: tokens?.["brandVersion"] === "jio-v2" ? props_.width : "100%",
            opacity: !value ? 0 : void 0
        }
    });
};
const $5c2cbe2b2431bcd1$export$a6c7ac8248d6e38a = (props)=>{
    const { children: children, events: events, className: className, style: style, layer: layer, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        ...events,
        className: className,
        style: style,
        "data-testid": rest?.["data-testid"],
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(props.children, (item)=>item && (0, $acw62.cloneElement)(item))
    });
};
const $5c2cbe2b2431bcd1$var$PromoCardArc = (props)=>{
    const { orientation: orientation, style: style, className: className } = props;
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0,0 L0,5 C1,3 1,-3 0,-5 L0,0",
            fill: "currentcolor"
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0,0 L0,10 C1,3 1,-3 0,-10 L0,0",
            fill: "currentcolor",
            style: {
                transform: "rotate(270deg) translateX(-100%) translateY(50%"
            }
        })
    });
};
const $5c2cbe2b2431bcd1$var$addV2TagToCompLayer = (tokens, layer)=>{
    if (!layer) return layer;
    if (tokens?.["brandVersion"] === "jio-v2") {
        if (!layer.endsWith("2")) return layer + "2";
    }
    return layer;
};
const $5c2cbe2b2431bcd1$var$RenderComponent = (Comp, props, componentsMap)=>{
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    const comp = $5c2cbe2b2431bcd1$var$addV2TagToCompLayer(tokens, Comp?.component);
    if (comp && componentsMap?.[comp]) Comp = (0, $acw62.createElement)(componentsMap?.[comp](), Comp.props);
    if (Array.isArray(Comp)) return Comp.map((C)=>{
        if (!C.component) return $5c2cbe2b2431bcd1$var$RenderComponent(C, {
            ...C.props,
            ...props
        }, componentsMap);
        const comp2 = $5c2cbe2b2431bcd1$var$addV2TagToCompLayer(tokens, C?.component);
        return $5c2cbe2b2431bcd1$var$RenderComponent(comp2, {
            ...C.props,
            ...props
        }, componentsMap);
    });
    if (!(0, $acw62.isValidElement)(Comp)) return null;
    const compName = $5c2cbe2b2431bcd1$var$getComponentName(Comp);
    const { slot_layers: slot_layers, ...newProps } = props ?? {};
    const { lock_all: lock_all, ...slotProps } = slot_layers?.[compName] ?? slot_layers?.[compName + "2"] ?? {};
    for(const prop in slotProps){
        const arr = [].concat(slotProps[prop]);
        const value = Comp.props[prop];
        if (arr.includes(value)) newProps[prop] = value;
        else {
            newProps[prop] = arr[0];
            value !== void 0 && console.warn(`Invalid property on ${compName} for ${prop} - currently ${value}. Value must be one of [${arr.join()}]`);
        }
    }
    if (lock_all) return (0, $acw62.createElement)(Comp.type, {
        ...Comp.props,
        ...newProps
    });
    return (0, $acw62.cloneElement)(Comp, {
        ...Comp.props,
        ...newProps
    });
};
const $5c2cbe2b2431bcd1$var$removeBrandPrefixes = (name)=>{
    const PREFIXES = [
        "jds_"
    ];
    let currentName = name;
    PREFIXES.forEach((prefix)=>{
        currentName = currentName.replace(prefix, "");
    });
    return currentName;
};
const $5c2cbe2b2431bcd1$var$getComponentName = (Comp)=>{
    if (!Comp) return "";
    if (Comp?.type?.slotName) return Comp?.type?.slotName?.replace(/\d+$/, "");
    if (Comp?.slotName) return Comp?.slotName?.replace(/\d+$/, "");
    return Comp?.type?.displayName ?? Comp?.displayName ?? "";
};
const $5c2cbe2b2431bcd1$export$8c6ed5c666ac1360 = ({ _childrenProps: _childrenProps, layer: layer, events: events, className: className, style: style = {}, disabled: disabled, slot_layers: slot_layers, ...rest })=>{
    const { api: children, props: props } = _childrenProps;
    if (!children?.[layer]?.name) return null;
    const Comp = props?.[children?.[layer]?.name];
    if (!Comp) return null;
    const hasStyle = Boolean(Object.keys(style || {}).length);
    const _accepts = children?.[layer]?.accepts.map((item)=>item.replace(/\d+$/, ""));
    const acceptedArrayItems = [];
    _accepts?.forEach((item)=>{
        if (typeof item === "string") acceptedArrayItems.push($5c2cbe2b2431bcd1$var$removeBrandPrefixes(item.toLowerCase()).replace(/\d+$/, ""));
        if (Array.isArray(item)) item.map((item2)=>acceptedArrayItems.push($5c2cbe2b2431bcd1$var$removeBrandPrefixes(item2?.toLowerCase()).replace(/\d+$/, "")));
        return acceptedArrayItems;
    });
    const shouldComponentRender = (Comp2)=>{
        if (Comp2.component) Comp2 = $5c2cbe2b2431bcd1$var$RenderComponent(Comp2, Comp2.props, _childrenProps?.componentsMap || {});
        const CompName = $5c2cbe2b2431bcd1$var$getComponentName(Comp2);
        const should = acceptedArrayItems.includes(CompName?.toLowerCase()) || _accepts.includes(CompName?.toLowerCase().replace(/\d+$/, "")) || [
            "any",
            "template",
            "Any"
        ].includes(_accepts[0]);
        if (!should) console.warn("Did not render", {
            Comp: Comp2,
            CompName: CompName,
            acceptedArrayItems: acceptedArrayItems,
            _accepts: _accepts
        });
        return should;
    };
    const isReactElement = (obj)=>obj?.$$typeof === Symbol.for("react.element");
    const isArrayOfReactElements = (obj)=>Array.isArray(obj) && obj.every(isReactElement);
    if (!isReactElement(Comp) && !isArrayOfReactElements(Comp)) console.warn("not a react element", Comp);
    if (Comp.type !== Symbol.for("react.fragment") && (0, $acw62.isValidElement)(Comp)) {
        if (shouldComponentRender(Comp)) {
            if (!hasStyle) return $5c2cbe2b2431bcd1$var$RenderComponent(Comp, {
                ...events,
                ...Comp.props,
                style: {
                    ...rest["style"],
                    ...Comp?.props?.style
                },
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {});
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: $5c2cbe2b2431bcd1$var$RenderComponent(Comp, {
                    ...events,
                    ...Comp.props,
                    style: {
                        ...rest["style"],
                        ...Comp?.props?.style
                    },
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {})
            });
        }
    }
    if (Array.isArray(Comp)) {
        if (children?.[layer]?.max) {
            if (!hasStyle) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$5c2cbe2b2431bcd1$var$RenderComponent(Item, {
                        key: $5c2cbe2b2431bcd1$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$5c2cbe2b2431bcd1$var$RenderComponent(Item, {
                        key: $5c2cbe2b2431bcd1$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        if (!hasStyle) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$5c2cbe2b2431bcd1$var$RenderComponent(Item, {
                    key: $5c2cbe2b2431bcd1$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: className,
            style: {
                ...style,
                display: "contents",
                pointerEvents: disabled ? "none" : void 0
            },
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$5c2cbe2b2431bcd1$var$RenderComponent(Item, {
                    key: $5c2cbe2b2431bcd1$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
    }
    const renderFragment = (Comp2)=>{
        let ComponentChildren;
        if (children?.[layer]?.max || Array.isArray(Comp2.props.children)) {
            ComponentChildren = Comp2.props.children.slice?.(0, children?.[layer]?.max).map((item)=>{
                if (item?.type === Symbol.for("react.fragment")) return renderFragment(item);
                else if (item) return shouldComponentRender(item) && $5c2cbe2b2431bcd1$var$RenderComponent(item, {
                    ...item.props,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {});
                return null;
            });
            if (!hasStyle) return ComponentChildren;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: ComponentChildren.map((child)=>shouldComponentRender(child) && $5c2cbe2b2431bcd1$var$RenderComponent(child, {
                        ...child.props,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        ComponentChildren = Comp2.props.children;
        return ComponentChildren.map((child)=>shouldComponentRender(child) && $5c2cbe2b2431bcd1$var$RenderComponent(child, {
                ...child.props,
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {}));
    };
    if (typeof Comp === "object" && Comp.type === Symbol.for("react.fragment")) return renderFragment(Comp);
    return null;
};
const $5c2cbe2b2431bcd1$var$ButtonVector = (props)=>{
    const transformAngle = props.direction !== "reversed" ? 180 : 0;
    const borderClass = props["border-type"] === "solid" ? "solid-border" : "none";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: $5c2cbe2b2431bcd1$var$classNames(props.className, borderClass, "sw-btn-vector"),
        style: {
            ...props.style,
            transform: `rotate(${transformAngle}deg)`
        },
        preserveAspectRatio: "none",
        viewBox: "0 0 40 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "path-1-inside-1_23_23",
                fill: "red",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0"
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "inside",
                d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0",
                fill: "currentcolor"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.53 56V57H12.5381L12.5463 56.9999L12.53 56ZM28.54 41.98L27.5923 41.6608L27.5891 41.6704L27.5861 41.68L28.54 41.98ZM40 28L40.1614 28.9869L40.1659 27.0139L40 28ZM28.54 14.02L27.5861 14.32L27.5892 14.33L27.5926 14.3399L28.54 14.02ZM12.53 0L12.5463 -0.999867L12.5381 -1H12.53V0ZM0 57H12.53V55H0V57ZM12.53 56C12.5463 56.9999 12.5469 56.9999 12.5476 56.9998C12.5479 56.9998 12.5486 56.9998 12.5491 56.9998C12.5503 56.9998 12.5516 56.9998 12.5531 56.9997C12.556 56.9997 12.5597 56.9996 12.5641 56.9995C12.5729 56.9993 12.5844 56.9989 12.5988 56.9984C12.6274 56.9974 12.6671 56.9957 12.7171 56.993C12.8171 56.9875 12.9588 56.9776 13.1374 56.96C13.4946 56.9249 14.0005 56.8588 14.6173 56.7345C15.8497 56.4863 17.5338 56.004 19.3606 55.0658C23.038 53.1773 27.2325 49.47 29.4939 42.28L27.5861 41.68C25.4975 48.32 21.687 51.6227 18.4469 53.2867C16.815 54.1248 15.3121 54.5544 14.2224 54.7739C13.6781 54.8836 13.2391 54.9404 12.9416 54.9696C12.7929 54.9843 12.6799 54.992 12.6069 54.996C12.5705 54.998 12.5441 54.9991 12.5284 54.9997C12.5205 54.9999 12.5153 55.0001 12.5128 55.0001C12.5116 55.0002 12.5111 55.0002 12.5112 55.0002C12.5113 55.0002 12.5115 55.0002 12.5119 55.0002C12.5121 55.0002 12.5126 55.0002 12.5127 55.0001C12.5132 55.0001 12.5137 55.0001 12.53 56ZM29.4877 42.2992C33.2983 30.9845 38.4683 29.2638 40.1614 28.9869L39.8386 27.0131C37.2517 27.4362 31.5817 29.8155 27.5923 41.6608L29.4877 42.2992ZM40.1659 27.0139C38.4677 26.7282 33.3074 25.0135 29.4874 13.7001L27.5926 14.3399C31.5926 26.1865 37.2523 28.5518 39.8341 28.9861L40.1659 27.0139ZM29.4939 13.72C27.2325 6.53004 23.038 2.82274 19.3606 0.934197C17.5338 -0.00395302 15.8497 -0.486254 14.6173 -0.734524C14.0005 -0.858788 13.4946 -0.924878 13.1374 -0.960018C12.9588 -0.977597 12.8171 -0.987457 12.7171 -0.992973C12.6671 -0.995731 12.6274 -0.997405 12.5988 -0.998413C12.5844 -0.998918 12.5729 -0.999256 12.5641 -0.999481C12.5597 -0.999594 12.556 -0.999678 12.5531 -0.99974C12.5516 -0.999771 12.5503 -0.999796 12.5491 -0.999817C12.5486 -0.999828 12.5479 -0.999841 12.5476 -0.999846C12.5469 -0.999857 12.5463 -0.999867 12.53 0C12.5137 0.999867 12.5132 0.999858 12.5127 0.99985C12.5126 0.999848 12.5121 0.99984 12.5119 0.999836C12.5115 0.999829 12.5113 0.999824 12.5112 0.999822C12.5111 0.999819 12.5116 0.99983 12.5128 0.999862C12.5153 0.999925 12.5205 1.00007 12.5284 1.00035C12.5441 1.0009 12.5705 1.00198 12.6069 1.00399C12.6799 1.00801 12.7929 1.01574 12.9416 1.03037C13.2391 1.05964 13.6781 1.11644 14.2224 1.22609C15.3121 1.44563 16.815 1.8752 18.4469 2.7133C21.687 4.37726 25.4975 7.67996 27.5861 14.32L29.4939 13.72ZM12.53 -1H0V1H12.53V-1Z",
                fill: "url(#paint0_angular_23_23)",
                mask: "url(#path-1-inside-1_23_23)"
            }),
            props["border-type"] === "gradient" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                    id: "paint0_angular_23_23",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(38.5 51.5) rotate(154.464) scale(70.402 85.8467)",
                    children: [
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.0165174",
                            stopColor: "#EAB872"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.280935",
                            stopColor: "#63371D"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.563131",
                            stopColor: "#FFEAC2"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.796371",
                            stopColor: "#AE824E"
                        })
                    ]
                })
            })
        ]
    });
};
const $5c2cbe2b2431bcd1$var$atomsMap = {
    container: $5c2cbe2b2431bcd1$export$42a852a2b6b56249,
    text: $5c2cbe2b2431bcd1$export$5f1af8db9871e1d6,
    icon: $5c2cbe2b2431bcd1$export$f04a61298a47a40f,
    image: $5c2cbe2b2431bcd1$export$3e431a229df88919,
    slider: $5c2cbe2b2431bcd1$export$472062a354075cee,
    animatedContainer: $5c2cbe2b2431bcd1$export$9382739d0e79620f,
    loader: $5c2cbe2b2431bcd1$export$3b0d6d7590275603,
    link: $5c2cbe2b2431bcd1$export$a6c7ac8248d6e38a,
    popup: $5c2cbe2b2431bcd1$export$129a32eedafa97c5,
    textarea: $5c2cbe2b2431bcd1$export$379139ebc1c2b235,
    tooltip: $5c2cbe2b2431bcd1$export$c92c6401b52a9298,
    input: $5c2cbe2b2431bcd1$export$f5b8910cec6cf069,
    promoCardArc: $5c2cbe2b2431bcd1$var$PromoCardArc,
    arc: $5c2cbe2b2431bcd1$export$6ef80ffb606dd232,
    slot: $5c2cbe2b2431bcd1$export$8c6ed5c666ac1360,
    skeletonLoader: $5c2cbe2b2431bcd1$export$d50980d2cec56085,
    button_vector: $5c2cbe2b2431bcd1$var$ButtonVector
};
const $5c2cbe2b2431bcd1$export$595884dc072315a0 = (layer)=>{
    const baseLayerName = $5c2cbe2b2431bcd1$var$getBaseLayerName(layer);
    return Object.keys($5c2cbe2b2431bcd1$var$atomsMap).includes(baseLayerName);
};
const $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38 = (componentProperties, props, componentName = "component", componentsMap, _custom = {}, parentRuntime)=>{
    const runtime = parentRuntime || props.runtime;
    const { hierarchy: hierarchy, api: api, ...rest } = componentProperties;
    const { componentTag: componentTag, ...restProps } = props;
    const customMergedJSON = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)({
        api: api,
        ...rest
    }, _custom);
    const defaultProps = (0, $6eea7234d56610fe$export$61b94149aeb1f59)(customMergedJSON.api);
    const invariants = (0, $6eea7234d56610fe$export$ce4be320c9b7d5be)(customMergedJSON);
    const normalisedProperties = $5c2cbe2b2431bcd1$var$processConfigAPI(api?.config, props);
    const mergedProps = {
        ...restProps,
        ...normalisedProperties
    };
    const flatTokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    const propTokens = (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(mergedProps, (v, k)=>$5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(k) && v !== "auto");
    const getPercentageTokens = Object.keys(defaultProps).filter((key)=>props[key] !== defaultProps[key]);
    const defaultSwitchables = $5c2cbe2b2431bcd1$export$dfce236e857ed8b0();
    const hasDifferentTokens = Object.keys((0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(propTokens, (v, k)=>v !== defaultSwitchables[k])).length > 0;
    const shouldIncludeAmpersand = getPercentageTokens.length > 0 && hasDifferentTokens || Object.values(customMergedJSON.base).some((item)=>Object.keys(item).some((key)=>key.endsWith("color") || key === "fill"));
    const config = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).brandResolverFn && !runtime ? {
        getAmpersandTokens: shouldIncludeAmpersand,
        getPercentageTokens: getPercentageTokens,
        getAllBaseLayers: false,
        transformer: false
    } : void 0;
    const uiTokens = (0, $6eea7234d56610fe$export$e025e4ac3d283105)(mergedProps, (0, $bff35c0dd9851fab$export$629a2bd3f5a49ecc)(customMergedJSON), config);
    const { layerProps: layerProps, styles: styles_ } = $5c2cbe2b2431bcd1$var$seperateComponentLayerProps(uiTokens);
    const { hierarchy: hierarchy_, styles: styles } = $5c2cbe2b2431bcd1$var$hiddenFilter({
        hierarchy_: hierarchy,
        styles_: styles_,
        api: api,
        props: mergedProps
    });
    const propMergedStyles = $5c2cbe2b2431bcd1$var$mergeStyleProperties(mergedProps, styles, api.data, layerProps);
    const drawnComponent = (0, $6eea7234d56610fe$export$a1a0a7262a295961)(componentName, propMergedStyles, hierarchy, invariants, {
        ...flatTokens,
        ...propTokens
    });
    return $5c2cbe2b2431bcd1$var$renderComponent({
        currentLayer: hierarchy_,
        api: api,
        props: mergedProps,
        componentName: customMergedJSON?.metadata?.name || componentName,
        children: api.children,
        componentsMap: componentsMap,
        base: propMergedStyles,
        layerProps: layerProps,
        internalIndex: props.internalIndex,
        root: true,
        componentTag: componentTag,
        drawnComponent: drawnComponent,
        runtime: runtime,
        tokens: flatTokens
    });
};
const $5c2cbe2b2431bcd1$var$ComponentWithTokens = ({ children: children, base: base, layer: layer, propTokens: propTokens, runtime: runtime })=>{
    const tokens = $5c2cbe2b2431bcd1$export$f34d637a75323a1e();
    if (runtime && // !['text', 'icon'].some((key) => layer.endsWith(key)) &&
    !layer.includes("jds_")) return (0, $acw62.cloneElement)(children, {
        style: Object.fromEntries(Object.entries(base[layer] || {}).map(([key, value])=>[
                key,
                (0, $6eea7234d56610fe$export$6a176e754d54672)(key, value, tokens)
            ]))
    });
    if (tokens.brandVersion !== "jio-v2") {
        if (Object.keys(tokens).some((key)=>key in base[layer])) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$e5cf4eff53e7947d, {
            value: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(base[layer], (v, k)=>$5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(k)),
            children: children
        });
        return children;
    }
    const colorKeys = [
        "appearance",
        "surface",
        "strokeSurface",
        "color",
        "background-color",
        "border-color",
        "fill"
    ];
    if (tokens?.["brandVersion"] !== "jio-v2" || (!base[layer] || !colorKeys.some((k)=>base[layer]?.[k])) && !Object.keys(propTokens || {}).length || layer.endsWith("slot")) return children;
    const colorProperty = Object.keys(base[layer] || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(base[layer] || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(base[layer]?.[colorProperty]) || "");
    const borderColorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(base[layer]?.[borderColorProperty]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$export$e5cf4eff53e7947d, {
        value: {
            ...(0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(base[layer], (v, k)=>$5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(k)),
            ...propTokens,
            surface: base[layer]?.surface?.toString() || surface || "ghost",
            strokeSurface: base[layer]?.strokeSurface?.toString() || strokeSurface || void 0
        },
        children: children
    });
};
const $5c2cbe2b2431bcd1$var$renderComponent = ({ currentLayer: currentLayer, api: api, props: props, componentName: componentName, children: children, componentsMap: componentsMap, base: base, layerProps: layerProps, internalIndex: internalIndex, root: root, componentTag: componentTag, drawnComponent: drawnComponent, runtime: runtime, tokens: tokens })=>{
    const isV2 = tokens?.["brandVersion"] === "jio-v2";
    if (typeof currentLayer === "string") {
        const CurrentComp = $5c2cbe2b2431bcd1$var$getCompFromKey(currentLayer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $5c2cbe2b2431bcd1$var$processDataAPI(api, currentLayer, props);
        const drawnClasses = drawnComponent.classes[currentLayer] ?? [];
        const drawnStyles = drawnComponent.styles;
        if (CurrentComp) {
            const processedConfigAPI = $5c2cbe2b2431bcd1$var$processConfigAPI(api?.config, props);
            const newProps = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(processedConfigAPI, layerProps?.[currentLayer], processData, {
                events: processedEvents
            }, processedA11y);
            const className = (0, $6eea7234d56610fe$export$c1260eec73bdf31d)(componentName, currentLayer);
            const isAtomicLayer = $5c2cbe2b2431bcd1$export$595884dc072315a0(currentLayer);
            const Component = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CurrentComp, {
                layer: currentLayer,
                "data-testid": (0, $6eea7234d56610fe$export$82c717ab02da3bac)(componentName, currentLayer),
                _childrenProps: {
                    api: children,
                    props: props,
                    componentsMap: componentsMap
                },
                disabled: props.disabled || layerProps?.[currentLayer]?.["disabled"],
                ...newProps,
                runtime: runtime && !currentLayer.includes("jds_"),
                ...newProps.events,
                isContainerFocusable: $5c2cbe2b2431bcd1$var$getIsContainerFocusable(api, currentLayer),
                className: $5c2cbe2b2431bcd1$export$595884dc072315a0 && isV2 ? $5c2cbe2b2431bcd1$var$classNames(className, ...drawnClasses, newProps.className) : !Object.keys(base).length ? "" : className,
                style: root ? drawnStyles : void 0,
                internalIndex: internalIndex || 0,
                processedA11y: processedA11y
            }, currentLayer);
            if (!(0, $acw62.isValidElement)(Component)) return null;
            if (!isAtomicLayer) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "contents",
                    ...root ? drawnStyles : {}
                },
                className: className,
                children: Component
            }, currentLayer);
            if (currentLayer.endsWith("slot")) {
                if (props?.[children?.[currentLayer]?.name]) return Component;
                return null;
            }
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$var$ComponentWithTokens, {
                base: base,
                layer: currentLayer,
                runtime: runtime,
                propTokens: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newProps, (v, k)=>$5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: Component
            }, currentLayer);
        }
    } else if (typeof currentLayer === "object" && !Array.isArray(currentLayer)) return Object.keys(currentLayer).map((layer)=>{
        const drawnClasses = drawnComponent.classes[layer] ?? [];
        const drawnStyles = drawnComponent.styles;
        const CurrentComp = $5c2cbe2b2431bcd1$var$getCompFromKey(layer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $5c2cbe2b2431bcd1$var$processDataAPI(api, layer, props) || {};
        if (CurrentComp) {
            const processedConfigAPI = $5c2cbe2b2431bcd1$var$processConfigAPI(api?.config, props);
            const newProps = {
                ...processedConfigAPI,
                ...layerProps?.[layer],
                ...processData,
                ...processedEvents,
                ...processedA11y,
                style: root ? props.style : void 0,
                componentTag: root ? componentTag : void 0,
                rootRef: root ? props.rootRef : void 0
            };
            const listName = api.data?.[layer]?.["value"]?.name;
            const arrayData = api.data?.[layer]?.["value"]?.type === "list" ? props[listName] : void 0;
            const className = (0, $6eea7234d56610fe$export$c1260eec73bdf31d)(componentName, layer);
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($5c2cbe2b2431bcd1$var$ComponentWithTokens, {
                base: base,
                layer: layer,
                runtime: runtime,
                propTokens: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newProps, (v, k)=>$5c2cbe2b2431bcd1$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CurrentComp, {
                    "data-testid": (0, $6eea7234d56610fe$export$82c717ab02da3bac)(componentName, layer),
                    ...newProps,
                    layer: layer,
                    runtime: runtime && !layer.includes("jds_"),
                    className: $5c2cbe2b2431bcd1$var$classNames(className, !root ? "" : newProps.className, ...isV2 ? drawnClasses : []),
                    isContainerFocusable: $5c2cbe2b2431bcd1$var$getIsContainerFocusable(api, layer),
                    style: root ? {
                        ...props.style ?? {},
                        ...drawnStyles
                    } : void 0,
                    events: processedEvents,
                    disabled: props.disabled || layerProps?.[layer]?.["disabled"],
                    internalIndex: internalIndex,
                    processedA11y: processedA11y,
                    children: arrayData ? arrayData?.map((valueItem, i)=>{
                        return $5c2cbe2b2431bcd1$var$renderComponent({
                            currentLayer: currentLayer[layer],
                            api: api,
                            props: {
                                ...props,
                                ...valueItem,
                                internalIndex: i
                            },
                            componentName: componentName,
                            children: children,
                            componentsMap: componentsMap,
                            base: base,
                            layerProps: layerProps,
                            internalIndex: valueItem.internalIndex || i,
                            drawnComponent: drawnComponent,
                            runtime: runtime,
                            tokens: tokens
                        });
                    }) : $5c2cbe2b2431bcd1$var$renderComponent({
                        currentLayer: currentLayer[layer],
                        api: api,
                        props: {
                            ...props
                        },
                        componentName: componentName,
                        children: children,
                        componentsMap: componentsMap,
                        base: base,
                        layerProps: layerProps,
                        internalIndex: internalIndex,
                        drawnComponent: drawnComponent,
                        runtime: runtime,
                        tokens: tokens
                    })
                }, layer)
            }, layer);
        }
        return null;
    });
    else if (typeof currentLayer === "object" && Array.isArray(currentLayer)) return currentLayer.map((child)=>{
        return $5c2cbe2b2431bcd1$var$renderComponent({
            currentLayer: child,
            api: api,
            props: props,
            componentName: componentName,
            children: children,
            componentsMap: componentsMap,
            base: base,
            layerProps: layerProps,
            internalIndex: internalIndex,
            drawnComponent: drawnComponent,
            runtime: runtime,
            tokens: tokens
        });
    });
    return null;
};
const $5c2cbe2b2431bcd1$var$getCompFromKey = (obj, componentsMap)=>{
    const layerName = $5c2cbe2b2431bcd1$var$getBaseLayerName(obj);
    if (componentsMap && componentsMap[layerName]) try {
        return componentsMap[layerName]?.() || null;
    } catch (error) {
        return null;
    }
    if ($5c2cbe2b2431bcd1$export$595884dc072315a0(layerName)) return $5c2cbe2b2431bcd1$var$atomsMap[layerName] || null;
    return null;
};
const $5c2cbe2b2431bcd1$var$excludedLayers = [
    "input",
    "container",
    "arc",
    "slider",
    "loader",
    "button_vector",
    "skeletonLoader"
];
const $5c2cbe2b2431bcd1$var$hasProps = (layerName = "", api, props, styles)=>{
    if ($5c2cbe2b2431bcd1$var$excludedLayers.some((layer)=>layerName.endsWith(layer))) return true;
    const apiLayers = api.data?.[layerName];
    const childlayers = api.children?.[layerName];
    if (!apiLayers && !childlayers && Object.values(apiLayers || {}).every(({ type: type })=>type === "boolean")) return true;
    const hasChildren = Boolean(props?.[childlayers?.name]);
    const hasData = Object.values(apiLayers || {}).some(({ name: name })=>![
            void 0,
            null,
            ""
        ].includes(props[name]) || ![
            void 0,
            null,
            ""
        ].includes(styles?.[layerName]?.[name]) || name.includes("."));
    const hasBaseProps = Object.keys((styles || {})[layerName] || {}).filter((key)=>Object.values(apiLayers || {}).find(({ name: name })=>name === key))?.length;
    if (!hasData && hasBaseProps) return true;
    if (!hasData && !(hasChildren && childlayers)) return false;
    return true;
};
const $5c2cbe2b2431bcd1$var$hiddenFilter = ({ hierarchy_: hierarchy_, styles_: styles_, api: api, props: props })=>{
    const hiddenLayers = [];
    const styles = Object.entries(styles_).reduce((acc, [layerName, styleProps])=>{
        if ($5c2cbe2b2431bcd1$var$isHidden(styleProps.hidden) && !styleProps?.["transition"]) hiddenLayers.push(layerName);
        else acc[layerName] = styleProps;
        return acc;
    }, {});
    const hierarchy = $5c2cbe2b2431bcd1$var$filterHierarchy(hierarchy_, hiddenLayers, api, props, styles);
    return {
        hierarchy: hierarchy,
        styles: styles
    };
};
const $5c2cbe2b2431bcd1$var$isHidden = (hidden)=>{
    if (typeof hidden === "string") return hidden.includes("true");
    return Boolean(hidden);
};
const $5c2cbe2b2431bcd1$var$isLayerHidden = (layer, hiddenLayers)=>{
    return hiddenLayers.includes(layer);
};
const $5c2cbe2b2431bcd1$var$filterHierarchy = (hierarchy, hiddenLayers, api, props, styles)=>{
    if (typeof hierarchy === "string" && !$5c2cbe2b2431bcd1$var$isLayerHidden(hierarchy, hiddenLayers) && $5c2cbe2b2431bcd1$var$hasProps(hierarchy, api, props, styles)) return hierarchy;
    else if (typeof hierarchy === "object" && !Array.isArray(hierarchy)) {
        const end = Object.keys(hierarchy).filter((key)=>{
            return !$5c2cbe2b2431bcd1$var$isLayerHidden(key, hiddenLayers) && $5c2cbe2b2431bcd1$var$hasProps(key, api, props);
        }).reduce((res, key)=>{
            res[key] = $5c2cbe2b2431bcd1$var$filterHierarchy(hierarchy[key], hiddenLayers, api, props, styles);
            return res;
        }, {});
        return end;
    } else if (typeof hierarchy === "object" && Array.isArray(hierarchy)) {
        const res = [];
        hierarchy.forEach((key)=>{
            res.push($5c2cbe2b2431bcd1$var$filterHierarchy(key, hiddenLayers, api, props, styles));
        });
        return res.filter((r)=>Object.keys(r).length).flat();
    }
    return {};
};
function $5c2cbe2b2431bcd1$var$getIsContainerFocusable(api, layer) {
    const clickEvent = api.events?.[layer]?.onClick;
    if (layer.includes("popup")) return false;
    if (layer.includes("button")) return true;
    if (!layer.includes("container")) return false;
    if (clickEvent) {
        const name = typeof clickEvent === "string" ? clickEvent : clickEvent.name;
        return !name.startsWith("_");
    }
}
const $5c2cbe2b2431bcd1$var$English$6 = {
    of: "of"
};
const $5c2cbe2b2431bcd1$var$Hindi$6 = {
    of: "\u0915\u093E"
};
const $5c2cbe2b2431bcd1$var$Marathi$6 = {
    of: "\u091A\u094D\u092F\u093E"
};
const $5c2cbe2b2431bcd1$var$Gujarati$6 = {
    of: "\u0AA8\u0ABE"
};
const $5c2cbe2b2431bcd1$var$Punjabi$6 = {
    of: "\u0A26\u0A47"
};
const $5c2cbe2b2431bcd1$var$Bengali$6 = {
    of: "\u098F\u09B0"
};
const $5c2cbe2b2431bcd1$var$Tamil$6 = {
    of: "\u0B87\u0BA9\u0BCD"
};
const $5c2cbe2b2431bcd1$var$Telugu$6 = {
    of: "\u0C2F\u0C4A\u0C15\u0C4D\u0C15"
};
const $5c2cbe2b2431bcd1$var$Kannada$6 = {
    of: "\u0CA8"
};
const $5c2cbe2b2431bcd1$var$Assamese$6 = {
    of: "\u09F0"
};
const $5c2cbe2b2431bcd1$var$Malayalam$6 = {
    of: "\u0D2F\u0D41\u0D1F\u0D46"
};
const $5c2cbe2b2431bcd1$var$Oriya$6 = {
    of: "\u0B30"
};
const $5c2cbe2b2431bcd1$var$of = {
    English: $5c2cbe2b2431bcd1$var$English$6,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$6,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$6,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$6,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$6,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$6,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$6,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$6,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$6,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$6,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$6,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$6
};
const $5c2cbe2b2431bcd1$var$ofData = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$6,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$6,
    English: $5c2cbe2b2431bcd1$var$English$6,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$6,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$6,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$6,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$6,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$6,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$6,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$6,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$6,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$6,
    default: $5c2cbe2b2431bcd1$var$of
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $5c2cbe2b2431bcd1$var$English$5 = {
    ConfirmButton: "Confirm"
};
const $5c2cbe2b2431bcd1$var$Hindi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902"
};
const $5c2cbe2b2431bcd1$var$Marathi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u0940"
};
const $5c2cbe2b2431bcd1$var$Gujarati$5 = {
    ConfirmButton: "\u0AAA\u0AC1\u0AB7\u0ACD\u0A9F\u0ABF \u0A95\u0AB0\u0ACB"
};
const $5c2cbe2b2431bcd1$var$Punjabi$5 = {
    ConfirmButton: "\u0A2A\u0A41\u0A38\u0A3C\u0A1F\u0A40 \u0A15\u0A30\u0A4B"
};
const $5c2cbe2b2431bcd1$var$Bengali$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8"
};
const $5c2cbe2b2431bcd1$var$Tamil$5 = {
    ConfirmButton: "\u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD"
};
const $5c2cbe2b2431bcd1$var$Telugu$5 = {
    ConfirmButton: "\u0C28\u0C3F\u0C30\u0C4D\u0C27\u0C3E\u0C30\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
};
const $5c2cbe2b2431bcd1$var$Kannada$5 = {
    ConfirmButton: "\u0CA6\u0CC3\u0CA2\u0CC0\u0C95\u0CB0\u0CBF\u0CB8\u0CBF"
};
const $5c2cbe2b2431bcd1$var$Assamese$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4"
};
const $5c2cbe2b2431bcd1$var$Malayalam$5 = {
    ConfirmButton: "\u0D38\u0D4D\u0D25\u0D3F\u0D30\u0D40\u0D15\u0D30\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15"
};
const $5c2cbe2b2431bcd1$var$Oriya$5 = {
    ConfirmButton: "\u0B28\u0B3F\u0B36\u0B4D\u0B1A\u0B3F\u0B24 \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41 |"
};
const $5c2cbe2b2431bcd1$var$confirmButtonData = {
    English: $5c2cbe2b2431bcd1$var$English$5,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$5,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$5,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$5,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$5,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$5,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$5,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$5,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$5,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$5,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$5,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$5
};
const $5c2cbe2b2431bcd1$var$as = "Assamese";
const $5c2cbe2b2431bcd1$var$bn = "Bengali";
const $5c2cbe2b2431bcd1$var$en = "English";
const $5c2cbe2b2431bcd1$var$gu = "Gujarati";
const $5c2cbe2b2431bcd1$var$hi = "Hindi";
const $5c2cbe2b2431bcd1$var$kn = "Kannada";
const $5c2cbe2b2431bcd1$var$ml = "Malayalam";
const $5c2cbe2b2431bcd1$var$mr = "Marathi";
const $5c2cbe2b2431bcd1$var$or = "Oriya";
const $5c2cbe2b2431bcd1$var$pa = "Punjabi";
const $5c2cbe2b2431bcd1$var$ta = "Tamil";
const $5c2cbe2b2431bcd1$var$te = "Telugu";
const $5c2cbe2b2431bcd1$var$localeLanguageData = {
    as: $5c2cbe2b2431bcd1$var$as,
    bn: $5c2cbe2b2431bcd1$var$bn,
    en: $5c2cbe2b2431bcd1$var$en,
    gu: $5c2cbe2b2431bcd1$var$gu,
    hi: $5c2cbe2b2431bcd1$var$hi,
    kn: $5c2cbe2b2431bcd1$var$kn,
    ml: $5c2cbe2b2431bcd1$var$ml,
    mr: $5c2cbe2b2431bcd1$var$mr,
    or: $5c2cbe2b2431bcd1$var$or,
    pa: $5c2cbe2b2431bcd1$var$pa,
    ta: $5c2cbe2b2431bcd1$var$ta,
    te: $5c2cbe2b2431bcd1$var$te
};
const $5c2cbe2b2431bcd1$var$English$4 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9",
    ten: "10",
    eleven: "11",
    twelve: "12",
    thirteen: "13",
    fourteen: "14",
    fifteen: "15",
    sixteen: "16",
    seventeen: "17",
    eighteen: "18",
    nineteen: "19",
    twenty: "20",
    twenty_one: "21",
    twenty_two: "22",
    twenty_three: "23",
    twenty_four: "24",
    twenty_five: "25",
    twenty_six: "26",
    twenty_seven: "27",
    twenty_eight: "28",
    twenty_nine: "29",
    thirty: "30",
    thirty_one: "31"
};
const $5c2cbe2b2431bcd1$var$Hindi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $5c2cbe2b2431bcd1$var$Marathi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $5c2cbe2b2431bcd1$var$Gujarati$4 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF",
    ten: "\u0AE7\u0AE6",
    eleven: "\u0AE7\u0AE7",
    twelve: "\u0AE7\u0AE8",
    thirteen: "\u0AE7\u0AE9",
    fourteen: "\u0AE7\u0AEA",
    fifteen: "\u0AE7\u0AEB",
    sixteen: "\u0AE7\u0AEC",
    seventeen: "\u0AE7\u0AED",
    eighteen: "\u0AE7\u0AEE",
    nineteen: "\u0AE7\u0AEF",
    twenty: "\u0AE8\u0AE6",
    twenty_one: "\u0AE8\u0AE7",
    twenty_two: "\u0AE8\u0AE8",
    twenty_three: "\u0AE8\u0AE9",
    twenty_four: "\u0AE8\u0AEA",
    twenty_five: "\u0AE8\u0AEB",
    twenty_six: "\u0AE8\u0AEC",
    twenty_seven: "\u0AE8\u0AED",
    twenty_eight: "\u0AE8\u0AEE",
    twenty_nine: "\u0AE8\u0AEF",
    thirty: "\u0AE9\u0AE6",
    thirty_one: "\u0AE9\u0AE7"
};
const $5c2cbe2b2431bcd1$var$Punjabi$4 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F",
    ten: "\u0A67\u0A66",
    eleven: "\u0A67\u0A67",
    twelve: "\u0A67\u0A68",
    thirteen: "\u0A67\u0A69",
    fourteen: "\u0A67\u0A6A",
    fifteen: "\u0A67\u0A6B",
    sixteen: "\u0A67\u0A6C",
    seventeen: "\u0A67\u0A6D",
    eighteen: "\u0A67\u0A6E",
    nineteen: "\u0A67\u0A6F",
    twenty: "\u0A68\u0A66",
    twenty_one: "\u0A68\u0A67",
    twenty_two: "\u0A68\u0A68",
    twenty_three: "\u0A68\u0A69",
    twenty_four: "\u0A68\u0A6A",
    twenty_five: "\u0A68\u0A6B",
    twenty_six: "\u0A68\u0A6C",
    twenty_seven: "\u0A68\u0A6D",
    twenty_eight: "\u0A68\u0A6E",
    twenty_nine: "\u0A68\u0A6F",
    thirty: "\u0A69\u0A66",
    thirty_one: "\u0A69\u0A67"
};
const $5c2cbe2b2431bcd1$var$Bengali$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $5c2cbe2b2431bcd1$var$Tamil$4 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF",
    ten: "\u0BE7\u0BE6",
    eleven: "\u0BE7\u0BE7",
    twelve: "\u0BE7\u0BE8",
    thirteen: "\u0BE7\u0BE9",
    fourteen: "\u0BE7\u0BEA",
    fifteen: "\u0BE7\u0BEB",
    sixteen: "\u0BE7\u0BEC",
    seventeen: "\u0BE7\u0BED",
    eighteen: "\u0BE7\u0BEE",
    nineteen: "\u0BE7\u0BEF",
    twenty: "\u0BE8\u0BE6",
    twenty_one: "\u0BE8\u0BE7",
    twenty_two: "\u0BE8\u0BE8",
    twenty_three: "\u0BE8\u0BE9",
    twenty_four: "\u0BE8\u0BEA",
    twenty_five: "\u0BE8\u0BEB",
    twenty_six: "\u0BE8\u0BEC",
    twenty_seven: "\u0BE8\u0BED",
    twenty_eight: "\u0BE8\u0BEE",
    twenty_nine: "\u0BE8\u0BEF",
    thirty: "\u0BE9\u0BE6",
    thirty_one: "\u0BE9\u0BE7"
};
const $5c2cbe2b2431bcd1$var$Telugu$4 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F",
    ten: "\u0C67\u0C66",
    eleven: "\u0C67\u0C67",
    twelve: "\u0C67\u0C68",
    thirteen: "\u0C67\u0C69",
    fourteen: "\u0C67\u0C6A",
    fifteen: "\u0C67\u0C6B",
    sixteen: "\u0C67\u0C6C",
    seventeen: "\u0C67\u0C6D",
    eighteen: "\u0C67\u0C6E",
    nineteen: "\u0C67\u0C6F",
    twenty: "\u0C68\u0C66",
    twenty_one: "\u0C68\u0C67",
    twenty_two: "\u0C68\u0C68",
    twenty_three: "\u0C68\u0C69",
    twenty_four: "\u0C68\u0C6A",
    twenty_five: "\u0C68\u0C6B",
    twenty_six: "\u0C68\u0C6C",
    twenty_seven: "\u0C68\u0C6D",
    twenty_eight: "\u0C68\u0C6E",
    twenty_nine: "\u0C68\u0C6F",
    thirty: "\u0C69\u0C66",
    thirty_one: "\u0C69\u0C67"
};
const $5c2cbe2b2431bcd1$var$Kannada$4 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF",
    ten: "\u0CE7\u0CE6",
    eleven: "\u0CE7\u0CE7",
    twelve: "\u0CE7\u0CE8",
    thirteen: "\u0CE7\u0CE9",
    fourteen: "\u0CE7\u0CEA",
    fifteen: "\u0CE7\u0CEB",
    sixteen: "\u0CE7\u0CEC",
    seventeen: "\u0CE7\u0CED",
    eighteen: "\u0CE7\u0CEE",
    nineteen: "\u0CE7\u0CEF",
    twenty: "\u0CE8\u0CE6",
    twenty_one: "\u0CE8\u0CE7",
    twenty_two: "\u0CE8\u0CE8",
    twenty_three: "\u0CE8\u0CE9",
    twenty_four: "\u0CE8\u0CEA",
    twenty_five: "\u0CE8\u0CEB",
    twenty_six: "\u0CE8\u0CEC",
    twenty_seven: "\u0CE8\u0CED",
    twenty_eight: "\u0CE8\u0CEE",
    twenty_nine: "\u0CE8\u0CEF",
    thirty: "\u0CE9\u0CE6",
    thirty_one: "\u0CE9\u0CE7"
};
const $5c2cbe2b2431bcd1$var$Assamese$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $5c2cbe2b2431bcd1$var$Malayalam$4 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F",
    ten: "\u0D67\u0D66",
    eleven: "\u0D67\u0D67",
    twelve: "\u0D67\u0D68",
    thirteen: "\u0D67\u0D69",
    fourteen: "\u0D67\u0D6A",
    fifteen: "\u0D67\u0D6B",
    sixteen: "\u0D67\u0D6C",
    seventeen: "\u0D67\u0D6D",
    eighteen: "\u0D67\u0D6E",
    nineteen: "\u0D67\u0D6F",
    twenty: "\u0D68\u0D66",
    twenty_one: "\u0D68\u0D67",
    twenty_two: "\u0D68\u0D68",
    twenty_three: "\u0D68\u0D69",
    twenty_four: "\u0D68\u0D6A",
    twenty_five: "\u0D68\u0D6B",
    twenty_six: "\u0D68\u0D6C",
    twenty_seven: "\u0D68\u0D6D",
    twenty_eight: "\u0D68\u0D6E",
    twenty_nine: "\u0D68\u0D6F",
    thirty: "\u0D69\u0D66",
    thirty_one: "\u0D69\u0D67"
};
const $5c2cbe2b2431bcd1$var$Oriya$4 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F",
    ten: "\u0B67\u0B66",
    eleven: "\u0B67\u0B67",
    twelve: "\u0B67\u0B68",
    thirteen: "\u0B67\u0B69",
    fourteen: "\u0B67\u0B6A",
    fifteen: "\u0B67\u0B6B",
    sixteen: "\u0B67\u0B6C",
    seventeen: "\u0B67\u0B6D",
    eighteen: "\u0B67\u0B6E",
    nineteen: "\u0B67\u0B6F",
    twenty: "\u0B68\u0B66",
    twenty_one: "\u0B68\u0B67",
    twenty_two: "\u0B68\u0B68",
    twenty_three: "\u0B68\u0B69",
    twenty_four: "\u0B68\u0B6A",
    twenty_five: "\u0B68\u0B6B",
    twenty_six: "\u0B68\u0B6C",
    twenty_seven: "\u0B68\u0B6D",
    twenty_eight: "\u0B68\u0B6E",
    twenty_nine: "\u0B68\u0B6F",
    thirty: "\u0B69\u0B66",
    thirty_one: "\u0B69\u0B67"
};
const $5c2cbe2b2431bcd1$var$monthDatesData = {
    English: $5c2cbe2b2431bcd1$var$English$4,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$4,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$4,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$4,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$4,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$4,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$4,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$4,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$4,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$4,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$4,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$4
};
const $5c2cbe2b2431bcd1$var$English$3 = {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
};
const $5c2cbe2b2431bcd1$var$Hindi$3 = {
    January: "\u091C\u0928\u0935\u0930\u0940",
    February: "\u092B\u0930\u0935\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u0905\u092A\u094D\u0930\u0948\u0932",
    May: "\u092E\u0908",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u093E\u0908",
    August: "\u0905\u0917\u0938\u094D\u0924",
    September: "\u0938\u093F\u0924\u0902\u092C\u0930",
    October: "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
    November: "\u0928\u0935\u0902\u092C\u0930",
    December: "\u0926\u093F\u0938\u0902\u092C\u0930"
};
const $5c2cbe2b2431bcd1$var$Marathi$3 = {
    January: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940",
    February: "\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u090F\u092A\u094D\u0930\u093F\u0932",
    May: "\u092E\u0947",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u0948",
    August: "\u0911\u0917\u0938\u094D\u091F",
    September: "\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930",
    October: "\u0911\u0915\u094D\u091F\u094B\u092C\u0930",
    November: "\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930",
    December: "\u0921\u093F\u0938\u0947\u0902\u092C\u0930"
};
const $5c2cbe2b2431bcd1$var$Gujarati$3 = {
    January: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
    February: "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
    March: "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
    April: "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
    May: "\u0AAE\u0AC7",
    June: "\u0A9C\u0AC2\u0AA8",
    July: "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
    August: "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
    September: "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    October: "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
    November: "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    December: "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
};
const $5c2cbe2b2431bcd1$var$Punjabi$3 = {
    January: "\u0A1C\u0A28\u0A35\u0A30\u0A40",
    February: "\u0A2B\u0A30\u0A35\u0A30\u0A40",
    March: "\u0A2E\u0A3E\u0A30\u0A1A",
    April: "\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32",
    May: "\u0A2E\u0A08",
    June: "\u0A1C\u0A42\u0A28",
    July: "\u0A1C\u0A41\u0A32\u0A3E\u0A08",
    August: "\u0A05\u0A17\u0A38\u0A24",
    September: "\u0A38\u0A24\u0A70\u0A2C\u0A30",
    October: "\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30",
    November: "\u0A28\u0A35\u0A70\u0A2C\u0A30",
    December: "\u0A26\u0A38\u0A70\u0A2C\u0A30"
};
const $5c2cbe2b2431bcd1$var$Bengali$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    February: "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    March: "\u09AE\u09BE\u09B0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0985\u0997\u09BE\u09B8\u09CD\u099F",
    September: "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
    November: "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
    December: "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
};
const $5c2cbe2b2431bcd1$var$Tamil$3 = {
    January: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
    February: "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
    March: "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
    April: "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
    May: "\u0BAE\u0BC7",
    June: "\u0B9C\u0BC2\u0BA9\u0BCD",
    July: "\u0B9C\u0BC2\u0BB2\u0BC8",
    August: "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BC1",
    September: "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    October: "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
    November: "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    December: "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
};
const $5c2cbe2b2431bcd1$var$Telugu$3 = {
    January: "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
    February: "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
    March: "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
    April: "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
    May: "\u0C2E\u0C47",
    June: "\u0C1C\u0C42\u0C28\u0C4D",
    July: "\u0C1C\u0C41\u0C32\u0C48",
    August: "\u0C06\u0C17\u0C37\u0C4D\u0C1F\u0C41",
    September: "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
    October: "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
    November: "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
    December: "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
};
const $5c2cbe2b2431bcd1$var$Kannada$3 = {
    January: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
    February: "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
    March: "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
    April: "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
    May: "\u0CAE\u0CC7",
    June: "\u0C9C\u0CC2\u0CA8\u0CCD",
    July: "\u0C9C\u0CC1\u0CB2\u0CC8",
    August: "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
    September: "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    October: "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
    November: "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    December: "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
};
const $5c2cbe2b2431bcd1$var$Assamese$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09F1\u09BE\u09F0\u09C0",
    February: "\u09AB\u09C7\u09AC\u09CD\u09F0\u09C1\u09F1\u09BE\u09F0\u09C0",
    March: "\u09AE\u09BE\u09F0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09F0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0986\u0997\u09B7\u09CD\u099F",
    September: "\u099B\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09F0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09F0",
    November: "\u09A8\u09F1\u09C7\u09AE\u09CD\u09AC\u09F0",
    December: "\u09A1\u09BF\u099A\u09C7\u09AE\u09CD\u09AC\u09F0"
};
const $5c2cbe2b2431bcd1$var$Malayalam$3 = {
    January: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F",
    February: "\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F",
    March: "\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D",
    April: "\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D",
    May: "\u0D2E\u0D47\u0D2F\u0D4D",
    June: "\u0D1C\u0D42\u0D7A",
    July: "\u0D1C\u0D42\u0D32\u0D48",
    August: "\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D",
    September: "\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C",
    October: "\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C",
    November: "\u0D28\u0D35\u0D02\u0D2C\u0D7C",
    December: "\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C"
};
const $5c2cbe2b2431bcd1$var$Oriya$3 = {
    January: "\u0B1C\u0B3E\u0B28\u0B41\u0B06\u0B30\u0B40",
    February: "\u0B2B\u0B47\u0B2C\u0B43\u0B5F\u0B3E\u0B30\u0B40",
    March: "\u0B2E\u0B3E\u0B30\u0B4D\u0B1A\u0B4D",
    April: "\u0B0F\u0B2A\u0B4D\u0B30\u0B3F\u0B32",
    May: "\u0B2E\u0B47",
    June: "\u0B1C\u0B41\u0B28",
    July: "\u0B1C\u0B41\u0B32\u0B3E\u0B07",
    August: "\u0B05\u0B17\u0B37\u0B4D\u0B1F",
    September: "\u0B38\u0B47\u0B2A\u0B4D\u0B1F\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    October: "\u0B05\u0B15\u0B4D\u0B1F\u0B4B\u0B2C\u0B30",
    November: "\u0B28\u0B2D\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    December: "\u0B21\u0B3F\u0B38\u0B47\u0B2E\u0B4D\u0B2C\u0B30"
};
const $5c2cbe2b2431bcd1$var$monthNamesData = {
    English: $5c2cbe2b2431bcd1$var$English$3,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$3,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$3,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$3,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$3,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$3,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$3,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$3,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$3,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$3,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$3,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$3
};
const $5c2cbe2b2431bcd1$var$English$2 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9"
};
const $5c2cbe2b2431bcd1$var$Hindi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $5c2cbe2b2431bcd1$var$Marathi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $5c2cbe2b2431bcd1$var$Gujarati$2 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF"
};
const $5c2cbe2b2431bcd1$var$Punjabi$2 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F"
};
const $5c2cbe2b2431bcd1$var$Bengali$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $5c2cbe2b2431bcd1$var$Tamil$2 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF"
};
const $5c2cbe2b2431bcd1$var$Telugu$2 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F"
};
const $5c2cbe2b2431bcd1$var$Kannada$2 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF"
};
const $5c2cbe2b2431bcd1$var$Assamese$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $5c2cbe2b2431bcd1$var$Malayalam$2 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F"
};
const $5c2cbe2b2431bcd1$var$Oriya$2 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F"
};
const $5c2cbe2b2431bcd1$var$numberData = {
    English: $5c2cbe2b2431bcd1$var$English$2,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$2,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$2,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$2,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$2,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$2,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$2,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$2,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$2,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$2,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$2,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$2
};
const $5c2cbe2b2431bcd1$var$English$1 = {
    Sunday: "S",
    Monday: "M",
    Tuesday: "T",
    Wednesday: "W",
    Thursday: "T",
    Friday: "F",
    Saturday: "S"
};
const $5c2cbe2b2431bcd1$var$Hindi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $5c2cbe2b2431bcd1$var$Marathi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $5c2cbe2b2431bcd1$var$Gujarati$1 = {
    Sunday: "\u0AB0",
    Monday: "\u0AB8\u0ACB",
    Tuesday: "\u0AAE\u0A82",
    Wednesday: "\u0AAC\u0AC1",
    Thursday: "\u0A97\u0AC1",
    Friday: "\u0AB6\u0AC1",
    Saturday: "\u0AB6"
};
const $5c2cbe2b2431bcd1$var$Punjabi$1 = {
    Sunday: "\u0A10",
    Monday: "\u0A38\u0A4B",
    Tuesday: "\u0A2E\u0A70",
    Wednesday: "\u0A2C\u0A41",
    Thursday: "\u0A35\u0A40",
    Friday: "\u0A36\u0A41",
    Saturday: "\u0A38\u0A3C"
};
const $5c2cbe2b2431bcd1$var$Bengali$1 = {
    Sunday: "\u09B0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $5c2cbe2b2431bcd1$var$Tamil$1 = {
    Sunday: "\u0B9E\u0BBE",
    Monday: "\u0BA4\u0BBF",
    Tuesday: "\u0B9A\u0BC6",
    Wednesday: "\u0BAA\u0BC1",
    Thursday: "\u0BB5\u0BBF",
    Friday: "\u0BB5\u0BC6",
    Saturday: "\u0B9A"
};
const $5c2cbe2b2431bcd1$var$Telugu$1 = {
    Sunday: "\u0C06",
    Monday: "\u0C38\u0C4B",
    Tuesday: "\u0C2E\u0C02",
    Wednesday: "\u0C2C\u0C41",
    Thursday: "\u0C17\u0C41",
    Friday: "\u0C36\u0C41",
    Saturday: "\u0C36"
};
const $5c2cbe2b2431bcd1$var$Kannada$1 = {
    Sunday: "\u0CAD\u0CBE",
    Monday: "\u0CB8\u0CCB",
    Tuesday: "\u0CAE\u0C82",
    Wednesday: "\u0CAC\u0CC1",
    Thursday: "\u0C97\u0CC1",
    Friday: "\u0CB6\u0CC1",
    Saturday: "\u0CB6"
};
const $5c2cbe2b2431bcd1$var$Assamese$1 = {
    Sunday: "\u09F0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $5c2cbe2b2431bcd1$var$Malayalam$1 = {
    Sunday: "\u0D1E\u0D3E",
    Monday: "\u0D24\u0D3F",
    Tuesday: "\u0D1A\u0D4A",
    Wednesday: "\u0D2C\u0D41",
    Thursday: "\u0D35\u0D4D\u0D2F",
    Friday: "\u0D35\u0D46",
    Saturday: "\u0D36"
};
const $5c2cbe2b2431bcd1$var$Oriya$1 = {
    Sunday: "\u0B30",
    Monday: "\u0B38\u0B4B",
    Tuesday: "\u0B2E\u0B02",
    Wednesday: "\u0B2C\u0B41",
    Thursday: "\u0B2C\u0B3F",
    Friday: "\u0B36\u0B41",
    Saturday: "\u0B36"
};
const $5c2cbe2b2431bcd1$var$weekdayInitialsData = {
    English: $5c2cbe2b2431bcd1$var$English$1,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi$1,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi$1,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati$1,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi$1,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali$1,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil$1,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu$1,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada$1,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese$1,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam$1,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya$1
};
const $5c2cbe2b2431bcd1$var$English = {
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday"
};
const $5c2cbe2b2431bcd1$var$Hindi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $5c2cbe2b2431bcd1$var$Marathi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0933\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $5c2cbe2b2431bcd1$var$Gujarati = {
    Sunday: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0",
    Monday: "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0",
    Tuesday: "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0",
    Wednesday: "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0",
    Thursday: "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0",
    Friday: "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0",
    Saturday: "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"
};
const $5c2cbe2b2431bcd1$var$Punjabi = {
    Sunday: "\u0A10\u0A24\u0A35\u0A3E\u0A30",
    Monday: "\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30",
    Tuesday: "\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30",
    Wednesday: "\u0A2C\u0A41\u0A71\u0A27\u0A35\u0A3E\u0A30",
    Thursday: "\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30",
    Friday: "\u0A36\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30",
    Saturday: "\u0A38\u0A3C\u0A28\u0A3F\u0A35\u0A3E\u0A30"
};
const $5c2cbe2b2431bcd1$var$Bengali = {
    Sunday: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
};
const $5c2cbe2b2431bcd1$var$Tamil = {
    Sunday: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
    Monday: "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
    Tuesday: "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
    Wednesday: "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
    Thursday: "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
    Friday: "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
    Saturday: "\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8"
};
const $5c2cbe2b2431bcd1$var$Telugu = {
    Sunday: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
    Monday: "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
    Tuesday: "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
    Wednesday: "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
    Thursday: "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
    Friday: "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
    Saturday: "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
};
const $5c2cbe2b2431bcd1$var$Kannada = {
    Sunday: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
    Monday: "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
    Tuesday: "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
    Wednesday: "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
    Thursday: "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
    Friday: "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
    Saturday: "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
};
const $5c2cbe2b2431bcd1$var$Assamese = {
    Sunday: "\u09AD\u09BE\u09A8\u09C1\u09F1\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09F0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09F0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09F0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09F0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09F0\u09AC\u09BE\u09F0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09F0"
};
const $5c2cbe2b2431bcd1$var$Malayalam = {
    Sunday: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A",
    Monday: "\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A",
    Tuesday: "\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A",
    Wednesday: "\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A",
    Thursday: "\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A",
    Friday: "\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A",
    Saturday: "\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A"
};
const $5c2cbe2b2431bcd1$var$Oriya = {
    Sunday: "\u0B30\u0B2C\u0B3F\u0B2C\u0B3E\u0B30",
    Monday: "\u0B38\u0B4B\u0B2E\u0B2C\u0B3E\u0B30",
    Tuesday: "\u0B2E\u0B19\u0B4D\u0B17\u0B33\u0B2C\u0B3E\u0B30",
    Wednesday: "\u0B2C\u0B41\u0B27\u0B2C\u0B3E\u0B30",
    Thursday: "\u0B2C\u0B43\u0B39\u0B38\u0B4D\u0B2A\u0B24\u0B3F\u0B2C\u0B3E\u0B30",
    Friday: "\u0B36\u0B41\u0B15\u0B4D\u0B30\u0B2C\u0B3E\u0B30",
    Saturday: "\u0B36\u0B28\u0B3F\u0B2C\u0B3E\u0B30"
};
const $5c2cbe2b2431bcd1$var$weekdayNamesData = {
    English: $5c2cbe2b2431bcd1$var$English,
    Hindi: $5c2cbe2b2431bcd1$var$Hindi,
    Marathi: $5c2cbe2b2431bcd1$var$Marathi,
    Gujarati: $5c2cbe2b2431bcd1$var$Gujarati,
    Punjabi: $5c2cbe2b2431bcd1$var$Punjabi,
    Bengali: $5c2cbe2b2431bcd1$var$Bengali,
    Tamil: $5c2cbe2b2431bcd1$var$Tamil,
    Telugu: $5c2cbe2b2431bcd1$var$Telugu,
    Kannada: $5c2cbe2b2431bcd1$var$Kannada,
    Assamese: $5c2cbe2b2431bcd1$var$Assamese,
    Malayalam: $5c2cbe2b2431bcd1$var$Malayalam,
    Oriya: $5c2cbe2b2431bcd1$var$Oriya
};
const $5c2cbe2b2431bcd1$var$LOCALE_LANGUAGE_MAP = $5c2cbe2b2431bcd1$var$localeLanguageData;
const $5c2cbe2b2431bcd1$var$MONTH_DATES = $5c2cbe2b2431bcd1$var$monthDatesData;
const $5c2cbe2b2431bcd1$var$NUMBERS = $5c2cbe2b2431bcd1$var$numberData;
const $5c2cbe2b2431bcd1$var$WEEKDAY_INITIALS = $5c2cbe2b2431bcd1$var$weekdayInitialsData;
const $5c2cbe2b2431bcd1$var$WEEKDAY_NAMES = $5c2cbe2b2431bcd1$var$weekdayNamesData;
const $5c2cbe2b2431bcd1$var$MONTH_NAMES = $5c2cbe2b2431bcd1$var$monthNamesData;
const $5c2cbe2b2431bcd1$var$CONFIRM_BUTTON = $5c2cbe2b2431bcd1$var$confirmButtonData;
const $5c2cbe2b2431bcd1$var$OF = $5c2cbe2b2431bcd1$var$ofData;
const $5c2cbe2b2431bcd1$var$weekdayKeys = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $5c2cbe2b2431bcd1$var$monthKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $5c2cbe2b2431bcd1$var$monthDateKeys = [
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty",
    "twenty_one",
    "twenty_two",
    "twenty_three",
    "twenty_four",
    "twenty_five",
    "twenty_six",
    "twenty_seven",
    "twenty_eight",
    "twenty_nine",
    "thirty",
    "thirty_one"
];
const $5c2cbe2b2431bcd1$var$numberKeys = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine"
];
function $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale) {
    return $5c2cbe2b2431bcd1$var$LOCALE_LANGUAGE_MAP[locale];
}
function $5c2cbe2b2431bcd1$export$4ee93fd31f185549(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const dates = $5c2cbe2b2431bcd1$var$MONTH_DATES[language];
    return $5c2cbe2b2431bcd1$var$monthDateKeys.map((key)=>dates[key]);
}
function $5c2cbe2b2431bcd1$export$cae41416faa27367(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const names = $5c2cbe2b2431bcd1$var$MONTH_NAMES[language];
    return $5c2cbe2b2431bcd1$var$monthKeys.map((key)=>names[key]);
}
function $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const numbers = $5c2cbe2b2431bcd1$var$NUMBERS[language];
    return $5c2cbe2b2431bcd1$var$numberKeys.map((key)=>numbers[key]);
}
function $5c2cbe2b2431bcd1$export$3d12634d88530fee(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const initials = $5c2cbe2b2431bcd1$var$WEEKDAY_INITIALS[language];
    return $5c2cbe2b2431bcd1$var$weekdayKeys.map((key)=>initials[key]);
}
function $5c2cbe2b2431bcd1$export$bd4a8430f86abf7b(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const names = $5c2cbe2b2431bcd1$var$WEEKDAY_NAMES[language];
    return $5c2cbe2b2431bcd1$var$weekdayKeys.map((key)=>names[key]);
}
function $5c2cbe2b2431bcd1$export$6d8d0ec03e692fdc(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const labelObj = $5c2cbe2b2431bcd1$var$CONFIRM_BUTTON[language];
    return Object.values(labelObj)[0];
}
function $5c2cbe2b2431bcd1$export$fb5267b92d6c6cd3(locale = "en") {
    const language = $5c2cbe2b2431bcd1$export$e085862dfb8d71(locale);
    const ofObj = $5c2cbe2b2431bcd1$var$OF[language];
    return Object.values(ofObj)[0];
}
const $5c2cbe2b2431bcd1$export$8793edee2d425525 = ()=>{};
const $5c2cbe2b2431bcd1$export$b806f3e5b648e4a8 = (cb, deps = [])=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};



var $acw62 = parcelRequire("acw62");
const $fe5170bdd3625759$var$sdl$2c = {
    "metadata": {
        "version": "1.0.0",
        "id": "icon-1.0.0",
        "name": "JDSIcon",
        "layerName": "jds_icon"
    },
    "hierarchy": {
        "container": [
            "icon",
            "lottie"
        ]
    },
    "base": {
        "container": {
            "background-color": "{icon_0}",
            "border-radius": "{icon_1}",
            "size": "{icon_2}",
            "justify-content": "{icon_3}",
            "align-items": "{icon_4}"
        },
        "icon": {
            "size": "{icon_5}",
            "color": "{icon_6}"
        },
        "lottie": {
            "hidden": true,
            "size": "{icon_5}",
            "repeat": true
        }
    },
    "variant": {
        "kind": {
            "background": {},
            "background_bold": {},
            "inverse": {}
        },
        "color": {
            "primary_50": {
                "icon": {
                    "color": "{icon_7}"
                }
            },
            "primary_30": {
                "icon": {
                    "color": "{icon_8}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{icon_9}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{icon_10}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{icon_11}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{icon_12}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{icon_13}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{icon_14}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{icon_15}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{icon_16}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{icon_17}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{icon_18}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{icon_19}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{icon_17}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{icon_18}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{icon_19}"
                }
            },
            "white": {
                "icon": {
                    "color": "{icon_20}"
                }
            },
            "none": {
                "icon": {
                    "color": ""
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "size": "{icon_21}"
                },
                "icon": {
                    "size": "{icon_22}"
                },
                "lottie": {
                    "size": "{icon_22}"
                }
            },
            "large": {
                "container": {
                    "size": "{icon_23}"
                },
                "icon": {
                    "size": "{icon_24}"
                },
                "lottie": {
                    "size": "{icon_24}"
                }
            },
            "xtra-large": {
                "container": {
                    "size": "{icon_25}"
                },
                "icon": {
                    "size": "{icon_26}"
                },
                "lottie": {
                    "size": "{icon_26}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "size": "{icon_27}"
                },
                "icon": {
                    "size": "{icon_28}"
                },
                "lottie": {
                    "size": "{icon_28}"
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "background": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_31}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_32}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_33}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_34}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_35}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_36}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_37}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_38}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_39}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_40}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_41}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_42}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_43}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_44}"
                    }
                }
            },
            "background_bold": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_45}"
                    },
                    "icon": {
                        "color": "{icon_46}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_47}"
                    },
                    "icon": {
                        "color": "{icon_48}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_49}"
                    },
                    "icon": {
                        "color": "{icon_50}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_51}"
                    },
                    "icon": {
                        "color": "{icon_52}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_53}"
                    },
                    "icon": {
                        "color": "{icon_54}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_55}"
                    },
                    "icon": {
                        "color": "{icon_56}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_57}"
                    },
                    "icon": {
                        "color": "{icon_58}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_59}"
                    },
                    "icon": {
                        "color": "{icon_60}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_61}"
                    },
                    "icon": {
                        "color": "{icon_62}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_63}"
                    },
                    "icon": {
                        "color": "{icon_64}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_65}"
                    },
                    "icon": {
                        "color": "{icon_66}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_67}"
                    },
                    "icon": {
                        "color": "{icon_68}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_69}"
                    },
                    "icon": {
                        "color": "{icon_70}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_71}"
                    },
                    "icon": {
                        "color": "{icon_72}"
                    }
                }
            },
            "inverse": {
                "primary_50": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_30": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_70": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_background": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "secondary_50": {
                    "icon": {
                        "color": "{icon_171}"
                    }
                },
                "sparkle_50": {
                    "icon": {
                        "color": "{icon_172}"
                    }
                },
                "primary_grey_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_80": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_100": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "feedback_success_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_error_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_warning_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                }
            }
        },
        {
            "medium": {
                "background": {
                    "container": {
                        "size": "{icon_73}"
                    },
                    "icon": {
                        "size": "{icon_74}"
                    },
                    "lottie": {
                        "size": "{icon_74}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_112}"
                    },
                    "icon": {
                        "size": "{icon_113}"
                    },
                    "lottie": {
                        "size": "{icon_113}"
                    }
                }
            },
            "small": {
                "background": {
                    "container": {
                        "size": "{icon_75}",
                        "background-color": "{icon_76}"
                    },
                    "icon": {
                        "size": "{icon_77}"
                    },
                    "lottie": {
                        "size": "{icon_77}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_114}"
                    },
                    "icon": {
                        "size": "{icon_115}"
                    },
                    "lottie": {
                        "size": "{icon_115}"
                    }
                }
            },
            "large": {
                "background": {
                    "container": {
                        "size": "{icon_78}"
                    },
                    "icon": {
                        "size": "{icon_79}"
                    },
                    "lottie": {
                        "size": "{icon_79}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_116}"
                    },
                    "icon": {
                        "size": "{icon_117}"
                    },
                    "lottie": {
                        "size": "{icon_117}"
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_80}"
                    },
                    "icon": {
                        "size": "{icon_81}"
                    },
                    "lottie": {
                        "size": "{icon_81}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_118}"
                    },
                    "icon": {
                        "size": "{icon_119}"
                    },
                    "lottie": {
                        "size": "{icon_119}"
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_82}"
                    },
                    "icon": {
                        "size": "{icon_83}"
                    },
                    "lottie": {
                        "size": "{icon_83}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_120}"
                    },
                    "icon": {
                        "size": "{icon_121}"
                    },
                    "lottie": {
                        "size": "{icon_121}"
                    }
                }
            }
        },
        {
            "small": {
                "background_bold": {
                    "primary_50": {
                        "container": {
                            "background-color": "{icon_84}"
                        },
                        "icon": {
                            "color": "{icon_85}"
                        }
                    },
                    "primary_30": {
                        "container": {
                            "background-color": "{icon_86}"
                        },
                        "icon": {
                            "color": "{icon_87}"
                        }
                    },
                    "primary_60": {
                        "container": {
                            "background-color": "{icon_88}"
                        },
                        "icon": {
                            "color": "{icon_89}"
                        }
                    },
                    "primary_70": {
                        "container": {
                            "background-color": "{icon_90}"
                        },
                        "icon": {
                            "color": "{icon_91}"
                        }
                    },
                    "primary_background": {
                        "container": {
                            "background-color": "{icon_92}"
                        },
                        "icon": {
                            "color": "{icon_93}"
                        }
                    },
                    "secondary_50": {
                        "container": {
                            "background-color": "{icon_94}"
                        },
                        "icon": {
                            "color": "{icon_95}"
                        }
                    },
                    "sparkle_50": {
                        "container": {
                            "background-color": "{icon_96}"
                        },
                        "icon": {
                            "color": "{icon_97}"
                        }
                    },
                    "primary_grey_60": {
                        "container": {
                            "background-color": "{icon_98}"
                        },
                        "icon": {
                            "color": "{icon_99}"
                        }
                    },
                    "primary_grey_80": {
                        "container": {
                            "background-color": "{icon_100}"
                        },
                        "icon": {
                            "color": "{icon_101}"
                        }
                    },
                    "primary_grey_100": {
                        "container": {
                            "background-color": "{icon_102}"
                        },
                        "icon": {
                            "color": "{icon_103}"
                        }
                    },
                    "white": {
                        "container": {
                            "background-color": "{icon_104}"
                        },
                        "icon": {
                            "color": "{icon_105}"
                        }
                    },
                    "feedback_success_50": {
                        "container": {
                            "background-color": "{icon_106}"
                        },
                        "icon": {
                            "color": "{icon_107}"
                        }
                    },
                    "feedback_error_50": {
                        "container": {
                            "background-color": "{icon_108}"
                        },
                        "icon": {
                            "color": "{icon_109}"
                        }
                    },
                    "feedback_warning_50": {
                        "container": {
                            "background-color": "{icon_110}"
                        },
                        "icon": {
                            "color": "{icon_111}"
                        }
                    }
                }
            },
            "medium": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_122}"
                        },
                        "icon": {
                            "size": "{icon_125}"
                        },
                        "lottie": {
                            "size": "{icon_125}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_123}"
                        },
                        "icon": {
                            "size": "{icon_126}"
                        },
                        "lottie": {
                            "size": "{icon_126}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_124}"
                        },
                        "icon": {
                            "size": "{icon_127}"
                        },
                        "lottie": {
                            "size": "{icon_127}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_128}"
                        },
                        "icon": {
                            "size": "{icon_131}"
                        },
                        "lottie": {
                            "size": "{icon_131}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_129}"
                        },
                        "icon": {
                            "size": "{icon_132}"
                        },
                        "lottie": {
                            "size": "{icon_132}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_130}"
                        },
                        "icon": {
                            "size": "{icon_133}"
                        },
                        "lottie": {
                            "size": "{icon_133}"
                        }
                    }
                }
            },
            "large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_135}"
                        },
                        "icon": {
                            "size": "{icon_137}"
                        },
                        "lottie": {
                            "size": "{icon_137}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_138}"
                        },
                        "lottie": {
                            "size": "{icon_138}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_139}"
                        },
                        "lottie": {
                            "size": "{icon_139}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_140}"
                        },
                        "icon": {
                            "size": "{icon_143}"
                        },
                        "lottie": {
                            "size": "{icon_143}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_141}"
                        },
                        "icon": {
                            "size": "{icon_144}"
                        },
                        "lottie": {
                            "size": "{icon_144}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_142}"
                        },
                        "icon": {
                            "size": "{icon_145}"
                        },
                        "lottie": {
                            "size": "{icon_145}"
                        }
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_146}"
                        },
                        "icon": {
                            "size": "{icon_149}"
                        },
                        "lottie": {
                            "size": "{icon_149}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_147}"
                        },
                        "icon": {
                            "size": "{icon_150}"
                        },
                        "lottie": {
                            "size": "{icon_150}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_148}"
                        },
                        "icon": {
                            "size": "{icon_151}"
                        },
                        "lottie": {
                            "size": "{icon_151}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_152}"
                        },
                        "icon": {
                            "size": "{icon_155}"
                        },
                        "lottie": {
                            "size": "{icon_155}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_153}"
                        },
                        "icon": {
                            "size": "{icon_156}"
                        },
                        "lottie": {
                            "size": "{icon_156}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_154}"
                        },
                        "icon": {
                            "size": "{icon_157}"
                        },
                        "lottie": {
                            "size": "{icon_157}"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_158}"
                        },
                        "icon": {
                            "size": "{icon_161}"
                        },
                        "lottie": {
                            "size": "{icon_161}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_159}"
                        },
                        "icon": {
                            "size": "{icon_162}"
                        },
                        "lottie": {
                            "size": "{icon_162}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_160}"
                        },
                        "icon": {
                            "size": "{icon_163}"
                        },
                        "lottie": {
                            "size": "{icon_163}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_164}"
                        },
                        "icon": {
                            "size": "{icon_167}"
                        },
                        "lottie": {
                            "size": "{icon_167}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_165}"
                        },
                        "icon": {
                            "size": "{icon_168}"
                        },
                        "lottie": {
                            "size": "{icon_168}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_166}"
                        },
                        "icon": {
                            "size": "{icon_169}"
                        },
                        "lottie": {
                            "size": "{icon_169}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "color"
        ],
        [
            "size",
            "kind"
        ],
        [
            "size",
            "kind",
            "color"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "It can be used to control size of icon. Please note that the actual size of the icon inside will vary based on the `kind` selected."
            },
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "background",
                    "background_bold",
                    "inverse"
                ],
                "doc_description": "It can be used to switch between 3 variants of Icon. 'background-bold' sets color prop as bg, Icon color is inverse of that."
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "size": {
                    "type": "size",
                    "name": "customSize",
                    "function": true
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "required": false
                },
                "size": {
                    "type": "size",
                    "name": "_size",
                    "function": true
                }
            },
            "lottie": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$2b = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-1.0.0",
        "name": "JDSAccordion",
        "layerName": "jds_accordion",
        "description": "An accordion is a list of headers that hide or reveal additional content when expanded.",
        "usage": "Accordion is used when users only need a few specific pieces of content within a page."
    },
    "hierarchy": {
        "container": [
            {
                "accordion-header-container": [
                    "prefix-slot",
                    {
                        "text-container": [
                            "title-jds-text",
                            "subtitle-jds-text"
                        ]
                    },
                    "jds_button"
                ]
            },
            {
                "children-container": [
                    {
                        "child-content-container": [
                            "content-slot"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{a_0}",
            "opacity": "{a_15}",
            "width": "{a_1}"
        },
        "accordion-header-container": {
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "width": "{a_5}",
            "padding-top": "{a_6}",
            "gap": "{a_7}"
        },
        "text-container": {
            "flex-direction": "{a_8}",
            "justify-content": "{a_9}",
            "align-items": "{a_10}",
            "gap": "{a_11}",
            "flex": 1
        },
        "jds_button": {
            "icon": "ic_add",
            "kind": "tertiary",
            "size": "medium",
            "state": "normal"
        },
        "children-container": {
            "hidden": true,
            "padding-top": "{a_12}",
            "width": "{a_13}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "child-content-container": {
            "width": "{a_14}"
        },
        "jds_divider": {
            "orientation": "horizontal",
            "pad": "xtra-xtra-small",
            "padPosition": "top"
        },
        "title-jds-text": {
            "font-family": "{listTitle}",
            "color": "{primaryGrey100}",
            "font-size": "{listTitle}",
            "line-height": "{listTitle}",
            "letter-spacing": "{listTitle}",
            "font-weight": "{listTitle}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_17}"
                },
                "accordion-header-container": {
                    "disabled": true
                },
                "jds_button": {
                    "disabled": true
                }
            }
        },
        "expandedPanel": {
            "true": {
                "children-container": {
                    "hidden": false,
                    "padding-top": "{a_16}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "plus": {
                "true": {
                    "jds_button": {
                        "icon": "{a_18}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_19}"
                    }
                }
            },
            "chevron": {
                "true": {
                    "jds_button": {
                        "icon": "{a_20}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "iconType",
            "expandedPanel"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "It can be used to display content as children of Accordion."
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1,
                "doc_description": "It can be used to display `avatar` or `icon` to the left of text."
            }
        },
        "config": {
            "expandedPanel": {
                "values": [
                    false,
                    true
                ],
                "doc-description": "If false/undefined, only allows one accordionPanel to be expanded by collapsing others on each click."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Accordion."
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            },
            "iconType": {
                "values": [
                    "chevron",
                    "plus"
                ],
                "doc_description": "The icon to be displayed. The plus icon changes to a minus icon when the corresponding panel is expanded."
            }
        },
        "data": {
            "children-container": {
                "max-height": {
                    "name": "_childrenHeight",
                    "type": "size"
                }
            },
            "title-jds-text": {
                "value": {
                    "name": "title",
                    "type": "string",
                    "doc_description": "This displays the title of Accordion."
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "name": "subtitle",
                    "type": "string",
                    "doc_description": "This displays the subtitle of Accordion."
                }
            }
        },
        "events": {
            "accordion-header-container": {
                "onClick": "onClick"
            },
            "jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "accordion-header-container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            },
            "jds_button": {
                "properties": {
                    "ariaExpanded": {
                        "name": "_ariaExpanded",
                        "prop": "expandedPanel"
                    },
                    "ariaControls": {
                        "name": "_ariaControls"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
const $fe5170bdd3625759$var$modifyProps = (props, map)=>{
    if (!props) return {};
    if (!map) return props;
    let finalProps = {
        ...props
    };
    const modifedProps = map(props);
    Object.entries(modifedProps).forEach(([key, obj])=>{
        const { properties: properties, variations: variations, defaultValue: defaultValue } = obj;
        const currentValue = props[key];
        if (typeof currentValue !== "undefined") {
            if (Object.keys(properties || {}).length) finalProps = {
                ...finalProps,
                ...properties
            };
            if (variations?.[currentValue]) finalProps = {
                ...finalProps,
                ...variations?.[currentValue]
            };
        } else if (defaultValue) finalProps = {
            ...finalProps,
            ...variations?.[defaultValue]
        };
    });
    return finalProps;
};
const $fe5170bdd3625759$var$withModifiedProps = (Component, map)=>(props)=>{
        if (!map) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
        Component.displayName = $fe5170bdd3625759$var$getDisplayName(Component);
        const finalProps = $fe5170bdd3625759$var$modifyProps(props, map);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...finalProps
        });
    };
const $fe5170bdd3625759$var$get = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $fe5170bdd3625759$var$debounce = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $fe5170bdd3625759$var$convertTextToComponent = (children)=>{
    if (typeof children === "string" && children.length) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
        text: children
    });
    return children || null;
};
const $fe5170bdd3625759$var$resolvePropObjectKeys = (prop, objPath, defValue)=>{
    if (!prop) return void 0;
    if (typeof prop === "string") return prop;
    return $fe5170bdd3625759$var$get(prop, objPath, defValue);
};
const $fe5170bdd3625759$var$useRootRef = (cb, deps = [])=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};
const $fe5170bdd3625759$var$PROP_MAP$v = (props)=>{
    return {
        header: {
            properties: {
                title: props.title || props.header?.title || props.header?.titleBlock?.text || props.header,
                subtitle: props.subtitle || props.header?.titleBlock?.helper,
                prefix: props.prefix || props.header?.prefix
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$2f = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$v);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const childContainer = element?.querySelector('div[data-testid="JDSAccordion-child-content-container"]');
        const [childrenHeight, setChildrenHeight] = (0, $acw62.useState)(0);
        (0, $acw62.useEffect)(()=>{
            if (!childContainer || !props.expandedPanel) return;
            const updateHeight = ()=>{
                requestAnimationFrame(()=>{
                    setChildrenHeight(childContainer.offsetHeight + 16);
                });
            };
            updateHeight();
            const resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(childContainer);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            childContainer,
            props.expandedPanel,
            props.children
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _ariaControls: "children-container",
                _childrenHeight: props.expandedPanel ? childrenHeight : 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$2g = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2b;
    const { expandedPanel: expandedPanel = false, disabled: disabled = false, showDivider: showDivider = true, iconType: iconType = "chevron", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), _ariaExpanded: _ariaExpanded = props.expandedPanel?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            expandedPanel: expandedPanel,
            disabled: disabled,
            showDivider: showDivider,
            iconType: iconType,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordion", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7cad6f17fd6e117b = $fe5170bdd3625759$var$withLogic$2f($fe5170bdd3625759$var$Component$2g);
$fe5170bdd3625759$export$7cad6f17fd6e117b.displayName = "AccordionPanel";
$fe5170bdd3625759$export$7cad6f17fd6e117b.slotName = "jds_accordion";
const $fe5170bdd3625759$var$sdl$2a = {
    "metadata": {
        "version": "1.0.0",
        "id": "action-button-1.0.0",
        "name": "JDSActionButton",
        "layerName": "jds_action_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "left-icon",
                    "jds-text",
                    "right-icon"
                ]
            },
            "loader"
        ]
    },
    "base": {
        "container": {
            "background-color": "{a_0}",
            "opacity": "{a_1}",
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "border-radius": "{a_5}"
        },
        "inner-container": {
            "opacity": "{a_64}",
            "border-width": "{a_24}",
            "background-color": "{a_6}",
            "flex-direction": "{a_7}",
            "align-items": "{a_8}",
            "justify-content": "{a_9}",
            "border-radius": "{a_10}",
            "padding-top": "{a_11}",
            "padding-right": "{a_12}",
            "padding-bottom": "{a_13}",
            "padding-left": "{a_14}",
            "gap": "{a_15}",
            "transition": {
                "property": [
                    "background-color",
                    "border-width",
                    "border-color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "background-color": "{a_16}"
                },
                "active": {
                    "background-color": "{a_17}"
                },
                "focus": {
                    "border-width": "{a_18}",
                    "border-color": "{a_19}"
                }
            }
        },
        "loader": {
            "hidden": true,
            "color": "{a_20}",
            "background-color": "{a_21}",
            "track-color": "{a_22}",
            "border-width": "{a_23}",
            "opacity": "{a_25}",
            "size": "{a_26}",
            "z-index": 1
        },
        "left-icon": {
            "size": "{a_27}",
            "color": "{a_28}",
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_29}"
                },
                "active": {
                    "color": "{a_30}"
                }
            }
        },
        "right-icon": {
            "size": "{a_31}",
            "color": "{a_32}",
            "hidden": true,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_33}"
                },
                "active": {
                    "color": "{a_34}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2,
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{primary70}",
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                },
                "active": {
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "inner-container": {
                    "padding-top": "{a_35}",
                    "padding-right": "{a_36}",
                    "padding-bottom": "{a_37}",
                    "padding-left": "{a_38}",
                    "gap": "{a_39}"
                },
                "left-icon": {
                    "size": "{a_40}"
                },
                "right-icon": {
                    "size": "{a_41}"
                },
                "loader": {
                    "size": "{a_42}"
                }
            },
            "large": {
                "inner-container": {
                    "padding-top": "{a_43}",
                    "padding-left": "{a_44}",
                    "padding-bottom": "{a_45}",
                    "padding-right": "{a_46}",
                    "gap": "{a_47}"
                },
                "left-icon": {
                    "size": "{a_48}"
                },
                "right-icon": {
                    "size": "{a_49}"
                },
                "loader": {
                    "size": "{a_50}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "extra-large": {
                "inner-container": {
                    "padding-top": "{a_51}",
                    "padding-right": "{a_52}",
                    "padding-bottom": "{a_53}",
                    "padding-left": "{a_54}",
                    "gap": "{a_55}"
                },
                "left-icon": {
                    "size": "{a_56}"
                },
                "right-icon": {
                    "size": "{a_57}"
                },
                "loader": {
                    "size": "{a_58}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "iconPosition": {
            "right": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": false
                }
            }
        },
        "state": {
            "loading": {
                "inner-container": {
                    "disabled": true,
                    "opacity": "{a_59}"
                },
                "left-icon": {
                    "opacity": "{a_60}"
                },
                "right-icon": {
                    "opacity": "{a_61}"
                },
                "loader": {
                    "hidden": false
                },
                "jds-text": {
                    "opacity": "{a_62}"
                }
            },
            "disabled": {
                "inner-container": {
                    "opacity": "{a_63}",
                    "disabled": true
                }
            }
        },
        "_hasIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_65}",
                        "border-width": "{a_66}",
                        "border-color": "{a_67}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_68}"
                            },
                            "active": {
                                "background-color": "{a_69}"
                            },
                            "focus": {
                                "border-width": "{a_70}",
                                "border-color": "{a_71}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_72}",
                        "behavior": {
                            "hover": {
                                "color": "{a_73}"
                            },
                            "active": {
                                "color": "{a_74}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_75}",
                        "behavior": {
                            "hover": {
                                "color": "{a_76}"
                            },
                            "active": {
                                "color": "{a_77}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_78}",
                        "padding-right": "{a_79}",
                        "background-color": "{a_82}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_83}"
                            },
                            "active": {
                                "background-color": "{a_84}"
                            },
                            "focus": {
                                "border-width": "{a_85}",
                                "border-radius": "{a_86}",
                                "border-color": "{a_87}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_88}",
                        "behavior": {
                            "hover": {
                                "color": "{a_89}"
                            },
                            "active": {
                                "color": "{a_90}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_91}",
                        "behavior": {
                            "hover": {
                                "color": "{a_92}"
                            },
                            "active": {
                                "color": "{a_93}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {
                                "color": "{primary50}"
                            },
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                }
            },
            "positive": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_94}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_95}"
                            },
                            "active": {
                                "background-color": "{a_96}"
                            },
                            "focus": {
                                "border-color": "{a_97}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_98}",
                        "behavior": {
                            "hover": {
                                "color": "{a_99}"
                            },
                            "active": {
                                "color": "{a_100}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_101}",
                        "behavior": {
                            "hover": {
                                "color": "{a_102}"
                            },
                            "active": {
                                "color": "{a_103}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_104}",
                        "border-width": "{a_105}",
                        "border-color": "{a_106}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_107}"
                            },
                            "active": {
                                "background-color": "{a_108}"
                            },
                            "focus": {
                                "border-color": "{a_109}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_110}",
                        "behavior": {
                            "hover": {
                                "color": "{a_111}"
                            },
                            "active": {
                                "color": "{a_112}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_113}",
                        "behavior": {
                            "hover": {
                                "color": "{a_114}"
                            },
                            "active": {
                                "color": "{a_115}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_80}",
                        "padding-right": "{a_81}",
                        "background-color": "{a_116}",
                        "border-radius": "{a_117}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_118}"
                            },
                            "active": {
                                "background-color": "{a_119}"
                            },
                            "focus": {
                                "border-color": "{a_120}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_121}",
                        "behavior": {
                            "hover": {
                                "color": "{a_122}"
                            },
                            "active": {
                                "color": "{a_123}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_124}",
                        "behavior": {
                            "hover": {
                                "color": "{a_125}"
                            },
                            "active": {
                                "color": "{a_126}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "negative": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_129}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_130}"
                            },
                            "active": {
                                "background-color": "{a_131}"
                            },
                            "focus": {
                                "border-color": "{a_132}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_133}",
                        "behavior": {
                            "hover": {
                                "color": "{a_134}"
                            },
                            "active": {
                                "color": "{a_135}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_136}",
                        "behavior": {
                            "hover": {
                                "color": "{a_137}"
                            },
                            "active": {
                                "color": "{a_138}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_139}",
                        "border-width": "{a_140}",
                        "border-color": "{a_141}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_142}"
                            },
                            "active": {
                                "background-color": "{a_143}"
                            },
                            "focus": {
                                "border-color": "{a_144}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_145}",
                        "behavior": {
                            "hover": {
                                "color": "{a_146}"
                            },
                            "active": {
                                "color": "{a_147}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_148}",
                        "behavior": {
                            "hover": {
                                "color": "{a_149}"
                            },
                            "active": {
                                "color": "{a_150}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_127}",
                        "padding-right": "{a_128}",
                        "background-color": "{a_151}",
                        "border-radius": "{a_152}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_153}"
                            },
                            "active": {
                                "background-color": "{a_154}"
                            },
                            "focus": {
                                "border-color": "{a_155}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_156}",
                        "behavior": {
                            "hover": {
                                "color": "{a_157}"
                            },
                            "active": {
                                "color": "{a_158}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_159}",
                        "behavior": {
                            "hover": {
                                "color": "{a_160}"
                            },
                            "active": {
                                "color": "{a_161}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_164}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_165}"
                            },
                            "active": {
                                "background-color": "{a_166}"
                            },
                            "focus": {
                                "border-color": "{a_167}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_168}",
                        "behavior": {
                            "hover": {
                                "color": "{a_169}"
                            },
                            "active": {
                                "color": "{a_170}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_171}",
                        "behavior": {
                            "hover": {
                                "color": "{a_172}"
                            },
                            "active": {
                                "color": "{a_173}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryGrey100}",
                        "behavior": {
                            "hover": {},
                            "active": {}
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_174}",
                        "border-width": "{a_175}",
                        "border-color": "{a_176}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_177}"
                            },
                            "active": {
                                "background-color": "{a_178}"
                            },
                            "focus": {
                                "border-width": "{a_179}",
                                "border-color": "{a_180}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_181}",
                        "behavior": {
                            "hover": {
                                "color": "{a_182}"
                            },
                            "active": {
                                "color": "{a_183}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_184}",
                        "behavior": {
                            "hover": {
                                "color": "{a_185}"
                            },
                            "active": {
                                "color": "{a_186}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_162}",
                        "padding-right": "{a_163}",
                        "background-color": "{a_187}",
                        "border-radius": "{a_188}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_189}"
                            },
                            "active": {
                                "background-color": "{a_190}"
                            },
                            "focus": {
                                "border-width": "{a_191}",
                                "border-color": "{a_192}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_193}",
                        "behavior": {
                            "hover": {
                                "color": "{a_194}"
                            },
                            "active": {
                                "color": "{a_195}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_196}",
                        "behavior": {
                            "hover": {
                                "color": "{a_197}"
                            },
                            "active": {
                                "color": "{a_198}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "small": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 32,
                        "height": 32
                    },
                    "left-icon": {
                        "size": "{a_199}"
                    },
                    "loader": {
                        "size": "{a_200}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 40,
                        "height": 40
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 48,
                        "height": 48
                    },
                    "left-icon": {
                        "size": "{a_201}"
                    },
                    "loader": {
                        "size": "{a_202}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra-large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 64,
                        "height": 64
                    },
                    "left-icon": {
                        "size": "{a_203}"
                    },
                    "loader": {
                        "size": "{a_204}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{a_205}"
                    },
                    "inner-container": {
                        "width": "{a_206}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "_hasLabel",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of ActionButton which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra-large"
                ],
                "doc_description": "it can be used to control the size of ActionButton."
            },
            "appearance": {
                "values": [
                    "normal",
                    "positive",
                    "negative",
                    "contrast"
                ],
                "doc_description": "It can be used to set the appearance of ActionButton."
            },
            "state": {
                "values": [
                    "normal",
                    "disabled",
                    "loading"
                ],
                "doc_description": "It can be used to change the state of ActionButton."
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to psoition icon."
            },
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to fill the container with ActionButton."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of ActionButton."
                }
            }
        },
        "events": {
            "inner-container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "inner-container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-hidden": "ariaHidden"
                }
            },
            "left-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyKinds = [
    "icon-only",
    "background-bold"
];
const $fe5170bdd3625759$var$legacySizes$4 = [
    "m",
    "s",
    "l",
    "xl",
    "xxl"
];
const $fe5170bdd3625759$var$PROP_MAP$u = (props)=>{
    if ($fe5170bdd3625759$var$legacyKinds.includes(props.kind)) console.warn("these values for the kind prop are deprecated", $fe5170bdd3625759$var$legacyKinds);
    if ($fe5170bdd3625759$var$legacySizes$4.includes(props.size)) console.warn("these values for the size prop are deprecated", $fe5170bdd3625759$var$legacySizes$4);
    return {
        ic: {
            properties: {
                ic: props.ic
            }
        },
        size: {
            defaultValue: "medium",
            variations: {
                m: {
                    size: "medium"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                },
                xxl: {
                    size: "xtra-xtra-large"
                },
                s: {
                    size: "small"
                }
            }
        },
        color: {
            variations: {
                primary: {
                    color: "primary_50"
                },
                secondary: {
                    color: "secondary_50"
                },
                sparkle: {
                    color: "sparkle_50"
                },
                "grey-100": {
                    color: "primary_grey_100"
                },
                "grey-80": {
                    color: "primary_grey_80"
                },
                "grey-60": {
                    color: "primary_grey_60"
                },
                success: {
                    color: "feedback_success"
                },
                error: {
                    color: "feedback_error"
                },
                warning: {
                    color: "feedback_warning"
                }
            }
        },
        kind: {
            defaultValue: "icon-only",
            variations: {
                "icon-only": {
                    kind: "default"
                },
                background: {
                    kind: "background"
                },
                "background-bold": {
                    kind: "background_bold"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$feedbackIcons = {
    feedback_success: "IcSuccessColored",
    feedback_error: "IcErrorColored",
    feedback_warning: "IcWarningColored"
};
const $fe5170bdd3625759$var$formatIconName = (iconName)=>{
    if (typeof iconName === "string" && iconName.startsWith("Ic")) {
        const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
        const words = iconName.slice(3).split("_");
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    }
    return iconName;
};
const $fe5170bdd3625759$var$withLogic$2e = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$u);
        let iconComponent = props.ic;
        if (typeof props.ic === "string") {
            if (props.color && Object.keys($fe5170bdd3625759$var$feedbackIcons).includes(props.color)) iconComponent = $fe5170bdd3625759$var$feedbackIcons[props.color] || props.ic;
        }
        let getCustomSize = props.customSize || void 0;
        if (getCustomSize) {
            const sizeInPx = /^(\d+)(px)?$/.exec(getCustomSize);
            if (sizeInPx) getCustomSize = sizeInPx[1];
            else {
                console.warn("customSize should only be provided in pixels (px) or as a number.");
                getCustomSize = void 0;
            }
            if (Number.parseInt(getCustomSize) > 1080) getCustomSize = "1080";
            else if (Number.parseInt(getCustomSize) < 8) getCustomSize = "8";
        }
        const iconSize = props.kind === "default" ? getCustomSize : getCustomSize !== void 0 ? 2 / 3 * Number.parseInt(getCustomSize) : getCustomSize;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                ariaLabel: props.ariaLabel || $fe5170bdd3625759$var$formatIconName(props.ic),
                _size: iconSize,
                customSize: getCustomSize
            },
            ic: iconComponent
        });
    });
const $fe5170bdd3625759$var$withLogic$2d = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label?.length),
                rootRef: ref,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    });
const $fe5170bdd3625759$var$Component$2f = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2a;
    const { kind: kind = "primary", size: size = "medium", appearance: appearance = "normal", state: state = "normal", iconPosition: iconPosition = "left", stretch: stretch = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            appearance: appearance,
            state: state,
            iconPosition: iconPosition,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSActionButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cfc7921d29ef7b80 = $fe5170bdd3625759$var$withLogic$2d($fe5170bdd3625759$var$Component$2f);
$fe5170bdd3625759$export$cfc7921d29ef7b80.displayName = "ActionButton";
$fe5170bdd3625759$export$cfc7921d29ef7b80.slotName = "jds_action_button";
const $fe5170bdd3625759$var$sdl$29 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar-1.0.0",
        "name": "JDSAvatar",
        "layerName": "jds_avatar",
        "description": "Avatars are used to show a thumbnail representation of an individual or business in the interface.",
        "usage": "Avatars can either be custom images uploaded by users, or default themed images, or automatically populated user initials."
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_17}",
            "width": "{a_0}",
            "height": "{a_1}",
            "display": "flex",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "border-width": "{a_7}",
            "border-color": "{a_8}"
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{sparkle60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}",
            "value": "ic_profile",
            "hidden": false,
            "ic": "ic_profile"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_profile"
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_9}",
                    "height": "{a_10}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{base}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_11}",
                    "height": "{a_12}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{m}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_13}",
                    "height": "{a_14}"
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-large": {
                "container": {
                    "width": 56,
                    "height": 56
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_15}",
                    "height": "{a_16}"
                },
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_18}"
                }
            }
        },
        "isClickable": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "kind": {
            "image": {
                "jds_image": {
                    "hidden": false
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {}
            },
            "initials": {
                "container": {
                    "background-color": "{a_19}"
                },
                "jds_image": {
                    "hidden": true
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "icon": {
                    "container": {
                        "behavior": {
                            "focus": {
                                "border-width": "{a_20}"
                            }
                        }
                    },
                    "jds-icon": {
                        "behavior": {
                            "hover": {
                                "color": "{primary60}"
                            },
                            "focus": {
                                "color": "{primary60}"
                            }
                        }
                    },
                    "jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{l}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "behavior": {
                            "hover": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            },
                            "focus": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            }
                        }
                    }
                },
                "initials": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "background-color": "{a_21}"
                            },
                            "focus": {
                                "border-width": "{a_22}",
                                "background-color": "{a_23}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "color": "{sparkle70}"
                            },
                            "focus": {
                                "color": "{sparkle70}"
                            }
                        }
                    }
                },
                "image": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "opacity": "{a_24}"
                            },
                            "focus": {
                                "border-width": "{a_25}",
                                "opacity": "{a_26}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isClickable",
            "kind"
        ]
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image",
                    "doc_description": "This is a user uploaded image. It will be used, when [kind] is set to image."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true,
                    "doc_description": "This is the two initials of user name. It will be used, when [kind] is set to initials."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "This can be used to control the size of Avatar."
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ],
                "doc_description": "It can be used to switch between 3 variants of Avatar."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Avatar."
            },
            "isClickable": {
                "values": [
                    false,
                    true
                ],
                "platform": "web",
                "doc_description": "It can be used to make Avatar Clickable"
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "role": {
                        "name": "role",
                        "platform": "web"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$3 = [
    "x-small",
    "x-large",
    "xx-large"
];
const $fe5170bdd3625759$var$PROP_MAP$t = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$3.includes(props.size)) console.warn("these sizes are not deprecated. use sizes starting with `xtra`");
    if (typeof props.image === "object") console.warn("Image as an element is deprecated. Pass a string instead");
    return {
        size: {
            properties: {
                size: props.size
            },
            defaultValue: "medium",
            variations: {
                "x-small": {
                    size: "xtra-small"
                },
                small: {
                    size: "small"
                },
                medium: {
                    size: "medium"
                },
                large: {
                    size: "large"
                },
                "x-large": {
                    size: "xtra-large"
                },
                "xx-large": {
                    size: "xtra-xtra-large"
                }
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            defaultValue: "default",
            variations: {
                default: {
                    icon: "ic_profile"
                }
            }
        },
        onClick: {
            properties: {
                onClick: props.onClick
            }
        }
    };
};
const $fe5170bdd3625759$var$extractInitials = (value = "A", size)=>{
    const trimmedValue = value?.trim();
    if (size === "xtra-small") return (trimmedValue[0] || "A").toUpperCase();
    if (trimmedValue.indexOf(" ") >= 0) {
        const strMatch = trimmedValue?.trim().match(/\b(\w)/g) || [
            ""
        ];
        const strJoin = strMatch.join("") || trimmedValue;
        return strJoin.toUpperCase().trim().substring(0, 2);
    }
    return trimmedValue.toUpperCase().trim().substring(0, 2);
};
const $fe5170bdd3625759$var$withLogic$2c = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$t);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            image: typeof props.image === "string" ? props.image : props.image?.props?.src,
            initials: $fe5170bdd3625759$var$extractInitials(props.initials, props.size || "")
        });
    };
const $fe5170bdd3625759$var$Component$2e = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$29;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, isClickable: isClickable = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "avatar", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            isClickable: isClickable,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatar", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e2255cf6045e8d47 = $fe5170bdd3625759$var$withLogic$2c($fe5170bdd3625759$var$Component$2e);
$fe5170bdd3625759$export$e2255cf6045e8d47.displayName = "Avatar";
$fe5170bdd3625759$export$e2255cf6045e8d47.slotName = "jds_avatar";
const $fe5170bdd3625759$var$sdl$28 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-2.0.0",
        "name": "JDSAvatarV2",
        "layerName": "jds_avatar_v2"
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            "jds_avatar_v2_status",
            "jds_avatar_v2_notification",
            "jds_avatar_v2_information",
            "jds_avatar_v2_complete_ring",
            "jds_avatar_v2_segmented_ring",
            "jds_avatar_v2_progress_ring"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "behavior": {
                "focus": {
                    "background-color": "{primary60}",
                    "border-radius": "{pill}",
                    "padding-left": "{xxs}",
                    "padding-right": "{xxs}",
                    "padding-top": "{xxs}",
                    "padding-bottom": "{xxs}"
                }
            }
        },
        "jds_avatar_v2_default": {
            "hidden": false,
            "size": "medium"
        },
        "jds_avatar_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_complete_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_segmented_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_progress_ring": {
            "hidden": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "status": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_status": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_notification": {
                    "hidden": false
                }
            },
            "information": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_information": {
                    "hidden": false
                }
            },
            "complete-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_complete_ring": {
                    "hidden": false
                }
            },
            "segmented-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_segmented_ring": {
                    "hidden": false
                }
            },
            "progress-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_progress_ring": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_avatar_v2_status": {
                    "size": "small"
                },
                "jds_avatar_v2_notification": {
                    "size": "small"
                },
                "jds_avatar_v2_information": {
                    "size": "small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "small"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_avatar_v2_status": {
                    "size": "large"
                },
                "jds_avatar_v2_notification": {
                    "size": "large"
                },
                "jds_avatar_v2_information": {
                    "size": "large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "default",
                    "status",
                    "notification",
                    "information",
                    "complete-ring",
                    "segmented-ring",
                    "progress-ring"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "initials": {
                    "type": "string",
                    "name": "initials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_status": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeStatus": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "statusBadgeStatus"
                },
                "kind": {
                    "type": "JDSAvatarV2Status.kind",
                    "name": "statusBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Status.placement",
                    "name": "statusBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "kind": {
                    "type": "JDSAvatarV2Notification.kind",
                    "name": "notificationBadgeKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_information": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeIcon": {
                    "type": "icon",
                    "name": "informationBadgeIcon"
                },
                "badgeColor": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "informationBadgeColor"
                },
                "badgeAppearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "informationBadgeAppearance"
                },
                "kind": {
                    "type": "JDSAvatarV2Information.kind",
                    "name": "informationBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Information.placement",
                    "name": "informationBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_complete_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "count": {
                    "type": "number",
                    "name": "segmentCount",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_avatar_v2_progress_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "progress": {
                    "type": "number",
                    "name": "progress"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "jds_avatar_v2_default": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_complete_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_progress_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2b = (Component)=>(props)=>{
        const trimChars = (initials2, size)=>{
            if (!initials2 || typeof initials2 !== "string" || initials2.trim() === "") return "";
            let initialsText = "";
            const array = initials2.trim().split(" ");
            if (array.length <= 1) initialsText = array[0].substring(0, 2);
            else initialsText = array[0][0] + array[1][0];
            initialsText = initialsText.substring(0, size);
            return initialsText.toUpperCase();
        };
        const initials = (item)=>{
            return trimChars(item.initials, item.size === "xtra-small" ? 1 : 2);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            initials: initials(props)
        });
    };
const $fe5170bdd3625759$var$Component$2d = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$28;
    const { kind: kind = "default", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ac4313c0728f5b84 = $fe5170bdd3625759$var$withLogic$2b($fe5170bdd3625759$var$Component$2d);
$fe5170bdd3625759$export$ac4313c0728f5b84.displayName = "AvatarV2";
$fe5170bdd3625759$export$ac4313c0728f5b84.slotName = "jds_avatar_v2";
const $fe5170bdd3625759$var$sdl$27 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-complete-ring-2.0.0",
        "name": "JDSAvatarV2CompleteRing",
        "layerName": "jds_avatar_v2_complete_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2a = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2c = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$27;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2CompleteRing", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$70f728d68d57ace9 = $fe5170bdd3625759$var$withLogic$2a($fe5170bdd3625759$var$Component$2c);
$fe5170bdd3625759$export$70f728d68d57ace9.displayName = "AvatarV2CompleteRing";
$fe5170bdd3625759$export$70f728d68d57ace9.slotName = "jds_avatar_v2_complete_ring";
const $fe5170bdd3625759$var$sdl$26 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-default-2.0.0",
        "name": "JDSAvatarV2Default",
        "layerName": "jds_avatar_v2_default",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_9}",
            "width": "{a_0}",
            "height": "{a_1}",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "behavior": {
                "active": {
                    "background-color": "{a_10}"
                }
            }
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "icon": {
            "hidden": false,
            "size": "{a_12}",
            "color": "{a_13}",
            "value": "ic_profile",
            "behavior": {
                "hover": {
                    "color": "{a_14}"
                },
                "active": {
                    "color": "{a_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary70}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primary50}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_16}",
                    "height": "{a_17}"
                },
                "icon": {
                    "size": "{a_26}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_18}",
                    "height": "{a_19}"
                },
                "icon": {
                    "size": "{a_27}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_20}",
                    "height": "{a_21}"
                },
                "icon": {
                    "size": "{a_28}"
                },
                "jds-text": {}
            },
            "xtra-large": {
                "container": {
                    "width": "{a_22}",
                    "height": "{a_23}"
                },
                "icon": {
                    "size": "{a_29}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_24}",
                    "height": "{a_25}"
                },
                "icon": {
                    "size": "{a_30}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_31}"
                }
            }
        },
        "kind": {
            "initials": {
                "jds_image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            },
            "image": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{a_34}"
                        },
                        "active": {
                            "background-color": "{a_36}"
                        }
                    }
                },
                "jds_image": {
                    "hidden": false,
                    "behavior": {
                        "hover": {
                            "opacity": "{a_33}"
                        },
                        "active": {
                            "opacity": "{a_35}"
                        }
                    }
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {}
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$29 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2b = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$26;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Avatar", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Default", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4860988e9a471058 = $fe5170bdd3625759$var$withLogic$29($fe5170bdd3625759$var$Component$2b);
$fe5170bdd3625759$export$4860988e9a471058.displayName = "AvatarV2Default";
$fe5170bdd3625759$export$4860988e9a471058.slotName = "jds_avatar_v2_default";
const $fe5170bdd3625759$var$sdl$25 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-information-2.0.0",
        "name": "JDSAvatarV2Information",
        "layerName": "jds_avatar_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "badge-container": {
            "padding-left": "{custom_11}",
            "padding-top": "{custom_11}",
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "size": "small",
            "kind": "information",
            "informationKind": "icon-circle",
            "border": true
        }
    },
    "variant": {
        "kind": {
            "label": {
                "jds_badge_v2": {
                    "informationKind": "label"
                }
            }
        },
        "size": {
            "xtra-small": {
                "container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_15}",
                            "padding-top": "{custom_15}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            },
            "medium": {
                "icon": {
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_11}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{xl}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_8}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_21}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_6}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_22}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "kind",
            "placement"
        ]
    ],
    "api": {
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                }
            },
            "jds_badge_v2": {
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                },
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "badgeColor"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "badgeAppearance"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "label"
                ]
            },
            "placement": {
                "values": [
                    "bottom-right",
                    "bottom-center"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Information Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$28 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2a = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$25;
    const { kind: kind = "icon", placement: placement = "bottom-right", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Information Badge", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Information", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$dbc79143cb6c67cb = $fe5170bdd3625759$var$withLogic$28($fe5170bdd3625759$var$Component$2a);
$fe5170bdd3625759$export$dbc79143cb6c67cb.displayName = "AvatarV2Information";
$fe5170bdd3625759$export$dbc79143cb6c67cb.slotName = "jds_avatar_v2_information";
const $fe5170bdd3625759$var$sdl$24 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-notification-2.0.0",
        "name": "JDSAvatarV2Notification",
        "layerName": "jds_avatar_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.end}",
            "opacity": "{opacity.enabled}"
        },
        "badge-container": {
            "padding-left": 28,
            "padding-bottom": 28,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "kind": "notification",
            "notificationKind": "dot",
            "size": "small"
        }
    },
    "variant": {
        "kind": {
            "number": {
                "jds_badge_v2": {
                    "notificationKind": "number"
                }
            },
            "number-symbol": {
                "jds_badge_v2": {
                    "notificationKind": "number-symbol"
                }
            }
        },
        "size": {
            "xtra-small": {
                "badge-container": {
                    "padding-left": 16,
                    "padding-bottom": 16
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "badge-container": {
                    "padding-left": 20,
                    "padding-bottom": 20
                },
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                }
            },
            "large": {
                "badge-container": {
                    "padding-left": 32,
                    "padding-bottom": 32
                },
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                }
            },
            "xtra-large": {
                "badge-container": {
                    "padding-left": 37,
                    "padding-bottom": 37
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                }
            },
            "xtra-xtra-large": {
                "badge-container": {
                    "padding-left": 87,
                    "padding-bottom": 87
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 15,
                        "padding-bottom": 15
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 19,
                        "padding-bottom": 19
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 23,
                        "padding-bottom": 27
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 27,
                        "padding-bottom": 35
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 35,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "xtra-large"
                    }
                }
            },
            "number-symbol": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_avatar_v2_default": {
                        "size": "small"
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 18,
                        "padding-bottom": 31
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 22,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 28,
                        "padding-bottom": 43
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-xtra-large": {
                    "badge-container": {
                        "padding-left": 75,
                        "padding-bottom": 87
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Active Notifications"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$27 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$29 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$24;
    const { kind: kind = "dot", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Active Notifications", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Notification", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c906bb7932dd69e9 = $fe5170bdd3625759$var$withLogic$27($fe5170bdd3625759$var$Component$29);
$fe5170bdd3625759$export$c906bb7932dd69e9.displayName = "AvatarV2Notification";
$fe5170bdd3625759$export$c906bb7932dd69e9.slotName = "jds_avatar_v2_notification";
const $fe5170bdd3625759$var$sdl$23 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_progress_ring-1.0.0",
        "name": "JDSAvatarV2ProgressRing",
        "layerName": "jds_avatar_v2_progress_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "base-arc",
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "base-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primaryGrey40}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 270,
            "z-index": 2,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "base-arc": {
                    "radius": 68,
                    "arcWidth": 4
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "base-arc": {
                    "radius": 34,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "base-arc": {
                    "radius": 30,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "base-arc": {
                    "radius": 20,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "base-arc": {
                    "radius": 16,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-arc": {
                "end": {
                    "type": "number",
                    "name": "progress",
                    "function": true
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Progress Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$26 = (Component)=>(props)=>{
        const progress = (items)=>{
            let percent = items.progress ?? 0;
            if (percent < 0) percent = Math.abs(percent);
            if (percent > 100) percent = percent % 100;
            return percent * 3.6;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            progress: progress(props)
        });
    };
const $fe5170bdd3625759$var$Component$28 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$23;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Progress Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2ProgressRing", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$add0715ef3cff303 = $fe5170bdd3625759$var$withLogic$26($fe5170bdd3625759$var$Component$28);
$fe5170bdd3625759$export$add0715ef3cff303.displayName = "AvatarV2ProgressRing";
$fe5170bdd3625759$export$add0715ef3cff303.slotName = "jds_avatar_v2_progress_ring";
const $fe5170bdd3625759$var$sdl$22 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_segmented_ring-1.0.0",
        "name": "JDSAvatarV2SegmentedRing",
        "layerName": "jds_avatar_v2_segmented_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "ring-container": [
                    "jds_segmented_ring_item"
                ]
            },
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-container": {
            "hidden": false,
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "z-index": 1,
            "disabled": true
        },
        "jds_segmented_ring_item": {
            "size": "medium",
            "z-index": 1
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-large"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_segmented_ring_item": {
                    "size": "large"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_segmented_ring_item": {
                    "size": "small"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_ring.startAngle": {
                    "type": "string",
                    "name": "startAngle"
                },
                "_ring.endAngle": {
                    "type": "string",
                    "name": "endAngle"
                }
            },
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-container": {
                "value": {
                    "type": "list",
                    "name": "_ring",
                    "object": {
                        "startAngle": "number",
                        "endAngle": "number"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "count",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_segmented_ring_item": {
                "startAngle": {
                    "type": "string",
                    "name": "ring.startAngle"
                },
                "endAngle": {
                    "type": "string",
                    "name": "ring.endAngle"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$25 = (Component)=>(props)=>{
        const defaultRingCount = 4;
        const startAngle = (index, len)=>{
            if (len === 1) return 0;
            const gap = 5;
            const portion = 360 / len;
            return portion * index + gap;
        };
        const endAngle = (index, len)=>{
            if (len === 1) return 360;
            const gap = 5;
            const portion = 360 / len;
            return portion * (index + 1) - gap;
        };
        const ring = (item)=>{
            const rings = [];
            const len = item.count || defaultRingCount;
            for(let index = 0; index < len; index++)rings.push({
                startAngle: startAngle(index, len),
                endAngle: endAngle(index, len)
            });
            return rings;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ring: ring(props)
            }
        });
    };
const $fe5170bdd3625759$var$Component$27 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$22;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2SegmentedRing", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9b02a99b26bc2fb = $fe5170bdd3625759$var$withLogic$25($fe5170bdd3625759$var$Component$27);
$fe5170bdd3625759$export$9b02a99b26bc2fb.displayName = "AvatarV2SegmentedRing";
$fe5170bdd3625759$export$9b02a99b26bc2fb.slotName = "jds_avatar_v2_segmented_ring";
const $fe5170bdd3625759$var$sdl$21 = {
    "metadata": {
        "version": "1.0.0",
        "name": "JDSAvatarV2Status",
        "layerName": "jds_avatar_v2_status",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "badge-container": {
            "padding-top": "{custom_11}",
            "padding-left": "{custom_11}",
            "padding-bottom": "{custom_5}",
            "z-index": 1,
            "disabled": true
        },
        "jds_badge_v2": {
            "kind": "status",
            "statusKind": "dot",
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "icon": {
                "jds_badge_v2": {
                    "statusKind": "icon",
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{custom_11}",
                    "padding-left": "{custom_11}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "text": {
                "jds_badge_v2": {
                    "statusKind": "label-container",
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "badge-container": {
                    "padding-top": "{custom_7}",
                    "padding-left": "{custom_7}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                },
                "badge-container": {
                    "padding-top": "{custom_10}",
                    "padding-left": "{custom_10}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{l}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                },
                "badge-container": {
                    "padding-top": "{custom_13}",
                    "padding-left": "{custom_13}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{base}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{custom_7}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{custom_10}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{l}",
                            "padding-left": "{l}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_11}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_13}",
                            "padding-left": "{custom_13}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{base}",
                            "padding-left": "{base}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "xtra-large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "text": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{huge}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{huge}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{xl}",
                            "padding-left": "{custom_12}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{custom_12}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{m}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_20}",
                            "padding-left": "{m}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size",
            "placement"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "icon",
                    "text"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "placement": {
                "values": [
                    "bottom",
                    "top"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "badgeStatus"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Status Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$24 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$26 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$21;
    const { kind: kind = "dot", size: size = "medium", placement: placement = "bottom", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Status Badge", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            placement: placement,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Status", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$6c44d71f4e8d3278 = $fe5170bdd3625759$var$withLogic$24($fe5170bdd3625759$var$Component$26);
$fe5170bdd3625759$export$6c44d71f4e8d3278.displayName = "AvatarV2Status";
$fe5170bdd3625759$export$6c44d71f4e8d3278.slotName = "jds_avatar_v2_status";
const $fe5170bdd3625759$var$sdl$20 = {
    "metadata": {
        "version": "1.0.0",
        "id": "badge-1.0.0",
        "name": "JDSBadge",
        "layerName": "jds_badge",
        "description": "A Badge is used to draw attention to new or categorized content elements.",
        "usage": "Badges are not interactive. They are only used to describe a category or feature of the content they associate with."
    },
    "hierarchy": {
        "container": [
            "icon",
            "text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-left": "{b_4}",
            "padding-right": "{b_5}",
            "padding-bottom": "{b_6}",
            "gap": "{b_7}",
            "background-color": "{b_8}",
            "border-radius": "{b_9}"
        },
        "icon": {
            "hidden": false,
            "size": "{b_10}",
            "color": "{b_11}",
            "justify-content": "{b_12}",
            "align-items": "{b_13}"
        },
        "text": {
            "hidden": false,
            "font-family": "{b_14}",
            "font-size": "{b_15}",
            "line-height": "{b_16}",
            "letter-spacing": "{b_17}",
            "font-weight": "{b_18}",
            "color": "{b_19}",
            "max-lines": 1,
            "text-transform": "{b_20}"
        }
    },
    "variant": {
        "kind": {
            "service": {
                "container": {
                    "border-radius": "{b_21}",
                    "background-color": "{b_22}",
                    "padding-top": "{b_23}",
                    "padding-left": "{b_24}",
                    "padding-right": "{b_25}",
                    "padding-bottom": "{b_26}",
                    "gap": "{b_27}"
                },
                "text": {
                    "font-family": "{b_28}",
                    "font-size": "{b_29}",
                    "line-height": "{b_30}",
                    "letter-spacing": "{b_31}",
                    "font-weight": "{b_32}",
                    "color": "{b_33}",
                    "text-transform": "{badge_variant_kind_service_text_text-transform}"
                },
                "icon": {
                    "size": "{b_34}",
                    "color": "{b_35}"
                }
            }
        },
        "_hasIcon": {
            "false": {
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "small": {
                    "container": {
                        "border-radius": "{b_36}"
                    },
                    "icon": {
                        "size": "{b_37}"
                    },
                    "text": {
                        "font-family": "{b_38}",
                        "font-size": "{b_39}",
                        "line-height": "{b_40}",
                        "letter-spacing": "{b_41}",
                        "font-weight": "{b_42}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_43}",
                        "padding-right": "{b_44}",
                        "gap": "{b_45}"
                    },
                    "icon": {
                        "size": "{b_46}"
                    },
                    "text": {
                        "font-family": "{b_47}",
                        "font-size": "{b_48}",
                        "line-height": "{b_49}",
                        "letter-spacing": "{b_50}",
                        "font-weight": "{b_51}"
                    }
                }
            }
        },
        {
            "service": {
                "false": {
                    "container": {
                        "padding-left": "{b_25}",
                        "padding-right": "{b_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "_hasIcon"
        ]
    ],
    "api": {
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It is used to display label of badge."
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon on the left with text."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "service"
                ],
                "doc_description": "It can be used to switch between 2 variants of Badge."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "It can be used to adjust the size of Badge."
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$modifyIcon = ({ kind: kind, icon: icon })=>{
    if (kind !== "service" || !icon) return icon;
    if (typeof icon === "string") {
        if (!icon.toString().toLowerCase().startsWith("ps")) return void 0;
        return icon;
    }
    return icon;
};
const $fe5170bdd3625759$var$withLogic$23 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            icon: $fe5170bdd3625759$var$modifyIcon(props)
        });
    };
const $fe5170bdd3625759$var$Component$25 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$20;
    const { kind: kind = "normal", size: size = "medium", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadge", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$37acb3580601e69a = $fe5170bdd3625759$var$withLogic$23($fe5170bdd3625759$var$Component$25);
$fe5170bdd3625759$export$37acb3580601e69a.displayName = "Badge";
$fe5170bdd3625759$export$37acb3580601e69a.slotName = "jds_badge";
const $fe5170bdd3625759$var$sdl$1$ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-2.0.0",
        "name": "JDSBadgeV2",
        "layerName": "jds_badge_v2"
    },
    "hierarchy": {
        "container": [
            {
                "children-container": [
                    "children-slot"
                ]
            },
            {
                "badge-container": [
                    "jds_badge_v2_information",
                    "jds_badge_v2_brand",
                    "jds_badge_v2_notification",
                    "jds_badge_v2_status"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "hidden": false
        },
        "badge-container": {
            "z-index": 1
        },
        "jds_badge_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_brand": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "children-container": {
            "hidden": false,
            "z-index": 0
        }
    },
    "variant": {
        "kind": {
            "information": {
                "jds_badge_v2_information": {
                    "hidden": false
                }
            },
            "brand": {
                "jds_badge_v2_brand": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_badge_v2_notification": {
                    "hidden": false
                }
            },
            "status": {
                "jds_badge_v2_status": {
                    "hidden": false
                }
            }
        },
        "placement": {
            "top": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.start}"
                }
            },
            "top_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.start}"
                }
            },
            "bottom_start": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.end}"
                }
            },
            "left": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.center}"
                }
            },
            "right": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_badge_v2_information": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_badge_v2_information": {
                    "size": "small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "small"
                },
                "jds_badge_v2_status": {
                    "size": "small"
                }
            },
            "large": {
                "jds_badge_v2_information": {
                    "size": "large"
                },
                "jds_badge_v2_brand": {
                    "size": "large"
                },
                "jds_badge_v2_notification": {
                    "size": "large"
                },
                "jds_badge_v2_status": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-xtra-large"
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "badge-container": {
                    "z-index": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "information",
                    "brand",
                    "notification",
                    "status"
                ]
            },
            "placement": {
                "values": [
                    "top_start",
                    "top",
                    "top_end",
                    "bottom_start",
                    "bottom",
                    "bottom_end",
                    "left",
                    "right"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "badge-container": {
                "translate-x": {
                    "type": "size",
                    "name": "offsetLeft"
                },
                "translate-y": {
                    "type": "size",
                    "name": "offsetTop"
                }
            },
            "jds_badge_v2_information": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "background": {
                    "type": "color",
                    "name": "backgroundInfoColor"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Information.kind",
                    "name": "informationKind"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "color"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "appearance"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_brand": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Brand.kind",
                    "name": "brandKind"
                },
                "emphasis": {
                    "type": "JDSBadgeV2Brand.emphasis",
                    "name": "brandEmphasis"
                }
            },
            "jds_badge_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Notification.kind",
                    "name": "notificationKind"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_status": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Status.kind",
                    "name": "statusKind"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "status"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "a11y": {
            "jds_badge_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_brand": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$22 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasChildrenSlot: Boolean(props.children)
            }
        });
    };
const $fe5170bdd3625759$var$Component$24 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1$;
    const { kind: kind = "information", placement: placement = "top_start", size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$561b3597d6384588 = $fe5170bdd3625759$var$withLogic$22($fe5170bdd3625759$var$Component$24);
$fe5170bdd3625759$export$561b3597d6384588.displayName = "BadgeV2";
$fe5170bdd3625759$export$561b3597d6384588.slotName = "jds_badge_v2";
const $fe5170bdd3625759$var$sdl$1_ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-brand-2.0.0",
        "name": "JDSBadgeV2Brand",
        "layerName": "jds_badge_v2_brand",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "image-container": [
                    "brand-jds_image"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{b_3}",
            "gap": "{b_4}",
            "border-radius": "{b_5}",
            "padding-left": "{b_6}",
            "padding-right": "{b_7}",
            "padding-top": "{b_8}",
            "padding-bottom": "{b_9}"
        },
        "image-container": {
            "border-radius": "{b_10}",
            "size": "{b_11}",
            "overflow": "hidden"
        },
        "brand-jds_image": {
            "aspectRatio": "round",
            "roundedCorner": false
        },
        "label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{global.white}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "circle": {
                "container": {
                    "padding-left": "{b_40}",
                    "padding-right": "{b_40}",
                    "padding-top": "{b_40}",
                    "padding-bottom": "{b_40}"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square": {
                "container": {
                    "border-radius": "{b_13}",
                    "padding-left": "{b_41}",
                    "padding-right": "{b_41}",
                    "padding-top": "{b_41}",
                    "padding-bottom": "{b_41}"
                },
                "image-container": {
                    "border-radius": "{b_12}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square-label": {
                "container": {
                    "border-radius": "{b_15}"
                },
                "image-container": {
                    "border-radius": "{b_16}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                }
            }
        },
        "size": {
            "medium": {
                "container": {
                    "padding-left": "{b_17}",
                    "padding-right": "{b_18}",
                    "padding-top": "{b_19}",
                    "padding-bottom": "{b_20}"
                },
                "image-container": {
                    "size": "{b_21}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "padding-left": "{b_22}",
                    "padding-right": "{b_23}",
                    "padding-top": "{b_24}",
                    "padding-bottom": "{b_25}"
                },
                "image-container": {
                    "size": "{b_26}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-large": {
                "container": {
                    "padding-left": "{b_27}",
                    "padding-right": "{b_28}",
                    "padding-top": "{b_29}",
                    "padding-bottom": "{b_30}"
                },
                "image-container": {
                    "size": "{b_31}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "padding-left": "{b_32}",
                    "padding-right": "{b_33}",
                    "padding-top": "{b_34}",
                    "padding-bottom": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "gap": "{b_37}"
                },
                "image-container": {
                    "size": "{b_38}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "emphasis": {
            "bold": {
                "container": {
                    "background-color": "{b_39}"
                }
            }
        }
    },
    "combination": [
        {
            "circle": {
                "medium": {
                    "container": {
                        "padding-left": "{b_42}",
                        "padding-right": "{b_42}",
                        "padding-top": "{b_42}",
                        "padding-bottom": "{b_42}"
                    },
                    "image-container": {
                        "size": "{b_43}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_44}",
                        "padding-right": "{b_44}",
                        "padding-top": "{b_44}",
                        "padding-bottom": "{b_44}"
                    },
                    "image-container": {
                        "size": "{b_45}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "padding-left": "{b_46}",
                        "padding-right": "{b_46}",
                        "padding-top": "{b_46}",
                        "padding-bottom": "{b_46}"
                    },
                    "image-container": {
                        "size": "{b_47}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_48}",
                        "padding-right": "{b_48}",
                        "padding-top": "{b_48}",
                        "padding-bottom": "{b_48}"
                    },
                    "image-container": {
                        "size": "{b_49}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_51}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_53}"
                    }
                }
            },
            "square": {
                "medium": {
                    "container": {
                        "border-radius": "{b_54}",
                        "padding-left": "{b_55}",
                        "padding-right": "{b_55}",
                        "padding-top": "{b_55}",
                        "padding-bottom": "{b_55}"
                    },
                    "image-container": {
                        "size": "{b_56}",
                        "border-radius": "{b_57}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_58}",
                        "padding-left": "{b_59}",
                        "padding-right": "{b_59}",
                        "padding-top": "{b_59}",
                        "padding-bottom": "{b_59}"
                    },
                    "image-container": {
                        "size": "{b_60}",
                        "border-radius": "{b_61}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_62}",
                        "padding-left": "{b_63}",
                        "padding-right": "{b_63}",
                        "padding-top": "{b_63}",
                        "padding-bottom": "{b_63}"
                    },
                    "image-container": {
                        "size": "{b_64}",
                        "border-radius": "{b_65}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_66}",
                        "padding-left": "{b_67}",
                        "padding-right": "{b_67}",
                        "padding-top": "{b_67}",
                        "padding-bottom": "{b_67}"
                    },
                    "image-container": {
                        "size": "{b_68}",
                        "border-radius": "{b_69}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_70}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_71}"
                    }
                }
            },
            "square-label": {
                "medium": {
                    "container": {
                        "border-radius": "{b_73}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_74}",
                        "padding-right": "{b_75}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_76}",
                        "padding-right": "{b_77}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_81}",
                        "padding-left": "{b_78}"
                    },
                    "image-container": {
                        "size": "{b_79}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_80}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_82}"
                    },
                    "image-container": {
                        "border-radius": "{b_72}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "circle-label",
                    "circle",
                    "square",
                    "square-label"
                ]
            },
            "size": {
                "values": [
                    "xtra-xtra-xtra-large",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "emphasis": {
                "values": [
                    "light",
                    "bold"
                ]
            }
        },
        "data": {
            "brand-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$21 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$23 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1_;
    const { kind: kind = "circle-label", size: size = "xtra-xtra-xtra-large", emphasis: emphasis = "light", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            emphasis: emphasis,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Brand", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3b623c6160d8d9d1 = $fe5170bdd3625759$var$withLogic$21($fe5170bdd3625759$var$Component$23);
$fe5170bdd3625759$export$3b623c6160d8d9d1.displayName = "BadgeV2Brand";
$fe5170bdd3625759$export$3b623c6160d8d9d1.slotName = "jds_badge_v2_brand";
const $fe5170bdd3625759$var$sdl$1Z = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-information-2.0.0",
        "name": "JDSBadgeV2Information",
        "layerName": "jds_badge_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "image-container": [
                            "jds_image"
                        ]
                    },
                    {
                        "icon-container": [
                            "icon"
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "border-radius": "{b_0}"
        },
        "inner-container": {
            "flex-direction": "{b_2}",
            "justify-content": "{b_3}",
            "align-items": "{b_4}",
            "background-color": "{b_5}",
            "gap": "{b_6}",
            "border-radius": "{b_7}",
            "padding-left": "{b_8}",
            "padding-right": "{b_9}",
            "padding-top": "{b_10}",
            "padding-bottom": "{b_11}"
        },
        "icon-container": {
            "hidden": false,
            "show": true,
            "flex-direction": "{b_12}",
            "justify-content": "{b_13}",
            "align-items": "{b_14}",
            "size": "{b_15}"
        },
        "icon": {
            "color": "{b_16}",
            "size": "{b_17}"
        },
        "image-container": {
            "hidden": true,
            "show": true,
            "flex-direction": "{b_18}",
            "justify-content": "{b_19}",
            "align-items": "{b_20}",
            "size": "{b_21}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "round"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon-container": {
                    "hidden": true
                }
            },
            "label-image": {
                "icon-container": {
                    "hidden": true
                },
                "image-container": {
                    "hidden": false
                }
            },
            "icon": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-circle": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-square": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "size": {
            "xtra-small": {
                "inner-container": {
                    "padding-right": "{b_25}",
                    "padding-top": "{b_26}",
                    "padding-bottom": "{b_27}"
                },
                "icon-container": {
                    "size": "{b_28}"
                },
                "icon": {
                    "size": "{b_29}"
                },
                "image-container": {
                    "size": "{b_30}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "inner-container": {
                    "padding-right": "{b_31}",
                    "padding-top": "{b_32}",
                    "padding-bottom": "{b_33}"
                },
                "icon-container": {
                    "size": "{b_34}"
                },
                "icon": {
                    "size": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "inner-container": {
                    "padding-right": "{b_37}",
                    "padding-top": "{b_38}",
                    "padding-bottom": "{b_39}"
                },
                "icon-container": {
                    "size": "{b_40}"
                },
                "icon": {
                    "size": "{b_41}"
                },
                "image-container": {
                    "size": "{b_42}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "inner-container": {
                    "padding-left": "{b_43}",
                    "padding-top": "{b_44}",
                    "padding-bottom": "{b_45}"
                }
            },
            "xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_46}"
                },
                "inner-container": {
                    "border-radius": "{b_47}",
                    "padding-left": "{b_48}",
                    "padding-top": "{b_49}",
                    "padding-bottom": "{b_50}"
                },
                "icon-container": {
                    "size": "{b_51}"
                },
                "icon": {
                    "size": "{b_52}"
                },
                "image-container": {
                    "size": "{b_53}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_54}"
                },
                "inner-container": {
                    "border-radius": "{b_55}",
                    "padding-left": "{b_56}",
                    "padding-right": "{b_57}",
                    "padding-top": "{b_58}",
                    "padding-bottom": "{b_59}"
                },
                "icon-container": {
                    "size": "{b_60}"
                },
                "icon": {
                    "size": "{b_61}"
                },
                "image-container": {
                    "size": "{b_62}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "color": {
            "secondary": {
                "inner-container": {
                    "background-color": "{b_22}"
                },
                "icon-container": {
                    "background-color": "{b_23}"
                },
                "icon": {
                    "color": "{b_24}"
                }
            },
            "positive": {
                "inner-container": {
                    "background-color": "{b_63}"
                },
                "icon-container": {
                    "background-color": "{b_64}"
                }
            },
            "warning": {
                "inner-container": {
                    "background-color": "{b_65}"
                },
                "icon-container": {
                    "background-color": "{b_66}"
                }
            },
            "negative": {
                "inner-container": {
                    "background-color": "{b_67}"
                },
                "icon-container": {
                    "background-color": "{b_68}"
                }
            },
            "neutral": {
                "inner-container": {
                    "background-color": "{b_69}"
                },
                "icon-container": {
                    "background-color": "{b_70}"
                }
            }
        },
        "border": {
            "true": {
                "container": {
                    "background-color": "{b_72}",
                    "padding-top": "{b_71}",
                    "padding-bottom": "{b_71}",
                    "padding-left": "{b_71}",
                    "padding-right": "{b_71}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-small": {
                    "inner-container": {
                        "padding-left": "{b_73}",
                        "padding-right": "{b_73}",
                        "padding-top": "{b_73}",
                        "padding-bottom": "{b_73}"
                    },
                    "icon-container": {
                        "size": "{b_74}"
                    },
                    "icon": {
                        "size": "{b_75}"
                    }
                },
                "small": {
                    "inner-container": {
                        "padding-left": "{b_76}",
                        "padding-right": "{b_76}",
                        "padding-top": "{b_76}",
                        "padding-bottom": "{b_76}"
                    },
                    "icon-container": {
                        "size": "{b_77}"
                    },
                    "icon": {
                        "size": "{b_78}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-left": "{b_79}",
                        "padding-right": "{b_79}",
                        "padding-top": "{b_79}",
                        "padding-bottom": "{b_79}"
                    },
                    "icon-container": {
                        "size": "{b_80}"
                    },
                    "icon": {
                        "size": "{b_81}"
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-left": "{b_82}",
                        "padding-right": "{b_82}",
                        "padding-top": "{b_82}",
                        "padding-bottom": "{b_82}"
                    },
                    "icon-container": {
                        "size": "{b_87}"
                    },
                    "icon": {
                        "size": "{b_88}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_83}",
                        "padding-right": "{b_83}",
                        "padding-top": "{b_83}",
                        "padding-bottom": "{b_83}"
                    },
                    "icon-container": {
                        "size": "{b_89}"
                    },
                    "icon": {
                        "size": "{b_90}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_84}",
                        "padding-right": "{b_84}",
                        "padding-top": "{b_84}",
                        "padding-bottom": "{b_84}"
                    },
                    "icon-container": {
                        "size": "{b_91}"
                    },
                    "icon": {
                        "size": "{b_92}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_85}",
                        "padding-right": "{b_85}",
                        "padding-top": "{b_85}",
                        "padding-bottom": "{b_85}"
                    },
                    "icon-container": {
                        "size": "{b_93}"
                    },
                    "icon": {
                        "size": "{b_94}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_86}",
                        "padding-right": "{b_86}",
                        "padding-top": "{b_86}",
                        "padding-bottom": "{b_86}"
                    },
                    "icon-container": {
                        "size": "{b_95}"
                    },
                    "icon": {
                        "size": "{b_96}"
                    }
                }
            },
            "icon-circle": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_97}"
                    },
                    "inner-container": {
                        "border-radius": "{b_98}",
                        "padding-left": "{b_99}",
                        "padding-right": "{b_99}",
                        "padding-top": "{b_99}",
                        "padding-bottom": "{b_99}"
                    },
                    "icon-container": {
                        "size": "{b_100}",
                        "border-radius": "{b_101}"
                    },
                    "icon": {
                        "size": "{b_102}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_103}"
                    },
                    "inner-container": {
                        "border-radius": "{b_104}",
                        "padding-left": "{b_105}",
                        "padding-right": "{b_105}",
                        "padding-top": "{b_105}",
                        "padding-bottom": "{b_105}"
                    },
                    "icon-container": {
                        "size": "{b_106}",
                        "border-radius": "{b_107}"
                    },
                    "icon": {
                        "size": "{b_108}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_109}"
                    },
                    "inner-container": {
                        "border-radius": "{b_109}",
                        "padding-left": "{b_110}",
                        "padding-right": "{b_110}",
                        "padding-top": "{b_110}",
                        "padding-bottom": "{b_110}"
                    },
                    "icon-container": {
                        "size": "{b_111}",
                        "border-radius": "{b_112}"
                    },
                    "icon": {
                        "size": "{b_113}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_114}"
                    },
                    "inner-container": {
                        "border-radius": "{b_114}",
                        "padding-left": "{b_115}",
                        "padding-right": "{b_115}",
                        "padding-top": "{b_115}",
                        "padding-bottom": "{b_115}"
                    },
                    "icon-container": {
                        "size": "{b_116}",
                        "border-radius": "{b_117}"
                    },
                    "icon": {
                        "size": "{b_118}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_119}"
                    },
                    "inner-container": {
                        "border-radius": "{b_119}",
                        "padding-left": "{b_120}",
                        "padding-right": "{b_120}",
                        "padding-top": "{b_120}",
                        "padding-bottom": "{b_120}"
                    },
                    "icon-container": {
                        "size": "{b_121}",
                        "border-radius": "{b_122}"
                    },
                    "icon": {
                        "size": "{b_123}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_124}"
                    },
                    "inner-container": {
                        "border-radius": "{b_124}",
                        "padding-left": "{b_125}",
                        "padding-right": "{b_125}",
                        "padding-top": "{b_125}",
                        "padding-bottom": "{b_125}"
                    },
                    "icon-container": {
                        "size": "{b_126}",
                        "border-radius": "{b_127}"
                    },
                    "icon": {
                        "size": "{b_128}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_129}"
                    },
                    "inner-container": {
                        "border-radius": "{b_129}",
                        "padding-left": "{b_130}",
                        "padding-right": "{b_130}",
                        "padding-top": "{b_130}",
                        "padding-bottom": "{b_130}"
                    },
                    "icon-container": {
                        "size": "{b_131}",
                        "border-radius": "{b_132}"
                    },
                    "icon": {
                        "size": "{b_133}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_134}"
                    },
                    "inner-container": {
                        "border-radius": "{b_134}",
                        "padding-left": "{b_135}",
                        "padding-right": "{b_135}",
                        "padding-top": "{b_135}",
                        "padding-bottom": "{b_135}"
                    },
                    "icon-container": {
                        "size": "{b_136}",
                        "border-radius": "{b_137}"
                    },
                    "icon": {
                        "size": "{b_138}"
                    }
                }
            },
            "icon-square": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_139}"
                    },
                    "inner-container": {
                        "border-radius": "{b_140}",
                        "padding-left": "{b_141}",
                        "padding-right": "{b_141}",
                        "padding-top": "{b_141}",
                        "padding-bottom": "{b_141}"
                    },
                    "icon-container": {
                        "size": "{b_142}",
                        "border-radius": "{b_143}"
                    },
                    "icon": {
                        "size": "{b_144}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_145}"
                    },
                    "inner-container": {
                        "border-radius": "{b_145}",
                        "padding-left": "{b_146}",
                        "padding-right": "{b_146}",
                        "padding-top": "{b_146}",
                        "padding-bottom": "{b_146}"
                    },
                    "icon-container": {
                        "size": "{b_147}",
                        "border-radius": "{b_148}"
                    },
                    "icon": {
                        "size": "{b_149}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_150}"
                    },
                    "inner-container": {
                        "border-radius": "{b_150}",
                        "padding-left": "{b_151}",
                        "padding-right": "{b_151}",
                        "padding-top": "{b_151}",
                        "padding-bottom": "{b_151}"
                    },
                    "icon-container": {
                        "size": "{b_152}",
                        "border-radius": "{b_153}"
                    },
                    "icon": {
                        "size": "{b_154}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_155}"
                    },
                    "inner-container": {
                        "border-radius": "{b_155}",
                        "padding-left": "{b_156}",
                        "padding-right": "{b_156}",
                        "padding-top": "{b_156}",
                        "padding-bottom": "{b_156}"
                    },
                    "icon-container": {
                        "size": "{b_157}",
                        "border-radius": "{b_158}"
                    },
                    "icon": {
                        "size": "{b_159}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_160}"
                    },
                    "inner-container": {
                        "border-radius": "{b_160}",
                        "padding-left": "{b_161}",
                        "padding-right": "{b_161}",
                        "padding-top": "{b_161}",
                        "padding-bottom": "{b_161}"
                    },
                    "icon-container": {
                        "size": "{b_162}",
                        "border-radius": "{b_163}"
                    },
                    "icon": {
                        "size": "{b_164}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_165}"
                    },
                    "inner-container": {
                        "border-radius": "{b_165}",
                        "padding-left": "{b_166}",
                        "padding-right": "{b_166}",
                        "padding-top": "{b_166}",
                        "padding-bottom": "{b_166}"
                    },
                    "icon-container": {
                        "size": "{b_167}",
                        "border-radius": "{b_168}"
                    },
                    "icon": {
                        "size": "{b_169}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_170}"
                    },
                    "inner-container": {
                        "border-radius": "{b_170}",
                        "padding-left": "{b_171}",
                        "padding-right": "{b_171}",
                        "padding-top": "{b_171}",
                        "padding-bottom": "{b_171}"
                    },
                    "icon-container": {
                        "size": "{b_172}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_174}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_175}"
                    },
                    "inner-container": {
                        "border-radius": "{b_175}",
                        "padding-left": "{b_176}",
                        "padding-right": "{b_176}",
                        "padding-top": "{b_176}",
                        "padding-bottom": "{b_176}"
                    },
                    "icon-container": {
                        "size": "{b_177}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_179}"
                    }
                }
            },
            "label": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{size.fit}",
                        "padding-left": "{b_184}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}",
                        "padding-left": "{b_186}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}",
                        "padding-left": "{b_190}"
                    }
                }
            },
            "label-icon": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                }
            },
            "label-image": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{size.fit}"
                    }
                }
            }
        },
        {
            "subtle": {
                "default": {
                    "inner-container": {
                        "background-color": "{b_207}"
                    },
                    "icon-container": {
                        "background-color": "{b_208}"
                    },
                    "icon": {
                        "color": "{b_209}"
                    },
                    "label-jds-text": {
                        "color": "{sparkle60}"
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{b_267}"
                    },
                    "icon-container": {
                        "background-color": "{b_268}"
                    },
                    "icon": {
                        "color": "{b_269}"
                    },
                    "label-jds-text": {
                        "color": "{secondary60}"
                    }
                },
                "positive": {
                    "inner-container": {
                        "background-color": "{b_210}"
                    },
                    "icon-container": {
                        "background-color": "{b_211}"
                    },
                    "icon": {
                        "color": "{b_212}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "warning": {
                    "inner-container": {
                        "background-color": "{b_213}"
                    },
                    "icon-container": {
                        "background-color": "{b_214}"
                    },
                    "icon": {
                        "color": "{b_215}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackWarning50}"
                    }
                },
                "negative": {
                    "inner-container": {
                        "background-color": "{b_216}"
                    },
                    "icon-container": {
                        "background-color": "{b_217}"
                    },
                    "icon": {
                        "color": "{b_218}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackError50}"
                    }
                },
                "neutral": {
                    "inner-container": {
                        "background-color": "{b_219}"
                    },
                    "icon-container": {
                        "background-color": "{b_220}"
                    },
                    "icon": {
                        "color": "{b_221}"
                    },
                    "label-jds-text": {
                        "color": "{primaryGrey80}"
                    }
                }
            }
        },
        {
            "icon": {
                "bold": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_222}"
                        },
                        "icon-container": {
                            "background-color": "{b_223}"
                        },
                        "icon": {
                            "color": "{b_224}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_264}"
                        },
                        "icon-container": {
                            "background-color": "{b_265}"
                        },
                        "icon": {
                            "color": "{b_266}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_225}"
                        },
                        "icon-container": {
                            "background-color": "{b_226}"
                        },
                        "icon": {
                            "color": "{b_227}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_228}"
                        },
                        "icon-container": {
                            "background-color": "{b_229}"
                        },
                        "icon": {
                            "color": "{b_230}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_231}"
                        },
                        "icon-container": {
                            "background-color": "{b_232}"
                        },
                        "icon": {
                            "color": "{b_233}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_234}"
                        },
                        "icon-container": {
                            "background-color": "{b_235}"
                        },
                        "icon": {
                            "color": "{b_236}"
                        }
                    }
                },
                "subtle": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_237}"
                        },
                        "icon-container": {
                            "background-color": "{b_238}"
                        },
                        "icon": {
                            "color": "{b_239}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_261}"
                        },
                        "icon-container": {
                            "background-color": "{b_262}"
                        },
                        "icon": {
                            "color": "{b_263}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_240}"
                        },
                        "icon-container": {
                            "background-color": "{b_241}"
                        },
                        "icon": {
                            "color": "{b_242}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_243}"
                        },
                        "icon-container": {
                            "background-color": "{b_244}"
                        },
                        "icon": {
                            "color": "{b_245}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_246}"
                        },
                        "icon-container": {
                            "background-color": "{b_247}"
                        },
                        "icon": {
                            "color": "{b_248}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_249}"
                        },
                        "icon-container": {
                            "background-color": "{b_250}"
                        },
                        "icon": {
                            "color": "{b_251}"
                        }
                    }
                }
            }
        },
        {
            "true": {
                "xtra-small": {
                    "container": {
                        "padding-left": "{b_252}",
                        "padding-right": "{b_252}",
                        "padding-top": "{b_252}",
                        "padding-bottom": "{b_252}"
                    }
                },
                "small": {
                    "container": {
                        "padding-left": "{b_253}",
                        "padding-right": "{b_253}",
                        "padding-top": "{b_253}",
                        "padding-bottom": "{b_253}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-left": "{b_254}",
                        "padding-right": "{b_254}",
                        "padding-top": "{b_254}",
                        "padding-bottom": "{b_254}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_255}",
                        "padding-right": "{b_255}",
                        "padding-top": "{b_255}",
                        "padding-bottom": "{b_255}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_256}",
                        "padding-right": "{b_256}",
                        "padding-top": "{b_256}",
                        "padding-bottom": "{b_256}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_257}",
                        "padding-right": "{b_257}",
                        "padding-top": "{b_257}",
                        "padding-bottom": "{b_257}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_258}",
                        "padding-right": "{b_258}",
                        "padding-top": "{b_258}",
                        "padding-bottom": "{b_258}"
                    }
                }
            }
        },
        {
            "true": {
                "icon": {
                    "container": {
                        "background-color": "{b_270}",
                        "padding-top": "{b_271}",
                        "padding-bottom": "{b_271}",
                        "padding-left": "{b_271}",
                        "padding-right": "{b_271}"
                    }
                }
            }
        },
        {
            "true": {
                "icon-circle": {
                    "large": {
                        "container": {
                            "padding-left": "{b_259}",
                            "padding-right": "{b_259}",
                            "padding-top": "{b_259}",
                            "padding-bottom": "{b_259}"
                        }
                    }
                },
                "icon-square": {
                    "large": {
                        "container": {
                            "padding-left": "{b_260}",
                            "padding-right": "{b_260}",
                            "padding-top": "{b_260}",
                            "padding-bottom": "{b_260}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "appearance",
            "color"
        ],
        [
            "kind",
            "appearance",
            "color"
        ],
        [
            "border",
            "size"
        ],
        [
            "border",
            "kind"
        ],
        [
            "border",
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "label-icon",
                    "label-image",
                    "label",
                    "icon",
                    "icon-circle",
                    "icon-square"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "color": {
                "values": [
                    "default",
                    "secondary",
                    "positive",
                    "warning",
                    "negative",
                    "neutral"
                ]
            },
            "appearance": {
                "values": [
                    "bold",
                    "subtle"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "inner-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "icon-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$20 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$22 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Z;
    const { kind: kind = "label-icon", size: size = "xtra-large", color: color = "default", appearance: appearance = "bold", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            color: color,
            appearance: appearance,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Information", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$50fcc0de7334f647 = $fe5170bdd3625759$var$withLogic$20($fe5170bdd3625759$var$Component$22);
$fe5170bdd3625759$export$50fcc0de7334f647.displayName = "BadgeV2Information";
$fe5170bdd3625759$export$50fcc0de7334f647.slotName = "jds_badge_v2_information";
const $fe5170bdd3625759$var$sdl$1Y = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-notification-2.0.0",
        "name": "JDSBadgeV2Notification",
        "layerName": "jds_badge_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            "label-jds-text",
                            "symbol-jds-text"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 10,
            "height": 10,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_6}"
        },
        "container": {
            "width": 8,
            "height": 8,
            "background-color": "{b_8}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "border-radius": "{b_6}",
            "padding-left": "{b_7}",
            "padding-right": "{b_7}",
            "padding-top": "{b_7}",
            "padding-bottom": "{b_7}"
        },
        "inner-container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "width": 7,
            "height": 7,
            "background-color": "{b_5}",
            "border-radius": "{b_6}"
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "symbol-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "+",
            "hidden": true,
            "text": "+"
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "inner-container": {
                    "show": true
                }
            },
            "number": {
                "label-jds-text": {
                    "hidden": false
                }
            },
            "number-symbol": {
                "outer-container": {
                    "border-radius": 5,
                    "width": "",
                    "height": 18,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "container": {
                    "border-radius": "{b_49}",
                    "width": "",
                    "height": 16,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "inner-container": {
                    "width": "",
                    "height": 14,
                    "border-radius": "{b_49}",
                    "padding-left": 3,
                    "padding-right": 3
                },
                "label-jds-text": {
                    "hidden": false
                },
                "symbol-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 10,
                    "height": 10
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 13,
                    "height": 13
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 17,
                    "height": 17
                }
            },
            "xtra-large": {
                "outer-container": {
                    "width": 26,
                    "height": 26
                },
                "container": {
                    "width": 24,
                    "height": 24
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 24,
                    "height": 24
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 27,
                    "height": 27
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 34,
                    "height": 34
                },
                "label-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                },
                "container": {
                    "background-color": "{b_9}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "medium": {
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "large": {
                    "inner-container": {
                        "width": 18,
                        "height": 18
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "width": 21,
                        "height": 21
                    }
                }
            },
            "number-symbol": {
                "small": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 18,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_53}",
                        "width": "",
                        "height": 16,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_53}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "medium": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_57}",
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_57}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 22,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_61}",
                        "width": "",
                        "height": 20,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 18,
                        "border-radius": "{b_61}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 26,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_65}",
                        "width": "",
                        "height": 24,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 20,
                        "border-radius": "{b_65}",
                        "padding-left": 4,
                        "padding-right": 4
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 30,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_69}",
                        "width": "",
                        "height": 28,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 24,
                        "border-radius": "{b_69}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 34,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_73}",
                        "width": "",
                        "height": 32,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 28,
                        "border-radius": "{b_73}",
                        "padding-left": 5,
                        "padding-right": 5
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 42,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_77}",
                        "width": "",
                        "height": 40,
                        "padding-left": 3,
                        "padding-right": 3
                    },
                    "inner-container": {
                        "width": "",
                        "height": 34,
                        "border-radius": "{b_77}",
                        "padding-left": "{b_78}",
                        "padding-right": 6
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Active Notification"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1$ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$21 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Y;
    const { kind: kind = "dot", size: size = "xtra-small", border: border = false, ariaLabel: ariaLabel = "Active Notification", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Notification", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5217f316f51857f9 = $fe5170bdd3625759$var$withLogic$1$($fe5170bdd3625759$var$Component$21);
$fe5170bdd3625759$export$5217f316f51857f9.displayName = "BadgeV2Notification";
$fe5170bdd3625759$export$5217f316f51857f9.slotName = "jds_badge_v2_notification";
const $fe5170bdd3625759$var$sdl$1X = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-status-2.0.0",
        "name": "JDSBadgeV2Status",
        "layerName": "jds_badge_v2_status",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            {
                                "status-container": [
                                    "status-icon"
                                ]
                            }
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 26,
            "height": 26,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_8}"
        },
        "container": {
            "width": 24,
            "height": 24,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "gap": "{custom_5}"
        },
        "inner-container": {
            "width": 24,
            "height": 24,
            "justify-content": "{b_1}",
            "align-items": "{b_2}"
        },
        "status-container": {
            "width": 20,
            "height": 20,
            "hidden": false,
            "show": true,
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}",
            "border-radius": "{b_8}",
            "background-color": "{b_9}"
        },
        "status-icon": {
            "value": "ic_message_send",
            "color": "{b_10}",
            "size": "{s}"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{feedbackSuccess50}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "status-icon": {
                    "hidden": true
                }
            },
            "label": {
                "outer-container": {
                    "background-color": "{global.transparent}",
                    "width": ""
                },
                "container": {
                    "width": ""
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "label-container": {
                "outer-container": {
                    "border-radius": 6,
                    "width": "",
                    "height": 30,
                    "padding-left": 3,
                    "padding-right": 3
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}"
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "outer-container": {
                    "width": 10,
                    "height": 10
                },
                "container": {
                    "width": 8,
                    "height": 8
                },
                "inner-container": {
                    "width": 8,
                    "height": 8
                },
                "status-container": {
                    "width": 7,
                    "height": 7
                },
                "status-icon": {
                    "size": "{xxs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 12,
                    "height": 12
                },
                "status-container": {
                    "width": 10,
                    "height": 10
                },
                "status-icon": {
                    "size": "{custom_15}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "width": 13,
                    "height": 13
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "status-container": {
                    "width": 17,
                    "height": 17
                },
                "status-icon": {
                    "size": "{custom_19}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 28,
                    "height": 28
                },
                "status-container": {
                    "width": 23,
                    "height": 23
                },
                "status-icon": {
                    "size": "{custom_24}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 32,
                    "height": 32
                },
                "status-container": {
                    "width": 27,
                    "height": 27
                },
                "status-icon": {
                    "size": "{base}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 40,
                    "height": 40
                },
                "status-container": {
                    "width": 33,
                    "height": 33
                },
                "status-icon": {
                    "size": "{custom_18}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "status": {
            "error": {
                "status-container": {
                    "background-color": "{b_30}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{feedbackError50}"
                }
            },
            "warning": {
                "status-container": {
                    "background-color": "{b_31}"
                },
                "status-icon": {
                    "value": "ic_exclamation"
                },
                "label-jds-text": {
                    "color": "{feedbackWarning50}"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true
                },
                "status-container": {
                    "background-color": "{b_32}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{primaryGrey60}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                }
            }
        }
    },
    "combination": [
        {
            "label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": 2,
                        "padding-bottom": 2
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "status-container": {
                        "width": 24,
                        "height": 24
                    }
                }
            },
            "dot-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            },
            "label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 26
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 34
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 10,
                        "width": "",
                        "height": 38
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 12,
                        "width": "",
                        "height": 48,
                        "padding-left": 4,
                        "padding-right": 4
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{s}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                }
            },
            "dot-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            }
        },
        {
            "label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_61}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_62}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_63}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_64}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "dot-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_65}"
                    },
                    "status-container": {
                        "background-color": "{b_66}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_67}"
                    },
                    "status-container": {
                        "background-color": "{b_68}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_69}"
                    },
                    "status-container": {
                        "background-color": "{b_70}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_71}"
                    },
                    "status-container": {
                        "background-color": "{b_72}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "icon-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_73}"
                    },
                    "status-container": {
                        "background-color": "{b_74}"
                    },
                    "status-icon": {
                        "color": "{b_75}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_76}"
                    },
                    "status-container": {
                        "background-color": "{b_77}"
                    },
                    "status-icon": {
                        "color": "{b_78}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_79}"
                    },
                    "status-container": {
                        "background-color": "{b_80}"
                    },
                    "status-icon": {
                        "color": "{b_81}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_82}"
                    },
                    "status-container": {
                        "background-color": "{b_83}"
                    },
                    "status-icon": {
                        "color": "{b_84}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            }
        },
        {
            "true": {
                "label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "dot-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "icon-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "status"
        ],
        [
            "border",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "dot",
                    "label",
                    "dot-label",
                    "icon-label",
                    "label-container",
                    "dot-label-container",
                    "icon-label-container"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "status": {
                "values": [
                    "success",
                    "error",
                    "warning",
                    "disabled"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1_ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$20 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1X;
    const { kind: kind = "icon", size: size = "xtra-large", status: status = "success", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            status: status,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Status", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$87daca618cc26b9 = $fe5170bdd3625759$var$withLogic$1_($fe5170bdd3625759$var$Component$20);
$fe5170bdd3625759$export$87daca618cc26b9.displayName = "BadgeV2Status";
$fe5170bdd3625759$export$87daca618cc26b9.slotName = "jds_badge_v2_status";
const $fe5170bdd3625759$var$sdl$1W = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-1.0.0",
        "name": "JDSBottomFooter",
        "layerName": "jds_bottom_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "copyright-container": [
                    {
                        "logo-container": [
                            {
                                "jds-icon-container": [
                                    "jds-icon"
                                ]
                            }
                        ]
                    },
                    {
                        "copyright-text-container": [
                            "jds_link",
                            "jds-text"
                        ]
                    }
                ]
            },
            {
                "informational-links-container": [
                    "jds_bottom_footer_link_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-right": "{b_4}",
            "padding-bottom": "{b_5}",
            "padding-left": "{b_6}",
            "background": "{b_7}"
        },
        "jds_link": {
            "textAppearance": "body_xxs",
            "kind": "submenu",
            "hidden": true
        },
        "copyright-container": {
            "gap": "{b_8}",
            "flex-direction": "{b_9}",
            "align-items": "{b_10}",
            "flex": 1
        },
        "informational-links-container": {
            "flex-direction": "row",
            "align-items": "{b_11}",
            "gap": 10
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{secondary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "_hasLink": {
            "true": {
                "jds_link": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "width": "{b_12}"
                }
            },
            "mobile": {
                "container": {
                    "flex-direction": "{b_13}",
                    "justify-content": "{b_14}",
                    "align-items": "{b_15}",
                    "padding-top": 0,
                    "padding-right": "{b_16}",
                    "padding-bottom": "{b_17}",
                    "padding-left": "{b_18}",
                    "gap": "{b_19}"
                },
                "copyright-container": {
                    "flex-direction": "{b_20}",
                    "align-items": "{b_21}",
                    "gap": "{b_22}"
                }
            }
        }
    },
    "api": {
        "config": {
            "_hasLink": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "informational-links-container": {
                "value": {
                    "name": "informationalLinks",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "separator": "boolean"
                    }
                }
            },
            "copyright-text-container": {
                "value": {
                    "name": "copyright",
                    "type": "object",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "newTab": "boolean"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "copyright.title"
                },
                "href": {
                    "type": "string",
                    "name": "copyright.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "copyright.newTab"
                }
            },
            "jds_bottom_footer_link_item": {
                "title": {
                    "type": "string",
                    "name": "informationalLinks.title"
                },
                "href": {
                    "type": "string",
                    "name": "informationalLinks.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "informationalLinks.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "informationalLinks.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "string",
                    "name": "informationalLinks.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "informationalLinks.onClick"
                },
                "separator": {
                    "name": "informationalLinks.separator",
                    "type": "boolean"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "copyrightText"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "logo"
                },
                "ic": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "copyRightAriaLabel",
                    "ariaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "informational-links-container": {
                "name": "informationalLinks",
                "repeating": {
                    "ariaLabel": "bottomlinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "bottomlinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_footer_link_item": {
                "properties": {
                    "role": "informationalLinks.bottomlinkRole",
                    "ariaLabel": "informationalLinks.bottomlinkAriaLabel",
                    "ariaDescribedby": "informationalLinks.bottomlinkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1Z = (Component)=>(props)=>{
        const length = props.informationalLinks?.length;
        const informationalLinks = props.informationalLinks?.map((item, i)=>({
                ...item,
                separator: i !== length - 1
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            _hasLink: Boolean(props.copyright?.href),
            informationalLinks: informationalLinks
        });
    };
const $fe5170bdd3625759$var$Component$1$ = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1W;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSBottomFooter", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$72ab4ebd04fea6e2 = $fe5170bdd3625759$var$withLogic$1Z($fe5170bdd3625759$var$Component$1$);
$fe5170bdd3625759$export$72ab4ebd04fea6e2.displayName = "BottomFooter";
$fe5170bdd3625759$export$72ab4ebd04fea6e2.slotName = "jds_bottom_footer";
const $fe5170bdd3625759$var$sdl$1V = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-link-item-1.0.0",
        "name": "JDSBottomFooterLinkItem",
        "layerName": "jds_bottom_footer_link_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link",
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "gap": "{b_0}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "vertical"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_xxs"
        }
    },
    "variant": {
        "separator": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "separator": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "onClick"
                },
                "provider": {
                    "type": "object",
                    "name": "provider",
                    "platform": "react"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1_ = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1V;
    const { separator: separator = true, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            separator: separator,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomFooterLinkItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b592413d575db486 = $fe5170bdd3625759$var$withLogic$1Y($fe5170bdd3625759$var$Component$1_);
$fe5170bdd3625759$export$b592413d575db486.displayName = "BottomFooterLinkItem";
$fe5170bdd3625759$export$b592413d575db486.slotName = "jds_bottom_footer_link_item";
const $fe5170bdd3625759$var$sdl$1U = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-item-1.0.0",
        "name": "JDSBottomNavigationItem",
        "layerName": "jds_bottom_navigation_item"
    },
    "hierarchy": {
        "container": [
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "gap": "{b_4}",
            "opacity": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        }
    },
    "variant": {
        "showLabel": {
            "true": {
                "jds-text": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "jds-icon": {
                    "color": "{secondary50}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_5}"
                }
            }
        },
        "multiLine": {
            "true": {
                "jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "api": {
        "config": {
            "showLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                },
                "ic": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onItemClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1X = (Component)=>({ selectedIndex: selectedIndex, internalIndex: internalIndex, ...rest })=>{
        const active = typeof selectedIndex === "number" && internalIndex === selectedIndex;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                active: active,
                onChange: (ev)=>{
                    if (internalIndex) rest.onClick?.(ev, internalIndex);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Z = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1U;
    const { showLabel: showLabel = false, active: active = false, disabled: disabled = false, multiLine: multiLine = false, onItemClick: onItemClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            showLabel: showLabel,
            active: active,
            disabled: disabled,
            multiLine: multiLine,
            onItemClick: onItemClick,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigationItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f5e7567009f715b2 = $fe5170bdd3625759$var$withLogic$1X($fe5170bdd3625759$var$Component$1Z);
$fe5170bdd3625759$export$f5e7567009f715b2.displayName = "BottomNavigationItem";
$fe5170bdd3625759$export$f5e7567009f715b2.slotName = "jds_bottom_navigation_item";
const $fe5170bdd3625759$var$sdl$1T = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheet",
        "layerName": "jds_desktop_bottom_sheet",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_desktop_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "background-color": "{d_3}",
            "size": "{d_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "padding-right": 90,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_desktop_bottom_sheet_internal": {
            "close": true
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "transparent"
                },
                "popup-container": {
                    "background-color": "transparent"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_desktop_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                },
                "jds_desktop_bottom_sheet_internal": {
                    "close": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_desktop_bottom_sheet_internal": {
                "height": {
                    "type": "number",
                    "name": "height"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "step_label": {
                    "type": "string",
                    "name": "label"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_desktop_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onBack": "onBack"
            }
        },
        "a11y": {
            "jds_desktop_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$WINDOW = typeof window === "object" && window || void 0;
const $fe5170bdd3625759$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $fe5170bdd3625759$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$fe5170bdd3625759$var$WINDOW?.matchMedia && $fe5170bdd3625759$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $acw62.useState)(getValue);
        (0, $acw62.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$fe5170bdd3625759$var$Devices.breakpoints = $fe5170bdd3625759$var$defaultBreakpoints;
const $fe5170bdd3625759$var$sdl$1S = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheet",
        "layerName": "jds_mobile_bottom_sheet"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_mobile_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "background-color": "{m_4}",
            "opacity": "{m_5}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_6}",
                "timing-function": "{m_7}"
            }
        },
        "jds_mobile_bottom_sheet_internal": {
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "{m_8}"
                },
                "popup-container": {
                    "background-color": "{m_9}"
                },
                "jds_mobile_bottom_sheet_internal": {
                    "kind": "passive"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{m_10}",
                    "transition": {
                        "timing-function": "{m_11}"
                    }
                },
                "jds_mobile_bottom_sheet_internal": {
                    "close": false
                }
            }
        },
        "controlType": {
            "stepper": {
                "jds_mobile_bottom_sheet_internal": {
                    "controlType": "stepper"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "primaryCtaDisabled": true
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "secondaryCtaDisabled": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_mobile_bottom_sheet_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "height",
                    "function": true
                },
                "stepLabel": {
                    "type": "string",
                    "name": "label"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_mobile_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onBack": "onBack",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onAppear": {
                    "name": "_onContainerAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "jds_mobile_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useEscapeClose = (handler, condition)=>{
    const escapeListener = (0, $acw62.useCallback)(()=>handler(), [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("keydown", (ev)=>{
            if ((condition || typeof condition === "undefined") && ev.key === "Escape") escapeListener();
        });
        return ()=>{
            document.removeEventListener("keydown", escapeListener);
        };
    }, [
        condition,
        escapeListener
    ]);
};
const $fe5170bdd3625759$var$useTransition = (externalOpen, cb, duration = 50)=>{
    const [open, setOpen] = (0, $acw62.useState)(externalOpen);
    const [internalOpen, setInternalOpen] = (0, $acw62.useState)(externalOpen);
    (0, $acw62.useEffect)(()=>{
        if (externalOpen) {
            setOpen(true);
            setTimeout(()=>{
                setInternalOpen(true);
            }, 10);
        } else {
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
            }, 500);
        }
    }, [
        externalOpen
    ]);
    return {
        className: internalOpen && open ? "expanded" : "",
        open: internalOpen || open,
        close: ()=>{
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
                cb?.();
            }, duration);
        }
    };
};
const $fe5170bdd3625759$var$PROP_MAP$s = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR$1 = "div.j-JDSMobileBottomSheetInternal-root-container";
const $fe5170bdd3625759$var$withLogic$1W = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$s);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const { open: open, className: className, close: closeFn } = $fe5170bdd3625759$var$useTransition(Boolean(!close), ()=>{
            if (allowClose) onClose?.();
        });
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const bottomsheetRef = element?.querySelector($fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR$1);
        (0, $acw62.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: !open,
                className: className,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Y = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1S;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheet", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$BottomSheet$1 = $fe5170bdd3625759$var$withLogic$1W($fe5170bdd3625759$var$Component$1Y);
$fe5170bdd3625759$var$BottomSheet$1.displayName = "BottomSheet";
$fe5170bdd3625759$var$BottomSheet$1.slotName = "jds_mobile_bottom_sheet";
const $fe5170bdd3625759$var$PROP_MAP$r = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryclick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryclick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR = "div.j-JDSDesktopBottomSheetInternal-root-container";
const $fe5170bdd3625759$var$withLogic$1V = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$r);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const bottomsheetRef = element?.querySelector($fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1X = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1T;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheet", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2058ef1a26004a97 = $fe5170bdd3625759$var$withLogic$1V($fe5170bdd3625759$var$Component$1X);
$fe5170bdd3625759$export$2058ef1a26004a97.displayName = "BottomSheet";
$fe5170bdd3625759$export$2058ef1a26004a97.slotName = "jds_desktop_bottom_sheet";
const $fe5170bdd3625759$var$sdl$1R = {
    "metadata": {
        "version": "1.0.0",
        "id": "button-1.0.0",
        "name": "JDSButton",
        "layerName": "jds_button",
        "description": "A button is an interactive control that allows the user to perform a specific action.",
        "usage": "A button accepts a user choice, response or command."
    },
    "hierarchy": {
        "container": [
            {
                "left-container": [
                    "left-icon",
                    "jds-text"
                ]
            },
            "right-icon",
            "loader"
        ]
    },
    "base": {
        "container": {
            "opacity": "{b_0}",
            "background-color": "{b_1}",
            "flex-direction": "{b_2}",
            "align-items": "{b_3}",
            "justify-content": "{b_4}",
            "border-radius": "{b_5}",
            "border-width": "{b_6}",
            "border-color": "{b_7}",
            "gap": "{b_8}",
            "behavior": {
                "hover": {
                    "background-color": "{b_10}"
                },
                "active": {
                    "background-color": "{b_11}"
                },
                "focus": {
                    "border-width": "{b_12}",
                    "border-color": "{b_13}"
                }
            }
        },
        "left-container": {
            "hidden": false,
            "flex-direction": "{b_14}",
            "align-items": "{b_15}",
            "justify-content": "{b_16}",
            "gap": "{b_17}",
            "flex-fill-android": false
        },
        "loader": {
            "color": "{b_18}",
            "background-color": "{b_19}",
            "border-width": "{b_20}",
            "hidden": true,
            "opacity": "{b_21}",
            "size": "{b_22}"
        },
        "left-icon": {
            "size": "{b_23}",
            "color": "{b_24}",
            "hidden": false
        },
        "right-icon": {
            "size": "{b_25}",
            "color": "{b_26}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primaryInverse}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "variant": {
        "_hasLabel": {
            "false": {
                "left-container": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "justify-content": "{b_28}",
                    "width": "{b_27}",
                    "gap": 0
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_29}"
                }
            }
        },
        "loading": {
            "true": {
                "container": {
                    "disabled": true
                },
                "loader": {
                    "hidden": false
                },
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasRightIcon": {
            "false": {
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasLeftIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "primary": {
                "normal": {
                    "left-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_30}"
                            }
                        }
                    },
                    "right-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_31}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary30}"
                            }
                        }
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_32}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_33}"
                            },
                            "active": {
                                "background-color": "{b_34}"
                            },
                            "focus": {
                                "border-color": "{b_35}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_36}"
                    },
                    "left-icon": {
                        "color": "{b_37}",
                        "behavior": {
                            "hover": {
                                "color": "{b_38}"
                            },
                            "active": {
                                "color": "{b_39}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_41}",
                        "behavior": {
                            "hover": {
                                "color": "{b_40}"
                            },
                            "active": {
                                "color": "{b_42}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackError20}"
                            }
                        }
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_43}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_44}"
                            },
                            "active": {
                                "background-color": "{b_45}"
                            },
                            "focus": {
                                "border-color": "{b_46}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_47}"
                    },
                    "left-icon": {
                        "color": "{b_48}",
                        "behavior": {
                            "hover": {
                                "color": "{b_49}"
                            },
                            "active": {
                                "color": "{b_50}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_51}",
                        "behavior": {
                            "hover": {
                                "color": "{b_52}"
                            },
                            "active": {
                                "color": "{b_53}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackSuccess20}"
                            }
                        }
                    }
                }
            },
            "secondary": {
                "normal": {
                    "container": {
                        "background-color": "{b_54}",
                        "border-width": "{b_55}",
                        "border-color": "{b_56}",
                        "behavior": {
                            "hover": {
                                "border-color": "{b_57}",
                                "background-color": "{b_58}"
                            },
                            "active": {
                                "background-color": "{b_59}",
                                "border-color": "{b_60}"
                            },
                            "focus": {
                                "border-color": "{b_61}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_62}"
                    },
                    "left-icon": {
                        "color": "{b_63}"
                    },
                    "right-icon": {
                        "color": "{b_64}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_65}",
                        "border-width": "{b_66}",
                        "border-color": "{b_67}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_68}",
                                "border-color": "{b_69}"
                            },
                            "focus": {
                                "border-color": "{b_70}",
                                "border-width": "{b_71}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_72}"
                    },
                    "left-icon": {
                        "color": "{b_73}"
                    },
                    "right-icon": {
                        "color": "{b_74}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_75}",
                        "border-width": "{b_76}",
                        "border-color": "{b_77}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_78}",
                                "border-color": "{b_79}"
                            },
                            "focus": {
                                "border-color": "{b_80}",
                                "border-width": "{b_81}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_82}"
                    },
                    "left-icon": {
                        "color": "{b_83}"
                    },
                    "right-icon": {
                        "color": "{b_84}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            },
            "tertiary": {
                "normal": {
                    "container": {
                        "border-width": "{b_9}",
                        "background-color": "{b_85}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_86}"
                            },
                            "active": {
                                "background-color": "{b_87}"
                            },
                            "focus": {
                                "border-color": "{b_88}",
                                "background-color": "{b_89}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_90}"
                    },
                    "left-icon": {
                        "color": "{b_91}"
                    },
                    "right-icon": {
                        "color": "{b_92}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_93}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_94}"
                            },
                            "active": {
                                "background-color": "{b_95}"
                            },
                            "focus": {
                                "border-color": "{b_96}",
                                "border-width": "{b_97}",
                                "background-color": "{b_98}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_99}"
                    },
                    "left-icon": {
                        "color": "{b_100}"
                    },
                    "right-icon": {
                        "color": "{b_101}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_102}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_103}"
                            },
                            "focus": {
                                "border-color": "{b_104}",
                                "border-width": "{b_105}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_106}"
                    },
                    "left-icon": {
                        "color": "{b_107}"
                    },
                    "right-icon": {
                        "color": "{b_108}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{b_109}",
                        "padding-right": "{b_110}",
                        "padding-bottom": "{b_111}",
                        "padding-left": "{b_112}"
                    },
                    "left-icon": {
                        "size": "{b_113}"
                    },
                    "right-icon": {
                        "size": "{b_114}"
                    },
                    "loader": {
                        "size": "{b_115}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-top": "{b_116}",
                        "padding-right": "{b_117}",
                        "padding-bottom": "{b_118}",
                        "padding-left": "{b_119}"
                    },
                    "left-icon": {
                        "size": "{b_120}"
                    },
                    "right-icon": {
                        "size": "{b_121}"
                    },
                    "loader": {
                        "size": "{b_122}"
                    }
                },
                "large": {
                    "container": {
                        "padding-top": "{b_123}",
                        "padding-left": "{b_124}",
                        "padding-bottom": "{b_125}",
                        "padding-right": "{b_126}"
                    },
                    "left-icon": {
                        "size": "{b_127}"
                    },
                    "right-icon": {
                        "size": "{b_128}"
                    },
                    "loader": {
                        "size": "{b_129}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "min-height": "{b_130}",
                        "min-width": "{b_131}"
                    },
                    "left-icon": {
                        "size": "{b_132}"
                    },
                    "right-icon": {
                        "size": "{b_133}"
                    },
                    "loader": {
                        "size": "{b_134}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "min-height": "{b_135}",
                        "min-width": "{b_136}"
                    },
                    "left-icon": {
                        "size": "{b_137}"
                    },
                    "right-icon": {
                        "size": "{b_138}"
                    },
                    "loader": {
                        "size": "{b_139}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "min-height": 56,
                        "min-width": 56
                    },
                    "left-icon": {
                        "size": "{b_140}"
                    },
                    "right-icon": {
                        "size": "{b_141}"
                    },
                    "loader": {
                        "size": "{b_142}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "true": {
                        "false": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_143}"
                                }
                            },
                            "true": {
                                "container": {
                                    "justify-content": "{b_144}"
                                }
                            }
                        }
                    }
                },
                "false": {
                    "false": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_145}"
                                }
                            }
                        },
                        "false": {
                            "true": {
                                "container": {
                                    "justify-content": "{b_146}"
                                }
                            }
                        }
                    },
                    "true": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_147}"
                                }
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "fullWidth",
            "_hasRightIcon",
            "_hasLeftIcon",
            "_hasLabel",
            "loading"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of Button which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "it can be used to control the size of Button."
            },
            "state": {
                "values": [
                    "normal",
                    "destructive",
                    "positive"
                ],
                "doc_description": "It can be used to change the state of Button."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to make Button full-width."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Button."
            },
            "_hasRightIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLeftIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "loading": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to add loading spinner to the right of label in Button."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "iconLeft",
                    "doc_description": "It can be used to add icon to the left of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It adds icon to the right of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Button."
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": "ariaExpanded",
                    "aria-controls": "ariaControls"
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1U = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const hasLabel = Boolean(props.children || props.title || props.label);
        if (props.children) console.warn("children prop is deprecated. Use label instead");
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                label: props.children || props.label || props.title,
                _hasRightIcon: Boolean(props.icon),
                _hasLabel: hasLabel,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    });
const $fe5170bdd3625759$var$Component$1W = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1R;
    const { kind: kind = "primary", size: size = "medium", state: state = "normal", fullWidth: fullWidth = false, disabled: disabled = false, loading: loading = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            state: state,
            fullWidth: fullWidth,
            disabled: disabled,
            loading: loading,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$353f5b6fc5456de1 = $fe5170bdd3625759$var$withLogic$1U($fe5170bdd3625759$var$Component$1W);
$fe5170bdd3625759$export$353f5b6fc5456de1.displayName = "Button";
$fe5170bdd3625759$export$353f5b6fc5456de1.slotName = "jds_button";
const $fe5170bdd3625759$var$sdl$1Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-1.0.0",
        "name": "JDSCarouselPagination",
        "layerName": "jds_carousel_pagination"
    },
    "hierarchy": {
        "container": [
            "jds_carousel_pagination_item"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "padding-top": "{c_4}",
            "padding-bottom": "{c_6}"
        },
        "jds_carousel_pagination_item": {
            "density": "relaxed"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_7}"
                },
                "jds_carousel_pagination_item": {
                    "density": "condensed"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "active": "boolean",
                        "kind": "JDSCarouselPaginationItem.kind"
                    }
                }
            },
            "jds_carousel_pagination_item": {
                "active": {
                    "type": "boolean",
                    "name": "items.active"
                },
                "kind": {
                    "type": "JDSCarouselPaginationItem.kind",
                    "name": "items.kind"
                }
            }
        },
        "events": {
            "jds_carousel_pagination_item": {
                "onDotClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getPaginationItemKind(currentIndex, kind, visibleArray, selectedIndex, total) {
    if (kind !== "diminishing") return "normal";
    if (visibleArray[0] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 1] === currentIndex && selectedIndex < total - 3) return "tail_dot_small";
    if (visibleArray[1] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 2] === currentIndex && selectedIndex < total - 3) return "tail_dot_large";
    return "normal";
}
const $fe5170bdd3625759$var$getVisibleItems = (selectedIndex, total)=>{
    let leftCount, rightCount;
    if (selectedIndex === total - 1) {
        leftCount = 6;
        rightCount = 0;
    } else if (selectedIndex === total - 2) {
        leftCount = 5;
        rightCount = 2;
    } else {
        leftCount = Math.min(selectedIndex, 4);
        leftCount = leftCount < 0 ? 0 : leftCount;
        rightCount = 7 - leftCount;
        rightCount = rightCount > total ? total : rightCount;
    }
    let left = Array.from({
        length: leftCount + 1
    }).map((_, i)=>selectedIndex - i);
    left.reverse();
    const right = Array.from({
        length: rightCount
    }).map((_, i)=>selectedIndex + i);
    return Array.from(/* @__PURE__ */ new Set([
        ...left,
        selectedIndex,
        ...right
    ]));
};
const $fe5170bdd3625759$var$withLogic$1T = (Component)=>(props)=>{
        const { selectedIndex: selectedIndex = 0, count: count, kind: kind } = props;
        const visibleItems = $fe5170bdd3625759$var$getVisibleItems(selectedIndex, count);
        const items = Array.from({
            length: count
        }).map((_, index)=>{
            const itemKind = $fe5170bdd3625759$var$getPaginationItemKind(index, count > 7 ? "diminishing" : "normal", visibleItems, selectedIndex, count);
            const isHidden = count > 7 && !visibleItems.includes(index);
            return {
                active: selectedIndex === index,
                kind: itemKind,
                internalClasses: [
                    isHidden ? "hide" : ""
                ].join(" ")
            };
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                position: "relative"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    items: items
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$1V = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Q;
    const { density: density = "undefined", onDotClick: onDotClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPagination", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$CarouselPagination = $fe5170bdd3625759$var$withLogic$1T($fe5170bdd3625759$var$Component$1V);
$fe5170bdd3625759$var$CarouselPagination.displayName = "CarouselPagination";
$fe5170bdd3625759$var$CarouselPagination.slotName = "jds_carousel_pagination";
const $fe5170bdd3625759$var$sdl$1P = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-item-1.0.0",
        "name": "JDSCarouselPaginationItem",
        "layerName": "jds_carousel_pagination_item",
        "internal": true
    },
    "hierarchy": {
        "container": []
    },
    "base": {
        "container": {
            "width": "{c_0}",
            "height": "{c_1}",
            "background-color": "{c_2}",
            "opacity": "{c_3}",
            "border-radius": "{c_4}",
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{c_5}",
                    "opacity": "{c_6}"
                },
                "active": {
                    "background-color": "{c_7}",
                    "opacity": "{c_8}"
                }
            }
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "height": "{c_9}"
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "opacity": "{c_10}",
                    "behavior": {
                        "hover": {
                            "background-color": "{c_11}"
                        },
                        "active": {
                            "background-color": "{c_12}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "container": {
                    "hidden": true
                }
            },
            "none": {
                "container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "condensed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_18}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_19}",
                            "height": "{c_20}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_21}",
                            "height": "{c_22}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_23}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_24}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_25}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            },
            "relaxed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_13}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_14}",
                            "height": "{c_15}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_16}",
                            "height": "{c_17}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_26}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_27}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_28}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "density",
            "active",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "tail_dot_large",
                    "tail_dot_small",
                    "invisible"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        },
        "data": {}
    }
};
const $fe5170bdd3625759$var$withLogic$1S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onDotClick: ()=>props.onDotClick?.(props.internalIndex),
                className: props.internalClasses
            }
        });
    };
const $fe5170bdd3625759$var$Component$1U = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1P;
    const { kind: kind = "normal", density: density = "relaxed", active: active = false, onDotClick: onDotClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            density: density,
            active: active,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPaginationItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$CarouselPaginationItem = $fe5170bdd3625759$var$withLogic$1S($fe5170bdd3625759$var$Component$1U);
$fe5170bdd3625759$var$CarouselPaginationItem.displayName = "CarouselPaginationItem";
$fe5170bdd3625759$var$CarouselPaginationItem.slotName = "jds_carousel_pagination_item";
const $fe5170bdd3625759$var$sdl$1O = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-slide-1.0.0",
        "name": "JDSCarouselSlide",
        "layerName": "jds_carousel_slide"
    },
    "hierarchy": {
        "container": [
            "slide-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "enter-animation-name": "slideHorizontallyToLeft",
            "exit-animation-name": "slideHorizontallyToLeft",
            "padding-left": "{xxs}",
            "padding-right": "{xxs}",
            "web-cursor": "pointer"
        }
    },
    "variant": {
        "active": {
            "true": {
                "container": {
                    "hidden": false
                }
            }
        },
        "forward": {
            "false": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToRight",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "padding-left": 0,
                    "padding-right": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "forward": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "tablet",
                    "desktop"
                ]
            }
        },
        "children": {
            "slide-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            }
        },
        "data": {}
    }
};
const $fe5170bdd3625759$var$makeClass = (classes)=>classes.filter((e)=>e).join(" ").trim();
const $fe5170bdd3625759$var$setCSSVar = (obj)=>{
    Object.keys(obj).forEach((key)=>obj[key] === void 0 && delete obj[key]);
    return obj;
};
const $fe5170bdd3625759$var$getPlatform = ()=>{
    if ($fe5170bdd3625759$var$Devices.isMobile()) return "mobile";
    if ($fe5170bdd3625759$var$Devices.isTablet()) return "tablet";
    return "desktop";
};
const $fe5170bdd3625759$var$withLogic$1R = (Component)=>(props)=>{
        const internalProps = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                active: true,
                platform: $fe5170bdd3625759$var$getPlatform(),
                onPointerDown: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchdown"
                    });
                },
                onPointerMove: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchmove"
                    });
                },
                onPointerUp: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchup"
                    });
                },
                onDragStart: (ev)=>{
                    ev.preventDefault();
                },
                onDragEnd: (ev)=>{
                    ev.preventDefault();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1T = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1O;
    const { active: active = false, forward: forward = true, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            active: active,
            forward: forward,
            onClick: onClick,
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselSlide", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cabb5ccfbd60cbd4 = $fe5170bdd3625759$var$withLogic$1R($fe5170bdd3625759$var$Component$1T);
$fe5170bdd3625759$export$cabb5ccfbd60cbd4.displayName = "CarouselSlide";
$fe5170bdd3625759$export$cabb5ccfbd60cbd4.slotName = "jds_carousel_slide";
const $fe5170bdd3625759$var$sdl$1N = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-block-1.0.0",
        "name": "JDSContentBlock",
        "layerName": "jds_content_block"
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-container": [
                    {
                        "caption-container": [
                            "caption-slot"
                        ]
                    },
                    "title-jds-text",
                    "description-jds-text",
                    {
                        "children-container": [
                            "children-slot"
                        ]
                    }
                ]
            },
            {
                "button-container": [
                    "primary-jds_button",
                    "secondary-jds_button",
                    "primary-inverted-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{c_0}",
            "align-items": "{c_1}",
            "justify-content": "{c_2}",
            "width": "{c_3}",
            "gap": "{m}"
        },
        "inner-container": {
            "flex-direction": "{c_4}",
            "align-items": "{c_5}",
            "justify-content": "{c_6}"
        },
        "caption-container": {
            "padding-bottom": "{c_8}",
            "hidden": false
        },
        "children-container": {
            "hidden": false
        },
        "button-container": {
            "flex-direction": "{c_12}",
            "gap": "{c_14}"
        },
        "primary-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": false
        },
        "secondary-jds_button": {
            "kind": "secondary",
            "size": "small"
        },
        "primary-inverted-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": true
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_9}"
        },
        "description-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_10}"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-small": {
                "title-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "small": {
                "title-jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}",
                    "padding-bottom": "{c_15}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "medium": {
                "caption-container": {
                    "padding-bottom": "{c_16}"
                },
                "button-container": {
                    "gap": "{c_18}"
                },
                "primary-jds_button": {
                    "size": "medium"
                },
                "secondary-jds_button": {
                    "size": "medium"
                },
                "primary-inverted-jds_button": {
                    "size": "medium"
                },
                "title-jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}",
                    "padding-bottom": "{c_17}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "large": {
                "caption-container": {
                    "padding-bottom": "{c_19}"
                },
                "button-container": {
                    "gap": "{c_22}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}",
                    "padding-bottom": "{c_20}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "xtra-large": {
                "caption-container": {
                    "padding-bottom": "{c_23}"
                },
                "button-container": {
                    "gap": "{c_26}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}",
                    "padding-bottom": "{c_24}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            }
        },
        "invertCTA": {
            "true": {
                "primary-jds_button": {
                    "hidden": true
                },
                "primary-inverted-jds_button": {
                    "hidden": false
                }
            }
        },
        "ctaWrap": {
            "vertical": {
                "button-container": {
                    "flex-direction": "{c_27}"
                },
                "primary-jds_button": {
                    "fullWidth": true
                },
                "secondary-jds_button": {
                    "fullWidth": true
                },
                "primary-inverted-jds_button": {
                    "fullWidth": true
                }
            }
        },
        "shouldOverrideColor": {
            "true": {
                "title-jds-text": {
                    "color": "{global.white}"
                },
                "description-jds-text": {
                    "color": "{global.white}"
                }
            }
        },
        "singleButton": {
            "false": {
                "inner-container": {
                    "width": "{c_28}"
                },
                "button-container": {
                    "width": "{c_29}"
                }
            }
        },
        "isTertiary": {
            "true": {
                "secondary-jds_button": {
                    "kind": "tertiary"
                }
            }
        },
        "_hasCaptionSlot": {
            "false": {
                "caption-container": {
                    "hidden": true
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "description-jds-text": {
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "_hasDescription": {
            "false": {
                "description-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "desktop": {
                "medium": {
                    "title-jds-text": {
                        "padding-bottom": "{c_30}"
                    }
                },
                "large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_31}"
                    }
                },
                "xtra-large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_32}"
                    }
                }
            }
        },
        {
            "true": {
                "xtra-xtra-small": {
                    "root-container": {
                        "flex-direction": "{c_33}",
                        "justify-content": "{c_34}",
                        "align-items": "{c_35}"
                    },
                    "button-container": {
                        "flex-direction": "{c_36}",
                        "justify-content": "{c_37}",
                        "align-items": "{c_38}"
                    },
                    "inner-container": {
                        "flex": 1
                    },
                    "primary-jds_button": {
                        "hidden": false
                    },
                    "secondary-jds_button": {
                        "hidden": true
                    },
                    "primary-inverted-jds_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "false": {
                "false": {
                    "title-jds-text": {
                        "padding-bottom": "{custom_5}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "size"
        ],
        [
            "singleButton",
            "size"
        ],
        [
            "_hasChildrenSlot",
            "_hasDescription"
        ]
    ],
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ],
                "doc_description": "It can be used to control the size of ContentBlock."
            },
            "ctaWrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "It can be used to either wrap the primary button, secondary button horizontally or vertically."
            },
            "invertCTA": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It inverts the order of the CTAs if true."
            },
            "shouldOverrideColor": {
                "values": [
                    false,
                    true
                ]
            },
            "singleButton": {
                "values": [
                    false,
                    true
                ]
            },
            "isTertiary": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCaptionSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "secondary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "primary-inverted-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of ContentBlock."
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the ContentBlock."
                }
            }
        },
        "children": {
            "caption-slot": {
                "name": "caption",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1,
                "doc_description": "It displays the header of the ContentBlock. Can be 'badge', 'text', 'tag'."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "primary-jds_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-inverted-jds_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "primary-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "primary-inverted-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$2 = [
    "m",
    "l",
    "xl",
    "s",
    "xs",
    "xxs"
];
const $fe5170bdd3625759$var$PROP_MAP$q = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$2.includes(props.size)) console.warn($fe5170bdd3625759$var$legacySizes$2.join(","), "are deprecated. Use sizes staring with xtra, large, small");
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.onPrimaryClick || props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.onSecondaryClick || props.secondaryCTA?.onClick
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$sizeMap = {
    xxs: "small",
    xs: "small",
    s: "small",
    m: "medium",
    l: "large",
    xl: "xtra-large",
    "xtra-small": "small",
    "xtra-xtra-small": "small",
    "xtra-large": "large"
};
const $fe5170bdd3625759$var$withLogic$1Q = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$q);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                caption: props.caption ? (0, $acw62.cloneElement)(props.caption, {
                    size: $fe5170bdd3625759$var$sizeMap[props.size] || props.size
                }) : void 0,
                _hasCaptionSlot: Boolean(props.caption),
                _hasChildrenSlot: Boolean(props.children),
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1S = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1N;
    const { size: size = "xtra-small", ctaWrap: ctaWrap = "horizontal", invertCTA: invertCTA = false, shouldOverrideColor: shouldOverrideColor = false, singleButton: singleButton = false, isTertiary: isTertiary = false, onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ctaWrap: ctaWrap,
            invertCTA: invertCTA,
            shouldOverrideColor: shouldOverrideColor,
            singleButton: singleButton,
            isTertiary: isTertiary,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentBlock", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$eb38b3b9c7f5f31b = $fe5170bdd3625759$var$withLogic$1Q($fe5170bdd3625759$var$Component$1S);
$fe5170bdd3625759$export$eb38b3b9c7f5f31b.displayName = "ContentBlock";
$fe5170bdd3625759$export$eb38b3b9c7f5f31b.slotName = "jds_content_block";
const $fe5170bdd3625759$var$JDSDatepickerDesktop = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktop",
        "layerName": "jds_datepicker_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_datepicker_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "hidden": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "hidden": false,
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_datepicker_desktop_internal": {
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "yearLoadCount": {
                    "type": "number",
                    "platform": "web",
                    "name": "yearLoadCount"
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                },
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_datepicker_desktop_internal": {
                "onClose": "onClose",
                "onSelect": "onSelect"
            }
        },
        "a11y": {
            "jds_datepicker_desktop_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1M = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobile",
        "layerName": "jds_datepicker_mobile"
    },
    "hierarchy": {
        "popup": [
            "jds_datepicker_mobile_internal"
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "jds_datepicker_mobile_internal": {
            "state": "default",
            "open": false
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "month_view"
                }
            },
            "year_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "year_view"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_datepicker_mobile_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_mobile_internal": {
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "calendarDays": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "_calendarDays"
                },
                "calendarRows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "_calendarRows"
                },
                "confirmDate": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "jds_datepicker_mobile_internal": {
                "onClose": "onClose",
                "onConfirm": "onConfirm"
            }
        },
        "a11y": {
            "jds_datepicker_mobile_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel",
                    "confirmAriaLabel": "confirmAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DatePickerWidth = 384;
const $fe5170bdd3625759$var$setPositions$1 = (position = "left-end", container, trigger)=>{
    if (!trigger || !container) return {
        left: 0,
        top: 0
    };
    const triggerBounds = trigger.getBoundingClientRect();
    const triggerOffsetTop = trigger.getBoundingClientRect()?.top;
    const triggerOffsetLeft = trigger.getBoundingClientRect()?.left;
    const bodyHeight = document.body.clientHeight;
    const bodyWidth = document.body.clientWidth;
    const datePickerHeight = 484;
    let left = 0;
    let top;
    let height;
    let width;
    switch(position){
        case "right-start":
        case "left-start":
            top = triggerOffsetTop;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "right-end":
        case "left-end":
            top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top < 0) top = triggerOffsetTop;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "right":
        case "left":
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2 < 0) top = triggerOffsetTop;
            if (triggerOffsetTop + triggerBounds.height / 2 + datePickerHeight / 2 > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "top-start":
        case "bottom-start":
            left = triggerOffsetLeft;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "top-end":
        case "bottom-end":
            left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            break;
        case "top":
        case "bottom":
            left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            break;
    }
    switch(position){
        case "right":
        case "right-start":
        case "right-end":
            left = triggerOffsetLeft + triggerBounds.width;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "left":
        case "left-start":
        case "left-end":
            left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width;
            break;
        case "top-start":
        case "top":
        case "top-end":
            top = triggerOffsetTop - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height;
            break;
        case "bottom-start":
        case "bottom":
        case "bottom-end":
            top = triggerOffsetTop + triggerBounds.height;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop - datePickerHeight;
            break;
        default:
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            left = triggerOffsetLeft + triggerBounds.width;
    }
    return {
        left: left,
        top: top,
        maxHeight: height,
        maxWidth: width
    };
};
const $fe5170bdd3625759$var$useToggle = (value, condition, listener)=>{
    const [selected, setSelected] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        setSelected(value);
    }, [
        value
    ]);
    const toggle = (e)=>{
        listener?.(e);
        if (condition || typeof condition === "undefined") setSelected(!selected);
    };
    const close = ()=>{
        if (selected) setSelected(false);
    };
    return {
        selected: selected,
        toggle: toggle,
        close: close
    };
};
const $fe5170bdd3625759$var$DEBOUNCE_TIME = 400;
const $fe5170bdd3625759$var$DATEPICKERINTERNAL_SELECTOR = "div.j-JDSDatepickerDesktopInternal-container";
const $fe5170bdd3625759$var$withLogic$1P = (Component)=>(props)=>{
        const { onClose: onClose, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const isMobile = $fe5170bdd3625759$var$Devices.isMobile();
        const [containerElement, setContainerElement] = (0, $acw62.useState)();
        const anchorRef = (0, $acw62.useRef)(null);
        const trigger = props.triggerRef || anchorRef;
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(!closeProp, true, props.onClose);
        const [coords, setCoords] = (0, $acw62.useState)({
            left: 0,
            top: 0
        });
        const calculateInitialPosition = (0, $acw62.useCallback)(()=>{
            if (trigger.current && containerElement) {
                const { left: left, top: top } = $fe5170bdd3625759$var$setPositions$1(props.position, containerElement, trigger.current);
                setCoords({
                    left: left,
                    top: top || 0
                });
            }
        }, [
            trigger,
            containerElement,
            props.position
        ]);
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(selected);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender) return;
            calculateInitialPosition();
        }, [
            shouldRender,
            calculateInitialPosition
        ]);
        const containerRef = (0, $acw62.useCallback)((ref)=>{
            setContainerElement(ref);
        }, []);
        (0, $acw62.useEffect)(()=>{
            const resizeObserver = new ResizeObserver(()=>{
                calculateInitialPosition();
            });
            if (trigger.current) resizeObserver.observe(trigger.current);
            return ()=>{
                if (trigger.current) resizeObserver.unobserve(trigger.current);
            };
        }, [
            trigger,
            calculateInitialPosition
        ]);
        (0, $acw62.useEffect)(()=>{
            window?.addEventListener("resize", $fe5170bdd3625759$var$debounce(calculateInitialPosition, $fe5170bdd3625759$var$DEBOUNCE_TIME));
            return ()=>window?.removeEventListener("resize", $fe5170bdd3625759$var$debounce(calculateInitialPosition, $fe5170bdd3625759$var$DEBOUNCE_TIME));
        }, [
            calculateInitialPosition
        ]);
        const scrollCloseListener = (0, $acw62.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {}), ...restChildren] = (0, $acw62.Children).toArray(props.children);
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (selected) setShouldRender(true);
            else timeout = setTimeout(()=>{
                setShouldRender(false);
                setCoords(null);
            }, $fe5170bdd3625759$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timeout);
        }, [
            selected
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender || !selected) return;
            const timer = setTimeout(()=>{
                const datePickerInternalRef = document.querySelector($fe5170bdd3625759$var$DATEPICKERINTERNAL_SELECTOR);
                datePickerInternalRef?.setAttribute("tabindex", "0");
                datePickerInternalRef?.focus();
            }, $fe5170bdd3625759$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timer);
        }, [
            shouldRender,
            selected
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (selected && event.key === "Escape") {
                    close();
                    onClose?.();
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            close,
            onClose,
            selected
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                shouldRender && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        open: selected,
                        triggerRef: containerRef,
                        onClose: ()=>{
                            if (selected) toggle();
                            onClose?.();
                        },
                        calendarData: {
                            disabledDates: props.disabledDates,
                            dateFilter: props.dateFilter,
                            min: props.min,
                            max: props.max
                        },
                        onClick: (ev)=>ev.stopPropagation(),
                        offsetX: coords?.left,
                        offsetY: coords?.top,
                        _onMonthSelect: (i)=>{
                            props.onMonthSelect?.();
                        },
                        _onYearSelect: (i)=>{
                            props.onYearSelect?.();
                        },
                        style: isMobile || coords ? void 0 : {
                            visibility: "hidden"
                        }
                    }
                }),
                (0, $acw62.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1R = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $fe5170bdd3625759$var$JDSDatepickerDesktop : $fe5170bdd3625759$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktop", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5109c6dd95d8fb00 = $fe5170bdd3625759$var$withLogic$1P($fe5170bdd3625759$var$Component$1R);
$fe5170bdd3625759$export$5109c6dd95d8fb00.displayName = "DatePicker";
$fe5170bdd3625759$export$5109c6dd95d8fb00.slotName = "jds_datepicker_desktop";
const $fe5170bdd3625759$var$sdl$1L = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-button-1.0.0",
        "name": "JDSDatepickerButton",
        "layerName": "jds_datepicker_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "disabled": false,
            "height": "{d_0}",
            "border-radius": "{d_2}",
            "background-color": "{d_3}",
            "border-width": "{d_4}",
            "border-color": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "padding-right": "{d_10}",
            "padding-left": "{d_11}",
            "behavior": {
                "hover": {
                    "border-color": "{d_12}"
                },
                "focus": {
                    "border-color": "{d_13}",
                    "border-width": "{d_14}"
                },
                "active": {
                    "border-color": "{d_15}",
                    "background-color": "{d_16}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primary60}",
            "value": "ic_chevron_down",
            "hidden": false,
            "ic": "ic_chevron_down"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "state": {
            "selected": {
                "container": {
                    "background-color": "{d_17}",
                    "border-color": "{d_18}"
                },
                "jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_19}",
                    "opacity": "{d_20}"
                }
            },
            "text_only": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "disabled",
                    "text_only"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1O = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaExpanded: props.state === "selected" ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Q = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1L;
    const { state: state = "default", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$395dd20d84297b30 = $fe5170bdd3625759$var$withLogic$1O($fe5170bdd3625759$var$Component$1Q);
$fe5170bdd3625759$export$395dd20d84297b30.displayName = "DatepickerButton";
$fe5170bdd3625759$export$395dd20d84297b30.slotName = "jds_datepicker_button";
const $fe5170bdd3625759$var$sdl$1K = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-1.0.0",
        "name": "JDSDatepickerCalendar",
        "layerName": "jds_datepicker_calendar",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_header",
            {
                "rows-container": [
                    "jds_datepicker_calendar_row"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "gap": "{d_3}"
        },
        "rows-container": {
            "flex-direction": "{d_4}",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_datepicker_calendar_header": {
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "rows-container": {
                "rows.day": {
                    "type": "date",
                    "name": "day"
                },
                "rows.month": {
                    "type": "number",
                    "name": "month"
                },
                "rows.year": {
                    "type": "number",
                    "name": "year"
                },
                "rows.selected": {
                    "type": "date",
                    "name": "selected"
                },
                "rows.disabled": {
                    "type": "object",
                    "name": "disabled",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "rows.loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "value": {
                    "type": "list",
                    "name": "rows",
                    "object": {
                        "row": "JDSDatepickerCalendarRow.row"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            },
            "jds_datepicker_calendar_row": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "_calendarAriaLabel",
                        "value": "Select date from calendar"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "properties": {
                    "dateAriaLabel": {
                        "name": "dateAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getNormalisedDate$1 = (value)=>{
    const date = new Date(value || /* @__PURE__ */ new Date());
    if (!date.getTime()) return {
        day: 0,
        month: 0,
        year: 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
function $fe5170bdd3625759$var$removeTime(d) {
    d.setHours(0, 0, 0, 0);
    return d;
}
const $fe5170bdd3625759$var$isToday = (date, month, year, day)=>{
    if (year !== date.getFullYear()) return false;
    if (month !== date.getMonth()) return false;
    if (day !== date.getDate()) return false;
    return true;
};
const $fe5170bdd3625759$var$isDateDisabled = (value, disabled, dateFilter, min, max)=>{
    if (dateFilter) return dateFilter(value);
    const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(value);
    const disabledData = disabled.map((d)=>$fe5170bdd3625759$var$getNormalisedDate$1(d));
    const disabledIndex = disabledData.findIndex((d)=>{
        if (!(d.day === day)) return false;
        if (!(d.month === month)) return false;
        if (!(d.year === year)) return false;
        return true;
    });
    if (disabledIndex >= 0) return true;
    if (min && max) {
        const minDate = $fe5170bdd3625759$var$removeTime(new Date(min));
        const maxDate = $fe5170bdd3625759$var$removeTime(new Date(max));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue <= maxDate && currentValue >= minDate);
    }
    if (min) {
        const minDate = $fe5170bdd3625759$var$removeTime(new Date(min));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue >= minDate);
    }
    if (max) {
        const maxDate = $fe5170bdd3625759$var$removeTime(new Date(max));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue <= maxDate);
    }
};
const $fe5170bdd3625759$var$getDayState = (day, month, year, currentCount, selected)=>{
    const today = /* @__PURE__ */ new Date();
    const selectedDate = $fe5170bdd3625759$var$getNormalisedDate$1(selected);
    if (day - 1 === currentCount && selectedDate.month === month && selectedDate.year === year) return "selected";
    if ($fe5170bdd3625759$var$isToday(today, month - 1, year, currentCount + 1)) return "current";
    return "default";
};
const $fe5170bdd3625759$var$createRows = (month = 0, year = 0, day = 0, disabled = [], dateFilter, selected, min, max)=>{
    const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const getMonthDatesFromLocale = (0, $acw62.useMemo)(()=>{
        return (0, $5c2cbe2b2431bcd1$export$4ee93fd31f185549)(language);
    }, [
        language
    ]);
    const visibleMonth = $fe5170bdd3625759$var$removeTime(new Date(year, month - 1, 1));
    const firstDayOfMonth = visibleMonth.getDay();
    const daysInMonth = new Date(year, month, 0).getDate();
    const blanks = [];
    for(let i = 0; i < firstDayOfMonth; i++)blanks.push({
        state: "empty"
    });
    const finalRows = [];
    const rows = Array.from({
        length: daysInMonth
    }).map((_, i)=>{
        return {
            value: i + 1,
            internalIndex: i + 1,
            state: $fe5170bdd3625759$var$getDayState(day, month, year, i, selected),
            disabled: $fe5170bdd3625759$var$isDateDisabled(new Date(year, month - 1, i + 1), disabled, dateFilter, min, max)
        };
    });
    const rowsWithBlanks = blanks.concat(rows);
    while(rowsWithBlanks.length % 7 !== 0)rowsWithBlanks.push({
        state: "empty"
    });
    let sum = 0;
    while(sum <= daysInMonth + 7){
        const localizedRows = rowsWithBlanks.slice(sum, sum + 7).map(({ value: value, state: state, disabled: disabled2, ...rest })=>({
                value: value ? getMonthDatesFromLocale[value - 1] : void 0,
                state: // Adjust index
                state,
                disabled: disabled2,
                ...rest
            }));
        finalRows.push({
            row: localizedRows
        });
        sum = sum + 7;
    }
    return finalRows;
};
const $fe5170bdd3625759$var$loadedYears = (max = 0, min = 0, selected, disabled)=>{
    const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const numeralList = (0, $acw62.useMemo)(()=>{
        return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
    }, [
        language
    ]);
    const getLocaleYear = (year)=>{
        const yearString = year?.toString();
        return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
    };
    return Array.from({
        length: max - min
    }).map((_, i)=>{
        return {
            name: getLocaleYear(min + i),
            value: min + i,
            selected: min + i === selected,
            disabled: disabled?.[i] === true
        };
    });
};
const $fe5170bdd3625759$var$loadedMonths = (selected, selectedYear, selectable, min, max)=>{
    const { month: minMonth, year: minYear } = $fe5170bdd3625759$var$getNormalisedDate$1(min);
    const { month: maxMonth, year: maxYear } = $fe5170bdd3625759$var$getNormalisedDate$1(max);
    const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const language = tokens?.lang;
    const getMonthNamesFromLocale = (0, $acw62.useMemo)(()=>{
        return (0, $5c2cbe2b2431bcd1$export$cae41416faa27367)(language);
    }, [
        language
    ]);
    return getMonthNamesFromLocale.map((month, i)=>{
        let disabled = false;
        if (selectedYear === minYear && min) disabled = i + 1 < minMonth;
        if (selectedYear === maxYear && max) disabled = disabled || i + 1 > maxMonth;
        return {
            name: month,
            value: i + 1,
            selected: selected === i + 1,
            disabled: !selectable || disabled
        };
    });
};
const $fe5170bdd3625759$var$getDisabledYears = (minYear, maxYear, minDate, maxDate)=>{
    if (!minDate && !maxDate) return [];
    const { year: currentMinYear } = $fe5170bdd3625759$var$getNormalisedDate$1(minDate);
    const { year: currentMaxYear } = $fe5170bdd3625759$var$getNormalisedDate$1(maxDate);
    const years = Array.from({
        length: maxYear - minYear
    }).map((_, i)=>{
        const year = minYear + i;
        if (minDate && maxDate) return year < currentMinYear || year > currentMaxYear;
        if (minDate) return year < currentMinYear;
        if (maxDate) return year > currentMaxYear;
        return false;
    });
    return years;
};
const $fe5170bdd3625759$var$withLogic$1N = (Component)=>(props)=>{
        const { month: month, year: year, day: day } = props;
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const getWeekdayInitialsFromLocale = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3d12634d88530fee)(language);
        }, [
            language
        ]);
        const rows = $fe5170bdd3625759$var$createRows(month, year, day, props.disabled.disabledDates, props.disabled.dateFilter, props.selected, props.disabled?.min, props.disabled?.max);
        const selectedDate = props.selected;
        const options = {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        };
        const dateWithoutTime = selectedDate.toLocaleDateString("en-US", options);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                dateAriaLabel: `Selected date ${dateWithoutTime}`,
                days: getWeekdayInitialsFromLocale.map((d)=>({
                        letter: d[0]
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$1P = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1K;
    const { onSwipeLeft: onSwipeLeft = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendar", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cfdbf347b14a0a8d = $fe5170bdd3625759$var$withLogic$1N($fe5170bdd3625759$var$Component$1P);
$fe5170bdd3625759$export$cfdbf347b14a0a8d.displayName = "DatepickerCalendar";
$fe5170bdd3625759$export$cfdbf347b14a0a8d.slotName = "jds_datepicker_calendar";
const $fe5170bdd3625759$var$sdl$1J = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-button-1.0.0",
        "name": "JDSDatepickerCalendarButton",
        "layerName": "jds_datepicker_calendar_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "button-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "height": "{d_6}",
            "show": true
        },
        "button-container": {
            "hidden": false,
            "flex-direction": "{d_8}",
            "justify-content": "{d_9}",
            "align-items": "{d_10}",
            "height": "{d_13}",
            "border-radius": "{d_14}",
            "border-width": 0,
            "border-color": "{d_15}",
            "background-color": "{d_16}",
            "behavior": {
                "hover": {
                    "background-color": "{d_17}"
                },
                "active": {
                    "background-color": "{d_18}"
                },
                "focus": {
                    "background-color": "{d_19}",
                    "border-width": "{d_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_type": {
            "rounded": {
                "container": {
                    "width": "{d_11}"
                },
                "button-container": {
                    "width": "{d_11}"
                }
            },
            "rectangular": {
                "container": {
                    "width": "{d_5}"
                },
                "button-container": {
                    "height": "{d_6}",
                    "width": "{d_3}",
                    "flex-direction": "{d_0}",
                    "justify-content": "{d_1}",
                    "align-items": "{d_2}"
                }
            }
        },
        "state": {
            "selected": {
                "button-container": {
                    "background-color": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "color": "{primary60}"
                        },
                        "focus": {
                            "color": "{primary60}"
                        }
                    }
                }
            },
            "current": {
                "button-container": {
                    "background-color": "{d_22}"
                }
            },
            "empty": {
                "button-container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_23}"
                },
                "button-container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_type": {
                "values": [
                    "rounded",
                    "rectangular"
                ]
            },
            "state": {
                "values": [
                    "default",
                    "selected",
                    "current",
                    "empty"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "value"
                }
            }
        },
        "events": {
            "button-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "button-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-current": "_ariaCurrent",
                    "aria-checked": "_ariaChecked"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ariaLabel: props.state === "selected" ? props.ariaLabel : `${props.value}`,
                _ariaCurrent: props.state === "current" ? "date" : void 0,
                _ariaChecked: props.state === "selected" ? "true" : "false",
                onClick: ()=>{
                    props.onClick?.(props.internalIndex, props.disabled);
                },
                _type: (props.value?.length ?? -1) > 2 ? "rectangular" : "rounded"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1O = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1J;
    const { state: state = "default", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2d81f864fd880f98 = $fe5170bdd3625759$var$withLogic$1M($fe5170bdd3625759$var$Component$1O);
$fe5170bdd3625759$export$2d81f864fd880f98.displayName = "DatepickerCalendarButton";
$fe5170bdd3625759$export$2d81f864fd880f98.slotName = "jds_datepicker_calendar_button";
const $fe5170bdd3625759$var$sdl$1I = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-header-1.0.0",
        "name": "JDSDatepickerCalendarHeader",
        "layerName": "jds_datepicker_calendar_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "days.letter"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    },
                    "aria-label": "_weekDayAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1L = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1N = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1I;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSDatepickerCalendarHeader", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2d5e85746b19c19b = $fe5170bdd3625759$var$withLogic$1L($fe5170bdd3625759$var$Component$1N);
$fe5170bdd3625759$export$2d5e85746b19c19b.displayName = "DatepickerCalendarHeader";
$fe5170bdd3625759$export$2d5e85746b19c19b.slotName = "jds_datepicker_calendar_header";
const $fe5170bdd3625759$var$sdl$1H = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-row-1.0.0",
        "name": "JDSDatepickerCalendarRow",
        "layerName": "jds_datepicker_calendar_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}"
        },
        "jds_datepicker_calendar_button": {
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "row.value"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "row.state"
                },
                "disabled": {
                    "type": "string",
                    "name": "row.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "properties": {
                    "ariaLabel": "dateAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1M = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1H;
    const { onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarRow", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$703dfd9521d4b08a = $fe5170bdd3625759$var$withLogic$1K($fe5170bdd3625759$var$Component$1M);
$fe5170bdd3625759$export$703dfd9521d4b08a.displayName = "DatepickerCalendarRow";
$fe5170bdd3625759$export$703dfd9521d4b08a.slotName = "jds_datepicker_calendar_row";
const $fe5170bdd3625759$var$JDSDatepickerDesktopInternal = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktopInternal",
        "platform": "web",
        "layerName": "jds_datepicker_desktop_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    {
                        "calender-view-container": [
                            "top-jds_divider",
                            "jds_datepicker_calendar",
                            "jds_datepicker_month_view",
                            "jds_datepicker_year_view"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{d_4}",
            "flex-direction": "{d_5}",
            "justify-content": "{d_6}",
            "align-items": "{d_7}",
            "border-radius": "{d_8}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000029"
            }
        },
        "top-container": {
            "flex-direction": "{d_9}",
            "justify-content": "{d_10}",
            "align-items": "{d_11}",
            "padding-top": "{d_12}",
            "padding-right": "{d_13}",
            "padding-bottom": "{d_14}",
            "padding-left": "{d_15}",
            "width": "{d_16}"
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-right": "{d_17}",
            "padding-left": "{d_18}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{d_19}",
            "justify-content": "{d_20}",
            "align-items": "{d_21}",
            "gap": "{d_22}"
        },
        "calender-view-container": {
            "flex-direction": "{d_23}",
            "justify-content": "{d_24}",
            "align-items": "{d_25}",
            "height": "{d_26}",
            "width": "{d_27}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-right": "{d_28}",
            "padding-left": "{d_29}",
            "padding-bottom": "{d_30}"
        },
        "jds_datepicker_month_view": {
            "hidden": true
        },
        "jds_datepicker_year_view": {
            "hidden": true
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_32}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month"
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_33}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            }
        },
        "data": {
            "container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "_years.yearLoadCount": {
                    "type": "number",
                    "name": "yearLoadCount"
                }
            },
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "_onContainerClick"
            },
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "value": "Date Picker"
                    }
                }
            },
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Click to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Click to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1G = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobileInternal",
        "layerName": "jds_datepicker_mobile_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    "top-jds_divider",
                    "jds_datepicker_calendar",
                    "jds_datepicker_month_view",
                    "jds_datepicker_year_view"
                ]
            },
            {
                "confirmation-container": [
                    "bottom-jds_divider",
                    {
                        "confirmation-group-container": [
                            "confirm-jds-text",
                            "confirm-jds_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "size": "{size.max}",
            "translate-y": "{size.max}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            }
        },
        "top-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.end}",
            "align-items": "{alignItems.center}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "padding-left": "{s}",
            "padding-right": "{s}",
            "width": "{size.max}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{m}",
            "flex": 1
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-left": "{s}",
            "padding-right": "{s}",
            "padding-bottom": "{m}"
        },
        "jds_datepicker_month_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "jds_datepicker_year_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "confirmation-container": {
            "padding-top": 0,
            "padding-bottom": "{m}",
            "flex-direction": "{flexDirection.column}",
            "gap": "{s}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "width": "{size.max}"
        },
        "bottom-jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "confirmation-group-container": {
            "padding-top": 0,
            "padding-right": "{m}",
            "padding-bottom": 0,
            "padding-left": "{m}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{s}",
            "width": "{size.max}"
        },
        "confirm-jds_button": {
            "fullWidth": true,
            "kind": "primary",
            "size": "medium"
        },
        "confirm-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month",
                    "showArrows": false
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year",
                    "showArrows": false
                }
            }
        },
        "open": {
            "true": {
                "container": {
                    "translate-y": 0
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "data": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "calendarDays"
                },
                "rows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "calendarRows"
                }
            },
            "confirm-jds_button": {
                "label": {
                    "type": "string",
                    "name": "_confirmLabel"
                }
            },
            "confirm-jds-text": {
                "value": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "_onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            },
            "confirm-jds_button": {
                "onClick": "onConfirm"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Tap to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Tap to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            },
            "confirm-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "confirmAriaLabel",
                        "value": "Tap to Confirm"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$YEAR_COUNT$1 = 50;
const $fe5170bdd3625759$var$withLogic$1J = (Component)=>(props)=>{
        const { yearSelectable: yearSelectable = true, monthSelectable: monthSelectable = true, ...rest } = props;
        const { lang: lang, platform: platform } = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const confirmLabelLocal = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$6d8d0ec03e692fdc)(lang);
        }, [
            lang
        ]);
        const [state, setState] = (0, $acw62.useState)("default");
        const anchorRef = (0, $acw62.useRef)(null);
        const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $acw62.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $acw62.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $acw62.useState)(year);
        (0, $acw62.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {}), ...restChildren] = (0, $acw62.Children).toArray(props.children);
        const formattedConfirmDate = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString(lang, {
            weekday: "short",
            day: "2-digit",
            month: "long",
            year: "numeric"
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        onClose: ()=>{
                            props.onClose?.();
                            setState("default");
                        },
                        yearSelectable: yearSelectable,
                        monthSelectable: monthSelectable,
                        confirmDate: formattedConfirmDate,
                        _confirmLabel: confirmLabelLocal,
                        value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                        onClick: (ev)=>ev.stopPropagation(),
                        date: selectedDate.date,
                        month: selectedMonth,
                        year: selectedYear,
                        monthName: selectedMonth - 1,
                        months: $fe5170bdd3625759$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.calendarData?.min, props.calendarData?.max),
                        loadedYears: $fe5170bdd3625759$var$loadedYears(selectedYear + $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear - $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear, $fe5170bdd3625759$var$getDisabledYears(selectedYear - $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear + $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, props.calendarData?.min, props.calendarData?.max)),
                        current: selectedYear,
                        state: state,
                        onConfirm: ()=>{
                            const date = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date);
                            props.onSelect?.(date);
                            props.onConfirm?.(date);
                            props?.onClose?.();
                        },
                        _onYearClick: ()=>setState("year_view"),
                        _onMonthClick: ()=>setState("month_view"),
                        _onBack: ()=>setState("default"),
                        _onSelect: (num)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            setState("default");
                        },
                        onSelect: (num, disabled)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            if (!disabled && platform === "desktop") {
                                props.onSelect?.(new Date(selectedYear, selectedMonth - 1, num));
                                props.onClose?.();
                            }
                            setState("default");
                        },
                        _onMonthSelect: (i)=>{
                            if (monthSelectable) {
                                setSelectedMonth(i);
                                setState("default");
                            }
                        },
                        _onYearSelect: (i)=>{
                            if (yearSelectable) {
                                setSelectedYear(i);
                                setState("default");
                            }
                        },
                        _onPrev: ()=>setSelectedMonth((m)=>{
                                if (m === 1) {
                                    setSelectedYear(selectedYear - 1);
                                    return 12;
                                }
                                return m - 1;
                            }),
                        _onNext: ()=>setSelectedMonth((m)=>{
                                if (m === 12) {
                                    setSelectedYear(selectedYear + 1);
                                    return 1;
                                }
                                return m + 1;
                            })
                    }
                }),
                (0, $acw62.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1L = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $fe5170bdd3625759$var$JDSDatepickerDesktopInternal : $fe5170bdd3625759$var$sdl$1G;
    const { state: state = "default", onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Click to Return", closeAriaLabel: closeAriaLabel = "Click to Close", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClose: onClose,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktopInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1f2289af8fea154d = $fe5170bdd3625759$var$withLogic$1J($fe5170bdd3625759$var$Component$1L);
$fe5170bdd3625759$export$1f2289af8fea154d.displayName = "DatepickerDesktopInternal";
$fe5170bdd3625759$export$1f2289af8fea154d.slotName = "jds_datepicker_desktop_internal";
const $fe5170bdd3625759$var$sdl$1F = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-header-1.0.0",
        "name": "JDSDatepickerHeader",
        "layerName": "jds_datepicker_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "left-jds_button",
            {
                "inner-container": [
                    "month-jds_datepicker_button",
                    "year-jds_datepicker_button"
                ]
            },
            "right-jds_button"
        ]
    },
    "base": {
        "container": {
            "width": "{d_0}",
            "height": "{d_1}",
            "flex-direction": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}"
        },
        "inner-container": {
            "height": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "flex": 1
        },
        "left-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_left",
            "size": "medium"
        },
        "right-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_right",
            "size": "medium"
        },
        "month-jds_datepicker_button": {
            "state": "default"
        },
        "year-jds_datepicker_button": {
            "state": "default"
        }
    },
    "variant": {
        "state": {
            "month": {
                "month-jds_datepicker_button": {
                    "state": "selected"
                }
            },
            "year": {
                "year-jds_datepicker_button": {
                    "state": "selected"
                }
            }
        },
        "showArrows": {
            "false": {
                "left-jds_button": {
                    "hidden": true
                },
                "right-jds_button": {
                    "hidden": true
                }
            }
        },
        "monthSelectable": {
            "false": {
                "month-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        },
        "yearSelectable": {
            "false": {
                "year-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "month-jds_datepicker_button": {
                        "state": "text_only"
                    },
                    "year-jds_datepicker_button": {
                        "state": "text_only"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "monthSelectable",
            "yearSelectable"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month",
                    "year"
                ]
            },
            "showArrows": {
                "values": [
                    true,
                    false
                ]
            },
            "monthSelectable": {
                "values": [
                    true,
                    false
                ]
            },
            "yearSelectable": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "month-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "month"
                }
            },
            "year-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "year"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "onPrev"
            },
            "month-jds_datepicker_button": {
                "onClick": "onMonthClick"
            },
            "year-jds_datepicker_button": {
                "onClick": "onYearClick"
            },
            "right-jds_button": {
                "onClick": "onNext"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousAriaLabel",
                        "value": "Navigate to previous month"
                    }
                }
            },
            "right-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextAriaLabel",
                        "value": "Navigate to next month"
                    }
                }
            },
            "month-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_monthAriaLabel"
                    }
                }
            },
            "year-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_yearAriaLabel"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1I = (Component)=>(props)=>{
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocaleYear = (year)=>{
            const yearString = year?.toString();
            return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const getMonthNamesFromLocale = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$cae41416faa27367)(language);
        }, [
            language
        ]);
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _monthAriaLabel: props.state === "month" ? "Select month" : `${monthNames[Number(props.month)]}, Select month`,
                _yearAriaLabel: props.state === "year" ? "Select year" : `${props.year}, Select year`
            },
            year: getLocaleYear(Number(props.year)),
            month: getMonthNamesFromLocale[Number(props.month)]
        });
    };
const $fe5170bdd3625759$var$Component$1K = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1F;
    const { state: state = "default", showArrows: showArrows = true, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, onPrev: onPrev = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMonthClick: onMonthClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onYearClick: onYearClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onNext: onNext = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), previousAriaLabel: previousAriaLabel = "Navigate to previous month", nextAriaLabel: nextAriaLabel = "Navigate to next month", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            showArrows: showArrows,
            monthSelectable: monthSelectable,
            yearSelectable: yearSelectable,
            onPrev: onPrev,
            onMonthClick: onMonthClick,
            onYearClick: onYearClick,
            onNext: onNext,
            previousAriaLabel: previousAriaLabel,
            nextAriaLabel: nextAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerHeader", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4677d90cce08ec53 = $fe5170bdd3625759$var$withLogic$1I($fe5170bdd3625759$var$Component$1K);
$fe5170bdd3625759$export$4677d90cce08ec53.displayName = "DatepickerHeader";
$fe5170bdd3625759$export$4677d90cce08ec53.slotName = "jds_datepicker_header";
const $fe5170bdd3625759$var$sdl$1E = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-month-view-1.0.0",
        "name": "JDSDatepickerMonthView",
        "layerName": "jds_datepicker_month_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": "{d_1}",
            "width": "{d_2}",
            "align-items": "{d_3}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "months.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "months.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "months.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1H = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.months?.[i]?.value);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1J = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1E;
    const { onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMonthView", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$df8c284ffe0bf6ce = $fe5170bdd3625759$var$withLogic$1H($fe5170bdd3625759$var$Component$1J);
$fe5170bdd3625759$export$df8c284ffe0bf6ce.displayName = "DatepickerMonthView";
$fe5170bdd3625759$export$df8c284ffe0bf6ce.slotName = "jds_datepicker_month_view";
const $fe5170bdd3625759$var$sdl$1D = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-view-button-1.0.0",
        "name": "JDSDatepickerViewButton",
        "layerName": "jds_datepicker_view_button",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}"
        },
        "container": {
            "height": "{d_4}",
            "width": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}"
        },
        "jds_button": {
            "kind": "tertiary",
            "size": "medium",
            "fullWidth": true,
            "state": "normal"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "jds_button": {
                    "kind": "primary"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_button": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_button": {
                "label": {
                    "type": "string",
                    "name": "name"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            }
        },
        "events": {
            "jds_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "jds_button": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1G = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: ()=>{
                    props?.onSelect?.(props.internalIndex + 1);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1I = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1D;
    const { disabled: disabled = false, selected: selected = false, onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            selected: selected,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerViewButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$99c3540c4320b145 = $fe5170bdd3625759$var$withLogic$1G($fe5170bdd3625759$var$Component$1I);
$fe5170bdd3625759$export$99c3540c4320b145.displayName = "DatepickerViewButton";
$fe5170bdd3625759$export$99c3540c4320b145.slotName = "jds_datepicker_view_button";
const $fe5170bdd3625759$var$sdl$1C = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-year-view-1.0.0",
        "name": "JDSDatepickerYearView",
        "layerName": "jds_datepicker_year_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": 300,
            "width": "{d_1}",
            "align-items": "{d_2}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "loadedYears.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "loadedYears.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "loadedYears.disabled"
                }
            }
        },
        "events": {
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                }
            },
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.loadedYears?.[i]?.value);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1H = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1C;
    const { onScroll: onScroll = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onScroll: onScroll,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerYearView", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$59892f17b1991230 = $fe5170bdd3625759$var$withLogic$1F($fe5170bdd3625759$var$Component$1H);
$fe5170bdd3625759$export$59892f17b1991230.displayName = "DatepickerYearView";
$fe5170bdd3625759$export$59892f17b1991230.slotName = "jds_datepicker_year_view";
const $fe5170bdd3625759$var$sdl$1B = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheetInternal",
        "layerName": "jds_desktop_bottom_sheet_internal",
        "platform": "web",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_button"
                                ]
                            },
                            "cancel-jds_button",
                            "step-jds-text"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_13}",
            "align-items": "{d_14}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_24}",
            "justify-content": "{d_25}",
            "background-color": "{d_26}",
            "align-items": "{d_27}",
            "border-top-left-radius": "{d_28}",
            "border-top-right-radius": "{d_29}",
            "width": "{d_15}",
            "translate-y": "{d_16}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{d_17}",
                "timing-function": "{d_18}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{d_30}",
            "justify-content": "{d_31}",
            "align-items": "{d_32}",
            "width": "{d_33}",
            "padding-top": "{d_34}",
            "padding-bottom": "{d_35}",
            "padding-left": "{d_36}",
            "padding-right": "{d_37}",
            "gap": "{d_38}"
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "medium",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{d_39}",
            "justify-content": "{d_40}",
            "align-items": "{d_41}",
            "padding-left": "{d_42}",
            "padding-right": "{d_43}",
            "width": "{d_44}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{d_47}",
            "gap": "{d_48}",
            "width": "{d_49}",
            "padding-bottom": "{d_50}",
            "padding-top": "{d_51}"
        },
        "back-container": {
            "flex": 1,
            "hidden": true
        },
        "back-jds_button": {
            "kind": "tertiary",
            "icon": "ic_back"
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "background-color": "{d_4}",
            "border-top-left-radius": "{d_5}",
            "border-top-right-radius": "{d_6}",
            "padding-left": "{d_7}",
            "padding-right": "{d_8}",
            "padding-top": "{d_9}",
            "padding-bottom": "{d_10}",
            "width": "{d_11}",
            "translate-y": "{d_12}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{d_45}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{d_46}"
        },
        "step-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{d_52}"
        }
    },
    "variant": {
        "controlType": {
            "stepper": {
                "back-container": {
                    "hidden": false
                },
                "cancel-jds_button": {
                    "hidden": true
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "{d_53}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": 0,
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": 0
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{size.max}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "number",
                    "name": "height"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "step_label"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "back-jds_button": {
                "onClick": "onBack"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Click to go Back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$p = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1E = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$p);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false",
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1G = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1B;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onBottomSheetClick: onBottomSheetClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Click to go Back", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheetInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a20173db319b8774 = $fe5170bdd3625759$var$withLogic$1E($fe5170bdd3625759$var$Component$1G);
$fe5170bdd3625759$export$a20173db319b8774.displayName = "DesktopBottomSheetInternal";
$fe5170bdd3625759$export$a20173db319b8774.slotName = "jds_desktop_bottom_sheet_internal";
const $fe5170bdd3625759$var$sdl$1A = {
    "metadata": {
        "version": "1.0.0",
        "id": "divider-1.0.0",
        "name": "JDSDivider",
        "layerName": "jds_divider",
        "description": "Dividers are used to group and divide contents within a page.",
        "usage": "Dividers are used inorder to establish clear grouping of content or emphasize the in-between boundaries of a list of content."
    },
    "hierarchy": {
        "container": [
            "start-container",
            "jds-text",
            "end-container"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "gap": "{d_4}",
            "flex": 1,
            "padding-left": "{d_5}",
            "padding-right": "{d_6}",
            "padding-top": "{d_7}",
            "padding-bottom": "{d_8}"
        },
        "start-container": {
            "hidden": false,
            "min-height": "{d_9}",
            "min-width": "{d_10}",
            "flex-direction": "{d_11}",
            "flex": 1,
            "background-color": "{d_12}",
            "border-radius": "{d_13}",
            "show": true
        },
        "end-container": {
            "hidden": true,
            "min-height": "{d_14}",
            "min-width": "{d_15}",
            "flex-direction": "{d_16}",
            "flex": 1,
            "background-color": "{d_17}",
            "border-radius": "{d_18}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "variant": {
            "stepper": {
                "start-container": {
                    "background-color": "{d_19}"
                },
                "end-container": {
                    "background-color": "{d_20}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "container": {
                    "width": "{d_21}"
                },
                "start-container": {
                    "height": 1
                },
                "end-container": {
                    "height": 1
                }
            },
            "vertical": {
                "container": {
                    "height": "{d_22}",
                    "flex-direction": "{d_23}"
                },
                "start-container": {
                    "width": 1,
                    "flex-direction": "{d_24}",
                    "flex": 1
                },
                "end-container": {
                    "width": 1,
                    "flex-direction": "{d_25}",
                    "flex": 1
                }
            }
        },
        "pad": {
            "none": {
                "container": {
                    "padding-top": 0,
                    "padding-bottom": 0,
                    "padding-right": 0,
                    "padding-left": 0
                }
            }
        },
        "_withLabel": {
            "true": {
                "end-container": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "base": {
                "all": {
                    "container": {
                        "padding-left": "{d_26}",
                        "padding-right": "{d_27}",
                        "padding-top": "{d_28}",
                        "padding-bottom": "{d_29}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_30}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_31}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": "{d_32}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_33}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_34}",
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_35}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_36}",
                        "padding-right": "{d_37}"
                    }
                }
            },
            "medium": {
                "all": {
                    "container": {
                        "padding-left": "{d_38}",
                        "padding-right": "{d_39}",
                        "padding-top": "{d_40}",
                        "padding-bottom": "{d_41}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_42}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_43}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": 0,
                        "padding-top": "{d_44}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": "{d_45}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_46}",
                        "padding-bottom": "{d_47}",
                        "padding-right": 0,
                        "padding-left": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_48}",
                        "padding-right": "{d_49}"
                    }
                }
            },
            "xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_50}",
                        "padding-right": "{d_51}",
                        "padding-top": "{d_52}",
                        "padding-bottom": "{d_53}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_54}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-right": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_55}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_56}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_57}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_58}",
                        "padding-bottom": "{d_59}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_60}",
                        "padding-right": "{d_61}"
                    }
                }
            },
            "xtra-xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_62}",
                        "padding-right": "{d_63}",
                        "padding-top": "{d_64}",
                        "padding-bottom": "{d_65}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_66}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_67}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_68}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_69}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_70}",
                        "padding-bottom": "{d_71}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": "{d_72}",
                        "padding-bottom": "{d_73}"
                    }
                }
            },
            "xtra-xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_74}",
                        "padding-right": "{d_75}",
                        "padding-top": "{d_76}",
                        "padding-bottom": "{d_77}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_78}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_79}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_80}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_81}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_82}",
                        "padding-bottom": "{d_83}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_84}",
                        "padding-right": "{d_85}"
                    }
                }
            },
            "xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_86}",
                        "padding-right": "{d_87}",
                        "padding-top": "{d_88}",
                        "padding-bottom": "{d_89}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_90}",
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_91}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_92}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_93}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_94}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_95}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_96}",
                        "padding-right": "{d_97}"
                    }
                }
            },
            "large": {
                "all": {
                    "container": {
                        "padding-left": "{d_98}",
                        "padding-right": "{d_99}",
                        "padding-top": "{d_100}",
                        "padding-bottom": "{d_101}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_102}",
                        "padding-right": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_103}",
                        "padding-left": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_104}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_105}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_106}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_107}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_108}",
                        "padding-right": "{d_109}"
                    }
                }
            },
            "huge": {
                "all": {
                    "container": {
                        "padding-left": "{d_110}",
                        "padding-right": "{d_111}",
                        "padding-top": "{d_112}",
                        "padding-bottom": "{d_113}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_114}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_115}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_116}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_117}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_118}",
                        "padding-bottom": "{d_119}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_120}",
                        "padding-right": "{d_121}"
                    }
                }
            },
            "massive": {
                "all": {
                    "container": {
                        "padding-left": "{d_122}",
                        "padding-right": "{d_123}",
                        "padding-top": "{d_124}",
                        "padding-bottom": "{d_125}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_126}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_127}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_128}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_129}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_130}",
                        "padding-bottom": "{d_131}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_132}",
                        "padding-right": "{d_133}"
                    }
                }
            },
            "small": {
                "left": {
                    "container": {
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "pad",
            "padPosition"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "orientation": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "Determines the view styles i.e. horizontal or vertical."
            },
            "variant": {
                "values": [
                    "default",
                    "stepper"
                ]
            },
            "_withLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "padPosition": {
                "values": [
                    "all",
                    "vertical",
                    "horizontal",
                    "bottom",
                    "top",
                    "left",
                    "right"
                ],
                "doc_description": "Sets the position of padding defined as part of `padding` property. If `padding` property present, this default to `all`."
            },
            "pad": {
                "values": [
                    "small",
                    "base",
                    "medium",
                    "xtra-small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-small",
                    "huge",
                    "massive",
                    "none"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "separator"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-orientation": {
                        "name": "_ariaOrientation",
                        "prop": "orientation"
                    },
                    "aria-hidden": {
                        "name": "ariaHidden"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyPadding = [
    "xx-small",
    "x-small",
    "x-large",
    "xx-large"
];
const $fe5170bdd3625759$var$PROP_MAP$o = (props)=>{
    if ($fe5170bdd3625759$var$legacyPadding.includes(props.pad)) console.warn("sizes starting with xx- are deprecated. Use sizes starting with `xtra`. Ex: x-small => xtra-small");
    return {
        pad: {
            variations: {
                base: {
                    pad: "base"
                },
                huge: {
                    pad: "huge"
                },
                medium: {
                    pad: "medium"
                },
                small: {
                    pad: "small"
                },
                large: {
                    pad: "large"
                },
                "x-small": {
                    pad: "xtra-small"
                },
                "xx-small": {
                    pad: "xtra-xtra-small"
                },
                "x-large": {
                    pad: "xtra-large"
                },
                "xx-large": {
                    pad: "xtra-xtra-large"
                },
                massive: {
                    pad: "massive"
                }
            }
        },
        appearance: {
            properties: {
                orientation: props.appearance || props.orientation
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1D = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$o);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _withLabel: Boolean(props.label?.length),
                orientation: props.orientation || props.appearance
            }
        });
    };
const $fe5170bdd3625759$var$Component$1F = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1A;
    const { orientation: orientation = "horizontal", variant: variant = "default", padPosition: padPosition = "all", pad: pad = "small", _ariaLabel: _ariaLabel = props.label?.toString(), _ariaOrientation: _ariaOrientation = props.orientation?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            orientation: orientation,
            variant: variant,
            padPosition: padPosition,
            pad: pad,
            _ariaLabel: _ariaLabel,
            _ariaOrientation: _ariaOrientation,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDivider", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2e0a83ec2e27ecbb = $fe5170bdd3625759$var$withLogic$1D($fe5170bdd3625759$var$Component$1F);
$fe5170bdd3625759$export$2e0a83ec2e27ecbb.displayName = "Divider";
$fe5170bdd3625759$export$2e0a83ec2e27ecbb.slotName = "jds_divider";
const $fe5170bdd3625759$var$sdl$1z = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenu",
        "layerName": "jds_dropdown_menu"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "background-color": "{global.transparent}",
            "hidden": true
        },
        "popup-container": {
            "hidden": false
        },
        "jds_dropdown_menu_internal": {
            "hidden": false,
            "kind": "single-select"
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_dropdown_menu_internal": {
                    "kind": "multi-select",
                    "showCTAButtons": true
                }
            }
        },
        "_menuFullScreen": {
            "true": {
                "popup-container": {
                    "size": "{size.max}"
                },
                "jds_dropdown_menu_internal": {
                    "menuFullScreen": true
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                },
                "jds_dropdown_menu_internal": {
                    "open": true
                }
            }
        },
        "searchTrigger": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "searchTrigger": true
                }
            }
        },
        "showCTAButtons": {
            "false": {
                "jds_dropdown_menu_internal": {
                    "showCTAButtons": false
                }
            }
        },
        "labelTextWrap": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "labelTextWrap": true
                }
            }
        },
        "width": {
            "trigger": {
                "jds_dropdown_menu_internal": {
                    "menuWidthConfig": "trigger"
                }
            }
        },
        "position": {
            "bottom_start": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_end"
                }
            },
            "top_start": {
                "jds_dropdown_menu_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_dropdown_menu_internal": {
                    "position": "top_end"
                }
            },
            "right_start": {
                "jds_dropdown_menu_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_dropdown_menu_internal": {
                    "position": "right_end"
                }
            },
            "left_start": {
                "jds_dropdown_menu_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_dropdown_menu_internal": {
                    "position": "left_end"
                }
            },
            "bottom_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_centre"
                }
            },
            "top_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "top_centre"
                }
            }
        }
    },
    "api": {
        "events": {
            "jds_dropdown_menu_internal": {
                "onSuffixClick": "onSuffixClick",
                "onSearchChange": "onSearchChange",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onContainerClick": "_onContainerClick",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "data": {
            "jds_dropdown_menu_internal": {
                "searchLabel": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "searchValue": {
                    "type": "string",
                    "name": "searchValue"
                },
                "searchSuffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "menuMaxHeight": {
                    "type": "string",
                    "name": "_menuMaxHeight"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "width": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "_menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "jds_dropdown_menu_internal": {
                "properties": {
                    "searchAriaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$findFocusedIndex(menuItems) {
    const focusedElement = document.activeElement;
    const index = menuItems.findIndex((item)=>item === focusedElement);
    return index;
}
function $fe5170bdd3625759$var$handlePrevOrNextItemFocus(focusIndex, containerDomRef, itemSelector) {
    const menuItems = containerDomRef?.querySelectorAll?.(itemSelector);
    if (!menuItems?.length) return;
    const currentFocusIndex = $fe5170bdd3625759$var$findFocusedIndex(Array.from(menuItems));
    if (focusIndex === 1) {
        if (currentFocusIndex < menuItems.length - 1) menuItems[currentFocusIndex + 1].focus();
        else menuItems[0].focus();
    } else if (focusIndex === -1) {
        if (currentFocusIndex > 0) menuItems[currentFocusIndex - 1].focus();
        else menuItems[menuItems.length - 1].focus();
    }
}
const $fe5170bdd3625759$var$spaceAvailabilityOrder = {
    "bottom-start": [
        "bottom-end",
        "bottom-center",
        "top-start",
        "top-end",
        "top-center"
    ],
    "bottom-end": [
        "bottom-start",
        "bottom-center",
        "top-end",
        "top-start",
        "top-center"
    ],
    "top-start": [
        "top-end",
        "top-center",
        "bottom-start",
        "bottom-end",
        "bottom-center"
    ],
    "top-end": [
        "top-start",
        "top-center",
        "bottom-end",
        "bottom-start",
        "bottom-center"
    ],
    "right-end": [
        "right-start",
        "left-end",
        "left-start"
    ],
    "right-start": [
        "right-end",
        "left-start",
        "left-end",
        "bottom-end",
        "bottom-center"
    ],
    "left-end": [
        "left-start",
        "right-end",
        "right-start"
    ],
    "left-start": [
        "left-end",
        "right-start",
        "right-end"
    ],
    "top-center": [
        "top-start",
        "top-end",
        "bottom-center",
        "bottom-start",
        "bottom-end"
    ],
    "bottom-center": [
        "bottom-start",
        "bottom-end",
        "top-center",
        "top-start",
        "top-end"
    ]
};
function $fe5170bdd3625759$var$getCalculatedPosition(position, anchorRect, containerDomRect) {
    if (!(position && anchorRect && containerDomRect)) return position;
    if ($fe5170bdd3625759$var$checkSpaceAvailability(position, anchorRect, containerDomRect)) return position;
    let alternativePosition = $fe5170bdd3625759$var$spaceAvailabilityOrder[position].find((alternativePosition2)=>{
        return $fe5170bdd3625759$var$checkSpaceAvailability(alternativePosition2, anchorRect, containerDomRect);
    });
    if (!alternativePosition) alternativePosition = $fe5170bdd3625759$var$checkBestAvailablePosition(anchorRect);
    return alternativePosition || position;
}
function $fe5170bdd3625759$var$checkBestAvailablePosition(anchorRect) {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const { bottom: bottom, top: top, left: left, right: right } = anchorRect;
    const positionWidthHeightRatios = {
        "bottom-start": (windowWidth - left) * (windowHeight - bottom),
        "bottom-end": right * (windowHeight - bottom),
        "top-start": (windowWidth - left) * top,
        "top-end": right * top,
        "right-start": (windowWidth - right) * (windowHeight - top),
        "right-end": (windowWidth - right) * bottom,
        "left-start": left * (windowHeight - top),
        "left-end": left * bottom,
        "top-center": 0,
        "bottom-center": 0
    };
    let bestPosition = "bottom-start";
    let bestAvailableSpace = 0;
    for (const [position, availableSpace] of Object.entries(positionWidthHeightRatios))if (availableSpace > bestAvailableSpace) {
        bestPosition = position;
        bestAvailableSpace = availableSpace;
    }
    return bestPosition;
}
function $fe5170bdd3625759$var$checkSpaceAvailability(position, anchorRect, containerDomRect) {
    const { width: anchorWidth, top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const screenStart = 0;
    switch(position){
        case "bottom-start":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + containerWidth < screenWidth;
        case "bottom-end":
            return anchorBottom + containerHeight < screenHeight && anchorRight - containerWidth > screenStart;
        case "top-start":
            return anchorLeft + containerWidth < screenWidth && anchorTop - containerHeight > 0;
        case "top-end":
            return anchorRight - containerWidth > screenStart && anchorTop - containerHeight > 0;
        case "right-end":
            return anchorRight + containerWidth < screenWidth && anchorBottom - containerHeight > 0;
        case "right-start":
            return anchorRight + containerWidth < screenWidth && anchorTop + containerHeight < screenHeight;
        case "left-end":
            return anchorLeft - containerWidth > screenStart && anchorBottom - containerHeight > 0;
        case "left-start":
            return anchorTop + containerHeight < screenHeight && anchorLeft - containerWidth > screenStart;
        case "top-center":
            return anchorTop - containerHeight > 0 && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        case "bottom-center":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        default:
            return true;
    }
}
const $fe5170bdd3625759$var$DropdownMenuContext = (0, $acw62.createContext)({
    activeMenuId: void 0,
    setActiveMenuId () {},
    labelTextWrap: true,
    selectedValue: void 0,
    setSelectedValue () {},
    selectedValues: [],
    setSelectedValues () {},
    isNested: false,
    setIsNested () {},
    resetSelections () {},
    applySelections () {}
});
const $fe5170bdd3625759$var$useScrollClose = (callback)=>{
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("scroll", callback);
        return ()=>{
            document.removeEventListener("scroll", callback);
        };
    }, [
        callback
    ]);
};
const $fe5170bdd3625759$var$MENU_MARGIN = 4;
const $fe5170bdd3625759$var$getIcon$1 = (icon)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon.props.ic,
        color: "grey-80"
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
};
function $fe5170bdd3625759$var$getPositionCoordinates(position, anchorRect, containerDomRect) {
    const { top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft, width: anchorWidth } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenHeight = window.innerHeight;
    const screenWidth = window.innerWidth;
    let left = 0;
    let top = 0;
    let maxHeight;
    let maxWidth;
    switch(position){
        case "bottom-start":
            left = anchorLeft;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "bottom-end":
            left = anchorRight - containerWidth;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = anchorRight;
            break;
        case "top-start":
            left = anchorLeft;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "top-end":
            left = anchorRight - containerWidth;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = anchorRight;
            break;
        case "right-end":
            left = anchorRight;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = screenWidth - anchorRight;
            break;
        case "right-start":
            left = anchorRight;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = screenWidth - anchorRight;
            break;
        case "left-end":
            left = anchorLeft - containerWidth;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = anchorLeft;
            break;
        case "left-start":
            left = anchorLeft - containerWidth;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = anchorLeft;
            break;
        case "top-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth;
            break;
        case "bottom-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth;
            break;
    }
    if (position.includes("top")) top -= $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("bottom")) top += $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("right")) left += $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("left")) left -= $fe5170bdd3625759$var$MENU_MARGIN;
    return {
        left: Math.round(left < 0 ? 0 : left),
        top: Math.round(top < 0 ? 0 : top),
        maxHeight: maxHeight,
        maxWidth: maxWidth
    };
}
const $fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR$1 = "div.j-JDSDropdownMenuInternal-menu-container";
const $fe5170bdd3625759$var$SEARCH_BAR_HEIGHT = 56;
const $fe5170bdd3625759$var$withLogic$1C = (Component)=>(props)=>{
        const [activeMenuId, setActiveMenuId] = (0, $acw62.useState)(void 0);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [labelTextWrap, setLabelTextWrap] = (0, $acw62.useState)(true);
        const [selectedValue, setSelectedValue] = (0, $acw62.useState)(void 0);
        const [selectedValues, setSelectedValues] = (0, $acw62.useState)([]);
        const [menuVisible, setMenuVisible] = (0, $acw62.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(false);
        const [isNested, setIsNested] = (0, $acw62.useState)(false);
        const [fullScreen, setFullScreen] = (0, $acw62.useState)(false);
        const [menuWidth, setMenuWidth] = (0, $acw62.useState)("max-content");
        const internalProps = props;
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR$1);
        const [coords, setCoords] = (0, $acw62.useState)({
            left: 0,
            top: 0,
            maxHeight: 0,
            maxWidth: void 0
        });
        const defaultValue = {
            activeMenuId: void 0,
            setActiveMenuId: setActiveMenuId,
            labelTextWrap: labelTextWrap,
            selectedValue: selectedValue,
            setSelectedValue (value) {
                setSelectedValue(value);
                if (props.value !== value) {
                    props?.onSelect?.(value);
                    props?.onClose?.();
                    setActiveMenuId(void 0);
                }
            },
            selectedValues: selectedValues,
            setSelectedValues: (values)=>setSelectedValues([
                    ...values
                ]),
            isNested: isNested,
            setIsNested: setIsNested,
            resetSelections: ()=>{
                setSelectedValues([]);
            },
            applySelections: ()=>{
                props?.onSelect?.(selectedValues);
                props?.onClose?.();
            }
        };
        (0, $acw62.useEffect)(()=>{
            if (props.open) {
                setInternalOpen(true);
                if (dropdownMenuRef && anchorEl?.current) {
                    setFullScreen(false);
                    setMenuWidth("max-content");
                    setTimeout(()=>{
                        const anchorDomRect = anchorEl.current?.getBoundingClientRect();
                        const containerDomRect = dropdownMenuRef?.getBoundingClientRect();
                        if (anchorDomRect && containerDomRect) {
                            const calculatedPosition = $fe5170bdd3625759$var$getCalculatedPosition(position || "bottom-start", anchorDomRect, containerDomRect);
                            const { left: left, top: top, maxHeight: maxHeight, maxWidth: maxWidth } = $fe5170bdd3625759$var$getPositionCoordinates(calculatedPosition, anchorDomRect, containerDomRect);
                            const menuItems = dropdownMenuRef.querySelectorAll(".j-JDSDropdownMenuItem-container");
                            const isFullScreen = $fe5170bdd3625759$var$Devices.isMobile() ? isNested || (menuItems?.length || 0) > 7 : false;
                            setFullScreen(isFullScreen);
                            if (isFullScreen) setCoords({
                                left: 0,
                                top: 0,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            else setCoords({
                                left: left,
                                top: top,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            setMenuVisible(true);
                            if (props.width === "trigger") setMenuWidth(`${anchorDomRect.width}px`);
                            else setMenuWidth(maxWidth && containerDomRect.width > maxWidth ? `${maxWidth}px` : "max-content");
                        }
                    }, 10);
                }
            } else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef,
            isNested
        ]);
        (0, $acw62.useEffect)(()=>{
            if (props.kind === "multi-select") setSelectedValues(props.value ? [
                props.value
            ] : []);
            else setSelectedValue(props.value);
        }, [
            props.value
        ]);
        (0, $acw62.useEffect)(()=>{
            setLabelTextWrap(!!props.labelTextWrap);
        }, [
            props.labelTextWrap
        ]);
        (0, $acw62.useEffect)(()=>{
            if (props.open && dropdownMenuRef) dropdownMenuRef.focus();
        }, [
            props.open,
            dropdownMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$DropdownMenuContext.Provider, {
            value: {
                ...defaultValue,
                setActiveMenuId: setActiveMenuId,
                setIsNested: setIsNested,
                activeMenuId: activeMenuId,
                labelTextWrap: labelTextWrap,
                selectedValue: selectedValue,
                selectedValues: selectedValues,
                isNested: isNested
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    open: internalOpen,
                    onClose: ()=>{
                        props?.onClose?.();
                        setMenuVisible(false);
                        setActiveMenuId(void 0);
                    },
                    rootRef: rootRef,
                    offsetX: internalProps.offsetX || `${coords.left}px`,
                    _menuWidth: fullScreen ? "100%" : menuWidth,
                    _menuFullScreen: fullScreen,
                    _menuMaxHeight: coords.maxHeight === 0 ? "unset" : props.searchTrigger ? `${coords.maxHeight - $fe5170bdd3625759$var$SEARCH_BAR_HEIGHT}px` : `${coords.maxHeight}px`,
                    offsetY: internalProps.offsetY || `${coords.top}px`,
                    searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                    searchLabel: props.searchLabel || "Search",
                    searchValue: props.searchValue,
                    onSuffixClick: props.onSuffixClick,
                    onSearchChange: props?.onSearchChange,
                    _onContainerClick: (event)=>{
                        event.stopPropagation();
                    },
                    onPrimaryClick: ()=>{
                        props.onPrimaryClick?.();
                        defaultValue.applySelections();
                    },
                    onSecondaryClick: ()=>{
                        props.onSecondaryClick?.();
                        defaultValue.resetSelections();
                    },
                    _menuContainerVisible: menuVisible
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$1E = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1z;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, width: width = "max-content", position: position = "bottom_start", onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            width: width,
            position: position,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenu", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e44a253a59704894 = $fe5170bdd3625759$var$withLogic$1C($fe5170bdd3625759$var$Component$1E);
$fe5170bdd3625759$export$e44a253a59704894.displayName = "DropdownMenu";
$fe5170bdd3625759$export$e44a253a59704894.slotName = "jds_dropdown_menu";
const $fe5170bdd3625759$var$sdl$1y = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-group-1.0.0",
        "name": "JDSDropdownMenuGroup",
        "layerName": "jds_dropdown_menu_group",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "top-jds_divider",
            {
                "label-container": [
                    "label-jds-text"
                ]
            },
            {
                "menu-item-container": [
                    "menu-item-slot"
                ]
            },
            "bottom-jds_divider"
        ]
    },
    "base": {
        "top-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "xtra-small",
            "padPosition": "top"
        },
        "bottom-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none",
            "padPosition": "all"
        },
        "label-container": {
            "width": "{d_6}",
            "padding-top": "{d_3}",
            "padding-right": "{d_5}",
            "padding-left": "{d_4}"
        },
        "container": {
            "hidden": false,
            "width": "{d_0}",
            "background-color": "{d_7}",
            "flex-direction": "{d_1}"
        },
        "menu-item-container": {
            "width": "{d_8}",
            "flex-direction": "{d_2}"
        },
        "menu-item-slot": {
            "hidden": false
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideTopDivider": {
            "true": {
                "top-jds_divider": {
                    "hidden": true
                },
                "label-container": {
                    "hidden": true
                }
            }
        },
        "hideBottomDivider": {
            "true": {
                "bottom-jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-item-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_item"
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "hideBottomDivider": {
                "values": [
                    false,
                    true
                ]
            },
            "_hideTopDivider": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1B = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hideTopDivider: !props.label
            }
        });
    };
const $fe5170bdd3625759$var$Component$1D = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1y;
    const { hideBottomDivider: hideBottomDivider = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            hideBottomDivider: hideBottomDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuGroup", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$246bebaba3a2f70e = $fe5170bdd3625759$var$withLogic$1B($fe5170bdd3625759$var$Component$1D);
$fe5170bdd3625759$export$246bebaba3a2f70e.displayName = "DropdownMenuGroup";
$fe5170bdd3625759$export$246bebaba3a2f70e.slotName = "jds_dropdown_menu_group";
const $fe5170bdd3625759$var$sdl$1x = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenuInternal",
        "layerName": "jds_dropdown_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            {
                "search-container": [
                    "jds_search_box"
                ]
            },
            {
                "menu-group-container": [
                    "menu-group-slot"
                ]
            },
            {
                "botton-container": [
                    "secondary-jds_action_button",
                    "primary-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "light_background",
            "width": "{size.max}"
        },
        "menu-group-container": {
            "hidden": false,
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto"
        },
        "search-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-left": "{base}",
            "padding-right": "{base}"
        },
        "menu-group-slot": {
            "hidden": false
        },
        "botton-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-bottom": "{m}",
            "padding-left": "{base}",
            "padding-right": "{base}",
            "flex-direction": "{flexDirection.row}",
            "gap": "{s}"
        },
        "primary-jds_action_button": {
            "kind": "primary",
            "size": "medium",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "kind": "secondary",
            "size": "medium",
            "stretch": true
        }
    },
    "variant": {
        "menuFullScreen": {
            "true": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        },
        "searchTrigger": {
            "true": {
                "search-container": {
                    "hidden": false
                }
            }
        },
        "kind": {
            "multi-select": {
                "botton-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "false": {
                    "botton-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "showCTAButtons"
        ]
    ],
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "jds_search_box": {
                "onSuffixClick": "onSuffixClick",
                "onChange": "onSearchChange"
            },
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onContainerClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "data": {
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "value": {
                    "type": "string",
                    "name": "searchValue"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                }
            },
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "menuWidth"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            },
            "menu-group-container": {
                "max-height": {
                    "type": "string",
                    "name": "menuMaxHeight"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "menuWidthConfig": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "ariaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR = "div.j-JDSDropdownMenuInternal-menu-container";
const $fe5170bdd3625759$var$withLogic$1A = (Component)=>(props)=>{
        const { activeMenuId: activeMenuId, setActiveMenuId: setActiveMenuId } = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [menuVisible, setMenuVisible] = (0, $acw62.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(false);
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (props.open) setTimeout(()=>{
                setInternalOpen(true);
                setMenuVisible(true);
            }, 10);
            else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: internalOpen,
                onClose: ()=>{
                    props?.onClose?.();
                    setMenuVisible(false);
                    setActiveMenuId(void 0);
                },
                rootRef: rootRef,
                searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                searchLabel: props.searchLabel || "Search",
                searchValue: props.searchValue,
                onSuffixClick: props.onSuffixClick,
                onSearchChange: props?.onSearchChange,
                _onContainerClick: (event)=>{
                    event.stopPropagation();
                },
                _menuContainerVisible: menuVisible
            }
        });
    };
const $fe5170bdd3625759$var$Component$1C = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1x;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, menuWidthConfig: menuWidthConfig = "max-content", position: position = "bottom_start", menuFullScreen: menuFullScreen = false, onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            menuWidthConfig: menuWidthConfig,
            position: position,
            menuFullScreen: menuFullScreen,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onAppear: onAppear,
            onContainerClick: onContainerClick,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5a9d97cdadce1b72 = $fe5170bdd3625759$var$withLogic$1A($fe5170bdd3625759$var$Component$1C);
$fe5170bdd3625759$export$5a9d97cdadce1b72.displayName = "DropdownMenuInternal";
$fe5170bdd3625759$export$5a9d97cdadce1b72.slotName = "jds_dropdown_menu_internal";
const $fe5170bdd3625759$var$sdl$1w = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItem",
        "layerName": "jds_dropdown_menu_item",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_checkbox",
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "jds_checkbox": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_checkbox": {
                    "hidden": false,
                    "checked": false
                },
                "container": {
                    "behavior": {
                        "active": {
                            "background-color": "{primaryGrey40}"
                        }
                    }
                },
                "icon": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey80}"
                        }
                    }
                },
                "label-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "description-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "suffix-jds-text": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey100}"
                        }
                    }
                }
            }
        },
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "jds_dropdown_menu_submenu": {
                    "hidden": false
                },
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "true": {
                    "container": {
                        "background-color": "{primaryGrey20}",
                        "behavior": {
                            "hover": {
                                "background-color": "{primaryGrey20}"
                            }
                        }
                    },
                    "icon": {
                        "color": "{primaryGrey80}"
                    },
                    "label-jds-text": {},
                    "description-jds-text": {},
                    "suffix-jds-text": {
                        "color": "{primaryGrey100}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "selected"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "jds_checkbox": {
                "onClick": "onItemSelect"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "jds_checkbox": {
                "indeterminate": {
                    "type": "boolean",
                    "name": "_indeterminate"
                },
                "checked": {
                    "type": "boolean",
                    "name": "_checked"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getUniqueId() {
    return $fe5170bdd3625759$var$generateId() + "-" + $fe5170bdd3625759$var$generateId() + "-" + $fe5170bdd3625759$var$generateId();
}
const $fe5170bdd3625759$var$generateId = function() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
};
const $fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR = "div.j-JDSDropdownMenuItem-container";
const $fe5170bdd3625759$var$SUBMENU_OFFSET_TOP = 8;
const $fe5170bdd3625759$var$SUBMENU_MARGIN = 4;
const $fe5170bdd3625759$var$getPrefixComponent = (prefix)=>{
    if (typeof prefix === "string") return $fe5170bdd3625759$var$getIcon$1(prefix);
    if (prefix?.props?.src) return (0, $acw62.cloneElement)(prefix, {
        ...prefix.props,
        roundedCorner: true,
        aspectRatio: "square",
        style: {
            width: "24px",
            height: "24px"
        }
    });
    if (prefix?.props?.initials || prefix?.props?.kind) return (0, $acw62.cloneElement)(prefix, {
        ...prefix.props,
        size: "x-small"
    });
    return void 0;
};
const $fe5170bdd3625759$var$withLogic$1z = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [selected, setSelected] = (0, $acw62.useState)(false);
        const [menuItemId, setMenuItemId] = (0, $acw62.useState)("");
        const context = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const [offset, setOffset] = (0, $acw62.useState)({
            offsetX: 0,
            offsetY: 0
        });
        (0, $acw62.useEffect)(()=>{
            setMenuItemId($fe5170bdd3625759$var$getUniqueId());
        }, []);
        (0, $acw62.useEffect)(()=>{
            if (context.isNested && !props.children) {
                if (selected) setSelected(false);
                return;
            }
            if (props.children) {
                context.setIsNested(true);
                setSelected(context.activeMenuId === menuItemId);
            } else if (props.kind === "multi-select") setSelected(context.selectedValues.includes(props.value || ""));
            else setSelected(context.selectedValue !== void 0 && context.selectedValue === props.value);
        }, [
            selected,
            context.activeMenuId,
            menuItemId,
            context.selectedValue,
            context.selectedValues,
            context.isNested,
            props.value,
            props.children
        ]);
        const handleSubMenuPositioning = ()=>{
            const dropdownMenuItemRef2 = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR);
            if (dropdownMenuItemRef2) {
                const { right: right, top: top, bottom: bottom, left: left } = dropdownMenuItemRef2.getBoundingClientRect();
                setOffset({
                    offsetX: `${right + $fe5170bdd3625759$var$SUBMENU_MARGIN}px`,
                    offsetY: `${top - $fe5170bdd3625759$var$SUBMENU_OFFSET_TOP}px`
                });
                setTimeout(()=>{
                    const subMenuRef = document.querySelector(".j-jds-JDSDropdownMenuSubMenu-menu-container");
                    if (!subMenuRef) return;
                    const subMenuDomRect = subMenuRef.getBoundingClientRect();
                    if (subMenuDomRect.right < window.innerWidth) return;
                    if (subMenuDomRect.width < left) setOffset(({ offsetY: offsetY })=>({
                            offsetX: `${left - (subMenuDomRect.width + $fe5170bdd3625759$var$SUBMENU_MARGIN)}px`,
                            offsetY: offsetY
                        }));
                    else setOffset({
                        offsetX: `${window.innerWidth - subMenuDomRect.width}px`,
                        offsetY: `${bottom + $fe5170bdd3625759$var$SUBMENU_MARGIN}px`
                    });
                }, 50);
            }
        };
        const dropdownMenuItemRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                switch(event.key){
                    case "ArrowRight":
                        if (document.activeElement === dropdownMenuItemRef) {
                            if (Boolean(props.children) && !selected) {
                                context.setActiveMenuId(menuItemId);
                                handleSubMenuPositioning();
                                setTimeout(()=>{
                                    const subMenuRef = document.querySelector(".j-JDSDropdownMenuSubMenu-menu-container");
                                    if (subMenuRef) $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, subMenuRef, ".j-JDSDropdownMenuItem-container");
                                }, 10);
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        break;
                    case "ArrowLeft":
                    case "Escape":
                        if (selected && context.activeMenuId) {
                            setSelected(false);
                            context.setActiveMenuId("");
                            dropdownMenuItemRef?.focus?.();
                        }
                        break;
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            selected,
            dropdownMenuItemRef,
            menuItemId
        ]);
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(props.children?.props?.children);
        const selectedItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(props.children?.props?.children).filter((child)=>{
            if (!(typeof child === "object")) return false;
            if (!("props" in child)) return false;
            return child.props.selected;
        });
        const isSelected = children.length ? selectedItems.length === children.length : props.selected;
        const handleClick = (event)=>{
            const updatedSelectedValues = [
                ...context.selectedValues
            ];
            if (props.children) {
                context.setActiveMenuId(menuItemId);
                handleSubMenuPositioning();
            } else if (props.kind === "multi-select") {
                const isChecked = event.target.checked;
                if (isChecked) {
                    if (!updatedSelectedValues.includes(props.value ?? "")) updatedSelectedValues.push(props.value ?? "");
                } else {
                    const index = updatedSelectedValues.indexOf(props.value ?? "");
                    if (index > -1) updatedSelectedValues.splice(index, 1);
                }
            } else context.setSelectedValue(props.value ?? "");
            if (props.kind === "multi-select") {
                children.forEach((child)=>{
                    if (typeof child === "object" && "props" in child) {
                        if (child.props.selected) {
                            if (!updatedSelectedValues.includes(child.props.value)) updatedSelectedValues.push(child.props.value);
                        } else {
                            const index = updatedSelectedValues.indexOf(child.props.value);
                            if (index > -1) updatedSelectedValues.splice(index, 1);
                        }
                    }
                });
                context.setSelectedValues(updatedSelectedValues);
            }
            props?.onClick?.(props.value);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                prefix: $fe5170bdd3625759$var$getPrefixComponent(props.prefix),
                disabled: Boolean(props.disabled),
                _labelTextWrap: context.labelTextWrap,
                _offsetX: offset.offsetX,
                _offsetY: offset.offsetY,
                _hasSubMenu: Boolean(props.children),
                selected: selected,
                _checked: isSelected,
                _indeterminate: !isSelected && selectedItems.length > 0,
                className: selected ? "selected" : "",
                onClick: handleClick,
                tabIndex: 0,
                _ariaExpanded: !props.children ? void 0 : selected ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1B = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1w;
    const { kind: kind = "single-select", selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onItemSelect: onItemSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            onItemSelect: onItemSelect,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ed97964d1871885d = $fe5170bdd3625759$var$withLogic$1z($fe5170bdd3625759$var$Component$1B);
$fe5170bdd3625759$export$ed97964d1871885d.displayName = "DropdownMenuItem";
$fe5170bdd3625759$export$ed97964d1871885d.slotName = "jds_dropdown_menu_item";
const $fe5170bdd3625759$var$sdl$1v = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenu",
        "layerName": "jds_dropdown_menu_sub_menu",
        "internal": true
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_sub_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 65,
            "background-color": "{global.transparent}",
            "passive": true
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "popup-container": {
                    "size": "{size.max}"
                }
            }
        }
    },
    "api": {
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_dropdown_menu_sub_menu_internal": {
                "_menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "_menuMaxHeight": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            }
        },
        "events": {
            "jds_dropdown_menu_sub_menu_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onSelect": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$DROPDOWNMENUSUBMENU_SELECTOR = "div.j-JDSDropdownMenuSubMenuInternal-menu-container";
const $fe5170bdd3625759$var$withLogic$1y = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const context = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const [visible, setVisible] = (0, $acw62.useState)(false);
        const childArray = (0, $acw62.Children).toArray(props.children);
        const firstChild = childArray[0];
        const dropdownMenuSubMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUSUBMENU_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (dropdownMenuSubMenuRef) setTimeout(()=>{
                dropdownMenuSubMenuRef.focus();
            });
        }, [
            dropdownMenuSubMenuRef,
            visible
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                const isOpen = dropdownMenuSubMenuRef?.contains(document.activeElement);
                if (isOpen) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                }
            };
            if (context.activeMenuId) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            dropdownMenuSubMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            setTimeout(()=>{
                setVisible(true);
            }, 50);
        }, []);
        const isMobile = $fe5170bdd3625759$var$Devices.isMobile();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _menuContainerVisible: visible,
                _menuWidth: "max-content",
                offsetX: isMobile ? 0 : props.offsetX,
                offsetY: isMobile ? 0 : props.offsetY,
                _platform: isMobile ? "mobile" : "desktop",
                children: (0, $acw62.isValidElement)(firstChild) ? firstChild.props._childrenProps.props.children : null
            }
        });
    };
const $fe5170bdd3625759$var$Component$1A = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1v;
    const { onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenu", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$51cd9091d2dcc10a = $fe5170bdd3625759$var$withLogic$1y($fe5170bdd3625759$var$Component$1A);
$fe5170bdd3625759$export$51cd9091d2dcc10a.displayName = "DropdownMenuSubMenu";
$fe5170bdd3625759$export$51cd9091d2dcc10a.slotName = "jds_dropdown_menu_sub_menu";
const $fe5170bdd3625759$var$sdl$1u = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenuInternal",
        "layerName": "jds_dropdown_menu_sub_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            "menu-group-slot"
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "menu-group-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "data": {
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "max-height": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            }
        },
        "events": {
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1x = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1z = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1u;
    const { onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onAppear: onAppear,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$897b7938c608ac58 = $fe5170bdd3625759$var$withLogic$1x($fe5170bdd3625759$var$Component$1z);
$fe5170bdd3625759$export$897b7938c608ac58.displayName = "DropdownMenuSubMenuInternal";
$fe5170bdd3625759$export$897b7938c608ac58.slotName = "jds_dropdown_menu_sub_menu_internal";
const $fe5170bdd3625759$var$sdl$1t = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFAB",
        "layerName": "jds_fab",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_fab_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 50,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "size": "{f_3}",
            "padding-right": "{f_4}",
            "padding-bottom": "{f_5}"
        },
        "jds_fab_internal": {
            "hidden": false
        }
    },
    "variant": {
        "show": {
            "false": {
                "popup-container": {
                    "padding-bottom": "0"
                },
                "jds_fab_internal": {
                    "show": false
                }
            }
        },
        "extend": {
            "false": {
                "jds_fab_internal": {
                    "extend": false
                }
            }
        },
        "disableAnimation": {
            "false": {
                "popup-container": {
                    "transition": {
                        "property": [
                            "padding-bottom"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                },
                "jds_fab_internal": {
                    "disableAnimation": false
                }
            },
            "true": {
                "jds_fab_internal": {
                    "disableAnimation": true
                }
            }
        }
    },
    "api": {
        "data": {
            "jds_fab_internal": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                },
                "icon": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to control the entry animation of FAB"
            }
        },
        "events": {
            "jds_fab_internal": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_fab_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1w = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $acw62.useState)(false);
        const [hovered, setHovered] = (0, $acw62.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $acw62.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $acw62.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fab-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1y = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1t;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFAB", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$72beae6a392d0fc6 = $fe5170bdd3625759$var$withLogic$1w($fe5170bdd3625759$var$Component$1y);
$fe5170bdd3625759$export$72beae6a392d0fc6.displayName = "FAB";
$fe5170bdd3625759$export$72beae6a392d0fc6.slotName = "jds_fab";
const $fe5170bdd3625759$var$sdl$1s = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFABInternal",
        "layerName": "jds_fab_internal",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen.",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{f_6}",
            "display": "flex",
            "flex-direction": "{f_7}",
            "justify-content": "{f_8}",
            "align-items": "{f_9}",
            "gap": "{f_10}",
            "border-radius": "{f_11}",
            "padding-top": "{f_12}",
            "padding-left": "{f_13}",
            "padding-right": "{f_14}",
            "padding-bottom": "{f_15}",
            "border-color": "{f_16}",
            "border-width": "{f_17}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "background-color": "{f_18}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                },
                "active": {
                    "background-color": "{f_19}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000003D"
                    }
                },
                "focus": {
                    "background-color": "{f_20}",
                    "border-width": "{f_21}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                }
            }
        },
        "icon": {
            "hidden": false,
            "size": "{f_22}",
            "color": "{f_23}",
            "border-radius": "{f_24}",
            "behavior": {
                "active": {
                    "color": "{f_25}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{secondaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{secondary30}"
                }
            }
        }
    },
    "variant": {
        "show": {
            "false": {
                "container": {
                    "hidden": true,
                    "translate-y": "{size.max}"
                }
            }
        },
        "extend": {
            "false": {
                "container": {
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "disableAnimation": {
            "false": {
                "container": {
                    "enter-animation-name": "slideVerticallyUp",
                    "exit-animation-name": "slideVerticallyDown",
                    "enter-animation-curve": "entrance_ease",
                    "exit-animation-curve": "exit_ease",
                    "enter-animation-duration": 500,
                    "exit-animation-duration": 500,
                    "translate-y": "0",
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right",
                            "translate-y"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            },
            "true": {
                "container": {
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "_hasTitle": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasTitle": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1v = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $acw62.useState)(false);
        const [hovered, setHovered] = (0, $acw62.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $acw62.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $acw62.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fabinternal-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1x = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1s;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFABInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f3670f01e3026458 = $fe5170bdd3625759$var$withLogic$1v($fe5170bdd3625759$var$Component$1x);
$fe5170bdd3625759$export$f3670f01e3026458.displayName = "FABInternal";
$fe5170bdd3625759$export$f3670f01e3026458.slotName = "jds_fab_internal";
const $fe5170bdd3625759$var$sdl$1r = {
    "metadata": {
        "version": "1.0.0",
        "id": "feedback-block-1.0.0",
        "name": "JDSFeedbackBlock",
        "layerName": "jds_feedback_block"
    },
    "hierarchy": {
        "container": [
            {
                "icon-container": [
                    "icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}"
        },
        "icon-container": {
            "flex-direction": "{f_5}",
            "justify-content": "{f_6}",
            "align-items": "{f_7}",
            "height": "{f_8}"
        },
        "icon": {
            "size": "{f_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "s": {
                "icon-container": {
                    "height": "{f_10}"
                },
                "icon": {
                    "size": "{f_11}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "state": {
            "success": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_success_colored",
                    "color": "{feedbackSuccess50}"
                },
                "jds-text": {
                    "color": "{feedbackSuccess80}"
                }
            },
            "error": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_error_colored",
                    "color": "{feedbackError50}"
                },
                "jds-text": {
                    "color": "{feedbackError80}"
                }
            },
            "warning": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_warning_colored",
                    "color": "{feedbackWarning50}"
                },
                "jds-text": {
                    "color": "{feedbackWarning80}"
                }
            }
        },
        "alignment": {
            "top": {
                "container": {
                    "align-items": "{f_4}"
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "l",
                    "s"
                ]
            },
            "state": {
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "alignment": {
                "values": [
                    "center",
                    "top"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "stateText"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1u = (Component)=>(props)=>{
        if (!props.stateText) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1w = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1r;
    const { size: size = "l", state: state = "none", alignment: alignment = "center", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            state: state,
            alignment: alignment,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFeedbackBlock", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$FeedbackBlock = $fe5170bdd3625759$var$withLogic$1u($fe5170bdd3625759$var$Component$1w);
$fe5170bdd3625759$var$FeedbackBlock.displayName = "FeedbackBlock";
$fe5170bdd3625759$var$FeedbackBlock.slotName = "jds_feedback_block";
const $fe5170bdd3625759$var$sdl$1q = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-control-1.0.0",
        "name": "JDSFileUploaderControl",
        "layerName": "jds_file_uploader_control",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "label-jds-text",
                    {
                        "info-jds-icon-container": [
                            "info-jds-icon"
                        ]
                    }
                ]
            },
            "upload-jds_button",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}",
            "width": "{f_4}",
            "opacity": "{f_5}"
        },
        "label-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}"
        },
        "upload-jds_button": {
            "iconLeft": "ic_upload",
            "kind": "secondary",
            "size": "medium",
            "fullWidth": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        },
        "info-jds-icon": {
            "size": "{base}",
            "color": "{primaryGrey80}",
            "value": "ic_info",
            "ic": "ic_info"
        },
        "info-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{base}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_info"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "upload-jds_button": {
                "label": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "upload-jds_button": {
                "onClick": "onClick"
            },
            "info-jds-icon": {
                "onClick": "onInfoClick"
            }
        },
        "a11y": {
            "upload-jds_button": {
                "properties": {
                    "ariaLabel": "uploadButtonAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1t = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1v = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1q;
    const { onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInfoClick: onInfoClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onInfoClick: onInfoClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderControl", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2548bc68b9cf13da = $fe5170bdd3625759$var$withLogic$1t($fe5170bdd3625759$var$Component$1v);
$fe5170bdd3625759$export$2548bc68b9cf13da.displayName = "FileUploaderControl";
$fe5170bdd3625759$export$2548bc68b9cf13da.slotName = "jds_file_uploader_control";
const $fe5170bdd3625759$var$sdl$1p = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-item-1.0.0",
        "name": "JDSFileUploaderItem",
        "layerName": "jds_file_uploader_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "file-container": [
                    {
                        "state-container": [
                            "jds_spinner",
                            {
                                "state-jds-icon-container": [
                                    "state-jds-icon"
                                ]
                            },
                            "message-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "suffix-jds_button"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}"
        },
        "file-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}",
            "padding-left": "{f_10}",
            "width": "{f_11}"
        },
        "state-container": {
            "flex-direction": "{f_12}",
            "justify-content": "{f_13}",
            "align-items": "{f_14}",
            "gap": "{f_15}"
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "size": "small"
        },
        "button-container": {
            "show": true,
            "size": "48",
            "align-items": "{f_16}"
        },
        "suffix-jds_button": {
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "small"
        },
        "jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none"
        },
        "state-jds-icon": {
            "size": "{m}",
            "color": "{primary50}",
            "hidden": true
        },
        "state-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "message-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        }
    },
    "variant": {
        "kind": {
            "collapsed": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_down"
                },
                "jds_divider": {
                    "hidden": true
                }
            },
            "expanded": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_up"
                },
                "jds_divider": {
                    "hidden": true
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "loading": {
                    "jds_spinner": {
                        "hidden": false
                    },
                    "state-jds-icon": {},
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": true
                    }
                },
                "success": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackSuccess50}",
                        "value": "ic_success_colored",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "error": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "suffix-jds_button": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackError50}",
                        "value": "ic_error_colored",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackError50}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "loading",
                    "success",
                    "error"
                ]
            },
            "kind": {
                "values": [
                    "normal",
                    "collapsed",
                    "expanded"
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "message-jds-text": {
                "value": {
                    "type": "string",
                    "name": "message"
                }
            }
        },
        "events": {
            "suffix-jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "message"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Remove File"
                    },
                    "ariaExpanded": "ariaExpanded"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            }
        });
    };
const $fe5170bdd3625759$var$Component$1u = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1p;
    const { state: state = "loading", kind: kind = "normal", showDivider: showDivider = true, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.message?.toString(), suffixAriaLabel: suffixAriaLabel = "Remove File", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            showDivider: showDivider,
            onClick: onClick,
            ariaLabel: ariaLabel,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b41bb47bfc36c3b4 = $fe5170bdd3625759$var$withLogic$1s($fe5170bdd3625759$var$Component$1u);
$fe5170bdd3625759$export$b41bb47bfc36c3b4.displayName = "FileUploaderItem";
$fe5170bdd3625759$export$b41bb47bfc36c3b4.slotName = "jds_file_uploader_item";
const $fe5170bdd3625759$var$sdl$1o = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-list-1.0.0",
        "name": "JDSFileUploaderList",
        "layerName": "jds_file_uploader_list",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}"
        },
        "jds_file_uploader_item": {
            "kind": "normal",
            "showDivider": true
        }
    },
    "variant": {
        "showDivider": {
            "false": {
                "jds_file_uploader_item": {
                    "showDivider": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            },
            "jds_file_uploader_item": {
                "state": {
                    "type": "number",
                    "name": "items.state"
                },
                "message": {
                    "type": "string",
                    "name": "items.message"
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1r = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1t = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1o;
    const { showDivider: showDivider = true, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            showDivider: showDivider,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderList", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3d00ed40fd09f854 = $fe5170bdd3625759$var$withLogic$1r($fe5170bdd3625759$var$Component$1t);
$fe5170bdd3625759$export$3d00ed40fd09f854.displayName = "FileUploaderList";
$fe5170bdd3625759$export$3d00ed40fd09f854.slotName = "jds_file_uploader_list";
const $fe5170bdd3625759$var$sdl$1n = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-panel-1.0.0",
        "name": "JDSFileUploaderPanel",
        "layerName": "jds_file_uploader_panel",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item",
            {
                "inner-container": [
                    "jds_progress_bar"
                ]
            },
            "jds_file_uploader_list"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}",
            "padding-top": "{f_7}",
            "padding-bottom": "{f_8}"
        },
        "inner-container": {
            "hidden": true,
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}",
            "width": "{f_13}"
        },
        "jds_file_uploader_item": {
            "hidden": true
        },
        "jds_progress_bar": {
            "kind": "determinate",
            "flex": 1
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_item": {
                    "hidden": false
                },
                "inner-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "collapsible": {
                "false": {
                    "jds_file_uploader_item": {
                        "kind": "collapsed"
                    },
                    "jds_file_uploader_list": {
                        "hidden": true
                    }
                },
                "true": {
                    "jds_file_uploader_item": {
                        "kind": "expanded"
                    },
                    "jds_file_uploader_list": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "expanded"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_item": {
                "message": {
                    "type": "string",
                    "name": "message"
                }
            },
            "jds_progress_bar": {
                "value": {
                    "type": "float",
                    "name": "value"
                }
            },
            "jds_file_uploader_list": {
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            },
            "jds_file_uploader_list": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_list": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "panelAriaLabel",
                    "ariaDescribedby": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "suffixAriaLabel": {
                        "name": "panelSuffixAriaLabel",
                        "value": "Toggle Files List"
                    },
                    "ariaExpanded": {
                        "name": "_ariaExpanded",
                        "prop": "expanded"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1q = (Component)=>(props)=>{
        const { toggle: toggle, selected: selected } = $fe5170bdd3625759$var$useToggle(props.expanded, true);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                expanded: selected,
                onClick: (ev)=>{
                    if (selected) props.onClose?.();
                    else props.onClick?.(ev);
                    toggle();
                },
                onClose: (index)=>{
                    props.onClose?.(index);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1s = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1n;
    const { kind: kind = "classic", expanded: expanded = false, showDivider: showDivider = true, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), panelSuffixAriaLabel: panelSuffixAriaLabel = "Toggle Files List", _ariaExpanded: _ariaExpanded = props.expanded?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onClick: onClick,
            onClose: onClose,
            panelSuffixAriaLabel: panelSuffixAriaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderPanel", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4089cd2315da078 = $fe5170bdd3625759$var$withLogic$1q($fe5170bdd3625759$var$Component$1s);
$fe5170bdd3625759$export$4089cd2315da078.displayName = "FileUploaderPanel";
$fe5170bdd3625759$export$4089cd2315da078.slotName = "jds_file_uploader_panel";
const $fe5170bdd3625759$var$sdl$1m = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-icon-link-1.0.0",
        "name": "JDSFooterIconLinks",
        "layerName": "jds_footer_icon_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "icons-container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "jds_button": {
            "size": "small"
        },
        "icons-container": {
            "flex-direction": "{f_3}",
            "gap": "{f_4}"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "api": {
        "data": {
            "icons-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "icon": "string",
                        "href": "string"
                    }
                }
            },
            "jds_button": {
                "icon": {
                    "name": "links.icon",
                    "type": "string"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "icons-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "iconAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_button": {
                "properties": {
                    "ariaLabel": "links.iconAriaLabel",
                    "ariaDescribedby": "links.iconAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1p = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1r = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1m;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterIconLinks", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ce48424ab2a5a45 = $fe5170bdd3625759$var$withLogic$1p($fe5170bdd3625759$var$Component$1r);
$fe5170bdd3625759$export$ce48424ab2a5a45.displayName = "FooterIconLinks";
$fe5170bdd3625759$export$ce48424ab2a5a45.slotName = "jds_footer_icon_links";
const $fe5170bdd3625759$var$sdl$1l = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-1.0.0",
        "name": "JDSFooterLinks",
        "layerName": "jds_footer_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "links-container": [
                    {
                        "link-item-container": [
                            "jds_link"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}"
        },
        "link-item-container": {
            "size": "{f_3}",
            "padding-top": "{f_4}",
            "padding-bottom": "{f_5}",
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "background-color": "{f_9}",
            "behavior": {
                "hover": {
                    "background-color": "{f_10}"
                }
            }
        },
        "links-container": {
            "padding-top": "{f_13}",
            "size": "{f_14}",
            "flex-direction": "{f_15}"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{f_11}",
            "padding-bottom": "{f_12}"
        }
    },
    "api": {
        "config": {},
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1o = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1q = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1l;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinks", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$553910ef0cc96026 = $fe5170bdd3625759$var$withLogic$1o($fe5170bdd3625759$var$Component$1q);
$fe5170bdd3625759$export$553910ef0cc96026.displayName = "FooterLinks";
$fe5170bdd3625759$export$553910ef0cc96026.slotName = "jds_footer_links";
const $fe5170bdd3625759$var$sdl$1k = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-grid-1.0.0",
        "name": "JDSFooterLinksGrid",
        "layerName": "jds_footer_links_grid",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_footer_links"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "size": "{f_1}",
            "gap": "{f_2}",
            "flex": 1
        }
    },
    "api": {
        "config": {},
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "title": "string",
                        "provider": "object",
                        "subLinks": "list"
                    }
                }
            },
            "jds_footer_links": {
                "links": {
                    "type": "list",
                    "name": "links.subLinks"
                },
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1n = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1p = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1k;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinksGrid", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e5275d44ac937bc0 = $fe5170bdd3625759$var$withLogic$1n($fe5170bdd3625759$var$Component$1p);
$fe5170bdd3625759$export$e5275d44ac937bc0.displayName = "FooterLinksGrid";
$fe5170bdd3625759$export$e5275d44ac937bc0.slotName = "jds_footer_links_grid";
const $fe5170bdd3625759$var$sdl$1j = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-market-links-1.0.0",
        "name": "JDSFooterMarketLinks",
        "layerName": "jds_footer_market_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "assets-container": [
                    "image"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "assets-container": {
            "flex-direction": "{f_3}",
            "align-items": "{f_4}",
            "gap": "{f_5}"
        },
        "image": {
            "height": 40,
            "object-fit": "contain"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "assets-container": {
                "value": {
                    "name": "assets",
                    "type": "list",
                    "object": {
                        "image": "image"
                    }
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "assets.image"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1m = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1o = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1j;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterMarketLinks", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4e70d4e1c9ec4c90 = $fe5170bdd3625759$var$withLogic$1m($fe5170bdd3625759$var$Component$1o);
$fe5170bdd3625759$export$4e70d4e1c9ec4c90.displayName = "FooterMarketLinks";
$fe5170bdd3625759$export$4e70d4e1c9ec4c90.slotName = "jds_footer_market_links";
const $fe5170bdd3625759$var$sdl$1i = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-desktop-1.0.0",
        "name": "JDSHeaderDesktop",
        "layerName": "jds_header_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            {
                                "prefix-container": [
                                    "prefix-jds_button",
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            },
                            {
                                "links-container": [
                                    "link-jds_link"
                                ]
                            }
                        ]
                    },
                    "jds_search_box",
                    {
                        "right-container": [
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-slot"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_mega_menu",
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "prefix-container": {
            "flex-direction": "{h_2}",
            "justify-content": "{h_3}",
            "align-items": "{h_4}",
            "gap": "{h_5}"
        },
        "header-container": {
            "min-width": "{h_6}",
            "background-color": "{h_7}",
            "flex-direction": "{h_8}",
            "justify-content": "{h_9}",
            "align-items": "{h_10}",
            "padding-left": "{h_11}",
            "padding-top": "{h_12}",
            "padding-right": "{h_13}",
            "padding-bottom": "{h_14}",
            "gap": "{h_15}",
            "height": "{h_16}"
        },
        "left-container": {
            "flex-direction": "{h_17}",
            "justify-content": "{h_18}",
            "align-items": "{h_19}",
            "gap": "{h_20}"
        },
        "logo-container": {
            "flex-direction": "{h_21}",
            "justify-content": "{h_22}",
            "align-items": "{h_23}",
            "gap": "{h_24}"
        },
        "profile-container": {
            "hidden": true,
            "flex-direction": "{h_25}",
            "justify-content": "{h_26}",
            "align-items": "{h_27}",
            "gap": "{h_28}"
        },
        "links-container": {
            "flex-direction": "{h_29}",
            "justify-content": "{h_30}",
            "align-items": "{h_31}",
            "gap": "{h_32}",
            "padding-left": "{h_33}",
            "flex": 1,
            "hidden": false
        },
        "right-container": {
            "flex-direction": "{h_34}",
            "justify-content": "{h_35}",
            "align-items": "{h_36}",
            "gap": "{h_37}"
        },
        "suffix-container": {
            "flex-direction": "{h_38}",
            "justify-content": "{h_39}",
            "align-items": "{h_40}",
            "gap": "{h_41}",
            "width": "{h_42}"
        },
        "icon-links-container": {
            "flex-direction": "{h_43}",
            "justify-content": "{h_44}",
            "align-items": "{h_45}",
            "gap": "{h_46}",
            "hidden": false
        },
        "prefix-jds_button": {
            "size": "medium",
            "fullWidth": false
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "icon-links-jds_link": {
            "size": "medium"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "max-width": "312",
            "width": "{h_47}"
        },
        "link-jds_link": {
            "kind": "header"
        },
        "jds_search_results": {
            "open": false,
            "hidden": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "link-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "links-container": {
                    "hidden": true
                },
                "profile-container": {
                    "hidden": false
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_mega_menu": {
                    "hidden": true
                },
                "header-container": {
                    "padding-left": "{h_49}",
                    "padding-right": "{h_50}",
                    "gap": "{h_51}",
                    "height": "{h_48}"
                },
                "left-container": {
                    "gap": "{h_52}"
                },
                "right-container": {
                    "gap": "{h_53}"
                },
                "suffix-container": {
                    "gap": "{h_54}"
                }
            }
        },
        "_variant": {
            "active_search": {
                "header-container": {
                    "justify-content": "{h_56}"
                },
                "profile-container": {
                    "hidden": true
                },
                "links-container": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "prefix-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "icon-links-container": {
                    "hidden": true
                },
                "jds_search_box": {
                    "max-width": "784",
                    "width": "{h_57}"
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "false": {
                "container": {
                    "width": "{h_58}"
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasSearchResults": {
            "false": {
                "jds_search_results": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "mobile": {
                "active_search": {
                    "suffix-jds_action_button": {
                        "hidden": false
                    }
                }
            },
            "desktop": {
                "default": {
                    "left-container": {
                        "width": "{h_55}"
                    }
                }
            }
        },
        {
            "mobile": {
                "false": {
                    "header-container": {
                        "justify-content": "{h_59}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ],
        [
            "_platform",
            "_variant"
        ],
        [
            "_platform",
            "search"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "fullWidth": {
                "values": [
                    true,
                    false
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSearchResults": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "links-container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event",
                        "subLinks": "list",
                        "active": "boolean"
                    }
                }
            },
            "link-jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                },
                "_active": {
                    "type": "string",
                    "name": "links.active"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                }
            },
            "header-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "elementRef"
                }
            },
            "container": {
                "value": {
                    "type": "object",
                    "name": "megaMenuProps",
                    "object": {
                        "subLinks": "list",
                        "offsetX": "size",
                        "offsetY": "size",
                        "width": "size",
                        "open": "boolean"
                    }
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "_maxWidth": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults"
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "jds_mega_menu": {
                "items": {
                    "type": "object",
                    "name": "megaMenuProps.subLinks"
                },
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "width": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "open": {
                    "type": "boolean",
                    "name": "megaMenuProps.open"
                }
            },
            "search-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tabs_desktop"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            },
            "icon-links-slot": {
                "name": "iconLinks",
                "accepts": [
                    "jds_link"
                ]
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "link-jds_link": {
                "onHover": "onHover"
            },
            "jds_mega_menu": {
                "onHoverEnd": "onMenuHoverEnd"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onKeydown": "onSearchKeydown"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "container": {
                "name": "megaMenuProps",
                "repeating": {
                    "ariaLabel": "menuItemAriaLabel",
                    "ariaDescribedby": {
                        "name": "menuItemAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "role": {
                        "name": "role"
                    }
                }
            },
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "link-jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Jdstext = {
    "metadata": {
        "version": "1.0.0",
        "id": "text-1.0.0",
        "name": "JDSText",
        "layerName": "jds_text"
    },
    "hierarchy": {
        "text": []
    },
    "base": {
        "text": {
            "font-family": "{text_1}",
            "color": "{text_2}",
            "font-size": "{text_3}",
            "line-height": "{text_4}",
            "letter-spacing": "{text_5}",
            "font-weight": "{text_6}",
            "text-decoration": "{text_7}",
            "text-transform": "{text_8}"
        }
    },
    "variant": {
        "textAlign": {
            "center": {
                "text": {
                    "text-align": "center"
                }
            },
            "right": {
                "text": {
                    "text-align": "right"
                }
            }
        },
        "textDecoration": {
            "underline": {
                "text": {
                    "text-decoration": "{text_9}"
                }
            },
            "line-through": {
                "text": {
                    "text-decoration": "{text_10}"
                }
            },
            "overline": {
                "text": {
                    "text-decoration": "{text_11}"
                }
            }
        },
        "color": {
            "primary_80": {
                "text": {
                    "color": "{text_12}"
                }
            },
            "primary_70": {
                "text": {
                    "color": "{text_13}"
                }
            },
            "primary_60": {
                "text": {
                    "color": "{text_14}"
                }
            },
            "primary_50": {
                "text": {
                    "color": "{text_15}"
                }
            },
            "primary_40": {
                "text": {
                    "color": "{text_16}"
                }
            },
            "primary_30": {
                "text": {
                    "color": "{text_17}"
                }
            },
            "primary_20": {
                "text": {
                    "color": "{text_18}"
                }
            },
            "primary_inverse": {
                "text": {
                    "color": "{text_19}"
                }
            },
            "primary_background": {
                "text": {
                    "color": "{text_20}"
                }
            },
            "primary_grey_100": {
                "text": {
                    "color": "{text_21}"
                }
            },
            "primary_grey_80": {
                "text": {
                    "color": "{text_22}"
                }
            },
            "primary_grey_60": {
                "text": {
                    "color": "{text_23}"
                }
            },
            "primary_grey_40": {
                "text": {
                    "color": "{text_24}"
                }
            },
            "primary_grey_20": {
                "text": {
                    "color": "{text_25}"
                }
            },
            "secondary_80": {
                "text": {
                    "color": "{text_26}"
                }
            },
            "secondary_70": {
                "text": {
                    "color": "{text_27}"
                }
            },
            "secondary_60": {
                "text": {
                    "color": "{text_28}"
                }
            },
            "secondary_50": {
                "text": {
                    "color": "{text_29}"
                }
            },
            "secondary_40": {
                "text": {
                    "color": "{text_30}"
                }
            },
            "secondary_30": {
                "text": {
                    "color": "{text_31}"
                }
            },
            "secondary_20": {
                "text": {
                    "color": "{text_32}"
                }
            },
            "secondary_inverse": {
                "text": {
                    "color": "{text_33}"
                }
            },
            "secondary_background": {
                "text": {
                    "color": "{text_34}"
                }
            },
            "secondary_grey_100": {
                "text": {
                    "color": "{text_35}"
                }
            },
            "secondary_grey_80": {
                "text": {
                    "color": "{text_36}"
                }
            },
            "secondary_grey_60": {
                "text": {
                    "color": "{text_37}"
                }
            },
            "secondary_grey_40": {
                "text": {
                    "color": "{text_38}"
                }
            },
            "secondary_grey_20": {
                "text": {
                    "color": "{text_39}"
                }
            },
            "sparkle_80": {
                "text": {
                    "color": "{text_40}"
                }
            },
            "sparkle_70": {
                "text": {
                    "color": "{text_41}"
                }
            },
            "sparkle_60": {
                "text": {
                    "color": "{text_42}"
                }
            },
            "sparkle_50": {
                "text": {
                    "color": "{text_43}"
                }
            },
            "sparkle_40": {
                "text": {
                    "color": "{text_44}"
                }
            },
            "sparkle_30": {
                "text": {
                    "color": "{text_45}"
                }
            },
            "sparkle_20": {
                "text": {
                    "color": "{text_46}"
                }
            },
            "sparkle_inverse": {
                "text": {
                    "color": "{text_47}"
                }
            },
            "sparkle_background": {
                "text": {
                    "color": "{text_48}"
                }
            },
            "sparkle_grey_100": {
                "text": {
                    "color": "{text_49}"
                }
            },
            "sparkle_grey_80": {
                "text": {
                    "color": "{text_50}"
                }
            },
            "sparkle_grey_60": {
                "text": {
                    "color": "{text_51}"
                }
            },
            "sparkle_grey_40": {
                "text": {
                    "color": "{text_52}"
                }
            },
            "sparkle_grey_20": {
                "text": {
                    "color": "{text_53}"
                }
            },
            "feedback_error_80": {
                "text": {
                    "color": "{text_54}"
                }
            },
            "feedback_error_50": {
                "text": {
                    "color": "{text_55}"
                }
            },
            "feedback_error_20": {
                "text": {
                    "color": "{text_56}"
                }
            },
            "feedback_warning_80": {
                "text": {
                    "color": "{text_57}"
                }
            },
            "feedback_warning_50": {
                "text": {
                    "color": "{text_58}"
                }
            },
            "feedback_warning_20": {
                "text": {
                    "color": "{text_59}"
                }
            },
            "feedback_success_80": {
                "text": {
                    "color": "{text_60}"
                }
            },
            "feedback_success_50": {
                "text": {
                    "color": "{text_61}"
                }
            },
            "feedback_success_20": {
                "text": {
                    "color": "{text_62}"
                }
            },
            "white": {
                "text": {
                    "color": "{text_63}"
                }
            },
            "black": {
                "text": {
                    "color": "{text_64}"
                }
            },
            "transparent": {
                "text": {
                    "color": "{text_65}"
                }
            }
        },
        "appearance": {
            "heading_xl": {
                "text": {
                    "font-size": "{text_66}",
                    "line-height": "{text_68}",
                    "letter-spacing": "{text_69}",
                    "font-weight": "{text_70}",
                    "font-family": "{text_67}"
                }
            },
            "heading_l": {
                "text": {
                    "font-size": "{text_71}",
                    "line-height": "{text_73}",
                    "letter-spacing": "{text_74}",
                    "font-weight": "{text_75}",
                    "font-family": "{text_72}"
                }
            },
            "heading_m": {
                "text": {
                    "font-size": "{text_76}",
                    "line-height": "{text_78}",
                    "letter-spacing": "{text_79}",
                    "font-weight": "{text_80}",
                    "font-family": "{text_77}"
                }
            },
            "heading_s": {
                "text": {
                    "font-size": "{text_81}",
                    "font-family": "{text_82}",
                    "line-height": "{text_83}",
                    "letter-spacing": "{text_84}",
                    "font-weight": "{text_85}"
                }
            },
            "heading_xs": {
                "text": {
                    "font-size": "{text_86}",
                    "font-family": "{text_87}",
                    "line-height": "{text_88}",
                    "letter-spacing": "{text_89}",
                    "font-weight": "{text_90}"
                }
            },
            "heading_xxs": {
                "text": {
                    "font-size": "{text_91}",
                    "line-height": "{text_93}",
                    "letter-spacing": "{text_94}",
                    "font-weight": "{text_95}",
                    "font-family": "{text_92}"
                }
            },
            "overline": {
                "text": {
                    "font-size": "{text_96}",
                    "font-family": "{text_97}",
                    "line-height": "{text_98}",
                    "letter-spacing": "{text_99}",
                    "font-weight": "{text_100}",
                    "text-transform": "{text_101}"
                }
            },
            "body_l": {
                "text": {
                    "font-size": "{text_102}",
                    "font-family": "{text_103}",
                    "line-height": "{text_104}",
                    "letter-spacing": "{text_105}",
                    "font-weight": "{text_106}"
                }
            },
            "body_l_bold": {
                "text": {
                    "font-size": "{text_107}",
                    "font-family": "{text_108}",
                    "line-height": "{text_109}",
                    "letter-spacing": "{text_110}",
                    "font-weight": "{text_111}"
                }
            },
            "body_l_link": {
                "text": {
                    "font-size": "{text_112}",
                    "font-family": "{text_113}",
                    "line-height": "{text_114}",
                    "letter-spacing": "{text_115}",
                    "font-weight": "{text_116}",
                    "color": "{text_0}"
                }
            },
            "body_m": {
                "text": {
                    "font-size": "{text_117}",
                    "font-family": "{text_118}",
                    "line-height": "{text_119}",
                    "letter-spacing": "{text_120}",
                    "font-weight": "{text_121}"
                }
            },
            "body_m_bold": {
                "text": {
                    "font-size": "{text_122}",
                    "font-family": "{text_123}",
                    "line-height": "{text_124}",
                    "letter-spacing": "{text_125}",
                    "font-weight": "{text_126}"
                }
            },
            "body_m_link": {
                "text": {
                    "font-size": "{text_127}",
                    "font-family": "{text_128}",
                    "line-height": "{text_129}",
                    "letter-spacing": "{text_130}",
                    "font-weight": "{text_131}",
                    "color": "{text_0}"
                }
            },
            "body_s": {
                "text": {
                    "font-size": "{text_132}",
                    "font-family": "{text_133}",
                    "line-height": "{text_134}",
                    "letter-spacing": "{text_135}",
                    "font-weight": "{text_136}"
                }
            },
            "body_s_bold": {
                "text": {
                    "font-size": "{text_137}",
                    "font-family": "{text_138}",
                    "line-height": "{text_139}",
                    "letter-spacing": "{text_140}",
                    "font-weight": "{text_141}"
                }
            },
            "body_s_link": {
                "text": {
                    "font-size": "{text_142}",
                    "font-family": "{text_143}",
                    "line-height": "{text_144}",
                    "letter-spacing": "{text_145}",
                    "font-weight": "{text_146}",
                    "color": "{text_0}"
                }
            },
            "body_xs": {
                "text": {
                    "font-size": "{text_147}",
                    "font-family": "{text_148}",
                    "line-height": "{text_149}",
                    "letter-spacing": "{text_150}",
                    "font-weight": "{text_151}"
                }
            },
            "body_xs_bold": {
                "text": {
                    "font-size": "{text_152}",
                    "font-family": "{text_153}",
                    "line-height": "{text_154}",
                    "letter-spacing": "{text_155}",
                    "font-weight": "{text_156}"
                }
            },
            "body_xs_link": {
                "text": {
                    "font-size": "{text_157}",
                    "font-family": "{text_158}",
                    "line-height": "{text_159}",
                    "letter-spacing": "{text_160}",
                    "font-weight": "{text_161}",
                    "color": "{text_0}"
                }
            },
            "body_xxs": {
                "text": {
                    "font-size": "{text_167}",
                    "font-family": "{text_168}",
                    "line-height": "{text_169}",
                    "letter-spacing": "{text_170}",
                    "font-weight": "{text_171}"
                }
            },
            "body_xxs_bold": {
                "text": {
                    "font-size": "{text_172}",
                    "font-family": "{text_173}",
                    "line-height": "{text_174}",
                    "letter-spacing": "{text_175}",
                    "font-weight": "{text_176}"
                }
            },
            "body_xxs_link": {
                "text": {
                    "font-size": "{text_177}",
                    "font-family": "{text_178}",
                    "line-height": "{text_179}",
                    "letter-spacing": "{text_180}",
                    "font-weight": "{text_181}",
                    "color": "{text_0}"
                }
            },
            "body_3xs": {
                "text": {
                    "font-size": "{text_182}",
                    "font-family": "{text_183}",
                    "line-height": "{text_184}",
                    "letter-spacing": "{text_185}",
                    "font-weight": "{text_186}"
                }
            },
            "body_3xs_bold": {
                "text": {
                    "font-size": "{text_187}",
                    "font-family": "{text_188}",
                    "line-height": "{text_189}",
                    "letter-spacing": "{text_190}",
                    "font-weight": "{text_191}"
                }
            },
            "body_3xs_link": {
                "text": {
                    "font-size": "{text_192}",
                    "font-family": "{text_193}",
                    "line-height": "{text_194}",
                    "letter-spacing": "{text_195}",
                    "font-weight": "{text_196}",
                    "color": "{text_0}"
                }
            },
            "list_title": {
                "text": {
                    "font-size": "{text_197}",
                    "font-family": "{text_198}",
                    "line-height": "{text_199}",
                    "letter-spacing": "{text_200}",
                    "font-weight": "{text_201}"
                }
            },
            "button": {
                "text": {
                    "font-size": "{text_202}",
                    "font-family": "{text_203}",
                    "line-height": "{text_204}",
                    "letter-spacing": "{text_205}",
                    "font-weight": "{text_206}"
                }
            },
            "code": {
                "text": {
                    "font-size": "{text_207}",
                    "font-family": "{text_208}",
                    "line-height": "{text_209}",
                    "letter-spacing": "{text_210}",
                    "font-weight": "{text_211}"
                }
            },
            "body_xs_caps": {
                "text": {
                    "font-size": "{text_variant_appearance_body_xs_caps_text_font-size}",
                    "line-height": "{text_163}",
                    "letter-spacing": "{text_165}",
                    "font-weight": "{text_166}",
                    "text-transform": "{text_164}",
                    "font-family": "{text_162}"
                }
            },
            "body_s_regular_para": {
                "text": {
                    "font-size": "{text_212}",
                    "line-height": "{text_213}",
                    "letter-spacing": "{text_214}",
                    "font-weight": "{text_215}",
                    "font-family": "{text_216}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to text.",
                "function": true
            },
            "textAlign": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It aligns text to left, center, right."
            },
            "textDecoration": {
                "values": [
                    "none",
                    "underline",
                    "line-through",
                    "overline"
                ],
                "doc_description": "It can be used to decorate text eg. 'underline', 'line-through', 'overline'."
            },
            "appearance": {
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ],
                "doc_description": "It can be used to set a font appearance based on our typography rules."
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "text",
                    "doc_description": "It the user input text."
                },
                "max-lines": {
                    "type": "number",
                    "name": "maxLines",
                    "function": true,
                    "required": false,
                    "doc_description": "It determines the maximum lines of text the user can pass as input."
                },
                "min-lines": {
                    "type": "number",
                    "name": "minLines",
                    "platform": "android",
                    "required": false,
                    "doc_description": "It determines the minimum lines of text the user can pass as input."
                },
                "trim-line-padding": {
                    "type": "string",
                    "name": "trimLinePadding",
                    "required": false,
                    "platform": "android",
                    "doc_description": "Defines whether the space that would be added to the top of first line, and bottom of the last line should be trimmed or not."
                },
                "textType": {
                    "type": "string",
                    "name": "textType",
                    "platform": "web"
                },
                "custom-color": {
                    "type": "color",
                    "name": "customColor",
                    "required": false,
                    "platform": "android"
                }
            }
        },
        "events": {
            "text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyTextColors = [
    "primary-grey-100",
    "primary-80",
    "primary-70",
    "primary-60",
    "primary-50",
    "primary-40",
    "primary-30",
    "primary-20",
    "primary-inverse",
    "primary-background",
    "primary-grey-80",
    "primary-grey-60",
    "primary-grey-40",
    "primary-grey-20",
    "secondary-80",
    "secondary-70",
    "secondary-60",
    "secondary-50",
    "secondary-40",
    "secondary-30",
    "secondary-20",
    "secondary-inverse",
    "secondary-background",
    "secondary-grey-100",
    "secondary-grey-80",
    "secondary-grey-60",
    "secondary-grey-40",
    "secondary-grey-20",
    "sparkle-80",
    "sparkle-70",
    "sparkle-60",
    "sparkle-50",
    "sparkle-40",
    "sparkle-30",
    "sparkle-20",
    "sparkle-inverse",
    "sparkle-background",
    "sparkle-grey-100",
    "sparkle-grey-80",
    "sparkle-grey-60",
    "sparkle-grey-40",
    "sparkle-grey-20",
    "feedback-error-80",
    "feedback-error-50",
    "feedback-error-20",
    "feedback-warning-80",
    "feedback-warning-50",
    "feedback-warning-20",
    "feedback-success-80",
    "feedback-success-50",
    "feedback-success-20"
];
const $fe5170bdd3625759$var$legacyAppearance = [
    "body-s",
    "heading-xl",
    "heading-l",
    "heading-m",
    "heading-s",
    "heading-xs",
    "heading-xxs",
    "overline",
    "body-l",
    "body-l-bold",
    "body-l-link",
    "body-m",
    "body-m-bold",
    "body-m-link",
    "body-s-bold",
    "body-s-link",
    "body-xs",
    "body-xs-bold",
    "body-xs-link",
    "body-xxs",
    "body-xxs-bold",
    "body-xxs-link",
    "list-title",
    "body_xs_caps"
];
const $fe5170bdd3625759$var$PROP_MAP$n = (props)=>{
    if ($fe5170bdd3625759$var$legacyAppearance.includes(props.appearance)) console.warn("these values for appearance prop are deprecated", $fe5170bdd3625759$var$legacyAppearance);
    if ($fe5170bdd3625759$var$legacyTextColors.includes(props.color)) console.warn("these values for color are deprecated", $fe5170bdd3625759$var$legacyTextColors);
    return {
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                "feedback-error-80": {
                    color: "feedback_error_80"
                },
                "feedback-error-50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.text || props.children
            }
        },
        text: {
            properties: {
                text: props.text || props.children
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1l = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$n);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $fe5170bdd3625759$var$Component$1n = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$Jdstext;
    const { color: color = "primary_grey_100", textAlign: textAlign = "left", textDecoration: textDecoration = "none", appearance: appearance = "body_s", onTextLayout: onTextLayout = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            textAlign: textAlign,
            textDecoration: textDecoration,
            appearance: appearance,
            onTextLayout: onTextLayout,
            ...rest
        },
        componentTag: componentTag
    }, "JDSText", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5f1af8db9871e1d6 = $fe5170bdd3625759$var$withLogic$1l($fe5170bdd3625759$var$Component$1n);
$fe5170bdd3625759$export$5f1af8db9871e1d6.displayName = "Text";
$fe5170bdd3625759$export$5f1af8db9871e1d6.slotName = "jds_text";
const $fe5170bdd3625759$var$PROP_MAP$m = (props)=>({
        searchConfig: {
            properties: {
                searchResults: props.searchConfig?.searchResults?.sections?.[0].results?.map((c)=>({
                        ...c,
                        label: c.title
                    })),
                searchResultHeader: props.searchConfig?.searchResults?.sections?.[0].header,
                searchLabel: props.searchConfig?.searchInput?.label,
                searchSuffix: props.searchConfig?.searchInput?.suffix,
                searchShowBack: props.searchConfig?.searchInput?.showBack,
                query: props.searchConfig?.searchInput?.value,
                searchResultHeaderAction: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.title,
                onSearchResultClick: props.searchConfig?.searchResults?.onResultsItemClick,
                onSearchResultHeaderActionClick: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.onClick
            }
        },
        suffix: {
            properties: {
                suffix: typeof props.suffix === "string" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                    children: props.suffix
                }) : props.suffix
            }
        }
    });
const $fe5170bdd3625759$var$sdl$1h = {
    "metadata": {
        "version": "1.0.0",
        "id": "link-1.0.0",
        "name": "JDSLink",
        "layerName": "jds_link"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "children-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{l_0}",
            "flex-direction": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "behavior": {
                "hover": {},
                "visited": {},
                "active": {},
                "focus": {
                    "border-radius": "{l_4}",
                    "border-width": "{l_5}",
                    "border-color": "{l_6}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-color": "primary_grey_60"
        }
    },
    "variant": {
        "_hasText": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "false": {
                "children-slot": {
                    "hidden": true
                }
            },
            "true": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "textAppearance": {
            "body_s": {
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            },
            "body_s_bold": {
                "jds-text": {}
            },
            "body_m": {
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "body_m_bold": {
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "body_l": {
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "body_l_bold": {
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            },
            "body_l_link": {
                "jds-text": {
                    "font-family": "{bodyLLink}",
                    "font-size": "{bodyLLink}",
                    "line-height": "{bodyLLink}",
                    "letter-spacing": "{bodyLLink}",
                    "font-weight": "{bodyLLink}"
                }
            },
            "body_xs": {
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            },
            "body_xxs": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "body_s_link": {
                "jds-text": {
                    "font-family": "{bodySLink}",
                    "font-size": "{bodySLink}",
                    "line-height": "{bodySLink}",
                    "letter-spacing": "{bodySLink}",
                    "font-weight": "{bodySLink}"
                }
            },
            "body_m_link": {
                "jds-text": {
                    "font-family": "{bodyMLink}",
                    "font-size": "{bodyMLink}",
                    "line-height": "{bodyMLink}",
                    "letter-spacing": "{bodyMLink}",
                    "font-weight": "{bodyMLink}"
                }
            },
            "body_xxs_link": {
                "jds-text": {
                    "font-family": "{bodyXxsLink}",
                    "font-size": "{bodyXxsLink}",
                    "line-height": "{bodyXxsLink}",
                    "letter-spacing": "{bodyXxsLink}",
                    "font-weight": "{bodyXxsLink}"
                }
            },
            "body_xs_link": {
                "jds-text": {
                    "font-family": "{bodyXsLink}",
                    "font-size": "{bodyXsLink}",
                    "line-height": "{bodyXsLink}",
                    "letter-spacing": "{bodyXsLink}",
                    "font-weight": "{bodyXsLink}"
                }
            },
            "body_xs_bold": {
                "jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "body_xxs_bold": {
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "heading_s": {
                "jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}"
                }
            },
            "overline": {
                "jds-text": {
                    "font-family": "{overline}",
                    "font-size": "{overline}",
                    "line-height": "{overline}",
                    "letter-spacing": "{overline}",
                    "font-weight": "{overline}",
                    "text-transform": "{overline}"
                }
            },
            "heading_xs": {
                "jds-text": {
                    "font-family": "{headingXs}",
                    "font-size": "{headingXs}",
                    "line-height": "{headingXs}",
                    "letter-spacing": "{headingXs}",
                    "font-weight": "{headingXs}"
                }
            },
            "heading_xxs": {
                "jds-text": {
                    "font-family": "{headingXxs}",
                    "font-size": "{headingXxs}",
                    "line-height": "{headingXxs}",
                    "letter-spacing": "{headingXxs}",
                    "font-weight": "{headingXxs}"
                }
            },
            "heading_l": {
                "jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}"
                }
            },
            "heading_m": {
                "jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}"
                }
            },
            "heading_xl": {
                "jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}"
                }
            },
            "list_title": {
                "jds-text": {
                    "font-family": "{listTitle}",
                    "font-size": "{listTitle}",
                    "line-height": "{listTitle}",
                    "letter-spacing": "{listTitle}",
                    "font-weight": "{listTitle}"
                }
            },
            "button": {
                "jds-text": {
                    "font-family": "{button}",
                    "font-size": "{button}",
                    "line-height": "{button}",
                    "letter-spacing": "{button}",
                    "font-weight": "{button}"
                }
            },
            "code": {
                "jds-text": {
                    "font-family": "{code}",
                    "font-size": "{code}",
                    "line-height": "{code}",
                    "letter-spacing": "{code}",
                    "font-weight": "{code}"
                }
            }
        },
        "kind": {
            "default": {
                "jds-text": {
                    "behavior": {
                        "hover": {
                            "color": "{primary50}"
                        },
                        "visited": {
                            "color": "{primaryGrey80}"
                        }
                    }
                }
            },
            "header": {
                "container": {
                    "behavior": {
                        "focus": {
                            "border-color": "{l_7}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "submenu": {
                "jds-text": {
                    "color": "{primaryGrey80}",
                    "behavior": {
                        "hover": {
                            "color": "{primaryGrey100}",
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "rich_text": {
                "jds-text": {
                    "color": "{primaryGrey100}",
                    "text-decoration": "{text-decoration.underline}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.none}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "header": {
                    "jds-text": {
                        "text-decoration": "{text-decoration.underline}"
                    }
                }
            }
        },
        {
            "header": {
                "none": {
                    "jds-text": {
                        "color": "{primaryInverse}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            },
                            "active": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            },
            "submenu": {
                "none": {
                    "jds-text": {}
                }
            },
            "rich_text": {
                "none": {
                    "jds-text": {
                        "font-family": "{bodySLink}",
                        "font-size": "{bodySLink}",
                        "line-height": "{bodySLink}",
                        "letter-spacing": "{bodySLink}",
                        "font-weight": "{bodySLink}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySBold}",
                                "color": "{primaryGrey100}",
                                "font-size": "{bodySBold}",
                                "line-height": "{bodySBold}",
                                "letter-spacing": "{bodySBold}",
                                "font-weight": "{bodySBold}",
                                "text-decoration": "{text-decoration.underline}"
                            }
                        }
                    }
                }
            },
            "default": {
                "none": {
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_active",
            "kind"
        ],
        [
            "kind",
            "textAppearance"
        ]
    ],
    "api": {
        "data": {
            "container": {
                "href": {
                    "type": "string",
                    "name": "href",
                    "doc_description": "User provided href of the Link."
                },
                "target": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displayes the title of Link."
                }
            }
        },
        "config": {
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            },
            "_active": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasChildren": {
                "values": [
                    true,
                    false
                ]
            },
            "textAppearance": {
                "type": "JDSText.appearance",
                "doc_description": "It can be used to apply certain style to the title of the link.",
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "header",
                    "submenu",
                    "rich_text"
                ],
                "doc_description": "It can be used to switch between 4 variants of Link."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "link"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withProviderProps = (Component)=>({ provider: provider = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {}), ...rest })=>{
        const currentProvider = provider || rest?.href ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
            href: rest?.href
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {});
        if (!Component) return null;
        return (0, $acw62.cloneElement)(currentProvider, {
            ...{
                ...provider?.props,
                target: rest.newTab ? "_blank" : void 0,
                tabIndex: -1,
                style: {
                    ...provider?.props?.style || {},
                    display: "inline-flex"
                }
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...rest
            })
        });
    };
const $fe5170bdd3625759$var$PROP_MAP$l = (props)=>{
    if (props.kind === "rich-text") console.warn("rich-text is deprecated, use rich_text instead");
    return {
        newTab: {
            properties: {
                newTab: props.newTab ? "_blank" : void 0
            }
        },
        kind: {
            variations: {
                default: {
                    kind: "default"
                },
                "rich-text": {
                    kind: "rich_text"
                }
            }
        },
        textAppearance: {
            properties: {},
            variations: {
                "body-s": {
                    textAppearance: "body-s"
                },
                "heading-xl": {
                    textAppearance: "heading_xl"
                },
                "heading-l": {
                    textAppearance: "heading_l"
                },
                "heading-m": {
                    textAppearance: "heading_m"
                },
                "heading-s": {
                    textAppearance: "heading_s"
                },
                "heading-xs": {
                    textAppearance: "heading_xs"
                },
                "heading-xxs": {
                    textAppearance: "heading_xxs"
                },
                overline: {
                    textAppearance: "overline"
                },
                "body-l": {
                    textAppearance: "body_l"
                },
                "body-l-bold": {
                    textAppearance: "body_l_bold"
                },
                "body-l-link": {
                    textAppearance: "body_l_link"
                },
                "body-m": {
                    textAppearance: "body_m"
                },
                "body-m-bold": {
                    textAppearance: "body_m_bold"
                },
                "body-m-link": {
                    textAppearance: "body_m_link"
                },
                "body-s-bold": {
                    textAppearance: "body_s_bold"
                },
                "body-s-link": {
                    textAppearance: "body_s_link"
                },
                "body-xs": {
                    textAppearance: "body_xs"
                },
                "body-xs-bold": {
                    textAppearance: "body_xs_bold"
                },
                "body-xs-link": {
                    textAppearance: "body_xs_link"
                },
                "body-xxs": {
                    textAppearance: "body_xxs"
                },
                "body-xxs-bold": {
                    textAppearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    textAppearance: "body_xxs_link"
                },
                "list-title": {
                    textAppearance: "list_title"
                },
                button: {
                    textAppearance: "button"
                },
                code: {
                    textAppearance: "code"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1k = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$l);
        const ComponentWithProvider = (0, $acw62.useMemo)(()=>$fe5170bdd3625759$var$withProviderProps(Component), []);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ComponentWithProvider, {
            ...{
                ...props,
                rootRef: ref,
                textAppearance: props.textAppearance || "body_s",
                _hasText: Boolean(props.title),
                _hasChildren: Boolean(props.children) && !props.title,
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        });
    });
const $fe5170bdd3625759$var$Component$1m = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1h;
    const { textAppearance: textAppearance = "undefined", kind: kind = "default", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            textAppearance: textAppearance,
            kind: kind,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSLink", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a6c7ac8248d6e38a = $fe5170bdd3625759$var$withLogic$1k($fe5170bdd3625759$var$Component$1m);
$fe5170bdd3625759$export$a6c7ac8248d6e38a.displayName = "Link";
$fe5170bdd3625759$export$a6c7ac8248d6e38a.slotName = "jds_link";
const $fe5170bdd3625759$var$sdl$1g = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "name": "JDSSidePanel",
        "description": "",
        "layerName": "jds_side_panel"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_side_panel_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "passive": true,
            "show": true
        },
        "popup-container": {
            "background-color": "#141414D9",
            "height": "{s_0}",
            "width": "{s_1}",
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "jds_side_panel_internal": {
            "open": false,
            "maxWidth": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}"
                },
                "jds_side_panel_internal": {
                    "open": true
                }
            }
        },
        "direction": {
            "right": {
                "popup-container": {
                    "justify-content": "{s_27}"
                },
                "jds_side_panel_internal": {
                    "direction": "right"
                }
            }
        },
        "maxWidth": {
            "true": {
                "jds_side_panel_internal": {
                    "maxWidth": true
                }
            }
        },
        "showClose": {
            "false": {
                "jds_side_panel_internal": {
                    "showClose": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [],
    "api": {
        "config": {
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "jds_side_panel_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                },
                "items.prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "items.title": {
                    "type": "string",
                    "name": "items.title"
                },
                "links.showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "prefix": {
                    "name": "prefix",
                    "type": "slot",
                    "accepts": [
                        "jds_avatar",
                        "jds_icon",
                        "jds_button"
                    ],
                    "max": 1
                },
                "header": {
                    "name": "header",
                    "type": "slot",
                    "doc_description": "Has pre-defined suffix as close button.",
                    "accepts": [
                        "jds_text"
                    ],
                    "max": 1
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks.",
                    "accepts": [
                        "any"
                    ]
                }
            }
        },
        "events": {
            "jds_side_panel_internal": {
                "onClose": "onClose",
                "onContainerClick": "_onContainerClick",
                "onSwipeLeft": "onClose",
                "onSidePanelSuffixClick": "onSidePanelSuffixClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_side_panel_internal": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$k = (props)=>{
    if (props.header?.title) console.warn("passing listblock props to header is deprecated");
    return {
        header: {
            properties: {
                prefix: props.header?.prefix,
                header: props.header?.titleBlock?.text || (props.header?.title ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                    children: props.header?.title
                }) : props.header)
            }
        },
        maxWidth: {
            properties: {
                maxWidth: !props.maxWidth
            }
        }
    };
};
const $fe5170bdd3625759$var$SIDEPANEL_SELECTOR = "div.j-JDSSidePanelInternal-container";
const $fe5170bdd3625759$var$withLogic$1j = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$k);
        const { className: className, open: open, close: close } = $fe5170bdd3625759$var$useTransition(Boolean(props.open), props.onClose, 500);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const sidepanelRef = element?.querySelector($fe5170bdd3625759$var$SIDEPANEL_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (props.open && sidepanelRef) sidepanelRef.focus();
        }, [
            props.open
        ]);
        const directionClass = props.direction === "right" ? "right" : "";
        const classes = [
            directionClass,
            className,
            !props.disableTransition ? "enable-transition" : ""
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                maxWidth: props.maxWidth || props.maxWidth === void 0,
                platform: $fe5170bdd3625759$var$getPlatform(),
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children),
                className: classes.join(" "),
                _onContainerClick: (ev)=>{
                    ev.stopPropagation();
                },
                onClose: close
            }
        });
    };
const $fe5170bdd3625759$var$Component$1l = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1g;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanel", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8689d3888980b1f3 = $fe5170bdd3625759$var$withLogic$1j($fe5170bdd3625759$var$Component$1l);
$fe5170bdd3625759$export$8689d3888980b1f3.displayName = "SidePanel";
$fe5170bdd3625759$export$8689d3888980b1f3.slotName = "jds_side_panel";
const $fe5170bdd3625759$var$sdl$1f = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-item-1.0.0",
        "name": "JDSSidePanelItem",
        "layerName": "jds_side_panel_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "title-jds_link"
                ]
            },
            "suffix-jds_action_button",
            "heading-jds-text",
            "jds_divider"
        ]
    },
    "base": {
        "jds_divider": {
            "hidden": true,
            "pad": "none",
            "orientation": "horizontal"
        },
        "container": {
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}"
        },
        "inner-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "gap": "{s_9}",
            "padding-top": "{s_10}",
            "padding-bottom": "{s_11}",
            "flex": 1
        },
        "title-jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_next",
            "size": "medium",
            "kind": "tertiary"
        },
        "heading-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-top": "{s_0}",
            "padding-bottom": "{s_1}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{primary20}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "showSuffix": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "type": {
            "divider": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_divider": {
                    "hidden": false
                }
            },
            "heading": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "showSuffix": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "title-jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "itemSuffixAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1i = (Component)=>(props)=>{
        const { prefix: prefix, ...rest } = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                onSuffixClick: ()=>{
                    rest.onSuffixClick?.(rest.internalIndex);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1k = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1f;
    const { type: type = "entry", showSuffix: showSuffix = true, onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            showSuffix: showSuffix,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$500ae19c14a3c46 = $fe5170bdd3625759$var$withLogic$1i($fe5170bdd3625759$var$Component$1k);
$fe5170bdd3625759$export$500ae19c14a3c46.displayName = "SidePanelItem";
$fe5170bdd3625759$export$500ae19c14a3c46.slotName = "jds_side_panel_item";
const $fe5170bdd3625759$var$createIconLinks = (iconLinks)=>{
    return iconLinks?.map((iconLink, i)=>{
        const { icon: icon, ...rest } = iconLink;
        return /* @__PURE__ */ (0, $acw62.createElement)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...rest,
            key: iconLink.href || i
        }, /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$353f5b6fc5456de1, {
            icon: icon
        }));
    });
};
const $fe5170bdd3625759$var$useResponsiveDevice = ()=>{
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(true);
    const handleResize = (0, $acw62.useCallback)(()=>{
        setIsDesktop($fe5170bdd3625759$var$Devices.isDesktop());
    }, []);
    (0, $acw62.useEffect)(()=>{
        setIsDesktop($fe5170bdd3625759$var$Devices.isDesktop());
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        handleResize
    ]);
    return isDesktop;
};
const $fe5170bdd3625759$var$withLogic$1h = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$m);
        const isDesktop = $fe5170bdd3625759$var$useResponsiveDevice();
        const links = props.links?.map((link, i)=>({
                ...link,
                active: props.activeLink === i,
                showSuffix: link.subLinks?.length,
                onHover: ()=>{
                    if (isDesktop) {
                        setSelectedLink(i);
                        setOpen(true);
                    }
                }
            }));
        const [distance, setDistance] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            width: 0
        });
        const [selectedLink, setSelectedLink] = (0, $acw62.useState)();
        const [open, setOpen] = (0, $acw62.useState)(false);
        const [internalSearchActive, setInternalSearchActive] = (0, $acw62.useState)(props.variant === "active_search");
        const [element, setElement] = (0, $acw62.useState)(null);
        const [searchValue, setSearchValue] = (0, $acw62.useState)(props.searchConfig?.searchInput?.value);
        const [currentLinks, setCurrentLinks] = (0, $acw62.useState)(links || []);
        const [sidePanelLinkIndex, setSidePanelLinkIndex] = (0, $acw62.useState)(0);
        const [lastSidePanelItems, setLastSidePanelItems] = (0, $acw62.useState)([
            links || []
        ]);
        const [sidePanelOpen, setSidePanelOpen] = (0, $acw62.useState)(false);
        const [sidePanelTitle, setSidePanelTitle] = (0, $acw62.useState)("");
        const updatePosition = (0, $acw62.useCallback)($fe5170bdd3625759$var$debounce((element2)=>{
            if (element2) {
                const { x: x, y: y, width: width, height: height } = element2.getBoundingClientRect();
                setDistance({
                    x: x,
                    y: y + height,
                    width: width
                });
            }
        }, 100), []);
        const ref = (0, $acw62.useCallback)((ref2)=>{
            if (ref2 && (open || internalSearchActive)) {
                setElement(ref2);
                updatePosition(ref2);
            }
        }, [
            updatePosition,
            open,
            internalSearchActive
        ]);
        const currentSelectedLinkIndex = typeof selectedLink === "number" ? selectedLink : -1;
        const megaMenuLinks = links?.[currentSelectedLinkIndex]?.subLinks?.map((t)=>({
                ...t,
                links: t.subLinks
            }));
        const handleSearchActiveChange = (val)=>{
            props?.onSearchStateChange?.(val ? "open" : "closed");
            setInternalSearchActive(val);
        };
        const listener = ()=>{
            setOpen(false);
            handleSearchActiveChange(false);
        };
        (0, $acw62.useEffect)(()=>{
            setInternalSearchActive(props.variant === "active_search");
        }, [
            props.variant
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", listener);
            return ()=>{
                window.removeEventListener("scroll", listener);
            };
        }, []);
        (0, $acw62.useEffect)(()=>{
            const targetLogo = document.querySelector('div[data-testid="JDSHeaderDesktop-logo-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSIcon-container"]');
            const targetAvatar = document.querySelector('div[data-testid="JDSHeaderDesktop-suffix-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSAvatar-container"]');
            const targetIconLinks = document.querySelectorAll(' a > div[data-testid="JDSLink-container"] > button[data-testid="JDSButton-container"]');
            if (targetLogo) targetLogo.setAttribute("tabindex", "-1");
            if (targetAvatar) targetAvatar.setAttribute("tabindex", "-1");
            if (targetIconLinks) targetIconLinks.forEach((el)=>el.setAttribute("tabindex", "-1"));
        }, []);
        const LogoItem = props.logo === null ? void 0 : props.logo?.props?.src || props.logo?.props?.ic ? props.logo : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: "IcJioDot",
            size: "xtra-large",
            color: "secondary_50"
        });
        const logoSlot = props.logoLink === null || props.logoLink === void 0 ? LogoItem : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.logoLink,
            children: LogoItem
        });
        const AvatarItem = props.avatar ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$e2255cf6045e8d47, {
            ...props.avatar
        }) : void 0;
        const avatarSlot = props.avatarLink === null || props.avatarLink === void 0 ? AvatarItem : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.avatarLink,
            children: AvatarItem
        });
        const suffixSlot = props.suffixLink === null || props.suffixLink === void 0 ? props.suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.suffixLink,
            children: props.suffix
        });
        const { onFocus: onFocus, onSuffixClick: onSuffixClick, onChange: onChange, onKeyDown: onKeyDown, ...rest } = (props.searchConfig || {}).searchInput || {};
        (0, $acw62.useEffect)(()=>{
            if (open) updatePosition(element);
        }, [
            open,
            element
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...props,
                        ...rest,
                        onSearchBoxSuffixClick: ()=>{
                            setSearchValue("");
                            props.searchConfig?.onSearchChange?.("");
                            onSuffixClick?.();
                        },
                        onSearchKeydown: onKeyDown || props.searchConfig?.onSearchKeyDown,
                        _hasSearchResults: Boolean(props.searchConfig?.searchResults),
                        suffix: suffixSlot,
                        prefixOnClick: ()=>{
                            if (!isDesktop && props.links?.length) setSidePanelOpen(true);
                        },
                        prefix: isDesktop || !props.links?.length ? props.prefix : "ic_burger_menu",
                        logo: logoSlot,
                        avatar: avatarSlot,
                        avatarOnClick: props.avatarOnClick || props.avatarLink,
                        onSearchIconClick: ()=>handleSearchActiveChange(true),
                        expandedSearch: internalSearchActive || props.expandedSearch,
                        onSearchResultContainerClick: (ev)=>ev.stopPropagation(),
                        tabs: props.tabs ? (0, $acw62.cloneElement)(props.tabs, {
                            appearance: "tab-bar"
                        }) : null,
                        onSearchResultClick: (ev)=>{
                            setSearchValue(ev.label);
                            handleSearchActiveChange(false);
                            props.searchConfig?.onSearchResultClick?.(ev);
                            props.searchConfig?.searchResults?.onResultsItemClick?.(ev);
                        },
                        _platform: isDesktop ? "desktop" : "mobile",
                        links: isDesktop ? links : void 0,
                        query: searchValue,
                        onSearchChange: (ev)=>{
                            setSearchValue(ev.target.value);
                            props.searchConfig?.onSearchChange?.(ev.target.value);
                            onChange?.(ev);
                        },
                        iconLinks: $fe5170bdd3625759$var$createIconLinks(props.iconLinks),
                        _variant: internalSearchActive ? "active_search" : "default",
                        onSearchFocus: (ev)=>{
                            handleSearchActiveChange(true);
                            props.searchConfig?.onSearchFocus?.();
                            onFocus?.(ev);
                        },
                        suffixOnClick: ()=>handleSearchActiveChange(false),
                        megaMenuProps: {
                            subLinks: megaMenuLinks,
                            offsetX: distance.x,
                            offsetY: distance.y,
                            width: distance.width + distance.x,
                            open: open
                        },
                        onMenuHoverEnd: ()=>setOpen(false),
                        onSearchClose: ()=>handleSearchActiveChange(false),
                        elementRef: ref
                    }
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$8689d3888980b1f3, {
                    open: sidePanelOpen,
                    onClose: ()=>setSidePanelOpen(false),
                    header: {
                        titleBlock: {
                            text: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                                color: "primary_inverse",
                                children: sidePanelTitle
                            })
                        },
                        prefix: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$353f5b6fc5456de1, {
                            icon: "ic_back",
                            onClick: ()=>{
                                const currentIndex = sidePanelLinkIndex;
                                const actualIndex = currentIndex < 0 ? 0 : currentIndex;
                                const currentItems = [
                                    ...lastSidePanelItems
                                ];
                                const lastItems = currentItems.splice(actualIndex, 1);
                                setSidePanelLinkIndex(actualIndex - 1);
                                if (lastItems?.[0]) setCurrentLinks(lastItems[0]);
                                setLastSidePanelItems(currentItems);
                            }
                        })
                    },
                    maxWidth: true,
                    children: currentLinks?.map((item, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$500ae19c14a3c46, {
                            type: item.type,
                            showSuffix: !!item.showSuffix,
                            prefix: item.prefix,
                            title: item.title,
                            ariaLabel: item.ariaLabel,
                            ariaDescribedby: item.ariaDescribedby,
                            itemSuffixAriaLabel: item.itemSuffixAriaLabel,
                            onSuffixClick: ()=>{
                                const subLinks = item.subLinks?.map((l)=>({
                                        ...l,
                                        showSuffix: Boolean(l.subLinks?.length)
                                    }));
                                if (subLinks) {
                                    setCurrentLinks(subLinks);
                                    setSidePanelLinkIndex(sidePanelLinkIndex + 1);
                                    setLastSidePanelItems((link)=>[
                                            ...link,
                                            currentLinks
                                        ]);
                                    setSidePanelTitle(item.title || "");
                                }
                                item.onSuffixClick?.();
                            },
                            custom: item.custom,
                            href: item.href,
                            newTab: true
                        }, index))
                })
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1j = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1i;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, fullWidth: fullWidth = true, onSearchActiveChange: onSearchActiveChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMenuHoverEnd: onMenuHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchKeydown: onSearchKeydown = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            fullWidth: fullWidth,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onHover: onHover,
            onMenuHoverEnd: onMenuHoverEnd,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchKeydown: onSearchKeydown,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderDesktop", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8b251419efc915eb = $fe5170bdd3625759$var$withLogic$1h($fe5170bdd3625759$var$Component$1j);
$fe5170bdd3625759$export$8b251419efc915eb.displayName = "Header";
$fe5170bdd3625759$export$8b251419efc915eb.slotName = "jds_header_desktop";
const $fe5170bdd3625759$var$sdl$1e = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-dot-1.0.0",
        "name": "JDSHorizontalStepItem",
        "layerName": "jds_horizontal_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "stepper-inner-container": [
                    "start-jds_divider",
                    "jds_stepper_dot",
                    "end-jds_divider"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{h_0}",
            "align-items": "{h_1}",
            "justify-content": "{h_2}",
            "size": "{h_3}",
            "gap": "{h_4}"
        },
        "stepper-inner-container": {
            "flex-direction": "{h_5}",
            "width": "{h_6}",
            "align-items": "{h_7}",
            "gap": "{h_8}"
        },
        "start-jds_divider": {
            "pad": "none",
            "flex": 1,
            "withLabel": false,
            "hidden": false,
            "opacity": "{h_11}"
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "hidden": false,
            "flex": 1,
            "opacity": "{h_12}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-right": "{h_9}",
            "padding-left": "{h_10}"
        }
    },
    "variant": {
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                },
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "active": {
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{h_13}"
                }
            },
            "end": {
                "start-jds_divider": {
                    "opacity": "{h_14}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "type": "JDSStepperDot.itemsType",
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1i = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1e;
    const { state: state = "undefined", itemsType: itemsType = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHorizontalStepItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$210661c11db5ef0f = $fe5170bdd3625759$var$withLogic$1g($fe5170bdd3625759$var$Component$1i);
$fe5170bdd3625759$export$210661c11db5ef0f.displayName = "HorizontalStepItem";
$fe5170bdd3625759$export$210661c11db5ef0f.slotName = "jds_horizontal_step_item";
const $fe5170bdd3625759$var$sdl$1d = {
    "metadata": {
        "version": "1.0.0",
        "id": "image-1.0.0",
        "name": "JDSImage",
        "layerName": "jds_image"
    },
    "hierarchy": {
        "container": [
            "image",
            "lottie",
            "icon",
            "provider-slot",
            {
                "skeleton-container": [
                    "skeleton-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{i_0}",
            "flex-direction": "{i_1}",
            "justify-content": "{i_2}",
            "align-items": "{i_3}",
            "width": "{i_4}",
            "height": "{i_5}",
            "border-radius": "{i_6}",
            "overflow": "hidden"
        },
        "image": {
            "hidden": false,
            "width": "{i_9}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{i_7}",
            "border-radius": "{i_8}",
            "z-index": 0
        },
        "lottie": {
            "hidden": true,
            "size": "{i_10}",
            "repeat": true
        },
        "icon": {
            "hidden": true,
            "value": "ic_broken_image",
            "size": "{i_11}",
            "color": "{i_12}",
            "z-index": 1
        },
        "provider-slot": {
            "hidden": true,
            "width": "{i_13}"
        },
        "skeleton-container": {
            "hidden": true,
            "z-index": 1,
            "aspect-ratio": "{i_14}",
            "width": "{i_15}"
        },
        "skeleton-slot": {
            "size": "{i_16}"
        }
    },
    "variant": {
        "contentScale": {
            "contain": {
                "image": {
                    "object-fit": "contain"
                }
            },
            "fill": {
                "image": {
                    "object-fit": "fill"
                }
            },
            "fit": {
                "image": {
                    "object-fit": "fit"
                }
            },
            "fill_height": {
                "image": {
                    "object-fit": "fill_height"
                }
            },
            "fill_width": {
                "image": {
                    "object-fit": "fill_width"
                }
            },
            "none": {
                "image": {
                    "object-fit": "none"
                }
            }
        },
        "imageFocus": {
            "left": {
                "image": {
                    "object-position": "left"
                }
            },
            "right": {
                "image": {
                    "object-position": "right"
                }
            },
            "top": {
                "image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "image": {
                    "object-position": "bottom"
                }
            }
        },
        "_state": {
            "loading": {
                "container": {
                    "background-color": "{i_17}"
                },
                "image": {
                    "opacity": "{i_18}"
                },
                "skeleton-container": {
                    "hidden": false
                }
            },
            "empty": {
                "container": {
                    "background-color": "{i_19}"
                },
                "image": {
                    "opacity": "{i_20}"
                },
                "icon": {
                    "hidden": false,
                    "value": "ic_image"
                }
            },
            "error": {
                "container": {
                    "background-color": "{i_21}"
                },
                "image": {
                    "opacity": "{i_22}"
                },
                "icon": {
                    "hidden": false
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "skeleton-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "round": {
                "true": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                }
            },
            "square": {
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0"
                    }
                }
            },
            "horizontal_4_3": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_23}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_24}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_25}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_26}"
                    }
                }
            },
            "horizontal_5_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_27}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_28}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_29}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_30}"
                    }
                }
            },
            "horizontal_16_9": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_31}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_32}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_33}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_34}"
                    }
                }
            },
            "vertical_4_5": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_35}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_36}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_37}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_38}"
                    }
                }
            },
            "vertical_3_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_39}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_40}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_41}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_42}"
                    }
                }
            },
            "vertical_9_16": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_43}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_44}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_45}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_46}"
                    }
                }
            },
            "horizontal_2_75__1": {
                "true": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_47}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_48}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_49}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_50}"
                    }
                }
            },
            "none": {
                "true": {
                    "image": {
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "aspectRatio",
            "roundedCorner"
        ]
    ],
    "api": {
        "config": {
            "aspectRatio": {
                "values": [
                    "square",
                    "round",
                    "horizontal_4_3",
                    "horizontal_5_4",
                    "horizontal_16_9",
                    "vertical_4_5",
                    "vertical_3_4",
                    "vertical_9_16",
                    "horizontal_2_75__1",
                    "none"
                ],
                "doc_description": "It can be used to change the aspect ratio of Image. 'round' takes the '1:1' aspect ratio as default."
            },
            "roundedCorner": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Border radius on image. This is `True` by default for all aspect ratios except `aspectRatio='horizontal_2_75__1'`. `horizontal_2_75__1` doesn't accept rounded corner."
            },
            "contentScale": {
                "values": [
                    "cover",
                    "contain",
                    "fit",
                    "fill",
                    "fill_height",
                    "fill_width",
                    "none"
                ]
            },
            "imageFocus": {
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ],
                "doc_description": "It can be used for reposition of the Image."
            },
            "_state": {
                "values": [
                    "loaded",
                    "loading",
                    "empty",
                    "error"
                ]
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_image.alt": {
                    "type": "string",
                    "name": "alt",
                    "platform": "web",
                    "function": true
                },
                "width": {
                    "type": "size",
                    "name": "width",
                    "platform": "ios"
                },
                "height": {
                    "type": "size",
                    "name": "height",
                    "platform": "ios"
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android",
                    "required": false
                },
                "coil_image_loader": {
                    "type": "imageLoader",
                    "name": "imageLoader",
                    "required": false,
                    "platform": "android"
                },
                "title": {
                    "type": "string",
                    "name": "title",
                    "platform": "web"
                }
            },
            "lottie": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "image": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onError": "onError",
                "onLoad": "onLoad",
                "onEmpty": "onEmpty",
                "onLoading": "onLoading"
            }
        },
        "children": {
            "provider-slot": {
                "name": "provider",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "skeleton-slot": {
                "name": "skeleton",
                "accepts": [
                    "jds_skeleton"
                ],
                "max": 1
            }
        },
        "a11y": {
            "image": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1c = {
    "metadata": {
        "version": "1.0.0",
        "id": "skeleton-1.0.0",
        "name": "JDSSkeleton",
        "layerName": "jds_skeleton"
    },
    "hierarchy": {
        "container": [
            "skeletonLoader"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{s_0}",
            "show": true,
            "overflow": "hidden"
        },
        "skeletonLoader": {
            "primary-color": "{s_1}",
            "secondary-color": "{s_2}",
            "hidden": true
        }
    },
    "variant": {
        "shape": {
            "circle": {
                "container": {
                    "aspect-ratio": "1",
                    "border-radius": "{s_3}"
                }
            },
            "heading": {
                "container": {
                    "height": "{s_4}",
                    "border-radius": "{s_5}"
                }
            },
            "paragraph": {
                "container": {
                    "border-radius": "{s_6}",
                    "height": "{s_7}"
                }
            },
            "rectangle": {
                "container": {
                    "border-radius": "{s_8}",
                    "aspect-ratio": "1.77"
                }
            },
            "square": {
                "container": {
                    "border-radius": "{s_9}",
                    "aspect-ratio": "1"
                }
            },
            "custom": {
                "container": {
                    "width": "{s_10}",
                    "height": "{s_11}"
                }
            }
        },
        "animated": {
            "true": {
                "skeletonLoader": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "width": {
                    "type": "size",
                    "name": "width",
                    "function": true,
                    "doc_description": "It can be used to determine width of all shapes od Skeleton."
                }
            }
        },
        "config": {
            "shape": {
                "values": [
                    "circle",
                    "heading",
                    "paragraph",
                    "rectangle",
                    "square",
                    "custom"
                ],
                "doc_description": "It is used to determine the shape of Skeleton."
            },
            "animated": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to add animantionto Skeleton."
            }
        },
        "a11y": {
            "container": {
                "name": "skeleton",
                "properties": {
                    "aria-busy": {
                        "name": "_ariaBusy",
                        "prop": "animated"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1f = (Component)=>(props)=>{
        if (props.shape === "custom" && !props.__noCustomWarn__) console.warn("shape=custom is an internal variant. Please do not use it");
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            },
            width: props.width
        });
    };
const $fe5170bdd3625759$var$Component$1h = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1c;
    const { shape: shape = "circle", animated: animated = false, _ariaBusy: _ariaBusy = props.animated?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            shape: shape,
            animated: animated,
            _ariaBusy: _ariaBusy,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSkeleton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8f31e4c4a37b8e9c = $fe5170bdd3625759$var$withLogic$1f($fe5170bdd3625759$var$Component$1h);
$fe5170bdd3625759$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
$fe5170bdd3625759$export$8f31e4c4a37b8e9c.slotName = "jds_skeleton";
const $fe5170bdd3625759$var$legacyAspectRatios = [
    "1:1",
    "round",
    "4:3",
    "5:4",
    "16:9",
    "4:5",
    "3:4",
    "9:16",
    "2.75:1"
];
const $fe5170bdd3625759$var$PROP_MAP$j = (props)=>{
    if ($fe5170bdd3625759$var$legacyAspectRatios.includes(props.aspectRatio)) console.warn("these values for aspect ratios are deprectaed", $fe5170bdd3625759$var$legacyAspectRatios);
    return {
        aspectRatio: {
            variations: {
                "1:1": {
                    aspectRatio: "square"
                },
                "4:3": {
                    aspectRatio: "horizontal_4_3"
                },
                "5:4": {
                    aspectRatio: "horizontal_5_4"
                },
                "16:9": {
                    aspectRatio: "horizontal_16_9"
                },
                "4:5": {
                    aspectRatio: "vertical_4_5"
                },
                "3:4": {
                    aspectRatio: "vertical_3_4"
                },
                "9:16": {
                    aspectRatio: "vertical_9_16"
                },
                "2.75:1": {
                    aspectRatio: "horizontal_2_75__1"
                }
            }
        },
        src: {
            properties: {
                src: props.src
            }
        },
        alt: {
            properties: {
                semantics: props.alt
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1e = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$j);
        const { src: src, onLoad: onLoad, onError: onError, ...rest } = props;
        const [imageStates, setImageStates] = (0, $acw62.useState)({
            error: false,
            loaded: false
        });
        const { error: error, loaded: loaded } = imageStates;
        const hasSrc = Boolean(src);
        const isBroken = hasSrc && loaded && error;
        const handleLoad = (e)=>{
            setImageStates({
                error: false,
                loaded: true
            });
            onLoad?.(e);
        };
        const handleError = (e)=>{
            if (!imageStates.error) {
                setImageStates({
                    error: true,
                    loaded: true
                });
                onError?.(e);
            }
        };
        const provider = ()=>{
            if (rest.provider) {
                const provider2 = rest.provider;
                return (0, $acw62.cloneElement)(rest?.provider, {
                    onLoad: (e)=>{
                        handleLoad(e);
                        provider2?.onLoad?.(e);
                    },
                    onError: (e)=>{
                        handleError(e);
                        provider2?.onError?.(e);
                    },
                    src: rest.provider?.props?.src || src
                });
            }
            return null;
        };
        const currentState = !hasSrc ? "empty" : isBroken ? "error" : loaded ? "loaded" : "loading";
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                skeleton: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$8f31e4c4a37b8e9c, {
                    shape: "custom",
                    animated: true,
                    width: "100%",
                    __noCustomWarn__: true
                }),
                _state: currentState,
                _loaderWidth: "100%",
                title: props.title || formatImageName(props.src),
                onLoad: handleLoad,
                onError: handleError,
                provider: provider() ?? void 0,
                _hasProvider: Boolean(rest.provider && currentState === "loaded"),
                src: rest?.provider?.props?.src || src || {},
                ariaLabel: props.ariaLabel || formatImageName(props.src)
            }
        });
    };
const $fe5170bdd3625759$var$Component$1g = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1d;
    const { aspectRatio: aspectRatio = "square", roundedCorner: roundedCorner = true, contentScale: contentScale = "cover", imageFocus: imageFocus = "center", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onError: onError = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onLoad: onLoad = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onEmpty: onEmpty = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onLoading: onLoading = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            aspectRatio: aspectRatio,
            roundedCorner: roundedCorner,
            contentScale: contentScale,
            imageFocus: imageFocus,
            onClick: onClick,
            onHover: onHover,
            onError: onError,
            onLoad: onLoad,
            onEmpty: onEmpty,
            onLoading: onLoading,
            ...rest
        },
        componentTag: componentTag
    }, "JDSImage", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3e431a229df88919 = $fe5170bdd3625759$var$withLogic$1e($fe5170bdd3625759$var$Component$1g);
$fe5170bdd3625759$export$3e431a229df88919.displayName = "Image";
$fe5170bdd3625759$export$3e431a229df88919.slotName = "jds_image";
const $fe5170bdd3625759$var$sdl$1b = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-1.0.0",
        "name": "JDSInput",
        "layerName": "jds_input"
    },
    "hierarchy": {
        "input": []
    },
    "base": {
        "input": {
            "type": "text",
            "text-align": "{i_0}",
            "placeholder-color": "{i_1}",
            "placeholder-font-family": "{i_2}",
            "placeholder-font-size": "{i_3}",
            "placeholder-line-height": "{i_5}",
            "placeholder-font-weight": "{i_4}",
            "input-color": "{i_7}",
            "input-font-family": "{i_8}",
            "input-font-size": "{i_9}",
            "input-line-height": "{i_11}",
            "input-font-weight": "{i_10}",
            "cursor-color": "{i_13}",
            "disabled": false,
            "width": "{i_14}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "input": {
                    "opacity": "{i_15}",
                    "disabled": true
                }
            }
        },
        "type": {
            "email": {
                "input": {
                    "type": "email"
                }
            },
            "number": {
                "input": {
                    "type": "number"
                }
            },
            "password": {
                "input": {
                    "type": "password"
                }
            },
            "textarea": {
                "input": {
                    "type": "textarea"
                }
            },
            "pin": {
                "input": {
                    "type": "pin"
                }
            },
            "phone": {
                "input": {
                    "type": "phone"
                }
            }
        },
        "color": {
            "primary_80": {
                "input": {
                    "input-color": "{i_27}"
                }
            },
            "primary_70": {
                "input": {
                    "input-color": "{i_28}"
                }
            },
            "primary_60": {
                "input": {
                    "input-color": "{i_29}"
                }
            },
            "primary_50": {
                "input": {
                    "input-color": "{i_30}"
                }
            },
            "primary_40": {
                "input": {
                    "input-color": "{i_31}"
                }
            },
            "primary_30": {
                "input": {
                    "input-color": "{i_32}"
                }
            },
            "primary_20": {
                "input": {
                    "input-color": "{i_33}"
                }
            },
            "primary_inverse": {
                "input": {
                    "input-color": "{i_34}"
                }
            },
            "primary_background": {
                "input": {
                    "input-color": "{i_35}"
                }
            },
            "primary_grey_100": {
                "input": {
                    "input-color": "{i_36}"
                }
            },
            "primary_grey_80": {
                "input": {
                    "input-color": "{i_37}"
                }
            },
            "primary_grey_60": {
                "input": {
                    "input-color": "{i_38}"
                }
            },
            "primary_grey_40": {
                "input": {
                    "input-color": "{i_39}"
                }
            },
            "primary_grey_20": {
                "input": {
                    "input-color": "{i_40}"
                }
            },
            "secondary_80": {
                "input": {
                    "input-color": "{i_41}"
                }
            },
            "secondary_70": {
                "input": {
                    "input-color": "{i_42}"
                }
            },
            "secondary_60": {
                "input": {
                    "input-color": "{i_43}"
                }
            },
            "secondary_50": {
                "input": {
                    "input-color": "{i_44}"
                }
            },
            "secondary_40": {
                "input": {
                    "input-color": "{i_45}"
                }
            },
            "secondary_30": {
                "input": {
                    "input-color": "{i_46}"
                }
            },
            "secondary_20": {
                "input": {
                    "input-color": "{i_47}"
                }
            },
            "secondary_inverse": {
                "input": {
                    "input-color": "{i_48}"
                }
            },
            "secondary_background": {
                "input": {
                    "input-color": "{i_49}"
                }
            },
            "secondary_grey_100": {
                "input": {
                    "input-color": "{i_50}"
                }
            },
            "secondary_grey_80": {
                "input": {
                    "input-color": "{i_51}"
                }
            },
            "secondary_grey_60": {
                "input": {
                    "input-color": "{i_52}"
                }
            },
            "secondary_grey_40": {
                "input": {
                    "input-color": "{i_53}"
                }
            },
            "secondary_grey_20": {
                "input": {
                    "input-color": "{i_54}"
                }
            },
            "sparkle_80": {
                "input": {
                    "input-color": "{i_55}"
                }
            },
            "sparkle_70": {
                "input": {
                    "input-color": "{i_56}"
                }
            },
            "sparkle_60": {
                "input": {
                    "input-color": "{i_57}"
                }
            },
            "sparkle_50": {
                "input": {
                    "input-color": "{i_58}"
                }
            },
            "sparkle_40": {
                "input": {
                    "input-color": "{i_59}"
                }
            },
            "sparkle_30": {
                "input": {
                    "input-color": "{i_60}"
                }
            },
            "sparkle_20": {
                "input": {
                    "input-color": "{i_61}"
                }
            },
            "sparkle_inverse": {
                "input": {
                    "input-color": "{i_62}"
                }
            },
            "sparkle_background": {
                "input": {
                    "input-color": "{i_63}"
                }
            },
            "sparkle_grey_100": {
                "input": {
                    "input-color": "{i_64}"
                }
            },
            "sparkle_grey_80": {
                "input": {
                    "input-color": "{i_65}"
                }
            },
            "sparkle_grey_60": {
                "input": {
                    "input-color": "{i_66}"
                }
            },
            "sparkle_grey_40": {
                "input": {
                    "input-color": "{i_67}"
                }
            },
            "sparkle_grey_20": {
                "input": {
                    "input-color": "{i_68}"
                }
            },
            "feedback_error_80": {
                "input": {
                    "input-color": "{i_69}"
                }
            },
            "feedback_error_50": {
                "input": {
                    "input-color": "{i_70}"
                }
            },
            "feedback_error_20": {
                "input": {
                    "input-color": "{i_71}"
                }
            },
            "feedback_warning_80": {
                "input": {
                    "input-color": "{i_72}"
                }
            },
            "feedback_warning_50": {
                "input": {
                    "input-color": "{i_73}"
                }
            },
            "feedback_warning_20": {
                "input": {
                    "input-color": "{i_74}"
                }
            },
            "feedback_success_80": {
                "input": {
                    "input-color": "{i_75}"
                }
            },
            "feedback_success_50": {
                "input": {
                    "input-color": "{i_76}"
                }
            },
            "feedback_success_20": {
                "input": {
                    "input-color": "{i_77}"
                }
            },
            "white": {
                "input": {
                    "input-color": "{i_78}"
                }
            },
            "black": {
                "input": {
                    "input-color": "{i_79}"
                }
            },
            "transparent": {
                "input": {
                    "input-color": "{i_80}"
                }
            }
        },
        "textAlign": {
            "center": {
                "input": {
                    "text-align": "{i_16}"
                }
            },
            "end": {
                "input": {
                    "text-align": "{i_17}"
                }
            },
            "justify": {
                "input": {
                    "text-align": "{i_18}"
                }
            }
        },
        "textSize": {
            "large": {
                "input": {
                    "placeholder-font-family": "{i_19}",
                    "placeholder-font-size": "{i_20}",
                    "placeholder-line-height": "{i_21}",
                    "placeholder-font-weight": "{i_22}",
                    "input-font-family": "{i_23}",
                    "input-font-size": "{i_24}",
                    "input-line-height": "{i_25}",
                    "input-font-weight": "{i_26}"
                }
            }
        },
        "readOnly": {
            "true": {
                "container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Input."
            },
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to Input text."
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ],
                "doc_description": "This is used to specify the type of input."
            },
            "textAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "justify"
                ],
                "doc_description": "It can be used to align text of the Input."
            },
            "textSize": {
                "values": [
                    "small",
                    "large"
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "min": {
                    "type": "number",
                    "name": "min"
                },
                "placeholder-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "input-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "max": {
                    "type": "number",
                    "name": "max"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": {
                        "name": "ariaInvalid"
                    },
                    "aria-placeholder": {
                        "name": "ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1d = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $fe5170bdd3625759$var$Component$1f = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1b;
    const { disabled: disabled = false, color: color = "primary_grey_100", type: type = "text", textAlign: textAlign = "start", textSize: textSize = "small", readOnly: readOnly = false, onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onKeyup: onKeyup = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPaste: onPaste = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaPlaceholder: ariaPlaceholder = props.placeholder?.toString(), ariaRequired: ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            color: color,
            type: type,
            textAlign: textAlign,
            textSize: textSize,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ariaPlaceholder: ariaPlaceholder,
            ariaRequired: ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInput", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Input = $fe5170bdd3625759$var$withLogic$1d($fe5170bdd3625759$var$Component$1f);
$fe5170bdd3625759$var$Input.displayName = "Input";
$fe5170bdd3625759$var$Input.slotName = "jds_input";
const $fe5170bdd3625759$var$sdl$1a = {
    "metadata": {
        "version": "1.0.0",
        "id": "checkbox-1.0.0",
        "name": "JDSCheckbox",
        "layerName": "jds_checkbox",
        "description": "Checkboxes are used within an interface to allow the user to select between one or more options."
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "control-container": [
                            "control-icon"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "opacity": "{c_38}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{c_4}",
            "justify-content": "{c_5}",
            "align-items": "{c_6}",
            "gap": "{c_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "control-container": {
            "hidden": false,
            "min-width": "{c_8}",
            "min-height": "{c_9}",
            "flex-direction": "{c_10}",
            "justify-content": "{c_11}",
            "align-items": "{c_12}",
            "background-color": "{c_13}",
            "border-radius": "{c_14}",
            "border-width": "{c_15}",
            "border-color": "{c_16}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{c_17}"
                },
                "active": {
                    "border-color": "{c_18}"
                },
                "focus": {
                    "border-width": "{c_19}",
                    "box-sizing": "content-box",
                    "border-color": "{c_20}"
                }
            }
        },
        "control-icon": {
            "hidden": true,
            "size": "{c_21}"
        },
        "jds_feedback_block": {
            "hidden": true,
            "state": "none",
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{c_22}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "control-container": {
                    "min-width": "{c_23}",
                    "min-height": "{c_24}"
                },
                "vertical-container": {
                    "gap": "{c_25}"
                },
                "control-icon": {
                    "size": "{c_26}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "control-container": {
                    "background-color": "{c_28}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_29}"
                        },
                        "active": {
                            "background-color": "{c_30}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_27}",
                    "color": "{c_31}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "indeterminate": {
            "true": {
                "control-container": {
                    "background-color": "{c_33}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_34}"
                        },
                        "focus": {
                            "background-color": "{c_35}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_32}",
                    "color": "{c_36}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{c_37}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programmatically make input active/inactive."
            },
            "indeterminate": {
                "values": [
                    false,
                    true
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Checkbox."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Checkbox."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Checkbox."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Checkbox."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "horizontal-container": {
                "properties": {
                    "role": {
                        "value": "checkbox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$checkInputMask(event, value, textMask, readonly, pattern) {
    if (readonly || !textMask) return "noop";
    if (!textMask && !pattern) return "noop";
    if ([
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(event.key) > -1) return "noop";
    const prevValue = value || "";
    if (textMask && typeof prevValue === "string" || pattern) {
        if (event.code === "Backspace") return "back";
        const regex = textMask ? new RegExp($fe5170bdd3625759$var$getTextMaskValue(textMask)) : pattern ? new RegExp(pattern) : void 0;
        if (!regex?.test(event.key) || textMask && (event.currentTarget.value?.length || 0) >= textMask.length) return "prevent";
    }
    return "noop";
}
const $fe5170bdd3625759$var$maskCharToRegexMap = {
    "#": "\\d",
    "&": "[A-Za-z]",
    "*": "[A-Za-z\\d]"
};
const $fe5170bdd3625759$var$getTextMask = (textMask)=>{
    if (!textMask) return void 0;
    if (typeof textMask === "string") return textMask;
    if (typeof textMask[0] === "object") return new RegExp(textMask[0]).source;
    return textMask[0];
};
const $fe5170bdd3625759$var$getTextMaskValue = (textMask)=>{
    return textMask.split("").map((t)=>`(${$fe5170bdd3625759$var$maskCharToRegexMap[t] || t})`).join("|");
};
const $fe5170bdd3625759$var$stateValues = {
    error: {
        state: "error",
        stateText: "errorText"
    },
    success: {
        state: "success",
        stateText: "successText"
    },
    warning: {
        state: "warning",
        stateText: "warningText"
    },
    required: {
        state: "error",
        stateText: "requiredText"
    }
};
const $fe5170bdd3625759$var$injectAutofillCSS = ()=>{
    const style = document.createElement("style");
    style.textContent = `
    input:-webkit-autofill {
      animation-name: autofill-start;
      animation-duration: 0.01s;
      animation-iteration-count: 1;
    }
    @keyframes autofill-start { from {} to {} }
  `;
    document.head.appendChild(style);
};
const $fe5170bdd3625759$var$useFocusedLabel = (props, ref)=>{
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const [inputFocused, setInputFocused] = (0, $acw62.useState)(false);
    const labelRef = ref?.querySelector(".j-JDSInputField-input_label-jds-text") || ref?.querySelector(".j-JDSTextarea-input_label-jds-text");
    (0, $acw62.useEffect)(()=>{
        $fe5170bdd3625759$var$injectAutofillCSS();
        const input = ref?.querySelector("input");
        const onAutoFill = (e)=>{
            if (e.animationName === "autofill-start") {
                labelRef?.classList?.add("position-top");
                setFocused(true);
            }
        };
        input?.addEventListener("animationstart", onAutoFill);
        return ()=>input?.removeEventListener("animationstart", onAutoFill);
    }, [
        ref
    ]);
    (0, $acw62.useEffect)(()=>{
        if (props.placeholder || props.value) labelRef?.classList?.add("position-top");
    }, [
        props.placeholder,
        labelRef,
        props.value
    ]);
    return {
        onChange: (ev)=>{
            setFocused(true);
            labelRef?.classList.add("position-top");
            props.onChange?.(ev);
        },
        onBlur: (ev)=>{
            if (!(ev.target.value || props.placeholder)) {
                setFocused(false);
                labelRef?.classList.remove("position-top");
            }
            props.onBlur?.(ev);
            setInputFocused(false);
        },
        onFocus: (ev)=>{
            setFocused(true);
            setInputFocused(true);
            props.onFocus?.(ev);
            labelRef?.classList.add("position-top");
        },
        focused: Boolean(props.value) || Boolean(props.placeholder) || focused,
        _inputFocused: inputFocused
    };
};
const $fe5170bdd3625759$var$useInputState = (state, required, onInvalid, stateConfig = {}, stateText)=>{
    const [inputState, setInputState] = (0, $acw62.useState)("none");
    (0, $acw62.useEffect)(()=>{
        if (!required) setInputState(state || "none");
    }, [
        state,
        required
    ]);
    const stateKey = $fe5170bdd3625759$var$stateValues?.[inputState || "none"]?.state;
    const stateTextKey = $fe5170bdd3625759$var$stateValues[inputState]?.stateText;
    return {
        onInvalid: (ev)=>{
            onInvalid?.(ev);
            if (required) setInputState("required");
            else setInputState("error");
        },
        inputState: state || stateKey,
        stateText: stateText || stateConfig?.[stateTextKey]
    };
};
const $fe5170bdd3625759$var$getRequiredLabel = (label = "", required)=>{
    return label + (required ? " *" : "");
};
const $fe5170bdd3625759$var$getIcon = (icon, onClick)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
    if (typeof icon === "object" && icon.component === "Icon") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ...icon.props,
        color: "grey-80"
    });
    if (icon.type?.displayName) return (0, $acw62.cloneElement)(icon, {
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon.props.ic,
        color: "grey-80",
        ...icon.props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
};
const $fe5170bdd3625759$var$getPrefixWidth = (element)=>{
    const prefixContainer = element?.querySelector('div[data-testid="JDSInputField-prefix-container"]');
    const { width: width } = prefixContainer?.getBoundingClientRect() || {};
    return width || 0;
};
const $fe5170bdd3625759$var$withLogic$1c = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $fe5170bdd3625759$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                prefix: $fe5170bdd3625759$var$getIcon(props.prefix, handlePrefixClick),
                suffix: $fe5170bdd3625759$var$getIcon(props.suffix, handleSuffixClick),
                onInvalid: onInvalid,
                _labelOffset: $fe5170bdd3625759$var$getPrefixWidth(element) + 8,
                onKeydown: (ev)=>{
                    const allowedCharsForNumber = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "e",
                        "-",
                        "+",
                        "."
                    ];
                    const allowedCharsForPhone = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "(",
                        ")",
                        "-",
                        " ",
                        "+"
                    ];
                    if ([
                        "number",
                        "phone"
                    ].includes(props.type)) {
                        if ([
                            "Backspace",
                            "Enter",
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(ev.key)) return;
                        const allowedChars = props.type === "number" ? allowedCharsForNumber : allowedCharsForPhone;
                        !allowedChars.includes(ev.key) && ev.preventDefault();
                    }
                    if (props.pattern && typeof props.value === "string" || props.textMask) {
                        const action = $fe5170bdd3625759$var$checkInputMask(ev, props.value, $fe5170bdd3625759$var$getTextMask(props.textMask), props.readonly, props.pattern);
                        if (action === "prevent" || action === "back") {
                            ev.preventDefault();
                            if (action === "back") {
                                const currentValue = (ev.currentTarget.value || "")?.slice(0, -1);
                                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                                tracker?.call(ev.target, currentValue);
                                const event = {
                                    ...ev,
                                    target: {
                                        ...ev.target,
                                        value: currentValue
                                    }
                                };
                                props.onChange?.(event);
                            }
                            return;
                        }
                    }
                    props.onKeyDown?.(ev);
                },
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: props.stateText || stateText,
                _hasPrefix: Boolean(props.prefix),
                _hasSuffix: Boolean(props.suffix),
                _labelFocus: focused,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $fe5170bdd3625759$var$withLogic$1b = (Component)=>(props)=>{
        const { stateText: stateText, inputState: inputState } = $fe5170bdd3625759$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaChecked: props.indeterminate ? "mixed" : props.checked === true ? "true" : "false",
                _hasHelper: Boolean(props.helperText),
                state: inputState,
                stateText: stateText
            }
        });
    };
const $fe5170bdd3625759$var$Component$1e = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1a;
    const { checked: checked = false, indeterminate: indeterminate = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            indeterminate: indeterminate,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCheckbox", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$fa1253a65a9e747d = $fe5170bdd3625759$var$withLogic$1b($fe5170bdd3625759$var$Component$1e);
$fe5170bdd3625759$export$fa1253a65a9e747d.displayName = "InputCheckbox";
$fe5170bdd3625759$export$fa1253a65a9e747d.slotName = "jds_checkbox";
const $fe5170bdd3625759$var$sdl$19 = {
    "metadata": {
        "version": "1.0.0",
        "id": "Input-code-item-1.0.0",
        "name": "JDSInputCodeItem",
        "layerName": "jds_input_code_item",
        "internal": true
    },
    "hierarchy": {
        "input-container": [
            "jds_input",
            {
                "active-line-container": [
                    "feedback-container"
                ]
            }
        ]
    },
    "base": {
        "input-container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "gap": "{i_3}",
            "width": "{i_4}",
            "behavior": {
                "hover": {}
            }
        },
        "jds_input": {
            "width": "{i_5}",
            "type": "phone",
            "textAlign": "center",
            "textSize": "large",
            "maxLength": 1
        },
        "active-line-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "width": "{i_9}",
            "padding-top": "{i_10}",
            "padding-bottom": "{i_11}"
        },
        "feedback-container": {
            "width": "{i_12}",
            "height": "{i_13}",
            "background-color": "{i_14}",
            "border-radius": "{i_15}",
            "show": true,
            "behavior": {
                "focus": {
                    "background-color": "{i_17}"
                },
                "active": {
                    "background-color": "{i_18}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_19}"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_20}"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_21}"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_input": {
                    "disabled": true
                }
            }
        },
        "secureText": {
            "true": {
                "jds_input": {
                    "type": "pin"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_22}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            },
            "secureText": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1a = (Component)=>(props)=>{
        const [inputFocus, setInputFocus] = (0, $acw62.useState)(false);
        const handleFocus = (0, $acw62.useCallback)((ev)=>{
            setInputFocus(true);
            if (props.onFocus) props.onFocus(ev);
        }, [
            props.onFocus
        ]);
        const handleBlur = (0, $acw62.useCallback)((ev)=>{
            setInputFocus(false);
            if (props.onBlur) props.onBlur(ev);
        }, [
            props.onBlur
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            _inputFocus: inputFocus,
            onFocus: handleFocus,
            onBlur: handleBlur
        });
    };
const $fe5170bdd3625759$var$Component$1d = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$19;
    const { autoComplete: autoComplete = false, secureText: secureText = false, state: state = "undefined", disabled: disabled = false, onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPaste: onPaste = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            autoComplete: autoComplete,
            secureText: secureText,
            state: state,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCodeItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$963da1aad44be4c4 = $fe5170bdd3625759$var$withLogic$1a($fe5170bdd3625759$var$Component$1d);
$fe5170bdd3625759$export$963da1aad44be4c4.displayName = "InputCodeItem";
$fe5170bdd3625759$export$963da1aad44be4c4.slotName = "jds_input_code_item";
const $fe5170bdd3625759$var$sdl$18 = {
    "metadata": {
        "version": "1.0.0",
        "id": "input_phone_dropdown-1.0.0",
        "name": "JDSInputPhoneDropdown",
        "layerName": "jds_input_phone_dropdown"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "country_code-jds-text",
                    {
                        "chevron-jds-icon-container": [
                            "chevron-jds-icon"
                        ]
                    }
                ]
            },
            "jds_menu_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{flexDirection.column}"
        },
        "container": {
            "flex-direction": "{flexDirection.row}",
            "gap": "{xxs}"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "country_code-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [],
    "combination_config": [],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "country_code-jds-text": {
                "value": {
                    "type": "string",
                    "name": "countryCode"
                },
                "color": {
                    "type": "JDSText.color",
                    "name": "countryCodeColor"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "countryFlag"
                },
                "ic": {
                    "type": "icon",
                    "name": "countryFlag"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onOpen",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_menu_block": {
                "onSelect": {
                    "name": "onSelect",
                    "object": {
                        "index": "number",
                        "value": "string"
                    }
                },
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Select Country Code"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$setPositions = (anchorEl, menuBlockref, stringMaxHeight)=>{
    let menuItemPositionY = 0;
    let menuItemPositionX;
    let maxCalculatedHeight = 0;
    if (anchorEl && window) {
        const { y: anchorTop, height: anchorHeight, x: anchorLeft, width: anchorWidth } = anchorEl.getBoundingClientRect();
        const { innerWidth: overlayWidth, innerHeight: overlayHeight } = window;
        let maxHeight = parseInt(stringMaxHeight || "");
        maxHeight = isNaN(maxHeight) ? overlayHeight - anchorTop : maxHeight;
        const { scrollHeight: menuHeight, scrollWidth: menuWidth } = menuBlockref || {
            scrollWidth: 0,
            scrollHeight: maxHeight || 0
        };
        const sectionBelowAnchor = overlayHeight - (anchorTop + anchorHeight);
        const sectionAboveAnchor = anchorTop;
        if (menuBlockref && sectionBelowAnchor <= (maxHeight || menuHeight) && sectionAboveAnchor > sectionBelowAnchor) {
            menuItemPositionY = anchorTop - menuHeight;
            if (menuItemPositionY < 0) {
                maxCalculatedHeight = anchorTop;
                menuItemPositionY = maxHeight ? anchorTop - maxHeight : menuHeight < anchorTop ? anchorTop - menuHeight : 0;
            }
        } else {
            maxCalculatedHeight = sectionBelowAnchor;
            menuItemPositionY = anchorTop + anchorHeight;
        }
        const availableHeight = sectionBelowAnchor > 0 ? sectionBelowAnchor : overlayHeight - anchorTop;
        maxHeight = Math.min(maxHeight, availableHeight);
        const hasHitRight = overlayWidth <= anchorLeft + menuWidth;
        menuItemPositionX = hasHitRight ? Math.max(anchorLeft + anchorWidth - menuWidth, 0) : anchorLeft;
        return {
            left: menuItemPositionX || 0,
            top: menuItemPositionY || 0,
            width: anchorWidth,
            height: (maxHeight || maxCalculatedHeight) - 10 - 14,
            maxHeight: (maxHeight || maxCalculatedHeight) - 10,
            overflowY: "auto"
        };
    }
    return {
        left: 0,
        top: 0,
        maxWidth: "fit-content",
        height: (maxCalculatedHeight || menuBlockref?.getBoundingClientRect()?.height || 0) - 10
    };
};
const $fe5170bdd3625759$var$withLogic$19 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [position, setPosition] = (0, $acw62.useState)({
            left: 0,
            top: 0
        });
        const updatePosition = ()=>{
            const menuBlockEl = element?.querySelector("div.j-JDSMenuBlock-container");
            return $fe5170bdd3625759$var$setPositions(element, menuBlockEl);
        };
        const { close: close, selected: selected, toggle: toggle } = $fe5170bdd3625759$var$useToggle(props.open, true);
        (0, $acw62.useEffect)(()=>{
            if (element && selected) {
                const { left: left, top: top } = updatePosition();
                setPosition({
                    left: left,
                    top: top
                });
            }
        }, [
            element,
            selected
        ]);
        const [selectedItem, setSelectedItem] = (0, $acw62.useState)(props.items?.[props.selectedIndex || 0]);
        const handleOnSelect = (selectedIndex)=>{
            const selectedData = props.items?.[selectedIndex];
            toggle();
            setSelectedItem(selectedData);
            props.onSelect?.(selectedIndex, selectedData?.value);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _offsetX: position.left,
                _offsetY: position.top,
                _maxWidth: "fit-content",
                open: selected,
                items: props.items,
                countryCode: selectedItem?.label,
                countryFlag: selectedItem?.prefix,
                onSelect: handleOnSelect,
                onOpen: ()=>{
                    toggle();
                    props.onOpen?.();
                },
                onClose: ()=>{
                    close();
                    props.onClose?.();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1c = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$18;
    const { open: open = false, disabled: disabled = false, onOpen: onOpen = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Select Country Code", ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            disabled: disabled,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputPhoneDropdown", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$770f20817cf88abc = $fe5170bdd3625759$var$withLogic$19($fe5170bdd3625759$var$Component$1c);
$fe5170bdd3625759$export$770f20817cf88abc.displayName = "InputPhoneDropdown";
$fe5170bdd3625759$export$770f20817cf88abc.slotName = "jds_input_phone_dropdown";
const $fe5170bdd3625759$var$sdl$17 = {
    "metadata": {
        "version": "1.0.0",
        "id": "list-block-1.0.0",
        "name": "JDSListBlock",
        "layerName": "jds_list_block",
        "description": "",
        "usage": ""
    },
    "hierarchy": {
        "root-container": [
            "top-slot",
            {
                "main-container": [
                    "prefix-slot",
                    {
                        "block-container": [
                            "title-jds-text",
                            {
                                "caption-container": [
                                    {
                                        "inner-caption-container": [
                                            "caption-block-text-slot",
                                            "caption-block-helper-slot"
                                        ]
                                    },
                                    "caption-block-value-slot"
                                ]
                            },
                            {
                                "title-container": [
                                    {
                                        "inner-title-container": [
                                            "title-block-text-slot",
                                            "title-block-helper-slot"
                                        ]
                                    },
                                    "title-block-value-slot"
                                ]
                            },
                            {
                                "helper-container": [
                                    {
                                        "inner-helper-container": [
                                            "helper-block-text-slot",
                                            "helper-block-helper-slot"
                                        ]
                                    },
                                    "helper-block-value-slot"
                                ]
                            }
                        ]
                    },
                    "suffix-slot"
                ]
            },
            "children-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{l_0}",
            "width": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "gap": "{l_4}",
            "padding-top": "{l_5}",
            "padding-bottom": "{l_6}"
        },
        "main-container": {
            "flex-direction": "{l_7}",
            "width": "{l_8}",
            "gap": "{l_9}",
            "justify-content": "{l_10}",
            "align-items": "{l_11}"
        },
        "block-container": {
            "flex-direction": "{l_12}",
            "flex": 1,
            "gap": "{l_13}",
            "justify-content": "{l_14}",
            "align-items": "{l_15}"
        },
        "caption-container": {
            "flex-direction": "{l_16}",
            "width": "{l_17}",
            "justify-content": "{l_18}",
            "align-items": "{l_19}",
            "gap": "{l_20}"
        },
        "inner-caption-container": {
            "flex-direction": "{l_21}",
            "justify-content": "{l_22}",
            "align-items": "{l_23}",
            "gap": "{l_24}"
        },
        "title-container": {
            "flex-direction": "{l_25}",
            "width": "{l_26}",
            "justify-content": "{l_27}",
            "align-items": "{l_28}",
            "gap": "{l_29}"
        },
        "inner-title-container": {
            "flex-direction": "{l_30}",
            "justify-content": "{l_31}",
            "align-items": "{l_32}",
            "gap": "{l_33}"
        },
        "helper-container": {
            "flex-direction": "{l_34}",
            "width": "{l_35}",
            "justify-content": "{l_36}",
            "align-items": "{l_37}",
            "gap": "{l_38}"
        },
        "inner-helper-container": {
            "flex-direction": "{l_39}",
            "justify-content": "{l_40}",
            "align-items": "{l_41}",
            "gap": "{l_42}"
        },
        "title-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "spacing": {
            "small": {
                "main-container": {
                    "gap": "{l_43}"
                },
                "root-container": {
                    "gap": "{l_44}"
                }
            }
        },
        "verticalAlignment": {
            "top": {
                "main-container": {
                    "align-items": "{l_45}"
                }
            }
        },
        "_isTitleVisible": {
            "true": {
                "caption-container": {
                    "hidden": true
                },
                "title-container": {
                    "hidden": true
                },
                "title-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "children": {
            "top-slot": {
                "name": "top",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_icon",
                    "jds_avatar",
                    "jds_image"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'avtar', 'image' as prefix for Listblock."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'text', 'button', 'link' as suffix for Listblock."
            },
            "caption-block-text-slot": {
                "name": "captionBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "caption-block-helper-slot": {
                "name": "captionBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "caption-block-value-slot": {
                "name": "captionBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-text-slot": {
                "name": "titleBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "title-block-helper-slot": {
                "name": "titleBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-value-slot": {
                "name": "titleBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-text-slot": {
                "name": "helperBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "helper-block-helper-slot": {
                "name": "helperBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-value-slot": {
                "name": "helperBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "spacing": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "Adjusts the spacing between ListBlock contents"
            },
            "verticalAlignment": {
                "values": [
                    "middle",
                    "top"
                ],
                "doc_description": "Vertical alignment for Prefix and Suffix."
            },
            "_isTitleVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySpacing = [
    "m",
    "s"
];
const $fe5170bdd3625759$var$PROP_MAP$i = (props)=>{
    if ($fe5170bdd3625759$var$legacySpacing.includes(props.spacing)) console.warn("these values for the spacing prop are deprecated", $fe5170bdd3625759$var$legacySpacing);
    return {
        captionBlock: {
            properties: {
                captionBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.text),
                captionBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.helper),
                captionBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.value)
            }
        },
        titleBlock: {
            properties: {
                titleBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.text),
                titleBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.helper),
                titleBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.value)
            }
        },
        helperBlock: {
            properties: {
                helperBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.text),
                helperBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.helper),
                helperBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.value)
            }
        },
        spacing: {
            properties: {
                spacing: props.spacing
            },
            defaultValue: "s",
            variations: {
                s: {
                    spacing: "small"
                },
                m: {
                    spacing: "medium"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$18 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$i);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _isTitleVisible: !(props.titleBlock?.text || props.titleBlockText)
            }
        });
    };
const $fe5170bdd3625759$var$Component$1b = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$17;
    const { spacing: spacing = "medium", verticalAlignment: verticalAlignment = "middle", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            spacing: spacing,
            verticalAlignment: verticalAlignment,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSListBlock", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7c8f337671b808e4 = $fe5170bdd3625759$var$withLogic$18($fe5170bdd3625759$var$Component$1b);
$fe5170bdd3625759$export$7c8f337671b808e4.displayName = "ListBlock";
$fe5170bdd3625759$export$7c8f337671b808e4.slotName = "jds_list_block";
const $fe5170bdd3625759$var$sdl$16 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenu",
        "layerName": "jds_mega_menu",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_megamenu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                },
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                }
            },
            "jds_megamenu_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                },
                "items.heading": {
                    "type": "string",
                    "name": "items.heading"
                },
                "items.subLinks": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "jds_megamenu_internal": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "jds_megamenu_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$17 = (Component)=>(props)=>{
        if (!props.open || !props.items?.length) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1a = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$16;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenu", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$aee42d298194d478 = $fe5170bdd3625759$var$withLogic$17($fe5170bdd3625759$var$Component$1a);
$fe5170bdd3625759$export$aee42d298194d478.displayName = "MegaMenu";
$fe5170bdd3625759$export$aee42d298194d478.slotName = "jds_mega_menu";
const $fe5170bdd3625759$var$sdl$15 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-block-1.0.0",
        "name": "JDSMegaMenuBlock",
        "layerName": "jds_mega_menu_block",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "heading-jds-text",
            {
                "links-container": [
                    "jds_mega_menu_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "gap": "{m_3}"
        },
        "links-container": {
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "align-items": "{m_6}"
        },
        "heading-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{m_7}"
        }
    },
    "api": {
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string"
                    }
                }
            },
            "jds_mega_menu_item": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_mega_menu_item": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$16 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$19 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$15;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuBlock", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5e96c1cbae381c93 = $fe5170bdd3625759$var$withLogic$16($fe5170bdd3625759$var$Component$19);
$fe5170bdd3625759$export$5e96c1cbae381c93.displayName = "MegaMenuBlock";
$fe5170bdd3625759$export$5e96c1cbae381c93.slotName = "jds_mega_menu_block";
const $fe5170bdd3625759$var$sdl$14 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenuInternal",
        "layerName": "jds_mega_menu_internal",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_mega_menu_block"
        ]
    },
    "base": {
        "container": {
            "width": "{m_1}",
            "flex-direction": "{m_2}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "background-color": "{m_5}",
            "padding-top": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-right": "{m_8}",
            "padding-left": "{m_9}",
            "gap": "{m_10}"
        }
    },
    "variant": {},
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                }
            },
            "jds_mega_menu_block": {
                "title": {
                    "type": "string",
                    "name": "items.heading"
                },
                "links": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "container": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$15 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$18 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$14;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d7717d03c9caf572 = $fe5170bdd3625759$var$withLogic$15($fe5170bdd3625759$var$Component$18);
$fe5170bdd3625759$export$d7717d03c9caf572.displayName = "MegaMenuInternal";
$fe5170bdd3625759$export$d7717d03c9caf572.slotName = "jds_mega_menu_internal";
const $fe5170bdd3625759$var$sdl$13 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-item-1.0.0",
        "name": "JDSMegaMenuItem",
        "layerName": "jds_mega_menu_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "padding-top": "{m_3}",
            "padding-bottom": "{m_4}"
        },
        "jds_link": {
            "kind": "submenu"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "onClick"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$14 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$17 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$13;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cc2d7d7492914f14 = $fe5170bdd3625759$var$withLogic$14($fe5170bdd3625759$var$Component$17);
$fe5170bdd3625759$export$cc2d7d7492914f14.displayName = "MegaMenuItem";
$fe5170bdd3625759$export$cc2d7d7492914f14.slotName = "jds_mega_menu_item";
const $fe5170bdd3625759$var$sdl$12 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlock",
        "layerName": "jds_menu_block"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_menu_block_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "padding-bottom": "{m_3}",
            "max-height": "{m_9}"
        },
        "jds_menu_block_internal": {
            "hidden": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_menu_block_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX",
                    "function": true
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY",
                    "function": true
                }
            },
            "jds_menu_block_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "minWidth": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "items.label": {
                    "type": "string",
                    "name": "items.label"
                },
                "items.value": {
                    "type": "string",
                    "name": "items.value"
                },
                "items.prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "items.suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "items.disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "items.selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_internal": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                },
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_menu_block_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useSelected = (selected)=>{
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(-1);
    (0, $acw62.useEffect)(()=>{
        if (typeof selected === "number") setSelectedIndex(selected);
    }, [
        selected
    ]);
    const updateIndex = (index)=>setSelectedIndex(index);
    return {
        index: selectedIndex,
        onClick: (index)=>{
            setSelectedIndex(index);
        },
        updateIndex: updateIndex
    };
};
const $fe5170bdd3625759$var$MENUBLOCK_SELECTOR$1 = "div#container.j-jds-menu-block-container";
const $fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR$1 = "div.j-JDSMenuBlockInternal-container";
const $fe5170bdd3625759$var$ANIMATION_DURATION$1 = 250;
const $fe5170bdd3625759$var$withLogic$13 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.selectedIndex);
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(props.open);
        const internalProps = props;
        const { items: items = props.items ?? [], anchorEl: anchorEl, open: open } = props;
        const menublockRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCK_SELECTOR$1);
        $fe5170bdd3625759$var$useEscapeClose(props.onClose, true);
        $fe5170bdd3625759$var$useScrollClose(props.onClose);
        (0, $acw62.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $fe5170bdd3625759$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (props.open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $fe5170bdd3625759$var$ANIMATION_DURATION$1);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $acw62.useEffect)(()=>{
            if (shouldRender && props.open) {
                const menublockInternalRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR$1);
                if (menublockInternalRef) menublockInternalRef.focus();
            } else anchorEl?.current?.focus();
        }, [
            shouldRender,
            props.open,
            element
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                },
                minWidth: internalProps.maxWidth || Math.max(width || 0, 250)
            }
        });
    };
const $fe5170bdd3625759$var$Component$16 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$12;
    const { open: open = false, onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onClick: onClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlock", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3a7690908a5e9b5 = $fe5170bdd3625759$var$withLogic$13($fe5170bdd3625759$var$Component$16);
$fe5170bdd3625759$export$3a7690908a5e9b5.displayName = "MenuBlock";
$fe5170bdd3625759$export$3a7690908a5e9b5.slotName = "jds_menu_block";
const $fe5170bdd3625759$var$sdl$11 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlockInternal",
        "layerName": "jds_menu_block_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_menu_block_item"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{intrinsicSize.max}",
            "lazy-scroll-android": false,
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{medium}",
            "overflow": "auto",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "transition": {
                "property": [
                    "max-height"
                ],
                "duration": "{slow}",
                "timing-function": "{easeExit}"
            }
        },
        "jds_menu_block_item": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "min-width": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "value": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                }
            },
            "jds_menu_block_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "hasIcon": {
                    "type": "boolean",
                    "name": "_hasIcon"
                },
                "selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_item": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                }
            },
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "listbox"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "value": "Choose an item"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_menu_block_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$MENUBLOCK_SELECTOR = "div#container.j-jds-menu-block-container";
const $fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR = "div.j-JDSMenuBlockInternal-container";
const $fe5170bdd3625759$var$ANIMATION_DURATION = 250;
const $fe5170bdd3625759$var$withLogic$12 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.selectedIndex);
        const internalProps = props;
        const { items: items = [], anchorEl: anchorEl, open: open } = props;
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(props.open);
        const menublockRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCK_SELECTOR);
        $fe5170bdd3625759$var$useEscapeClose(props.onClose, true);
        $fe5170bdd3625759$var$useScrollClose(props.onClose);
        (0, $acw62.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $fe5170bdd3625759$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $fe5170bdd3625759$var$ANIMATION_DURATION);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender || !props.open) return;
            const timeout = setTimeout(()=>{
                const menublockInternalRef = document.querySelector($fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR);
                menublockInternalRef?.focus();
            }, $fe5170bdd3625759$var$ANIMATION_DURATION);
            return ()=>clearTimeout(timeout);
        }, [
            shouldRender,
            props.open
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$15 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$11;
    const { open: open = false, onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), _ariaLabel: _ariaLabel = "Choose an item", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onAppear: onAppear,
            onClick: onClick,
            _ariaLabel: _ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f9b98c24bc73aa75 = $fe5170bdd3625759$var$withLogic$12($fe5170bdd3625759$var$Component$15);
$fe5170bdd3625759$export$f9b98c24bc73aa75.displayName = "MenuBlockInternal";
$fe5170bdd3625759$export$f9b98c24bc73aa75.slotName = "jds_menu_block_internal";
const $fe5170bdd3625759$var$sdl$10 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-item-1.0.0",
        "name": "JDSMenuBlockItem",
        "layerName": "jds_menu_block_item"
    },
    "hierarchy": {
        "container": [
            {
                "entry-container": [
                    {
                        "left-container": [
                            {
                                "prefix-jds-icon-container": [
                                    "prefix-jds-icon"
                                ]
                            },
                            "entry-jds-text"
                        ]
                    },
                    {
                        "suffix-jds-icon-container": [
                            "suffix-jds-icon"
                        ]
                    }
                ]
            },
            {
                "divider-container": [
                    "jds_divider"
                ]
            },
            {
                "heading-container": [
                    "heading-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{m_0}",
            "background-color": "{m_1}",
            "width": "{m_2}"
        },
        "entry-container": {
            "hidden": false,
            "background-color": "{m_3}",
            "width": "{m_4}",
            "padding-top": "{m_5}",
            "padding-right": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-left": "{m_8}",
            "flex-direction": "{m_9}",
            "align-items": "{m_10}",
            "justify-content": "{m_11}",
            "border-width": 0,
            "border-color": "{m_12}",
            "border-radius": 0,
            "behavior": {
                "hover": {
                    "background-color": "{m_13}"
                },
                "focus": {
                    "border-width": 2,
                    "border-color": "{m_14}",
                    "border-radius": "{m_15}"
                }
            }
        },
        "divider-container": {
            "hidden": true,
            "width": "{m_16}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "heading-container": {
            "hidden": true,
            "padding-top": "{m_17}",
            "padding-right": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "width": "{m_21}",
            "align-items": "{m_22}",
            "justify-content": "{m_23}"
        },
        "left-container": {
            "gap": "{m_24}",
            "flex-direction": "{m_25}",
            "align-items": "{m_26}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "hidden": true
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "entry-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "suffix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "suffix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "type": {
            "divider": {
                "entry-container": {
                    "hidden": true
                },
                "divider-container": {
                    "hidden": false
                }
            },
            "heading": {
                "entry-container": {
                    "hidden": true
                },
                "heading-container": {
                    "hidden": false
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{m_27}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{m_28}"
                }
            }
        },
        "hasIcon": {
            "true": {
                "heading-container": {
                    "padding-left": "{m_29}"
                },
                "prefix-jds-icon": {
                    "hidden": false
                },
                "prefix-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_item.value": {
                    "type": "string",
                    "name": "value"
                }
            },
            "entry-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "suffix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix"
                },
                "ic": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "entry-container": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "option"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "selected"
                    },
                    "aria-hidden": {
                        "name": "_ariaHidden",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$11 = (Component)=>(props)=>{
        const internalProps = props;
        const selected = internalProps.internalIndex === props.selectedIndex;
        const handleSelect = ()=>{
            props.onSelect?.(internalProps.internalIndex);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Enter" && internalProps.internalIndex === props.selectedIndex) handleSelect();
        };
        const handleClick = ()=>{
            handleSelect();
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                selected: selected,
                ariaLabel: props.type === "heading" ? props.ariaLabel || `${props.label} heading` : props.ariaLabel,
                _ariaHidden: props.type === "divider" ? "true" : void 0,
                _ariaSelected: props.type === "entry" ? selected : void 0,
                _hasIcon: internalProps._hasIcon || Boolean(props.prefix),
                onSelect: !props.type || props.type === "entry" ? handleSelect : void 0,
                prefix: props.prefix || (internalProps._hasIcon ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {}) : void 0)
            }
        });
    };
const $fe5170bdd3625759$var$Component$14 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$10;
    const { type: type = "entry", selected: selected = false, disabled: disabled = false, hasIcon: hasIcon = false, onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            selected: selected,
            disabled: disabled,
            hasIcon: hasIcon,
            onSelect: onSelect,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3789e0cd450be8da = $fe5170bdd3625759$var$withLogic$11($fe5170bdd3625759$var$Component$14);
$fe5170bdd3625759$export$3789e0cd450be8da.displayName = "MenuBlockItem";
$fe5170bdd3625759$export$3789e0cd450be8da.slotName = "jds_menu_block_item";
const $fe5170bdd3625759$var$sdl$$ = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheetInternal",
        "layerName": "jds_mobile_bottom_sheet_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_action_button"
                                ]
                            },
                            "empty-container",
                            "step-jds-text",
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "width": "{m_3}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "background-color": "{m_6}",
            "align-items": "{m_7}",
            "border-top-left-radius": "{m_8}",
            "border-top-right-radius": "{m_9}",
            "width": "{m_10}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": "{m_11}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_12}",
                "timing-function": "{m_13}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "width": "{m_17}",
            "padding-top": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "padding-right": "{m_21}",
            "gap": "{m_22}"
        },
        "back-container": {
            "flex": "{m_23}",
            "hidden": true
        },
        "back-jds_action_button": {
            "padding-top": "{xs}",
            "icon": "ic_back",
            "size": "medium",
            "kind": "tertiary"
        },
        "empty-container": {
            "flex": "{m_24}"
        },
        "cancel-jds_button": {
            "padding-top": "{xs}",
            "hidden": false,
            "icon": "ic_close",
            "size": "large",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{m_26}",
            "justify-content": "{m_27}",
            "align-items": "{m_28}",
            "padding-left": "{m_29}",
            "padding-right": "{m_30}",
            "width": "{m_31}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{m_34}",
            "gap": "{m_35}",
            "width": "{m_36}",
            "padding-bottom": "{m_37}",
            "padding-top": "{m_38}"
        },
        "children-slot": {
            "flex-fill-android": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_39}",
            "justify-content": "{m_40}",
            "align-items": "{m_41}",
            "background-color": "{m_42}",
            "border-top-left-radius": "{m_43}",
            "border-top-right-radius": "{m_44}",
            "padding-left": "{m_45}",
            "padding-right": "{m_46}",
            "padding-top": "{m_47}",
            "padding-bottom": "{m_48}",
            "width": "{m_49}",
            "translate-y": "{m_50}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_51}",
                "timing-function": "{m_52}"
            }
        },
        "step-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{m_25}"
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{xs}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{m_33}"
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": "{m_53}",
                        "y": "{m_54}",
                        "blur": "{m_55}",
                        "spread": "{m_56}",
                        "color": "{m_57}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": "{m_58}",
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "controlType": {
            "stepper": {
                "cancel-jds_button": {
                    "hidden": true
                },
                "back-container": {
                    "hidden": false
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_noButton": {
            "true": {
                "root-container": {
                    "padding-bottom": "{m_59}"
                },
                "cta-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": "{m_60}"
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{m_61}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_noButton": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "stepLabel"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "back-jds_action_button": {
                "onClick": "onBack"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Tap to go back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$10 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$13 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$$;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBottomSheetClick: onBottomSheetClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Tap to go back", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onAppear: onAppear,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheetInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9ac5eac5233c654 = $fe5170bdd3625759$var$withLogic$10($fe5170bdd3625759$var$Component$13);
$fe5170bdd3625759$export$9ac5eac5233c654.displayName = "MobileBottomSheetInternal";
$fe5170bdd3625759$export$9ac5eac5233c654.slotName = "jds_mobile_bottom_sheet_internal";
const $fe5170bdd3625759$var$sdl$_ = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktop",
        "layerName": "jds_modal_desktop",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "size": "{m_5}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_modal_desktop_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_desktop_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_desktop_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_desktop_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_desktop_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_desktop_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            }
        },
        "data": {
            "jds_modal_desktop_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_desktop_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_desktop_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$Z = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobile",
        "layerName": "jds_modal_mobile"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_mobile_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{m_4}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_5}",
                "timing-function": "{m_6}"
            }
        },
        "jds_modal_mobile_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_mobile_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_mobile_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_mobile_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_mobile_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{m_7}",
                    "transition": {
                        "timing-function": "{m_8}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_mobile_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "disableOutsideClick": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It determines whether modal should close and the onClose event should be triggered when clicking outside modal.",
                "function": true
            }
        },
        "data": {
            "jds_modal_mobile_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_mobile_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_mobile_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "headerAriaLabel": "headerAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$1 = [
    "s",
    "m"
];
const $fe5170bdd3625759$var$PROP_MAP$h = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$1.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title || props.primaryCTA,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title || props.secondaryCTA,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$MODAL_SELECTOR$1 = "div.j-JDSModalMobileInternal-root-container";
const $fe5170bdd3625759$var$withLogic$$ = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$h);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind, isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const modalRef = element?.querySelector($fe5170bdd3625759$var$MODAL_SELECTOR$1);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest.onClose?.();
            }
        };
        $fe5170bdd3625759$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $acw62.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
        }, [
            closeProp
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose,
                isCloseable: isClosable || props.isCloseable
            }
        });
    };
const $fe5170bdd3625759$var$Component$12 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Z;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, disableOutsideClick: disableOutsideClick = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            disableOutsideClick: disableOutsideClick,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobile", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Modal$1 = $fe5170bdd3625759$var$withLogic$$($fe5170bdd3625759$var$Component$12);
$fe5170bdd3625759$var$Modal$1.displayName = "Modal";
$fe5170bdd3625759$var$Modal$1.slotName = "jds_modal_mobile";
const $fe5170bdd3625759$var$legacySizes = [
    "s",
    "m"
];
const $fe5170bdd3625759$var$PROP_MAP$g = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        onClose: {
            properties: {
                onCloseCallback: props.onClose
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$MODAL_SELECTOR = "div.j-JDSModalDesktopInternal-root-container";
const $fe5170bdd3625759$var$withLogic$_ = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$g);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind = "dialog", isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const modalRef = element?.querySelector($fe5170bdd3625759$var$MODAL_SELECTOR);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest?.onClose?.();
            }
        };
        $fe5170bdd3625759$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $acw62.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
            if (!closeProp) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
            return ()=>{
                document.body.style.overflow = "";
            };
        }, [
            closeProp
        ]);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$Modal$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose
            }
        });
    };
const $fe5170bdd3625759$var$Component$11 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$_;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktop", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2b77a92f1a5ad772 = $fe5170bdd3625759$var$withLogic$_($fe5170bdd3625759$var$Component$11);
$fe5170bdd3625759$export$2b77a92f1a5ad772.displayName = "Modal";
$fe5170bdd3625759$export$2b77a92f1a5ad772.slotName = "jds_modal_desktop";
const $fe5170bdd3625759$var$sdl$Y = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktopInternal",
        "layerName": "jds_modal_desktop_internal",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "root-container": [
                    {
                        "cancel-container": [
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            {
                                "header-container": [
                                    "header-jds-text"
                                ]
                            },
                            {
                                "children-container": [
                                    "children-slot"
                                ]
                            },
                            {
                                "button-container": [
                                    "secondary-jds_action_button",
                                    "primary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_7}",
            "background-color": "{m_8}",
            "opacity": "{m_9}"
        },
        "root-container": {
            "z-index": 1,
            "flex-direction": "{m_10}",
            "justify-content": "{m_11}",
            "align-items": "{m_12}",
            "border-radius": "{m_13}",
            "background-color": "{m_14}",
            "width": "{m_15}",
            "max-height": "{m_16}"
        },
        "cancel-container": {
            "flex-direction": "{m_17}",
            "justify-content": "{m_18}",
            "align-items": "{m_19}",
            "width": "{m_20}",
            "padding-top": "{m_21}",
            "padding-bottom": "{m_22}",
            "padding-left": "{m_23}",
            "padding-right": "{m_24}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_25}",
            "justify-content": "{m_26}",
            "align-items": "{m_27}",
            "padding-left": "{m_28}",
            "padding-right": "{m_29}",
            "padding-bottom": "{m_30}",
            "width": "{m_31}",
            "overflow": "{m_32}"
        },
        "header-container": {
            "flex-direction": "{m_34}",
            "justify-content": "{m_35}",
            "align-items": "{m_36}",
            "width": "{m_37}",
            "padding-bottom": "{m_38}"
        },
        "children-container": {
            "width": "{m_39}",
            "overflow": "{m_40}"
        },
        "button-container": {
            "width": "{m_41}",
            "justify-content": "{m_42}",
            "align-items": "{m_43}",
            "flex-direction": "{m_44}",
            "gap": "{m_45}",
            "padding-top": "{m_46}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": false
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_47}",
            "justify-content": "{m_48}",
            "align-items": "{m_49}",
            "border-radius": "{m_50}",
            "background-color": "{elevation1}",
            "padding-left": "{m_52}",
            "padding-right": "{m_53}",
            "padding-top": "{m_54}",
            "padding-bottom": "{m_55}",
            "max-width": "{m_56}",
            "max-height": "{m_57}",
            "overflow": "{m_33}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_58}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_59}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_60}",
                    "padding-right": "{m_61}",
                    "padding-bottom": "{m_62}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_63}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_64}"
                    }
                }
            }
        },
        {
            "medium": {
                "desktop": {
                    "root-container": {
                        "width": "584"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "464"
                    }
                }
            },
            "small": {
                "desktop": {
                    "root-container": {
                        "width": "412"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "412"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ],
        [
            "size",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "custom-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$Z = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $fe5170bdd3625759$var$Component$10 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Y;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktopInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3e0ada2dd34546e6 = $fe5170bdd3625759$var$withLogic$Z($fe5170bdd3625759$var$Component$10);
$fe5170bdd3625759$export$3e0ada2dd34546e6.displayName = "ModalDesktopInternal";
$fe5170bdd3625759$export$3e0ada2dd34546e6.slotName = "jds_modal_desktop_internal";
const $fe5170bdd3625759$var$sdl$X = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobileInternal",
        "layerName": "jds_modal_mobile_internal"
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "outer-container": [
                    {
                        "root-container": [
                            {
                                "cancel-container": [
                                    "cancel-jds_button"
                                ]
                            },
                            {
                                "vertical-container": [
                                    {
                                        "header-container": [
                                            "header-jds-text"
                                        ]
                                    },
                                    {
                                        "children-container": [
                                            "children-slot"
                                        ]
                                    },
                                    {
                                        "button-container": [
                                            "primary-jds_action_button",
                                            "secondary-jds_action_button"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "custom-container": [
                            "children-slot"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_4}",
            "background-color": "{m_5}",
            "opacity": "{m_6}"
        },
        "outer-container": {
            "z-index": 1,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "max-height": "{m_19}",
            "width": "{m_18}",
            "padding-top": "{m_20}",
            "padding-bottom": "{m_21}",
            "padding-left": "{m_22}",
            "padding-right": "{m_23}"
        },
        "root-container": {
            "flex-direction": "{m_7}",
            "justify-content": "{m_8}",
            "align-items": "{m_9}",
            "border-radius": "{m_10}",
            "width": "{m_11}",
            "background-color": "{m_13}",
            "max-height": "{m_12}"
        },
        "cancel-container": {
            "flex-direction": "{m_24}",
            "justify-content": "{m_25}",
            "align-items": "{m_26}",
            "width": "{m_27}",
            "padding-top": "{m_28}",
            "padding-bottom": "{m_29}",
            "padding-left": "{m_30}",
            "padding-right": "{m_31}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_32}",
            "justify-content": "{m_33}",
            "align-items": "{m_34}",
            "width": "{m_35}",
            "padding-left": "{m_36}",
            "padding-right": "{m_37}",
            "padding-bottom": "{m_38}",
            "overflow": "{m_39}"
        },
        "header-container": {
            "flex-direction": "{m_40}",
            "justify-content": "{m_41}",
            "align-items": "{m_42}",
            "width": "{m_43}",
            "padding-bottom": "{m_44}"
        },
        "children-container": {
            "width": "{m_46}",
            "overflow": "{m_47}",
            "flex-direction": "{m_48}",
            "align-items": "{m_45}",
            "flex-fill-android": false
        },
        "button-container": {
            "width": "{m_49}",
            "justify-content": "{m_50}",
            "align-items": "{m_51}",
            "flex-direction": "{m_52}",
            "gap": "{m_53}",
            "padding-top": "{m_54}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": true
        },
        "custom-container": {
            "hidden": true,
            "flex-direction": "{m_55}",
            "justify-content": "{m_56}",
            "align-items": "{m_57}",
            "border-radius": "{m_58}",
            "background-color": "{elevation1}",
            "padding-left": "{m_60}",
            "padding-right": "{m_61}",
            "padding-top": "{m_62}",
            "padding-bottom": "{m_63}",
            "width": "{m_64}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_65}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_66}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_67}",
                    "padding-right": "{m_68}",
                    "padding-bottom": "{m_69}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_70}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_71}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ]
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements."
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "header-jds_text": {
                "properties": {
                    "aria-label": {
                        "name": "headerAriaLabel",
                        "prop": "header"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $fe5170bdd3625759$var$Component$$ = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$X;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onCancel: onCancel = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", headerAriaLabel: headerAriaLabel = props.header?.toString(), _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            headerAriaLabel: headerAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobileInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e70e9b240ff3bbbf = $fe5170bdd3625759$var$withLogic$Y($fe5170bdd3625759$var$Component$$);
$fe5170bdd3625759$export$e70e9b240ff3bbbf.displayName = "ModalMobileInternal";
$fe5170bdd3625759$export$e70e9b240ff3bbbf.slotName = "jds_modal_mobile_internal";
const $fe5170bdd3625759$var$sdl$W = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-button-1.0.0",
        "name": "JDSNotificationButton",
        "layerName": "jds_notification_button"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "padding-top": "{n_0}",
            "padding-right": "{n_1}",
            "padding-bottom": "{n_2}",
            "padding-left": "{n_3}",
            "background-color": "{n_4}",
            "border-radius": 1e3,
            "border-width": "1",
            "border-color": "{n_5}",
            "behavior": {
                "hover": {
                    "border-color": "{n_6}"
                },
                "active": {
                    "background-color": "{n_7}"
                },
                "focus": {
                    "border-width": "4",
                    "border-color": "{n_8}"
                }
            }
        },
        "icon": {
            "size": "{n_14}",
            "color": "{n_13}"
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary20}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "isDisabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{n_9}"
                }
            }
        },
        "kind": {
            "tertiary": {
                "container": {
                    "border-width": "0",
                    "behavior": {
                        "hover": {
                            "background-color": "{n_10}"
                        },
                        "active": {
                            "background-color": "{n_11}"
                        },
                        "focus": {
                            "background-color": "{n_12}"
                        }
                    }
                }
            }
        },
        "_hasLabel": {
            "false": {
                "container": {
                    "padding-top": "{n_15}",
                    "padding-bottom": "{n_16}",
                    "padding-left": "{n_17}",
                    "padding-right": "{n_18}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasIcon": {
            "true": {
                "icon": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "isDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "secondary",
                    "tertiary"
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$X = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label),
                tabIndex: 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$_ = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$W;
    const { isDisabled: isDisabled = false, kind: kind = "secondary", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            isDisabled: isDisabled,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NotificationButton = $fe5170bdd3625759$var$withLogic$X($fe5170bdd3625759$var$Component$_);
$fe5170bdd3625759$var$NotificationButton.displayName = "NotificationButton";
$fe5170bdd3625759$var$NotificationButton.slotName = "jds_notification_button";
const $fe5170bdd3625759$var$sdl$V = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudge",
        "layerName": "jds_nudge"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{n_0}",
            "max-width": "{n_1}",
            "border-radius": "{n_2}",
            "background-color": "{n_3}",
            "flex-direction": "{n_4}",
            "gap": "{n_5}",
            "padding-top": "{n_6}",
            "padding-right": "{n_7}",
            "padding-bottom": "{n_8}",
            "padding-left": "{n_9}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{n_10}",
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_11}"
        },
        "center-container": {
            "flex-direction": "{n_15}",
            "justify-content": "{n_16}",
            "align-items": "{n_17}",
            "gap": "{n_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "show": false,
            "gap": "{n_20}",
            "flex-direction": "{n_21}",
            "justify-content": "{n_22}",
            "width": "{n_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{n_23}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{n_24}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.negativeMax}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Nudge when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Nudge"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Nudge."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Nudge."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Nudge."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Nudge."
                },
                "maxLines": {
                    "type": "number",
                    "name": "maxLines",
                    "doc_description": "Allows customization of max lines for the description text."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeUp": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            },
            "base-container": {
                "properties": {
                    "aria-hidden": {
                        "value": "true"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$f = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
function $fe5170bdd3625759$var$subscribe(eventClass, func) {
    const handler = function() {
        func(eventClass.args);
    };
    document.addEventListener(eventClass.eventName, handler, {
        passive: true
    });
    return {
        unsubscribe: function unsubscribe() {
            document.removeEventListener(eventClass.eventName, handler);
        }
    };
}
function $fe5170bdd3625759$var$publish(event) {
    const nativeEvent = new CustomEvent(event.constructor.eventName, {
        detail: event.constructor.args
    });
    document.dispatchEvent(nativeEvent);
}
const $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA = 10;
const $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA = 5;
const $fe5170bdd3625759$var$TOAST_SELECTOR = "div.j-JDSToast-root-container";
const $fe5170bdd3625759$var$resolvePrefixIcon = (props)=>{
    if (typeof props.prefix === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: props.prefix
    });
    return props.prefix;
};
function $fe5170bdd3625759$var$getDismissTime(isCTAPresent, dismissAfter) {
    let timer = $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA;
    if (isCTAPresent) timer = $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA;
    if (dismissAfter !== void 0) {
        const defaultMinTimer = 2;
        const defaultMaxTimer = isCTAPresent ? $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA : $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA;
        if (dismissAfter < defaultMinTimer) timer = defaultMinTimer;
        else if (dismissAfter < defaultMaxTimer) timer = dismissAfter;
    }
    return timer;
}
const $fe5170bdd3625759$var$withLogic$W = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$f);
        const { onClose: onClose, onShow: onShow, primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: userId, suffix: suffix, dismissAfter: dismissAfter, ...rest } = props;
        const uniqueId = userId || `toast-${Math.random().toString(36).substr(2, 9)}`;
        const [closeToast, setCloseToast] = (0, $acw62.useState)();
        const [timeToClose, setTimeToClose] = (0, $acw62.useState)(0);
        const [intervalID, setIntervalID] = (0, $acw62.useState)();
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const isCTAPresent = !!(primaryCTA || secondaryCTA);
        const TOAST_CLOSING_TIME = $fe5170bdd3625759$var$getDismissTime(isCTAPresent, dismissAfter);
        const platformClass = $fe5170bdd3625759$var$getPlatform() === "mobile" ? "mobile-toast" : "desktop-toast";
        const [toastQueue, setToastQueue] = (0, $acw62.useState)([]);
        const [timeouts, setTimeouts] = (0, $acw62.useState)({});
        (0, $acw62.useEffect)(()=>{
            if (!toastQueue.includes(uniqueId)) setToastQueue((prevQueue)=>[
                    ...prevQueue,
                    uniqueId
                ]);
            const dismissTimer = setTimeout(()=>{
                setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
                handleToastUnmount();
            }, TOAST_CLOSING_TIME * 1e3);
            setTimeouts((prevTimeouts)=>({
                    ...prevTimeouts,
                    [uniqueId]: dismissTimer
                }));
            return ()=>{
                clearTimeout(dismissTimer);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            };
        }, [
            uniqueId,
            TOAST_CLOSING_TIME
        ]);
        const handleToastUnmount = (0, $acw62.useCallback)(()=>{
            console.log("unmount");
            setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
            if ($fe5170bdd3625759$var$toast && typeof $fe5170bdd3625759$var$toast.dismiss === "function") $fe5170bdd3625759$var$toast.dismiss(uniqueId);
            onClose?.(uniqueId);
            if (timeouts[uniqueId]) {
                clearTimeout(timeouts[uniqueId]);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            }
            if (element?.classList.contains("visible") && timeouts[uniqueId]) element.classList.remove("visible");
            setCloseToast(true);
        }, [
            uniqueId,
            onClose,
            timeouts
        ]);
        const handleToastStart = (0, $acw62.useCallback)(()=>{
            console.log("mount");
            if (timeToClose <= TOAST_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) clearInterval(intervalID2);
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        }, [
            TOAST_CLOSING_TIME,
            timeToClose
        ]);
        const handleToastPause = (0, $acw62.useCallback)(()=>{
            if (timeToClose !== TOAST_CLOSING_TIME) clearInterval(intervalID);
        }, [
            timeToClose,
            TOAST_CLOSING_TIME,
            intervalID
        ]);
        (0, $acw62.useEffect)(()=>{
            uniqueId && onShow && onShow(uniqueId);
            setTimeout(()=>setCloseToast(false), 10);
            const toastElement = document.querySelector($fe5170bdd3625759$var$TOAST_SELECTOR);
            if (toastElement) {
                toastElement.setAttribute("tabindex", "0");
                toastElement.focus();
            }
            const { unsubscribe: toastCloseUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationCloseService, (data)=>{
                if (uniqueId && data[uniqueId] === "toast") handleToastClose();
            });
            if (window) {
                handleToastStart();
                window.addEventListener("blur", handleToastPause);
                window.addEventListener("focus", handleToastStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleToastPause);
                    window.removeEventListener("focus", handleToastStart);
                }
                uniqueId && onClose && onClose(uniqueId);
                toastCloseUnsubscribe();
            };
        }, [
            uniqueId
        ]);
        (0, $acw62.useEffect)(()=>{
            if (timeToClose === TOAST_CLOSING_TIME) handleToastClose();
        }, [
            timeToClose,
            TOAST_CLOSING_TIME
        ]);
        const handleToastClose = ()=>{
            setCloseToast(true);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                onClose: handleToastUnmount,
                onMouseEnter: ()=>{
                    handleToastPause();
                },
                onMouseLeave: ()=>{
                    handleToastStart();
                },
                ...rest,
                prefix: $fe5170bdd3625759$var$resolvePrefixIcon(props),
                open: true,
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NotificationButton, {
                    ...suffix
                }),
                className: `v1 ${closeToast === false ? "visible" : ""} ${platformClass}`,
                rootRef: rootRef,
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description),
                _platform: $fe5170bdd3625759$var$getPlatform(),
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA
            }
        });
    };
const $fe5170bdd3625759$var$PROP_MAP$e = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
const $fe5170bdd3625759$var$NUDGE_CLOSING_TIME = 5;
const $fe5170bdd3625759$var$withLogic$V = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$e);
        const { primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: id, onShow: onShow, onClose: onClose, suffix: suffix, maxLines: maxLines, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [closeNudge, setCloseNudge] = (0, $acw62.useState)(true);
        const [timeToClose, setTimeToClose] = (0, $acw62.useState)(0);
        const [intervalID, setIntervalID] = (0, $acw62.useState)();
        const defaultMaxLine = 1;
        const isCTAGroupAbsent = !(primaryCTA && secondaryCTA || (primaryCTA || secondaryCTA) && showClose);
        const handleNudgeUnmount = (0, $acw62.useCallback)(()=>{
            if (id) {
                $fe5170bdd3625759$var$nudge.dismiss(id);
                if (element?.classList.contains("visible")) element.classList.remove("visible");
                onClose?.(id);
                setCloseNudge(true);
            }
        }, [
            id,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            id && onShow && onShow(id);
            setTimeout(()=>setCloseNudge(false), 10);
            const { unsubscribe: nudgeCloseUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationCloseService, (data)=>{
                if (id && data[id] === "nudge") handleNudgeClose();
            });
            if (window) {
                handleNudgeStart();
                window.addEventListener("blur", handleNudgePause);
                window.addEventListener("focus", handleNudgeStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleNudgePause);
                    window.removeEventListener("focus", handleNudgeStart);
                }
                id && onClose && onClose(id);
                nudgeCloseUnsubscribe();
            };
        }, [
            id
        ]);
        (0, $acw62.useEffect)(()=>{
            if (isCTAGroupAbsent && timeToClose >= $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) handleNudgeUnmount();
        }, [
            timeToClose,
            handleNudgeUnmount,
            isCTAGroupAbsent
        ]);
        const handleNudgeStart = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) {
                            clearInterval(intervalID2);
                            return time;
                        }
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        };
        const handleNudgePause = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) clearInterval(intervalID);
        };
        const handleNudgeClose = ()=>{
            setCloseNudge(true);
        };
        (0, $acw62.useEffect)(()=>{
            if (element) {
                const el = element.querySelector('[data-testid="JDSNudge-support-jds-text"]');
                if (el) el.style.setProperty("--max-lines", `${maxLines || defaultMaxLine}`);
            }
        }, [
            element,
            maxLines
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                onClose: handleNudgeUnmount,
                onMouseEnter: ()=>{
                    handleNudgePause();
                },
                onMouseLeave: ()=>{
                    handleNudgeStart();
                },
                ...rest,
                prefix: $fe5170bdd3625759$var$resolvePrefixIcon(props),
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NotificationButton, {
                    ...suffix
                }),
                rootRef: rootRef,
                open: true,
                className: closeNudge === false ? "visible" : "",
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA,
                maxLines: maxLines ?? defaultMaxLine,
                _platform: $fe5170bdd3625759$var$getPlatform(),
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description)
            }
        });
    };
const $fe5170bdd3625759$var$Component$Z = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$V;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onUpdate: onUpdate = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onHover: onHover,
            onUpdate: onUpdate,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudge", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Nudge = $fe5170bdd3625759$var$withLogic$V($fe5170bdd3625759$var$Component$Z);
$fe5170bdd3625759$var$Nudge.displayName = "Nudge";
$fe5170bdd3625759$var$Nudge.slotName = "jds_nudge";
const $fe5170bdd3625759$var$sdl$U = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-button-1.0.0",
        "name": "JDSPaginationButton",
        "layerName": "jds_pagination_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "size": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "behavior": {
                "hover": {},
                "focus": {},
                "active": {}
            }
        },
        "inner-container": {
            "background-color": "{p_3}",
            "flex-direction": "{p_4}",
            "justify-content": "{p_5}",
            "align-items": "{p_6}",
            "border-radius": "{p_7}",
            "width": "{p_8}",
            "height": "{p_9}",
            "opacity": "{p_10}",
            "gap": "{p_11}",
            "border-color": "{p_12}",
            "behavior": {
                "hover": {
                    "background-color": "{p_13}"
                },
                "active": {
                    "background-color": "{p_14}"
                },
                "focus": {
                    "border-width": "{p_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary40}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{primary60}"
                },
                "active": {
                    "color": "{primary60}"
                },
                "focus": {
                    "color": "{primary60}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "selected": {
                "inner-container": {
                    "background-color": "{p_16}"
                },
                "jds-text": {
                    "color": "{primary30}"
                }
            },
            "ellipsis": {
                "container": {
                    "disabled": true
                },
                "inner-container": {
                    "background-color": "{p_17}"
                },
                "jds-text": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "ellipsis"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-current": "_ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$U = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaCurrent: props.state === "selected" ? "page" : void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$Y = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$U;
    const { state: state = "default", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPaginationButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c3639e97caabff2c = $fe5170bdd3625759$var$withLogic$U($fe5170bdd3625759$var$Component$Y);
$fe5170bdd3625759$export$c3639e97caabff2c.displayName = "PaginationButton";
$fe5170bdd3625759$export$c3639e97caabff2c.slotName = "jds_pagination_button";
const $fe5170bdd3625759$var$sdl$T = {
    "metadata": {
        "version": "1.0.0",
        "id": "progress-bar-1.0.0",
        "name": "JDSProgressBar",
        "layerName": "jds_progress_bar"
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "jds-text",
                    "value-jds-text"
                ]
            },
            {
                "determinate-container": [
                    "active-container",
                    "invisible-container"
                ]
            },
            {
                "indeterminate-container": [
                    "track-container",
                    "active-animatedContainer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "gap": "{p_3}",
            "width": "{p_4}",
            "background-color": "{p_5}"
        },
        "top-container": {
            "hidden": false,
            "show": false,
            "background-color": "{p_6}",
            "flex-direction": "{p_7}",
            "justify-content": "{p_8}",
            "align-items": "{p_9}",
            "width": "{p_10}",
            "gap": "{p_11}"
        },
        "determinate-container": {
            "hidden": false,
            "background-color": "{p_12}",
            "height": "{p_13}",
            "width": "{p_14}",
            "flex-direction": "{p_15}",
            "justify-content": "{p_16}",
            "align-items": "{p_17}",
            "border-radius": "{p_18}"
        },
        "active-container": {
            "background-color": "{p_19}",
            "height": "{p_20}",
            "border-radius": "{p_21}",
            "show": true
        },
        "invisible-container": {
            "height": "{p_22}",
            "show": true
        },
        "indeterminate-container": {
            "hidden": true,
            "flex-direction": "{p_23}",
            "background-color": "{p_24}",
            "height": "{p_25}",
            "width": "{p_26}",
            "border-radius": "{p_27}",
            "overflow": "hidden"
        },
        "track-container": {
            "height": "{p_28}",
            "show": true
        },
        "active-animatedContainer": {
            "height": "{p_29}",
            "width": "{p_30}",
            "background-color": "{p_31}",
            "z-index": 1,
            "border-radius": "{p_32}",
            "animation-curve": "entrance_ease",
            "animation-duration": 1e3
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "value-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "indeterminate": {
                "determinate-container": {
                    "hidden": true
                },
                "indeterminate-container": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "active-container": {
                    "background-color": "{p_33}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_34}"
                }
            },
            "error": {
                "active-container": {
                    "background-color": "{p_35}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_36}"
                }
            },
            "warning": {
                "active-container": {
                    "background-color": "{p_37}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_38}"
                }
            }
        },
        "labelPosition": {
            "center": {
                "top-container": {
                    "justify-content": "{p_39}"
                }
            }
        },
        "_hasValueLabel": {
            "false": {
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabel": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabelOrValueLabel": {
            "false": {
                "top-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.start}"
                    },
                    "value-jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.end}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "labelPosition",
            "_hasValueLabel"
        ],
        [
            "labelPosition",
            "_hasLabel"
        ]
    ],
    "api": {
        "data": {
            "active-container": {
                "flex": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of progress bar."
                }
            },
            "invisible-container": {
                "flex": {
                    "type": "float",
                    "name": "_invisible"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the main label of Progess Bar."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueLabel",
                    "doc_description": "It displays the support label of Progess Bar."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "determinate",
                    "indeterminate"
                ],
                "doc_description": "It can be used to switch between 2 variants of progess bar."
            },
            "labelPosition": {
                "values": [
                    "stretch",
                    "center"
                ],
                "doc_description": "It can be used align label of progress bar to center or at the ends of progress bar."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.This can be dynamically changed as per user's form handling.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_hasLabelOrValueLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasValueLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "progressbar"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "platform": "web,ios"
                    },
                    "aria-busy": {
                        "name": "ariaBusy",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$d = (props)=>({
        type: {
            properties: {
                kind: props.type
            }
        }
    });
const $fe5170bdd3625759$var$withLogic$T = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$d);
        const { value: value = 0, ...rest } = props;
        const min = 0;
        const max = value < 1 ? 1 : 100;
        const calculatedValue = value / (max - min);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                value: calculatedValue,
                _invisible: 1 - calculatedValue,
                _ariaValuenow: props.kind === "indeterminate" ? void 0 : props.value,
                _ariaValuemin: props.kind === "indeterminate" ? void 0 : "0",
                _ariaValuemax: props.kind === "indeterminate" ? void 0 : "100",
                ariaBusy: props.kind === "indeterminate" ? "true" : props.ariaBusy
            }
        });
    };
const $fe5170bdd3625759$var$Component$X = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$T;
    const { kind: kind = "determinate", labelPosition: labelPosition = "stretch", state: state = "undefined", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            labelPosition: labelPosition,
            state: state,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSProgressBar", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c17561cb55d4db30 = $fe5170bdd3625759$var$withLogic$T($fe5170bdd3625759$var$Component$X);
$fe5170bdd3625759$export$c17561cb55d4db30.displayName = "ProgressBar";
$fe5170bdd3625759$export$c17561cb55d4db30.slotName = "jds_progress_bar";
const $fe5170bdd3625759$var$sdl$S = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-item-1.0.0",
        "name": "JDSRatingBarItem",
        "layerName": "jds_rating_bar_item"
    },
    "hierarchy": {
        "container": [
            {
                "start-container": [
                    "start-icon"
                ]
            },
            {
                "end-container": [
                    "end-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{r_0}",
            "behavior": {
                "focus": {
                    "border-width": "{r_1}",
                    "border-color": "{r_2}"
                }
            }
        },
        "start-container": {
            "clip-first-half": true
        },
        "start-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        },
        "end-container": {
            "hidden": true,
            "clip-first-half": false,
            "z-index": 1
        },
        "end-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        }
    },
    "variant": {
        "size": {
            "small": {
                "start-icon": {
                    "size": "{r_3}"
                },
                "end-icon": {
                    "size": "{r_4}"
                }
            },
            "large": {
                "start-icon": {
                    "size": "{r_5}"
                },
                "end-icon": {
                    "size": "{r_6}"
                }
            }
        },
        "isInteractive": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{r_7}"
                }
            }
        },
        "isHalfRated": {
            "true": {
                "end-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "false": {
                        "start-icon": {
                            "color": "{r_8}"
                        },
                        "end-icon": {
                            "color": "{r_9}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_10}"
                        },
                        "end-icon": {
                            "color": "{r_11}"
                        }
                    }
                },
                "true": {
                    "false": {
                        "start-icon": {
                            "color": "{r_12}"
                        },
                        "end-icon": {
                            "color": "{r_13}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_14}"
                        },
                        "end-icon": {
                            "color": "{r_15}"
                        }
                    }
                }
            },
            "true": {
                "false": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_16}",
                                    "border-color": "{r_18}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_20}",
                            "behavior": {
                                "active": {
                                    "color": "{r_24}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_21}",
                            "behavior": {
                                "active": {
                                    "color": "{r_25}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_17}",
                                    "border-color": "{r_19}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "true": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_28}",
                                    "border-color": "{r_26}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_30}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_31}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_29}",
                                    "border-color": "{r_27}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_32}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_33}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "start-icon": {
                        "color": "{r_38}"
                    },
                    "end-icon": {
                        "color": "{r_39}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isInteractive",
            "isActive",
            "isHovered"
        ],
        [
            "isInteractive",
            "isHalfRated"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "isInteractive": {
                "values": [
                    false,
                    true
                ]
            },
            "isActive": {
                "values": [
                    false,
                    true
                ]
            },
            "isHovered": {
                "values": [
                    false,
                    true
                ]
            },
            "isHalfRated": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "start-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "clipValue",
                    "function": true
                }
            },
            "end-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "_updatedClipValue"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-checked": {
                        "name": "ariaChecked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "interactive" ? "radio" : void 0
            },
            onHover: ()=>{
                props.onMouseEnter?.(props.internalIndex);
            },
            onHoverEnd: ()=>{
                props.onMouseLeave?.(-1);
            },
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            },
            _updatedClipValue: props.clipValue !== void 0 ? `${((1 - Number(props.clipValue?.slice(0, -1)) / 100) * 100).toString()}%` : void 0
        });
    };
const $fe5170bdd3625759$var$Component$W = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$S;
    const { size: size = "medium", isInteractive: isInteractive = false, isActive: isActive = false, isHovered: isHovered = false, isHalfRated: isHalfRated = false, disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            isInteractive: isInteractive,
            isActive: isActive,
            isHovered: isHovered,
            isHalfRated: isHalfRated,
            disabled: disabled,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBarItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b473c78e8d3557fd = $fe5170bdd3625759$var$withLogic$S($fe5170bdd3625759$var$Component$W);
$fe5170bdd3625759$export$b473c78e8d3557fd.displayName = "RatingBarItem";
$fe5170bdd3625759$export$b473c78e8d3557fd.slotName = "jds_rating_bar_item";
const $fe5170bdd3625759$var$sdl$R = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-box-1.0.0",
        "name": "JDSSearchBox",
        "layerName": "jds_search_box",
        "description": "The search pattern allows users to quickly find relevant content by typing a querry",
        "usage": "The Search function is triggered as soon as the user focuses in the search field or hits on the search icon. Initially he can see a list of recent searches and quick links but as soon as he starts typing he would see suggestions relevant with his querry."
    },
    "hierarchy": {
        "container": [
            {
                "prefix-container": [
                    "prefix-icon"
                ]
            },
            "input",
            {
                "suffix-container": [
                    "suffix-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_10}",
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "padding-right": "{s_4}",
            "padding-left": "{s_5}",
            "width": "{s_6}",
            "height": "{s_7}",
            "border-radius": "{s_8}",
            "gap": "{s_9}",
            "behavior": {
                "focus": {
                    "border-color": "{s_11}",
                    "border-width": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                }
            }
        },
        "input": {
            "type": "search",
            "text-align": "{s_14}",
            "placeholder-color": "{s_15}",
            "placeholder-font-family": "{s_16}",
            "placeholder-font-size": "{s_17}",
            "placeholder-line-height": "{s_18}",
            "placeholder-letter-spacing": "{s_19}",
            "placeholder-font-weight": "{s_20}",
            "input-color": "{s_21}",
            "input-font-family": "{s_22}",
            "input-font-size": "{s_23}",
            "input-line-height": "{s_24}",
            "input-letter-spacing": "{s_25}",
            "input-font-weight": "{s_26}",
            "cursor-color": "{s_27}",
            "width": "{size.max}",
            "disabled": false,
            "flex": 1,
            "behavior": {
                "hover": {
                    "placeholder-color": "{s_28}"
                },
                "focus": {
                    "placeholder-color": "{s_29}"
                },
                "active": {
                    "placeholder-color": "{s_30}"
                }
            }
        },
        "prefix-container": {
            "flex-direction": "{s_31}",
            "justify-content": "{s_32}",
            "align-items": "{s_33}"
        },
        "prefix-icon": {
            "size": "{s_34}",
            "color": "{s_35}",
            "behavior": {
                "hover": {
                    "color": "{s_36}"
                },
                "focus": {
                    "color": "{s_37}"
                },
                "active": {
                    "color": "{s_38}"
                }
            }
        },
        "suffix-container": {
            "flex-direction": "{s_39}",
            "justify-content": "{s_40}",
            "align-items": "{s_41}"
        },
        "suffix-icon": {
            "size": "{s_42}",
            "color": "{s_43}",
            "behavior": {
                "hover": {
                    "color": "{s_44}"
                },
                "focus": {
                    "color": "{s_45}"
                },
                "active": {
                    "color": "{s_46}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "header": {
                "container": {
                    "background-color": "{s_47}",
                    "behavior": {
                        "focus": {
                            "border-color": "{s_48}",
                            "border-width": 4
                        },
                        "active": {
                            "background-color": "{s_49}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_50}",
                    "behavior": {
                        "hover": {
                            "color": "{s_51}"
                        },
                        "active": {
                            "color": "{s_52}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_53}",
                    "behavior": {
                        "hover": {
                            "color": "{s_54}"
                        },
                        "active": {
                            "color": "{s_55}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_56}",
                    "placeholder-color": "{s_57}",
                    "cursor-color": "{s_58}",
                    "behavior": {
                        "hover": {
                            "placeholder-color": "{s_59}"
                        }
                    }
                }
            },
            "light_background": {
                "container": {
                    "background-color": "{s_60}",
                    "border-color": "{s_61}",
                    "border-width": "{s_65}",
                    "behavior": {
                        "hover": {
                            "background-color": "{s_60}",
                            "border-color": "{s_62}"
                        },
                        "focus": {
                            "background-color": "{s_60}",
                            "border-color": "{s_63}",
                            "border-width": "{s_66}"
                        },
                        "active": {
                            "background-color": "{s_60}",
                            "border-color": "{s_64}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_67}",
                    "cursor-color": "{s_68}",
                    "behavior": {
                        "active": {
                            "placeholder-color": "{s_69}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_70}",
                    "behavior": {
                        "hover": {
                            "color": "{s_71}"
                        },
                        "focus": {
                            "color": "{s_72}"
                        },
                        "active": {
                            "color": "{s_73}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_74}",
                    "behavior": {
                        "active": {
                            "color": "{s_75}"
                        }
                    }
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_76}"
                },
                "prefix-container": {
                    "disabled": true
                },
                "suffix-container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "suffix-icon": {
                    "color": "{s_77}"
                }
            }
        },
        "_inputFocus": {
            "true": {
                "input": {
                    "placeholder-color": "{s_79}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_78}"
                    }
                }
            },
            "light_background": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_80}"
                    }
                }
            }
        },
        {
            "light_background": {
                "true": {
                    "container": {
                        "border-color": "{s_81}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "_isValueEmpty"
        ],
        [
            "kind",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "header",
                    "light_background"
                ],
                "doc_description": "It determines if SearchBox is to be used on header or normal background."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "_isValueEmpty": {
                "values": [
                    true,
                    false
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes user input for text to be searched."
                },
                "name": {
                    "type": "string",
                    "name": "name",
                    "doc_description": "It displays name of search box."
                },
                "placeholder": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays placeholder text of search box."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix",
                    "function": true,
                    "doc_description": "It can be used to pass icon as prefix."
                }
            },
            "suffix-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix",
                    "doc_description": "It can be used to display icon on the right of search box."
                }
            },
            "container": {
                "_prefix.showBack": {
                    "type": "boolean",
                    "name": "showBack"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            },
            "prefix-container": {
                "onClick": "onBack"
            },
            "suffix-container": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "prefix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "prefixAriaLabel"
                    }
                }
            },
            "suffix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "suffixAriaLabel"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "search"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    }
                }
            },
            "input": {
                "name": "input",
                "properties": {
                    "role": {
                        "value": "searchbox"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$R = (Component)=>(props)=>{
        const { onBack: onBack, ...rest } = props;
        const [typing, setTyping] = (0, $acw62.useState)(false);
        const [value, setValue] = (0, $acw62.useState)(props.value);
        const element = (0, $acw62.useRef)(null);
        const [focused, setFocused] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            setValue(props.value);
        }, [
            props.value
        ]);
        const triggerChange = (value2 = "")=>{
            if (element) {
                const input = element?.current;
                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                tracker?.call(input, value2);
                const event = new Event("input", {
                    bubbles: true
                });
                input?.dispatchEvent(event);
            }
        };
        const formatIconName = (iconName)=>{
            if (typeof iconName === "string" && iconName.startsWith("Ic")) {
                const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
                const words = iconName.slice(3).split("_");
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            }
            return iconName;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                value: value,
                prefixAriaLabel: props.prefixAriaLabel || formatIconName(props.prefix),
                suffixAriaLabel: props.suffixAriaLabel || formatIconName(props.suffix),
                onBack: ()=>{
                    if (focused && props.showBack) onBack?.(value || "");
                    else props.onPrefixClick?.(value);
                },
                prefix: props.showBack && focused ? "IcBack" : props.prefix,
                suffix: typing ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: "suffix-container",
                    onMouseDown: (e)=>e.preventDefault(),
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onSuffixClick?.();
                    },
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $41afd5d0591e38b4$export$464f071bbd2cc5e5), {})
                }) : props.suffix,
                onFocus: (ev)=>{
                    props.onFocus?.(ev);
                    setFocused(true);
                    setTyping(Boolean(ev.target.value));
                },
                _isValueEmpty: !typing,
                onBlur: (ev)=>{
                    props.onBlur?.(ev);
                    if (!ev.target.value) setFocused(false);
                    if (!(ev.relatedTarget?.id === "suffix-container")) setTyping(false);
                },
                onChange: (ev)=>{
                    setTyping(Boolean(ev.target.value));
                    props.onChange?.(ev);
                    setValue(ev.target.value);
                },
                layerRefs: {
                    input: element
                },
                _inputFocus: focused,
                onSuffixClick: ()=>{
                    props?.onSuffixClick?.();
                    if (typing) {
                        setValue("");
                        triggerChange("");
                        setTyping(false);
                    }
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$V = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$R;
    const { kind: kind = "normal", disabled: disabled = false, onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onKeyup: onKeyup = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onBack: onBack,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchBox", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5a58787633b0b5d8 = $fe5170bdd3625759$var$withLogic$R($fe5170bdd3625759$var$Component$V);
$fe5170bdd3625759$export$5a58787633b0b5d8.displayName = "SearchBox";
$fe5170bdd3625759$export$5a58787633b0b5d8.slotName = "jds_search_box";
const $fe5170bdd3625759$var$sdl$Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResults",
        "layerName": "jds_search_results"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_search_results_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "width": "{size.max}",
            "background-color": "{global.transparent}",
            "border-radius": 0
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "appearance": {
            "box": {
                "jds_search_results_internal": {
                    "appearance": "box"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to open or close search result items."
            }
        },
        "data": {
            "jds_search_results_internal": {
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                },
                "headerAction": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                },
                "results": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "results.label": {
                    "type": "string",
                    "name": "results.label"
                },
                "results.icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_search_results_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick",
                "onHeaderActionClick": "onHeaderActionClick",
                "onContainerClick": "_onContainerClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_search_results_internal": {
                "name": "results",
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "headerActionAriaLabel": "headerActionAriaLabel",
                    "headerActionAriaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": "headerActionAriaHidden"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$c = (props)=>({
        properties: {
            results: props.results?.map((r)=>({
                    ...r,
                    title: r.label,
                    icon: r.icon
                })),
            header: props.header,
            headerAction: props.headerAction?.title,
            onHeaderActionClick: props.headerAction?.onClick
        }
    });
const $fe5170bdd3625759$var$withLogic$Q = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$c);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    _onContainerClick: (ev)=>ev.stopPropagation()
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$U = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Q;
    const { appearance: appearance = "normal", open: open = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            open: open,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResults", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$aee53da69e9839be = $fe5170bdd3625759$var$withLogic$Q($fe5170bdd3625759$var$Component$U);
$fe5170bdd3625759$export$aee53da69e9839be.displayName = "SearchResults";
$fe5170bdd3625759$export$aee53da69e9839be.slotName = "jds_search_results";
const $fe5170bdd3625759$var$sdl$P = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResultsInternal",
        "layerName": "jds_search_results_internal"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "heading-container": [
                            "jds-text",
                            "jds_action_button"
                        ]
                    },
                    {
                        "results-container": [
                            "jds_search_result_item"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}",
            "padding-top": "{base}",
            "padding-right": "{base}",
            "padding-bottom": "{base}",
            "padding-left": "{base}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "container": {
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}"
        },
        "heading-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.spaceBetween}",
            "align-items": "{alignItems.start}",
            "width": "{size.max}"
        },
        "jds_action_button": {
            "kind": "tertiary",
            "size": "small",
            "appearance": "normal",
            "state": "normal",
            "iconPosition": "left",
            "stretch": false
        },
        "results-container": {
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.start}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "appearance": {
            "box": {
                "root-container": {
                    "border-radius": "{xl}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            }
        },
        "data": {
            "container": {
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                }
            },
            "jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                }
            },
            "results-container": {
                "value": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                }
            },
            "jds_search_result_item": {
                "label": {
                    "type": "string",
                    "name": "results.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds_search_result_item": {
                "onClick": "onClick"
            },
            "jds_action_button": {
                "onClick": "onHeaderActionClick"
            },
            "container": {
                "onClick": "onContainerClick"
            }
        },
        "a11y": {
            "jds_action_button": {
                "properties": {
                    "ariaLabel": "headerActionAriaLabel",
                    "ariaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": {
                        "name": "ariaHidden",
                        "value": "true"
                    }
                }
            },
            "results-container": {
                "name": "results",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_result_item": {
                "properties": {
                    "ariaLabel": "results.resultAriaLabel",
                    "ariaDescribedby": "results.resultAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$P = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$T = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$P;
    const { appearance: appearance = "normal", onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaHidden: ariaHidden = "true", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            onAppear: onAppear,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onContainerClick: onContainerClick,
            ariaHidden: ariaHidden,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultsInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$49b46bbe543bdb4b = $fe5170bdd3625759$var$withLogic$P($fe5170bdd3625759$var$Component$T);
$fe5170bdd3625759$export$49b46bbe543bdb4b.displayName = "SearchResultsInternal";
$fe5170bdd3625759$export$49b46bbe543bdb4b.slotName = "jds_search_results_internal";
const $fe5170bdd3625759$var$sdl$O = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-item-1.0.0",
        "name": "JDSSearchResultItem",
        "layerName": "jds_search_result_item"
    },
    "hierarchy": {
        "container": [
            "icon",
            {
                "text-container": [
                    "jds_search_result_text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}",
            "gap": "{s_1}",
            "padding-top": "{s_2}",
            "padding-bottom": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}",
            "behavior": {
                "hover": {
                    "background-color": "{s_6}"
                },
                "active": {
                    "background-color": "{s_7}"
                },
                "focus": {
                    "background-color": "{s_8}"
                }
            }
        },
        "icon": {
            "size": "{s_9}",
            "color": "{s_10}"
        },
        "text-container": {
            "flex-direction": "{s_11}",
            "justify-content": "{s_12}",
            "align-items": "{s_13}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "_splitLabel.label": {
                    "type": "string",
                    "name": "label"
                },
                "_splitLabel.query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "text-container": {
                "value": {
                    "type": "list",
                    "name": "_splitLabel",
                    "object": {
                        "bold": "boolean",
                        "text": "string"
                    }
                }
            },
            "jds_search_result_text": {
                "text": {
                    "type": "string",
                    "name": "_splitLabel.text"
                },
                "bold": {
                    "type": "boolean",
                    "name": "_splitLabel.bold"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$O = (Component)=>(props)=>{
        const { query: query = "", label: label = "", ...rest } = props;
        const index = label.indexOf(query);
        const leftPart = label.slice(0, index);
        const rightPart = label.slice(index + query.length, label.length);
        const labels = index >= 0 ? [
            leftPart,
            query,
            rightPart
        ] : [
            label
        ];
        const _splitLabel = labels.map((l)=>({
                text: l.replace(" ", "\xa0"),
                bold: query === l
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                _splitLabel: _splitLabel,
                ariaLabel: props.ariaLabel || label,
                onClick: ()=>{
                    rest?.onClick?.({
                        label: label,
                        icon: rest.icon,
                        index: rest.internalIndex
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$S = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$O;
    const { onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$56e008c8bd1ccf7c = $fe5170bdd3625759$var$withLogic$O($fe5170bdd3625759$var$Component$S);
$fe5170bdd3625759$export$56e008c8bd1ccf7c.displayName = "SearchResultItem";
$fe5170bdd3625759$export$56e008c8bd1ccf7c.slotName = "jds_search_result_item";
const $fe5170bdd3625759$var$sdl$N = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-text-1.0.0",
        "name": "JDSSearchResultText",
        "layerName": "jds_search_result_text"
    },
    "hierarchy": {
        "jds-text": []
    },
    "base": {
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "variant": {
        "bold": {
            "true": {
                "jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "bold": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$N = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$R = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$N;
    const { bold: bold = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            bold: bold,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultText", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2a7e910d17016306 = $fe5170bdd3625759$var$withLogic$N($fe5170bdd3625759$var$Component$R);
$fe5170bdd3625759$export$2a7e910d17016306.displayName = "SearchResultText";
$fe5170bdd3625759$export$2a7e910d17016306.slotName = "jds_search_result_text";
const $fe5170bdd3625759$var$sdl$M = {
    "metadata": {
        "version": "1.0.0",
        "id": "Segmented-ring-item-1.0.0",
        "name": "JDSSegmentedRingItem",
        "layerName": "jds_segmented_ring_item",
        "internal": true
    },
    "hierarchy": {
        "arc": []
    },
    "base": {
        "arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            }
        },
        "data": {
            "arc": {
                "start": {
                    "type": "number",
                    "name": "startAngle"
                },
                "end": {
                    "type": "number",
                    "name": "endAngle"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$Q = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$M;
    const { size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSegmentedRingItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$28d80c087760154d = $fe5170bdd3625759$var$withLogic$M($fe5170bdd3625759$var$Component$Q);
$fe5170bdd3625759$export$28d80c087760154d.displayName = "SegmentedRingItem";
$fe5170bdd3625759$export$28d80c087760154d.slotName = "jds_segmented_ring_item";
const $fe5170bdd3625759$var$sdl$L = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-button-1.0.0",
        "name": "JDSSelectorButton",
        "layerName": "jds_selector_button",
        "description": "A selector button is an interactive control that allows the user to perform a selection action."
    },
    "hierarchy": {
        "container": [
            "left-icon",
            "jds-text",
            "right-icon"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "border-radius": "{s_4}",
            "padding-bottom": "{s_5}",
            "padding-top": "{s_6}",
            "padding-left": "{s_7}",
            "padding-right": "{s_8}",
            "border-width": "{s_9}",
            "gap": "{s_10}",
            "opacity": "{s_11}",
            "behavior": {
                "hover": {
                    "background-color": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                },
                "focus": {
                    "border-width": "{s_14}",
                    "border-color": "{s_15}"
                }
            }
        },
        "left-icon": {
            "hidden": false,
            "size": "{s_16}",
            "color": "{s_17}",
            "behavior": {
                "hover": {
                    "color": "{s_18}"
                }
            }
        },
        "right-icon": {
            "hidden": true,
            "size": "{s_19}",
            "color": "{s_20}",
            "behavior": {
                "hover": {
                    "color": "{s_21}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_22}"
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "primary": {
                    "true": {
                        "container": {
                            "background-color": "{s_23}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_24}"
                                },
                                "active": {
                                    "background-color": "{s_25}"
                                },
                                "focus": {
                                    "border-color": "{s_26}"
                                }
                            }
                        }
                    },
                    "false": {
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_27}",
                            "border-width": "{s_28}",
                            "border-color": "{s_29}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_30}",
                                    "border-color": "{s_31}"
                                },
                                "active": {
                                    "background-color": "{s_32}"
                                },
                                "focus": {
                                    "border-width": "{s_33}",
                                    "border-color": "{s_34}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_35}"
                        },
                        "right-icon": {
                            "color": "{s_36}"
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_37}",
                            "border-width": "{s_38}",
                            "border-color": "{s_39}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_40}"
                                },
                                "active": {
                                    "background-color": "{s_41}"
                                },
                                "focus": {
                                    "border-width": "{s_42}",
                                    "border-color": "{s_43}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_44}",
                            "behavior": {
                                "active": {
                                    "color": "{s_45}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_46}",
                            "behavior": {
                                "active": {
                                    "color": "{s_47}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_48}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_49}",
                                    "border-color": "{s_50}",
                                    "border-width": "{s_51}"
                                },
                                "active": {
                                    "background-color": "{s_52}"
                                },
                                "focus": {
                                    "border-width": "{s_53}",
                                    "border-color": "{s_54}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_55}",
                            "behavior": {
                                "active": {
                                    "color": "{s_56}"
                                },
                                "hover": {
                                    "color": "{s_57}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_58}",
                            "behavior": {
                                "active": {
                                    "color": "{s_59}"
                                },
                                "hover": {
                                    "color": "{s_60}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                },
                                "hover": {}
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_61}",
                            "behavior": {
                                "hover": {
                                    "border-width": "{s_62}",
                                    "border-color": "{s_63}",
                                    "background-color": "{s_64}"
                                },
                                "active": {
                                    "background-color": "{s_65}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_66}",
                            "behavior": {
                                "active": {
                                    "color": "{s_67}"
                                },
                                "hover": {
                                    "color": "{s_68}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_69}",
                            "behavior": {
                                "active": {
                                    "color": "{s_70}"
                                },
                                "hover": {
                                    "color": "{s_71}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_72}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_73}",
                                    "border-color": "{s_74}"
                                },
                                "hover": {
                                    "background-color": "{s_75}"
                                },
                                "active": {
                                    "background-color": "{s_76}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_77}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_78}"
                                },
                                "active": {
                                    "color": "{s_79}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_80}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_81}"
                                },
                                "active": {
                                    "color": "{s_82}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary70}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_83}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_84}"
                                },
                                "active": {
                                    "background-color": "{s_85}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_86}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_87}"
                                },
                                "active": {
                                    "color": "{s_88}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_89}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_90}"
                                },
                                "active": {
                                    "color": "{s_91}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                }
            },
            "grey_scale": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_92}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_93}"
                                },
                                "active": {
                                    "background-color": "{s_94}"
                                },
                                "focus": {
                                    "border-width": "{s_95}",
                                    "border-color": "{s_96}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_97}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_98}"
                                },
                                "active": {
                                    "color": "{s_99}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_100}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_101}"
                                },
                                "active": {
                                    "color": "{s_102}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                },
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_103}",
                            "border-width": "{s_104}",
                            "border-color": "{s_105}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_106}",
                                    "border-color": "{s_107}"
                                },
                                "active": {
                                    "background-color": "{s_108}"
                                },
                                "focus": {
                                    "border-width": "{s_109}",
                                    "border-color": "{s_110}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_111}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_295}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_112}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_296}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_113}",
                            "border-width": 1,
                            "border-color": "{s_114}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_115}"
                                },
                                "active": {
                                    "background-color": "{s_116}"
                                },
                                "focus": {
                                    "border-width": "{s_117}",
                                    "border-color": "{s_118}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_119}",
                            "behavior": {
                                "active": {
                                    "color": "{s_120}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_121}",
                            "behavior": {
                                "active": {
                                    "color": "{s_122}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_123}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_124}",
                                    "border-width": "{s_125}"
                                },
                                "active": {
                                    "background-color": "{s_126}"
                                },
                                "focus": {
                                    "border-width": "{s_127}",
                                    "border-color": "{s_128}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_129}",
                            "behavior": {
                                "active": {
                                    "color": "{s_130}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_131}",
                            "behavior": {
                                "active": {
                                    "color": "{s_132}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_133}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_134}",
                                    "border-width": "{s_135}",
                                    "background-color": "{s_136}"
                                },
                                "active": {
                                    "background-color": "{s_137}"
                                },
                                "focus": {
                                    "border-width": "{s_138}",
                                    "border-color": "{s_139}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_140}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_141}"
                                },
                                "active": {
                                    "color": "{s_142}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_143}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_144}"
                                },
                                "active": {
                                    "color": "{s_145}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_146}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_147}"
                                },
                                "focus": {
                                    "border-width": "{s_148}",
                                    "border-color": "{s_149}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_150}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_151}"
                                },
                                "active": {
                                    "color": "{s_152}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_153}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_154}"
                                },
                                "active": {
                                    "color": "{s_155}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_156}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_157}"
                                },
                                "focus": {
                                    "border-width": "{s_158}",
                                    "border-color": "{s_159}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_160}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_161}"
                                },
                                "active": {
                                    "color": "{s_162}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_163}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_164}"
                                },
                                "active": {
                                    "color": "{s_165}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_166}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_167}"
                                },
                                "active": {
                                    "background-color": "{s_168}"
                                },
                                "focus": {
                                    "border-width": "{s_169}",
                                    "border-color": "{s_170}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_171}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_172}"
                                },
                                "focus": {
                                    "color": "{s_173}"
                                },
                                "active": {
                                    "color": "{s_174}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_175}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_176}"
                                },
                                "focus": {
                                    "color": "{s_177}"
                                },
                                "active": {
                                    "color": "{s_178}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "hover": {},
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_179}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_180}"
                                },
                                "active": {
                                    "background-color": "{s_181}"
                                },
                                "focus": {
                                    "background-color": "{s_182}",
                                    "border-width": "{s_183}",
                                    "border-color": "{s_184}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_185}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_186}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_187}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_188}"
                                }
                            }
                        },
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_189}",
                            "border-width": "{s_190}",
                            "border-color": "{s_191}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_192}",
                                    "border-color": "{s_193}"
                                },
                                "active": {
                                    "background-color": "{s_194}"
                                },
                                "focus": {
                                    "border-width": "{s_195}",
                                    "border-color": "{s_196}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_197}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_198}"
                                },
                                "active": {
                                    "color": "{s_199}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_200}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_201}"
                                },
                                "active": {
                                    "color": "{s_202}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_203}",
                            "border-width": 1,
                            "border-color": "{s_204}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_205}"
                                },
                                "active": {
                                    "background-color": "{s_206}"
                                },
                                "focus": {
                                    "border-width": "{s_207}",
                                    "border-color": "{s_208}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_209}",
                            "behavior": {
                                "active": {
                                    "color": "{s_210}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_211}",
                            "behavior": {
                                "active": {
                                    "color": "{s_212}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "false": {
                        "container": {
                            "background-color": "{s_213}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_214}",
                                    "border-width": 1,
                                    "border-color": "{s_215}"
                                },
                                "active": {
                                    "background-color": "{s_216}"
                                },
                                "focus": {
                                    "border-width": "{s_217}",
                                    "border-color": "{s_218}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_219}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_220}"
                                },
                                "active": {
                                    "color": "{s_221}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_222}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_223}"
                                },
                                "active": {
                                    "color": "{s_224}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_225}",
                            "behavior": {
                                "hover": {
                                    "border-width": 1,
                                    "border-color": "{s_226}"
                                },
                                "focus": {
                                    "border-width": "{s_227}",
                                    "border-color": "{s_228}"
                                },
                                "active": {
                                    "background-color": "{s_229}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_230}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_231}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_232}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_233}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "background-color": "primary_inverse"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "false": {
                        "container": {
                            "background-color": "{s_234}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_235}",
                                    "border-color": "{s_236}"
                                },
                                "hover": {
                                    "background-color": "{s_237}"
                                },
                                "active": {
                                    "background-color": "{s_238}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_239}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_240}"
                                },
                                "active": {
                                    "color": "{s_241}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_242}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_243}"
                                },
                                "active": {
                                    "color": "{s_244}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {
                                    "color": "{primary30}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_245}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_246}",
                                    "border-color": "{s_247}"
                                },
                                "hover": {
                                    "background-color": "{s_248}"
                                },
                                "active": {
                                    "background-color": "{s_249}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_250}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_251}"
                                },
                                "active": {
                                    "color": "{s_252}"
                                },
                                "focus": {
                                    "color": "{s_253}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_254}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_255}"
                                },
                                "active": {
                                    "color": "{s_256}"
                                },
                                "focus": {
                                    "color": "{s_257}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary30}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {},
                                "focus": {}
                            }
                        }
                    }
                }
            }
        },
        {
            "tertiary_narrow": {
                "small": {
                    "container": {
                        "padding-bottom": "{s_258}",
                        "padding-top": "{s_259}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "medium": {
                    "container": {
                        "padding-bottom": "{s_260}",
                        "padding-top": "{s_261}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "large": {
                    "container": {
                        "padding-bottom": "{s_262}",
                        "padding-top": "{s_263}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-bottom": "{s_264}",
                        "padding-top": "{s_265}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{s_266}",
                        "padding-bottom": "{s_267}"
                    },
                    "left-icon": {
                        "size": "{s_268}"
                    },
                    "right-icon": {
                        "size": "{s_269}"
                    },
                    "jds-text": {}
                },
                "large": {
                    "container": {
                        "padding-top": "{s_270}",
                        "padding-left": "{s_271}",
                        "padding-bottom": "{s_272}",
                        "padding-right": "{s_273}"
                    },
                    "left-icon": {
                        "size": "{s_274}"
                    },
                    "right-icon": {
                        "size": "{s_275}"
                    },
                    "jds-text": {
                        "font-family": "{bodyMBold}",
                        "font-size": "{bodyMBold}",
                        "line-height": "{bodyMBold}",
                        "letter-spacing": "{bodyMBold}",
                        "font-weight": "{bodyMBold}"
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-top": "{s_276}",
                        "padding-right": "{s_277}",
                        "padding-bottom": "{s_278}",
                        "padding-left": "{s_279}"
                    },
                    "left-icon": {
                        "size": "{s_280}"
                    },
                    "right-icon": {
                        "size": "{s_281}"
                    },
                    "jds-text": {
                        "font-family": "{bodyLBold}",
                        "font-size": "{bodyLBold}",
                        "line-height": "{bodyLBold}",
                        "letter-spacing": "{bodyLBold}",
                        "font-weight": "{bodyLBold}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "width": "{s_282}",
                        "height": "{s_283}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_284}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "width": "{s_285}",
                        "height": "{s_286}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "width": "{s_287}",
                        "height": "{s_288}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_289}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra_large": {
                    "container": {
                        "width": "{s_290}",
                        "height": "{s_291}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_292}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "right": {
                    "left-icon": {
                        "hidden": true
                    },
                    "right-icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{s_293}",
                        "justify-content": "{s_294}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind",
            "selected"
        ],
        [
            "kind",
            "size"
        ],
        [
            "_hasText",
            "size"
        ],
        [
            "_hasText",
            "iconPosition"
        ],
        [
            "_hasText",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary",
                    "tertiary_narrow"
                ]
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "grey_scale",
                    "contrast"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra_large"
                ],
                "doc_description": "Sizes of the button"
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SelectorButton."
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$b = (props)=>{
    if (props.size === "extra-large") console.warn("extra-large size is deprecated. use `extra_large`");
    if (props.appearance === "grey-scale") console.warn("grey-scale appearance is deprecated. use `grey_scale`");
    if (props.kind === "tertiary-narrow") console.warn("tertiary-narrow prop of kind is deprecated. Use `tertirary_narrow`");
    return {
        appearance: {
            properties: {
                appearance: props.appearance
            },
            variations: {
                "grey-scale": {
                    appearance: "grey_scale"
                },
                contrast: {
                    appearance: "contrast"
                },
                normal: {
                    appearance: "normal"
                }
            }
        },
        size: {
            properties: {
                size: props.size
            },
            variations: {
                medium: {
                    size: "medium"
                },
                small: {
                    size: "small"
                },
                large: {
                    size: "large"
                },
                "extra-large": {
                    size: "extra_large"
                }
            }
        },
        label: {
            properties: {
                text: props.label
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        icon: {
            properties: {
                icon: props.icon
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            variations: {
                primary: {
                    kind: "primary"
                },
                secondary: {
                    kind: "secondary"
                },
                tertiary: {
                    kind: "tertiary"
                },
                "tertiary-narrow": {
                    kind: "tertiary_narrow"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$L = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$b);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasText: Boolean(props.text?.length || props?.children),
                rootRef: ref
            }
        });
    });
const $fe5170bdd3625759$var$Component$P = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$L;
    const { kind: kind = "primary", iconPosition: iconPosition = "left", appearance: appearance = "normal", size: size = "medium", disabled: disabled = false, selected: selected = false, stretch: stretch = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), _ariaPressed: _ariaPressed = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            iconPosition: iconPosition,
            appearance: appearance,
            size: size,
            disabled: disabled,
            selected: selected,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$880a7f9ee0ea89e0 = $fe5170bdd3625759$var$withLogic$L($fe5170bdd3625759$var$Component$P);
$fe5170bdd3625759$export$880a7f9ee0ea89e0.displayName = "SelectorButton";
$fe5170bdd3625759$export$880a7f9ee0ea89e0.slotName = "jds_selector_button";
const $fe5170bdd3625759$var$sdl$K = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-item-1.0.0",
        "name": "JDSSelectorItem",
        "layerName": "jds_selector_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_0}",
            "background-color": "{s_1}",
            "flex-direction": "{s_2}",
            "align-items": "{s_3}",
            "justify-content": "{s_4}",
            "border-radius": "{s_5}",
            "gap": "{s_6}",
            "padding-top": "{s_7}",
            "padding-right": "{s_8}",
            "padding-bottom": "{s_9}",
            "padding-left": "{s_10}",
            "behavior": {
                "focus": {
                    "background-color": "{s_11}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{s_12}",
                        "color": "{s_13}"
                    }
                },
                "hover": {
                    "background-color": "{s_14}"
                },
                "active": {
                    "background-color": "{s_15}"
                }
            }
        },
        "icon": {
            "size": "{s_16}",
            "color": "{s_17}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primary60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{s_19}"
                        },
                        "active": {
                            "background-color": "{s_20}"
                        },
                        "focus": {
                            "background-color": "{s_21}"
                        }
                    }
                },
                "icon": {
                    "color": "{s_22}",
                    "behavior": {
                        "active": {
                            "color": "{s_23}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {},
                        "active": {
                            "color": "{primary30}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "container": {
                    "flex-direction": "{s_24}",
                    "gap": "{s_27}"
                }
            }
        },
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_25}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "selected"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                selected: props.check || props.selectedIndex === props.internalIndex,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    };
const $fe5170bdd3625759$var$Component$O = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$K;
    const { selected: selected = false, stretch: stretch = false, kind: kind = "label_icon", wrap: wrap = "horizontal", disabled: disabled = false, onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ec8540225d9cc6a2 = $fe5170bdd3625759$var$withLogic$K($fe5170bdd3625759$var$Component$O);
$fe5170bdd3625759$export$ec8540225d9cc6a2.displayName = "SelectorItem";
$fe5170bdd3625759$export$ec8540225d9cc6a2.slotName = "jds_selector_item";
const $fe5170bdd3625759$var$sdl$J = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "layerName": "jds_side_panel_internal",
        "name": "JDSSidePanelInternal",
        "description": "",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "avatar-slot",
                            "header-text-slot"
                        ]
                    },
                    "suffix-jds_action_button"
                ]
            },
            "children-slot",
            {
                "section-container": [
                    "jds_side_panel_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "width": 412,
            "height": "{s_5}",
            "flex-direction": "{s_6}",
            "background-color": "{s_7}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "translate-x": "{size.negativeMax}",
            "transition": {
                "property": [
                    "translate-x"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "section-container": {
            "hidden": true,
            "height": "{s_8}",
            "width": "{s_9}",
            "flex-direction": "{s_10}",
            "justify-content": "{s_11}",
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-top": "{s_14}",
            "padding-right": "{s_15}"
        },
        "header-container": {
            "background-color": "{s_16}",
            "padding-top": "{s_17}",
            "padding-bottom": "{s_18}",
            "padding-right": "{s_19}",
            "padding-left": "{s_20}",
            "width": "{s_21}",
            "justify-content": "{s_22}",
            "align-items": "{s_23}"
        },
        "left-container": {
            "flex-direction": "{s_24}",
            "gap": "{s_25}",
            "align-items": "{s_26}"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "large"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "translate-x": 0,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "direction": {
            "right": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "showClose": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "true": {
                "section-container": {
                    "hidden": false
                },
                "children-slot": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "container": {
                        "width": "{s_28}"
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_29}"
                    }
                }
            },
            "false": {
                "desktop": {
                    "container": {
                        "width": 412
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_30}"
                    }
                }
            }
        },
        {
            "false": {
                "right": {
                    "container": {
                        "translate-x": "{size.max}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "maxWidth",
            "_platform"
        ],
        [
            "open",
            "direction"
        ]
    ],
    "api": {
        "children": {
            "avatar-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_button"
                ],
                "max": 1
            },
            "header-text-slot": {
                "name": "header",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "Has pre-defined suffix as close button."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks."
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "_hasChildren": {
                "values": [
                    false,
                    true
                ]
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "section-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                }
            },
            "jds_side_panel_item": {
                "prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onClose"
            },
            "container": {
                "onClick": "onContainerClick",
                "onSwipeLeft": "onSwipeLeft"
            },
            "jds_side_panel_item": {
                "onSuffixClick": "onSidePanelSuffixClick"
            }
        },
        "a11y": {
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Close Side Panel"
                    }
                }
            },
            "section-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_side_panel_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "itemSuffixAriaLabel": "items.itemSuffixAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$J = (Component)=>(props)=>{
        const { onSwipeLeft: onSwipeLeft, ...rest } = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...rest
        });
    };
const $fe5170bdd3625759$var$Component$N = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$J;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), suffixAriaLabel: suffixAriaLabel = "Close Side Panel", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onContainerClick: onContainerClick,
            onSwipeLeft: onSwipeLeft,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8b5d5577a4deadf6 = $fe5170bdd3625759$var$withLogic$J($fe5170bdd3625759$var$Component$N);
$fe5170bdd3625759$export$8b5d5577a4deadf6.displayName = "SidePanelInternal";
$fe5170bdd3625759$export$8b5d5577a4deadf6.slotName = "jds_side_panel_internal";
const $fe5170bdd3625759$var$sdl$I = {
    "metadata": {
        "version": "1.0.0",
        "id": "spinner-1.0.0",
        "name": "JDSSpinner",
        "layerName": "jds_spinner"
    },
    "hierarchy": {
        "container": [
            {
                "spinner-container": [
                    {
                        "arc-container": [
                            "base-arc",
                            "normal-arc",
                            "third-arc",
                            "second-arc",
                            "first-arc"
                        ]
                    }
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "gap": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "flex-direction": "{s_4}"
        },
        "spinner-container": {
            "size": "{s_5}"
        },
        "arc-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "size": "{s_9}"
        },
        "base-arc": {
            "fill": "{s_10}",
            "radius": "{s_11}",
            "arcWidth": "{s_12}",
            "start": "{s_13}",
            "end": "{s_14}",
            "z-index": 0
        },
        "normal-arc": {
            "fill": "{s_15}",
            "radius": "{s_16}",
            "arcWidth": "{s_17}",
            "start": "{s_18}",
            "end": "{s_19}",
            "z-index": 1,
            "animation-duration": "{s_20}",
            "animate": true
        },
        "first-arc": {
            "hidden": true,
            "fill": "{s_21}",
            "radius": "{s_22}",
            "arcWidth": "{s_23}",
            "start": "{s_24}",
            "end": "{s_25}",
            "z-index": 3,
            "animation-delay": "{s_26}",
            "animation-duration": "{s_27}",
            "animate": true
        },
        "second-arc": {
            "hidden": true,
            "fill": "{s_28}",
            "radius": "{s_29}",
            "arcWidth": "{s_30}",
            "start": "{s_31}",
            "end": "{s_32}",
            "z-index": 2,
            "animation-delay": "{s_33}",
            "animation-duration": "{s_34}",
            "animate": true
        },
        "third-arc": {
            "hidden": true,
            "fill": "{s_35}",
            "radius": "{s_36}",
            "arcWidth": "{s_37}",
            "start": "{s_38}",
            "end": "{s_39}",
            "z-index": 1,
            "animation-duration": "{s_40}",
            "animate": true
        },
        "jds-text": {
            "font-family": "{bodyM}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyM}",
            "line-height": "{bodyM}",
            "letter-spacing": "{bodyM}",
            "font-weight": "{bodyM}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "labelPosition": {
            "bottom": {
                "container": {
                    "flex-direction": "{s_41}"
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "gap": "{s_42}"
                },
                "spinner-container": {
                    "size": "{s_43}"
                },
                "base-arc": {
                    "arcWidth": "{s_44}",
                    "radius": "{s_45}"
                },
                "normal-arc": {
                    "arcWidth": "{s_46}",
                    "radius": "{s_47}"
                },
                "first-arc": {
                    "arcWidth": "{s_48}",
                    "radius": "{s_49}"
                },
                "second-arc": {
                    "arcWidth": "{s_50}",
                    "radius": "{s_51}"
                },
                "third-arc": {
                    "arcWidth": "{s_52}",
                    "radius": "{s_53}"
                },
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "isOverlay": {
            "true": {
                "jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_determinate": {
            "true": {
                "normal-arc": {
                    "animate": false
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "bottom": {
                    "container": {
                        "flex-direction": "{s_55}"
                    }
                }
            }
        },
        {
            "false": {
                "inline": {
                    "normal-arc": {
                        "fill": "{s_54}"
                    }
                },
                "vibrant": {
                    "normal-arc": {
                        "hidden": true
                    },
                    "first-arc": {
                        "hidden": false
                    },
                    "second-arc": {
                        "hidden": false
                    },
                    "third-arc": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "labelPosition"
        ],
        [
            "_determinate",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "labelPosition": {
                "values": [
                    "right",
                    "bottom"
                ],
                "doc_description": "It determines the position of the label. Note: if using a small spinner, the label can only be positioned on the right."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size od Spinner."
            },
            "kind": {
                "values": [
                    "normal",
                    "inline",
                    "vibrant"
                ],
                "doc_description": "It determines the appearance of the spinner .`inline` inherits from text color,`normal`: single color, `vibrant`: three color."
            },
            "isOverlay": {
                "values": [
                    false,
                    true
                ]
            },
            "_determinate": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "normal-arc": {
                "end": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It can be used to take value of spinner from user."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the label of Spinner."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Loading"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-live": {
                        "name": "ariaLive",
                        "value": "polite"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$a = (props)=>({
        appearance: {
            properties: {
                kind: props.appearance
            }
        }
    });
const $fe5170bdd3625759$var$withLogic$I = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$a);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            appearance: props.appearance || "normal",
            ...{
                ...props,
                _determinate: props.value !== void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$M = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$I;
    const { labelPosition: labelPosition = "right", size: size = "medium", kind: kind = "normal", isOverlay: isOverlay = false, ariaLabel: ariaLabel = "Loading", ariaLive: ariaLive = "polite", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            labelPosition: labelPosition,
            size: size,
            kind: kind,
            isOverlay: isOverlay,
            ariaLabel: ariaLabel,
            ariaLive: ariaLive,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSpinner", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7f7cbe89f1eacd2 = $fe5170bdd3625759$var$withLogic$I($fe5170bdd3625759$var$Component$M);
$fe5170bdd3625759$export$7f7cbe89f1eacd2.displayName = "Spinner";
$fe5170bdd3625759$export$7f7cbe89f1eacd2.slotName = "jds_spinner";
const $fe5170bdd3625759$var$sdl$H = {
    "metadata": {
        "name": "JDSStepperDot",
        "version": "1.0.0",
        "layerName": "jds_stepper_dot",
        "description": "Steppers help break a complex task into a series of manageable steps and guides useres through each step of their progress.",
        "usage": "Steppers are used to support new and improve existing processes such as checkout and account application journeys.",
        "internal": true
    },
    "hierarchy": {
        "step-icon-container": [
            "count-jds-text",
            "icon",
            "complete-icon",
            "dot-container"
        ]
    },
    "base": {
        "step-icon-container": {
            "background-color": "{s_0}",
            "border-width": "{s_1}",
            "border-color": "{s_2}",
            "min-height": "{s_3}",
            "min-width": "{s_4}",
            "justify-content": "{s_5}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "show": true
        },
        "icon": {
            "hidden": true,
            "color": "{s_8}",
            "size": "{s_9}"
        },
        "complete-icon": {
            "hidden": true,
            "value": "ic_confirm",
            "color": "{s_10}",
            "size": "{s_11}"
        },
        "dot-container": {
            "hidden": true,
            "background-color": "{s_12}",
            "width": "{s_13}",
            "height": "{s_14}",
            "border-radius": "{s_15}",
            "show": true
        },
        "count-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{sparkleGrey60}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "active": {
                "step-icon-container": {
                    "background-color": "{s_16}",
                    "border-color": "{s_17}"
                },
                "icon": {
                    "color": "{s_18}"
                },
                "dot-container": {
                    "background-color": "{s_19}"
                },
                "count-jds-text": {
                    "color": "{sparkleInverse}"
                }
            },
            "complete": {
                "step-icon-container": {
                    "background-color": "{s_20}",
                    "border-color": "{s_21}"
                },
                "complete-icon": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "disabled": {
                "step-icon-container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        },
        "itemsType": {
            "icon": {
                "dot-container": {
                    "hidden": true
                },
                "step-icon-container": {
                    "height": "{s_22}",
                    "width": "{s_23}"
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "dot": {
                "icon": {
                    "hidden": true
                },
                "dot-container": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "complete": {
                "icon": {
                    "icon": {
                        "hidden": true
                    }
                },
                "dot": {
                    "dot-container": {
                        "hidden": true
                    }
                }
            },
            "active": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            },
            "inactive": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "warning": {
                "active": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_24}"
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                },
                "complete": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_25}"
                    },
                    "complete-icon": {
                        "hidden": true
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "itemsType"
        ],
        [
            "activeState",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ],
                "doc_description": "Represents the type of Stepper indication."
            },
            "activeState": {
                "values": [
                    "normal",
                    "warning"
                ],
                "doc_description": "Devs will set this to show the warning states for active index only."
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true,
                    "doc_description": "Optional icon. Only shows if parent stepper type is icon."
                }
            },
            "count-jds-text": {
                "value": {
                    "type": "string",
                    "name": "index"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$H = (Component)=>(props)=>{
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            index: numeralList[Number(props.index ?? 0)]
        });
    };
const $fe5170bdd3625759$var$Component$L = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$H;
    const { state: state = "inactive", itemsType: itemsType = "numbered", activeState: activeState = "normal", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            activeState: activeState,
            ...rest
        },
        componentTag: componentTag
    }, "JDSStepperDot", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$435f28d5690c41ca = $fe5170bdd3625759$var$withLogic$H($fe5170bdd3625759$var$Component$L);
$fe5170bdd3625759$export$435f28d5690c41ca.displayName = "StepperDot";
$fe5170bdd3625759$export$435f28d5690c41ca.slotName = "jds_stepper_dot";
const $fe5170bdd3625759$var$sdl$G = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-1.0.0",
        "name": "JDSTabBar",
        "layerName": "jds_tab_bar"
    },
    "hierarchy": {
        "container": [
            {
                "tab-container": [
                    "jds_tab_item"
                ]
            },
            {
                "indicator-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_3}",
            "align-items": "{t_4}",
            "width": "{t_1}"
        },
        "indicator-container": {
            "z-index": 1,
            "show": true,
            "width": "{t_2}"
        },
        "tab-container": {
            "width": "{t_5}",
            "opacity": "{t_6}",
            "background-color": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex-direction": "{t_11}"
        },
        "jds_tab_item": {
            "kind": "label_icon",
            "appearance": "normal"
        },
        "outer-container": {
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_15}",
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        },
        "inner-container": {
            "background-color": "{t_17}",
            "border-radius": "{t_16}",
            "height": "{t_18}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "tab-container": {
                    "width": "{t_19}",
                    "justify-content": "{t_20}"
                },
                "jds_tab_item": {
                    "flex": 1
                }
            }
        },
        "kind": {
            "label": {
                "jds_tab_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_item": {
                    "kind": "icon"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "tab-container": {
                    "background-color": "{t_21}",
                    "padding-right": "{t_22}",
                    "padding-left": "{t_23}"
                },
                "jds_tab_item": {
                    "appearance": "tab_bar"
                },
                "inner-container": {
                    "mode": "dark",
                    "background-color": "{t_24}"
                }
            }
        }
    },
    "combination": [
        {
            "mobile": {
                "tab_bar": {
                    "indicator-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    },
                    "tab-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit"
                ]
            },
            "kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "tab-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                }
            },
            "jds_tab_item": {
                "activeTab": {
                    "type": "number",
                    "name": "activeTab"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            }
        },
        "events": {
            "jds_tab_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onChange"
            },
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                },
                "onAppear": {
                    "name": "_onTabAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "tab-container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_tab_item": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$G = (Component)=>(props)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const [activeTabStyles, setActiveTabStyles] = (0, $acw62.useState)({
            _left: void 0,
            _width: void 0
        });
        const calculateStyles = (0, $acw62.useCallback)(()=>{
            const tabContainers = Array.from(element?.querySelectorAll("div.j-JDSTabItem-outer-container") || []);
            const active = tabContainers[props.activeTab || 0];
            setActiveTabStyles({
                _left: active?.offsetLeft,
                _width: active?.offsetWidth
            });
        }, [
            element,
            props.activeTab
        ]);
        (0, $acw62.useEffect)(()=>{
            if (element) {
                calculateStyles();
                const resizeObserver = new ResizeObserver(()=>{
                    calculateStyles();
                });
                element.querySelectorAll("div.j-JDSTabItem-outer-container").forEach((tabContainer)=>{
                    resizeObserver.observe(tabContainer);
                });
                return ()=>{
                    resizeObserver.disconnect();
                };
            }
        }, [
            element,
            calculateStyles
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("resize", calculateStyles);
            return ()=>{
                window.removeEventListener("resize", calculateStyles);
            };
        }, [
            calculateStyles
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _left: activeTabStyles._left,
                _width: activeTabStyles._width
            }
        });
    };
const $fe5170bdd3625759$var$Component$K = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$G;
    const { overflow: overflow = "scroll", kind: kind = "undefined", appearance: appearance = "undefined", onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onScroll: onScroll = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            kind: kind,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabBar", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f97dc4a5a0177256 = $fe5170bdd3625759$var$withLogic$G($fe5170bdd3625759$var$Component$K);
$fe5170bdd3625759$export$f97dc4a5a0177256.displayName = "TabBar";
$fe5170bdd3625759$export$f97dc4a5a0177256.slotName = "jds_tab_bar";
const $fe5170bdd3625759$var$sdl$F = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-item-1.0.0",
        "name": "JDSTabItem",
        "layerName": "jds_tab_item"
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    "icon",
                    "text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "background-color": "{t_0}",
            "flex-direction": "{t_1}",
            "align-items": "{t_2}",
            "justify-content": "{t_3}",
            "min-height": "{t_4}",
            "height": "{t_6}",
            "width": "{t_5}",
            "opacity": "{t_33}",
            "behavior": {
                "hover": {},
                "active": {}
            }
        },
        "container": {
            "flex-direction": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex": 1,
            "padding-top": "{t_11}",
            "padding-bottom": "{t_12}",
            "padding-right": "{t_13}",
            "padding-left": "{t_14}",
            "behavior": {
                "focus": {
                    "border-width": "{t_15}",
                    "border-color": "{t_16}",
                    "border-radius": "{t_17}"
                }
            }
        },
        "text": {
            "color": "{t_22}",
            "font-family": "{t_24}",
            "font-size": "{t_23}",
            "line-height": "{t_26}",
            "letter-spacing": "{t_27}",
            "font-weight": "{t_25}",
            "max-lines": 2,
            "behavior": {
                "hover": {
                    "color": "{t_28}"
                },
                "active": {
                    "color": "{tabitem_base_text_behavior_active_color}"
                }
            }
        },
        "icon": {
            "size": "{t_18}",
            "color": "{t_19}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{t_20}"
                },
                "active": {
                    "color": "{t_21}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "text": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "outer-container": {
                    "disabled": true,
                    "opacity": "{t_34}"
                },
                "container": {
                    "disabled": true
                }
            }
        },
        "appearance": {
            "normal": {
                "text": {
                    "behavior": {
                        "hover": {
                            "color": "{t_35}"
                        },
                        "active": {
                            "color": "{t_36}"
                        }
                    }
                }
            },
            "tab_bar": {
                "container": {
                    "mode": "dark",
                    "behavior": {
                        "active": {
                            "background-color": "{t_37}"
                        },
                        "focus": {
                            "border-color": "{t_38}"
                        }
                    }
                },
                "text": {
                    "color": "{t_42}",
                    "behavior": {
                        "hover": {
                            "color": "{t_43}"
                        },
                        "active": {
                            "color": "{t_44}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_39}",
                    "behavior": {
                        "hover": {
                            "color": "{t_40}"
                        },
                        "active": {
                            "color": "{t_41}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "active": {
                "normal": {
                    "text": {
                        "color": "{t_46}"
                    },
                    "icon": {
                        "color": "{t_45}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active"
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "outer-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                }
            },
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5c2cbe2b2431bcd1$export$e5cf4eff53e7947d), {
            value: {
                mode: props.appearance === "tab_bar" ? "dark" : void 0
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    onClick: ()=>{
                        if (!props.disabled) props.onClick?.(props.internalIndex);
                    },
                    state: props.activeTab === props.internalIndex ? "active" : "default",
                    _ariaSelected: props.activeTab === props.internalIndex
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$J = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$F;
    const { state: state = "inactive", kind: kind = "label_icon", appearance: appearance = "normal", disabled: disabled = false, onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            appearance: appearance,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$17043b9d35150718 = $fe5170bdd3625759$var$withLogic$F($fe5170bdd3625759$var$Component$J);
$fe5170bdd3625759$export$17043b9d35150718.displayName = "TabItem";
$fe5170bdd3625759$export$17043b9d35150718.slotName = "jds_tab_item";
const $fe5170bdd3625759$var$sdl$E = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-body-1.0.0",
        "name": "JDSTableBody",
        "layerName": "jds_table_body",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_row"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_1}"
        },
        "jds_table_row": {}
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_row": {
                    "density": "condensed"
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_2}"
                },
                "jds_table_row": {
                    "flex": 1
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_row": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "function": true
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "zebra": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "rows",
                    "function": true,
                    "object": {
                        "cells": "JDSTableRow.cells"
                    }
                }
            },
            "jds_table_row": {
                "cells": {
                    "name": "rows.cells",
                    "type": "list"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$E = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$I = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$E;
    const { density: density = "undefined", columnDivider: columnDivider = false, fullWidth: fullWidth = false, zebra: zebra = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            zebra: zebra,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableBody", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$76ccd210b9029917 = $fe5170bdd3625759$var$withLogic$E($fe5170bdd3625759$var$Component$I);
$fe5170bdd3625759$export$76ccd210b9029917.displayName = "TableBody";
$fe5170bdd3625759$export$76ccd210b9029917.slotName = "jds_table_body";
const $fe5170bdd3625759$var$sdl$D = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-cell-1.0.0",
        "name": "JDSTableCell",
        "layerName": "jds_table_cell",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "background-color": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-top": "{t_6}",
            "padding-bottom": "{t_7}",
            "border-color": "{t_8}",
            "border-bottom-width": 1,
            "width": "{t_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "padding-left": "{t_10}",
                    "padding-right": "{t_11}",
                    "padding-top": "{t_12}",
                    "padding-bottom": "{t_13}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "container": {
                    "border-color": "{t_14}",
                    "border-right-width": "{t_15}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "true": {
                    "container": {
                        "background-color": "{t_16}",
                        "border-color": "{t_17}",
                        "border-bottom-width": "{t_19}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "color": "{primaryInverse}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                },
                "false": {
                    "container": {
                        "border-bottom-width": "{t_20}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                }
            },
            "cell": {
                "true": {
                    "container": {
                        "background-color": "{t_18}",
                        "border-bottom-width": "{t_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "background"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "type": {
                "values": [
                    "cell",
                    "header"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$D = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "header" ? "columnheader" : "cell"
            }
        });
    };
const $fe5170bdd3625759$var$Component$H = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$D;
    const { type: type = "cell", density: density = "relaxed", background: background = false, columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            density: density,
            background: background,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableCell", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1e4baea7053fc0e3 = $fe5170bdd3625759$var$withLogic$D($fe5170bdd3625759$var$Component$H);
$fe5170bdd3625759$export$1e4baea7053fc0e3.displayName = "TableCell";
$fe5170bdd3625759$export$1e4baea7053fc0e3.slotName = "jds_table_cell";
const $fe5170bdd3625759$var$sdl$C = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-row-1.0.0",
        "name": "JDSTableRow",
        "layerName": "jds_table_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_cell"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "lazy-scroll-android": false,
            "width": "{intrinsicSize.max}"
        },
        "jds_table_cell": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_cell": {
                    "density": "condensed"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_cell": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "cells",
                    "object": {
                        "text": "string",
                        "type": "JDSTableCell.type",
                        "background": "boolean"
                    }
                }
            },
            "jds_table_cell": {
                "label": {
                    "name": "cells.text",
                    "type": "string"
                },
                "type": {
                    "name": "cells.type",
                    "type": "JDSTableCell.type"
                },
                "background": {
                    "name": "cells.background",
                    "type": "boolean"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "row"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$C = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$G = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$C;
    const { density: density = "undefined", columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableRow", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b05581f4e764e162 = $fe5170bdd3625759$var$withLogic$C($fe5170bdd3625759$var$Component$G);
$fe5170bdd3625759$export$b05581f4e764e162.displayName = "TableRow";
$fe5170bdd3625759$export$b05581f4e764e162.slotName = "jds_table_row";
const $fe5170bdd3625759$var$sdl$B = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-desktop-1.0.0",
        "name": "JDSTabsDesktop",
        "platform": "web",
        "layerName": "jds_tabs_desktop",
        "description": "Horizontal scrollable tabs is a navigation  device placed at the top of a page or content area that they relate to and can be separated into smaller groups of related information",
        "usage": "Use this type of tabs to organize related product information on a model landing page."
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    "prev-jds_button",
                    {
                        "tablist-container": [
                            "jds_tab_bar"
                        ]
                    },
                    "next-jds_button"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "width": "{t_1}"
        },
        "jds_tab_bar": {
            "width": "{t_2}",
            "overflow": "scroll",
            "appearance": "normal",
            "kind": "label_icon"
        },
        "header-container": {
            "flex-direction": "{t_3}",
            "width": "{t_4}",
            "align-items": "{t_5}"
        },
        "prev-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "hidden": true
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "hidden": true
        },
        "tablist-container": {
            "width": "{t_6}",
            "overflow": "auto"
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "jds_tab_bar": {
                    "overflow": "fit"
                },
                "tablist-container": {
                    "overflow": "hidden"
                }
            },
            "arrows": {
                "prev-jds_button": {
                    "hidden": false
                },
                "next-jds_button": {
                    "hidden": false
                },
                "header-container": {
                    "gap": "{t_7}"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "jds_tab_bar": {
                    "appearance": "tab_bar"
                },
                "header-container": {
                    "background-color": "{t_8}"
                }
            }
        },
        "_kind": {
            "label": {
                "jds_tab_bar": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_bar": {
                    "kind": "icon"
                }
            }
        },
        "_hideNextBtn": {
            "true": {
                "next-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hidePrevBtn": {
            "true": {
                "prev-jds_button": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit",
                    "arrows"
                ],
                "doc_dscription": "Setting this to true makes the Tab fit the available width."
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "_hideNextBtn": {
                "values": [
                    false,
                    true
                ]
            },
            "_hidePrevBtn": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_tab_bar": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                },
                "activeTab": {
                    "type": "number",
                    "name": "activeTab",
                    "doc_description": "Changes programatically the active tab with animation."
                }
            }
        },
        "events": {
            "jds_tab_bar": {
                "onChange": "onChange",
                "onScroll": "onScroll"
            },
            "prev-jds_button": {
                "onClick": "onPrevClick"
            },
            "next-jds_button": {
                "onClick": "onNextClick"
            }
        },
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ]
            }
        },
        "a11y": {
            "jds_tab_bar": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "prev-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Tab"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Tab"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getOverflow = (props)=>{
    if ([
        "tab-bar",
        "tab_bar"
    ].includes(props.appearance)) {
        if ([
            "arrow",
            "arrows"
        ].includes(props.overflow)) return "scroll";
    }
    return props.overflow;
};
const $fe5170bdd3625759$var$PROP_MAP$9 = (props)=>{
    if (props.appearance === "tab-bar") console.warn("appearance tab-bar is deprecated. Use tab_bar instead");
    if (props.overflow === "arrow") console.warn("overflow arrrow is deprecated. Use arrow instead");
    return {
        appearance: {
            variations: {
                normal: {
                    appearance: "normal"
                },
                "tab-bar": {
                    appearance: "tab_bar"
                }
            }
        },
        overflow: {
            variations: {
                arrow: {
                    overflow: "arrows"
                }
            },
            normal: {
                overflow: "normal"
            }
        }
    };
};
const $fe5170bdd3625759$var$TAB_LIST_CLASS = 'div[data-testid="JDSTabsDesktop-tablist-container"]';
const $fe5170bdd3625759$var$SCROLLABLE_CLASS = ".j-JDSTabBar-tab-container";
const $fe5170bdd3625759$var$withLogic$B = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$9);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.activeTab || 0);
        const items = props.items || props.children?.map((c)=>c.props);
        const tabListElement = element?.querySelector($fe5170bdd3625759$var$TAB_LIST_CLASS);
        const scrollableELement = element?.querySelector($fe5170bdd3625759$var$SCROLLABLE_CLASS);
        const hasIcon = items?.every((i)=>i?.icon);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                items: items,
                rootRef: rootRef,
                _kind: hasIcon ? "label_icon" : "label",
                activeTab: index,
                overflow: $fe5170bdd3625759$var$getOverflow(props),
                onNextClick: ()=>{
                    if (tabListElement && scrollableELement) {
                        const scrollValue = Math.min(tabListElement.scrollWidth, tabListElement.scrollLeft + tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                onPrevClick: ()=>{
                    if (tabListElement) {
                        const scrollValue = Math.max(0, tabListElement.scrollLeft - tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                content: items?.[index]?.children,
                onChange: (i)=>{
                    onClick(i);
                    props.onChange?.(i);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$F = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$B;
    const { overflow: overflow = "scroll", appearance: appearance = "undefined", onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onScroll: onScroll = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrevClick: onPrevClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onNextClick: onNextClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Tab", nextButtonAriaLabel: nextButtonAriaLabel = "Next Tab", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            onPrevClick: onPrevClick,
            onNextClick: onNextClick,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabsDesktop", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b2539bed5023c21c = $fe5170bdd3625759$var$withLogic$B($fe5170bdd3625759$var$Component$F);
$fe5170bdd3625759$export$b2539bed5023c21c.displayName = "Tabs";
$fe5170bdd3625759$export$b2539bed5023c21c.slotName = "jds_tabs_desktop";
const $fe5170bdd3625759$var$sdl$A = {
    "metadata": {
        "version": "1.0.0",
        "id": "tag-1.0.0",
        "name": "JDSTag",
        "layerName": "jds_tag",
        "description": "Tags are keywords used to describe, categorize, or filter content.",
        "usage": "Use tags when content is mapped to multiple categories, and the user needs a way to differentiate between them."
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "display": "flex",
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "padding-top": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-bottom": "{t_6}",
            "gap": "{t_7}",
            "background-color": "{t_8}",
            "border-radius": "{t_9}",
            "border-width": "{t_10}",
            "border-color": "{t_11}",
            "opacity": "{t_30}",
            "behavior": {
                "active": {
                    "border-color": "{t_13}"
                },
                "focus": {
                    "border-color": "{t_14}",
                    "border-width": "{t_15}"
                },
                "hover": {
                    "border-color": "{t_12}"
                }
            }
        },
        "icon": {
            "hidden": true,
            "size": "{t_16}",
            "color": "{t_17}",
            "behavior": {
                "hover": {
                    "color": "{t_18}"
                },
                "active": {
                    "color": "{t_19}"
                },
                "focus": {
                    "color": "{t_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": false,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{sparkle80}"
                },
                "active": {
                    "color": "{sparkle80}"
                },
                "focus": {
                    "color": "{sparkle80}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "container": {
                    "padding-top": "{t_31}",
                    "padding-left": "{t_32}",
                    "padding-right": "{t_33}",
                    "padding-bottom": "{t_34}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "kind": {
            "filter": {
                "icon": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "background-color": "{t_23}",
                    "border-width": "{t_21}",
                    "border-color": "{t_22}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_24}"
                        },
                        "active": {
                            "background-color": "{t_25}",
                            "border-color": "{t_26}",
                            "border-width": 1
                        },
                        "focus": {
                            "background-color": "{t_27}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_28}",
                    "value": "ic_close"
                },
                "jds-text": {
                    "color": "{sparkle80}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{t_29}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tag."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size of Tag."
            },
            "kind": {
                "values": [
                    "toggle",
                    "filter"
                ],
                "doc_description": "It can be used to switch between 2 variants of Tag."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Tag."
            },
            "active": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to activate Tag."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$A = (Component)=>(props)=>{
        const { selected: selected, toggle: toggle } = $fe5170bdd3625759$var$useToggle(props.active, props.kind !== "normal", props.onClick);
        const icon = selected ? "IcClose" : typeof props.icon === "string" ? props.icon : "IcAdd";
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: toggle,
                active: selected,
                icon: icon
            }
        });
    };
const $fe5170bdd3625759$var$Component$E = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$A;
    const { size: size = "medium", kind: kind = "toggle", disabled: disabled = false, active: active = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPressed: _ariaPressed = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            active: active,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTag", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3288d34c523a1192 = $fe5170bdd3625759$var$withLogic$A($fe5170bdd3625759$var$Component$E);
$fe5170bdd3625759$export$3288d34c523a1192.displayName = "Tag";
$fe5170bdd3625759$export$3288d34c523a1192.slotName = "jds_tag";
const $fe5170bdd3625759$var$sdl$z = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToast",
        "layerName": "jds_toast"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{t_0}",
            "max-width": "{t_1}",
            "border-radius": "{t_2}",
            "background-color": "{t_3}",
            "flex-direction": "{t_4}",
            "gap": "{t_5}",
            "padding-top": "{t_6}",
            "padding-right": "{t_7}",
            "padding-bottom": "{t_8}",
            "padding-left": "{t_9}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{t_10}",
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_11}"
        },
        "center-container": {
            "flex-direction": "{t_15}",
            "justify-content": "{t_16}",
            "align-items": "{t_17}",
            "gap": "{t_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "gap": "{t_20}",
            "flex-direction": "{t_21}",
            "justify-content": "{t_22}",
            "width": "{t_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{t_23}"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{t_24}"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.max}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Toast when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Toast"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "dismissAfter"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Toast."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Toast."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeDown": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Component$D = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$z;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onUpdate: onUpdate = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onUpdate: onUpdate,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToast", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Toast = $fe5170bdd3625759$var$withLogic$W($fe5170bdd3625759$var$Component$D);
$fe5170bdd3625759$var$Toast.displayName = "Toast";
$fe5170bdd3625759$var$Toast.slotName = "jds_toast";
const $fe5170bdd3625759$var$sdl$y = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltip",
        "layerName": "jds_tooltip",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_tooltip_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "passive": true,
            "hidden": true,
            "priority": 30
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}"
        },
        "jds_tooltip_internal": {}
    },
    "variant": {
        "position": {
            "right_start": {
                "jds_tooltip_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_tooltip_internal": {
                    "position": "right_end"
                }
            },
            "left": {
                "jds_tooltip_internal": {
                    "position": "left"
                }
            },
            "left_start": {
                "jds_tooltip_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_tooltip_internal": {
                    "position": "left_end"
                }
            },
            "top": {
                "jds_tooltip_internal": {
                    "position": "top"
                }
            },
            "top_start": {
                "jds_tooltip_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_tooltip_internal": {
                    "position": "top_end"
                }
            },
            "bottom": {
                "jds_tooltip_internal": {
                    "position": "bottom"
                }
            },
            "bottom_start": {
                "jds_tooltip_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_tooltip_internal": {
                    "position": "bottom_end"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds_tooltip_internal": {
                    "_platform": "desktop"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to progamtically open and close Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "jds_tooltip_internal": {
                "label": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                },
                "triggerSpacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_tooltip_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            },
            "popup": {
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_tooltip_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$calculateOffsets(position, anchorRect, tooltipRect, gap) {
    let offsetX = "";
    let offsetY = "";
    const halfAnchorWidth = anchorRect.width / 2;
    const halfAnchorHeight = anchorRect.height / 2;
    const halfTooltipWidth = tooltipRect.width / 2;
    const halfTooltipHeight = tooltipRect.height / 2;
    const tipSize = 24;
    const tipSpace = 4;
    const verticalCenterX = anchorRect.left + halfAnchorWidth - halfTooltipWidth;
    const verticalEndX = anchorRect.right - tooltipRect.width - tipSpace;
    const verticalStartX = anchorRect.left + halfAnchorWidth - tipSize + tipSpace;
    const horizontalCenterY = anchorRect.top + halfAnchorHeight - halfTooltipHeight;
    const horizontalEndY = anchorRect.bottom - tooltipRect.height - tipSpace;
    const horizontalStartY = anchorRect.top + halfAnchorHeight - tipSize + tipSpace;
    const bottomY = anchorRect.bottom + gap;
    const topY = anchorRect.top - tooltipRect.height - gap;
    const leftX = anchorRect.left - tooltipRect.width - gap;
    const rightX = anchorRect.right + gap;
    switch(position){
        case "bottom":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "top":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${topY}px`;
            break;
        case "left":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "left_end":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "left_start":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
        case "right":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "right_end":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "right_start":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
    }
    return {
        offsetX: offsetX,
        offsetY: offsetY
    };
}
const $fe5170bdd3625759$var$SPACE_AVAILABILITY_ORDER = {
    bottom_start: [
        "top_start",
        "bottom",
        "bottom_end",
        "top",
        "top_end"
    ],
    bottom_end: [
        "top_end",
        "bottom",
        "bottom_start",
        "top",
        "top_start"
    ],
    top_start: [
        "bottom_start",
        "top",
        "top_end",
        "bottom",
        "bottom_end"
    ],
    top_end: [
        "bottom_end",
        "top",
        "top_start",
        "bottom",
        "bottom_start"
    ],
    right_end: [
        "left_end",
        "right",
        "right_start",
        "left",
        "left_start"
    ],
    right_start: [
        "left_start",
        "right",
        "right_end",
        "left",
        "left_end"
    ],
    left_end: [
        "right_end",
        "left",
        "left_start",
        "right",
        "right_start"
    ],
    left_start: [
        "right_start",
        "left",
        "left_end",
        "right",
        "right_end"
    ],
    top: [
        "bottom",
        "top_start",
        "top_end",
        "bottom_start",
        "bottom_end"
    ],
    bottom: [
        "top",
        "bottom_start",
        "bottom_end",
        "top_start",
        "top_end"
    ],
    left: [
        "right",
        "left_start",
        "left_end",
        "right_start",
        "right_end"
    ],
    right: [
        "left",
        "right_start",
        "right_end",
        "left_start",
        "left_end"
    ]
};
function $fe5170bdd3625759$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap) {
    const { offsetX: offsetX, offsetY: offsetY } = $fe5170bdd3625759$var$calculateOffsets(position, anchorRect, tooltipRect, gap);
    const positionX = parseInt(offsetX);
    const positionY = parseInt(offsetY);
    const { right: right, bottom: bottom } = tooltipRect;
    const { innerWidth: screenWidth, innerHeight: screenHeight } = window;
    switch(position){
        case "top":
            return positionY > 0 && positionX > 0 && right < screenWidth;
        case "top_start":
            return positionY > 0 && right < screenWidth;
        case "top_end":
            return positionY > 0 && positionX > 0;
        case "right_start":
            return bottom < screenHeight && right < screenWidth;
        case "right_end":
            return positionY > 0 && right < screenWidth;
        case "right":
            return positionY > 0 && bottom < screenHeight && right < screenWidth;
        case "bottom_start":
            return bottom < screenHeight && right < screenWidth;
        case "bottom_end":
            return bottom < screenHeight && positionX > 0;
        case "bottom":
            return bottom < screenHeight && positionX > 0 && right < screenWidth;
        case "left_start":
            return bottom < screenHeight && positionX > 0;
        case "left_end":
            return positionY > 0 && positionX > 0;
        case "left":
            return bottom < screenHeight && positionY > 0 && positionX > 0;
        default:
            return true;
    }
}
function $fe5170bdd3625759$var$getFlippedPosition(position, anchorRect, tooltipRect, gap) {
    if ($fe5170bdd3625759$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap)) return position;
    const alternativePosition = $fe5170bdd3625759$var$SPACE_AVAILABILITY_ORDER[position].find((alternativePosition2)=>{
        return $fe5170bdd3625759$var$isTooltipPositionFit(alternativePosition2, anchorRect, tooltipRect, gap);
    });
    return alternativePosition || position;
}
const $fe5170bdd3625759$var$LONG_PRESS_DELAY = 1e3;
const $fe5170bdd3625759$var$SUSTAIN_TIME = 3e3;
const $fe5170bdd3625759$var$getPosition = (anchor, tooltip, position = "right", TIP_OFFSET = $fe5170bdd3625759$var$Devices.isTablet() ? 20 : 8, isDesktop)=>{
    if (anchor && tooltip) {
        const anchorRect = anchor.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const resolvedOffset = typeof TIP_OFFSET === "string" ? parseInt(TIP_OFFSET.replace("px", "")) : TIP_OFFSET;
        const maxOffset = isDesktop ? 8 : 20;
        const clampedffset = (0, $5c2cbe2b2431bcd1$export$7d15b64cf5a3a4c4)(resolvedOffset, 0, maxOffset);
        const currentPosition = $fe5170bdd3625759$var$getFlippedPosition(position, anchorRect, tooltipRect, clampedffset);
        const { offsetX: offsetX, offsetY: offsetY } = $fe5170bdd3625759$var$calculateOffsets(currentPosition, anchorRect, tooltipRect, clampedffset);
        return {
            offsetX: offsetX.replace("px", ""),
            offsetY: offsetY.replace("px", ""),
            newPosition: currentPosition
        };
    }
    return {
        offsetX: 0,
        offsetY: 0
    };
};
const $fe5170bdd3625759$var$legacyTooltipPositions = [
    "right-start",
    "right-end",
    "bottom-start",
    "bottom-end",
    "left-start",
    "left-end",
    "top-start",
    "top-end"
];
const $fe5170bdd3625759$var$PROP_MAP$8 = (props)=>{
    if ($fe5170bdd3625759$var$legacyTooltipPositions.includes(props.position)) console.warn("these values for the position prop are deprecated", $fe5170bdd3625759$var$legacyTooltipPositions);
    return {
        position: {
            variations: {
                "right-start": {
                    position: "right_start"
                },
                "left-start": {
                    position: "left_start"
                },
                "bottom-start": {
                    position: "bottom_start"
                },
                "top-start": {
                    position: "top_start"
                },
                "left-end": {
                    position: "left_end"
                },
                "right-end": {
                    position: "right_end"
                },
                "top-end": {
                    position: "top_end"
                },
                "bottom-end": {
                    position: "bottom_end"
                },
                left: {
                    position: "left"
                },
                right: {
                    position: "right"
                },
                top: {
                    position: "top"
                },
                bottom: {
                    position: "bottom"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$z = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$8);
        const { children: children, ...rest } = props;
        const ref = (0, $acw62.useRef)(null);
        const { toggle: toggle, selected: selected, close: close } = $fe5170bdd3625759$var$useToggle(props.open);
        const [element, setElement] = (0, $acw62.useState)(null);
        const triggerRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { desktop: desktop } = $fe5170bdd3625759$var$Devices.useMedia();
        const { offsetX: offsetX, offsetY: offsetY, newPosition: newPosition } = $fe5170bdd3625759$var$getPosition(ref.current, element, rest.position, props.triggerSpacing, desktop);
        const timerRef = (0, $acw62.useRef)();
        const isTouchActive = (0, $acw62.useRef)(false);
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        offsetX: offsetX,
                        offsetY: offsetY,
                        _platform: $fe5170bdd3625759$var$getPlatform(),
                        width: "300px",
                        position: newPosition || props.position,
                        open: Boolean(selected),
                        triggerRef: triggerRef
                    }
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    onMouseEnter: ()=>{
                        if (!(window && "ontouchstart" in window)) toggle();
                    },
                    onMouseLeave: close,
                    onTouchStart: ()=>{
                        if (window && "ontouchstart" in window && $fe5170bdd3625759$var$Devices.isMobile()) {
                            isTouchActive.current = true;
                            timerRef.current = setTimeout(toggle, $fe5170bdd3625759$var$LONG_PRESS_DELAY);
                        }
                    },
                    onTouchEnd: ()=>{
                        if ($fe5170bdd3625759$var$Devices.isMobile()) {
                            isTouchActive.current = false;
                            if (selected) setTimeout(close, $fe5170bdd3625759$var$SUSTAIN_TIME);
                            else if (timerRef.current) clearTimeout(timerRef.current);
                        }
                    },
                    ref: ref,
                    style: {
                        width: "fit-content"
                    },
                    children: children
                })
            ]
        });
    };
const $fe5170bdd3625759$var$Component$C = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$y;
    const { position: position = "right", open: open = false, onTextLayout: onTextLayout = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onHover: onHover = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            open: open,
            onTextLayout: onTextLayout,
            onHover: onHover,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltip", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$28c660c63b792dea = $fe5170bdd3625759$var$withLogic$z($fe5170bdd3625759$var$Component$C);
$fe5170bdd3625759$export$28c660c63b792dea.displayName = "Tooltip";
$fe5170bdd3625759$export$28c660c63b792dea.slotName = "jds_tooltip";
const $fe5170bdd3625759$var$sdl$x = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltipInternal",
        "layerName": "jds_tooltip_internal",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user.",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            "start-tooltip",
            {
                "text-container": [
                    "jds-text"
                ]
            },
            "end-tooltip"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{t_3}",
            "justify-content": "{t_4}",
            "align-items": "{t_5}",
            "overflow": "{tooltip_base_root-container-overflow}"
        },
        "text-container": {
            "border-radius": "{t_7}",
            "border-width": "{t_8}",
            "background-color": "{t_9}",
            "padding-left": "{t_12}",
            "padding-right": "{t_13}",
            "padding-top": "{t_14}",
            "padding-bottom": "{t_15}",
            "min-height": "{t_40}",
            "align-items": "{t_41}"
        },
        "start-tooltip": {
            "color": "{t_10}",
            "position": "right",
            "hidden": false
        },
        "end-tooltip": {
            "color": "{t_11}",
            "position": "right",
            "hidden": true
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryBackground}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "position": {
            "right_start": {
                "root-container": {
                    "align-items": "{t_16}"
                },
                "start-tooltip": {
                    "position": "right_start",
                    "padding-top": "{t_17}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "right_end": {
                "root-container": {
                    "align-items": "{t_18}"
                },
                "start-tooltip": {
                    "position": "right_end",
                    "padding-bottom": "{t_19}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "left": {
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left",
                    "hidden": false
                }
            },
            "left_start": {
                "root-container": {
                    "align-items": "{t_20}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_start",
                    "padding-top": "{t_21}",
                    "hidden": false
                }
            },
            "left_end": {
                "root-container": {
                    "align-items": "{t_22}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_end",
                    "padding-bottom": "{t_23}",
                    "hidden": false
                }
            },
            "top": {
                "root-container": {
                    "flex-direction": "{t_24}",
                    "align-items": "{t_25}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top",
                    "hidden": false
                }
            },
            "top_start": {
                "root-container": {
                    "flex-direction": "{t_26}",
                    "align-items": "{t_27}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_start",
                    "padding-left": "{t_28}",
                    "hidden": false
                }
            },
            "top_end": {
                "root-container": {
                    "flex-direction": "{t_29}",
                    "align-items": "{t_30}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_end",
                    "padding-right": "{t_31}",
                    "hidden": false
                }
            },
            "bottom": {
                "root-container": {
                    "flex-direction": "{t_32}",
                    "align-items": "{t_33}"
                },
                "start-tooltip": {
                    "position": "bottom",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_start": {
                "root-container": {
                    "flex-direction": "{t_34}",
                    "align-items": "{t_35}"
                },
                "start-tooltip": {
                    "padding-left": "{t_36}",
                    "position": "bottom_start",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_end": {
                "root-container": {
                    "flex-direction": "{t_37}",
                    "align-items": "{t_38}"
                },
                "start-tooltip": {
                    "position": "bottom_end",
                    "padding-right": "{t_39}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "root-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "max-width": {
                    "type": "size",
                    "name": "width"
                },
                "spacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds-text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "tooltip"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$B = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$x;
    const { position: position = "right", onAppear: onAppear = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onTextLayout: onTextLayout = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            onAppear: onAppear,
            onTextLayout: onTextLayout,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltipInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d8d56a9a74e44761 = $fe5170bdd3625759$var$withLogic$y($fe5170bdd3625759$var$Component$B);
$fe5170bdd3625759$export$d8d56a9a74e44761.displayName = "TooltipInternal";
$fe5170bdd3625759$export$d8d56a9a74e44761.slotName = "jds_tooltip_internal";
const $fe5170bdd3625759$var$sdl$w = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-vertical-step-item-1.0.0",
        "name": "JDSVerticalStepItem",
        "layerName": "jds_vertical_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "step-dot-container": [
                    "jds_stepper_dot",
                    "label-jds-text"
                ]
            },
            {
                "step-indicator-container": [
                    "end-jds_divider",
                    {
                        "content-container": [
                            {
                                "content-child-container": [
                                    "content-slot"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "gap": "{v_3}",
            "size": "{v_4}"
        },
        "end-container": {
            "hidden": false,
            "flex": 1,
            "opacity": "{v_5}"
        },
        "content-child-container": {
            "flex-direction": "{v_6}",
            "justify-content": "{v_7}",
            "align-items": "{v_8}",
            "hidden": false
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "orientation": "vertical"
        },
        "step-indicator-container": {
            "height": "{v_9}",
            "flex-direction": "{v_10}",
            "justify-content": "{v_11}",
            "align-items": "{v_12}",
            "padding-left": 15,
            "min-height": "{v_13}"
        },
        "step-dot-container": {
            "flex-direction": "{v_15}",
            "justify-content": "{v_16}",
            "align-items": "{v_17}",
            "gap": "{v_18}"
        },
        "content-container": {
            "padding-top": "{v_19}",
            "padding-left": 31,
            "padding-bottom": "{v_20}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top",
                    "padding-bottom"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "variant": {
        "_hideChild": {
            "true": {
                "content-container": {
                    "hidden": false,
                    "padding-top": "{verticalstepitem_variant__hideChild_true_content-container_padding-top}",
                    "padding-bottom": "{verticalstepitem_variant__hideChild_true_content-container_padding-bottom}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{v_24}"
                }
            }
        }
    },
    "api": {
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            },
            "_hideChild": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "content-container": {
                "max-height": {
                    "name": "_contentHeight",
                    "type": "size"
                }
            },
            "label-jds-text": {
                "value": {
                    "name": "label",
                    "type": "string"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$x = (Component)=>(props)=>{
        const active = props.state === "active";
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _hideChild: active,
                _contentHeight: active ? element?.querySelector('div[data-testid="JDSVerticalStepItem-content-container"]')?.scrollHeight : 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$A = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$w;
    const { state: state = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSVerticalStepItem", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c4bee818be0dfd5a = $fe5170bdd3625759$var$withLogic$x($fe5170bdd3625759$var$Component$A);
$fe5170bdd3625759$export$c4bee818be0dfd5a.displayName = "VerticalStepItem";
$fe5170bdd3625759$export$c4bee818be0dfd5a.slotName = "jds_vertical_step_item";
const $fe5170bdd3625759$var$v1Map = {
    jds_text: ()=>$fe5170bdd3625759$export$5f1af8db9871e1d6,
    jds_tag: ()=>$fe5170bdd3625759$export$3288d34c523a1192,
    jds_icon: ()=>$fe5170bdd3625759$export$f04a61298a47a40f,
    jds_skeleton: ()=>$fe5170bdd3625759$export$8f31e4c4a37b8e9c,
    jds_badge: ()=>$fe5170bdd3625759$export$37acb3580601e69a,
    jds_toast: ()=>$fe5170bdd3625759$var$Toast,
    jds_nudge: ()=>$fe5170bdd3625759$var$Nudge,
    jds_fab: ()=>$fe5170bdd3625759$export$72beae6a392d0fc6,
    jds_fab_internal: ()=>$fe5170bdd3625759$export$f3670f01e3026458,
    jds_selector_item: ()=>$fe5170bdd3625759$export$ec8540225d9cc6a2,
    jds_table_cell: ()=>$fe5170bdd3625759$export$1e4baea7053fc0e3,
    jds_table_row: ()=>$fe5170bdd3625759$export$b05581f4e764e162,
    jds_table_body: ()=>$fe5170bdd3625759$export$76ccd210b9029917,
    jds_selector_button: ()=>$fe5170bdd3625759$export$880a7f9ee0ea89e0,
    jds_menu_block_item: ()=>$fe5170bdd3625759$export$3789e0cd450be8da,
    jds_notification_button: ()=>$fe5170bdd3625759$var$NotificationButton,
    jds_action_button: ()=>$fe5170bdd3625759$export$cfc7921d29ef7b80,
    jds_tab_item: ()=>$fe5170bdd3625759$export$17043b9d35150718,
    jds_feedback_block: ()=>$fe5170bdd3625759$var$FeedbackBlock,
    jds_link: ()=>$fe5170bdd3625759$export$a6c7ac8248d6e38a,
    jds_bottom_footer_link_item: ()=>$fe5170bdd3625759$export$b592413d575db486,
    jds_bottom_sheet: ()=>$fe5170bdd3625759$export$2058ef1a26004a97,
    jds_desktop_bottom_sheet_internal: ()=>$fe5170bdd3625759$export$a20173db319b8774,
    jds_mobile_bottom_sheet_internal: ()=>$fe5170bdd3625759$export$9ac5eac5233c654,
    jds_divider: ()=>$fe5170bdd3625759$export$2e0a83ec2e27ecbb,
    jds_image: ()=>$fe5170bdd3625759$export$3e431a229df88919,
    jds_footer_links: ()=>$fe5170bdd3625759$export$553910ef0cc96026,
    jds_footer_icon_links: ()=>$fe5170bdd3625759$export$ce48424ab2a5a45,
    jds_footer_market_links: ()=>$fe5170bdd3625759$export$4e70d4e1c9ec4c90,
    jds_footer_links_grid: ()=>$fe5170bdd3625759$export$e5275d44ac937bc0,
    jds_bottom_footer: ()=>$fe5170bdd3625759$export$72ab4ebd04fea6e2,
    jds_content_block: ()=>$fe5170bdd3625759$export$eb38b3b9c7f5f31b,
    jds_search_result_item: ()=>$fe5170bdd3625759$export$56e008c8bd1ccf7c,
    jds_search_results_internal: ()=>$fe5170bdd3625759$export$49b46bbe543bdb4b,
    jds_avatar: ()=>$fe5170bdd3625759$export$e2255cf6045e8d47,
    jds_segmented_ring_item: ()=>$fe5170bdd3625759$export$28d80c087760154d,
    jds_avatar_v2: ()=>$fe5170bdd3625759$export$ac4313c0728f5b84,
    jds_avatar_v2_segmented_ring: ()=>$fe5170bdd3625759$export$9b02a99b26bc2fb,
    jds_avatar_v2_progress_ring: ()=>$fe5170bdd3625759$export$add0715ef3cff303,
    jds_avatar_v2_complete_ring: ()=>$fe5170bdd3625759$export$70f728d68d57ace9,
    jds_avatar_v2_default: ()=>$fe5170bdd3625759$export$4860988e9a471058,
    jds_avatar_v2_information: ()=>$fe5170bdd3625759$export$dbc79143cb6c67cb,
    jds_avatar_v2_status: ()=>$fe5170bdd3625759$export$6c44d71f4e8d3278,
    jds_avatar_v2_notification: ()=>$fe5170bdd3625759$export$c906bb7932dd69e9,
    jds_button: ()=>$fe5170bdd3625759$export$353f5b6fc5456de1,
    jds_accordion: ()=>$fe5170bdd3625759$export$7cad6f17fd6e117b,
    jds_mega_menu_item: ()=>$fe5170bdd3625759$export$cc2d7d7492914f14,
    jds_mega_menu_block: ()=>$fe5170bdd3625759$export$5e96c1cbae381c93,
    jds_search_box: ()=>$fe5170bdd3625759$export$5a58787633b0b5d8,
    jds_modal_desktop_internal: ()=>$fe5170bdd3625759$export$3e0ada2dd34546e6,
    jds_modal_mobile_internal: ()=>$fe5170bdd3625759$export$e70e9b240ff3bbbf,
    jds_modal_desktop: ()=>$fe5170bdd3625759$export$2b77a92f1a5ad772,
    jds_side_panel_item: ()=>$fe5170bdd3625759$export$500ae19c14a3c46,
    jds_side_panel_internal: ()=>$fe5170bdd3625759$export$8b5d5577a4deadf6,
    jds_header: ()=>$fe5170bdd3625759$export$8b251419efc915eb,
    jds_mega_menu: ()=>$fe5170bdd3625759$export$aee42d298194d478,
    jds_bottom_navigation_item: ()=>$fe5170bdd3625759$export$f5e7567009f715b2,
    jds_bottom_navigation2: ()=>BottomNavigation2,
    jds_carousel_pagination_item: ()=>$fe5170bdd3625759$var$CarouselPaginationItem,
    jds_carousel_pagination: ()=>$fe5170bdd3625759$var$CarouselPagination,
    jds_carousel_slide: ()=>$fe5170bdd3625759$export$cabb5ccfbd60cbd4,
    jds_datepicker_button: ()=>$fe5170bdd3625759$export$395dd20d84297b30,
    jds_datepicker_calendar_button: ()=>$fe5170bdd3625759$export$2d81f864fd880f98,
    jds_datepicker_view_button: ()=>$fe5170bdd3625759$export$99c3540c4320b145,
    jds_datepicker_calendar_row: ()=>$fe5170bdd3625759$export$703dfd9521d4b08a,
    jds_datepicker_calendar: ()=>$fe5170bdd3625759$export$cfdbf347b14a0a8d,
    jds_datepicker_year_view: ()=>$fe5170bdd3625759$export$59892f17b1991230,
    jds_datepicker_calendar_header: ()=>$fe5170bdd3625759$export$2d5e85746b19c19b,
    jds_datepicker_header: ()=>$fe5170bdd3625759$export$4677d90cce08ec53,
    jds_datepicker_month_view: ()=>$fe5170bdd3625759$export$df8c284ffe0bf6ce,
    jds_dropdown_menu_item: ()=>$fe5170bdd3625759$export$ed97964d1871885d,
    jds_dropdown_menu_group: ()=>$fe5170bdd3625759$export$246bebaba3a2f70e,
    jds_dropdown_menu: ()=>$fe5170bdd3625759$export$e44a253a59704894,
    jds_dropdown_menu_submenu: ()=>$fe5170bdd3625759$export$51cd9091d2dcc10a,
    jds_dropdown_menu_sub_menu_internal: ()=>$fe5170bdd3625759$export$897b7938c608ac58,
    jds_dropdown_menu_internal: ()=>$fe5170bdd3625759$export$5a9d97cdadce1b72,
    jds_pagination_button: ()=>$fe5170bdd3625759$export$c3639e97caabff2c,
    jds_datepicker: ()=>$fe5170bdd3625759$export$5109c6dd95d8fb00,
    jds_datepicker_desktop_internal: ()=>$fe5170bdd3625759$export$1f2289af8fea154d,
    jds_datepicker_mobile_internal: ()=>$fe5170bdd3625759$export$1f2289af8fea154d,
    jds_menu_block: ()=>$fe5170bdd3625759$export$3a7690908a5e9b5,
    jds_menu_block_internal: ()=>$fe5170bdd3625759$export$f9b98c24bc73aa75,
    jds_list_block: ()=>$fe5170bdd3625759$export$7c8f337671b808e4,
    jds_input: ()=>$fe5170bdd3625759$var$Input,
    jds_input_code_item: ()=>$fe5170bdd3625759$export$963da1aad44be4c4,
    jds_tab_bar: ()=>$fe5170bdd3625759$export$f97dc4a5a0177256,
    jds_search_results: ()=>$fe5170bdd3625759$export$aee53da69e9839be,
    jds_search_result_text: ()=>$fe5170bdd3625759$export$2a7e910d17016306,
    jds_stepper_dot: ()=>$fe5170bdd3625759$export$435f28d5690c41ca,
    jds_step_item_vertical: ()=>$fe5170bdd3625759$export$c4bee818be0dfd5a,
    jds_step_item_horizontal: ()=>$fe5170bdd3625759$export$210661c11db5ef0f,
    jds_spinner: ()=>$fe5170bdd3625759$export$7f7cbe89f1eacd2,
    jds_tooltip: ()=>$fe5170bdd3625759$export$28c660c63b792dea,
    jds_tooltip_internal: ()=>$fe5170bdd3625759$export$d8d56a9a74e44761,
    jds_checkbox: ()=>$fe5170bdd3625759$export$fa1253a65a9e747d,
    swadesh_checkbox: ()=>$fe5170bdd3625759$export$fa1253a65a9e747d,
    swadesh_text: ()=>$fe5170bdd3625759$export$5f1af8db9871e1d6,
    jds_rating_bar_item: ()=>$fe5170bdd3625759$export$b473c78e8d3557fd,
    jds_file_uploader_control: ()=>$fe5170bdd3625759$export$2548bc68b9cf13da,
    jds_file_uploader_panel: ()=>$fe5170bdd3625759$export$4089cd2315da078,
    jds_file_uploader_item: ()=>$fe5170bdd3625759$export$b41bb47bfc36c3b4,
    jds_file_uploader_list: ()=>$fe5170bdd3625759$export$3d00ed40fd09f854,
    jds_progress_bar: ()=>$fe5170bdd3625759$export$c17561cb55d4db30,
    jds_input_phone_dropdown: ()=>$fe5170bdd3625759$export$770f20817cf88abc,
    jds_badge_v2: ()=>$fe5170bdd3625759$export$561b3597d6384588,
    jds_badge_v2_status: ()=>$fe5170bdd3625759$export$87daca618cc26b9,
    jds_badge_v2_information: ()=>$fe5170bdd3625759$export$50fcc0de7334f647,
    jds_badge_v2_notification: ()=>$fe5170bdd3625759$export$5217f316f51857f9,
    jds_badge_v2_brand: ()=>$fe5170bdd3625759$export$3b623c6160d8d9d1,
    jds_tabs_desktop: ()=>$fe5170bdd3625759$export$b2539bed5023c21c,
    jds_megamenu_internal: ()=>$fe5170bdd3625759$export$d7717d03c9caf572
};
const $fe5170bdd3625759$var$componentsMap = {
    ...$fe5170bdd3625759$var$v1Map
};
const $fe5170bdd3625759$var$Component$z = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2c;
    const { size: size = "medium", color: color = "primary_50", kind: kind = "default", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            color: color,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSIcon", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f04a61298a47a40f = $fe5170bdd3625759$var$withLogic$2e($fe5170bdd3625759$var$Component$z);
$fe5170bdd3625759$export$f04a61298a47a40f.displayName = "Icon";
$fe5170bdd3625759$export$f04a61298a47a40f.slotName = "jds_icon";
const $fe5170bdd3625759$var$_NotificationService = class {
    constructor(args){
        $fe5170bdd3625759$var$_NotificationService.args = args;
    }
};
let $fe5170bdd3625759$var$NotificationService = $fe5170bdd3625759$var$_NotificationService;
$fe5170bdd3625759$var$NotificationService.eventName = "notification";
const $fe5170bdd3625759$var$_NotificationCloseService = class {
    constructor(args){
        $fe5170bdd3625759$var$_NotificationCloseService.args = args;
    }
};
let $fe5170bdd3625759$var$NotificationCloseService = $fe5170bdd3625759$var$_NotificationCloseService;
$fe5170bdd3625759$var$NotificationCloseService.eventName = "close-notifications";
const $fe5170bdd3625759$var$_NotificationController = class {
    static updateNotifications(type) {
        if (type === "nudge") {
            $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationService({
                type: type,
                notifications: [
                    ...$fe5170bdd3625759$var$_NotificationController.nudges
                ]
            }));
            return;
        }
        $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationService({
            type: type,
            notifications: [
                ...$fe5170bdd3625759$var$_NotificationController.toasts
            ]
        }));
    }
    static createID(type) {
        const id = /* @__PURE__ */ new Date().getTime() + Math.random().toString();
        return this.getNotificationIndex(type, id) < 0 ? id : this.createID(type);
    }
    static getNotificationIndex(type, id) {
        if (type === "nudge") return $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((item)=>item.id === id);
        return $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((item)=>item.id === id);
    }
    static getNotification(id, type) {
        const index = $fe5170bdd3625759$var$_NotificationController.getNotificationIndex(type, id);
        if (this.isActive(id, type) && index >= 0) {
            if (type === "nudge") return $fe5170bdd3625759$var$_NotificationController.nudges[index];
            return $fe5170bdd3625759$var$_NotificationController.toasts[index];
        }
    }
    static nudge(props) {
        if (!props.title) {
            console.warn("Notification: [Nudge] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("nudge", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("nudge");
            if (!$fe5170bdd3625759$var$_NotificationController.isActive(ID, "nudge")) {
                const nudgeItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $fe5170bdd3625759$var$_NotificationController.nudges.push(nudgeItem);
                this.updateNotifications("nudge");
            }
            return ID;
        }
        return ID;
    }
    static toast(props) {
        if (!props.title) {
            console.warn("Notification: [Toast] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("toast", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("toast");
            if (!$fe5170bdd3625759$var$_NotificationController.isActive(ID, "toast")) {
                const toastItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $fe5170bdd3625759$var$_NotificationController.toasts.push(toastItem);
                this.updateNotifications("toast");
            }
            return ID;
        }
        return ID;
    }
    static dismiss(id, type) {
        if (this.isActive(id, type)) {
            $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationCloseService({
                [id]: type
            }));
            setTimeout(()=>{
                if (type === "nudge") {
                    const newNudgeList = $fe5170bdd3625759$var$_NotificationController.nudges.filter((item)=>item.id !== id);
                    $fe5170bdd3625759$var$_NotificationController.nudges = newNudgeList;
                } else {
                    const newToastList = $fe5170bdd3625759$var$_NotificationController.toasts.filter((item)=>item.id !== id);
                    $fe5170bdd3625759$var$_NotificationController.toasts = newToastList;
                }
                this.updateNotifications(type);
            }, 500);
        }
        return id;
    }
    static update(id, type, props) {
        const notificationIndex = this.getNotificationIndex(type, id);
        if (notificationIndex >= 0) {
            if (this.isActive(id, type)) {
                if (type === "nudge") {
                    const currentNudge = $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((nudge2)=>nudge2.id === id);
                    const updatedNudgeItem = {
                        ...$fe5170bdd3625759$var$_NotificationController.nudges[currentNudge],
                        ...props
                    };
                    $fe5170bdd3625759$var$_NotificationController.nudges[currentNudge] = updatedNudgeItem;
                } else {
                    const currentToast = $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((toast2)=>toast2.id === id);
                    const updatedToastItem = {
                        ...$fe5170bdd3625759$var$_NotificationController.toasts[currentToast],
                        ...props
                    };
                    $fe5170bdd3625759$var$_NotificationController.toasts[currentToast] = updatedToastItem;
                }
                this.updateNotifications(type);
            }
        }
    }
    static isActive(id, type) {
        const exists = type === "nudge" ? $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((nudgeItem)=>nudgeItem.id === id) >= 0 : $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((toastItem)=>toastItem.id === id) >= 0;
        return exists;
    }
    static dismissAll(type) {
        const activeIds = {};
        $fe5170bdd3625759$var$_NotificationController.nudges.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "nudge";
        });
        $fe5170bdd3625759$var$_NotificationController.toasts.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "toast";
        });
        $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationCloseService(activeIds));
        setTimeout(()=>{
            if (type === "nudge") $fe5170bdd3625759$var$_NotificationController.nudges = [];
            else $fe5170bdd3625759$var$_NotificationController.toasts = [];
            this.updateNotifications(type);
        }, 500);
    }
};
let $fe5170bdd3625759$var$NotificationController = $fe5170bdd3625759$var$_NotificationController;
$fe5170bdd3625759$var$NotificationController.nudges = [];
$fe5170bdd3625759$var$NotificationController.toasts = [];
const $fe5170bdd3625759$var$createProps = (props)=>typeof props === "string" ? {
        title: props
    } : props;
const $fe5170bdd3625759$var$nudge = (props)=>$fe5170bdd3625759$var$NotificationController.nudge($fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$nudge.update = (id, props)=>$fe5170bdd3625759$var$NotificationController.update(id, "nudge", $fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$nudge.dismiss = (id)=>$fe5170bdd3625759$var$NotificationController.dismiss(id, "nudge");
$fe5170bdd3625759$var$nudge.dismissAll = ()=>$fe5170bdd3625759$var$NotificationController.dismissAll("nudge");
$fe5170bdd3625759$var$nudge.isActive = (id)=>$fe5170bdd3625759$var$NotificationController.isActive(id, "nudge");
$fe5170bdd3625759$var$nudge.get = (id)=>$fe5170bdd3625759$var$NotificationController.getNotification(id, "nudge");
const $fe5170bdd3625759$var$toast = (props)=>$fe5170bdd3625759$var$NotificationController.toast($fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$toast.update = (id, props)=>$fe5170bdd3625759$var$NotificationController.update(id, "toast", $fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$toast.dismissAll = ()=>$fe5170bdd3625759$var$NotificationController.dismissAll("toast");
$fe5170bdd3625759$var$toast.dismiss = (id)=>$fe5170bdd3625759$var$NotificationController.dismiss(id, "toast");
$fe5170bdd3625759$var$toast.info = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f2a56b92690f077c$export$556fe0871d9b7899), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.error = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $87c0f97f25197d00$export$ed1619aa732c6643), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.success = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dd949b1a0491130c$export$50c1b72d39add9), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.warning = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7dab575aad091c08$export$47407925ae9f1f0e), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.isActive = (id)=>$fe5170bdd3625759$var$NotificationController.isActive(id, "toast");
$fe5170bdd3625759$var$toast.get = (id)=>$fe5170bdd3625759$var$NotificationController.getNotification(id, "toast");
const $fe5170bdd3625759$var$sdl$v = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-banner-1.0.0",
        "name": "JDSNotificationBanner",
        "layerName": "jds_notification_banner"
    },
    "hierarchy": {
        "root-container": [
            {
                "main-container": [
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    },
                    {
                        "text-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "cta-jds_button",
                            "close-jds_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "bottom-cta-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "min-height": "{n_0}",
            "width": "{n_1}",
            "flex-direction": "{n_2}",
            "justify-content": "{n_3}",
            "align-items": "{n_4}",
            "padding-top": "{n_5}",
            "padding-right": "{n_6}",
            "padding-bottom": "{n_7}",
            "padding-left": "{n_8}",
            "gap": "{n_9}",
            "border-radius": "{n_10}",
            "background-color": "{n_11}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": 0,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulEntrance}"
            }
        },
        "main-container": {
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_15}",
            "gap": "{n_16}"
        },
        "text-container": {
            "flex": 1,
            "justify-content": "{n_17}",
            "align-items": "{n_18}",
            "flex-direction": "{n_19}",
            "gap": "{n_20}"
        },
        "button-container": {
            "flex-direction": "{n_21}",
            "gap": "{n_22}"
        },
        "cta-jds_button": {
            "hidden": false,
            "size": "small",
            "kind": "secondary"
        },
        "close-jds_button": {
            "size": "small",
            "kind": "tertiary",
            "icon": "ic_close"
        },
        "bottom-container": {
            "hidden": true,
            "flex-direction": "{n_24}",
            "justify-content": "{n_25}",
            "align-items": "{n_26}",
            "width": "{n_23}"
        },
        "bottom-cta-jds_button": {
            "size": "small",
            "kind": "secondary"
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 4,
            "maxLines": 4
        }
    },
    "variant": {
        "ctaPosition": {
            "bottom": {
                "cta-jds_button": {
                    "hidden": true
                },
                "bottom-container": {
                    "hidden": false
                }
            }
        },
        "open": {
            "false": {
                "root-container": {
                    "hidden": true,
                    "translate-y": "{size.negativeMax}",
                    "transition": {
                        "timing-function": "{easeJoyfulExit}"
                    }
                }
            }
        },
        "_showClose": {
            "false": {
                "close-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "main-container": {
                    "align-items": "{n_27}"
                },
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "root-container": {
                        "padding-left": "{n_28}",
                        "padding-right": "{n_29}",
                        "border-radius": 0
                    }
                },
                "mobile": {
                    "root-container": {
                        "padding-left": "{n_30}",
                        "padding-right": "{n_31}",
                        "border-radius": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "padding-left": "{n_32}",
                        "padding-right": "{n_33}",
                        "border-radius": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "global",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "global": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    true,
                    false
                ]
            },
            "closeOnSuffixClick": {
                "values": [
                    true,
                    false
                ]
            },
            "ctaPosition": {
                "values": [
                    "inline",
                    "bottom"
                ]
            },
            "_showClose": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet",
                    "mobile"
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "close-jds_button": {
                "icon": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "bottom-cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "events": {
            "cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "bottom-cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "close-jds_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "banner"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeButtonAriaLabel",
                        "value": "Close Button"
                    },
                    "ariaDescribedby": {
                        "name": "closeButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "bottom-cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$7 = (props)=>{
    if (typeof props.description === "object") console.warn("Passing Listblock props is deprecated. Please pass a string");
    return {
        cta: {
            properties: {
                cta: $fe5170bdd3625759$var$resolvePropObjectKeys(props.cta, "title", ""),
                onCTAClick: props.cta?.onClick ?? props.onCTAClick
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$w = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$7);
        const [open, setOpen] = (0, $acw62.useState)(props.open);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(props.open);
        (0, $acw62.useEffect)(()=>{
            if (props.open) {
                setOpen(true);
                setTimeout(()=>{
                    setInternalOpen(true);
                }, 10);
            } else {
                setOpen(false);
                setTimeout(()=>setInternalOpen(false), 500);
            }
        }, [
            props.open
        ]);
        const getPlatform = ()=>{
            if ($fe5170bdd3625759$var$Devices.isMobile()) return "mobile";
            if ($fe5170bdd3625759$var$Devices.isTablet()) return "tablet";
            return "desktop";
        };
        const expandedClass = internalOpen && open ? "expanded" : "";
        const classes = [
            expandedClass
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open || internalOpen,
                _showClose: !(props.suffix === null),
                _platform: getPlatform(),
                className: classes.join(" "),
                suffix: [
                    "",
                    void 0
                ].includes(props.suffix) ? "IcClose" : props.suffix,
                onSuffixClick: (ev)=>{
                    if (props.closeOnSuffixClick) {
                        setOpen(false);
                        setTimeout(()=>{
                            setInternalOpen(false);
                        }, 500);
                    }
                    props.onSuffixClick?.(ev);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$y = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$v;
    const { global: global = false, open: open = true, closeOnSuffixClick: closeOnSuffixClick = true, ctaPosition: ctaPosition = "inline", onCTAClick: onCTAClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), closeButtonAriaLabel: closeButtonAriaLabel = "Close Button", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            global: global,
            open: open,
            closeOnSuffixClick: closeOnSuffixClick,
            ctaPosition: ctaPosition,
            onCTAClick: onCTAClick,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            closeButtonAriaLabel: closeButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationBanner", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NotificationBanner = $fe5170bdd3625759$var$withLogic$w($fe5170bdd3625759$var$Component$y);
$fe5170bdd3625759$var$NotificationBanner.displayName = "NotificationBanner";
$fe5170bdd3625759$var$NotificationBanner.slotName = "jds_notification_banner";
const $fe5170bdd3625759$var$sdl$u = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudgeContainer",
        "layerName": "jds_nudge_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_nudge"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{n_0}",
            "size": "{n_1}",
            "padding-top": "{n_2}",
            "padding-right": "{n_3}",
            "padding-bottom": "{n_4}",
            "padding-left": "{n_5}"
        },
        "root-container": {
            "flex-direction": "{n_6}",
            "justify-content": "{n_7}",
            "align-items": "{n_8}",
            "size": "{n_9}",
            "gap": "{n_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeNudges",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_nudge": {
                "prefix": {
                    "type": "string",
                    "name": "activeNudges.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeNudges.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeNudges.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeNudges.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeNudges.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeNudges.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeNudges.id"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeNudges.suffix"
                },
                "maxLines": {
                    "type": "number",
                    "name": "activeNudges.maxLines"
                }
            }
        },
        "events": {
            "jds_nudge": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_nudge": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$v = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                activeNudges: props.nudges.map((n)=>({
                        ...n,
                        prefix: n.prefix || n.icon
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$x = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$u;
    const { onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onShow: onShow = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudgeContainer", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NudgeContainer = $fe5170bdd3625759$var$withLogic$v($fe5170bdd3625759$var$Component$x);
$fe5170bdd3625759$var$NudgeContainer.displayName = "NudgeContainer";
$fe5170bdd3625759$var$NudgeContainer.slotName = "jds_nudge_container";
const $fe5170bdd3625759$var$sdl$t = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToastContainer",
        "layerName": "jds_toast_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_toast"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "size": "{t_1}",
            "padding-top": "{t_2}",
            "padding-right": "{t_3}",
            "padding-bottom": "{t_4}",
            "padding-left": "{t_5}"
        },
        "root-container": {
            "flex-direction": "{t_6}",
            "justify-content": "{t_7}",
            "align-items": "{t_8}",
            "size": "{t_9}",
            "gap": "{t_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeToasts",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "dismissAfter": "number",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_toast": {
                "prefix": {
                    "type": "string",
                    "name": "activeToasts.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeToasts.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeToasts.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeToasts.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeToasts.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeToasts.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeToasts.id"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "activeToasts.dismissAfter"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeToasts.suffix"
                }
            }
        },
        "events": {
            "jds_toast": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_toast": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$u = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                activeToasts: props.toasts.map((t)=>({
                        ...t,
                        prefix: t.prefix || t.icon
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$w = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$t;
    const { onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onShow: onShow = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToastContainer", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$ToastContainer = $fe5170bdd3625759$var$withLogic$u($fe5170bdd3625759$var$Component$w);
$fe5170bdd3625759$var$ToastContainer.displayName = "ToastContainer";
$fe5170bdd3625759$var$ToastContainer.slotName = "jds_toast_container";
const $fe5170bdd3625759$var$NotificationContainer = (props)=>{
    const { className: className, onShow: onShow, onClose: onClose, ...rest } = props;
    const classes = [
        className,
        "j-notificationContainer"
    ].join(" ");
    const notificationContRef = (0, $acw62.useRef)(null);
    const [nudges, setNudges] = (0, $acw62.useState)([]);
    const [toasts, setToasts] = (0, $acw62.useState)([]);
    const maxOnScreen = $fe5170bdd3625759$var$Devices.isMobile() ? 1 : 5;
    (0, $acw62.useEffect)(()=>{
        const { unsubscribe: nudgeUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationService, (data)=>{
            if (data.type === "nudge") setNudges(data.notifications);
        });
        const { unsubscribe: toastUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationService, (data)=>{
            if (data.type === "toast") setToasts(data.notifications);
        });
        return ()=>{
            $fe5170bdd3625759$var$nudge.dismissAll();
            nudgeUnsubscribe();
            $fe5170bdd3625759$var$toast.dismissAll();
            toastUnsubscribe();
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes,
        ...rest,
        ref: notificationContRef,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NudgeContainer, {
                onShow: onShow,
                onClose: onClose,
                nudges: nudges.slice(0, maxOnScreen).reverse()
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$ToastContainer, {
                onShow: onShow,
                onClose: onClose,
                toasts: toasts.slice(0, maxOnScreen).reverse()
            })
        ]
    });
};
$fe5170bdd3625759$var$NotificationContainer.displayName = "NotificationContainer";
$fe5170bdd3625759$var$NotificationContainer.defaultProps = {};
const $fe5170bdd3625759$var$sdl$s = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-list-1.0.0",
        "name": "JDSAccordionList",
        "layerName": "jds_accordion_list"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_accordion"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{a_0}",
            "width": "{a_1}"
        },
        "container": {
            "hidden": true,
            "flex-direction": "{a_2}",
            "width": "{a_3}"
        },
        "content-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_hasItems": {
            "true": {
                "content-slot": {
                    "hidden": true
                },
                "container": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "function": true,
                    "object": {
                        "children": "slot",
                        "prefix": "slot",
                        "expandedPanel": "boolean",
                        "showDivider": "boolean",
                        "disabled": "boolean",
                        "title": "string",
                        "subtitle": "string",
                        "onClick": "event"
                    }
                }
            },
            "jds_accordion": {
                "iconType": {
                    "type": "JDSAccordion.iconType",
                    "name": "iconType"
                },
                "children": {
                    "type": "slot",
                    "name": "items.children"
                },
                "prefix": {
                    "type": "slot",
                    "name": "items.prefix"
                },
                "expandedPanel": {
                    "type": "boolean",
                    "name": "items.expandedPanel"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "items.showDivider"
                },
                "subtitle": {
                    "type": "string",
                    "name": "items.subtitle"
                },
                "onClick": {
                    "type": "event",
                    "name": "items.onClick"
                }
            }
        },
        "config": {
            "iconType": {
                "type": "JDSAccordion.iconType",
                "values": [
                    "chevron",
                    "plus"
                ]
            },
            "allowMultiple": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasItems": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "jds_accordion"
                ]
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            },
            "jds_accordion": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getAllowedPanels = (panels, allowMultiple)=>{
    if (!panels) return [];
    if (allowMultiple) return panels;
    return [
        panels[0]
    ];
};
const $fe5170bdd3625759$var$withLogic$t = (Component)=>(props)=>{
        const { allowMultiple: allowMultiple, children: children, onChange: onChange, iconType: iconType } = props;
        const [selected, setSelected] = (0, $acw62.useState)($fe5170bdd3625759$var$getAllowedPanels(props.expanded, allowMultiple));
        (0, $acw62.useEffect)(()=>{
            setSelected($fe5170bdd3625759$var$getAllowedPanels(props.expanded, allowMultiple));
        }, [
            props.expanded,
            allowMultiple
        ]);
        const childrenArray = (0, $acw62.useMemo)(()=>{
            if (!children) return [];
            if (Array.isArray(children)) return children;
            if (children.type === Symbol.for("react.fragment")) {
                const validChild = children.props.children;
                return Array.isArray(validChild) ? validChild : [
                    validChild
                ];
            }
            return [
                children
            ];
        }, [
            children
        ]);
        const handleSelected = (0, $acw62.useCallback)((i)=>{
            let newSelected = [
                ...selected
            ];
            if (selected.includes(i)) {
                const idx = newSelected.findIndex((s)=>s === i);
                if (allowMultiple) {
                    if (idx >= 0) newSelected.splice(idx, 1);
                } else newSelected = [];
            } else if (!allowMultiple) newSelected = [
                i
            ];
            else newSelected.push(i);
            setSelected(newSelected);
            onChange?.(newSelected);
        }, [
            selected,
            allowMultiple,
            onChange
        ]);
        const expandedChildren = (0, $acw62.useMemo)(()=>childrenArray?.map((c, i)=>{
                return (0, $acw62.cloneElement)(c, {
                    ...c.props,
                    iconType: iconType || c.props.iconType,
                    onClick: (e)=>{
                        handleSelected(i);
                        c.props.onClick?.(e);
                    },
                    expandedPanel: c?.props?.expandedPanel || selected.includes(i),
                    disabled: Boolean(c.props?.disabled)
                });
            }), [
            childrenArray,
            handleSelected,
            iconType,
            selected
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasItems: Boolean(props.items?.length),
                items: props?.items?.map((item, i)=>{
                    return {
                        ...item,
                        key: item?.title ?? "" + i,
                        iconType: iconType,
                        onClick: (e)=>{
                            handleSelected(i);
                            item.onClick?.(e);
                        },
                        expandedPanel: item?.expandedPanel || selected.includes(i),
                        disabled: Boolean(item?.disabled)
                    };
                })
            },
            children: expandedChildren
        });
    };
const $fe5170bdd3625759$var$Component$v = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$s;
    const { iconType: iconType = "undefined", allowMultiple: allowMultiple = false, custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            iconType: iconType,
            allowMultiple: allowMultiple,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordionList", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a766cd26d0d69044 = $fe5170bdd3625759$var$withLogic$t($fe5170bdd3625759$var$Component$v);
$fe5170bdd3625759$export$a766cd26d0d69044.displayName = "Accordion";
$fe5170bdd3625759$export$a766cd26d0d69044.slotName = "jds_accordion_list";
const $fe5170bdd3625759$var$sdl$r = {
    "metadata": {
        "version": "1.0.0",
        "id": "base-icon-1.0.0",
        "name": "JDSBaseIcon",
        "layerName": "jds_base_icon"
    },
    "hierarchy": {
        "icon": []
    },
    "base": {
        "icon": {
            "size": "{b_0}",
            "color": "{b_1}"
        }
    },
    "variant": {
        "color": {
            "primary_30": {
                "icon": {
                    "color": "{b_2}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{b_3}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{b_4}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{b_5}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{b_6}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{b_7}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{b_8}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{b_9}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{b_10}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{b_11}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{b_12}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{b_13}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{b_11}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{b_12}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{b_13}"
                }
            },
            "white": {
                "icon": {
                    "color": "{b_14}"
                }
            },
            "none": {
                "icon": {
                    "color": "{b_15}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            }
        },
        "data": {
            "icon": {
                "size": {
                    "type": "size",
                    "default": 16,
                    "name": "size",
                    "function": true,
                    "doc_description": "It can take the integer size user wants to pass."
                },
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user wants to pass or the name of icon. e.g. `ic='IcFavorite'`. User can also pass any custom icon he may have stored locally."
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$u = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$r;
    const { color: color = "primary_50", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBaseIcon", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$20931e2295160b07 = $fe5170bdd3625759$var$withLogic$s($fe5170bdd3625759$var$Component$u);
$fe5170bdd3625759$export$20931e2295160b07.displayName = "BaseIcon";
$fe5170bdd3625759$export$20931e2295160b07.slotName = "jds_base_icon";
const $fe5170bdd3625759$var$sdl$q = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-1.0.0",
        "name": "JDSBottomNavigation",
        "layerName": "jds_bottom_navigation"
    },
    "hierarchy": {
        "container": [
            "jds_bottom_navigation_item"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "background-color": "{b_4}",
            "padding-left": "{b_5}",
            "padding-top": "{b_6}",
            "padding-right": "{b_7}",
            "padding-bottom": "{b_8}",
            "gap": "{b_9}",
            "box-shadow": {
                "x": "{b_10}",
                "y": "{b_11}",
                "blur": "{b_12}",
                "spread": "{b_13}",
                "color": "{b_15}"
            }
        },
        "jds_bottom_navigation_item": {
            "flex": "{b_14}"
        }
    },
    "variant": {
        "multiLine": {
            "true": {
                "jds_bottom_navigation_item": {
                    "multiLine": true
                }
            },
            "false": {
                "jds_bottom_navigation_item": {
                    "multiLine": false
                }
            }
        }
    },
    "api": {
        "config": {
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "icon": "icon",
                        "label": "string",
                        "disabled": "boolean"
                    },
                    "doc_description": "It shows list of items."
                }
            },
            "jds_bottom_navigation_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "activeIndex",
                    "doc_description": "It can be used to change the current active index."
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "linkProps": {
                    "type": "object",
                    "name": "items.linkProps"
                },
                "showLabel": {
                    "type": "boolean",
                    "name": "showLabel",
                    "doc_description": "Shows label below icon if true,by default it is false."
                }
            }
        },
        "events": {
            "jds_bottom_navigation_item": {
                "onItemClick": "onChange"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "navAriaLabel",
                    "ariaDescribedby": {
                        "name": "navAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_navigation_item": {
                "properties": {
                    "ariaLabel": "items.navAriaLabel",
                    "ariaDescribedby": "items.navAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$6 = (props = {})=>{
    return {
        items: {
            properties: {
                items: props?.items?.map((i)=>({
                        ...i,
                        label: i.label || i.title
                    }))
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$r = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$6);
        const { activeIndex: activeIndex, items: items = [], onChange: onChange, ...rest } = props;
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(activeIndex);
        const navItems = items.map((item, i)=>({
                ...item,
                linkProps: {
                    href: item["href"],
                    provider: item["provider"],
                    target: item["target"],
                    newTab: item["newTab"]
                },
                showLabel: props.showLabel,
                onClick: (ev)=>{
                    if (!item.disabled) {
                        item["onClick"]?.(ev);
                        onClick(i);
                        onChange?.(i);
                    }
                }
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                items: navItems,
                activeIndex: index,
                selectedIndex: index
            }
        });
    };
const $fe5170bdd3625759$var$Component$t = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$q;
    const { multiLine: multiLine = false, onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            multiLine: multiLine,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigation", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b77dc13a7753f3ee = $fe5170bdd3625759$var$withLogic$r($fe5170bdd3625759$var$Component$t);
$fe5170bdd3625759$export$b77dc13a7753f3ee.displayName = "BottomNav";
$fe5170bdd3625759$export$b77dc13a7753f3ee.slotName = "jds_bottom_navigation";
const $fe5170bdd3625759$var$sdl$p = {
    "metadata": {
        "version": "1.0.0",
        "id": "breadcrumbs-1.0.0",
        "name": "JDSBreadcrumbs",
        "layerName": "jds_breadcrumbs",
        "platform": "web",
        "description": "Breadcrumbs are a navigation system used to show hierarchy and navigational context for a user's location on a website. It helps users to understand where they are within a website's structure and move between levels.",
        "usage": "Breadcrumbs are used to categorize information in the search results and thus help the SEO of the site."
    },
    "hierarchy": {
        "container": [
            {
                "link-container": [
                    "jds_link",
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    }
                ]
            },
            "jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "height": "{b_3}"
        },
        "link-container": {
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_right",
            "ic": "ic_chevron_right"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_right"
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "link-container": {
                "value": {
                    "type": "list",
                    "name": "shownLinks",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "provider": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "shownLinks.title"
                },
                "newTab": {
                    "type": "string",
                    "name": "shownLinks.newTab",
                    "platform": "web"
                },
                "href": {
                    "type": "string",
                    "name": "shownLinks.href"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "shownLinks.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "shownLinks.onClick"
                },
                "provider": {
                    "type": "event",
                    "name": "shownLinks.provider",
                    "platform": "react"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "hiddenLinks"
                },
                "open": {
                    "type": "boolean",
                    "name": "open"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "currentPage"
                }
            }
        },
        "events": {
            "jds_link": {
                "onClick": "onClick"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    }
                }
            },
            "link-container": {
                "name": "shownLinks",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "shownLinks.linkAriaLabel",
                    "ariaDescribedby": "shownLinks.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$q = (Component)=>(props)=>{
        const { children: children = [], links: linksArray = [] } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [open, setOpen] = (0, $acw62.useState)(false);
        const truncatedRef = (0, $acw62.useRef)(false);
        const [position, setPosition] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            height: 0
        });
        const normalizedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
        const allowedLinkIndices = (0, $acw62.useMemo)(()=>{
            const lastIndex = normalizedChildren.length - 1 || linksArray.length - 1 || 0;
            return [
                0,
                lastIndex
            ];
        }, [
            normalizedChildren,
            linksArray
        ]);
        const hiddenLinks = normalizedChildren.map((l, i)=>{
            if (!allowedLinkIndices.includes(i)) return {
                label: l.props?.title || linksArray?.[i]?.title
            };
            return null;
        }).filter((i)=>!!i);
        const getShownLinks = (0, $acw62.useMemo)(()=>{
            if (normalizedChildren.length > 1 && (element?.offsetWidth && element.offsetWidth > window.innerWidth / 2 || truncatedRef.current)) {
                truncatedRef.current = true;
                return allowedLinkIndices.map((index, i)=>{
                    if (i === 1) return {
                        title: "...",
                        onClick: (ev)=>{
                            setOpen(true);
                            const { target: target } = ev;
                            const { left: left, top: top, height: height } = $fe5170bdd3625759$var$setPositions(target, void 0);
                            setPosition({
                                x: left,
                                y: top,
                                height: height
                            });
                        }
                    };
                    return normalizedChildren[index]?.props || linksArray?.[index];
                });
            } else if (!truncatedRef.current) {
                truncatedRef.current = false;
                return linksArray.length ? linksArray : normalizedChildren.map((l)=>l.props);
            }
        }, [
            element,
            normalizedChildren,
            allowedLinkIndices,
            linksArray
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                hiddenLinks: hiddenLinks,
                shownLinks: getShownLinks,
                rootRef: rootRef,
                open: open,
                _offsetX: position.x,
                _offsetY: position.y,
                _maxHeight: position.height,
                maxWidth: "fit-content",
                onClose: ()=>setOpen(false),
                children: null
            }
        });
    };
const $fe5170bdd3625759$var$Component$s = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$p;
    const { onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onSelect: onSelect,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBreadcrumbs", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2dc68d50d56fbbd = $fe5170bdd3625759$var$withLogic$q($fe5170bdd3625759$var$Component$s);
$fe5170bdd3625759$export$2dc68d50d56fbbd.displayName = "Breadcrumbs";
$fe5170bdd3625759$export$2dc68d50d56fbbd.slotName = "jds_breadcrumbs";
const $fe5170bdd3625759$var$sdl$o = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-1.0.0",
        "name": "JDSCarousel",
        "layerName": "jds_carousel",
        "description": "Carousel is a component for cycling through a series of content slides that can be composed of a combination of images, text and cards.",
        "usage": "Carousels are used to promote multiple items of conent within a single area on a screen."
    },
    "hierarchy": {
        "container": [
            {
                "slider-container": [
                    "carousel-slot"
                ]
            },
            {
                "control-container": [
                    {
                        "left-container": [
                            {
                                "progress-container": [
                                    "jds_spinner",
                                    "prefix-jds_action_button"
                                ]
                            },
                            {
                                "prefix-container": [
                                    "title-jds-text",
                                    "subtitle-jds-text"
                                ]
                            }
                        ]
                    },
                    "jds_carousel_pagination",
                    {
                        "right-container": [
                            "back-jds_action_button",
                            "next-jds_action_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "width": "{c_4}"
        },
        "slider-container": {
            "width": "{c_5}"
        },
        "control-container": {
            "flex-direction": "{c_6}",
            "justify-content": "{c_7}",
            "align-items": "{c_8}",
            "gap": "{c_9}",
            "width": "{c_10}"
        },
        "left-container": {
            "flex": 1,
            "max-width": "{c_11}",
            "flex-direction": "{c_12}",
            "justify-content": "{c_13}",
            "align-items": "{c_14}",
            "gap": "{c_15}",
            "padding-top": "{c_16}",
            "padding-bottom": "{c_17}",
            "show": true
        },
        "progress-container": {
            "hidden": true,
            "flex-direction": "{c_21}",
            "justify-content": "{c_22}",
            "align-items": "{c_23}"
        },
        "prefix-jds_action_button": {
            "icon": "ic_play",
            "size": "medium",
            "kind": "secondary",
            "z-index": 0
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": true,
            "flex-direction": "{c_18}",
            "justify-content": "{c_19}",
            "align-items": "{c_20}"
        },
        "right-container": {
            "flex": 1,
            "max-width": "{c_27}",
            "flex-direction": "{c_28}",
            "justify-content": "{c_29}",
            "align-items": "{c_30}",
            "gap": "{c_31}",
            "padding-top": "{c_32}",
            "padding-bottom": "{c_33}",
            "show": true
        },
        "back-jds_action_button": {
            "hidden": true,
            "icon": "ic_back",
            "size": "medium",
            "kind": "secondary"
        },
        "next-jds_action_button": {
            "hidden": true,
            "icon": "ic_next",
            "size": "medium",
            "kind": "secondary"
        },
        "jds_carousel_pagination": {
            "hidden": false
        },
        "title-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "Label",
            "text": "Label"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_34}"
                },
                "prefix-jds_action_button": {
                    "size": "small"
                },
                "back-jds_action_button": {
                    "size": "small"
                },
                "next-jds_action_button": {
                    "size": "small"
                },
                "jds_carousel_pagination": {
                    "density": "condensed"
                }
            }
        },
        "indicatorType": {
            "label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            },
            "dot_label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": false
                }
            },
            "none": {
                "prefix-container": {
                    "hidden": true
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            }
        },
        "autoPlay": {
            "false": {
                "left-container": {
                    "hidden": false
                }
            },
            "true": {
                "progress-container": {
                    "hidden": false
                }
            }
        },
        "showArrows": {
            "true": {
                "back-jds_action_button": {
                    "hidden": false
                },
                "next-jds_action_button": {
                    "hidden": false
                }
            }
        },
        "playing": {
            "true": {
                "prefix-jds_action_button": {
                    "icon": "ic_pause"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "prefix-jds_action_button": {
                        "z-index": 1,
                        "kind": "tertiary"
                    },
                    "jds_spinner": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "back-jds_action_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "false": {
                    "progress-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "autoPlay",
            "showDurationProgress"
        ],
        [
            "showArrows",
            "hideLeftArrow"
        ],
        [
            "playing",
            "showPlayPause"
        ]
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "indicatorType": {
                "values": [
                    "dot",
                    "label",
                    "dot_label",
                    "none"
                ]
            },
            "showArrows": {
                "values": [
                    false,
                    true
                ]
            },
            "hideLeftArrow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "hideNextSlide": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "autoPlay": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "hide autoplay button when autoPlay=false"
            },
            "showPlayPause": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "hide autoplay button when showPlayPause=false"
            },
            "playing": {
                "values": [
                    false,
                    true
                ]
            },
            "showDurationProgress": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_carousel_pagination": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "count": {
                    "type": "number",
                    "name": "totalSlides",
                    "doc_description": "to be used when number of children != total slides (e.g. when lazyloading or server pagination)"
                },
                "items": {
                    "type": "list",
                    "name": "_paginationItems"
                }
            },
            "jds_spinner": {
                "value": {
                    "type": "number",
                    "name": "_value"
                }
            },
            "slider-container": {
                "customHeight": {
                    "type": "number",
                    "name": "customHeight",
                    "platform": "ios",
                    "doc_description": "This can be used to set a custom user provided height for carousel container, instead of default height(200) rendered from engine"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_subtitle"
                }
            }
        },
        "children": {
            "carousel-slot": {
                "name": "children",
                "accepts": [
                    "jds_carousel_slide"
                ]
            }
        },
        "events": {
            "prefix-jds_action_button": {
                "onClick": {
                    "name": "onPlayPause",
                    "doc_description": "Triggered on resume/play/pause of auto playing slides."
                }
            },
            "back-jds_action_button": {
                "onClick": "onBackBtn"
            },
            "next-jds_action_button": {
                "onClick": "onNextBtn"
            },
            "jds_carousel_pagination": {
                "onDotClick": {
                    "name": "onDotClick",
                    "doc_description": "Triggerred on click of pagination dot"
                }
            },
            "slider-container": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            },
            "carousel-slot": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            }
        },
        "a11y": {
            "prefix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "PlayPauseAriaLabel",
                        "value": "Pause or Play Auto slide rotation"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Previous Slide"
                    }
                }
            },
            "next-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Slide"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$clampValue = (index, total)=>{
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
};
const $fe5170bdd3625759$var$sortedOrder = (children)=>{
    children.sort((a, b)=>{
        const elementA = a;
        const elementB = b;
        return (elementA.props.order || -1) - (elementB.props.order || -1);
    });
    return children;
};
const $fe5170bdd3625759$var$AUTOPLAY_DURATION = 3e3;
const $fe5170bdd3625759$var$TRANSITION_DURATION = 300;
const $fe5170bdd3625759$var$TOTALSPINNER_VALUE = 360;
const $fe5170bdd3625759$var$withLogic$p = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const { activeIndex: activeIndex = -1, initialIndex: initialIndex = 0, slideDuration: slideDuration = $fe5170bdd3625759$var$AUTOPLAY_DURATION, hideNextSlide: hideNextSlide, totalSlides: slideCount = 0, ...props } = userProps;
        const SLIDE_PERCENT = $fe5170bdd3625759$var$Devices.isMobile() && !hideNextSlide ? 92 : 100;
        const totalSlides = slideCount || (0, $acw62.Children).count(props.children);
        const [spinnerValue, setSpinnerValue] = (0, $acw62.useState)($fe5170bdd3625759$var$TOTALSPINNER_VALUE);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const transitionProgressRef = (0, $acw62.useRef)(false);
        const intervalRef = (0, $acw62.useRef)();
        const spinnerIntervalRef = (0, $acw62.useRef)();
        const [selected, setSelected] = (0, $acw62.useState)(props.playing);
        (0, $acw62.useEffect)(()=>{
            handleAutoPlay(Boolean(props.playing));
            return ()=>{
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
            };
        }, [
            props.playing
        ]);
        const [index, setIndex] = (0, $acw62.useState)(0);
        const touchRef = (0, $acw62.useRef)({
            start: 0,
            end: 0,
            started: false,
            id: 0
        });
        const totalDistance = (0, $acw62.useRef)(0);
        const [totalTouchDistance, setTotalDistance] = (0, $acw62.useState)(0);
        (0, $acw62.useEffect)(()=>{
            if (typeof initialIndex !== "undefined") jumpToSlide(initialIndex);
        }, [
            initialIndex
        ]);
        (0, $acw62.useEffect)(()=>{
            if (element) jumpToSlide(activeIndex);
        }, [
            activeIndex
        ]);
        const handleEndSlidePositions = (idx)=>{
            const currentIndex = idx === void 0 ? index : idx;
            const slides = Array.from(element?.querySelectorAll("div.j-jds-carousel-slide-container") || []);
            const firstSlide = slides[0];
            const lastSlide = slides[slides.length - 1];
            if (firstSlide) {
                if (currentIndex === totalSlides - 1) firstSlide.style.transform = `translateX(${(totalSlides || 1) * 100}%)`;
                else firstSlide.style.transform = "unset";
            }
            if (lastSlide) {
                if (currentIndex === 0) lastSlide.style.transform = `translateX(-${(totalSlides || 1) * 100}%)`;
                else lastSlide.style.transform = "unset";
            }
        };
        const enableTransition = ()=>{
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = $fe5170bdd3625759$var$TRANSITION_DURATION + "ms";
        };
        const next = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $fe5170bdd3625759$var$clampValue(index + 1, totalSlides);
            moveToPanel(nextIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        const prev = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $fe5170bdd3625759$var$clampValue(index - 1, totalSlides);
            moveToPanel(nextIndex, -1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        function handleImmediateTransitionToSlide(slideIndex) {
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = "0ms";
            handleEndSlidePositions(totalSlides - 1);
            setTotalDistance(slideIndex * -1 * SLIDE_PERCENT);
            setTimeout(enableTransition, $fe5170bdd3625759$var$TRANSITION_DURATION);
        }
        const jumpToSlide = (idx)=>{
            if (transitionProgressRef.current) return;
            const clampedIndex = $fe5170bdd3625759$var$clampValue(idx, totalSlides);
            if (clampedIndex === index) return;
            moveToPanel(clampedIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        (0, $acw62.useImperativeHandle)(ref, ()=>({
                getCurrentIndex: ()=>touchRef.current.id,
                goToSlide: jumpToSlide,
                next: next,
                prev: prev,
                getCaption: (currentIndex, _)=>{
                    return (0, $acw62.Children).toArray(props.children)[currentIndex].props.label || "";
                }
            }));
        const moveToPanel = (index2, dir = 1)=>{
            let distance = 0;
            if (dir > 0) {
                if (index2 === 0) {
                    distance = 0;
                    transitionProgressRef.current = true;
                    setTimeout(()=>{
                        handleImmediateTransitionToSlide(0);
                        transitionProgressRef.current = false;
                    }, $fe5170bdd3625759$var$TRANSITION_DURATION);
                } else distance = index2 * -1 * SLIDE_PERCENT;
            } else if (totalSlides - 1 === index2) {
                distance = SLIDE_PERCENT;
                transitionProgressRef.current = true;
                setTimeout(()=>{
                    handleImmediateTransitionToSlide(totalSlides - 1);
                    transitionProgressRef.current = false;
                }, $fe5170bdd3625759$var$TRANSITION_DURATION);
            } else distance = index2 * -1 * SLIDE_PERCENT;
            setTotalDistance(distance);
            setIndex(index2);
            touchRef.current.id = index2;
        };
        const handlePointerStart = (e)=>{
            handleEndSlidePositions();
            touchRef.current.started = true;
            touchRef.current.start = e.clientX;
            totalDistance.current = totalTouchDistance;
        };
        const handlePointerMove = (ev)=>{
            const containerWidth = element?.offsetWidth || 1;
            if (touchRef.current.started) {
                touchRef.current.end = ev.clientX;
                const difference = 100 / containerWidth * (touchRef.current.end - touchRef.current.start);
                const aactiveSlideDistance = index * -1 * SLIDE_PERCENT;
                setTotalDistance(aactiveSlideDistance + difference);
            }
        };
        const handlePointerEnd = (ev)=>{
            const difference = touchRef.current.end - touchRef.current.start;
            const diff = Math.abs(difference) / ev.currentTarget.offsetWidth * 100;
            touchRef.current = {
                start: 0,
                started: false,
                end: 0,
                id: touchRef.current.id
            };
            if (Math.abs(diff) > 30) {
                if (difference < 0) next();
                else prev();
            } else setTotalDistance(totalDistance.current);
        };
        (0, $acw62.useEffect)(()=>{
            if (!props.autoPlay) {
                if (intervalRef.current) clearInterval(intervalRef.current);
                if (spinnerIntervalRef.current) clearInterval(spinnerIntervalRef.current);
            }
        }, [
            props.autoPlay
        ]);
        const handleAutoPlay = (selected2)=>{
            console.log("handleAutoPlay called", selected2);
            setSelected(selected2);
            if (!selected2) {
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
                props?.onPause?.(index);
                setSpinnerValue(0);
            } else {
                props?.onPlay?.(index);
                const animationDuration = slideDuration;
                let startTimestamp;
                const animate = (timestamp)=>{
                    if (!startTimestamp) startTimestamp = timestamp;
                    const progress = timestamp - startTimestamp;
                    const percentage = Math.min(progress / animationDuration, 1);
                    const newValue = percentage * 360;
                    setSpinnerValue(newValue);
                    if (progress < animationDuration) requestAnimationFrame(animate);
                    else {
                        startTimestamp = 0;
                        setTimeout(animate, slideDuration);
                    }
                };
                intervalRef.current = setInterval(()=>{
                    if (transitionProgressRef.current) return;
                    const nextIndex = $fe5170bdd3625759$var$clampValue(touchRef.current.id + 1, totalSlides);
                    moveToPanel(nextIndex, 1);
                    setTimeout(()=>{
                        handleEndSlidePositions(touchRef.current.id);
                    }, $fe5170bdd3625759$var$TRANSITION_DURATION);
                }, slideDuration);
                animate(performance.now());
                spinnerIntervalRef.current = setInterval(()=>{
                    animate(performance.now());
                }, slideDuration);
            }
        };
        const handleDotClick = (idx)=>{
            let dir = -1;
            if (idx < index) dir = -1;
            else dir = 1;
            moveToPanel(idx, dir);
            props.onPaginationClick?.();
            handleEndSlidePositions(idx);
        };
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const localOf = (0, $5c2cbe2b2431bcd1$export$fb5267b92d6c6cd3)(language);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                "--move": totalTouchDistance + "%",
                "--slide-width": SLIDE_PERCENT + "%"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    totalSlides: totalSlides,
                    rootRef: rootRef,
                    children: $fe5170bdd3625759$var$sortedOrder((0, $acw62.Children).toArray(props.children)),
                    selectedIndex: index,
                    count: totalSlides,
                    _subtitle: `${getLocalNumber(index + 1)} ${localOf ?? "of"} ${getLocalNumber(totalSlides)}`,
                    onNextBtn: ()=>{
                        next();
                    },
                    onBackBtn: prev,
                    onNext: (ev, { type: type })=>{
                        if (type === "touchdown") handlePointerStart(ev);
                        else if (type === "touchmove") handlePointerMove(ev);
                        else handlePointerEnd(ev);
                    },
                    playing: selected,
                    _value: spinnerValue,
                    onPlayPause: ()=>handleAutoPlay(!selected),
                    onDotClick: handleDotClick
                }
            })
        });
    });
const $fe5170bdd3625759$var$Component$r = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$o;
    const { density: density = "undefined", indicatorType: indicatorType = "dot", showArrows: showArrows = false, hideLeftArrow: hideLeftArrow = false, hideNextSlide: hideNextSlide = false, autoPlay: autoPlay = false, showPlayPause: showPlayPause = true, playing: playing = false, showDurationProgress: showDurationProgress = false, onPlayPause: onPlayPause = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBackBtn: onBackBtn = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onNextBtn: onNextBtn = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDotClick: onDotClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onNext: onNext = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBack: onBack = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), PlayPauseAriaLabel: PlayPauseAriaLabel = "Pause or Play Auto slide rotation", backButtonAriaLabel: backButtonAriaLabel = "Previous Slide", nextButtonAriaLabel: nextButtonAriaLabel = "Next Slide", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            indicatorType: indicatorType,
            showArrows: showArrows,
            hideLeftArrow: hideLeftArrow,
            hideNextSlide: hideNextSlide,
            autoPlay: autoPlay,
            showPlayPause: showPlayPause,
            playing: playing,
            showDurationProgress: showDurationProgress,
            onPlayPause: onPlayPause,
            onBackBtn: onBackBtn,
            onNextBtn: onNextBtn,
            onDotClick: onDotClick,
            onClick: onClick,
            onNext: onNext,
            onBack: onBack,
            PlayPauseAriaLabel: PlayPauseAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarousel", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$144901db2ea8e967 = $fe5170bdd3625759$var$withLogic$p($fe5170bdd3625759$var$Component$r);
$fe5170bdd3625759$export$144901db2ea8e967.displayName = "Carousel";
$fe5170bdd3625759$export$144901db2ea8e967.slotName = "jds_carousel";
const $fe5170bdd3625759$var$sdl$n = {
    "metadata": {
        "version": "1.0.0",
        "id": "container-1.0.0",
        "name": "JDSContainer",
        "layerName": "jds_container"
    },
    "hierarchy": {
        "container": [
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "show": true,
            "background-color": "{global.transparent}",
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "padding-left": 0,
            "padding-top": 0,
            "padding-bottom": 0,
            "padding-right": 0,
            "border-bottom-width": 0,
            "border-top-width": 0,
            "border-right-width": 0,
            "border-left-width": 0,
            "border-top-left-radius": 0,
            "border-top-right-radius": 0,
            "border-bottom-left-radius": 0,
            "border-bottom-right-radius": 0
        }
    },
    "variant": {
        "direction": {
            "column": {
                "container": {
                    "flex-direction": "{flexDirection.column}"
                }
            },
            "stack": {
                "container": {
                    "flex-direction": "{flexDirection.stack}"
                }
            }
        }
    },
    "combination": [
        {
            "row": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                }
            }
        },
        {
            "row": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "direction",
            "verticalAlign"
        ],
        [
            "direction",
            "horizontalAlign"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "config": {
            "verticalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "horizontalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "direction": {
                "values": [
                    "row",
                    "column",
                    "stack"
                ]
            }
        },
        "data": {
            "container": {
                "width": {
                    "type": "token",
                    "name": "width"
                },
                "height": {
                    "type": "token",
                    "name": "height"
                },
                "background-color": {
                    "type": "string",
                    "name": "backgroundColor"
                },
                "border-radius": {
                    "type": "token",
                    "name": "radius"
                },
                "padding-left": {
                    "type": "token",
                    "name": "paddingLeft"
                },
                "padding-right": {
                    "type": "token",
                    "name": "paddingRight"
                },
                "padding-top": {
                    "type": "token",
                    "name": "paddingTop"
                },
                "padding-bottom": {
                    "type": "token",
                    "name": "paddingBottom"
                },
                "flex": {
                    "type": "number",
                    "name": "flex"
                },
                "border-left-width": {
                    "type": "token",
                    "name": "borderLeftWidth"
                },
                "border-right-width": {
                    "type": "token",
                    "name": "borderRightWidth"
                },
                "border-top-width": {
                    "type": "token",
                    "name": "borderTopWidth"
                },
                "border-bottom-width": {
                    "type": "token",
                    "name": "borderBottomWidth"
                },
                "border-top-left-radius": {
                    "type": "token",
                    "name": "borderTopLeftRadius"
                },
                "border-top-right-radius": {
                    "type": "token",
                    "name": "borderTopRightRadius"
                },
                "border-bottom-left-radius": {
                    "type": "token",
                    "name": "borderBottomLeftRadius"
                },
                "border-bottom-right-radius": {
                    "type": "token",
                    "name": "borderBottomRightRadius"
                },
                "border-color": {
                    "type": "string",
                    "name": "borderColor"
                },
                "gap": {
                    "type": "token",
                    "name": "gap"
                },
                "overflow": {
                    "type": "string",
                    "name": "overflow",
                    "platform": "web"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$o = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const [borderTop, borderRight, borderBottom, borderLeft] = props.borderWidth || [];
        const allSides = props.padding?.length === 1 ? Array.from({
            length: 4
        }).map(()=>props.padding?.[0]) : props.padding;
        const [paddingTop, paddingRight, paddingBottom, paddingLeft] = allSides || [];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children),
                width: props.fullWidth ? "{size.max}" : props.width,
                borderTopWidth: borderTop || props.borderTopWidth,
                borderLeftWidth: borderLeft || props.borderLeftWidth,
                borderRightWidth: borderRight || props.borderLeftWidth,
                borderBottomWidth: borderBottom || props.borderLeftWidth,
                paddingTop: paddingTop || props.paddingTop,
                paddingBottom: paddingBottom || props.paddingBottom,
                paddingRight: paddingRight || props.paddingRight,
                paddingLeft: paddingLeft || props.paddingLeft,
                gap: props.gap ?? 0,
                borderBottomLeftRadius: props.borderBottomLeftRadius || props.radius,
                borderBottomRightRadius: props.borderBottomRightRadius || props.radius,
                borderTopLeftRadius: props.borderTopLeftRadius || props.radius,
                borderTopRightRadius: props.borderTopRightRadius || props.radius
            }
        });
    });
const $fe5170bdd3625759$var$Component$q = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$n;
    const { verticalAlign: verticalAlign = "start", horizontalAlign: horizontalAlign = "start", direction: direction = "row", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            verticalAlign: verticalAlign,
            horizontalAlign: horizontalAlign,
            direction: direction,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContainer", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$42a852a2b6b56249 = $fe5170bdd3625759$var$withLogic$o($fe5170bdd3625759$var$Component$q);
$fe5170bdd3625759$export$42a852a2b6b56249.displayName = "Container";
$fe5170bdd3625759$export$42a852a2b6b56249.slotName = "jds_container";
const $fe5170bdd3625759$var$sdl$m = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-card-1.0.0",
        "name": "JDSContentCard",
        "layerName": "jds_content_card",
        "description": "Content cards are blocks of content that contain various combinations of components in different structures.",
        "usage": "Content cards are used to organise content in meaningful blocks within a page."
    },
    "hierarchy": {
        "root-container": [
            {
                "header-container": [
                    "header-slot"
                ]
            },
            {
                "image-content-container": [
                    "jds_image",
                    "jds_content_block"
                ]
            },
            {
                "children-container": [
                    "children-slot"
                ]
            },
            "footer-jds-text"
        ]
    },
    "base": {
        "root-container": {
            "overflow": "hidden",
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "flex-direction": "{c_2}",
            "justify-content": "{c_3}",
            "align-items": "{c_4}",
            "background-color": "{c_5}",
            "padding-bottom": "{c_29}",
            "gap": "{base}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000000E"
                    }
                }
            }
        },
        "header-container": {
            "hidden": false,
            "justify-content": "{c_6}",
            "align-items": "{c_7}",
            "width": "{c_8}",
            "padding-left": "{c_9}",
            "padding-right": "{c_10}"
        },
        "children-container": {
            "hidden": false,
            "justify-content": "{c_12}",
            "align-items": "{c_13}",
            "width": "{c_14}",
            "padding-left": "{c_15}"
        },
        "image-content-container": {
            "flex-direction": "{c_18}",
            "width": "{c_19}",
            "justify-content": "{c_20}",
            "align-items": "{c_21}",
            "gap": "{base}"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": true,
            "imageFocus": "center"
        },
        "jds_content_block": {
            "size": "xtra-small",
            "padding-left": "{c_24}",
            "padding-right": "{c_25}"
        },
        "footer-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{c_27}",
            "padding-right": "{c_28}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "_hasHeaderSlot": {
            "false": {
                "header-container": {
                    "hidden": true
                },
                "image-content-container": {
                    "padding-top": 0
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockAndImageProps": {
            "false": {
                "image-content-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockProps": {
            "false": {
                "jds_content_block": {
                    "hidden": true
                }
            }
        },
        "_hasImageProps": {
            "false": {
                "image-content-container": {
                    "padding-top": 0
                },
                "jds_image": {
                    "hidden": true
                },
                "jds_content_block": {
                    "padding-top": 0
                }
            }
        },
        "condensed": {
            "true": {
                "jds_content_block": {
                    "ctaWrap": "vertical"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "jds_content_block": {
                    "padding-left": 0
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "xtra-xtra-small": {
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                },
                "small": {
                    "jds_content_block": {
                        "size": "small"
                    }
                },
                "medium": {
                    "jds_content_block": {
                        "size": "medium"
                    }
                },
                "large": {
                    "jds_content_block": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "jds_content_block": {
                        "size": "xtra-large"
                    }
                }
            }
        },
        {
            "true": {
                "horizontal": {
                    "image-content-container": {
                        "padding-left": "{c_30}",
                        "padding-top": "{c_31}",
                        "flex-direction": "{c_32}"
                    },
                    "jds_image": {
                        "flex": "0.2",
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "flex": "0.8",
                        "size": "xtra-xtra-small"
                    }
                },
                "vertical": {
                    "root-container": {
                        "width": "{c_33}"
                    },
                    "jds_image": {
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                }
            },
            "false": {
                "horizontal": {
                    "root-container": {
                        "width": "{c_34}"
                    },
                    "image-content-container": {
                        "padding-left": "{c_35}",
                        "padding-top": "{c_36}",
                        "flex-direction": "{c_37}"
                    },
                    "jds_image": {
                        "flex": "0.3"
                    },
                    "jds_content_block": {
                        "flex": "0.7"
                    }
                }
            }
        },
        {
            "true": {
                "vertical": {
                    "mobile": {
                        "root-container": {
                            "width": "{c_38}"
                        }
                    }
                }
            }
        },
        {
            "horizontal": {
                "false": {
                    "jds_content_block": {
                        "flex": 1,
                        "padding-left": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "condensed",
            "size"
        ],
        [
            "condensed",
            "orientation"
        ],
        [
            "condensed",
            "orientation",
            "_platform"
        ],
        [
            "orientation",
            "_hasImageProps"
        ]
    ],
    "api": {
        "children": {
            "header-slot": {
                "name": "header",
                "accepts": [
                    "jds_list_block"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ]
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "condensed": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasHeaderSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockAndImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable. If any other CTAs are sent, they will not be clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "caption": {
                    "type": "slot",
                    "name": "caption",
                    "accepts": [
                        "jds_badge",
                        "jds_text",
                        "jds_tag"
                    ],
                    "function": true
                },
                "ctaWrap": {
                    "type": "JDSContentBlock.ctaWrap",
                    "name": "ctaWrap"
                },
                "isTertiary": {
                    "type": "boolean",
                    "name": "isTertiary"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "alt": {
                    "type": "string",
                    "name": "imgAlt"
                },
                "title": {
                    "type": "string",
                    "name": "imgTitle"
                },
                "borderRadius": {
                    "type": "size",
                    "default": 24,
                    "name": "borderRadius"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$5 = (props)=>{
    if (typeof props.image === "object") console.warn("passing a JSX element is deprecated. pass the image source as as string");
    if (typeof props.footer === "object") console.warn("Passing JSX.Element is deprecated. Please pass a string");
    return {
        image: {
            properties: {
                image: $fe5170bdd3625759$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$n = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$5);
        const hasContentBlockProps = Boolean(props.title || props.description || props.primaryCTA || props.secondaryCTA || props.caption);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasHeaderSlot: Boolean(props.header),
                _hasChildrenSlot: Boolean(props.children),
                _hasContentBlockProps: hasContentBlockProps,
                _hasImageProps: Boolean(props.image),
                _hasContentBlockAndImageProps: Boolean(hasContentBlockProps || props.image),
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile",
                children: props.children ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        width: "100%"
                    },
                    children: props.children
                }) : void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$p = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$m;
    const { size: size = "xtra-small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", shadow: shadow = true, condensed: condensed = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            shadow: shadow,
            condensed: condensed,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentCard", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$60332b2344f7fe41 = $fe5170bdd3625759$var$withLogic$n($fe5170bdd3625759$var$Component$p);
$fe5170bdd3625759$export$60332b2344f7fe41.displayName = "Card";
$fe5170bdd3625759$export$60332b2344f7fe41.slotName = "jds_content_card";
const $fe5170bdd3625759$var$YEAR_COUNT = 50;
const $fe5170bdd3625759$var$withLogic$m = (Component)=>(props)=>{
        const { onClose: onClose, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const [state, setState] = (0, $acw62.useState)("default");
        const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $acw62.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $acw62.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $acw62.useState)(year);
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(props.open, !closeProp);
        const scrollCloseListener = (0, $acw62.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        (0, $acw62.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const months = $fe5170bdd3625759$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.min, props.max);
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const confirmLabelLocal = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$6d8d0ec03e692fdc)(language);
        }, [
            language
        ]);
        if (!selected) return props.children;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                confirmDate: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString("en-GB", {
                    weekday: "short",
                    day: "2-digit",
                    month: "long",
                    year: "numeric"
                }),
                _confirmLabel: confirmLabelLocal,
                calendarData: {
                    disabledDates: props.disabledDates,
                    dateFilter: props.dateFilter,
                    min: props.min,
                    max: props.max
                },
                open: selected,
                value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                onClose: ()=>{
                    if (selected) toggle();
                    onClose?.();
                },
                onClick: (ev)=>ev.stopPropagation(),
                date: selectedDate.date,
                month: selectedMonth,
                year: selectedYear,
                monthName: [
                    selectedMonth - 1
                ]?.slice(0, 3),
                months: months,
                state: state,
                offsetX: 0,
                offsetY: 0,
                yearData: {
                    count: $fe5170bdd3625759$var$YEAR_COUNT,
                    min: selectedYear - $fe5170bdd3625759$var$YEAR_COUNT / 2,
                    max: selectedYear + $fe5170bdd3625759$var$YEAR_COUNT / 2,
                    disabled: $fe5170bdd3625759$var$getDisabledYears(selectedYear - $fe5170bdd3625759$var$YEAR_COUNT / 2, selectedYear + $fe5170bdd3625759$var$YEAR_COUNT / 2, props.min, props.max)
                },
                _onYearClick: ()=>setState("year_view"),
                _onMonthClick: ()=>setState("month_view"),
                _onBack: ()=>setState("default"),
                onSelect: (num, disabled)=>{
                    if (!disabled) setSelectedDate({
                        date: num,
                        month: selectedMonth,
                        year: selectedYear
                    });
                    setState("default");
                },
                _onConfirm: ()=>{
                    props.onSelect?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onChange?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onConfirm?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    close();
                    onClose?.();
                },
                _onMonthSelect: (i)=>{
                    if (monthSelectable) {
                        setSelectedMonth(i);
                        setState("default");
                        props.onMonthSelect?.();
                    }
                },
                _onYearSelect: (i)=>{
                    if (yearSelectable) {
                        setSelectedYear(i);
                        setState("default");
                        props.onYearSelect?.();
                    }
                },
                _onPrev: ()=>setSelectedMonth((m)=>{
                        if (m === 1) {
                            setSelectedYear(selectedYear - 1);
                            return 12;
                        }
                        return m - 1;
                    }),
                _onNext: ()=>setSelectedMonth((m)=>{
                        if (m === 12) {
                            setSelectedYear(selectedYear + 1);
                            return 1;
                        }
                        return m + 1;
                    })
            },
            children: props.children
        });
    };
const $fe5170bdd3625759$var$Component$o = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onConfirm: onConfirm = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobile", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$92b06b9488028257 = $fe5170bdd3625759$var$withLogic$m($fe5170bdd3625759$var$Component$o);
$fe5170bdd3625759$export$92b06b9488028257.displayName = "DatepickerMobile";
$fe5170bdd3625759$export$92b06b9488028257.slotName = "jds_datepicker_mobile";
const $fe5170bdd3625759$var$withLogic$l = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$n = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1G;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onConfirm: onConfirm = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Tap to Return", closeAriaLabel: closeAriaLabel = "Tap to Close", confirmAriaLabel: confirmAriaLabel = "Tap to Confirm", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            confirmAriaLabel: confirmAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobileInternal", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8d28dfe32d652778 = $fe5170bdd3625759$var$withLogic$l($fe5170bdd3625759$var$Component$n);
$fe5170bdd3625759$export$8d28dfe32d652778.displayName = "DatepickerMobileInternal";
$fe5170bdd3625759$export$8d28dfe32d652778.slotName = "jds_datepicker_mobile_internal";
const $fe5170bdd3625759$var$sdl$l = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-1.0.0",
        "name": "JDSDropdown",
        "layerName": "jds_dropdown",
        "description": "Dropdowns allow users to choose from a list of options presented contextually as a list. A dropdown in this document is a combination of a trigger and an options popup.",
        "usage": "Dropdowns are used when you want users to take an action or provide input."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "label-jds-text",
                    {
                        "select-container": [
                            {
                                "text-container": [
                                    {
                                        "prefix-icon-container": [
                                            "prefix-icon"
                                        ]
                                    },
                                    "current-jds-text",
                                    "placeholder-jds-text"
                                ]
                            },
                            {
                                "chevron-jds-icon-container": [
                                    "chevron-jds-icon"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "gap": "{d_1}",
            "width": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}",
            "behavior": {
                "hover": {}
            },
            "opacity": "{d_37}"
        },
        "field-container": {
            "flex-direction": "{d_5}",
            "width": "{d_6}",
            "align-items": "{d_7}",
            "justify-content": "{d_8}",
            "padding-bottom": "{d_9}"
        },
        "text-container": {
            "flex-direction": "{d_10}",
            "overflow": "hidden",
            "flex": 1,
            "hidden": false,
            "gap": "{d_11}"
        },
        "select-container": {
            "flex-direction": "{d_12}",
            "justify-content": "{d_13}",
            "width": "{d_14}",
            "padding-top": 20,
            "align-items": "{d_15}",
            "z-index": 0
        },
        "active-line-container": {
            "flex-direction": "{d_16}",
            "width": "{d_17}",
            "align-items": "{d_18}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{d_19}",
            "height": 2,
            "background-color": "{d_20}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{d_21}"
                },
                "focus": {
                    "background-color": "{d_22}"
                },
                "active": {
                    "background-color": "{d_23}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-icon-container": {
            "hidden": true
        },
        "prefix-icon": {
            "size": "{d_34}",
            "color": "{d_35}"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "z-index": 1
        },
        "label-border-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "current-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "placeholder-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "field-container": {
                    "label-jds_text": {
                        "hidden": true
                    }
                },
                "select-container": {
                    "height": "{d_51}",
                    "border-width": "{d_24}",
                    "border-color": "{d_25}",
                    "border-radius": "{d_26}",
                    "background-color": "{d_50}",
                    "padding-top": "{d_27}",
                    "padding-bottom": "{d_28}",
                    "padding-left": "{d_29}",
                    "padding-right": "{d_30}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_31}"
                        },
                        "focus": {
                            "background-color": "{d_32}"
                        },
                        "active": {
                            "background-color": "{d_33}"
                        }
                    }
                },
                "label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_36}"
                },
                "select-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{d_38}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_39}"
                        },
                        "focus": {
                            "background-color": "{d_40}"
                        },
                        "active": {
                            "background-color": "{d_41}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_38}"
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{d_42}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_43}"
                        },
                        "focus": {
                            "background-color": "{d_44}"
                        },
                        "active": {
                            "background-color": "{d_45}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_42}"
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{d_46}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_47}"
                        },
                        "focus": {
                            "background-color": "{d_48}"
                        },
                        "active": {
                            "background-color": "{d_49}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_46}"
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_isLabelEmpty": {
            "true": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isPlaceHolderEmpty": {
            "true": {
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "current-jds-text": {
                    "hidden": false
                },
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{d_52}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_53}"
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{d_54}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "padding-left": "{d_55}"
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_56}"
                    },
                    "label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{d_58}"
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "select-container": {
                        "padding-left": "{d_57}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ],
        [
            "_hasPrefix",
            "border"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_isLabelEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPlaceHolderEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isValueEmpty": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "This should pass down values to MenuBlock\u2019s items prop. selected determines the default selected value currently.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "current-jds-text": {
                "value": {
                    "type": "string",
                    "name": "current"
                }
            },
            "placeholder-jds-text": {
                "value": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "active-line-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "select-container": {
                "onClick": "onOpen"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "select-container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$4 = (props)=>{
    return {
        state: {
            properties: {
                state: props.state
            },
            variations: {
                error: {
                    stateText: props.stateConfig?.errorText || props.stateText
                },
                success: {
                    stateText: props.stateConfig?.successText || props.stateText
                },
                warning: {
                    stateText: props.stateConfig?.warningText || props.stateText
                },
                required: {
                    stateText: props.stateConfig?.requiredText
                }
            }
        },
        items: {
            properties: {
                items: props.items || []
            }
        }
    };
};
const $fe5170bdd3625759$var$SELECT_CONTAINER_SELECTOR = 'div[data-testid="JDSDropdown-select-container"]';
const $fe5170bdd3625759$var$OFFSET = 12;
const $fe5170bdd3625759$var$withLogic$k = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$4);
        const [distance, setDistance] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
        const [isPositionReady, setIsPositionReady] = (0, $acw62.useState)(false);
        const { selectedIndex: selectedIndex, items: items = [], onSelect: onSelect } = props;
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(selectedIndex);
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(false);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const selectContainer = element?.querySelector($fe5170bdd3625759$var$SELECT_CONTAINER_SELECTOR);
        const calculatePositions = ()=>{
            if (selectContainer) {
                const { height: height, left: x, top: y, width: width = 0 } = $fe5170bdd3625759$var$setPositions(selectContainer, void 0);
                setDistance({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
                setIsPositionReady(true);
            }
        };
        const handleOpen = ()=>{
            calculatePositions();
            toggle(true);
        };
        (0, $acw62.useEffect)(()=>{
            if (!selected) {
                setIsPositionReady(false);
                selectContainer?.focus?.();
            }
        }, [
            selected
        ]);
        const hasPrefix = Boolean(props.prefix);
        const currentIdx = props.value ? items.findIndex((item)=>item.value === props.value) : index;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                current: items[currentIdx]?.label,
                open: selected && isPositionReady,
                onSelect: (index2)=>{
                    onClick(index2);
                    onSelect?.(index2, items[index2]?.value || items[index2]?.label);
                },
                rootRef: rootRef,
                _hasPrefix: hasPrefix,
                _inputFocus: currentIdx >= 0,
                selectedIndex: currentIdx,
                onClose: ()=>{
                    close();
                    props.onClose?.();
                },
                onOpen: ()=>{
                    handleOpen();
                    props.onOpen?.();
                },
                _labelFocus: Boolean(currentIdx >= 0 || props.placeholder),
                _offsetX: distance.x,
                _offsetY: distance.y + $fe5170bdd3625759$var$OFFSET,
                _maxWidth: distance.width,
                _maxHeight: distance.height,
                _isValueEmpty: !items[currentIdx]?.label,
                _isPlaceHolderEmpty: !props.placeholder
            }
        });
    };
const $fe5170bdd3625759$var$Component$m = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$l;
    const { open: open = false, border: border = false, disabled: disabled = false, state: state = "undefined", onOpen: onOpen = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            border: border,
            disabled: disabled,
            state: state,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdown", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4ca664383a1d455a = $fe5170bdd3625759$var$withLogic$k($fe5170bdd3625759$var$Component$m);
$fe5170bdd3625759$export$4ca664383a1d455a.displayName = "InputDropdown";
$fe5170bdd3625759$export$4ca664383a1d455a.slotName = "jds_dropdown";
const $fe5170bdd3625759$var$sdl$k = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItemMobile",
        "platform": "android",
        "layerName": "jds_dropdown_menu_item_mobile",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$j = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$l = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$k;
    const { selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), _ariaExpanded: _ariaExpanded = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItemMobile", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7d15013c6b8c3bad = $fe5170bdd3625759$var$withLogic$j($fe5170bdd3625759$var$Component$l);
$fe5170bdd3625759$export$7d15013c6b8c3bad.displayName = "DropdownMenuItemMobile";
$fe5170bdd3625759$export$7d15013c6b8c3bad.slotName = "jds_dropdown_menu_item_mobile";
const $fe5170bdd3625759$var$sdl$j = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-1.0.0",
        "name": "JDSFileUploader",
        "layerName": "jds_file_uploader"
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_control",
            "jds_file_uploader_panel"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "gap": "{f_4}",
            "opacity": "{f_5}"
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_panel": {
                    "kind": "collapsible"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "type": "JDSFileUploaderPanel.kind",
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_control": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "helperText": {
                    "type": "string",
                    "name": "helperText"
                },
                "uploadButtonLabel": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "jds_file_uploader_panel": {
                "message": {
                    "type": "string",
                    "name": "message"
                },
                "value": {
                    "type": "float",
                    "name": "value"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "expanded": {
                    "type": "boolean",
                    "name": "expanded"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_control": {
                "onInfoClick": "onInfoClick",
                "onClick": "onClick"
            },
            "jds_file_uploader_panel": {
                "onClick": "onExpand",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_control": {
                "properties": {
                    "uploadButtonAriaLabel": "uploadButtonAriaLabel"
                }
            },
            "jds_file_uploader_panel": {
                "properties": {
                    "panelAriaLabel": "panelAriaLabel",
                    "panelAriaDescribedBy": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "panelSuffixAriaLabel": "panelSuffixAriaLabel"
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$i = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$k = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$j;
    const { kind: kind = "undefined", expanded: expanded = false, showDivider: showDivider = true, onInfoClick: onInfoClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onExpand: onExpand = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onClose: onClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onInfoClick: onInfoClick,
            onClick: onClick,
            onExpand: onExpand,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploader", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1a5cb5295a7d2749 = $fe5170bdd3625759$var$withLogic$i($fe5170bdd3625759$var$Component$k);
$fe5170bdd3625759$export$1a5cb5295a7d2749.displayName = "FileUploader";
$fe5170bdd3625759$export$1a5cb5295a7d2749.slotName = "jds_file_uploader";
const $fe5170bdd3625759$var$sdl$i = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-1.0.0",
        "name": "JDSFooter",
        "layerName": "jds_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "main-container": [
                    {
                        "content-container": [
                            "content-slot"
                        ]
                    },
                    {
                        "social-links-container": [
                            "jds_footer_icon_links",
                            "jds_footer_market_links"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_divider",
                    "jds_bottom_footer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}",
            "background-color": "{f_3}"
        },
        "main-container": {
            "flex-direction": "{f_4}",
            "justify-content": "{f_5}",
            "align-items": "{f_6}",
            "gap": "{f_7}",
            "size": "{f_8}",
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}"
        },
        "social-links-container": {
            "padding-top": "{f_13}",
            "flex-direction": "{f_14}",
            "gap": "{f_15}",
            "width": "{f_28}"
        },
        "bottom-container": {
            "flex-direction": "{f_16}",
            "align-items": "{f_17}",
            "width": "{f_18}",
            "gap": 0
        },
        "jds_divider": {
            "pad": "none"
        },
        "jds_bottom_footer": {
            "_platform": "desktop"
        },
        "content-container": {
            "width": "{f_19}"
        },
        "content-slot": {
            "width": "{f_20}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "bottom-container": {
                    "gap": "{f_21}"
                },
                "jds_bottom_footer": {
                    "_platform": "mobile"
                },
                "main-container": {
                    "flex-direction": "{f_22}",
                    "justify-content": "{f_23}",
                    "padding-top": "{f_24}",
                    "padding-bottom": "{f_25}",
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                }
            }
        },
        "_hasMainContainerProps": {
            "false": {
                "main-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentSlot": {
            "false": {
                "content-container": {
                    "hidden": true
                }
            }
        },
        "_hasSocialLinksContainer": {
            "false": {
                "social-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasFooterIconLinks": {
            "false": {
                "jds_footer_icon_links": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "_hasMainContainerProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasSocialLinksContainer": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasFooterIconLinks": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "data": {
            "main_container": {
                "value": {
                    "name": "links",
                    "type": "object",
                    "object": {
                        "links": "list"
                    }
                }
            },
            "social-links-container": {
                "marketplace": {
                    "type": "object",
                    "name": "marketplace",
                    "object": {
                        "assets": "JDSFooterMarketLinks.assets",
                        "title": "string"
                    }
                },
                "social": {
                    "type": "object",
                    "name": "social",
                    "object": {
                        "links": "JDSFooterIconLinks.links",
                        "title": "string"
                    }
                }
            },
            "jds_footer_icon_links": {
                "links": {
                    "name": "social.links",
                    "type": "list"
                },
                "title": {
                    "name": "social.title",
                    "type": "string"
                }
            },
            "jds_footer_market_links": {
                "assets": {
                    "name": "marketplace.assets",
                    "type": "list"
                },
                "title": {
                    "name": "marketplace.title",
                    "type": "string"
                }
            },
            "jds_bottom_footer": {
                "copyright": {
                    "type": "JDSBottomFooter.copyright",
                    "name": "copyright"
                },
                "copyrightText": {
                    "type": "string",
                    "name": "copyrightText"
                },
                "informationalLinks": {
                    "type": "JDSBottomFooter.informationalLinks",
                    "name": "bottomLinks"
                },
                "logo": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Footer"
                    }
                }
            },
            "jds_bottom_footer": {
                "properties": {
                    "copyRightAriaLabel": "copyRightAriaLabel",
                    "copyRightAriaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$3 = (props)=>({
        marketplace: {
            properties: {
                title: props.marketplace?.title,
                assets: props.marketplace?.stores?.map((store)=>({
                        image: store.badgeAsset,
                        href: store.href
                    }))
            }
        },
        mainLinks: {
            properties: {
                links: props.mainLinks?.map((l)=>({
                        title: l.heading,
                        subLinks: l.links
                    }))
            }
        }
    });
const $fe5170bdd3625759$var$FooterAccordion = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a766cd26d0d69044, {
        allowMultiple: true,
        children: props.links?.map((link)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$7cad6f17fd6e117b, {
                header: link.title,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$553910ef0cc96026, {
                    links: link.subLinks
                })
            }, link.title))
    });
};
const $fe5170bdd3625759$var$withLogic$h = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$3);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile",
                _hasMainContainerProps: Boolean(props.marketplace || props.links || props.social),
                copyright: props.copyright,
                _hasContentSlot: Boolean(props.links),
                _hasFooterIconLinks: Boolean(props.social),
                _hasSocialLinksContainer: Boolean(props.social || props.marketplace),
                children: $fe5170bdd3625759$var$Devices.isDesktop() ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$e5275d44ac937bc0, {
                    links: props.links
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$FooterAccordion, {
                    links: props.links
                })
            }
        });
    };
const $fe5170bdd3625759$var$Component$j = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$i;
    const { ariaLabel: ariaLabel = "Footer", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFooter", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a06f1c675e846f6f = $fe5170bdd3625759$var$withLogic$h($fe5170bdd3625759$var$Component$j);
$fe5170bdd3625759$export$a06f1c675e846f6f.displayName = "Footer";
$fe5170bdd3625759$export$a06f1c675e846f6f.slotName = "jds_footer";
const $fe5170bdd3625759$var$sdl$h = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-mobile-1.0.0",
        "name": "JDSHeaderMobile",
        "layerName": "jds_header_mobile"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "prefix-jds_button",
                            {
                                "prefix-container": [
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            }
                        ]
                    },
                    {
                        "right-container": [
                            "jds_search_box",
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-jds_button"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "header-container": {
            "min-width": "{h_2}",
            "width": "{h_3}",
            "background-color": "{h_4}",
            "flex-direction": "{h_5}",
            "justify-content": "{h_6}",
            "align-items": "{h_7}",
            "padding-left": "{h_43}",
            "padding-top": "{h_9}",
            "padding-right": "{h_44}",
            "padding-bottom": "{h_11}",
            "height": "{h_13}",
            "gap": "{h_45}"
        },
        "left-container": {
            "flex-direction": "{h_14}",
            "justify-content": "{h_15}",
            "align-items": "{h_16}"
        },
        "prefix-container": {
            "flex-direction": "{h_18}",
            "justify-content": "{h_19}",
            "align-items": "{h_20}",
            "gap": "{h_21}"
        },
        "prefix-jds_button": {
            "size": "medium"
        },
        "logo-container": {
            "hidden": false,
            "flex-direction": "{h_22}",
            "justify-content": "{h_23}",
            "align-items": "{h_24}",
            "gap": "{h_25}"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "flex": 1
        },
        "right-container": {
            "flex-direction": "{h_31}",
            "justify-content": "{h_32}",
            "align-items": "{h_33}",
            "gap": "{h_47}"
        },
        "suffix-container": {
            "flex-direction": "{h_35}",
            "justify-content": "{h_36}",
            "align-items": "{h_37}",
            "gap": "{h_48}"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "icon-links-container": {
            "flex-direction": "{h_39}",
            "justify-content": "{h_40}",
            "align-items": "{h_41}",
            "gap": "{h_42}",
            "hidden": false
        },
        "icon-links-jds_button": {
            "size": "medium"
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "jds_search_results": {
            "open": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "_variant": {
            "active_search": {
                "prefix-slot": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "jds_search_box": {
                    "prefix": "ic_search",
                    "flex": 1
                },
                "left-container": {
                    "hidden": true
                },
                "icon-links-container": {
                    "hidden": true
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "left-container": {
                    "flex": 1
                },
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_isBrandMissing": {
            "true": {
                "logo-container": {
                    "hidden": true
                }
            }
        },
        "_isPrefixButtonMissing": {
            "true": {
                "header-container": {
                    "padding-left": "{h_50}"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "left-container": {
                        "flex": 1
                    },
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isBrandMissing": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPrefixButtonMissing": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "icon-links-container": {
                "value": {
                    "type": "list",
                    "name": "icons",
                    "object": {
                        "icon": "icon",
                        "onClick": "event"
                    }
                }
            },
            "icon-links-jds_button": {
                "icon": {
                    "name": "icons.icon",
                    "type": "icon"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix",
                    "function": true
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "number",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "number",
                    "name": "_offsetY"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults",
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tab"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "header-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onBack": "onSearchBoxPrefixClick"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "icon-links-container": {
                "name": "icons",
                "repeating": {
                    "ariaLabel": "iconLinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconLinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_results": {
                "name": "searchResults",
                "repeating": {
                    "ariaLabel": "searchResultAriaLabel",
                    "ariaDescribedby": {
                        "name": "searchResultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon-links-jds_button": {
                "properties": {
                    "ariaLabel": "icons.iconLinkAriaLabel",
                    "ariaDescribedby": "icons.iconLinkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$i = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$h;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, onSearchActiveChange: onSearchActiveChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchBoxPrefixClick: onSearchBoxPrefixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchBoxPrefixClick: onSearchBoxPrefixClick,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderMobile", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9f3d994e721c19d3 = $fe5170bdd3625759$var$withLogic$g($fe5170bdd3625759$var$Component$i);
$fe5170bdd3625759$export$9f3d994e721c19d3.displayName = "HeaderMobile";
$fe5170bdd3625759$export$9f3d994e721c19d3.slotName = "jds_header_mobile";
const $fe5170bdd3625759$var$sdl$g = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-code-1.0.0",
        "name": "JDSInputCode",
        "layerName": "jds_input_code"
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "jds_input_code_item"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "width": "{i_3}",
            "gap": "{i_4}",
            "opacity": "{i_11}"
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "justify-content": "{i_6}",
            "align-items": "{i_7}",
            "width": "{i_8}",
            "gap": "{i_9}"
        },
        "jds_input_code_item": {
            "flex": 1
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{i_10}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input_code_item": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable the autocomplete feature in the inputcode.",
                "platform": "web"
            },
            "autofocus": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to Focus on the Inputcode.",
                "platform": "web"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "container": {
                "_codes.value": {
                    "type": "string",
                    "name": "value"
                },
                "_codes.placeholder": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "field-container": {
                "value": {
                    "type": "list",
                    "name": "_codes",
                    "object": {
                        "value": "string",
                        "placeholder": "string"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "codeLength",
                    "doc_description": "It can be used to control length of Code."
                }
            },
            "jds_input_code_item": {
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'."
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled",
                    "doc_description": "It can be used to enable or disable Code."
                },
                "autofocus": {
                    "type": "boolean",
                    "name": "autofocus",
                    "doc_description": "It can be used to enable the autoFocus on InputCode.",
                    "platform": "web,ios"
                },
                "value": {
                    "type": "string",
                    "name": "codes.value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "codes.placeholder"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input required."
                },
                "secureText": {
                    "type": "boolean",
                    "name": "secureText"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Code."
                }
            }
        },
        "events": {
            "jds_input_code_item": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onBackPress": {
                    "name": "onBackPress",
                    "platform": "android"
                },
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "input"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_input_code_item": {
                "properties": {
                    "ariaLabel": {
                        "name": "codeAriaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$f = (Component)=>(props)=>{
        const { value: propValue, onChange: onChange, autofocus: autofocus, ...rest } = props;
        const [element, setElement] = (0, $acw62.useState)(null);
        const rootRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { inputState: inputState, stateText: stateText, onInvalid: onInvalid } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        const [value, setValue] = (0, $acw62.useState)(propValue?.split("") || []);
        (0, $acw62.useState)(propValue || "");
        const [updatedValue, setUpdatedValue] = (0, $acw62.useState)("");
        const inputs = Array.from(element?.getElementsByTagName("input") || []);
        const autofocusExecuted = (0, $acw62.useRef)(false);
        (0, $acw62.useEffect)(()=>{
            if (autofocus && !autofocusExecuted.current && inputs.length > 0) {
                autofocusExecuted.current = true;
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        }, [
            autofocus,
            inputs
        ]);
        (0, $acw62.useEffect)(()=>{
            setValue(propValue?.split("") || []);
            setUpdatedValue(propValue || "");
        }, [
            propValue
        ]);
        const focusNext = (i)=>{
            if (i + 1 < inputs.length) {
                inputs[i + 1]?.focus();
                inputs[i + 1]?.select();
            }
        };
        const focusPrev = (i)=>{
            if (i > 0) {
                inputs[i - 1]?.focus();
                inputs[i - 1]?.select();
            } else {
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        };
        const handleChange = (ev, i)=>{
            const inputValue = ev.target.value;
            const newValue = [
                ...value
            ];
            if (inputValue.length > 1) {
                Array.from({
                    length: inputValue.length
                }).forEach((_, idx)=>{
                    newValue[idx] = inputValue[idx];
                });
                const lastUpdatedIndex = i + inputValue.length - 1;
                inputs[lastUpdatedIndex]?.focus();
                inputs[lastUpdatedIndex]?.select();
            } else {
                newValue[i] = inputValue.slice(-1) || "";
                focusNext(i);
            }
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) {
                const event = {
                    ...ev,
                    target: {
                        ...ev.target,
                        value: newValue.join("")
                    }
                };
                props.onChange(event);
            }
        };
        const handleFocus = (ev, i)=>{
            const target = ev.target;
            const selectValue = ()=>{
                if (document.activeElement === target) {
                    target.select();
                    setTimeout(selectValue, 0);
                }
            };
            selectValue();
        };
        const handleKeyDown = (ev, i)=>{
            const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab"
            ];
            const isPasteShortcut = (ev.ctrlKey || ev.metaKey) && ev.key.toLowerCase() === "v";
            if (!/^\d$/.test(ev.key) && !allowedKeys.includes(ev.key) && !isPasteShortcut) {
                ev.preventDefault();
                return;
            }
            switch(ev.key){
                case "Backspace":
                case "Delete":
                    {
                        const newValue = [
                            ...value
                        ];
                        if (!ev.currentTarget.value && i > 0) {
                            newValue[i - 1] = "";
                            focusPrev(i);
                        } else newValue[i] = "";
                        setValue(newValue);
                        setUpdatedValue(newValue.join(""));
                        if (props.onChange) props.onChange({
                            ...ev,
                            target: {
                                ...ev.target,
                                value: newValue.join("")
                            }
                        });
                        ev.preventDefault();
                        break;
                    }
                case "ArrowLeft":
                    focusPrev(i);
                    ev.preventDefault();
                    break;
                case "ArrowRight":
                    focusNext(i);
                    ev.preventDefault();
                    break;
                case "Tab":
                    if (ev.shiftKey) focusPrev(i);
                    else focusNext(i);
                    ev.preventDefault();
                    break;
            }
        };
        const handlePaste = (ev, i)=>{
            ev.preventDefault();
            const clipboardValue = ev.clipboardData.getData("text").replace(/\D/g, "").split("").slice(0, props.codeLength);
            const newValue = [
                ...Array(props.codeLength).fill(""),
                ...value
            ].slice(0, props.codeLength);
            let lastIndex = i;
            clipboardValue.forEach((char, idx)=>{
                if (i + idx < newValue.length) {
                    newValue[i + idx] = char;
                    lastIndex = i + idx;
                }
            });
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) props.onChange({
                ...ev,
                target: {
                    ...ev.target,
                    value: newValue.join("")
                }
            });
            setTimeout(()=>{
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
            }, 0);
        };
        const handleInput = (ev, i)=>{
            const inputValue = ev.target.value;
            if (inputValue.length > 1) {
                const autofillValues = inputValue.split("").slice(0, props.codeLength);
                const newValue = autofillValues.concat(value.slice(autofillValues.length));
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const lastIndex = autofillValues.length - 1;
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else if (inputValue) {
                const newValue = [
                    ...value
                ];
                newValue[i] = inputValue.slice(-1);
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const nextFocusIndex = Math.min(newValue.join("").length, props.codeLength - 1);
                inputs[nextFocusIndex]?.focus();
                inputs[nextFocusIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else handleChange(ev, i);
        };
        const codes = Array.from({
            length: props.codeLength || 6
        }).map((_, i)=>({
                placeholder: props.placeholder?.[i] || (i + 1).toString(),
                value: value[i] || "",
                onChange: (ev)=>handleChange(ev, i),
                onFocus: (ev)=>handleFocus(ev),
                onKeyDown: (ev)=>handleKeyDown(ev, i),
                onPaste: (ev)=>handlePaste(ev, i),
                onInput: (ev)=>handleInput(ev, i)
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                _codes: codes,
                ariaLabel: props.ariaLabel || `Input code of length ${props.codeLength}`
            }
        });
    };
const $fe5170bdd3625759$var$Component$h = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$g;
    const { disabled: disabled = false, autoComplete: autoComplete = false, autofocus: autofocus = false, state: state = "undefined", onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBackPress: onBackPress = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPaste: onPaste = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            autoComplete: autoComplete,
            autofocus: autofocus,
            state: state,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onBackPress: onBackPress,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCode", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$6d59a84bf808ad3a = $fe5170bdd3625759$var$withLogic$f($fe5170bdd3625759$var$Component$h);
$fe5170bdd3625759$export$6d59a84bf808ad3a.displayName = "InputCode";
$fe5170bdd3625759$export$6d59a84bf808ad3a.slotName = "jds_input_code";
const $fe5170bdd3625759$var$sdl$f = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-date-1.0.0",
        "name": "JDSInputDate",
        "layerName": "jds_input_date",
        "description": "",
        "usage": "Input date component is used to help users enter a memorable date or one they can easily look up for example a date of birth or an expiration date of the credit card."
    },
    "hierarchy": {
        "container": [
            {
                "outer-container": [
                    {
                        "field-container": [
                            "label-jds-text",
                            {
                                "input-container": [
                                    {
                                        "dd-container": [
                                            "dd-jds_input",
                                            {
                                                "dd-active-line-container": [
                                                    "dd-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "left-slash-container",
                                    {
                                        "mm-container": [
                                            "mm-jds_input",
                                            {
                                                "mm-active-line-container": [
                                                    "mm-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "right-slash-container",
                                    {
                                        "yy-container": [
                                            "yy-jds_input",
                                            {
                                                "yy-active-line-container": [
                                                    "yy-feedback-container"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "calendar-container": [
                            "calendar-jds_action_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_feedback_block",
                    "helper-jds-text",
                    "jds_datepicker"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "align-items": "{i_1}",
            "gap": "{i_2}",
            "width": "{i_3}"
        },
        "outer-container": {
            "flex-direction": "{i_4}",
            "width": "{i_5}",
            "align-items": "{i_6}"
        },
        "field-container": {
            "flex": 1,
            "flex-direction": "{i_7}",
            "width": "{i_8}",
            "align-items": "{i_9}"
        },
        "input-container": {
            "width": "{i_10}",
            "gap": "{i_11}",
            "height": 36,
            "align-items": "{i_12}"
        },
        "dd-container": {
            "flex-direction": "{i_13}",
            "flex": 1,
            "gap": "{i_14}",
            "align-items": "{i_15}"
        },
        "dd-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_16}",
            "maxLength": 2,
            "placeholder": "dd"
        },
        "dd-active-line-container": {
            "width": "{i_17}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "dd-feedback-container": {
            "height": 2,
            "width": "{i_18}",
            "background-color": "{i_19}",
            "show": true
        },
        "left-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_20}",
            "show": true
        },
        "mm-container": {
            "flex-direction": "{i_21}",
            "flex": 1,
            "gap": "{i_22}",
            "align-items": "{i_23}"
        },
        "mm-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_24}",
            "maxLength": 2,
            "placeholder": "mm"
        },
        "mm-active-line-container": {
            "width": "{i_25}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "mm-feedback-container": {
            "height": 2,
            "width": "{i_26}",
            "background-color": "{i_27}",
            "show": true
        },
        "right-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_28}",
            "show": true
        },
        "yy-container": {
            "flex-direction": "{i_29}",
            "flex": 1,
            "gap": "{i_30}",
            "align-items": "{i_31}"
        },
        "yy-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_32}",
            "maxLength": 4,
            "placeholder": "yyyy"
        },
        "yy-active-line-container": {
            "width": "{i_33}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "yy-feedback-container": {
            "height": 2,
            "width": "{i_34}",
            "background-color": "{i_35}",
            "show": true
        },
        "calendar-container": {
            "hidden": false,
            "justify-content": "{i_36}",
            "align-items": "{i_37}"
        },
        "calendar-jds_action_button": {
            "kind": "tertiary",
            "size": "medium",
            "icon": "ic_calendar"
        },
        "bottom-container": {
            "flex-direction": "{i_38}",
            "align-items": "{i_39}",
            "gap": "{i_40}",
            "width": "{i_41}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "field-container": {
                    "opacity": "{i_42}",
                    "disabled": true
                },
                "bottom-container": {
                    "opacity": "{i_43}",
                    "disabled": true
                },
                "dd-jds_input": {
                    "disabled": true
                },
                "mm-jds_input": {
                    "disabled": true
                },
                "yy-jds_input": {
                    "disabled": true
                },
                "calendar-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "error": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_44}"
                },
                "mm-feedback-container": {
                    "background-color": "{i_45}"
                },
                "yy-feedback-container": {
                    "background-color": "{i_46}"
                }
            }
        },
        "ddError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_47}"
                }
            }
        },
        "mmError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "mm-feedback-container": {
                    "background-color": "{i_48}"
                }
            }
        },
        "yyError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "yy-feedback-container": {
                    "background-color": "{i_49}"
                }
            }
        },
        "showCalendar": {
            "false": {
                "calendar-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Determines the disabled input field"
            },
            "error": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "The error state of the input"
            },
            "ddError": {
                "values": [
                    false,
                    true
                ]
            },
            "mmError": {
                "values": [
                    false,
                    true
                ]
            },
            "yyError": {
                "values": [
                    false,
                    true
                ]
            },
            "showCalendar": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "dd-jds_input": {
                "value": {
                    "type": "number",
                    "name": "ddValue"
                }
            },
            "mm-jds_input": {
                "value": {
                    "type": "number",
                    "name": "mmValue"
                }
            },
            "yy-jds_input": {
                "value": {
                    "type": "number",
                    "name": "yyValue"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "errorText",
                    "doc_description": "The error text to display"
                }
            },
            "jds_datepicker": {
                "open": {
                    "type": "boolean",
                    "name": "_datepickerOpen"
                },
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "min": {
                    "type": "date",
                    "name": "min",
                    "doc_description": "Defines the min date possible"
                },
                "max": {
                    "type": "date",
                    "name": "max",
                    "doc_description": "Defines the max date possible"
                },
                "value": {
                    "type": "date",
                    "name": "_calendarValue"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "Determines the label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "The helper text to display"
                }
            }
        },
        "events": {
            "calendar-jds_action_button": {
                "onClick": "onCalendarClick"
            },
            "dd-jds_input": {
                "onChange": "onDateChange",
                "onSubmit": "onDateSubmit",
                "onKeydown": {
                    "name": "onDateKeydown",
                    "platform": "web"
                },
                "onBlur": "onDateBlur"
            },
            "mm-jds_input": {
                "onChange": "onMonthChange",
                "onSubmit": "onMonthSubmit",
                "onKeydown": {
                    "name": "onMonthKeydown",
                    "platform": "web"
                },
                "onBlur": "onMonthBlur"
            },
            "yy-jds_input": {
                "onChange": "onYearChange",
                "onSubmit": "onYearSubmit",
                "onKeydown": {
                    "name": "onYearKeydown",
                    "platform": "web"
                },
                "onBlur": "onYearBlur"
            },
            "jds_datepicker": {
                "onClose": "onDatepickerClose",
                "onSelect": "onDatepickerSelect",
                "onConfirm": "onDatepickerSelect"
            }
        },
        "a11y": {
            "dd-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "dateAriaLabel",
                        "value": "Insert day"
                    }
                }
            },
            "mm-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "monthAriaLabel",
                        "value": "Insert month"
                    }
                }
            },
            "yy-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "yearAriaLabel",
                        "value": "Insert year"
                    }
                }
            },
            "calendar-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "datepickerAriaLabel",
                        "value": "Launch datepicker"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DATEPICKER_LAYER_ID = ".j-JDSInputDate-calendar-container";
const $fe5170bdd3625759$var$getNormalisedDate = (value)=>{
    if (!value) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    const date = new Date(value);
    if (!date.getTime()) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
const $fe5170bdd3625759$var$validateYear = (value, min, max)=>{
    const { year: year = 0 } = value;
    const { year: minYear = 0 } = $fe5170bdd3625759$var$getNormalisedDate(min);
    const { year: maxYear = 0 } = $fe5170bdd3625759$var$getNormalisedDate(max);
    if (min && year) {
        if (year < minYear) return false;
    }
    if (max && year) {
        if (year > maxYear) return false;
    }
    return true;
};
const $fe5170bdd3625759$var$validateMonth = (value, min, max)=>{
    if (!$fe5170bdd3625759$var$validateYear(value, min, max)) return false;
    const { year: year, month: month } = value;
    if (!month || month < 1 || month > 12) return false;
    const { year: minYear, month: minMonth = 0 } = $fe5170bdd3625759$var$getNormalisedDate(min);
    const { year: maxYear, month: maxMonth = 0 } = $fe5170bdd3625759$var$getNormalisedDate(max);
    if (year === minYear && month < minMonth) return false;
    if (year === maxYear && month > maxMonth) return false;
    return true;
};
const $fe5170bdd3625759$var$validateDate = (value, min, max)=>{
    const { day: day, month: month, year: year } = value;
    if (!day || !month || !year) return true;
    const currentDate = new Date(year, month - 1, day);
    const minDate = min ? new Date(min) : null;
    const maxDate = max ? new Date(max) : null;
    const isLeapYear = (year2)=>{
        return year2 % 4 === 0;
    };
    const monthsWith30Days = [
        4,
        6,
        9,
        11
    ];
    if (month < 1 || month > 12 || day < 1) return false;
    if (monthsWith30Days.includes(month) && day > 30) return false;
    if (month === 2) {
        if (isLeapYear(year) && day > 29) return false;
        if (!isLeapYear(year) && day > 28) return false;
    } else if (day > 31) return false;
    if (minDate && currentDate < minDate) return false;
    if (maxDate && currentDate > maxDate) return false;
    if (minDate && year === minDate.getFullYear()) {
        if (month < minDate.getMonth() + 1) return false;
        if (month === minDate.getMonth() + 1 && day < minDate.getDate()) return false;
    }
    if (maxDate && year === maxDate.getFullYear()) {
        if (month > maxDate.getMonth() + 1) return false;
        if (month === maxDate.getMonth() + 1 && day > maxDate.getDate()) return false;
    }
    return true;
};
const $fe5170bdd3625759$var$nodeJump = (key, sourceNode, nextNode, prevNode, sourceNodeError)=>{
    switch(key){
        case "Backspace":
            if (!sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select());
            break;
        case "ArrowLeft":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select?.());
            break;
        case "ArrowRight":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>nextNode?.select?.());
            break;
    }
};
const $fe5170bdd3625759$var$getDateFromObject = (obj)=>new Date(obj.year || 0, obj.month || 0, obj.day);
const $fe5170bdd3625759$var$getDateStringFromObject = (obj)=>`${obj.year || ""}/${(obj.month || "").toString().padStart(2, "0")}/${(obj.day || "").toString().padStart(2, "0")}`;
const $fe5170bdd3625759$var$getDisabledsDays = (date, step)=>{
    if (!step) return [];
    const { month: month = 0, year: year = 0 } = date;
    const daysInMonth = new Date(year, month, 0).getDate();
    const numbers = Array.from({
        length: daysInMonth
    }).map((_, i)=>i + 1);
    const filteredNumbers = numbers.filter((i)=>{
        return i % step === 0;
    });
    return filteredNumbers.map((i)=>new Date(year, month - 1, i));
};
const $fe5170bdd3625759$var$withLogic$e = (Component)=>(props)=>{
        const { value: value, datePicker: datePicker, min: min, max: max, error: error, errorText: errorText, errorFieldsObject: errorFieldsObject, setValidity: setValidity, setCustomValidity: setCustomValidity, onChange: onChange, step: step, ...rest } = props;
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(false);
        const [date, setDate] = (0, $acw62.useState)($fe5170bdd3625759$var$getNormalisedDate(value));
        const [element, setElement] = (0, $acw62.useState)(null);
        (0, $acw62.useEffect)(()=>{
            if (value === "") setDate({
                day: void 0,
                month: void 0,
                year: void 0
            });
            else setDate($fe5170bdd3625759$var$getNormalisedDate(value));
        }, [
            value
        ]);
        const [focus, setFocus] = (0, $acw62.useState)({
            dd: false,
            mm: false,
            yy: false
        });
        const { day: day, month: month, year: year } = date;
        const rootRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const datePickerLayer = element?.querySelector($fe5170bdd3625759$var$DATEPICKER_LAYER_ID);
        const inputs = Array.from(element?.querySelectorAll("input") || []);
        const ddInput = inputs.find((input)=>input.placeholder === "dd");
        const mmInput = inputs.find((input)=>input.placeholder === "mm");
        const yyyInput = inputs.find((input)=>input.placeholder === "yyyy");
        const { dd: dd, mm: mm, yyyy: yyyy, errorLocalText: errorLocalText } = setCustomValidity?.(new Date(date.year || 0, date.month || 0, date.day)) || {};
        const userValidated = setValidity?.($fe5170bdd3625759$var$getDateFromObject(date));
        const dayError = !focus.dd && (userValidated || dd || errorFieldsObject?.dd || error || date.day && !$fe5170bdd3625759$var$validateDate(date, min, max) || rest.required && !date.day);
        const monthError = !focus.mm && (userValidated || mm || errorFieldsObject?.mm || error || date.month && !$fe5170bdd3625759$var$validateMonth(date, min, max) || rest.required && !date.month);
        const yearError = !focus.yy && (userValidated || yyyy || errorFieldsObject?.yyyy || error || date.year && !$fe5170bdd3625759$var$validateYear(date, min, max) || rest.required && !date.year);
        const getCurrentDate = ()=>{
            const now = /* @__PURE__ */ new Date();
            return {
                day: now.getDate(),
                month: now.getMonth() + 1,
                year: now.getFullYear()
            };
        };
        const isInvalidDate = (date2)=>{
            return !date2 || isNaN(date2.day ?? NaN) || date2.day === 0 || !$fe5170bdd3625759$var$validateDate(date2) || !$fe5170bdd3625759$var$validateMonth(date2) || isNaN(date2.month ?? NaN) || date2.month === 0 || isNaN(date2.year ?? NaN) || date2.year === 0;
        };
        const formatDate = (date2)=>{
            const mm2 = String(date2.month).padStart(2, "0");
            const dd2 = String(date2.day).padStart(2, "0");
            const yyyy2 = date2.year;
            return `${mm2}-${dd2}-${yyyy2}`;
        };
        const [calendarValue, setCalendarValue] = (0, $acw62.useState)(formatDate(getCurrentDate()));
        (0, $acw62.useEffect)(()=>{
            setCalendarValue(formatDate(isInvalidDate(date) ? getCurrentDate() : date));
        }, [
            date
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                min: min,
                max: max,
                errorText: errorLocalText || errorText,
                _datepickerOpen: selected,
                dateAriaLabel: props.dateAriaLabel || "Input date",
                monthAriaLabel: props.monthAriaLabel || "Input month",
                yearAriaLabel: props.yearAriaLabel || "Input year",
                datepickerAriaLabel: props.datepickerAriaLabel || "Launch datepicker",
                onMonthKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, mmInput, yyyInput, ddInput, monthError);
                },
                onDateKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, ddInput, mmInput, void 0, dayError);
                },
                onYearKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, yyyInput, void 0, mmInput, yearError);
                },
                showCalendar: datePicker,
                onCalendarClick: toggle,
                onDatepickerClose: close,
                rootRef: rootRef,
                disabledDates: $fe5170bdd3625759$var$getDisabledsDays(date, parseInt(step)),
                ddValue: focus.dd ? day : day?.toString().padStart(2, "0") || "",
                mmValue: focus.mm ? month : month?.toString().padStart(2, "0") || "",
                yyValue: focus.yy ? year : year?.toString().padStart(4, "0") || "",
                _calendarValue: calendarValue,
                onDatepickerSelect: (value2)=>{
                    const date2 = $fe5170bdd3625759$var$getNormalisedDate(value2);
                    setDate(date2);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(date2));
                },
                triggerRef: {
                    current: datePickerLayer
                },
                ddError: dayError,
                mmError: monthError,
                yyError: yearError,
                onDateChange: (ev)=>{
                    setFocus({
                        ...focus,
                        dd: true
                    });
                    const currentValue = {
                        ...date,
                        day: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !dayError) setTimeout(()=>mmInput?.select?.());
                },
                onMonthChange: (ev)=>{
                    setFocus({
                        ...focus,
                        mm: true
                    });
                    const currentValue = {
                        ...date,
                        month: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !monthError) setTimeout(()=>yyyInput?.select?.());
                },
                onYearChange: (ev)=>{
                    setFocus({
                        ...focus,
                        yy: true
                    });
                    const currentValue = {
                        ...date,
                        year: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                },
                onDateBlur: ()=>{
                    setFocus({
                        ...focus,
                        dd: false
                    });
                },
                onMonthBlur: ()=>{
                    setFocus({
                        ...focus,
                        mm: false
                    });
                },
                onYearBlur: ()=>{
                    setFocus({
                        ...focus,
                        yy: false
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$g = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$f;
    const { disabled: disabled = false, error: error = false, ddError: ddError = false, mmError: mmError = false, yyError: yyError = false, showCalendar: showCalendar = true, onCalendarClick: onCalendarClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDateChange: onDateChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDateSubmit: onDateSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDateKeydown: onDateKeydown = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDateBlur: onDateBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMonthChange: onMonthChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMonthSubmit: onMonthSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMonthKeydown: onMonthKeydown = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onMonthBlur: onMonthBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onYearChange: onYearChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onYearSubmit: onYearSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onYearKeydown: onYearKeydown = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onYearBlur: onYearBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDatepickerClose: onDatepickerClose = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onDatepickerSelect: onDatepickerSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), dateAriaLabel: dateAriaLabel = "Insert day", monthAriaLabel: monthAriaLabel = "Insert month", yearAriaLabel: yearAriaLabel = "Insert year", datepickerAriaLabel: datepickerAriaLabel = "Launch datepicker", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            error: error,
            ddError: ddError,
            mmError: mmError,
            yyError: yyError,
            showCalendar: showCalendar,
            onCalendarClick: onCalendarClick,
            onDateChange: onDateChange,
            onDateSubmit: onDateSubmit,
            onDateKeydown: onDateKeydown,
            onDateBlur: onDateBlur,
            onMonthChange: onMonthChange,
            onMonthSubmit: onMonthSubmit,
            onMonthKeydown: onMonthKeydown,
            onMonthBlur: onMonthBlur,
            onYearChange: onYearChange,
            onYearSubmit: onYearSubmit,
            onYearKeydown: onYearKeydown,
            onYearBlur: onYearBlur,
            onDatepickerClose: onDatepickerClose,
            onDatepickerSelect: onDatepickerSelect,
            dateAriaLabel: dateAriaLabel,
            monthAriaLabel: monthAriaLabel,
            yearAriaLabel: yearAriaLabel,
            datepickerAriaLabel: datepickerAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputDate", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7ac9d04ce3f22c96 = $fe5170bdd3625759$var$withLogic$e($fe5170bdd3625759$var$Component$g);
$fe5170bdd3625759$export$7ac9d04ce3f22c96.displayName = "InputDate";
$fe5170bdd3625759$export$7ac9d04ce3f22c96.slotName = "jds_input_date";
const $fe5170bdd3625759$var$sdl$e = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-field-1.0.0",
        "name": "JDSInputField",
        "layerName": "jds_input_field",
        "description": "A input field give context to the information that a user needs to input. They're commonly used in forms."
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            {
                                "prefix-container": [
                                    "prefix-slot"
                                ]
                            },
                            "jds_input",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "gap": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_30}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "width": "{i_6}",
            "align-items": "{i_7}",
            "justify-content": "{i_8}",
            "padding-bottom": "{i_9}",
            "animate-stack-alignment": true
        },
        "input-container": {
            "flex-direction": "{i_10}",
            "justify-content": "{i_11}",
            "width": "{i_12}",
            "gap": "{i_13}",
            "padding-top": 20,
            "align-items": "{i_14}",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": false
        },
        "jds_input": {
            "disabled": false,
            "type": "text",
            "textAlign": "{i_17}",
            "rows": 1,
            "flex": 1
        },
        "active-line-container": {
            "flex-direction": "{i_21}",
            "width": "{i_22}",
            "align-items": "{i_23}",
            "padding-bottom": 1,
            "padding-top": 1
        },
        "feedback-container": {
            "width": "{i_24}",
            "height": 2,
            "background-color": "{i_25}",
            "border-radius": 48,
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{i_26}"
                },
                "focus": {
                    "background-color": "{i_27}"
                },
                "active": {
                    "background-color": "{i_28}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "prefix-slot": {
            "disabled": false
        },
        "suffix-slot": {
            "disabled": false
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1,
            "animate-padding-left": true
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_29}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_31}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_32}"
                        },
                        "focus": {
                            "background-color": "{i_33}"
                        },
                        "active": {
                            "background-color": "{i_34}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_35}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_36}"
                        },
                        "focus": {
                            "background-color": "{i_37}"
                        },
                        "active": {
                            "background-color": "{i_38}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_39}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_40}"
                        },
                        "focus": {
                            "background-color": "{i_41}"
                        },
                        "active": {
                            "background-color": "{i_42}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "_hasSuffix": {
            "true": {
                "suffix-icon-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{i_43}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_44}"
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{i_45}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_47}"
                    },
                    "input_label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_48}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_input_phone_dropdown",
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as prefix."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_spinner"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as suffix."
            }
        },
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable InputField."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "type": {
                "type": "JDSInput.type",
                "function": true,
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSuffix": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes value from user for the Input field."
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder",
                    "doc_description": "It displays the placeholder of Input field."
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength",
                    "doc_description": "It can be used to bound user's input within a maximum character limit."
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input field required."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "padding-left": {
                    "type": "size",
                    "name": "_labelOffset"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It dispalys helper text of the input field."
                }
            }
        },
        "events": {
            "prefix-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick",
                "onSlotMeasure": {
                    "name": "onPrefixSlotWidth",
                    "platform": "android"
                }
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Component$f = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$e;
    const { disabled: disabled = false, state: state = "undefined", type: type = "undefined", onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrefixSlotWidth: onPrefixSlotWidth = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            state: state,
            type: type,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onPrefixSlotWidth: onPrefixSlotWidth,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputField", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$dd2171e2b7d3bc5b = $fe5170bdd3625759$var$withLogic$1c($fe5170bdd3625759$var$Component$f);
$fe5170bdd3625759$export$dd2171e2b7d3bc5b.displayName = "InputField";
$fe5170bdd3625759$export$dd2171e2b7d3bc5b.slotName = "jds_input_field";
const $fe5170bdd3625759$var$sdl$d = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-1.0.0",
        "name": "JDSPagination",
        "layerName": "jds_pagination"
    },
    "hierarchy": {
        "container": [
            "first-jds_button",
            "previous-jds_button",
            {
                "basic-container": [
                    "data-jds_pagination_button"
                ]
            },
            {
                "compact-container": [
                    "helper-jds-text"
                ]
            },
            "next-jds_button",
            "last-jds_button"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "justify-content": "{p_2}",
            "align-items": "{p_3}",
            "padding-left": "{p_4}",
            "padding-right": "{p_5}",
            "width": "{p_6}",
            "min-height": "{p_7}"
        },
        "basic-container": {
            "flex-direction": "{p_8}"
        },
        "previous-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "last-jds_button": {
            "hidden": true,
            "icon": "ic_lastpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "first-jds_button": {
            "hidden": true,
            "icon": "ic_firstpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "compact-container": {
            "flex-direction": "{p_9}",
            "hidden": true,
            "gap": "{p_10}",
            "padding-left": "{p_11}",
            "padding-right": "{p_12}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "compact": {
                "compact-container": {
                    "hidden": false
                },
                "basic-container": {
                    "hidden": true
                },
                "last-jds_button": {
                    "hidden": false
                },
                "first-jds_button": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "basic",
                    "compact"
                ]
            }
        },
        "data": {
            "container": {
                "_items.page": {
                    "type": "number",
                    "name": "page"
                },
                "_items.totalPages": {
                    "type": "number",
                    "name": "totalPages"
                }
            },
            "basic-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "text": "string",
                        "state": "JDSPaginationButton.state"
                    }
                }
            },
            "data-jds_pagination_button": {
                "text": {
                    "type": "string",
                    "name": "_items.text"
                },
                "state": {
                    "type": "JDSPaginationButton.state",
                    "name": "_items.state"
                }
            },
            "first-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_firstDisabled"
                }
            },
            "previous-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_previousDisabled"
                }
            },
            "next-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_nextDisabled"
                }
            },
            "last-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_lastDisabled"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_helperText"
                }
            }
        },
        "events": {
            "first-jds_button": {
                "onClick": "onFirst"
            },
            "previous-jds_button": {
                "onClick": "onPrevious"
            },
            "next-jds_button": {
                "onClick": "onNext"
            },
            "last-jds_button": {
                "onClick": "onLast"
            },
            "data-jds_pagination_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "previous-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Page"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Page"
                    }
                }
            },
            "last-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "lastButtonAriaLabel",
                        "value": "Last Page"
                    }
                }
            },
            "first-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "firstButtonAriaLabel",
                        "value": "First Page"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Pagination navigation"
                    },
                    "aria-describedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$ellipsis = {
    state: "ellipsis",
    text: "..."
};
function $fe5170bdd3625759$var$getTruncatedFiniteItems(length, page) {
    if (page <= 4) {
        const start2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        const end2 = {
            state: page === length ? "selected" : "default",
            text: length.toString()
        };
        return [
            ...start2,
            $fe5170bdd3625759$var$ellipsis,
            end2
        ];
    } else if (page >= length - 3) {
        const start2 = {
            state: page === 1 ? "selected" : "default",
            text: "1"
        };
        const end2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: page === index + length - 4 ? "selected" : "default",
                text: `${index + length - 4}`
            }));
        return [
            start2,
            $fe5170bdd3625759$var$ellipsis,
            ...end2
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const end = {
        state: page === length ? "selected" : "default",
        text: length.toString()
    };
    const mid = Array.from({
        length: 3
    }).map((_, index)=>({
            state: index + page - 1 === page ? "selected" : "default",
            text: `${index + page - 1}`
        }));
    return [
        start,
        $fe5170bdd3625759$var$ellipsis,
        ...mid,
        $fe5170bdd3625759$var$ellipsis,
        end
    ];
}
function $fe5170bdd3625759$var$getInfiniteItems(page) {
    if (page <= 5) {
        const start2 = Array.from({
            length: 6
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        return [
            ...start2,
            $fe5170bdd3625759$var$ellipsis
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const mid = Array.from({
        length: 4
    }).map((_, index)=>({
            state: index + page - 2 === page ? "selected" : "default",
            text: `${index + page - 2}`
        }));
    return [
        start,
        $fe5170bdd3625759$var$ellipsis,
        ...mid,
        $fe5170bdd3625759$var$ellipsis
    ];
}
function $fe5170bdd3625759$var$getBasicItems(length, page) {
    return Array.from({
        length: length
    }).map((_, index)=>({
            text: `${index + 1}`,
            state: index + 1 === page ? "selected" : "default"
        }));
}
const $fe5170bdd3625759$var$withLogic$d = (Component)=>(props)=>{
        const { page: page, totalPages: totalPages = 0, onPageChange: onPageChange, kind: kind, ...rest } = props;
        const { index: index, onClick: onClick, updateIndex: updateIndex } = $fe5170bdd3625759$var$useSelected(page);
        const handlePrev = ()=>{
            if (index !== 0) {
                updateIndex(index - 1);
                onPageChange?.(index - 1);
            }
        };
        const handleNext = ()=>{
            if (index !== totalPages) {
                updateIndex(index + 1);
                onPageChange?.(index + 1);
            }
        };
        const handleOnLast = ()=>{
            updateIndex(totalPages);
            onPageChange?.(totalPages);
        };
        const handleOnFirst = ()=>{
            updateIndex(1);
            onPageChange?.(1);
        };
        const items = ()=>{
            const length = totalPages ?? 0;
            const page2 = index ?? 0;
            if (length > 0 && length <= 7) return $fe5170bdd3625759$var$getBasicItems(length, page2);
            else if (length > 7) return $fe5170bdd3625759$var$getTruncatedFiniteItems(length, page2);
            else if (length < 1) return $fe5170bdd3625759$var$getInfiniteItems(page2);
            return [];
        };
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const currentItems = items().map((item, i)=>({
                ...item,
                text: item.text !== "..." ? getLocalNumber(Number(item.text)) : item.text,
                onSelect: ()=>{
                    const { text: text } = item;
                    if (text !== "...") {
                        const currentPage = parseInt(text);
                        onClick(currentPage);
                        onPageChange?.(currentPage);
                    }
                }
            }));
        const firstButtonState = index === 1;
        const lastButtonState = index === totalPages;
        console.log(lastButtonState, 205);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                _items: currentItems,
                kind: kind,
                onPrevious: handlePrev,
                onNext: handleNext,
                _helperText: `${getLocalNumber(index)} / ${getLocalNumber(totalPages)}`,
                onFirst: handleOnFirst,
                onLast: handleOnLast,
                _previousDisabled: firstButtonState,
                _firstDisabled: firstButtonState,
                _lastDisabled: lastButtonState,
                _nextDisabled: lastButtonState
            }
        });
    };
const $fe5170bdd3625759$var$Component$e = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$d;
    const { kind: kind = "basic", onFirst: onFirst = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrevious: onPrevious = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onNext: onNext = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onLast: onLast = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSelect: onSelect = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Page", nextButtonAriaLabel: nextButtonAriaLabel = "Next Page", lastButtonAriaLabel: lastButtonAriaLabel = "Last Page", firstButtonAriaLabel: firstButtonAriaLabel = "First Page", ariaLabel: ariaLabel = "Pagination navigation", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            onFirst: onFirst,
            onPrevious: onPrevious,
            onNext: onNext,
            onLast: onLast,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            lastButtonAriaLabel: lastButtonAriaLabel,
            firstButtonAriaLabel: firstButtonAriaLabel,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPagination", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$68f5e1453c188a82 = $fe5170bdd3625759$var$withLogic$d($fe5170bdd3625759$var$Component$e);
$fe5170bdd3625759$export$68f5e1453c188a82.displayName = "Pagination";
$fe5170bdd3625759$export$68f5e1453c188a82.slotName = "jds_pagination";
const $fe5170bdd3625759$var$sdl$c = {
    "metadata": {
        "version": "1.0.0",
        "id": "promo-card-1.0.0",
        "name": "JDSPromoCard",
        "layerName": "jds_promo_card",
        "description": "Promotional cards are compositions of text and images intended to promote a specific service or feature.",
        "usage": "Promotional cards are used to announce a new feature or motivate users to take an action."
    },
    "hierarchy": {
        "root-container": [
            {
                "vertical-container": [
                    {
                        "vertical-image-container": [
                            "vertical-jds_image",
                            "vertical-promoCardArc"
                        ]
                    },
                    {
                        "vertical-content-container": [
                            "vertical-jds_content_block"
                        ]
                    }
                ]
            },
            {
                "horizontal-container": [
                    {
                        "horizontal-content-container": [
                            "horizontal-jds_content_block"
                        ]
                    },
                    {
                        "horizontal-image-container": [
                            "horizontal-image",
                            "horizontal-promoCardArc"
                        ]
                    }
                ]
            },
            {
                "footer-container": [
                    "prefix-slot",
                    "suffix-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "width": "{p_2}",
            "justify-content": "{p_3}",
            "align-items": "{p_4}",
            "border-radius": "{p_5}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            }
        },
        "vertical-container": {
            "mode": "bold",
            "flex-direction": "{p_6}",
            "align-items": "{p_7}",
            "justify-content": "{p_8}",
            "width": "{p_9}",
            "border-radius": "{p_10}",
            "background-color": "{p_11}",
            "overflow": "hidden"
        },
        "horizontal-container": {
            "hidden": true,
            "mode": "bold",
            "flex-direction": "{p_12}",
            "align-items": "{p_13}",
            "justify-content": "{p_14}",
            "width": "{p_15}",
            "border-radius": "{p_16}",
            "height": "{p_17}",
            "background-color": "{p_18}",
            "overflow": "hidden"
        },
        "vertical-content-container": {
            "flex-direction": "{p_19}",
            "align-items": "{p_20}",
            "justify-content": "{p_21}",
            "width": "{p_22}",
            "mode": "bold",
            "background-color": "{p_23}",
            "border-bottom-left-radius": "{p_24}",
            "border-bottom-right-radius": "{p_25}",
            "padding-right": "{p_26}",
            "padding-bottom": "{p_27}",
            "padding-left": "{p_28}"
        },
        "horizontal-content-container": {
            "flex-direction": "{p_29}",
            "align-items": "{p_30}",
            "justify-content": "{p_31}",
            "height": "{p_32}",
            "mode": "bold",
            "background-color": "{p_33}",
            "flex": 1,
            "padding-top": "{p_34}",
            "padding-right": "{p_35}",
            "padding-bottom": "{p_36}",
            "padding-left": "{p_37}"
        },
        "vertical-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "horizontal-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "vertical-image-container": {
            "width": "{p_38}",
            "flex-direction": "{p_39}",
            "align-items": "{p_40}"
        },
        "horizontal-image-container": {
            "flex": 1,
            "height": "{p_41}",
            "flex-direction": "{p_42}",
            "align-items": "{p_43}",
            "justify-content": "{p_44}"
        },
        "vertical-jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false
        },
        "horizontal-image": {
            "overflow": "hidden",
            "height": "{p_45}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{aspect_ratio.16.9}"
        },
        "vertical-promoCardArc": {
            "mode": "bold",
            "color": "{p_46}",
            "orientation": "vertical",
            "width": "{p_47}",
            "height": "{p_48}",
            "z-index": 1
        },
        "horizontal-promoCardArc": {
            "mode": "bold",
            "color": "{p_49}",
            "orientation": "horizontal",
            "height": "{p_50}",
            "width": "{p_51}",
            "z-index": 1
        },
        "footer-container": {
            "color": "{p_52}",
            "width": "{p_53}",
            "justify-content": "{p_54}",
            "align-items": "{p_55}",
            "flex-direction": "{p_56}",
            "gap": "{p_57}",
            "padding-left": "{p_58}",
            "padding-right": "{p_59}",
            "padding-top": "{p_60}",
            "padding-bottom": "{p_61}",
            "mode": "light",
            "show": false
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "vertical-jds_image": {
                    "aspectRatio": "square"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.1.1}"
                }
            },
            "landscape": {
                "vertical-jds_image": {
                    "aspectRatio": "horizontal_4_3"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.3}"
                }
            },
            "portrait": {
                "vertical-jds_image": {
                    "aspectRatio": "vertical_4_5"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.5}"
                }
            }
        },
        "imageFocus": {
            "left": {
                "vertical-jds_image": {
                    "imageFocus": "left"
                },
                "horizontal-image": {
                    "object-position": "left"
                }
            },
            "right": {
                "vertical-jds_image": {
                    "imageFocus": "right"
                },
                "horizontal-image": {
                    "object-position": "right"
                }
            },
            "top": {
                "vertical-jds_image": {
                    "imageFocus": "top"
                },
                "horizontal-image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "vertical-jds_image": {
                    "imageFocus": "bottom"
                },
                "horizontal-image": {
                    "object-position": "bottom"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "vertical-jds_content_block": {
                    "size": "xtra-small"
                },
                "horizontal-jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "medium": {
                "vertical-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_62}",
                    "padding-right": "{p_63}",
                    "padding-bottom": "{p_64}",
                    "padding-left": "{p_65}"
                }
            },
            "large": {
                "vertical-jds_content_block": {
                    "size": "large"
                },
                "horizontal-jds_content_block": {
                    "size": "large"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_66}",
                    "padding-right": "{p_67}",
                    "padding-bottom": "{p_68}",
                    "padding-left": "{p_69}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "vertical-container": {
                    "hidden": true
                },
                "horizontal-container": {
                    "hidden": false
                }
            }
        },
        "_hasFooter": {
            "false": {
                "footer-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "footerPrefix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerPrefix corresponds to the left part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            },
            "suffix-slot": {
                "name": "footerSuffix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerSuffix corresponds to the right part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            }
        },
        "config": {
            "size": {
                "values": [
                    "small",
                    "xtra-small",
                    "medium",
                    "large"
                ],
                "doc_description": "Determines the size of the PromoCard. Size dictates the text and spacing."
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "imageFocus": {
                "type": "JDSImage.imageFocus",
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFooter": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "horizontal-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "vertical-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "horizontal-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "vertical-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "horizontal-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            },
            "vertical-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "horizontal-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "horizontal-image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$c = (Component)=>(props)=>{
        const { footerPrefix: footerPrefix, footerSuffix: footerSuffix, ...rest } = props;
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\.\w+$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5c2cbe2b2431bcd1$export$e5cf4eff53e7947d), {
            value: {
                ...tokens,
                mode: "bold"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...rest,
                    _hasChildren: Boolean(rest.children),
                    _hasFooter: Boolean(footerPrefix || footerSuffix),
                    children: $fe5170bdd3625759$var$convertTextToComponent(rest.children),
                    footerPrefix: $fe5170bdd3625759$var$convertTextToComponent(footerPrefix),
                    footerSuffix: $fe5170bdd3625759$var$convertTextToComponent(footerSuffix),
                    _imageAriaLabel: formatImageName(props.image)
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$d = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$c;
    const { size: size = "small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", imageFocus: imageFocus = "undefined", shadow: shadow = true, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            imageFocus: imageFocus,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPromoCard", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ad00a5af021e778b = $fe5170bdd3625759$var$withLogic$c($fe5170bdd3625759$var$Component$d);
$fe5170bdd3625759$export$ad00a5af021e778b.displayName = "PromoCard";
$fe5170bdd3625759$export$ad00a5af021e778b.slotName = "jds_promo_card";
const $fe5170bdd3625759$var$sdl$b = {
    "metadata": {
        "version": "1.0.0",
        "id": "radio-button-1.0.0",
        "name": "JDSRadioButton",
        "layerName": "jds_radio_button",
        "description": "Radio buttons are used when there is alist of two or more options that are mutually exclusive and the user must select exactly one choice.",
        "usage": ""
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{r_0}",
            "justify-content": "{r_1}",
            "align-items": "{r_2}",
            "gap": "{r_3}",
            "opacity": "{r_36}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{r_4}",
            "justify-content": "{r_5}",
            "align-items": "{r_6}",
            "gap": "{r_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "outer-container": {
            "hidden": false,
            "min-width": "{r_8}",
            "min-height": "{r_9}",
            "flex-direction": "{r_10}",
            "justify-content": "{r_11}",
            "align-items": "{r_12}",
            "background-color": "{r_13}",
            "border-radius": "{r_14}",
            "border-width": "{r_16}",
            "border-color": "{r_15}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{r_18}"
                },
                "active": {
                    "border-color": "{r_19}"
                },
                "focus": {
                    "border-width": 4,
                    "box-sizing": "content-box",
                    "border-color": "{r_20}"
                }
            }
        },
        "inner-container": {
            "hidden": true,
            "min-width": "{r_21}",
            "min-height": "{r_22}",
            "border-radius": "{r_23}",
            "show": true
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "{r_24}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "small": {
                "outer-container": {
                    "min-width": "{r_25}",
                    "min-height": "{r_26}"
                },
                "vertical-container": {
                    "gap": "{r_27}"
                },
                "inner-container": {
                    "min-width": "{r_28}",
                    "min-height": "{r_29}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "outer-container": {
                    "background-color": "{r_30}",
                    "border-width": "{r_17}",
                    "behavior": {
                        "hover": {
                            "background-color": "{r_31}"
                        },
                        "active": {
                            "background-color": "{r_32}"
                        },
                        "focus": {
                            "background-color": "{r_33}"
                        }
                    }
                },
                "inner-container": {
                    "hidden": false,
                    "background-color": "{r_34}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{r_35}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to programatically make input active/inactive."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$b = (Component)=>(props)=>{
        const handleClick = (ev)=>{
            if (props.onClick) props.onClick({
                ...ev,
                currentTarget: {
                    value: props.value
                },
                target: {
                    value: props.value
                }
            });
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                checked: props.checked,
                onClick: handleClick
            }
        });
    };
const $fe5170bdd3625759$var$Component$c = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$b;
    const { checked: checked = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRadioButton", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$324f219e224c2ba4 = $fe5170bdd3625759$var$withLogic$b($fe5170bdd3625759$var$Component$c);
$fe5170bdd3625759$export$324f219e224c2ba4.displayName = "InputRadio";
$fe5170bdd3625759$export$324f219e224c2ba4.slotName = "jds_radio_button";
const $fe5170bdd3625759$var$sdl$a = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-1.0.0",
        "name": "JDSRatingBar",
        "layerName": "jds_rating_bar"
    },
    "hierarchy": {
        "vertical-container": [
            "top_label-jds-text",
            {
                "horizontal-container": [
                    "left_label-jds-text",
                    "compact-jds_rating_bar_item",
                    {
                        "rating-bar-container": [
                            "jds_rating_bar_item"
                        ]
                    },
                    "right_label-jds-text",
                    "right_support-jds-text"
                ]
            },
            "bottom_label-jds-text",
            "bottom_support-jds-text",
            "jds_feedback_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{r_0}",
            "align-items": "{r_1}",
            "justify-content": "{r_2}",
            "gap": "{r_3}"
        },
        "horizontal-container": {
            "flex-direction": "{r_4}",
            "align-items": "{r_26}",
            "justify-content": "{r_6}",
            "gap": "{r_7}"
        },
        "compact-jds_rating_bar_item": {
            "hidden": true,
            "isInteractive": false,
            "isActive": true,
            "isHalfRated": false,
            "size": "medium"
        },
        "rating-bar-container": {
            "flex-direction": "{r_8}"
        },
        "jds_feedback_block": {
            "size": "l",
            "hidden": true
        },
        "top_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "left_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "vertical-container": {
                    "gap": "{r_9}"
                },
                "horizontal-container": {
                    "gap": "{r_10}"
                },
                "compact-jds_rating_bar_item": {
                    "size": "small"
                },
                "top_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "left_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "bottom_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "bottom_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "large": {
                "compact-jds_rating_bar_item": {
                    "size": "large"
                }
            }
        },
        "labelPosition": {
            "bottom_center": {
                "vertical-container": {
                    "align-items": "{r_11}"
                },
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "bottom_left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "top_center": {
                "vertical-container": {
                    "align-items": "{r_12}"
                }
            },
            "right": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "right_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            },
            "left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "left_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            }
        },
        "type": {
            "read_only_expanded": {
                "rating-bar-container": {
                    "disabled": true
                },
                "jds_rating_bar_item": {
                    "isInteractive": false
                }
            },
            "read_only_compact": {
                "rating-bar-container": {
                    "hidden": true
                },
                "compact-jds_rating_bar_item": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "disabled": true,
                    "opacity": "{r_13}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "read_only_compact": {
                "top_left": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "top_center": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_left": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_center": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "read_only_expanded": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_15}"
                    },
                    "horizontal-container": {
                        "gap": "{r_14}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_16}"
                    },
                    "horizontal-container": {
                        "gap": "{r_17}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_18}"
                    },
                    "horizontal-container": {
                        "gap": "{r_19}"
                    }
                }
            },
            "read_only_compact": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_21}"
                    },
                    "horizontal-container": {
                        "gap": "{r_20}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_22}"
                    },
                    "horizontal-container": {
                        "gap": "{r_23}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_24}"
                    },
                    "horizontal-container": {
                        "gap": "{r_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "labelPosition"
        ],
        [
            "type",
            "size"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "type": "JDSRatingBarItem.size",
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "labelPosition": {
                "values": [
                    "top_left",
                    "bottom_left",
                    "top_center",
                    "bottom_center",
                    "right",
                    "left"
                ]
            },
            "type": {
                "values": [
                    "interactive",
                    "read_only_expanded",
                    "read_only_compact"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "rating-bar-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "isInteractive": "boolean",
                        "isActive": "boolean",
                        "isHalfRated": "boolean",
                        "isHovered": "boolean",
                        "rating": "clipValueSize"
                    }
                },
                "_items.rating": {
                    "type": "float",
                    "name": "rating"
                },
                "_items.count": {
                    "type": "number",
                    "name": "count"
                }
            },
            "jds_rating_bar_item": {
                "size": {
                    "type": "JDSRatingBarItem.size",
                    "name": "size"
                },
                "isInteractive": {
                    "type": "boolean",
                    "name": "_items.isInteractive"
                },
                "isActive": {
                    "type": "boolean",
                    "name": "_items.isActive"
                },
                "isHovered": {
                    "type": "boolean",
                    "name": "_items.isHovered"
                },
                "isHalfRated": {
                    "type": "boolean",
                    "name": "_items.isHalfRated"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "clipValue": {
                    "type": "clipValueSize",
                    "name": "_items.rating"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "top_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "left_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "right_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "bottom_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "right_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            },
            "bottom_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            }
        },
        "events": {
            "jds_rating_bar_item": {
                "onClick": "onChange",
                "onHover": {
                    "name": "_onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "_onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "rating-bar-container": {
                "name": "_items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaChecked": "itemAriaChecked"
                }
            },
            "jds_rating_bar_item": {
                "properties": {
                    "ariaLabel": "_items.itemAriaLabel",
                    "ariaChecked": "_items.itemAriaChecked"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$EPSILON = 5e-3;
const $fe5170bdd3625759$var$withLogic$a = (Component)=>({ rating: rating = -1, ...props })=>{
        const { index: userRating, updateIndex: updateIndex } = $fe5170bdd3625759$var$useSelected(rating);
        const ratingIsInt = Math.abs(Math.floor(userRating) - userRating) < $fe5170bdd3625759$var$EPSILON;
        const [hoverIndex, setHoverIndex] = (0, $acw62.useState)(-1);
        const decimalPart = Math.abs(Math.floor(userRating) - userRating);
        const tokens = (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $5c2cbe2b2431bcd1$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const roundedUserRating = Math.round(userRating);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rating: userRating,
                _role: props.type === "interactive" ? "radiogroup" : "img",
                ariaLabel: props.type === "interactive" ? `${roundedUserRating} star` : `Rated ${roundedUserRating} out of ${props.count} star`,
                _label: props.type === "read_only_compact" ? getLocalNumber(rating) : props.label,
                _onHover: (idx)=>{
                    setHoverIndex(idx);
                },
                _onHoverEnd: (idx)=>{
                    setHoverIndex(idx);
                },
                _items: Array.from({
                    length: props.count || 0
                }).map((_, i)=>{
                    const isHalfRated = !ratingIsInt && i + 1 === Math.ceil(userRating);
                    return {
                        isInteractive: props.type === "interactive",
                        itemAriaLabel: props.type === "interactive" ? `${i + 1} star` : void 0,
                        itemAriaChecked: props.type === "interactive" ? userRating === i + 1 ? "true" : "false" : void 0,
                        isActive: hoverIndex === -1 ? i + 1 <= userRating : i <= hoverIndex,
                        isHalfRated: isHalfRated,
                        rating: isHalfRated ? 100 * (1 - decimalPart) + "%" : void 0,
                        onChange: (index)=>{
                            if (props.type === "interactive") {
                                updateIndex(index + 1);
                                props.onChange?.(index + 1);
                            }
                        }
                    };
                })
            }
        });
    };
const $fe5170bdd3625759$var$Component$b = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$a;
    const { size: size = "undefined", labelPosition: labelPosition = "top_left", type: type = "interactive", disabled: disabled = false, state: state = "undefined", onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            labelPosition: labelPosition,
            type: type,
            disabled: disabled,
            state: state,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBar", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$43a203ef9d36f4e4 = $fe5170bdd3625759$var$withLogic$a($fe5170bdd3625759$var$Component$b);
$fe5170bdd3625759$export$43a203ef9d36f4e4.displayName = "RatingBar";
$fe5170bdd3625759$export$43a203ef9d36f4e4.slotName = "jds_rating_bar";
const $fe5170bdd3625759$var$sdl$9 = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-1.0.0",
        "layerName": "jds_selector",
        "name": "JDSSelector",
        "description": "A selector is a control that allows the user choose a value from a range of options."
    },
    "hierarchy": {
        "container": [
            {
                "selector-container": [
                    "jds_selector_item"
                ]
            },
            {
                "outer-container": [
                    "inner-container"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}"
        },
        "selector-container": {
            "opacity": "{s_1}",
            "align-items": "{s_2}",
            "justify-content": "{s_3}",
            "border-radius": "{s_4}",
            "padding-top": "{s_5}",
            "padding-right": "{s_6}",
            "padding-bottom": "{s_7}",
            "padding-left": "{s_8}",
            "gap": "{s_15}",
            "flex-direction": "{s_16}"
        },
        "jds_selector_item": {
            "wrap": "horizontal",
            "kind": "label_icon"
        },
        "outer-container": {
            "z-index": -1,
            "justify-content": "{s_19}",
            "background-color": "{s_13}",
            "border-radius": "{s_4}",
            "align-items": "{s_20}",
            "padding-top": "{s_9}",
            "padding-right": "{s_10}",
            "padding-bottom": "{s_11}",
            "padding-left": "{s_12}",
            "width": "{s_17}",
            "height": "{s_18}",
            "disabled": true,
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        },
        "inner-container": {
            "background-color": "{s_21}",
            "border-radius": "{s_22}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        }
    },
    "variant": {
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_23}"
                },
                "selector-container": {
                    "width": "{s_24}"
                },
                "jds_selector_item": {
                    "flex": 1,
                    "stretch": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "jds_selector_item": {
                    "wrap": "vertical"
                }
            }
        },
        "kind": {
            "label": {
                "jds_selector_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_selector_item": {
                    "kind": "icon"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to fill the container in which Selector is present."
            },
            "kind": {
                "type": "JDSSelectorItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "type": "JDSSelectorItem.wrap",
                "values": [
                    "horizontal",
                    "vertical"
                ]
            }
        },
        "data": {
            "selector-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "value": "string",
                        "label": "string",
                        "id": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_selector_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "It gives the current index of selected button of Selector. User can overwrite it by passing a new value."
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "id": {
                    "type": "string",
                    "name": "items.id"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                },
                "height": {
                    "type": "size",
                    "name": "_height"
                }
            }
        },
        "events": {
            "jds_selector_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick"
            },
            "container": {
                "onAppear": {
                    "name": "_onSelectorAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "selector-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                },
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "iconAriaLabel": "iconAriaLabel"
                }
            },
            "jds_selector_item": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby",
                    "iconAriaLabel": "items.iconAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$9 = (Component)=>({ items: userItems = [], ...props })=>{
        const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(props.selectedIndex || 0);
        const [dimensions, setDimensions] = (0, $acw62.useState)({
            left: 0,
            width: 0,
            height: 0
        });
        const { rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef((element)=>{
            const updateDimensions = ()=>{
                const selectorContainers2 = Array.from(element?.querySelectorAll("div.j-JDSSelectorItem-container") || []);
                const selectedContainer = selectorContainers2[selectedIndex];
                if (selectedContainer) setDimensions({
                    left: selectedContainer?.offsetLeft,
                    width: selectedContainer?.offsetWidth,
                    height: selectedContainer?.offsetHeight
                });
            };
            updateDimensions();
            const resizeObserver = new ResizeObserver(()=>{
                updateDimensions();
            });
            const selectorContainers = element?.querySelectorAll("div.j-JDSSelectorItem-container") || [];
            selectorContainers.forEach((container)=>{
                resizeObserver.observe(container);
            });
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            selectedIndex,
            props.stretch,
            props.wrap
        ]);
        (0, $acw62.useEffect)(()=>{
            if (typeof props.selectedIndex === "number") setSelectedIndex(props.selectedIndex);
            else setSelectedIndex(0);
        }, [
            props.selectedIndex
        ]);
        const items = userItems.map((item, i)=>({
                ...item,
                selected: selectedIndex === i,
                selectedIndex: selectedIndex,
                onClick: (ev)=>{
                    setSelectedIndex(i);
                    props.onChange?.(item.value, i, ev);
                }
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                selectedIndex: selectedIndex,
                items: items,
                rootRef: rootRef,
                _left: dimensions.left,
                _width: dimensions.width,
                _height: dimensions.height
            }
        });
    };
const $fe5170bdd3625759$var$Component$a = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$9;
    const { stretch: stretch = false, kind: kind = "undefined", wrap: wrap = "undefined", onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelector", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$87e9c2ff338a8575 = $fe5170bdd3625759$var$withLogic$9($fe5170bdd3625759$var$Component$a);
$fe5170bdd3625759$export$87e9c2ff338a8575.displayName = "Selectors";
$fe5170bdd3625759$export$87e9c2ff338a8575.slotName = "jds_selector";
const $fe5170bdd3625759$var$sdl$8 = {
    "metadata": {
        "version": "1.0.0",
        "id": "service-card-1.0.0",
        "name": "JDSServiceCard",
        "layerName": "jds_service_card",
        "description": "Service cards are blocks of images and text aiming to promote and connect services.",
        "usage": "Service cards are used to drive users from one Jio service to another."
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-stack-container": [
                    "blur-image",
                    {
                        "internal-vertical-container": [
                            {
                                "image-container": [
                                    "jds_image"
                                ]
                            },
                            {
                                "content-block-container": [
                                    "jds_content_block"
                                ]
                            }
                        ]
                    }
                ]
            },
            "jds_badge"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{s_0}",
            "size": "{s_2}",
            "justify-content": "{s_4}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "overflow": "hidden"
        },
        "inner-stack-container": {
            "flex-direction": "{s_1}",
            "size": "{s_3}",
            "justify-content": "{s_5}",
            "align-items": "{alignItems.end}",
            "overflow": "hidden"
        },
        "blur-image": {
            "height": "{s_8}",
            "width": "{s_9}",
            "object-fit": "cover",
            "blur-radius": "{s_10}",
            "z-index": 0
        },
        "internal-vertical-container": {
            "flex-direction": "{s_12}",
            "size": "{s_13}",
            "justify-content": "{s_14}",
            "align-items": "{s_15}",
            "z-index": 1
        },
        "image-container": {
            "flex-direction": "{s_16}",
            "justify-content": "{s_17}",
            "align-items": "{s_18}",
            "height": "{s_19}",
            "width": "{s_20}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false,
            "imageFocus": "center"
        },
        "jds_badge": {
            "kind": "service",
            "padding-top": "{s_21}",
            "padding-left": "{s_22}",
            "z-index": 1
        },
        "content-block-container": {
            "background-color": "{s_23}",
            "width": "{s_24}",
            "padding-top": "{s_25}",
            "padding-bottom": "{s_26}",
            "padding-left": "{s_27}",
            "padding-right": "{s_28}"
        },
        "jds_content_block": {
            "size": "xtra-xtra-small",
            "invertCTA": false,
            "ctaWrap": "horizontal",
            "shouldOverrideColor": true,
            "singleButton": true,
            "width": "{s_29}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "true": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_content_block": {
                    "size": "small"
                }
            }
        },
        "_hasFullCardCTA": {
            "true": {
                "root-container": {
                    "behavior": {
                        "hover": {
                            "box-shadow": {
                                "x": 0,
                                "y": 4,
                                "blur": 16,
                                "spread": 0,
                                "color": "#00000014"
                            }
                        }
                    }
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "xtra-xtra-small",
                    "xtra-small",
                    "small"
                ],
                "doc_description": "Determines the size of the ContentBlock. Size dictates the text and spacing. For size=`xxs`, the layout also changes if only a single CTA is sent."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFullCardCTA": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "blur-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds_badge": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "name": "serviceCard"
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge": {
                "properties": {
                    "ariaLabel": "badgeAriaLabel",
                    "ariaDescribedby": {
                        "name": "badgeAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$2 = (props)=>{
    if (typeof props.description === "object") console.warn("passing description as an element is deprecated");
    if (typeof props.image === "object") console.warn("passing image as an element is deprecated");
    return {
        image: {
            properties: {
                image: $fe5170bdd3625759$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        caption: {
            properties: {
                badgeLabel: props.caption?.label,
                badgeIcon: props.caption?.icon
            }
        },
        size: {
            defaultValue: "xxs",
            variations: {
                s: {
                    size: "small"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$8 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$2);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$9 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$8;
    const { size: size = "xtra-xtra-small", imageRatio: imageRatio = "wide", shadow: shadow = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            imageRatio: imageRatio,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSServiceCard", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$47e19cb482b7c646 = $fe5170bdd3625759$var$withLogic$8($fe5170bdd3625759$var$Component$9);
$fe5170bdd3625759$export$47e19cb482b7c646.displayName = "ServiceCard";
$fe5170bdd3625759$export$47e19cb482b7c646.slotName = "jds_service_card";
const $fe5170bdd3625759$var$sdl$7 = {
    "metadata": {
        "version": "1.0.0",
        "id": "slider-1.0.0",
        "name": "JDSSlider",
        "layerName": "jds_slider",
        "description": "Continuous Sliders allow the selection of a value within a given range.",
        "usage": "Use Continuous Sliders whenever it makes easy for the user to select a value within a minimum and maximum range. Sliders work best when the specific value does not matter to the user, but an approximate value is good enough."
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "label-jds-text",
                    {
                        "inner-container": [
                            "value-jds-text",
                            "jds_input"
                        ]
                    }
                ]
            },
            "slider",
            {
                "bottom-container": [
                    "min-jds-text",
                    "max-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{s_0}",
            "justify-content": "{s_1}",
            "align-items": "{s_2}",
            "width": "{s_3}",
            "gap": "{s_4}"
        },
        "top-container": {
            "hidden": false,
            "flex-direction": "{s_5}",
            "justify-content": "{s_6}",
            "align-items": "{s_7}",
            "width": "{s_8}",
            "gap": "{s_9}"
        },
        "inner-container": {
            "hidden": false,
            "height": 32,
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-right": "{s_14}",
            "border-width": "{s_15}",
            "border-color": "{s_16}",
            "border-radius": "{s_17}"
        },
        "jds_input": {
            "disabled": false,
            "hidden": true,
            "type": "number",
            "textAlign": "end",
            "rows": 1,
            "width": 93
        },
        "slider": {
            "width": "{s_18}",
            "track-height": "{s_19}",
            "inactive-color": "{s_20}",
            "active-color": "{s_21}",
            "ball-size": 20,
            "ball-color": "{s_22}",
            "ball-border-color": "{s_23}",
            "ball-border-width": 0,
            "border-radius": "{s_24}",
            "behavior": {
                "hover": {
                    "ball-color": "{s_25}"
                },
                "active": {
                    "active-color": "{s_26}",
                    "ball-color": "{s_27}"
                },
                "focus": {
                    "ball-border-width": "{s_28}"
                }
            }
        },
        "bottom-container": {
            "hidden": false,
            "show": false,
            "flex-direction": "{s_29}",
            "justify-content": "{s_30}",
            "align-items": "{s_31}",
            "width": "{s_32}"
        },
        "jds_feedback_block": {
            "size": "s",
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "flex": 1,
            "justify-content": "{s_10}",
            "align-items": "{s_11}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "value-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "min-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "max-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideMinMaxLabel": {
            "true": {
                "bottom-container": {
                    "hidden": true
                }
            }
        },
        "editableTextBox": {
            "true": {
                "jds_input": {
                    "hidden": false
                },
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "state": {
            "success": {
                "inner-container": {
                    "border-color": "{s_33}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "inner-container": {
                    "border-color": "{s_34}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "inner-container": {
                    "border-color": "{s_35}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_36}"
                },
                "jds_input": {
                    "disabled": true
                },
                "slider": {
                    "disabled": true,
                    "behavior": {
                        "hover": {
                            "ball-color": "{s_37}"
                        },
                        "active": {
                            "active-color": "{s_38}",
                            "ball-color": "{s_39}"
                        },
                        "focus": {
                            "ball-border-width": 0
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_hideMinMaxLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "editableTextBox": {
                "values": [
                    false,
                    true
                ],
                "doc_description": " It allows user to input their own number in the text box that moves the slider value. By default this textbox is in readonly mode."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "slider": {
                "step": {
                    "type": "number",
                    "name": "step",
                    "doc_description": "It determines number of divisions slider should slide by."
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "value": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Slider."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                }
            },
            "min-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMin"
                }
            },
            "max-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMax"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Slider."
                }
            }
        },
        "events": {
            "slider": {
                "onChange": "onValueChange",
                "onEditChange": {
                    "name": "onEditChange",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "slider": {
                "name": "container",
                "properties": {
                    "role": {
                        "value": "slider"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "prop": "value",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "prop": "min",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "prop": "max",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$1 = (props)=>({
        onChange: {
            properties: {
                onChange: props.onChange,
                onValueChange: props.onChange
            }
        }
    });
function $fe5170bdd3625759$var$getSteppedValue(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $fe5170bdd3625759$var$clamp(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $fe5170bdd3625759$var$clamp = (value, min, max)=>Math.max(min, Math.min(value, max));
const $fe5170bdd3625759$var$withLogic$7 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$1);
        const { value: userValue = 0 } = props;
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const [value, setValue] = (0, $acw62.useState)(userValue);
        const [inputValue, setInputValue] = (0, $acw62.useState)(userValue);
        (0, $acw62.useEffect)(()=>{
            setValue(userValue);
            setInputValue(userValue);
        }, [
            userValue
        ]);
        const getSuffixValue = (value2, editable)=>{
            if (editable) return value2;
            return Intl.NumberFormat().format(value2);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                value: value,
                valueSuffix: getSuffixValue(inputValue, props.editableTextBox),
                state: inputState,
                stateText: stateText || props.stateText,
                onInvalid: onInvalid,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                max: props.max || 100,
                min: props.min || 0,
                onBlur: (ev)=>{
                    const currentValue = ev.target.value ? parseInt(ev.target.value) : value;
                    const steppedValue = $fe5170bdd3625759$var$getSteppedValue(currentValue, props.step, props.min, props.max);
                    setValue(steppedValue);
                    const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                    tracker?.call(ev.target, currentValue);
                    setInputValue(steppedValue);
                    props?.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: steppedValue
                        }
                    });
                },
                onChange: (ev)=>{
                    setInputValue(parseInt(ev.target.value));
                },
                onValueChange: (ev)=>{
                    setValue(parseInt(ev.target.value));
                    setInputValue(ev.target.value);
                    props?.onChange?.(ev);
                },
                labelMin: Intl.NumberFormat().format(props.min || 0),
                labelMax: Intl.NumberFormat().format(props.max || 100)
            }
        });
    };
const $fe5170bdd3625759$var$Component$8 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$7;
    const { editableTextBox: editableTextBox = false, state: state = "undefined", disabled: disabled = false, onValueChange: onValueChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onEditChange: onEditChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaValuenow: _ariaValuenow = props.value?.toString(), _ariaValuemin: _ariaValuemin = props.min?.toString(), _ariaValuemax: _ariaValuemax = props.max?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            editableTextBox: editableTextBox,
            state: state,
            disabled: disabled,
            onValueChange: onValueChange,
            onEditChange: onEditChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaValuenow: _ariaValuenow,
            _ariaValuemin: _ariaValuemin,
            _ariaValuemax: _ariaValuemax,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSlider", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$97be854b3aad3c92 = $fe5170bdd3625759$var$withLogic$7($fe5170bdd3625759$var$Component$8);
$fe5170bdd3625759$export$97be854b3aad3c92.displayName = "InputSlider";
$fe5170bdd3625759$export$97be854b3aad3c92.slotName = "jds_slider";
const $fe5170bdd3625759$var$sdl$6 = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-1.0.0",
        "name": "JDSTable",
        "layerName": "jds_table",
        "description": "Simple tables display information in a tabular data format with rows and columns. The organize information in a way that's easy to scan so that users can look for patterns and develop insights from data.",
        "usage": "Simple tables are used on wide viewports only or whenever their layout can easily fit in the screen - not too many columns."
    },
    "hierarchy": {
        "container": [
            "jds_table_body",
            "footer-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "border-radius": "{t_2}",
            "border-width": "{t_3}",
            "border-color": "{t_4}",
            "overflow": "hidden",
            "align-items": "{t_6}"
        },
        "footer-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{t_7}",
            "padding-right": "{t_8}",
            "padding-top": "{t_9}",
            "padding-bottom": "{t_10}",
            "hidden": true
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_body": {
                    "density": "condensed"
                },
                "footer-jds-text": {
                    "padding-left": "{t_11}",
                    "padding-right": "{t_12}",
                    "padding-top": "{t_13}",
                    "padding-bottom": "{t_14}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_body": {
                    "columnDivider": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_5}"
                },
                "jds_table_body": {
                    "fullWidth": true
                }
            }
        },
        "_hasFooter": {
            "true": {
                "footer-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Show/hide border between columns."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasFooter": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_table_body": {
                "rows": {
                    "name": "rows",
                    "type": "list",
                    "object": {
                        "cells": "list"
                    },
                    "doc_description": "Pass rows as an array of objects {[HEADER_NAME_1]?: , [HEADER_NAME_2]?:...}, where each row is an object where:\n- the properties are equal to header names\n- values are displayed in columns\n- properties for non-existent header.name are ignored, warning is displayed\n- missing header property results in empty column"
                },
                "zebra": {
                    "type": "boolean",
                    "name": "zebra"
                },
                "background": {
                    "type": "boolean",
                    "name": "background"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer",
                    "doc_description": "Optional text at the bottom."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "table"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "table"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$6 = (Component)=>(props)=>{
        const isZebra = props.rowStyle === "zebra" || props.zebra;
        const rows = props.headers.map((header)=>({
                cells: [
                    {
                        text: header.value,
                        type: "header",
                        background: props.headerBackground || props.background
                    },
                    ...props.rows.map((row, i)=>({
                            text: row[header.name] || `\xa0`,
                            background: isZebra && i % 2 === 0
                        }))
                ]
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                background: Boolean(props.headerBackground),
                _hasFooter: Boolean(props.footer)
            }
        });
    };
const $fe5170bdd3625759$var$Component$7 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$6;
    const { density: density = "undefined", background: background = false, columnDivider: columnDivider = false, fullWidth: fullWidth = false, ariaLabel: ariaLabel = "table", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            background: background,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTable", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$54ec01a60f47d33d = $fe5170bdd3625759$var$withLogic$6($fe5170bdd3625759$var$Component$7);
$fe5170bdd3625759$export$54ec01a60f47d33d.displayName = "Table";
$fe5170bdd3625759$export$54ec01a60f47d33d.slotName = "jds_table";
const $fe5170bdd3625759$var$sdl$5 = {
    "metadata": {
        "version": "1.0.1",
        "id": "test-1.0.1",
        "name": "TestComponent",
        "layerName": "test_component",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "heading-text",
            "icon",
            "image"
        ]
    },
    "base": {
        "container": {
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "background-color": "blue",
            "border-color": "",
            "border-radius": "",
            "border-width": "",
            "border-style": "",
            "height": "",
            "width": "",
            "max-height": "",
            "min-height": "",
            "max-width": "",
            "min-width": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "opacity": "",
            "align-items": "",
            "justify-content": "",
            "flex-direction": "",
            "gap": "",
            "display": "",
            "outline": "",
            "pointer-events": "",
            "cursor": "",
            "z-index": ""
        },
        "heading-text": {
            "color": "#f4f4f4",
            "align-items": "",
            "flex-direction": "",
            "font-family": "",
            "font-size": "",
            "font-weight": "",
            "gap": "",
            "justify-content": "",
            "letter-spacing": "",
            "line-height": "",
            "opacity": "",
            "outline": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "pointer-events": "",
            "width": "",
            "z-index": "",
            "text-decoration": "",
            "text-overflow": "",
            "text-transform": ""
        },
        "icon": {
            "background-color": "",
            "color": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "height": "24",
            "width": "24",
            "size": "{m}",
            "opacity": "",
            "outline": "",
            "justify-content": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "align-items": "",
            "box-sizing": ""
        },
        "image": {
            "align-items": "",
            "aspect-ratio": "{aspect_ratio.1.1}",
            "border-radius": "",
            "opacity": "",
            "hidden": true,
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "pointer-events": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "object-fit": "",
            "object-position": ""
        }
    },
    "variant": {
        "kind": {
            "SERVICE": {
                "container": {
                    "border-radius": "{pill}",
                    "background-color": "#75757580",
                    "padding-top": "{xxs}",
                    "padding-left": "{xxs}",
                    "padding-right": "{s}",
                    "padding-bottom": "{xxs}",
                    "gap": "{xs}"
                },
                "heading-text": {
                    "appearance": "BODY_M_BOLD",
                    "color": "WHITE"
                },
                "icon": {
                    "size": "{m}",
                    "color": "{global.transparent}"
                }
            }
        }
    },
    "api": {
        "data": {
            "heading-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "NORMAL",
                    "SERVICE"
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$5 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$6 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$5;
    const { kind: kind = "NORMAL", custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            ...rest
        },
        componentTag: componentTag
    }, "TestComponent", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d8fd24743e1b801f = $fe5170bdd3625759$var$withLogic$5($fe5170bdd3625759$var$Component$6);
$fe5170bdd3625759$export$d8fd24743e1b801f.displayName = "TestComponent";
$fe5170bdd3625759$export$d8fd24743e1b801f.slotName = "test_component";
const $fe5170bdd3625759$var$sdl$4 = {
    "metadata": {
        "version": "1.0.0",
        "id": "textarea-1.0.0",
        "name": "JDSTextarea",
        "layerName": "jds_textarea",
        "description": "A Textarea lets a user input a longer amount of text than an input field, typically spanning across multiple lines.",
        "usage": "Use a textarea when the input being expected is likely to extend beyond one line."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            "input"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "gap": "{t_3}",
            "width": "{t_4}",
            "opacity": "{t_42}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{t_5}",
            "width": "{t_6}",
            "padding-bottom": "{t_7}",
            "justify-content": "{t_8}",
            "align-items": "{t_9}"
        },
        "input-container": {
            "flex-direction": "{t_10}",
            "justify-content": "{t_11}",
            "width": "{t_12}",
            "padding-top": 20,
            "align-items": "{t_13}",
            "z-index": 0
        },
        "input": {
            "disabled": false,
            "type": "textarea",
            "flex": 1,
            "text-align": "{t_14}",
            "placeholder-color": "{t_15}",
            "placeholder-font-family": "{t_16}",
            "placeholder-font-size": "{t_17}",
            "placeholder-line-height": "{t_18}",
            "placeholder-letter-spacing": "{t_19}",
            "placeholder-font-weight": "{t_20}",
            "input-color": "{t_21}",
            "input-font-family": "{t_22}",
            "input-font-size": "{t_23}",
            "input-line-height": "{t_24}",
            "input-letter-spacing": "{t_25}",
            "input-font-weight": "{t_26}",
            "resize-color": "{t_27}",
            "cursor-color": "{t_28}",
            "width": "{t_29}",
            "behavior": {
                "hover": {
                    "resize-color": "{t_30}"
                },
                "focus": {
                    "resize-color": "{t_31}"
                },
                "active": {
                    "resize-color": "{t_32}"
                }
            }
        },
        "active-line-container": {
            "flex-direction": "{t_33}",
            "width": "{t_34}",
            "align-items": "{t_35}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{t_36}",
            "height": 2,
            "background-color": "{t_37}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{t_38}"
                },
                "focus": {
                    "background-color": "{t_39}"
                },
                "active": {
                    "background-color": "{t_40}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-border-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "hidden": true,
            "maxLines": 1
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{t_41}"
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "input-container": {
                    "padding-top": "{t_45}"
                },
                "field-container": {
                    "border-width": "{t_43}",
                    "border-color": "{t_44}",
                    "border-radius": "{t_46}",
                    "padding-top": "{t_45}",
                    "padding-bottom": "{t_47}",
                    "padding-left": "{t_48}",
                    "padding-right": "{t_49}"
                },
                "input_label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{t_50}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_51}"
                        },
                        "focus": {
                            "background-color": "{t_52}"
                        },
                        "active": {
                            "background-color": "{t_53}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_50}"
                },
                "input": {
                    "resize-color": "{t_54}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_55}"
                        },
                        "focus": {
                            "resize-color": "{t_56}"
                        },
                        "active": {
                            "resize-color": "{t_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{t_58}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_59}"
                        },
                        "focus": {
                            "background-color": "{t_60}"
                        },
                        "active": {
                            "background-color": "{t_61}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_58}"
                },
                "input": {
                    "resize-color": "{t_62}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_63}"
                        },
                        "focus": {
                            "resize-color": "{t_64}"
                        },
                        "active": {
                            "resize-color": "{t_65}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{t_66}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_67}"
                        },
                        "focus": {
                            "background-color": "{t_68}"
                        },
                        "active": {
                            "background-color": "{t_69}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_66}"
                },
                "input": {
                    "resize-color": "{t_70}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_71}"
                        },
                        "focus": {
                            "resize-color": "{t_72}"
                        },
                        "active": {
                            "resize-color": "{t_73}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_labelFocus": {
            "true": {
                "field-container": {
                    "align-items": "{t_74}"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}",
                    "padding-top": 0
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{t_75}"
                    },
                    "input": {
                        "resize-color": "{t_76}"
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "field-container": {
                        "border-color": "{t_77}"
                    },
                    "input": {
                        "input-color": "{t_79}",
                        "disabled": true,
                        "resize-color": "{t_78}",
                        "behavior": {
                            "hover": {
                                "resize-color": "{t_78}"
                            },
                            "focus": {
                                "resize-color": "{t_78}"
                            },
                            "active": {
                                "resize-color": "{t_78}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ],
        [
            "border",
            "readOnly"
        ]
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "border": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can change the border of textArea"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It is used when border is set to true"
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "minLines": {
                    "type": "number",
                    "name": "minLines"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Textarea."
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": "ariaInvalid",
                    "aria-placeholder": {
                        "name": "_ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$4 = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $fe5170bdd3625759$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                _labelFocus: focused,
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $fe5170bdd3625759$var$Component$5 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$4;
    const { disabled: disabled = false, border: border = false, state: state = "undefined", readOnly: readOnly = false, onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPlaceholder: _ariaPlaceholder = props.placeholder?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            border: border,
            state: state,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaPlaceholder: _ariaPlaceholder,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTextarea", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3d88bd58d836b21e = $fe5170bdd3625759$var$withLogic$4($fe5170bdd3625759$var$Component$5);
$fe5170bdd3625759$export$3d88bd58d836b21e.displayName = "InputTextarea";
$fe5170bdd3625759$export$3d88bd58d836b21e.slotName = "jds_textarea";
const $fe5170bdd3625759$var$sdl$3 = {
    "metadata": {
        "version": "1.0.0",
        "id": "toggle-1.0.0",
        "name": "JDSToggle",
        "description": "Interaction element for decision making that may or may not be accompanied by a label, depending on the context of use.",
        "layerName": "jds_toggle"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "prefix-icon-container": [
                            {
                                "toggle-jds-icon-container": [
                                    "toggle-jds-icon"
                                ]
                            }
                        ]
                    },
                    "left-jds-text",
                    {
                        "pill-container": [
                            "ball-container"
                        ]
                    },
                    "right-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{t_1}",
            "justify-content": "{t_2}",
            "align-items": "{t_3}",
            "gap": "{t_4}",
            "opacity": "{t_42}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{t_5}",
            "justify-content": "{t_6}",
            "align-items": "{t_7}",
            "gap": "{t_8}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "pill-container": {
            "hidden": false,
            "min-width": "{t_9}",
            "min-height": "{t_10}",
            "flex-direction": "{t_11}",
            "justify-content": "{t_12}",
            "align-items": "{t_13}",
            "padding-left": "{t_14}",
            "padding-right": "{t_15}",
            "background-color": "{t_16}",
            "border-radius": "{t_17}",
            "border-width": "{t_18}",
            "border-color": "{t_19}",
            "behavior": {
                "hover": {
                    "border-color": "{t_20}"
                },
                "active": {
                    "border-color": "{t_21}"
                },
                "focus": {
                    "border-width": "{t_24}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{t_22}",
                        "color": "{t_23}"
                    }
                }
            }
        },
        "ball-container": {
            "hidden": false,
            "min-width": "{t_25}",
            "min-height": "{t_26}",
            "background-color": "{t_27}",
            "border-radius": "{t_28}",
            "show": true
        },
        "prefix-icon-container": {
            "flex-direction": "{t_0}"
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "left-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{t_29}",
            "flex-fill-android": false,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "right-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "toggle-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "toggle-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "pill-container": {
                    "min-width": "{t_30}",
                    "min-height": "{t_31}"
                },
                "vertical-container": {
                    "gap": "{t_32}"
                },
                "ball-container": {
                    "min-width": "{t_33}",
                    "min-height": "{t_34}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "left-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "right-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "toggle-jds-icon": {
                    "size": "{base}"
                },
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "labelPosition": {
            "right": {
                "left-jds-text": {
                    "hidden": true
                },
                "right-jds-text": {
                    "hidden": false
                }
            }
        },
        "_hasIcon": {
            "false": {
                "prefix-icon-container": {
                    "hidden": true
                }
            }
        },
        "checked": {
            "true": {
                "pill-container": {
                    "justify-content": "{t_35}",
                    "background-color": "{t_36}",
                    "border-width": "{t_37}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_38}"
                        },
                        "active": {
                            "background-color": "{t_39}"
                        }
                    }
                },
                "ball-container": {
                    "background-color": "{t_40}"
                },
                "left-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "right-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "toggle-jds-icon": {},
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "horizontal-container": {
                    "disabled": true
                },
                "prefix-icon-container": {
                    "disabled": true
                },
                "vertical-container": {
                    "opacity": "{t_41}"
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programatically make input active/inactive."
            },
            "labelPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to position lable to either left or right of Toggle."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Toggle."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Toggle."
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to show or hide the prefix icon container."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "left-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "right-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "toggle-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                },
                "ic": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Toggle."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            },
            "prefix-icon-container": {
                "onClick": "onPrefixClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "switch"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useSwitch = (value)=>{
    const [switchState, setSwitchState] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setSwitchState(Boolean(value));
    }, [
        value
    ]);
    return {
        switchState: switchState,
        onChange: (value2)=>setSwitchState(value2)
    };
};
const $fe5170bdd3625759$var$withLogic$3 = (Component)=>(props)=>{
        const { switchState: switchState, onChange: onChange } = $fe5170bdd3625759$var$useSwitch(props.checked);
        const { stateText: stateText, inputState: inputState } = $fe5170bdd3625759$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasIcon: Boolean(props.icon || props.prefix),
                state: inputState,
                stateText: stateText,
                icon: props.icon,
                checked: switchState,
                onClick: (ev)=>{
                    onChange?.(!switchState);
                    props.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: props.value || "",
                            checked: !switchState
                        }
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$4 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$3;
    const { checked: checked = false, labelPosition: labelPosition = "left", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            labelPosition: labelPosition,
            size: size,
            disabled: disabled,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToggle", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ed3c6fc36a947b6a = $fe5170bdd3625759$var$withLogic$3($fe5170bdd3625759$var$Component$4);
$fe5170bdd3625759$export$ed3c6fc36a947b6a.displayName = "InputToggle";
$fe5170bdd3625759$export$ed3c6fc36a947b6a.slotName = "jds_toggle";
const $fe5170bdd3625759$var$sdl$2 = {
    "metadata": {
        "version": "2.0.0",
        "id": "input-field-2.0.0",
        "name": "JDSInputFieldV2",
        "layerName": "jds_input_field_v2"
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "input_label-jds-text",
                    "info-slot"
                ]
            },
            {
                "input-container": [
                    "prefix-slot",
                    "jds_input",
                    "suffix-slot"
                ]
            },
            {
                "helper-container": [
                    "jds_feedback_block",
                    "helper-jds-text"
                ]
            },
            {
                "dynamic-container": [
                    "dynamic-jds-text",
                    "dynamic-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_5}",
            "gap": "{i_9}"
        },
        "label-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "gap": "{i_9}"
        },
        "input-container": {
            "flex-direction": "{i_13}",
            "justify-content": "{i_14}",
            "align-items": "{i_15}",
            "width": "{i_16}",
            "height": "{i_17}",
            "gap": "{i_18}",
            "padding-left": "{i_19}",
            "padding-right": "{i_20}",
            "border-width": "{i_23}",
            "border-color": "{i_24}",
            "border-radius": "{i_26}",
            "behavior": {
                "hover": {
                    "border-color": "{i_27}"
                },
                "active": {
                    "border-color": "{i_28}"
                },
                "focus": {
                    "border-color": "{i_29}"
                }
            }
        },
        "jds_input": {
            "type": "text",
            "textAlign": "{i_30}",
            "rows": 1,
            "flex": "{i_31}"
        },
        "helper-container": {
            "flex-direction": "{i_32}",
            "justify-content": "{i_33}",
            "align-items": "{i_34}",
            "gap": "{i_35}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none",
            "alignment": "top"
        },
        "dynamic-container": {
            "flex-direction": "{i_40}",
            "justify-content": "{i_41}",
            "align-items": "{i_42}",
            "gap": "{i_36}",
            "hidden": false
        },
        "dynamic-jds_action_button": {
            "kind": "tertiary",
            "size": "small"
        },
        "input_label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "dynamic-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey60}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_hasDynamic": {
            "false": {
                "dynamic-container": {
                    "hidden": true
                }
            }
        },
        "_noPrefix": {
            "true": {
                "input-container": {
                    "padding-left": "{i_0}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_45}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "input-container": {
                    "border-color": "{i_46}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_47}"
                        },
                        "focus": {
                            "border-color": "{i_48}"
                        },
                        "active": {
                            "border-color": "{i_49}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "input-container": {
                    "border-color": "{i_50}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_51}"
                        },
                        "focus": {
                            "border-color": "{i_52}"
                        },
                        "active": {
                            "border-color": "{i_53}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "input-container": {
                    "border-color": "{i_54}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_55}"
                        },
                        "focus": {
                            "border-color": "{i_56}"
                        },
                        "active": {
                            "border-color": "{i_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "size": {
            "small": {
                "input-container": {
                    "height": "{i_58}"
                }
            },
            "large": {
                "input-container": {
                    "height": "{i_61}",
                    "gap": "{i_62}",
                    "padding-left": "{i_63}",
                    "padding-right": "{i_64}"
                },
                "jds_feedback_block": {
                    "size": "l"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "dynamic-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "pin": {
                "jds_input": {
                    "type": "number",
                    "letterSpacing": 12,
                    "textAlign": "center"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "readOnly": {
            "true": {
                "jds_input": {
                    "readOnly": true,
                    "color": "primary_grey_80"
                },
                "input-container": {
                    "border-color": "{i_25}"
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_input_phone_dropdown"
                ],
                "function": true
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_button",
                    "jds_icon",
                    "jds_spinner"
                ],
                "function": true
            },
            "info-slot": {
                "name": "info",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "_hasDynamic": {
                "values": [
                    true,
                    false
                ]
            },
            "_noPrefix": {
                "values": [
                    true,
                    false
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "pin",
                    "phone"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "dynamic-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            },
            "dynamic-jds-text": {
                "value": {
                    "type": "string",
                    "name": "dynamicText"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            },
            "dynamic-jds_action_button": {
                "onClick": "onButtonClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            },
            "dynamic-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "dynamicButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "dynamicButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2 = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        const handlephonetype = (event)=>{
            const { value: value } = event.target;
            if (props.type === "phone") {
                const filteredValue = value.replace(/[^\d+]/g, "");
                event.target.value = filteredValue;
            }
            props.onChange?.(event);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                layerRefs: {
                    input: ref
                }
            },
            prefix: $fe5170bdd3625759$var$getIcon(props.prefix, handlePrefixClick),
            suffix: $fe5170bdd3625759$var$getIcon(props.suffix, handleSuffixClick),
            label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
            _hasDynamic: Boolean(props.dynamicText || props.dynamicButtonText),
            _noPrefix: !props.prefix,
            onChange: handlephonetype
        });
    });
const $fe5170bdd3625759$var$Component$3 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2;
    const { state: state = "undefined", size: size = "medium", type: type = "text", disabled: disabled = false, readOnly: readOnly = false, onFocus: onFocus = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onBlur: onBlur = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onChange: onChange = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onInvalid: onInvalid = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSubmit: onSubmit = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), onButtonClick: onButtonClick = (0, $5c2cbe2b2431bcd1$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), dynamicButtonAriaLabel: dynamicButtonAriaLabel = props.dynamicButtonText?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            size: size,
            type: type,
            disabled: disabled,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            onButtonClick: onButtonClick,
            ariaLabel: ariaLabel,
            dynamicButtonAriaLabel: dynamicButtonAriaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputFieldV2", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ac0438506784559a = $fe5170bdd3625759$var$withLogic$2($fe5170bdd3625759$var$Component$3);
$fe5170bdd3625759$export$ac0438506784559a.displayName = "InputFieldV2";
$fe5170bdd3625759$export$ac0438506784559a.slotName = "jds_input_field_v2";
const $fe5170bdd3625759$var$PROP_MAP = (props)=>({
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                feedback_error_80: {
                    color: "feedback_error_80"
                },
                "feedback-error_50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        text: {
            properties: {
                text: props.text
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    });
const $fe5170bdd3625759$var$Component$2 = ({ children: children, ...props })=>{
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)($fe5170bdd3625759$var$Jdstext, {
        ...props,
        text: props.text || children
    }, "JDSText", $fe5170bdd3625759$var$componentsMap);
};
const $fe5170bdd3625759$export$a8a3e93435678ff9 = $fe5170bdd3625759$var$withModifiedProps($fe5170bdd3625759$var$Component$2, $fe5170bdd3625759$var$PROP_MAP);
$fe5170bdd3625759$export$a8a3e93435678ff9.defaultProps = {
    as: "h1"
};
const $fe5170bdd3625759$var$CSSTransition = (props)=>{
    const { in: _in, appear: appear, children: children, className: className, timeout: timeout = 150, onEntered: onEntered, onExited: onExited, unmountOnExit: unmountOnExit, enter: enter, exit: exit, ...rest } = props;
    const rootPrefixedClassNames = (root, ...classList)=>$fe5170bdd3625759$var$makeClass([
            root,
            ...classList.map((classN)=>`${root}-${classN}`)
        ]);
    const [classes, setClasses] = (0, $acw62.useState)(rootPrefixedClassNames(className, "initial"));
    const [status, setStatus] = (0, $acw62.useState)(_in ? 1 /* ENTERING */  : 3 /* EXITED */ );
    const [_appear, setAppear] = (0, $acw62.useState)(appear);
    (0, $acw62.useEffect)(()=>{
        if (_in && (appear || enter)) {
            setStatus(1 /* ENTERING */ );
            setTimeout(()=>setStatus(0 /* ENTERED */ ), timeout);
            setAppear(false);
        } else if (!_appear || exit) {
            setAppear(appear);
            setStatus(2 /* EXITING */ );
            setTimeout(()=>setStatus(3 /* EXITED */ ), timeout);
        }
        return ()=>{
            setStatus(3 /* EXITED */ );
        };
    }, [
        _in
    ]);
    (0, $acw62.useEffect)(()=>{
        switch(status){
            case 1 /* ENTERING */ :
                setClasses($fe5170bdd3625759$var$makeClass([
                    className,
                    `${className}-enter`,
                    "enter-active"
                ]));
                break;
            case 0 /* ENTERED */ :
                onEntered?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "enter", "enter-done"));
                break;
            case 2 /* EXITING */ :
                setClasses(rootPrefixedClassNames(className, `exit`, "exit-active"));
                break;
            case 3 /* EXITED */ :
                onExited?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "exit", "exit-done"));
                break;
        }
    }, [
        status
    ]);
    const shouldUnMount = unmountOnExit && status === 3 /* EXITED */ ;
    return shouldUnMount ? null : (0, $acw62.cloneElement)(children, {
        className: $fe5170bdd3625759$var$makeClass([
            classes,
            children.props.className
        ]),
        ...rest
    });
};
const $fe5170bdd3625759$var$OnVisible = (props)=>{
    const { onChange: onChange, children: children, percent: percent = 50, visibleClassName: visibleClassName, wrappingElement: wrappingElement = "div", ...rest } = props;
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const intersectionObserverRef = (0, $acw62.useRef)(null);
    const handleInteraction = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                onChange?.(true);
                setVisible(true);
                intersectionObserverRef?.current?.disconnect();
            }
        });
    };
    const domRef = (0, $acw62.useCallback)((ref)=>{
        const intersectionObserver = new IntersectionObserver(handleInteraction, {
            threshold: percent / 100
        });
        intersectionObserverRef.current = intersectionObserver;
        if (ref) intersectionObserver.observe(ref);
        return ()=>intersectionObserver.disconnect();
    }, []);
    return (0, $acw62.createElement)(wrappingElement, {
        ref: domRef,
        ...rest,
        className: visible ? visibleClassName : void 0
    }, children);
};
const $fe5170bdd3625759$var$FadeOnScroll = (props)=>{
    const [isVisible, setVisible] = (0, $acw62.useState)(false);
    const uniqKey = props.uniqueKey || "-no-key";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$OnVisible, {
        onChange: (val)=>{
            setVisible(val);
            props.onVisible && props.onVisible(false);
        },
        visibleClassName: "fadeup-visible",
        percent: 5,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$CSSTransition, {
            in: props.enter === void 0 ? isVisible : isVisible && props.enter,
            appear: true,
            className: props.animationClass || "fadeup",
            onEntered: ()=>{
                props.onVisible && props.onVisible(true);
            },
            timeout: 150,
            ...props.transitionProps,
            children: props.children
        }, uniqKey)
    });
};
$fe5170bdd3625759$var$FadeOnScroll.defaultProps = {
    animateClass: "fadeup"
};
const $fe5170bdd3625759$var$Container = (0, $acw62.forwardRef)((props, ref)=>{
    const { padPosition: padPosition, displayOn: displayOn, animateIn: animateIn, animateNow: animateNow, layout: layout, pad: pad, as: as = "section", rounded: rounded, onVisible: onVisible, background: background, mode: mode, ...rest } = props;
    const classNames = $fe5170bdd3625759$var$makeClass([
        props.className,
        "j-container",
        pad && `sp--${pad}`,
        (pad || padPosition) && `pd--${padPosition || "all"}`,
        layout && `l-layout--${layout}`,
        displayOn && `l-breakpoint--${displayOn}`,
        background && `bg--${background}`,
        rounded && `l-radius--${rounded}`,
        animateIn && "fadeup-initial"
    ]);
    const modeProp = {};
    if (mode) modeProp["data-mode"] = mode || "light";
    const ContainerTag = as;
    const containerDom = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ContainerTag, {
        ref: ref,
        ...modeProp,
        ...rest,
        className: classNames,
        children: props.children
    });
    if (!(animateIn === true || animateNow === true)) return containerDom;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$FadeOnScroll, {
        animate: animateIn,
        uniqueKey: classNames + "-" + props.id,
        onVisible: onVisible,
        enter: animateNow,
        children: containerDom
    });
});
$fe5170bdd3625759$var$Container.defaultProps = {
    as: "section"
};
const $fe5170bdd3625759$var$FULL_LAYOUTS = [
    "full-width"
];
const $fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping = {
    top: "start",
    bottom: "end"
};
const $fe5170bdd3625759$export$ce6636bfa4e9f0e8 = (props)=>{
    const { className: className, children: children, layout: layout = "1-col-even", verticalAlignment: verticalAlignment = "stretch", horizontalAlignment: horizontalAlignment = "stretch", margin: margin, marginPosition: marginPosition, ...rest } = props;
    const SLIDER_ENABLED_PANELS = [
        "2-col-overflow",
        "3-col-overflow",
        "4-col-overflow"
    ];
    const { tablet: tablet } = $fe5170bdd3625759$var$Devices.useMedia();
    const hasSlider = SLIDER_ENABLED_PANELS.includes(layout) && tablet;
    const classes = $fe5170bdd3625759$var$makeClass([
        className,
        $fe5170bdd3625759$var$FULL_LAYOUTS.includes(layout) ? "l-layout--full" : "l-layout--max-width",
        "j-content-layout",
        `j-content-layout__layout-${layout}`,
        margin && `sp--${margin}`,
        margin && marginPosition && `mg--${marginPosition}`,
        hasSlider && "j-content-layout__slider"
    ]);
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(0);
    const styleVars = $fe5170bdd3625759$var$setCSSVar({
        "--content-layout-horizontal-alignment": horizontalAlignment,
        "--content-layout-vertical-alignment": Object.keys($fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping).includes(verticalAlignment) ? $fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping[verticalAlignment] : verticalAlignment
    });
    const modifiedStyles = {
        ...props.style || {},
        ...styleVars
    };
    const contentPanelClasses = $fe5170bdd3625759$var$makeClass([
        "j-content-layout-panel"
    ]);
    const GAP_SIZE = 16;
    const TOUCH_THRESHOLD = 20;
    const touchRef = (0, $acw62.useRef)({
        start: 0,
        end: 0,
        id: 0
    });
    const contentLayoutRef = (0, $acw62.useRef)(null);
    const moveToPanel = (scrollValue)=>{
        const currentActiveIndex = touchRef.current.id >= 0 ? touchRef.current.id : 0;
        Array.from(contentLayoutRef.current?.children || []).forEach((item)=>{
            item.style.transform = "translateX(-" + scrollValue + "px)";
        });
        setActiveIndex(currentActiveIndex);
    };
    const handlePointerStart = (e)=>{
        if (hasSlider) touchRef.current.start = e.clientX;
    };
    const getScrolledValue = (panelItemIndex)=>{
        let totalScrolled = 0;
        const items = Array.from(contentLayoutRef.current?.children || []);
        const panelIndexDifference = Math.abs(touchRef.current.id - panelItemIndex);
        items.length = panelItemIndex > 0 ? panelIndexDifference === 0 ? panelItemIndex : panelItemIndex - panelIndexDifference : 0;
        items.forEach((_, elIndex)=>{
            totalScrolled = totalScrolled + items[elIndex].offsetWidth + GAP_SIZE;
        });
        return totalScrolled;
    };
    const handlePointerMove = (ev)=>{
        if (hasSlider && touchRef.current.start) {
            touchRef.current.end = ev.clientX;
            if (ev.cancelable) ev.preventDefault();
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const panelItemIndex = parseInt(ev.currentTarget.getAttribute("data-index") || "0");
            const totalScrolled = getScrolledValue(panelItemIndex);
            const scrollValue = totalScrolled + -1 * touchDistance;
            moveToPanel(scrollValue);
        }
    };
    const handlePointerEnd = (ev)=>{
        if (hasSlider && touchRef.current.end) {
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const childItemsLength = contentLayoutRef.current?.children.length || 0;
            const touchDistancePercent = 100 / ev.currentTarget.offsetWidth * Math.abs(touchDistance);
            let nextPanelID = touchRef.current.id < 0 ? 1 : touchRef.current.id;
            if (touchDistancePercent > TOUCH_THRESHOLD) nextPanelID += touchDistance < 0 ? 1 : -1;
            nextPanelID = nextPanelID >= childItemsLength ? nextPanelID - 1 : nextPanelID;
            touchRef.current.start = 0;
            slideToPanel(nextPanelID);
        }
    };
    const handlePointerOut = ()=>{
        touchRef.current.start = 0;
        slideToPanel(touchRef.current.id);
        touchRef.current.end = 0;
    };
    const slideToPanel = (index)=>{
        touchRef.current.id = index;
        const scrollValue = getScrolledValue(index);
        moveToPanel(scrollValue);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...rest,
                ref: contentLayoutRef,
                className: classes,
                style: modifiedStyles,
                children: (0, $acw62.Children).map(children, (child, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onPointerDown: handlePointerStart,
                        onPointerUp: handlePointerEnd,
                        onPointerMove: handlePointerMove,
                        onPointerOut: handlePointerOut,
                        "data-index": index,
                        className: contentPanelClasses,
                        children: child
                    }))
            }),
            hasSlider && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$Container, {
                className: "pagination__wrapper",
                layout: "centered",
                pad: "xs",
                padPosition: "vertical",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$CarouselPagination, {
                    clickable: true,
                    onDotClick: slideToPanel,
                    count: (0, $acw62.Children).count(children),
                    selectedIndex: activeIndex
                })
            })
        ]
    });
};
$fe5170bdd3625759$export$ce6636bfa4e9f0e8.defaultProps = {
    layout: "1-col-even",
    horizontalAlignment: "stretch",
    verticalAlignment: "stretch",
    margin: "layout"
};
const $fe5170bdd3625759$export$ef2184bd89960b14 = (props)=>{
    const { template: template, templateTablet: templateTablet, templateMobile: templateMobile, gap: gap, align: align, justify: justify, ...rest } = props;
    const classNames = $fe5170bdd3625759$var$makeClass([
        props.className,
        "j-grid"
    ]);
    const styleVars = $fe5170bdd3625759$var$setCSSVar({
        "--grid-template": template,
        "--grid-template-tablet": templateTablet,
        "--grid-template-mobile": templateMobile || templateTablet,
        "--grid-gap": gap,
        "--grid-align": align,
        "--grid-justify": justify
    });
    const modifiedStyles = Object.assign(props.style || {}, styleVars);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...rest,
        className: classNames,
        style: modifiedStyles,
        children: props.children
    });
};
$fe5170bdd3625759$export$ef2184bd89960b14.defaultProps = {
    template: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "var(--spacing-base)",
    align: "center"
};
const $fe5170bdd3625759$var$Horizontal = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$eef1e68107c58ef2, {
        ...props,
        direction: "horizontal"
    });
const $fe5170bdd3625759$var$Vertical = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$eef1e68107c58ef2, {
        ...props,
        direction: "vertical"
    });
const $fe5170bdd3625759$export$eef1e68107c58ef2 = (props)=>{
    const { className: className, value: value, direction: direction, ...rest } = props;
    const classes = $fe5170bdd3625759$var$makeClass([
        className,
        value && `sp--${value}`,
        direction === "horizontal" ? "pd--right" : "pd--bottom",
        `j-Space__${direction}`,
        "j-Space"
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: classes,
        ...rest
    });
};
$fe5170bdd3625759$export$eef1e68107c58ef2.H = $fe5170bdd3625759$var$Horizontal;
$fe5170bdd3625759$export$eef1e68107c58ef2.V = $fe5170bdd3625759$var$Vertical;
$fe5170bdd3625759$export$eef1e68107c58ef2.displayName = "Space";
$fe5170bdd3625759$export$eef1e68107c58ef2.defaultProps = {
    direction: "vertical",
    value: "s"
};
const $fe5170bdd3625759$var$sdl$1 = {
    "metadata": {
        "version": "1.0.0",
        "id": "horizontal-stepper-1.0.0",
        "name": "JDSHorizontalStepper",
        "layerName": "jds_horizontal_stepper"
    },
    "hierarchy": {
        "container": [
            {
                "step-indicator-container": [
                    "jds_step_item_horizontal"
                ]
            },
            {
                "stepper-children-container": [
                    "stepper-content-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{h_0}",
            "flex-direction": "{h_1}",
            "size": "{h_2}"
        },
        "step-indicator-container": {
            "flex-direction": "{h_3}",
            "justify-content": "{h_4}",
            "align-items": "{h_5}",
            "size": "{h_6}",
            "padding-left": "{h_7}",
            "padding-right": "{h_8}"
        },
        "jds_step_item_horizontal": {
            "flex": 1
        },
        "stepper-children-container": {
            "size": "{h_9}",
            "flex-direction": "{h_10}",
            "justify-content": "{h_11}",
            "align-items": "{h_12}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500
        }
    },
    "api": {
        "data": {
            "container": {
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "step-indicator-container": {
                "value": {
                    "name": "stepItems",
                    "type": "list",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "activeState": "JDSStepperDot.activeState",
                        "direction": "JDSHorizontalStepItem.direction"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSHorizontalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "children": {
            "stepper-content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "a11y": {
            "step-indicator-container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$AnimatedStepItem = ({ children: children, show: show, animateState: animateState })=>{
    const { className: className } = $fe5170bdd3625759$var$useTransition(Boolean(show));
    if (!show) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: [
            className,
            "animate-step-item",
            animateState
        ].join(" "),
        children: children
    });
};
const $fe5170bdd3625759$var$getCompletedStepItems = (stepItems)=>{
    const filteredList = stepItems.filter((item)=>item.complete);
    if (!filteredList.length) return [
        -1
    ];
    return filteredList.map((_, i)=>i);
};
const $fe5170bdd3625759$var$getState = (idx, stepItems, completedList)=>{
    if (stepItems[idx]?.disabled) return "disabled";
    if (completedList.includes(idx)) return "complete";
    const activeItems = stepItems.findIndex((t, i)=>!completedList.includes(i) && !t.disabled);
    return activeItems === idx ? "active" : "inactive";
};
const $fe5170bdd3625759$var$useStepper = (props, stepperRef)=>{
    const { children: children, onActiveChange: onActiveChange, onComplete: onComplete, orientation: orientation } = props;
    const stepItems = children.map((c)=>c.props);
    const [animateState, setAnimateState] = (0, $acw62.useState)("next");
    const [completedList, setCompletedList] = (0, $acw62.useState)($fe5170bdd3625759$var$getCompletedStepItems(stepItems));
    const completeIndex = completedList.sort()[completedList.length - 1];
    (0, $acw62.useImperativeHandle)(stepperRef, ()=>({
            next: ()=>{
                const nextIndex = completeIndex === stepItems.length ? stepItems.length - 1 : completeIndex + 1;
                const actualIndex = stepItems[nextIndex].disabled ? nextIndex + 1 : nextIndex;
                setCompletedList([
                    ...completedList,
                    actualIndex
                ]);
                stepItems?.[completeIndex]?.onComplete?.();
                onActiveChange?.(actualIndex);
                setAnimateState("next");
                if (nextIndex === stepItems.length - 1) onComplete?.();
            },
            prev: ()=>{
                const prevIndex = completeIndex === stepItems.length - 1 ? [
                    completeIndex,
                    completeIndex - 1
                ] : [
                    completeIndex
                ];
                const currentList = completedList.filter((t)=>!prevIndex.includes(t));
                setCompletedList(currentList);
                setAnimateState("prev");
            }
        }), [
        completeIndex,
        completedList,
        stepItems,
        onActiveChange,
        onComplete
    ]);
    const updatedStepItems = stepItems.map((item, i)=>{
        const direction = i === 0 || orientation === "vertical" && i !== stepItems.length - 1 ? "end" : i === stepItems.length - 1 ? "start" : "both";
        const state = $fe5170bdd3625759$var$getState(i, stepItems, completedList);
        return {
            ...item,
            content: item.children,
            itemsType: props.itemsType,
            icon: item.activeState === "warning" ? void 0 : item.icon,
            _compeleteDivider: i >= completeIndex && orientation === "horizontal",
            direction: direction,
            index: i + 1,
            state: state,
            _ariaCurrent: state === "active" ? "step" : void 0
        };
    });
    return {
        stepItems: updatedStepItems,
        completeIndex: completeIndex,
        animateState: animateState
    };
};
const $fe5170bdd3625759$var$withLogic$1 = (Component)=>(0, $acw62.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems, animateState: animateState } = $fe5170bdd3625759$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems,
                content: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: stepItems.map((item, i)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$AnimatedStepItem, {
                            animateState: animateState,
                            show: item.state === "active",
                            children: item.children
                        }, i))
                })
            }
        });
    });
const $fe5170bdd3625759$var$Component$1 = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSHorizontalStepper", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$HorizontalStepper = $fe5170bdd3625759$var$withLogic$1($fe5170bdd3625759$var$Component$1);
$fe5170bdd3625759$var$HorizontalStepper.displayName = "HorizontalStepper";
$fe5170bdd3625759$var$HorizontalStepper.slotName = "jds_horizontal_stepper";
const $fe5170bdd3625759$export$3ced97e5087256a2 = (props)=>null;
const $fe5170bdd3625759$var$sdl = {
    "metadata": {
        "version": "1.0.0",
        "id": "vertical-stepper-1.0.0",
        "name": "JDSVerticalStepper",
        "layerName": "jds_vertical_stepper"
    },
    "hierarchy": {
        "container": [
            "jds_step_item_vertical"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "size": "{v_3}",
            "gap": "{v_4}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "stepItems",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "direction": "JDSVerticalStepItem.direction",
                        "content": "template",
                        "activeState": "JDSStepperDot.activeState"
                    }
                },
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "jds_step_item_vertical": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSVerticalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "content": {
                    "type": "template",
                    "name": "stepItems.content"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "a11y": {
            "container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_vertical": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic = (Component)=>(0, $acw62.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems } = $fe5170bdd3625759$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems
            }
        });
    });
const $fe5170bdd3625759$var$Component = (props)=>{
    (0, $5c2cbe2b2431bcd1$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl;
    const { custom: custom = "", ...rest } = props;
    return (0, $5c2cbe2b2431bcd1$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSVerticalStepper", $fe5170bdd3625759$var$componentsMap, (0, $5c2cbe2b2431bcd1$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$VerticalStepper = $fe5170bdd3625759$var$withLogic($fe5170bdd3625759$var$Component);
$fe5170bdd3625759$var$VerticalStepper.displayName = "VerticalStepper";
$fe5170bdd3625759$var$VerticalStepper.slotName = "jds_vertical_stepper";
const $fe5170bdd3625759$export$ed8ca599049e8881 = (0, $acw62.forwardRef)(({ orientation: orientation, ...rest }, ref)=>{
    if (orientation === "vertical") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$VerticalStepper, {
        ...rest,
        ref: ref,
        orientation: "vertical"
    });
    if (orientation === "auto") {
        const isVertical = $fe5170bdd3625759$var$Devices.isMobile() && rest.children?.length > 6;
        if (isVertical) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$VerticalStepper, {
            ref: ref,
            ...rest,
            orientation: "vertical"
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$HorizontalStepper, {
        ...rest,
        ref: ref,
        orientation: "horizontal"
    });
});
const $fe5170bdd3625759$export$c13f210c706eb549 = (props)=>null;
const $fe5170bdd3625759$export$36ba2f559d49a8f6 = {
    nudge: $fe5170bdd3625759$var$nudge,
    toast: $fe5170bdd3625759$var$toast,
    Container: $fe5170bdd3625759$var$NotificationContainer,
    Banner: $fe5170bdd3625759$var$NotificationBanner
};






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
var $b00d3e7401eac195$var$L = (t)=>typeof t == "number" && !isNaN(t), $b00d3e7401eac195$var$N = (t)=>typeof t == "string", $b00d3e7401eac195$var$P = (t)=>typeof t == "function", $b00d3e7401eac195$var$ut = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$L(t), $b00d3e7401eac195$var$z = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) ? t : null, $b00d3e7401eac195$var$yt = (t, o)=>t === !1 || $b00d3e7401eac195$var$L(t) && t > 0 ? t : o, $b00d3e7401eac195$var$F = (t)=>(0, $acw62.isValidElement)(t) || $b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) || $b00d3e7401eac195$var$L(t);
function $b00d3e7401eac195$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $b00d3e7401eac195$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $acw62.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $b00d3e7401eac195$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, s);
    };
}
function $b00d3e7401eac195$var$tt(t, o) {
    return {
        content: $b00d3e7401eac195$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $b00d3e7401eac195$var$ot(t, o, e = !1) {
    return (0, $acw62.isValidElement)(t) && !$b00d3e7401eac195$var$N(t.type) ? (0, $acw62.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $b00d3e7401eac195$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $b00d3e7401eac195$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b00d3e7401eac195$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $b00d3e7401eac195$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $b00d3e7401eac195$var$Qt = 1, $b00d3e7401eac195$var$st = ()=>`${$b00d3e7401eac195$var$Qt++}`;
function $b00d3e7401eac195$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($b00d3e7401eac195$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($b00d3e7401eac195$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $b00d3e7401eac195$var$z(n.className || f.toastClassName),
                progressClassName: $b00d3e7401eac195$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $b00d3e7401eac195$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $b00d3e7401eac195$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $b00d3e7401eac195$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $b00d3e7401eac195$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $b00d3e7401eac195$var$I = new Map, $b00d3e7401eac195$var$U = [], $b00d3e7401eac195$var$rt = new Set, $b00d3e7401eac195$var$Wt = (t)=>$b00d3e7401eac195$var$rt.forEach((o)=>o(t)), $b00d3e7401eac195$var$ht = ()=>$b00d3e7401eac195$var$I.size > 0;
function $b00d3e7401eac195$var$Gt() {
    $b00d3e7401eac195$var$U.forEach((t)=>$b00d3e7401eac195$var$nt(t.content, t.options)), $b00d3e7401eac195$var$U = [];
}
var $b00d3e7401eac195$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $b00d3e7401eac195$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $b00d3e7401eac195$var$X(t, o) {
    var r;
    if (o) return !!((r = $b00d3e7401eac195$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $b00d3e7401eac195$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $b00d3e7401eac195$var$xt(t) {
    if (!$b00d3e7401eac195$var$ht()) {
        $b00d3e7401eac195$var$U = $b00d3e7401eac195$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $b00d3e7401eac195$var$ut(t)) $b00d3e7401eac195$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $b00d3e7401eac195$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $b00d3e7401eac195$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $b00d3e7401eac195$var$Et = (t = {})=>{
    $b00d3e7401eac195$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $b00d3e7401eac195$var$nt(t, o) {
    $b00d3e7401eac195$var$F(t) && ($b00d3e7401eac195$var$ht() || $b00d3e7401eac195$var$U.push({
        content: t,
        options: o
    }), $b00d3e7401eac195$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $b00d3e7401eac195$var$Pt(t) {
    var o;
    (o = $b00d3e7401eac195$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $b00d3e7401eac195$var$it(t, o) {
    $b00d3e7401eac195$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $b00d3e7401eac195$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $b00d3e7401eac195$var$vt(o, t, $b00d3e7401eac195$var$Wt);
            $b00d3e7401eac195$var$I.set(o, r);
            let a = r.observe(e);
            return $b00d3e7401eac195$var$Gt(), ()=>{
                a(), $b00d3e7401eac195$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $b00d3e7401eac195$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $b00d3e7401eac195$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $b00d3e7401eac195$var$St(t) {
    return $b00d3e7401eac195$var$rt.add(t), ()=>{
        $b00d3e7401eac195$var$rt.delete(t);
    };
}
function $b00d3e7401eac195$var$qt(t) {
    return t && ($b00d3e7401eac195$var$N(t.toastId) || $b00d3e7401eac195$var$L(t.toastId)) ? t.toastId : $b00d3e7401eac195$var$st();
}
function $b00d3e7401eac195$var$H(t, o) {
    return $b00d3e7401eac195$var$nt(t, o), o.toastId;
}
function $b00d3e7401eac195$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $b00d3e7401eac195$var$qt(o)
    };
}
function $b00d3e7401eac195$var$W(t) {
    return (o, e)=>$b00d3e7401eac195$var$H(o, $b00d3e7401eac195$var$Q(t, e));
}
function $b00d3e7401eac195$export$b410431fab84fa58(t, o) {
    return $b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", o));
}
$b00d3e7401eac195$export$b410431fab84fa58.loading = (t, o)=>$b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $b00d3e7401eac195$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $b00d3e7401eac195$var$N(o) ? $b00d3e7401eac195$export$b410431fab84fa58.loading(o, a) : $b00d3e7401eac195$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $b00d3e7401eac195$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $b00d3e7401eac195$var$N(g) ? {
            render: g
        } : g;
        return l ? $b00d3e7401eac195$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $b00d3e7401eac195$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $b00d3e7401eac195$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$b00d3e7401eac195$export$b410431fab84fa58.promise = $b00d3e7401eac195$var$Kt;
$b00d3e7401eac195$export$b410431fab84fa58.success = $b00d3e7401eac195$var$W("success");
$b00d3e7401eac195$export$b410431fab84fa58.info = $b00d3e7401eac195$var$W("info");
$b00d3e7401eac195$export$b410431fab84fa58.error = $b00d3e7401eac195$var$W("error");
$b00d3e7401eac195$export$b410431fab84fa58.warning = $b00d3e7401eac195$var$W("warning");
$b00d3e7401eac195$export$b410431fab84fa58.warn = $b00d3e7401eac195$export$b410431fab84fa58.warning;
$b00d3e7401eac195$export$b410431fab84fa58.dark = (t, o)=>$b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $b00d3e7401eac195$var$Yt(t) {
    $b00d3e7401eac195$var$xt(t);
}
$b00d3e7401eac195$export$b410431fab84fa58.dismiss = $b00d3e7401eac195$var$Yt;
$b00d3e7401eac195$export$b410431fab84fa58.clearWaitingQueue = $b00d3e7401eac195$var$Et;
$b00d3e7401eac195$export$b410431fab84fa58.isActive = $b00d3e7401eac195$var$X;
$b00d3e7401eac195$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $b00d3e7401eac195$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $b00d3e7401eac195$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $b00d3e7401eac195$var$H(s, l);
    }
};
$b00d3e7401eac195$export$b410431fab84fa58.done = (t)=>{
    $b00d3e7401eac195$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$b00d3e7401eac195$export$b410431fab84fa58.onChange = $b00d3e7401eac195$var$St;
$b00d3e7401eac195$export$b410431fab84fa58.play = (t)=>$b00d3e7401eac195$var$it(!0, t);
$b00d3e7401eac195$export$b410431fab84fa58.pause = (t)=>$b00d3e7401eac195$var$it(!1, t);
function $b00d3e7401eac195$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $acw62.useRef)($b00d3e7401eac195$var$It(t)).current;
    r(t);
    let a = (s = (0, $acw62.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $b00d3e7401eac195$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $b00d3e7401eac195$var$Nt(t) {
    let [o, e] = (0, $acw62.useState)(!1), [r, a] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), s = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $b00d3e7401eac195$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $acw62.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $b00d3e7401eac195$var$G = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $b00d3e7401eac195$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $b00d3e7401eac195$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $b00d3e7401eac195$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $b00d3e7401eac195$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $b00d3e7401eac195$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $b00d3e7401eac195$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $b00d3e7401eac195$export$4f13f83fd8bb1dac = {
    info: $b00d3e7401eac195$var$no,
    warning: $b00d3e7401eac195$var$ro,
    success: $b00d3e7401eac195$var$io,
    error: $b00d3e7401eac195$var$lo,
    spinner: $b00d3e7401eac195$var$fo
}, $b00d3e7401eac195$var$co = (t)=>t in $b00d3e7401eac195$export$4f13f83fd8bb1dac;
function $b00d3e7401eac195$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($b00d3e7401eac195$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $acw62.isValidElement)(r) ? a = (0, $acw62.cloneElement)(r, l) : e ? a = $b00d3e7401eac195$export$4f13f83fd8bb1dac.spinner() : $b00d3e7401eac195$var$co(o) && (a = $b00d3e7401eac195$export$4f13f83fd8bb1dac[o](l))), a;
}
var $b00d3e7401eac195$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $b00d3e7401eac195$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $b00d3e7401eac195$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(M, E), mt = $b00d3e7401eac195$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($b00d3e7401eac195$var$P(s) ? V = s(Z) : (0, $acw62.isValidElement)(s) ? V = (0, $acw62.cloneElement)(s, Z) : V = $b00d3e7401eac195$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $b00d3e7401eac195$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $b00d3e7401eac195$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $b00d3e7401eac195$export$d20e79fdc3899e95 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("bounce", !0)), $b00d3e7401eac195$export$d8dc01b5c85a37b9 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("slide", !0)), $b00d3e7401eac195$export$65cfd44a2050f99 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("zoom")), $b00d3e7401eac195$export$4d2fae537bd90431 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("flip"));
var $b00d3e7401eac195$var$vo = {
    position: "top-right",
    transition: $b00d3e7401eac195$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $b00d3e7401eac195$var$dt(t) {
    let o = {
        ...$b00d3e7401eac195$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $acw62.useState)(!0), l = (0, $acw62.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $b00d3e7401eac195$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $b00d3e7401eac195$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(p, $b00d3e7401eac195$var$z(T));
    }
    function E() {
        e && (a(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
    }
    return $b00d3e7401eac195$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $acw62.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $b00d3e7401eac195$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $b00d3e7401eac195$var$$t = new Map, $b00d3e7401eac195$var$Rt = (t, o)=>{
    $b00d3e7401eac195$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $b00d3e7401eac195$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $b00d3e7401eac195$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $b00d3e7401eac195$export$f2815235e76a62b9(t) {
    return $b00d3e7401eac195$var$Rt($b00d3e7401eac195$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$dt, {
        ...t
    });
}



parcelRequire("acw62");


const $482ccd6e8e9b33b1$var$CustomToast = ({ type: type, message: message, closeToast: closeToast })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "toast-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "toast-icon",
                children: type === "success" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                        width: 15,
                        height: 15
                    }),
                    color: "feedback_success_50"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b5ba81d287aab3e$export$7e7b259dce3cfe53), {
                        width: 15,
                        height: 15
                    }),
                    color: "feedback_error_50"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "toast-message",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                    appearance: "body-s-bold",
                    color: "primary-background",
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "toast-close",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {}),
                    color: "none",
                    onClick: closeToast
                })
            })
        ]
    });
};
var $482ccd6e8e9b33b1$export$2e2bcd8739ae039 = $482ccd6e8e9b33b1$var$CustomToast;



const $1b412f8fcdc342fd$var$LoadPopUp = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    let loadPreferenceCenter;
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        const encodedData = params.get("details");
        loadPreferenceCenter = (parcelRequire("82Ay3")).default;
        let tenantId = "";
        let businessId = "";
        let consentHandleId = "";
        let callBackUrl = "";
        let secureid = "";
        if (encodedData) try {
            const decoded = atob(encodedData);
            const parsed = JSON.parse(decoded);
            tenantId = parsed.tenantId || "";
            businessId = parsed.businessId || "";
            consentHandleId = parsed.consentHandleId || "";
            callBackUrl = parsed.callBackUrl || "";
            secureid = parsed.secCode || "";
        } catch (err) {
            console.log("Error decoding Base64 data param:", err);
        }
        const errors = [];
        if (!consentHandleId) errors.push("Consent Handle ID is missing");
        if (!tenantId) errors.push("Tenant ID is missing");
        if (!businessId) errors.push("Business ID is missing");
        if (!callBackUrl) errors.push("Callback URL is missing");
        if (!secureid) errors.push("Secure Code is missing");
        if (errors.length > 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors.map((err, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: `${index + 1}. ${err}`
                        }, index))
                }), {
                icon: false
            });
            return;
        } else if (errors.length === 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors[0]
                }), {
                icon: false
            });
            return;
        }
        setTimeout(()=>{
            try {
                loadPreferenceCenter(consentHandleId, tenantId, businessId, callBackUrl, secureid);
                setLoading(false);
            } catch (err) {
                console.error("Error loading preference center:", err);
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Failed to load preference center."
                    }), {
                    icon: false
                });
            } finally{
            // setLoading(false);
            }
        }, 2000);
    }, [
        location.search
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>console.log("LoadPopUp unmounted");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "load-popup-container",
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "overlay",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "loader"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "loader-text",
                        children: "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $1b412f8fcdc342fd$export$2e2bcd8739ae039 = $1b412f8fcdc342fd$var$LoadPopUp;


const $1ea0bcfb5b0a50ad$var$Nav = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
            path: "/",
            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b412f8fcdc342fd$export$2e2bcd8739ae039), {})
        })
    });
};
var $1ea0bcfb5b0a50ad$export$2e2bcd8739ae039 = $1ea0bcfb5b0a50ad$var$Nav;



function $4c8cda5d2c6d1d8b$var$App() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c2cbe2b2431bcd1$export$e5cf4eff53e7947d), {
        value: {
            theme: "JioBase",
            mode: "light"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "app-layout",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ea0bcfb5b0a50ad$export$2e2bcd8739ae039), {})
        })
    });
}
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;


// store/store.js
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__defProps = Object.defineProperties;
var $5f9e38360d79f95a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5f9e38360d79f95a$var$__spreadProps = (a, b)=>$5f9e38360d79f95a$var$__defProps(a, $5f9e38360d79f95a$var$__getOwnPropDescs(b));
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? $5f9e38360d79f95a$var$getFinalValue(proxyDraft) : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop) || $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.delete(prop);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $5f9e38360d79f95a$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value) {
    var _a;
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || ((_a = state.assigned_) == null ? void 0 : _a.get(prop)) || !$5f9e38360d79f95a$export$16e3aed3edb85946(value) || value[$5f9e38360d79f95a$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (base === null || !$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $5f9e38360d79f95a$var$_globalIterator = globalThis.Iterator;
var $5f9e38360d79f95a$var$hasIteratorFrom = typeof ($5f9e38360d79f95a$var$_globalIterator == null ? void 0 : $5f9e38360d79f95a$var$_globalIterator.from) === "function";
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).size;
        }
        has(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($5f9e38360d79f95a$var$hasIteratorFrom) return $5f9e38360d79f95a$var$_globalIterator.from(iterable);
        const iterator = $5f9e38360d79f95a$var$__spreadProps($5f9e38360d79f95a$var$__spreadValues({}, iterable), {
            [Symbol.iterator]: ()=>iterator
        });
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $5f9e38360d79f95a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $5f9e38360d79f95a$var$latest(state).length === 0) return isInsert ? $5f9e38360d79f95a$var$latest(state).length : void 0;
        $5f9e38360d79f95a$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($5f9e38360d79f95a$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a, _b;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $5f9e38360d79f95a$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex((_a = args[0]) != null ? _a : 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $5f9e38360d79f95a$var$prepareCopy(state);
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex((_b = args[0]) != null ? _b : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const thisArg = args[1];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate.call(thisArg, source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const thisArg = args[1];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate.call(thisArg, source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/devModeChecks/cacheSizeCheck.ts
var $375276bea32f9eda$var$CACHE_SIZE_CHECK_THRESHOLD = 1e3;
var $375276bea32f9eda$var$runCacheSizeCheck = (cacheSize, funcName)=>{
    let stack = void 0;
    try {
        throw new Error();
    } catch (e) {
        ({ stack: stack } = e);
    }
    console.warn(`A function memoized with weakMapMemoize${funcName ? ` (\`${funcName}\`)` : ""} has seen over ${cacheSize} distinct values for the same primitive argument position.
Results keyed by primitive arguments are held strongly and are only released by \`clearCache()\`, so this cache will keep growing for as long as the function keeps seeing new values.
If it is called with ever-changing primitives (ids, offsets, timestamps), pass the \`maxSize\` option to bound the cache, switch to \`lruMemoize\`, or call \`.clearCache()\` at a suitable point.
See https://reselect.js.org/api/development-only-checks#cachesizecheck for details.`, {
        stack: stack
    });
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once",
    cacheSizeCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $375276bea32f9eda$var$StrongRef : WeakRef;
var $375276bea32f9eda$var$Ref = /* @__PURE__ */ $375276bea32f9eda$var$getWeakRef();
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$var$maybeDeref(r) {
    if (r instanceof $375276bea32f9eda$var$Ref) return r.deref();
    return r;
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck, maxSize: maxSize } = options;
    const useGenerations = maxSize !== void 0;
    if (useGenerations && (!Number.isInteger(maxSize) || maxSize < 1)) throw new TypeError(`maxSize must be a positive integer, received: ${maxSize}`);
    let prevNode = null;
    let insertionCount = 0;
    let lastResult;
    let resultsCount = 0;
    let hasWarnedAboutCacheSize = false;
    function maybeFlipGenerations() {
        if (insertionCount >= maxSize) {
            prevNode = fnNode;
            fnNode = $375276bea32f9eda$var$createCacheNode();
            insertionCount = 0;
        }
    }
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                    insertionCount++;
                } else cacheNode = primitiveNode;
            }
        }
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) return cacheNode.v;
        if (prevNode !== null) {
            let prevCacheNode = prevNode;
            for(let i = 0, l = length; i < l; i++){
                const arg = arguments[i];
                let next;
                if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                    const prevObjectCache = prevCacheNode.o;
                    next = prevObjectCache !== null ? prevObjectCache.get(arg) : void 0;
                } else {
                    const prevPrimitiveCache = prevCacheNode.p;
                    next = prevPrimitiveCache !== null ? prevPrimitiveCache.get(arg) : void 0;
                }
                if (next === void 0) {
                    prevCacheNode = null;
                    break;
                }
                prevCacheNode = next;
            }
            if (prevCacheNode !== null && prevCacheNode.s === $375276bea32f9eda$var$TERMINATED) {
                const promotedNode = cacheNode;
                promotedNode.s = $375276bea32f9eda$var$TERMINATED;
                promotedNode.v = prevCacheNode.v;
                maybeFlipGenerations();
                return prevCacheNode.v;
            }
        }
        const terminatedNode = cacheNode;
        let result = func.apply(null, arguments);
        resultsCount++;
        if (resultEqualityCheck) {
            const lastResultValue = $375276bea32f9eda$var$maybeDeref(lastResult);
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? /* @__PURE__ */ new $375276bea32f9eda$var$Ref(result) : result;
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        if (useGenerations) maybeFlipGenerations();
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        prevNode = null;
        insertionCount = 0;
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$withoutResultEqualityCheck = (option)=>{
    if (option === null || typeof option !== "object" || !("resultEqualityCheck" in option)) return option;
    const optionCopy = $375276bea32f9eda$var$__spreadValues({}, option);
    delete optionCopy.resultEqualityCheck;
    return optionCopy;
};
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const probeMemoizeOptions = [];
    const { length: length } = memoizeOptions;
    for(let i = 0; i < length; i++)probeMemoizeOptions.push($375276bea32f9eda$var$withoutResultEqualityCheck(memoizeOptions[i]));
    const createAnEmptyObject = memoize(()=>({}), ...probeMemoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const { length: length } = dependencies;
            const inputSelectorResults = new Array(length);
            for(let i = 0; i < length; i++)inputSelectorResults[i] = dependencies[i].apply(null, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        findMatchingEntry (value, resultEqualityCheck) {
            const current = entry;
            return current !== void 0 && resultEqualityCheck(current.value, value) ? current : void 0;
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(entry.key, key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        entries.unshift({
            key: key,
            value: value
        });
        if (entries.length > maxSize) entries.pop();
    }
    function findMatchingEntry(value, resultEqualityCheck) {
        const currentEntries = entries;
        const { length: length } = currentEntries;
        for(let i = 0; i < length; i++){
            const entry = currentEntries[i];
            if (resultEqualityCheck(entry.value, value)) return entry;
        }
        return void 0;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        findMatchingEntry: findMatchingEntry,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const matchingEntry = cache.findMatchingEntry(value, resultEqualityCheck);
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


//#region src/createDraftSafeSelector.ts
const $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector = Object.assign((...args)=>{
        const selector = createSelector(...args);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector
    });
    return createDraftSafeSelector;
};
const $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
//#endregion
//#region src/devtoolsExtension.ts
const $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__;
//#endregion
//#region src/tsHelpers.ts
const $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/typeof.js
function $d91034f47eb948f2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d91034f47eb948f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d91034f47eb948f2$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPrimitive.js
function $d91034f47eb948f2$var$toPrimitive(t, r) {
    if ("object" != $d91034f47eb948f2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d91034f47eb948f2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPropertyKey.js
function $d91034f47eb948f2$var$toPropertyKey(t) {
    var i = $d91034f47eb948f2$var$toPrimitive(t, "string");
    return "symbol" == $d91034f47eb948f2$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/defineProperty.js
function $d91034f47eb948f2$var$_defineProperty(e, r, t) {
    return (r = $d91034f47eb948f2$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectSpread2.js
function $d91034f47eb948f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d91034f47eb948f2$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d91034f47eb948f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d91034f47eb948f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d91034f47eb948f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
//#endregion
//#region src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
//#endregion
//#region src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                elapsed += Date.now() - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, Tuple.prototype);
    }
    static get [Symbol.species]() {
        return Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new Tuple(...arr[0].concat(this));
        return new Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
//#endregion
//#region src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", inProgress = /* @__PURE__ */ new Map()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        const alreadyInProgress = inProgress.get(obj);
        if (alreadyInProgress) return alreadyInProgress;
        tracked.children = {};
        inProgress.set(obj, tracked);
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                if (ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                })) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath, inProgress);
        }
        inProgress.delete(obj);
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "", seen = /* @__PURE__ */ new Map()) {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    let seenValues = seen.get(trackedProperty);
    if (!seenValues) {
        seenValues = /* @__PURE__ */ new Set();
        seen.set(trackedProperty, seenValues);
    } else if (seenValues.has(obj)) return {
        wasMutated: false
    };
    seenValues.add(obj);
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath, seen);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
const $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk$1 = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options !== null && options !== void 0 ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk$1) {
            if ($d91034f47eb948f2$var$isBoolean(thunk$1)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk$1.extraArgument));
        }
        return middlewareArray;
    };
//#endregion
//#region src/autoBatchEnhancer.ts
const $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
const $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
const $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
const $d91034f47eb948f2$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        let rafId;
        let timerId;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        rafId = raf(callback);
        timerId = setTimeout(callback, timeout);
    };
};
const $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? typeof window !== "undefined" && window.requestAnimationFrame ? $d91034f47eb948f2$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                subscribe (listener) {
                    const wrappedListener = ()=>notifying && listener();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener);
                    };
                },
                dispatch (action) {
                    try {
                        var _action$meta;
                        notifying = !(action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
//#endregion
//#region src/getDefaultEnhancers.ts
const $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options !== null && options !== void 0 ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
//#endregion
//#region src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware1;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$_objectSpread2({
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
//#endregion
//#region src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
//#endregion
//#region src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer })=>reducer)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($d91034f47eb948f2$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
//#endregion
//#region src/matchers.ts
const $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
//#endregion
//#region src/nanoid.ts
let $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
let $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
//#endregion
//#region src/createAsyncThunk.ts
const $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $d91034f47eb948f2$var$_defineProperty(this, "_type", void 0);
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $d91034f47eb948f2$var$_defineProperty(this, "_type", void 0);
    }
};
const $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
const $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
const $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: payload !== void 0,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        var _options$condition, _options$getPendingMe;
                        let conditionResult = options === null || options === void 0 || (_options$condition = options.condition) === null || _options$condition === void 0 ? void 0 : _options$condition.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        if (abortController.signal.aborted) throw {
                            name: "AbortError",
                            message: abortReason || "Aborted"
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options === null || options === void 0 || (_options$getPendingMe = options.getPendingMeta) === null || _options$getPendingMe === void 0 ? void 0 : _options$getPendingMe.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    if (!(options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition)) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk.withTypes = ()=>createAsyncThunk;
    return createAsyncThunk;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutPropertiesLoose.js
function $d91034f47eb948f2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutProperties.js
function $d91034f47eb948f2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d91034f47eb948f2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
//#endregion
//#region src/createSlice.ts
const $d91034f47eb948f2$var$_excluded = [
    "reducerPath"
];
const $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
const $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
let $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType) {
    ReducerType["reducer"] = "reducer";
    ReducerType["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType["asyncThunk"] = "asyncThunk";
    return ReducerType;
}({});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _creators$asyncThunk;
    const cAT = creators === null || creators === void 0 || (_creators$asyncThunk = creators.asyncThunk) === null || _creators$asyncThunk === void 0 ? void 0 : _creators$asyncThunk[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher (matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction (name, actionCreator) {
                context.actionCreators[name] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name, reducer) {
                context.sliceCaseReducersByName[name] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                return $d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap()), selectState, ()=>{
                    var _options$selectors;
                    const map = {};
                    for (const [name, selector] of Object.entries((_options$selectors = options.selectors) !== null && _options$selectors !== void 0 ? _options$selectors : {}))map[name] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {}, {
            injectInto (injectable, _ref = {}) {
                let { reducerPath: pathOpt } = _ref, config = $d91034f47eb948f2$var$_objectWithoutProperties(_ref, $d91034f47eb948f2$var$_excluded);
                const newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
const $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$_objectSpread2({
            _reducerDefinitionType: "asyncThunk",
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer"
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare",
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop$1,
        pending: pending || $d91034f47eb948f2$var$noop$1,
        rejected: rejected || $d91034f47eb948f2$var$noop$1,
        settled: settled || $d91034f47eb948f2$var$noop$1
    });
}
function $d91034f47eb948f2$var$noop$1() {}
//#endregion
//#region src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
//#endregion
//#region src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector(selectState, selectEntities);
        return {
            selectIds: createSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector(selectState, selectAll),
            selectTotal: createSelector(selectState, selectTotal),
            selectById: createSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
//#endregion
//#region src/entities/state_adapter.ts
const $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
//#endregion
//#region src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
//#endregion
//#region src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        setManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original = state.entities[update.id];
        if (original === void 0) return false;
        const updated = Object.assign({}, original, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) {
                var _updatesPerEntity$upd;
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        if (updates.length > 0) {
            if (updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
//#endregion
//#region src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        if (comparisonFunction(item, currentItem) >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds !== null && existingIds !== void 0 ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        setManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        const updatesPerEntity = {};
        for (const update of updates)if (update.id in state.entities) {
            var _updatesPerEntity$upd;
            updatesPerEntity[update.id] = {
                id: update.id,
                changes: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
            };
        }
        for (const update of Object.values(updatesPerEntity)){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function mergeFunction(state, addedItems, appliedUpdates, replacedIds) {
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
//#endregion
//#region src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$_objectSpread2({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
//#endregion
//#region src/listenerMiddleware/exceptions.ts
const $d91034f47eb948f2$var$task = "task";
const $d91034f47eb948f2$var$listener = "listener";
const $d91034f47eb948f2$var$completed = "completed";
const $d91034f47eb948f2$var$cancelled = "cancelled";
const $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
const $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
const $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
const $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$_defineProperty(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$_defineProperty(this, "message", void 0);
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
//#endregion
//#region src/listenerMiddleware/utils.ts
const $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
const $d91034f47eb948f2$var$noop = ()=>{};
const $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop)=>{
    promise.catch(onError);
    return promise;
};
const $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
//#endregion
//#region src/listenerMiddleware/task.ts
const $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop;
    });
}
const $d91034f47eb948f2$var$runTask = async (task, cleanUp)=>{
    try {
        await Promise.resolve();
        return {
            status: "ok",
            value: await task()
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp === null || cleanUp === void 0 || cleanUp();
    }
};
const $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
const $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
//#endregion
//#region src/listenerMiddleware/index.ts
const { assign: $d91034f47eb948f2$var$assign } = Object;
const $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
const $d91034f47eb948f2$var$alm = "listenerMiddleware";
const $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
const $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const promises = [
            new Promise((resolve, reject)=>{
                let stopListening = startListening({
                    predicate: predicate,
                    effect: (action, listenerApi)=>{
                        listenerApi.unsubscribe();
                        resolve([
                            action,
                            listenerApi.getState(),
                            listenerApi.getOriginalState()
                        ]);
                    }
                });
                unsubscribe = ()=>{
                    stopListening();
                    reject();
                };
            })
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
const $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
const $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
const $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        return (typeof type === "string" ? entry.type === type : entry.predicate === predicate) && entry.effect === effect;
    });
};
const $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
const $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener);
        listenerMap.clear();
    };
};
const $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
const $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
const $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
const $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
const $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
const $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _executingListeners$g;
        const count = (_executingListeners$g = executingListeners.get(entry)) !== null && _executingListeners$g !== void 0 ? _executingListeners$g : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _executingListeners$g2;
        const count = (_executingListeners$g2 = executingListeners.get(entry)) !== null && _executingListeners$g2 !== void 0 ? _executingListeners$g2 : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _findListenerEntry;
        const entry = (_findListenerEntry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) !== null && _findListenerEntry !== void 0 ? _findListenerEntry : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
//#endregion
//#region src/dynamicMiddleware/index.ts
const $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
const $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _action$meta;
        return (action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.instanceId) === instanceId;
    };
const $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    let middlewareVersion = 0;
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware(...middlewares) {
        const previousSize = middlewareMap.size;
        middlewares.forEach((middleware)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
        if (middlewareMap.size !== previousSize) middlewareVersion++;
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>{
            let appliedVersion = -1;
            let dispatch = next;
            return (action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                if (appliedVersion !== middlewareVersion) {
                    dispatch = getFinalMiddleware(api)(next);
                    appliedVersion = middlewareVersion;
                }
                return dispatch(action);
            };
        };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
//#endregion
//#region src/combineSlices.ts
const $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
const $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
const $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
const $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
const $d91034f47eb948f2$var$createStateProxy = (stateProxyMap, state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
const $d91034f47eb948f2$var$original$1 = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
const $d91034f47eb948f2$var$emptyObject = {};
const $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const stateProxyMap = /* @__PURE__ */ new WeakMap();
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(stateProxyMap, selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original$1
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
//#endregion
//#region src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $dc4a47ea750d5f98$export$711117ad6ad27992 = 'persist:';
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $dc4a47ea750d5f98$export$5514fc3b4067675f = 'persist/PURGE';
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === 'object';
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)('local');
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;



// src/store/reducers/CommonReducer.js
const $dee2f92127058cd3$export$9cab09fb538b7032 = "SAVE_MOBILE_NO";
const $dee2f92127058cd3$export$9c0ab32b559369bf = "SAVE_CONFIG";


const $714babfa78423ce1$var$initialState = {
    tenant_id: "589c95c6-4bb8-4678-8c0b-c15c736cb46d",
    customer_id: "",
    mobile_no: "",
    business_id: "589c95c6-4bb8-4678-8c0b-c15c736cb46d",
    template_id: "86e7e715-da74-4410-a05f-5c40d39a6f84"
};
const $714babfa78423ce1$var$commonReducer = (state = $714babfa78423ce1$var$initialState, action)=>{
    switch(action.type){
        case 0, $dee2f92127058cd3$export$9cab09fb538b7032:
            return {
                ...state,
                mobile_no: action.payload.mobileNo
            };
        case 0, $dee2f92127058cd3$export$9c0ab32b559369bf:
            return {
                ...state,
                tenant_id: action.payload.tenantId,
                business_id: action.payload.businessId,
                template_id: action.payload.templateId
            };
        default:
            return state;
    }
};
var $714babfa78423ce1$export$2e2bcd8739ae039 = $714babfa78423ce1$var$commonReducer;


// Persist config
const $68f6ed6174fa5191$var$persistConfig = {
    key: "root",
    storage: $b36a05dffe55b995$export$2e2bcd8739ae039
};
// Combine reducers
const $68f6ed6174fa5191$var$rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    common: (0, $714babfa78423ce1$export$2e2bcd8739ae039)
});
// Persisted reducer
const $68f6ed6174fa5191$var$persistedReducer = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)($68f6ed6174fa5191$var$persistConfig, $68f6ed6174fa5191$var$rootReducer);
const $68f6ed6174fa5191$export$6f57813fe9f31bf9 = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: $68f6ed6174fa5191$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: false
        }),
    devTools: true
});
const $68f6ed6174fa5191$export$7b682ac9934ca3e4 = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)($68f6ed6174fa5191$export$6f57813fe9f31bf9);


const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
    store: (0, $68f6ed6174fa5191$export$6f57813fe9f31bf9),
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=s.f6c3b6d5.js.map
